/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { graphql, type GraphQLResponseResolver, type RequestHandlerOptions } from 'msw'
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  JSONString: { input: any; output: any; }
  TimeDelta: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
  Upload: { input: any; output: any; }
  join__FieldSet: { input: any; output: any; }
  link__Import: { input: any; output: any; }
}

export interface AccountStatus {
  __typename: 'AccountStatus';
  accountActivated: Scalars['Boolean']['output'];
  applicationUse?: Maybe<Scalars['String']['output']>;
  canUpdatePlan: Scalars['Boolean']['output'];
  logModel?: Maybe<Scalars['String']['output']>;
  planExpirationDays?: Maybe<Scalars['Int']['output']>;
  planType?: Maybe<Scalars['String']['output']>;
  pricingModel?: Maybe<Scalars['String']['output']>;
  totalCredits?: Maybe<Scalars['Int']['output']>;
}

export interface Action {
  __typename: 'Action';
  /** @deprecated Deprecated in favor of enabled */
  active: Scalars['Boolean']['output'];
  /** @deprecated Deprecated in favor of configurationJson */
  configuration: Scalars['JSONString']['output'];
  configurationJson: Scalars['JSONString']['output'];
  createdTime: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notificationTypeEnums: Array<ActionNotificationType>;
  notificationTypes: Scalars['JSONString']['output'];
  parameters: Array<ActionParameter>;
  type: Scalars['String']['output'];
}

export interface ActionConfigurationSchema {
  __typename: 'ActionConfigurationSchema';
  schemaJson: Scalars['String']['output'];
  typeName: Scalars['String']['output'];
  typeValue: Scalars['String']['output'];
}

export interface ActionFields {
  configurationJson: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  notificationTypes: Array<ActionNotificationType>;
  type: Scalars['String']['input'];
}

export enum ActionNotificationType {
  InsightClosed = 'INSIGHT_CLOSED',
  InsightOnDemand = 'INSIGHT_ON_DEMAND',
  NewInsight = 'NEW_INSIGHT',
  RuleAutoDisabled = 'RULE_AUTO_DISABLED',
  SensorOffline = 'SENSOR_OFFLINE'
}

export interface ActionParameter {
  __typename: 'ActionParameter';
  displayName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
}

export interface ActionParameterValue {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
}

export interface AddEntityNote {
  __typename: 'AddEntityNote';
  data: EntityNote;
}

export interface AddEntityTags {
  __typename: 'AddEntityTags';
  data?: Maybe<EntityInterface>;
}

export interface AddInsightComment {
  __typename: 'AddInsightComment';
  data: InsightComment;
}

export interface AddInsightCommentsById {
  __typename: 'AddInsightCommentsById';
  ok: Scalars['Boolean']['output'];
}

export interface AddInsightRelatedIncident {
  __typename: 'AddInsightRelatedIncident';
  data: Insight;
}

export interface AddInsightToIncident {
  __typename: 'AddInsightToIncident';
  data: Insight;
}

export interface AddItemToMatchList {
  __typename: 'AddItemToMatchList';
  data: MatchListItem;
  finishedProcessing: Scalars['Boolean']['output'];
}

export interface AddItemToSuppressList {
  __typename: 'AddItemToSuppressList';
  data: SuppressListItem;
  finishedProcessing: Scalars['Boolean']['output'];
}

export interface AddItemToThreatIntelSource {
  __typename: 'AddItemToThreatIntelSource';
  data: ThreatIntelItem;
  finishedProcessing: Scalars['Boolean']['output'];
}

export interface AddItemsToList {
  __typename: 'AddItemsToList';
  ok: Scalars['Boolean']['output'];
}

export interface AddItemsToSuppressList {
  __typename: 'AddItemsToSuppressList';
  ok: Scalars['Boolean']['output'];
}

export interface AddItemsToThreatIntelSource {
  __typename: 'AddItemsToThreatIntelSource';
  ok: Scalars['Boolean']['output'];
}

export interface AddSignalsToInsight {
  __typename: 'AddSignalsToInsight';
  data: Insight;
}

export interface AddTagToInsight {
  __typename: 'AddTagToInsight';
  data: Insight;
}

export interface AddTagToInsightsById {
  __typename: 'AddTagToInsightsById';
  ok: Scalars['Boolean']['output'];
}

export interface AddYaraRuleToCustomYaraSource {
  __typename: 'AddYaraRuleToCustomYaraSource';
  data: YaraRule;
}

export interface AddYaraRulesToCustomYaraSource {
  __typename: 'AddYaraRulesToCustomYaraSource';
  ok: Scalars['Boolean']['output'];
}

export interface AggregationRule extends RuleInterface {
  __typename: 'AggregationRule';
  aggregationFunctions: Array<AggregationRuleAggregationFunction>;
  assetField?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of status */
  autoDisabledReason?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  contentType: ContentType;
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  createdByUser?: Maybe<User>;
  deleted: Scalars['Boolean']['output'];
  descriptionExpression: Scalars['String']['output'];
  descriptionExpressionOverride?: Maybe<StringRuleOverride>;
  enabled: Scalars['Boolean']['output'];
  entitySelectors: Array<OutputEntitySelectorType>;
  entitySelectorsOverride?: Maybe<EntitySelectorsRuleOverride>;
  exportJson: Scalars['String']['output'];
  failing: Scalars['Boolean']['output'];
  groupByAsset: Scalars['Boolean']['output'];
  groupByFields: Array<Scalars['String']['output']>;
  groupByFieldsOverride?: Maybe<StringListRuleOverride>;
  hasOverride: Scalars['Boolean']['output'];
  history: Array<RuleHistoryEvent>;
  id: Scalars['ID']['output'];
  isPrototype: Scalars['Boolean']['output'];
  isPrototypeOverride?: Maybe<BooleanRuleOverride>;
  lastUpdated: Scalars['DateTime']['output'];
  lastUpdatedBy: Scalars['String']['output'];
  lastUpdatedByUser?: Maybe<User>;
  matchExpression: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameExpression: Scalars['String']['output'];
  nameExpressionOverride?: Maybe<StringRuleOverride>;
  nameOverride?: Maybe<StringRuleOverride>;
  parentJaskId?: Maybe<Scalars['ID']['output']>;
  rawJson?: Maybe<Scalars['String']['output']>;
  rawStatus?: Maybe<RuleStatus>;
  ruleDescription?: Maybe<Scalars['String']['output']>;
  ruleId: Scalars['Int']['output'];
  ruleSource: Scalars['String']['output'];
  ruleType: Scalars['String']['output'];
  scoreMapping: RuleScoreMapping;
  scoreMappingOverride?: Maybe<RuleScoreMappingRuleOverride>;
  signalCount07d: Scalars['Int']['output'];
  signalCount24h: Scalars['Int']['output'];
  status: RuleStatus;
  stream: Scalars['String']['output'];
  summaryExpression: Scalars['String']['output'];
  summaryExpressionOverride?: Maybe<StringRuleOverride>;
  suppressionWindowSize?: Maybe<Scalars['Int']['output']>;
  suppressionWindowSizeOverride?: Maybe<IntRuleOverride>;
  tags: Array<Scalars['String']['output']>;
  tagsOverride?: Maybe<StringListRuleOverride>;
  triggerExpression: Scalars['String']['output'];
  tuningExpressionIds?: Maybe<Array<Scalars['String']['output']>>;
  tuningExpressions?: Maybe<Array<RuleTuningExpression>>;
  version: Scalars['Int']['output'];
  windowSize: Scalars['Int']['output'];
  windowSizeName: Scalars['String']['output'];
  windowSizeOverride?: Maybe<IntRuleOverride>;
}

export interface AggregationRuleAggregationFunction {
  __typename: 'AggregationRuleAggregationFunction';
  arguments: Array<Scalars['String']['output']>;
  function: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface AggregationRuleAggregationFunctionField {
  arguments: Array<Scalars['String']['input']>;
  function: Scalars['String']['input'];
  name: Scalars['String']['input'];
}

export interface AggregationRuleFields {
  aggregationFunctions: Array<AggregationRuleAggregationFunctionField>;
  assetField?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  descriptionExpression: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  groupByAsset: Scalars['Boolean']['input'];
  groupByFields: Array<Scalars['String']['input']>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  matchExpression: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nameExpression: Scalars['String']['input'];
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  scoreMapping: RuleScoreMappingFields;
  stream: Scalars['String']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  triggerExpression: Scalars['String']['input'];
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  windowSize: RuleWindowSizeEnum;
  windowSizeMilliseconds?: InputMaybe<Scalars['BigInt']['input']>;
}

export interface AggregationRuleFunction {
  __typename: 'AggregationRuleFunction';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parameters: Array<AggregationRuleFunctionParameter>;
}

export interface AggregationRuleFunctionParameter {
  __typename: 'AggregationRuleFunctionParameter';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export enum AggregationType {
  Average = 'Average',
  Count = 'Count',
  Maximum = 'Maximum',
  Minimum = 'Minimum',
  None = 'None',
  Sum = 'Sum'
}

export enum AlertSource {
  Algorithm = 'ALGORITHM',
  Canary = 'CANARY',
  Rule = 'RULE',
  User = 'USER'
}

export interface AllEntityPage {
  __typename: 'AllEntityPage';
  nextPageToken?: Maybe<Scalars['String']['output']>;
  objects: Array<EntityInterface>;
}

export interface AllInsightPage {
  __typename: 'AllInsightPage';
  nextPageToken?: Maybe<Scalars['String']['output']>;
  objects: Array<Insight>;
}

export interface AllSignalPage {
  __typename: 'AllSignalPage';
  nextPageToken?: Maybe<Scalars['String']['output']>;
  objects: Array<Signal>;
}

export interface AllThreatIntelItemPage {
  __typename: 'AllThreatIntelItemPage';
  nextPageToken?: Maybe<Scalars['String']['output']>;
  objects: Array<ThreatIntelItem>;
}

export interface AllowedInsightStatus {
  __typename: 'AllowedInsightStatus';
  insightStatus: InsightStatus;
  requiredFields: Array<InsightRequiredFieldType>;
}

export interface AnomaliThreatIntelSourceFields {
  apiKey: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  filter: Scalars['String']['input'];
  inactiveFilter?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  username: Scalars['String']['input'];
}

export interface AuditLog {
  __typename: 'AuditLog';
  actingUsername?: Maybe<Scalars['String']['output']>;
  actionType?: Maybe<Scalars['String']['output']>;
  authMethod?: Maybe<AuthenticationMethod>;
  dataJson?: Maybe<Scalars['String']['output']>;
  httpMethod?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  targetsJson?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
}

export interface AuditLogPage {
  __typename: 'AuditLogPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<AuditLog>;
  total: Scalars['Int']['output'];
}

export enum AuthenticationMethod {
  ApiKeyInAuthHeader = 'API_KEY_IN_AUTH_HEADER',
  ApiKeyInHeader = 'API_KEY_IN_HEADER',
  ApiKeyInQuery = 'API_KEY_IN_QUERY',
  BasicAuth = 'BASIC_AUTH',
  Cookie = 'COOKIE',
  Jwt = 'JWT'
}

export interface AutoCompleteValue {
  __typename: 'AutoCompleteValue';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
}

export interface AutoCompleteValueInput {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
}

export interface Automation {
  __typename: 'Automation';
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  cseResourceSubTypes?: Maybe<Array<Scalars['String']['output']>>;
  cseResourceType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  executionTypes: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  playbookId: Scalars['String']['output'];
}

export interface AutomationFields {
  cseResourceSubTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  cseResourceType: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  executionTypes: Array<Scalars['String']['input']>;
  playbookId: Scalars['String']['input'];
}

export interface AutomationPage {
  __typename: 'AutomationPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<Automation>;
  total: Scalars['Int']['output'];
}

export interface AutomationSort {
  direction?: SortDir;
  field?: AutomationSortableField;
}

export enum AutomationSortableField {
  Created = 'CREATED',
  CseResourceType = 'CSE_RESOURCE_TYPE',
  Enabled = 'ENABLED'
}

export interface BaseLines {
  __typename: 'BaseLines';
  continuousIngest?: Maybe<Scalars['Int']['output']>;
  cseIngest?: Maybe<Scalars['Int']['output']>;
  featureActivation?: Maybe<FeatureActivation>;
  frequentIngest?: Maybe<Scalars['Int']['output']>;
  infrequentIngest?: Maybe<Scalars['Int']['output']>;
  metrics?: Maybe<Scalars['Int']['output']>;
  tracingIngest?: Maybe<Scalars['Int']['output']>;
}

export enum BaselineStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Insufficient = 'INSUFFICIENT',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  TooManyRecords = 'TOO_MANY_RECORDS'
}

export interface BigIntCountWithDelta {
  __typename: 'BigIntCountWithDelta';
  count?: Maybe<Scalars['BigInt']['output']>;
  delta?: Maybe<Scalars['Float']['output']>;
}

export interface BigIntDataPoint {
  __typename: 'BigIntDataPoint';
  timestamp: Scalars['DateTime']['output'];
  value: Scalars['BigInt']['output'];
}

export interface BigIntRuleOverride {
  __typename: 'BigIntRuleOverride';
  original?: Maybe<Scalars['BigInt']['output']>;
  override?: Maybe<Scalars['BigInt']['output']>;
}

export interface BooleanRuleOverride {
  __typename: 'BooleanRuleOverride';
  original?: Maybe<Scalars['Boolean']['output']>;
  override?: Maybe<Scalars['Boolean']['output']>;
}

export interface BulkAddEntityTags {
  __typename: 'BulkAddEntityTags';
  data?: Maybe<Array<Maybe<EntityInterface>>>;
}

export interface BulkDeleteMatchListItems {
  __typename: 'BulkDeleteMatchListItems';
  errorResults: Array<Scalars['ID']['output']>;
}

export interface BulkRemoveEntityTags {
  __typename: 'BulkRemoveEntityTags';
  data?: Maybe<Array<Maybe<EntityInterface>>>;
}

export interface BulkUpdateEntityCriticality {
  __typename: 'BulkUpdateEntityCriticality';
  data?: Maybe<Array<Maybe<EntityInterface>>>;
}

export interface BulkUpdateEntityTags {
  __typename: 'BulkUpdateEntityTags';
  data?: Maybe<Array<Maybe<EntityInterface>>>;
}

export interface BulkUpdateEntityWhitelist {
  __typename: 'BulkUpdateEntityWhitelist';
  data?: Maybe<Array<Maybe<EntityInterface>>>;
}

export interface BulkUpsertNetworkBlocks {
  __typename: 'BulkUpsertNetworkBlocks';
  data: Array<NetworkBlock>;
}

export interface CancelSumoRecordSearchJob {
  __typename: 'CancelSumoRecordSearchJob';
  ok: Scalars['Boolean']['output'];
}

export interface Category {
  __typename: 'Category';
  name: Scalars['String']['output'];
}

export interface ChainRule extends RuleInterface {
  __typename: 'ChainRule';
  assetField?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of status */
  autoDisabledReason?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  contentType: ContentType;
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  createdByUser?: Maybe<User>;
  deleted: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  descriptionOverride?: Maybe<StringRuleOverride>;
  enabled: Scalars['Boolean']['output'];
  entitySelectors: Array<OutputEntitySelectorType>;
  entitySelectorsOverride?: Maybe<EntitySelectorsRuleOverride>;
  exportJson: Scalars['String']['output'];
  expressionsAndLimits: Array<ChainRuleExpressionAndLimit>;
  expressionsAndLimitsOverride?: Maybe<ExpressionAndLimitsRuleOverride>;
  failing: Scalars['Boolean']['output'];
  groupByFields: Array<Scalars['String']['output']>;
  groupByFieldsOverride?: Maybe<StringListRuleOverride>;
  hasOverride: Scalars['Boolean']['output'];
  history: Array<RuleHistoryEvent>;
  id: Scalars['ID']['output'];
  isPrototype: Scalars['Boolean']['output'];
  isPrototypeOverride?: Maybe<BooleanRuleOverride>;
  lastUpdated: Scalars['DateTime']['output'];
  lastUpdatedBy: Scalars['String']['output'];
  lastUpdatedByUser?: Maybe<User>;
  name: Scalars['String']['output'];
  nameOverride?: Maybe<StringRuleOverride>;
  ordered: Scalars['Boolean']['output'];
  parentJaskId?: Maybe<Scalars['ID']['output']>;
  rawJson?: Maybe<Scalars['String']['output']>;
  rawStatus?: Maybe<RuleStatus>;
  ruleDescription?: Maybe<Scalars['String']['output']>;
  ruleId: Scalars['Int']['output'];
  ruleSource: Scalars['String']['output'];
  ruleType: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  scoreOverride?: Maybe<IntRuleOverride>;
  signalCount07d: Scalars['Int']['output'];
  signalCount24h: Scalars['Int']['output'];
  status: RuleStatus;
  stream: Scalars['String']['output'];
  summaryExpression: Scalars['String']['output'];
  summaryExpressionOverride?: Maybe<StringRuleOverride>;
  suppressionWindowSize?: Maybe<Scalars['Int']['output']>;
  suppressionWindowSizeOverride?: Maybe<IntRuleOverride>;
  tags: Array<Scalars['String']['output']>;
  tagsOverride?: Maybe<StringListRuleOverride>;
  tuningExpressionIds?: Maybe<Array<Scalars['String']['output']>>;
  tuningExpressions?: Maybe<Array<RuleTuningExpression>>;
  version: Scalars['Int']['output'];
  windowSize: Scalars['Int']['output'];
  windowSizeName: Scalars['String']['output'];
  windowSizeOverride?: Maybe<IntRuleOverride>;
}

export interface ChainRuleExpressionAndLimit {
  __typename: 'ChainRuleExpressionAndLimit';
  expression: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  limit: Scalars['Int']['output'];
}

export interface ChainRuleExpressionAndLimitField {
  expression: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
}

export interface ChainRuleFields {
  assetField?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  expressionsAndLimits: Array<ChainRuleExpressionAndLimitField>;
  groupByFields?: InputMaybe<Array<Scalars['String']['input']>>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  ordered?: InputMaybe<Scalars['Boolean']['input']>;
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  score: Scalars['Int']['input'];
  stream: Scalars['String']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  windowSize: RuleWindowSizeEnum;
  windowSizeMilliseconds?: InputMaybe<Scalars['BigInt']['input']>;
}

export interface ClearSumoLogicGeneralConfig {
  __typename: 'ClearSumoLogicGeneralConfig';
  ok: Scalars['Boolean']['output'];
}

export interface ClearSumoLogicSupportConfig {
  __typename: 'ClearSumoLogicSupportConfig';
  ok: Scalars['Boolean']['output'];
}

export interface ComputerInventory extends InventoryInterface {
  __typename: 'ComputerInventory';
  computerName?: Maybe<Scalars['String']['output']>;
  deviceUniqueId?: Maybe<Scalars['String']['output']>;
  groups: Array<Scalars['String']['output']>;
  hostname?: Maybe<Scalars['String']['output']>;
  ip: Array<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  mac?: Maybe<Scalars['String']['output']>;
  metadataJson: Scalars['String']['output'];
  natIp: Array<Scalars['String']['output']>;
  normalizedComputerName?: Maybe<Scalars['String']['output']>;
  normalizedHostname?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  parsedTime: Scalars['String']['output'];
  source: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  uniqueId: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
}

export interface ConfirmInsightTriageRecommendation {
  __typename: 'ConfirmInsightTriageRecommendation';
  data: Insight;
}

export interface Content {
  __typename: 'Content';
  accessKey?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  externalId?: Maybe<Scalars['BigInt']['output']>;
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['Int']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  parameters?: Maybe<Array<SearchQueryParameter>>;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  path: Scalars['String']['output'];
  query?: Maybe<Scalars['String']['output']>;
  runAsIdOverride?: Maybe<Scalars['Int']['output']>;
  scheduled?: Maybe<Scalars['Boolean']['output']>;
  timeRangeEnd?: Maybe<Scalars['Timestamp']['output']>;
  timeRangeExpression?: Maybe<Scalars['String']['output']>;
  timeRangeStart?: Maybe<Scalars['Timestamp']['output']>;
  type: ContentTypeSumo;
  visibility?: Maybe<Scalars['String']['output']>;
}

export interface ContentPage {
  __typename: 'ContentPage';
  id: Scalars['ID']['output'];
  items: Array<Content>;
}

export enum ContentType {
  Anomaly = 'ANOMALY',
  Canary = 'CANARY',
  FileAnalysis = 'FILE_ANALYSIS',
  Rule = 'RULE',
  ThirdParty = 'THIRD_PARTY',
  ThreatIntel = 'THREAT_INTEL'
}

export enum ContentTypeSumo {
  Dashboard = 'DASHBOARD',
  Folder = 'FOLDER',
  Log = 'LOG',
  Lookup = 'LOOKUP',
  Metric = 'METRIC'
}

export interface ContextAction {
  __typename: 'ContextAction';
  allRecordFields: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  entityTypes: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  iocTypes: Array<ContextActionIocType>;
  name: Scalars['String']['output'];
  recordFields: Array<Scalars['String']['output']>;
  source: ContextActionSource;
  template: Scalars['String']['output'];
  type: ContextActionType;
  /** @deprecated Deprecated in favor of template */
  urlTemplate: Scalars['String']['output'];
}

export enum ContextActionIocType {
  Asn = 'ASN',
  Domain = 'DOMAIN',
  Hash = 'HASH',
  IpAddress = 'IP_ADDRESS',
  MacAddress = 'MAC_ADDRESS',
  Port = 'PORT',
  RecordProperty = 'RECORD_PROPERTY',
  Url = 'URL'
}

export interface ContextActionPage {
  __typename: 'ContextActionPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<ContextAction>;
  total: Scalars['Int']['output'];
}

export interface ContextActionSort {
  direction?: SortDir;
  field?: ContextActionSortableField;
}

export enum ContextActionSortableField {
  Name = 'NAME',
  UrlTemplate = 'URL_TEMPLATE'
}

export enum ContextActionSource {
  Jask = 'JASK',
  Modified = 'MODIFIED',
  User = 'USER'
}

export enum ContextActionType {
  Query = 'QUERY',
  Url = 'URL'
}

export interface CountForVendor {
  __typename: 'CountForVendor';
  count: Scalars['BigInt']['output'];
  vendor: Scalars['String']['output'];
}

export interface CountForVendorAndProduct {
  __typename: 'CountForVendorAndProduct';
  count: Scalars['BigInt']['output'];
  product: Scalars['String']['output'];
  vendor?: Maybe<Scalars['String']['output']>;
}

export interface CountWithDelta {
  __typename: 'CountWithDelta';
  count?: Maybe<Scalars['Int']['output']>;
  delta?: Maybe<Scalars['Float']['output']>;
}

export interface CountsByVendorAndProductDataPoint {
  __typename: 'CountsByVendorAndProductDataPoint';
  timestamp: Scalars['DateTime']['output'];
  value: Array<CountForVendorAndProduct>;
}

export interface CountsByVendorDataPoint {
  __typename: 'CountsByVendorDataPoint';
  timestamp: Scalars['DateTime']['output'];
  value: Array<CountForVendor>;
}

export interface CreateAction {
  __typename: 'CreateAction';
  data: Action;
}

export interface CreateAggregationRule {
  __typename: 'CreateAggregationRule';
  data: AggregationRule;
}

export interface CreateAggregationRuleFields {
  aggregationFunctions: Array<AggregationRuleAggregationFunctionField>;
  assetField?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  descriptionExpression: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  groupByAsset: Scalars['Boolean']['input'];
  groupByFields: Array<Scalars['String']['input']>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  matchExpression: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nameExpression: Scalars['String']['input'];
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  scoreMapping: RuleScoreMappingFields;
  stream: Scalars['String']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  triggerExpression: Scalars['String']['input'];
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  windowSize: RuleWindowSizeEnum;
  windowSizeMilliseconds?: InputMaybe<Scalars['BigInt']['input']>;
}

export interface CreateAnomaliThreatIntelSource {
  __typename: 'CreateAnomaliThreatIntelSource';
  data: ThreatIntelSource;
}

export interface CreateAutomation {
  __typename: 'CreateAutomation';
  data: Automation;
}

export interface CreateChainRule {
  __typename: 'CreateChainRule';
  data: ChainRule;
}

export interface CreateChainRuleFields {
  assetField?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  expressionsAndLimits: Array<ChainRuleExpressionAndLimitField>;
  groupByFields?: InputMaybe<Array<Scalars['String']['input']>>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  ordered?: InputMaybe<Scalars['Boolean']['input']>;
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  score: Scalars['Int']['input'];
  stream: Scalars['String']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  windowSize: RuleWindowSizeEnum;
  windowSizeMilliseconds?: InputMaybe<Scalars['BigInt']['input']>;
}

export interface CreateContextAction {
  __typename: 'CreateContextAction';
  data: ContextAction;
}

export interface CreateCustomEntityType {
  __typename: 'CreateCustomEntityType';
  data: CustomEntityType;
}

export interface CreateCustomEntityTypeFields {
  fields: Array<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
}

export interface CreateCustomInsight {
  __typename: 'CreateCustomInsight';
  data: CustomInsight;
}

export interface CreateCustomInsightFields {
  description: Scalars['String']['input'];
  dynamicSeverity?: InputMaybe<Array<DynamicInsightSeverityField>>;
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  ordered: Scalars['Boolean']['input'];
  ruleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  severity: InsightSeverityPyEnum;
  signalMatchStrategy?: InputMaybe<CustomInsightSignalMatchStrategy>;
  signalNames?: InputMaybe<Array<Scalars['String']['input']>>;
  tags: Array<Scalars['String']['input']>;
}

export interface CreateCustomMatchListColumn {
  __typename: 'CreateCustomMatchListColumn';
  data: CustomMatchListColumn;
}

export interface CreateCustomThreatIntelSource {
  __typename: 'CreateCustomThreatIntelSource';
  data: ThreatIntelSource;
}

export interface CreateCustomYaraSource {
  __typename: 'CreateCustomYaraSource';
  data: YaraSource;
}

export interface CreateCustomerSourcedEntityLookupTable {
  __typename: 'CreateCustomerSourcedEntityLookupTable';
  data: CustomerSourcedEntityLookupTable;
}

export interface CreateCustomerSourcedEntityLookupTableFields {
  keyColumnName: Scalars['String']['input'];
  sourceCategory?: InputMaybe<Scalars['String']['input']>;
  tablePath: Scalars['String']['input'];
  type: EntityLookupTableType;
  valueColumnName: Scalars['String']['input'];
}

export interface CreateEntityCriticalityConfig {
  __typename: 'CreateEntityCriticalityConfig';
  data: EntityCriticalityConfig;
}

export interface CreateEntityCriticalityConfigFields {
  name: Scalars['String']['input'];
  severityExpression: Scalars['String']['input'];
}

export interface CreateEntityValueEntityGroupConfiguration {
  __typename: 'CreateEntityValueEntityGroupConfiguration';
  data: EntityGroupConfiguration;
}

export interface CreateFavoriteField {
  __typename: 'CreateFavoriteField';
  data: FavoriteField;
}

export interface CreateFirstSeenRule {
  __typename: 'CreateFirstSeenRule';
  data: FirstSeenRule;
}

export interface CreateFirstSeenRuleFields {
  assetField?: InputMaybe<Scalars['String']['input']>;
  baselineType?: InputMaybe<FirstSeenRuleBaselineType>;
  baselineWindowSize: Scalars['BigInt']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  descriptionExpression: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  filterExpression: Scalars['String']['input'];
  groupByFields: Array<Scalars['String']['input']>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nameExpression: Scalars['String']['input'];
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  retentionWindowSize: Scalars['BigInt']['input'];
  score: Scalars['Int']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  valueExpression?: InputMaybe<Scalars['String']['input']>;
  valueFields?: InputMaybe<Array<Scalars['String']['input']>>;
  version?: Scalars['Int']['input'];
}

export interface CreateGithubYaraSource {
  __typename: 'CreateGithubYaraSource';
  data: YaraSource;
}

export interface CreateIdefenseThreatIntelSource {
  __typename: 'CreateIdefenseThreatIntelSource';
  data: ThreatIntelSource;
}

export interface CreateIncidentFromInsight {
  __typename: 'CreateIncidentFromInsight';
  data: Insight;
}

export interface CreateInsightFromSignal {
  __typename: 'CreateInsightFromSignal';
  data: Insight;
}

export interface CreateInsightFromSignals {
  __typename: 'CreateInsightFromSignals';
  data: Insight;
}

export interface CreateInsightResolution {
  __typename: 'CreateInsightResolution';
  data: InsightResolution;
}

export interface CreateInsightResolutionFields {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
}

export interface CreateInsightStatus {
  __typename: 'CreateInsightStatus';
  data: InsightStatus;
}

export interface CreateInsightStatusFields {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
}

export interface CreateInventoryEntityGroupConfiguration {
  __typename: 'CreateInventoryEntityGroupConfiguration';
  data: EntityGroupConfiguration;
}

export interface CreateInventoryEntityLookupTable {
  __typename: 'CreateInventoryEntityLookupTable';
  data: InventoryEntityLookupTable;
}

export interface CreateInventoryEntityLookupTableFields {
  inventorySource: Scalars['String']['input'];
  sourceCategory?: InputMaybe<Scalars['String']['input']>;
  tablePath: Scalars['String']['input'];
  type: EntityLookupTableType;
}

export interface CreateLogMapping {
  __typename: 'CreateLogMapping';
  data: LogMapping;
}

export interface CreateLogMappingFields {
  enabled: Scalars['Boolean']['input'];
  fields: Array<LogMappingFieldFields>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  productGuid: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
  relatesEntities?: InputMaybe<Scalars['Boolean']['input']>;
  skippedValues?: InputMaybe<Array<Scalars['String']['input']>>;
  structuredFields?: InputMaybe<LogMappingStructuredInputFields>;
  structuredInputs?: InputMaybe<Array<LogMappingStructuredInputFields>>;
  unstructuredFields?: InputMaybe<UnstructuredLogMappingFields>;
}

export interface CreateMatchList {
  __typename: 'CreateMatchList';
  data: MatchList;
}

export interface CreateMatchRule {
  __typename: 'CreateMatchRule';
  data: MatchRule;
}

export interface CreateMatchRuleFields {
  assetField?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  expression: Scalars['String']['input'];
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  score: Scalars['Int']['input'];
  stream: Scalars['String']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

export interface CreateNetworkBlock {
  __typename: 'CreateNetworkBlock';
  data: NetworkBlock;
}

export interface CreateOutlierRule {
  __typename: 'CreateOutlierRule';
  data: OutlierRule;
}

export interface CreateOutlierRuleFields {
  aggregationFunctions: Array<OutlierRuleAggregationFunctionField>;
  assetField?: InputMaybe<Scalars['String']['input']>;
  baselineWindowSize: Scalars['BigInt']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  descriptionExpression: Scalars['String']['input'];
  deviationThreshold: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  floorValue: Scalars['Int']['input'];
  groupByFields: Array<Scalars['String']['input']>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  matchExpression: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nameExpression: Scalars['String']['input'];
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  retentionWindowSize: Scalars['BigInt']['input'];
  score: Scalars['Int']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  windowSize: RuleWindowSizeEnum;
  windowSizeMilliseconds?: InputMaybe<Scalars['BigInt']['input']>;
}

export interface CreateRecordArtifactConfig {
  __typename: 'CreateRecordArtifactConfig';
  data: RecordArtifactConfig;
}

export interface CreateRole {
  __typename: 'CreateRole';
  data: Role;
}

export interface CreateRoleFields {
  name: Scalars['String']['input'];
  permissions: Array<Scalars['ID']['input']>;
}

export interface CreateRuleTuningExpression {
  __typename: 'CreateRuleTuningExpression';
  data: RuleTuningExpression;
}

export interface CreateRuleTuningExpressionFields {
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  exclude: Scalars['Boolean']['input'];
  expression: Scalars['String']['input'];
  isGlobal: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  ruleIds: Array<Scalars['ID']['input']>;
}

export interface CreateStreamingExportConfiguration {
  __typename: 'CreateStreamingExportConfiguration';
  data: StreamingExportConfiguration;
}

export interface CreateSumoMapping {
  __typename: 'CreateSumoMapping';
  data: SumoMapping;
}

export interface CreateSuppressList {
  __typename: 'CreateSuppressList';
  data: SuppressList;
}

export interface CreateTagSchema {
  __typename: 'CreateTagSchema';
  data: TagSchema;
}

export interface CreateTagSchemaFields {
  contentTypes?: InputMaybe<Array<TagContentType>>;
  freeform: Scalars['Boolean']['input'];
  key: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  valueOptions?: InputMaybe<Array<TagSchemaValueOptionFields>>;
}

export interface CreateTaxiiThreatIntelSource {
  __typename: 'CreateTaxiiThreatIntelSource';
  data: ThreatIntelSource;
}

export interface CreateTemplatedMatchRule {
  __typename: 'CreateTemplatedMatchRule';
  data: TemplatedMatchRule;
}

export interface CreateTemplatedMatchRuleFields {
  assetField?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  descriptionExpression: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  expression: Scalars['String']['input'];
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nameExpression: Scalars['String']['input'];
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  scoreMapping: RuleScoreMappingFields;
  stream: Scalars['String']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

export interface CreateThreatQThreatIntelSource {
  __typename: 'CreateThreatQThreatIntelSource';
  data: ThreatIntelSource;
}

export interface CreateThresholdRule {
  __typename: 'CreateThresholdRule';
  data: ThresholdRule;
}

export interface CreateThresholdRuleFields {
  assetField?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  countDistinct: Scalars['Boolean']['input'];
  countField?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  expression: Scalars['String']['input'];
  groupByFields?: InputMaybe<Array<Scalars['String']['input']>>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  score: Scalars['Int']['input'];
  stream: Scalars['String']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  version: Scalars['Int']['input'];
  windowSize: RuleWindowSizeEnum;
  windowSizeMilliseconds?: InputMaybe<Scalars['BigInt']['input']>;
}

export interface CreditSubscription {
  __typename: 'CreditSubscription';
  allocatedCredits?: Maybe<Scalars['Int']['output']>;
  baselines: BaseLines;
  credits: Scalars['Int']['output'];
  deploymentChargeCredits?: Maybe<Scalars['Int']['output']>;
  endDate: Scalars['String']['output'];
  plan: CreditSubscriptionPlan;
  startDate: Scalars['String']['output'];
  status: CreditSubscriptionStatus;
}

export interface CreditSubscriptionPlan {
  planName: Scalars['String']['output'];
}

export enum CreditSubscriptionStatus {
  Active = 'Active',
  Canceled = 'Canceled',
  Draft = 'Draft',
  Error = 'Error'
}

export interface CurrentUser {
  __typename: 'CurrentUser';
  accountNotificationsEnabled: Scalars['Boolean']['output'];
  active: Scalars['Boolean']['output'];
  apiKey: Scalars['String']['output'];
  apiKeyEnabled: Scalars['Boolean']['output'];
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailConfirmed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insightReportNotificationInterval: NotificationInterval;
  intercomUserHash: Scalars['String']['output'];
  lastActive?: Maybe<Scalars['DateTime']['output']>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  mfaEnabled: Scalars['Boolean']['output'];
  mfaQrCodeUrl?: Maybe<Scalars['String']['output']>;
  mfaSecret?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions: Array<Scalars['String']['output']>;
  preferredDateFormat?: Maybe<Scalars['String']['output']>;
  preferredTimezone?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  showTimezoneOffset?: Maybe<Scalars['Boolean']['output']>;
  teams: Array<Scalars['String']['output']>;
  username: Scalars['String']['output'];
}

export interface CurrentUserSumo {
  __typename: 'CurrentUserSumo';
  accountOwner: Scalars['Boolean']['output'];
  accountStatus: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  authenticationSource: Scalars['String']['output'];
  canManageUsers: Scalars['Boolean']['output'];
  daysUntilPasswordExpires: Scalars['Int']['output'];
  defaultLoginUrl?: Maybe<Scalars['String']['output']>;
  demoConversionLink: Scalars['String']['output'];
  demoUser: Scalars['Boolean']['output'];
  deployment: Scalars['String']['output'];
  dynamicProperties: Scalars['JSONObject']['output'];
  eligibleForSelfServe: Scalars['Boolean']['output'];
  emailVerified: Scalars['Boolean']['output'];
  featureFlags?: Maybe<Array<Scalars['String']['output']>>;
  firstName: Scalars['String']['output'];
  helpBaseUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isChildOrgUser: Scalars['Boolean']['output'];
  isInitialSetupRequired: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  manageAnomaly: Scalars['Boolean']['output'];
  manageCollectors: Scalars['Boolean']['output'];
  maximumNumberOfUsers: Scalars['Int']['output'];
  mfaAllowed: Scalars['Boolean']['output'];
  mfaCanDisable: Scalars['Boolean']['output'];
  mfaEnabled: Scalars['Boolean']['output'];
  mspLogoImagePath?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orgCreationDate: Scalars['Timestamp']['output'];
  organization: Scalars['String']['output'];
  organizationId: Scalars['Int']['output'];
  partner: Scalars['String']['output'];
  partnerKnobs?: Maybe<Scalars['String']['output']>;
  permissions: Array<Scalars['String']['output']>;
  readAnomaly: Scalars['Boolean']['output'];
  readCollectors: Scalars['Boolean']['output'];
  requiresNewPassword: Scalars['Boolean']['output'];
  roles?: Maybe<Array<Scalars['String']['output']>>;
  samlEnabled: Scalars['Boolean']['output'];
  samlLockdownEnabled: Scalars['Boolean']['output'];
  samlLockdownUser: Scalars['Boolean']['output'];
  serverTimestamp: Scalars['Int']['output'];
  showDemoOverview: Scalars['Boolean']['output'];
  slaAccepted: Scalars['Boolean']['output'];
  switchableOrgs: Array<SwitchableOrg>;
  systemVersion: Scalars['String']['output'];
  usageStatus: Scalars['String']['output'];
  userCreationTime: Scalars['Int']['output'];
  userHashForIntercom: Scalars['String']['output'];
  userIdForIntercom: Scalars['String']['output'];
}

export interface CustomEntityType {
  __typename: 'CustomEntityType';
  fields: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface CustomEntityTypePage {
  __typename: 'CustomEntityTypePage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<CustomEntityType>;
  total: Scalars['Int']['output'];
}

export interface CustomInsight {
  __typename: 'CustomInsight';
  created: Scalars['DateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  dynamicSeverity?: Maybe<Array<DynamicInsightSeverity>>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  ordered: Scalars['Boolean']['output'];
  ruleIds: Array<Scalars['String']['output']>;
  severity: InsightSeverityPyEnum;
  signalMatchStrategy?: Maybe<CustomInsightSignalMatchStrategy>;
  signalNames: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
}

export interface CustomInsightPage {
  __typename: 'CustomInsightPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<CustomInsight>;
  total: Scalars['Int']['output'];
}

export enum CustomInsightSignalMatchStrategy {
  Entity = 'ENTITY',
  Strict = 'STRICT'
}

export interface CustomMatchListColumn {
  __typename: 'CustomMatchListColumn';
  fields: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
}

export interface CustomMatchListColumnFields {
  fields: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
}

export interface CustomStatusCount {
  __typename: 'CustomStatusCount';
  count: Scalars['Int']['output'];
  statusId: Scalars['Int']['output'];
  statusName: Scalars['String']['output'];
}

export interface CustomThreatIntelSourceFields {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
}

export interface CustomYaraRuleFields {
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  expression: Scalars['String']['input'];
  severity: Scalars['Int']['input'];
}

export interface CustomYaraSourceFields {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
}

export interface CustomerSourcedEntityLookupTable {
  __typename: 'CustomerSourcedEntityLookupTable';
  contentId: Scalars['String']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  keyColumnName: Scalars['String']['output'];
  sourceCategory?: Maybe<Scalars['String']['output']>;
  tableId: Scalars['String']['output'];
  tablePath?: Maybe<Scalars['String']['output']>;
  type: EntityLookupTableType;
  valueColumnName: Scalars['String']['output'];
}

export interface Dashboard extends Folderable {
  __typename: 'Dashboard';
  accessKey?: Maybe<Scalars['String']['output']>;
  actions?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['BigInt']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  modifiedAt?: Maybe<Scalars['BigInt']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['BigInt']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  relativePath?: Maybe<Array<PathElement>>;
  runAsIdOverride?: Maybe<Scalars['BigInt']['output']>;
  sharedAt?: Maybe<Scalars['BigInt']['output']>;
  sharerId?: Maybe<Scalars['BigInt']['output']>;
  sharerName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  useViewerRbac?: Maybe<Scalars['Boolean']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
}

export interface DashboardRecentItem extends RecentItem {
  __typename: 'DashboardRecentItem';
  accessKey?: Maybe<Scalars['String']['output']>;
  accessTime: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  pageType: RecentPageType;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  runAsIdOverride?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
}

export interface DashboardRecentItemFields {
  accessKey?: InputMaybe<Scalars['String']['input']>;
  accessTime: Scalars['Timestamp']['input'];
  /** @deprecated use owner instead */
  author?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use ownerId instead */
  authorId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Will no longer be used */
  customerId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['BigInt']['input']>;
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  ownerId?: InputMaybe<Scalars['String']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  pageType: RecentPageType;
  runAsIdOverride?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated Will no longer be used */
  url?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
}

export interface DateTimeRange {
  __typename: 'DateTimeRange';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
}

export interface DeleteAction {
  __typename: 'DeleteAction';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteAutomation {
  __typename: 'DeleteAutomation';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteContextAction {
  __typename: 'DeleteContextAction';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteCustomEntityType {
  __typename: 'DeleteCustomEntityType';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteCustomInsight {
  __typename: 'DeleteCustomInsight';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteCustomMatchListColumn {
  __typename: 'DeleteCustomMatchListColumn';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteCustomYaraRule {
  __typename: 'DeleteCustomYaraRule';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteCustomerSourcedEntityLookupTable {
  __typename: 'DeleteCustomerSourcedEntityLookupTable';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteEntityCriticalityConfig {
  __typename: 'DeleteEntityCriticalityConfig';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteEntityGroupConfiguration {
  __typename: 'DeleteEntityGroupConfiguration';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteEntityNote {
  __typename: 'DeleteEntityNote';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteFavoriteField {
  __typename: 'DeleteFavoriteField';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteInsight {
  __typename: 'DeleteInsight';
  data: Scalars['ID']['output'];
}

export interface DeleteInsightComment {
  __typename: 'DeleteInsightComment';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteInsightResolution {
  __typename: 'DeleteInsightResolution';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteInsightStatus {
  __typename: 'DeleteInsightStatus';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteInsightsById {
  __typename: 'DeleteInsightsById';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteInventoryEntityLookupTable {
  __typename: 'DeleteInventoryEntityLookupTable';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteLogMapping {
  __typename: 'DeleteLogMapping';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteMatchList {
  __typename: 'DeleteMatchList';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteMatchListItem {
  __typename: 'DeleteMatchListItem';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteNetworkBlock {
  __typename: 'DeleteNetworkBlock';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteRecordArtifactConfig {
  __typename: 'DeleteRecordArtifactConfig';
  data: Scalars['ID']['output'];
}

export interface DeleteRole {
  __typename: 'DeleteRole';
  data: Role;
}

export interface DeleteRule {
  __typename: 'DeleteRule';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteRuleTuningExpression {
  __typename: 'DeleteRuleTuningExpression';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteStreamingExportConfiguration {
  __typename: 'DeleteStreamingExportConfiguration';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteSumoMapping {
  __typename: 'DeleteSumoMapping';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteSuppressList {
  __typename: 'DeleteSuppressList';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteSuppressListItem {
  __typename: 'DeleteSuppressListItem';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteTagSchema {
  __typename: 'DeleteTagSchema';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteThreatIntelItem {
  __typename: 'DeleteThreatIntelItem';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteThreatIntelSource {
  __typename: 'DeleteThreatIntelSource';
  ok: Scalars['Boolean']['output'];
}

export interface DeleteYaraSource {
  __typename: 'DeleteYaraSource';
  ok: Scalars['Boolean']['output'];
}

export interface DomainMapping {
  __typename: 'DomainMapping';
  normalizedDomain: Scalars['String']['output'];
  rawDomain: Scalars['String']['output'];
}

export interface DomainMappingFields {
  normalizedDomain: Scalars['String']['input'];
  rawDomain: Scalars['String']['input'];
}

export interface Download {
  __typename: 'Download';
  checksum?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  environment?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isRecommendedVersion?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  s3Url?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['String']['output']>;
}

export interface DynamicInsightSeverity {
  __typename: 'DynamicInsightSeverity';
  insightSeverity: InsightSeverityPyEnum;
  minimumSignalSeverity: Scalars['Int']['output'];
}

export interface DynamicInsightSeverityField {
  insightSeverity: InsightSeverityPyEnum;
  minimumSignalSeverity: Scalars['Int']['input'];
}

export interface EnforcedOutputField {
  __typename: 'EnforcedOutputField';
  enforcedOutputs: Array<Maybe<Scalars['String']['output']>>;
  field: Scalars['String']['output'];
}

export interface Enrichment {
  __typename: 'Enrichment';
  detail: Scalars['String']['output'];
  detailJson: Scalars['String']['output'];
  enrichedObjId: Scalars['String']['output'];
  enrichedObjType: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  normalizedIndicator?: Maybe<NormalizedIndicator>;
  raw?: Maybe<Scalars['String']['output']>;
  reputation?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export interface EnrichmentConfig {
  __typename: 'EnrichmentConfig';
  enrichment: Scalars['JSONString']['output'];
  virustotalEnabled: Scalars['Boolean']['output'];
}

export interface EntityAuditLog {
  __typename: 'EntityAuditLog';
  action: EntityAuditLogAction;
  id: Scalars['ID']['output'];
  metaJson: Scalars['String']['output'];
  suppressedComment?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  user: User;
  username: Scalars['String']['output'];
}

export enum EntityAuditLogAction {
  Criticality = 'CRITICALITY',
  Tags = 'TAGS',
  Unwhitelist = 'UNWHITELIST',
  Whitelist = 'WHITELIST'
}

export interface EntityChangeHistory {
  __typename: 'EntityChangeHistory';
  action: EntityChangeHistoryAction;
  fieldName: Scalars['String']['output'];
  newValue: Scalars['String']['output'];
  oldValue?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
}

export enum EntityChangeHistoryAction {
  Add = 'ADD',
  Change = 'CHANGE'
}

export interface EntityCriticalityConfig {
  __typename: 'EntityCriticalityConfig';
  entityCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  severityExpression: Scalars['String']['output'];
}

export interface EntityCriticalityConfigPage {
  __typename: 'EntityCriticalityConfigPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<EntityCriticalityConfig>;
  total: Scalars['Int']['output'];
}

export interface EntityDomainConfiguration {
  __typename: 'EntityDomainConfiguration';
  adDomainNormalizationEnabled: Scalars['Boolean']['output'];
  awsNormalizationEnabled: Scalars['Boolean']['output'];
  defaultNormalizedDomain?: Maybe<Scalars['String']['output']>;
  domainMappings: Array<DomainMapping>;
  fqdnNormalizationEnabled: Scalars['Boolean']['output'];
  normalizeHostnames: Scalars['Boolean']['output'];
  normalizeUsernames: Scalars['Boolean']['output'];
}

export interface EntityDomainConfigurationFields {
  adDomainNormalizationEnabled: Scalars['Boolean']['input'];
  awsNormalizationEnabled: Scalars['Boolean']['input'];
  defaultNormalizedDomain?: InputMaybe<Scalars['String']['input']>;
  domainMappings: Array<DomainMappingFields>;
  fqdnNormalizationEnabled: Scalars['Boolean']['input'];
  normalizeHostnames: Scalars['Boolean']['input'];
  normalizeUsernames: Scalars['Boolean']['input'];
}

export interface EntityFieldAndType {
  __typename: 'EntityFieldAndType';
  field: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface EntityGroupConfiguration {
  __typename: 'EntityGroupConfiguration';
  configurationType: EntityGroupConfigurationType;
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  criticality?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dynamicTags?: Maybe<Scalars['Boolean']['output']>;
  entityNamespace?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inventoryKey?: Maybe<Scalars['String']['output']>;
  inventorySource?: Maybe<Scalars['String']['output']>;
  inventoryType?: Maybe<EntityGroupConfigurationInventoryType>;
  inventoryValue?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  networkBlock?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  suppressed?: Maybe<Scalars['Boolean']['output']>;
  tagSchema?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
}

export enum EntityGroupConfigurationInventoryType {
  Computer = 'computer',
  User = 'user'
}

export interface EntityGroupConfigurationPage {
  __typename: 'EntityGroupConfigurationPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<EntityGroupConfiguration>;
  total: Scalars['Int']['output'];
}

export interface EntityGroupConfigurationSort {
  direction?: SortDir;
  field?: EntityGroupConfigurationSortableField;
}

export enum EntityGroupConfigurationSortableField {
  ConfigurationType = 'CONFIGURATION_TYPE',
  Created = 'CREATED',
  Criticality = 'CRITICALITY',
  EntityType = 'ENTITY_TYPE',
  InventoryType = 'INVENTORY_TYPE',
  Name = 'NAME',
  NetworkBlock = 'NETWORK_BLOCK',
  Prefix = 'PREFIX',
  Suffix = 'SUFFIX',
  Suppressed = 'SUPPRESSED'
}

export enum EntityGroupConfigurationType {
  EntityValue = 'ENTITY_VALUE',
  Inventory = 'INVENTORY'
}

export interface EntityInterface {
  __typename: 'EntityInterface';
  activityScore: Scalars['Int']['output'];
  auditLog: Array<EntityAuditLog>;
  changeHistory: Array<EntityChangeHistory>;
  criticality?: Maybe<Scalars['String']['output']>;
  currentEntity?: Maybe<Scalars['String']['output']>;
  currentStateSignalIds: Array<Scalars['String']['output']>;
  currentStateSignals: Array<Signal>;
  enrichments: Array<Enrichment>;
  entityType: Scalars['String']['output'];
  entityTypeName: Scalars['String']['output'];
  entityTypeObject?: Maybe<CustomEntityType>;
  executedAutomations: Array<ExecutedAutomation>;
  firstSeen?: Maybe<Scalars['DateTime']['output']>;
  hasIndicator: Scalars['Boolean']['output'];
  /** @deprecated Deprecated in favor of value */
  hostname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insights: InsightPage;
  inventory: Array<Inventory>;
  involvedEntities: Array<EntityInterface>;
  involvedSignals: SignalPage;
  ipAddressDetails?: Maybe<IpAddress>;
  isWhitelisted: Scalars['Boolean']['output'];
  lastSeen?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Deprecated in favor of value */
  macAddress?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of value */
  name: Scalars['String']['output'];
  networkBlocks: Array<NetworkBlock>;
  notes?: Maybe<Array<EntityNote>>;
  recentSignalSeverity: Scalars['Int']['output'];
  relatedEntities: Array<EntityInterface>;
  reputation?: Maybe<Scalars['String']['output']>;
  reputationSources: Array<EntityReputationSource>;
  sensorZone?: Maybe<Scalars['String']['output']>;
  signals: Array<Signal>;
  signalsV2: SignalPage;
  sources?: Maybe<Array<EntityMetadataSource>>;
  /** @deprecated Deprecated in favor of suppressListsObj */
  suppressLists: Array<Scalars['String']['output']>;
  suppressListsObj: Array<SuppressList>;
  tags: Array<Scalars['String']['output']>;
  value: Scalars['String']['output'];
  whitelistedComment?: Maybe<Scalars['String']['output']>;
}


export interface EntityInterfaceAuditLogArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<SortDir>;
}


export interface EntityInterfaceChangeHistoryArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface EntityInterfaceInsightsArgs {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InsightSort>>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  uniqueResults?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface EntityInterfaceInvolvedEntitiesArgs {
  end: Scalars['DateTime']['input'];
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  start: Scalars['DateTime']['input'];
}


export interface EntityInterfaceInvolvedSignalsArgs {
  insightId: Scalars['ID']['input'];
}


export interface EntityInterfaceRelatedEntitiesArgs {
  end: Scalars['DateTime']['input'];
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  start: Scalars['DateTime']['input'];
}


export interface EntityInterfaceSignalsArgs {
  hasInsight?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SignalSort>>;
}


export interface EntityInterfaceSignalsV2Args {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  hasInsight?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SignalSort>>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  uniqueResults?: InputMaybe<Scalars['Boolean']['input']>;
}

export enum EntityLookupTableType {
  HostIdToHostname = 'hostIdToHostname',
  UserIdToUsername = 'userIdToUsername',
  UsernameToUsername = 'usernameToUsername'
}

export interface EntityMetadataSource {
  __typename: 'EntityMetadataSource';
  criticality?: Maybe<Scalars['String']['output']>;
  entityGroupConfigurationId?: Maybe<Scalars['String']['output']>;
  entityGroupConfigurationName?: Maybe<Scalars['String']['output']>;
  sourceType: Scalars['String']['output'];
  suppressed?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<Scalars['String']['output']>;
}

export interface EntityNote {
  __typename: 'EntityNote';
  author?: Maybe<User>;
  id: Scalars['ID']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  note: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
}

export interface EntityPage {
  __typename: 'EntityPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<EntityInterface>;
  total: Scalars['Int']['output'];
}

export enum EntityReputationSource {
  Enrichment = 'ENRICHMENT',
  ThreatIntelligence = 'THREAT_INTELLIGENCE'
}

export interface EntitySelectorsRuleOverride {
  __typename: 'EntitySelectorsRuleOverride';
  original?: Maybe<Array<OutputEntitySelectorType>>;
  override?: Maybe<Array<OutputEntitySelectorType>>;
}

export interface EntitySort {
  direction?: SortDir;
  field?: EntitySortableField;
}

export enum EntitySortableField {
  ActivityScore = 'ACTIVITY_SCORE',
  Hostname = 'HOSTNAME',
  IpAddress = 'IP_ADDRESS',
  LastSeen = 'LAST_SEEN',
  Name = 'NAME',
  Os = 'OS',
  RecentSignalSeverity = 'RECENT_SIGNAL_SEVERITY',
  Relevance = 'RELEVANCE',
  Type = 'TYPE'
}

export interface EntityTagOption {
  __typename: 'EntityTagOption';
  label?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
}

export interface EntityTimelineGroup {
  __typename: 'EntityTimelineGroup';
  endTimestamp: Scalars['DateTime']['output'];
  recordCount: Scalars['Int']['output'];
  startTimestamp: Scalars['DateTime']['output'];
  summary: Scalars['String']['output'];
  uids: Array<Scalars['String']['output']>;
}

export interface EntityValueEntityGroupConfigurationFields {
  configurationType: EntityGroupConfigurationType;
  criticality?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityNamespace?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  networkBlock?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  suppressed?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface ExecuteAction {
  __typename: 'ExecuteAction';
  ok: Scalars['Boolean']['output'];
}

export interface ExecuteAutomation {
  __typename: 'ExecuteAutomation';
  executionIds?: Maybe<Array<Scalars['String']['output']>>;
  playbooksWithErrors?: Maybe<Array<Scalars['String']['output']>>;
}

export interface ExecuteAutomationFields {
  automationIds: Array<Scalars['String']['input']>;
  executionCseResources: Array<ExecutionCseResource>;
}

export interface ExecutedAutomation {
  __typename: 'ExecutedAutomation';
  cseResourceId: Scalars['String']['output'];
  cseResourceType: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  executionId: Scalars['String']['output'];
  playbookDescription?: Maybe<Scalars['String']['output']>;
  playbookId: Scalars['String']['output'];
  playbookName: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  statusCode?: Maybe<Scalars['Int']['output']>;
}

export interface ExecutionCseResource {
  cseResourceType: Scalars['String']['input'];
  id: Scalars['String']['input'];
}

export interface ExpressionAndLimitsRuleOverride {
  __typename: 'ExpressionAndLimitsRuleOverride';
  original?: Maybe<Array<ChainRuleExpressionAndLimit>>;
  override?: Maybe<Array<ChainRuleExpressionAndLimit>>;
}

export interface FavoriteField {
  __typename: 'FavoriteField';
  applyToAllObjectTypes: Scalars['Boolean']['output'];
  associatedObjectTypes: Array<Scalars['String']['output']>;
  fieldName: Scalars['String']['output'];
  fieldType: FavoriteFieldType;
  id: Scalars['ID']['output'];
}

export interface FavoriteFieldPage {
  __typename: 'FavoriteFieldPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<FavoriteField>;
  total: Scalars['Int']['output'];
}

export interface FavoriteFieldSort {
  direction?: SortDir;
  field?: FavoriteFieldSortableField;
}

export enum FavoriteFieldSortableField {
  ApplyToAllObjectTypes = 'APPLY_TO_ALL_OBJECT_TYPES',
  FieldName = 'FIELD_NAME'
}

export enum FavoriteFieldType {
  Inventory = 'INVENTORY',
  Record = 'RECORD'
}

export interface FeatureActivation {
  __typename: 'FeatureActivation';
  cse?: Maybe<Scalars['Boolean']['output']>;
}

export enum FeatureFlag {
  BulkInsightActions = 'BULK_INSIGHT_ACTIONS',
  BulkSignalActions = 'BULK_SIGNAL_ACTIONS',
  CloudSoarIntegration = 'CLOUD_SOAR_INTEGRATION',
  ContextActionQuery = 'CONTEXT_ACTION_QUERY',
  CustomEntityType = 'CUSTOM_ENTITY_TYPE',
  CustomInsightResolutions = 'CUSTOM_INSIGHT_RESOLUTIONS',
  CustomInsightStatusOrder = 'CUSTOM_INSIGHT_STATUS_ORDER',
  CustomMappings = 'CUSTOM_MAPPINGS',
  EntityCriticality = 'ENTITY_CRITICALITY',
  ExportSourceCategoryConfigurable = 'EXPORT_SOURCE_CATEGORY_CONFIGURABLE',
  FavoriteFields = 'FAVORITE_FIELDS',
  FavoriteFieldsConfig = 'FAVORITE_FIELDS_CONFIG',
  GisInsightConfidence = 'GIS_INSIGHT_CONFIDENCE',
  GlobalContentEnabledByDefault = 'GLOBAL_CONTENT_ENABLED_BY_DEFAULT',
  HideZeppelin = 'HIDE_ZEPPELIN',
  InsightMetrics = 'INSIGHT_METRICS',
  Inventory = 'INVENTORY',
  OnePlatform = 'ONE_PLATFORM',
  OverrideGlobalRule = 'OVERRIDE_GLOBAL_RULE',
  RecordsInCepSignals = 'RECORDS_IN_CEP_SIGNALS',
  RecordArtifacts = 'RECORD_ARTIFACTS',
  RecordSearch = 'RECORD_SEARCH',
  RecordSearchConfiguration = 'RECORD_SEARCH_CONFIGURATION',
  RelatedEntities = 'RELATED_ENTITIES',
  RequireCloudSensorSumoUrl = 'REQUIRE_CLOUD_SENSOR_SUMO_URL',
  RuleErrors = 'RULE_ERRORS',
  RuleTesting = 'RULE_TESTING',
  RuleTuningExpressions = 'RULE_TUNING_EXPRESSIONS',
  SignalSummary = 'SIGNAL_SUMMARY',
  SumoSso = 'SUMO_SSO',
  SuppressLists = 'SUPPRESS_LISTS',
  Tagging = 'TAGGING',
  TestFf1 = 'TEST_FF1',
  TestFf2 = 'TEST_FF2',
  TestFf3 = 'TEST_FF3',
  UnparsedMappings = 'UNPARSED_MAPPINGS',
  ValidateWithSloop = 'VALIDATE_WITH_SLOOP',
  ViewCustomMappings = 'VIEW_CUSTOM_MAPPINGS'
}

export enum FeatureType {
  Cip = 'CIP',
  Csiem = 'CSIEM',
  Csoar = 'CSOAR'
}

export interface FederatedChildOrg {
  __typename: 'FederatedChildOrg';
  deployment: Scalars['String']['output'];
  tenant: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  tenantUrl: Scalars['String']['output'];
}

export interface FieldGroupBy {
  __typename: 'FieldGroupBy';
  fieldName: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface FinishMfaLogin {
  __typename: 'FinishMfaLogin';
  data: CurrentUser;
}

export interface FirstSeenRule extends RuleInterface {
  __typename: 'FirstSeenRule';
  assetField?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of status */
  autoDisabledReason?: Maybe<Scalars['String']['output']>;
  baselineLastStarted?: Maybe<Scalars['DateTime']['output']>;
  baselineStatus: BaselineStatus;
  baselineType: FirstSeenRuleBaselineType;
  baselineWindowSize: Scalars['BigInt']['output'];
  baselineWindowSizeOverride?: Maybe<BigIntRuleOverride>;
  category?: Maybe<Scalars['String']['output']>;
  contentType: ContentType;
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  createdByUser?: Maybe<User>;
  deleted: Scalars['Boolean']['output'];
  descriptionExpression: Scalars['String']['output'];
  descriptionExpressionOverride?: Maybe<StringRuleOverride>;
  enabled: Scalars['Boolean']['output'];
  entitySelectors: Array<OutputEntitySelectorType>;
  entitySelectorsOverride?: Maybe<EntitySelectorsRuleOverride>;
  exportJson: Scalars['String']['output'];
  failing: Scalars['Boolean']['output'];
  filterExpression: Scalars['String']['output'];
  groupByFields: Array<Scalars['String']['output']>;
  groupByFieldsOverride?: Maybe<StringListRuleOverride>;
  hasOverride: Scalars['Boolean']['output'];
  history: Array<RuleHistoryEvent>;
  id: Scalars['ID']['output'];
  isPrototype: Scalars['Boolean']['output'];
  isPrototypeOverride?: Maybe<BooleanRuleOverride>;
  lastUpdated: Scalars['DateTime']['output'];
  lastUpdatedBy: Scalars['String']['output'];
  lastUpdatedByUser?: Maybe<User>;
  name: Scalars['String']['output'];
  nameExpression: Scalars['String']['output'];
  nameExpressionOverride?: Maybe<StringRuleOverride>;
  nameOverride?: Maybe<StringRuleOverride>;
  parentJaskId?: Maybe<Scalars['ID']['output']>;
  rawJson?: Maybe<Scalars['String']['output']>;
  rawStatus?: Maybe<RuleStatus>;
  retentionWindowSize: Scalars['BigInt']['output'];
  retentionWindowSizeOverride?: Maybe<BigIntRuleOverride>;
  ruleDescription?: Maybe<Scalars['String']['output']>;
  ruleId: Scalars['Int']['output'];
  ruleSource: Scalars['String']['output'];
  ruleType: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  scoreOverride?: Maybe<IntRuleOverride>;
  signalCount07d: Scalars['Int']['output'];
  signalCount24h: Scalars['Int']['output'];
  status: RuleStatus;
  summaryExpression: Scalars['String']['output'];
  summaryExpressionOverride?: Maybe<StringRuleOverride>;
  suppressionWindowSize?: Maybe<Scalars['Int']['output']>;
  suppressionWindowSizeOverride?: Maybe<IntRuleOverride>;
  tags: Array<Scalars['String']['output']>;
  tagsOverride?: Maybe<StringListRuleOverride>;
  tuningExpressionIds?: Maybe<Array<Scalars['String']['output']>>;
  tuningExpressions?: Maybe<Array<RuleTuningExpression>>;
  /** @deprecated Deprecated in favour of valueFields */
  valueExpression?: Maybe<Scalars['String']['output']>;
  valueFields?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated Deprecated in favour of self incrementing */
  version: Scalars['Int']['output'];
}

export enum FirstSeenRuleBaselineType {
  Global = 'GLOBAL',
  PerEntity = 'PER_ENTITY'
}

export interface Folder extends Folderable {
  __typename: 'Folder';
  accessKey?: Maybe<Scalars['String']['output']>;
  actions?: Maybe<Array<Scalars['String']['output']>>;
  children?: Maybe<Array<FolderableType>>;
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['BigInt']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  modifiedAt?: Maybe<Scalars['BigInt']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['BigInt']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  relativePath?: Maybe<Array<PathElement>>;
  runAsIdOverride?: Maybe<Scalars['BigInt']['output']>;
  sharedAt?: Maybe<Scalars['BigInt']['output']>;
  sharerId?: Maybe<Scalars['BigInt']['output']>;
  sharerName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  useViewerRbac?: Maybe<Scalars['Boolean']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
}

export interface Folderable {
  accessKey?: Maybe<Scalars['String']['output']>;
  actions?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['BigInt']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  modifiedAt?: Maybe<Scalars['BigInt']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['BigInt']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  relativePath?: Maybe<Array<PathElement>>;
  runAsIdOverride?: Maybe<Scalars['BigInt']['output']>;
  sharedAt?: Maybe<Scalars['BigInt']['output']>;
  sharerId?: Maybe<Scalars['BigInt']['output']>;
  sharerName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  useViewerRbac?: Maybe<Scalars['Boolean']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
}

export type FolderableType = Dashboard | Folder | LookupTable | Metric | MetricV2 | Search;

export interface ForgotPassword {
  __typename: 'ForgotPassword';
  ok: Scalars['Boolean']['output'];
}

export interface GithubYaraSourceFields {
  branch?: InputMaybe<Scalars['String']['input']>;
  defaultSeverity: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
  yaraFileRegex: Scalars['String']['input'];
}

export interface GroupByInput {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  fieldValue?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
}

export interface GroupedInsightPage {
  __typename: 'GroupedInsightPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<Insight>;
  status: InsightStatus;
  total: Scalars['Int']['output'];
}

export interface IpAddress {
  __typename: 'IPAddress';
  accuracyRadius?: Maybe<Scalars['Int']['output']>;
  address: Scalars['String']['output'];
  asn?: Maybe<Scalars['String']['output']>;
  aso?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  continentCode?: Maybe<Scalars['String']['output']>;
  continentName?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Not supported by Sloop */
  isInternal: Scalars['Boolean']['output'];
  isp?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  org?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
}

export interface IdefenseConfig {
  __typename: 'IdefenseConfig';
  apiKey: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
}

export interface IdefenseThreatIntelSourceFields {
  apiKey: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
}

export interface ImportRuleFailure {
  __typename: 'ImportRuleFailure';
  ruleName: Scalars['String']['output'];
}

export interface ImportRules {
  __typename: 'ImportRules';
  failures: Array<ImportRuleFailure>;
  successCount: Scalars['Int']['output'];
}

export interface IncidentSearchResult {
  __typename: 'IncidentSearchResult';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
}

export interface IncidentTemplate {
  __typename: 'IncidentTemplate';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
}

export interface InputEntitySelectorType {
  entityType: Scalars['String']['input'];
  expression: Scalars['String']['input'];
}

export interface Insight {
  __typename: 'Insight';
  allowedNextStatuses: Array<AllowedInsightStatus>;
  artifacts: Array<InsightArtifact>;
  /** @deprecated Use assignee for user or team. */
  assignedTo?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<InsightAssignee>;
  closed?: Maybe<Scalars['DateTime']['output']>;
  closedBy?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use tenant instead */
  cluster?: Maybe<Scalars['String']['output']>;
  comments: Array<InsightComment>;
  confidence?: Maybe<Scalars['Float']['output']>;
  created: Scalars['DateTime']['output'];
  deployment: Scalars['String']['output'];
  description: Scalars['String']['output'];
  duplicateInsight?: Maybe<Insight>;
  duplicateInsightId?: Maybe<Scalars['String']['output']>;
  enrichments: Array<Enrichment>;
  entity: EntityInterface;
  executedAutomations: Array<ExecutedAutomation>;
  firstResponded?: Maybe<Scalars['DateTime']['output']>;
  firstRespondedBy?: Maybe<Scalars['String']['output']>;
  history: Array<InsightHistoryEvent>;
  /** @deprecated Deprecated in favor of readableId */
  id: Scalars['ID']['output'];
  insightSignalSeverityTotal: Scalars['Int']['output'];
  involvedEntities: Array<Maybe<EntityInterface>>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originalSeverity?: Maybe<InsightSeverityPyEnum>;
  readableId: Scalars['String']['output'];
  recordDateTimeRange: DateTimeRange;
  recordSummaryFields: Array<RecordSummaryField>;
  relatedEnrichments: Array<Enrichment>;
  relatedIncidents: Array<RelatedIncident>;
  relatedInsights?: Maybe<Array<Insight>>;
  relatedSignals?: Maybe<Array<Signal>>;
  resolution?: Maybe<Scalars['String']['output']>;
  severity: InsightSeverityPyEnum;
  severityValue: Scalars['Int']['output'];
  signalCount: Scalars['Int']['output'];
  signals: Array<Signal>;
  source: AlertSource;
  status: InsightStatusName;
  subResolution?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  /** @deprecated Use assignee for user or team. */
  teamAssignedTo?: Maybe<Scalars['String']['output']>;
  tenant: Scalars['String']['output'];
  tenantName: Scalars['String']['output'];
  tenantUrl?: Maybe<Scalars['String']['output']>;
  timeToDetection?: Maybe<Scalars['TimeDelta']['output']>;
  timeToRemediation?: Maybe<Scalars['TimeDelta']['output']>;
  timeToResponse?: Maybe<Scalars['TimeDelta']['output']>;
  timestamp: Scalars['DateTime']['output'];
  triage?: Maybe<Triage>;
  uniqueSignalCount: Scalars['Int']['output'];
}


export interface InsightCommentsArgs {
  sortDir?: InputMaybe<SortDir>;
}


export interface InsightHistoryArgs {
  includeSystemCreationEvents?: InputMaybe<Scalars['Boolean']['input']>;
  sortDir?: InputMaybe<SortDir>;
}


export interface InsightRecordSummaryFieldsArgs {
  fieldNames: Array<Scalars['String']['input']>;
}

export interface InsightActivityFeedEvent {
  __typename: 'InsightActivityFeedEvent';
  action: InsightActivityFeedEventAction;
  insightId: Scalars['String']['output'];
  insightName: Scalars['String']['output'];
  insightReadableId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
}

export type InsightActivityFeedEventAction = InsightAssigneeUpdatedAction | InsightCommentAddedAction | InsightCreatedAction | InsightStatusUpdatedAction;

export interface InsightActivityFeedEventPage {
  __typename: 'InsightActivityFeedEventPage';
  nextPageTimestamp?: Maybe<Scalars['DateTime']['output']>;
  objects: Array<InsightActivityFeedEvent>;
}

export interface InsightArtifact {
  __typename: 'InsightArtifact';
  name: Scalars['String']['output'];
  recordStream: Scalars['String']['output'];
  recordUid: Scalars['String']['output'];
  signal: Signal;
  value: Scalars['String']['output'];
}

export type InsightAssignee = Team | UnknownTeam | UnknownUser | User;

export enum InsightAssigneeTypes {
  Team = 'TEAM',
  User = 'USER'
}

export interface InsightAssigneeUpdatedAction {
  __typename: 'InsightAssigneeUpdatedAction';
  assignee?: Maybe<InsightAssignee>;
}

export enum InsightClearableFields {
  Assignee = 'ASSIGNEE'
}

export interface InsightComment {
  __typename: 'InsightComment';
  author?: Maybe<User>;
  body: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
}

export interface InsightCommentAddedAction {
  __typename: 'InsightCommentAddedAction';
  body: Scalars['String']['output'];
}

export interface InsightConfig {
  __typename: 'InsightConfig';
  globalSignalSuppressionWindow?: Maybe<Scalars['Int']['output']>;
  lookbackDays?: Maybe<Scalars['Float']['output']>;
  threshold?: Maybe<Scalars['Float']['output']>;
}

export interface InsightConfigInput {
  globalSignalSuppressionWindow?: InputMaybe<Scalars['Int']['input']>;
  lookbackDays?: InputMaybe<Scalars['Float']['input']>;
  threshold?: InputMaybe<Scalars['Float']['input']>;
}

export interface InsightCountByStatus {
  __typename: 'InsightCountByStatus';
  closed: Scalars['Int']['output'];
  inProgress: Scalars['Int']['output'];
  new: Scalars['Int']['output'];
  other: Scalars['Int']['output'];
  otherDetail?: Maybe<Array<CustomStatusCount>>;
}

export interface InsightCountsByStatusDataPoint {
  __typename: 'InsightCountsByStatusDataPoint';
  timestamp: Scalars['DateTime']['output'];
  value: InsightCountByStatus;
}

export interface InsightCreatedAction {
  __typename: 'InsightCreatedAction';
  source: AlertSource;
}

export interface InsightEditableAssignee {
  type: InsightAssigneeTypes;
  value: Scalars['String']['input'];
}

export interface InsightEditableFields {
  assignee?: InputMaybe<InsightEditableAssignee>;
  duplicateInsightId?: InputMaybe<Scalars['String']['input']>;
  fieldsToClear?: InputMaybe<Array<InsightClearableFields>>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<InsightSeverityPyEnum>;
  status?: InputMaybe<Scalars['String']['input']>;
}

export interface InsightEntityActivity {
  __typename: 'InsightEntityActivity';
  entityId: Scalars['String']['output'];
  involvedSignalIds: Array<Scalars['String']['output']>;
  isPrimaryEntity: Scalars['Boolean']['output'];
  relatedEntityIds: Array<Scalars['String']['output']>;
}

export enum InsightGroupBy {
  Status = 'STATUS'
}

export interface InsightGroupOffset {
  limit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface InsightHistoryEvent {
  __typename: 'InsightHistoryEvent';
  description: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  user?: Maybe<User>;
}

export interface InsightPage {
  __typename: 'InsightPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<Insight>;
  total: Scalars['Int']['output'];
}

export enum InsightRequiredFieldType {
  Comment = 'COMMENT'
}

export interface InsightResolution {
  __typename: 'InsightResolution';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<InsightResolution>;
  parentId?: Maybe<Scalars['Int']['output']>;
  source: Scalars['String']['output'];
  subResolutions: Array<InsightResolution>;
}

export interface InsightResolutionPage {
  __typename: 'InsightResolutionPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<InsightResolution>;
  total: Scalars['Int']['output'];
}

export enum InsightSeverityPyEnum {
  Critical = 'CRITICAL',
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export interface InsightSort {
  direction?: SortDir;
  field?: InsightSortableField;
}

export enum InsightSortableField {
  Assignee = 'ASSIGNEE',
  Confidence = 'CONFIDENCE',
  Created = 'CREATED',
  EntityName = 'ENTITY_NAME',
  Name = 'NAME',
  Relevance = 'RELEVANCE',
  SerialId = 'SERIAL_ID',
  Severity = 'SEVERITY',
  SignalCount = 'SIGNAL_COUNT',
  Status = 'STATUS',
  Timestamp = 'TIMESTAMP',
  TriageVerdict = 'TRIAGE_VERDICT',
  UniqueSignalCount = 'UNIQUE_SIGNAL_COUNT'
}

export interface InsightStatus {
  __typename: 'InsightStatus';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  source: Scalars['String']['output'];
}

export interface InsightStatusName {
  __typename: 'InsightStatusName';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
}

export interface InsightStatusUpdatedAction {
  __typename: 'InsightStatusUpdatedAction';
  status: InsightStatus;
}

export interface InsightTagOption {
  __typename: 'InsightTagOption';
  label?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
}

export interface IntRuleOverride {
  __typename: 'IntRuleOverride';
  original?: Maybe<Scalars['Int']['output']>;
  override?: Maybe<Scalars['Int']['output']>;
}

export type Inventory = ComputerInventory | UserInventory;

export interface InventoryEntityGroupConfigurationFields {
  configurationType: EntityGroupConfigurationType;
  criticality?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dynamicTags?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  inventoryKey?: InputMaybe<Scalars['String']['input']>;
  inventorySource: Scalars['String']['input'];
  inventoryType?: InputMaybe<EntityGroupConfigurationInventoryType>;
  inventoryValue?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  suppressed?: InputMaybe<Scalars['Boolean']['input']>;
  tagSchema?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface InventoryEntityLookupTable {
  __typename: 'InventoryEntityLookupTable';
  contentId: Scalars['String']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inventorySource: Scalars['String']['output'];
  sourceCategory?: Maybe<Scalars['String']['output']>;
  tableId: Scalars['String']['output'];
  tablePath: Scalars['String']['output'];
  type: EntityLookupTableType;
}

export interface InventoryGroupOption {
  __typename: 'InventoryGroupOption';
  value: Scalars['String']['output'];
}

export interface InventoryInterface {
  groups: Array<Scalars['String']['output']>;
  metadataJson: Scalars['String']['output'];
  parsedTime: Scalars['String']['output'];
  source: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  uniqueId: Scalars['String']['output'];
}

export interface InventoryPage {
  __typename: 'InventoryPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<Inventory>;
  total: Scalars['Int']['output'];
}

export interface InventorySort {
  direction?: SortDir;
  field?: InventorySortableField;
}

export enum InventorySortableField {
  Timestamp = 'TIMESTAMP'
}

export interface InviteFailure {
  __typename: 'InviteFailure';
  email: Scalars['String']['output'];
  message: Scalars['String']['output'];
}

export interface InviteUser {
  __typename: 'InviteUser';
  data: UserInvitation;
  ok?: Maybe<Scalars['Boolean']['output']>;
}

export interface InviteUsers {
  __typename: 'InviteUsers';
  data: Array<UserInvitation>;
  failures: Array<InviteFailure>;
}

export interface ItemMeta {
  __typename: 'ItemMeta';
  created?: Maybe<UserAudit>;
  description: Scalars['String']['output'];
  updated?: Maybe<UserAudit>;
}

export interface KeyEvidence {
  __typename: 'KeyEvidence';
  id: Scalars['ID']['output'];
  reasoning: Scalars['String']['output'];
  signalAnalyses: Array<SignalAnalysis>;
  title: Scalars['String']['output'];
  verdict: SimpleVerdict;
}

export interface LibraryGlobalView {
  __typename: 'LibraryGlobalView';
  adminRecommended: Folder;
  installedApps?: Maybe<Folder>;
  users: Folder;
}

export interface LivetailQuery {
  __typename: 'LivetailQuery';
  queryString: Scalars['String']['output'];
  screenId: Scalars['String']['output'];
}

export interface LivetailQueryInput {
  queryString: Scalars['String']['input'];
  screenId: Scalars['String']['input'];
}

export interface LivetailRecentItem extends RecentItem {
  __typename: 'LivetailRecentItem';
  accessKey?: Maybe<Scalars['String']['output']>;
  accessTime: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['Int']['output'];
  livetailQueries: Array<LivetailQuery>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  pageType: RecentPageType;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  runAsIdOverride?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
}

export interface LivetailRecentItemFields {
  accessTime: Scalars['Timestamp']['input'];
  id: Scalars['Int']['input'];
  livetailQueries: Array<LivetailQueryInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageType: RecentPageType;
}

export interface LogMapping {
  __typename: 'LogMapping';
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  eventIdPattern?: Maybe<Scalars['String']['output']>;
  fields: Array<LogMappingField>;
  id: Scalars['String']['output'];
  /** @deprecated Migrated to field(s) on schema. */
  inputJson?: Maybe<Scalars['String']['output']>;
  inputProduct?: Maybe<Scalars['String']['output']>;
  inputVendor?: Maybe<Scalars['String']['output']>;
  isCustom: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isStructured: Scalars['Boolean']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  lastUpdatedBy: Scalars['String']['output'];
  logFormat?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated Migrated to field(s) on schema. */
  outputJson?: Maybe<Scalars['String']['output']>;
  outputProductGuid?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of parsing_patterns */
  parsingPattern?: Maybe<ParsingPattern>;
  parsingPatterns: Array<ParsingPattern>;
  /** @deprecated Deprecated in favor of parsing_patterns */
  patternName?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  recordCount07d: Scalars['BigInt']['output'];
  recordCount24h: Scalars['BigInt']['output'];
  recordType: Scalars['String']['output'];
  relatesEntities: Scalars['Boolean']['output'];
  skippedValues: Array<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  structuredInputs: Array<LogMappingStructuredInput>;
  unstructuredFields?: Maybe<UnstructuredLogMappingFieldsApi>;
  vendor?: Maybe<Scalars['String']['output']>;
}

export interface LogMappingField {
  __typename: 'LogMappingField';
  alternateValues?: Maybe<Array<Scalars['String']['output']>>;
  caseInsensitive?: Maybe<Scalars['Boolean']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  fieldJoin?: Maybe<Array<Scalars['String']['output']>>;
  format?: Maybe<Scalars['String']['output']>;
  formatParameters?: Maybe<Array<Scalars['String']['output']>>;
  joinDelimiter?: Maybe<Scalars['String']['output']>;
  lookup?: Maybe<Array<LogMappingFieldLookupKeyValue>>;
  name: Scalars['String']['output'];
  skippedValues?: Maybe<Array<Scalars['String']['output']>>;
  splitDelimiter?: Maybe<Scalars['String']['output']>;
  splitIndex?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  valueType?: Maybe<Scalars['String']['output']>;
}

export interface LogMappingFieldFields {
  alternateValues?: InputMaybe<Array<Scalars['String']['input']>>;
  caseInsensitive?: InputMaybe<Scalars['Boolean']['input']>;
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  fieldJoin?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Scalars['String']['input']>;
  formatParameters?: InputMaybe<Array<Scalars['String']['input']>>;
  joinDelimiter?: InputMaybe<Scalars['String']['input']>;
  lookup?: InputMaybe<Array<LogMappingFieldLookupKeyValueFields>>;
  name: Scalars['String']['input'];
  skippedValues?: InputMaybe<Array<Scalars['String']['input']>>;
  splitDelimiter?: InputMaybe<Scalars['String']['input']>;
  splitIndex?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
}

export interface LogMappingFieldLookupKeyValue {
  __typename: 'LogMappingFieldLookupKeyValue';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface LogMappingFieldLookupKeyValueFields {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
}

export interface LogMappingFieldValueTypeOption {
  __typename: 'LogMappingFieldValueTypeOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface LogMappingLogFormatOption {
  __typename: 'LogMappingLogFormatOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface LogMappingMappableField {
  __typename: 'LogMappingMappableField';
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface LogMappingOptions {
  __typename: 'LogMappingOptions';
  fieldValueTypeOptions: Array<LogMappingFieldValueTypeOption>;
  logFormatOptions: Array<LogMappingLogFormatOption>;
  parsingPatternOptions: Array<LogMappingParsingPatternOption>;
  recordTypeOptions: Array<LogMappingRecordTypeOption>;
}

export interface LogMappingPage {
  __typename: 'LogMappingPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<LogMapping>;
  total: Scalars['Int']['output'];
}

export interface LogMappingParsingPatternOption {
  __typename: 'LogMappingParsingPatternOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface LogMappingRecordTypeOption {
  __typename: 'LogMappingRecordTypeOption';
  mappableFields: Array<LogMappingMappableField>;
  objectType: Scalars['String']['output'];
}

export interface LogMappingSort {
  direction?: SortDir;
  field?: LogMappingSortableField;
}

export enum LogMappingSortableField {
  Enabled = 'ENABLED',
  IsCustom = 'IS_CUSTOM',
  IsStructured = 'IS_STRUCTURED',
  LogFormat = 'LOG_FORMAT',
  Name = 'NAME',
  Product = 'PRODUCT',
  RecordCount_07D = 'RECORD_COUNT_07D',
  RecordCount_24H = 'RECORD_COUNT_24H',
  RecordType = 'RECORD_TYPE',
  Relevance = 'RELEVANCE',
  Vendor = 'VENDOR'
}

export interface LogMappingStructuredInput {
  __typename: 'LogMappingStructuredInput';
  eventIdPattern: Scalars['String']['output'];
  logFormat: Scalars['String']['output'];
  product: Scalars['String']['output'];
  vendor: Scalars['String']['output'];
}

export interface LogMappingStructuredInputFields {
  eventIdPattern: Scalars['String']['input'];
  logFormat: Scalars['String']['input'];
  product: Scalars['String']['input'];
  vendor: Scalars['String']['input'];
}

export interface LogMappingVendorAndProduct {
  __typename: 'LogMappingVendorAndProduct';
  guid: Scalars['String']['output'];
  product: Scalars['String']['output'];
  vendor: Scalars['String']['output'];
}

export interface LogRecentItem extends RecentItem {
  __typename: 'LogRecentItem';
  accessKey?: Maybe<Scalars['String']['output']>;
  accessTime: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['BigInt']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  pageType: RecentPageType;
  parameters?: Maybe<Array<SearchQueryParameter>>;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  pinned: Scalars['Boolean']['output'];
  query?: Maybe<Scalars['String']['output']>;
  runAsIdOverride?: Maybe<Scalars['Int']['output']>;
  scheduled?: Maybe<Scalars['Boolean']['output']>;
  timeRangeEnd?: Maybe<Scalars['Timestamp']['output']>;
  timeRangeExpression?: Maybe<Scalars['String']['output']>;
  timeRangeStart?: Maybe<Scalars['Timestamp']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
}

export interface LogRecentItemFields {
  accessKey?: InputMaybe<Scalars['String']['input']>;
  accessTime: Scalars['Timestamp']['input'];
  /** @deprecated use owner instead */
  author?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use ownerId instead */
  authorId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Will no longer be used */
  customerId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['BigInt']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** @deprecated use pinned instead */
  metadata?: InputMaybe<LogRecentItemMetadataFields>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  pageType: RecentPageType;
  parameters?: InputMaybe<Array<SearchQueryParameterInput>>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  runAsIdOverride?: InputMaybe<Scalars['Int']['input']>;
  timeRangeEnd?: InputMaybe<Scalars['Timestamp']['input']>;
  timeRangeExpression?: InputMaybe<Scalars['String']['input']>;
  timeRangeStart?: InputMaybe<Scalars['Timestamp']['input']>;
  /** @deprecated Will no longer be used */
  url?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
}

export interface LogRecentItemMetadata {
  __typename: 'LogRecentItemMetadata';
  pinned: Scalars['Boolean']['output'];
  saved: Scalars['Boolean']['output'];
}

export interface LogRecentItemMetadataFields {
  pinned: Scalars['Boolean']['input'];
  saved: Scalars['Boolean']['input'];
}

export interface LoginUser {
  __typename: 'LoginUser';
  data?: Maybe<CurrentUser>;
  mfaQrCode?: Maybe<Scalars['String']['output']>;
  mfaRequired: Scalars['Boolean']['output'];
  mfaSecret?: Maybe<Scalars['String']['output']>;
  mfaSession?: Maybe<Scalars['String']['output']>;
}

export interface LogoutUser {
  __typename: 'LogoutUser';
  redirectUrl: Scalars['String']['output'];
}

export interface LookupTable extends Folderable {
  __typename: 'LookupTable';
  accessKey?: Maybe<Scalars['String']['output']>;
  actions?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['BigInt']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  modifiedAt?: Maybe<Scalars['BigInt']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['BigInt']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  relativePath?: Maybe<Array<PathElement>>;
  runAsIdOverride?: Maybe<Scalars['BigInt']['output']>;
  sharedAt?: Maybe<Scalars['BigInt']['output']>;
  sharerId?: Maybe<Scalars['BigInt']['output']>;
  sharerName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  useViewerRbac?: Maybe<Scalars['Boolean']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
}

export interface MatchList {
  __typename: 'MatchList';
  active: Scalars['Boolean']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  defaultTtl?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items: MatchListItemPage;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  targetColumn: Scalars['String']['output'];
}


export interface MatchListItemsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface MatchListFields {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  defaultTtl?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  targetColumn: Scalars['String']['input'];
}

export interface MatchListItem {
  __typename: 'MatchListItem';
  active: Scalars['Boolean']['output'];
  expiration?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  listId: Scalars['String']['output'];
  meta?: Maybe<ItemMeta>;
  value: Scalars['String']['output'];
}

export interface MatchListItemFields {
  active: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
}

export interface MatchListItemPage {
  __typename: 'MatchListItemPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<MatchListItem>;
  total: Scalars['Int']['output'];
}

export interface MatchListItemSort {
  direction?: SortDir;
  field?: MatchListItemSortableField;
}

export enum MatchListItemSortableField {
  Active = 'ACTIVE',
  Created = 'CREATED',
  Description = 'DESCRIPTION',
  ExpirationDate = 'EXPIRATION_DATE',
  Value = 'VALUE'
}

export interface MatchListPage {
  __typename: 'MatchListPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<MatchList>;
  total: Scalars['Int']['output'];
}

export interface MatchRule extends RuleInterface {
  __typename: 'MatchRule';
  assetField?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of status */
  autoDisabledReason?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  contentType: ContentType;
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  createdByUser?: Maybe<User>;
  deleted: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  entitySelectors: Array<OutputEntitySelectorType>;
  entitySelectorsOverride?: Maybe<EntitySelectorsRuleOverride>;
  exportJson: Scalars['String']['output'];
  expression: Scalars['String']['output'];
  failing: Scalars['Boolean']['output'];
  hasOverride: Scalars['Boolean']['output'];
  history: Array<RuleHistoryEvent>;
  id: Scalars['ID']['output'];
  isPrototype: Scalars['Boolean']['output'];
  isPrototypeOverride?: Maybe<BooleanRuleOverride>;
  lastUpdated: Scalars['DateTime']['output'];
  lastUpdatedBy: Scalars['String']['output'];
  lastUpdatedByUser?: Maybe<User>;
  name: Scalars['String']['output'];
  nameOverride?: Maybe<StringRuleOverride>;
  parentJaskId?: Maybe<Scalars['ID']['output']>;
  rawJson?: Maybe<Scalars['String']['output']>;
  rawStatus?: Maybe<RuleStatus>;
  ruleDescription?: Maybe<Scalars['String']['output']>;
  ruleId: Scalars['Int']['output'];
  ruleSource: Scalars['String']['output'];
  ruleType: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  signalCount07d: Scalars['Int']['output'];
  signalCount24h: Scalars['Int']['output'];
  status: RuleStatus;
  stream: Scalars['String']['output'];
  summaryExpression: Scalars['String']['output'];
  summaryExpressionOverride?: Maybe<StringRuleOverride>;
  suppressionWindowSize?: Maybe<Scalars['Int']['output']>;
  suppressionWindowSizeOverride?: Maybe<IntRuleOverride>;
  tags: Array<Scalars['String']['output']>;
  tagsOverride?: Maybe<StringListRuleOverride>;
  tuningExpressionIds?: Maybe<Array<Scalars['String']['output']>>;
  tuningExpressions?: Maybe<Array<RuleTuningExpression>>;
}

export interface MatchRuleFields {
  assetField?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  expression: Scalars['String']['input'];
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  score: Scalars['Int']['input'];
  stream: Scalars['String']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

export interface MatchedField {
  __typename: 'MatchedField';
  characterRanges: Array<MatchedFieldCharacterRange>;
  exact: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface MatchedFieldCharacterRange {
  __typename: 'MatchedFieldCharacterRange';
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
}

export interface Metric extends Folderable {
  __typename: 'Metric';
  accessKey?: Maybe<Scalars['String']['output']>;
  actions?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['BigInt']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  modifiedAt?: Maybe<Scalars['BigInt']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['BigInt']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  relativePath?: Maybe<Array<PathElement>>;
  runAsIdOverride?: Maybe<Scalars['BigInt']['output']>;
  sharedAt?: Maybe<Scalars['BigInt']['output']>;
  sharerId?: Maybe<Scalars['BigInt']['output']>;
  sharerName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  useViewerRbac?: Maybe<Scalars['Boolean']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
}

export interface MetricQueryFields {
  metricsQueryData?: InputMaybe<MetricsQueryDataInput>;
  metricsQueryMode?: InputMaybe<QueryModes>;
  queryKey: Scalars['String']['input'];
  queryString: Scalars['String']['input'];
  queryType?: QueryTypes;
  type: MetricsQueryType;
}

export interface MetricRecentItem extends RecentItem {
  __typename: 'MetricRecentItem';
  accessKey?: Maybe<Scalars['String']['output']>;
  accessTime: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['BigInt']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  pageType: RecentPageType;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  queries?: Maybe<Array<MetricsQuery>>;
  query?: Maybe<Scalars['String']['output']>;
  queryType?: Maybe<QueryTypes>;
  runAsIdOverride?: Maybe<Scalars['Int']['output']>;
  timeRangeEnd?: Maybe<Scalars['Timestamp']['output']>;
  timeRangeExpression?: Maybe<Scalars['String']['output']>;
  timeRangeStart?: Maybe<Scalars['Timestamp']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
}

export interface MetricRecentItemFields {
  accessKey?: InputMaybe<Scalars['String']['input']>;
  accessTime: Scalars['Timestamp']['input'];
  /** @deprecated use owner instead */
  author?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated use ownerId instead */
  authorId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Will no longer be used */
  customerId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['BigInt']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  /** @deprecated use pinned instead */
  metadata?: InputMaybe<MetricRecentItemMetadataFields>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  ownerName?: InputMaybe<Scalars['String']['input']>;
  pageType: RecentPageType;
  queries?: InputMaybe<Array<MetricQueryFields>>;
  query?: InputMaybe<Scalars['String']['input']>;
  queryType?: QueryTypes;
  runAsIdOverride?: InputMaybe<Scalars['Int']['input']>;
  timeRangeEnd?: InputMaybe<Scalars['Timestamp']['input']>;
  timeRangeExpression?: InputMaybe<Scalars['String']['input']>;
  timeRangeStart?: InputMaybe<Scalars['Timestamp']['input']>;
  /** @deprecated Will no longer be used */
  url?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
}

export interface MetricRecentItemMetadata {
  __typename: 'MetricRecentItemMetadata';
  saved: Scalars['Boolean']['output'];
}

export interface MetricRecentItemMetadataFields {
  saved: Scalars['Boolean']['input'];
}

export interface MetricV2 extends Folderable {
  __typename: 'MetricV2';
  accessKey?: Maybe<Scalars['String']['output']>;
  actions?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['BigInt']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  modifiedAt?: Maybe<Scalars['BigInt']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['BigInt']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  relativePath?: Maybe<Array<PathElement>>;
  runAsIdOverride?: Maybe<Scalars['BigInt']['output']>;
  sharedAt?: Maybe<Scalars['BigInt']['output']>;
  sharerId?: Maybe<Scalars['BigInt']['output']>;
  sharerName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  useViewerRbac?: Maybe<Scalars['Boolean']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
}

export interface MetricsQuery {
  __typename: 'MetricsQuery';
  metricsQueryData?: Maybe<MetricsQueryData>;
  metricsQueryMode: QueryModes;
  queryKey: Scalars['String']['output'];
  queryString: Scalars['String']['output'];
  queryType: QueryTypes;
  type: MetricsQueryType;
}

export interface MetricsQueryData {
  __typename: 'MetricsQueryData';
  filters?: Maybe<Array<Maybe<MetricsQueryFilter>>>;
  metric: Scalars['String']['output'];
  operators?: Maybe<Scalars['JSON']['output']>;
  type: Scalars['String']['output'];
}

export interface MetricsQueryDataInput {
  filters?: InputMaybe<Array<MetricsQueryFilterInput>>;
  metric: Scalars['String']['input'];
  operators: Scalars['String']['input'];
  type: Scalars['String']['input'];
}

export type MetricsQueryFilter = MetricsQueryFilterByPair | MetricsQueryFilterByValue;

export interface MetricsQueryFilterByPair {
  __typename: 'MetricsQueryFilterByPair';
  key: Scalars['String']['output'];
  negation: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface MetricsQueryFilterByValue {
  __typename: 'MetricsQueryFilterByValue';
  negation: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface MetricsQueryFilterInput {
  key?: InputMaybe<Scalars['String']['input']>;
  negation: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
}

export enum MetricsQueryType {
  AdvancedMetricsQuery = 'AdvancedMetricsQuery',
  BasicMetricsQuery = 'BasicMetricsQuery',
  LogsQuery = 'LogsQuery'
}

export interface MitreCoverageColorLegend {
  __typename: 'MitreCoverageColorLegend';
  coverageLevelHighHexCode: Scalars['String']['output'];
  coverageLevelLowHexCode: Scalars['String']['output'];
  coverageLevelMediumHexCode: Scalars['String']['output'];
  coverageLevelNoneHexCode: Scalars['String']['output'];
}

export interface MitreTactic {
  __typename: 'MitreTactic';
  description?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  techniques?: Maybe<Array<MitreTechnique>>;
}

export interface MitreTacticCoverageView {
  __typename: 'MitreTacticCoverageView';
  subTechniqueCoverageCount: Scalars['Int']['output'];
  subTechniqueCoverageTotal: Scalars['Int']['output'];
  tactics?: Maybe<Array<MitreTactic>>;
  techniqueCoverageCount: Scalars['Int']['output'];
  techniqueCoverageTotal: Scalars['Int']['output'];
}

export interface MitreTacticTechniqueFilter {
  __typename: 'MitreTacticTechniqueFilter';
  subTechniques?: Maybe<Array<MitreTechnique>>;
  tactics?: Maybe<Array<MitreTactic>>;
  techniques?: Maybe<Array<MitreTechnique>>;
}

export interface MitreTaggedRule {
  __typename: 'MitreTaggedRule';
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prototype: Scalars['Boolean']['output'];
  source: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface MitreTaggedRules {
  __typename: 'MitreTaggedRules';
  rules?: Maybe<Array<MitreTaggedRule>>;
}

export interface MitreTechnique {
  __typename: 'MitreTechnique';
  coverageLevel: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  externalUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rules: Array<Rule>;
  rulesCoverageFields?: Maybe<Array<Scalars['String']['output']>>;
  rulesFiredRecently: Array<Rule>;
  subTechniques: Array<MitreTechnique>;
  undetectable: Scalars['String']['output'];
}


export interface MitreTechniqueCoverageLevelArgs {
  rulesFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorProductGuidsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  view: Scalars['String']['input'];
}


export interface MitreTechniqueRulesArgs {
  rulesFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorProductGuidsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  view: Scalars['String']['input'];
}


export interface MitreTechniqueRulesFiredRecentlyArgs {
  rulesFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorProductGuidsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  view: Scalars['String']['input'];
}

export interface Mutation {
  __typename: 'Mutation';
  addEntityNote?: Maybe<AddEntityNote>;
  addEntityTags?: Maybe<AddEntityTags>;
  addFavorite: ContentPage;
  addInsightComment?: Maybe<AddInsightComment>;
  addInsightCommentsById?: Maybe<AddInsightCommentsById>;
  addInsightRelatedIncident?: Maybe<AddInsightRelatedIncident>;
  addInsightToIncident?: Maybe<AddInsightToIncident>;
  addItemToMatchList?: Maybe<AddItemToMatchList>;
  addItemToSuppressList?: Maybe<AddItemToSuppressList>;
  addItemToThreatIntelSource?: Maybe<AddItemToThreatIntelSource>;
  addItemsToList?: Maybe<AddItemsToList>;
  addItemsToSuppressList?: Maybe<AddItemsToSuppressList>;
  addItemsToThreatIntelSource?: Maybe<AddItemsToThreatIntelSource>;
  addSignalsToInsight?: Maybe<AddSignalsToInsight>;
  addTagToInsight?: Maybe<AddTagToInsight>;
  addTagToInsightsById?: Maybe<AddTagToInsightsById>;
  addYaraRuleToCustomYaraSource?: Maybe<AddYaraRuleToCustomYaraSource>;
  addYaraRulesToCustomYaraSource?: Maybe<AddYaraRulesToCustomYaraSource>;
  bulkAddEntityTags?: Maybe<BulkAddEntityTags>;
  bulkDeleteMatchListItems?: Maybe<BulkDeleteMatchListItems>;
  bulkRemoveEntityTags?: Maybe<BulkRemoveEntityTags>;
  bulkUpdateEntityCriticality?: Maybe<BulkUpdateEntityCriticality>;
  bulkUpdateEntityTags?: Maybe<BulkUpdateEntityTags>;
  bulkUpdateEntityWhitelist?: Maybe<BulkUpdateEntityWhitelist>;
  bulkUpsertNetworkBlocks?: Maybe<BulkUpsertNetworkBlocks>;
  cancelSumoRecordSearchJob?: Maybe<CancelSumoRecordSearchJob>;
  clearSumoLogicConfig?: Maybe<ClearSumoLogicSupportConfig>;
  clearSumoLogicGeneralConfig?: Maybe<ClearSumoLogicGeneralConfig>;
  clearSumoLogicSupportConfig?: Maybe<ClearSumoLogicSupportConfig>;
  confirmInsightTriageRecommendation?: Maybe<ConfirmInsightTriageRecommendation>;
  createAction?: Maybe<CreateAction>;
  createAggregationRule?: Maybe<CreateAggregationRule>;
  createAnomaliThreatIntelSource?: Maybe<CreateAnomaliThreatIntelSource>;
  createAutomation?: Maybe<CreateAutomation>;
  createChainRule?: Maybe<CreateChainRule>;
  createContextAction?: Maybe<CreateContextAction>;
  createCustomEntityType?: Maybe<CreateCustomEntityType>;
  createCustomInsight?: Maybe<CreateCustomInsight>;
  createCustomMatchListColumn?: Maybe<CreateCustomMatchListColumn>;
  createCustomThreatIntelSource?: Maybe<CreateCustomThreatIntelSource>;
  createCustomYaraSource?: Maybe<CreateCustomYaraSource>;
  createCustomerSourcedEntityLookupTable?: Maybe<CreateCustomerSourcedEntityLookupTable>;
  createEntityCriticalityConfig?: Maybe<CreateEntityCriticalityConfig>;
  createEntityValueEntityGroupConfiguration?: Maybe<CreateEntityValueEntityGroupConfiguration>;
  createFavoriteField?: Maybe<CreateFavoriteField>;
  createFirstSeenRule?: Maybe<CreateFirstSeenRule>;
  createGithubYaraSource?: Maybe<CreateGithubYaraSource>;
  createIdefenseThreatIntelSource?: Maybe<CreateIdefenseThreatIntelSource>;
  createIncidentFromInsight?: Maybe<CreateIncidentFromInsight>;
  createInsightFromSignal?: Maybe<CreateInsightFromSignal>;
  createInsightFromSignals?: Maybe<CreateInsightFromSignals>;
  createInsightResolution?: Maybe<CreateInsightResolution>;
  createInsightStatus?: Maybe<CreateInsightStatus>;
  createInventoryEntityGroupConfiguration?: Maybe<CreateInventoryEntityGroupConfiguration>;
  createInventoryEntityLookupTable?: Maybe<CreateInventoryEntityLookupTable>;
  createLogMapping?: Maybe<CreateLogMapping>;
  createMatchList?: Maybe<CreateMatchList>;
  createMatchRule?: Maybe<CreateMatchRule>;
  createNetworkBlock?: Maybe<CreateNetworkBlock>;
  createOutlierRule?: Maybe<CreateOutlierRule>;
  createRecordArtifactConfig?: Maybe<CreateRecordArtifactConfig>;
  createRole?: Maybe<CreateRole>;
  createRuleTuningExpression?: Maybe<CreateRuleTuningExpression>;
  createStreamingExportConfiguration?: Maybe<CreateStreamingExportConfiguration>;
  createSumoMapping?: Maybe<CreateSumoMapping>;
  createSuppressList?: Maybe<CreateSuppressList>;
  createTagSchema?: Maybe<CreateTagSchema>;
  createTaxiiThreatIntelSource?: Maybe<CreateTaxiiThreatIntelSource>;
  createTemplatedMatchRule?: Maybe<CreateTemplatedMatchRule>;
  createThreatQThreatIntelSource?: Maybe<CreateThreatQThreatIntelSource>;
  createThresholdRule?: Maybe<CreateThresholdRule>;
  deleteAction?: Maybe<DeleteAction>;
  deleteAutomation?: Maybe<DeleteAutomation>;
  deleteContentAdminMode: Scalars['Boolean']['output'];
  deleteContextAction?: Maybe<DeleteContextAction>;
  deleteCustomEntityType?: Maybe<DeleteCustomEntityType>;
  deleteCustomInsight?: Maybe<DeleteCustomInsight>;
  deleteCustomMatchListColumn?: Maybe<DeleteCustomMatchListColumn>;
  deleteCustomYaraRule?: Maybe<DeleteCustomYaraRule>;
  deleteCustomerSourcedEntityLookupTable?: Maybe<DeleteCustomerSourcedEntityLookupTable>;
  deleteEntityCriticalityConfig?: Maybe<DeleteEntityCriticalityConfig>;
  deleteEntityGroupConfiguration?: Maybe<DeleteEntityGroupConfiguration>;
  deleteEntityNote?: Maybe<DeleteEntityNote>;
  deleteFavoriteField?: Maybe<DeleteFavoriteField>;
  deleteInsight?: Maybe<DeleteInsight>;
  deleteInsightComment?: Maybe<DeleteInsightComment>;
  deleteInsightResolution?: Maybe<DeleteInsightResolution>;
  deleteInsightStatus?: Maybe<DeleteInsightStatus>;
  deleteInsightsById?: Maybe<DeleteInsightsById>;
  deleteInventoryEntityLookupTable?: Maybe<DeleteInventoryEntityLookupTable>;
  deleteLogMapping?: Maybe<DeleteLogMapping>;
  deleteMatchList?: Maybe<DeleteMatchList>;
  deleteMatchListItem?: Maybe<DeleteMatchListItem>;
  deleteNetworkBlock?: Maybe<DeleteNetworkBlock>;
  deleteRecordArtifactConfig?: Maybe<DeleteRecordArtifactConfig>;
  deleteRole?: Maybe<DeleteRole>;
  deleteRule?: Maybe<DeleteRule>;
  deleteRuleTuningExpression?: Maybe<DeleteRuleTuningExpression>;
  deleteStreamingExportConfiguration?: Maybe<DeleteStreamingExportConfiguration>;
  deleteSumoMapping?: Maybe<DeleteSumoMapping>;
  deleteSuppressList?: Maybe<DeleteSuppressList>;
  deleteSuppressListItem?: Maybe<DeleteSuppressListItem>;
  deleteTagSchema?: Maybe<DeleteTagSchema>;
  deleteThreatIntelItem?: Maybe<DeleteThreatIntelItem>;
  deleteThreatIntelSource?: Maybe<DeleteThreatIntelSource>;
  deleteYaraSource?: Maybe<DeleteYaraSource>;
  executeAction?: Maybe<ExecuteAction>;
  executeAutomation?: Maybe<ExecuteAutomation>;
  finishMfaLogin?: Maybe<FinishMfaLogin>;
  forgotPassword?: Maybe<ForgotPassword>;
  importRules?: Maybe<ImportRules>;
  inviteUser?: Maybe<InviteUser>;
  inviteUsers?: Maybe<InviteUsers>;
  loginUser?: Maybe<LoginUser>;
  logoutUser?: Maybe<LogoutUser>;
  migrateRecents: MutationResponse;
  overrideAggregationRule?: Maybe<OverrideAggregationRule>;
  overrideChainRule?: Maybe<OverrideChainRule>;
  overrideFirstSeenRule?: Maybe<OverrideFirstSeenRule>;
  overrideMatchRule?: Maybe<OverrideMatchRule>;
  overrideOutlierRule?: Maybe<OverrideOutlierRule>;
  overrideTemplatedMatchRule?: Maybe<OverrideTemplatedMatchRule>;
  overrideThresholdRule?: Maybe<OverrideThresholdRule>;
  promoteTriageToIncident?: Maybe<PromoteTriageToIncident>;
  removeEntityTags?: Maybe<RemoveEntityTags>;
  removeFavorite: ContentPage;
  removeInsightRelatedIncident?: Maybe<RemoveInsightRelatedIncident>;
  removeSignalsFromInsight?: Maybe<RemoveSignalsFromInsight>;
  removeTagFromInsight?: Maybe<RemoveTagFromInsight>;
  removeTagFromInsightsById?: Maybe<RemoveTagFromInsightsById>;
  reorderInsightStatuses?: Maybe<ReorderInsightStatuses>;
  resendCurrentUserConfirmationEmail?: Maybe<ResendCurrentUserConfirmationEmail>;
  resendUserConfirmationEmail?: Maybe<ResendUserConfirmationEmail>;
  resetCurrentUserApiKey?: Maybe<ResetCurrentUserApiKey>;
  resetCurrentUserMfaSecret?: Maybe<ResetCurrentUserMfaSecret>;
  resetPassword?: Maybe<ResetPassword>;
  resetUserApiKey?: Maybe<ResetUserApiKey>;
  resetUserMfaSecret?: Maybe<ResetUserMfaSecret>;
  resyncFilteredRecents: MutationResponse;
  saveEntityEnrichment?: Maybe<SaveEntityEnrichment>;
  saveInsightEnrichment?: Maybe<SaveInsightEnrichment>;
  saveSignalEnrichment?: Maybe<SaveSignalEnrichment>;
  setContentAdminMode: Scalars['Boolean']['output'];
  setNavAsideCollapsed: MutationResponse;
  setNavDrawerPinnedMenu: MutationResponse;
  setNavDrawerWidth: MutationResponse;
  signUp?: Maybe<SignUp>;
  startCanaryLookupJob?: Maybe<StartCanaryLookupJob>;
  startEntityTimelineGroupRecordJob?: Maybe<StartEntityTimelineGroupRecordJob>;
  startEntityTimelineJob?: Maybe<StartEntityTimelineJob>;
  startSumoInsightSearchJob?: Maybe<StartSumoInsightSearchJob>;
  startSumoRawMessageLookupJob?: Maybe<StartSumoRawMessageLookupJob>;
  startSumoRecordSearchJob?: Maybe<StartSumoRecordSearchJob>;
  startSumoRecordSearchJobForRuleExpression?: Maybe<StartSumoRecordSearchJobForRuleExpression>;
  startSumoRecordSearchJobForSignal?: Maybe<StartSumoRecordSearchJobForSignal>;
  triggerActivationEmail: MutationResponse;
  triggerVerificationEmail: MutationResponse;
  uninviteUser?: Maybe<UninviteUser>;
  updateAction?: Maybe<UpdateAction>;
  updateAggregationRule?: Maybe<UpdateAggregationRule>;
  updateAnomaliThreatIntelSource?: Maybe<UpdateAnomaliThreatIntelSource>;
  updateAssignedInsightEmailsEnabled?: Maybe<UpdateAssignedInsightEmailsEnabled>;
  updateAutomation?: Maybe<UpdateAutomation>;
  updateBuiltInRule?: Maybe<UpdateBuiltInRule>;
  updateChainRule?: Maybe<UpdateChainRule>;
  updateContextAction?: Maybe<UpdateContextAction>;
  updateCurrentUser?: Maybe<UpdateCurrentUser>;
  updateCustomEntityType?: Maybe<UpdateCustomEntityType>;
  updateCustomInsight?: Maybe<UpdateCustomInsight>;
  updateCustomInsightEnabled?: Maybe<UpdateCustomInsightEnabled>;
  updateCustomMatchListColumn?: Maybe<UpdateCustomMatchListColumn>;
  updateCustomThreatIntelSource?: Maybe<UpdateCustomThreatIntelSource>;
  updateCustomYaraRule?: Maybe<UpdateCustomYaraRule>;
  updateCustomYaraSource?: Maybe<UpdateCustomYaraSource>;
  updateCustomerSourcedEntityLookupTable?: Maybe<UpdateCustomerSourcedEntityLookupTable>;
  /** @deprecated use updateDashboardRecentItemsV2 instead */
  updateDashboardRecentItems: Array<Maybe<DashboardRecentItem>>;
  updateDashboardRecentItemsV2: MutationResponse;
  updateEntityCriticality?: Maybe<UpdateEntityCriticality>;
  updateEntityCriticalityConfig?: Maybe<UpdateEntityCriticalityConfig>;
  updateEntityDomainConfiguration?: Maybe<UpdateEntityDomainConfiguration>;
  updateEntityNote?: Maybe<UpdateEntityNote>;
  updateEntityTags?: Maybe<UpdateEntityTags>;
  updateEntityValueEntityGroupConfiguration?: Maybe<UpdateEntityValueEntityGroupConfiguration>;
  updateEntityWhitelist?: Maybe<UpdateEntityWhitelist>;
  updateFavoriteField?: Maybe<UpdateFavoriteField>;
  updateFirstSeenRule?: Maybe<UpdateFirstSeenRule>;
  updateGithubYaraSource?: Maybe<UpdateGithubYaraSource>;
  updateIdefenseThreatIntelSource?: Maybe<UpdateIdefenseThreatIntelSource>;
  updateInsight?: Maybe<UpdateInsight>;
  updateInsightComment?: Maybe<UpdateInsightComment>;
  updateInsightConfig?: Maybe<UpdateInsightConfig>;
  updateInsightResolution?: Maybe<UpdateInsightResolution>;
  updateInsightStatus?: Maybe<UpdateInsightStatus>;
  updateInsightStatusInProgressEnabled?: Maybe<UpdateInsightStatusInProgressEnabled>;
  updateInsightsById?: Maybe<UpdateInsightsById>;
  updateInventoryEntityGroupConfiguration?: Maybe<UpdateInventoryEntityGroupConfiguration>;
  updateInventoryEntityLookupTable?: Maybe<UpdateInventoryEntityLookupTable>;
  updateLivetailRecentItems: MutationResponse;
  updateLogMapping?: Maybe<UpdateLogMapping>;
  updateLogMappingEnabled?: Maybe<UpdateLogMappingEnabled>;
  /** @deprecated use updateLogRecentItemsV2 instead */
  updateLogRecentItems: Array<Maybe<LogRecentItem>>;
  updateLogRecentItemsV2: MutationResponse;
  updateMatchList?: Maybe<UpdateMatchList>;
  updateMatchListItem?: Maybe<UpdateMatchListItem>;
  updateMatchRule?: Maybe<UpdateMatchRule>;
  /** @deprecated use updateMetricRecentItemsV2 instead */
  updateMetricRecentItems: Array<Maybe<MetricRecentItem>>;
  updateMetricRecentItemsV2: MutationResponse;
  updateMfaEnabled?: Maybe<UpdateMfaEnabled>;
  updateMitreAttackCoverageColors?: Maybe<UpdateMitreAttackCoverageColors>;
  updateNetworkBlock?: Maybe<UpdateNetworkBlock>;
  updateOutlierRule?: Maybe<UpdateOutlierRule>;
  updateRecordArtifactConfig?: Maybe<UpdateRecordArtifactConfig>;
  updateRole?: Maybe<UpdateRole>;
  updateRuleEnabled?: Maybe<UpdateRuleEnabled>;
  updateRuleTuningExpression?: Maybe<UpdateRuleTuningExpression>;
  updateRuleTuningExpressionEnabled?: Maybe<UpdateRuleTuningExpressionEnabled>;
  updateSpanRecentItems: MutationResponse;
  updateSsoSettings?: Maybe<UpdateSsoSettings>;
  updateStandardPageRecentItems: MutationResponse;
  updateStreamingExportConfiguration?: Maybe<UpdateStreamingExportConfiguration>;
  updateSumoLogicConfig?: Maybe<UpdateSumoLogicSupportConfig>;
  updateSumoLogicGeneralConfig?: Maybe<UpdateSumoLogicGeneralConfig>;
  updateSumoLogicSupportConfig?: Maybe<UpdateSumoLogicSupportConfig>;
  updateSumoMapping?: Maybe<UpdateSumoMapping>;
  updateSumoSsoEnabled?: Maybe<UpdateSumoSsoEnabled>;
  updateSuppressList?: Maybe<UpdateSuppressList>;
  updateSuppressListItem?: Maybe<UpdateSuppressListItem>;
  updateTagSchema?: Maybe<UpdateTagSchema>;
  updateTaxiiThreatIntelSource?: Maybe<UpdateTaxiiThreatIntelSource>;
  updateTemplatedMatchRule?: Maybe<UpdateTemplatedMatchRule>;
  updateThreatIntelItem?: Maybe<UpdateThreatIntelItem>;
  updateThreatQThreatIntelSource?: Maybe<UpdateThreatQThreatIntelSource>;
  updateThresholdRule?: Maybe<UpdateThresholdRule>;
  updateUser?: Maybe<UpdateUser>;
  updateVirusTotalConfig?: Maybe<UpdateVirusTotalConfig>;
  uploadEntityGroupsCsv?: Maybe<UploadEntityGroupConfigurationMutationsCsv>;
  uploadEntityMutationsCsv?: Maybe<UploadEntityMutationsCsv>;
  uploadItemsToList?: Maybe<UploadItemsToList>;
  uploadItemsToSuppressList?: Maybe<UploadItemsToSuppressList>;
  uploadItemsToThreatIntelSource?: Maybe<UploadItemsToThreatIntelSource>;
  uploadNetworkBlocksCsv?: Maybe<UploadNetworkBlocksCsv>;
  visitEntityPage?: Maybe<VisitEntityPage>;
  visitInsightPage?: Maybe<VisitInsightPage>;
  visitSearchQueryPage?: Maybe<VisitSearchQueryPage>;
  visitSignalPage?: Maybe<VisitSignalPage>;
}


export interface MutationAddEntityNoteArgs {
  entityId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
}


export interface MutationAddEntityTagsArgs {
  entityId: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']>;
}


export interface MutationAddFavoriteArgs {
  contentId: Scalars['ID']['input'];
  legacyRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  types: Array<ContentTypeSumo>;
}


export interface MutationAddInsightCommentArgs {
  body: Scalars['String']['input'];
  insightId: Scalars['ID']['input'];
}


export interface MutationAddInsightCommentsByIdArgs {
  body: Scalars['String']['input'];
  ids: Array<Scalars['ID']['input']>;
}


export interface MutationAddInsightRelatedIncidentArgs {
  insightId: Scalars['ID']['input'];
  relatedIncidentFields: RelatedIncidentFields;
}


export interface MutationAddInsightToIncidentArgs {
  incidentId: Scalars['Int']['input'];
  insightId: Scalars['ID']['input'];
}


export interface MutationAddItemToMatchListArgs {
  itemFields: MatchListItemFields;
  listId: Scalars['ID']['input'];
}


export interface MutationAddItemToSuppressListArgs {
  itemFields: SuppressListItemFields;
  listId: Scalars['ID']['input'];
}


export interface MutationAddItemToThreatIntelSourceArgs {
  itemFields: ThreatIntelItemFields;
  threatIntelSourceId: Scalars['ID']['input'];
}


export interface MutationAddItemsToListArgs {
  items: Array<MatchListItemFields>;
  listId: Scalars['String']['input'];
}


export interface MutationAddItemsToSuppressListArgs {
  items: Array<SuppressListItemFields>;
  listId: Scalars['String']['input'];
}


export interface MutationAddItemsToThreatIntelSourceArgs {
  items: Array<ThreatIntelItemFields>;
  threatIntelSourceId: Scalars['ID']['input'];
}


export interface MutationAddSignalsToInsightArgs {
  insightId: Scalars['ID']['input'];
  signalIds: Array<Scalars['ID']['input']>;
}


export interface MutationAddTagToInsightArgs {
  id: Scalars['ID']['input'];
  tagName: Scalars['String']['input'];
}


export interface MutationAddTagToInsightsByIdArgs {
  ids: Array<Scalars['ID']['input']>;
  tagName: Scalars['String']['input'];
}


export interface MutationAddYaraRuleToCustomYaraSourceArgs {
  yaraRuleFields: CustomYaraRuleFields;
  yaraSourceId: Scalars['ID']['input'];
}


export interface MutationAddYaraRulesToCustomYaraSourceArgs {
  yaraRules: Array<CustomYaraRuleFields>;
  yaraSourceId: Scalars['ID']['input'];
}


export interface MutationBulkAddEntityTagsArgs {
  entityIds: Array<Scalars['ID']['input']>;
  tags: Array<Scalars['String']['input']>;
}


export interface MutationBulkDeleteMatchListItemsArgs {
  ids: Array<InputMaybe<Scalars['ID']['input']>>;
}


export interface MutationBulkRemoveEntityTagsArgs {
  entityIds: Array<Scalars['ID']['input']>;
  tags: Array<Scalars['String']['input']>;
}


export interface MutationBulkUpdateEntityCriticalityArgs {
  criticality?: InputMaybe<Scalars['String']['input']>;
  entityIds: Array<Scalars['ID']['input']>;
}


export interface MutationBulkUpdateEntityTagsArgs {
  entityIds: Array<Scalars['ID']['input']>;
  tags: Array<Scalars['String']['input']>;
}


export interface MutationBulkUpdateEntityWhitelistArgs {
  comment?: InputMaybe<Scalars['String']['input']>;
  entityIds: Array<Scalars['ID']['input']>;
  whitelistFlag: Scalars['Boolean']['input'];
}


export interface MutationBulkUpsertNetworkBlocksArgs {
  networkBlocks: Array<NetworkBlockFields>;
}


export interface MutationCancelSumoRecordSearchJobArgs {
  jobId: Scalars['String']['input'];
}


export interface MutationConfirmInsightTriageRecommendationArgs {
  accepted: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
}


export interface MutationCreateActionArgs {
  fields: ActionFields;
}


export interface MutationCreateAggregationRuleArgs {
  fields: CreateAggregationRuleFields;
}


export interface MutationCreateAnomaliThreatIntelSourceArgs {
  fields: AnomaliThreatIntelSourceFields;
}


export interface MutationCreateAutomationArgs {
  fields: AutomationFields;
}


export interface MutationCreateChainRuleArgs {
  fields: CreateChainRuleFields;
}


export interface MutationCreateContextActionArgs {
  allRecordFields?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  iocTypes: Array<ContextActionIocType>;
  name: Scalars['String']['input'];
  recordFields?: InputMaybe<Array<Scalars['String']['input']>>;
  template?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ContextActionType>;
  urlTemplate?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationCreateCustomEntityTypeArgs {
  fields: CreateCustomEntityTypeFields;
}


export interface MutationCreateCustomInsightArgs {
  fields: CreateCustomInsightFields;
}


export interface MutationCreateCustomMatchListColumnArgs {
  fields: CustomMatchListColumnFields;
}


export interface MutationCreateCustomThreatIntelSourceArgs {
  fields: CustomThreatIntelSourceFields;
}


export interface MutationCreateCustomYaraSourceArgs {
  fields: CustomYaraSourceFields;
}


export interface MutationCreateCustomerSourcedEntityLookupTableArgs {
  fields: CreateCustomerSourcedEntityLookupTableFields;
}


export interface MutationCreateEntityCriticalityConfigArgs {
  fields: CreateEntityCriticalityConfigFields;
}


export interface MutationCreateEntityValueEntityGroupConfigurationArgs {
  fields: EntityValueEntityGroupConfigurationFields;
}


export interface MutationCreateFavoriteFieldArgs {
  applyToAllObjectTypes: Scalars['Boolean']['input'];
  associatedObjectTypes: Array<Scalars['String']['input']>;
  fieldName: Scalars['String']['input'];
  fieldType?: InputMaybe<FavoriteFieldType>;
}


export interface MutationCreateFirstSeenRuleArgs {
  fields: CreateFirstSeenRuleFields;
}


export interface MutationCreateGithubYaraSourceArgs {
  fields: GithubYaraSourceFields;
}


export interface MutationCreateIdefenseThreatIntelSourceArgs {
  fields: IdefenseThreatIntelSourceFields;
}


export interface MutationCreateIncidentFromInsightArgs {
  incidentTemplateId: Scalars['Int']['input'];
  insightId: Scalars['ID']['input'];
}


export interface MutationCreateInsightFromSignalArgs {
  signalId: Scalars['ID']['input'];
}


export interface MutationCreateInsightFromSignalsArgs {
  signalIds: Array<Scalars['ID']['input']>;
}


export interface MutationCreateInsightResolutionArgs {
  fields?: InputMaybe<CreateInsightResolutionFields>;
}


export interface MutationCreateInsightStatusArgs {
  fields?: InputMaybe<CreateInsightStatusFields>;
}


export interface MutationCreateInventoryEntityGroupConfigurationArgs {
  fields: InventoryEntityGroupConfigurationFields;
}


export interface MutationCreateInventoryEntityLookupTableArgs {
  fields: CreateInventoryEntityLookupTableFields;
}


export interface MutationCreateLogMappingArgs {
  fields: CreateLogMappingFields;
}


export interface MutationCreateMatchListArgs {
  fields: MatchListFields;
}


export interface MutationCreateMatchRuleArgs {
  fields: CreateMatchRuleFields;
}


export interface MutationCreateNetworkBlockArgs {
  fields: NetworkBlockFields;
}


export interface MutationCreateOutlierRuleArgs {
  fields: CreateOutlierRuleFields;
}


export interface MutationCreateRecordArtifactConfigArgs {
  fields: RecordArtifactConfigEditableFields;
}


export interface MutationCreateRoleArgs {
  fields?: InputMaybe<CreateRoleFields>;
}


export interface MutationCreateRuleTuningExpressionArgs {
  fields: CreateRuleTuningExpressionFields;
}


export interface MutationCreateStreamingExportConfigurationArgs {
  fields: StreamingExportConfigurationFields;
}


export interface MutationCreateSumoMappingArgs {
  fields: SumoMappingFields;
}


export interface MutationCreateSuppressListArgs {
  fields: SuppressListFields;
}


export interface MutationCreateTagSchemaArgs {
  fields: CreateTagSchemaFields;
}


export interface MutationCreateTaxiiThreatIntelSourceArgs {
  fields: TaxiiThreatIntelSourceFields;
}


export interface MutationCreateTemplatedMatchRuleArgs {
  fields: CreateTemplatedMatchRuleFields;
}


export interface MutationCreateThreatQThreatIntelSourceArgs {
  fields: ThreatQThreatIntelSourceFields;
}


export interface MutationCreateThresholdRuleArgs {
  fields: CreateThresholdRuleFields;
}


export interface MutationDeleteActionArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteAutomationArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteContextActionArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteCustomEntityTypeArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteCustomInsightArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationDeleteCustomMatchListColumnArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteCustomYaraRuleArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationDeleteCustomerSourcedEntityLookupTableArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteEntityCriticalityConfigArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteEntityGroupConfigurationArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteEntityNoteArgs {
  entityId: Scalars['ID']['input'];
  entityNoteId: Scalars['ID']['input'];
}


export interface MutationDeleteFavoriteFieldArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteInsightArgs {
  insightId: Scalars['ID']['input'];
}


export interface MutationDeleteInsightCommentArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteInsightResolutionArgs {
  id: Scalars['Int']['input'];
}


export interface MutationDeleteInsightStatusArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteInsightsByIdArgs {
  ids: Array<Scalars['ID']['input']>;
}


export interface MutationDeleteInventoryEntityLookupTableArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteLogMappingArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteMatchListArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteMatchListItemArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationDeleteNetworkBlockArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteRecordArtifactConfigArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteRoleArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteRuleArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteRuleTuningExpressionArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteStreamingExportConfigurationArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteSumoMappingArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteSuppressListArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteSuppressListItemArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationDeleteTagSchemaArgs {
  key: Scalars['ID']['input'];
}


export interface MutationDeleteThreatIntelItemArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationDeleteThreatIntelSourceArgs {
  id: Scalars['ID']['input'];
}


export interface MutationDeleteYaraSourceArgs {
  id: Scalars['ID']['input'];
}


export interface MutationExecuteActionArgs {
  actionId: Scalars['ID']['input'];
  insightId: Scalars['ID']['input'];
  parameterValues?: InputMaybe<Array<ActionParameterValue>>;
}


export interface MutationExecuteAutomationArgs {
  fields: ExecuteAutomationFields;
}


export interface MutationFinishMfaLoginArgs {
  mfaSession: Scalars['String']['input'];
  mfaToken: Scalars['String']['input'];
  secret?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
}


export interface MutationForgotPasswordArgs {
  email: Scalars['String']['input'];
}


export interface MutationImportRulesArgs {
  file: Scalars['Upload']['input'];
}


export interface MutationInviteUserArgs {
  email: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationInviteUsersArgs {
  emails: Array<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationLoginUserArgs {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
}


export interface MutationOverrideAggregationRuleArgs {
  fields: OverrideAggregationRuleFields;
  id: Scalars['ID']['input'];
}


export interface MutationOverrideChainRuleArgs {
  fields: OverrideChainRuleFields;
  id: Scalars['ID']['input'];
}


export interface MutationOverrideFirstSeenRuleArgs {
  fields: OverrideFirstSeenRuleFields;
  id: Scalars['ID']['input'];
}


export interface MutationOverrideMatchRuleArgs {
  fields: OverrideMatchRuleFields;
  id: Scalars['ID']['input'];
}


export interface MutationOverrideOutlierRuleArgs {
  fields: OverrideOutlierRuleFields;
  id: Scalars['ID']['input'];
}


export interface MutationOverrideTemplatedMatchRuleArgs {
  fields: OverrideTemplatedMatchRuleFields;
  id: Scalars['ID']['input'];
}


export interface MutationOverrideThresholdRuleArgs {
  fields: OverrideThresholdRuleFields;
  id: Scalars['ID']['input'];
}


export interface MutationPromoteTriageToIncidentArgs {
  incidentTemplateId: Scalars['Int']['input'];
  insightId: Scalars['ID']['input'];
  triageId: Scalars['Int']['input'];
}


export interface MutationRemoveEntityTagsArgs {
  entityId: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']>;
}


export interface MutationRemoveFavoriteArgs {
  contentId: Scalars['ID']['input'];
  legacyRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  types: Array<ContentTypeSumo>;
}


export interface MutationRemoveInsightRelatedIncidentArgs {
  incidentId: Scalars['Int']['input'];
  insightId: Scalars['ID']['input'];
}


export interface MutationRemoveSignalsFromInsightArgs {
  insightId: Scalars['ID']['input'];
  signalIds: Array<Scalars['ID']['input']>;
}


export interface MutationRemoveTagFromInsightArgs {
  id: Scalars['ID']['input'];
  tagName: Scalars['String']['input'];
}


export interface MutationRemoveTagFromInsightsByIdArgs {
  ids: Array<Scalars['ID']['input']>;
  tagName: Scalars['String']['input'];
}


export interface MutationReorderInsightStatusesArgs {
  orderedIds: Array<Scalars['ID']['input']>;
}


export interface MutationResendUserConfirmationEmailArgs {
  id: Scalars['ID']['input'];
}


export interface MutationResetPasswordArgs {
  confirmPassword: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}


export interface MutationResetUserApiKeyArgs {
  id: Scalars['ID']['input'];
}


export interface MutationResetUserMfaSecretArgs {
  id: Scalars['ID']['input'];
}


export interface MutationSaveEntityEnrichmentArgs {
  detailJson: Scalars['String']['input'];
  enrichmentType: Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  raw?: InputMaybe<Scalars['String']['input']>;
  reputation?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationSaveInsightEnrichmentArgs {
  detailJson: Scalars['String']['input'];
  enrichmentType: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  insightId: Scalars['ID']['input'];
  raw?: InputMaybe<Scalars['String']['input']>;
  reputation?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationSaveSignalEnrichmentArgs {
  detailJson: Scalars['String']['input'];
  enrichmentType: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  raw?: InputMaybe<Scalars['String']['input']>;
  reputation?: InputMaybe<Scalars['String']['input']>;
  signalId: Scalars['ID']['input'];
}


export interface MutationSetNavAsideCollapsedArgs {
  collapsed: Scalars['Boolean']['input'];
}


export interface MutationSetNavDrawerPinnedMenuArgs {
  pinnedMenu: Scalars['String']['input'];
}


export interface MutationSetNavDrawerWidthArgs {
  width: Scalars['Int']['input'];
}


export interface MutationSignUpArgs {
  confirmPassword: Scalars['String']['input'];
  confirmationToken: Scalars['String']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
}


export interface MutationStartCanaryLookupJobArgs {
  end: Scalars['DateTime']['input'];
  indexType: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
}


export interface MutationStartEntityTimelineGroupRecordJobArgs {
  endTimestamp: Scalars['DateTime']['input'];
  entityId: Scalars['String']['input'];
  objectTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  startTimestamp: Scalars['DateTime']['input'];
  summary: Scalars['String']['input'];
}


export interface MutationStartEntityTimelineJobArgs {
  endTimestamp: Scalars['DateTime']['input'];
  entityId: Scalars['String']['input'];
  objectTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  sortDir: SortDir;
  startTimestamp: Scalars['DateTime']['input'];
}


export interface MutationStartSumoInsightSearchJobArgs {
  end: Scalars['DateTime']['input'];
  insightId: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
}


export interface MutationStartSumoRawMessageLookupJobArgs {
  messageId: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
}


export interface MutationStartSumoRecordSearchJobArgs {
  end: Scalars['DateTime']['input'];
  q: Scalars['String']['input'];
  querySyntax?: InputMaybe<SumoSearchQuerySyntax>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<SortDir>;
  start: Scalars['DateTime']['input'];
}


export interface MutationStartSumoRecordSearchJobForRuleExpressionArgs {
  end: Scalars['DateTime']['input'];
  ruleExpression: Scalars['String']['input'];
  ruleTuningExpressions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ruleTuningTranslationExpressions?: InputMaybe<Array<InputMaybe<RuleTuningExpressionTranslationFields>>>;
  start: Scalars['DateTime']['input'];
}


export interface MutationStartSumoRecordSearchJobForSignalArgs {
  signalId: Scalars['String']['input'];
}


export interface MutationTriggerActivationEmailArgs {
  name: Scalars['String']['input'];
}


export interface MutationTriggerVerificationEmailArgs {
  userId: Scalars['String']['input'];
}


export interface MutationUninviteUserArgs {
  email: Scalars['String']['input'];
}


export interface MutationUpdateActionArgs {
  fields: ActionFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateAggregationRuleArgs {
  fields: UpdateAggregationRuleFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateAnomaliThreatIntelSourceArgs {
  fields: UpdatableAnomaliThreatIntelSourceFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateAssignedInsightEmailsEnabledArgs {
  enabled: Scalars['Boolean']['input'];
}


export interface MutationUpdateAutomationArgs {
  fields: UpdateAutomationFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateBuiltInRuleArgs {
  fields: UpdateBuiltInRuleFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateChainRuleArgs {
  fields: UpdateChainRuleFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateContextActionArgs {
  fields: UpdatableContextActionFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateCurrentUserArgs {
  updatedFields: UpdatedCurrentUserFields;
}


export interface MutationUpdateCustomEntityTypeArgs {
  fields: UpdateCustomEntityTypeFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateCustomInsightArgs {
  fields: UpdateCustomInsightFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateCustomInsightEnabledArgs {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationUpdateCustomMatchListColumnArgs {
  fields: CustomMatchListColumnFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateCustomThreatIntelSourceArgs {
  fields: UpdatableCustomThreatIntelSourceFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateCustomYaraRuleArgs {
  fields: CustomYaraRuleFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateCustomYaraSourceArgs {
  fields: UpdatableCustomYaraSourceFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateCustomerSourcedEntityLookupTableArgs {
  fields: UpdateCustomerSourcedEntityLookupTableFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateDashboardRecentItemsArgs {
  updatedValue: Array<InputMaybe<DashboardRecentItemFields>>;
}


export interface MutationUpdateDashboardRecentItemsV2Args {
  updatedValue: Array<DashboardRecentItemFields>;
}


export interface MutationUpdateEntityCriticalityArgs {
  criticality?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
}


export interface MutationUpdateEntityCriticalityConfigArgs {
  fields: UpdateEntityCriticalityConfigFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateEntityDomainConfigurationArgs {
  fields: EntityDomainConfigurationFields;
}


export interface MutationUpdateEntityNoteArgs {
  entityId: Scalars['ID']['input'];
  entityNoteId: Scalars['ID']['input'];
  note: Scalars['String']['input'];
}


export interface MutationUpdateEntityTagsArgs {
  entityId: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']>;
}


export interface MutationUpdateEntityValueEntityGroupConfigurationArgs {
  fields: EntityValueEntityGroupConfigurationFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateEntityWhitelistArgs {
  comment?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
  whitelistFlag: Scalars['Boolean']['input'];
}


export interface MutationUpdateFavoriteFieldArgs {
  fields: UpdatableFavoriteFieldFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateFirstSeenRuleArgs {
  fields: UpdateFirstSeenRuleFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateGithubYaraSourceArgs {
  fields: UpdatableGithubYaraSourceFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateIdefenseThreatIntelSourceArgs {
  fields: UpdatableIdefenseThreatIntelSourceFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateInsightArgs {
  fields: InsightEditableFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateInsightCommentArgs {
  body: Scalars['String']['input'];
  id: Scalars['ID']['input'];
}


export interface MutationUpdateInsightConfigArgs {
  config: InsightConfigInput;
}


export interface MutationUpdateInsightResolutionArgs {
  fields?: InputMaybe<UpdateInsightResolutionFields>;
  id: Scalars['Int']['input'];
}


export interface MutationUpdateInsightStatusArgs {
  fields?: InputMaybe<UpdateInsightStatusFields>;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateInsightStatusInProgressEnabledArgs {
  enable: Scalars['Boolean']['input'];
}


export interface MutationUpdateInsightsByIdArgs {
  fields?: InputMaybe<InsightEditableFields>;
  ids: Array<Scalars['ID']['input']>;
}


export interface MutationUpdateInventoryEntityGroupConfigurationArgs {
  fields: InventoryEntityGroupConfigurationFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateInventoryEntityLookupTableArgs {
  fields: UpdateInventoryEntityLookupTableFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateLivetailRecentItemsArgs {
  updatedValue: Array<LivetailRecentItemFields>;
}


export interface MutationUpdateLogMappingArgs {
  fields: UpdateLogMappingFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateLogMappingEnabledArgs {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
}


export interface MutationUpdateLogRecentItemsArgs {
  updatedValue: Array<InputMaybe<LogRecentItemFields>>;
}


export interface MutationUpdateLogRecentItemsV2Args {
  updatedValue: Array<LogRecentItemFields>;
}


export interface MutationUpdateMatchListArgs {
  fields: UpdatableMatchListFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateMatchListItemArgs {
  fields?: InputMaybe<UpdatableMatchListItemFields>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationUpdateMatchRuleArgs {
  fields: UpdateMatchRuleFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateMetricRecentItemsArgs {
  updatedValue: Array<InputMaybe<MetricRecentItemFields>>;
}


export interface MutationUpdateMetricRecentItemsV2Args {
  updatedValue: Array<MetricRecentItemFields>;
}


export interface MutationUpdateMfaEnabledArgs {
  enabled: Scalars['Boolean']['input'];
}


export interface MutationUpdateMitreAttackCoverageColorsArgs {
  coverageLevel: Scalars['String']['input'];
  hexCode: Scalars['String']['input'];
}


export interface MutationUpdateNetworkBlockArgs {
  fields: UpdatableNetworkBlockFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateOutlierRuleArgs {
  fields: UpdateOutlierRuleFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateRecordArtifactConfigArgs {
  fields: RecordArtifactConfigEditableFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateRoleArgs {
  fields?: InputMaybe<UpdateRoleFields>;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateRuleEnabledArgs {
  duplicated?: InputMaybe<Scalars['Boolean']['input']>;
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
}


export interface MutationUpdateRuleTuningExpressionArgs {
  fields: UpdateRuleTuningExpressionFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateRuleTuningExpressionEnabledArgs {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
}


export interface MutationUpdateSpanRecentItemsArgs {
  updatedValue: Array<SpansRecentItemFields>;
}


export interface MutationUpdateSsoSettingsArgs {
  enabled: Scalars['Boolean']['input'];
  logoutUrl?: InputMaybe<Scalars['String']['input']>;
  metadataUrl?: InputMaybe<Scalars['String']['input']>;
  metadataXml?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationUpdateStandardPageRecentItemsArgs {
  updatedValue: Array<StandardPageRecentItemFields>;
}


export interface MutationUpdateStreamingExportConfigurationArgs {
  fields: StreamingExportConfigurationFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateSumoLogicConfigArgs {
  customerId: Scalars['String']['input'];
  region: Scalars['String']['input'];
}


export interface MutationUpdateSumoLogicGeneralConfigArgs {
  accessId: Scalars['String']['input'];
  accessKey: Scalars['String']['input'];
}


export interface MutationUpdateSumoLogicSupportConfigArgs {
  customerId: Scalars['String']['input'];
  region: Scalars['String']['input'];
}


export interface MutationUpdateSumoMappingArgs {
  fields: SumoMappingFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateSumoSsoEnabledArgs {
  enabled: Scalars['Boolean']['input'];
}


export interface MutationUpdateSuppressListArgs {
  fields: UpdatableSuppressListFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateSuppressListItemArgs {
  fields?: InputMaybe<UpdatableSuppressListItemFields>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationUpdateTagSchemaArgs {
  fields: UpdateTagSchemaFields;
}


export interface MutationUpdateTaxiiThreatIntelSourceArgs {
  fields: UpdatableTaxiiThreatIntelSourceFields;
  fieldsToClear: Array<TaxiiClearableFields>;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateTemplatedMatchRuleArgs {
  fields: UpdateTemplatedMatchRuleFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateThreatIntelItemArgs {
  fields?: InputMaybe<UpdatableThreatIntelItemFields>;
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationUpdateThreatQThreatIntelSourceArgs {
  fields: UpdatableThreatQThreatIntelSourceFields;
  fieldsToClear: Array<ThreatQClearableFields>;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateThresholdRuleArgs {
  fields: UpdateThresholdRuleFields;
  id: Scalars['ID']['input'];
}


export interface MutationUpdateUserArgs {
  id: Scalars['ID']['input'];
  updatedFields: UpdatedUserFields;
}


export interface MutationUpdateVirusTotalConfigArgs {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
}


export interface MutationUploadEntityGroupsCsvArgs {
  file: Scalars['Upload']['input'];
}


export interface MutationUploadEntityMutationsCsvArgs {
  file: Scalars['Upload']['input'];
}


export interface MutationUploadItemsToListArgs {
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
  file: Scalars['Upload']['input'];
  listId: Scalars['String']['input'];
}


export interface MutationUploadItemsToSuppressListArgs {
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
  file: Scalars['Upload']['input'];
  listId: Scalars['String']['input'];
}


export interface MutationUploadItemsToThreatIntelSourceArgs {
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
  file: Scalars['Upload']['input'];
  threatIntelSourceId: Scalars['String']['input'];
}


export interface MutationUploadNetworkBlocksCsvArgs {
  file: Scalars['Upload']['input'];
}


export interface MutationVisitEntityPageArgs {
  id: Scalars['ID']['input'];
}


export interface MutationVisitInsightPageArgs {
  id: Scalars['ID']['input'];
}


export interface MutationVisitSearchQueryPageArgs {
  q: Scalars['String']['input'];
  resultType: SearchResultType;
}


export interface MutationVisitSignalPageArgs {
  id: Scalars['ID']['input'];
}

export interface MutationResponse {
  __typename: 'MutationResponse';
  success: Scalars['Boolean']['output'];
}

export interface NetworkBlock {
  __typename: 'NetworkBlock';
  addressBlock: Scalars['String']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  internal: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  suppressesSignals: Scalars['Boolean']['output'];
}

export interface NetworkBlockFields {
  addressBlock: Scalars['String']['input'];
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  suppressesSignals?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface NetworkBlockPage {
  __typename: 'NetworkBlockPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<NetworkBlock>;
  total: Scalars['Int']['output'];
}

export interface NetworkBlockSort {
  direction?: SortDir;
  field?: NetworkBlockSortableField;
}

export enum NetworkBlockSortableField {
  AddressBlock = 'ADDRESS_BLOCK',
  Created = 'CREATED',
  Internal = 'INTERNAL',
  Label = 'LABEL',
  SuppressesSignals = 'SUPPRESSES_SIGNALS'
}

export interface NonTrialPlan extends CreditSubscriptionPlan {
  __typename: 'NonTrialPlan';
  planName: Scalars['String']['output'];
}

export interface NormalizedIndicator {
  __typename: 'NormalizedIndicator';
  actors?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['Int']['output']>;
  fields?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imported?: Maybe<Scalars['DateTime']['output']>;
  indicator?: Maybe<Scalars['String']['output']>;
  killChain?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  threatType?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
}

export enum NotificationInterval {
  Daily = 'DAILY',
  Never = 'NEVER',
  Weekly = 'WEEKLY'
}

export interface Organization {
  __typename: 'Organization';
  deploymentId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  orgId: Scalars['String']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  subscription: CreditSubscription;
}

export interface OrganizationsPage {
  __typename: 'OrganizationsPage';
  data: Array<Organization>;
  next?: Maybe<Scalars['String']['output']>;
}

export interface OutlierRule extends RuleInterface {
  __typename: 'OutlierRule';
  aggregationFunctions: Array<OutlierRuleAggregationFunction>;
  assetField?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of status */
  autoDisabledReason?: Maybe<Scalars['String']['output']>;
  baselineLastStarted?: Maybe<Scalars['DateTime']['output']>;
  baselineStatus: BaselineStatus;
  baselineWindowSize: Scalars['BigInt']['output'];
  baselineWindowSizeOverride?: Maybe<BigIntRuleOverride>;
  category?: Maybe<Scalars['String']['output']>;
  contentType: ContentType;
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  createdByUser?: Maybe<User>;
  deleted: Scalars['Boolean']['output'];
  descriptionExpression: Scalars['String']['output'];
  descriptionExpressionOverride?: Maybe<StringRuleOverride>;
  deviationThreshold: Scalars['Int']['output'];
  deviationThresholdOverride?: Maybe<IntRuleOverride>;
  enabled: Scalars['Boolean']['output'];
  entitySelectors: Array<OutputEntitySelectorType>;
  entitySelectorsOverride?: Maybe<EntitySelectorsRuleOverride>;
  exportJson: Scalars['String']['output'];
  failing: Scalars['Boolean']['output'];
  floorValue: Scalars['Int']['output'];
  floorValueOverride?: Maybe<IntRuleOverride>;
  groupByFields: Array<Scalars['String']['output']>;
  groupByFieldsOverride?: Maybe<StringListRuleOverride>;
  hasOverride: Scalars['Boolean']['output'];
  history: Array<RuleHistoryEvent>;
  id: Scalars['ID']['output'];
  isPrototype: Scalars['Boolean']['output'];
  isPrototypeOverride?: Maybe<BooleanRuleOverride>;
  lastUpdated: Scalars['DateTime']['output'];
  lastUpdatedBy: Scalars['String']['output'];
  lastUpdatedByUser?: Maybe<User>;
  matchExpression: Scalars['String']['output'];
  name: Scalars['String']['output'];
  nameExpression: Scalars['String']['output'];
  nameExpressionOverride?: Maybe<StringRuleOverride>;
  nameOverride?: Maybe<StringRuleOverride>;
  parentJaskId?: Maybe<Scalars['ID']['output']>;
  rawJson?: Maybe<Scalars['String']['output']>;
  rawStatus?: Maybe<RuleStatus>;
  retentionWindowSize: Scalars['BigInt']['output'];
  retentionWindowSizeOverride?: Maybe<BigIntRuleOverride>;
  ruleDescription?: Maybe<Scalars['String']['output']>;
  ruleId: Scalars['Int']['output'];
  ruleSource: Scalars['String']['output'];
  ruleType: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  scoreOverride?: Maybe<IntRuleOverride>;
  signalCount07d: Scalars['Int']['output'];
  signalCount24h: Scalars['Int']['output'];
  status: RuleStatus;
  summaryExpression: Scalars['String']['output'];
  summaryExpressionOverride?: Maybe<StringRuleOverride>;
  suppressionWindowSize?: Maybe<Scalars['Int']['output']>;
  suppressionWindowSizeOverride?: Maybe<IntRuleOverride>;
  tags: Array<Scalars['String']['output']>;
  tagsOverride?: Maybe<StringListRuleOverride>;
  tuningExpressionIds?: Maybe<Array<Scalars['String']['output']>>;
  tuningExpressions?: Maybe<Array<RuleTuningExpression>>;
  version: Scalars['Int']['output'];
  windowSize: Scalars['Int']['output'];
  windowSizeName: Scalars['String']['output'];
  windowSizeOverride?: Maybe<IntRuleOverride>;
}

export interface OutlierRuleAggregationFunction {
  __typename: 'OutlierRuleAggregationFunction';
  arguments: Array<Scalars['String']['output']>;
  function: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface OutlierRuleAggregationFunctionField {
  arguments: Array<Scalars['String']['input']>;
  function: Scalars['String']['input'];
  name: Scalars['String']['input'];
}

export interface OutputEntitySelectorType {
  __typename: 'OutputEntitySelectorType';
  entityType: Scalars['String']['output'];
  expression: Scalars['String']['output'];
}

export interface OverrideAggregationRule {
  __typename: 'OverrideAggregationRule';
  data: AggregationRule;
}

export interface OverrideAggregationRuleFields {
  descriptionExpression?: InputMaybe<Scalars['String']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  groupByFields?: InputMaybe<Array<Scalars['String']['input']>>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameExpression?: InputMaybe<Scalars['String']['input']>;
  ruleDescription?: InputMaybe<Scalars['String']['input']>;
  scoreMapping?: InputMaybe<RuleScoreMappingFields>;
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  windowSize?: InputMaybe<RuleWindowSizeEnum>;
  windowSizeMilliseconds?: InputMaybe<Scalars['BigInt']['input']>;
}

export interface OverrideChainRule {
  __typename: 'OverrideChainRule';
  data: ChainRule;
}

export interface OverrideChainRuleFields {
  description?: InputMaybe<Scalars['String']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  groupByFields?: InputMaybe<Array<Scalars['String']['input']>>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  limits?: InputMaybe<Array<OverrideChainRuleLimitField>>;
  name?: InputMaybe<Scalars['String']['input']>;
  ruleDescription?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  windowSize?: InputMaybe<RuleWindowSizeEnum>;
  windowSizeMilliseconds?: InputMaybe<Scalars['BigInt']['input']>;
}

export interface OverrideChainRuleLimitField {
  index: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}

export interface OverrideFirstSeenRule {
  __typename: 'OverrideFirstSeenRule';
  data: FirstSeenRule;
}

export interface OverrideFirstSeenRuleFields {
  baselineWindowSize?: InputMaybe<Scalars['BigInt']['input']>;
  descriptionExpression?: InputMaybe<Scalars['String']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  groupByFields?: InputMaybe<Array<Scalars['String']['input']>>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameExpression?: InputMaybe<Scalars['String']['input']>;
  retentionWindowSize?: InputMaybe<Scalars['BigInt']['input']>;
  ruleDescription?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

export interface OverrideMatchRule {
  __typename: 'OverrideMatchRule';
  data: MatchRule;
}

export interface OverrideMatchRuleFields {
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ruleDescription?: InputMaybe<Scalars['String']['input']>;
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

export interface OverrideOutlierRule {
  __typename: 'OverrideOutlierRule';
  data: OutlierRule;
}

export interface OverrideOutlierRuleFields {
  baselineWindowSize?: InputMaybe<Scalars['BigInt']['input']>;
  descriptionExpression?: InputMaybe<Scalars['String']['input']>;
  deviationThreshold?: InputMaybe<Scalars['BigInt']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  floorValue?: InputMaybe<Scalars['BigInt']['input']>;
  groupByFields?: InputMaybe<Array<Scalars['String']['input']>>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameExpression?: InputMaybe<Scalars['String']['input']>;
  retentionWindowSize?: InputMaybe<Scalars['BigInt']['input']>;
  ruleDescription?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  windowSize?: InputMaybe<RuleWindowSizeEnum>;
  windowSizeMilliseconds?: InputMaybe<Scalars['BigInt']['input']>;
}

export interface OverrideTemplatedMatchRule {
  __typename: 'OverrideTemplatedMatchRule';
  data: TemplatedMatchRule;
}

export interface OverrideTemplatedMatchRuleFields {
  descriptionExpression?: InputMaybe<Scalars['String']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameExpression?: InputMaybe<Scalars['String']['input']>;
  ruleDescription?: InputMaybe<Scalars['String']['input']>;
  scoreMapping?: InputMaybe<RuleScoreMappingFields>;
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

export interface OverrideThresholdRule {
  __typename: 'OverrideThresholdRule';
  data: ThresholdRule;
}

export interface OverrideThresholdRuleFields {
  description?: InputMaybe<Scalars['String']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  groupByFields?: InputMaybe<Array<Scalars['String']['input']>>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ruleDescription?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  windowSize?: InputMaybe<RuleWindowSizeEnum>;
  windowSizeMilliseconds?: InputMaybe<Scalars['BigInt']['input']>;
}

export interface ParameterAutoComplete {
  __typename: 'ParameterAutoComplete';
  autoCompleteKey?: Maybe<Scalars['String']['output']>;
  autoCompleteValues?: Maybe<Array<AutoCompleteValue>>;
  lookupMetaData?: Maybe<ServiceAutoCompleteLookupMetaData>;
  type?: Maybe<Scalars['String']['output']>;
}

export interface ParameterAutoCompleteInput {
  autoCompleteKey?: InputMaybe<Scalars['String']['input']>;
  autoCompleteValues?: InputMaybe<Array<InputMaybe<AutoCompleteValueInput>>>;
  lookupMetaData?: InputMaybe<ServiceAutoCompleteLookupMetaDataInput>;
  type?: InputMaybe<Scalars['String']['input']>;
}

export interface ParameterLabelValue {
  __typename: 'ParameterLabelValue';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
}

export interface ParameterLabelValueInput {
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
}

export interface ParsedStructuredLogField {
  __typename: 'ParsedStructuredLogField';
  name?: Maybe<Scalars['String']['output']>;
  samples?: Maybe<Array<Maybe<ParsedStructuredLogSample>>>;
}

export interface ParsedStructuredLogResult {
  __typename: 'ParsedStructuredLogResult';
  fields?: Maybe<Array<Maybe<ParsedStructuredLogField>>>;
  format?: Maybe<Scalars['String']['output']>;
}

export interface ParsedStructuredLogSample {
  __typename: 'ParsedStructuredLogSample';
  count?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
}

export interface ParsingPattern {
  __typename: 'ParsingPattern';
  id: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface PathElement {
  __typename: 'PathElement';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
}

export interface Permission {
  __typename: 'Permission';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
}

export interface PermissionPage {
  __typename: 'PermissionPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<Permission>;
  total: Scalars['Int']['output'];
}

export interface Playbook {
  __typename: 'Playbook';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface Privilege {
  __typename: 'Privilege';
  description: Scalars['String']['output'];
  key: UserPrivilege;
  value: Scalars['Boolean']['output'];
}

export interface PromoteTriageToIncident {
  __typename: 'PromoteTriageToIncident';
  data: Insight;
}

export interface Query {
  __typename: 'Query';
  accountStatus: AccountStatus;
  action: Action;
  actionConfigurationSchema: ActionConfigurationSchema;
  actionConfigurationSchemas?: Maybe<Array<ActionConfigurationSchema>>;
  actions: Array<Action>;
  activeDeviceCount: Scalars['Int']['output'];
  activeUserCount: Scalars['Int']['output'];
  aggregationRuleFunctions: Array<AggregationRuleFunction>;
  aggregationRuleValidationResult: RuleValidationResult;
  alertCount: Scalars['Int']['output'];
  allEntities: AllEntityPage;
  allInsights: AllInsightPage;
  allSignals: AllSignalPage;
  allThreatIntelItems: AllThreatIntelItemPage;
  allowedInsightStatuses: Array<AllowedInsightStatus>;
  apiDocumentationLink: Scalars['String']['output'];
  assignedInsightEmailsEnabled: Scalars['Boolean']['output'];
  auditLogs?: Maybe<AuditLogPage>;
  automation: Automation;
  automations: AutomationPage;
  bigIntInsightCountWithDelta: BigIntCountWithDelta;
  bigIntRecordCountWithDelta: BigIntCountWithDelta;
  bigIntSignalCountWithDelta: BigIntCountWithDelta;
  categories: Array<Category>;
  chainRuleValidationResult: RuleValidationResult;
  cloudSoarUrl?: Maybe<Scalars['String']['output']>;
  contentItems: Array<FolderableType>;
  contextAction: ContextAction;
  contextActions: ContextActionPage;
  coverageColorHexCodes: MitreCoverageColorLegend;
  cspCustomReportUrl?: Maybe<Scalars['String']['output']>;
  currentUser: CurrentUser;
  currentUserSumo: CurrentUserSumo;
  customEntityType: CustomEntityType;
  customEntityTypes: CustomEntityTypePage;
  customInsight: CustomInsight;
  customInsights: CustomInsightPage;
  customMatchListColumn: CustomMatchListColumn;
  customMatchListColumnLimit: Scalars['Int']['output'];
  customMatchListColumns: Array<CustomMatchListColumn>;
  customerSourcedLookupTable: CustomerSourcedEntityLookupTable;
  customerSourcedLookupTables: Array<CustomerSourcedEntityLookupTable>;
  deployment: Scalars['String']['output'];
  downloadsForProduct: Array<Maybe<Download>>;
  dslSearchResults: SearchResultPage;
  enabledFeatureFlagEnums: Array<FeatureFlag>;
  enabledFeatureFlags: Array<Scalars['String']['output']>;
  enabledFeatureflagsV2: Array<Scalars['String']['output']>;
  enforcedOutputSchemaFields: Array<EnforcedOutputField>;
  enrichmentConfig: EnrichmentConfig;
  entities: EntityPage;
  entitiesByListIds?: Maybe<Array<EntityInterface>>;
  entity: EntityInterface;
  entityCriticalityConfig: EntityCriticalityConfig;
  entityCriticalityConfigs: EntityCriticalityConfigPage;
  entityDomainConfiguration: EntityDomainConfiguration;
  entityFields: Array<Scalars['String']['output']>;
  entityFieldsWithTypes: Array<EntityFieldAndType>;
  entityGroupConfiguration: EntityGroupConfiguration;
  entityGroupConfigurations: EntityGroupConfigurationPage;
  entityNotes: Array<EntityNote>;
  entityTagOptions: Array<EntityTagOption>;
  entityTimelineGroups: Array<EntityTimelineGroup>;
  favoriteFields: FavoriteFieldPage;
  favoriteItems: ContentPage;
  federatedChildOrgs: Array<FederatedChildOrg>;
  folder?: Maybe<Folder>;
  groupedInsights: Array<GroupedInsightPage>;
  healthCheck: Scalars['String']['output'];
  incidentSearchResults: Array<IncidentSearchResult>;
  incidentTemplates: Array<IncidentTemplate>;
  insight: Insight;
  insightActivityFeedEvents: InsightActivityFeedEventPage;
  insightClosedCounts: Array<BigIntDataPoint>;
  insightConfig?: Maybe<InsightConfig>;
  /** @deprecated Deprecated in favor of bigIntInsightCountWithDelta */
  insightCountWithDelta: CountWithDelta;
  insightCounts: Array<BigIntDataPoint>;
  insightCountsByStatus: Array<InsightCountsByStatusDataPoint>;
  insightEntityActivity: Array<InsightEntityActivity>;
  insightResolution: InsightResolution;
  insightResolutions: InsightResolutionPage;
  insightStatus: InsightStatus;
  insightStatusInProgressEnabled: Scalars['Boolean']['output'];
  insightStatuses: Array<InsightStatus>;
  insightTagOptions: Array<InsightTagOption>;
  insights: InsightPage;
  inventories: InventoryPage;
  inventoryGroupOptions: Array<InventoryGroupOption>;
  inventoryLookupTable: InventoryEntityLookupTable;
  inventoryLookupTableSources: Array<Scalars['String']['output']>;
  inventoryLookupTables: Array<InventoryEntityLookupTable>;
  inventorySources?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isFederatedCluster: Scalars['Boolean']['output'];
  isInContentAdminMode: Scalars['Boolean']['output'];
  libraryGlobalView: LibraryGlobalView;
  logExecutionContext: Scalars['String']['output'];
  logMapping: LogMapping;
  logMappingOptions: LogMappingOptions;
  logMappingVendorsAndProducts: Array<LogMappingVendorAndProduct>;
  logMappings: LogMappingPage;
  matchList: MatchList;
  matchListItem: MatchListItem;
  matchListItemCount: Scalars['Int']['output'];
  matchListItemLimit: Scalars['Int']['output'];
  matchListItems: MatchListItemPage;
  matchListItems2: MatchListItemPage;
  matchLists: MatchListPage;
  matchRuleValidationResult: RuleValidationResult;
  meanTimeToDetection?: Maybe<Scalars['TimeDelta']['output']>;
  meanTimeToRemediation?: Maybe<Scalars['TimeDelta']['output']>;
  meanTimeToResponse?: Maybe<Scalars['TimeDelta']['output']>;
  mfaEnabled: Scalars['Boolean']['output'];
  mitreAttackCoverageExportJson: Scalars['String']['output'];
  mitreTaggedRules: MitreTaggedRules;
  networkBlock: NetworkBlock;
  networkBlocks: NetworkBlockPage;
  networkBlocksByIp: Array<NetworkBlock>;
  objectTypes: Array<Scalars['String']['output']>;
  orgId: Scalars['String']['output'];
  orgName: Scalars['String']['output'];
  organizations: OrganizationsPage;
  parsedStructuredLog?: Maybe<ParsedStructuredLogResult>;
  permissions: PermissionPage;
  pinnedSearches: ContentPage;
  playbooks: Array<Playbook>;
  recentItems: ContentPage;
  recentItemsV2: RecentItemsByType;
  recentlyVisitedDetailPages: Array<VisitedDetailPage>;
  recentlyVisitedSearchQueryPages: Array<VisitedSearchQueryPage>;
  recordArtifactConfigs: RecordArtifactConfigPage;
  /** @deprecated Deprecated in favor of bigIntRecordCountWithDelta */
  recordCountWithDelta: CountWithDelta;
  recordCounts: Array<BigIntDataPoint>;
  recordCountsByParsed: Array<RecordCountsByParsedDataPoint>;
  recordCountsByVendor: Array<CountsByVendorDataPoint>;
  recordCountsByVendorAndProduct: Array<CountsByVendorAndProductDataPoint>;
  recordSchema: Scalars['String']['output'];
  recordStreams?: Maybe<Array<Scalars['String']['output']>>;
  relatedEntities: Array<RelatedEntity>;
  relatedEntitiesById?: Maybe<Array<EntityInterface>>;
  role: Role;
  roles: RolePage;
  rule: Rule;
  ruleStreams?: Maybe<Array<Scalars['String']['output']>>;
  ruleTagOptions: Array<RuleTagOption>;
  ruleTranslation: Scalars['String']['output'];
  ruleTuningExpression: RuleTuningExpression;
  ruleTuningExpressions: RuleTuningExpressionPage;
  rules: RulePage;
  savedSearches: Array<SavedSearch>;
  searchFieldSuggestions: SearchFieldSuggestionPage;
  sensorZones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sessionTimeoutMinutes?: Maybe<Scalars['Int']['output']>;
  signal: Signal;
  /** @deprecated Deprecated in favor of bigIntSignalCountWithDelta */
  signalCountWithDelta: CountWithDelta;
  signalCounts: Array<BigIntDataPoint>;
  signalCountsByVendor: Array<CountsByVendorDataPoint>;
  signalCountsByVendorAndProduct: Array<CountsByVendorAndProductDataPoint>;
  signalTagOptions: Array<SignalTagOption>;
  signals: SignalPage;
  ssoEnabled: Scalars['Boolean']['output'];
  ssoSettings: SsoSettings;
  streamingExportConfiguration: StreamingExportConfiguration;
  streamingExportConfigurations: StreamingExportConfigurationPage;
  sumoLogicAccessId?: Maybe<Scalars['String']['output']>;
  sumoLogicBaseUrl?: Maybe<Scalars['String']['output']>;
  sumoLogicCustomerId?: Maybe<Scalars['String']['output']>;
  sumoLogicRegion?: Maybe<Scalars['String']['output']>;
  sumoMapping: SumoMapping;
  sumoMappings: SumoMappingPage;
  sumoRawMessageLookupJobResult?: Maybe<Scalars['String']['output']>;
  sumoRecordSearchJobObjectTypeCounts: Array<SumoSearchObjectTypeCount>;
  sumoRecordSearchJobResults: Array<Scalars['String']['output']>;
  sumoRecordSearchJobStatus: SumoSearchJobStatus;
  sumoRecordSearchQuery: Scalars['String']['output'];
  sumoSsoEnabled: Scalars['Boolean']['output'];
  sumoUsers: SumoUsersPage;
  suppressList: SuppressList;
  suppressListItem: SuppressListItem;
  suppressListItemCount: Scalars['Int']['output'];
  suppressListItemLimit: Scalars['Int']['output'];
  suppressListItems: SuppressListItemPage;
  suppressLists: SuppressListPage;
  tactics: MitreTacticCoverageView;
  tacticsAndTechniquesFilter: MitreTacticTechniqueFilter;
  tagSchema: TagSchema;
  tagSchemas: Array<TagSchema>;
  teams: TeamPage;
  technique: MitreTechnique;
  templatedMatchRuleValidationResult: RuleValidationResult;
  threatIntelItem: ThreatIntelItem;
  threatIntelItemCount: Scalars['Int']['output'];
  threatIntelItemLimit: Scalars['Int']['output'];
  threatIntelItems: ThreatIntelItemPage;
  threatIntelItems2: ThreatIntelItemPage;
  threatIntelSource: ThreatIntelSource;
  threatIntelSources: ThreatIntelSourcePage;
  thresholdRuleValidationResult: RuleValidationResult;
  tiers: TiersPage;
  user: User;
  userInvitations: UserInvitationPage;
  userPreferences: UserPreferences;
  userPrivileges: Array<Privilege>;
  usernameForPasswordReset: Scalars['String']['output'];
  users: UserPage;
  validateYaraExpression?: Maybe<YaraExpressionValidationError>;
  vendorProductsFilter: VendorProductFilter;
  version: Scalars['String']['output'];
  virusTotalConfig: VirusTotalConfig;
  yaraRule: YaraRule;
  yaraRules: YaraRulePage;
  yaraSource: YaraSource;
  yaraSources: YaraSourcePage;
}


export interface QueryActionArgs {
  id: Scalars['ID']['input'];
}


export interface QueryActionConfigurationSchemaArgs {
  typeValue: Scalars['String']['input'];
}


export interface QueryActionsArgs {
  notificationType?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryActiveDeviceCountArgs {
  daysBack?: InputMaybe<Scalars['Int']['input']>;
  interval?: InputMaybe<Scalars['TimeDelta']['input']>;
}


export interface QueryActiveUserCountArgs {
  daysBack?: InputMaybe<Scalars['Int']['input']>;
  interval?: InputMaybe<Scalars['TimeDelta']['input']>;
}


export interface QueryAggregationRuleValidationResultArgs {
  ruleFields: AggregationRuleFields;
}


export interface QueryAllEntitiesArgs {
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryAllInsightsArgs {
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryAllSignalsArgs {
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryAllThreatIntelItemsArgs {
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ThreatIntelItemSort>>;
  sourceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryAllowedInsightStatusesArgs {
  insightId?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryAuditLogsArgs {
  actingUsername?: InputMaybe<Scalars['String']['input']>;
  endTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  startTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  targetInsightId?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryAutomationArgs {
  id: Scalars['ID']['input'];
}


export interface QueryAutomationsArgs {
  cseResourceType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AutomationSort>>;
}


export interface QueryBigIntInsightCountWithDeltaArgs {
  interval?: InputMaybe<Scalars['TimeDelta']['input']>;
}


export interface QueryBigIntRecordCountWithDeltaArgs {
  interval?: InputMaybe<Scalars['TimeDelta']['input']>;
}


export interface QueryBigIntSignalCountWithDeltaArgs {
  interval?: InputMaybe<Scalars['TimeDelta']['input']>;
}


export interface QueryChainRuleValidationResultArgs {
  ruleFields: ChainRuleFields;
}


export interface QueryContentItemsArgs {
  depth?: InputMaybe<Scalars['Int']['input']>;
  findExpression: Scalars['String']['input'];
  include: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryContextActionArgs {
  id: Scalars['ID']['input'];
}


export interface QueryContextActionsArgs {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  iocType?: InputMaybe<ContextActionIocType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ContextActionSort>>;
}


export interface QueryCustomEntityTypeArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryCustomEntityTypesArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryCustomInsightArgs {
  id: Scalars['ID']['input'];
}


export interface QueryCustomInsightsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryCustomMatchListColumnArgs {
  id: Scalars['ID']['input'];
}


export interface QueryCustomerSourcedLookupTableArgs {
  id: Scalars['ID']['input'];
}


export interface QueryDownloadsForProductArgs {
  product: Scalars['String']['input'];
}


export interface QueryDslSearchResultsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  resultType?: InputMaybe<SearchResultType>;
  sort?: InputMaybe<Array<SearchResultSort>>;
}


export interface QueryEnabledFeatureFlagsArgs {
  enabledByDefaultFeatureFlags?: InputMaybe<Array<Scalars['String']['input']>>;
  featureFlagsToLookup: Array<Scalars['String']['input']>;
}


export interface QueryEnabledFeatureflagsV2Args {
  featureflagsToLookup?: InputMaybe<Array<Scalars['String']['input']>>;
  fetchAll?: InputMaybe<Scalars['Boolean']['input']>;
  forceDisabledFlags?: InputMaybe<Array<Scalars['String']['input']>>;
  forceEnabledFlags?: InputMaybe<Array<Scalars['String']['input']>>;
}


export interface QueryEntitiesArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<EntitySort>>;
}


export interface QueryEntitiesByListIdsArgs {
  entityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}


export interface QueryEntityArgs {
  id: Scalars['ID']['input'];
}


export interface QueryEntityCriticalityConfigArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryEntityCriticalityConfigsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryEntityGroupConfigurationArgs {
  id: Scalars['ID']['input'];
}


export interface QueryEntityGroupConfigurationsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<EntityGroupConfigurationSort>>;
}


export interface QueryEntityNotesArgs {
  entityId: Scalars['ID']['input'];
}


export interface QueryEntityTimelineGroupsArgs {
  jobId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryFavoriteFieldsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<FavoriteFieldSort>>;
}


export interface QueryFavoriteItemsArgs {
  legacyRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  types: Array<ContentTypeSumo>;
}


export interface QueryFolderArgs {
  id: Scalars['Int']['input'];
}


export interface QueryGroupedInsightsArgs {
  groupBy: InsightGroupBy;
  groups?: InputMaybe<Array<InputMaybe<InsightGroupOffset>>>;
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InsightSort>>;
}


export interface QueryIncidentSearchResultsArgs {
  query: Scalars['String']['input'];
}


export interface QueryInsightArgs {
  id: Scalars['ID']['input'];
  includeEntityDetails?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryInsightActivityFeedEventsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextPageTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
}


export interface QueryInsightClosedCountsArgs {
  bucketDuration: Scalars['TimeDelta']['input'];
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryInsightCountWithDeltaArgs {
  interval?: InputMaybe<Scalars['TimeDelta']['input']>;
}


export interface QueryInsightCountsArgs {
  bucketDuration: Scalars['TimeDelta']['input'];
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryInsightCountsByStatusArgs {
  bucketDuration: Scalars['TimeDelta']['input'];
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryInsightEntityActivityArgs {
  insightId: Scalars['ID']['input'];
}


export interface QueryInsightResolutionArgs {
  id: Scalars['Int']['input'];
}


export interface QueryInsightResolutionsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sourceFilter?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryInsightStatusArgs {
  id: Scalars['ID']['input'];
}


export interface QueryInsightStatusesArgs {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface QueryInsightsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InsightSort>>;
}


export interface QueryInventoriesArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InventorySort>>;
}


export interface QueryInventoryLookupTableArgs {
  id: Scalars['ID']['input'];
}


export interface QueryLogMappingArgs {
  id: Scalars['String']['input'];
}


export interface QueryLogMappingVendorsAndProductsArgs {
  product?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryLogMappingsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<LogMappingSort>>;
}


export interface QueryMatchListArgs {
  getTargetCustomColumnName?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
}


export interface QueryMatchListItemArgs {
  id: Scalars['ID']['input'];
}


export interface QueryMatchListItemsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  listIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<MatchListItemSort>>;
}


export interface QueryMatchListItems2Args {
  limit?: InputMaybe<Scalars['Int']['input']>;
  listIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<MatchListItemSort>>;
}


export interface QueryMatchListsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<SortDir>;
}


export interface QueryMatchRuleValidationResultArgs {
  ruleFields: MatchRuleFields;
}


export interface QueryMeanTimeToDetectionArgs {
  interval?: InputMaybe<Scalars['TimeDelta']['input']>;
}


export interface QueryMeanTimeToRemediationArgs {
  interval?: InputMaybe<Scalars['TimeDelta']['input']>;
}


export interface QueryMeanTimeToResponseArgs {
  interval?: InputMaybe<Scalars['TimeDelta']['input']>;
}


export interface QueryMitreAttackCoverageExportJsonArgs {
  includeFiltered?: InputMaybe<Scalars['Boolean']['input']>;
  rulesFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  subTechniquesFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tacticsFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  techniquesFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorProductGuidsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  view: Scalars['String']['input'];
}


export interface QueryMitreTaggedRulesArgs {
  includeDisabledRules?: InputMaybe<Scalars['Boolean']['input']>;
  includeEnabledRules?: InputMaybe<Scalars['Boolean']['input']>;
  includeNonPrototypeRules?: InputMaybe<Scalars['Boolean']['input']>;
  includePrototypeRules?: InputMaybe<Scalars['Boolean']['input']>;
  includeSumoRules?: InputMaybe<Scalars['Boolean']['input']>;
  includeUserRules?: InputMaybe<Scalars['Boolean']['input']>;
  view: Scalars['String']['input'];
}


export interface QueryNetworkBlockArgs {
  id: Scalars['ID']['input'];
}


export interface QueryNetworkBlocksArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<NetworkBlockSort>>;
}


export interface QueryNetworkBlocksByIpArgs {
  address: Scalars['String']['input'];
}


export interface QueryOrganizationsArgs {
  emailId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  parentDeploymentId: Scalars['String']['input'];
  status?: InputMaybe<CreditSubscriptionStatus>;
}


export interface QueryParsedStructuredLogArgs {
  text: Scalars['String']['input'];
}


export interface QueryPermissionsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryPinnedSearchesArgs {
  legacyRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryRecentItemsArgs {
  legacyRoutes?: InputMaybe<Scalars['Boolean']['input']>;
  types: Array<ContentTypeSumo>;
}


export interface QueryRecordArtifactConfigsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<SortDir>;
}


export interface QueryRecordCountWithDeltaArgs {
  interval?: InputMaybe<Scalars['TimeDelta']['input']>;
}


export interface QueryRecordCountsArgs {
  bucketDuration: Scalars['TimeDelta']['input'];
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start: Scalars['DateTime']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryRecordCountsByParsedArgs {
  daysBack: Scalars['Int']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryRecordCountsByVendorArgs {
  daysBack: Scalars['Int']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryRecordCountsByVendorAndProductArgs {
  daysBack: Scalars['Int']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryRecordSchemaArgs {
  recordType: Scalars['String']['input'];
}


export interface QueryRelatedEntitiesArgs {
  end: Scalars['DateTime']['input'];
  ip: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
}


export interface QueryRelatedEntitiesByIdArgs {
  end: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
}


export interface QueryRoleArgs {
  id: Scalars['ID']['input'];
}


export interface QueryRolesArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface QueryRuleArgs {
  id: Scalars['ID']['input'];
}


export interface QueryRuleTranslationArgs {
  ruleExpression: Scalars['String']['input'];
  ruleTuningExpressions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ruleTuningTranslationExpressions?: InputMaybe<Array<RuleTuningExpressionTranslationFields>>;
}


export interface QueryRuleTuningExpressionArgs {
  id: Scalars['ID']['input'];
}


export interface QueryRuleTuningExpressionsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<RuleTuningExpressionSort>>;
}


export interface QueryRulesArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<RuleSort>>;
}


export interface QuerySavedSearchesArgs {
  ids: Array<Scalars['Int']['input']>;
}


export interface QuerySearchFieldSuggestionsArgs {
  fieldName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  resultType: SearchResultType;
}


export interface QuerySignalArgs {
  id: Scalars['ID']['input'];
}


export interface QuerySignalCountWithDeltaArgs {
  interval?: InputMaybe<Scalars['TimeDelta']['input']>;
}


export interface QuerySignalCountsArgs {
  bucketDuration: Scalars['TimeDelta']['input'];
  end?: InputMaybe<Scalars['DateTime']['input']>;
  ruleId?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['DateTime']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}


export interface QuerySignalCountsByVendorArgs {
  daysBack: Scalars['Int']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}


export interface QuerySignalCountsByVendorAndProductArgs {
  daysBack: Scalars['Int']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}


export interface QuerySignalsArgs {
  includeEntityDetails?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SignalSort>>;
}


export interface QueryStreamingExportConfigurationArgs {
  id: Scalars['ID']['input'];
}


export interface QueryStreamingExportConfigurationsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<StreamingExportConfigurationSort>>;
}


export interface QuerySumoMappingArgs {
  id: Scalars['ID']['input'];
}


export interface QuerySumoMappingsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<SumoMappingSort>>;
}


export interface QuerySumoRawMessageLookupJobResultArgs {
  jobId: Scalars['ID']['input'];
}


export interface QuerySumoRecordSearchJobObjectTypeCountsArgs {
  jobId: Scalars['ID']['input'];
}


export interface QuerySumoRecordSearchJobResultsArgs {
  jobId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}


export interface QuerySumoRecordSearchJobStatusArgs {
  jobId: Scalars['ID']['input'];
}


export interface QuerySumoRecordSearchQueryArgs {
  q: Scalars['String']['input'];
  querySyntax?: InputMaybe<SumoSearchQuerySyntax>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<SortDir>;
}


export interface QuerySumoUsersArgs {
  fetchAllUsers?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
}


export interface QuerySuppressListArgs {
  id: Scalars['ID']['input'];
}


export interface QuerySuppressListItemArgs {
  id: Scalars['ID']['input'];
}


export interface QuerySuppressListItemsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  listIds?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<SuppressListItemSort>>;
}


export interface QuerySuppressListsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<SortDir>;
}


export interface QueryTacticsArgs {
  rulesFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  subTechniquesFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tacticsFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  techniquesFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vendorProductGuidsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  view: Scalars['String']['input'];
}


export interface QueryTagSchemaArgs {
  key: Scalars['ID']['input'];
}


export interface QueryTechniqueArgs {
  id: Scalars['ID']['input'];
}


export interface QueryTemplatedMatchRuleValidationResultArgs {
  ruleFields: TemplatedMatchRuleFields;
}


export interface QueryThreatIntelItemArgs {
  id: Scalars['ID']['input'];
}


export interface QueryThreatIntelItemsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ThreatIntelItemSort>>;
  sourceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sourceName?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryThreatIntelItems2Args {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<ThreatIntelItemSort>>;
  sourceIds?: InputMaybe<Array<Scalars['String']['input']>>;
}


export interface QueryThreatIntelSourceArgs {
  id: Scalars['ID']['input'];
}


export interface QueryThreatIntelSourcesArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<SortDir>;
}


export interface QueryThresholdRuleValidationResultArgs {
  ruleFields: ThresholdRuleFields;
}


export interface QueryTiersArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextPageToken?: InputMaybe<Scalars['String']['input']>;
  viewTypes?: InputMaybe<Scalars['String']['input']>;
}


export interface QueryUserArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


export interface QueryUserInvitationsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<SortDir>;
}


export interface QueryUsernameForPasswordResetArgs {
  email: Scalars['String']['input'];
  passwordResetToken: Scalars['String']['input'];
}


export interface QueryUsersArgs {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  emailConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<SortDir>;
}


export interface QueryValidateYaraExpressionArgs {
  expression: Scalars['String']['input'];
}


export interface QueryVendorProductsFilterArgs {
  view: Scalars['String']['input'];
}


export interface QueryYaraRuleArgs {
  id: Scalars['ID']['input'];
}


export interface QueryYaraRulesArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<YaraRuleSort>>;
  sourceIds?: InputMaybe<Array<Scalars['String']['input']>>;
}


export interface QueryYaraSourceArgs {
  id: Scalars['ID']['input'];
}


export interface QueryYaraSourcesArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<SortDir>;
}

export enum QueryModes {
  Advanced = 'Advanced',
  Basic = 'Basic'
}

export enum QueryTypes {
  Logs = 'Logs',
  Metrics = 'Metrics'
}

export interface RecentItem {
  accessKey?: Maybe<Scalars['String']['output']>;
  accessTime: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  pageType: RecentPageType;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  runAsIdOverride?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
}

export interface RecentItemsByType {
  __typename: 'RecentItemsByType';
  dashboards: Array<DashboardRecentItem>;
  livetails: Array<LivetailRecentItem>;
  logs: Array<LogRecentItem>;
  metrics: Array<MetricRecentItem>;
  spans: Array<SpanRecentItem>;
  standardPages: Array<StandardPageRecentItem>;
}

export enum RecentPageType {
  Dashboard = 'dashboard',
  Livetail = 'livetail',
  Log = 'log',
  Metric = 'metric',
  Span = 'span',
  StandardPage = 'standardPage'
}

export interface RecordArtifactConfig {
  __typename: 'RecordArtifactConfig';
  fieldPath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  recordType: Scalars['String']['output'];
}

export interface RecordArtifactConfigEditableFields {
  fieldPath: Scalars['String']['input'];
  name: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
}

export interface RecordArtifactConfigPage {
  __typename: 'RecordArtifactConfigPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<RecordArtifactConfig>;
  total: Scalars['Int']['output'];
}

export interface RecordCountByParsed {
  __typename: 'RecordCountByParsed';
  parsed: Scalars['BigInt']['output'];
  unparsed: Scalars['BigInt']['output'];
}

export interface RecordCountsByParsedDataPoint {
  __typename: 'RecordCountsByParsedDataPoint';
  timestamp: Scalars['DateTime']['output'];
  value: RecordCountByParsed;
}

export interface RecordSummaryField {
  __typename: 'RecordSummaryField';
  fieldName: Scalars['String']['output'];
  fieldValue: Scalars['String']['output'];
  recordCount: Scalars['Int']['output'];
}

export interface RelatedEntity {
  __typename: 'RelatedEntity';
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface RelatedIncident {
  __typename: 'RelatedIncident';
  assignee?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  link: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
}

export interface RelatedIncidentFields {
  assignee?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  link: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
}

export interface RemoveEntityTags {
  __typename: 'RemoveEntityTags';
  data?: Maybe<EntityInterface>;
}

export interface RemoveInsightRelatedIncident {
  __typename: 'RemoveInsightRelatedIncident';
  data: Insight;
}

export interface RemoveSignalsFromInsight {
  __typename: 'RemoveSignalsFromInsight';
  data: Insight;
}

export interface RemoveTagFromInsight {
  __typename: 'RemoveTagFromInsight';
  data: Insight;
}

export interface RemoveTagFromInsightsById {
  __typename: 'RemoveTagFromInsightsById';
  ok: Scalars['Boolean']['output'];
}

export interface ReorderInsightStatuses {
  __typename: 'ReorderInsightStatuses';
  ok: Scalars['Boolean']['output'];
}

export interface ResendCurrentUserConfirmationEmail {
  __typename: 'ResendCurrentUserConfirmationEmail';
  ok: Scalars['Boolean']['output'];
}

export interface ResendUserConfirmationEmail {
  __typename: 'ResendUserConfirmationEmail';
  ok: Scalars['Boolean']['output'];
}

export interface ResetCurrentUserApiKey {
  __typename: 'ResetCurrentUserApiKey';
  data: CurrentUser;
}

export interface ResetCurrentUserMfaSecret {
  __typename: 'ResetCurrentUserMfaSecret';
  data: CurrentUser;
}

export interface ResetPassword {
  __typename: 'ResetPassword';
  ok: Scalars['Boolean']['output'];
}

export interface ResetUserApiKey {
  __typename: 'ResetUserApiKey';
  data: User;
}

export interface ResetUserMfaSecret {
  __typename: 'ResetUserMfaSecret';
  data: User;
}

export interface Role {
  __typename: 'Role';
  assignedTo: Array<User>;
  deleted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Permission>;
}

export interface RolePage {
  __typename: 'RolePage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<Role>;
  total: Scalars['Int']['output'];
}

export type Rule = AggregationRule | ChainRule | FirstSeenRule | MatchRule | OutlierRule | TemplatedMatchRule | ThresholdRule;

export interface RuleHistoryEvent {
  __typename: 'RuleHistoryEvent';
  description: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  user?: Maybe<User>;
}

export interface RuleInterface {
  assetField?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of status */
  autoDisabledReason?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  contentType: ContentType;
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  createdByUser?: Maybe<User>;
  deleted: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  entitySelectors: Array<OutputEntitySelectorType>;
  entitySelectorsOverride?: Maybe<EntitySelectorsRuleOverride>;
  exportJson: Scalars['String']['output'];
  failing: Scalars['Boolean']['output'];
  hasOverride: Scalars['Boolean']['output'];
  history: Array<RuleHistoryEvent>;
  id: Scalars['ID']['output'];
  isPrototype: Scalars['Boolean']['output'];
  isPrototypeOverride?: Maybe<BooleanRuleOverride>;
  lastUpdated: Scalars['DateTime']['output'];
  lastUpdatedBy: Scalars['String']['output'];
  lastUpdatedByUser?: Maybe<User>;
  name: Scalars['String']['output'];
  nameOverride?: Maybe<StringRuleOverride>;
  parentJaskId?: Maybe<Scalars['ID']['output']>;
  rawJson?: Maybe<Scalars['String']['output']>;
  rawStatus?: Maybe<RuleStatus>;
  ruleDescription?: Maybe<Scalars['String']['output']>;
  ruleId: Scalars['Int']['output'];
  ruleSource: Scalars['String']['output'];
  ruleType: Scalars['String']['output'];
  signalCount07d: Scalars['Int']['output'];
  signalCount24h: Scalars['Int']['output'];
  status: RuleStatus;
  summaryExpression: Scalars['String']['output'];
  summaryExpressionOverride?: Maybe<StringRuleOverride>;
  suppressionWindowSize?: Maybe<Scalars['Int']['output']>;
  suppressionWindowSizeOverride?: Maybe<IntRuleOverride>;
  tags: Array<Scalars['String']['output']>;
  tagsOverride?: Maybe<StringListRuleOverride>;
  tuningExpressionIds?: Maybe<Array<Scalars['String']['output']>>;
  tuningExpressions?: Maybe<Array<RuleTuningExpression>>;
}

export interface RulePage {
  __typename: 'RulePage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<Rule>;
  total: Scalars['Int']['output'];
}

export interface RuleScoreMapping {
  __typename: 'RuleScoreMapping';
  default?: Maybe<Scalars['Int']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  mapping?: Maybe<Array<RuleScoreMappingItem>>;
  type: Scalars['String']['output'];
}

export interface RuleScoreMappingFields {
  default?: InputMaybe<Scalars['Int']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  mapping?: InputMaybe<Array<RuleScoreMappingItemFields>>;
  type: Scalars['String']['input'];
}

export interface RuleScoreMappingItem {
  __typename: 'RuleScoreMappingItem';
  from?: Maybe<Scalars['String']['output']>;
  fromEnd?: Maybe<Scalars['String']['output']>;
  to: Scalars['Int']['output'];
  type: Scalars['String']['output'];
}

export interface RuleScoreMappingItemFields {
  from?: InputMaybe<Scalars['String']['input']>;
  fromEnd?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['Int']['input'];
  type: Scalars['String']['input'];
}

export interface RuleScoreMappingRuleOverride {
  __typename: 'RuleScoreMappingRuleOverride';
  original?: Maybe<RuleScoreMapping>;
  override?: Maybe<RuleScoreMapping>;
}

export interface RuleSort {
  direction?: SortDir;
  field?: RuleSortableField;
}

export enum RuleSortableField {
  Created = 'CREATED',
  Enabled = 'ENABLED',
  Name = 'NAME',
  RuleSource = 'RULE_SOURCE',
  Score = 'SCORE',
  SignalCount_07D = 'SIGNAL_COUNT_07D',
  SignalCount_24H = 'SIGNAL_COUNT_24H',
  Updated = 'UPDATED'
}

export interface RuleStatus {
  __typename: 'RuleStatus';
  expression?: Maybe<Scalars['String']['output']>;
  expressionErrorEndIndex?: Maybe<Scalars['Int']['output']>;
  expressionErrorStartIndex?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of message */
  stackTrace?: Maybe<Scalars['String']['output']>;
  status: RuleStatusEnum;
}

export enum RuleStatusEnum {
  Active = 'ACTIVE',
  Degraded = 'DEGRADED',
  Disabled = 'DISABLED',
  FailedAndDisabled = 'FAILED_AND_DISABLED',
  RateLimited = 'RATE_LIMITED',
  Warning = 'WARNING'
}

export interface RuleTagOption {
  __typename: 'RuleTagOption';
  label?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
}

export interface RuleTuningExpression {
  __typename: 'RuleTuningExpression';
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  createdByUser?: Maybe<User>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  exclude: Scalars['Boolean']['output'];
  expression: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isGlobal: Scalars['Boolean']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  lastUpdatedBy: Scalars['String']['output'];
  lastUpdatedByUser?: Maybe<User>;
  name: Scalars['String']['output'];
  relatedRuleCount: Scalars['Int']['output'];
  ruleIds?: Maybe<Array<Scalars['String']['output']>>;
  rules?: Maybe<Array<Rule>>;
}

export interface RuleTuningExpressionPage {
  __typename: 'RuleTuningExpressionPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<RuleTuningExpression>;
  total: Scalars['Int']['output'];
}

export interface RuleTuningExpressionSort {
  direction?: SortDir;
  field?: RuleTuningExpressionSortableField;
}

export enum RuleTuningExpressionSortableField {
  Created = 'CREATED',
  Enabled = 'ENABLED',
  Name = 'NAME',
  RelatedRuleCount = 'RELATED_RULE_COUNT',
  Updated = 'UPDATED'
}

export interface RuleTuningExpressionTranslationFields {
  exclude: Scalars['Boolean']['input'];
  expression: Scalars['String']['input'];
}

export interface RuleValidationResult {
  __typename: 'RuleValidationResult';
  errorMessage: Scalars['String']['output'];
  isValid: Scalars['Boolean']['output'];
}

export enum RuleWindowSizeEnum {
  Custom = 'CUSTOM',
  T05D = 'T05D',
  T05M = 'T05M',
  T10M = 'T10M',
  T12H = 'T12H',
  T24H = 'T24H',
  T30M = 'T30M',
  T60M = 'T60M',
  Value = 'Value'
}

export interface SaveEntityEnrichment {
  __typename: 'SaveEntityEnrichment';
  data: Enrichment;
}

export interface SaveInsightEnrichment {
  __typename: 'SaveInsightEnrichment';
  data: Enrichment;
}

export interface SaveSignalEnrichment {
  __typename: 'SaveSignalEnrichment';
  data: Enrichment;
}

export interface SavedSearch {
  __typename: 'SavedSearch';
  description?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ownersId?: Maybe<Scalars['Int']['output']>;
  parameters?: Maybe<Array<SearchQueryParameter>>;
  query?: Maybe<SavedSearchQuery>;
  shared?: Maybe<Scalars['Boolean']['output']>;
}

export interface SavedSearchQuery {
  __typename: 'SavedSearchQuery';
  endTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  fromSavedSearch?: Maybe<Scalars['Boolean']['output']>;
  nameOverride?: Maybe<Scalars['String']['output']>;
  queryString?: Maybe<Scalars['String']['output']>;
  savedSearchId?: Maybe<Scalars['Int']['output']>;
  startTimestamp?: Maybe<Scalars['Timestamp']['output']>;
  timeExecuted?: Maybe<Scalars['BigInt']['output']>;
  timeRange?: Maybe<Scalars['String']['output']>;
}

export interface Search extends Folderable {
  __typename: 'Search';
  accessKey?: Maybe<Scalars['String']['output']>;
  actions?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['BigInt']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['BigInt']['output'];
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  modifiedAt?: Maybe<Scalars['BigInt']['output']>;
  modifiedBy?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['BigInt']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  relativePath?: Maybe<Array<PathElement>>;
  runAsIdOverride?: Maybe<Scalars['BigInt']['output']>;
  scheduled?: Maybe<Scalars['Boolean']['output']>;
  scheduledKnown?: Maybe<Scalars['Boolean']['output']>;
  sharedAt?: Maybe<Scalars['BigInt']['output']>;
  sharerId?: Maybe<Scalars['BigInt']['output']>;
  sharerName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  useViewerRbac?: Maybe<Scalars['Boolean']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
}

export interface SearchFieldSuggestion {
  __typename: 'SearchFieldSuggestion';
  value: Scalars['String']['output'];
}

export interface SearchFieldSuggestionPage {
  __typename: 'SearchFieldSuggestionPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<SearchFieldSuggestion>;
  total: Scalars['Int']['output'];
}

export interface SearchQueryParameter {
  __typename: 'SearchQueryParameter';
  autoComplete?: Maybe<ParameterAutoComplete>;
  dataType?: Maybe<Scalars['String']['output']>;
  desc?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<ParameterLabelValue>;
}

export interface SearchQueryParameterInput {
  autoComplete?: InputMaybe<ParameterAutoCompleteInput>;
  dataType?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<ParameterLabelValueInput>;
}

export interface SearchResult {
  __typename: 'SearchResult';
  matchedField?: Maybe<MatchedField>;
  object: SearchResultObject;
}

export type SearchResultObject = EntityInterface | Insight | Signal;

export interface SearchResultPage {
  __typename: 'SearchResultPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<SearchResult>;
  total: Scalars['Int']['output'];
}

export interface SearchResultSort {
  direction?: SortDir;
  field?: SearchResultSortableField;
}

export enum SearchResultSortableField {
  ActivityScore = 'ACTIVITY_SCORE',
  Assignee = 'ASSIGNEE',
  Confidence = 'CONFIDENCE',
  ContentType = 'CONTENT_TYPE',
  Created = 'CREATED',
  EntityName = 'ENTITY_NAME',
  Hostname = 'HOSTNAME',
  IpAddress = 'IP_ADDRESS',
  LastSeen = 'LAST_SEEN',
  Name = 'NAME',
  Os = 'OS',
  RecentSignalSeverity = 'RECENT_SIGNAL_SEVERITY',
  RecordCount = 'RECORD_COUNT',
  Relevance = 'RELEVANCE',
  RuleType = 'RULE_TYPE',
  SerialId = 'SERIAL_ID',
  Severity = 'SEVERITY',
  SignalCount = 'SIGNAL_COUNT',
  Stage = 'STAGE',
  Status = 'STATUS',
  Timestamp = 'TIMESTAMP',
  TriageVerdict = 'TRIAGE_VERDICT',
  Type = 'TYPE',
  UniqueSignalCount = 'UNIQUE_SIGNAL_COUNT'
}

export enum SearchResultType {
  All = 'ALL',
  Entities = 'ENTITIES',
  Insights = 'INSIGHTS',
  Mappings = 'MAPPINGS',
  Signals = 'SIGNALS'
}

export interface ServiceAutoCompleteLookupMetaData {
  __typename: 'ServiceAutoCompleteLookupMetaData';
  fileName?: Maybe<Scalars['String']['output']>;
  labelColumn?: Maybe<Scalars['String']['output']>;
  valueColumn?: Maybe<Scalars['String']['output']>;
}

export interface ServiceAutoCompleteLookupMetaDataInput {
  fileName?: InputMaybe<Scalars['String']['input']>;
  labelColumn?: InputMaybe<Scalars['String']['input']>;
  valueColumn?: InputMaybe<Scalars['String']['input']>;
}

export interface SignUp {
  __typename: 'SignUp';
  data: CurrentUser;
}

export interface Signal {
  __typename: 'Signal';
  allRecordsJson: Scalars['String']['output'];
  artifacts?: Maybe<Array<SignalArtifact>>;
  /** @deprecated Deprecated in favor of stage */
  category: Scalars['String']['output'];
  cipRecordsQuery?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  contentTypeEnum: ContentType;
  created: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enrichments: Array<Enrichment>;
  entities: Array<EntityInterface>;
  entity: EntityInterface;
  extra?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insights: Array<Insight>;
  involvedEntities: Array<Maybe<EntityInterface>>;
  isSuppressedByEntity: Scalars['Boolean']['output'];
  isSuppressedBySuppressList: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  prototype?: Maybe<Scalars['Boolean']['output']>;
  recordCount: Scalars['Int']['output'];
  recordSearchDetails?: Maybe<SignalRecordSearchDetails>;
  recordTypes: Array<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
  ruleType?: Maybe<Scalars['String']['output']>;
  severity: Scalars['Int']['output'];
  /** @deprecated Deprecated in favor of contentType */
  sourceType?: Maybe<Scalars['String']['output']>;
  stage: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  supportsRecordSearch: Scalars['Boolean']['output'];
  suppressed?: Maybe<Scalars['Boolean']['output']>;
  suppressedBy?: Maybe<Scalars['String']['output']>;
  suppressedByNetworkBlock: Scalars['Boolean']['output'];
  suppressedBySignal?: Maybe<Signal>;
  /** @deprecated Does not yet work until changes are made in Radar */
  suppressedBySuppressListNames: Array<Scalars['String']['output']>;
  /** @deprecated Does not yet work until changes are made in Radar */
  suppressedBySuppressLists: Array<SuppressList>;
  suppressesSignals: SignalPage;
  tags: Array<Scalars['String']['output']>;
  threatIntelIndicatorIds: Array<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
}


export interface SignalSuppressesSignalsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface SignalAnalysis {
  __typename: 'SignalAnalysis';
  artifact: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reasoning: Scalars['String']['output'];
  rootCause: Scalars['String']['output'];
  ruleId: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  verdict: SimpleVerdict;
}

export interface SignalArtifact {
  __typename: 'SignalArtifact';
  name: Scalars['String']['output'];
  recordStream: Scalars['String']['output'];
  recordUid: Scalars['String']['output'];
  value: Scalars['String']['output'];
}

export interface SignalPage {
  __typename: 'SignalPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<Signal>;
  total: Scalars['Int']['output'];
}

export interface SignalRecordSearchDetails {
  __typename: 'SignalRecordSearchDetails';
  query: Scalars['String']['output'];
  queryEndTime: Scalars['DateTime']['output'];
  queryStartTime: Scalars['DateTime']['output'];
}

export interface SignalSort {
  direction?: SortDir;
  field?: SignalSortableField;
}

export enum SignalSortableField {
  ContentType = 'CONTENT_TYPE',
  Created = 'CREATED',
  Name = 'NAME',
  RecordCount = 'RECORD_COUNT',
  Relevance = 'RELEVANCE',
  RuleType = 'RULE_TYPE',
  Severity = 'SEVERITY',
  Stage = 'STAGE',
  Timestamp = 'TIMESTAMP'
}

export interface SignalTagOption {
  __typename: 'SignalTagOption';
  label?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
}

export enum SimpleVerdict {
  Benign = 'BENIGN',
  Inconclusive = 'INCONCLUSIVE',
  Malicious = 'MALICIOUS',
  Suspicious = 'SUSPICIOUS'
}

export enum SortDir {
  Asc = 'ASC',
  Desc = 'DESC'
}

export interface SpanFilterInput {
  fieldName: Scalars['String']['input'];
  fieldValue?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
}

export interface SpanFilterKeyValuePair {
  __typename: 'SpanFilterKeyValuePair';
  fieldName: Scalars['String']['output'];
  fieldValue: Scalars['String']['output'];
  operator: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface SpanFilterStandAloneKey {
  __typename: 'SpanFilterStandAloneKey';
  fieldName: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface SpanQuery {
  __typename: 'SpanQuery';
  queryKey: Scalars['String']['output'];
  queryString: Scalars['String']['output'];
  queryType: Scalars['String']['output'];
  spansQueryData: SpansQueryData;
  type: Scalars['String']['output'];
}

export interface SpanQueryInput {
  queryKey: Scalars['String']['input'];
  queryString: Scalars['String']['input'];
  queryType: Scalars['String']['input'];
  spansQueryData: SpansQueryDataInput;
  type: Scalars['String']['input'];
}

export interface SpanRecentItem extends RecentItem {
  __typename: 'SpanRecentItem';
  accessKey?: Maybe<Scalars['String']['output']>;
  accessTime: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  pageType: RecentPageType;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  queryString: Scalars['String']['output'];
  runAsIdOverride?: Maybe<Scalars['Int']['output']>;
  spanQueries: Array<SpanQuery>;
  timeRange?: Maybe<Array<SpanTimeRange>>;
  urlHash: Scalars['String']['output'];
  visibility?: Maybe<Scalars['String']['output']>;
}

export interface SpanTimeRange {
  __typename: 'SpanTimeRange';
  d: Scalars['BigInt']['output'];
  t: Scalars['String']['output'];
}

export interface SpanTimeRangeInput {
  d: Scalars['BigInt']['input'];
  t: Scalars['String']['input'];
}

export type SpansFilter = SpanFilterKeyValuePair | SpanFilterStandAloneKey;

export type SpansGroupBy = FieldGroupBy | TimeGroupBy;

export interface SpansLimit {
  __typename: 'SpansLimit';
  direction: Scalars['String']['output'];
  limitValue: Scalars['Int']['output'];
}

export interface SpansLimitInput {
  direction: Scalars['String']['input'];
  limitValue: Scalars['Int']['input'];
}

export interface SpansQueryData {
  __typename: 'SpansQueryData';
  facetsQueryString: Scalars['String']['output'];
  filters: Array<SpansFilter>;
  groupBy: Array<SpansGroupBy>;
  limit?: Maybe<Array<SpansLimit>>;
  visualizations: Array<Scalars['JSONObject']['output']>;
}

export interface SpansQueryDataInput {
  facetsQueryString: Scalars['String']['input'];
  filters: Array<SpanFilterInput>;
  groupBy: Array<GroupByInput>;
  limit?: InputMaybe<Array<SpansLimitInput>>;
  visualizations: Array<Scalars['JSONObject']['input']>;
}

export interface SpansRecentItemFields {
  accessTime: Scalars['Timestamp']['input'];
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pageType: RecentPageType;
  queryString: Scalars['String']['input'];
  spanQueries: Array<SpanQueryInput>;
  timeRange: Array<SpanTimeRangeInput>;
  urlHash: Scalars['String']['input'];
}

export interface SsoSettings {
  __typename: 'SsoSettings';
  enabled: Scalars['Boolean']['output'];
  logoutUrl?: Maybe<Scalars['String']['output']>;
  metadataUrl?: Maybe<Scalars['String']['output']>;
  metadataXml?: Maybe<Scalars['String']['output']>;
  ssoUrl: Scalars['String']['output'];
}

export interface StandardPageRecentItem extends RecentItem {
  __typename: 'StandardPageRecentItem';
  accessId: Scalars['String']['output'];
  accessKey?: Maybe<Scalars['String']['output']>;
  accessTime: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['BigInt']['output']>;
  feature?: Maybe<FeatureType>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  ownerName?: Maybe<Scalars['String']['output']>;
  pageType: RecentPageType;
  parentId?: Maybe<Scalars['BigInt']['output']>;
  runAsIdOverride?: Maybe<Scalars['Int']['output']>;
  standardPageType: StandardPageType;
  visibility?: Maybe<Scalars['String']['output']>;
}

export interface StandardPageRecentItemFields {
  accessId: Scalars['String']['input'];
  /** @deprecated use accessId instead */
  accessKey?: InputMaybe<Scalars['String']['input']>;
  accessTime: Scalars['Timestamp']['input'];
  feature?: InputMaybe<FeatureType>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  pageType: RecentPageType;
  standardPageType: StandardPageType;
}

export enum StandardPageType {
  Alert = 'alert',
  CustomInsight = 'customInsight',
  Entity = 'entity',
  FileAnalysis = 'fileAnalysis',
  Insight = 'insight',
  Integration = 'integration',
  LookUp = 'lookUp',
  MatchList = 'matchList',
  Playbook = 'playbook',
  Rule = 'rule',
  RuleTuning = 'ruleTuning',
  Signal = 'signal',
  SloDashboard = 'sloDashboard',
  SuppressedList = 'suppressedList',
  ThreatIntelligence = 'threatIntelligence',
  Trace = 'trace'
}

export interface StartCanaryLookupJob {
  __typename: 'StartCanaryLookupJob';
  jobId: Scalars['String']['output'];
}

export interface StartEntityTimelineGroupRecordJob {
  __typename: 'StartEntityTimelineGroupRecordJob';
  jobId: Scalars['String']['output'];
}

export interface StartEntityTimelineJob {
  __typename: 'StartEntityTimelineJob';
  jobId: Scalars['String']['output'];
}

export interface StartSumoInsightSearchJob {
  __typename: 'StartSumoInsightSearchJob';
  end: Scalars['DateTime']['output'];
  jobId: Scalars['String']['output'];
  query: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
}

export interface StartSumoRawMessageLookupJob {
  __typename: 'StartSumoRawMessageLookupJob';
  end: Scalars['DateTime']['output'];
  jobId: Scalars['String']['output'];
  query: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
}

export interface StartSumoRecordSearchJob {
  __typename: 'StartSumoRecordSearchJob';
  end: Scalars['DateTime']['output'];
  jobId: Scalars['String']['output'];
  query: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
}

export interface StartSumoRecordSearchJobForRuleExpression {
  __typename: 'StartSumoRecordSearchJobForRuleExpression';
  end: Scalars['DateTime']['output'];
  jobId: Scalars['String']['output'];
  query: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
}

export interface StartSumoRecordSearchJobForSignal {
  __typename: 'StartSumoRecordSearchJobForSignal';
  end: Scalars['DateTime']['output'];
  exploreInLogsQuery: Scalars['String']['output'];
  jobId: Scalars['String']['output'];
  query: Scalars['String']['output'];
  start: Scalars['DateTime']['output'];
}

export interface StreamingExportConfiguration {
  __typename: 'StreamingExportConfiguration';
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  dataStream: StreamingExportConfigurationDataStream;
  exportUrl: Scalars['String']['output'];
  filterExpression?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sourceCategory: Scalars['String']['output'];
}

export enum StreamingExportConfigurationDataStream {
  Raw = 'RAW',
  Record = 'RECORD',
  Signal = 'SIGNAL'
}

export interface StreamingExportConfigurationFields {
  dataStream: StreamingExportConfigurationDataStream;
  exportUrl: Scalars['String']['input'];
  filterExpression?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sourceCategory?: InputMaybe<Scalars['String']['input']>;
}

export interface StreamingExportConfigurationPage {
  __typename: 'StreamingExportConfigurationPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<StreamingExportConfiguration>;
  total: Scalars['Int']['output'];
}

export interface StreamingExportConfigurationSort {
  direction?: SortDir;
  field?: StreamingExportConfigurationSortableField;
}

export enum StreamingExportConfigurationSortableField {
  DataStream = 'DATA_STREAM',
  ExportUrl = 'EXPORT_URL'
}

export interface StringListRuleOverride {
  __typename: 'StringListRuleOverride';
  original?: Maybe<Array<Scalars['String']['output']>>;
  override?: Maybe<Array<Scalars['String']['output']>>;
}

export interface StringRuleOverride {
  __typename: 'StringRuleOverride';
  original?: Maybe<Scalars['String']['output']>;
  override?: Maybe<Scalars['String']['output']>;
}

export interface SumoMapping {
  __typename: 'SumoMapping';
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  eventId?: Maybe<Scalars['String']['output']>;
  exportConfigJson: Scalars['JSONString']['output'];
  id: Scalars['ID']['output'];
  jsonExplode?: Maybe<Scalars['String']['output']>;
  jsonZipOperations: Array<SumoMappingJsonZipOperation>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  logFormat: Scalars['String']['output'];
  product?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  sourceCategory: Scalars['String']['output'];
  syslogDelimiter?: Maybe<Scalars['String']['output']>;
  syslogFormat?: Maybe<Scalars['String']['output']>;
  syslogKvDelimiter?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
}

export interface SumoMappingFields {
  enabled: Scalars['Boolean']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  jsonExplode?: InputMaybe<Scalars['String']['input']>;
  jsonZipOperations?: InputMaybe<Array<SumoMappingJsonZipOperationFields>>;
  logFormat: Scalars['String']['input'];
  product?: InputMaybe<Scalars['String']['input']>;
  sourceCategory: Scalars['String']['input'];
  syslogDelimiter?: InputMaybe<Scalars['String']['input']>;
  syslogFormat?: InputMaybe<Scalars['String']['input']>;
  syslogKvDelimiter?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
}

export interface SumoMappingJsonZipOperation {
  __typename: 'SumoMappingJsonZipOperation';
  keyName: Scalars['String']['output'];
  matchKey: Scalars['String']['output'];
  matchValue: Scalars['String']['output'];
}

export interface SumoMappingJsonZipOperationFields {
  keyName: Scalars['String']['input'];
  matchKey: Scalars['String']['input'];
  matchValue: Scalars['String']['input'];
}

export interface SumoMappingPage {
  __typename: 'SumoMappingPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<SumoMapping>;
  total: Scalars['Int']['output'];
}

export interface SumoMappingSort {
  direction?: SortDir;
  field?: SumoMappingSortableField;
}

export enum SumoMappingSortableField {
  Enabled = 'ENABLED',
  EventId = 'EVENT_ID',
  Product = 'PRODUCT',
  Source = 'SOURCE',
  SourceCategory = 'SOURCE_CATEGORY',
  Vendor = 'VENDOR'
}

export interface SumoSearchHistogramBucket {
  __typename: 'SumoSearchHistogramBucket';
  count: Scalars['Int']['output'];
  length: Scalars['TimeDelta']['output'];
  startTimestamp: Scalars['DateTime']['output'];
}

export enum SumoSearchJobState {
  Cancelled = 'CANCELLED',
  DoneGatheringResults = 'DONE_GATHERING_RESULTS',
  GatheringResults = 'GATHERING_RESULTS',
  NotStarted = 'NOT_STARTED',
  Paused = 'PAUSED'
}

export interface SumoSearchJobStatus {
  __typename: 'SumoSearchJobStatus';
  histogramBuckets: Array<SumoSearchHistogramBucket>;
  state: SumoSearchJobState;
  total: Scalars['Int']['output'];
}

export interface SumoSearchObjectTypeCount {
  __typename: 'SumoSearchObjectTypeCount';
  count: Scalars['Int']['output'];
  objectType: Scalars['String']['output'];
}

export enum SumoSearchQuerySyntax {
  CseDsl = 'CSE_DSL',
  SqlRuleExpression = 'SQL_RULE_EXPRESSION'
}

export interface SumoUser {
  __typename: 'SumoUser';
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  isMfaEnabled: Scalars['Boolean']['output'];
  lastLoginTimestamp: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  modifiedAt: Scalars['String']['output'];
  modifiedBy: Scalars['String']['output'];
  roleIds: Array<Maybe<Scalars['String']['output']>>;
}

export interface SumoUsersPage {
  __typename: 'SumoUsersPage';
  data: Array<Maybe<SumoUser>>;
  next?: Maybe<Scalars['String']['output']>;
}

export interface SuppressList {
  __typename: 'SuppressList';
  active: Scalars['Boolean']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  defaultTtl?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items: SuppressListItemPage;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  targetColumn: Scalars['String']['output'];
}


export interface SuppressListItemsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface SuppressListFields {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  defaultTtl?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  targetColumn: Scalars['String']['input'];
}

export interface SuppressListItem {
  __typename: 'SuppressListItem';
  active: Scalars['Boolean']['output'];
  expiration?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  listId: Scalars['String']['output'];
  meta?: Maybe<ItemMeta>;
  value: Scalars['String']['output'];
}

export interface SuppressListItemFields {
  active: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
}

export interface SuppressListItemPage {
  __typename: 'SuppressListItemPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<SuppressListItem>;
  total: Scalars['Int']['output'];
}

export interface SuppressListItemSort {
  direction?: SortDir;
  field?: SuppressListItemSortableField;
}

export enum SuppressListItemSortableField {
  Active = 'ACTIVE',
  Created = 'CREATED',
  Description = 'DESCRIPTION',
  ExpirationDate = 'EXPIRATION_DATE',
  Value = 'VALUE'
}

export interface SuppressListPage {
  __typename: 'SuppressListPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<SuppressList>;
  total: Scalars['Int']['output'];
}

export interface SwitchableOrg {
  __typename: 'SwitchableOrg';
  deployment: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isCurrent: Scalars['Boolean']['output'];
  isEnabled: Scalars['Boolean']['output'];
  orgId: Scalars['String']['output'];
  path: Scalars['String']['output'];
  subdomain?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
}

export enum TagContentType {
  CustomInsight = 'customInsight',
  Entity = 'entity',
  Rule = 'rule',
  ThreatIntelligence = 'threatIntelligence'
}

export interface TagSchema {
  __typename: 'TagSchema';
  contentTypeEnums?: Maybe<Array<TagContentType>>;
  /** @deprecated Deprecated in favor of contentTypeEnums */
  contentTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  freeform?: Maybe<Scalars['Boolean']['output']>;
  key: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  valueOptionObjects?: Maybe<Array<TagSchemaValueOption>>;
  /** @deprecated Deprecated in favor of valueOptionObjects */
  valueOptions?: Maybe<Scalars['JSONString']['output']>;
}

export interface TagSchemaValueOption {
  __typename: 'TagSchemaValueOption';
  label?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
}

export interface TagSchemaValueOptionFields {
  label?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
}

export enum TaxiiClearableFields {
  Certificate = 'CERTIFICATE'
}

export interface TaxiiFeed {
  __typename: 'TaxiiFeed';
  collections?: Maybe<Scalars['String']['output']>;
  consecutiveFailureCount: Scalars['Int']['output'];
  defaultTtlDays?: Maybe<Scalars['Float']['output']>;
  enabled: Scalars['Boolean']['output'];
  hasCertificate: Scalars['Boolean']['output'];
  hasCertificatePassword: Scalars['Boolean']['output'];
  hasPassword: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastPollSize?: Maybe<Scalars['Int']['output']>;
  lastRun?: Maybe<Scalars['DateTime']['output']>;
  lastTimeDataReceived?: Maybe<Scalars['DateTime']['output']>;
  lastTimeFailed?: Maybe<Scalars['DateTime']['output']>;
  maxLookbackDays?: Maybe<Scalars['Int']['output']>;
  pollIntervalMinutes: Scalars['Int']['output'];
  recentFailures: Array<TaxiiFeedFailure>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  useTtlFromIndicators: Scalars['Boolean']['output'];
  username?: Maybe<Scalars['String']['output']>;
}

export interface TaxiiFeedFailure {
  __typename: 'TaxiiFeedFailure';
  collectionName?: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['DateTime']['output']>;
}

export interface TaxiiThreatIntelSourceFields {
  certificate?: InputMaybe<Scalars['Upload']['input']>;
  certificatePassword?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<Scalars['String']['input']>;
  defaultTtlDays?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  maxLookbackDays?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  pollIntervalMinutes: Scalars['Int']['input'];
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  useTtlFromIndicators?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
}

export interface Team {
  __typename: 'Team';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
}

export interface TeamPage {
  __typename: 'TeamPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<Team>;
  total: Scalars['Int']['output'];
}

export interface TemplatedMatchRule extends RuleInterface {
  __typename: 'TemplatedMatchRule';
  assetField?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of status */
  autoDisabledReason?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  contentType: ContentType;
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  createdByUser?: Maybe<User>;
  deleted: Scalars['Boolean']['output'];
  descriptionExpression: Scalars['String']['output'];
  descriptionExpressionOverride?: Maybe<StringRuleOverride>;
  enabled: Scalars['Boolean']['output'];
  entitySelectors: Array<OutputEntitySelectorType>;
  entitySelectorsOverride?: Maybe<EntitySelectorsRuleOverride>;
  exportJson: Scalars['String']['output'];
  expression: Scalars['String']['output'];
  failing: Scalars['Boolean']['output'];
  hasOverride: Scalars['Boolean']['output'];
  history: Array<RuleHistoryEvent>;
  id: Scalars['ID']['output'];
  isPrototype: Scalars['Boolean']['output'];
  isPrototypeOverride?: Maybe<BooleanRuleOverride>;
  lastUpdated: Scalars['DateTime']['output'];
  lastUpdatedBy: Scalars['String']['output'];
  lastUpdatedByUser?: Maybe<User>;
  name: Scalars['String']['output'];
  nameExpression: Scalars['String']['output'];
  nameExpressionOverride?: Maybe<StringRuleOverride>;
  nameOverride?: Maybe<StringRuleOverride>;
  parentJaskId?: Maybe<Scalars['ID']['output']>;
  rawJson?: Maybe<Scalars['String']['output']>;
  rawStatus?: Maybe<RuleStatus>;
  ruleDescription?: Maybe<Scalars['String']['output']>;
  ruleId: Scalars['Int']['output'];
  ruleSource: Scalars['String']['output'];
  ruleType: Scalars['String']['output'];
  scoreMapping: RuleScoreMapping;
  scoreMappingOverride?: Maybe<RuleScoreMappingRuleOverride>;
  signalCount07d: Scalars['Int']['output'];
  signalCount24h: Scalars['Int']['output'];
  status: RuleStatus;
  stream: Scalars['String']['output'];
  summaryExpression: Scalars['String']['output'];
  summaryExpressionOverride?: Maybe<StringRuleOverride>;
  suppressionWindowSize?: Maybe<Scalars['Int']['output']>;
  suppressionWindowSizeOverride?: Maybe<IntRuleOverride>;
  tags: Array<Scalars['String']['output']>;
  tagsOverride?: Maybe<StringListRuleOverride>;
  tuningExpressionIds?: Maybe<Array<Scalars['String']['output']>>;
  tuningExpressions?: Maybe<Array<RuleTuningExpression>>;
}

export interface TemplatedMatchRuleFields {
  assetField?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  descriptionExpression: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  expression: Scalars['String']['input'];
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nameExpression: Scalars['String']['input'];
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  scoreMapping: RuleScoreMappingFields;
  stream: Scalars['String']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

export interface ThreatIntelItem {
  __typename: 'ThreatIntelItem';
  active: Scalars['Boolean']['output'];
  expiration?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  listId: Scalars['String']['output'];
  meta?: Maybe<ItemMeta>;
  source: ThreatIntelSource;
  value: Scalars['String']['output'];
}

export interface ThreatIntelItemFields {
  active: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
}

export interface ThreatIntelItemPage {
  __typename: 'ThreatIntelItemPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<ThreatIntelItem>;
  total: Scalars['Int']['output'];
}

export interface ThreatIntelItemSort {
  direction?: SortDir;
  field?: ThreatIntelItemSortableField;
}

export enum ThreatIntelItemSortableField {
  Active = 'ACTIVE',
  Created = 'CREATED',
  Description = 'DESCRIPTION',
  ExpirationDate = 'EXPIRATION_DATE',
  Value = 'VALUE'
}

export interface ThreatIntelSource {
  __typename: 'ThreatIntelSource';
  created?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  idefenseConfig?: Maybe<IdefenseConfig>;
  items: ThreatIntelItemPage;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sourceType: ThreatIntelSourceType;
  taxiiFeed?: Maybe<TaxiiFeed>;
  threatQConfig?: Maybe<ThreatQConfig>;
}


export interface ThreatIntelSourceItemsArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface ThreatIntelSourcePage {
  __typename: 'ThreatIntelSourcePage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<ThreatIntelSource>;
  total: Scalars['Int']['output'];
}

export enum ThreatIntelSourceType {
  Anomali = 'ANOMALI',
  Custom = 'CUSTOM',
  Idefense = 'IDEFENSE',
  Taxii = 'TAXII',
  Threatq = 'THREATQ'
}

export enum ThreatQClearableFields {
  Certificate = 'CERTIFICATE'
}

export interface ThreatQConfig {
  __typename: 'ThreatQConfig';
  baseUrl: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  customFiltersJson: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  extraHeaders?: Maybe<Scalars['String']['output']>;
  hasCertificate: Scalars['Boolean']['output'];
  pollIntervalMinutes: Scalars['Int']['output'];
  useExpiration: Scalars['Boolean']['output'];
}

export interface ThreatQThreatIntelSourceFields {
  baseUrl: Scalars['String']['input'];
  certificate?: InputMaybe<Scalars['Upload']['input']>;
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  customFiltersJson?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  extraHeaders?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pollIntervalMinutes: Scalars['Int']['input'];
  useExpiration?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface ThresholdRule extends RuleInterface {
  __typename: 'ThresholdRule';
  assetField?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated in favor of status */
  autoDisabledReason?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  contentType: ContentType;
  countDistinct: Scalars['Boolean']['output'];
  countField?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  createdByUser?: Maybe<User>;
  deleted: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  descriptionOverride?: Maybe<StringRuleOverride>;
  enabled: Scalars['Boolean']['output'];
  entitySelectors: Array<OutputEntitySelectorType>;
  entitySelectorsOverride?: Maybe<EntitySelectorsRuleOverride>;
  exportJson: Scalars['String']['output'];
  expression: Scalars['String']['output'];
  failing: Scalars['Boolean']['output'];
  groupByFields: Array<Scalars['String']['output']>;
  groupByFieldsOverride?: Maybe<StringListRuleOverride>;
  hasOverride: Scalars['Boolean']['output'];
  history: Array<RuleHistoryEvent>;
  id: Scalars['ID']['output'];
  isPrototype: Scalars['Boolean']['output'];
  isPrototypeOverride?: Maybe<BooleanRuleOverride>;
  lastUpdated: Scalars['DateTime']['output'];
  lastUpdatedBy: Scalars['String']['output'];
  lastUpdatedByUser?: Maybe<User>;
  limit: Scalars['Int']['output'];
  limitOverride?: Maybe<IntRuleOverride>;
  name: Scalars['String']['output'];
  nameOverride?: Maybe<StringRuleOverride>;
  parentJaskId?: Maybe<Scalars['ID']['output']>;
  rawJson?: Maybe<Scalars['String']['output']>;
  rawStatus?: Maybe<RuleStatus>;
  ruleDescription?: Maybe<Scalars['String']['output']>;
  ruleId: Scalars['Int']['output'];
  ruleSource: Scalars['String']['output'];
  ruleType: Scalars['String']['output'];
  score: Scalars['Int']['output'];
  scoreOverride?: Maybe<IntRuleOverride>;
  signalCount07d: Scalars['Int']['output'];
  signalCount24h: Scalars['Int']['output'];
  status: RuleStatus;
  stream: Scalars['String']['output'];
  summaryExpression: Scalars['String']['output'];
  summaryExpressionOverride?: Maybe<StringRuleOverride>;
  suppressionWindowSize?: Maybe<Scalars['Int']['output']>;
  suppressionWindowSizeOverride?: Maybe<IntRuleOverride>;
  tags: Array<Scalars['String']['output']>;
  tagsOverride?: Maybe<StringListRuleOverride>;
  tuningExpressionIds?: Maybe<Array<Scalars['String']['output']>>;
  tuningExpressions?: Maybe<Array<RuleTuningExpression>>;
  version: Scalars['Int']['output'];
  windowSize: Scalars['Int']['output'];
  windowSizeName: Scalars['String']['output'];
  windowSizeOverride?: Maybe<IntRuleOverride>;
}

export interface ThresholdRuleFields {
  assetField?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  countDistinct: Scalars['Boolean']['input'];
  countField?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  expression: Scalars['String']['input'];
  groupByFields?: InputMaybe<Array<Scalars['String']['input']>>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  score: Scalars['Int']['input'];
  stream: Scalars['String']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  version: Scalars['Int']['input'];
  windowSize: RuleWindowSizeEnum;
  windowSizeMilliseconds?: InputMaybe<Scalars['BigInt']['input']>;
}

export interface Tier {
  __typename: 'Tier';
  analyticsTier: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface TiersPage {
  __typename: 'TiersPage';
  data: Array<Maybe<Tier>>;
  next?: Maybe<Scalars['String']['output']>;
}

export interface TimeGroupBy {
  __typename: 'TimeGroupBy';
  fieldValue: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface Triage {
  __typename: 'Triage';
  id: Scalars['ID']['output'];
  insightID: Scalars['ID']['output'];
  keyEvidences: Array<KeyEvidence>;
  recommendation?: Maybe<TriageRecommendation>;
  summary?: Maybe<Scalars['String']['output']>;
  verdict: TriageVerdict;
}

export interface TriageRecommendation {
  __typename: 'TriageRecommendation';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  severity: InsightSeverityPyEnum;
}

export enum TriageVerdict {
  Benign = 'BENIGN',
  Inconclusive = 'INCONCLUSIVE',
  InProgress = 'IN_PROGRESS',
  Malicious = 'MALICIOUS',
  Suspicious = 'SUSPICIOUS'
}

export interface TrialPlan extends CreditSubscriptionPlan {
  __typename: 'TrialPlan';
  daysLeft: Scalars['Int']['output'];
  planName: Scalars['String']['output'];
}

export interface UninviteUser {
  __typename: 'UninviteUser';
  ok?: Maybe<Scalars['Boolean']['output']>;
}

export interface UnknownTeam {
  __typename: 'UnknownTeam';
  name: Scalars['String']['output'];
}

export interface UnknownUser {
  __typename: 'UnknownUser';
  username: Scalars['String']['output'];
}

export interface UnstructuredLogMappingFields {
  patternNames: Array<Scalars['String']['input']>;
}

export interface UnstructuredLogMappingFieldsApi {
  __typename: 'UnstructuredLogMappingFieldsApi';
  patternNames: Array<Scalars['String']['output']>;
}

export interface UpdatableAnomaliThreatIntelSourceFields {
  apiKey: Scalars['String']['input'];
  description: Scalars['String']['input'];
  enabled: Scalars['String']['input'];
  filter: Scalars['String']['input'];
  inactiveFilter?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
}

export interface UpdatableContextActionFields {
  allRecordFields?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entityTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  iocTypes: Array<ContextActionIocType>;
  name: Scalars['String']['input'];
  recordFields?: InputMaybe<Array<Scalars['String']['input']>>;
  template?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ContextActionType>;
  urlTemplate?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdatableCustomThreatIntelSourceFields {
  description: Scalars['String']['input'];
}

export interface UpdatableCustomYaraSourceFields {
  description: Scalars['String']['input'];
}

export interface UpdatableFavoriteFieldFields {
  applyToAllObjectTypes: Scalars['Boolean']['input'];
  associatedObjectTypes: Array<Scalars['String']['input']>;
  fieldName: Scalars['String']['input'];
}

export interface UpdatableGithubYaraSourceFields {
  branch?: InputMaybe<Scalars['String']['input']>;
  defaultSeverity: Scalars['Int']['input'];
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
  yaraFileRegex: Scalars['String']['input'];
}

export interface UpdatableIdefenseThreatIntelSourceFields {
  apiKey: Scalars['String']['input'];
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
}

export interface UpdatableMatchListFields {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  defaultTtl?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
}

export interface UpdatableMatchListItemFields {
  active: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface UpdatableNetworkBlockFields {
  addressBlock?: InputMaybe<Scalars['String']['input']>;
  internal?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  suppressesSignals?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface UpdatableSuppressListFields {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  defaultTtl?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
}

export interface UpdatableSuppressListItemFields {
  active: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface UpdatableTaxiiThreatIntelSourceFields {
  certificate?: InputMaybe<Scalars['Upload']['input']>;
  certificatePassword?: InputMaybe<Scalars['String']['input']>;
  collections?: InputMaybe<Scalars['String']['input']>;
  defaultTtlDays?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxLookbackDays?: InputMaybe<Scalars['Int']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pollIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  subscriptionId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  useTtlFromIndicators?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdatableThreatIntelItemFields {
  active: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface UpdatableThreatQThreatIntelSourceFields {
  baseUrl: Scalars['String']['input'];
  certificate?: InputMaybe<Scalars['Upload']['input']>;
  clientId: Scalars['String']['input'];
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  customFiltersJson?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  extraHeaders?: InputMaybe<Scalars['String']['input']>;
  pollIntervalMinutes: Scalars['Int']['input'];
  useExpiration?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface UpdateAction {
  __typename: 'UpdateAction';
  data: Action;
}

export interface UpdateAggregationRule {
  __typename: 'UpdateAggregationRule';
  data: AggregationRule;
}

export interface UpdateAggregationRuleFields {
  aggregationFunctions: Array<AggregationRuleAggregationFunctionField>;
  assetField?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  descriptionExpression: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  groupByAsset: Scalars['Boolean']['input'];
  groupByFields: Array<Scalars['String']['input']>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  matchExpression: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nameExpression: Scalars['String']['input'];
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  scoreMapping: RuleScoreMappingFields;
  stream: Scalars['String']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  triggerExpression: Scalars['String']['input'];
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  windowSize: RuleWindowSizeEnum;
  windowSizeMilliseconds?: InputMaybe<Scalars['BigInt']['input']>;
}

export interface UpdateAnomaliThreatIntelSource {
  __typename: 'UpdateAnomaliThreatIntelSource';
  data: ThreatIntelSource;
}

export interface UpdateAssignedInsightEmailsEnabled {
  __typename: 'UpdateAssignedInsightEmailsEnabled';
  ok: Scalars['Boolean']['output'];
}

export interface UpdateAutomation {
  __typename: 'UpdateAutomation';
  data: Automation;
}

export interface UpdateAutomationFields {
  cseResourceSubTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  executionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface UpdateBuiltInRule {
  __typename: 'UpdateBuiltInRule';
  ok: Scalars['Boolean']['output'];
}

export interface UpdateBuiltInRuleFields {
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ruleDescription?: InputMaybe<Scalars['String']['input']>;
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

export interface UpdateChainRule {
  __typename: 'UpdateChainRule';
  data: ChainRule;
}

export interface UpdateChainRuleFields {
  assetField?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  expressionsAndLimits: Array<ChainRuleExpressionAndLimitField>;
  groupByFields?: InputMaybe<Array<Scalars['String']['input']>>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  ordered?: InputMaybe<Scalars['Boolean']['input']>;
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  score: Scalars['Int']['input'];
  stream: Scalars['String']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  windowSize: RuleWindowSizeEnum;
  windowSizeMilliseconds?: InputMaybe<Scalars['BigInt']['input']>;
}

export interface UpdateContextAction {
  __typename: 'UpdateContextAction';
  data: ContextAction;
}

export interface UpdateCurrentUser {
  __typename: 'UpdateCurrentUser';
  data: CurrentUser;
}

export interface UpdateCustomEntityType {
  __typename: 'UpdateCustomEntityType';
  data: CustomEntityType;
}

export interface UpdateCustomEntityTypeFields {
  fields: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
}

export interface UpdateCustomInsight {
  __typename: 'UpdateCustomInsight';
  data: CustomInsight;
}

export interface UpdateCustomInsightEnabled {
  __typename: 'UpdateCustomInsightEnabled';
  ok: Scalars['Boolean']['output'];
}

export interface UpdateCustomInsightFields {
  description: Scalars['String']['input'];
  dynamicSeverity?: InputMaybe<Array<DynamicInsightSeverityField>>;
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  ordered: Scalars['Boolean']['input'];
  ruleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  severity: InsightSeverityPyEnum;
  signalMatchStrategy?: InputMaybe<CustomInsightSignalMatchStrategy>;
  signalNames?: InputMaybe<Array<Scalars['String']['input']>>;
  tags: Array<Scalars['String']['input']>;
}

export interface UpdateCustomMatchListColumn {
  __typename: 'UpdateCustomMatchListColumn';
  data: CustomMatchListColumn;
}

export interface UpdateCustomThreatIntelSource {
  __typename: 'UpdateCustomThreatIntelSource';
  data: ThreatIntelSource;
}

export interface UpdateCustomYaraRule {
  __typename: 'UpdateCustomYaraRule';
  data: YaraRule;
}

export interface UpdateCustomYaraSource {
  __typename: 'UpdateCustomYaraSource';
  data: YaraSource;
}

export interface UpdateCustomerSourcedEntityLookupTable {
  __typename: 'UpdateCustomerSourcedEntityLookupTable';
  data: CustomerSourcedEntityLookupTable;
}

export interface UpdateCustomerSourcedEntityLookupTableFields {
  sourceCategory: Scalars['String']['input'];
}

export interface UpdateEntityCriticality {
  __typename: 'UpdateEntityCriticality';
  data?: Maybe<EntityInterface>;
}

export interface UpdateEntityCriticalityConfig {
  __typename: 'UpdateEntityCriticalityConfig';
  data: EntityCriticalityConfig;
}

export interface UpdateEntityCriticalityConfigFields {
  severityExpression: Scalars['String']['input'];
}

export interface UpdateEntityDomainConfiguration {
  __typename: 'UpdateEntityDomainConfiguration';
  ok: Scalars['Boolean']['output'];
}

export interface UpdateEntityNote {
  __typename: 'UpdateEntityNote';
  data: EntityNote;
}

export interface UpdateEntityTags {
  __typename: 'UpdateEntityTags';
  data?: Maybe<EntityInterface>;
}

export interface UpdateEntityValueEntityGroupConfiguration {
  __typename: 'UpdateEntityValueEntityGroupConfiguration';
  data: EntityGroupConfiguration;
}

export interface UpdateEntityWhitelist {
  __typename: 'UpdateEntityWhitelist';
  data?: Maybe<EntityInterface>;
}

export interface UpdateFavoriteField {
  __typename: 'UpdateFavoriteField';
  data: FavoriteField;
}

export interface UpdateFirstSeenRule {
  __typename: 'UpdateFirstSeenRule';
  data: FirstSeenRule;
}

export interface UpdateFirstSeenRuleFields {
  assetField?: InputMaybe<Scalars['String']['input']>;
  baselineType?: InputMaybe<FirstSeenRuleBaselineType>;
  baselineWindowSize: Scalars['BigInt']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  descriptionExpression: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  filterExpression: Scalars['String']['input'];
  groupByFields: Array<Scalars['String']['input']>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nameExpression: Scalars['String']['input'];
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  retentionWindowSize: Scalars['BigInt']['input'];
  score: Scalars['Int']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  valueExpression?: InputMaybe<Scalars['String']['input']>;
  valueFields?: InputMaybe<Array<Scalars['String']['input']>>;
  version?: Scalars['Int']['input'];
}

export interface UpdateGithubYaraSource {
  __typename: 'UpdateGithubYaraSource';
  data: YaraSource;
}

export interface UpdateIdefenseThreatIntelSource {
  __typename: 'UpdateIdefenseThreatIntelSource';
  data: ThreatIntelSource;
}

export interface UpdateInsight {
  __typename: 'UpdateInsight';
  data: Insight;
}

export interface UpdateInsightComment {
  __typename: 'UpdateInsightComment';
  data: InsightComment;
}

export interface UpdateInsightConfig {
  __typename: 'UpdateInsightConfig';
  data: InsightConfig;
}

export interface UpdateInsightResolution {
  __typename: 'UpdateInsightResolution';
  data: InsightResolution;
}

export interface UpdateInsightResolutionFields {
  description?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateInsightStatus {
  __typename: 'UpdateInsightStatus';
  data: InsightStatus;
}

export interface UpdateInsightStatusFields {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
}

export interface UpdateInsightStatusInProgressEnabled {
  __typename: 'UpdateInsightStatusInProgressEnabled';
  ok: Scalars['Boolean']['output'];
}

export interface UpdateInsightsById {
  __typename: 'UpdateInsightsById';
  ok: Scalars['Boolean']['output'];
}

export interface UpdateInventoryEntityGroupConfiguration {
  __typename: 'UpdateInventoryEntityGroupConfiguration';
  data: EntityGroupConfiguration;
}

export interface UpdateInventoryEntityLookupTable {
  __typename: 'UpdateInventoryEntityLookupTable';
  data: InventoryEntityLookupTable;
}

export interface UpdateInventoryEntityLookupTableFields {
  sourceCategory: Scalars['String']['input'];
}

export interface UpdateLogMapping {
  __typename: 'UpdateLogMapping';
  data: LogMapping;
}

export interface UpdateLogMappingEnabled {
  __typename: 'UpdateLogMappingEnabled';
  data: LogMapping;
}

export interface UpdateLogMappingFields {
  fields: Array<LogMappingFieldFields>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  productGuid: Scalars['String']['input'];
  recordType: Scalars['String']['input'];
  relatesEntities?: InputMaybe<Scalars['Boolean']['input']>;
  skippedValues?: InputMaybe<Array<Scalars['String']['input']>>;
  structuredFields?: InputMaybe<LogMappingStructuredInputFields>;
  structuredInputs?: InputMaybe<Array<LogMappingStructuredInputFields>>;
  unstructuredFields?: InputMaybe<UnstructuredLogMappingFields>;
}

export interface UpdateMatchList {
  __typename: 'UpdateMatchList';
  data: MatchList;
}

export interface UpdateMatchListItem {
  __typename: 'UpdateMatchListItem';
  data: MatchListItem;
  finishedProcessing: Scalars['Boolean']['output'];
}

export interface UpdateMatchRule {
  __typename: 'UpdateMatchRule';
  data: MatchRule;
}

export interface UpdateMatchRuleFields {
  assetField?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  expression: Scalars['String']['input'];
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  score: Scalars['Int']['input'];
  stream: Scalars['String']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

export interface UpdateMfaEnabled {
  __typename: 'UpdateMfaEnabled';
  ok: Scalars['Boolean']['output'];
}

export interface UpdateMitreAttackCoverageColors {
  __typename: 'UpdateMitreAttackCoverageColors';
  data: MitreCoverageColorLegend;
}

export interface UpdateNetworkBlock {
  __typename: 'UpdateNetworkBlock';
  data: NetworkBlock;
}

export interface UpdateOutlierRule {
  __typename: 'UpdateOutlierRule';
  data: OutlierRule;
}

export interface UpdateOutlierRuleFields {
  aggregationFunctions: Array<OutlierRuleAggregationFunctionField>;
  assetField?: InputMaybe<Scalars['String']['input']>;
  baselineWindowSize: Scalars['BigInt']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  descriptionExpression: Scalars['String']['input'];
  deviationThreshold: Scalars['Int']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  floorValue: Scalars['Int']['input'];
  groupByFields: Array<Scalars['String']['input']>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  matchExpression: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nameExpression: Scalars['String']['input'];
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  retentionWindowSize: Scalars['BigInt']['input'];
  score: Scalars['Int']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  windowSize: RuleWindowSizeEnum;
  windowSizeMilliseconds?: InputMaybe<Scalars['BigInt']['input']>;
}

export interface UpdateRecordArtifactConfig {
  __typename: 'UpdateRecordArtifactConfig';
  data: RecordArtifactConfig;
}

export interface UpdateRole {
  __typename: 'UpdateRole';
  data: Role;
}

export interface UpdateRoleFields {
  name: Scalars['String']['input'];
  permissions: Array<Scalars['ID']['input']>;
}

export interface UpdateRuleEnabled {
  __typename: 'UpdateRuleEnabled';
  ok: Scalars['Boolean']['output'];
}

export interface UpdateRuleTuningExpression {
  __typename: 'UpdateRuleTuningExpression';
  data: RuleTuningExpression;
}

export interface UpdateRuleTuningExpressionEnabled {
  __typename: 'UpdateRuleTuningExpressionEnabled';
  ok: Scalars['Boolean']['output'];
}

export interface UpdateRuleTuningExpressionFields {
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  exclude: Scalars['Boolean']['input'];
  expression: Scalars['String']['input'];
  isGlobal: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  ruleIds: Array<Scalars['ID']['input']>;
}

export interface UpdateSsoSettings {
  __typename: 'UpdateSsoSettings';
  data: SsoSettings;
}

export interface UpdateStreamingExportConfiguration {
  __typename: 'UpdateStreamingExportConfiguration';
  data: StreamingExportConfiguration;
}

export interface UpdateSumoLogicGeneralConfig {
  __typename: 'UpdateSumoLogicGeneralConfig';
  ok: Scalars['Boolean']['output'];
}

export interface UpdateSumoLogicSupportConfig {
  __typename: 'UpdateSumoLogicSupportConfig';
  ok: Scalars['Boolean']['output'];
}

export interface UpdateSumoMapping {
  __typename: 'UpdateSumoMapping';
  data: SumoMapping;
}

export interface UpdateSumoSsoEnabled {
  __typename: 'UpdateSumoSsoEnabled';
  ok: Scalars['Boolean']['output'];
}

export interface UpdateSuppressList {
  __typename: 'UpdateSuppressList';
  data: SuppressList;
}

export interface UpdateSuppressListItem {
  __typename: 'UpdateSuppressListItem';
  data: SuppressListItem;
  finishedProcessing: Scalars['Boolean']['output'];
}

export interface UpdateTagSchema {
  __typename: 'UpdateTagSchema';
  data: TagSchema;
}

export interface UpdateTagSchemaFields {
  contentTypes?: InputMaybe<Array<TagContentType>>;
  freeform: Scalars['Boolean']['input'];
  key: Scalars['ID']['input'];
  label: Scalars['String']['input'];
  valueOptions?: InputMaybe<Array<TagSchemaValueOptionFields>>;
}

export interface UpdateTaxiiThreatIntelSource {
  __typename: 'UpdateTaxiiThreatIntelSource';
  data: ThreatIntelSource;
}

export interface UpdateTemplatedMatchRule {
  __typename: 'UpdateTemplatedMatchRule';
  data: TemplatedMatchRule;
}

export interface UpdateTemplatedMatchRuleFields {
  assetField?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  descriptionExpression: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  expression: Scalars['String']['input'];
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nameExpression: Scalars['String']['input'];
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  scoreMapping: RuleScoreMappingFields;
  stream: Scalars['String']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
}

export interface UpdateThreatIntelItem {
  __typename: 'UpdateThreatIntelItem';
  data: ThreatIntelItem;
  finishedProcessing: Scalars['Boolean']['output'];
}

export interface UpdateThreatQThreatIntelSource {
  __typename: 'UpdateThreatQThreatIntelSource';
  data: ThreatIntelSource;
}

export interface UpdateThresholdRule {
  __typename: 'UpdateThresholdRule';
  data: ThresholdRule;
}

export interface UpdateThresholdRuleFields {
  assetField?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  countDistinct: Scalars['Boolean']['input'];
  countField?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  entitySelectors?: InputMaybe<Array<InputEntitySelectorType>>;
  expression: Scalars['String']['input'];
  groupByFields?: InputMaybe<Array<Scalars['String']['input']>>;
  isPrototype?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  parentJaskId?: InputMaybe<Scalars['ID']['input']>;
  score: Scalars['Int']['input'];
  stream: Scalars['String']['input'];
  summaryExpression?: InputMaybe<Scalars['String']['input']>;
  suppressionWindowSize?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tuningExpressionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  version: Scalars['Int']['input'];
  windowSize: RuleWindowSizeEnum;
  windowSizeMilliseconds?: InputMaybe<Scalars['BigInt']['input']>;
}

export interface UpdateUser {
  __typename: 'UpdateUser';
  data: User;
}

export interface UpdateVirusTotalConfig {
  __typename: 'UpdateVirusTotalConfig';
  data: VirusTotalConfig;
}

export interface UpdatedCurrentUserFields {
  accountNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  confirmPassword?: InputMaybe<Scalars['String']['input']>;
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  insightReportNotificationInterval?: InputMaybe<NotificationInterval>;
  mfaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  preferredTimezone?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdatedUserFields {
  accountNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  apiKeyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  insightReportNotificationInterval?: InputMaybe<NotificationInterval>;
  mfaEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<Array<Scalars['String']['input']>>;
  username?: InputMaybe<Scalars['String']['input']>;
}

export interface UploadEntityGroupConfigurationMutationsCsv {
  __typename: 'UploadEntityGroupConfigurationMutationsCsv';
  uploadedEntityGroupCount: Scalars['Int']['output'];
}

export interface UploadEntityMutationsCsv {
  __typename: 'UploadEntityMutationsCsv';
  uploadedEntitiesCount: Scalars['Int']['output'];
}

export interface UploadItemsToList {
  __typename: 'UploadItemsToList';
  uploadedItemCount: Scalars['Int']['output'];
}

export interface UploadItemsToSuppressList {
  __typename: 'UploadItemsToSuppressList';
  uploadedItemCount: Scalars['Int']['output'];
}

export interface UploadItemsToThreatIntelSource {
  __typename: 'UploadItemsToThreatIntelSource';
  uploadedItemCount: Scalars['Int']['output'];
}

export interface UploadNetworkBlocksCsv {
  __typename: 'UploadNetworkBlocksCsv';
  uploadedNetworkBlockCount: Scalars['Int']['output'];
}

export interface User {
  __typename: 'User';
  accountNotificationsEnabled: Scalars['Boolean']['output'];
  active: Scalars['Boolean']['output'];
  apiKeyEnabled: Scalars['Boolean']['output'];
  createdTime?: Maybe<Scalars['DateTime']['output']>;
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailConfirmed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  insightReportNotificationInterval: NotificationInterval;
  lastActive?: Maybe<Scalars['DateTime']['output']>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  mfaEnabled: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  permissions: Array<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  teams: Array<Scalars['String']['output']>;
  username: Scalars['String']['output'];
}

export interface UserAudit {
  __typename: 'UserAudit';
  username: Scalars['String']['output'];
  when: Scalars['DateTime']['output'];
}

export interface UserInventory extends InventoryInterface {
  __typename: 'UserInventory';
  department?: Maybe<Scalars['String']['output']>;
  emails: Array<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  groups: Array<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  metadataJson: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  normalizedUsername?: Maybe<Scalars['String']['output']>;
  parsedTime: Scalars['String']['output'];
  source: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  uniqueId: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
}

export interface UserInvitation {
  __typename: 'UserInvitation';
  created?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  expired?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<Scalars['String']['output']>;
}

export interface UserInvitationPage {
  __typename: 'UserInvitationPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<UserInvitation>;
  total: Scalars['Int']['output'];
}

export interface UserPage {
  __typename: 'UserPage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<User>;
  total: Scalars['Int']['output'];
}

export interface UserPreferences {
  __typename: 'UserPreferences';
  displayAlertBadge?: Maybe<Scalars['Boolean']['output']>;
  navAsideCollapsed?: Maybe<Scalars['Boolean']['output']>;
  navDrawerPinnedMenu?: Maybe<Scalars['String']['output']>;
  navDrawerWidth?: Maybe<Scalars['Int']['output']>;
  navOpenLinksInNewTab?: Maybe<Scalars['Boolean']['output']>;
  sessionTimeout?: Maybe<Scalars['Int']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  useDarkTheme?: Maybe<Scalars['Boolean']['output']>;
}

export enum UserPrivilege {
  AwsApps = 'AWSApps',
  AwsSubscriptions = 'AWSSubscriptions',
  AwsUpgradeEligible = 'AWSUpgradeEligible',
  AccessKeysAccess = 'AccessKeysAccess',
  AccountBetaParticipationAccess = 'AccountBetaParticipationAccess',
  AccountBillingAccess = 'AccountBillingAccess',
  AccountDataManagementAccess = 'AccountDataManagementAccess',
  AccountNewUpgradeAccess = 'AccountNewUpgradeAccess',
  AccountOverviewAccess = 'AccountOverviewAccess',
  AccountUpgradeAccess = 'AccountUpgradeAccess',
  AccountsPageDataManagementAccess = 'AccountsPageDataManagementAccess',
  AgentsAccess = 'AgentsAccess',
  AlertsConnectionsViewAccess = 'AlertsConnectionsViewAccess',
  ApiDocAccess = 'ApiDocAccess',
  ArchiveAccess = 'ArchiveAccess',
  AuditLoggingView = 'AuditLoggingView',
  BillingAccess = 'BillingAccess',
  CseAccess = 'CSEAccess',
  CanChangeAccountSubdomain = 'CanChangeAccountSubdomain',
  CanChangeEmail = 'CanChangeEmail',
  CanChangeOrgName = 'CanChangeOrgName',
  CanCreateAccessKeys = 'CanCreateAccessKeys',
  CanDeleteOrg = 'CanDeleteOrg',
  CanDisplayAlertResponsePageListView = 'CanDisplayAlertResponsePageListView',
  CanDisplayMonitoringSloListView = 'CanDisplayMonitoringSLOListView',
  CanSetAsDefaultDashboard = 'CanSetAsDefaultDashboard',
  ChangeCreditsAllocationAccess = 'ChangeCreditsAllocationAccess',
  CloudSoarAccess = 'CloudSoarAccess',
  CloudSoarAppCentralAccess = 'CloudSoarAppCentralAccess',
  CloudSoarAutomationRulesAccess = 'CloudSoarAutomationRulesAccess',
  CloudSoarBridgeMonitoringAccess = 'CloudSoarBridgeMonitoringAccess',
  CloudSoarCustomizationFields = 'CloudSoarCustomizationFields',
  CloudSoarCustomizationIncidentLabels = 'CloudSoarCustomizationIncidentLabels',
  CloudSoarD1Access = 'CloudSoarD1Access',
  CloudSoarD2Access = 'CloudSoarD2Access',
  CloudSoarEntitiesAccess = 'CloudSoarEntitiesAccess',
  CloudSoarGeneralConfigure = 'CloudSoarGeneralConfigure',
  CloudSoarIncidentAccess = 'CloudSoarIncidentAccess',
  CloudSoarIncidentTemplatesAccess = 'CloudSoarIncidentTemplatesAccess',
  CloudSoarIncidentTriageAccess = 'CloudSoarIncidentTriageAccess',
  CloudSoarIntegrationsAccess = 'CloudSoarIntegrationsAccess',
  CloudSoarNotificationConfigure = 'CloudSoarNotificationConfigure',
  CloudSoarNotificationTriage = 'CloudSoarNotificationTriage',
  CloudSoarPlaybooksAccess = 'CloudSoarPlaybooksAccess',
  CloudSoarReportAccess = 'CloudSoarReportAccess',
  CloudSoarUserManagementGroups = 'CloudSoarUserManagementGroups',
  CollectionDataForwardingAccess = 'CollectionDataForwardingAccess',
  CollectorsAccess = 'CollectorsAccess',
  ConcurrentSessionLimitView = 'ConcurrentSessionLimitView',
  ConnectionsAccess = 'ConnectionsAccess',
  ConnectionsViewAccess = 'ConnectionsViewAccess',
  ContentManagementTabAccess = 'ContentManagementTabAccess',
  CreateOrganizationsAccess = 'CreateOrganizationsAccess',
  CreateTrialOrganizationsAccess = 'CreateTrialOrganizationsAccess',
  CseContentOptInView = 'CseContentOptInView',
  CustomInsightsAccess = 'CustomInsightsAccess',
  DataAccessLevelView = 'DataAccessLevelView',
  DataDeletionAccess = 'DataDeletionAccess',
  DataForwardingAccess = 'DataForwardingAccess',
  DataUsageLoggingViewAccess = 'DataUsageLoggingViewAccess',
  DeactivateOrganizationsAccess = 'DeactivateOrganizationsAccess',
  EntityInventoryAccess = 'EntityInventoryAccess',
  FieldExtractionRulesAccess = 'FieldExtractionRulesAccess',
  FieldsManageAccess = 'FieldsManageAccess',
  FieldsViewAccess = 'FieldsViewAccess',
  FileAnalysisAccess = 'FileAnalysisAccess',
  HealthEventsAccess = 'HealthEventsAccess',
  HerokuUser = 'HerokuUser',
  IndexesViewAccess = 'IndexesViewAccess',
  IngestAccess = 'IngestAccess',
  IngestCollectionsAccess = 'IngestCollectionsAccess',
  InstallationTokensAccess = 'InstallationTokensAccess',
  LookupContentAccess = 'LookupContentAccess',
  MacrosAccess = 'MacrosAccess',
  ManagePaymentTabAccess = 'ManagePaymentTabAccess',
  ManageScheduledViewsAccess = 'ManageScheduledViewsAccess',
  ManageViewsAccess = 'ManageViewsAccess',
  MatchListsAccess = 'MatchListsAccess',
  MetricsAccess = 'MetricsAccess',
  MetricsDpmAccess = 'MetricsDPMAccess',
  MetricsExtractionAccess = 'MetricsExtractionAccess',
  MetricsRulesAccess = 'MetricsRulesAccess',
  MetricsTransformationRulesAccess = 'MetricsTransformationRulesAccess',
  MitreCoverageAccess = 'MitreCoverageAccess',
  MonitorsOarIntegrationAccess = 'MonitorsOarIntegrationAccess',
  MultiRetentionAccountView = 'MultiRetentionAccountView',
  MutingSchedulesAccess = 'MutingSchedulesAccess',
  MutingSchedulesManageAccess = 'MutingSchedulesManageAccess',
  MutingSchedulesViewAccess = 'MutingSchedulesViewAccess',
  NeedsActivation = 'NeedsActivation',
  NetworkBlocksAccess = 'NetworkBlocksAccess',
  NewFerManageAccess = 'NewFERManageAccess',
  NewFerViewAccess = 'NewFERViewAccess',
  PaidTrial = 'PaidTrial',
  ParsersViewAccess = 'ParsersViewAccess',
  PartitionsManageAccess = 'PartitionsManageAccess',
  PartitionsNewViewAccess = 'PartitionsNewViewAccess',
  PasswordPolicyAccess = 'PasswordPolicyAccess',
  PoliciesAccess = 'PoliciesAccess',
  PreviewApps = 'PreviewApps',
  PublicDashboardView = 'PublicDashboardView',
  RecordsAccess = 'RecordsAccess',
  RequestUpgrade = 'RequestUpgrade',
  RequestUpgradeButton = 'RequestUpgradeButton',
  RequestUpgradeV2Access = 'RequestUpgradeV2Access',
  RolesTabAccess = 'RolesTabAccess',
  RootCauseExplorerAccess = 'RootCauseExplorerAccess',
  RuleTuningAccess = 'RuleTuningAccess',
  RulesAccess = 'RulesAccess',
  SamlAccess = 'SAMLAccess',
  SlfApps = 'SLFApps',
  SanaCsiemAccess = 'SanaCsiemAccess',
  SanaInformationModelsManageAccess = 'SanaInformationModelsManageAccess',
  SanaInformationModelsViewAccess = 'SanaInformationModelsViewAccess',
  SanaLookupTablesAccess = 'SanaLookupTablesAccess',
  SanaParsersManageAccess = 'SanaParsersManageAccess',
  SanaParsersViewAccess = 'SanaParsersViewAccess',
  ScheduledViewsAccess = 'ScheduledViewsAccess',
  SearchAuditLoggingView = 'SearchAuditLoggingView',
  SecurityDetectionAccess = 'SecurityDetectionAccess',
  ServiceAccountsAccess = 'ServiceAccountsAccess',
  ServiceMapAccess = 'ServiceMapAccess',
  SessionRulesAccess = 'SessionRulesAccess',
  SessionRulesPageAccess = 'SessionRulesPageAccess',
  SiemActionsAccess = 'SiemActionsAccess',
  SiemAutomationAccess = 'SiemAutomationAccess',
  SiemContextActions = 'SiemContextActions',
  SiemCustomEntityTypesAccess = 'SiemCustomEntityTypesAccess',
  SiemEnrichmentsAccess = 'SiemEnrichmentsAccess',
  SiemEntitiesAccess = 'SiemEntitiesAccess',
  SiemEntityCriticalityAccess = 'SiemEntityCriticalityAccess',
  SiemEntityGroupsAccess = 'SiemEntityGroupsAccess',
  SiemIngestMappingsAccess = 'SiemIngestMappingsAccess',
  SiemInsightDetectionAccess = 'SiemInsightDetectionAccess',
  SiemInsightResolutionAccess = 'SiemInsightResolutionAccess',
  SiemInsightStatusAccess = 'SiemInsightStatusAccess',
  SiemIntegrationsAccess = 'SiemIntegrationsAccess',
  SiemLogMappingsAccess = 'SiemLogMappingsAccess',
  SiemNormalizationAccess = 'SiemNormalizationAccess',
  SiemSearchAccess = 'SiemSearchAccess',
  SiemStatusAccess = 'SiemStatusAccess',
  SiemTagSchemasAccess = 'SiemTagSchemasAccess',
  SiemThreatIntelligenceAccess = 'SiemThreatIntelligenceAccess',
  SignalsAccess = 'SignalsAccess',
  SlosManageAccess = 'SlosManageAccess',
  SlosViewAccess = 'SlosViewAccess',
  SourceTemplateAccess = 'SourceTemplateAccess',
  SpansAnalyticsAccess = 'SpansAnalyticsAccess',
  SupportAccountView = 'SupportAccountView',
  SuppressedListsAccess = 'SuppressedListsAccess',
  ThreatIntelligenceAccess = 'ThreatIntelligenceAccess',
  TraceAnalyticsAccess = 'TraceAnalyticsAccess',
  TrafficShapingAccess = 'TrafficShapingAccess',
  UiDataForwardingFlagsEnabled = 'UIDataForwardingFlagsEnabled',
  UiPerIndexDataForwardingEnabled = 'UIPerIndexDataForwardingEnabled',
  UnifiedMonitorsAdminAccess = 'UnifiedMonitorsAdminAccess',
  UnifiedMonitorsLockAccess = 'UnifiedMonitorsLockAccess',
  UnifiedMonitorsManageAccess = 'UnifiedMonitorsManageAccess',
  UnifiedMonitorsViewAccess = 'UnifiedMonitorsViewAccess',
  UpgradeTrialOrganizationsAccess = 'UpgradeTrialOrganizationsAccess',
  UsageManagementTabAccess = 'UsageManagementTabAccess',
  UseNewBatonTransactionStateMachine = 'UseNewBatonTransactionStateMachine',
  UserSessionTimeoutView = 'UserSessionTimeoutView',
  UsersTabAccess = 'UsersTabAccess',
  ViewOrganizationsAccess = 'ViewOrganizationsAccess',
  ViewsAccess = 'ViewsAccess',
  WhitelistAccess = 'WhitelistAccess'
}

export interface VendorProduct {
  __typename: 'VendorProduct';
  guid: Scalars['String']['output'];
  product: Scalars['String']['output'];
  vendor: Scalars['String']['output'];
}

export interface VendorProductFilter {
  __typename: 'VendorProductFilter';
  vendorProducts?: Maybe<Array<VendorProduct>>;
}

export interface VirusTotalConfig {
  __typename: 'VirusTotalConfig';
  apiKey?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
}

export interface VisitEntityPage {
  __typename: 'VisitEntityPage';
  data: Array<VisitedDetailPage>;
}

export interface VisitInsightPage {
  __typename: 'VisitInsightPage';
  data: Array<VisitedDetailPage>;
}

export interface VisitSearchQueryPage {
  __typename: 'VisitSearchQueryPage';
  data: Array<VisitedSearchQueryPage>;
}

export interface VisitSignalPage {
  __typename: 'VisitSignalPage';
  data: Array<VisitedDetailPage>;
}

export type VisitedDetailPage = VisitedEntityPage | VisitedInsightPage | VisitedSignalPage;

export interface VisitedEntityPage extends VisitedPageInterface {
  __typename: 'VisitedEntityPage';
  entity?: Maybe<EntityInterface>;
  entityId: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
}

export interface VisitedInsightPage extends VisitedPageInterface {
  __typename: 'VisitedInsightPage';
  insight?: Maybe<Insight>;
  insightId: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
}

export interface VisitedPageInterface {
  timestamp: Scalars['DateTime']['output'];
}

export interface VisitedSearchQueryPage extends VisitedPageInterface {
  __typename: 'VisitedSearchQueryPage';
  q: Scalars['String']['output'];
  resultType: SearchResultType;
  timestamp: Scalars['DateTime']['output'];
}

export interface VisitedSignalPage extends VisitedPageInterface {
  __typename: 'VisitedSignalPage';
  signal?: Maybe<Signal>;
  signalId: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
}

export enum YaraExpressionValidationError {
  IncludesNotAllowed = 'INCLUDES_NOT_ALLOWED',
  OnlyOneRuleAllowed = 'ONLY_ONE_RULE_ALLOWED',
  ParseError = 'PARSE_ERROR',
  UnknownImportsNotAllowed = 'UNKNOWN_IMPORTS_NOT_ALLOWED'
}

export interface YaraGithubConfig {
  __typename: 'YaraGithubConfig';
  branch?: Maybe<Scalars['String']['output']>;
  defaultSeverity: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  lastChecked?: Maybe<Scalars['DateTime']['output']>;
  lastRunReport?: Maybe<YaraGithubRunReport>;
  token?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
  yaraFileRegex: Scalars['String']['output'];
}

export interface YaraGithubRunReport {
  __typename: 'YaraGithubRunReport';
  changed: Array<Scalars['String']['output']>;
  created: Array<Scalars['String']['output']>;
  deleted: Array<Scalars['String']['output']>;
  duplicates: Array<Scalars['String']['output']>;
  parsedRules: Array<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  unchanged: Array<Scalars['String']['output']>;
  yaraFilePaths: Array<Scalars['String']['output']>;
  yaraFileRegex: Scalars['String']['output'];
  zipUrl: Scalars['String']['output'];
}

export interface YaraRule {
  __typename: 'YaraRule';
  category: Scalars['String']['output'];
  contentType: ContentType;
  created: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  createdByUser?: Maybe<User>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  expression: Scalars['String']['output'];
  history: Array<RuleHistoryEvent>;
  id: Scalars['ID']['output'];
  lastUpdated: Scalars['DateTime']['output'];
  lastUpdatedBy: Scalars['String']['output'];
  lastUpdatedByUser?: Maybe<User>;
  name: Scalars['String']['output'];
  ruleSource: Scalars['String']['output'];
  severity: Scalars['Int']['output'];
  signalCount07d: Scalars['Int']['output'];
  signalCount24h: Scalars['Int']['output'];
  source: YaraSource;
  stream: Scalars['String']['output'];
  yaraSourceId: Scalars['String']['output'];
}

export interface YaraRulePage {
  __typename: 'YaraRulePage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<YaraRule>;
  total: Scalars['Int']['output'];
}

export interface YaraRuleSort {
  direction?: SortDir;
  field?: YaraRuleSortableField;
}

export enum YaraRuleSortableField {
  Created = 'CREATED',
  Enabled = 'ENABLED',
  Name = 'NAME',
  Score = 'SCORE',
  SignalCount_07D = 'SIGNAL_COUNT_07D',
  SignalCount_24H = 'SIGNAL_COUNT_24H',
  Updated = 'UPDATED'
}

export interface YaraSource {
  __typename: 'YaraSource';
  created?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  githubConfig?: Maybe<YaraGithubConfig>;
  id: Scalars['ID']['output'];
  issues: Array<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rules: YaraRulePage;
  sourceType: YaraSourceType;
}


export interface YaraSourceRulesArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}

export interface YaraSourcePage {
  __typename: 'YaraSourcePage';
  hasNextPage: Scalars['Boolean']['output'];
  objects: Array<YaraSource>;
  total: Scalars['Int']['output'];
}

export enum YaraSourceType {
  Custom = 'CUSTOM',
  Git = 'GIT',
  Sumo = 'SUMO'
}

export enum Join__Graph {
  Aurora = 'AURORA'
}

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY'
}

export type CurrentUserFragment = { __typename: 'CurrentUser', createdTime?: any | null, email?: string | null, id: string, name?: string | null, permissions: Array<string>, preferredTimezone?: string | null, username: string };

export type AppInfoOperationQueryVariables = Exact<{
  featureFlagsToLookup: Array<Scalars['String']['input']> | Scalars['String']['input'];
  enabledByDefaultFeatureFlags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AppInfoOperationQuery = { __typename: 'Query', isFederatedCluster: boolean, enabledFeatureFlags: Array<string>, version: string, sumoLogicRegion?: string | null, deployment: string, orgId: string, orgName: string, cspCustomReportUrl?: string | null, sessionTimeoutMinutes?: number | null, currentUser: { __typename: 'CurrentUser', createdTime?: any | null, email?: string | null, id: string, name?: string | null, permissions: Array<string>, preferredTimezone?: string | null, username: string } };

export type CurrentUserSumoFragment = { __typename: 'CurrentUserSumo', id: string, accountType: string, accountStatus: string, organization: string, organizationId: number, userHashForIntercom: string, userIdForIntercom: string };

export type AppInfoOperationSumoQueryVariables = Exact<{ [key: string]: never; }>;


export type AppInfoOperationSumoQuery = { __typename: 'Query', currentUserSumo: { __typename: 'CurrentUserSumo', id: string, accountType: string, accountStatus: string, organization: string, organizationId: number, userHashForIntercom: string, userIdForIntercom: string } };

export type UserFieldsFragment = { __typename: 'User', accountNotificationsEnabled: boolean, active: boolean, apiKeyEnabled: boolean, createdTime?: any | null, displayName: string, emailConfirmed: boolean, email?: string | null, id: string, lastLogin?: any | null, lastActive?: any | null, mfaEnabled: boolean, name?: string | null, role: string, teams: Array<string>, username: string };

export type UsersOperationQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<SortDir>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UsersOperationQuery = { __typename: 'Query', mfaEnabled: boolean, ssoEnabled: boolean, users: { __typename: 'UserPage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'User', accountNotificationsEnabled: boolean, active: boolean, apiKeyEnabled: boolean, createdTime?: any | null, displayName: string, emailConfirmed: boolean, email?: string | null, id: string, lastLogin?: any | null, lastActive?: any | null, mfaEnabled: boolean, name?: string | null, role: string, teams: Array<string>, username: string }> } };

export type AllUsersFragment = { __typename: 'User', displayName: string, email?: string | null, id: string, name?: string | null, username: string };

export type AllUsersOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type AllUsersOperationQuery = { __typename: 'Query', users: { __typename: 'UserPage', objects: Array<{ __typename: 'User', displayName: string, email?: string | null, id: string, name?: string | null, username: string }> } };

export type AssignedInsightEmailConfigOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type AssignedInsightEmailConfigOperationQuery = { __typename: 'Query', assignedInsightEmailsEnabled: boolean };

export type UpdateAssignedInsightEmailsEnabledMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
}>;


export type UpdateAssignedInsightEmailsEnabledMutation = { __typename: 'Mutation', updateAssignedInsightEmailsEnabled?: { __typename: 'UpdateAssignedInsightEmailsEnabled', ok: boolean } | null };

export type ActionObjectFragment = { __typename: 'Action', id: string, name: string, type: string, enabled: boolean, configurationJson: any, createdTime: any, notificationTypes: any, parameters: Array<{ __typename: 'ActionParameter', name: string, displayName: string, required: boolean }> };

export type ActionsOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type ActionsOperationQuery = { __typename: 'Query', actions: Array<{ __typename: 'Action', id: string, name: string, type: string, enabled: boolean, configurationJson: any, createdTime: any, notificationTypes: any, parameters: Array<{ __typename: 'ActionParameter', name: string, displayName: string, required: boolean }> }> };

export type CreateActionOperationMutationVariables = Exact<{
  fields: ActionFields;
}>;


export type CreateActionOperationMutation = { __typename: 'Mutation', createAction?: { __typename: 'CreateAction', data: { __typename: 'Action', id: string, name: string, type: string, enabled: boolean, configurationJson: any, createdTime: any, notificationTypes: any, parameters: Array<{ __typename: 'ActionParameter', name: string, displayName: string, required: boolean }> } } | null };

export type UpdateActionOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: ActionFields;
}>;


export type UpdateActionOperationMutation = { __typename: 'Mutation', updateAction?: { __typename: 'UpdateAction', data: { __typename: 'Action', id: string, name: string, type: string, enabled: boolean, configurationJson: any, createdTime: any, notificationTypes: any, parameters: Array<{ __typename: 'ActionParameter', name: string, displayName: string, required: boolean }> } } | null };

export type ActionConfigurationSchemasOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type ActionConfigurationSchemasOperationQuery = { __typename: 'Query', actionConfigurationSchemas?: Array<{ __typename: 'ActionConfigurationSchema', typeName: string, typeValue: string, schemaJson: string }> | null };

export type DeleteActionOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteActionOperationMutation = { __typename: 'Mutation', deleteAction?: { __typename: 'DeleteAction', ok: boolean } | null };

export type AutomationRowFragment = { __typename: 'Automation', description?: string | null, cseResourceSubTypes?: Array<string> | null, cseResourceType: string, enabled: boolean, executionTypes: Array<string>, id: string, name: string, playbookId: string };

export type AutomationQueryOperationQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<AutomationSort> | AutomationSort>;
}>;


export type AutomationQueryOperationQuery = { __typename: 'Query', automations: { __typename: 'AutomationPage', hasNextPage: boolean, total: number, objects: Array<{ __typename: 'Automation', description?: string | null, cseResourceSubTypes?: Array<string> | null, cseResourceType: string, enabled: boolean, executionTypes: Array<string>, id: string, name: string, playbookId: string }> } };

export type DeleteAutomationOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAutomationOperationMutation = { __typename: 'Mutation', deleteAutomation?: { __typename: 'DeleteAutomation', ok: boolean } | null };

export type CreateAutomationOperationMutationVariables = Exact<{
  fields: AutomationFields;
}>;


export type CreateAutomationOperationMutation = { __typename: 'Mutation', createAutomation?: { __typename: 'CreateAutomation', data: { __typename: 'Automation', description?: string | null, cseResourceSubTypes?: Array<string> | null, cseResourceType: string, enabled: boolean, executionTypes: Array<string>, id: string, name: string, playbookId: string } } | null };

export type UpdateAutomationOperationMutationVariables = Exact<{
  fields: UpdateAutomationFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateAutomationOperationMutation = { __typename: 'Mutation', updateAutomation?: { __typename: 'UpdateAutomation', data: { __typename: 'Automation', description?: string | null, cseResourceSubTypes?: Array<string> | null, cseResourceType: string, enabled: boolean, executionTypes: Array<string>, id: string, name: string, playbookId: string } } | null };

export type AutomationConfigQueryOperationQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AutomationConfigQueryOperationQuery = { __typename: 'Query', automations: { __typename: 'AutomationPage', total: number, objects: Array<{ __typename: 'Automation', description?: string | null, cseResourceSubTypes?: Array<string> | null, cseResourceType: string, enabled: boolean, executionTypes: Array<string>, id: string, name: string, playbookId: string }> } };

export type DeleteAutomationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteAutomationMutation = { __typename: 'Mutation', deleteAutomation?: { __typename: 'DeleteAutomation', ok: boolean } | null };

export type PlaybooksQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type PlaybooksQueryOperationQuery = { __typename: 'Query', playbooks: Array<{ __typename: 'Playbook', id: string, name: string, type: string }> };

export type UpdateAutomationMutationVariables = Exact<{
  fields: UpdateAutomationFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateAutomationMutation = { __typename: 'Mutation', updateAutomation?: { __typename: 'UpdateAutomation', data: { __typename: 'Automation', cseResourceSubTypes?: Array<string> | null, executionTypes: Array<string>, enabled: boolean } } | null };

export type CreateAutomationMutationVariables = Exact<{
  fields: AutomationFields;
}>;


export type CreateAutomationMutation = { __typename: 'Mutation', createAutomation?: { __typename: 'CreateAutomation', data: { __typename: 'Automation', id: string, playbookId: string, name: string, description?: string | null, cseResourceType: string, cseResourceSubTypes?: Array<string> | null, executionTypes: Array<string>, enabled: boolean } } | null };

export type ToggleContextActionOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: UpdatableContextActionFields;
}>;


export type ToggleContextActionOperationMutation = { __typename: 'Mutation', updateContextAction?: { __typename: 'UpdateContextAction', data: { __typename: 'ContextAction', allRecordFields: boolean, enabled: boolean, entityTypes: Array<string>, id: string, iocTypes: Array<ContextActionIocType>, name: string, recordFields: Array<string>, template: string, type: ContextActionType } } | null };

export type DeleteContextActionOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteContextActionOperationMutation = { __typename: 'Mutation', deleteContextAction?: { __typename: 'DeleteContextAction', ok: boolean } | null };

export type ContextActionCreateOperationMutationVariables = Exact<{
  allRecordFields?: InputMaybe<Scalars['Boolean']['input']>;
  entityTypes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  name: Scalars['String']['input'];
  recordFields: Array<Scalars['String']['input']> | Scalars['String']['input'];
  template: Scalars['String']['input'];
  iocTypes: Array<ContextActionIocType> | ContextActionIocType;
  type: ContextActionType;
}>;


export type ContextActionCreateOperationMutation = { __typename: 'Mutation', createContextAction?: { __typename: 'CreateContextAction', data: { __typename: 'ContextAction', allRecordFields: boolean, enabled: boolean, entityTypes: Array<string>, id: string, iocTypes: Array<ContextActionIocType>, name: string, recordFields: Array<string>, template: string, type: ContextActionType } } | null };

export type ContextActionUpdateOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: UpdatableContextActionFields;
}>;


export type ContextActionUpdateOperationMutation = { __typename: 'Mutation', updateContextAction?: { __typename: 'UpdateContextAction', data: { __typename: 'ContextAction', allRecordFields: boolean, enabled: boolean, entityTypes: Array<string>, id: string, iocTypes: Array<ContextActionIocType>, name: string, recordFields: Array<string>, template: string, type: ContextActionType } } | null };

export type ContextActionFragment = { __typename: 'ContextAction', allRecordFields: boolean, enabled: boolean, entityTypes: Array<string>, id: string, iocTypes: Array<ContextActionIocType>, name: string, recordFields: Array<string>, template: string, type: ContextActionType };

export type ContextActionsQueryOperationQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<ContextActionSort> | ContextActionSort>;
}>;


export type ContextActionsQueryOperationQuery = { __typename: 'Query', contextActions: { __typename: 'ContextActionPage', hasNextPage: boolean, total: number, objects: Array<{ __typename: 'ContextAction', allRecordFields: boolean, enabled: boolean, entityTypes: Array<string>, id: string, iocTypes: Array<ContextActionIocType>, name: string, recordFields: Array<string>, template: string, type: ContextActionType }> } };

export type EnrichmentOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type EnrichmentOperationQuery = { __typename: 'Query', virusTotalConfig: { __typename: 'VirusTotalConfig', enabled: boolean, apiKey?: string | null } };

export type UpdateVirusTotalConfigOperationMutationVariables = Exact<{
  apiKey?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
}>;


export type UpdateVirusTotalConfigOperationMutation = { __typename: 'Mutation', updateVirusTotalConfig?: { __typename: 'UpdateVirusTotalConfig', data: { __typename: 'VirusTotalConfig', enabled: boolean, apiKey?: string | null } } | null };

export type CreateEntityValueConfigurationGroupMutationVariables = Exact<{
  fields: EntityValueEntityGroupConfigurationFields;
}>;


export type CreateEntityValueConfigurationGroupMutation = { __typename: 'Mutation', createEntityValueEntityGroupConfiguration?: { __typename: 'CreateEntityValueEntityGroupConfiguration', data: { __typename: 'EntityGroupConfiguration', id: string } } | null };

export type UpdateEntityValueConfigurationGroupMutationVariables = Exact<{
  fields: EntityValueEntityGroupConfigurationFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateEntityValueConfigurationGroupMutation = { __typename: 'Mutation', updateEntityValueEntityGroupConfiguration?: { __typename: 'UpdateEntityValueEntityGroupConfiguration', data: { __typename: 'EntityGroupConfiguration', id: string } } | null };

export type CreateInventoryConfigurationGroupMutationVariables = Exact<{
  fields: InventoryEntityGroupConfigurationFields;
}>;


export type CreateInventoryConfigurationGroupMutation = { __typename: 'Mutation', createInventoryEntityGroupConfiguration?: { __typename: 'CreateInventoryEntityGroupConfiguration', data: { __typename: 'EntityGroupConfiguration', id: string } } | null };

export type UpdateInventoryConfigurationGroupMutationVariables = Exact<{
  fields: InventoryEntityGroupConfigurationFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateInventoryConfigurationGroupMutation = { __typename: 'Mutation', updateInventoryEntityGroupConfiguration?: { __typename: 'UpdateInventoryEntityGroupConfiguration', data: { __typename: 'EntityGroupConfiguration', id: string } } | null };

export type EntityCriticalityConfigListItemFragment = { __typename: 'EntityCriticalityConfig', id: string, name: string, severityExpression: string, entityCount: number };

export type EntityCriticalityConfigsListQueryVariables = Exact<{ [key: string]: never; }>;


export type EntityCriticalityConfigsListQuery = { __typename: 'Query', entityCriticalityConfigs: { __typename: 'EntityCriticalityConfigPage', hasNextPage: boolean, total: number, objects: Array<{ __typename: 'EntityCriticalityConfig', id: string, name: string, severityExpression: string, entityCount: number }> } };

export type EntityGroupConfigurationCriticalityFragment = { __typename: 'EntityGroupConfiguration', id: string, criticality?: string | null };

export type EntityGroupConfigurationCriticalityListQueryVariables = Exact<{ [key: string]: never; }>;


export type EntityGroupConfigurationCriticalityListQuery = { __typename: 'Query', entityGroupConfigurations: { __typename: 'EntityGroupConfigurationPage', objects: Array<{ __typename: 'EntityGroupConfiguration', id: string, criticality?: string | null }> } };

export type DeleteEntityCriticalityConfigMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEntityCriticalityConfigMutation = { __typename: 'Mutation', deleteEntityCriticalityConfig?: { __typename: 'DeleteEntityCriticalityConfig', ok: boolean } | null };

export type CreateEntityCriticalityConfigMutationVariables = Exact<{
  fields: CreateEntityCriticalityConfigFields;
}>;


export type CreateEntityCriticalityConfigMutation = { __typename: 'Mutation', createEntityCriticalityConfig?: { __typename: 'CreateEntityCriticalityConfig', data: { __typename: 'EntityCriticalityConfig', id: string, name: string, severityExpression: string, entityCount: number } } | null };

export type UpdateEntityCriticalityConfigMutationVariables = Exact<{
  fields: UpdateEntityCriticalityConfigFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateEntityCriticalityConfigMutation = { __typename: 'Mutation', updateEntityCriticalityConfig?: { __typename: 'UpdateEntityCriticalityConfig', data: { __typename: 'EntityCriticalityConfig', id: string, name: string, severityExpression: string, entityCount: number } } | null };

export type DeleteEntityGroupConfigurationOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteEntityGroupConfigurationOperationMutation = { __typename: 'Mutation', deleteEntityGroupConfiguration?: { __typename: 'DeleteEntityGroupConfiguration', ok: boolean } | null };

export type UploadEntityGroupsCsvOperationMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadEntityGroupsCsvOperationMutation = { __typename: 'Mutation', uploadEntityGroupsCsv?: { __typename: 'UploadEntityGroupConfigurationMutationsCsv', uploadedEntityGroupCount: number } | null };

export type EntityGroupConfigurationFragment = { __typename: 'EntityGroupConfiguration', id: string, name: string, configurationType: EntityGroupConfigurationType, criticality?: string | null, description?: string | null, entityType?: string | null, group?: string | null, inventoryKey?: string | null, inventoryValue?: string | null, inventorySource?: string | null, inventoryType?: EntityGroupConfigurationInventoryType | null, dynamicTags?: boolean | null, tagSchema?: string | null, networkBlock?: string | null, prefix?: string | null, suffix?: string | null, suppressed?: boolean | null, tags?: Array<string> | null, entityNamespace?: string | null };

export type EntityGroupConfigurationsOperationQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort: EntityGroupConfigurationSortableField;
  sortDir: SortDir;
  q: Scalars['String']['input'];
}>;


export type EntityGroupConfigurationsOperationQuery = { __typename: 'Query', entityGroupConfigurations: { __typename: 'EntityGroupConfigurationPage', hasNextPage: boolean, total: number, objects: Array<{ __typename: 'EntityGroupConfiguration', id: string, name: string, configurationType: EntityGroupConfigurationType, criticality?: string | null, description?: string | null, entityType?: string | null, group?: string | null, inventoryKey?: string | null, inventoryValue?: string | null, inventorySource?: string | null, inventoryType?: EntityGroupConfigurationInventoryType | null, dynamicTags?: boolean | null, tagSchema?: string | null, networkBlock?: string | null, prefix?: string | null, suffix?: string | null, suppressed?: boolean | null, tags?: Array<string> | null, entityNamespace?: string | null }> } };

export type SensorZonesOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type SensorZonesOperationQuery = { __typename: 'Query', sensorZones?: Array<string | null> | null };

export type EntityDomainConfigOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type EntityDomainConfigOperationQuery = { __typename: 'Query', entityDomainConfiguration: { __typename: 'EntityDomainConfiguration', normalizeUsernames: boolean, normalizeHostnames: boolean, defaultNormalizedDomain?: string | null, adDomainNormalizationEnabled: boolean, fqdnNormalizationEnabled: boolean, awsNormalizationEnabled: boolean, domainMappings: Array<{ __typename: 'DomainMapping', rawDomain: string, normalizedDomain: string }> } };

export type UpdateEntityDomainConfigOperationMutationVariables = Exact<{
  fields: EntityDomainConfigurationFields;
}>;


export type UpdateEntityDomainConfigOperationMutation = { __typename: 'Mutation', updateEntityDomainConfiguration?: { __typename: 'UpdateEntityDomainConfiguration', ok: boolean } | null };

export type DeleteInventoryEntityLookupTableOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteInventoryEntityLookupTableOperationMutation = { __typename: 'Mutation', deleteInventoryEntityLookupTable?: { __typename: 'DeleteInventoryEntityLookupTable', ok: boolean } | null };

export type DeleteCustomerSourcedEntityLookupTableOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCustomerSourcedEntityLookupTableOperationMutation = { __typename: 'Mutation', deleteCustomerSourcedEntityLookupTable?: { __typename: 'DeleteCustomerSourcedEntityLookupTable', ok: boolean } | null };

export type UpdateCustomerSourcedEntityLookupTableOperationMutationVariables = Exact<{
  fields: UpdateCustomerSourcedEntityLookupTableFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateCustomerSourcedEntityLookupTableOperationMutation = { __typename: 'Mutation', updateCustomerSourcedEntityLookupTable?: { __typename: 'UpdateCustomerSourcedEntityLookupTable', data: { __typename: 'CustomerSourcedEntityLookupTable', id: string, tableId: string, contentId: string, type: EntityLookupTableType, sourceCategory?: string | null, keyColumnName: string, valueColumnName: string, tablePath?: string | null, created?: any | null } } | null };

export type CreateCustomerSourcedEntityLookupTableOperationMutationVariables = Exact<{
  fields: CreateCustomerSourcedEntityLookupTableFields;
}>;


export type CreateCustomerSourcedEntityLookupTableOperationMutation = { __typename: 'Mutation', createCustomerSourcedEntityLookupTable?: { __typename: 'CreateCustomerSourcedEntityLookupTable', data: { __typename: 'CustomerSourcedEntityLookupTable', id: string, tableId: string, contentId: string, type: EntityLookupTableType, sourceCategory?: string | null, keyColumnName: string, valueColumnName: string, tablePath?: string | null, created?: any | null } } | null };

export type InventoryLookupTablesQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type InventoryLookupTablesQueryOperationQuery = { __typename: 'Query', inventoryLookupTables: Array<{ __typename: 'InventoryEntityLookupTable', id: string, tableId: string, contentId: string, type: EntityLookupTableType, inventorySource: string, sourceCategory?: string | null, tablePath: string, created?: any | null }> };

export type CustomerSourcedLookupTablesQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerSourcedLookupTablesQueryOperationQuery = { __typename: 'Query', customerSourcedLookupTables: Array<{ __typename: 'CustomerSourcedEntityLookupTable', id: string, tableId: string, contentId: string, type: EntityLookupTableType, sourceCategory?: string | null, keyColumnName: string, valueColumnName: string, tablePath?: string | null, created?: any | null }> };

export type CustomEntityTypeConfigListItemFragment = { __typename: 'CustomEntityType', id: string, identifier: string, name: string, fields: Array<string> };

export type CustomEntityTypesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CustomEntityTypesQuery = { __typename: 'Query', customEntityTypes: { __typename: 'CustomEntityTypePage', hasNextPage: boolean, total: number, objects: Array<{ __typename: 'CustomEntityType', id: string, identifier: string, name: string, fields: Array<string> }> } };

export type DeleteCustomEntityTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCustomEntityTypeMutation = { __typename: 'Mutation', deleteCustomEntityType?: { __typename: 'DeleteCustomEntityType', ok: boolean } | null };

export type CreateCustomEntityTypeMutationVariables = Exact<{
  fields: CreateCustomEntityTypeFields;
}>;


export type CreateCustomEntityTypeMutation = { __typename: 'Mutation', createCustomEntityType?: { __typename: 'CreateCustomEntityType', data: { __typename: 'CustomEntityType', id: string, identifier: string, name: string, fields: Array<string> } } | null };

export type UpdateCustomEntityTypeMutationVariables = Exact<{
  fields: UpdateCustomEntityTypeFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateCustomEntityTypeMutation = { __typename: 'Mutation', updateCustomEntityType?: { __typename: 'UpdateCustomEntityType', data: { __typename: 'CustomEntityType', id: string, identifier: string, name: string, fields: Array<string> } } | null };

export type ReservedEntityFieldsOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type ReservedEntityFieldsOperationQuery = { __typename: 'Query', entityFields: Array<string> };

export type UpdateInsightConfigOperationMutationVariables = Exact<{
  config: InsightConfigInput;
}>;


export type UpdateInsightConfigOperationMutation = { __typename: 'Mutation', updateInsightConfig?: { __typename: 'UpdateInsightConfig', data: { __typename: 'InsightConfig', lookbackDays?: number | null, threshold?: number | null, globalSignalSuppressionWindow?: number | null } } | null };

export type InsightSubResolutionFragment = { __typename: 'InsightResolution', id: number, name: string, description?: string | null, parentId?: number | null };

export type InsightResolutionFragment = { __typename: 'InsightResolution', id: number, name: string, description?: string | null, parentId?: number | null, subResolutions: Array<{ __typename: 'InsightResolution', id: number, name: string, description?: string | null, parentId?: number | null }> };

export type InsightResolutionQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type InsightResolutionQueryOperationQuery = { __typename: 'Query', insightResolutions: { __typename: 'InsightResolutionPage', total: number, objects: Array<{ __typename: 'InsightResolution', id: number, name: string, description?: string | null, parentId?: number | null, subResolutions: Array<{ __typename: 'InsightResolution', id: number, name: string, description?: string | null, parentId?: number | null }> }> } };

export type DeleteInsightResolutionOperationMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteInsightResolutionOperationMutation = { __typename: 'Mutation', deleteInsightResolution?: { __typename: 'DeleteInsightResolution', ok: boolean } | null };

export type CreateInsightResolutionMutationOperationMutationVariables = Exact<{
  fields: CreateInsightResolutionFields;
}>;


export type CreateInsightResolutionMutationOperationMutation = { __typename: 'Mutation', createInsightResolution?: { __typename: 'CreateInsightResolution', data: { __typename: 'InsightResolution', id: number, name: string, description?: string | null, parentId?: number | null } } | null };

export type UpdateInsightResolutionMutationOperationMutationVariables = Exact<{
  fields: UpdateInsightResolutionFields;
  id: Scalars['Int']['input'];
}>;


export type UpdateInsightResolutionMutationOperationMutation = { __typename: 'Mutation', updateInsightResolution?: { __typename: 'UpdateInsightResolution', data: { __typename: 'InsightResolution', id: number, name: string, description?: string | null, parentId?: number | null } } | null };

export type SingleInsightResolutionQueryOperationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SingleInsightResolutionQueryOperationQuery = { __typename: 'Query', insightResolution: { __typename: 'InsightResolution', id: number, name: string, description?: string | null, parentId?: number | null, subResolutions: Array<{ __typename: 'InsightResolution', id: number, name: string, description?: string | null, parentId?: number | null }> } };

export type UpdateLogMappingOperationMutationVariables = Exact<{
  fields: UpdateLogMappingFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateLogMappingOperationMutation = { __typename: 'Mutation', updateLogMapping?: { __typename: 'UpdateLogMapping', data: { __typename: 'LogMapping', id: string, name: string, source: string, recordType: string, isStructured: boolean, vendor?: string | null, product?: string | null, isCustom: boolean, isEnabled: boolean, skippedValues: Array<string>, fields: Array<{ __typename: 'LogMappingField', alternateValues?: Array<string> | null, caseInsensitive?: boolean | null, defaultValue?: string | null, fieldJoin?: Array<string> | null, format?: string | null, formatParameters?: Array<string> | null, joinDelimiter?: string | null, name: string, splitDelimiter?: string | null, splitIndex?: string | null, value?: string | null, valueType?: string | null, lookup?: Array<{ __typename: 'LogMappingFieldLookupKeyValue', key: string, value: string }> | null }>, parsingPatterns: Array<{ __typename: 'ParsingPattern', id: string, value: string }>, structuredInputs: Array<{ __typename: 'LogMappingStructuredInput', logFormat: string, vendor: string, product: string, eventIdPattern: string }> } } | null };

export type LogMappingOptionsQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type LogMappingOptionsQueryOperationQuery = { __typename: 'Query', logMappingOptions: { __typename: 'LogMappingOptions', fieldValueTypeOptions: Array<{ __typename: 'LogMappingFieldValueTypeOption', label: string, value: string }> } };

export type LogMappingFormatOptionsQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type LogMappingFormatOptionsQueryOperationQuery = { __typename: 'Query', logMappingOptions: { __typename: 'LogMappingOptions', logFormatOptions: Array<{ __typename: 'LogMappingLogFormatOption', value: string, label: string }> } };

export type LogMappingRecordTypeQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type LogMappingRecordTypeQueryOperationQuery = { __typename: 'Query', logMappingOptions: { __typename: 'LogMappingOptions', recordTypeOptions: Array<{ __typename: 'LogMappingRecordTypeOption', objectType: string, mappableFields: Array<{ __typename: 'LogMappingMappableField', name: string, type: string }> }> } };

export type ParsingPatternOptionsQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type ParsingPatternOptionsQueryOperationQuery = { __typename: 'Query', logMappingOptions: { __typename: 'LogMappingOptions', parsingPatternOptions: Array<{ __typename: 'LogMappingParsingPatternOption', value: string, label: string }> } };

export type LogMappingVendorsAndProductsQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type LogMappingVendorsAndProductsQueryOperationQuery = { __typename: 'Query', logMappingVendorsAndProducts: Array<{ __typename: 'LogMappingVendorAndProduct', guid: string, product: string, vendor: string }> };

export type CreateLogMappingOperationMutationVariables = Exact<{
  fields: CreateLogMappingFields;
}>;


export type CreateLogMappingOperationMutation = { __typename: 'Mutation', createLogMapping?: { __typename: 'CreateLogMapping', data: { __typename: 'LogMapping', id: string, name: string, source: string, recordType: string, isStructured: boolean, vendor?: string | null, product?: string | null, isCustom: boolean, isEnabled: boolean, skippedValues: Array<string>, fields: Array<{ __typename: 'LogMappingField', alternateValues?: Array<string> | null, caseInsensitive?: boolean | null, defaultValue?: string | null, fieldJoin?: Array<string> | null, format?: string | null, formatParameters?: Array<string> | null, joinDelimiter?: string | null, name: string, splitDelimiter?: string | null, splitIndex?: string | null, value?: string | null, valueType?: string | null, lookup?: Array<{ __typename: 'LogMappingFieldLookupKeyValue', key: string, value: string }> | null }>, parsingPatterns: Array<{ __typename: 'ParsingPattern', id: string, value: string }>, structuredInputs: Array<{ __typename: 'LogMappingStructuredInput', logFormat: string, vendor: string, product: string, eventIdPattern: string }> } } | null };

export type EnforcedOutputSchemaFieldsQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type EnforcedOutputSchemaFieldsQueryOperationQuery = { __typename: 'Query', enforcedOutputSchemaFields: Array<{ __typename: 'EnforcedOutputField', field: string, enforcedOutputs: Array<string | null> }> };

export type LogMappingRecordMetricsQueryOperationQueryVariables = Exact<{
  daysBack: Scalars['Int']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type LogMappingRecordMetricsQueryOperationQuery = { __typename: 'Query', recordCountsByParsed: Array<{ __typename: 'RecordCountsByParsedDataPoint', timestamp: any, value: { __typename: 'RecordCountByParsed', parsed: any, unparsed: any } }>, recordCountsByVendorAndProduct: Array<{ __typename: 'CountsByVendorAndProductDataPoint', timestamp: any, value: Array<{ __typename: 'CountForVendorAndProduct', count: any, product: string, vendor?: string | null }> }>, signalCountsByVendorAndProduct: Array<{ __typename: 'CountsByVendorAndProductDataPoint', timestamp: any, value: Array<{ __typename: 'CountForVendorAndProduct', count: any, product: string, vendor?: string | null }> }> };

export type LogMappingFragment = { __typename: 'LogMapping', id: string, name: string, recordType: string, isStructured: boolean, inputVendor?: string | null, inputProduct?: string | null, vendor?: string | null, product?: string | null, logFormat?: string | null, eventIdPattern?: string | null, isCustom: boolean, isEnabled: boolean, recordCount07d: any, recordCount24h: any, source: string, parsingPatterns: Array<{ __typename: 'ParsingPattern', id: string, value: string }>, structuredInputs: Array<{ __typename: 'LogMappingStructuredInput', vendor: string, product: string }> };

export type LogMappingsQueryOperationQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sort: LogMappingSortableField;
  sortDir: SortDir;
  q?: InputMaybe<Scalars['String']['input']>;
}>;


export type LogMappingsQueryOperationQuery = { __typename: 'Query', logMappings: { __typename: 'LogMappingPage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'LogMapping', id: string, name: string, recordType: string, isStructured: boolean, inputVendor?: string | null, inputProduct?: string | null, vendor?: string | null, product?: string | null, logFormat?: string | null, eventIdPattern?: string | null, isCustom: boolean, isEnabled: boolean, recordCount07d: any, recordCount24h: any, source: string, parsingPatterns: Array<{ __typename: 'ParsingPattern', id: string, value: string }>, structuredInputs: Array<{ __typename: 'LogMappingStructuredInput', vendor: string, product: string }> }> } };

export type UpdateMappingEnabledOperationMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
}>;


export type UpdateMappingEnabledOperationMutation = { __typename: 'Mutation', updateLogMappingEnabled?: { __typename: 'UpdateLogMappingEnabled', data: { __typename: 'LogMapping', id: string, isEnabled: boolean, lastUpdated: any, lastUpdatedBy: string } } | null };

export type DeleteLogMappingOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteLogMappingOperationMutation = { __typename: 'Mutation', deleteLogMapping?: { __typename: 'DeleteLogMapping', ok: boolean } | null };

export type LogMappingFieldsFragment = { __typename: 'LogMapping', id: string, name: string, source: string, recordType: string, isStructured: boolean, vendor?: string | null, product?: string | null, isCustom: boolean, isEnabled: boolean, skippedValues: Array<string>, fields: Array<{ __typename: 'LogMappingField', alternateValues?: Array<string> | null, caseInsensitive?: boolean | null, defaultValue?: string | null, fieldJoin?: Array<string> | null, format?: string | null, formatParameters?: Array<string> | null, joinDelimiter?: string | null, name: string, splitDelimiter?: string | null, splitIndex?: string | null, value?: string | null, valueType?: string | null, lookup?: Array<{ __typename: 'LogMappingFieldLookupKeyValue', key: string, value: string }> | null }>, parsingPatterns: Array<{ __typename: 'ParsingPattern', id: string, value: string }>, structuredInputs: Array<{ __typename: 'LogMappingStructuredInput', logFormat: string, vendor: string, product: string, eventIdPattern: string }> };

export type LogMappingDetailQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type LogMappingDetailQuery = { __typename: 'Query', logMapping: { __typename: 'LogMapping', id: string, name: string, source: string, recordType: string, isStructured: boolean, vendor?: string | null, product?: string | null, isCustom: boolean, isEnabled: boolean, skippedValues: Array<string>, fields: Array<{ __typename: 'LogMappingField', alternateValues?: Array<string> | null, caseInsensitive?: boolean | null, defaultValue?: string | null, fieldJoin?: Array<string> | null, format?: string | null, formatParameters?: Array<string> | null, joinDelimiter?: string | null, name: string, splitDelimiter?: string | null, splitIndex?: string | null, value?: string | null, valueType?: string | null, lookup?: Array<{ __typename: 'LogMappingFieldLookupKeyValue', key: string, value: string }> | null }>, parsingPatterns: Array<{ __typename: 'ParsingPattern', id: string, value: string }>, structuredInputs: Array<{ __typename: 'LogMappingStructuredInput', logFormat: string, vendor: string, product: string, eventIdPattern: string }> }, logMappingVendorsAndProducts: Array<{ __typename: 'LogMappingVendorAndProduct', guid: string, product: string, vendor: string }> };

export type SumoMappingObjectFieldsFragment = { __typename: 'SumoMapping', id: string, enabled: boolean, sourceCategory: string, vendor?: string | null, product?: string | null, eventId?: string | null, logFormat: string, syslogFormat?: string | null, syslogDelimiter?: string | null, syslogKvDelimiter?: string | null, jsonExplode?: string | null, exportConfigJson: any, created: any, lastUpdated?: any | null, createdBy: string, lastUpdatedBy?: string | null, jsonZipOperations: Array<{ __typename: 'SumoMappingJsonZipOperation', keyName: string, matchKey: string, matchValue: string }> };

export type SumoMappingsOperationQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sort: SumoMappingSortableField;
  sortDir: SortDir;
}>;


export type SumoMappingsOperationQuery = { __typename: 'Query', sumoMappings: { __typename: 'SumoMappingPage', hasNextPage: boolean, total: number, objects: Array<{ __typename: 'SumoMapping', id: string, enabled: boolean, sourceCategory: string, vendor?: string | null, product?: string | null, eventId?: string | null, logFormat: string, syslogFormat?: string | null, syslogDelimiter?: string | null, syslogKvDelimiter?: string | null, jsonExplode?: string | null, exportConfigJson: any, created: any, lastUpdated?: any | null, createdBy: string, lastUpdatedBy?: string | null, jsonZipOperations: Array<{ __typename: 'SumoMappingJsonZipOperation', keyName: string, matchKey: string, matchValue: string }> }> } };

export type DeleteSumoMappingOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSumoMappingOperationMutation = { __typename: 'Mutation', deleteSumoMapping?: { __typename: 'DeleteSumoMapping', ok: boolean } | null };

export type CreateSumoMappingOperationMutationVariables = Exact<{
  fields: SumoMappingFields;
}>;


export type CreateSumoMappingOperationMutation = { __typename: 'Mutation', createSumoMapping?: { __typename: 'CreateSumoMapping', data: { __typename: 'SumoMapping', id: string, enabled: boolean, sourceCategory: string, vendor?: string | null, product?: string | null, eventId?: string | null, logFormat: string, syslogFormat?: string | null, syslogDelimiter?: string | null, syslogKvDelimiter?: string | null, jsonExplode?: string | null, exportConfigJson: any, created: any, lastUpdated?: any | null, createdBy: string, lastUpdatedBy?: string | null, jsonZipOperations: Array<{ __typename: 'SumoMappingJsonZipOperation', keyName: string, matchKey: string, matchValue: string }> } } | null };

export type UpdateSumoMappingOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: SumoMappingFields;
}>;


export type UpdateSumoMappingOperationMutation = { __typename: 'Mutation', updateSumoMapping?: { __typename: 'UpdateSumoMapping', data: { __typename: 'SumoMapping', id: string, enabled: boolean, sourceCategory: string, vendor?: string | null, product?: string | null, eventId?: string | null, logFormat: string, syslogFormat?: string | null, syslogDelimiter?: string | null, syslogKvDelimiter?: string | null, jsonExplode?: string | null, exportConfigJson: any, created: any, lastUpdated?: any | null, createdBy: string, lastUpdatedBy?: string | null, jsonZipOperations: Array<{ __typename: 'SumoMappingJsonZipOperation', keyName: string, matchKey: string, matchValue: string }> } } | null };

export type CreateTagSchemaOperationMutationVariables = Exact<{
  fields: CreateTagSchemaFields;
}>;


export type CreateTagSchemaOperationMutation = { __typename: 'Mutation', createTagSchema?: { __typename: 'CreateTagSchema', data: { __typename: 'TagSchema', key: string, label?: string | null, contentTypeEnums?: Array<TagContentType> | null, valueOptionObjects?: Array<{ __typename: 'TagSchemaValueOption', value: string, label?: string | null, link?: string | null }> | null } } | null };

export type UpdateTagSchemaOperationMutationVariables = Exact<{
  fields: UpdateTagSchemaFields;
}>;


export type UpdateTagSchemaOperationMutation = { __typename: 'Mutation', updateTagSchema?: { __typename: 'UpdateTagSchema', data: { __typename: 'TagSchema', key: string, label?: string | null, contentTypeEnums?: Array<TagContentType> | null, valueOptionObjects?: Array<{ __typename: 'TagSchemaValueOption', value: string, label?: string | null, link?: string | null }> | null } } | null };

export type DeleteTagSchemaOperationMutationVariables = Exact<{
  key: Scalars['ID']['input'];
}>;


export type DeleteTagSchemaOperationMutation = { __typename: 'Mutation', deleteTagSchema?: { __typename: 'DeleteTagSchema', ok: boolean } | null };

export type WorkflowInsightStatusFragment = { __typename: 'InsightStatus', id: string, name: string, displayName: string, source: string, description?: string | null, color?: string | null };

export type CreateInsightStatusOperationMutationVariables = Exact<{
  fields: CreateInsightStatusFields;
}>;


export type CreateInsightStatusOperationMutation = { __typename: 'Mutation', createInsightStatus?: { __typename: 'CreateInsightStatus', data: { __typename: 'InsightStatus', id: string, name: string, displayName: string, source: string, description?: string | null, color?: string | null } } | null };

export type UpdateInsightStatusWorkflowOperationMutationVariables = Exact<{
  fields: UpdateInsightStatusFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateInsightStatusWorkflowOperationMutation = { __typename: 'Mutation', updateInsightStatus?: { __typename: 'UpdateInsightStatus', data: { __typename: 'InsightStatus', id: string, name: string, displayName: string, source: string, description?: string | null, color?: string | null } } | null };

export type InsightStatusesOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type InsightStatusesOperationQuery = { __typename: 'Query', insightStatusInProgressEnabled: boolean, insightStatuses: Array<{ __typename: 'InsightStatus', id: string, name: string, displayName: string, source: string, description?: string | null, color?: string | null }> };

export type DeleteInsightStatusOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteInsightStatusOperationMutation = { __typename: 'Mutation', deleteInsightStatus?: { __typename: 'DeleteInsightStatus', ok: boolean } | null };

export type ReorderInsightStatusesOperationMutationVariables = Exact<{
  orderedIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReorderInsightStatusesOperationMutation = { __typename: 'Mutation', reorderInsightStatuses?: { __typename: 'ReorderInsightStatuses', ok: boolean } | null };

export type UpdateInsightInProgressStatusOperationMutationVariables = Exact<{
  enable: Scalars['Boolean']['input'];
}>;


export type UpdateInsightInProgressStatusOperationMutation = { __typename: 'Mutation', updateInsightStatusInProgressEnabled?: { __typename: 'UpdateInsightStatusInProgressEnabled', ok: boolean } | null };

export type CustomInsightFieldsFragment = { __typename: 'CustomInsight', id: string, created: any, deleted: boolean, description: string, enabled: boolean, lastUpdated: any, name: string, ordered: boolean, ruleIds: Array<string>, severity: InsightSeverityPyEnum, signalNames: Array<string>, signalMatchStrategy?: CustomInsightSignalMatchStrategy | null, tags: Array<string>, dynamicSeverity?: Array<{ __typename: 'DynamicInsightSeverity', minimumSignalSeverity: number, insightSeverity: InsightSeverityPyEnum }> | null };

export type CustomInsightsQueryOperationQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type CustomInsightsQueryOperationQuery = { __typename: 'Query', customInsights: { __typename: 'CustomInsightPage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'CustomInsight', id: string, created: any, deleted: boolean, description: string, enabled: boolean, lastUpdated: any, name: string, ordered: boolean, ruleIds: Array<string>, severity: InsightSeverityPyEnum, signalNames: Array<string>, signalMatchStrategy?: CustomInsightSignalMatchStrategy | null, tags: Array<string>, dynamicSeverity?: Array<{ __typename: 'DynamicInsightSeverity', minimumSignalSeverity: number, insightSeverity: InsightSeverityPyEnum }> | null }> } };

export type CustomInsightQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CustomInsightQuery = { __typename: 'Query', customInsight: { __typename: 'CustomInsight', id: string, created: any, deleted: boolean, description: string, enabled: boolean, lastUpdated: any, name: string, ordered: boolean, ruleIds: Array<string>, severity: InsightSeverityPyEnum, signalNames: Array<string>, signalMatchStrategy?: CustomInsightSignalMatchStrategy | null, tags: Array<string>, dynamicSeverity?: Array<{ __typename: 'DynamicInsightSeverity', minimumSignalSeverity: number, insightSeverity: InsightSeverityPyEnum }> | null } };

export type CreateCustomInsightOperationMutationVariables = Exact<{
  fields: CreateCustomInsightFields;
}>;


export type CreateCustomInsightOperationMutation = { __typename: 'Mutation', createCustomInsight?: { __typename: 'CreateCustomInsight', data: { __typename: 'CustomInsight', id: string, created: any, deleted: boolean, description: string, enabled: boolean, lastUpdated: any, name: string, ordered: boolean, ruleIds: Array<string>, severity: InsightSeverityPyEnum, signalNames: Array<string>, signalMatchStrategy?: CustomInsightSignalMatchStrategy | null, tags: Array<string>, dynamicSeverity?: Array<{ __typename: 'DynamicInsightSeverity', minimumSignalSeverity: number, insightSeverity: InsightSeverityPyEnum }> | null } } | null };

export type UpdateCustomInsightOperationMutationVariables = Exact<{
  fields: UpdateCustomInsightFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateCustomInsightOperationMutation = { __typename: 'Mutation', updateCustomInsight?: { __typename: 'UpdateCustomInsight', data: { __typename: 'CustomInsight', id: string, created: any, deleted: boolean, description: string, enabled: boolean, lastUpdated: any, name: string, ordered: boolean, ruleIds: Array<string>, severity: InsightSeverityPyEnum, signalNames: Array<string>, signalMatchStrategy?: CustomInsightSignalMatchStrategy | null, tags: Array<string>, dynamicSeverity?: Array<{ __typename: 'DynamicInsightSeverity', minimumSignalSeverity: number, insightSeverity: InsightSeverityPyEnum }> | null } } | null };

export type UpdateCustomInsightEnabledOperationMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
}>;


export type UpdateCustomInsightEnabledOperationMutation = { __typename: 'Mutation', updateCustomInsightEnabled?: { __typename: 'UpdateCustomInsightEnabled', ok: boolean } | null };

export type DeleteCustomInsightOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCustomInsightOperationMutation = { __typename: 'Mutation', deleteCustomInsight?: { __typename: 'DeleteCustomInsight', ok: boolean } | null };

export type YaraRuleEditorOperationQueryVariables = Exact<{
  sourceId: Scalars['ID']['input'];
  ruleId: Scalars['ID']['input'];
  fetchYaraRule: Scalars['Boolean']['input'];
}>;


export type YaraRuleEditorOperationQuery = { __typename: 'Query', yaraSource: { __typename: 'YaraSource', id: string, name: string, description?: string | null, sourceType: YaraSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, issues: Array<string>, githubConfig?: { __typename: 'YaraGithubConfig', enabled: boolean, url: string, username?: string | null, token?: string | null, yaraFileRegex: string, defaultSeverity: number } | null, rules: { __typename: 'YaraRulePage', total: number } }, yaraRule?: { __typename: 'YaraRule', enabled: boolean, name: string, id: string, description: string, expression: string, severity: number, ruleSource: string } };

export type YaraExpressionValidationOperationQueryVariables = Exact<{
  expression: Scalars['String']['input'];
  runValidation: Scalars['Boolean']['input'];
}>;


export type YaraExpressionValidationOperationQuery = { __typename: 'Query', validateYaraExpression?: YaraExpressionValidationError | null };

export type AddYaraRuleToYaraSourceOperationMutationVariables = Exact<{
  yaraSourceId: Scalars['ID']['input'];
  ruleFields: CustomYaraRuleFields;
}>;


export type AddYaraRuleToYaraSourceOperationMutation = { __typename: 'Mutation', addYaraRuleToCustomYaraSource?: { __typename: 'AddYaraRuleToCustomYaraSource', data: { __typename: 'YaraRule', enabled: boolean, name: string, id: string, description: string, expression: string, severity: number, ruleSource: string } } | null };

export type UpdateYaraRuleOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: CustomYaraRuleFields;
}>;


export type UpdateYaraRuleOperationMutation = { __typename: 'Mutation', updateCustomYaraRule?: { __typename: 'UpdateCustomYaraRule', data: { __typename: 'YaraRule', enabled: boolean, name: string, id: string, description: string, expression: string, severity: number, ruleSource: string } } | null };

export type YaraRulesSearchOperationQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort: YaraRuleSortableField;
  sortDir: SortDir;
  q: Scalars['String']['input'];
}>;


export type YaraRulesSearchOperationQuery = { __typename: 'Query', yaraRules: { __typename: 'YaraRulePage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'YaraRule', enabled: boolean, name: string, id: string, description: string, expression: string, severity: number, ruleSource: string, source: { __typename: 'YaraSource', id: string, name: string, sourceType: YaraSourceType } }> } };

export type SearchYaraRuleFragment = { __typename: 'YaraRule', enabled: boolean, name: string, id: string, description: string, expression: string, severity: number, ruleSource: string, source: { __typename: 'YaraSource', id: string, name: string, sourceType: YaraSourceType } };

export type DeleteYaraSourceOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteYaraSourceOperationMutation = { __typename: 'Mutation', deleteYaraSource?: { __typename: 'DeleteYaraSource', ok: boolean } | null };

export type YaraSourceDetailOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type YaraSourceDetailOperationQuery = { __typename: 'Query', yaraSource: { __typename: 'YaraSource', id: string, name: string, description?: string | null, sourceType: YaraSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, issues: Array<string>, githubConfig?: { __typename: 'YaraGithubConfig', enabled: boolean, url: string, username?: string | null, token?: string | null, yaraFileRegex: string, defaultSeverity: number } | null, rules: { __typename: 'YaraRulePage', total: number } } };

export type YaraRulesOperationQueryVariables = Exact<{
  sourceIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort: YaraRuleSortableField;
  sortDir: SortDir;
  q: Scalars['String']['input'];
}>;


export type YaraRulesOperationQuery = { __typename: 'Query', yaraRules: { __typename: 'YaraRulePage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'YaraRule', enabled: boolean, name: string, id: string, description: string, expression: string, severity: number, ruleSource: string }> } };

export type CreateCustomYaraSourceOperationMutationVariables = Exact<{
  fields: CustomYaraSourceFields;
}>;


export type CreateCustomYaraSourceOperationMutation = { __typename: 'Mutation', createCustomYaraSource?: { __typename: 'CreateCustomYaraSource', data: { __typename: 'YaraSource', id: string, name: string, description?: string | null, sourceType: YaraSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, issues: Array<string>, githubConfig?: { __typename: 'YaraGithubConfig', enabled: boolean, url: string, username?: string | null, token?: string | null, yaraFileRegex: string, defaultSeverity: number } | null, rules: { __typename: 'YaraRulePage', total: number } } } | null };

export type UpdateCustomYaraSourceOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: UpdatableCustomYaraSourceFields;
}>;


export type UpdateCustomYaraSourceOperationMutation = { __typename: 'Mutation', updateCustomYaraSource?: { __typename: 'UpdateCustomYaraSource', data: { __typename: 'YaraSource', id: string, name: string, description?: string | null, sourceType: YaraSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, issues: Array<string>, githubConfig?: { __typename: 'YaraGithubConfig', enabled: boolean, url: string, username?: string | null, token?: string | null, yaraFileRegex: string, defaultSeverity: number } | null, rules: { __typename: 'YaraRulePage', total: number } } } | null };

export type CreateGithubYaraSourceOperationMutationVariables = Exact<{
  fields: GithubYaraSourceFields;
}>;


export type CreateGithubYaraSourceOperationMutation = { __typename: 'Mutation', createGithubYaraSource?: { __typename: 'CreateGithubYaraSource', data: { __typename: 'YaraSource', id: string, name: string, description?: string | null, sourceType: YaraSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, issues: Array<string>, githubConfig?: { __typename: 'YaraGithubConfig', enabled: boolean, url: string, username?: string | null, token?: string | null, yaraFileRegex: string, defaultSeverity: number } | null, rules: { __typename: 'YaraRulePage', total: number } } } | null };

export type UpdateGithubYaraSourceOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: UpdatableGithubYaraSourceFields;
}>;


export type UpdateGithubYaraSourceOperationMutation = { __typename: 'Mutation', updateGithubYaraSource?: { __typename: 'UpdateGithubYaraSource', data: { __typename: 'YaraSource', id: string, name: string, description?: string | null, sourceType: YaraSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, issues: Array<string>, githubConfig?: { __typename: 'YaraGithubConfig', enabled: boolean, url: string, username?: string | null, token?: string | null, yaraFileRegex: string, defaultSeverity: number } | null, rules: { __typename: 'YaraRulePage', total: number } } } | null };

export type YaraSourceEditorOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type YaraSourceEditorOperationQuery = { __typename: 'Query', yaraSource: { __typename: 'YaraSource', id: string, name: string, description?: string | null, sourceType: YaraSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, issues: Array<string>, githubConfig?: { __typename: 'YaraGithubConfig', enabled: boolean, url: string, username?: string | null, token?: string | null, yaraFileRegex: string, defaultSeverity: number } | null, rules: { __typename: 'YaraRulePage', total: number } } };

export type YaraSourcesOperationQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sort: Scalars['String']['input'];
  sortDir: SortDir;
}>;


export type YaraSourcesOperationQuery = { __typename: 'Query', yaraSources: { __typename: 'YaraSourcePage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'YaraSource', id: string, name: string, description?: string | null, sourceType: YaraSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, issues: Array<string>, githubConfig?: { __typename: 'YaraGithubConfig', enabled: boolean, url: string, username?: string | null, token?: string | null, yaraFileRegex: string, defaultSeverity: number } | null, rules: { __typename: 'YaraRulePage', total: number } }> } };

export type YaraSourceFragment = { __typename: 'YaraSource', id: string, name: string, description?: string | null, sourceType: YaraSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, issues: Array<string>, githubConfig?: { __typename: 'YaraGithubConfig', enabled: boolean, url: string, username?: string | null, token?: string | null, yaraFileRegex: string, defaultSeverity: number } | null, rules: { __typename: 'YaraRulePage', total: number } };

export type YaraRuleFragment = { __typename: 'YaraRule', enabled: boolean, name: string, id: string, description: string, expression: string, severity: number, ruleSource: string };

export type DeleteYaraRuleOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteYaraRuleOperationMutation = { __typename: 'Mutation', deleteCustomYaraRule?: { __typename: 'DeleteCustomYaraRule', ok: boolean } | null };

export type DeleteCustomMatchListColumnOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCustomMatchListColumnOperationMutation = { __typename: 'Mutation', deleteCustomMatchListColumn?: { __typename: 'DeleteCustomMatchListColumn', ok: boolean } | null };

export type CreateCustomMatchListColumnOperationMutationVariables = Exact<{
  fields: CustomMatchListColumnFields;
}>;


export type CreateCustomMatchListColumnOperationMutation = { __typename: 'Mutation', createCustomMatchListColumn?: { __typename: 'CreateCustomMatchListColumn', data: { __typename: 'CustomMatchListColumn', id: string, name: string, fields: Array<string> } } | null };

export type UpdateCustomMatchListColumnOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: CustomMatchListColumnFields;
}>;


export type UpdateCustomMatchListColumnOperationMutation = { __typename: 'Mutation', updateCustomMatchListColumn?: { __typename: 'UpdateCustomMatchListColumn', data: { __typename: 'CustomMatchListColumn', id: string, name: string, fields: Array<string> } } | null };

export type UploadItemsToListOperationMutationVariables = Exact<{
  listId: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
  file: Scalars['Upload']['input'];
}>;


export type UploadItemsToListOperationMutation = { __typename: 'Mutation', uploadItemsToList?: { __typename: 'UploadItemsToList', uploadedItemCount: number } | null };

export type MatchListFragment = { __typename: 'MatchList', id: string, name: string, description?: string | null, defaultTtl?: number | null, targetColumn: string, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, items: { __typename: 'MatchListItemPage', total: number } };

export type MatchListItemFragment = { __typename: 'MatchListItem', id: string, value: string, active: boolean, expiration?: any | null, meta?: { __typename: 'ItemMeta', description: string } | null };

export type MatchListsOperationQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sort: Scalars['String']['input'];
  sortDir: SortDir;
}>;


export type MatchListsOperationQuery = { __typename: 'Query', matchListItemLimit: number, matchListItemCount: number, matchLists: { __typename: 'MatchListPage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'MatchList', id: string, name: string, description?: string | null, defaultTtl?: number | null, targetColumn: string, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, items: { __typename: 'MatchListItemPage', total: number } }> } };

export type DeleteMatchListOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMatchListOperationMutation = { __typename: 'Mutation', deleteMatchList?: { __typename: 'DeleteMatchList', ok: boolean } | null };

export type CreateMatchListOperationMutationVariables = Exact<{
  fields: MatchListFields;
}>;


export type CreateMatchListOperationMutation = { __typename: 'Mutation', createMatchList?: { __typename: 'CreateMatchList', data: { __typename: 'MatchList', id: string, name: string, description?: string | null, defaultTtl?: number | null, targetColumn: string, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, items: { __typename: 'MatchListItemPage', total: number } } } | null };

export type UpdateMatchListOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: UpdatableMatchListFields;
}>;


export type UpdateMatchListOperationMutation = { __typename: 'Mutation', updateMatchList?: { __typename: 'UpdateMatchList', data: { __typename: 'MatchList', id: string, name: string, description?: string | null, defaultTtl?: number | null, targetColumn: string, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, items: { __typename: 'MatchListItemPage', total: number } } } | null };

export type AddMatchListItemOperationMutationVariables = Exact<{
  itemFields: MatchListItemFields;
  listId: Scalars['ID']['input'];
}>;


export type AddMatchListItemOperationMutation = { __typename: 'Mutation', addItemToMatchList?: { __typename: 'AddItemToMatchList', finishedProcessing: boolean, data: { __typename: 'MatchListItem', id: string, value: string, active: boolean, expiration?: any | null, meta?: { __typename: 'ItemMeta', description: string } | null } } | null };

export type UpdateMatchListItemOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: UpdatableMatchListItemFields;
}>;


export type UpdateMatchListItemOperationMutation = { __typename: 'Mutation', updateMatchListItem?: { __typename: 'UpdateMatchListItem', finishedProcessing: boolean, data: { __typename: 'MatchListItem', id: string, value: string, active: boolean, expiration?: any | null, meta?: { __typename: 'ItemMeta', description: string } | null } } | null };

export type DeleteMatchListItemOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMatchListItemOperationMutation = { __typename: 'Mutation', deleteMatchListItem?: { __typename: 'DeleteMatchListItem', ok: boolean } | null };

export type MatchListItemsOperationQueryVariables = Exact<{
  listIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort: MatchListItemSortableField;
  sortDir: SortDir;
  q: Scalars['String']['input'];
}>;


export type MatchListItemsOperationQuery = { __typename: 'Query', matchListItems: { __typename: 'MatchListItemPage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'MatchListItem', id: string, value: string, active: boolean, expiration?: any | null, meta?: { __typename: 'ItemMeta', description: string } | null }> } };

export type MatchListDetailOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MatchListDetailOperationQuery = { __typename: 'Query', matchList: { __typename: 'MatchList', id: string, name: string, description?: string | null, defaultTtl?: number | null, targetColumn: string, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, items: { __typename: 'MatchListItemPage', total: number } } };

export type MatchListSelectFragment = { __typename: 'MatchList', id: string, name: string };

export type MatchListsSelectOperationQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort: Scalars['String']['input'];
  sortDir: SortDir;
}>;


export type MatchListsSelectOperationQuery = { __typename: 'Query', matchLists: { __typename: 'MatchListPage', total: number, objects: Array<{ __typename: 'MatchList', id: string, name: string }> } };

export type NetworkBlockFragment = { __typename: 'NetworkBlock', id: string, addressBlock: string, label: string, internal: boolean, suppressesSignals: boolean, created?: any | null };

export type NetworkBlocksOperationQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sort: NetworkBlockSortableField;
  sortDir: SortDir;
  q?: InputMaybe<Scalars['String']['input']>;
}>;


export type NetworkBlocksOperationQuery = { __typename: 'Query', networkBlocks: { __typename: 'NetworkBlockPage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'NetworkBlock', id: string, addressBlock: string, label: string, internal: boolean, suppressesSignals: boolean, created?: any | null }> } };

export type CreateNetworkBlockOperationMutationVariables = Exact<{
  fields: NetworkBlockFields;
}>;


export type CreateNetworkBlockOperationMutation = { __typename: 'Mutation', createNetworkBlock?: { __typename: 'CreateNetworkBlock', data: { __typename: 'NetworkBlock', id: string, addressBlock: string, label: string, internal: boolean, suppressesSignals: boolean, created?: any | null } } | null };

export type UpdateNetworkBlockOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: UpdatableNetworkBlockFields;
}>;


export type UpdateNetworkBlockOperationMutation = { __typename: 'Mutation', updateNetworkBlock?: { __typename: 'UpdateNetworkBlock', data: { __typename: 'NetworkBlock', id: string, addressBlock: string, label: string, internal: boolean, suppressesSignals: boolean, created?: any | null } } | null };

export type DeleteNetworkBlockOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteNetworkBlockOperationMutation = { __typename: 'Mutation', deleteNetworkBlock?: { __typename: 'DeleteNetworkBlock', ok: boolean } | null };

export type UploadNetworkBlocksOperationMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadNetworkBlocksOperationMutation = { __typename: 'Mutation', uploadNetworkBlocksCsv?: { __typename: 'UploadNetworkBlocksCsv', uploadedNetworkBlockCount: number } | null };

export type RuleTuningExpressionFragment = { __typename: 'RuleTuningExpression', id: string, name: string, description: string, expression: string, enabled: boolean, isGlobal: boolean, exclude: boolean, created: any, lastUpdated: any, rules?: Array<{ __typename: 'AggregationRule', id: string } | { __typename: 'ChainRule', id: string } | { __typename: 'FirstSeenRule', id: string } | { __typename: 'MatchRule', id: string } | { __typename: 'OutlierRule', id: string } | { __typename: 'TemplatedMatchRule', id: string } | { __typename: 'ThresholdRule', id: string }> | null, lastUpdatedByUser?: { __typename: 'User', id: string, email?: string | null, name?: string | null } | null };

export type RuleTuningExpressionsQueryOperationQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort: RuleTuningExpressionSortableField;
  sortDir: SortDir;
}>;


export type RuleTuningExpressionsQueryOperationQuery = { __typename: 'Query', ruleTuningExpressions: { __typename: 'RuleTuningExpressionPage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'RuleTuningExpression', id: string, name: string, description: string, expression: string, enabled: boolean, isGlobal: boolean, exclude: boolean, created: any, lastUpdated: any, rules?: Array<{ __typename: 'AggregationRule', id: string } | { __typename: 'ChainRule', id: string } | { __typename: 'FirstSeenRule', id: string } | { __typename: 'MatchRule', id: string } | { __typename: 'OutlierRule', id: string } | { __typename: 'TemplatedMatchRule', id: string } | { __typename: 'ThresholdRule', id: string }> | null, lastUpdatedByUser?: { __typename: 'User', id: string, email?: string | null, name?: string | null } | null }> } };

export type RuleTuningExpressionQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RuleTuningExpressionQueryOperationQuery = { __typename: 'Query', ruleTuningExpression: { __typename: 'RuleTuningExpression', id: string, name: string, description: string, expression: string, enabled: boolean, isGlobal: boolean, exclude: boolean, created: any, lastUpdated: any, rules?: Array<{ __typename: 'AggregationRule', id: string } | { __typename: 'ChainRule', id: string } | { __typename: 'FirstSeenRule', id: string } | { __typename: 'MatchRule', id: string } | { __typename: 'OutlierRule', id: string } | { __typename: 'TemplatedMatchRule', id: string } | { __typename: 'ThresholdRule', id: string }> | null, lastUpdatedByUser?: { __typename: 'User', id: string, email?: string | null, name?: string | null } | null } };

export type CreateRuleTuningExpressionOperationMutationVariables = Exact<{
  fields: CreateRuleTuningExpressionFields;
}>;


export type CreateRuleTuningExpressionOperationMutation = { __typename: 'Mutation', createRuleTuningExpression?: { __typename: 'CreateRuleTuningExpression', data: { __typename: 'RuleTuningExpression', id: string, name: string, description: string, expression: string, enabled: boolean, isGlobal: boolean, exclude: boolean, created: any, lastUpdated: any, rules?: Array<{ __typename: 'AggregationRule', id: string } | { __typename: 'ChainRule', id: string } | { __typename: 'FirstSeenRule', id: string } | { __typename: 'MatchRule', id: string } | { __typename: 'OutlierRule', id: string } | { __typename: 'TemplatedMatchRule', id: string } | { __typename: 'ThresholdRule', id: string }> | null, lastUpdatedByUser?: { __typename: 'User', id: string, email?: string | null, name?: string | null } | null } } | null };

export type UpdateRuleTuningExpressionOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: UpdateRuleTuningExpressionFields;
}>;


export type UpdateRuleTuningExpressionOperationMutation = { __typename: 'Mutation', updateRuleTuningExpression?: { __typename: 'UpdateRuleTuningExpression', data: { __typename: 'RuleTuningExpression', id: string, name: string, description: string, expression: string, enabled: boolean, isGlobal: boolean, exclude: boolean, created: any, lastUpdated: any, rules?: Array<{ __typename: 'AggregationRule', id: string } | { __typename: 'ChainRule', id: string } | { __typename: 'FirstSeenRule', id: string } | { __typename: 'MatchRule', id: string } | { __typename: 'OutlierRule', id: string } | { __typename: 'TemplatedMatchRule', id: string } | { __typename: 'ThresholdRule', id: string }> | null, lastUpdatedByUser?: { __typename: 'User', id: string, email?: string | null, name?: string | null } | null } } | null };

export type UpdateRuleTuningExpressionEnabledOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type UpdateRuleTuningExpressionEnabledOperationMutation = { __typename: 'Mutation', updateRuleTuningExpressionEnabled?: { __typename: 'UpdateRuleTuningExpressionEnabled', ok: boolean } | null };

export type DeleteRuleTuningExpressionOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRuleTuningExpressionOperationMutation = { __typename: 'Mutation', deleteRuleTuningExpression?: { __typename: 'DeleteRuleTuningExpression', ok: boolean } | null };

export type DeleteRuleOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRuleOperationMutation = { __typename: 'Mutation', deleteRule?: { __typename: 'DeleteRule', ok: boolean } | null };

export type RuleTranslationOperationQueryVariables = Exact<{
  ruleExpression: Scalars['String']['input'];
  ruleTuningTranslationExpressions: Array<RuleTuningExpressionTranslationFields> | RuleTuningExpressionTranslationFields;
}>;


export type RuleTranslationOperationQuery = { __typename: 'Query', ruleTranslation: string };

export type RuleRecordSchemaOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type RuleRecordSchemaOperationQuery = { __typename: 'Query', recordSchema: string };

type RuleExportFragment_AggregationRule = { __typename: 'AggregationRule', exportJson: string };

type RuleExportFragment_ChainRule = { __typename: 'ChainRule', exportJson: string };

type RuleExportFragment_FirstSeenRule = { __typename: 'FirstSeenRule', exportJson: string };

type RuleExportFragment_MatchRule = { __typename: 'MatchRule', exportJson: string };

type RuleExportFragment_OutlierRule = { __typename: 'OutlierRule', exportJson: string };

type RuleExportFragment_TemplatedMatchRule = { __typename: 'TemplatedMatchRule', exportJson: string };

type RuleExportFragment_ThresholdRule = { __typename: 'ThresholdRule', exportJson: string };

export type RuleExportFragment = RuleExportFragment_AggregationRule | RuleExportFragment_ChainRule | RuleExportFragment_FirstSeenRule | RuleExportFragment_MatchRule | RuleExportFragment_OutlierRule | RuleExportFragment_TemplatedMatchRule | RuleExportFragment_ThresholdRule;

export type RuleExportOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RuleExportOperationQuery = { __typename: 'Query', rule: { __typename: 'AggregationRule', exportJson: string } | { __typename: 'ChainRule', exportJson: string } | { __typename: 'FirstSeenRule', exportJson: string } | { __typename: 'MatchRule', exportJson: string } | { __typename: 'OutlierRule', exportJson: string } | { __typename: 'TemplatedMatchRule', exportJson: string } | { __typename: 'ThresholdRule', exportJson: string } };

export type ImportRulesMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type ImportRulesMutation = { __typename: 'Mutation', importRules?: { __typename: 'ImportRules', successCount: number, failures: Array<{ __typename: 'ImportRuleFailure', ruleName: string }> } | null };

export type AggregationRuleFunctionsOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type AggregationRuleFunctionsOperationQuery = { __typename: 'Query', aggregationRuleFunctions: Array<{ __typename: 'AggregationRuleFunction', name: string, description: string, parameters: Array<{ __typename: 'AggregationRuleFunctionParameter', name: string, description: string }> }> };

export type RuleBuilderQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RuleBuilderQueryOperationQuery = { __typename: 'Query', rule: { __typename: 'AggregationRule', suppressionWindowSize?: number | null, descriptionExpression: string, groupByAsset: boolean, groupByFields: Array<string>, matchExpression: string, nameExpression: string, triggerExpression: string, created: any, isPrototype: boolean, id: string, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, hasOverride: boolean, windowSizeMilliseconds: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, aggregationFunctions: Array<{ __typename: 'AggregationRuleAggregationFunction', name: string, function: string, arguments: Array<string> }>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null }, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreMappingOverride?: { __typename: 'RuleScoreMappingRuleOverride', original?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null, override?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null } | { __typename: 'ChainRule', suppressionWindowSize?: number | null, description: string, score: number, created: any, groupByFields: Array<string>, isPrototype: boolean, id: string, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, ordered: boolean, summaryExpression: string, tags: Array<string>, windowSizeMilliseconds: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, expressionsAndLimits: Array<{ __typename: 'ChainRuleExpressionAndLimit', index: number, expression: string, limit: number }>, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, expressionsAndLimitsOverride?: { __typename: 'ExpressionAndLimitsRuleOverride', original?: Array<{ __typename: 'ChainRuleExpressionAndLimit', expression: string, limit: number, index: number }> | null, override?: Array<{ __typename: 'ChainRuleExpressionAndLimit', expression: string, limit: number, index: number }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null } | { __typename: 'FirstSeenRule', suppressionWindowSize?: number | null, baselineType: FirstSeenRuleBaselineType, baselineStatus: BaselineStatus, baselineWindowSize: any, baselineLastStarted?: any | null, created: any, descriptionExpression: string, enabled: boolean, filterExpression: string, groupByFields: Array<string>, id: string, isPrototype: boolean, lastUpdated: any, name: string, nameExpression: string, retentionWindowSize: any, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, score: number, summaryExpression: string, tags: Array<string>, valueExpression?: string | null, valueFields?: Array<string> | null, version: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, baselineWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, retentionWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, exclude: boolean, id: string, isGlobal: boolean, name: string }> | null } | { __typename: 'MatchRule', description: string, expression: string, score: number, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null } | { __typename: 'OutlierRule', baselineWindowSize: any, baselineLastStarted?: any | null, baselineStatus: BaselineStatus, descriptionExpression: string, deviationThreshold: number, floorValue: number, groupByFields: Array<string>, matchExpression: string, nameExpression: string, retentionWindowSize: any, score: number, windowSize: number, windowSizeName: string, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, aggregationFunctions: Array<{ __typename: 'OutlierRuleAggregationFunction', name: string, function: string, arguments: Array<string> }>, baselineWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, deviationThresholdOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', entityType: string, expression: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', entityType: string, expression: string }> | null } | null, floorValueOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, retentionWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null } | { __typename: 'TemplatedMatchRule', expression: string, descriptionExpression: string, nameExpression: string, hasOverride: boolean, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null }, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreMappingOverride?: { __typename: 'RuleScoreMappingRuleOverride', original?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null, override?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null } | { __typename: 'ThresholdRule', countDistinct: boolean, countField?: string | null, description: string, expression: string, groupByFields: Array<string>, limit: number, score: number, version: number, hasOverride: boolean, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, windowSizeMilliseconds: number, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, limitOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null } };

export type UpdateBuiltInRuleOperationMutationVariables = Exact<{
  fields: UpdateBuiltInRuleFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateBuiltInRuleOperationMutation = { __typename: 'Mutation', updateBuiltInRule?: { __typename: 'UpdateBuiltInRule', ok: boolean } | null };

export type OverrideBuiltInTemplatedMatchRuleOperationMutationVariables = Exact<{
  fields: OverrideTemplatedMatchRuleFields;
  id: Scalars['ID']['input'];
}>;


export type OverrideBuiltInTemplatedMatchRuleOperationMutation = { __typename: 'Mutation', overrideTemplatedMatchRule?: { __typename: 'OverrideTemplatedMatchRule', data: { __typename: 'TemplatedMatchRule', expression: string, descriptionExpression: string, nameExpression: string, hasOverride: boolean, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null }, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreMappingOverride?: { __typename: 'RuleScoreMappingRuleOverride', original?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null, override?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null } } | null };

export type OverrideBuiltInThresholdRuleOperationMutationVariables = Exact<{
  fields: OverrideThresholdRuleFields;
  id: Scalars['ID']['input'];
}>;


export type OverrideBuiltInThresholdRuleOperationMutation = { __typename: 'Mutation', overrideThresholdRule?: { __typename: 'OverrideThresholdRule', data: { __typename: 'ThresholdRule', countDistinct: boolean, countField?: string | null, description: string, expression: string, groupByFields: Array<string>, limit: number, score: number, version: number, hasOverride: boolean, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, windowSizeMilliseconds: number, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, limitOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null } } | null };

export type OverrideBuiltInAggregationRuleOperationMutationVariables = Exact<{
  fields: OverrideAggregationRuleFields;
  id: Scalars['ID']['input'];
}>;


export type OverrideBuiltInAggregationRuleOperationMutation = { __typename: 'Mutation', overrideAggregationRule?: { __typename: 'OverrideAggregationRule', data: { __typename: 'AggregationRule', suppressionWindowSize?: number | null, descriptionExpression: string, groupByAsset: boolean, groupByFields: Array<string>, matchExpression: string, nameExpression: string, triggerExpression: string, created: any, isPrototype: boolean, id: string, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, hasOverride: boolean, windowSizeMilliseconds: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, aggregationFunctions: Array<{ __typename: 'AggregationRuleAggregationFunction', name: string, function: string, arguments: Array<string> }>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null }, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreMappingOverride?: { __typename: 'RuleScoreMappingRuleOverride', original?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null, override?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null } } | null };

export type OverrideBuiltInChainRuleOperationMutationVariables = Exact<{
  fields: OverrideChainRuleFields;
  id: Scalars['ID']['input'];
}>;


export type OverrideBuiltInChainRuleOperationMutation = { __typename: 'Mutation', overrideChainRule?: { __typename: 'OverrideChainRule', data: { __typename: 'ChainRule', suppressionWindowSize?: number | null, description: string, score: number, created: any, groupByFields: Array<string>, isPrototype: boolean, id: string, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, ordered: boolean, summaryExpression: string, tags: Array<string>, windowSizeMilliseconds: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, expressionsAndLimits: Array<{ __typename: 'ChainRuleExpressionAndLimit', index: number, expression: string, limit: number }>, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, expressionsAndLimitsOverride?: { __typename: 'ExpressionAndLimitsRuleOverride', original?: Array<{ __typename: 'ChainRuleExpressionAndLimit', expression: string, limit: number, index: number }> | null, override?: Array<{ __typename: 'ChainRuleExpressionAndLimit', expression: string, limit: number, index: number }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null } } | null };

export type OverrideBuiltInFirstSeenRuleOperationMutationVariables = Exact<{
  fields: OverrideFirstSeenRuleFields;
  id: Scalars['ID']['input'];
}>;


export type OverrideBuiltInFirstSeenRuleOperationMutation = { __typename: 'Mutation', overrideFirstSeenRule?: { __typename: 'OverrideFirstSeenRule', data: { __typename: 'FirstSeenRule', suppressionWindowSize?: number | null, baselineType: FirstSeenRuleBaselineType, baselineStatus: BaselineStatus, baselineWindowSize: any, baselineLastStarted?: any | null, created: any, descriptionExpression: string, enabled: boolean, filterExpression: string, groupByFields: Array<string>, id: string, isPrototype: boolean, lastUpdated: any, name: string, nameExpression: string, retentionWindowSize: any, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, score: number, summaryExpression: string, tags: Array<string>, valueExpression?: string | null, valueFields?: Array<string> | null, version: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, baselineWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, retentionWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, exclude: boolean, id: string, isGlobal: boolean, name: string }> | null } } | null };

export type OverrideBuiltInOutlierRuleOperationMutationVariables = Exact<{
  fields: OverrideOutlierRuleFields;
  id: Scalars['ID']['input'];
}>;


export type OverrideBuiltInOutlierRuleOperationMutation = { __typename: 'Mutation', overrideOutlierRule?: { __typename: 'OverrideOutlierRule', data: { __typename: 'OutlierRule', baselineWindowSize: any, baselineLastStarted?: any | null, baselineStatus: BaselineStatus, descriptionExpression: string, deviationThreshold: number, floorValue: number, groupByFields: Array<string>, matchExpression: string, nameExpression: string, retentionWindowSize: any, score: number, windowSize: number, windowSizeName: string, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, aggregationFunctions: Array<{ __typename: 'OutlierRuleAggregationFunction', name: string, function: string, arguments: Array<string> }>, baselineWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, deviationThresholdOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', entityType: string, expression: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', entityType: string, expression: string }> | null } | null, floorValueOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, retentionWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null } } | null };

export type RuleSignalCountOperationQueryVariables = Exact<{
  bucketDuration: Scalars['TimeDelta']['input'];
  end?: InputMaybe<Scalars['DateTime']['input']>;
  ruleId: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type RuleSignalCountOperationQuery = { __typename: 'Query', signalCounts: Array<{ __typename: 'BigIntDataPoint', timestamp: any, value: any }> };

export type RuleBuilderLastSignalQueryOperationQueryVariables = Exact<{
  q: Scalars['String']['input'];
}>;


export type RuleBuilderLastSignalQueryOperationQuery = { __typename: 'Query', signals: { __typename: 'SignalPage', objects: Array<{ __typename: 'Signal', id: string, timestamp: any }> } };

type CommonRuleBuilderFields_AggregationRule_Fragment = { __typename: 'AggregationRule', suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null };

type CommonRuleBuilderFields_ChainRule_Fragment = { __typename: 'ChainRule', suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null };

type CommonRuleBuilderFields_FirstSeenRule_Fragment = { __typename: 'FirstSeenRule', suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null };

type CommonRuleBuilderFields_MatchRule_Fragment = { __typename: 'MatchRule', suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null };

type CommonRuleBuilderFields_OutlierRule_Fragment = { __typename: 'OutlierRule', suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null };

type CommonRuleBuilderFields_TemplatedMatchRule_Fragment = { __typename: 'TemplatedMatchRule', suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null };

type CommonRuleBuilderFields_ThresholdRule_Fragment = { __typename: 'ThresholdRule', suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null };

export type CommonRuleBuilderFieldsFragment = CommonRuleBuilderFields_AggregationRule_Fragment | CommonRuleBuilderFields_ChainRule_Fragment | CommonRuleBuilderFields_FirstSeenRule_Fragment | CommonRuleBuilderFields_MatchRule_Fragment | CommonRuleBuilderFields_OutlierRule_Fragment | CommonRuleBuilderFields_TemplatedMatchRule_Fragment | CommonRuleBuilderFields_ThresholdRule_Fragment;

export type ThresholdRuleBuilderFieldsFragment = { __typename: 'ThresholdRule', countDistinct: boolean, countField?: string | null, description: string, expression: string, groupByFields: Array<string>, limit: number, score: number, version: number, hasOverride: boolean, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, windowSizeMilliseconds: number, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, limitOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null };

export type MatchRuleBuilderFieldsFragment = { __typename: 'MatchRule', description: string, expression: string, score: number, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null };

export type ChainRuleBuilderFieldsFragment = { __typename: 'ChainRule', suppressionWindowSize?: number | null, description: string, score: number, created: any, groupByFields: Array<string>, isPrototype: boolean, id: string, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, ordered: boolean, summaryExpression: string, tags: Array<string>, windowSizeMilliseconds: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, expressionsAndLimits: Array<{ __typename: 'ChainRuleExpressionAndLimit', index: number, expression: string, limit: number }>, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, expressionsAndLimitsOverride?: { __typename: 'ExpressionAndLimitsRuleOverride', original?: Array<{ __typename: 'ChainRuleExpressionAndLimit', expression: string, limit: number, index: number }> | null, override?: Array<{ __typename: 'ChainRuleExpressionAndLimit', expression: string, limit: number, index: number }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null };

export type RuleBuilderScoreMappingFieldsFragment = { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null };

export type TemplatedMatchRuleBuilderFieldsFragment = { __typename: 'TemplatedMatchRule', expression: string, descriptionExpression: string, nameExpression: string, hasOverride: boolean, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null }, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreMappingOverride?: { __typename: 'RuleScoreMappingRuleOverride', original?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null, override?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null };

export type AggregationRuleBuilderFieldsFragment = { __typename: 'AggregationRule', suppressionWindowSize?: number | null, descriptionExpression: string, groupByAsset: boolean, groupByFields: Array<string>, matchExpression: string, nameExpression: string, triggerExpression: string, created: any, isPrototype: boolean, id: string, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, hasOverride: boolean, windowSizeMilliseconds: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, aggregationFunctions: Array<{ __typename: 'AggregationRuleAggregationFunction', name: string, function: string, arguments: Array<string> }>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null }, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreMappingOverride?: { __typename: 'RuleScoreMappingRuleOverride', original?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null, override?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null };

export type FirstSeenRuleBuilderFieldsFragment = { __typename: 'FirstSeenRule', suppressionWindowSize?: number | null, baselineType: FirstSeenRuleBaselineType, baselineStatus: BaselineStatus, baselineWindowSize: any, baselineLastStarted?: any | null, created: any, descriptionExpression: string, enabled: boolean, filterExpression: string, groupByFields: Array<string>, id: string, isPrototype: boolean, lastUpdated: any, name: string, nameExpression: string, retentionWindowSize: any, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, score: number, summaryExpression: string, tags: Array<string>, valueExpression?: string | null, valueFields?: Array<string> | null, version: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, baselineWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, retentionWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, exclude: boolean, id: string, isGlobal: boolean, name: string }> | null };

export type OutlierRuleBuilderFieldsFragment = { __typename: 'OutlierRule', baselineWindowSize: any, baselineLastStarted?: any | null, baselineStatus: BaselineStatus, descriptionExpression: string, deviationThreshold: number, floorValue: number, groupByFields: Array<string>, matchExpression: string, nameExpression: string, retentionWindowSize: any, score: number, windowSize: number, windowSizeName: string, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, aggregationFunctions: Array<{ __typename: 'OutlierRuleAggregationFunction', name: string, function: string, arguments: Array<string> }>, baselineWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, deviationThresholdOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', entityType: string, expression: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', entityType: string, expression: string }> | null } | null, floorValueOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, retentionWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null };

type RuleBuilderFragment_AggregationRule = { __typename: 'AggregationRule', suppressionWindowSize?: number | null, descriptionExpression: string, groupByAsset: boolean, groupByFields: Array<string>, matchExpression: string, nameExpression: string, triggerExpression: string, created: any, isPrototype: boolean, id: string, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, hasOverride: boolean, windowSizeMilliseconds: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, aggregationFunctions: Array<{ __typename: 'AggregationRuleAggregationFunction', name: string, function: string, arguments: Array<string> }>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null }, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreMappingOverride?: { __typename: 'RuleScoreMappingRuleOverride', original?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null, override?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null };

type RuleBuilderFragment_ChainRule = { __typename: 'ChainRule', suppressionWindowSize?: number | null, description: string, score: number, created: any, groupByFields: Array<string>, isPrototype: boolean, id: string, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, ordered: boolean, summaryExpression: string, tags: Array<string>, windowSizeMilliseconds: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, expressionsAndLimits: Array<{ __typename: 'ChainRuleExpressionAndLimit', index: number, expression: string, limit: number }>, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, expressionsAndLimitsOverride?: { __typename: 'ExpressionAndLimitsRuleOverride', original?: Array<{ __typename: 'ChainRuleExpressionAndLimit', expression: string, limit: number, index: number }> | null, override?: Array<{ __typename: 'ChainRuleExpressionAndLimit', expression: string, limit: number, index: number }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null };

type RuleBuilderFragment_FirstSeenRule = { __typename: 'FirstSeenRule', suppressionWindowSize?: number | null, baselineType: FirstSeenRuleBaselineType, baselineStatus: BaselineStatus, baselineWindowSize: any, baselineLastStarted?: any | null, created: any, descriptionExpression: string, enabled: boolean, filterExpression: string, groupByFields: Array<string>, id: string, isPrototype: boolean, lastUpdated: any, name: string, nameExpression: string, retentionWindowSize: any, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, score: number, summaryExpression: string, tags: Array<string>, valueExpression?: string | null, valueFields?: Array<string> | null, version: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, baselineWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, retentionWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, exclude: boolean, id: string, isGlobal: boolean, name: string }> | null };

type RuleBuilderFragment_MatchRule = { __typename: 'MatchRule', description: string, expression: string, score: number, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null };

type RuleBuilderFragment_OutlierRule = { __typename: 'OutlierRule', baselineWindowSize: any, baselineLastStarted?: any | null, baselineStatus: BaselineStatus, descriptionExpression: string, deviationThreshold: number, floorValue: number, groupByFields: Array<string>, matchExpression: string, nameExpression: string, retentionWindowSize: any, score: number, windowSize: number, windowSizeName: string, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, aggregationFunctions: Array<{ __typename: 'OutlierRuleAggregationFunction', name: string, function: string, arguments: Array<string> }>, baselineWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, deviationThresholdOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', entityType: string, expression: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', entityType: string, expression: string }> | null } | null, floorValueOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, retentionWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null };

type RuleBuilderFragment_TemplatedMatchRule = { __typename: 'TemplatedMatchRule', expression: string, descriptionExpression: string, nameExpression: string, hasOverride: boolean, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null }, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreMappingOverride?: { __typename: 'RuleScoreMappingRuleOverride', original?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null, override?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null };

type RuleBuilderFragment_ThresholdRule = { __typename: 'ThresholdRule', countDistinct: boolean, countField?: string | null, description: string, expression: string, groupByFields: Array<string>, limit: number, score: number, version: number, hasOverride: boolean, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, windowSizeMilliseconds: number, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, limitOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null };

export type RuleBuilderFragment = RuleBuilderFragment_AggregationRule | RuleBuilderFragment_ChainRule | RuleBuilderFragment_FirstSeenRule | RuleBuilderFragment_MatchRule | RuleBuilderFragment_OutlierRule | RuleBuilderFragment_TemplatedMatchRule | RuleBuilderFragment_ThresholdRule;

export type RuleValidationResultFragment = { __typename: 'RuleValidationResult', isValid: boolean, errorMessage: string };

export type MatchRuleValidationResultOperationQueryVariables = Exact<{
  ruleFields: MatchRuleFields;
}>;


export type MatchRuleValidationResultOperationQuery = { __typename: 'Query', matchRuleValidationResult: { __typename: 'RuleValidationResult', isValid: boolean, errorMessage: string } };

export type ThresholdRuleValidationResultOperationQueryVariables = Exact<{
  ruleFields: ThresholdRuleFields;
}>;


export type ThresholdRuleValidationResultOperationQuery = { __typename: 'Query', thresholdRuleValidationResult: { __typename: 'RuleValidationResult', isValid: boolean, errorMessage: string } };

export type ChainRuleValidationResultOperationQueryVariables = Exact<{
  ruleFields: ChainRuleFields;
}>;


export type ChainRuleValidationResultOperationQuery = { __typename: 'Query', chainRuleValidationResult: { __typename: 'RuleValidationResult', isValid: boolean, errorMessage: string } };

export type AggregationRuleValidationResultOperationQueryVariables = Exact<{
  ruleFields: AggregationRuleFields;
}>;


export type AggregationRuleValidationResultOperationQuery = { __typename: 'Query', aggregationRuleValidationResult: { __typename: 'RuleValidationResult', isValid: boolean, errorMessage: string } };

export type TemplatedMatchRuleValidationResultOperationQueryVariables = Exact<{
  ruleFields: TemplatedMatchRuleFields;
}>;


export type TemplatedMatchRuleValidationResultOperationQuery = { __typename: 'Query', templatedMatchRuleValidationResult: { __typename: 'RuleValidationResult', isValid: boolean, errorMessage: string } };

export type CreateThresholdRuleBuilderOperationMutationVariables = Exact<{
  fields: CreateThresholdRuleFields;
}>;


export type CreateThresholdRuleBuilderOperationMutation = { __typename: 'Mutation', createThresholdRule?: { __typename: 'CreateThresholdRule', data: { __typename: 'ThresholdRule', countDistinct: boolean, countField?: string | null, description: string, expression: string, groupByFields: Array<string>, limit: number, score: number, version: number, hasOverride: boolean, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, windowSizeMilliseconds: number, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, limitOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null } } | null };

export type UpdateThresholdRuleBuilderOperationMutationVariables = Exact<{
  fields: UpdateThresholdRuleFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateThresholdRuleBuilderOperationMutation = { __typename: 'Mutation', updateThresholdRule?: { __typename: 'UpdateThresholdRule', data: { __typename: 'ThresholdRule', countDistinct: boolean, countField?: string | null, description: string, expression: string, groupByFields: Array<string>, limit: number, score: number, version: number, hasOverride: boolean, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, windowSizeMilliseconds: number, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, limitOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null } } | null };

export type CreateAggregationRuleBuilderOperationMutationVariables = Exact<{
  fields: CreateAggregationRuleFields;
}>;


export type CreateAggregationRuleBuilderOperationMutation = { __typename: 'Mutation', createAggregationRule?: { __typename: 'CreateAggregationRule', data: { __typename: 'AggregationRule', suppressionWindowSize?: number | null, descriptionExpression: string, groupByAsset: boolean, groupByFields: Array<string>, matchExpression: string, nameExpression: string, triggerExpression: string, created: any, isPrototype: boolean, id: string, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, hasOverride: boolean, windowSizeMilliseconds: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, aggregationFunctions: Array<{ __typename: 'AggregationRuleAggregationFunction', name: string, function: string, arguments: Array<string> }>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null }, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreMappingOverride?: { __typename: 'RuleScoreMappingRuleOverride', original?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null, override?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null } } | null };

export type UpdateAggregationRuleBuilderOperationMutationVariables = Exact<{
  fields: UpdateAggregationRuleFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateAggregationRuleBuilderOperationMutation = { __typename: 'Mutation', updateAggregationRule?: { __typename: 'UpdateAggregationRule', data: { __typename: 'AggregationRule', suppressionWindowSize?: number | null, descriptionExpression: string, groupByAsset: boolean, groupByFields: Array<string>, matchExpression: string, nameExpression: string, triggerExpression: string, created: any, isPrototype: boolean, id: string, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, hasOverride: boolean, windowSizeMilliseconds: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, aggregationFunctions: Array<{ __typename: 'AggregationRuleAggregationFunction', name: string, function: string, arguments: Array<string> }>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null }, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreMappingOverride?: { __typename: 'RuleScoreMappingRuleOverride', original?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null, override?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null } } | null };

export type CreateChainRuleBuilderOperationMutationVariables = Exact<{
  fields: CreateChainRuleFields;
}>;


export type CreateChainRuleBuilderOperationMutation = { __typename: 'Mutation', createChainRule?: { __typename: 'CreateChainRule', data: { __typename: 'ChainRule', suppressionWindowSize?: number | null, description: string, score: number, created: any, groupByFields: Array<string>, isPrototype: boolean, id: string, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, ordered: boolean, summaryExpression: string, tags: Array<string>, windowSizeMilliseconds: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, expressionsAndLimits: Array<{ __typename: 'ChainRuleExpressionAndLimit', index: number, expression: string, limit: number }>, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, expressionsAndLimitsOverride?: { __typename: 'ExpressionAndLimitsRuleOverride', original?: Array<{ __typename: 'ChainRuleExpressionAndLimit', expression: string, limit: number, index: number }> | null, override?: Array<{ __typename: 'ChainRuleExpressionAndLimit', expression: string, limit: number, index: number }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null } } | null };

export type UpdateChainRuleBuilderOperationMutationVariables = Exact<{
  fields: UpdateChainRuleFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateChainRuleBuilderOperationMutation = { __typename: 'Mutation', updateChainRule?: { __typename: 'UpdateChainRule', data: { __typename: 'ChainRule', suppressionWindowSize?: number | null, description: string, score: number, created: any, groupByFields: Array<string>, isPrototype: boolean, id: string, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, ordered: boolean, summaryExpression: string, tags: Array<string>, windowSizeMilliseconds: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, expressionsAndLimits: Array<{ __typename: 'ChainRuleExpressionAndLimit', index: number, expression: string, limit: number }>, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, expressionsAndLimitsOverride?: { __typename: 'ExpressionAndLimitsRuleOverride', original?: Array<{ __typename: 'ChainRuleExpressionAndLimit', expression: string, limit: number, index: number }> | null, override?: Array<{ __typename: 'ChainRuleExpressionAndLimit', expression: string, limit: number, index: number }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null } } | null };

export type CreateFirstSeenRuleBuilderOperationMutationVariables = Exact<{
  fields: CreateFirstSeenRuleFields;
}>;


export type CreateFirstSeenRuleBuilderOperationMutation = { __typename: 'Mutation', createFirstSeenRule?: { __typename: 'CreateFirstSeenRule', data: { __typename: 'FirstSeenRule', suppressionWindowSize?: number | null, baselineType: FirstSeenRuleBaselineType, baselineStatus: BaselineStatus, baselineWindowSize: any, baselineLastStarted?: any | null, created: any, descriptionExpression: string, enabled: boolean, filterExpression: string, groupByFields: Array<string>, id: string, isPrototype: boolean, lastUpdated: any, name: string, nameExpression: string, retentionWindowSize: any, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, score: number, summaryExpression: string, tags: Array<string>, valueExpression?: string | null, valueFields?: Array<string> | null, version: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, baselineWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, retentionWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, exclude: boolean, id: string, isGlobal: boolean, name: string }> | null } } | null };

export type UpdateFirstSeenRuleBuilderOperationMutationVariables = Exact<{
  includeSuppressionWindowSize: Scalars['Boolean']['input'];
  fields: UpdateFirstSeenRuleFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateFirstSeenRuleBuilderOperationMutation = { __typename: 'Mutation', updateFirstSeenRule?: { __typename: 'UpdateFirstSeenRule', data: { __typename: 'FirstSeenRule', suppressionWindowSize?: number | null, baselineType: FirstSeenRuleBaselineType, baselineStatus: BaselineStatus, baselineWindowSize: any, baselineLastStarted?: any | null, created: any, descriptionExpression: string, enabled: boolean, filterExpression: string, groupByFields: Array<string>, id: string, isPrototype: boolean, lastUpdated: any, name: string, nameExpression: string, retentionWindowSize: any, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, score: number, summaryExpression: string, tags: Array<string>, valueExpression?: string | null, valueFields?: Array<string> | null, version: number, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, baselineWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, retentionWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, exclude: boolean, id: string, isGlobal: boolean, name: string }> | null } } | null };

export type CreateTemplatedMatchRuleBuilderOperationMutationVariables = Exact<{
  fields: CreateTemplatedMatchRuleFields;
}>;


export type CreateTemplatedMatchRuleBuilderOperationMutation = { __typename: 'Mutation', createTemplatedMatchRule?: { __typename: 'CreateTemplatedMatchRule', data: { __typename: 'TemplatedMatchRule', expression: string, descriptionExpression: string, nameExpression: string, hasOverride: boolean, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null }, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreMappingOverride?: { __typename: 'RuleScoreMappingRuleOverride', original?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null, override?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null } } | null };

export type UpdateTemplatedMatchRuleBuilderOperationMutationVariables = Exact<{
  includeSuppressionWindowSize: Scalars['Boolean']['input'];
  fields: UpdateTemplatedMatchRuleFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateTemplatedMatchRuleBuilderOperationMutation = { __typename: 'Mutation', updateTemplatedMatchRule?: { __typename: 'UpdateTemplatedMatchRule', data: { __typename: 'TemplatedMatchRule', suppressionWindowSize?: number | null, expression: string, descriptionExpression: string, nameExpression: string, hasOverride: boolean, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null }, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }> | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, scoreMappingOverride?: { __typename: 'RuleScoreMappingRuleOverride', original?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null, override?: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, fromEnd?: string | null, to: number }> | null } | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null } } | null };

export type UpdateMatchRuleBuilderOperationMutationVariables = Exact<{
  fields: UpdateMatchRuleFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateMatchRuleBuilderOperationMutation = { __typename: 'Mutation', updateMatchRule?: { __typename: 'UpdateMatchRule', data: { __typename: 'MatchRule', description: string, expression: string, score: number, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null } } | null };

export type CreateOutlierRuleBuilderOperationMutationVariables = Exact<{
  fields: CreateOutlierRuleFields;
}>;


export type CreateOutlierRuleBuilderOperationMutation = { __typename: 'Mutation', createOutlierRule?: { __typename: 'CreateOutlierRule', data: { __typename: 'OutlierRule', baselineWindowSize: any, baselineLastStarted?: any | null, baselineStatus: BaselineStatus, descriptionExpression: string, deviationThreshold: number, floorValue: number, groupByFields: Array<string>, matchExpression: string, nameExpression: string, retentionWindowSize: any, score: number, windowSize: number, windowSizeName: string, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, aggregationFunctions: Array<{ __typename: 'OutlierRuleAggregationFunction', name: string, function: string, arguments: Array<string> }>, baselineWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, deviationThresholdOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', entityType: string, expression: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', entityType: string, expression: string }> | null } | null, floorValueOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, retentionWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null } } | null };

export type UpdateOutlierRuleBuilderOperationMutationVariables = Exact<{
  fields: UpdateOutlierRuleFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateOutlierRuleBuilderOperationMutation = { __typename: 'Mutation', updateOutlierRule?: { __typename: 'UpdateOutlierRule', data: { __typename: 'OutlierRule', baselineWindowSize: any, baselineLastStarted?: any | null, baselineStatus: BaselineStatus, descriptionExpression: string, deviationThreshold: number, floorValue: number, groupByFields: Array<string>, matchExpression: string, nameExpression: string, retentionWindowSize: any, score: number, windowSize: number, windowSizeName: string, suppressionWindowSize?: number | null, created: any, id: string, isPrototype: boolean, lastUpdated: any, name: string, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, enabled: boolean, summaryExpression: string, tags: Array<string>, aggregationFunctions: Array<{ __typename: 'OutlierRuleAggregationFunction', name: string, function: string, arguments: Array<string> }>, baselineWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, descriptionExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, deviationThresholdOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, entitySelectorsOverride?: { __typename: 'EntitySelectorsRuleOverride', original?: Array<{ __typename: 'OutputEntitySelectorType', entityType: string, expression: string }> | null, override?: Array<{ __typename: 'OutputEntitySelectorType', entityType: string, expression: string }> | null } | null, floorValueOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, groupByFieldsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, isPrototypeOverride?: { __typename: 'BooleanRuleOverride', original?: boolean | null, override?: boolean | null } | null, nameExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, nameOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, retentionWindowSizeOverride?: { __typename: 'BigIntRuleOverride', original?: any | null, override?: any | null } | null, scoreOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, summaryExpressionOverride?: { __typename: 'StringRuleOverride', original?: string | null, override?: string | null } | null, tagsOverride?: { __typename: 'StringListRuleOverride', original?: Array<string> | null, override?: Array<string> | null } | null, windowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, suppressionWindowSizeOverride?: { __typename: 'IntRuleOverride', original?: number | null, override?: number | null } | null, createdByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, history: Array<{ __typename: 'RuleHistoryEvent', description: string, timestamp: any, user?: { __typename: 'User', email?: string | null, name?: string | null, role: string, username: string } | null }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null }, tuningExpressions?: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> | null } } | null };

export type UpdateRuleEnabledOperationMutationVariables = Exact<{
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  duplicated?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateRuleEnabledOperationMutation = { __typename: 'Mutation', updateRuleEnabled?: { __typename: 'UpdateRuleEnabled', ok: boolean } | null };

export type RulesListQueryOperationQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort: RuleSortableField;
  sortDir: SortDir;
}>;


export type RulesListQueryOperationQuery = { __typename: 'Query', rules: { __typename: 'RulePage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'AggregationRule', created: any, enabled: boolean, id: string, isPrototype: boolean, lastUpdated: any, name: string, parentJaskId?: string | null, ruleId: number, ruleSource: string, ruleType: string, signalCount07d: number, signalCount24h: number, descriptionExpression: string, groupByAsset: boolean, groupByFields: Array<string>, matchExpression: string, nameExpression: string, suppressionWindowSize?: number | null, triggerExpression: string, windowSize: number, tags: Array<string>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null } | null, aggregationFunctions: Array<{ __typename: 'AggregationRuleAggregationFunction', name: string, function: string, arguments: Array<string> }>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, to: number }> | null }, status: { __typename: 'RuleStatus', message?: string | null, status: RuleStatusEnum } } | { __typename: 'ChainRule', isPrototype: boolean, created: any, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, description: string, enabled: boolean, groupByFields: Array<string>, id: string, lastUpdated: any, name: string, parentJaskId?: string | null, ruleId: number, ruleSource: string, ruleType: string, score: number, windowSize: number, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, expressionsAndLimits: Array<{ __typename: 'ChainRuleExpressionAndLimit', index: number, expression: string, limit: number }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null } } | { __typename: 'FirstSeenRule', baselineLastStarted?: any | null, baselineWindowSize: any, baselineStatus: BaselineStatus, created: any, enabled: boolean, descriptionExpression: string, id: string, isPrototype: boolean, groupByFields: Array<string>, lastUpdated: any, name: string, nameExpression: string, parentJaskId?: string | null, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, score: number, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null } | null, status: { __typename: 'RuleStatus', message?: string | null, status: RuleStatusEnum } } | { __typename: 'MatchRule', id: string, isPrototype: boolean, name: string, enabled: boolean, description: string, ruleId: number, expression: string, ruleSource: string, ruleType: string, parentJaskId?: string | null, score: number, created: any, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, lastUpdated: any, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, lastUpdatedByUser?: { __typename: 'User', id: string, email?: string | null, name?: string | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null } } | { __typename: 'OutlierRule', baselineLastStarted?: any | null, baselineStatus: BaselineStatus, baselineWindowSize: any, created: any, enabled: boolean, descriptionExpression: string, id: string, isPrototype: boolean, groupByFields: Array<string>, lastUpdated: any, name: string, nameExpression: string, parentJaskId?: string | null, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, score: number, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null } | null, status: { __typename: 'RuleStatus', message?: string | null, status: RuleStatusEnum } } | { __typename: 'TemplatedMatchRule', id: string, isPrototype: boolean, expression: string, name: string, enabled: boolean, ruleId: number, ruleSource: string, ruleType: string, nameExpression: string, descriptionExpression: string, parentJaskId?: string | null, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, created: any, lastUpdated: any, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, to: number }> | null }, lastUpdatedByUser?: { __typename: 'User', id: string, email?: string | null, name?: string | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null } } | { __typename: 'ThresholdRule', isPrototype: boolean, countDistinct: boolean, countField?: string | null, created: any, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, description: string, enabled: boolean, expression: string, groupByFields: Array<string>, id: string, lastUpdated: any, limit: number, name: string, parentJaskId?: string | null, ruleId: number, ruleSource: string, ruleType: string, score: number, version: number, windowSize: number, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null } }> } };

export type MatchRuleTypeFieldsFragment = { __typename: 'MatchRule', id: string, isPrototype: boolean, name: string, enabled: boolean, description: string, ruleId: number, expression: string, ruleSource: string, ruleType: string, parentJaskId?: string | null, score: number, created: any, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, lastUpdated: any, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, lastUpdatedByUser?: { __typename: 'User', id: string, email?: string | null, name?: string | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null } };

export type ThresholdRuleTypeFieldsFragment = { __typename: 'ThresholdRule', isPrototype: boolean, countDistinct: boolean, countField?: string | null, created: any, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, description: string, enabled: boolean, expression: string, groupByFields: Array<string>, id: string, lastUpdated: any, limit: number, name: string, parentJaskId?: string | null, ruleId: number, ruleSource: string, ruleType: string, score: number, version: number, windowSize: number, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null } };

export type ChainRuleTypeFieldsFragment = { __typename: 'ChainRule', isPrototype: boolean, created: any, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, description: string, enabled: boolean, groupByFields: Array<string>, id: string, lastUpdated: any, name: string, parentJaskId?: string | null, ruleId: number, ruleSource: string, ruleType: string, score: number, windowSize: number, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, expressionsAndLimits: Array<{ __typename: 'ChainRuleExpressionAndLimit', index: number, expression: string, limit: number }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null } };

export type TemplatedMatchRuleTypeFieldsFragment = { __typename: 'TemplatedMatchRule', id: string, isPrototype: boolean, expression: string, name: string, enabled: boolean, ruleId: number, ruleSource: string, ruleType: string, nameExpression: string, descriptionExpression: string, parentJaskId?: string | null, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, created: any, lastUpdated: any, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, to: number }> | null }, lastUpdatedByUser?: { __typename: 'User', id: string, email?: string | null, name?: string | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null } };

export type AggregationRuleTypeFieldsFragment = { __typename: 'AggregationRule', created: any, enabled: boolean, id: string, isPrototype: boolean, lastUpdated: any, name: string, parentJaskId?: string | null, ruleId: number, ruleSource: string, ruleType: string, signalCount07d: number, signalCount24h: number, descriptionExpression: string, groupByAsset: boolean, groupByFields: Array<string>, matchExpression: string, nameExpression: string, suppressionWindowSize?: number | null, triggerExpression: string, windowSize: number, tags: Array<string>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null } | null, aggregationFunctions: Array<{ __typename: 'AggregationRuleAggregationFunction', name: string, function: string, arguments: Array<string> }>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, to: number }> | null }, status: { __typename: 'RuleStatus', message?: string | null, status: RuleStatusEnum } };

export type FirstSeenRuleTypeFieldsFragment = { __typename: 'FirstSeenRule', baselineLastStarted?: any | null, baselineWindowSize: any, baselineStatus: BaselineStatus, created: any, enabled: boolean, descriptionExpression: string, id: string, isPrototype: boolean, groupByFields: Array<string>, lastUpdated: any, name: string, nameExpression: string, parentJaskId?: string | null, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, score: number, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null } | null, status: { __typename: 'RuleStatus', message?: string | null, status: RuleStatusEnum } };

export type OutlierRuleTypeFieldsFragment = { __typename: 'OutlierRule', baselineLastStarted?: any | null, baselineStatus: BaselineStatus, baselineWindowSize: any, created: any, enabled: boolean, descriptionExpression: string, id: string, isPrototype: boolean, groupByFields: Array<string>, lastUpdated: any, name: string, nameExpression: string, parentJaskId?: string | null, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, score: number, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null } | null, status: { __typename: 'RuleStatus', message?: string | null, status: RuleStatusEnum } };

type RuleFragment_AggregationRule = { __typename: 'AggregationRule', created: any, enabled: boolean, id: string, isPrototype: boolean, lastUpdated: any, name: string, parentJaskId?: string | null, ruleId: number, ruleSource: string, ruleType: string, signalCount07d: number, signalCount24h: number, descriptionExpression: string, groupByAsset: boolean, groupByFields: Array<string>, matchExpression: string, nameExpression: string, suppressionWindowSize?: number | null, triggerExpression: string, windowSize: number, tags: Array<string>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null } | null, aggregationFunctions: Array<{ __typename: 'AggregationRuleAggregationFunction', name: string, function: string, arguments: Array<string> }>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, to: number }> | null }, status: { __typename: 'RuleStatus', message?: string | null, status: RuleStatusEnum } };

type RuleFragment_ChainRule = { __typename: 'ChainRule', isPrototype: boolean, created: any, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, description: string, enabled: boolean, groupByFields: Array<string>, id: string, lastUpdated: any, name: string, parentJaskId?: string | null, ruleId: number, ruleSource: string, ruleType: string, score: number, windowSize: number, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, expressionsAndLimits: Array<{ __typename: 'ChainRuleExpressionAndLimit', index: number, expression: string, limit: number }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null } };

type RuleFragment_FirstSeenRule = { __typename: 'FirstSeenRule', baselineLastStarted?: any | null, baselineWindowSize: any, baselineStatus: BaselineStatus, created: any, enabled: boolean, descriptionExpression: string, id: string, isPrototype: boolean, groupByFields: Array<string>, lastUpdated: any, name: string, nameExpression: string, parentJaskId?: string | null, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, score: number, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null } | null, status: { __typename: 'RuleStatus', message?: string | null, status: RuleStatusEnum } };

type RuleFragment_MatchRule = { __typename: 'MatchRule', id: string, isPrototype: boolean, name: string, enabled: boolean, description: string, ruleId: number, expression: string, ruleSource: string, ruleType: string, parentJaskId?: string | null, score: number, created: any, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, lastUpdated: any, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, lastUpdatedByUser?: { __typename: 'User', id: string, email?: string | null, name?: string | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null } };

type RuleFragment_OutlierRule = { __typename: 'OutlierRule', baselineLastStarted?: any | null, baselineStatus: BaselineStatus, baselineWindowSize: any, created: any, enabled: boolean, descriptionExpression: string, id: string, isPrototype: boolean, groupByFields: Array<string>, lastUpdated: any, name: string, nameExpression: string, parentJaskId?: string | null, ruleDescription?: string | null, ruleId: number, ruleSource: string, ruleType: string, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, score: number, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null } | null, status: { __typename: 'RuleStatus', message?: string | null, status: RuleStatusEnum } };

type RuleFragment_TemplatedMatchRule = { __typename: 'TemplatedMatchRule', id: string, isPrototype: boolean, expression: string, name: string, enabled: boolean, ruleId: number, ruleSource: string, ruleType: string, nameExpression: string, descriptionExpression: string, parentJaskId?: string | null, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, created: any, lastUpdated: any, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, scoreMapping: { __typename: 'RuleScoreMapping', type: string, default?: number | null, field?: string | null, mapping?: Array<{ __typename: 'RuleScoreMappingItem', type: string, from?: string | null, to: number }> | null }, lastUpdatedByUser?: { __typename: 'User', id: string, email?: string | null, name?: string | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null } };

type RuleFragment_ThresholdRule = { __typename: 'ThresholdRule', isPrototype: boolean, countDistinct: boolean, countField?: string | null, created: any, signalCount07d: number, signalCount24h: number, suppressionWindowSize?: number | null, description: string, enabled: boolean, expression: string, groupByFields: Array<string>, id: string, lastUpdated: any, limit: number, name: string, parentJaskId?: string | null, ruleId: number, ruleSource: string, ruleType: string, score: number, version: number, windowSize: number, tags: Array<string>, entitySelectors: Array<{ __typename: 'OutputEntitySelectorType', expression: string, entityType: string }>, lastUpdatedByUser?: { __typename: 'User', email?: string | null, id: string, name?: string | null } | null, status: { __typename: 'RuleStatus', status: RuleStatusEnum, message?: string | null } };

export type RuleFragment = RuleFragment_AggregationRule | RuleFragment_ChainRule | RuleFragment_FirstSeenRule | RuleFragment_MatchRule | RuleFragment_OutlierRule | RuleFragment_TemplatedMatchRule | RuleFragment_ThresholdRule;

export type UploadListItemsToListOperationMutationVariables = Exact<{
  listId: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
  file: Scalars['Upload']['input'];
}>;


export type UploadListItemsToListOperationMutation = { __typename: 'Mutation', uploadItemsToList?: { __typename: 'UploadItemsToList', uploadedItemCount: number } | null };

export type SuppressListFragment = { __typename: 'SuppressList', id: string, name: string, description?: string | null, defaultTtl?: number | null, targetColumn: string, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, items: { __typename: 'SuppressListItemPage', total: number } };

export type SuppressedListOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SuppressedListOperationQuery = { __typename: 'Query', suppressList: { __typename: 'SuppressList', id: string, name: string, description?: string | null, defaultTtl?: number | null, targetColumn: string, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, items: { __typename: 'SuppressListItemPage', total: number } } };

export type SuppressListItemFragment = { __typename: 'SuppressListItem', id: string, value: string, active: boolean, expiration?: any | null, listId: string, meta?: { __typename: 'ItemMeta', description: string } | null };

export type SuppressedListItemsOperationQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  q: Scalars['String']['input'];
  sort: SuppressListItemSortableField;
  sortDir: SortDir;
}>;


export type SuppressedListItemsOperationQuery = { __typename: 'Query', suppressListItems: { __typename: 'SuppressListItemPage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'SuppressListItem', id: string, value: string, active: boolean, expiration?: any | null, listId: string, meta?: { __typename: 'ItemMeta', description: string } | null }> } };

export type SuppressedListsOperationQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sort: Scalars['String']['input'];
  sortDir: SortDir;
}>;


export type SuppressedListsOperationQuery = { __typename: 'Query', suppressListItemLimit: number, suppressListItemCount: number, suppressLists: { __typename: 'SuppressListPage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'SuppressList', id: string, name: string, description?: string | null, defaultTtl?: number | null, targetColumn: string, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, items: { __typename: 'SuppressListItemPage', total: number } }> } };

export type DeleteSuppressedListItemOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSuppressedListItemOperationMutation = { __typename: 'Mutation', deleteSuppressListItem?: { __typename: 'DeleteSuppressListItem', ok: boolean } | null };

export type AddItemToSuppressedListOperationMutationVariables = Exact<{
  listId: Scalars['ID']['input'];
  itemFields: SuppressListItemFields;
}>;


export type AddItemToSuppressedListOperationMutation = { __typename: 'Mutation', addItemToSuppressList?: { __typename: 'AddItemToSuppressList', finishedProcessing: boolean, data: { __typename: 'SuppressListItem', id: string, value: string, active: boolean, expiration?: any | null, listId: string, meta?: { __typename: 'ItemMeta', description: string } | null } } | null };

export type UpdateSuppressedListItemOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: UpdatableSuppressListItemFields;
}>;


export type UpdateSuppressedListItemOperationMutation = { __typename: 'Mutation', updateSuppressListItem?: { __typename: 'UpdateSuppressListItem', finishedProcessing: boolean, data: { __typename: 'SuppressListItem', id: string, value: string, active: boolean, expiration?: any | null, listId: string, meta?: { __typename: 'ItemMeta', description: string } | null } } | null };

export type DeleteSuppressedListOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSuppressedListOperationMutation = { __typename: 'Mutation', deleteSuppressList?: { __typename: 'DeleteSuppressList', ok: boolean } | null };

export type CreateSuppressedListOperationMutationVariables = Exact<{
  fields: SuppressListFields;
}>;


export type CreateSuppressedListOperationMutation = { __typename: 'Mutation', createSuppressList?: { __typename: 'CreateSuppressList', data: { __typename: 'SuppressList', id: string, name: string, description?: string | null, defaultTtl?: number | null, targetColumn: string, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, items: { __typename: 'SuppressListItemPage', total: number } } } | null };

export type UpdateSuppressedListOperationMutationVariables = Exact<{
  fields: UpdatableSuppressListFields;
  id: Scalars['ID']['input'];
}>;


export type UpdateSuppressedListOperationMutation = { __typename: 'Mutation', updateSuppressList?: { __typename: 'UpdateSuppressList', data: { __typename: 'SuppressList', id: string, name: string, description?: string | null, defaultTtl?: number | null, targetColumn: string, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, items: { __typename: 'SuppressListItemPage', total: number } } } | null };

export type SuppressListSelectFragment = { __typename: 'SuppressList', id: string, name: string };

export type SuppressedListSelectOperationQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort: Scalars['String']['input'];
  sortDir: SortDir;
}>;


export type SuppressedListSelectOperationQuery = { __typename: 'Query', suppressLists: { __typename: 'SuppressListPage', total: number, objects: Array<{ __typename: 'SuppressList', id: string, name: string }> } };

export type ThreatIntelItemEditorOperationQueryVariables = Exact<{
  itemId: Scalars['ID']['input'];
  fetchItem: Scalars['Boolean']['input'];
}>;


export type ThreatIntelItemEditorOperationQuery = { __typename: 'Query', threatIntelItem?: { __typename: 'ThreatIntelItem', id: string, value: string, active: boolean, expiration?: any | null, meta?: { __typename: 'ItemMeta', description: string } | null } };

export type AddItemToThreatIntelSourceOperationMutationVariables = Exact<{
  threatIntelSourceId: Scalars['ID']['input'];
  itemFields: ThreatIntelItemFields;
}>;


export type AddItemToThreatIntelSourceOperationMutation = { __typename: 'Mutation', addItemToThreatIntelSource?: { __typename: 'AddItemToThreatIntelSource', data: { __typename: 'ThreatIntelItem', id: string, value: string, active: boolean, expiration?: any | null, meta?: { __typename: 'ItemMeta', description: string } | null } } | null };

export type UpdateThreatIntelItemOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: UpdatableThreatIntelItemFields;
}>;


export type UpdateThreatIntelItemOperationMutation = { __typename: 'Mutation', updateThreatIntelItem?: { __typename: 'UpdateThreatIntelItem', finishedProcessing: boolean, data: { __typename: 'ThreatIntelItem', id: string, value: string, active: boolean, expiration?: any | null, meta?: { __typename: 'ItemMeta', description: string } | null } } | null };

export type ThreatIntelItemsSearchOperationQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort: ThreatIntelItemSortableField;
  sortDir: SortDir;
  q: Scalars['String']['input'];
}>;


export type ThreatIntelItemsSearchOperationQuery = { __typename: 'Query', threatIntelItems: { __typename: 'ThreatIntelItemPage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'ThreatIntelItem', id: string, value: string, active: boolean, expiration?: any | null, source: { __typename: 'ThreatIntelSource', id: string, name: string, sourceType: ThreatIntelSourceType }, meta?: { __typename: 'ItemMeta', description: string } | null }> } };

export type ThreatIntelSearchItemFragment = { __typename: 'ThreatIntelItem', id: string, value: string, active: boolean, expiration?: any | null, source: { __typename: 'ThreatIntelSource', id: string, name: string, sourceType: ThreatIntelSourceType }, meta?: { __typename: 'ItemMeta', description: string } | null };

export type UploadItemsToThreatIntelSourceOperationMutationVariables = Exact<{
  threatIntelSourceId: Scalars['String']['input'];
  expiration?: InputMaybe<Scalars['DateTime']['input']>;
  file: Scalars['Upload']['input'];
}>;


export type UploadItemsToThreatIntelSourceOperationMutation = { __typename: 'Mutation', uploadItemsToThreatIntelSource?: { __typename: 'UploadItemsToThreatIntelSource', uploadedItemCount: number } | null };

export type DeleteThreatIntelSourceOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteThreatIntelSourceOperationMutation = { __typename: 'Mutation', deleteThreatIntelSource?: { __typename: 'DeleteThreatIntelSource', ok: boolean } | null };

export type ThreatIntelSourceDetailOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ThreatIntelSourceDetailOperationQuery = { __typename: 'Query', threatIntelSource: { __typename: 'ThreatIntelSource', id: string, name: string, description?: string | null, sourceType: ThreatIntelSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, taxiiFeed?: { __typename: 'TaxiiFeed', url: string, username?: string | null, hasPassword: boolean, lastTimeDataReceived?: any | null, lastTimeFailed?: any | null, consecutiveFailureCount: number, lastPollSize?: number | null, enabled: boolean, maxLookbackDays?: number | null, pollIntervalMinutes: number, useTtlFromIndicators: boolean, defaultTtlDays?: number | null, hasCertificate: boolean, hasCertificatePassword: boolean, lastRun?: any | null, collections?: string | null, subscriptionId?: string | null, recentFailures: Array<{ __typename: 'TaxiiFeedFailure', timestamp?: any | null, error: string, collectionName?: string | null }> } | null, idefenseConfig?: { __typename: 'IdefenseConfig', enabled: boolean, apiKey: string } | null, threatQConfig?: { __typename: 'ThreatQConfig', enabled: boolean, baseUrl: string, clientId: string, pollIntervalMinutes: number, customFiltersJson: string, extraHeaders?: string | null, hasCertificate: boolean, useExpiration: boolean } | null, items: { __typename: 'ThreatIntelItemPage', total: number } } };

export type ThreatIntelItemsOperationQueryVariables = Exact<{
  sourceIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort: ThreatIntelItemSortableField;
  sortDir: SortDir;
  q: Scalars['String']['input'];
}>;


export type ThreatIntelItemsOperationQuery = { __typename: 'Query', threatIntelItems: { __typename: 'ThreatIntelItemPage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'ThreatIntelItem', id: string, value: string, active: boolean, expiration?: any | null, meta?: { __typename: 'ItemMeta', description: string } | null }> } };

export type CreateCustomThreatIntelSourceOperationMutationVariables = Exact<{
  fields: CustomThreatIntelSourceFields;
}>;


export type CreateCustomThreatIntelSourceOperationMutation = { __typename: 'Mutation', createCustomThreatIntelSource?: { __typename: 'CreateCustomThreatIntelSource', data: { __typename: 'ThreatIntelSource', id: string, name: string, description?: string | null, sourceType: ThreatIntelSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, taxiiFeed?: { __typename: 'TaxiiFeed', url: string, username?: string | null, hasPassword: boolean, lastTimeDataReceived?: any | null, lastTimeFailed?: any | null, consecutiveFailureCount: number, lastPollSize?: number | null, enabled: boolean, maxLookbackDays?: number | null, pollIntervalMinutes: number, useTtlFromIndicators: boolean, defaultTtlDays?: number | null, hasCertificate: boolean, hasCertificatePassword: boolean, lastRun?: any | null, collections?: string | null, subscriptionId?: string | null, recentFailures: Array<{ __typename: 'TaxiiFeedFailure', timestamp?: any | null, error: string, collectionName?: string | null }> } | null, idefenseConfig?: { __typename: 'IdefenseConfig', enabled: boolean, apiKey: string } | null, threatQConfig?: { __typename: 'ThreatQConfig', enabled: boolean, baseUrl: string, clientId: string, pollIntervalMinutes: number, customFiltersJson: string, extraHeaders?: string | null, hasCertificate: boolean, useExpiration: boolean } | null, items: { __typename: 'ThreatIntelItemPage', total: number } } } | null };

export type UpdateCustomThreatIntelSourceOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: UpdatableCustomThreatIntelSourceFields;
}>;


export type UpdateCustomThreatIntelSourceOperationMutation = { __typename: 'Mutation', updateCustomThreatIntelSource?: { __typename: 'UpdateCustomThreatIntelSource', data: { __typename: 'ThreatIntelSource', id: string, name: string, description?: string | null, sourceType: ThreatIntelSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, taxiiFeed?: { __typename: 'TaxiiFeed', url: string, username?: string | null, hasPassword: boolean, lastTimeDataReceived?: any | null, lastTimeFailed?: any | null, consecutiveFailureCount: number, lastPollSize?: number | null, enabled: boolean, maxLookbackDays?: number | null, pollIntervalMinutes: number, useTtlFromIndicators: boolean, defaultTtlDays?: number | null, hasCertificate: boolean, hasCertificatePassword: boolean, lastRun?: any | null, collections?: string | null, subscriptionId?: string | null, recentFailures: Array<{ __typename: 'TaxiiFeedFailure', timestamp?: any | null, error: string, collectionName?: string | null }> } | null, idefenseConfig?: { __typename: 'IdefenseConfig', enabled: boolean, apiKey: string } | null, threatQConfig?: { __typename: 'ThreatQConfig', enabled: boolean, baseUrl: string, clientId: string, pollIntervalMinutes: number, customFiltersJson: string, extraHeaders?: string | null, hasCertificate: boolean, useExpiration: boolean } | null, items: { __typename: 'ThreatIntelItemPage', total: number } } } | null };

export type CreateIdefenseThreatIntelSourceOperationMutationVariables = Exact<{
  fields: IdefenseThreatIntelSourceFields;
}>;


export type CreateIdefenseThreatIntelSourceOperationMutation = { __typename: 'Mutation', createIdefenseThreatIntelSource?: { __typename: 'CreateIdefenseThreatIntelSource', data: { __typename: 'ThreatIntelSource', id: string, name: string, description?: string | null, sourceType: ThreatIntelSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, taxiiFeed?: { __typename: 'TaxiiFeed', url: string, username?: string | null, hasPassword: boolean, lastTimeDataReceived?: any | null, lastTimeFailed?: any | null, consecutiveFailureCount: number, lastPollSize?: number | null, enabled: boolean, maxLookbackDays?: number | null, pollIntervalMinutes: number, useTtlFromIndicators: boolean, defaultTtlDays?: number | null, hasCertificate: boolean, hasCertificatePassword: boolean, lastRun?: any | null, collections?: string | null, subscriptionId?: string | null, recentFailures: Array<{ __typename: 'TaxiiFeedFailure', timestamp?: any | null, error: string, collectionName?: string | null }> } | null, idefenseConfig?: { __typename: 'IdefenseConfig', enabled: boolean, apiKey: string } | null, threatQConfig?: { __typename: 'ThreatQConfig', enabled: boolean, baseUrl: string, clientId: string, pollIntervalMinutes: number, customFiltersJson: string, extraHeaders?: string | null, hasCertificate: boolean, useExpiration: boolean } | null, items: { __typename: 'ThreatIntelItemPage', total: number } } } | null };

export type UpdateIdefenseThreatIntelSourceOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: UpdatableIdefenseThreatIntelSourceFields;
}>;


export type UpdateIdefenseThreatIntelSourceOperationMutation = { __typename: 'Mutation', updateIdefenseThreatIntelSource?: { __typename: 'UpdateIdefenseThreatIntelSource', data: { __typename: 'ThreatIntelSource', id: string, name: string, description?: string | null, sourceType: ThreatIntelSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, taxiiFeed?: { __typename: 'TaxiiFeed', url: string, username?: string | null, hasPassword: boolean, lastTimeDataReceived?: any | null, lastTimeFailed?: any | null, consecutiveFailureCount: number, lastPollSize?: number | null, enabled: boolean, maxLookbackDays?: number | null, pollIntervalMinutes: number, useTtlFromIndicators: boolean, defaultTtlDays?: number | null, hasCertificate: boolean, hasCertificatePassword: boolean, lastRun?: any | null, collections?: string | null, subscriptionId?: string | null, recentFailures: Array<{ __typename: 'TaxiiFeedFailure', timestamp?: any | null, error: string, collectionName?: string | null }> } | null, idefenseConfig?: { __typename: 'IdefenseConfig', enabled: boolean, apiKey: string } | null, threatQConfig?: { __typename: 'ThreatQConfig', enabled: boolean, baseUrl: string, clientId: string, pollIntervalMinutes: number, customFiltersJson: string, extraHeaders?: string | null, hasCertificate: boolean, useExpiration: boolean } | null, items: { __typename: 'ThreatIntelItemPage', total: number } } } | null };

export type CreateTaxiiThreatIntelSourceOperationMutationVariables = Exact<{
  fields: TaxiiThreatIntelSourceFields;
}>;


export type CreateTaxiiThreatIntelSourceOperationMutation = { __typename: 'Mutation', createTaxiiThreatIntelSource?: { __typename: 'CreateTaxiiThreatIntelSource', data: { __typename: 'ThreatIntelSource', id: string, name: string, description?: string | null, sourceType: ThreatIntelSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, taxiiFeed?: { __typename: 'TaxiiFeed', url: string, username?: string | null, hasPassword: boolean, lastTimeDataReceived?: any | null, lastTimeFailed?: any | null, consecutiveFailureCount: number, lastPollSize?: number | null, enabled: boolean, maxLookbackDays?: number | null, pollIntervalMinutes: number, useTtlFromIndicators: boolean, defaultTtlDays?: number | null, hasCertificate: boolean, hasCertificatePassword: boolean, lastRun?: any | null, collections?: string | null, subscriptionId?: string | null, recentFailures: Array<{ __typename: 'TaxiiFeedFailure', timestamp?: any | null, error: string, collectionName?: string | null }> } | null, idefenseConfig?: { __typename: 'IdefenseConfig', enabled: boolean, apiKey: string } | null, threatQConfig?: { __typename: 'ThreatQConfig', enabled: boolean, baseUrl: string, clientId: string, pollIntervalMinutes: number, customFiltersJson: string, extraHeaders?: string | null, hasCertificate: boolean, useExpiration: boolean } | null, items: { __typename: 'ThreatIntelItemPage', total: number } } } | null };

export type UpdateTaxiiThreatIntelSourceOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: UpdatableTaxiiThreatIntelSourceFields;
  fieldsToClear: Array<TaxiiClearableFields> | TaxiiClearableFields;
}>;


export type UpdateTaxiiThreatIntelSourceOperationMutation = { __typename: 'Mutation', updateTaxiiThreatIntelSource?: { __typename: 'UpdateTaxiiThreatIntelSource', data: { __typename: 'ThreatIntelSource', id: string, name: string, description?: string | null, sourceType: ThreatIntelSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, taxiiFeed?: { __typename: 'TaxiiFeed', url: string, username?: string | null, hasPassword: boolean, lastTimeDataReceived?: any | null, lastTimeFailed?: any | null, consecutiveFailureCount: number, lastPollSize?: number | null, enabled: boolean, maxLookbackDays?: number | null, pollIntervalMinutes: number, useTtlFromIndicators: boolean, defaultTtlDays?: number | null, hasCertificate: boolean, hasCertificatePassword: boolean, lastRun?: any | null, collections?: string | null, subscriptionId?: string | null, recentFailures: Array<{ __typename: 'TaxiiFeedFailure', timestamp?: any | null, error: string, collectionName?: string | null }> } | null, idefenseConfig?: { __typename: 'IdefenseConfig', enabled: boolean, apiKey: string } | null, threatQConfig?: { __typename: 'ThreatQConfig', enabled: boolean, baseUrl: string, clientId: string, pollIntervalMinutes: number, customFiltersJson: string, extraHeaders?: string | null, hasCertificate: boolean, useExpiration: boolean } | null, items: { __typename: 'ThreatIntelItemPage', total: number } } } | null };

export type ThreatIntelSourceEditorOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ThreatIntelSourceEditorOperationQuery = { __typename: 'Query', threatIntelSource: { __typename: 'ThreatIntelSource', id: string, name: string, description?: string | null, sourceType: ThreatIntelSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, taxiiFeed?: { __typename: 'TaxiiFeed', url: string, username?: string | null, hasPassword: boolean, lastTimeDataReceived?: any | null, lastTimeFailed?: any | null, consecutiveFailureCount: number, lastPollSize?: number | null, enabled: boolean, maxLookbackDays?: number | null, pollIntervalMinutes: number, useTtlFromIndicators: boolean, defaultTtlDays?: number | null, hasCertificate: boolean, hasCertificatePassword: boolean, lastRun?: any | null, collections?: string | null, subscriptionId?: string | null, recentFailures: Array<{ __typename: 'TaxiiFeedFailure', timestamp?: any | null, error: string, collectionName?: string | null }> } | null, idefenseConfig?: { __typename: 'IdefenseConfig', enabled: boolean, apiKey: string } | null, threatQConfig?: { __typename: 'ThreatQConfig', enabled: boolean, baseUrl: string, clientId: string, pollIntervalMinutes: number, customFiltersJson: string, extraHeaders?: string | null, hasCertificate: boolean, useExpiration: boolean } | null, items: { __typename: 'ThreatIntelItemPage', total: number } } };

export type CreateThreatQThreatIntelSourceOperationMutationVariables = Exact<{
  fields: ThreatQThreatIntelSourceFields;
}>;


export type CreateThreatQThreatIntelSourceOperationMutation = { __typename: 'Mutation', createThreatQThreatIntelSource?: { __typename: 'CreateThreatQThreatIntelSource', data: { __typename: 'ThreatIntelSource', id: string, name: string, description?: string | null, sourceType: ThreatIntelSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, taxiiFeed?: { __typename: 'TaxiiFeed', url: string, username?: string | null, hasPassword: boolean, lastTimeDataReceived?: any | null, lastTimeFailed?: any | null, consecutiveFailureCount: number, lastPollSize?: number | null, enabled: boolean, maxLookbackDays?: number | null, pollIntervalMinutes: number, useTtlFromIndicators: boolean, defaultTtlDays?: number | null, hasCertificate: boolean, hasCertificatePassword: boolean, lastRun?: any | null, collections?: string | null, subscriptionId?: string | null, recentFailures: Array<{ __typename: 'TaxiiFeedFailure', timestamp?: any | null, error: string, collectionName?: string | null }> } | null, idefenseConfig?: { __typename: 'IdefenseConfig', enabled: boolean, apiKey: string } | null, threatQConfig?: { __typename: 'ThreatQConfig', enabled: boolean, baseUrl: string, clientId: string, pollIntervalMinutes: number, customFiltersJson: string, extraHeaders?: string | null, hasCertificate: boolean, useExpiration: boolean } | null, items: { __typename: 'ThreatIntelItemPage', total: number } } } | null };

export type UpdateThreatQThreatIntelSourceOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: UpdatableThreatQThreatIntelSourceFields;
  fieldsToClear: Array<ThreatQClearableFields> | ThreatQClearableFields;
}>;


export type UpdateThreatQThreatIntelSourceOperationMutation = { __typename: 'Mutation', updateThreatQThreatIntelSource?: { __typename: 'UpdateThreatQThreatIntelSource', data: { __typename: 'ThreatIntelSource', id: string, name: string, description?: string | null, sourceType: ThreatIntelSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, taxiiFeed?: { __typename: 'TaxiiFeed', url: string, username?: string | null, hasPassword: boolean, lastTimeDataReceived?: any | null, lastTimeFailed?: any | null, consecutiveFailureCount: number, lastPollSize?: number | null, enabled: boolean, maxLookbackDays?: number | null, pollIntervalMinutes: number, useTtlFromIndicators: boolean, defaultTtlDays?: number | null, hasCertificate: boolean, hasCertificatePassword: boolean, lastRun?: any | null, collections?: string | null, subscriptionId?: string | null, recentFailures: Array<{ __typename: 'TaxiiFeedFailure', timestamp?: any | null, error: string, collectionName?: string | null }> } | null, idefenseConfig?: { __typename: 'IdefenseConfig', enabled: boolean, apiKey: string } | null, threatQConfig?: { __typename: 'ThreatQConfig', enabled: boolean, baseUrl: string, clientId: string, pollIntervalMinutes: number, customFiltersJson: string, extraHeaders?: string | null, hasCertificate: boolean, useExpiration: boolean } | null, items: { __typename: 'ThreatIntelItemPage', total: number } } } | null };

export type ThreatIntelSourcesOperationQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sort: Scalars['String']['input'];
  sortDir: SortDir;
}>;


export type ThreatIntelSourcesOperationQuery = { __typename: 'Query', threatIntelItemCount: number, threatIntelItemLimit: number, threatIntelSources: { __typename: 'ThreatIntelSourcePage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'ThreatIntelSource', id: string, name: string, description?: string | null, sourceType: ThreatIntelSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, taxiiFeed?: { __typename: 'TaxiiFeed', url: string, username?: string | null, hasPassword: boolean, lastTimeDataReceived?: any | null, lastTimeFailed?: any | null, consecutiveFailureCount: number, lastPollSize?: number | null, enabled: boolean, maxLookbackDays?: number | null, pollIntervalMinutes: number, useTtlFromIndicators: boolean, defaultTtlDays?: number | null, hasCertificate: boolean, hasCertificatePassword: boolean, lastRun?: any | null, collections?: string | null, subscriptionId?: string | null, recentFailures: Array<{ __typename: 'TaxiiFeedFailure', timestamp?: any | null, error: string, collectionName?: string | null }> } | null, idefenseConfig?: { __typename: 'IdefenseConfig', enabled: boolean, apiKey: string } | null, threatQConfig?: { __typename: 'ThreatQConfig', enabled: boolean, baseUrl: string, clientId: string, pollIntervalMinutes: number, customFiltersJson: string, extraHeaders?: string | null, hasCertificate: boolean, useExpiration: boolean } | null, items: { __typename: 'ThreatIntelItemPage', total: number } }> } };

export type ThreatIntelTaxiiFeedFragment = { __typename: 'TaxiiFeed', url: string, username?: string | null, hasPassword: boolean, lastTimeDataReceived?: any | null, lastTimeFailed?: any | null, consecutiveFailureCount: number, lastPollSize?: number | null, enabled: boolean, maxLookbackDays?: number | null, pollIntervalMinutes: number, useTtlFromIndicators: boolean, defaultTtlDays?: number | null, hasCertificate: boolean, hasCertificatePassword: boolean, lastRun?: any | null, collections?: string | null, subscriptionId?: string | null, recentFailures: Array<{ __typename: 'TaxiiFeedFailure', timestamp?: any | null, error: string, collectionName?: string | null }> };

export type ThreatIntelSourceFragment = { __typename: 'ThreatIntelSource', id: string, name: string, description?: string | null, sourceType: ThreatIntelSourceType, created?: any | null, createdBy?: string | null, lastUpdated?: any | null, lastUpdatedBy?: string | null, taxiiFeed?: { __typename: 'TaxiiFeed', url: string, username?: string | null, hasPassword: boolean, lastTimeDataReceived?: any | null, lastTimeFailed?: any | null, consecutiveFailureCount: number, lastPollSize?: number | null, enabled: boolean, maxLookbackDays?: number | null, pollIntervalMinutes: number, useTtlFromIndicators: boolean, defaultTtlDays?: number | null, hasCertificate: boolean, hasCertificatePassword: boolean, lastRun?: any | null, collections?: string | null, subscriptionId?: string | null, recentFailures: Array<{ __typename: 'TaxiiFeedFailure', timestamp?: any | null, error: string, collectionName?: string | null }> } | null, idefenseConfig?: { __typename: 'IdefenseConfig', enabled: boolean, apiKey: string } | null, threatQConfig?: { __typename: 'ThreatQConfig', enabled: boolean, baseUrl: string, clientId: string, pollIntervalMinutes: number, customFiltersJson: string, extraHeaders?: string | null, hasCertificate: boolean, useExpiration: boolean } | null, items: { __typename: 'ThreatIntelItemPage', total: number } };

export type ThreatIntelItemFragment = { __typename: 'ThreatIntelItem', id: string, value: string, active: boolean, expiration?: any | null, meta?: { __typename: 'ItemMeta', description: string } | null };

export type DeleteThreatIntelItemOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteThreatIntelItemOperationMutation = { __typename: 'Mutation', deleteThreatIntelItem?: { __typename: 'DeleteThreatIntelItem', ok: boolean } | null };

export type EnrichmentsFilterQueryOperationQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type EnrichmentsFilterQueryOperationQuery = { __typename: 'Query', entitiesByListIds?: Array<{ __typename: 'EntityInterface', id: string, entityTypeName: string, value: string }> | null };

export type EntityEnhancementsQueryDetailsOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityEnhancementsQueryDetailsOperationQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', id: string, entityTypeName: string, value: string, reputation?: string | null } };

export type SignalEnhancementsDetailsQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SignalEnhancementsDetailsQueryOperationQuery = { __typename: 'Query', signal: { __typename: 'Signal', id: string, name: string } };

export type InsightEnhancementsDetailsQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InsightEnhancementsDetailsQueryOperationQuery = { __typename: 'Query', insight: { __typename: 'Insight', id: string, readableId: string } };

export type BulkUpdateEntityCriticalityOperationMutationVariables = Exact<{
  entityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  criticality?: InputMaybe<Scalars['String']['input']>;
}>;


export type BulkUpdateEntityCriticalityOperationMutation = { __typename: 'Mutation', bulkUpdateEntityCriticality?: { __typename: 'BulkUpdateEntityCriticality', data?: Array<{ __typename: 'EntityInterface', id: string, criticality?: string | null } | null> | null } | null };

export type BulkUpdateEntitySuppressionOperationMutationVariables = Exact<{
  comment?: InputMaybe<Scalars['String']['input']>;
  entityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  whitelistFlag: Scalars['Boolean']['input'];
}>;


export type BulkUpdateEntitySuppressionOperationMutation = { __typename: 'Mutation', bulkUpdateEntityWhitelist?: { __typename: 'BulkUpdateEntityWhitelist', data?: Array<{ __typename: 'EntityInterface', id: string, isWhitelisted: boolean, whitelistedComment?: string | null } | null> | null } | null };

export type BulkUpdateEntityTagsOperationMutationVariables = Exact<{
  entityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BulkUpdateEntityTagsOperationMutation = { __typename: 'Mutation', bulkUpdateEntityTags?: { __typename: 'BulkUpdateEntityTags', data?: Array<{ __typename: 'EntityInterface', id: string, tags: Array<string> } | null> | null } | null };

export type BulkAddEntityTagsOperationMutationVariables = Exact<{
  entityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BulkAddEntityTagsOperationMutation = { __typename: 'Mutation', bulkAddEntityTags?: { __typename: 'BulkAddEntityTags', data?: Array<{ __typename: 'EntityInterface', id: string, tags: Array<string> } | null> | null } | null };

export type BulkRemoveEntityTagsOperationMutationVariables = Exact<{
  entityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type BulkRemoveEntityTagsOperationMutation = { __typename: 'Mutation', bulkRemoveEntityTags?: { __typename: 'BulkRemoveEntityTags', data?: Array<{ __typename: 'EntityInterface', id: string, tags: Array<string> } | null> | null } | null };

export type EntityCriticalitySelectConfigsQueryVariables = Exact<{ [key: string]: never; }>;


export type EntityCriticalitySelectConfigsQuery = { __typename: 'Query', entityCriticalityConfigs: { __typename: 'EntityCriticalityConfigPage', total: number, objects: Array<{ __typename: 'EntityCriticalityConfig', id: string, name: string, severityExpression: string }> } };

export type EntityDetailsTimelineSignalsFragment = { __typename: 'Signal', contentType?: string | null, description?: string | null, id: string, name: string, severity: number, timestamp: any };

export type EntityDetailsTimelineQueryOperationQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  q: Scalars['String']['input'];
  sort: SignalSortableField;
  sortDir: SortDir;
}>;


export type EntityDetailsTimelineQueryOperationQuery = { __typename: 'Query', signals: { __typename: 'SignalPage', hasNextPage: boolean, total: number, objects: Array<{ __typename: 'Signal', contentType?: string | null, description?: string | null, id: string, name: string, severity: number, timestamp: any }> } };

export type CreateInsightFromEntitySignalsOperationMutationVariables = Exact<{
  signalIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateInsightFromEntitySignalsOperationMutation = { __typename: 'Mutation', createInsightFromSignals?: { __typename: 'CreateInsightFromSignals', data: { __typename: 'Insight', id: string } } | null };

export type EntityDetailsInsightsFragment = { __typename: 'Insight', readableId: string, timestamp: any, resolution?: string | null, subResolution?: string | null, id: string, deployment: string, tenant: string, name: string, description: string, confidence?: number | null, tags: Array<string>, severity: InsightSeverityPyEnum, tenantUrl?: string | null, signalCount: number, signals: Array<{ __typename: 'Signal', id: string }>, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam' } | { __typename: 'UnknownUser' } | { __typename: 'User', id: string, displayName: string, username: string, email?: string | null } | null, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, status: { __typename: 'InsightStatusName', id: string, name: string, displayName: string } };

export type EntityDetailsInsightsSignalsQueryOperationQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  insightsQuery: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  signalsQuery: Scalars['String']['input'];
  sort: SignalSortableField;
  sortDir: SortDir;
}>;


export type EntityDetailsInsightsSignalsQueryOperationQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', id: string, activityScore: number, currentStateSignals: Array<{ __typename: 'Signal', allRecordsJson: string, description?: string | null, id: string, name: string, recordCount: number, ruleType?: string | null, ruleId?: string | null, severity: number, prototype?: boolean | null, suppressedBy?: string | null, isSuppressedBySuppressList: boolean, suppressedByNetworkBlock: boolean, isSuppressedByEntity: boolean, timestamp: any, summary: string, tags: Array<string>, contentType: ContentType, entity: { __typename: 'EntityInterface', id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null } }> }, insights: { __typename: 'InsightPage', objects: Array<{ __typename: 'Insight', readableId: string, timestamp: any, resolution?: string | null, subResolution?: string | null, id: string, deployment: string, tenant: string, name: string, description: string, confidence?: number | null, tags: Array<string>, severity: InsightSeverityPyEnum, tenantUrl?: string | null, signalCount: number, signals: Array<{ __typename: 'Signal', id: string }>, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam' } | { __typename: 'UnknownUser' } | { __typename: 'User', id: string, displayName: string, username: string, email?: string | null } | null, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, status: { __typename: 'InsightStatusName', id: string, name: string, displayName: string } }> }, insightStatuses: Array<{ __typename: 'InsightStatus', id: string, name: string, color?: string | null }>, signals: { __typename: 'SignalPage', total: number, objects: Array<{ __typename: 'Signal', allRecordsJson: string, description?: string | null, id: string, name: string, recordCount: number, ruleType?: string | null, ruleId?: string | null, severity: number, prototype?: boolean | null, suppressedBy?: string | null, isSuppressedBySuppressList: boolean, suppressedByNetworkBlock: boolean, isSuppressedByEntity: boolean, timestamp: any, summary: string, tags: Array<string>, contentType: ContentType, entity: { __typename: 'EntityInterface', id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null } }> } };

export type EntityDetailsSignalsSummaryQueryOperationQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  allSignalsQuery: Scalars['String']['input'];
  suppressedSignalsQuery: Scalars['String']['input'];
  unsuppressedSignalsQuery: Scalars['String']['input'];
  prototypeSignalsQuery: Scalars['String']['input'];
  sort: SignalSortableField;
  sortDir: SortDir;
}>;


export type EntityDetailsSignalsSummaryQueryOperationQuery = { __typename: 'Query', allSignals: { __typename: 'SignalPage', total: number }, suppressedSignals: { __typename: 'SignalPage', total: number }, unSuppressedSignals: { __typename: 'SignalPage', total: number }, prototypeSignals: { __typename: 'SignalPage', total: number } };

export type EntityDetailsTagsQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityDetailsTagsQueryOperationQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', id: string, tags: Array<string> } };

export type UpdateEntityDetailsTagsOperationMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateEntityDetailsTagsOperationMutation = { __typename: 'Mutation', updateEntityTags?: { __typename: 'UpdateEntityTags', data?: { __typename: 'EntityInterface', id: string, tags: Array<string> } | null } | null };

export type InsightAsideQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InsightAsideQuery = { __typename: 'Query', insight: { __typename: 'Insight', readableId: string, name: string, description: string, severity: InsightSeverityPyEnum, confidence?: number | null, uniqueSignalCount: number, signalCount: number, timestamp: any, created: any, tags: Array<string>, entity: { __typename: 'EntityInterface', id: string, entityType: string, entityTypeName: string, name: string, reputation?: string | null, reputationSources: Array<EntityReputationSource> }, relatedIncidents: Array<{ __typename: 'RelatedIncident', assignee?: string | null, id: number, link: string, name?: string | null, status?: string | null, type: string }>, signals: Array<{ __typename: 'Signal', id: string, timestamp: any }> } };

export type SignalAsideQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SignalAsideQuery = { __typename: 'Query', signal: { __typename: 'Signal', id: string, name: string, created: any, summary: string, severity: number, ruleId?: string | null, ruleType?: string | null, contentTypeEnum: ContentType, timestamp: any, suppressed?: boolean | null, isSuppressedBySuppressList: boolean, suppressedByNetworkBlock: boolean, isSuppressedByEntity: boolean, tags: Array<string>, entity: { __typename: 'EntityInterface', id: string, entityType: string, entityTypeName: string, name: string }, insights: Array<{ __typename: 'Insight', readableId: string, name: string }>, suppressedBySignal?: { __typename: 'Signal', id: string, name: string, contentTypeEnum: ContentType, insights: Array<{ __typename: 'Insight', readableId: string }> } | null } };

export type StartEntityTimelineJobMutationVariables = Exact<{
  entityId: Scalars['String']['input'];
  startTimestamp: Scalars['DateTime']['input'];
  endTimestamp: Scalars['DateTime']['input'];
  sortDir: SortDir;
  objectTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type StartEntityTimelineJobMutation = { __typename: 'Mutation', startEntityTimelineJob?: { __typename: 'StartEntityTimelineJob', jobId: string } | null };

export type StartEntityTimelineGroupRecordJobMutationVariables = Exact<{
  entityId: Scalars['String']['input'];
  startTimestamp: Scalars['DateTime']['input'];
  endTimestamp: Scalars['DateTime']['input'];
  summary: Scalars['String']['input'];
  objectTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type StartEntityTimelineGroupRecordJobMutation = { __typename: 'Mutation', startEntityTimelineGroupRecordJob?: { __typename: 'StartEntityTimelineGroupRecordJob', jobId: string } | null };

export type GetEntityTimelineGroupsQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetEntityTimelineGroupsQuery = { __typename: 'Query', entityTimelineGroups: Array<{ __typename: 'EntityTimelineGroup', startTimestamp: any, endTimestamp: any, summary: string, recordCount: number, uids: Array<string> }>, sumoRecordSearchJobStatus: { __typename: 'SumoSearchJobStatus', state: SumoSearchJobState, total: number } };

export type GetRecordGroupDetailsQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
}>;


export type GetRecordGroupDetailsQuery = { __typename: 'Query', sumoRecordSearchJobResults: Array<string>, sumoRecordSearchJobStatus: { __typename: 'SumoSearchJobStatus', state: SumoSearchJobState } };

export type EntityTimelineSignalInsightFragment = { __typename: 'Insight', name: string, readableId: string, severity: InsightSeverityPyEnum };

export type EntityTimelineSignalsFragment = { __typename: 'Signal', id: string, name: string, severity: number, allRecordsJson: string, insights: Array<{ __typename: 'Insight', name: string, readableId: string, severity: InsightSeverityPyEnum }> };

export type GetEntityTimelineSignalsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
}>;


export type GetEntityTimelineSignalsQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', signals: { __typename: 'SignalPage', total: number, objects: Array<{ __typename: 'Signal', id: string, name: string, severity: number, allRecordsJson: string, insights: Array<{ __typename: 'Insight', name: string, readableId: string, severity: InsightSeverityPyEnum }> }> } } };

export type EntityScoreQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type EntityScoreQueryOperationQuery = { __typename: 'Query', insightConfig?: { __typename: 'InsightConfig', threshold?: number | null } | null };

export type IndicatorQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
}>;


export type IndicatorQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', id: string, reputation?: string | null, reputationSources: Array<EntityReputationSource> } };

export type UploadEntityMutationsCsvMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadEntityMutationsCsvMutation = { __typename: 'Mutation', uploadEntityMutationsCsv?: { __typename: 'UploadEntityMutationsCsv', uploadedEntitiesCount: number } | null };

export type UpdateEntitySuppressionMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  suppressed: Scalars['Boolean']['input'];
}>;


export type UpdateEntitySuppressionMutation = { __typename: 'Mutation', updateEntityWhitelist?: { __typename: 'UpdateEntityWhitelist', data?: { __typename: 'EntityInterface', activityScore: number, criticality?: string | null, entityType: string, entityTypeName: string, id: string, isWhitelisted: boolean, lastSeen?: any | null, recentSignalSeverity: number, reputation?: string | null, reputationSources: Array<EntityReputationSource>, sensorZone?: string | null, tags: Array<string>, value: string, suppressListsObj: Array<{ __typename: 'SuppressList', id: string, name: string }> } | null } | null };

export type EntityListFragment = { __typename: 'EntityInterface', activityScore: number, criticality?: string | null, entityType: string, entityTypeName: string, id: string, isWhitelisted: boolean, lastSeen?: any | null, recentSignalSeverity: number, reputation?: string | null, reputationSources: Array<EntityReputationSource>, sensorZone?: string | null, tags: Array<string>, value: string, suppressListsObj: Array<{ __typename: 'SuppressList', id: string, name: string }> };

export type EntityListQueryOperationQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort: EntitySortableField;
  sortDir: SortDir;
}>;


export type EntityListQueryOperationQuery = { __typename: 'Query', insightConfig?: { __typename: 'InsightConfig', threshold?: number | null } | null, entities: { __typename: 'EntityPage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'EntityInterface', activityScore: number, criticality?: string | null, entityType: string, entityTypeName: string, id: string, isWhitelisted: boolean, lastSeen?: any | null, recentSignalSeverity: number, reputation?: string | null, reputationSources: Array<EntityReputationSource>, sensorZone?: string | null, tags: Array<string>, value: string, suppressListsObj: Array<{ __typename: 'SuppressList', id: string, name: string }> }> } };

export type EntityDetailsAuditLogFragment = { __typename: 'EntityAuditLog', id: string, action: EntityAuditLogAction, timestamp: any, suppressedComment?: string | null, metaJson: string, user: { __typename: 'User', id: string, email?: string | null, displayName: string } };

export type EntityDetailsAuditLogQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityDetailsAuditLogQueryOperationQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', id: string, auditLog: Array<{ __typename: 'EntityAuditLog', id: string, action: EntityAuditLogAction, timestamp: any, suppressedComment?: string | null, metaJson: string, user: { __typename: 'User', id: string, email?: string | null, displayName: string } }> } };

export type EntityCriticalityConfigListFragment = { __typename: 'EntityCriticalityConfig', id: string, name: string, severityExpression: string };

export type EntityCriticalityConfigListQueryVariables = Exact<{ [key: string]: never; }>;


export type EntityCriticalityConfigListQuery = { __typename: 'Query', entityCriticalityConfigs: { __typename: 'EntityCriticalityConfigPage', total: number, objects: Array<{ __typename: 'EntityCriticalityConfig', id: string, name: string, severityExpression: string }> } };

export type InventoryLookupOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type InventoryLookupOperationQuery = { __typename: 'Query', inventoryLookupTableSources: Array<string> };

export type HudRadarQueryOperationQueryVariables = Exact<{
  start: Scalars['DateTime']['input'];
  end?: InputMaybe<Scalars['DateTime']['input']>;
  insightBucket: Scalars['TimeDelta']['input'];
  signalBucket: Scalars['TimeDelta']['input'];
  recordBucket: Scalars['TimeDelta']['input'];
}>;


export type HudRadarQueryOperationQuery = { __typename: 'Query', insightCountsByStatus: Array<{ __typename: 'InsightCountsByStatusDataPoint', timestamp: any, value: { __typename: 'InsightCountByStatus', closed: number, inProgress: number, new: number, other: number, otherDetail?: Array<{ __typename: 'CustomStatusCount', statusName: string, statusId: number, count: number }> | null } }>, insightStatuses: Array<{ __typename: 'InsightStatus', id: string, color?: string | null, source: string }>, recordCounts: Array<{ __typename: 'BigIntDataPoint', timestamp: any, value: any }>, signalCounts: Array<{ __typename: 'BigIntDataPoint', timestamp: any, value: any }> };

export type InsightActivityFeedQueryOperationQueryVariables = Exact<{
  nextPageTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type InsightActivityFeedQueryOperationQuery = { __typename: 'Query', insightActivityFeedEvents: { __typename: 'InsightActivityFeedEventPage', nextPageTimestamp?: any | null, objects: Array<{ __typename: 'InsightActivityFeedEvent', timestamp: any, insightId: string, insightName: string, action: { __typename: 'InsightAssigneeUpdatedAction', assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam', name: string } | { __typename: 'UnknownUser', username: string } | { __typename: 'User', id: string, displayName: string } | null } | { __typename: 'InsightCommentAddedAction', body: string } | { __typename: 'InsightCreatedAction', source: AlertSource } | { __typename: 'InsightStatusUpdatedAction', status: { __typename: 'InsightStatus', displayName: string } }, user?: { __typename: 'User', id: string, email?: string | null, displayName: string } | null }> } };

export type InsightCountsQueryOperationQueryVariables = Exact<{
  start: Scalars['DateTime']['input'];
  end?: InputMaybe<Scalars['DateTime']['input']>;
  insightBucket: Scalars['TimeDelta']['input'];
  insightClosedBucket: Scalars['TimeDelta']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type InsightCountsQueryOperationQuery = { __typename: 'Query', insightCounts: Array<{ __typename: 'BigIntDataPoint', timestamp: any, value: any }>, insightClosedCounts: Array<{ __typename: 'BigIntDataPoint', timestamp: any, value: any }> };

export type InsightMetricsQueryOperationQueryVariables = Exact<{
  interval: Scalars['TimeDelta']['input'];
}>;


export type InsightMetricsQueryOperationQuery = { __typename: 'Query', meanTimeToDetection?: any | null, meanTimeToResponse?: any | null, meanTimeToRemediation?: any | null };

export type InsightStatusMetricsStatusFragment = { __typename: 'InsightStatus', name: string, id: string, displayName: string, color?: string | null };

export type InsightStatusMetricsFragment = { __typename: 'InsightCountsByStatusDataPoint', timestamp: any, value: { __typename: 'InsightCountByStatus', closed: number, inProgress: number, new: number, other: number, otherDetail?: Array<{ __typename: 'CustomStatusCount', statusId: number, statusName: string, count: number }> | null } };

export type InsightStatusMetricsQueryVariables = Exact<{
  start: Scalars['DateTime']['input'];
  end?: InputMaybe<Scalars['DateTime']['input']>;
  insightBucket: Scalars['TimeDelta']['input'];
}>;


export type InsightStatusMetricsQuery = { __typename: 'Query', insightCountsByStatus: Array<{ __typename: 'InsightCountsByStatusDataPoint', timestamp: any, value: { __typename: 'InsightCountByStatus', closed: number, inProgress: number, new: number, other: number, otherDetail?: Array<{ __typename: 'CustomStatusCount', statusId: number, statusName: string, count: number }> | null } }>, insightStatuses: Array<{ __typename: 'InsightStatus', name: string, id: string, displayName: string, color?: string | null }> };

export type PipelineMetricsOperationQueryVariables = Exact<{
  interval?: InputMaybe<Scalars['TimeDelta']['input']>;
}>;


export type PipelineMetricsOperationQuery = { __typename: 'Query', records: { __typename: 'BigIntCountWithDelta', count?: any | null, delta?: number | null }, signals: { __typename: 'BigIntCountWithDelta', count?: any | null, delta?: number | null }, insights: { __typename: 'BigIntCountWithDelta', count?: any | null, delta?: number | null } };

export type TopEntitiesQueryOperationQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<EntitySort> | EntitySort>;
}>;


export type TopEntitiesQueryOperationQuery = { __typename: 'Query', entities: { __typename: 'EntityPage', objects: Array<{ __typename: 'EntityInterface', currentStateSignalIds: Array<string>, entityTypeName: string, entityType: string, id: string, name: string, recentSignalSeverity: number, reputation?: string | null, reputationSources: Array<EntityReputationSource> }> }, insightConfig?: { __typename: 'InsightConfig', lookbackDays?: number | null } | null };

export type TopInsightQueryOperationQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InsightSort> | InsightSort>;
  enableAIInsightSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableAgenticSecOps?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TopInsightQueryOperationQuery = { __typename: 'Query', insights: { __typename: 'InsightPage', objects: Array<{ __typename: 'Insight', deployment: string, tenant: string, tenantName: string, tenantUrl?: string | null, created: any, description: string, id: string, readableId: string, name: string, signalCount: number, uniqueSignalCount: number, severity: InsightSeverityPyEnum, confidence?: number | null, resolution?: string | null, summary?: string | null, subResolution?: string | null, tags: Array<string>, lastUpdated?: any | null, timestamp: any, source: AlertSource, entity: { __typename: 'EntityInterface', isWhitelisted: boolean, id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, signals: Array<{ __typename: 'Signal', contentType?: string | null, id: string, name: string, severity: number, timestamp: any }>, status: { __typename: 'InsightStatusName', id: string, name: string, displayName: string }, triage?: { __typename: 'Triage', id: string, insightID: string, verdict: TriageVerdict, summary?: string | null, recommendation?: { __typename: 'TriageRecommendation', accepted?: boolean | null, severity: InsightSeverityPyEnum } | null, keyEvidences: Array<{ __typename: 'KeyEvidence', id: string, title: string, reasoning: string, verdict: SimpleVerdict }> } | null, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam', name: string } | { __typename: 'UnknownUser', username: string } | { __typename: 'User', id: string, displayName: string, username: string, email?: string | null } | null }> } };

export type InsightAutomationsQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type InsightAutomationsQueryOperationQuery = { __typename: 'Query', automations: { __typename: 'AutomationPage', objects: Array<{ __typename: 'Automation', description?: string | null, enabled: boolean, executionTypes: Array<string>, id: string, name: string, playbookId: string }> } };

export type ExecuteInsightAutomationOperationMutationVariables = Exact<{
  fields: ExecuteAutomationFields;
}>;


export type ExecuteInsightAutomationOperationMutation = { __typename: 'Mutation', executeAutomation?: { __typename: 'ExecuteAutomation', executionIds?: Array<string> | null, playbooksWithErrors?: Array<string> | null } | null };

export type DeleteInsightCommentOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteInsightCommentOperationMutation = { __typename: 'Mutation', deleteInsightComment?: { __typename: 'DeleteInsightComment', ok: boolean } | null };

export type AddToIncidentDialogOperationQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type AddToIncidentDialogOperationQuery = { __typename: 'Query', incidentSearchResults: Array<{ __typename: 'IncidentSearchResult', id: number, name: string }> };

export type AddInsightToIncidentOperationMutationVariables = Exact<{
  insightId: Scalars['ID']['input'];
  incidentId: Scalars['Int']['input'];
  enableAIInsightSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableAgenticSecOps?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddInsightToIncidentOperationMutation = { __typename: 'Mutation', addInsightToIncident?: { __typename: 'AddInsightToIncident', data: { __typename: 'Insight', deployment: string, tenant: string, tenantName: string, tenantUrl?: string | null, created: any, description: string, id: string, readableId: string, name: string, signalCount: number, uniqueSignalCount: number, severity: InsightSeverityPyEnum, confidence?: number | null, resolution?: string | null, summary?: string | null, subResolution?: string | null, tags: Array<string>, lastUpdated?: any | null, timestamp: any, source: AlertSource, entity: { __typename: 'EntityInterface', isWhitelisted: boolean, id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, signals: Array<{ __typename: 'Signal', contentType?: string | null, id: string, name: string, severity: number, timestamp: any }>, status: { __typename: 'InsightStatusName', id: string, name: string, displayName: string }, triage?: { __typename: 'Triage', id: string, insightID: string, verdict: TriageVerdict, summary?: string | null, recommendation?: { __typename: 'TriageRecommendation', accepted?: boolean | null, severity: InsightSeverityPyEnum } | null, keyEvidences: Array<{ __typename: 'KeyEvidence', id: string, title: string, reasoning: string, verdict: SimpleVerdict }> } | null, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam', name: string } | { __typename: 'UnknownUser', username: string } | { __typename: 'User', id: string, displayName: string, username: string, email?: string | null } | null } } | null };

export type CreateIncidentFromInsightOperationMutationVariables = Exact<{
  insightId: Scalars['ID']['input'];
  incidentTemplateId: Scalars['Int']['input'];
  enableAIInsightSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableAgenticSecOps?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateIncidentFromInsightOperationMutation = { __typename: 'Mutation', createIncidentFromInsight?: { __typename: 'CreateIncidentFromInsight', data: { __typename: 'Insight', deployment: string, tenant: string, tenantName: string, tenantUrl?: string | null, created: any, description: string, id: string, readableId: string, name: string, signalCount: number, uniqueSignalCount: number, severity: InsightSeverityPyEnum, confidence?: number | null, resolution?: string | null, summary?: string | null, subResolution?: string | null, tags: Array<string>, lastUpdated?: any | null, timestamp: any, source: AlertSource, entity: { __typename: 'EntityInterface', isWhitelisted: boolean, id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, signals: Array<{ __typename: 'Signal', contentType?: string | null, id: string, name: string, severity: number, timestamp: any }>, status: { __typename: 'InsightStatusName', id: string, name: string, displayName: string }, triage?: { __typename: 'Triage', id: string, insightID: string, verdict: TriageVerdict, summary?: string | null, recommendation?: { __typename: 'TriageRecommendation', accepted?: boolean | null, severity: InsightSeverityPyEnum } | null, keyEvidences: Array<{ __typename: 'KeyEvidence', id: string, title: string, reasoning: string, verdict: SimpleVerdict }> } | null, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam', name: string } | { __typename: 'UnknownUser', username: string } | { __typename: 'User', id: string, displayName: string, username: string, email?: string | null } | null } } | null };

export type AddTagToInsightOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  tagName: Scalars['String']['input'];
}>;


export type AddTagToInsightOperationMutation = { __typename: 'Mutation', addTagToInsight?: { __typename: 'AddTagToInsight', data: { __typename: 'Insight', id: string, tags: Array<string> } } | null };

export type RemoveTagFromInsightOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  tagName: Scalars['String']['input'];
}>;


export type RemoveTagFromInsightOperationMutation = { __typename: 'Mutation', removeTagFromInsight?: { __typename: 'RemoveTagFromInsight', data: { __typename: 'Insight', id: string, tags: Array<string> } } | null };

export type UpdateInsightOperationMutationVariables = Exact<{
  fields: InsightEditableFields;
  id: Scalars['ID']['input'];
  addComment: Scalars['Boolean']['input'];
  commentBody: Scalars['String']['input'];
}>;


export type UpdateInsightOperationMutation = { __typename: 'Mutation', addInsightComment?: { __typename: 'AddInsightComment', data: { __typename: 'InsightComment', id: string } } | null, updateInsight?: { __typename: 'UpdateInsight', data: { __typename: 'Insight', id: string, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam' } | { __typename: 'UnknownUser' } | { __typename: 'User', id: string, displayName: string, username: string } | null, status: { __typename: 'InsightStatusName', name: string, displayName: string }, comments: Array<{ __typename: 'InsightComment', body: string, id: string, timestamp: any, user?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null }>, history: Array<{ __typename: 'InsightHistoryEvent', timestamp: any, body: string, user?: { __typename: 'User', id: string, name?: string | null, email?: string | null, username: string } | null }> } } | null };

export type ExecuteActionOperationMutationVariables = Exact<{
  insightId: Scalars['ID']['input'];
  actionId: Scalars['ID']['input'];
  parameterValues?: InputMaybe<Array<ActionParameterValue> | ActionParameterValue>;
}>;


export type ExecuteActionOperationMutation = { __typename: 'Mutation', executeAction?: { __typename: 'ExecuteAction', ok: boolean } | null };

export type AddInsightCommentOperationMutationVariables = Exact<{
  body: Scalars['String']['input'];
  insightId: Scalars['ID']['input'];
}>;


export type AddInsightCommentOperationMutation = { __typename: 'Mutation', addInsightComment?: { __typename: 'AddInsightComment', data: { __typename: 'InsightComment', id: string, timestamp: any, body: string, author?: { __typename: 'User', id: string } | null } } | null };

export type DeleteInsightOperationMutationVariables = Exact<{
  insightId: Scalars['ID']['input'];
}>;


export type DeleteInsightOperationMutation = { __typename: 'Mutation', deleteInsight?: { __typename: 'DeleteInsight', data: string } | null };

export type VisitInsightPageOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type VisitInsightPageOperationMutation = { __typename: 'Mutation', visitInsightPage?: { __typename: 'VisitInsightPage', data: Array<{ __typename: 'VisitedEntityPage', timestamp: any } | { __typename: 'VisitedInsightPage', timestamp: any } | { __typename: 'VisitedSignalPage', timestamp: any }> } | null };

export type InsightEntityActivityQueryOperationQueryVariables = Exact<{
  insightId: Scalars['ID']['input'];
}>;


export type InsightEntityActivityQueryOperationQuery = { __typename: 'Query', insightEntityActivity: Array<{ __typename: 'InsightEntityActivity', entityId: string, relatedEntityIds: Array<string>, isPrimaryEntity: boolean }> };

export type InsightEntitiesByListIdsQueryOperationQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type InsightEntitiesByListIdsQueryOperationQuery = { __typename: 'Query', entitiesByListIds?: Array<{ __typename: 'EntityInterface', id: string, entityType: string, entityTypeName: string, value: string }> | null };

export type InsightEntityAutomationsQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type InsightEntityAutomationsQueryOperationQuery = { __typename: 'Query', automations: { __typename: 'AutomationPage', objects: Array<{ __typename: 'Automation', cseResourceSubTypes?: Array<string> | null, description?: string | null, enabled: boolean, executionTypes: Array<string>, id: string, name: string, playbookId: string }> } };

export type ExecuteInsightEntityAutomationOperationMutationVariables = Exact<{
  fields: ExecuteAutomationFields;
}>;


export type ExecuteInsightEntityAutomationOperationMutation = { __typename: 'Mutation', executeAutomation?: { __typename: 'ExecuteAutomation', executionIds?: Array<string> | null, playbooksWithErrors?: Array<string> | null } | null };

export type InsightEntityDetailsQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  detectionWindowStartTime: Scalars['DateTime']['input'];
  detectionWindowEndTime: Scalars['DateTime']['input'];
}>;


export type InsightEntityDetailsQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', entityType: string, entityTypeName: string, id: string, recentSignalSeverity: number, sensorZone?: string | null, reputation?: string | null, reputationSources: Array<EntityReputationSource>, tags: Array<string>, value: string, insights: { __typename: 'InsightPage', total: number }, signals: { __typename: 'SignalPage', total: number } } };

export type InsightEntityFragment = { __typename: 'EntityInterface', id: string, entityType: string, entityTypeName: string, reputation?: string | null, value: string };

export type EntityWithRelatedEntitiesFragment = { __typename: 'EntityInterface', id: string, entityType: string, entityTypeName: string, reputation?: string | null, value: string, relatedEntities: Array<{ __typename: 'EntityInterface', id: string, entityType: string, entityTypeName: string, reputation?: string | null, value: string }> };

export type InsightEntityWithRelationsFragment = { __typename: 'EntityInterface', id: string, relatedEntities: Array<{ __typename: 'EntityInterface', id: string, entityType: string, entityTypeName: string, reputation?: string | null, value: string }>, involvedEntities: Array<{ __typename: 'EntityInterface', id: string, entityType: string, entityTypeName: string, reputation?: string | null, value: string }> };

export type EntityRelationshipsByIdsQueryVariables = Exact<{
  entityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
  entityTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type EntityRelationshipsByIdsQuery = { __typename: 'Query', entitiesByListIds?: Array<{ __typename: 'EntityInterface', id: string, relatedEntities: Array<{ __typename: 'EntityInterface', id: string, entityType: string, entityTypeName: string, reputation?: string | null, value: string }>, involvedEntities: Array<{ __typename: 'EntityInterface', id: string, entityType: string, entityTypeName: string, reputation?: string | null, value: string }> }> | null };

export type EntitiesDetailsQueryVariables = Exact<{
  entityIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type EntitiesDetailsQuery = { __typename: 'Query', entitiesByListIds?: Array<{ __typename: 'EntityInterface', id: string, entityType: string, entityTypeName: string, reputation?: string | null, value: string }> | null };

export type InsightEntityActivityQueryVariables = Exact<{
  insightId: Scalars['ID']['input'];
}>;


export type InsightEntityActivityQuery = { __typename: 'Query', insightEntityActivity: Array<{ __typename: 'InsightEntityActivity', entityId: string, relatedEntityIds: Array<string>, involvedSignalIds: Array<string>, isPrimaryEntity: boolean }> };

export type RelatedEntitiesCountQueryVariables = Exact<{
  insightId: Scalars['ID']['input'];
}>;


export type RelatedEntitiesCountQuery = { __typename: 'Query', insightEntityActivity: Array<{ __typename: 'InsightEntityActivity', entityId: string, relatedEntityIds: Array<string> }> };

export type InsightsListForSelectQueryOperationQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
}>;


export type InsightsListForSelectQueryOperationQuery = { __typename: 'Query', insights: { __typename: 'InsightPage', total: number, objects: Array<{ __typename: 'Insight', readableId: string, name: string, timestamp: any }> } };

export type UpdateInsightResolutionOperationMutationVariables = Exact<{
  fields: InsightEditableFields;
  id: Scalars['ID']['input'];
  addComment: Scalars['Boolean']['input'];
  commentBody: Scalars['String']['input'];
}>;


export type UpdateInsightResolutionOperationMutation = { __typename: 'Mutation', addInsightComment?: { __typename: 'AddInsightComment', data: { __typename: 'InsightComment', id: string } } | null, updateInsight?: { __typename: 'UpdateInsight', data: { __typename: 'Insight', id: string, resolution?: string | null, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam' } | { __typename: 'UnknownUser' } | { __typename: 'User', id: string, displayName: string, username: string } | null, status: { __typename: 'InsightStatusName', name: string, displayName: string } } } | null };

export type UpdateInsightsResolutionOperationMutationVariables = Exact<{
  fields: InsightEditableFields;
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  addComment: Scalars['Boolean']['input'];
  commentBody: Scalars['String']['input'];
}>;


export type UpdateInsightsResolutionOperationMutation = { __typename: 'Mutation', addInsightCommentsById?: { __typename: 'AddInsightCommentsById', ok: boolean } | null, updateInsightsById?: { __typename: 'UpdateInsightsById', ok: boolean } | null };

export type RemoveSignalsMutationOperationMutationVariables = Exact<{
  signalIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  insightId: Scalars['ID']['input'];
}>;


export type RemoveSignalsMutationOperationMutation = { __typename: 'Mutation', removeSignalsFromInsight?: { __typename: 'RemoveSignalsFromInsight', data: { __typename: 'Insight', signals: Array<{ __typename: 'Signal', allRecordsJson: string, description?: string | null, id: string, name: string, recordCount: number, ruleType?: string | null, ruleId?: string | null, severity: number, prototype?: boolean | null, suppressedBy?: string | null, isSuppressedBySuppressList: boolean, suppressedByNetworkBlock: boolean, isSuppressedByEntity: boolean, timestamp: any, summary: string, tags: Array<string>, contentType: ContentType, entity: { __typename: 'EntityInterface', id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null } }>, relatedSignals?: Array<{ __typename: 'Signal', allRecordsJson: string, description?: string | null, id: string, name: string, recordCount: number, ruleType?: string | null, ruleId?: string | null, severity: number, prototype?: boolean | null, suppressedBy?: string | null, isSuppressedBySuppressList: boolean, suppressedByNetworkBlock: boolean, isSuppressedByEntity: boolean, timestamp: any, summary: string, tags: Array<string>, contentType: ContentType, entity: { __typename: 'EntityInterface', id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null } }> | null } } | null };

export type AddSignalsMutationOperationMutationVariables = Exact<{
  signalId: Scalars['ID']['input'];
  insightId: Scalars['ID']['input'];
}>;


export type AddSignalsMutationOperationMutation = { __typename: 'Mutation', addSignalsToInsight?: { __typename: 'AddSignalsToInsight', data: { __typename: 'Insight', signals: Array<{ __typename: 'Signal', allRecordsJson: string, description?: string | null, id: string, name: string, recordCount: number, ruleType?: string | null, ruleId?: string | null, severity: number, prototype?: boolean | null, suppressedBy?: string | null, isSuppressedBySuppressList: boolean, suppressedByNetworkBlock: boolean, isSuppressedByEntity: boolean, timestamp: any, summary: string, tags: Array<string>, contentType: ContentType, entity: { __typename: 'EntityInterface', id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null } }>, relatedSignals?: Array<{ __typename: 'Signal', allRecordsJson: string, description?: string | null, id: string, name: string, recordCount: number, ruleType?: string | null, ruleId?: string | null, severity: number, prototype?: boolean | null, suppressedBy?: string | null, isSuppressedBySuppressList: boolean, suppressedByNetworkBlock: boolean, isSuppressedByEntity: boolean, timestamp: any, summary: string, tags: Array<string>, contentType: ContentType, entity: { __typename: 'EntityInterface', id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null } }> | null } } | null };

export type SignalFragment = { __typename: 'Signal', allRecordsJson: string, description?: string | null, id: string, name: string, recordCount: number, ruleType?: string | null, ruleId?: string | null, severity: number, prototype?: boolean | null, suppressedBy?: string | null, isSuppressedBySuppressList: boolean, suppressedByNetworkBlock: boolean, isSuppressedByEntity: boolean, timestamp: any, summary: string, tags: Array<string>, contentType: ContentType, entity: { __typename: 'EntityInterface', id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null } };

export type InsightDetailRelatedInsightFragment = { __typename: 'Insight', id: string, deployment: string, tenant: string, name: string, readableId: string, tenantUrl?: string | null, created: any, signals: Array<{ __typename: 'Signal', id: string }> };

export type InsightSignalsQueryVariables = Exact<{
  insightId: Scalars['ID']['input'];
}>;


export type InsightSignalsQuery = { __typename: 'Query', insight: { __typename: 'Insight', signals: Array<{ __typename: 'Signal', allRecordsJson: string, description?: string | null, id: string, name: string, recordCount: number, ruleType?: string | null, ruleId?: string | null, severity: number, prototype?: boolean | null, suppressedBy?: string | null, isSuppressedBySuppressList: boolean, suppressedByNetworkBlock: boolean, isSuppressedByEntity: boolean, timestamp: any, summary: string, tags: Array<string>, contentType: ContentType, entity: { __typename: 'EntityInterface', id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null } }> } };

export type RelatedInsightSignalsQueryVariables = Exact<{
  insightId: Scalars['ID']['input'];
}>;


export type RelatedInsightSignalsQuery = { __typename: 'Query', insight: { __typename: 'Insight', id: string, readableId: string, relatedSignals?: Array<{ __typename: 'Signal', allRecordsJson: string, description?: string | null, id: string, name: string, recordCount: number, ruleType?: string | null, ruleId?: string | null, severity: number, prototype?: boolean | null, suppressedBy?: string | null, isSuppressedBySuppressList: boolean, suppressedByNetworkBlock: boolean, isSuppressedByEntity: boolean, timestamp: any, summary: string, tags: Array<string>, contentType: ContentType, entity: { __typename: 'EntityInterface', id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null } }> | null, relatedInsights?: Array<{ __typename: 'Insight', id: string, deployment: string, tenant: string, name: string, readableId: string, tenantUrl?: string | null, created: any, signals: Array<{ __typename: 'Signal', id: string }> }> | null } };

export type RelatedSignalTimelineQueryVariables = Exact<{
  insightId: Scalars['ID']['input'];
  includeRelated: Scalars['Boolean']['input'];
}>;


export type RelatedSignalTimelineQuery = { __typename: 'Query', insight: { __typename: 'Insight', id: string, readableId: string, relatedSignals?: Array<{ __typename: 'Signal', contentType?: string | null, description?: string | null, id: string, name: string, severity: number, timestamp: any }> | null, signals: Array<{ __typename: 'Signal', contentType?: string | null, description?: string | null, id: string, name: string, severity: number, timestamp: any }> } };

export type SignalTimelineFragment = { __typename: 'Signal', contentType?: string | null, description?: string | null, id: string, name: string, severity: number, timestamp: any };

export type GetLinkableSignalsQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
}>;


export type GetLinkableSignalsQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', id: string, signals: Array<{ __typename: 'Signal', id: string, name: string, timestamp: any }> } };

export type InsightCommentFragment = { __typename: 'InsightComment', body: string, id: string, timestamp: any, user?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null };

export type InsightCommentsFragment = { __typename: 'Insight', comments: Array<{ __typename: 'InsightComment', body: string, id: string, timestamp: any, user?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null }> };

export type InsightHistoryEventFragment = { __typename: 'InsightHistoryEvent', timestamp: any, body: string, user?: { __typename: 'User', id: string, name?: string | null, email?: string | null, username: string } | null };

export type InsightHistoryEventsFragment = { __typename: 'Insight', history: Array<{ __typename: 'InsightHistoryEvent', timestamp: any, body: string, user?: { __typename: 'User', id: string, name?: string | null, email?: string | null, username: string } | null }> };

export type InsightHistoryQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InsightHistoryQueryOperationQuery = { __typename: 'Query', insight: { __typename: 'Insight', id: string, history: Array<{ __typename: 'InsightHistoryEvent', timestamp: any, body: string, user?: { __typename: 'User', id: string, name?: string | null, email?: string | null, username: string } | null }> } };

export type InsightCommentsQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InsightCommentsQueryOperationQuery = { __typename: 'Query', insight: { __typename: 'Insight', id: string, comments: Array<{ __typename: 'InsightComment', body: string, id: string, timestamp: any, user?: { __typename: 'User', email?: string | null, id: string, name?: string | null, username: string } | null }> } };

export type InsightExecutedAutomationsCountQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InsightExecutedAutomationsCountQueryOperationQuery = { __typename: 'Query', insight: { __typename: 'Insight', id: string, executedAutomations: Array<{ __typename: 'ExecutedAutomation', executionId: string, statusCode?: number | null }> } };

export type InsightDetailSignalFragment = { __typename: 'Signal', allRecordsJson: string, description?: string | null, id: string, name: string, recordCount: number, ruleType?: string | null, severity: number, prototype?: boolean | null, suppressedBy?: string | null, isSuppressedBySuppressList: boolean, suppressedByNetworkBlock: boolean, isSuppressedByEntity: boolean, timestamp: any, summary: string, tags: Array<string>, contentType: ContentType };

type InsightDetailAssigneeFragment_Team = { __typename: 'Team', id: string, name: string };

type InsightDetailAssigneeFragment_UnknownTeam = { __typename: 'UnknownTeam' };

type InsightDetailAssigneeFragment_UnknownUser = { __typename: 'UnknownUser' };

type InsightDetailAssigneeFragment_User = { __typename: 'User', id: string, displayName: string, username: string };

export type InsightDetailAssigneeFragment = InsightDetailAssigneeFragment_Team | InsightDetailAssigneeFragment_UnknownTeam | InsightDetailAssigneeFragment_UnknownUser | InsightDetailAssigneeFragment_User;

export type InsightDetailInsightFragment = { __typename: 'Insight', description: string, insightSignalSeverityTotal: number, signalCount: number, source: AlertSource, uniqueSignalCount: number, resolution?: string | null, subResolution?: string | null, id: string, name: string, readableId: string, severity: InsightSeverityPyEnum, originalSeverity?: InsightSeverityPyEnum | null, confidence?: number | null, tags: Array<string>, timestamp: any, created: any, summary?: string | null, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam' } | { __typename: 'UnknownUser' } | { __typename: 'User', id: string, displayName: string, username: string } | null, duplicateInsight?: { __typename: 'Insight', id: string, name: string } | null, enrichments: Array<{ __typename: 'Enrichment', type: string, enrichedObjId: string, enrichedObjType: string, raw?: string | null, detailJson: string, externalUrl?: string | null, reputation?: string | null, expiresAt?: any | null }>, relatedEnrichments: Array<{ __typename: 'Enrichment', type: string, enrichedObjId: string, enrichedObjType: string, raw?: string | null, detailJson: string, externalUrl?: string | null, reputation?: string | null, expiresAt?: any | null }>, entity: { __typename: 'EntityInterface', recentSignalSeverity: number, reputation?: string | null, reputationSources: Array<EntityReputationSource>, id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, recordDateTimeRange: { __typename: 'DateTimeRange', start: any, end: any }, signals: Array<{ __typename: 'Signal', allRecordsJson: string, description?: string | null, id: string, name: string, recordCount: number, ruleType?: string | null, severity: number, prototype?: boolean | null, suppressedBy?: string | null, isSuppressedBySuppressList: boolean, suppressedByNetworkBlock: boolean, isSuppressedByEntity: boolean, timestamp: any, summary: string, tags: Array<string>, contentType: ContentType }>, status: { __typename: 'InsightStatusName', name: string, displayName: string }, triage?: { __typename: 'Triage', id: string, insightID: string, verdict: TriageVerdict, summary?: string | null, recommendation?: { __typename: 'TriageRecommendation', accepted?: boolean | null, severity: InsightSeverityPyEnum } | null, keyEvidences: Array<{ __typename: 'KeyEvidence', id: string, title: string, reasoning: string, verdict: SimpleVerdict }> } | null };

export type InsightDetailActionFragment = { __typename: 'Action', configurationJson: any, createdTime: any, id: string, name: string, notificationTypes: any, type: string, enabled: boolean, parameters: Array<{ __typename: 'ActionParameter', name: string, displayName: string, required: boolean }> };

export type InsightThresholdConfigFragment = { __typename: 'InsightConfig', threshold?: number | null };

export type InsightQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  enableAIInsightSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableAgenticSecOps?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InsightQueryOperationQuery = { __typename: 'Query', actions: Array<{ __typename: 'Action', configurationJson: any, createdTime: any, id: string, name: string, notificationTypes: any, type: string, enabled: boolean, parameters: Array<{ __typename: 'ActionParameter', name: string, displayName: string, required: boolean }> }>, insight: { __typename: 'Insight', description: string, insightSignalSeverityTotal: number, signalCount: number, source: AlertSource, uniqueSignalCount: number, resolution?: string | null, subResolution?: string | null, id: string, name: string, readableId: string, severity: InsightSeverityPyEnum, originalSeverity?: InsightSeverityPyEnum | null, confidence?: number | null, tags: Array<string>, timestamp: any, created: any, summary?: string | null, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam' } | { __typename: 'UnknownUser' } | { __typename: 'User', id: string, displayName: string, username: string } | null, duplicateInsight?: { __typename: 'Insight', id: string, name: string } | null, enrichments: Array<{ __typename: 'Enrichment', type: string, enrichedObjId: string, enrichedObjType: string, raw?: string | null, detailJson: string, externalUrl?: string | null, reputation?: string | null, expiresAt?: any | null }>, relatedEnrichments: Array<{ __typename: 'Enrichment', type: string, enrichedObjId: string, enrichedObjType: string, raw?: string | null, detailJson: string, externalUrl?: string | null, reputation?: string | null, expiresAt?: any | null }>, entity: { __typename: 'EntityInterface', recentSignalSeverity: number, reputation?: string | null, reputationSources: Array<EntityReputationSource>, id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, recordDateTimeRange: { __typename: 'DateTimeRange', start: any, end: any }, signals: Array<{ __typename: 'Signal', allRecordsJson: string, description?: string | null, id: string, name: string, recordCount: number, ruleType?: string | null, severity: number, prototype?: boolean | null, suppressedBy?: string | null, isSuppressedBySuppressList: boolean, suppressedByNetworkBlock: boolean, isSuppressedByEntity: boolean, timestamp: any, summary: string, tags: Array<string>, contentType: ContentType }>, status: { __typename: 'InsightStatusName', name: string, displayName: string }, triage?: { __typename: 'Triage', id: string, insightID: string, verdict: TriageVerdict, summary?: string | null, recommendation?: { __typename: 'TriageRecommendation', accepted?: boolean | null, severity: InsightSeverityPyEnum } | null, keyEvidences: Array<{ __typename: 'KeyEvidence', id: string, title: string, reasoning: string, verdict: SimpleVerdict }> } | null }, insightConfig?: { __typename: 'InsightConfig', threshold?: number | null } | null, teams: { __typename: 'TeamPage', hasNextPage: boolean, total: number, objects: Array<{ __typename: 'Team', id: string, name: string }> }, users: { __typename: 'UserPage', hasNextPage: boolean, total: number, objects: Array<{ __typename: 'User', id: string, name?: string | null, email?: string | null, username: string }> } };

export type EntityRecentSignalFragment = { __typename: 'Signal', id: string, name: string, recordCount: number, contentType?: string | null, severity: number, timestamp: any };

export type EntityRecentSignalsQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
}>;


export type EntityRecentSignalsQueryOperationQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', id: string, signals: { __typename: 'SignalPage', total: number, objects: Array<{ __typename: 'Signal', id: string, name: string, recordCount: number, contentType?: string | null, severity: number, timestamp: any }> } } };

export type EntityRecentInsightsQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
  limit: Scalars['Int']['input'];
}>;


export type EntityRecentInsightsQueryOperationQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', id: string, insights: { __typename: 'InsightPage', objects: Array<{ __typename: 'Insight', readableId: string, created: any, name: string, uniqueSignalCount: number, signalCount: number, severity: InsightSeverityPyEnum }> } } };

export type AddInsightCommentsByIdOperationMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  commentBody: Scalars['String']['input'];
}>;


export type AddInsightCommentsByIdOperationMutation = { __typename: 'Mutation', addInsightCommentsById?: { __typename: 'AddInsightCommentsById', ok: boolean } | null };

export type GroupedInsightFragment = { __typename: 'Insight', deployment: string, tenant: string, tenantName: string, tenantUrl?: string | null, id: string, name: string, readableId: string, signalCount: number, severity: InsightSeverityPyEnum, confidence?: number | null, timestamp: any, resolution?: string | null, subResolution?: string | null, entity: { __typename: 'EntityInterface', id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, signals: Array<{ __typename: 'Signal', id: string, name: string, timestamp: any }>, status: { __typename: 'InsightStatusName', name: string, displayName: string }, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam', name: string } | { __typename: 'UnknownUser', username: string } | { __typename: 'User', id: string, displayName: string, username: string, email?: string | null } | null };

export type GroupedInsightsQueryOperationQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort: InsightSortableField;
  sortDir: SortDir;
  groups?: InputMaybe<Array<InsightGroupOffset> | InsightGroupOffset>;
}>;


export type GroupedInsightsQueryOperationQuery = { __typename: 'Query', groupedInsights: Array<{ __typename: 'GroupedInsightPage', total: number, hasNextPage: boolean, status: { __typename: 'InsightStatus', id: string, name: string, displayName: string }, objects: Array<{ __typename: 'Insight', deployment: string, tenant: string, tenantName: string, tenantUrl?: string | null, id: string, name: string, readableId: string, signalCount: number, severity: InsightSeverityPyEnum, confidence?: number | null, timestamp: any, resolution?: string | null, subResolution?: string | null, entity: { __typename: 'EntityInterface', id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, signals: Array<{ __typename: 'Signal', id: string, name: string, timestamp: any }>, status: { __typename: 'InsightStatusName', name: string, displayName: string }, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam', name: string } | { __typename: 'UnknownUser', username: string } | { __typename: 'User', id: string, displayName: string, username: string, email?: string | null } | null }> }>, insightStatuses: Array<{ __typename: 'InsightStatus', id: string, name: string, displayName: string, color?: string | null }> };

export type InsightsFilterFieldQueryVariables = Exact<{ [key: string]: never; }>;


export type InsightsFilterFieldQuery = { __typename: 'Query', insightStatuses: Array<{ __typename: 'InsightStatus', displayName: string, id: string, name: string }>, teams: { __typename: 'TeamPage', objects: Array<{ __typename: 'Team', id: string, name: string }> } };

export type InsightsListQueryOperationQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort: InsightSortableField;
  sortDir: SortDir;
  enableAIInsightSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableAgenticSecOps?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InsightsListQueryOperationQuery = { __typename: 'Query', insights: { __typename: 'InsightPage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'Insight', deployment: string, tenant: string, tenantName: string, tenantUrl?: string | null, created: any, description: string, id: string, readableId: string, name: string, signalCount: number, uniqueSignalCount: number, severity: InsightSeverityPyEnum, confidence?: number | null, resolution?: string | null, summary?: string | null, subResolution?: string | null, tags: Array<string>, lastUpdated?: any | null, timestamp: any, source: AlertSource, entity: { __typename: 'EntityInterface', isWhitelisted: boolean, id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, signals: Array<{ __typename: 'Signal', contentType?: string | null, id: string, name: string, severity: number, timestamp: any }>, status: { __typename: 'InsightStatusName', id: string, name: string, displayName: string }, triage?: { __typename: 'Triage', id: string, insightID: string, verdict: TriageVerdict, summary?: string | null, recommendation?: { __typename: 'TriageRecommendation', accepted?: boolean | null, severity: InsightSeverityPyEnum } | null, keyEvidences: Array<{ __typename: 'KeyEvidence', id: string, title: string, reasoning: string, verdict: SimpleVerdict }> } | null, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam', name: string } | { __typename: 'UnknownUser', username: string } | { __typename: 'User', id: string, displayName: string, username: string, email?: string | null } | null }> }, insightStatuses: Array<{ __typename: 'InsightStatus', id: string, name: string, displayName: string, color?: string | null }>, teams: { __typename: 'TeamPage', objects: Array<{ __typename: 'Team', id: string, name: string }> }, categories: Array<{ __typename: 'Category', name: string }> };

export type InsightsDataGridQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort: InsightSortableField;
  sortDir: SortDir;
  enableAIInsightSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableAgenticSecOps?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type InsightsDataGridQuery = { __typename: 'Query', insights: { __typename: 'InsightPage', total: number, hasNextPage: boolean, objects: Array<{ __typename: 'Insight', deployment: string, tenant: string, tenantName: string, tenantUrl?: string | null, created: any, description: string, id: string, readableId: string, name: string, signalCount: number, uniqueSignalCount: number, severity: InsightSeverityPyEnum, confidence?: number | null, resolution?: string | null, summary?: string | null, subResolution?: string | null, tags: Array<string>, lastUpdated?: any | null, timestamp: any, source: AlertSource, entity: { __typename: 'EntityInterface', isWhitelisted: boolean, id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, signals: Array<{ __typename: 'Signal', contentType?: string | null, id: string, name: string, severity: number, timestamp: any }>, status: { __typename: 'InsightStatusName', id: string, name: string, displayName: string }, triage?: { __typename: 'Triage', id: string, insightID: string, verdict: TriageVerdict, summary?: string | null, recommendation?: { __typename: 'TriageRecommendation', accepted?: boolean | null, severity: InsightSeverityPyEnum } | null, keyEvidences: Array<{ __typename: 'KeyEvidence', id: string, title: string, reasoning: string, verdict: SimpleVerdict }> } | null, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam', name: string } | { __typename: 'UnknownUser', username: string } | { __typename: 'User', id: string, displayName: string, username: string, email?: string | null } | null }> } };

export type UpdateInsightsByIdOperationMutationVariables = Exact<{
  fields?: InputMaybe<InsightEditableFields>;
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  addComment: Scalars['Boolean']['input'];
  commentBody: Scalars['String']['input'];
}>;


export type UpdateInsightsByIdOperationMutation = { __typename: 'Mutation', addInsightCommentsById?: { __typename: 'AddInsightCommentsById', ok: boolean } | null, updateInsightsById?: { __typename: 'UpdateInsightsById', ok: boolean } | null };

export type UpdateInsightSeverityOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  fields: InsightEditableFields;
  enableAIInsightSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableAgenticSecOps?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateInsightSeverityOperationMutation = { __typename: 'Mutation', updateInsight?: { __typename: 'UpdateInsight', data: { __typename: 'Insight', deployment: string, tenant: string, tenantName: string, tenantUrl?: string | null, created: any, description: string, id: string, readableId: string, name: string, signalCount: number, uniqueSignalCount: number, severity: InsightSeverityPyEnum, confidence?: number | null, resolution?: string | null, summary?: string | null, subResolution?: string | null, tags: Array<string>, lastUpdated?: any | null, timestamp: any, source: AlertSource, entity: { __typename: 'EntityInterface', isWhitelisted: boolean, id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, signals: Array<{ __typename: 'Signal', contentType?: string | null, id: string, name: string, severity: number, timestamp: any }>, status: { __typename: 'InsightStatusName', id: string, name: string, displayName: string }, triage?: { __typename: 'Triage', id: string, insightID: string, verdict: TriageVerdict, summary?: string | null, recommendation?: { __typename: 'TriageRecommendation', accepted?: boolean | null, severity: InsightSeverityPyEnum } | null, keyEvidences: Array<{ __typename: 'KeyEvidence', id: string, title: string, reasoning: string, verdict: SimpleVerdict }> } | null, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam', name: string } | { __typename: 'UnknownUser', username: string } | { __typename: 'User', id: string, displayName: string, username: string, email?: string | null } | null } } | null };

export type UpdateInsightStatusOperationMutationVariables = Exact<{
  fields: InsightEditableFields;
  id: Scalars['ID']['input'];
  addComment: Scalars['Boolean']['input'];
  commentBody: Scalars['String']['input'];
  enableAIInsightSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableAgenticSecOps?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateInsightStatusOperationMutation = { __typename: 'Mutation', addInsightComment?: { __typename: 'AddInsightComment', data: { __typename: 'InsightComment', id: string } } | null, updateInsight?: { __typename: 'UpdateInsight', data: { __typename: 'Insight', deployment: string, tenant: string, tenantName: string, tenantUrl?: string | null, created: any, description: string, id: string, readableId: string, name: string, signalCount: number, uniqueSignalCount: number, severity: InsightSeverityPyEnum, confidence?: number | null, resolution?: string | null, summary?: string | null, subResolution?: string | null, tags: Array<string>, lastUpdated?: any | null, timestamp: any, source: AlertSource, entity: { __typename: 'EntityInterface', isWhitelisted: boolean, id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, signals: Array<{ __typename: 'Signal', contentType?: string | null, id: string, name: string, severity: number, timestamp: any }>, status: { __typename: 'InsightStatusName', id: string, name: string, displayName: string }, triage?: { __typename: 'Triage', id: string, insightID: string, verdict: TriageVerdict, summary?: string | null, recommendation?: { __typename: 'TriageRecommendation', accepted?: boolean | null, severity: InsightSeverityPyEnum } | null, keyEvidences: Array<{ __typename: 'KeyEvidence', id: string, title: string, reasoning: string, verdict: SimpleVerdict }> } | null, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam', name: string } | { __typename: 'UnknownUser', username: string } | { __typename: 'User', id: string, displayName: string, username: string, email?: string | null } | null } } | null };

export type UpdateInsightAssigneeOperationMutationVariables = Exact<{
  fields: InsightEditableFields;
  id: Scalars['ID']['input'];
  enableAIInsightSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableAgenticSecOps?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateInsightAssigneeOperationMutation = { __typename: 'Mutation', updateInsight?: { __typename: 'UpdateInsight', data: { __typename: 'Insight', deployment: string, tenant: string, tenantName: string, tenantUrl?: string | null, created: any, description: string, id: string, readableId: string, name: string, signalCount: number, uniqueSignalCount: number, severity: InsightSeverityPyEnum, confidence?: number | null, resolution?: string | null, summary?: string | null, subResolution?: string | null, tags: Array<string>, lastUpdated?: any | null, timestamp: any, source: AlertSource, entity: { __typename: 'EntityInterface', isWhitelisted: boolean, id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, signals: Array<{ __typename: 'Signal', contentType?: string | null, id: string, name: string, severity: number, timestamp: any }>, status: { __typename: 'InsightStatusName', id: string, name: string, displayName: string }, triage?: { __typename: 'Triage', id: string, insightID: string, verdict: TriageVerdict, summary?: string | null, recommendation?: { __typename: 'TriageRecommendation', accepted?: boolean | null, severity: InsightSeverityPyEnum } | null, keyEvidences: Array<{ __typename: 'KeyEvidence', id: string, title: string, reasoning: string, verdict: SimpleVerdict }> } | null, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam', name: string } | { __typename: 'UnknownUser', username: string } | { __typename: 'User', id: string, displayName: string, username: string, email?: string | null } | null } } | null };

export type ConfirmTriageRecommendationOperationMutationVariables = Exact<{
  accepted: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  enableAIInsightSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableAgenticSecOps?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ConfirmTriageRecommendationOperationMutation = { __typename: 'Mutation', confirmInsightTriageRecommendation?: { __typename: 'ConfirmInsightTriageRecommendation', data: { __typename: 'Insight', deployment: string, tenant: string, tenantName: string, tenantUrl?: string | null, created: any, description: string, id: string, readableId: string, name: string, signalCount: number, uniqueSignalCount: number, severity: InsightSeverityPyEnum, confidence?: number | null, resolution?: string | null, summary?: string | null, subResolution?: string | null, tags: Array<string>, lastUpdated?: any | null, timestamp: any, source: AlertSource, entity: { __typename: 'EntityInterface', isWhitelisted: boolean, id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, signals: Array<{ __typename: 'Signal', contentType?: string | null, id: string, name: string, severity: number, timestamp: any }>, status: { __typename: 'InsightStatusName', id: string, name: string, displayName: string }, triage?: { __typename: 'Triage', id: string, insightID: string, verdict: TriageVerdict, summary?: string | null, recommendation?: { __typename: 'TriageRecommendation', accepted?: boolean | null, severity: InsightSeverityPyEnum } | null, keyEvidences: Array<{ __typename: 'KeyEvidence', id: string, title: string, reasoning: string, verdict: SimpleVerdict }> } | null, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam', name: string } | { __typename: 'UnknownUser', username: string } | { __typename: 'User', id: string, displayName: string, username: string, email?: string | null } | null } } | null };

export type FederatedChildOrgsListQueryVariables = Exact<{ [key: string]: never; }>;


export type FederatedChildOrgsListQuery = { __typename: 'Query', federatedChildOrgs: Array<{ __typename: 'FederatedChildOrg', tenant: string, tenantName: string, tenantUrl: string }> };

export type ApiDocumentationLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiDocumentationLinkQuery = { __typename: 'Query', apiDocumentationLink: string };

export type UserProfileFieldsFragment = { __typename: 'CurrentUser', accountNotificationsEnabled: boolean, apiKey: string, apiKeyEnabled: boolean, displayName: string, email?: string | null, emailConfirmed: boolean, insightReportNotificationInterval: NotificationInterval, lastLogin?: any | null, mfaEnabled: boolean, mfaQrCodeUrl?: string | null, mfaSecret?: string | null, name?: string | null, preferredTimezone?: string | null, role: string, username: string };

export type UserProfileOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type UserProfileOperationQuery = { __typename: 'Query', version: string, currentUser: { __typename: 'CurrentUser', accountNotificationsEnabled: boolean, apiKey: string, apiKeyEnabled: boolean, displayName: string, email?: string | null, emailConfirmed: boolean, insightReportNotificationInterval: NotificationInterval, lastLogin?: any | null, mfaEnabled: boolean, mfaQrCodeUrl?: string | null, mfaSecret?: string | null, name?: string | null, preferredTimezone?: string | null, role: string, username: string } };

export type CloudSoarUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type CloudSoarUrlQuery = { __typename: 'Query', cloudSoarUrl?: string | null };

export type RecordsTabQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type RecordsTabQueryOperationQuery = { __typename: 'Query', recordSchema: string };

export type AdvancedSearchQueryOperationQueryVariables = Exact<{
  q: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  resultType: SearchResultType;
  sort?: InputMaybe<Array<SearchResultSort> | SearchResultSort>;
}>;


export type AdvancedSearchQueryOperationQuery = { __typename: 'Query', dslSearchResults: { __typename: 'SearchResultPage', hasNextPage: boolean, total: number, objects: Array<{ __typename: 'SearchResult', matchedField?: { __typename: 'MatchedField', name: string, value: string, exact: boolean, characterRanges: Array<{ __typename: 'MatchedFieldCharacterRange', start: number, end: number }> } | null, object: { __typename: 'EntityInterface', id: string, entityType: string, value: string, lastSeen?: any | null, activityScore: number, entityTypeName: string, isWhitelisted: boolean, name: string } | { __typename: 'Insight', id: string, name: string, timestamp: any, signalCount: number, uniqueSignalCount: number, entity: { __typename: 'EntityInterface', id: string, value: string, sensorZone?: string | null, name: string } } | { __typename: 'Signal', id: string, name: string, severity: number, timestamp: any } }> } };

export type KeywordSearchQueryOperationQueryVariables = Exact<{
  q: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  resultType: SearchResultType;
}>;


export type KeywordSearchQueryOperationQuery = { __typename: 'Query', dslSearchResults: { __typename: 'SearchResultPage', hasNextPage: boolean, total: number, objects: Array<{ __typename: 'SearchResult', matchedField?: { __typename: 'MatchedField', name: string, value: string, exact: boolean, characterRanges: Array<{ __typename: 'MatchedFieldCharacterRange', start: number, end: number }> } | null, object: { __typename: 'EntityInterface', id: string, entityType: string, value: string, sensorZone?: string | null, lastSeen?: any | null, activityScore: number, entityTypeName: string, isWhitelisted: boolean, name: string } | { __typename: 'Insight', id: string, name: string, timestamp: any, signalCount: number, uniqueSignalCount: number, entity: { __typename: 'EntityInterface', id: string, value: string, sensorZone?: string | null, name: string } } | { __typename: 'Signal', id: string, name: string, severity: number, timestamp: any } }> }, insights: { __typename: 'InsightPage', total: number }, signals: { __typename: 'SignalPage', total: number }, entities: { __typename: 'EntityPage', total: number } };

export type SearchHistoryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchHistoryOperationQuery = { __typename: 'Query', recentlyVisitedDetailPages: Array<{ __typename: 'VisitedEntityPage', timestamp: any, entity?: { __typename: 'EntityInterface', id: string, name: string } | null } | { __typename: 'VisitedInsightPage', timestamp: any, insight?: { __typename: 'Insight', id: string, name: string } | null } | { __typename: 'VisitedSignalPage', timestamp: any, signal?: { __typename: 'Signal', id: string, name: string } | null }>, recentlyVisitedSearchQueryPages: Array<{ __typename: 'VisitedSearchQueryPage', q: string, resultType: SearchResultType, timestamp: any }>, insightStatuses: Array<{ __typename: 'InsightStatus', id: string, name: string, displayName: string, description?: string | null }>, teams: { __typename: 'TeamPage', objects: Array<{ __typename: 'Team', id: string, name: string }> }, users: { __typename: 'UserPage', objects: Array<{ __typename: 'User', displayName: string, email?: string | null, id: string, name?: string | null, username: string }> }, entityCriticalityConfigs: { __typename: 'EntityCriticalityConfigPage', objects: Array<{ __typename: 'EntityCriticalityConfig', name: string }> } };

export type SearchHistoryInsightStatusFragment = { __typename: 'InsightStatus', id: string, name: string, displayName: string, description?: string | null };

export type EntityCriticalityConfigsFragment = { __typename: 'EntityCriticalityConfig', name: string };

export type VisitedInsightPageFragment = { __typename: 'VisitedInsightPage', timestamp: any, insight?: { __typename: 'Insight', id: string, name: string } | null };

export type VisitedSignalPageFragment = { __typename: 'VisitedSignalPage', timestamp: any, signal?: { __typename: 'Signal', id: string, name: string } | null };

export type VisitedEntityPageFragment = { __typename: 'VisitedEntityPage', timestamp: any, entity?: { __typename: 'EntityInterface', id: string, name: string } | null };

type RecentlyVisitedDetailsPageFragment_VisitedEntityPage = { __typename: 'VisitedEntityPage', timestamp: any, entity?: { __typename: 'EntityInterface', id: string, name: string } | null };

type RecentlyVisitedDetailsPageFragment_VisitedInsightPage = { __typename: 'VisitedInsightPage', timestamp: any, insight?: { __typename: 'Insight', id: string, name: string } | null };

type RecentlyVisitedDetailsPageFragment_VisitedSignalPage = { __typename: 'VisitedSignalPage', timestamp: any, signal?: { __typename: 'Signal', id: string, name: string } | null };

export type RecentlyVisitedDetailsPageFragment = RecentlyVisitedDetailsPageFragment_VisitedEntityPage | RecentlyVisitedDetailsPageFragment_VisitedInsightPage | RecentlyVisitedDetailsPageFragment_VisitedSignalPage;

export type VisitedSearchQueryPageFragment = { __typename: 'VisitedSearchQueryPage', q: string, resultType: SearchResultType, timestamp: any };

export type SearchHistoryUserFragment = { __typename: 'User', displayName: string, email?: string | null, id: string, name?: string | null, username: string };

export type FilterQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type FilterQueryOperationQuery = { __typename: 'Query', recordSchema: string, recentlyVisitedSearchQueryPages: Array<{ __typename: 'VisitedSearchQueryPage', q: string, resultType: SearchResultType, timestamp: any }>, insightStatuses: Array<{ __typename: 'InsightStatus', id: string, name: string, displayName: string, description?: string | null }>, teams: { __typename: 'TeamPage', objects: Array<{ __typename: 'Team', id: string, name: string }> }, users: { __typename: 'UserPage', objects: Array<{ __typename: 'User', id: string, name?: string | null, email?: string | null, username: string, displayName: string }> }, categories: Array<{ __typename: 'Category', name: string }>, entityCriticalityConfigs: { __typename: 'EntityCriticalityConfigPage', objects: Array<{ __typename: 'EntityCriticalityConfig', name: string }> } };

export type VisitSearchQueryPageOperationMutationVariables = Exact<{
  q: Scalars['String']['input'];
  resultType: SearchResultType;
}>;


export type VisitSearchQueryPageOperationMutation = { __typename: 'Mutation', visitSearchQueryPage?: { __typename: 'VisitSearchQueryPage', data: Array<{ __typename: 'VisitedSearchQueryPage', q: string }> } | null };

export type SignalQueryFragment = { __typename: 'Signal', description?: string | null, extra?: string | null, id: string, name: string, prototype?: boolean | null, ruleId?: string | null, ruleType?: string | null, allRecordsJson: string, recordCount: number, severity: number, summary: string, supportsRecordSearch: boolean, isSuppressedByEntity: boolean, isSuppressedBySuppressList: boolean, suppressedByNetworkBlock: boolean, tags: Array<string>, timestamp: any, created: any, contentType: ContentType, enrichments: Array<{ __typename: 'Enrichment', type: string, enrichedObjId: string, enrichedObjType: string, raw?: string | null, detailJson: string, externalUrl?: string | null, reputation?: string | null, expiresAt?: any | null }>, suppressedBySignal?: { __typename: 'Signal', id: string, name: string, contentType: ContentType, insights: Array<{ __typename: 'Insight', id: string }> } | null, suppressesSignals: { __typename: 'SignalPage', total: number }, entity: { __typename: 'EntityInterface', id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, insights: Array<{ __typename: 'Insight', id: string, name: string, readableId: string, signals: Array<{ __typename: 'Signal', id: string }> }> };

export type SignalQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SignalQueryOperationQuery = { __typename: 'Query', signal: { __typename: 'Signal', description?: string | null, extra?: string | null, id: string, name: string, prototype?: boolean | null, ruleId?: string | null, ruleType?: string | null, allRecordsJson: string, recordCount: number, severity: number, summary: string, supportsRecordSearch: boolean, isSuppressedByEntity: boolean, isSuppressedBySuppressList: boolean, suppressedByNetworkBlock: boolean, tags: Array<string>, timestamp: any, created: any, contentType: ContentType, enrichments: Array<{ __typename: 'Enrichment', type: string, enrichedObjId: string, enrichedObjType: string, raw?: string | null, detailJson: string, externalUrl?: string | null, reputation?: string | null, expiresAt?: any | null }>, suppressedBySignal?: { __typename: 'Signal', id: string, name: string, contentType: ContentType, insights: Array<{ __typename: 'Insight', id: string }> } | null, suppressesSignals: { __typename: 'SignalPage', total: number }, entity: { __typename: 'EntityInterface', id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, insights: Array<{ __typename: 'Insight', id: string, name: string, readableId: string, signals: Array<{ __typename: 'Signal', id: string }> }> } };

export type VisitSignalPageOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type VisitSignalPageOperationMutation = { __typename: 'Mutation', visitSignalPage?: { __typename: 'VisitSignalPage', data: Array<{ __typename: 'VisitedEntityPage', timestamp: any } | { __typename: 'VisitedInsightPage', timestamp: any } | { __typename: 'VisitedSignalPage', timestamp: any }> } | null };

export type SignalRuleQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SignalRuleQueryOperationQuery = { __typename: 'Query', rule: { __typename: 'AggregationRule' } | { __typename: 'ChainRule' } | { __typename: 'FirstSeenRule', baselineWindowSize: any, retentionWindowSize: any, valueExpression?: string | null, valueFields?: Array<string> | null } | { __typename: 'MatchRule' } | { __typename: 'OutlierRule', baselineWindowSize: any, deviationThreshold: number, floorValue: number, retentionWindowSize: any, windowSize: number, windowSizeName: string, aggregationFunctions: Array<{ __typename: 'OutlierRuleAggregationFunction', function: string }> } | { __typename: 'TemplatedMatchRule' } | { __typename: 'ThresholdRule' } };

export type StartSumoRecordSearchJobForSignalMutationVariables = Exact<{
  signalId: Scalars['String']['input'];
}>;


export type StartSumoRecordSearchJobForSignalMutation = { __typename: 'Mutation', startSumoRecordSearchJobForSignal?: { __typename: 'StartSumoRecordSearchJobForSignal', jobId: string, query: string, exploreInLogsQuery: string, start: any, end: any } | null };

export type CancelSumoRecordSearchJobForSignalOperationMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type CancelSumoRecordSearchJobForSignalOperationMutation = { __typename: 'Mutation', cancelSumoRecordSearchJob?: { __typename: 'CancelSumoRecordSearchJob', ok: boolean } | null };

export type RecordSearchResultsForSignalOperationQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type RecordSearchResultsForSignalOperationQuery = { __typename: 'Query', sumoRecordSearchJobResults: Array<string>, sumoRecordSearchJobStatus: { __typename: 'SumoSearchJobStatus', state: SumoSearchJobState, total: number, histogramBuckets: Array<{ __typename: 'SumoSearchHistogramBucket', startTimestamp: any, length: any, count: number }> } };

export type SuppressedSignalQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuppressedSignalQueryOperationQuery = { __typename: 'Query', signal: { __typename: 'Signal', id: string, suppressesSignals: { __typename: 'SignalPage', total: number, objects: Array<{ __typename: 'Signal', allRecordsJson: string, description?: string | null, id: string, name: string, recordCount: number, ruleType?: string | null, ruleId?: string | null, severity: number, prototype?: boolean | null, suppressedBy?: string | null, isSuppressedBySuppressList: boolean, suppressedByNetworkBlock: boolean, isSuppressedByEntity: boolean, timestamp: any, summary: string, tags: Array<string>, contentType: ContentType, entity: { __typename: 'EntityInterface', id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null } }> } } };

export type SignalNameQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SignalNameQueryOperationQuery = { __typename: 'Query', signal: { __typename: 'Signal', id: string, name: string } };

export type SignalsQueryOperationQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort: SignalSortableField;
  sortDir: SortDir;
}>;


export type SignalsQueryOperationQuery = { __typename: 'Query', signals: { __typename: 'SignalPage', hasNextPage: boolean, total: number, objects: Array<{ __typename: 'Signal', allRecordsJson: string, description?: string | null, id: string, name: string, recordCount: number, ruleType?: string | null, ruleId?: string | null, severity: number, prototype?: boolean | null, suppressedBy?: string | null, isSuppressedBySuppressList: boolean, suppressedByNetworkBlock: boolean, isSuppressedByEntity: boolean, timestamp: any, summary: string, tags: Array<string>, contentType: ContentType, entity: { __typename: 'EntityInterface', id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null } }> }, categories: Array<{ __typename: 'Category', name: string }>, insightConfig?: { __typename: 'InsightConfig', threshold?: number | null } | null };

export type EntityDetailsIpAddressFragment = { __typename: 'IPAddress', address: string, version?: string | null, continentCode?: string | null, continentName?: string | null, countryCode?: string | null, countryName?: string | null, region?: string | null, city?: string | null, latitude?: number | null, longitude?: number | null, accuracyRadius?: number | null, isp?: string | null, org?: string | null, asn?: string | null, aso?: string | null, location?: string | null };

export type EntityDetailsFragment = { __typename: 'EntityInterface', activityScore: number, recentSignalSeverity: number, criticality?: string | null, entityType: string, entityTypeName: string, firstSeen?: any | null, id: string, isWhitelisted: boolean, lastSeen?: any | null, value: string, sensorZone?: string | null, enrichments: Array<{ __typename: 'Enrichment', type: string, enrichedObjId: string, enrichedObjType: string, raw?: string | null, detailJson: string, externalUrl?: string | null, reputation?: string | null, expiresAt?: any | null }>, networkBlocks: Array<{ __typename: 'NetworkBlock', addressBlock: string, label: string }>, ipAddressDetails?: { __typename: 'IPAddress', address: string, version?: string | null, continentCode?: string | null, continentName?: string | null, countryCode?: string | null, countryName?: string | null, region?: string | null, city?: string | null, latitude?: number | null, longitude?: number | null, accuracyRadius?: number | null, isp?: string | null, org?: string | null, asn?: string | null, aso?: string | null, location?: string | null } | null, sources?: Array<{ __typename: 'EntityMetadataSource', sourceType: string }> | null };

export type EntityDetailsQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityDetailsQueryOperationQuery = { __typename: 'Query', insightConfig?: { __typename: 'InsightConfig', threshold?: number | null } | null, entity: { __typename: 'EntityInterface', activityScore: number, recentSignalSeverity: number, criticality?: string | null, entityType: string, entityTypeName: string, firstSeen?: any | null, id: string, isWhitelisted: boolean, lastSeen?: any | null, value: string, sensorZone?: string | null, enrichments: Array<{ __typename: 'Enrichment', type: string, enrichedObjId: string, enrichedObjType: string, raw?: string | null, detailJson: string, externalUrl?: string | null, reputation?: string | null, expiresAt?: any | null }>, networkBlocks: Array<{ __typename: 'NetworkBlock', addressBlock: string, label: string }>, ipAddressDetails?: { __typename: 'IPAddress', address: string, version?: string | null, continentCode?: string | null, continentName?: string | null, countryCode?: string | null, countryName?: string | null, region?: string | null, city?: string | null, latitude?: number | null, longitude?: number | null, accuracyRadius?: number | null, isp?: string | null, org?: string | null, asn?: string | null, aso?: string | null, location?: string | null } | null, sources?: Array<{ __typename: 'EntityMetadataSource', sourceType: string }> | null } };

export type EntitySummaryFragment = { __typename: 'EntityInterface', activityScore: number, criticality?: string | null, entityType: string, entityTypeName: string, firstSeen?: any | null, id: string, isWhitelisted: boolean, lastSeen?: any | null, value: string, sensorZone?: string | null, enrichments: Array<{ __typename: 'Enrichment', detailJson: string, type: string }>, networkBlocks: Array<{ __typename: 'NetworkBlock', addressBlock: string, label: string }>, ipAddressDetails?: { __typename: 'IPAddress', address: string, version?: string | null, continentCode?: string | null, continentName?: string | null, countryCode?: string | null, countryName?: string | null, region?: string | null, city?: string | null, latitude?: number | null, longitude?: number | null, accuracyRadius?: number | null, isp?: string | null, org?: string | null, asn?: string | null, aso?: string | null, location?: string | null } | null, signals: { __typename: 'SignalPage', total: number }, insights: { __typename: 'InsightPage', total: number } };

export type EntitySummaryQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  detectionWindowStartTime: Scalars['DateTime']['input'];
  detectionWindowEndTime: Scalars['DateTime']['input'];
}>;


export type EntitySummaryQueryOperationQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', activityScore: number, criticality?: string | null, entityType: string, entityTypeName: string, firstSeen?: any | null, id: string, isWhitelisted: boolean, lastSeen?: any | null, value: string, sensorZone?: string | null, enrichments: Array<{ __typename: 'Enrichment', detailJson: string, type: string }>, networkBlocks: Array<{ __typename: 'NetworkBlock', addressBlock: string, label: string }>, ipAddressDetails?: { __typename: 'IPAddress', address: string, version?: string | null, continentCode?: string | null, continentName?: string | null, countryCode?: string | null, countryName?: string | null, region?: string | null, city?: string | null, latitude?: number | null, longitude?: number | null, accuracyRadius?: number | null, isp?: string | null, org?: string | null, asn?: string | null, aso?: string | null, location?: string | null } | null, signals: { __typename: 'SignalPage', total: number }, insights: { __typename: 'InsightPage', total: number } } };

export type EntityExecutedAutomationsFragment = { __typename: 'ExecutedAutomation', executionId: string, statusCode?: number | null };

export type EntityExecutedAutomationsCountQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityExecutedAutomationsCountQueryOperationQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', id: string, executedAutomations: Array<{ __typename: 'ExecutedAutomation', executionId: string, statusCode?: number | null }> } };

export type InsightConfigQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type InsightConfigQueryOperationQuery = { __typename: 'Query', insightConfig?: { __typename: 'InsightConfig', lookbackDays?: number | null, threshold?: number | null, globalSignalSuppressionWindow?: number | null } | null };

export type InsightAssigneeFieldsFragment = { __typename: 'Insight', assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam', name: string } | { __typename: 'UnknownUser', username: string } | { __typename: 'User', id: string, displayName: string, username: string, email?: string | null } | null };

export type InsightSignalFieldsFragment = { __typename: 'Signal', contentType?: string | null, id: string, name: string, severity: number, timestamp: any };

export type EntityFieldsFragment = { __typename: 'EntityInterface', id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null };

export type KeyEvidenceFieldsFragment = { __typename: 'KeyEvidence', id: string, title: string, reasoning: string, verdict: SimpleVerdict };

export type InsightTriageFieldsFragment = { __typename: 'Triage', id: string, insightID: string, verdict: TriageVerdict, summary?: string | null, recommendation?: { __typename: 'TriageRecommendation', accepted?: boolean | null, severity: InsightSeverityPyEnum } | null, keyEvidences: Array<{ __typename: 'KeyEvidence', id: string, title: string, reasoning: string, verdict: SimpleVerdict }> };

export type InsightFieldsFragment = { __typename: 'Insight', deployment: string, tenant: string, tenantName: string, tenantUrl?: string | null, created: any, description: string, id: string, readableId: string, name: string, signalCount: number, uniqueSignalCount: number, severity: InsightSeverityPyEnum, confidence?: number | null, resolution?: string | null, summary?: string | null, subResolution?: string | null, tags: Array<string>, lastUpdated?: any | null, timestamp: any, source: AlertSource, entity: { __typename: 'EntityInterface', isWhitelisted: boolean, id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, signals: Array<{ __typename: 'Signal', contentType?: string | null, id: string, name: string, severity: number, timestamp: any }>, status: { __typename: 'InsightStatusName', id: string, name: string, displayName: string }, triage?: { __typename: 'Triage', id: string, insightID: string, verdict: TriageVerdict, summary?: string | null, recommendation?: { __typename: 'TriageRecommendation', accepted?: boolean | null, severity: InsightSeverityPyEnum } | null, keyEvidences: Array<{ __typename: 'KeyEvidence', id: string, title: string, reasoning: string, verdict: SimpleVerdict }> } | null, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam', name: string } | { __typename: 'UnknownUser', username: string } | { __typename: 'User', id: string, displayName: string, username: string, email?: string | null } | null };

export type AddSignalsToInsightOperationMutationVariables = Exact<{
  insightId: Scalars['ID']['input'];
  signalIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AddSignalsToInsightOperationMutation = { __typename: 'Mutation', addSignalsToInsight?: { __typename: 'AddSignalsToInsight', data: { __typename: 'Insight', id: string } } | null };

export type RemoveSignalsFromInsightOperationMutationVariables = Exact<{
  signalIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  insightId: Scalars['ID']['input'];
  enableAIInsightSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableAgenticSecOps?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RemoveSignalsFromInsightOperationMutation = { __typename: 'Mutation', removeSignalsFromInsight?: { __typename: 'RemoveSignalsFromInsight', data: { __typename: 'Insight', deployment: string, tenant: string, tenantName: string, tenantUrl?: string | null, created: any, description: string, id: string, readableId: string, name: string, signalCount: number, uniqueSignalCount: number, severity: InsightSeverityPyEnum, confidence?: number | null, resolution?: string | null, summary?: string | null, subResolution?: string | null, tags: Array<string>, lastUpdated?: any | null, timestamp: any, source: AlertSource, entity: { __typename: 'EntityInterface', isWhitelisted: boolean, id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, signals: Array<{ __typename: 'Signal', contentType?: string | null, id: string, name: string, severity: number, timestamp: any }>, status: { __typename: 'InsightStatusName', id: string, name: string, displayName: string }, triage?: { __typename: 'Triage', id: string, insightID: string, verdict: TriageVerdict, summary?: string | null, recommendation?: { __typename: 'TriageRecommendation', accepted?: boolean | null, severity: InsightSeverityPyEnum } | null, keyEvidences: Array<{ __typename: 'KeyEvidence', id: string, title: string, reasoning: string, verdict: SimpleVerdict }> } | null, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam', name: string } | { __typename: 'UnknownUser', username: string } | { __typename: 'User', id: string, displayName: string, username: string, email?: string | null } | null } } | null };

export type CreateInsightFromSignalOperationMutationVariables = Exact<{
  signalId: Scalars['ID']['input'];
  enableAIInsightSummary?: InputMaybe<Scalars['Boolean']['input']>;
  enableAgenticSecOps?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateInsightFromSignalOperationMutation = { __typename: 'Mutation', createInsightFromSignal?: { __typename: 'CreateInsightFromSignal', data: { __typename: 'Insight', deployment: string, tenant: string, tenantName: string, tenantUrl?: string | null, created: any, description: string, id: string, readableId: string, name: string, signalCount: number, uniqueSignalCount: number, severity: InsightSeverityPyEnum, confidence?: number | null, resolution?: string | null, summary?: string | null, subResolution?: string | null, tags: Array<string>, lastUpdated?: any | null, timestamp: any, source: AlertSource, entity: { __typename: 'EntityInterface', isWhitelisted: boolean, id: string, criticality?: string | null, entityType: string, entityTypeName: string, value: string, sensorZone?: string | null }, relatedIncidents: Array<{ __typename: 'RelatedIncident', id: number, name?: string | null, type: string, link: string, status?: string | null, assignee?: string | null }>, signals: Array<{ __typename: 'Signal', contentType?: string | null, id: string, name: string, severity: number, timestamp: any }>, status: { __typename: 'InsightStatusName', id: string, name: string, displayName: string }, triage?: { __typename: 'Triage', id: string, insightID: string, verdict: TriageVerdict, summary?: string | null, recommendation?: { __typename: 'TriageRecommendation', accepted?: boolean | null, severity: InsightSeverityPyEnum } | null, keyEvidences: Array<{ __typename: 'KeyEvidence', id: string, title: string, reasoning: string, verdict: SimpleVerdict }> } | null, assignee?: { __typename: 'Team', id: string, name: string } | { __typename: 'UnknownTeam', name: string } | { __typename: 'UnknownUser', username: string } | { __typename: 'User', id: string, displayName: string, username: string, email?: string | null } | null } } | null };

export type AssigneeQueryVariables = Exact<{ [key: string]: never; }>;


export type AssigneeQuery = { __typename: 'Query', teams: { __typename: 'TeamPage', objects: Array<{ __typename: 'Team', id: string, name: string }> }, users: { __typename: 'UserPage', objects: Array<{ __typename: 'User', id: string, name?: string | null, email?: string | null, username: string, displayName: string }> } };

export type EnabledContextActionFragment = { __typename: 'ContextAction', allRecordFields: boolean, entityTypes: Array<string>, id: string, iocTypes: Array<ContextActionIocType>, name: string, recordFields: Array<string>, template: string };

export type EnabledContextActionsQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type EnabledContextActionsQueryOperationQuery = { __typename: 'Query', sumoLogicBaseUrl?: string | null, sumoLogicRegion?: string | null, contextActions: { __typename: 'ContextActionPage', hasNextPage: boolean, total: number, objects: Array<{ __typename: 'ContextAction', allRecordFields: boolean, entityTypes: Array<string>, id: string, iocTypes: Array<ContextActionIocType>, name: string, recordFields: Array<string>, template: string }> } };

export type EntityAsideEnrichmentFieldsFragment = { __typename: 'Enrichment', reputation?: string | null, type: string, externalUrl?: string | null, normalizedIndicator?: { __typename: 'NormalizedIndicator', id?: string | null, indicator?: string | null, source?: string | null } | null };

export type EntityAsideSuppressListFragment = { __typename: 'SuppressList', id: string, name: string };

export type EntityAsideEntitySourcesFragment = { __typename: 'EntityMetadataSource', sourceType: string, entityGroupConfigurationId?: string | null, entityGroupConfigurationName?: string | null };

export type EntityAsideEntityFragment = { __typename: 'EntityInterface', id: string, entityType: string, entityTypeName: string, isWhitelisted: boolean, reputation?: string | null, value: string, recentSignalSeverity: number, auditLog: Array<{ __typename: 'EntityAuditLog', id: string }>, enrichments: Array<{ __typename: 'Enrichment', reputation?: string | null, type: string, externalUrl?: string | null, normalizedIndicator?: { __typename: 'NormalizedIndicator', id?: string | null, indicator?: string | null, source?: string | null } | null }>, insights: { __typename: 'InsightPage', total: number, objects: Array<{ __typename: 'Insight', name: string, readableId: string, severity: InsightSeverityPyEnum, timestamp: any }> }, ipAddressDetails?: { __typename: 'IPAddress', address: string, countryCode?: string | null, countryName?: string | null } | null, suppressListsObj: Array<{ __typename: 'SuppressList', id: string, name: string }>, networkBlocks: Array<{ __typename: 'NetworkBlock', id: string }>, notes?: Array<{ __typename: 'EntityNote', id: string }> | null, sources?: Array<{ __typename: 'EntityMetadataSource', sourceType: string, entityGroupConfigurationId?: string | null, entityGroupConfigurationName?: string | null }> | null, signals: { __typename: 'SignalPage', total: number, objects: Array<{ __typename: 'Signal', created: any, id: string, name: string }> } };

export type EntityAsideLookbackOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type EntityAsideLookbackOperationQuery = { __typename: 'Query', insightConfig?: { __typename: 'InsightConfig', lookbackDays?: number | null, threshold?: number | null } | null };

export type EntityAsideQueryOperationQueryVariables = Exact<{
  detectionWindowStartTime: Scalars['DateTime']['input'];
  detectionWindowEndTime: Scalars['DateTime']['input'];
  id: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type EntityAsideQueryOperationQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', id: string, entityType: string, entityTypeName: string, isWhitelisted: boolean, reputation?: string | null, value: string, recentSignalSeverity: number, auditLog: Array<{ __typename: 'EntityAuditLog', id: string }>, enrichments: Array<{ __typename: 'Enrichment', reputation?: string | null, type: string, externalUrl?: string | null, normalizedIndicator?: { __typename: 'NormalizedIndicator', id?: string | null, indicator?: string | null, source?: string | null } | null }>, insights: { __typename: 'InsightPage', total: number, objects: Array<{ __typename: 'Insight', name: string, readableId: string, severity: InsightSeverityPyEnum, timestamp: any }> }, ipAddressDetails?: { __typename: 'IPAddress', address: string, countryCode?: string | null, countryName?: string | null } | null, suppressListsObj: Array<{ __typename: 'SuppressList', id: string, name: string }>, networkBlocks: Array<{ __typename: 'NetworkBlock', id: string }>, notes?: Array<{ __typename: 'EntityNote', id: string }> | null, sources?: Array<{ __typename: 'EntityMetadataSource', sourceType: string, entityGroupConfigurationId?: string | null, entityGroupConfigurationName?: string | null }> | null, signals: { __typename: 'SignalPage', total: number, objects: Array<{ __typename: 'Signal', created: any, id: string, name: string }> } } };

export type EntityNetworkBlocksQueryOperationQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type EntityNetworkBlocksQueryOperationQuery = { __typename: 'Query', networkBlocksByIp: Array<{ __typename: 'NetworkBlock', id: string, addressBlock: string, label: string }> };

export type EntityAsideUpdateSuppressionMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  whitelistFlag: Scalars['Boolean']['input'];
}>;


export type EntityAsideUpdateSuppressionMutation = { __typename: 'Mutation', updateEntityWhitelist?: { __typename: 'UpdateEntityWhitelist', data?: { __typename: 'EntityInterface', id: string, isWhitelisted: boolean } | null } | null };

export type EntityInputTagsQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityInputTagsQueryOperationQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', id: string, tags: Array<string> }, entityTagOptions: Array<{ __typename: 'EntityTagOption', value: string }>, tagSchemas: Array<{ __typename: 'TagSchema', key: string, label?: string | null, contentTypeEnums?: Array<TagContentType> | null, freeform?: boolean | null, valueOptionObjects?: Array<{ __typename: 'TagSchemaValueOption', value: string, label?: string | null, link?: string | null }> | null }> };

export type EntityInputTagsUpdateOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type EntityInputTagsUpdateOperationMutation = { __typename: 'Mutation', updateEntityTags?: { __typename: 'UpdateEntityTags', data?: { __typename: 'EntityInterface', id: string, tags: Array<string> } | null } | null };

export type EntityInputTagsDeleteOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type EntityInputTagsDeleteOperationMutation = { __typename: 'Mutation', removeEntityTags?: { __typename: 'RemoveEntityTags', data?: { __typename: 'EntityInterface', id: string, tags: Array<string> } | null } | null };

export type EntityInputCriticalityQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityInputCriticalityQueryOperationQuery = { __typename: 'Query', entityCriticalityConfigs: { __typename: 'EntityCriticalityConfigPage', objects: Array<{ __typename: 'EntityCriticalityConfig', id: string, name: string, severityExpression: string }> }, entity: { __typename: 'EntityInterface', criticality?: string | null, id: string } };

export type UpdateEntityInputCriticalityMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  criticality?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateEntityInputCriticalityMutation = { __typename: 'Mutation', updateEntityCriticality?: { __typename: 'UpdateEntityCriticality', data?: { __typename: 'EntityInterface', id: string, criticality?: string | null } | null } | null };

export type EntityAutomationsQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type EntityAutomationsQueryOperationQuery = { __typename: 'Query', automations: { __typename: 'AutomationPage', objects: Array<{ __typename: 'Automation', cseResourceSubTypes?: Array<string> | null, description?: string | null, enabled: boolean, executionTypes: Array<string>, id: string, name: string, playbookId: string }> } };

export type EntityTypeQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityTypeQueryOperationQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', entityType: string, id: string } };

export type ExecuteEntityAutomationOperationMutationVariables = Exact<{
  fields: ExecuteAutomationFields;
}>;


export type ExecuteEntityAutomationOperationMutation = { __typename: 'Mutation', executeAutomation?: { __typename: 'ExecuteAutomation', executionIds?: Array<string> | null, playbooksWithErrors?: Array<string> | null } | null };

export type EntityFormNotesQueryOperationQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
}>;


export type EntityFormNotesQueryOperationQuery = { __typename: 'Query', currentUser: { __typename: 'CurrentUser', displayName: string, id: string, role: string }, entityNotes: Array<{ __typename: 'EntityNote', id: string, lastUpdated: any, note: string, timestamp: any, author?: { __typename: 'User', displayName: string, id: string, role: string } | null }> };

export type EntityFormNotesUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  note: Scalars['String']['input'];
}>;


export type EntityFormNotesUpdateMutation = { __typename: 'Mutation', addEntityNote?: { __typename: 'AddEntityNote', data: { __typename: 'EntityNote', id: string, note: string, timestamp: any, author?: { __typename: 'User', displayName: string, id: string, role: string } | null } } | null };

export type EntityFormNotesDeleteMutationVariables = Exact<{
  entityId: Scalars['ID']['input'];
  entityNoteId: Scalars['ID']['input'];
}>;


export type EntityFormNotesDeleteMutation = { __typename: 'Mutation', deleteEntityNote?: { __typename: 'DeleteEntityNote', ok: boolean } | null };

export type InsightExecutedAutomationQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InsightExecutedAutomationQueryOperationQuery = { __typename: 'Query', insight: { __typename: 'Insight', id: string, executedAutomations: Array<{ __typename: 'ExecutedAutomation', executionId: string, cseResourceType: string, cseResourceId: string, playbookDescription?: string | null, playbookName: string, startDate?: any | null, status: string, statusCode?: number | null }> } };

export type EntityExecutedAutomationsQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityExecutedAutomationsQueryOperationQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', id: string, executedAutomations: Array<{ __typename: 'ExecutedAutomation', executionId: string, cseResourceType: string, cseResourceId: string, playbookDescription?: string | null, playbookName: string, startDate?: any | null, status: string, statusCode?: number | null }> } };

export type InsightDisplayQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InsightDisplayQueryOperationQuery = { __typename: 'Query', insight: { __typename: 'Insight', id: string, readableId: string, name: string } };

export type EntityDisplayQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityDisplayQueryOperationQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', id: string, entityTypeName: string, value: string } };

export type CreateFavoriteFieldOperationMutationVariables = Exact<{
  fieldName: Scalars['String']['input'];
  fieldType: FavoriteFieldType;
}>;


export type CreateFavoriteFieldOperationMutation = { __typename: 'Mutation', createFavoriteField?: { __typename: 'CreateFavoriteField', data: { __typename: 'FavoriteField', applyToAllObjectTypes: boolean, associatedObjectTypes: Array<string>, fieldName: string, fieldType: FavoriteFieldType, id: string } } | null };

export type DeleteFavoriteFieldOperationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFavoriteFieldOperationMutation = { __typename: 'Mutation', deleteFavoriteField?: { __typename: 'DeleteFavoriteField', ok: boolean } | null };

export type FavoriteFieldsQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type FavoriteFieldsQueryOperationQuery = { __typename: 'Query', favoriteFields: { __typename: 'FavoriteFieldPage', objects: Array<{ __typename: 'FavoriteField', id: string, fieldName: string, fieldType: FavoriteFieldType, applyToAllObjectTypes: boolean, associatedObjectTypes: Array<string> }> } };

export type EnabledFeatureFlagsQueryVariables = Exact<{
  featureFlagsToLookup: Array<Scalars['String']['input']> | Scalars['String']['input'];
  enabledByDefaultFeatureFlags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type EnabledFeatureFlagsQuery = { __typename: 'Query', enabledFeatureFlags: Array<string> };

export type SearchFilterQueryOperationQueryVariables = Exact<{
  query: Scalars['String']['input'];
  resultType: SearchResultType;
  fieldName: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchFilterQueryOperationQuery = { __typename: 'Query', searchFieldSuggestions: { __typename: 'SearchFieldSuggestionPage', total: number, objects: Array<{ __typename: 'SearchFieldSuggestion', value: string }> } };

export type InsightStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InsightStatusQuery = { __typename: 'Query', insightStatus: { __typename: 'InsightStatus', id: string, color?: string | null } };

export type InsightStatusDisplayFragment = { __typename: 'InsightStatus', id: string, name: string, displayName: string, color?: string | null };

export type InsightStatusesQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type InsightStatusesQueryOperationQuery = { __typename: 'Query', insightStatuses: Array<{ __typename: 'InsightStatus', id: string, name: string, displayName: string, color?: string | null }> };

export type EntityInventoryComputerFragment = { __typename: 'ComputerInventory', computerName?: string | null, deviceUniqueId?: string | null, groups: Array<string>, hostname?: string | null, ip: Array<string>, location?: string | null, mac?: string | null, metadataJson?: string, natIp: Array<string>, normalizedComputerName?: string | null, normalizedHostname?: string | null, os?: string | null, osVersion?: string | null, parsedTime: string, source: string, timestamp: string, userId?: string | null };

export type EntityInventoryUserFragment = { __typename: 'UserInventory', department?: string | null, emails: Array<string>, givenName?: string | null, groups: Array<string>, lastName?: string | null, metadataJson?: string, middleName?: string | null, normalizedUsername?: string | null, parsedTime: string, source: string, timestamp: string, username: string };

export type EntityInventoryFragment = { __typename: 'EntityInterface', criticality?: string | null, id: string, inventory: Array<{ __typename: 'ComputerInventory', computerName?: string | null, deviceUniqueId?: string | null, groups: Array<string>, hostname?: string | null, ip: Array<string>, location?: string | null, mac?: string | null, metadataJson?: string, natIp: Array<string>, normalizedComputerName?: string | null, normalizedHostname?: string | null, os?: string | null, osVersion?: string | null, parsedTime: string, source: string, timestamp: string, userId?: string | null } | { __typename: 'UserInventory', department?: string | null, emails: Array<string>, givenName?: string | null, groups: Array<string>, lastName?: string | null, metadataJson?: string, middleName?: string | null, normalizedUsername?: string | null, parsedTime: string, source: string, timestamp: string, username: string }> };

export type EntityInventoryQueryOperationQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
  includeMetadata: Scalars['Boolean']['input'];
}>;


export type EntityInventoryQueryOperationQuery = { __typename: 'Query', entity: { __typename: 'EntityInterface', criticality?: string | null, id: string, inventory: Array<{ __typename: 'ComputerInventory', computerName?: string | null, deviceUniqueId?: string | null, groups: Array<string>, hostname?: string | null, ip: Array<string>, location?: string | null, mac?: string | null, metadataJson?: string, natIp: Array<string>, normalizedComputerName?: string | null, normalizedHostname?: string | null, os?: string | null, osVersion?: string | null, parsedTime: string, source: string, timestamp: string, userId?: string | null } | { __typename: 'UserInventory', department?: string | null, emails: Array<string>, givenName?: string | null, groups: Array<string>, lastName?: string | null, metadataJson?: string, middleName?: string | null, normalizedUsername?: string | null, parsedTime: string, source: string, timestamp: string, username: string }> } };

export type RecordSearchResultsOperationQueryVariables = Exact<{
  searchStarted: Scalars['Boolean']['input'];
  jobId: Scalars['ID']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type RecordSearchResultsOperationQuery = { __typename: 'Query', sumoRecordSearchJobResults?: Array<string>, sumoRecordSearchJobStatus?: { __typename: 'SumoSearchJobStatus', state: SumoSearchJobState, total: number, histogramBuckets: Array<{ __typename: 'SumoSearchHistogramBucket', startTimestamp: any, length: any, count: number }> }, sumoRecordSearchJobObjectTypeCounts?: Array<{ __typename: 'SumoSearchObjectTypeCount', objectType: string, count: number }> };

export type SumoRecordSearchOperationQueryVariables = Exact<{
  q: Scalars['String']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<SortDir>;
  querySyntax?: InputMaybe<SumoSearchQuerySyntax>;
}>;


export type SumoRecordSearchOperationQuery = { __typename: 'Query', sumoRecordSearchQuery: string };

export type StartSumoRecordSearchJobOperationMutationVariables = Exact<{
  q: Scalars['String']['input'];
  querySyntax?: InputMaybe<SumoSearchQuerySyntax>;
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
  sort?: InputMaybe<Scalars['String']['input']>;
  sortDir?: InputMaybe<SortDir>;
}>;


export type StartSumoRecordSearchJobOperationMutation = { __typename: 'Mutation', startSumoRecordSearchJob?: { __typename: 'StartSumoRecordSearchJob', jobId: string } | null };

export type StartSumoRecordSearchJobForRuleExpressionMutationVariables = Exact<{
  ruleExpression: Scalars['String']['input'];
  ruleTuningTranslationExpressions: Array<RuleTuningExpressionTranslationFields> | RuleTuningExpressionTranslationFields;
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
}>;


export type StartSumoRecordSearchJobForRuleExpressionMutation = { __typename: 'Mutation', startSumoRecordSearchJobForRuleExpression?: { __typename: 'StartSumoRecordSearchJobForRuleExpression', jobId: string } | null };

export type CancelSumoRecordSearchJobOperationMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type CancelSumoRecordSearchJobOperationMutation = { __typename: 'Mutation', cancelSumoRecordSearchJob?: { __typename: 'CancelSumoRecordSearchJob', ok: boolean } | null };

export type RuleExpressionResultsOperationQueryVariables = Exact<{
  jobId: Scalars['ID']['input'];
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type RuleExpressionResultsOperationQuery = { __typename: 'Query', sumoRecordSearchJobResults: Array<string>, sumoRecordSearchJobStatus: { __typename: 'SumoSearchJobStatus', state: SumoSearchJobState, total: number } };

export type EntityFieldsAndIndicatorQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
}>;


export type EntityFieldsAndIndicatorQuery = { __typename: 'Query', entityFieldsWithTypes: Array<{ __typename: 'EntityFieldAndType', field: string, type: string }>, entity: { __typename: 'EntityInterface', id: string, entityType: string, reputation?: string | null, reputationSources: Array<EntityReputationSource> } };

export type RelatedEntitiesQueryOperationQueryVariables = Exact<{
  ip: Scalars['String']['input'];
  start: Scalars['DateTime']['input'];
  end: Scalars['DateTime']['input'];
}>;


export type RelatedEntitiesQueryOperationQuery = { __typename: 'Query', relatedEntities: Array<{ __typename: 'RelatedEntity', id: string, type: string, value: string }> };

type RuleItemFragment_AggregationRule = { __typename: 'AggregationRule', enabled: boolean, id: string, name: string };

type RuleItemFragment_ChainRule = { __typename: 'ChainRule', enabled: boolean, id: string, name: string };

type RuleItemFragment_FirstSeenRule = { __typename: 'FirstSeenRule', enabled: boolean, id: string, name: string };

type RuleItemFragment_MatchRule = { __typename: 'MatchRule', enabled: boolean, id: string, name: string };

type RuleItemFragment_OutlierRule = { __typename: 'OutlierRule', enabled: boolean, id: string, name: string };

type RuleItemFragment_TemplatedMatchRule = { __typename: 'TemplatedMatchRule', enabled: boolean, id: string, name: string };

type RuleItemFragment_ThresholdRule = { __typename: 'ThresholdRule', enabled: boolean, id: string, name: string };

export type RuleItemFragment = RuleItemFragment_AggregationRule | RuleItemFragment_ChainRule | RuleItemFragment_FirstSeenRule | RuleItemFragment_MatchRule | RuleItemFragment_OutlierRule | RuleItemFragment_TemplatedMatchRule | RuleItemFragment_ThresholdRule;

export type RuleItemQueryOperationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RuleItemQueryOperationQuery = { __typename: 'Query', rule: { __typename: 'AggregationRule', enabled: boolean, id: string, name: string } | { __typename: 'ChainRule', enabled: boolean, id: string, name: string } | { __typename: 'FirstSeenRule', enabled: boolean, id: string, name: string } | { __typename: 'MatchRule', enabled: boolean, id: string, name: string } | { __typename: 'OutlierRule', enabled: boolean, id: string, name: string } | { __typename: 'TemplatedMatchRule', enabled: boolean, id: string, name: string } | { __typename: 'ThresholdRule', enabled: boolean, id: string, name: string } };

type RuleSelectFragment_AggregationRule = { __typename: 'AggregationRule', enabled: boolean, id: string, name: string };

type RuleSelectFragment_ChainRule = { __typename: 'ChainRule', enabled: boolean, id: string, name: string };

type RuleSelectFragment_FirstSeenRule = { __typename: 'FirstSeenRule', enabled: boolean, id: string, name: string };

type RuleSelectFragment_MatchRule = { __typename: 'MatchRule', enabled: boolean, id: string, name: string };

type RuleSelectFragment_OutlierRule = { __typename: 'OutlierRule', enabled: boolean, id: string, name: string };

type RuleSelectFragment_TemplatedMatchRule = { __typename: 'TemplatedMatchRule', enabled: boolean, id: string, name: string };

type RuleSelectFragment_ThresholdRule = { __typename: 'ThresholdRule', enabled: boolean, id: string, name: string };

export type RuleSelectFragment = RuleSelectFragment_AggregationRule | RuleSelectFragment_ChainRule | RuleSelectFragment_FirstSeenRule | RuleSelectFragment_MatchRule | RuleSelectFragment_OutlierRule | RuleSelectFragment_TemplatedMatchRule | RuleSelectFragment_ThresholdRule;

export type RulesListForSelectQueryOperationQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort: RuleSortableField;
  sortDir: SortDir;
}>;


export type RulesListForSelectQueryOperationQuery = { __typename: 'Query', rules: { __typename: 'RulePage', total: number, objects: Array<{ __typename: 'AggregationRule', enabled: boolean, id: string, name: string } | { __typename: 'ChainRule', enabled: boolean, id: string, name: string } | { __typename: 'FirstSeenRule', enabled: boolean, id: string, name: string } | { __typename: 'MatchRule', enabled: boolean, id: string, name: string } | { __typename: 'OutlierRule', enabled: boolean, id: string, name: string } | { __typename: 'TemplatedMatchRule', enabled: boolean, id: string, name: string } | { __typename: 'ThresholdRule', enabled: boolean, id: string, name: string }> } };

export type SchemaFieldQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type SchemaFieldQueryOperationQuery = { __typename: 'Query', logMappingOptions: { __typename: 'LogMappingOptions', recordTypeOptions: Array<{ __typename: 'LogMappingRecordTypeOption', objectType: string, mappableFields: Array<{ __typename: 'LogMappingMappableField', name: string, type: string }> }> } };

export type SelectIncidentTemplateDialogOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type SelectIncidentTemplateDialogOperationQuery = { __typename: 'Query', incidentTemplates: Array<{ __typename: 'IncidentTemplate', id: number, name: string }> };

export type StartSumoRawMessageLookupJobOperationMutationVariables = Exact<{
  messageId: Scalars['String']['input'];
  timestamp: Scalars['DateTime']['input'];
}>;


export type StartSumoRawMessageLookupJobOperationMutation = { __typename: 'Mutation', startSumoRawMessageLookupJob?: { __typename: 'StartSumoRawMessageLookupJob', jobId: string } | null };

export type SumoRawMessageLookupJobResultOperationQueryVariables = Exact<{
  searchStarted: Scalars['Boolean']['input'];
  jobId: Scalars['ID']['input'];
}>;


export type SumoRawMessageLookupJobResultOperationQuery = { __typename: 'Query', sumoRawMessageLookupJobResult?: string | null, sumoRecordSearchJobStatus?: { __typename: 'SumoSearchJobStatus', state: SumoSearchJobState, total: number } };

export type InsightTagOptionsOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type InsightTagOptionsOperationQuery = { __typename: 'Query', insightTagOptions: Array<{ __typename: 'InsightTagOption', value: string, label?: string | null }> };

export type EntityTagOptionsOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type EntityTagOptionsOperationQuery = { __typename: 'Query', entityTagOptions: Array<{ __typename: 'EntityTagOption', value: string, label?: string | null }> };

export type SignalTagOptionsOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type SignalTagOptionsOperationQuery = { __typename: 'Query', signalTagOptions: Array<{ __typename: 'SignalTagOption', value: string, label?: string | null }> };

export type RuleTagOptionsOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type RuleTagOptionsOperationQuery = { __typename: 'Query', ruleTagOptions: Array<{ __typename: 'RuleTagOption', value: string, label?: string | null }> };

export type BulkEntityFieldsAndIndicatorQueryVariables = Exact<{
  entityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkEntityFieldsAndIndicatorQuery = { __typename: 'Query', entityFieldsWithTypes: Array<{ __typename: 'EntityFieldAndType', field: string, type: string }>, entitiesByListIds?: Array<{ __typename: 'EntityInterface', id: string, entityType: string, reputation?: string | null, reputationSources: Array<EntityReputationSource> }> | null };

export type RecordSchemaOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type RecordSchemaOperationQuery = { __typename: 'Query', recordSchema: string };

export type EntityFieldsQueryOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type EntityFieldsQueryOperationQuery = { __typename: 'Query', entityFieldsWithTypes: Array<{ __typename: 'EntityFieldAndType', field: string, type: string }> };

export type PermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PermissionsQuery = { __typename: 'Query', currentUser: { __typename: 'CurrentUser', permissions: Array<string> } };

export type EntitiesByListIdQueryOperationQueryVariables = Exact<{
  entityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type EntitiesByListIdQueryOperationQuery = { __typename: 'Query', entitiesByListIds?: Array<{ __typename: 'EntityInterface', id: string, entityType: string, reputation?: string | null, reputationSources: Array<EntityReputationSource> }> | null };

export type TestRuleTuningExpressionFragment = { __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string };

export type LinkRuleTuningExpressionQueryOperationQueryVariables = Exact<{
  prefix?: InputMaybe<Scalars['String']['input']>;
}>;


export type LinkRuleTuningExpressionQueryOperationQuery = { __typename: 'Query', ruleTuningExpressions: { __typename: 'RuleTuningExpressionPage', objects: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> } };

export type TestRuleTuningExpressionQueryOperationQueryVariables = Exact<{
  q?: InputMaybe<Scalars['String']['input']>;
}>;


export type TestRuleTuningExpressionQueryOperationQuery = { __typename: 'Query', ruleTuningExpressions: { __typename: 'RuleTuningExpressionPage', objects: Array<{ __typename: 'RuleTuningExpression', enabled: boolean, expression: string, id: string, isGlobal: boolean, exclude: boolean, name: string }> } };

export type CustomMatchListColumnsOperationQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomMatchListColumnsOperationQuery = { __typename: 'Query', customMatchListColumnLimit: number, customMatchListColumns: Array<{ __typename: 'CustomMatchListColumn', id: string, name: string, fields: Array<string> }> };

export const CurrentUserFragmentDoc = gql`
    fragment CurrentUserFragment on CurrentUser {
  createdTime
  email
  id
  name
  permissions
  preferredTimezone
  username
}
    `;
export const CurrentUserSumoFragmentDoc = gql`
    fragment CurrentUserSumoFragment on CurrentUserSumo {
  id
  accountType
  accountStatus
  organization
  organizationId
  userHashForIntercom
  userIdForIntercom
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  accountNotificationsEnabled
  active
  apiKeyEnabled
  createdTime
  displayName
  emailConfirmed
  email
  id
  lastLogin
  lastActive
  mfaEnabled
  name
  role
  teams
  username
}
    `;
export const AllUsersFragmentDoc = gql`
    fragment AllUsersFragment on User {
  displayName
  email
  id
  name
  username
}
    `;
export const ActionObjectFragmentDoc = gql`
    fragment ActionObjectFragment on Action {
  id
  name
  type
  enabled
  parameters {
    name
    displayName
    required
  }
  configurationJson
  createdTime
  notificationTypes
}
    `;
export const AutomationRowFragmentDoc = gql`
    fragment AutomationRow on Automation {
  description
  cseResourceSubTypes
  cseResourceType
  enabled
  executionTypes
  id
  name
  playbookId
}
    `;
export const ContextActionFragmentDoc = gql`
    fragment ContextActionFragment on ContextAction {
  allRecordFields
  enabled
  entityTypes
  id
  iocTypes
  name
  recordFields
  template
  type
}
    `;
export const EntityCriticalityConfigListItemFragmentDoc = gql`
    fragment EntityCriticalityConfigListItemFragment on EntityCriticalityConfig {
  id
  name
  severityExpression
  entityCount
}
    `;
export const EntityGroupConfigurationCriticalityFragmentDoc = gql`
    fragment EntityGroupConfigurationCriticalityFragment on EntityGroupConfiguration {
  id
  criticality
}
    `;
export const EntityGroupConfigurationFragmentDoc = gql`
    fragment EntityGroupConfigurationFragment on EntityGroupConfiguration {
  id
  name
  configurationType
  criticality
  description
  entityType
  group
  inventoryKey
  inventoryValue
  inventorySource
  inventoryType
  dynamicTags
  tagSchema
  networkBlock
  prefix
  suffix
  suppressed
  tags
  entityNamespace
}
    `;
export const CustomEntityTypeConfigListItemFragmentDoc = gql`
    fragment CustomEntityTypeConfigListItemFragment on CustomEntityType {
  id
  identifier
  name
  fields
}
    `;
export const InsightSubResolutionFragmentDoc = gql`
    fragment InsightSubResolutionFragment on InsightResolution {
  id
  name
  description
  parentId
}
    `;
export const InsightResolutionFragmentDoc = gql`
    fragment InsightResolutionFragment on InsightResolution {
  id
  name
  description
  parentId
  subResolutions {
    ...InsightSubResolutionFragment
  }
}
    ${InsightSubResolutionFragmentDoc}`;
export const LogMappingFragmentDoc = gql`
    fragment LogMappingFragment on LogMapping {
  id
  name
  recordType
  isStructured
  parsingPatterns {
    id
    value
  }
  structuredInputs {
    vendor
    product
  }
  inputVendor
  inputProduct
  vendor
  product
  logFormat
  eventIdPattern
  isCustom
  isEnabled
  recordCount07d
  recordCount24h
  source
}
    `;
export const LogMappingFieldsFragmentDoc = gql`
    fragment LogMappingFields on LogMapping {
  id
  name
  source
  recordType
  fields {
    alternateValues
    caseInsensitive
    defaultValue
    fieldJoin
    format
    formatParameters
    joinDelimiter
    lookup {
      key
      value
    }
    name
    splitDelimiter
    splitIndex
    value
    valueType
  }
  isStructured
  parsingPatterns {
    id
    value
  }
  structuredInputs {
    logFormat
    vendor
    product
    eventIdPattern
  }
  vendor
  product
  isCustom
  isEnabled
  skippedValues
}
    `;
export const SumoMappingObjectFieldsFragmentDoc = gql`
    fragment SumoMappingObjectFields on SumoMapping {
  id
  enabled
  sourceCategory
  vendor
  product
  eventId
  logFormat
  syslogFormat
  syslogDelimiter
  syslogKvDelimiter
  jsonExplode
  jsonZipOperations {
    keyName
    matchKey
    matchValue
  }
  exportConfigJson
  created
  lastUpdated
  createdBy
  lastUpdatedBy
}
    `;
export const WorkflowInsightStatusFragmentDoc = gql`
    fragment WorkflowInsightStatusFragment on InsightStatus {
  id
  name
  displayName
  source
  description
  color
}
    `;
export const CustomInsightFieldsFragmentDoc = gql`
    fragment CustomInsightFields on CustomInsight {
  id
  created
  deleted
  description
  dynamicSeverity {
    minimumSignalSeverity
    insightSeverity
  }
  enabled
  lastUpdated
  name
  ordered
  ruleIds
  severity
  signalNames
  signalMatchStrategy
  tags
}
    `;
export const YaraRuleFragmentDoc = gql`
    fragment YaraRule on YaraRule {
  enabled
  name
  id
  description
  expression
  severity
  ruleSource
}
    `;
export const SearchYaraRuleFragmentDoc = gql`
    fragment SearchYaraRule on YaraRule {
  ...YaraRule
  source {
    id
    name
    sourceType
  }
}
    ${YaraRuleFragmentDoc}`;
export const YaraSourceFragmentDoc = gql`
    fragment YaraSource on YaraSource {
  id
  name
  description
  sourceType
  created
  createdBy
  lastUpdated
  lastUpdatedBy
  githubConfig {
    enabled
    url
    username
    token
    yaraFileRegex
    defaultSeverity
  }
  rules {
    total
  }
  issues
}
    `;
export const MatchListFragmentDoc = gql`
    fragment MatchList on MatchList {
  id
  name
  description
  defaultTtl
  targetColumn
  created
  createdBy
  lastUpdated
  lastUpdatedBy
  items {
    total
  }
}
    `;
export const MatchListItemFragmentDoc = gql`
    fragment MatchListItem on MatchListItem {
  id
  value
  active
  expiration
  meta {
    description
  }
}
    `;
export const MatchListSelectFragmentDoc = gql`
    fragment MatchListSelectFragment on MatchList {
  id
  name
}
    `;
export const NetworkBlockFragmentDoc = gql`
    fragment NetworkBlock on NetworkBlock {
  id
  addressBlock
  label
  internal
  suppressesSignals
  created
}
    `;
export const RuleTuningExpressionFragmentDoc = gql`
    fragment RuleTuningExpression on RuleTuningExpression {
  id
  name
  description
  expression
  enabled
  isGlobal
  exclude
  rules {
    ... on RuleInterface {
      id
    }
  }
  created
  lastUpdated
  lastUpdatedByUser {
    id
    email
    name
  }
}
    `;
export const RuleExportFragmentDoc = gql`
    fragment RuleExportFragment on RuleInterface {
  exportJson
}
    `;
export const RuleBuilderScoreMappingFieldsFragmentDoc = gql`
    fragment RuleBuilderScoreMappingFields on RuleScoreMapping {
  type
  default
  field
  mapping {
    type
    from
    fromEnd
    to
  }
}
    `;
export const AggregationRuleBuilderFieldsFragmentDoc = gql`
    fragment AggregationRuleBuilderFields on AggregationRule {
  suppressionWindowSize
  suppressionWindowSizeOverride {
    original
    override
  }
  aggregationFunctions {
    name
    function
    arguments
  }
  descriptionExpression
  entitySelectors {
    expression
    entityType
  }
  groupByAsset
  groupByFields
  matchExpression
  nameExpression
  scoreMapping {
    ...RuleBuilderScoreMappingFields
  }
  triggerExpression
  windowSizeMilliseconds: windowSize
  created
  createdByUser {
    email
    id
    name
    username
  }
  history {
    user {
      email
      name
      role
      username
    }
    description
    timestamp
  }
  isPrototype
  id
  lastUpdated
  lastUpdatedByUser {
    email
    id
    name
    username
  }
  name
  ruleDescription
  ruleId
  ruleSource
  ruleType
  enabled
  status {
    status
    message
  }
  summaryExpression
  tags
  tuningExpressions {
    enabled
    expression
    id
    isGlobal
    exclude
    name
  }
  hasOverride
  isPrototypeOverride {
    original
    override
  }
  entitySelectorsOverride {
    original {
      expression
      entityType
    }
    override {
      expression
      entityType
    }
  }
  nameOverride {
    original
    override
  }
  nameExpressionOverride {
    original
    override
  }
  summaryExpressionOverride {
    original
    override
  }
  tagsOverride {
    original
    override
  }
  descriptionExpressionOverride {
    original
    override
  }
  scoreMappingOverride {
    original {
      ...RuleBuilderScoreMappingFields
    }
    override {
      ...RuleBuilderScoreMappingFields
    }
  }
  groupByFieldsOverride {
    original
    override
  }
  windowSizeOverride {
    original
    override
  }
}
    ${RuleBuilderScoreMappingFieldsFragmentDoc}`;
export const ChainRuleBuilderFieldsFragmentDoc = gql`
    fragment ChainRuleBuilderFields on ChainRule {
  suppressionWindowSize
  suppressionWindowSizeOverride {
    original
    override
  }
  description
  entitySelectors {
    expression
    entityType
  }
  expressionsAndLimits {
    index
    expression
    limit
  }
  score
  windowSizeMilliseconds: windowSize
  created
  createdByUser {
    email
    id
    name
    username
  }
  history {
    user {
      email
      name
      role
      username
    }
    description
    timestamp
  }
  groupByFields
  isPrototype
  id
  lastUpdated
  lastUpdatedByUser {
    email
    id
    name
    username
  }
  name
  ruleDescription
  ruleId
  ruleSource
  ruleType
  enabled
  status {
    status
    message
  }
  ordered
  summaryExpression
  tags
  tuningExpressions {
    enabled
    expression
    id
    isGlobal
    exclude
    name
  }
  isPrototypeOverride {
    original
    override
  }
  entitySelectorsOverride {
    original {
      expression
      entityType
    }
    override {
      expression
      entityType
    }
  }
  expressionsAndLimitsOverride {
    original {
      expression
      limit
      index
    }
    override {
      expression
      limit
      index
    }
  }
  nameOverride {
    original
    override
  }
  summaryExpressionOverride {
    original
    override
  }
  tagsOverride {
    original
    override
  }
  descriptionOverride {
    original
    override
  }
  scoreOverride {
    original
    override
  }
  windowSizeOverride {
    original
    override
  }
  groupByFieldsOverride {
    original
    override
  }
}
    `;
export const FirstSeenRuleBuilderFieldsFragmentDoc = gql`
    fragment FirstSeenRuleBuilderFields on FirstSeenRule {
  suppressionWindowSize
  suppressionWindowSizeOverride {
    original
    override
  }
  baselineType
  baselineStatus
  baselineWindowSize
  baselineWindowSizeOverride {
    original
    override
  }
  baselineLastStarted
  created
  createdByUser {
    email
    id
    name
    username
  }
  descriptionExpression
  descriptionExpressionOverride {
    original
    override
  }
  enabled
  entitySelectors {
    expression
    entityType
  }
  entitySelectorsOverride {
    original {
      expression
      entityType
    }
    override {
      expression
      entityType
    }
  }
  filterExpression
  groupByFields
  groupByFieldsOverride {
    original
    override
  }
  history {
    user {
      email
      name
      role
      username
    }
    description
    timestamp
  }
  groupByFields
  groupByFieldsOverride {
    original
    override
  }
  id
  isPrototype
  isPrototypeOverride {
    original
    override
  }
  lastUpdated
  lastUpdatedByUser {
    email
    id
    name
    username
  }
  name
  nameOverride {
    original
    override
  }
  nameExpression
  nameExpressionOverride {
    original
    override
  }
  retentionWindowSize
  retentionWindowSizeOverride {
    original
    override
  }
  ruleDescription
  ruleId
  ruleSource
  ruleType
  score
  scoreOverride {
    original
    override
  }
  status {
    status
    message
  }
  summaryExpression
  summaryExpressionOverride {
    original
    override
  }
  tags
  tagsOverride {
    original
    override
  }
  tuningExpressions {
    enabled
    expression
    exclude
    id
    isGlobal
    name
  }
  valueExpression
  valueFields
  version
}
    `;
export const CommonRuleBuilderFieldsFragmentDoc = gql`
    fragment CommonRuleBuilderFields on RuleInterface {
  suppressionWindowSize
  suppressionWindowSizeOverride {
    original
    override
  }
  created
  createdByUser {
    email
    id
    name
    username
  }
  entitySelectors {
    expression
    entityType
  }
  history {
    user {
      email
      name
      role
      username
    }
    description
    timestamp
  }
  id
  isPrototype
  lastUpdated
  lastUpdatedByUser {
    email
    id
    name
    username
  }
  name
  ruleDescription
  ruleId
  ruleSource
  ruleType
  enabled
  status {
    status
    message
  }
  summaryExpression
  tags
  tuningExpressions {
    enabled
    expression
    id
    isGlobal
    exclude
    name
  }
}
    `;
export const MatchRuleBuilderFieldsFragmentDoc = gql`
    fragment MatchRuleBuilderFields on MatchRule {
  ...CommonRuleBuilderFields
  description
  expression
  score
}
    ${CommonRuleBuilderFieldsFragmentDoc}`;
export const OutlierRuleBuilderFieldsFragmentDoc = gql`
    fragment OutlierRuleBuilderFields on OutlierRule {
  ...CommonRuleBuilderFields
  aggregationFunctions {
    name
    function
    arguments
  }
  baselineWindowSize
  baselineWindowSizeOverride {
    original
    override
  }
  baselineLastStarted
  baselineStatus
  descriptionExpression
  descriptionExpressionOverride {
    original
    override
  }
  deviationThreshold
  deviationThresholdOverride {
    original
    override
  }
  entitySelectorsOverride {
    original {
      entityType
      expression
    }
    override {
      entityType
      expression
    }
  }
  floorValue
  floorValueOverride {
    original
    override
  }
  groupByFields
  groupByFieldsOverride {
    original
    override
  }
  isPrototypeOverride {
    original
    override
  }
  matchExpression
  nameExpression
  nameExpressionOverride {
    original
    override
  }
  nameOverride {
    original
    override
  }
  retentionWindowSize
  retentionWindowSizeOverride {
    original
    override
  }
  score
  scoreOverride {
    original
    override
  }
  summaryExpressionOverride {
    original
    override
  }
  tagsOverride {
    original
    override
  }
  windowSize
  windowSizeName
  windowSizeOverride {
    original
    override
  }
}
    ${CommonRuleBuilderFieldsFragmentDoc}`;
export const TemplatedMatchRuleBuilderFieldsFragmentDoc = gql`
    fragment TemplatedMatchRuleBuilderFields on TemplatedMatchRule {
  ...CommonRuleBuilderFields
  scoreMapping {
    ...RuleBuilderScoreMappingFields
  }
  expression
  descriptionExpression
  nameExpression
  hasOverride
  isPrototypeOverride {
    original
    override
  }
  entitySelectorsOverride {
    original {
      expression
      entityType
    }
    override {
      expression
      entityType
    }
  }
  nameOverride {
    original
    override
  }
  summaryExpressionOverride {
    original
    override
  }
  tagsOverride {
    original
    override
  }
  descriptionExpressionOverride {
    original
    override
  }
  nameExpressionOverride {
    original
    override
  }
  scoreMappingOverride {
    original {
      ...RuleBuilderScoreMappingFields
    }
    override {
      ...RuleBuilderScoreMappingFields
    }
  }
}
    ${CommonRuleBuilderFieldsFragmentDoc}
${RuleBuilderScoreMappingFieldsFragmentDoc}`;
export const ThresholdRuleBuilderFieldsFragmentDoc = gql`
    fragment ThresholdRuleBuilderFields on ThresholdRule {
  ...CommonRuleBuilderFields
  countDistinct
  countField
  description
  expression
  groupByFields
  limit
  score
  version
  windowSizeMilliseconds: windowSize
  hasOverride
  isPrototypeOverride {
    original
    override
  }
  entitySelectorsOverride {
    original {
      expression
      entityType
    }
    override {
      expression
      entityType
    }
  }
  nameOverride {
    original
    override
  }
  summaryExpressionOverride {
    original
    override
  }
  tagsOverride {
    original
    override
  }
  descriptionOverride {
    original
    override
  }
  scoreOverride {
    original
    override
  }
  limitOverride {
    original
    override
  }
  groupByFieldsOverride {
    original
    override
  }
  windowSizeOverride {
    original
    override
  }
}
    ${CommonRuleBuilderFieldsFragmentDoc}`;
export const RuleBuilderFragmentDoc = gql`
    fragment RuleBuilderFragment on Rule {
  ...AggregationRuleBuilderFields
  ...ChainRuleBuilderFields
  ...FirstSeenRuleBuilderFields
  ...MatchRuleBuilderFields
  ...OutlierRuleBuilderFields
  ...TemplatedMatchRuleBuilderFields
  ...ThresholdRuleBuilderFields
}
    ${AggregationRuleBuilderFieldsFragmentDoc}
${ChainRuleBuilderFieldsFragmentDoc}
${FirstSeenRuleBuilderFieldsFragmentDoc}
${MatchRuleBuilderFieldsFragmentDoc}
${OutlierRuleBuilderFieldsFragmentDoc}
${TemplatedMatchRuleBuilderFieldsFragmentDoc}
${ThresholdRuleBuilderFieldsFragmentDoc}`;
export const RuleValidationResultFragmentDoc = gql`
    fragment RuleValidationResult on RuleValidationResult {
  isValid
  errorMessage
}
    `;
export const AggregationRuleTypeFieldsFragmentDoc = gql`
    fragment AggregationRuleTypeFields on AggregationRule {
  created
  enabled
  id
  isPrototype
  lastUpdated
  lastUpdatedByUser {
    email
    id
    name
  }
  name
  parentJaskId
  ruleId
  ruleSource
  ruleType
  signalCount07d
  signalCount24h
  aggregationFunctions {
    name
    function
    arguments
  }
  entitySelectors {
    expression
    entityType
  }
  descriptionExpression
  groupByAsset
  groupByFields
  matchExpression
  nameExpression
  suppressionWindowSize
  scoreMapping {
    type
    default
    field
    mapping {
      type
      from
      to
    }
  }
  triggerExpression
  windowSize
  status {
    message
    status
  }
  tags
}
    `;
export const ChainRuleTypeFieldsFragmentDoc = gql`
    fragment ChainRuleTypeFields on ChainRule {
  isPrototype
  entitySelectors {
    expression
    entityType
  }
  created
  signalCount07d
  signalCount24h
  suppressionWindowSize
  description
  enabled
  expressionsAndLimits {
    index
    expression
    limit
  }
  groupByFields
  id
  lastUpdated
  lastUpdatedByUser {
    email
    id
    name
  }
  name
  parentJaskId
  ruleId
  ruleSource
  ruleType
  score
  windowSize
  status {
    status
    message
  }
  tags
}
    `;
export const FirstSeenRuleTypeFieldsFragmentDoc = gql`
    fragment FirstSeenRuleTypeFields on FirstSeenRule {
  baselineLastStarted
  baselineWindowSize
  baselineStatus
  created
  enabled
  entitySelectors {
    expression
    entityType
  }
  descriptionExpression
  id
  isPrototype
  groupByFields
  lastUpdated
  lastUpdatedByUser {
    email
    id
    name
  }
  name
  nameExpression
  parentJaskId
  ruleDescription
  ruleId
  ruleSource
  ruleType
  signalCount07d
  signalCount24h
  suppressionWindowSize
  score
  status {
    message
    status
  }
  tags
}
    `;
export const MatchRuleTypeFieldsFragmentDoc = gql`
    fragment MatchRuleTypeFields on MatchRule {
  id
  isPrototype
  name
  enabled
  description
  ruleId
  expression
  ruleSource
  entitySelectors {
    expression
    entityType
  }
  ruleType
  parentJaskId
  score
  created
  signalCount07d
  signalCount24h
  suppressionWindowSize
  lastUpdated
  lastUpdatedByUser {
    id
    email
    name
  }
  status {
    status
    message
  }
  tags
}
    `;
export const OutlierRuleTypeFieldsFragmentDoc = gql`
    fragment OutlierRuleTypeFields on OutlierRule {
  baselineLastStarted
  baselineStatus
  baselineWindowSize
  created
  enabled
  entitySelectors {
    expression
    entityType
  }
  descriptionExpression
  id
  isPrototype
  groupByFields
  lastUpdated
  lastUpdatedByUser {
    email
    id
    name
  }
  name
  nameExpression
  parentJaskId
  ruleDescription
  ruleId
  ruleSource
  ruleType
  signalCount07d
  signalCount24h
  suppressionWindowSize
  score
  status {
    message
    status
  }
  tags
}
    `;
export const TemplatedMatchRuleTypeFieldsFragmentDoc = gql`
    fragment TemplatedMatchRuleTypeFields on TemplatedMatchRule {
  id
  isPrototype
  expression
  name
  enabled
  ruleId
  ruleSource
  ruleType
  nameExpression
  descriptionExpression
  entitySelectors {
    expression
    entityType
  }
  parentJaskId
  signalCount07d
  signalCount24h
  suppressionWindowSize
  scoreMapping {
    type
    default
    field
    mapping {
      type
      from
      to
    }
  }
  created
  lastUpdated
  lastUpdatedByUser {
    id
    email
    name
  }
  status {
    status
    message
  }
  tags
}
    `;
export const ThresholdRuleTypeFieldsFragmentDoc = gql`
    fragment ThresholdRuleTypeFields on ThresholdRule {
  isPrototype
  entitySelectors {
    expression
    entityType
  }
  countDistinct
  countField
  created
  signalCount07d
  signalCount24h
  suppressionWindowSize
  description
  enabled
  expression
  groupByFields
  id
  lastUpdated
  lastUpdatedByUser {
    email
    id
    name
  }
  limit
  name
  parentJaskId
  ruleId
  ruleSource
  ruleType
  score
  version
  windowSize
  status {
    status
    message
  }
  tags
}
    `;
export const RuleFragmentDoc = gql`
    fragment RuleFragment on Rule {
  ...AggregationRuleTypeFields
  ...ChainRuleTypeFields
  ...FirstSeenRuleTypeFields
  ...MatchRuleTypeFields
  ...OutlierRuleTypeFields
  ...TemplatedMatchRuleTypeFields
  ...ThresholdRuleTypeFields
}
    ${AggregationRuleTypeFieldsFragmentDoc}
${ChainRuleTypeFieldsFragmentDoc}
${FirstSeenRuleTypeFieldsFragmentDoc}
${MatchRuleTypeFieldsFragmentDoc}
${OutlierRuleTypeFieldsFragmentDoc}
${TemplatedMatchRuleTypeFieldsFragmentDoc}
${ThresholdRuleTypeFieldsFragmentDoc}`;
export const SuppressListFragmentDoc = gql`
    fragment SuppressList on SuppressList {
  id
  name
  description
  defaultTtl
  targetColumn
  created
  createdBy
  lastUpdated
  lastUpdatedBy
  items {
    total
  }
}
    `;
export const SuppressListItemFragmentDoc = gql`
    fragment SuppressListItem on SuppressListItem {
  id
  value
  active
  expiration
  meta {
    description
  }
  listId
}
    `;
export const SuppressListSelectFragmentDoc = gql`
    fragment SuppressListSelectFragment on SuppressList {
  id
  name
}
    `;
export const ThreatIntelItemFragmentDoc = gql`
    fragment ThreatIntelItem on ThreatIntelItem {
  id
  value
  active
  expiration
  meta {
    description
  }
}
    `;
export const ThreatIntelSearchItemFragmentDoc = gql`
    fragment ThreatIntelSearchItem on ThreatIntelItem {
  ...ThreatIntelItem
  source {
    id
    name
    sourceType
  }
}
    ${ThreatIntelItemFragmentDoc}`;
export const ThreatIntelTaxiiFeedFragmentDoc = gql`
    fragment ThreatIntelTaxiiFeed on TaxiiFeed {
  url
  username
  hasPassword
  lastTimeDataReceived
  lastTimeFailed
  consecutiveFailureCount
  lastPollSize
  enabled
  maxLookbackDays
  pollIntervalMinutes
  useTtlFromIndicators
  defaultTtlDays
  hasCertificate
  hasCertificatePassword
  lastRun
  collections
  subscriptionId
  recentFailures {
    timestamp
    error
    collectionName
  }
}
    `;
export const ThreatIntelSourceFragmentDoc = gql`
    fragment ThreatIntelSource on ThreatIntelSource {
  id
  name
  description
  sourceType
  created
  createdBy
  lastUpdated
  lastUpdatedBy
  taxiiFeed {
    ...ThreatIntelTaxiiFeed
  }
  idefenseConfig {
    enabled
    apiKey
  }
  threatQConfig {
    enabled
    baseUrl
    clientId
    pollIntervalMinutes
    customFiltersJson
    extraHeaders
    hasCertificate
    useExpiration
  }
  items {
    total
  }
}
    ${ThreatIntelTaxiiFeedFragmentDoc}`;
export const EntityDetailsTimelineSignalsFragmentDoc = gql`
    fragment EntityDetailsTimelineSignalsFragment on Signal {
  contentType
  description
  id
  name
  severity
  timestamp
}
    `;
export const EntityDetailsInsightsFragmentDoc = gql`
    fragment EntityDetailsInsightsFragment on Insight {
  signals {
    id
  }
  assignee {
    ... on Team {
      id
      name
    }
    ... on User {
      id
      displayName
      username
      email
    }
  }
  readableId
  relatedIncidents {
    id
    name
    type
    link
    status
    assignee
  }
  status {
    id
    name
    displayName
  }
  timestamp
  resolution
  subResolution
  id
  deployment
  tenant
  name
  description
  confidence
  tags
  severity
  tenantUrl
  signalCount
}
    `;
export const EntityTimelineSignalInsightFragmentDoc = gql`
    fragment EntityTimelineSignalInsightFragment on Insight {
  name
  readableId
  severity
}
    `;
export const EntityTimelineSignalsFragmentDoc = gql`
    fragment EntityTimelineSignalsFragment on Signal {
  id
  name
  severity
  allRecordsJson
  insights {
    ...EntityTimelineSignalInsightFragment
  }
}
    ${EntityTimelineSignalInsightFragmentDoc}`;
export const EntityListFragmentDoc = gql`
    fragment EntityListFragment on EntityInterface {
  activityScore
  criticality
  entityType
  entityTypeName
  id
  isWhitelisted
  lastSeen
  recentSignalSeverity
  reputation
  reputationSources
  sensorZone
  suppressListsObj {
    id
    name
  }
  tags
  value
}
    `;
export const EntityDetailsAuditLogFragmentDoc = gql`
    fragment EntityDetailsAuditLogFragment on EntityAuditLog {
  id
  action
  timestamp
  suppressedComment
  metaJson
  user {
    id
    email
    displayName
  }
}
    `;
export const EntityCriticalityConfigListFragmentDoc = gql`
    fragment EntityCriticalityConfigListFragment on EntityCriticalityConfig {
  id
  name
  severityExpression
}
    `;
export const InsightStatusMetricsStatusFragmentDoc = gql`
    fragment InsightStatusMetricsStatusFragment on InsightStatus {
  name
  id
  displayName
  color
}
    `;
export const InsightStatusMetricsFragmentDoc = gql`
    fragment InsightStatusMetricsFragment on InsightCountsByStatusDataPoint {
  timestamp
  value {
    closed
    inProgress
    new
    other
    otherDetail {
      statusId
      statusName
      count
    }
  }
}
    `;
export const InsightEntityFragmentDoc = gql`
    fragment InsightEntity on EntityInterface {
  id
  entityType
  entityTypeName
  reputation
  value
}
    `;
export const EntityWithRelatedEntitiesFragmentDoc = gql`
    fragment EntityWithRelatedEntities on EntityInterface {
  ...InsightEntity
  relatedEntities(start: $start, end: $end) {
    ...InsightEntity
  }
}
    ${InsightEntityFragmentDoc}`;
export const InsightEntityWithRelationsFragmentDoc = gql`
    fragment InsightEntityWithRelations on EntityInterface {
  id
  relatedEntities(start: $start, end: $end, entityTypes: $entityTypes) {
    ...InsightEntity
  }
  involvedEntities(start: $start, end: $end, entityTypes: $entityTypes) {
    ...InsightEntity
  }
}
    ${InsightEntityFragmentDoc}`;
export const EntityFieldsFragmentDoc = gql`
    fragment EntityFieldsFragment on EntityInterface {
  id
  criticality
  entityType
  entityTypeName
  value
  sensorZone
}
    `;
export const SignalFragmentDoc = gql`
    fragment SignalFragment on Signal {
  allRecordsJson
  description
  entity {
    ...EntityFieldsFragment
  }
  id
  name
  recordCount
  ruleType
  ruleId
  severity
  prototype
  suppressedBy
  isSuppressedBySuppressList
  suppressedByNetworkBlock
  isSuppressedByEntity
  contentType: contentTypeEnum
  timestamp
  summary
  tags
}
    ${EntityFieldsFragmentDoc}`;
export const InsightDetailRelatedInsightFragmentDoc = gql`
    fragment InsightDetailRelatedInsight on Insight {
  id
  deployment
  tenant
  name
  readableId
  signals {
    id
  }
  tenantUrl
  created
}
    `;
export const SignalTimelineFragmentDoc = gql`
    fragment SignalTimelineFragment on Signal {
  contentType
  description
  id
  name
  severity
  timestamp
}
    `;
export const InsightCommentFragmentDoc = gql`
    fragment InsightComment on InsightComment {
  user: author {
    email
    id
    name
    username
  }
  body
  id
  timestamp
}
    `;
export const InsightCommentsFragmentDoc = gql`
    fragment InsightComments on Insight {
  comments {
    ...InsightComment
  }
}
    ${InsightCommentFragmentDoc}`;
export const InsightHistoryEventFragmentDoc = gql`
    fragment InsightHistoryEvent on InsightHistoryEvent {
  user {
    id
    name
    email
    username
  }
  body: description
  timestamp
}
    `;
export const InsightHistoryEventsFragmentDoc = gql`
    fragment InsightHistoryEvents on Insight {
  history {
    ...InsightHistoryEvent
  }
}
    ${InsightHistoryEventFragmentDoc}`;
export const InsightDetailAssigneeFragmentDoc = gql`
    fragment InsightDetailAssigneeFragment on InsightAssignee {
  ... on Team {
    id
    name
  }
  ... on User {
    id
    displayName
    username
  }
}
    `;
export const InsightDetailSignalFragmentDoc = gql`
    fragment InsightDetailSignalFragment on Signal {
  allRecordsJson
  description
  id
  name
  recordCount
  ruleType
  severity
  prototype
  suppressedBy
  isSuppressedBySuppressList
  suppressedByNetworkBlock
  isSuppressedByEntity
  contentType: contentTypeEnum
  timestamp
  summary
  tags
}
    `;
export const KeyEvidenceFieldsFragmentDoc = gql`
    fragment KeyEvidenceFields on KeyEvidence {
  id
  title
  reasoning
  verdict
}
    `;
export const InsightTriageFieldsFragmentDoc = gql`
    fragment InsightTriageFields on Triage {
  id
  insightID
  verdict
  summary
  recommendation {
    accepted
    severity
  }
  keyEvidences {
    ...KeyEvidenceFields
  }
}
    ${KeyEvidenceFieldsFragmentDoc}`;
export const InsightDetailInsightFragmentDoc = gql`
    fragment InsightDetailInsightFragment on Insight {
  assignee {
    ...InsightDetailAssigneeFragment
  }
  description
  insightSignalSeverityTotal
  signalCount
  source
  uniqueSignalCount
  resolution
  subResolution
  duplicateInsight {
    id
    name
  }
  enrichments {
    type
    enrichedObjId
    enrichedObjType
    raw
    detailJson
    externalUrl
    reputation
    expiresAt
  }
  relatedEnrichments {
    type
    enrichedObjId
    enrichedObjType
    raw
    detailJson
    externalUrl
    reputation
    expiresAt
  }
  entity {
    ...EntityFieldsFragment
    recentSignalSeverity
    reputation
    reputationSources
  }
  id
  name
  readableId
  relatedIncidents {
    id
    name
    type
    link
    status
    assignee
  }
  recordDateTimeRange {
    start
    end
  }
  severity
  originalSeverity
  confidence
  signals {
    ...InsightDetailSignalFragment
  }
  tags
  status {
    name
    displayName
  }
  timestamp
  created
  summary @include(if: $enableAIInsightSummary)
  triage @include(if: $enableAgenticSecOps) {
    ...InsightTriageFields
  }
}
    ${InsightDetailAssigneeFragmentDoc}
${EntityFieldsFragmentDoc}
${InsightDetailSignalFragmentDoc}
${InsightTriageFieldsFragmentDoc}`;
export const InsightDetailActionFragmentDoc = gql`
    fragment InsightDetailActionFragment on Action {
  configurationJson
  createdTime
  id
  parameters {
    name
    displayName
    required
  }
  name
  notificationTypes
  type
  enabled
}
    `;
export const InsightThresholdConfigFragmentDoc = gql`
    fragment InsightThresholdConfigFragment on InsightConfig {
  threshold
}
    `;
export const EntityRecentSignalFragmentDoc = gql`
    fragment EntityRecentSignal on Signal {
  id
  name
  recordCount
  contentType
  severity
  timestamp
}
    `;
export const InsightAssigneeFieldsFragmentDoc = gql`
    fragment InsightAssigneeFields on Insight {
  assignee {
    ... on Team {
      id
      name
    }
    ... on User {
      id
      displayName
      username
      email
    }
    ... on UnknownUser {
      username
    }
    ... on UnknownTeam {
      name
    }
  }
}
    `;
export const GroupedInsightFragmentDoc = gql`
    fragment GroupedInsightFragment on Insight {
  ...InsightAssigneeFields
  deployment
  tenant
  tenantName
  tenantUrl
  entity {
    ...EntityFieldsFragment
  }
  id
  name
  readableId
  relatedIncidents {
    id
    name
    type
    link
    status
    assignee
  }
  signalCount
  severity
  confidence
  signals {
    id
    name
    timestamp
  }
  status {
    name
    displayName
  }
  timestamp
  resolution
  subResolution
}
    ${InsightAssigneeFieldsFragmentDoc}
${EntityFieldsFragmentDoc}`;
export const UserProfileFieldsFragmentDoc = gql`
    fragment UserProfileFields on CurrentUser {
  accountNotificationsEnabled
  apiKey
  apiKeyEnabled
  displayName
  email
  emailConfirmed
  insightReportNotificationInterval
  lastLogin
  mfaEnabled
  mfaQrCodeUrl
  mfaSecret
  name
  preferredTimezone
  role
  username
}
    `;
export const SearchHistoryInsightStatusFragmentDoc = gql`
    fragment SearchHistoryInsightStatusFragment on InsightStatus {
  id
  name
  displayName
  description
}
    `;
export const EntityCriticalityConfigsFragmentDoc = gql`
    fragment EntityCriticalityConfigsFragment on EntityCriticalityConfig {
  name
}
    `;
export const VisitedInsightPageFragmentDoc = gql`
    fragment VisitedInsightPageFragment on VisitedInsightPage {
  insight {
    id
    name
  }
  timestamp
}
    `;
export const VisitedSignalPageFragmentDoc = gql`
    fragment VisitedSignalPageFragment on VisitedSignalPage {
  signal {
    id
    name
  }
  timestamp
}
    `;
export const VisitedEntityPageFragmentDoc = gql`
    fragment VisitedEntityPageFragment on VisitedEntityPage {
  entity {
    ... on EntityInterface {
      id
      name: value
    }
  }
  timestamp
}
    `;
export const RecentlyVisitedDetailsPageFragmentDoc = gql`
    fragment RecentlyVisitedDetailsPageFragment on VisitedDetailPage {
  ...VisitedInsightPageFragment
  ...VisitedSignalPageFragment
  ...VisitedEntityPageFragment
}
    ${VisitedInsightPageFragmentDoc}
${VisitedSignalPageFragmentDoc}
${VisitedEntityPageFragmentDoc}`;
export const VisitedSearchQueryPageFragmentDoc = gql`
    fragment VisitedSearchQueryPageFragment on VisitedSearchQueryPage {
  q
  resultType
  timestamp
}
    `;
export const SearchHistoryUserFragmentDoc = gql`
    fragment SearchHistoryUserFragment on User {
  displayName
  email
  id
  name
  username
}
    `;
export const SignalQueryFragmentDoc = gql`
    fragment SignalQueryFragment on Signal {
  description
  enrichments {
    type
    enrichedObjId
    enrichedObjType
    raw
    detailJson
    externalUrl
    reputation
    expiresAt
  }
  extra
  id
  name
  prototype
  ruleId
  ruleType
  allRecordsJson
  recordCount
  contentType: contentTypeEnum
  severity
  suppressedBySignal {
    id
    name
    contentType: contentTypeEnum
    insights {
      id
    }
  }
  summary
  supportsRecordSearch
  isSuppressedByEntity
  isSuppressedBySuppressList
  ruleType
  suppressedByNetworkBlock
  suppressesSignals {
    total
  }
  tags
  timestamp
  created
  entity {
    ...EntityFieldsFragment
  }
  extra
  id
  insights {
    id
    name
    readableId
    signals {
      id
    }
  }
}
    ${EntityFieldsFragmentDoc}`;
export const EntityDetailsIpAddressFragmentDoc = gql`
    fragment EntityDetailsIpAddressFragment on IPAddress {
  address
  version
  continentCode
  continentName
  countryCode
  countryName
  region
  city
  latitude
  longitude
  accuracyRadius
  isp
  org
  asn
  aso
  location
}
    `;
export const EntityDetailsFragmentDoc = gql`
    fragment EntityDetailsFragment on EntityInterface {
  activityScore
  recentSignalSeverity
  criticality
  enrichments {
    type
    enrichedObjId
    enrichedObjType
    raw
    detailJson
    externalUrl
    reputation
    expiresAt
  }
  entityType
  entityTypeName
  firstSeen
  id
  isWhitelisted
  lastSeen
  networkBlocks {
    addressBlock
    label
  }
  value
  sensorZone
  ipAddressDetails {
    ...EntityDetailsIpAddressFragment
  }
  sources {
    sourceType
  }
}
    ${EntityDetailsIpAddressFragmentDoc}`;
export const EntitySummaryFragmentDoc = gql`
    fragment EntitySummaryFragment on EntityInterface {
  activityScore
  criticality
  enrichments {
    detailJson
    type
  }
  entityType
  entityTypeName
  firstSeen
  id
  isWhitelisted
  lastSeen
  networkBlocks {
    addressBlock
    label
  }
  value
  sensorZone
  ipAddressDetails {
    address
    version
    continentCode
    continentName
    countryCode
    countryName
    region
    city
    latitude
    longitude
    accuracyRadius
    isp
    org
    asn
    aso
    location
  }
  signals: signalsV2(
    start: $detectionWindowStartTime
    end: $detectionWindowEndTime
    uniqueResults: true
  ) {
    total
  }
  insights(
    start: $detectionWindowStartTime
    end: $detectionWindowEndTime
    uniqueResults: true
  ) {
    total
  }
}
    `;
export const EntityExecutedAutomationsFragmentDoc = gql`
    fragment EntityExecutedAutomationsFragment on ExecutedAutomation {
  executionId
  statusCode
}
    `;
export const InsightSignalFieldsFragmentDoc = gql`
    fragment InsightSignalFields on Signal {
  contentType
  id
  name
  severity
  timestamp
}
    `;
export const InsightFieldsFragmentDoc = gql`
    fragment InsightFields on Insight {
  ...InsightAssigneeFields
  deployment
  tenant
  tenantName
  tenantUrl
  created
  description
  entity {
    ...EntityFieldsFragment
    isWhitelisted
  }
  id
  readableId
  relatedIncidents {
    id
    name
    type
    link
    status
    assignee
  }
  name
  signalCount
  uniqueSignalCount
  severity
  confidence
  signals {
    ...InsightSignalFields
  }
  resolution
  summary @include(if: $enableAIInsightSummary)
  subResolution
  tags
  status {
    id
    name
    displayName
  }
  lastUpdated
  timestamp
  source
  triage @include(if: $enableAgenticSecOps) {
    ...InsightTriageFields
  }
}
    ${InsightAssigneeFieldsFragmentDoc}
${EntityFieldsFragmentDoc}
${InsightSignalFieldsFragmentDoc}
${InsightTriageFieldsFragmentDoc}`;
export const EnabledContextActionFragmentDoc = gql`
    fragment EnabledContextActionFragment on ContextAction {
  allRecordFields
  entityTypes
  id
  iocTypes
  name
  recordFields
  template
}
    `;
export const EntityAsideEnrichmentFieldsFragmentDoc = gql`
    fragment EntityAsideEnrichmentFields on Enrichment {
  reputation
  type
  externalUrl
  normalizedIndicator {
    id
    indicator
    source
    __typename
  }
  __typename
}
    `;
export const EntityAsideSuppressListFragmentDoc = gql`
    fragment EntityAsideSuppressList on SuppressList {
  id
  name
}
    `;
export const EntityAsideEntitySourcesFragmentDoc = gql`
    fragment EntityAsideEntitySources on EntityMetadataSource {
  sourceType
  entityGroupConfigurationId
  entityGroupConfigurationName
}
    `;
export const EntityAsideEntityFragmentDoc = gql`
    fragment EntityAsideEntity on EntityInterface {
  auditLog {
    id
  }
  id
  enrichments {
    ...EntityAsideEnrichmentFields
  }
  entityType
  entityTypeName
  insights(
    end: $detectionWindowEndTime
    limit: $limit
    offset: $offset
    start: $detectionWindowStartTime
    uniqueResults: true
  ) {
    objects {
      name
      readableId
      severity
      timestamp
    }
    total
  }
  ipAddressDetails {
    address
    countryCode
    countryName
  }
  isWhitelisted
  suppressListsObj {
    ...EntityAsideSuppressList
  }
  networkBlocks {
    id
  }
  notes {
    id
  }
  reputation
  sources {
    ...EntityAsideEntitySources
  }
  signals: signalsV2(
    end: $detectionWindowEndTime
    limit: $limit
    offset: $offset
    start: $detectionWindowStartTime
    uniqueResults: true
  ) {
    objects {
      created
      id
      name
    }
    total
  }
  value
  recentSignalSeverity
}
    ${EntityAsideEnrichmentFieldsFragmentDoc}
${EntityAsideSuppressListFragmentDoc}
${EntityAsideEntitySourcesFragmentDoc}`;
export const InsightStatusDisplayFragmentDoc = gql`
    fragment InsightStatusDisplay on InsightStatus {
  id
  name
  displayName
  color
}
    `;
export const EntityInventoryComputerFragmentDoc = gql`
    fragment EntityInventoryComputerFragment on ComputerInventory {
  computerName
  deviceUniqueId
  groups
  hostname
  ip
  location
  mac
  metadataJson @include(if: $includeMetadata)
  natIp
  normalizedComputerName
  normalizedHostname
  os
  osVersion
  parsedTime
  source
  timestamp
  userId
}
    `;
export const EntityInventoryUserFragmentDoc = gql`
    fragment EntityInventoryUserFragment on UserInventory {
  department
  emails
  givenName
  groups
  lastName
  metadataJson @include(if: $includeMetadata)
  middleName
  normalizedUsername
  parsedTime
  source
  timestamp
  username
}
    `;
export const EntityInventoryFragmentDoc = gql`
    fragment EntityInventoryFragment on EntityInterface {
  criticality
  id
  inventory {
    ...EntityInventoryComputerFragment
    ...EntityInventoryUserFragment
  }
}
    ${EntityInventoryComputerFragmentDoc}
${EntityInventoryUserFragmentDoc}`;
export const RuleItemFragmentDoc = gql`
    fragment RuleItemFragment on RuleInterface {
  enabled
  id
  name
}
    `;
export const RuleSelectFragmentDoc = gql`
    fragment RuleSelectFragment on RuleInterface {
  enabled
  id
  name
}
    `;
export const TestRuleTuningExpressionFragmentDoc = gql`
    fragment TestRuleTuningExpressionFragment on RuleTuningExpression {
  enabled
  expression
  id
  isGlobal
  exclude
  name
}
    `;
export const AppInfoOperationDocument = gql`
    query AppInfoOperation($featureFlagsToLookup: [String!]!, $enabledByDefaultFeatureFlags: [String!]!) {
  currentUser {
    ...CurrentUserFragment
  }
  isFederatedCluster
  enabledFeatureFlags(
    featureFlagsToLookup: $featureFlagsToLookup
    enabledByDefaultFeatureFlags: $enabledByDefaultFeatureFlags
  )
  version
  sumoLogicRegion
  deployment
  orgId
  orgName
  cspCustomReportUrl
  sessionTimeoutMinutes
}
    ${CurrentUserFragmentDoc}`;

/**
 * __useAppInfoOperationQuery__
 *
 * To run a query within a React component, call `useAppInfoOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppInfoOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppInfoOperationQuery({
 *   variables: {
 *      featureFlagsToLookup: // value for 'featureFlagsToLookup'
 *      enabledByDefaultFeatureFlags: // value for 'enabledByDefaultFeatureFlags'
 *   },
 * });
 */
export function useAppInfoOperationQuery(baseOptions: Apollo.QueryHookOptions<AppInfoOperationQuery, AppInfoOperationQueryVariables> & ({ variables: AppInfoOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppInfoOperationQuery, AppInfoOperationQueryVariables>(AppInfoOperationDocument, options);
      }
export function useAppInfoOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppInfoOperationQuery, AppInfoOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppInfoOperationQuery, AppInfoOperationQueryVariables>(AppInfoOperationDocument, options);
        }
export function useAppInfoOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AppInfoOperationQuery, AppInfoOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppInfoOperationQuery, AppInfoOperationQueryVariables>(AppInfoOperationDocument, options);
        }
export type AppInfoOperationQueryHookResult = ReturnType<typeof useAppInfoOperationQuery>;
export type AppInfoOperationLazyQueryHookResult = ReturnType<typeof useAppInfoOperationLazyQuery>;
export type AppInfoOperationSuspenseQueryHookResult = ReturnType<typeof useAppInfoOperationSuspenseQuery>;
export type AppInfoOperationQueryResult = Apollo.QueryResult<AppInfoOperationQuery, AppInfoOperationQueryVariables>;
export const AppInfoOperationSumoDocument = gql`
    query AppInfoOperationSumo {
  currentUserSumo {
    ...CurrentUserSumoFragment
  }
}
    ${CurrentUserSumoFragmentDoc}`;

/**
 * __useAppInfoOperationSumoQuery__
 *
 * To run a query within a React component, call `useAppInfoOperationSumoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppInfoOperationSumoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppInfoOperationSumoQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppInfoOperationSumoQuery(baseOptions?: Apollo.QueryHookOptions<AppInfoOperationSumoQuery, AppInfoOperationSumoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppInfoOperationSumoQuery, AppInfoOperationSumoQueryVariables>(AppInfoOperationSumoDocument, options);
      }
export function useAppInfoOperationSumoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppInfoOperationSumoQuery, AppInfoOperationSumoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppInfoOperationSumoQuery, AppInfoOperationSumoQueryVariables>(AppInfoOperationSumoDocument, options);
        }
export function useAppInfoOperationSumoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AppInfoOperationSumoQuery, AppInfoOperationSumoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AppInfoOperationSumoQuery, AppInfoOperationSumoQueryVariables>(AppInfoOperationSumoDocument, options);
        }
export type AppInfoOperationSumoQueryHookResult = ReturnType<typeof useAppInfoOperationSumoQuery>;
export type AppInfoOperationSumoLazyQueryHookResult = ReturnType<typeof useAppInfoOperationSumoLazyQuery>;
export type AppInfoOperationSumoSuspenseQueryHookResult = ReturnType<typeof useAppInfoOperationSumoSuspenseQuery>;
export type AppInfoOperationSumoQueryResult = Apollo.QueryResult<AppInfoOperationSumoQuery, AppInfoOperationSumoQueryVariables>;
export const UsersOperationDocument = gql`
    query UsersOperation($offset: Int, $limit: Int, $sort: String, $sortDir: SortDir, $active: Boolean) {
  users(
    offset: $offset
    limit: $limit
    sort: $sort
    sortDir: $sortDir
    active: $active
  ) {
    total
    hasNextPage
    objects {
      ...UserFields
    }
  }
  mfaEnabled
  ssoEnabled
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUsersOperationQuery__
 *
 * To run a query within a React component, call `useUsersOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersOperationQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUsersOperationQuery(baseOptions?: Apollo.QueryHookOptions<UsersOperationQuery, UsersOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersOperationQuery, UsersOperationQueryVariables>(UsersOperationDocument, options);
      }
export function useUsersOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsersOperationQuery, UsersOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersOperationQuery, UsersOperationQueryVariables>(UsersOperationDocument, options);
        }
export function useUsersOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersOperationQuery, UsersOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersOperationQuery, UsersOperationQueryVariables>(UsersOperationDocument, options);
        }
export type UsersOperationQueryHookResult = ReturnType<typeof useUsersOperationQuery>;
export type UsersOperationLazyQueryHookResult = ReturnType<typeof useUsersOperationLazyQuery>;
export type UsersOperationSuspenseQueryHookResult = ReturnType<typeof useUsersOperationSuspenseQuery>;
export type UsersOperationQueryResult = Apollo.QueryResult<UsersOperationQuery, UsersOperationQueryVariables>;
export const AllUsersOperationDocument = gql`
    query AllUsersOperation {
  users(active: true, limit: 1000) {
    objects {
      ...AllUsersFragment
    }
  }
}
    ${AllUsersFragmentDoc}`;

/**
 * __useAllUsersOperationQuery__
 *
 * To run a query within a React component, call `useAllUsersOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllUsersOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllUsersOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllUsersOperationQuery(baseOptions?: Apollo.QueryHookOptions<AllUsersOperationQuery, AllUsersOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllUsersOperationQuery, AllUsersOperationQueryVariables>(AllUsersOperationDocument, options);
      }
export function useAllUsersOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllUsersOperationQuery, AllUsersOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllUsersOperationQuery, AllUsersOperationQueryVariables>(AllUsersOperationDocument, options);
        }
export function useAllUsersOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllUsersOperationQuery, AllUsersOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllUsersOperationQuery, AllUsersOperationQueryVariables>(AllUsersOperationDocument, options);
        }
export type AllUsersOperationQueryHookResult = ReturnType<typeof useAllUsersOperationQuery>;
export type AllUsersOperationLazyQueryHookResult = ReturnType<typeof useAllUsersOperationLazyQuery>;
export type AllUsersOperationSuspenseQueryHookResult = ReturnType<typeof useAllUsersOperationSuspenseQuery>;
export type AllUsersOperationQueryResult = Apollo.QueryResult<AllUsersOperationQuery, AllUsersOperationQueryVariables>;
export const AssignedInsightEmailConfigOperationDocument = gql`
    query AssignedInsightEmailConfigOperation {
  assignedInsightEmailsEnabled
}
    `;

/**
 * __useAssignedInsightEmailConfigOperationQuery__
 *
 * To run a query within a React component, call `useAssignedInsightEmailConfigOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignedInsightEmailConfigOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignedInsightEmailConfigOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssignedInsightEmailConfigOperationQuery(baseOptions?: Apollo.QueryHookOptions<AssignedInsightEmailConfigOperationQuery, AssignedInsightEmailConfigOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignedInsightEmailConfigOperationQuery, AssignedInsightEmailConfigOperationQueryVariables>(AssignedInsightEmailConfigOperationDocument, options);
      }
export function useAssignedInsightEmailConfigOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignedInsightEmailConfigOperationQuery, AssignedInsightEmailConfigOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignedInsightEmailConfigOperationQuery, AssignedInsightEmailConfigOperationQueryVariables>(AssignedInsightEmailConfigOperationDocument, options);
        }
export function useAssignedInsightEmailConfigOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssignedInsightEmailConfigOperationQuery, AssignedInsightEmailConfigOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssignedInsightEmailConfigOperationQuery, AssignedInsightEmailConfigOperationQueryVariables>(AssignedInsightEmailConfigOperationDocument, options);
        }
export type AssignedInsightEmailConfigOperationQueryHookResult = ReturnType<typeof useAssignedInsightEmailConfigOperationQuery>;
export type AssignedInsightEmailConfigOperationLazyQueryHookResult = ReturnType<typeof useAssignedInsightEmailConfigOperationLazyQuery>;
export type AssignedInsightEmailConfigOperationSuspenseQueryHookResult = ReturnType<typeof useAssignedInsightEmailConfigOperationSuspenseQuery>;
export type AssignedInsightEmailConfigOperationQueryResult = Apollo.QueryResult<AssignedInsightEmailConfigOperationQuery, AssignedInsightEmailConfigOperationQueryVariables>;
export const UpdateAssignedInsightEmailsEnabledDocument = gql`
    mutation UpdateAssignedInsightEmailsEnabled($enabled: Boolean!) {
  updateAssignedInsightEmailsEnabled(enabled: $enabled) {
    ok
  }
}
    `;
export type UpdateAssignedInsightEmailsEnabledMutationFn = Apollo.MutationFunction<UpdateAssignedInsightEmailsEnabledMutation, UpdateAssignedInsightEmailsEnabledMutationVariables>;

/**
 * __useUpdateAssignedInsightEmailsEnabledMutation__
 *
 * To run a mutation, you first call `useUpdateAssignedInsightEmailsEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssignedInsightEmailsEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssignedInsightEmailsEnabledMutation, { data, loading, error }] = useUpdateAssignedInsightEmailsEnabledMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateAssignedInsightEmailsEnabledMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssignedInsightEmailsEnabledMutation, UpdateAssignedInsightEmailsEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssignedInsightEmailsEnabledMutation, UpdateAssignedInsightEmailsEnabledMutationVariables>(UpdateAssignedInsightEmailsEnabledDocument, options);
      }
export type UpdateAssignedInsightEmailsEnabledMutationHookResult = ReturnType<typeof useUpdateAssignedInsightEmailsEnabledMutation>;
export type UpdateAssignedInsightEmailsEnabledMutationResult = Apollo.MutationResult<UpdateAssignedInsightEmailsEnabledMutation>;
export type UpdateAssignedInsightEmailsEnabledMutationOptions = Apollo.BaseMutationOptions<UpdateAssignedInsightEmailsEnabledMutation, UpdateAssignedInsightEmailsEnabledMutationVariables>;
export const ActionsOperationDocument = gql`
    query ActionsOperation {
  actions {
    ...ActionObjectFragment
  }
}
    ${ActionObjectFragmentDoc}`;

/**
 * __useActionsOperationQuery__
 *
 * To run a query within a React component, call `useActionsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionsOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useActionsOperationQuery(baseOptions?: Apollo.QueryHookOptions<ActionsOperationQuery, ActionsOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionsOperationQuery, ActionsOperationQueryVariables>(ActionsOperationDocument, options);
      }
export function useActionsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionsOperationQuery, ActionsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionsOperationQuery, ActionsOperationQueryVariables>(ActionsOperationDocument, options);
        }
export function useActionsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActionsOperationQuery, ActionsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActionsOperationQuery, ActionsOperationQueryVariables>(ActionsOperationDocument, options);
        }
export type ActionsOperationQueryHookResult = ReturnType<typeof useActionsOperationQuery>;
export type ActionsOperationLazyQueryHookResult = ReturnType<typeof useActionsOperationLazyQuery>;
export type ActionsOperationSuspenseQueryHookResult = ReturnType<typeof useActionsOperationSuspenseQuery>;
export type ActionsOperationQueryResult = Apollo.QueryResult<ActionsOperationQuery, ActionsOperationQueryVariables>;
export const CreateActionOperationDocument = gql`
    mutation CreateActionOperation($fields: ActionFields!) {
  createAction(fields: $fields) {
    data {
      ...ActionObjectFragment
    }
  }
}
    ${ActionObjectFragmentDoc}`;
export type CreateActionOperationMutationFn = Apollo.MutationFunction<CreateActionOperationMutation, CreateActionOperationMutationVariables>;

/**
 * __useCreateActionOperationMutation__
 *
 * To run a mutation, you first call `useCreateActionOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateActionOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createActionOperationMutation, { data, loading, error }] = useCreateActionOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateActionOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateActionOperationMutation, CreateActionOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateActionOperationMutation, CreateActionOperationMutationVariables>(CreateActionOperationDocument, options);
      }
export type CreateActionOperationMutationHookResult = ReturnType<typeof useCreateActionOperationMutation>;
export type CreateActionOperationMutationResult = Apollo.MutationResult<CreateActionOperationMutation>;
export type CreateActionOperationMutationOptions = Apollo.BaseMutationOptions<CreateActionOperationMutation, CreateActionOperationMutationVariables>;
export const UpdateActionOperationDocument = gql`
    mutation UpdateActionOperation($id: ID!, $fields: ActionFields!) {
  updateAction(id: $id, fields: $fields) {
    data {
      ...ActionObjectFragment
    }
  }
}
    ${ActionObjectFragmentDoc}`;
export type UpdateActionOperationMutationFn = Apollo.MutationFunction<UpdateActionOperationMutation, UpdateActionOperationMutationVariables>;

/**
 * __useUpdateActionOperationMutation__
 *
 * To run a mutation, you first call `useUpdateActionOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionOperationMutation, { data, loading, error }] = useUpdateActionOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateActionOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActionOperationMutation, UpdateActionOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActionOperationMutation, UpdateActionOperationMutationVariables>(UpdateActionOperationDocument, options);
      }
export type UpdateActionOperationMutationHookResult = ReturnType<typeof useUpdateActionOperationMutation>;
export type UpdateActionOperationMutationResult = Apollo.MutationResult<UpdateActionOperationMutation>;
export type UpdateActionOperationMutationOptions = Apollo.BaseMutationOptions<UpdateActionOperationMutation, UpdateActionOperationMutationVariables>;
export const ActionConfigurationSchemasOperationDocument = gql`
    query ActionConfigurationSchemasOperation {
  actionConfigurationSchemas {
    typeName
    typeValue
    schemaJson
  }
}
    `;

/**
 * __useActionConfigurationSchemasOperationQuery__
 *
 * To run a query within a React component, call `useActionConfigurationSchemasOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionConfigurationSchemasOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionConfigurationSchemasOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useActionConfigurationSchemasOperationQuery(baseOptions?: Apollo.QueryHookOptions<ActionConfigurationSchemasOperationQuery, ActionConfigurationSchemasOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionConfigurationSchemasOperationQuery, ActionConfigurationSchemasOperationQueryVariables>(ActionConfigurationSchemasOperationDocument, options);
      }
export function useActionConfigurationSchemasOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionConfigurationSchemasOperationQuery, ActionConfigurationSchemasOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionConfigurationSchemasOperationQuery, ActionConfigurationSchemasOperationQueryVariables>(ActionConfigurationSchemasOperationDocument, options);
        }
export function useActionConfigurationSchemasOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActionConfigurationSchemasOperationQuery, ActionConfigurationSchemasOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActionConfigurationSchemasOperationQuery, ActionConfigurationSchemasOperationQueryVariables>(ActionConfigurationSchemasOperationDocument, options);
        }
export type ActionConfigurationSchemasOperationQueryHookResult = ReturnType<typeof useActionConfigurationSchemasOperationQuery>;
export type ActionConfigurationSchemasOperationLazyQueryHookResult = ReturnType<typeof useActionConfigurationSchemasOperationLazyQuery>;
export type ActionConfigurationSchemasOperationSuspenseQueryHookResult = ReturnType<typeof useActionConfigurationSchemasOperationSuspenseQuery>;
export type ActionConfigurationSchemasOperationQueryResult = Apollo.QueryResult<ActionConfigurationSchemasOperationQuery, ActionConfigurationSchemasOperationQueryVariables>;
export const DeleteActionOperationDocument = gql`
    mutation DeleteActionOperation($id: ID!) {
  deleteAction(id: $id) {
    ok
  }
}
    `;
export type DeleteActionOperationMutationFn = Apollo.MutationFunction<DeleteActionOperationMutation, DeleteActionOperationMutationVariables>;

/**
 * __useDeleteActionOperationMutation__
 *
 * To run a mutation, you first call `useDeleteActionOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActionOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActionOperationMutation, { data, loading, error }] = useDeleteActionOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteActionOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActionOperationMutation, DeleteActionOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActionOperationMutation, DeleteActionOperationMutationVariables>(DeleteActionOperationDocument, options);
      }
export type DeleteActionOperationMutationHookResult = ReturnType<typeof useDeleteActionOperationMutation>;
export type DeleteActionOperationMutationResult = Apollo.MutationResult<DeleteActionOperationMutation>;
export type DeleteActionOperationMutationOptions = Apollo.BaseMutationOptions<DeleteActionOperationMutation, DeleteActionOperationMutationVariables>;
export const AutomationQueryOperationDocument = gql`
    query AutomationQueryOperation($offset: Int, $limit: Int, $sort: [AutomationSort!]) {
  automations(offset: $offset, limit: $limit, sort: $sort) {
    hasNextPage
    total
    objects {
      ...AutomationRow
    }
  }
}
    ${AutomationRowFragmentDoc}`;

/**
 * __useAutomationQueryOperation__
 *
 * To run a query within a React component, call `useAutomationQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useAutomationQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomationQueryOperation({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAutomationQueryOperation(baseOptions?: Apollo.QueryHookOptions<AutomationQueryOperationQuery, AutomationQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutomationQueryOperationQuery, AutomationQueryOperationQueryVariables>(AutomationQueryOperationDocument, options);
      }
export function useAutomationQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutomationQueryOperationQuery, AutomationQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutomationQueryOperationQuery, AutomationQueryOperationQueryVariables>(AutomationQueryOperationDocument, options);
        }
export function useAutomationQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutomationQueryOperationQuery, AutomationQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AutomationQueryOperationQuery, AutomationQueryOperationQueryVariables>(AutomationQueryOperationDocument, options);
        }
export type AutomationQueryOperationHookResult = ReturnType<typeof useAutomationQueryOperation>;
export type AutomationQueryOperationLazyQueryHookResult = ReturnType<typeof useAutomationQueryOperationLazyQuery>;
export type AutomationQueryOperationSuspenseQueryHookResult = ReturnType<typeof useAutomationQueryOperationSuspenseQuery>;
export type AutomationQueryOperationQueryResult = Apollo.QueryResult<AutomationQueryOperationQuery, AutomationQueryOperationQueryVariables>;
export const DeleteAutomationOperationDocument = gql`
    mutation DeleteAutomationOperation($id: ID!) {
  deleteAutomation(id: $id) {
    ok
  }
}
    `;
export type DeleteAutomationOperationMutationFn = Apollo.MutationFunction<DeleteAutomationOperationMutation, DeleteAutomationOperationMutationVariables>;

/**
 * __useDeleteAutomationOperationMutation__
 *
 * To run a mutation, you first call `useDeleteAutomationOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAutomationOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAutomationOperationMutation, { data, loading, error }] = useDeleteAutomationOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAutomationOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAutomationOperationMutation, DeleteAutomationOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAutomationOperationMutation, DeleteAutomationOperationMutationVariables>(DeleteAutomationOperationDocument, options);
      }
export type DeleteAutomationOperationMutationHookResult = ReturnType<typeof useDeleteAutomationOperationMutation>;
export type DeleteAutomationOperationMutationResult = Apollo.MutationResult<DeleteAutomationOperationMutation>;
export type DeleteAutomationOperationMutationOptions = Apollo.BaseMutationOptions<DeleteAutomationOperationMutation, DeleteAutomationOperationMutationVariables>;
export const CreateAutomationOperationDocument = gql`
    mutation CreateAutomationOperation($fields: AutomationFields!) {
  createAutomation(fields: $fields) {
    data {
      ...AutomationRow
    }
  }
}
    ${AutomationRowFragmentDoc}`;
export type CreateAutomationOperationMutationFn = Apollo.MutationFunction<CreateAutomationOperationMutation, CreateAutomationOperationMutationVariables>;

/**
 * __useCreateAutomationOperationMutation__
 *
 * To run a mutation, you first call `useCreateAutomationOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutomationOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutomationOperationMutation, { data, loading, error }] = useCreateAutomationOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateAutomationOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAutomationOperationMutation, CreateAutomationOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAutomationOperationMutation, CreateAutomationOperationMutationVariables>(CreateAutomationOperationDocument, options);
      }
export type CreateAutomationOperationMutationHookResult = ReturnType<typeof useCreateAutomationOperationMutation>;
export type CreateAutomationOperationMutationResult = Apollo.MutationResult<CreateAutomationOperationMutation>;
export type CreateAutomationOperationMutationOptions = Apollo.BaseMutationOptions<CreateAutomationOperationMutation, CreateAutomationOperationMutationVariables>;
export const UpdateAutomationOperationDocument = gql`
    mutation UpdateAutomationOperation($fields: UpdateAutomationFields!, $id: ID!) {
  updateAutomation(fields: $fields, id: $id) {
    data {
      ...AutomationRow
    }
  }
}
    ${AutomationRowFragmentDoc}`;
export type UpdateAutomationOperationMutationFn = Apollo.MutationFunction<UpdateAutomationOperationMutation, UpdateAutomationOperationMutationVariables>;

/**
 * __useUpdateAutomationOperationMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomationOperationMutation, { data, loading, error }] = useUpdateAutomationOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAutomationOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomationOperationMutation, UpdateAutomationOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomationOperationMutation, UpdateAutomationOperationMutationVariables>(UpdateAutomationOperationDocument, options);
      }
export type UpdateAutomationOperationMutationHookResult = ReturnType<typeof useUpdateAutomationOperationMutation>;
export type UpdateAutomationOperationMutationResult = Apollo.MutationResult<UpdateAutomationOperationMutation>;
export type UpdateAutomationOperationMutationOptions = Apollo.BaseMutationOptions<UpdateAutomationOperationMutation, UpdateAutomationOperationMutationVariables>;
export const AutomationConfigQueryOperationDocument = gql`
    query AutomationConfigQueryOperation($offset: Int, $limit: Int) {
  automations(offset: $offset, limit: $limit) {
    total
    objects {
      description
      cseResourceSubTypes
      cseResourceType
      enabled
      executionTypes
      id
      name
      playbookId
    }
  }
}
    `;

/**
 * __useAutomationConfigQueryOperation__
 *
 * To run a query within a React component, call `useAutomationConfigQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useAutomationConfigQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutomationConfigQueryOperation({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useAutomationConfigQueryOperation(baseOptions?: Apollo.QueryHookOptions<AutomationConfigQueryOperationQuery, AutomationConfigQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AutomationConfigQueryOperationQuery, AutomationConfigQueryOperationQueryVariables>(AutomationConfigQueryOperationDocument, options);
      }
export function useAutomationConfigQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AutomationConfigQueryOperationQuery, AutomationConfigQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AutomationConfigQueryOperationQuery, AutomationConfigQueryOperationQueryVariables>(AutomationConfigQueryOperationDocument, options);
        }
export function useAutomationConfigQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AutomationConfigQueryOperationQuery, AutomationConfigQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AutomationConfigQueryOperationQuery, AutomationConfigQueryOperationQueryVariables>(AutomationConfigQueryOperationDocument, options);
        }
export type AutomationConfigQueryOperationHookResult = ReturnType<typeof useAutomationConfigQueryOperation>;
export type AutomationConfigQueryOperationLazyQueryHookResult = ReturnType<typeof useAutomationConfigQueryOperationLazyQuery>;
export type AutomationConfigQueryOperationSuspenseQueryHookResult = ReturnType<typeof useAutomationConfigQueryOperationSuspenseQuery>;
export type AutomationConfigQueryOperationQueryResult = Apollo.QueryResult<AutomationConfigQueryOperationQuery, AutomationConfigQueryOperationQueryVariables>;
export const DeleteAutomationDocument = gql`
    mutation DeleteAutomation($id: ID!) {
  deleteAutomation(id: $id) {
    ok
  }
}
    `;
export type DeleteAutomationMutationFn = Apollo.MutationFunction<DeleteAutomationMutation, DeleteAutomationMutationVariables>;

/**
 * __useDeleteAutomationMutation__
 *
 * To run a mutation, you first call `useDeleteAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAutomationMutation, { data, loading, error }] = useDeleteAutomationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAutomationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAutomationMutation, DeleteAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAutomationMutation, DeleteAutomationMutationVariables>(DeleteAutomationDocument, options);
      }
export type DeleteAutomationMutationHookResult = ReturnType<typeof useDeleteAutomationMutation>;
export type DeleteAutomationMutationResult = Apollo.MutationResult<DeleteAutomationMutation>;
export type DeleteAutomationMutationOptions = Apollo.BaseMutationOptions<DeleteAutomationMutation, DeleteAutomationMutationVariables>;
export const PlaybooksQueryOperationDocument = gql`
    query PlaybooksQueryOperation {
  playbooks {
    id
    name
    type
  }
}
    `;

/**
 * __usePlaybooksQueryOperation__
 *
 * To run a query within a React component, call `usePlaybooksQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `usePlaybooksQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaybooksQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function usePlaybooksQueryOperation(baseOptions?: Apollo.QueryHookOptions<PlaybooksQueryOperationQuery, PlaybooksQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlaybooksQueryOperationQuery, PlaybooksQueryOperationQueryVariables>(PlaybooksQueryOperationDocument, options);
      }
export function usePlaybooksQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlaybooksQueryOperationQuery, PlaybooksQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlaybooksQueryOperationQuery, PlaybooksQueryOperationQueryVariables>(PlaybooksQueryOperationDocument, options);
        }
export function usePlaybooksQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlaybooksQueryOperationQuery, PlaybooksQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlaybooksQueryOperationQuery, PlaybooksQueryOperationQueryVariables>(PlaybooksQueryOperationDocument, options);
        }
export type PlaybooksQueryOperationHookResult = ReturnType<typeof usePlaybooksQueryOperation>;
export type PlaybooksQueryOperationLazyQueryHookResult = ReturnType<typeof usePlaybooksQueryOperationLazyQuery>;
export type PlaybooksQueryOperationSuspenseQueryHookResult = ReturnType<typeof usePlaybooksQueryOperationSuspenseQuery>;
export type PlaybooksQueryOperationQueryResult = Apollo.QueryResult<PlaybooksQueryOperationQuery, PlaybooksQueryOperationQueryVariables>;
export const UpdateAutomationDocument = gql`
    mutation UpdateAutomation($fields: UpdateAutomationFields!, $id: ID!) {
  updateAutomation(fields: $fields, id: $id) {
    data {
      cseResourceSubTypes
      executionTypes
      enabled
    }
  }
}
    `;
export type UpdateAutomationMutationFn = Apollo.MutationFunction<UpdateAutomationMutation, UpdateAutomationMutationVariables>;

/**
 * __useUpdateAutomationMutation__
 *
 * To run a mutation, you first call `useUpdateAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutomationMutation, { data, loading, error }] = useUpdateAutomationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAutomationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAutomationMutation, UpdateAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAutomationMutation, UpdateAutomationMutationVariables>(UpdateAutomationDocument, options);
      }
export type UpdateAutomationMutationHookResult = ReturnType<typeof useUpdateAutomationMutation>;
export type UpdateAutomationMutationResult = Apollo.MutationResult<UpdateAutomationMutation>;
export type UpdateAutomationMutationOptions = Apollo.BaseMutationOptions<UpdateAutomationMutation, UpdateAutomationMutationVariables>;
export const CreateAutomationDocument = gql`
    mutation CreateAutomation($fields: AutomationFields!) {
  createAutomation(fields: $fields) {
    data {
      id
      playbookId
      name
      description
      cseResourceType
      cseResourceSubTypes
      executionTypes
      enabled
    }
  }
}
    `;
export type CreateAutomationMutationFn = Apollo.MutationFunction<CreateAutomationMutation, CreateAutomationMutationVariables>;

/**
 * __useCreateAutomationMutation__
 *
 * To run a mutation, you first call `useCreateAutomationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutomationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutomationMutation, { data, loading, error }] = useCreateAutomationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateAutomationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAutomationMutation, CreateAutomationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAutomationMutation, CreateAutomationMutationVariables>(CreateAutomationDocument, options);
      }
export type CreateAutomationMutationHookResult = ReturnType<typeof useCreateAutomationMutation>;
export type CreateAutomationMutationResult = Apollo.MutationResult<CreateAutomationMutation>;
export type CreateAutomationMutationOptions = Apollo.BaseMutationOptions<CreateAutomationMutation, CreateAutomationMutationVariables>;
export const ToggleContextActionOperationDocument = gql`
    mutation ToggleContextActionOperation($id: ID!, $fields: UpdatableContextActionFields!) {
  updateContextAction(id: $id, fields: $fields) {
    data {
      allRecordFields
      enabled
      entityTypes
      id
      iocTypes
      name
      recordFields
      template
      type
    }
  }
}
    `;
export type ToggleContextActionOperationMutationFn = Apollo.MutationFunction<ToggleContextActionOperationMutation, ToggleContextActionOperationMutationVariables>;

/**
 * __useToggleContextActionOperationMutation__
 *
 * To run a mutation, you first call `useToggleContextActionOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleContextActionOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleContextActionOperationMutation, { data, loading, error }] = useToggleContextActionOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useToggleContextActionOperationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleContextActionOperationMutation, ToggleContextActionOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleContextActionOperationMutation, ToggleContextActionOperationMutationVariables>(ToggleContextActionOperationDocument, options);
      }
export type ToggleContextActionOperationMutationHookResult = ReturnType<typeof useToggleContextActionOperationMutation>;
export type ToggleContextActionOperationMutationResult = Apollo.MutationResult<ToggleContextActionOperationMutation>;
export type ToggleContextActionOperationMutationOptions = Apollo.BaseMutationOptions<ToggleContextActionOperationMutation, ToggleContextActionOperationMutationVariables>;
export const DeleteContextActionOperationDocument = gql`
    mutation DeleteContextActionOperation($id: ID!) {
  deleteContextAction(id: $id) {
    ok
  }
}
    `;
export type DeleteContextActionOperationMutationFn = Apollo.MutationFunction<DeleteContextActionOperationMutation, DeleteContextActionOperationMutationVariables>;

/**
 * __useDeleteContextActionOperationMutation__
 *
 * To run a mutation, you first call `useDeleteContextActionOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContextActionOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContextActionOperationMutation, { data, loading, error }] = useDeleteContextActionOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContextActionOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContextActionOperationMutation, DeleteContextActionOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContextActionOperationMutation, DeleteContextActionOperationMutationVariables>(DeleteContextActionOperationDocument, options);
      }
export type DeleteContextActionOperationMutationHookResult = ReturnType<typeof useDeleteContextActionOperationMutation>;
export type DeleteContextActionOperationMutationResult = Apollo.MutationResult<DeleteContextActionOperationMutation>;
export type DeleteContextActionOperationMutationOptions = Apollo.BaseMutationOptions<DeleteContextActionOperationMutation, DeleteContextActionOperationMutationVariables>;
export const ContextActionCreateOperationDocument = gql`
    mutation ContextActionCreateOperation($allRecordFields: Boolean = false, $entityTypes: [String!]!, $name: String!, $recordFields: [String!]!, $template: String!, $iocTypes: [ContextActionIocType!]!, $type: ContextActionType!) {
  createContextAction(
    allRecordFields: $allRecordFields
    entityTypes: $entityTypes
    recordFields: $recordFields
    iocTypes: $iocTypes
    name: $name
    template: $template
    type: $type
  ) {
    data {
      allRecordFields
      enabled
      entityTypes
      id
      iocTypes
      name
      recordFields
      template
      type
    }
  }
}
    `;
export type ContextActionCreateOperationMutationFn = Apollo.MutationFunction<ContextActionCreateOperationMutation, ContextActionCreateOperationMutationVariables>;

/**
 * __useContextActionCreateOperationMutation__
 *
 * To run a mutation, you first call `useContextActionCreateOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContextActionCreateOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contextActionCreateOperationMutation, { data, loading, error }] = useContextActionCreateOperationMutation({
 *   variables: {
 *      allRecordFields: // value for 'allRecordFields'
 *      entityTypes: // value for 'entityTypes'
 *      name: // value for 'name'
 *      recordFields: // value for 'recordFields'
 *      template: // value for 'template'
 *      iocTypes: // value for 'iocTypes'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useContextActionCreateOperationMutation(baseOptions?: Apollo.MutationHookOptions<ContextActionCreateOperationMutation, ContextActionCreateOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContextActionCreateOperationMutation, ContextActionCreateOperationMutationVariables>(ContextActionCreateOperationDocument, options);
      }
export type ContextActionCreateOperationMutationHookResult = ReturnType<typeof useContextActionCreateOperationMutation>;
export type ContextActionCreateOperationMutationResult = Apollo.MutationResult<ContextActionCreateOperationMutation>;
export type ContextActionCreateOperationMutationOptions = Apollo.BaseMutationOptions<ContextActionCreateOperationMutation, ContextActionCreateOperationMutationVariables>;
export const ContextActionUpdateOperationDocument = gql`
    mutation ContextActionUpdateOperation($id: ID!, $fields: UpdatableContextActionFields!) {
  updateContextAction(id: $id, fields: $fields) {
    data {
      allRecordFields
      enabled
      entityTypes
      id
      iocTypes
      name
      recordFields
      template
      type
    }
  }
}
    `;
export type ContextActionUpdateOperationMutationFn = Apollo.MutationFunction<ContextActionUpdateOperationMutation, ContextActionUpdateOperationMutationVariables>;

/**
 * __useContextActionUpdateOperationMutation__
 *
 * To run a mutation, you first call `useContextActionUpdateOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContextActionUpdateOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contextActionUpdateOperationMutation, { data, loading, error }] = useContextActionUpdateOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useContextActionUpdateOperationMutation(baseOptions?: Apollo.MutationHookOptions<ContextActionUpdateOperationMutation, ContextActionUpdateOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContextActionUpdateOperationMutation, ContextActionUpdateOperationMutationVariables>(ContextActionUpdateOperationDocument, options);
      }
export type ContextActionUpdateOperationMutationHookResult = ReturnType<typeof useContextActionUpdateOperationMutation>;
export type ContextActionUpdateOperationMutationResult = Apollo.MutationResult<ContextActionUpdateOperationMutation>;
export type ContextActionUpdateOperationMutationOptions = Apollo.BaseMutationOptions<ContextActionUpdateOperationMutation, ContextActionUpdateOperationMutationVariables>;
export const ContextActionsQueryOperationDocument = gql`
    query ContextActionsQueryOperation($offset: Int, $limit: Int, $sort: [ContextActionSort!]) {
  contextActions(offset: $offset, limit: $limit, sort: $sort) {
    hasNextPage
    total
    objects {
      ...ContextActionFragment
    }
  }
}
    ${ContextActionFragmentDoc}`;

/**
 * __useContextActionsQueryOperation__
 *
 * To run a query within a React component, call `useContextActionsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useContextActionsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContextActionsQueryOperation({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useContextActionsQueryOperation(baseOptions?: Apollo.QueryHookOptions<ContextActionsQueryOperationQuery, ContextActionsQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContextActionsQueryOperationQuery, ContextActionsQueryOperationQueryVariables>(ContextActionsQueryOperationDocument, options);
      }
export function useContextActionsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContextActionsQueryOperationQuery, ContextActionsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContextActionsQueryOperationQuery, ContextActionsQueryOperationQueryVariables>(ContextActionsQueryOperationDocument, options);
        }
export function useContextActionsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContextActionsQueryOperationQuery, ContextActionsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContextActionsQueryOperationQuery, ContextActionsQueryOperationQueryVariables>(ContextActionsQueryOperationDocument, options);
        }
export type ContextActionsQueryOperationHookResult = ReturnType<typeof useContextActionsQueryOperation>;
export type ContextActionsQueryOperationLazyQueryHookResult = ReturnType<typeof useContextActionsQueryOperationLazyQuery>;
export type ContextActionsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useContextActionsQueryOperationSuspenseQuery>;
export type ContextActionsQueryOperationQueryResult = Apollo.QueryResult<ContextActionsQueryOperationQuery, ContextActionsQueryOperationQueryVariables>;
export const EnrichmentOperationDocument = gql`
    query EnrichmentOperation {
  virusTotalConfig {
    enabled
    apiKey
  }
}
    `;

/**
 * __useEnrichmentOperationQuery__
 *
 * To run a query within a React component, call `useEnrichmentOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnrichmentOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrichmentOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnrichmentOperationQuery(baseOptions?: Apollo.QueryHookOptions<EnrichmentOperationQuery, EnrichmentOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrichmentOperationQuery, EnrichmentOperationQueryVariables>(EnrichmentOperationDocument, options);
      }
export function useEnrichmentOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrichmentOperationQuery, EnrichmentOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrichmentOperationQuery, EnrichmentOperationQueryVariables>(EnrichmentOperationDocument, options);
        }
export function useEnrichmentOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EnrichmentOperationQuery, EnrichmentOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnrichmentOperationQuery, EnrichmentOperationQueryVariables>(EnrichmentOperationDocument, options);
        }
export type EnrichmentOperationQueryHookResult = ReturnType<typeof useEnrichmentOperationQuery>;
export type EnrichmentOperationLazyQueryHookResult = ReturnType<typeof useEnrichmentOperationLazyQuery>;
export type EnrichmentOperationSuspenseQueryHookResult = ReturnType<typeof useEnrichmentOperationSuspenseQuery>;
export type EnrichmentOperationQueryResult = Apollo.QueryResult<EnrichmentOperationQuery, EnrichmentOperationQueryVariables>;
export const UpdateVirusTotalConfigOperationDocument = gql`
    mutation UpdateVirusTotalConfigOperation($apiKey: String, $enabled: Boolean!) {
  updateVirusTotalConfig(apiKey: $apiKey, enabled: $enabled) {
    data {
      enabled
      apiKey
    }
  }
}
    `;
export type UpdateVirusTotalConfigOperationMutationFn = Apollo.MutationFunction<UpdateVirusTotalConfigOperationMutation, UpdateVirusTotalConfigOperationMutationVariables>;

/**
 * __useUpdateVirusTotalConfigOperationMutation__
 *
 * To run a mutation, you first call `useUpdateVirusTotalConfigOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVirusTotalConfigOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVirusTotalConfigOperationMutation, { data, loading, error }] = useUpdateVirusTotalConfigOperationMutation({
 *   variables: {
 *      apiKey: // value for 'apiKey'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateVirusTotalConfigOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVirusTotalConfigOperationMutation, UpdateVirusTotalConfigOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVirusTotalConfigOperationMutation, UpdateVirusTotalConfigOperationMutationVariables>(UpdateVirusTotalConfigOperationDocument, options);
      }
export type UpdateVirusTotalConfigOperationMutationHookResult = ReturnType<typeof useUpdateVirusTotalConfigOperationMutation>;
export type UpdateVirusTotalConfigOperationMutationResult = Apollo.MutationResult<UpdateVirusTotalConfigOperationMutation>;
export type UpdateVirusTotalConfigOperationMutationOptions = Apollo.BaseMutationOptions<UpdateVirusTotalConfigOperationMutation, UpdateVirusTotalConfigOperationMutationVariables>;
export const CreateEntityValueConfigurationGroupDocument = gql`
    mutation CreateEntityValueConfigurationGroup($fields: EntityValueEntityGroupConfigurationFields!) {
  createEntityValueEntityGroupConfiguration(fields: $fields) {
    data {
      id
    }
  }
}
    `;
export type CreateEntityValueConfigurationGroupMutationFn = Apollo.MutationFunction<CreateEntityValueConfigurationGroupMutation, CreateEntityValueConfigurationGroupMutationVariables>;

/**
 * __useCreateEntityValueConfigurationGroupMutation__
 *
 * To run a mutation, you first call `useCreateEntityValueConfigurationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityValueConfigurationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityValueConfigurationGroupMutation, { data, loading, error }] = useCreateEntityValueConfigurationGroupMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateEntityValueConfigurationGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateEntityValueConfigurationGroupMutation, CreateEntityValueConfigurationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEntityValueConfigurationGroupMutation, CreateEntityValueConfigurationGroupMutationVariables>(CreateEntityValueConfigurationGroupDocument, options);
      }
export type CreateEntityValueConfigurationGroupMutationHookResult = ReturnType<typeof useCreateEntityValueConfigurationGroupMutation>;
export type CreateEntityValueConfigurationGroupMutationResult = Apollo.MutationResult<CreateEntityValueConfigurationGroupMutation>;
export type CreateEntityValueConfigurationGroupMutationOptions = Apollo.BaseMutationOptions<CreateEntityValueConfigurationGroupMutation, CreateEntityValueConfigurationGroupMutationVariables>;
export const UpdateEntityValueConfigurationGroupDocument = gql`
    mutation UpdateEntityValueConfigurationGroup($fields: EntityValueEntityGroupConfigurationFields!, $id: ID!) {
  updateEntityValueEntityGroupConfiguration(fields: $fields, id: $id) {
    data {
      id
    }
  }
}
    `;
export type UpdateEntityValueConfigurationGroupMutationFn = Apollo.MutationFunction<UpdateEntityValueConfigurationGroupMutation, UpdateEntityValueConfigurationGroupMutationVariables>;

/**
 * __useUpdateEntityValueConfigurationGroupMutation__
 *
 * To run a mutation, you first call `useUpdateEntityValueConfigurationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityValueConfigurationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityValueConfigurationGroupMutation, { data, loading, error }] = useUpdateEntityValueConfigurationGroupMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateEntityValueConfigurationGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityValueConfigurationGroupMutation, UpdateEntityValueConfigurationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityValueConfigurationGroupMutation, UpdateEntityValueConfigurationGroupMutationVariables>(UpdateEntityValueConfigurationGroupDocument, options);
      }
export type UpdateEntityValueConfigurationGroupMutationHookResult = ReturnType<typeof useUpdateEntityValueConfigurationGroupMutation>;
export type UpdateEntityValueConfigurationGroupMutationResult = Apollo.MutationResult<UpdateEntityValueConfigurationGroupMutation>;
export type UpdateEntityValueConfigurationGroupMutationOptions = Apollo.BaseMutationOptions<UpdateEntityValueConfigurationGroupMutation, UpdateEntityValueConfigurationGroupMutationVariables>;
export const CreateInventoryConfigurationGroupDocument = gql`
    mutation CreateInventoryConfigurationGroup($fields: InventoryEntityGroupConfigurationFields!) {
  createInventoryEntityGroupConfiguration(fields: $fields) {
    data {
      id
    }
  }
}
    `;
export type CreateInventoryConfigurationGroupMutationFn = Apollo.MutationFunction<CreateInventoryConfigurationGroupMutation, CreateInventoryConfigurationGroupMutationVariables>;

/**
 * __useCreateInventoryConfigurationGroupMutation__
 *
 * To run a mutation, you first call `useCreateInventoryConfigurationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInventoryConfigurationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInventoryConfigurationGroupMutation, { data, loading, error }] = useCreateInventoryConfigurationGroupMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateInventoryConfigurationGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateInventoryConfigurationGroupMutation, CreateInventoryConfigurationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInventoryConfigurationGroupMutation, CreateInventoryConfigurationGroupMutationVariables>(CreateInventoryConfigurationGroupDocument, options);
      }
export type CreateInventoryConfigurationGroupMutationHookResult = ReturnType<typeof useCreateInventoryConfigurationGroupMutation>;
export type CreateInventoryConfigurationGroupMutationResult = Apollo.MutationResult<CreateInventoryConfigurationGroupMutation>;
export type CreateInventoryConfigurationGroupMutationOptions = Apollo.BaseMutationOptions<CreateInventoryConfigurationGroupMutation, CreateInventoryConfigurationGroupMutationVariables>;
export const UpdateInventoryConfigurationGroupDocument = gql`
    mutation UpdateInventoryConfigurationGroup($fields: InventoryEntityGroupConfigurationFields!, $id: ID!) {
  updateInventoryEntityGroupConfiguration(fields: $fields, id: $id) {
    data {
      id
    }
  }
}
    `;
export type UpdateInventoryConfigurationGroupMutationFn = Apollo.MutationFunction<UpdateInventoryConfigurationGroupMutation, UpdateInventoryConfigurationGroupMutationVariables>;

/**
 * __useUpdateInventoryConfigurationGroupMutation__
 *
 * To run a mutation, you first call `useUpdateInventoryConfigurationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInventoryConfigurationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInventoryConfigurationGroupMutation, { data, loading, error }] = useUpdateInventoryConfigurationGroupMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateInventoryConfigurationGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInventoryConfigurationGroupMutation, UpdateInventoryConfigurationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInventoryConfigurationGroupMutation, UpdateInventoryConfigurationGroupMutationVariables>(UpdateInventoryConfigurationGroupDocument, options);
      }
export type UpdateInventoryConfigurationGroupMutationHookResult = ReturnType<typeof useUpdateInventoryConfigurationGroupMutation>;
export type UpdateInventoryConfigurationGroupMutationResult = Apollo.MutationResult<UpdateInventoryConfigurationGroupMutation>;
export type UpdateInventoryConfigurationGroupMutationOptions = Apollo.BaseMutationOptions<UpdateInventoryConfigurationGroupMutation, UpdateInventoryConfigurationGroupMutationVariables>;
export const EntityCriticalityConfigsListDocument = gql`
    query EntityCriticalityConfigsList {
  entityCriticalityConfigs {
    hasNextPage
    objects {
      ...EntityCriticalityConfigListItemFragment
    }
    total
  }
}
    ${EntityCriticalityConfigListItemFragmentDoc}`;

/**
 * __useEntityCriticalityConfigsListQuery__
 *
 * To run a query within a React component, call `useEntityCriticalityConfigsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityCriticalityConfigsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityCriticalityConfigsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntityCriticalityConfigsListQuery(baseOptions?: Apollo.QueryHookOptions<EntityCriticalityConfigsListQuery, EntityCriticalityConfigsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityCriticalityConfigsListQuery, EntityCriticalityConfigsListQueryVariables>(EntityCriticalityConfigsListDocument, options);
      }
export function useEntityCriticalityConfigsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityCriticalityConfigsListQuery, EntityCriticalityConfigsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityCriticalityConfigsListQuery, EntityCriticalityConfigsListQueryVariables>(EntityCriticalityConfigsListDocument, options);
        }
export function useEntityCriticalityConfigsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityCriticalityConfigsListQuery, EntityCriticalityConfigsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityCriticalityConfigsListQuery, EntityCriticalityConfigsListQueryVariables>(EntityCriticalityConfigsListDocument, options);
        }
export type EntityCriticalityConfigsListQueryHookResult = ReturnType<typeof useEntityCriticalityConfigsListQuery>;
export type EntityCriticalityConfigsListLazyQueryHookResult = ReturnType<typeof useEntityCriticalityConfigsListLazyQuery>;
export type EntityCriticalityConfigsListSuspenseQueryHookResult = ReturnType<typeof useEntityCriticalityConfigsListSuspenseQuery>;
export type EntityCriticalityConfigsListQueryResult = Apollo.QueryResult<EntityCriticalityConfigsListQuery, EntityCriticalityConfigsListQueryVariables>;
export const EntityGroupConfigurationCriticalityListDocument = gql`
    query EntityGroupConfigurationCriticalityList {
  entityGroupConfigurations {
    objects {
      ...EntityGroupConfigurationCriticalityFragment
    }
  }
}
    ${EntityGroupConfigurationCriticalityFragmentDoc}`;

/**
 * __useEntityGroupConfigurationCriticalityListQuery__
 *
 * To run a query within a React component, call `useEntityGroupConfigurationCriticalityListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityGroupConfigurationCriticalityListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityGroupConfigurationCriticalityListQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntityGroupConfigurationCriticalityListQuery(baseOptions?: Apollo.QueryHookOptions<EntityGroupConfigurationCriticalityListQuery, EntityGroupConfigurationCriticalityListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityGroupConfigurationCriticalityListQuery, EntityGroupConfigurationCriticalityListQueryVariables>(EntityGroupConfigurationCriticalityListDocument, options);
      }
export function useEntityGroupConfigurationCriticalityListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityGroupConfigurationCriticalityListQuery, EntityGroupConfigurationCriticalityListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityGroupConfigurationCriticalityListQuery, EntityGroupConfigurationCriticalityListQueryVariables>(EntityGroupConfigurationCriticalityListDocument, options);
        }
export function useEntityGroupConfigurationCriticalityListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityGroupConfigurationCriticalityListQuery, EntityGroupConfigurationCriticalityListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityGroupConfigurationCriticalityListQuery, EntityGroupConfigurationCriticalityListQueryVariables>(EntityGroupConfigurationCriticalityListDocument, options);
        }
export type EntityGroupConfigurationCriticalityListQueryHookResult = ReturnType<typeof useEntityGroupConfigurationCriticalityListQuery>;
export type EntityGroupConfigurationCriticalityListLazyQueryHookResult = ReturnType<typeof useEntityGroupConfigurationCriticalityListLazyQuery>;
export type EntityGroupConfigurationCriticalityListSuspenseQueryHookResult = ReturnType<typeof useEntityGroupConfigurationCriticalityListSuspenseQuery>;
export type EntityGroupConfigurationCriticalityListQueryResult = Apollo.QueryResult<EntityGroupConfigurationCriticalityListQuery, EntityGroupConfigurationCriticalityListQueryVariables>;
export const DeleteEntityCriticalityConfigDocument = gql`
    mutation DeleteEntityCriticalityConfig($id: ID!) {
  deleteEntityCriticalityConfig(id: $id) {
    ok
  }
}
    `;
export type DeleteEntityCriticalityConfigMutationFn = Apollo.MutationFunction<DeleteEntityCriticalityConfigMutation, DeleteEntityCriticalityConfigMutationVariables>;

/**
 * __useDeleteEntityCriticalityConfigMutation__
 *
 * To run a mutation, you first call `useDeleteEntityCriticalityConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityCriticalityConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityCriticalityConfigMutation, { data, loading, error }] = useDeleteEntityCriticalityConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEntityCriticalityConfigMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEntityCriticalityConfigMutation, DeleteEntityCriticalityConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEntityCriticalityConfigMutation, DeleteEntityCriticalityConfigMutationVariables>(DeleteEntityCriticalityConfigDocument, options);
      }
export type DeleteEntityCriticalityConfigMutationHookResult = ReturnType<typeof useDeleteEntityCriticalityConfigMutation>;
export type DeleteEntityCriticalityConfigMutationResult = Apollo.MutationResult<DeleteEntityCriticalityConfigMutation>;
export type DeleteEntityCriticalityConfigMutationOptions = Apollo.BaseMutationOptions<DeleteEntityCriticalityConfigMutation, DeleteEntityCriticalityConfigMutationVariables>;
export const CreateEntityCriticalityConfigDocument = gql`
    mutation CreateEntityCriticalityConfig($fields: CreateEntityCriticalityConfigFields!) {
  createEntityCriticalityConfig(fields: $fields) {
    data {
      id
      name
      severityExpression
      entityCount
    }
  }
}
    `;
export type CreateEntityCriticalityConfigMutationFn = Apollo.MutationFunction<CreateEntityCriticalityConfigMutation, CreateEntityCriticalityConfigMutationVariables>;

/**
 * __useCreateEntityCriticalityConfigMutation__
 *
 * To run a mutation, you first call `useCreateEntityCriticalityConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEntityCriticalityConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEntityCriticalityConfigMutation, { data, loading, error }] = useCreateEntityCriticalityConfigMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateEntityCriticalityConfigMutation(baseOptions?: Apollo.MutationHookOptions<CreateEntityCriticalityConfigMutation, CreateEntityCriticalityConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEntityCriticalityConfigMutation, CreateEntityCriticalityConfigMutationVariables>(CreateEntityCriticalityConfigDocument, options);
      }
export type CreateEntityCriticalityConfigMutationHookResult = ReturnType<typeof useCreateEntityCriticalityConfigMutation>;
export type CreateEntityCriticalityConfigMutationResult = Apollo.MutationResult<CreateEntityCriticalityConfigMutation>;
export type CreateEntityCriticalityConfigMutationOptions = Apollo.BaseMutationOptions<CreateEntityCriticalityConfigMutation, CreateEntityCriticalityConfigMutationVariables>;
export const UpdateEntityCriticalityConfigDocument = gql`
    mutation UpdateEntityCriticalityConfig($fields: UpdateEntityCriticalityConfigFields!, $id: ID!) {
  updateEntityCriticalityConfig(fields: $fields, id: $id) {
    data {
      id
      name
      severityExpression
      entityCount
    }
  }
}
    `;
export type UpdateEntityCriticalityConfigMutationFn = Apollo.MutationFunction<UpdateEntityCriticalityConfigMutation, UpdateEntityCriticalityConfigMutationVariables>;

/**
 * __useUpdateEntityCriticalityConfigMutation__
 *
 * To run a mutation, you first call `useUpdateEntityCriticalityConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityCriticalityConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityCriticalityConfigMutation, { data, loading, error }] = useUpdateEntityCriticalityConfigMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateEntityCriticalityConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityCriticalityConfigMutation, UpdateEntityCriticalityConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityCriticalityConfigMutation, UpdateEntityCriticalityConfigMutationVariables>(UpdateEntityCriticalityConfigDocument, options);
      }
export type UpdateEntityCriticalityConfigMutationHookResult = ReturnType<typeof useUpdateEntityCriticalityConfigMutation>;
export type UpdateEntityCriticalityConfigMutationResult = Apollo.MutationResult<UpdateEntityCriticalityConfigMutation>;
export type UpdateEntityCriticalityConfigMutationOptions = Apollo.BaseMutationOptions<UpdateEntityCriticalityConfigMutation, UpdateEntityCriticalityConfigMutationVariables>;
export const DeleteEntityGroupConfigurationOperationDocument = gql`
    mutation DeleteEntityGroupConfigurationOperation($id: ID!) {
  deleteEntityGroupConfiguration(id: $id) {
    ok
  }
}
    `;
export type DeleteEntityGroupConfigurationOperationMutationFn = Apollo.MutationFunction<DeleteEntityGroupConfigurationOperationMutation, DeleteEntityGroupConfigurationOperationMutationVariables>;

/**
 * __useDeleteEntityGroupConfigurationOperationMutation__
 *
 * To run a mutation, you first call `useDeleteEntityGroupConfigurationOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEntityGroupConfigurationOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEntityGroupConfigurationOperationMutation, { data, loading, error }] = useDeleteEntityGroupConfigurationOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEntityGroupConfigurationOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEntityGroupConfigurationOperationMutation, DeleteEntityGroupConfigurationOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEntityGroupConfigurationOperationMutation, DeleteEntityGroupConfigurationOperationMutationVariables>(DeleteEntityGroupConfigurationOperationDocument, options);
      }
export type DeleteEntityGroupConfigurationOperationMutationHookResult = ReturnType<typeof useDeleteEntityGroupConfigurationOperationMutation>;
export type DeleteEntityGroupConfigurationOperationMutationResult = Apollo.MutationResult<DeleteEntityGroupConfigurationOperationMutation>;
export type DeleteEntityGroupConfigurationOperationMutationOptions = Apollo.BaseMutationOptions<DeleteEntityGroupConfigurationOperationMutation, DeleteEntityGroupConfigurationOperationMutationVariables>;
export const UploadEntityGroupsCsvOperationDocument = gql`
    mutation UploadEntityGroupsCsvOperation($file: Upload!) {
  uploadEntityGroupsCsv(file: $file) {
    uploadedEntityGroupCount
  }
}
    `;
export type UploadEntityGroupsCsvOperationMutationFn = Apollo.MutationFunction<UploadEntityGroupsCsvOperationMutation, UploadEntityGroupsCsvOperationMutationVariables>;

/**
 * __useUploadEntityGroupsCsvOperationMutation__
 *
 * To run a mutation, you first call `useUploadEntityGroupsCsvOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEntityGroupsCsvOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEntityGroupsCsvOperationMutation, { data, loading, error }] = useUploadEntityGroupsCsvOperationMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadEntityGroupsCsvOperationMutation(baseOptions?: Apollo.MutationHookOptions<UploadEntityGroupsCsvOperationMutation, UploadEntityGroupsCsvOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadEntityGroupsCsvOperationMutation, UploadEntityGroupsCsvOperationMutationVariables>(UploadEntityGroupsCsvOperationDocument, options);
      }
export type UploadEntityGroupsCsvOperationMutationHookResult = ReturnType<typeof useUploadEntityGroupsCsvOperationMutation>;
export type UploadEntityGroupsCsvOperationMutationResult = Apollo.MutationResult<UploadEntityGroupsCsvOperationMutation>;
export type UploadEntityGroupsCsvOperationMutationOptions = Apollo.BaseMutationOptions<UploadEntityGroupsCsvOperationMutation, UploadEntityGroupsCsvOperationMutationVariables>;
export const EntityGroupConfigurationsOperationDocument = gql`
    query EntityGroupConfigurationsOperation($offset: Int, $limit: Int, $sort: EntityGroupConfigurationSortableField!, $sortDir: SortDir!, $q: String!) {
  entityGroupConfigurations(
    offset: $offset
    limit: $limit
    sort: [{field: $sort, direction: $sortDir}]
    q: $q
  ) {
    hasNextPage
    total
    objects {
      ...EntityGroupConfigurationFragment
    }
  }
}
    ${EntityGroupConfigurationFragmentDoc}`;

/**
 * __useEntityGroupConfigurationsOperationQuery__
 *
 * To run a query within a React component, call `useEntityGroupConfigurationsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityGroupConfigurationsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityGroupConfigurationsOperationQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useEntityGroupConfigurationsOperationQuery(baseOptions: Apollo.QueryHookOptions<EntityGroupConfigurationsOperationQuery, EntityGroupConfigurationsOperationQueryVariables> & ({ variables: EntityGroupConfigurationsOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityGroupConfigurationsOperationQuery, EntityGroupConfigurationsOperationQueryVariables>(EntityGroupConfigurationsOperationDocument, options);
      }
export function useEntityGroupConfigurationsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityGroupConfigurationsOperationQuery, EntityGroupConfigurationsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityGroupConfigurationsOperationQuery, EntityGroupConfigurationsOperationQueryVariables>(EntityGroupConfigurationsOperationDocument, options);
        }
export function useEntityGroupConfigurationsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityGroupConfigurationsOperationQuery, EntityGroupConfigurationsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityGroupConfigurationsOperationQuery, EntityGroupConfigurationsOperationQueryVariables>(EntityGroupConfigurationsOperationDocument, options);
        }
export type EntityGroupConfigurationsOperationQueryHookResult = ReturnType<typeof useEntityGroupConfigurationsOperationQuery>;
export type EntityGroupConfigurationsOperationLazyQueryHookResult = ReturnType<typeof useEntityGroupConfigurationsOperationLazyQuery>;
export type EntityGroupConfigurationsOperationSuspenseQueryHookResult = ReturnType<typeof useEntityGroupConfigurationsOperationSuspenseQuery>;
export type EntityGroupConfigurationsOperationQueryResult = Apollo.QueryResult<EntityGroupConfigurationsOperationQuery, EntityGroupConfigurationsOperationQueryVariables>;
export const SensorZonesOperationDocument = gql`
    query SensorZonesOperation {
  sensorZones
}
    `;

/**
 * __useSensorZonesOperationQuery__
 *
 * To run a query within a React component, call `useSensorZonesOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSensorZonesOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSensorZonesOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useSensorZonesOperationQuery(baseOptions?: Apollo.QueryHookOptions<SensorZonesOperationQuery, SensorZonesOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SensorZonesOperationQuery, SensorZonesOperationQueryVariables>(SensorZonesOperationDocument, options);
      }
export function useSensorZonesOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SensorZonesOperationQuery, SensorZonesOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SensorZonesOperationQuery, SensorZonesOperationQueryVariables>(SensorZonesOperationDocument, options);
        }
export function useSensorZonesOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SensorZonesOperationQuery, SensorZonesOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SensorZonesOperationQuery, SensorZonesOperationQueryVariables>(SensorZonesOperationDocument, options);
        }
export type SensorZonesOperationQueryHookResult = ReturnType<typeof useSensorZonesOperationQuery>;
export type SensorZonesOperationLazyQueryHookResult = ReturnType<typeof useSensorZonesOperationLazyQuery>;
export type SensorZonesOperationSuspenseQueryHookResult = ReturnType<typeof useSensorZonesOperationSuspenseQuery>;
export type SensorZonesOperationQueryResult = Apollo.QueryResult<SensorZonesOperationQuery, SensorZonesOperationQueryVariables>;
export const EntityDomainConfigOperationDocument = gql`
    query EntityDomainConfigOperation {
  entityDomainConfiguration {
    normalizeUsernames
    normalizeHostnames
    defaultNormalizedDomain
    domainMappings {
      rawDomain
      normalizedDomain
    }
    adDomainNormalizationEnabled
    fqdnNormalizationEnabled
    awsNormalizationEnabled
  }
}
    `;

/**
 * __useEntityDomainConfigOperationQuery__
 *
 * To run a query within a React component, call `useEntityDomainConfigOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityDomainConfigOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityDomainConfigOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntityDomainConfigOperationQuery(baseOptions?: Apollo.QueryHookOptions<EntityDomainConfigOperationQuery, EntityDomainConfigOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityDomainConfigOperationQuery, EntityDomainConfigOperationQueryVariables>(EntityDomainConfigOperationDocument, options);
      }
export function useEntityDomainConfigOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityDomainConfigOperationQuery, EntityDomainConfigOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityDomainConfigOperationQuery, EntityDomainConfigOperationQueryVariables>(EntityDomainConfigOperationDocument, options);
        }
export function useEntityDomainConfigOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityDomainConfigOperationQuery, EntityDomainConfigOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityDomainConfigOperationQuery, EntityDomainConfigOperationQueryVariables>(EntityDomainConfigOperationDocument, options);
        }
export type EntityDomainConfigOperationQueryHookResult = ReturnType<typeof useEntityDomainConfigOperationQuery>;
export type EntityDomainConfigOperationLazyQueryHookResult = ReturnType<typeof useEntityDomainConfigOperationLazyQuery>;
export type EntityDomainConfigOperationSuspenseQueryHookResult = ReturnType<typeof useEntityDomainConfigOperationSuspenseQuery>;
export type EntityDomainConfigOperationQueryResult = Apollo.QueryResult<EntityDomainConfigOperationQuery, EntityDomainConfigOperationQueryVariables>;
export const UpdateEntityDomainConfigOperationDocument = gql`
    mutation UpdateEntityDomainConfigOperation($fields: EntityDomainConfigurationFields!) {
  updateEntityDomainConfiguration(fields: $fields) {
    ok
  }
}
    `;
export type UpdateEntityDomainConfigOperationMutationFn = Apollo.MutationFunction<UpdateEntityDomainConfigOperationMutation, UpdateEntityDomainConfigOperationMutationVariables>;

/**
 * __useUpdateEntityDomainConfigOperationMutation__
 *
 * To run a mutation, you first call `useUpdateEntityDomainConfigOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityDomainConfigOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityDomainConfigOperationMutation, { data, loading, error }] = useUpdateEntityDomainConfigOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateEntityDomainConfigOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityDomainConfigOperationMutation, UpdateEntityDomainConfigOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityDomainConfigOperationMutation, UpdateEntityDomainConfigOperationMutationVariables>(UpdateEntityDomainConfigOperationDocument, options);
      }
export type UpdateEntityDomainConfigOperationMutationHookResult = ReturnType<typeof useUpdateEntityDomainConfigOperationMutation>;
export type UpdateEntityDomainConfigOperationMutationResult = Apollo.MutationResult<UpdateEntityDomainConfigOperationMutation>;
export type UpdateEntityDomainConfigOperationMutationOptions = Apollo.BaseMutationOptions<UpdateEntityDomainConfigOperationMutation, UpdateEntityDomainConfigOperationMutationVariables>;
export const DeleteInventoryEntityLookupTableOperationDocument = gql`
    mutation DeleteInventoryEntityLookupTableOperation($id: ID!) {
  deleteInventoryEntityLookupTable(id: $id) {
    ok
  }
}
    `;
export type DeleteInventoryEntityLookupTableOperationMutationFn = Apollo.MutationFunction<DeleteInventoryEntityLookupTableOperationMutation, DeleteInventoryEntityLookupTableOperationMutationVariables>;

/**
 * __useDeleteInventoryEntityLookupTableOperationMutation__
 *
 * To run a mutation, you first call `useDeleteInventoryEntityLookupTableOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInventoryEntityLookupTableOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInventoryEntityLookupTableOperationMutation, { data, loading, error }] = useDeleteInventoryEntityLookupTableOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInventoryEntityLookupTableOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInventoryEntityLookupTableOperationMutation, DeleteInventoryEntityLookupTableOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInventoryEntityLookupTableOperationMutation, DeleteInventoryEntityLookupTableOperationMutationVariables>(DeleteInventoryEntityLookupTableOperationDocument, options);
      }
export type DeleteInventoryEntityLookupTableOperationMutationHookResult = ReturnType<typeof useDeleteInventoryEntityLookupTableOperationMutation>;
export type DeleteInventoryEntityLookupTableOperationMutationResult = Apollo.MutationResult<DeleteInventoryEntityLookupTableOperationMutation>;
export type DeleteInventoryEntityLookupTableOperationMutationOptions = Apollo.BaseMutationOptions<DeleteInventoryEntityLookupTableOperationMutation, DeleteInventoryEntityLookupTableOperationMutationVariables>;
export const DeleteCustomerSourcedEntityLookupTableOperationDocument = gql`
    mutation DeleteCustomerSourcedEntityLookupTableOperation($id: ID!) {
  deleteCustomerSourcedEntityLookupTable(id: $id) {
    ok
  }
}
    `;
export type DeleteCustomerSourcedEntityLookupTableOperationMutationFn = Apollo.MutationFunction<DeleteCustomerSourcedEntityLookupTableOperationMutation, DeleteCustomerSourcedEntityLookupTableOperationMutationVariables>;

/**
 * __useDeleteCustomerSourcedEntityLookupTableOperationMutation__
 *
 * To run a mutation, you first call `useDeleteCustomerSourcedEntityLookupTableOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomerSourcedEntityLookupTableOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomerSourcedEntityLookupTableOperationMutation, { data, loading, error }] = useDeleteCustomerSourcedEntityLookupTableOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomerSourcedEntityLookupTableOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomerSourcedEntityLookupTableOperationMutation, DeleteCustomerSourcedEntityLookupTableOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomerSourcedEntityLookupTableOperationMutation, DeleteCustomerSourcedEntityLookupTableOperationMutationVariables>(DeleteCustomerSourcedEntityLookupTableOperationDocument, options);
      }
export type DeleteCustomerSourcedEntityLookupTableOperationMutationHookResult = ReturnType<typeof useDeleteCustomerSourcedEntityLookupTableOperationMutation>;
export type DeleteCustomerSourcedEntityLookupTableOperationMutationResult = Apollo.MutationResult<DeleteCustomerSourcedEntityLookupTableOperationMutation>;
export type DeleteCustomerSourcedEntityLookupTableOperationMutationOptions = Apollo.BaseMutationOptions<DeleteCustomerSourcedEntityLookupTableOperationMutation, DeleteCustomerSourcedEntityLookupTableOperationMutationVariables>;
export const UpdateCustomerSourcedEntityLookupTableOperationDocument = gql`
    mutation UpdateCustomerSourcedEntityLookupTableOperation($fields: UpdateCustomerSourcedEntityLookupTableFields!, $id: ID!) {
  updateCustomerSourcedEntityLookupTable(fields: $fields, id: $id) {
    data {
      id
      tableId
      contentId
      type
      sourceCategory
      keyColumnName
      valueColumnName
      tablePath
      created
    }
  }
}
    `;
export type UpdateCustomerSourcedEntityLookupTableOperationMutationFn = Apollo.MutationFunction<UpdateCustomerSourcedEntityLookupTableOperationMutation, UpdateCustomerSourcedEntityLookupTableOperationMutationVariables>;

/**
 * __useUpdateCustomerSourcedEntityLookupTableOperationMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerSourcedEntityLookupTableOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerSourcedEntityLookupTableOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerSourcedEntityLookupTableOperationMutation, { data, loading, error }] = useUpdateCustomerSourcedEntityLookupTableOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCustomerSourcedEntityLookupTableOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerSourcedEntityLookupTableOperationMutation, UpdateCustomerSourcedEntityLookupTableOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerSourcedEntityLookupTableOperationMutation, UpdateCustomerSourcedEntityLookupTableOperationMutationVariables>(UpdateCustomerSourcedEntityLookupTableOperationDocument, options);
      }
export type UpdateCustomerSourcedEntityLookupTableOperationMutationHookResult = ReturnType<typeof useUpdateCustomerSourcedEntityLookupTableOperationMutation>;
export type UpdateCustomerSourcedEntityLookupTableOperationMutationResult = Apollo.MutationResult<UpdateCustomerSourcedEntityLookupTableOperationMutation>;
export type UpdateCustomerSourcedEntityLookupTableOperationMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerSourcedEntityLookupTableOperationMutation, UpdateCustomerSourcedEntityLookupTableOperationMutationVariables>;
export const CreateCustomerSourcedEntityLookupTableOperationDocument = gql`
    mutation CreateCustomerSourcedEntityLookupTableOperation($fields: CreateCustomerSourcedEntityLookupTableFields!) {
  createCustomerSourcedEntityLookupTable(fields: $fields) {
    data {
      id
      tableId
      contentId
      type
      sourceCategory
      keyColumnName
      valueColumnName
      tablePath
      created
    }
  }
}
    `;
export type CreateCustomerSourcedEntityLookupTableOperationMutationFn = Apollo.MutationFunction<CreateCustomerSourcedEntityLookupTableOperationMutation, CreateCustomerSourcedEntityLookupTableOperationMutationVariables>;

/**
 * __useCreateCustomerSourcedEntityLookupTableOperationMutation__
 *
 * To run a mutation, you first call `useCreateCustomerSourcedEntityLookupTableOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerSourcedEntityLookupTableOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerSourcedEntityLookupTableOperationMutation, { data, loading, error }] = useCreateCustomerSourcedEntityLookupTableOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateCustomerSourcedEntityLookupTableOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomerSourcedEntityLookupTableOperationMutation, CreateCustomerSourcedEntityLookupTableOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomerSourcedEntityLookupTableOperationMutation, CreateCustomerSourcedEntityLookupTableOperationMutationVariables>(CreateCustomerSourcedEntityLookupTableOperationDocument, options);
      }
export type CreateCustomerSourcedEntityLookupTableOperationMutationHookResult = ReturnType<typeof useCreateCustomerSourcedEntityLookupTableOperationMutation>;
export type CreateCustomerSourcedEntityLookupTableOperationMutationResult = Apollo.MutationResult<CreateCustomerSourcedEntityLookupTableOperationMutation>;
export type CreateCustomerSourcedEntityLookupTableOperationMutationOptions = Apollo.BaseMutationOptions<CreateCustomerSourcedEntityLookupTableOperationMutation, CreateCustomerSourcedEntityLookupTableOperationMutationVariables>;
export const InventoryLookupTablesQueryOperationDocument = gql`
    query InventoryLookupTablesQueryOperation {
  inventoryLookupTables {
    id
    tableId
    contentId
    type
    inventorySource
    sourceCategory
    tablePath
    created
  }
}
    `;

/**
 * __useInventoryLookupTablesQueryOperation__
 *
 * To run a query within a React component, call `useInventoryLookupTablesQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInventoryLookupTablesQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryLookupTablesQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useInventoryLookupTablesQueryOperation(baseOptions?: Apollo.QueryHookOptions<InventoryLookupTablesQueryOperationQuery, InventoryLookupTablesQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryLookupTablesQueryOperationQuery, InventoryLookupTablesQueryOperationQueryVariables>(InventoryLookupTablesQueryOperationDocument, options);
      }
export function useInventoryLookupTablesQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryLookupTablesQueryOperationQuery, InventoryLookupTablesQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryLookupTablesQueryOperationQuery, InventoryLookupTablesQueryOperationQueryVariables>(InventoryLookupTablesQueryOperationDocument, options);
        }
export function useInventoryLookupTablesQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InventoryLookupTablesQueryOperationQuery, InventoryLookupTablesQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InventoryLookupTablesQueryOperationQuery, InventoryLookupTablesQueryOperationQueryVariables>(InventoryLookupTablesQueryOperationDocument, options);
        }
export type InventoryLookupTablesQueryOperationHookResult = ReturnType<typeof useInventoryLookupTablesQueryOperation>;
export type InventoryLookupTablesQueryOperationLazyQueryHookResult = ReturnType<typeof useInventoryLookupTablesQueryOperationLazyQuery>;
export type InventoryLookupTablesQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInventoryLookupTablesQueryOperationSuspenseQuery>;
export type InventoryLookupTablesQueryOperationQueryResult = Apollo.QueryResult<InventoryLookupTablesQueryOperationQuery, InventoryLookupTablesQueryOperationQueryVariables>;
export const CustomerSourcedLookupTablesQueryOperationDocument = gql`
    query CustomerSourcedLookupTablesQueryOperation {
  customerSourcedLookupTables {
    id
    tableId
    contentId
    type
    sourceCategory
    keyColumnName
    valueColumnName
    tablePath
    created
  }
}
    `;

/**
 * __useCustomerSourcedLookupTablesQueryOperation__
 *
 * To run a query within a React component, call `useCustomerSourcedLookupTablesQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSourcedLookupTablesQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSourcedLookupTablesQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useCustomerSourcedLookupTablesQueryOperation(baseOptions?: Apollo.QueryHookOptions<CustomerSourcedLookupTablesQueryOperationQuery, CustomerSourcedLookupTablesQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerSourcedLookupTablesQueryOperationQuery, CustomerSourcedLookupTablesQueryOperationQueryVariables>(CustomerSourcedLookupTablesQueryOperationDocument, options);
      }
export function useCustomerSourcedLookupTablesQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerSourcedLookupTablesQueryOperationQuery, CustomerSourcedLookupTablesQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerSourcedLookupTablesQueryOperationQuery, CustomerSourcedLookupTablesQueryOperationQueryVariables>(CustomerSourcedLookupTablesQueryOperationDocument, options);
        }
export function useCustomerSourcedLookupTablesQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomerSourcedLookupTablesQueryOperationQuery, CustomerSourcedLookupTablesQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomerSourcedLookupTablesQueryOperationQuery, CustomerSourcedLookupTablesQueryOperationQueryVariables>(CustomerSourcedLookupTablesQueryOperationDocument, options);
        }
export type CustomerSourcedLookupTablesQueryOperationHookResult = ReturnType<typeof useCustomerSourcedLookupTablesQueryOperation>;
export type CustomerSourcedLookupTablesQueryOperationLazyQueryHookResult = ReturnType<typeof useCustomerSourcedLookupTablesQueryOperationLazyQuery>;
export type CustomerSourcedLookupTablesQueryOperationSuspenseQueryHookResult = ReturnType<typeof useCustomerSourcedLookupTablesQueryOperationSuspenseQuery>;
export type CustomerSourcedLookupTablesQueryOperationQueryResult = Apollo.QueryResult<CustomerSourcedLookupTablesQueryOperationQuery, CustomerSourcedLookupTablesQueryOperationQueryVariables>;
export const CustomEntityTypesDocument = gql`
    query CustomEntityTypes($offset: Int, $limit: Int) {
  customEntityTypes(offset: $offset, limit: $limit) {
    hasNextPage
    objects {
      ...CustomEntityTypeConfigListItemFragment
    }
    total
  }
}
    ${CustomEntityTypeConfigListItemFragmentDoc}`;

/**
 * __useCustomEntityTypesQuery__
 *
 * To run a query within a React component, call `useCustomEntityTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomEntityTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomEntityTypesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCustomEntityTypesQuery(baseOptions?: Apollo.QueryHookOptions<CustomEntityTypesQuery, CustomEntityTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomEntityTypesQuery, CustomEntityTypesQueryVariables>(CustomEntityTypesDocument, options);
      }
export function useCustomEntityTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomEntityTypesQuery, CustomEntityTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomEntityTypesQuery, CustomEntityTypesQueryVariables>(CustomEntityTypesDocument, options);
        }
export function useCustomEntityTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomEntityTypesQuery, CustomEntityTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomEntityTypesQuery, CustomEntityTypesQueryVariables>(CustomEntityTypesDocument, options);
        }
export type CustomEntityTypesQueryHookResult = ReturnType<typeof useCustomEntityTypesQuery>;
export type CustomEntityTypesLazyQueryHookResult = ReturnType<typeof useCustomEntityTypesLazyQuery>;
export type CustomEntityTypesSuspenseQueryHookResult = ReturnType<typeof useCustomEntityTypesSuspenseQuery>;
export type CustomEntityTypesQueryResult = Apollo.QueryResult<CustomEntityTypesQuery, CustomEntityTypesQueryVariables>;
export const DeleteCustomEntityTypeDocument = gql`
    mutation DeleteCustomEntityType($id: ID!) {
  deleteCustomEntityType(id: $id) {
    ok
  }
}
    `;
export type DeleteCustomEntityTypeMutationFn = Apollo.MutationFunction<DeleteCustomEntityTypeMutation, DeleteCustomEntityTypeMutationVariables>;

/**
 * __useDeleteCustomEntityTypeMutation__
 *
 * To run a mutation, you first call `useDeleteCustomEntityTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomEntityTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomEntityTypeMutation, { data, loading, error }] = useDeleteCustomEntityTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomEntityTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomEntityTypeMutation, DeleteCustomEntityTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomEntityTypeMutation, DeleteCustomEntityTypeMutationVariables>(DeleteCustomEntityTypeDocument, options);
      }
export type DeleteCustomEntityTypeMutationHookResult = ReturnType<typeof useDeleteCustomEntityTypeMutation>;
export type DeleteCustomEntityTypeMutationResult = Apollo.MutationResult<DeleteCustomEntityTypeMutation>;
export type DeleteCustomEntityTypeMutationOptions = Apollo.BaseMutationOptions<DeleteCustomEntityTypeMutation, DeleteCustomEntityTypeMutationVariables>;
export const CreateCustomEntityTypeDocument = gql`
    mutation CreateCustomEntityType($fields: CreateCustomEntityTypeFields!) {
  createCustomEntityType(fields: $fields) {
    data {
      id
      identifier
      name
      fields
    }
  }
}
    `;
export type CreateCustomEntityTypeMutationFn = Apollo.MutationFunction<CreateCustomEntityTypeMutation, CreateCustomEntityTypeMutationVariables>;

/**
 * __useCreateCustomEntityTypeMutation__
 *
 * To run a mutation, you first call `useCreateCustomEntityTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomEntityTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomEntityTypeMutation, { data, loading, error }] = useCreateCustomEntityTypeMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateCustomEntityTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomEntityTypeMutation, CreateCustomEntityTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomEntityTypeMutation, CreateCustomEntityTypeMutationVariables>(CreateCustomEntityTypeDocument, options);
      }
export type CreateCustomEntityTypeMutationHookResult = ReturnType<typeof useCreateCustomEntityTypeMutation>;
export type CreateCustomEntityTypeMutationResult = Apollo.MutationResult<CreateCustomEntityTypeMutation>;
export type CreateCustomEntityTypeMutationOptions = Apollo.BaseMutationOptions<CreateCustomEntityTypeMutation, CreateCustomEntityTypeMutationVariables>;
export const UpdateCustomEntityTypeDocument = gql`
    mutation UpdateCustomEntityType($fields: UpdateCustomEntityTypeFields!, $id: ID!) {
  updateCustomEntityType(fields: $fields, id: $id) {
    data {
      id
      identifier
      name
      fields
    }
  }
}
    `;
export type UpdateCustomEntityTypeMutationFn = Apollo.MutationFunction<UpdateCustomEntityTypeMutation, UpdateCustomEntityTypeMutationVariables>;

/**
 * __useUpdateCustomEntityTypeMutation__
 *
 * To run a mutation, you first call `useUpdateCustomEntityTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomEntityTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomEntityTypeMutation, { data, loading, error }] = useUpdateCustomEntityTypeMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCustomEntityTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomEntityTypeMutation, UpdateCustomEntityTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomEntityTypeMutation, UpdateCustomEntityTypeMutationVariables>(UpdateCustomEntityTypeDocument, options);
      }
export type UpdateCustomEntityTypeMutationHookResult = ReturnType<typeof useUpdateCustomEntityTypeMutation>;
export type UpdateCustomEntityTypeMutationResult = Apollo.MutationResult<UpdateCustomEntityTypeMutation>;
export type UpdateCustomEntityTypeMutationOptions = Apollo.BaseMutationOptions<UpdateCustomEntityTypeMutation, UpdateCustomEntityTypeMutationVariables>;
export const ReservedEntityFieldsOperationDocument = gql`
    query ReservedEntityFieldsOperation {
  entityFields
}
    `;

/**
 * __useReservedEntityFieldsOperationQuery__
 *
 * To run a query within a React component, call `useReservedEntityFieldsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservedEntityFieldsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservedEntityFieldsOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useReservedEntityFieldsOperationQuery(baseOptions?: Apollo.QueryHookOptions<ReservedEntityFieldsOperationQuery, ReservedEntityFieldsOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservedEntityFieldsOperationQuery, ReservedEntityFieldsOperationQueryVariables>(ReservedEntityFieldsOperationDocument, options);
      }
export function useReservedEntityFieldsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservedEntityFieldsOperationQuery, ReservedEntityFieldsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservedEntityFieldsOperationQuery, ReservedEntityFieldsOperationQueryVariables>(ReservedEntityFieldsOperationDocument, options);
        }
export function useReservedEntityFieldsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReservedEntityFieldsOperationQuery, ReservedEntityFieldsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReservedEntityFieldsOperationQuery, ReservedEntityFieldsOperationQueryVariables>(ReservedEntityFieldsOperationDocument, options);
        }
export type ReservedEntityFieldsOperationQueryHookResult = ReturnType<typeof useReservedEntityFieldsOperationQuery>;
export type ReservedEntityFieldsOperationLazyQueryHookResult = ReturnType<typeof useReservedEntityFieldsOperationLazyQuery>;
export type ReservedEntityFieldsOperationSuspenseQueryHookResult = ReturnType<typeof useReservedEntityFieldsOperationSuspenseQuery>;
export type ReservedEntityFieldsOperationQueryResult = Apollo.QueryResult<ReservedEntityFieldsOperationQuery, ReservedEntityFieldsOperationQueryVariables>;
export const UpdateInsightConfigOperationDocument = gql`
    mutation UpdateInsightConfigOperation($config: InsightConfigInput!) {
  updateInsightConfig(config: $config) {
    data {
      lookbackDays
      threshold
      globalSignalSuppressionWindow
    }
  }
}
    `;
export type UpdateInsightConfigOperationMutationFn = Apollo.MutationFunction<UpdateInsightConfigOperationMutation, UpdateInsightConfigOperationMutationVariables>;

/**
 * __useUpdateInsightConfigOperationMutation__
 *
 * To run a mutation, you first call `useUpdateInsightConfigOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightConfigOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightConfigOperationMutation, { data, loading, error }] = useUpdateInsightConfigOperationMutation({
 *   variables: {
 *      config: // value for 'config'
 *   },
 * });
 */
export function useUpdateInsightConfigOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsightConfigOperationMutation, UpdateInsightConfigOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsightConfigOperationMutation, UpdateInsightConfigOperationMutationVariables>(UpdateInsightConfigOperationDocument, options);
      }
export type UpdateInsightConfigOperationMutationHookResult = ReturnType<typeof useUpdateInsightConfigOperationMutation>;
export type UpdateInsightConfigOperationMutationResult = Apollo.MutationResult<UpdateInsightConfigOperationMutation>;
export type UpdateInsightConfigOperationMutationOptions = Apollo.BaseMutationOptions<UpdateInsightConfigOperationMutation, UpdateInsightConfigOperationMutationVariables>;
export const InsightResolutionQueryOperationDocument = gql`
    query InsightResolutionQueryOperation {
  insightResolutions(sourceFilter: "sumo") {
    total
    objects {
      ...InsightResolutionFragment
    }
  }
}
    ${InsightResolutionFragmentDoc}`;

/**
 * __useInsightResolutionQueryOperation__
 *
 * To run a query within a React component, call `useInsightResolutionQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightResolutionQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightResolutionQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useInsightResolutionQueryOperation(baseOptions?: Apollo.QueryHookOptions<InsightResolutionQueryOperationQuery, InsightResolutionQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightResolutionQueryOperationQuery, InsightResolutionQueryOperationQueryVariables>(InsightResolutionQueryOperationDocument, options);
      }
export function useInsightResolutionQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightResolutionQueryOperationQuery, InsightResolutionQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightResolutionQueryOperationQuery, InsightResolutionQueryOperationQueryVariables>(InsightResolutionQueryOperationDocument, options);
        }
export function useInsightResolutionQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightResolutionQueryOperationQuery, InsightResolutionQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightResolutionQueryOperationQuery, InsightResolutionQueryOperationQueryVariables>(InsightResolutionQueryOperationDocument, options);
        }
export type InsightResolutionQueryOperationHookResult = ReturnType<typeof useInsightResolutionQueryOperation>;
export type InsightResolutionQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightResolutionQueryOperationLazyQuery>;
export type InsightResolutionQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightResolutionQueryOperationSuspenseQuery>;
export type InsightResolutionQueryOperationQueryResult = Apollo.QueryResult<InsightResolutionQueryOperationQuery, InsightResolutionQueryOperationQueryVariables>;
export const DeleteInsightResolutionOperationDocument = gql`
    mutation DeleteInsightResolutionOperation($id: Int!) {
  deleteInsightResolution(id: $id) {
    ok
  }
}
    `;
export type DeleteInsightResolutionOperationMutationFn = Apollo.MutationFunction<DeleteInsightResolutionOperationMutation, DeleteInsightResolutionOperationMutationVariables>;

/**
 * __useDeleteInsightResolutionOperationMutation__
 *
 * To run a mutation, you first call `useDeleteInsightResolutionOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInsightResolutionOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInsightResolutionOperationMutation, { data, loading, error }] = useDeleteInsightResolutionOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInsightResolutionOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInsightResolutionOperationMutation, DeleteInsightResolutionOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInsightResolutionOperationMutation, DeleteInsightResolutionOperationMutationVariables>(DeleteInsightResolutionOperationDocument, options);
      }
export type DeleteInsightResolutionOperationMutationHookResult = ReturnType<typeof useDeleteInsightResolutionOperationMutation>;
export type DeleteInsightResolutionOperationMutationResult = Apollo.MutationResult<DeleteInsightResolutionOperationMutation>;
export type DeleteInsightResolutionOperationMutationOptions = Apollo.BaseMutationOptions<DeleteInsightResolutionOperationMutation, DeleteInsightResolutionOperationMutationVariables>;
export const CreateInsightResolutionMutationOperationDocument = gql`
    mutation CreateInsightResolutionMutationOperation($fields: CreateInsightResolutionFields!) {
  createInsightResolution(fields: $fields) {
    data {
      ...InsightSubResolutionFragment
    }
  }
}
    ${InsightSubResolutionFragmentDoc}`;
export type CreateInsightResolutionMutationOperationMutationFn = Apollo.MutationFunction<CreateInsightResolutionMutationOperationMutation, CreateInsightResolutionMutationOperationMutationVariables>;

/**
 * __useCreateInsightResolutionMutationOperation__
 *
 * To run a mutation, you first call `useCreateInsightResolutionMutationOperation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsightResolutionMutationOperation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsightResolutionMutationOperation, { data, loading, error }] = useCreateInsightResolutionMutationOperation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateInsightResolutionMutationOperation(baseOptions?: Apollo.MutationHookOptions<CreateInsightResolutionMutationOperationMutation, CreateInsightResolutionMutationOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInsightResolutionMutationOperationMutation, CreateInsightResolutionMutationOperationMutationVariables>(CreateInsightResolutionMutationOperationDocument, options);
      }
export type CreateInsightResolutionMutationOperationHookResult = ReturnType<typeof useCreateInsightResolutionMutationOperation>;
export type CreateInsightResolutionMutationOperationMutationResult = Apollo.MutationResult<CreateInsightResolutionMutationOperationMutation>;
export type CreateInsightResolutionMutationOperationMutationOptions = Apollo.BaseMutationOptions<CreateInsightResolutionMutationOperationMutation, CreateInsightResolutionMutationOperationMutationVariables>;
export const UpdateInsightResolutionMutationOperationDocument = gql`
    mutation UpdateInsightResolutionMutationOperation($fields: UpdateInsightResolutionFields!, $id: Int!) {
  updateInsightResolution(fields: $fields, id: $id) {
    data {
      ...InsightSubResolutionFragment
    }
  }
}
    ${InsightSubResolutionFragmentDoc}`;
export type UpdateInsightResolutionMutationOperationMutationFn = Apollo.MutationFunction<UpdateInsightResolutionMutationOperationMutation, UpdateInsightResolutionMutationOperationMutationVariables>;

/**
 * __useUpdateInsightResolutionMutationOperation__
 *
 * To run a mutation, you first call `useUpdateInsightResolutionMutationOperation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightResolutionMutationOperation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightResolutionMutationOperation, { data, loading, error }] = useUpdateInsightResolutionMutationOperation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateInsightResolutionMutationOperation(baseOptions?: Apollo.MutationHookOptions<UpdateInsightResolutionMutationOperationMutation, UpdateInsightResolutionMutationOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsightResolutionMutationOperationMutation, UpdateInsightResolutionMutationOperationMutationVariables>(UpdateInsightResolutionMutationOperationDocument, options);
      }
export type UpdateInsightResolutionMutationOperationHookResult = ReturnType<typeof useUpdateInsightResolutionMutationOperation>;
export type UpdateInsightResolutionMutationOperationMutationResult = Apollo.MutationResult<UpdateInsightResolutionMutationOperationMutation>;
export type UpdateInsightResolutionMutationOperationMutationOptions = Apollo.BaseMutationOptions<UpdateInsightResolutionMutationOperationMutation, UpdateInsightResolutionMutationOperationMutationVariables>;
export const SingleInsightResolutionQueryOperationDocument = gql`
    query SingleInsightResolutionQueryOperation($id: Int!) {
  insightResolution(id: $id) {
    ...InsightResolutionFragment
  }
}
    ${InsightResolutionFragmentDoc}`;

/**
 * __useSingleInsightResolutionQueryOperation__
 *
 * To run a query within a React component, call `useSingleInsightResolutionQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useSingleInsightResolutionQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleInsightResolutionQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleInsightResolutionQueryOperation(baseOptions: Apollo.QueryHookOptions<SingleInsightResolutionQueryOperationQuery, SingleInsightResolutionQueryOperationQueryVariables> & ({ variables: SingleInsightResolutionQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleInsightResolutionQueryOperationQuery, SingleInsightResolutionQueryOperationQueryVariables>(SingleInsightResolutionQueryOperationDocument, options);
      }
export function useSingleInsightResolutionQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleInsightResolutionQueryOperationQuery, SingleInsightResolutionQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleInsightResolutionQueryOperationQuery, SingleInsightResolutionQueryOperationQueryVariables>(SingleInsightResolutionQueryOperationDocument, options);
        }
export function useSingleInsightResolutionQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SingleInsightResolutionQueryOperationQuery, SingleInsightResolutionQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleInsightResolutionQueryOperationQuery, SingleInsightResolutionQueryOperationQueryVariables>(SingleInsightResolutionQueryOperationDocument, options);
        }
export type SingleInsightResolutionQueryOperationHookResult = ReturnType<typeof useSingleInsightResolutionQueryOperation>;
export type SingleInsightResolutionQueryOperationLazyQueryHookResult = ReturnType<typeof useSingleInsightResolutionQueryOperationLazyQuery>;
export type SingleInsightResolutionQueryOperationSuspenseQueryHookResult = ReturnType<typeof useSingleInsightResolutionQueryOperationSuspenseQuery>;
export type SingleInsightResolutionQueryOperationQueryResult = Apollo.QueryResult<SingleInsightResolutionQueryOperationQuery, SingleInsightResolutionQueryOperationQueryVariables>;
export const UpdateLogMappingOperationDocument = gql`
    mutation UpdateLogMappingOperation($fields: UpdateLogMappingFields!, $id: ID!) {
  updateLogMapping(fields: $fields, id: $id) {
    data {
      ...LogMappingFields
    }
  }
}
    ${LogMappingFieldsFragmentDoc}`;
export type UpdateLogMappingOperationMutationFn = Apollo.MutationFunction<UpdateLogMappingOperationMutation, UpdateLogMappingOperationMutationVariables>;

/**
 * __useUpdateLogMappingOperationMutation__
 *
 * To run a mutation, you first call `useUpdateLogMappingOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLogMappingOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLogMappingOperationMutation, { data, loading, error }] = useUpdateLogMappingOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateLogMappingOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLogMappingOperationMutation, UpdateLogMappingOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLogMappingOperationMutation, UpdateLogMappingOperationMutationVariables>(UpdateLogMappingOperationDocument, options);
      }
export type UpdateLogMappingOperationMutationHookResult = ReturnType<typeof useUpdateLogMappingOperationMutation>;
export type UpdateLogMappingOperationMutationResult = Apollo.MutationResult<UpdateLogMappingOperationMutation>;
export type UpdateLogMappingOperationMutationOptions = Apollo.BaseMutationOptions<UpdateLogMappingOperationMutation, UpdateLogMappingOperationMutationVariables>;
export const LogMappingOptionsQueryOperationDocument = gql`
    query LogMappingOptionsQueryOperation {
  logMappingOptions {
    fieldValueTypeOptions {
      label
      value
    }
  }
}
    `;

/**
 * __useLogMappingOptionsQueryOperation__
 *
 * To run a query within a React component, call `useLogMappingOptionsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useLogMappingOptionsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogMappingOptionsQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useLogMappingOptionsQueryOperation(baseOptions?: Apollo.QueryHookOptions<LogMappingOptionsQueryOperationQuery, LogMappingOptionsQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogMappingOptionsQueryOperationQuery, LogMappingOptionsQueryOperationQueryVariables>(LogMappingOptionsQueryOperationDocument, options);
      }
export function useLogMappingOptionsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogMappingOptionsQueryOperationQuery, LogMappingOptionsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogMappingOptionsQueryOperationQuery, LogMappingOptionsQueryOperationQueryVariables>(LogMappingOptionsQueryOperationDocument, options);
        }
export function useLogMappingOptionsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LogMappingOptionsQueryOperationQuery, LogMappingOptionsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LogMappingOptionsQueryOperationQuery, LogMappingOptionsQueryOperationQueryVariables>(LogMappingOptionsQueryOperationDocument, options);
        }
export type LogMappingOptionsQueryOperationHookResult = ReturnType<typeof useLogMappingOptionsQueryOperation>;
export type LogMappingOptionsQueryOperationLazyQueryHookResult = ReturnType<typeof useLogMappingOptionsQueryOperationLazyQuery>;
export type LogMappingOptionsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useLogMappingOptionsQueryOperationSuspenseQuery>;
export type LogMappingOptionsQueryOperationQueryResult = Apollo.QueryResult<LogMappingOptionsQueryOperationQuery, LogMappingOptionsQueryOperationQueryVariables>;
export const LogMappingFormatOptionsQueryOperationDocument = gql`
    query LogMappingFormatOptionsQueryOperation {
  logMappingOptions {
    logFormatOptions {
      value
      label
    }
  }
}
    `;

/**
 * __useLogMappingFormatOptionsQueryOperation__
 *
 * To run a query within a React component, call `useLogMappingFormatOptionsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useLogMappingFormatOptionsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogMappingFormatOptionsQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useLogMappingFormatOptionsQueryOperation(baseOptions?: Apollo.QueryHookOptions<LogMappingFormatOptionsQueryOperationQuery, LogMappingFormatOptionsQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogMappingFormatOptionsQueryOperationQuery, LogMappingFormatOptionsQueryOperationQueryVariables>(LogMappingFormatOptionsQueryOperationDocument, options);
      }
export function useLogMappingFormatOptionsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogMappingFormatOptionsQueryOperationQuery, LogMappingFormatOptionsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogMappingFormatOptionsQueryOperationQuery, LogMappingFormatOptionsQueryOperationQueryVariables>(LogMappingFormatOptionsQueryOperationDocument, options);
        }
export function useLogMappingFormatOptionsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LogMappingFormatOptionsQueryOperationQuery, LogMappingFormatOptionsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LogMappingFormatOptionsQueryOperationQuery, LogMappingFormatOptionsQueryOperationQueryVariables>(LogMappingFormatOptionsQueryOperationDocument, options);
        }
export type LogMappingFormatOptionsQueryOperationHookResult = ReturnType<typeof useLogMappingFormatOptionsQueryOperation>;
export type LogMappingFormatOptionsQueryOperationLazyQueryHookResult = ReturnType<typeof useLogMappingFormatOptionsQueryOperationLazyQuery>;
export type LogMappingFormatOptionsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useLogMappingFormatOptionsQueryOperationSuspenseQuery>;
export type LogMappingFormatOptionsQueryOperationQueryResult = Apollo.QueryResult<LogMappingFormatOptionsQueryOperationQuery, LogMappingFormatOptionsQueryOperationQueryVariables>;
export const LogMappingRecordTypeQueryOperationDocument = gql`
    query LogMappingRecordTypeQueryOperation {
  logMappingOptions {
    recordTypeOptions {
      objectType
      mappableFields {
        name
        type
      }
    }
  }
}
    `;

/**
 * __useLogMappingRecordTypeQueryOperation__
 *
 * To run a query within a React component, call `useLogMappingRecordTypeQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useLogMappingRecordTypeQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogMappingRecordTypeQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useLogMappingRecordTypeQueryOperation(baseOptions?: Apollo.QueryHookOptions<LogMappingRecordTypeQueryOperationQuery, LogMappingRecordTypeQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogMappingRecordTypeQueryOperationQuery, LogMappingRecordTypeQueryOperationQueryVariables>(LogMappingRecordTypeQueryOperationDocument, options);
      }
export function useLogMappingRecordTypeQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogMappingRecordTypeQueryOperationQuery, LogMappingRecordTypeQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogMappingRecordTypeQueryOperationQuery, LogMappingRecordTypeQueryOperationQueryVariables>(LogMappingRecordTypeQueryOperationDocument, options);
        }
export function useLogMappingRecordTypeQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LogMappingRecordTypeQueryOperationQuery, LogMappingRecordTypeQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LogMappingRecordTypeQueryOperationQuery, LogMappingRecordTypeQueryOperationQueryVariables>(LogMappingRecordTypeQueryOperationDocument, options);
        }
export type LogMappingRecordTypeQueryOperationHookResult = ReturnType<typeof useLogMappingRecordTypeQueryOperation>;
export type LogMappingRecordTypeQueryOperationLazyQueryHookResult = ReturnType<typeof useLogMappingRecordTypeQueryOperationLazyQuery>;
export type LogMappingRecordTypeQueryOperationSuspenseQueryHookResult = ReturnType<typeof useLogMappingRecordTypeQueryOperationSuspenseQuery>;
export type LogMappingRecordTypeQueryOperationQueryResult = Apollo.QueryResult<LogMappingRecordTypeQueryOperationQuery, LogMappingRecordTypeQueryOperationQueryVariables>;
export const ParsingPatternOptionsQueryOperationDocument = gql`
    query ParsingPatternOptionsQueryOperation {
  logMappingOptions {
    parsingPatternOptions {
      value
      label
    }
  }
}
    `;

/**
 * __useParsingPatternOptionsQueryOperation__
 *
 * To run a query within a React component, call `useParsingPatternOptionsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useParsingPatternOptionsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParsingPatternOptionsQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useParsingPatternOptionsQueryOperation(baseOptions?: Apollo.QueryHookOptions<ParsingPatternOptionsQueryOperationQuery, ParsingPatternOptionsQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParsingPatternOptionsQueryOperationQuery, ParsingPatternOptionsQueryOperationQueryVariables>(ParsingPatternOptionsQueryOperationDocument, options);
      }
export function useParsingPatternOptionsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParsingPatternOptionsQueryOperationQuery, ParsingPatternOptionsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParsingPatternOptionsQueryOperationQuery, ParsingPatternOptionsQueryOperationQueryVariables>(ParsingPatternOptionsQueryOperationDocument, options);
        }
export function useParsingPatternOptionsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ParsingPatternOptionsQueryOperationQuery, ParsingPatternOptionsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ParsingPatternOptionsQueryOperationQuery, ParsingPatternOptionsQueryOperationQueryVariables>(ParsingPatternOptionsQueryOperationDocument, options);
        }
export type ParsingPatternOptionsQueryOperationHookResult = ReturnType<typeof useParsingPatternOptionsQueryOperation>;
export type ParsingPatternOptionsQueryOperationLazyQueryHookResult = ReturnType<typeof useParsingPatternOptionsQueryOperationLazyQuery>;
export type ParsingPatternOptionsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useParsingPatternOptionsQueryOperationSuspenseQuery>;
export type ParsingPatternOptionsQueryOperationQueryResult = Apollo.QueryResult<ParsingPatternOptionsQueryOperationQuery, ParsingPatternOptionsQueryOperationQueryVariables>;
export const LogMappingVendorsAndProductsQueryOperationDocument = gql`
    query LogMappingVendorsAndProductsQueryOperation {
  logMappingVendorsAndProducts {
    guid
    product
    vendor
  }
}
    `;

/**
 * __useLogMappingVendorsAndProductsQueryOperation__
 *
 * To run a query within a React component, call `useLogMappingVendorsAndProductsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useLogMappingVendorsAndProductsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogMappingVendorsAndProductsQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useLogMappingVendorsAndProductsQueryOperation(baseOptions?: Apollo.QueryHookOptions<LogMappingVendorsAndProductsQueryOperationQuery, LogMappingVendorsAndProductsQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogMappingVendorsAndProductsQueryOperationQuery, LogMappingVendorsAndProductsQueryOperationQueryVariables>(LogMappingVendorsAndProductsQueryOperationDocument, options);
      }
export function useLogMappingVendorsAndProductsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogMappingVendorsAndProductsQueryOperationQuery, LogMappingVendorsAndProductsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogMappingVendorsAndProductsQueryOperationQuery, LogMappingVendorsAndProductsQueryOperationQueryVariables>(LogMappingVendorsAndProductsQueryOperationDocument, options);
        }
export function useLogMappingVendorsAndProductsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LogMappingVendorsAndProductsQueryOperationQuery, LogMappingVendorsAndProductsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LogMappingVendorsAndProductsQueryOperationQuery, LogMappingVendorsAndProductsQueryOperationQueryVariables>(LogMappingVendorsAndProductsQueryOperationDocument, options);
        }
export type LogMappingVendorsAndProductsQueryOperationHookResult = ReturnType<typeof useLogMappingVendorsAndProductsQueryOperation>;
export type LogMappingVendorsAndProductsQueryOperationLazyQueryHookResult = ReturnType<typeof useLogMappingVendorsAndProductsQueryOperationLazyQuery>;
export type LogMappingVendorsAndProductsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useLogMappingVendorsAndProductsQueryOperationSuspenseQuery>;
export type LogMappingVendorsAndProductsQueryOperationQueryResult = Apollo.QueryResult<LogMappingVendorsAndProductsQueryOperationQuery, LogMappingVendorsAndProductsQueryOperationQueryVariables>;
export const CreateLogMappingOperationDocument = gql`
    mutation CreateLogMappingOperation($fields: CreateLogMappingFields!) {
  createLogMapping(fields: $fields) {
    data {
      ...LogMappingFields
    }
  }
}
    ${LogMappingFieldsFragmentDoc}`;
export type CreateLogMappingOperationMutationFn = Apollo.MutationFunction<CreateLogMappingOperationMutation, CreateLogMappingOperationMutationVariables>;

/**
 * __useCreateLogMappingOperationMutation__
 *
 * To run a mutation, you first call `useCreateLogMappingOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLogMappingOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLogMappingOperationMutation, { data, loading, error }] = useCreateLogMappingOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateLogMappingOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLogMappingOperationMutation, CreateLogMappingOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLogMappingOperationMutation, CreateLogMappingOperationMutationVariables>(CreateLogMappingOperationDocument, options);
      }
export type CreateLogMappingOperationMutationHookResult = ReturnType<typeof useCreateLogMappingOperationMutation>;
export type CreateLogMappingOperationMutationResult = Apollo.MutationResult<CreateLogMappingOperationMutation>;
export type CreateLogMappingOperationMutationOptions = Apollo.BaseMutationOptions<CreateLogMappingOperationMutation, CreateLogMappingOperationMutationVariables>;
export const EnforcedOutputSchemaFieldsQueryOperationDocument = gql`
    query EnforcedOutputSchemaFieldsQueryOperation {
  enforcedOutputSchemaFields {
    field
    enforcedOutputs
  }
}
    `;

/**
 * __useEnforcedOutputSchemaFieldsQueryOperation__
 *
 * To run a query within a React component, call `useEnforcedOutputSchemaFieldsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEnforcedOutputSchemaFieldsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnforcedOutputSchemaFieldsQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useEnforcedOutputSchemaFieldsQueryOperation(baseOptions?: Apollo.QueryHookOptions<EnforcedOutputSchemaFieldsQueryOperationQuery, EnforcedOutputSchemaFieldsQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnforcedOutputSchemaFieldsQueryOperationQuery, EnforcedOutputSchemaFieldsQueryOperationQueryVariables>(EnforcedOutputSchemaFieldsQueryOperationDocument, options);
      }
export function useEnforcedOutputSchemaFieldsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnforcedOutputSchemaFieldsQueryOperationQuery, EnforcedOutputSchemaFieldsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnforcedOutputSchemaFieldsQueryOperationQuery, EnforcedOutputSchemaFieldsQueryOperationQueryVariables>(EnforcedOutputSchemaFieldsQueryOperationDocument, options);
        }
export function useEnforcedOutputSchemaFieldsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EnforcedOutputSchemaFieldsQueryOperationQuery, EnforcedOutputSchemaFieldsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnforcedOutputSchemaFieldsQueryOperationQuery, EnforcedOutputSchemaFieldsQueryOperationQueryVariables>(EnforcedOutputSchemaFieldsQueryOperationDocument, options);
        }
export type EnforcedOutputSchemaFieldsQueryOperationHookResult = ReturnType<typeof useEnforcedOutputSchemaFieldsQueryOperation>;
export type EnforcedOutputSchemaFieldsQueryOperationLazyQueryHookResult = ReturnType<typeof useEnforcedOutputSchemaFieldsQueryOperationLazyQuery>;
export type EnforcedOutputSchemaFieldsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEnforcedOutputSchemaFieldsQueryOperationSuspenseQuery>;
export type EnforcedOutputSchemaFieldsQueryOperationQueryResult = Apollo.QueryResult<EnforcedOutputSchemaFieldsQueryOperationQuery, EnforcedOutputSchemaFieldsQueryOperationQueryVariables>;
export const LogMappingRecordMetricsQueryOperationDocument = gql`
    query LogMappingRecordMetricsQueryOperation($daysBack: Int!, $timezone: String) {
  recordCountsByParsed(daysBack: $daysBack, timezone: $timezone) {
    timestamp
    value {
      parsed
      unparsed
    }
  }
  recordCountsByVendorAndProduct(daysBack: $daysBack, timezone: $timezone) {
    timestamp
    value {
      count
      product
      vendor
    }
  }
  signalCountsByVendorAndProduct(daysBack: $daysBack, timezone: $timezone) {
    timestamp
    value {
      count
      product
      vendor
    }
  }
}
    `;

/**
 * __useLogMappingRecordMetricsQueryOperation__
 *
 * To run a query within a React component, call `useLogMappingRecordMetricsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useLogMappingRecordMetricsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogMappingRecordMetricsQueryOperation({
 *   variables: {
 *      daysBack: // value for 'daysBack'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useLogMappingRecordMetricsQueryOperation(baseOptions: Apollo.QueryHookOptions<LogMappingRecordMetricsQueryOperationQuery, LogMappingRecordMetricsQueryOperationQueryVariables> & ({ variables: LogMappingRecordMetricsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogMappingRecordMetricsQueryOperationQuery, LogMappingRecordMetricsQueryOperationQueryVariables>(LogMappingRecordMetricsQueryOperationDocument, options);
      }
export function useLogMappingRecordMetricsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogMappingRecordMetricsQueryOperationQuery, LogMappingRecordMetricsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogMappingRecordMetricsQueryOperationQuery, LogMappingRecordMetricsQueryOperationQueryVariables>(LogMappingRecordMetricsQueryOperationDocument, options);
        }
export function useLogMappingRecordMetricsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LogMappingRecordMetricsQueryOperationQuery, LogMappingRecordMetricsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LogMappingRecordMetricsQueryOperationQuery, LogMappingRecordMetricsQueryOperationQueryVariables>(LogMappingRecordMetricsQueryOperationDocument, options);
        }
export type LogMappingRecordMetricsQueryOperationHookResult = ReturnType<typeof useLogMappingRecordMetricsQueryOperation>;
export type LogMappingRecordMetricsQueryOperationLazyQueryHookResult = ReturnType<typeof useLogMappingRecordMetricsQueryOperationLazyQuery>;
export type LogMappingRecordMetricsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useLogMappingRecordMetricsQueryOperationSuspenseQuery>;
export type LogMappingRecordMetricsQueryOperationQueryResult = Apollo.QueryResult<LogMappingRecordMetricsQueryOperationQuery, LogMappingRecordMetricsQueryOperationQueryVariables>;
export const LogMappingsQueryOperationDocument = gql`
    query LogMappingsQueryOperation($offset: Int!, $limit: Int!, $sort: LogMappingSortableField!, $sortDir: SortDir!, $q: String) {
  logMappings(
    offset: $offset
    limit: $limit
    q: $q
    sort: [{field: $sort, direction: $sortDir}]
  ) {
    total
    hasNextPage
    objects {
      ...LogMappingFragment
    }
  }
}
    ${LogMappingFragmentDoc}`;

/**
 * __useLogMappingsQueryOperation__
 *
 * To run a query within a React component, call `useLogMappingsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useLogMappingsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogMappingsQueryOperation({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useLogMappingsQueryOperation(baseOptions: Apollo.QueryHookOptions<LogMappingsQueryOperationQuery, LogMappingsQueryOperationQueryVariables> & ({ variables: LogMappingsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogMappingsQueryOperationQuery, LogMappingsQueryOperationQueryVariables>(LogMappingsQueryOperationDocument, options);
      }
export function useLogMappingsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogMappingsQueryOperationQuery, LogMappingsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogMappingsQueryOperationQuery, LogMappingsQueryOperationQueryVariables>(LogMappingsQueryOperationDocument, options);
        }
export function useLogMappingsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LogMappingsQueryOperationQuery, LogMappingsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LogMappingsQueryOperationQuery, LogMappingsQueryOperationQueryVariables>(LogMappingsQueryOperationDocument, options);
        }
export type LogMappingsQueryOperationHookResult = ReturnType<typeof useLogMappingsQueryOperation>;
export type LogMappingsQueryOperationLazyQueryHookResult = ReturnType<typeof useLogMappingsQueryOperationLazyQuery>;
export type LogMappingsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useLogMappingsQueryOperationSuspenseQuery>;
export type LogMappingsQueryOperationQueryResult = Apollo.QueryResult<LogMappingsQueryOperationQuery, LogMappingsQueryOperationQueryVariables>;
export const UpdateMappingEnabledOperationDocument = gql`
    mutation UpdateMappingEnabledOperation($enabled: Boolean!, $id: ID!) {
  updateLogMappingEnabled(enabled: $enabled, id: $id) {
    data {
      id
      isEnabled
      lastUpdated
      lastUpdatedBy
    }
  }
}
    `;
export type UpdateMappingEnabledOperationMutationFn = Apollo.MutationFunction<UpdateMappingEnabledOperationMutation, UpdateMappingEnabledOperationMutationVariables>;

/**
 * __useUpdateMappingEnabledOperationMutation__
 *
 * To run a mutation, you first call `useUpdateMappingEnabledOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMappingEnabledOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMappingEnabledOperationMutation, { data, loading, error }] = useUpdateMappingEnabledOperationMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateMappingEnabledOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMappingEnabledOperationMutation, UpdateMappingEnabledOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMappingEnabledOperationMutation, UpdateMappingEnabledOperationMutationVariables>(UpdateMappingEnabledOperationDocument, options);
      }
export type UpdateMappingEnabledOperationMutationHookResult = ReturnType<typeof useUpdateMappingEnabledOperationMutation>;
export type UpdateMappingEnabledOperationMutationResult = Apollo.MutationResult<UpdateMappingEnabledOperationMutation>;
export type UpdateMappingEnabledOperationMutationOptions = Apollo.BaseMutationOptions<UpdateMappingEnabledOperationMutation, UpdateMappingEnabledOperationMutationVariables>;
export const DeleteLogMappingOperationDocument = gql`
    mutation DeleteLogMappingOperation($id: ID!) {
  deleteLogMapping(id: $id) {
    ok
  }
}
    `;
export type DeleteLogMappingOperationMutationFn = Apollo.MutationFunction<DeleteLogMappingOperationMutation, DeleteLogMappingOperationMutationVariables>;

/**
 * __useDeleteLogMappingOperationMutation__
 *
 * To run a mutation, you first call `useDeleteLogMappingOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLogMappingOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLogMappingOperationMutation, { data, loading, error }] = useDeleteLogMappingOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLogMappingOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLogMappingOperationMutation, DeleteLogMappingOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLogMappingOperationMutation, DeleteLogMappingOperationMutationVariables>(DeleteLogMappingOperationDocument, options);
      }
export type DeleteLogMappingOperationMutationHookResult = ReturnType<typeof useDeleteLogMappingOperationMutation>;
export type DeleteLogMappingOperationMutationResult = Apollo.MutationResult<DeleteLogMappingOperationMutation>;
export type DeleteLogMappingOperationMutationOptions = Apollo.BaseMutationOptions<DeleteLogMappingOperationMutation, DeleteLogMappingOperationMutationVariables>;
export const LogMappingDetailQueryDocument = gql`
    query LogMappingDetailQuery($id: String!) {
  logMapping(id: $id) {
    ...LogMappingFields
  }
  logMappingVendorsAndProducts {
    guid
    product
    vendor
  }
}
    ${LogMappingFieldsFragmentDoc}`;

/**
 * __useLogMappingDetailQuery__
 *
 * To run a query within a React component, call `useLogMappingDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogMappingDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogMappingDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLogMappingDetailQuery(baseOptions: Apollo.QueryHookOptions<LogMappingDetailQuery, LogMappingDetailQueryVariables> & ({ variables: LogMappingDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogMappingDetailQuery, LogMappingDetailQueryVariables>(LogMappingDetailQueryDocument, options);
      }
export function useLogMappingDetailQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogMappingDetailQuery, LogMappingDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogMappingDetailQuery, LogMappingDetailQueryVariables>(LogMappingDetailQueryDocument, options);
        }
export function useLogMappingDetailQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LogMappingDetailQuery, LogMappingDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LogMappingDetailQuery, LogMappingDetailQueryVariables>(LogMappingDetailQueryDocument, options);
        }
export type LogMappingDetailQueryHookResult = ReturnType<typeof useLogMappingDetailQuery>;
export type LogMappingDetailQueryLazyQueryHookResult = ReturnType<typeof useLogMappingDetailQueryLazyQuery>;
export type LogMappingDetailQuerySuspenseQueryHookResult = ReturnType<typeof useLogMappingDetailQuerySuspenseQuery>;
export type LogMappingDetailQueryQueryResult = Apollo.QueryResult<LogMappingDetailQuery, LogMappingDetailQueryVariables>;
export const SumoMappingsOperationDocument = gql`
    query SumoMappingsOperation($offset: Int!, $limit: Int!, $sort: SumoMappingSortableField!, $sortDir: SortDir!) {
  sumoMappings(
    offset: $offset
    limit: $limit
    sort: [{field: $sort, direction: $sortDir}]
  ) {
    hasNextPage
    total
    objects {
      ...SumoMappingObjectFields
    }
  }
}
    ${SumoMappingObjectFieldsFragmentDoc}`;

/**
 * __useSumoMappingsOperationQuery__
 *
 * To run a query within a React component, call `useSumoMappingsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSumoMappingsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSumoMappingsOperationQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useSumoMappingsOperationQuery(baseOptions: Apollo.QueryHookOptions<SumoMappingsOperationQuery, SumoMappingsOperationQueryVariables> & ({ variables: SumoMappingsOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SumoMappingsOperationQuery, SumoMappingsOperationQueryVariables>(SumoMappingsOperationDocument, options);
      }
export function useSumoMappingsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SumoMappingsOperationQuery, SumoMappingsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SumoMappingsOperationQuery, SumoMappingsOperationQueryVariables>(SumoMappingsOperationDocument, options);
        }
export function useSumoMappingsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SumoMappingsOperationQuery, SumoMappingsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SumoMappingsOperationQuery, SumoMappingsOperationQueryVariables>(SumoMappingsOperationDocument, options);
        }
export type SumoMappingsOperationQueryHookResult = ReturnType<typeof useSumoMappingsOperationQuery>;
export type SumoMappingsOperationLazyQueryHookResult = ReturnType<typeof useSumoMappingsOperationLazyQuery>;
export type SumoMappingsOperationSuspenseQueryHookResult = ReturnType<typeof useSumoMappingsOperationSuspenseQuery>;
export type SumoMappingsOperationQueryResult = Apollo.QueryResult<SumoMappingsOperationQuery, SumoMappingsOperationQueryVariables>;
export const DeleteSumoMappingOperationDocument = gql`
    mutation DeleteSumoMappingOperation($id: ID!) {
  deleteSumoMapping(id: $id) {
    ok
  }
}
    `;
export type DeleteSumoMappingOperationMutationFn = Apollo.MutationFunction<DeleteSumoMappingOperationMutation, DeleteSumoMappingOperationMutationVariables>;

/**
 * __useDeleteSumoMappingOperationMutation__
 *
 * To run a mutation, you first call `useDeleteSumoMappingOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSumoMappingOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSumoMappingOperationMutation, { data, loading, error }] = useDeleteSumoMappingOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSumoMappingOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSumoMappingOperationMutation, DeleteSumoMappingOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSumoMappingOperationMutation, DeleteSumoMappingOperationMutationVariables>(DeleteSumoMappingOperationDocument, options);
      }
export type DeleteSumoMappingOperationMutationHookResult = ReturnType<typeof useDeleteSumoMappingOperationMutation>;
export type DeleteSumoMappingOperationMutationResult = Apollo.MutationResult<DeleteSumoMappingOperationMutation>;
export type DeleteSumoMappingOperationMutationOptions = Apollo.BaseMutationOptions<DeleteSumoMappingOperationMutation, DeleteSumoMappingOperationMutationVariables>;
export const CreateSumoMappingOperationDocument = gql`
    mutation CreateSumoMappingOperation($fields: SumoMappingFields!) {
  createSumoMapping(fields: $fields) {
    data {
      ...SumoMappingObjectFields
    }
  }
}
    ${SumoMappingObjectFieldsFragmentDoc}`;
export type CreateSumoMappingOperationMutationFn = Apollo.MutationFunction<CreateSumoMappingOperationMutation, CreateSumoMappingOperationMutationVariables>;

/**
 * __useCreateSumoMappingOperationMutation__
 *
 * To run a mutation, you first call `useCreateSumoMappingOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSumoMappingOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSumoMappingOperationMutation, { data, loading, error }] = useCreateSumoMappingOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateSumoMappingOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSumoMappingOperationMutation, CreateSumoMappingOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSumoMappingOperationMutation, CreateSumoMappingOperationMutationVariables>(CreateSumoMappingOperationDocument, options);
      }
export type CreateSumoMappingOperationMutationHookResult = ReturnType<typeof useCreateSumoMappingOperationMutation>;
export type CreateSumoMappingOperationMutationResult = Apollo.MutationResult<CreateSumoMappingOperationMutation>;
export type CreateSumoMappingOperationMutationOptions = Apollo.BaseMutationOptions<CreateSumoMappingOperationMutation, CreateSumoMappingOperationMutationVariables>;
export const UpdateSumoMappingOperationDocument = gql`
    mutation UpdateSumoMappingOperation($id: ID!, $fields: SumoMappingFields!) {
  updateSumoMapping(id: $id, fields: $fields) {
    data {
      ...SumoMappingObjectFields
    }
  }
}
    ${SumoMappingObjectFieldsFragmentDoc}`;
export type UpdateSumoMappingOperationMutationFn = Apollo.MutationFunction<UpdateSumoMappingOperationMutation, UpdateSumoMappingOperationMutationVariables>;

/**
 * __useUpdateSumoMappingOperationMutation__
 *
 * To run a mutation, you first call `useUpdateSumoMappingOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSumoMappingOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSumoMappingOperationMutation, { data, loading, error }] = useUpdateSumoMappingOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateSumoMappingOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSumoMappingOperationMutation, UpdateSumoMappingOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSumoMappingOperationMutation, UpdateSumoMappingOperationMutationVariables>(UpdateSumoMappingOperationDocument, options);
      }
export type UpdateSumoMappingOperationMutationHookResult = ReturnType<typeof useUpdateSumoMappingOperationMutation>;
export type UpdateSumoMappingOperationMutationResult = Apollo.MutationResult<UpdateSumoMappingOperationMutation>;
export type UpdateSumoMappingOperationMutationOptions = Apollo.BaseMutationOptions<UpdateSumoMappingOperationMutation, UpdateSumoMappingOperationMutationVariables>;
export const CreateTagSchemaOperationDocument = gql`
    mutation CreateTagSchemaOperation($fields: CreateTagSchemaFields!) {
  createTagSchema(fields: $fields) {
    data {
      key
      label
      contentTypeEnums
      valueOptionObjects {
        value
        label
        link
      }
    }
  }
}
    `;
export type CreateTagSchemaOperationMutationFn = Apollo.MutationFunction<CreateTagSchemaOperationMutation, CreateTagSchemaOperationMutationVariables>;

/**
 * __useCreateTagSchemaOperationMutation__
 *
 * To run a mutation, you first call `useCreateTagSchemaOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagSchemaOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagSchemaOperationMutation, { data, loading, error }] = useCreateTagSchemaOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateTagSchemaOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagSchemaOperationMutation, CreateTagSchemaOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagSchemaOperationMutation, CreateTagSchemaOperationMutationVariables>(CreateTagSchemaOperationDocument, options);
      }
export type CreateTagSchemaOperationMutationHookResult = ReturnType<typeof useCreateTagSchemaOperationMutation>;
export type CreateTagSchemaOperationMutationResult = Apollo.MutationResult<CreateTagSchemaOperationMutation>;
export type CreateTagSchemaOperationMutationOptions = Apollo.BaseMutationOptions<CreateTagSchemaOperationMutation, CreateTagSchemaOperationMutationVariables>;
export const UpdateTagSchemaOperationDocument = gql`
    mutation UpdateTagSchemaOperation($fields: UpdateTagSchemaFields!) {
  updateTagSchema(fields: $fields) {
    data {
      key
      label
      contentTypeEnums
      valueOptionObjects {
        value
        label
        link
      }
    }
  }
}
    `;
export type UpdateTagSchemaOperationMutationFn = Apollo.MutationFunction<UpdateTagSchemaOperationMutation, UpdateTagSchemaOperationMutationVariables>;

/**
 * __useUpdateTagSchemaOperationMutation__
 *
 * To run a mutation, you first call `useUpdateTagSchemaOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagSchemaOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagSchemaOperationMutation, { data, loading, error }] = useUpdateTagSchemaOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateTagSchemaOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagSchemaOperationMutation, UpdateTagSchemaOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagSchemaOperationMutation, UpdateTagSchemaOperationMutationVariables>(UpdateTagSchemaOperationDocument, options);
      }
export type UpdateTagSchemaOperationMutationHookResult = ReturnType<typeof useUpdateTagSchemaOperationMutation>;
export type UpdateTagSchemaOperationMutationResult = Apollo.MutationResult<UpdateTagSchemaOperationMutation>;
export type UpdateTagSchemaOperationMutationOptions = Apollo.BaseMutationOptions<UpdateTagSchemaOperationMutation, UpdateTagSchemaOperationMutationVariables>;
export const DeleteTagSchemaOperationDocument = gql`
    mutation DeleteTagSchemaOperation($key: ID!) {
  deleteTagSchema(key: $key) {
    ok
  }
}
    `;
export type DeleteTagSchemaOperationMutationFn = Apollo.MutationFunction<DeleteTagSchemaOperationMutation, DeleteTagSchemaOperationMutationVariables>;

/**
 * __useDeleteTagSchemaOperationMutation__
 *
 * To run a mutation, you first call `useDeleteTagSchemaOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagSchemaOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagSchemaOperationMutation, { data, loading, error }] = useDeleteTagSchemaOperationMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useDeleteTagSchemaOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagSchemaOperationMutation, DeleteTagSchemaOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagSchemaOperationMutation, DeleteTagSchemaOperationMutationVariables>(DeleteTagSchemaOperationDocument, options);
      }
export type DeleteTagSchemaOperationMutationHookResult = ReturnType<typeof useDeleteTagSchemaOperationMutation>;
export type DeleteTagSchemaOperationMutationResult = Apollo.MutationResult<DeleteTagSchemaOperationMutation>;
export type DeleteTagSchemaOperationMutationOptions = Apollo.BaseMutationOptions<DeleteTagSchemaOperationMutation, DeleteTagSchemaOperationMutationVariables>;
export const CreateInsightStatusOperationDocument = gql`
    mutation CreateInsightStatusOperation($fields: CreateInsightStatusFields!) {
  createInsightStatus(fields: $fields) {
    data {
      ...WorkflowInsightStatusFragment
    }
  }
}
    ${WorkflowInsightStatusFragmentDoc}`;
export type CreateInsightStatusOperationMutationFn = Apollo.MutationFunction<CreateInsightStatusOperationMutation, CreateInsightStatusOperationMutationVariables>;

/**
 * __useCreateInsightStatusOperationMutation__
 *
 * To run a mutation, you first call `useCreateInsightStatusOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsightStatusOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsightStatusOperationMutation, { data, loading, error }] = useCreateInsightStatusOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateInsightStatusOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateInsightStatusOperationMutation, CreateInsightStatusOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInsightStatusOperationMutation, CreateInsightStatusOperationMutationVariables>(CreateInsightStatusOperationDocument, options);
      }
export type CreateInsightStatusOperationMutationHookResult = ReturnType<typeof useCreateInsightStatusOperationMutation>;
export type CreateInsightStatusOperationMutationResult = Apollo.MutationResult<CreateInsightStatusOperationMutation>;
export type CreateInsightStatusOperationMutationOptions = Apollo.BaseMutationOptions<CreateInsightStatusOperationMutation, CreateInsightStatusOperationMutationVariables>;
export const UpdateInsightStatusWorkflowOperationDocument = gql`
    mutation UpdateInsightStatusWorkflowOperation($fields: UpdateInsightStatusFields!, $id: ID!) {
  updateInsightStatus(fields: $fields, id: $id) {
    data {
      ...WorkflowInsightStatusFragment
    }
  }
}
    ${WorkflowInsightStatusFragmentDoc}`;
export type UpdateInsightStatusWorkflowOperationMutationFn = Apollo.MutationFunction<UpdateInsightStatusWorkflowOperationMutation, UpdateInsightStatusWorkflowOperationMutationVariables>;

/**
 * __useUpdateInsightStatusWorkflowOperationMutation__
 *
 * To run a mutation, you first call `useUpdateInsightStatusWorkflowOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightStatusWorkflowOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightStatusWorkflowOperationMutation, { data, loading, error }] = useUpdateInsightStatusWorkflowOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateInsightStatusWorkflowOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsightStatusWorkflowOperationMutation, UpdateInsightStatusWorkflowOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsightStatusWorkflowOperationMutation, UpdateInsightStatusWorkflowOperationMutationVariables>(UpdateInsightStatusWorkflowOperationDocument, options);
      }
export type UpdateInsightStatusWorkflowOperationMutationHookResult = ReturnType<typeof useUpdateInsightStatusWorkflowOperationMutation>;
export type UpdateInsightStatusWorkflowOperationMutationResult = Apollo.MutationResult<UpdateInsightStatusWorkflowOperationMutation>;
export type UpdateInsightStatusWorkflowOperationMutationOptions = Apollo.BaseMutationOptions<UpdateInsightStatusWorkflowOperationMutation, UpdateInsightStatusWorkflowOperationMutationVariables>;
export const InsightStatusesOperationDocument = gql`
    query InsightStatusesOperation {
  insightStatuses(includeDisabled: true) {
    ...WorkflowInsightStatusFragment
  }
  insightStatusInProgressEnabled
}
    ${WorkflowInsightStatusFragmentDoc}`;

/**
 * __useInsightStatusesOperationQuery__
 *
 * To run a query within a React component, call `useInsightStatusesOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightStatusesOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightStatusesOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useInsightStatusesOperationQuery(baseOptions?: Apollo.QueryHookOptions<InsightStatusesOperationQuery, InsightStatusesOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightStatusesOperationQuery, InsightStatusesOperationQueryVariables>(InsightStatusesOperationDocument, options);
      }
export function useInsightStatusesOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightStatusesOperationQuery, InsightStatusesOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightStatusesOperationQuery, InsightStatusesOperationQueryVariables>(InsightStatusesOperationDocument, options);
        }
export function useInsightStatusesOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightStatusesOperationQuery, InsightStatusesOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightStatusesOperationQuery, InsightStatusesOperationQueryVariables>(InsightStatusesOperationDocument, options);
        }
export type InsightStatusesOperationQueryHookResult = ReturnType<typeof useInsightStatusesOperationQuery>;
export type InsightStatusesOperationLazyQueryHookResult = ReturnType<typeof useInsightStatusesOperationLazyQuery>;
export type InsightStatusesOperationSuspenseQueryHookResult = ReturnType<typeof useInsightStatusesOperationSuspenseQuery>;
export type InsightStatusesOperationQueryResult = Apollo.QueryResult<InsightStatusesOperationQuery, InsightStatusesOperationQueryVariables>;
export const DeleteInsightStatusOperationDocument = gql`
    mutation DeleteInsightStatusOperation($id: ID!) {
  deleteInsightStatus(id: $id) {
    ok
  }
}
    `;
export type DeleteInsightStatusOperationMutationFn = Apollo.MutationFunction<DeleteInsightStatusOperationMutation, DeleteInsightStatusOperationMutationVariables>;

/**
 * __useDeleteInsightStatusOperationMutation__
 *
 * To run a mutation, you first call `useDeleteInsightStatusOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInsightStatusOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInsightStatusOperationMutation, { data, loading, error }] = useDeleteInsightStatusOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInsightStatusOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInsightStatusOperationMutation, DeleteInsightStatusOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInsightStatusOperationMutation, DeleteInsightStatusOperationMutationVariables>(DeleteInsightStatusOperationDocument, options);
      }
export type DeleteInsightStatusOperationMutationHookResult = ReturnType<typeof useDeleteInsightStatusOperationMutation>;
export type DeleteInsightStatusOperationMutationResult = Apollo.MutationResult<DeleteInsightStatusOperationMutation>;
export type DeleteInsightStatusOperationMutationOptions = Apollo.BaseMutationOptions<DeleteInsightStatusOperationMutation, DeleteInsightStatusOperationMutationVariables>;
export const ReorderInsightStatusesOperationDocument = gql`
    mutation ReorderInsightStatusesOperation($orderedIds: [ID!]!) {
  reorderInsightStatuses(orderedIds: $orderedIds) {
    ok
  }
}
    `;
export type ReorderInsightStatusesOperationMutationFn = Apollo.MutationFunction<ReorderInsightStatusesOperationMutation, ReorderInsightStatusesOperationMutationVariables>;

/**
 * __useReorderInsightStatusesOperationMutation__
 *
 * To run a mutation, you first call `useReorderInsightStatusesOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReorderInsightStatusesOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reorderInsightStatusesOperationMutation, { data, loading, error }] = useReorderInsightStatusesOperationMutation({
 *   variables: {
 *      orderedIds: // value for 'orderedIds'
 *   },
 * });
 */
export function useReorderInsightStatusesOperationMutation(baseOptions?: Apollo.MutationHookOptions<ReorderInsightStatusesOperationMutation, ReorderInsightStatusesOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReorderInsightStatusesOperationMutation, ReorderInsightStatusesOperationMutationVariables>(ReorderInsightStatusesOperationDocument, options);
      }
export type ReorderInsightStatusesOperationMutationHookResult = ReturnType<typeof useReorderInsightStatusesOperationMutation>;
export type ReorderInsightStatusesOperationMutationResult = Apollo.MutationResult<ReorderInsightStatusesOperationMutation>;
export type ReorderInsightStatusesOperationMutationOptions = Apollo.BaseMutationOptions<ReorderInsightStatusesOperationMutation, ReorderInsightStatusesOperationMutationVariables>;
export const UpdateInsightInProgressStatusOperationDocument = gql`
    mutation UpdateInsightInProgressStatusOperation($enable: Boolean!) {
  updateInsightStatusInProgressEnabled(enable: $enable) {
    ok
  }
}
    `;
export type UpdateInsightInProgressStatusOperationMutationFn = Apollo.MutationFunction<UpdateInsightInProgressStatusOperationMutation, UpdateInsightInProgressStatusOperationMutationVariables>;

/**
 * __useUpdateInsightInProgressStatusOperationMutation__
 *
 * To run a mutation, you first call `useUpdateInsightInProgressStatusOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightInProgressStatusOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightInProgressStatusOperationMutation, { data, loading, error }] = useUpdateInsightInProgressStatusOperationMutation({
 *   variables: {
 *      enable: // value for 'enable'
 *   },
 * });
 */
export function useUpdateInsightInProgressStatusOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsightInProgressStatusOperationMutation, UpdateInsightInProgressStatusOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsightInProgressStatusOperationMutation, UpdateInsightInProgressStatusOperationMutationVariables>(UpdateInsightInProgressStatusOperationDocument, options);
      }
export type UpdateInsightInProgressStatusOperationMutationHookResult = ReturnType<typeof useUpdateInsightInProgressStatusOperationMutation>;
export type UpdateInsightInProgressStatusOperationMutationResult = Apollo.MutationResult<UpdateInsightInProgressStatusOperationMutation>;
export type UpdateInsightInProgressStatusOperationMutationOptions = Apollo.BaseMutationOptions<UpdateInsightInProgressStatusOperationMutation, UpdateInsightInProgressStatusOperationMutationVariables>;
export const CustomInsightsQueryOperationDocument = gql`
    query CustomInsightsQueryOperation($offset: Int!, $limit: Int!) {
  customInsights(offset: $offset, limit: $limit) {
    total
    hasNextPage
    objects {
      ...CustomInsightFields
    }
  }
}
    ${CustomInsightFieldsFragmentDoc}`;

/**
 * __useCustomInsightsQueryOperation__
 *
 * To run a query within a React component, call `useCustomInsightsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useCustomInsightsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomInsightsQueryOperation({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useCustomInsightsQueryOperation(baseOptions: Apollo.QueryHookOptions<CustomInsightsQueryOperationQuery, CustomInsightsQueryOperationQueryVariables> & ({ variables: CustomInsightsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomInsightsQueryOperationQuery, CustomInsightsQueryOperationQueryVariables>(CustomInsightsQueryOperationDocument, options);
      }
export function useCustomInsightsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomInsightsQueryOperationQuery, CustomInsightsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomInsightsQueryOperationQuery, CustomInsightsQueryOperationQueryVariables>(CustomInsightsQueryOperationDocument, options);
        }
export function useCustomInsightsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomInsightsQueryOperationQuery, CustomInsightsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomInsightsQueryOperationQuery, CustomInsightsQueryOperationQueryVariables>(CustomInsightsQueryOperationDocument, options);
        }
export type CustomInsightsQueryOperationHookResult = ReturnType<typeof useCustomInsightsQueryOperation>;
export type CustomInsightsQueryOperationLazyQueryHookResult = ReturnType<typeof useCustomInsightsQueryOperationLazyQuery>;
export type CustomInsightsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useCustomInsightsQueryOperationSuspenseQuery>;
export type CustomInsightsQueryOperationQueryResult = Apollo.QueryResult<CustomInsightsQueryOperationQuery, CustomInsightsQueryOperationQueryVariables>;
export const CustomInsightQueryDocument = gql`
    query CustomInsightQuery($id: ID!) {
  customInsight(id: $id) {
    ...CustomInsightFields
  }
}
    ${CustomInsightFieldsFragmentDoc}`;

/**
 * __useCustomInsightQuery__
 *
 * To run a query within a React component, call `useCustomInsightQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomInsightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomInsightQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomInsightQuery(baseOptions: Apollo.QueryHookOptions<CustomInsightQuery, CustomInsightQueryVariables> & ({ variables: CustomInsightQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomInsightQuery, CustomInsightQueryVariables>(CustomInsightQueryDocument, options);
      }
export function useCustomInsightQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomInsightQuery, CustomInsightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomInsightQuery, CustomInsightQueryVariables>(CustomInsightQueryDocument, options);
        }
export function useCustomInsightQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomInsightQuery, CustomInsightQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomInsightQuery, CustomInsightQueryVariables>(CustomInsightQueryDocument, options);
        }
export type CustomInsightQueryHookResult = ReturnType<typeof useCustomInsightQuery>;
export type CustomInsightQueryLazyQueryHookResult = ReturnType<typeof useCustomInsightQueryLazyQuery>;
export type CustomInsightQuerySuspenseQueryHookResult = ReturnType<typeof useCustomInsightQuerySuspenseQuery>;
export type CustomInsightQueryQueryResult = Apollo.QueryResult<CustomInsightQuery, CustomInsightQueryVariables>;
export const CreateCustomInsightOperationDocument = gql`
    mutation CreateCustomInsightOperation($fields: CreateCustomInsightFields!) {
  createCustomInsight(fields: $fields) {
    data {
      ...CustomInsightFields
    }
  }
}
    ${CustomInsightFieldsFragmentDoc}`;
export type CreateCustomInsightOperationMutationFn = Apollo.MutationFunction<CreateCustomInsightOperationMutation, CreateCustomInsightOperationMutationVariables>;

/**
 * __useCreateCustomInsightOperationMutation__
 *
 * To run a mutation, you first call `useCreateCustomInsightOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomInsightOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomInsightOperationMutation, { data, loading, error }] = useCreateCustomInsightOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateCustomInsightOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomInsightOperationMutation, CreateCustomInsightOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomInsightOperationMutation, CreateCustomInsightOperationMutationVariables>(CreateCustomInsightOperationDocument, options);
      }
export type CreateCustomInsightOperationMutationHookResult = ReturnType<typeof useCreateCustomInsightOperationMutation>;
export type CreateCustomInsightOperationMutationResult = Apollo.MutationResult<CreateCustomInsightOperationMutation>;
export type CreateCustomInsightOperationMutationOptions = Apollo.BaseMutationOptions<CreateCustomInsightOperationMutation, CreateCustomInsightOperationMutationVariables>;
export const UpdateCustomInsightOperationDocument = gql`
    mutation UpdateCustomInsightOperation($fields: UpdateCustomInsightFields!, $id: ID!) {
  updateCustomInsight(fields: $fields, id: $id) {
    data {
      ...CustomInsightFields
    }
  }
}
    ${CustomInsightFieldsFragmentDoc}`;
export type UpdateCustomInsightOperationMutationFn = Apollo.MutationFunction<UpdateCustomInsightOperationMutation, UpdateCustomInsightOperationMutationVariables>;

/**
 * __useUpdateCustomInsightOperationMutation__
 *
 * To run a mutation, you first call `useUpdateCustomInsightOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomInsightOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomInsightOperationMutation, { data, loading, error }] = useUpdateCustomInsightOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCustomInsightOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomInsightOperationMutation, UpdateCustomInsightOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomInsightOperationMutation, UpdateCustomInsightOperationMutationVariables>(UpdateCustomInsightOperationDocument, options);
      }
export type UpdateCustomInsightOperationMutationHookResult = ReturnType<typeof useUpdateCustomInsightOperationMutation>;
export type UpdateCustomInsightOperationMutationResult = Apollo.MutationResult<UpdateCustomInsightOperationMutation>;
export type UpdateCustomInsightOperationMutationOptions = Apollo.BaseMutationOptions<UpdateCustomInsightOperationMutation, UpdateCustomInsightOperationMutationVariables>;
export const UpdateCustomInsightEnabledOperationDocument = gql`
    mutation UpdateCustomInsightEnabledOperation($enabled: Boolean!, $id: ID!) {
  updateCustomInsightEnabled(enabled: $enabled, id: $id) {
    ok
  }
}
    `;
export type UpdateCustomInsightEnabledOperationMutationFn = Apollo.MutationFunction<UpdateCustomInsightEnabledOperationMutation, UpdateCustomInsightEnabledOperationMutationVariables>;

/**
 * __useUpdateCustomInsightEnabledOperationMutation__
 *
 * To run a mutation, you first call `useUpdateCustomInsightEnabledOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomInsightEnabledOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomInsightEnabledOperationMutation, { data, loading, error }] = useUpdateCustomInsightEnabledOperationMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCustomInsightEnabledOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomInsightEnabledOperationMutation, UpdateCustomInsightEnabledOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomInsightEnabledOperationMutation, UpdateCustomInsightEnabledOperationMutationVariables>(UpdateCustomInsightEnabledOperationDocument, options);
      }
export type UpdateCustomInsightEnabledOperationMutationHookResult = ReturnType<typeof useUpdateCustomInsightEnabledOperationMutation>;
export type UpdateCustomInsightEnabledOperationMutationResult = Apollo.MutationResult<UpdateCustomInsightEnabledOperationMutation>;
export type UpdateCustomInsightEnabledOperationMutationOptions = Apollo.BaseMutationOptions<UpdateCustomInsightEnabledOperationMutation, UpdateCustomInsightEnabledOperationMutationVariables>;
export const DeleteCustomInsightOperationDocument = gql`
    mutation DeleteCustomInsightOperation($id: ID!) {
  deleteCustomInsight(id: $id) {
    ok
  }
}
    `;
export type DeleteCustomInsightOperationMutationFn = Apollo.MutationFunction<DeleteCustomInsightOperationMutation, DeleteCustomInsightOperationMutationVariables>;

/**
 * __useDeleteCustomInsightOperationMutation__
 *
 * To run a mutation, you first call `useDeleteCustomInsightOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomInsightOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomInsightOperationMutation, { data, loading, error }] = useDeleteCustomInsightOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomInsightOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomInsightOperationMutation, DeleteCustomInsightOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomInsightOperationMutation, DeleteCustomInsightOperationMutationVariables>(DeleteCustomInsightOperationDocument, options);
      }
export type DeleteCustomInsightOperationMutationHookResult = ReturnType<typeof useDeleteCustomInsightOperationMutation>;
export type DeleteCustomInsightOperationMutationResult = Apollo.MutationResult<DeleteCustomInsightOperationMutation>;
export type DeleteCustomInsightOperationMutationOptions = Apollo.BaseMutationOptions<DeleteCustomInsightOperationMutation, DeleteCustomInsightOperationMutationVariables>;
export const YaraRuleEditorOperationDocument = gql`
    query YaraRuleEditorOperation($sourceId: ID!, $ruleId: ID!, $fetchYaraRule: Boolean!) {
  yaraSource(id: $sourceId) {
    ...YaraSource
  }
  yaraRule(id: $ruleId) @include(if: $fetchYaraRule) {
    ...YaraRule
  }
}
    ${YaraSourceFragmentDoc}
${YaraRuleFragmentDoc}`;

/**
 * __useYaraRuleEditorOperationQuery__
 *
 * To run a query within a React component, call `useYaraRuleEditorOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useYaraRuleEditorOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYaraRuleEditorOperationQuery({
 *   variables: {
 *      sourceId: // value for 'sourceId'
 *      ruleId: // value for 'ruleId'
 *      fetchYaraRule: // value for 'fetchYaraRule'
 *   },
 * });
 */
export function useYaraRuleEditorOperationQuery(baseOptions: Apollo.QueryHookOptions<YaraRuleEditorOperationQuery, YaraRuleEditorOperationQueryVariables> & ({ variables: YaraRuleEditorOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YaraRuleEditorOperationQuery, YaraRuleEditorOperationQueryVariables>(YaraRuleEditorOperationDocument, options);
      }
export function useYaraRuleEditorOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YaraRuleEditorOperationQuery, YaraRuleEditorOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YaraRuleEditorOperationQuery, YaraRuleEditorOperationQueryVariables>(YaraRuleEditorOperationDocument, options);
        }
export function useYaraRuleEditorOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<YaraRuleEditorOperationQuery, YaraRuleEditorOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<YaraRuleEditorOperationQuery, YaraRuleEditorOperationQueryVariables>(YaraRuleEditorOperationDocument, options);
        }
export type YaraRuleEditorOperationQueryHookResult = ReturnType<typeof useYaraRuleEditorOperationQuery>;
export type YaraRuleEditorOperationLazyQueryHookResult = ReturnType<typeof useYaraRuleEditorOperationLazyQuery>;
export type YaraRuleEditorOperationSuspenseQueryHookResult = ReturnType<typeof useYaraRuleEditorOperationSuspenseQuery>;
export type YaraRuleEditorOperationQueryResult = Apollo.QueryResult<YaraRuleEditorOperationQuery, YaraRuleEditorOperationQueryVariables>;
export const YaraExpressionValidationOperationDocument = gql`
    query YaraExpressionValidationOperation($expression: String!, $runValidation: Boolean!) {
  validateYaraExpression(expression: $expression) @include(if: $runValidation)
}
    `;

/**
 * __useYaraExpressionValidationOperationQuery__
 *
 * To run a query within a React component, call `useYaraExpressionValidationOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useYaraExpressionValidationOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYaraExpressionValidationOperationQuery({
 *   variables: {
 *      expression: // value for 'expression'
 *      runValidation: // value for 'runValidation'
 *   },
 * });
 */
export function useYaraExpressionValidationOperationQuery(baseOptions: Apollo.QueryHookOptions<YaraExpressionValidationOperationQuery, YaraExpressionValidationOperationQueryVariables> & ({ variables: YaraExpressionValidationOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YaraExpressionValidationOperationQuery, YaraExpressionValidationOperationQueryVariables>(YaraExpressionValidationOperationDocument, options);
      }
export function useYaraExpressionValidationOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YaraExpressionValidationOperationQuery, YaraExpressionValidationOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YaraExpressionValidationOperationQuery, YaraExpressionValidationOperationQueryVariables>(YaraExpressionValidationOperationDocument, options);
        }
export function useYaraExpressionValidationOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<YaraExpressionValidationOperationQuery, YaraExpressionValidationOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<YaraExpressionValidationOperationQuery, YaraExpressionValidationOperationQueryVariables>(YaraExpressionValidationOperationDocument, options);
        }
export type YaraExpressionValidationOperationQueryHookResult = ReturnType<typeof useYaraExpressionValidationOperationQuery>;
export type YaraExpressionValidationOperationLazyQueryHookResult = ReturnType<typeof useYaraExpressionValidationOperationLazyQuery>;
export type YaraExpressionValidationOperationSuspenseQueryHookResult = ReturnType<typeof useYaraExpressionValidationOperationSuspenseQuery>;
export type YaraExpressionValidationOperationQueryResult = Apollo.QueryResult<YaraExpressionValidationOperationQuery, YaraExpressionValidationOperationQueryVariables>;
export const AddYaraRuleToYaraSourceOperationDocument = gql`
    mutation AddYaraRuleToYaraSourceOperation($yaraSourceId: ID!, $ruleFields: CustomYaraRuleFields!) {
  addYaraRuleToCustomYaraSource(
    yaraSourceId: $yaraSourceId
    yaraRuleFields: $ruleFields
  ) {
    data {
      ...YaraRule
    }
  }
}
    ${YaraRuleFragmentDoc}`;
export type AddYaraRuleToYaraSourceOperationMutationFn = Apollo.MutationFunction<AddYaraRuleToYaraSourceOperationMutation, AddYaraRuleToYaraSourceOperationMutationVariables>;

/**
 * __useAddYaraRuleToYaraSourceOperationMutation__
 *
 * To run a mutation, you first call `useAddYaraRuleToYaraSourceOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddYaraRuleToYaraSourceOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addYaraRuleToYaraSourceOperationMutation, { data, loading, error }] = useAddYaraRuleToYaraSourceOperationMutation({
 *   variables: {
 *      yaraSourceId: // value for 'yaraSourceId'
 *      ruleFields: // value for 'ruleFields'
 *   },
 * });
 */
export function useAddYaraRuleToYaraSourceOperationMutation(baseOptions?: Apollo.MutationHookOptions<AddYaraRuleToYaraSourceOperationMutation, AddYaraRuleToYaraSourceOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddYaraRuleToYaraSourceOperationMutation, AddYaraRuleToYaraSourceOperationMutationVariables>(AddYaraRuleToYaraSourceOperationDocument, options);
      }
export type AddYaraRuleToYaraSourceOperationMutationHookResult = ReturnType<typeof useAddYaraRuleToYaraSourceOperationMutation>;
export type AddYaraRuleToYaraSourceOperationMutationResult = Apollo.MutationResult<AddYaraRuleToYaraSourceOperationMutation>;
export type AddYaraRuleToYaraSourceOperationMutationOptions = Apollo.BaseMutationOptions<AddYaraRuleToYaraSourceOperationMutation, AddYaraRuleToYaraSourceOperationMutationVariables>;
export const UpdateYaraRuleOperationDocument = gql`
    mutation UpdateYaraRuleOperation($id: ID!, $fields: CustomYaraRuleFields!) {
  updateCustomYaraRule(id: $id, fields: $fields) {
    data {
      ...YaraRule
    }
  }
}
    ${YaraRuleFragmentDoc}`;
export type UpdateYaraRuleOperationMutationFn = Apollo.MutationFunction<UpdateYaraRuleOperationMutation, UpdateYaraRuleOperationMutationVariables>;

/**
 * __useUpdateYaraRuleOperationMutation__
 *
 * To run a mutation, you first call `useUpdateYaraRuleOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateYaraRuleOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateYaraRuleOperationMutation, { data, loading, error }] = useUpdateYaraRuleOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateYaraRuleOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateYaraRuleOperationMutation, UpdateYaraRuleOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateYaraRuleOperationMutation, UpdateYaraRuleOperationMutationVariables>(UpdateYaraRuleOperationDocument, options);
      }
export type UpdateYaraRuleOperationMutationHookResult = ReturnType<typeof useUpdateYaraRuleOperationMutation>;
export type UpdateYaraRuleOperationMutationResult = Apollo.MutationResult<UpdateYaraRuleOperationMutation>;
export type UpdateYaraRuleOperationMutationOptions = Apollo.BaseMutationOptions<UpdateYaraRuleOperationMutation, UpdateYaraRuleOperationMutationVariables>;
export const YaraRulesSearchOperationDocument = gql`
    query YaraRulesSearchOperation($offset: Int, $limit: Int, $sort: YaraRuleSortableField!, $sortDir: SortDir!, $q: String!) {
  yaraRules(
    offset: $offset
    limit: $limit
    sort: [{field: $sort, direction: $sortDir}]
    q: $q
  ) {
    total
    hasNextPage
    objects {
      ...SearchYaraRule
    }
  }
}
    ${SearchYaraRuleFragmentDoc}`;

/**
 * __useYaraRulesSearchOperationQuery__
 *
 * To run a query within a React component, call `useYaraRulesSearchOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useYaraRulesSearchOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYaraRulesSearchOperationQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useYaraRulesSearchOperationQuery(baseOptions: Apollo.QueryHookOptions<YaraRulesSearchOperationQuery, YaraRulesSearchOperationQueryVariables> & ({ variables: YaraRulesSearchOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YaraRulesSearchOperationQuery, YaraRulesSearchOperationQueryVariables>(YaraRulesSearchOperationDocument, options);
      }
export function useYaraRulesSearchOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YaraRulesSearchOperationQuery, YaraRulesSearchOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YaraRulesSearchOperationQuery, YaraRulesSearchOperationQueryVariables>(YaraRulesSearchOperationDocument, options);
        }
export function useYaraRulesSearchOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<YaraRulesSearchOperationQuery, YaraRulesSearchOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<YaraRulesSearchOperationQuery, YaraRulesSearchOperationQueryVariables>(YaraRulesSearchOperationDocument, options);
        }
export type YaraRulesSearchOperationQueryHookResult = ReturnType<typeof useYaraRulesSearchOperationQuery>;
export type YaraRulesSearchOperationLazyQueryHookResult = ReturnType<typeof useYaraRulesSearchOperationLazyQuery>;
export type YaraRulesSearchOperationSuspenseQueryHookResult = ReturnType<typeof useYaraRulesSearchOperationSuspenseQuery>;
export type YaraRulesSearchOperationQueryResult = Apollo.QueryResult<YaraRulesSearchOperationQuery, YaraRulesSearchOperationQueryVariables>;
export const DeleteYaraSourceOperationDocument = gql`
    mutation DeleteYaraSourceOperation($id: ID!) {
  deleteYaraSource(id: $id) {
    ok
  }
}
    `;
export type DeleteYaraSourceOperationMutationFn = Apollo.MutationFunction<DeleteYaraSourceOperationMutation, DeleteYaraSourceOperationMutationVariables>;

/**
 * __useDeleteYaraSourceOperationMutation__
 *
 * To run a mutation, you first call `useDeleteYaraSourceOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteYaraSourceOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteYaraSourceOperationMutation, { data, loading, error }] = useDeleteYaraSourceOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteYaraSourceOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteYaraSourceOperationMutation, DeleteYaraSourceOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteYaraSourceOperationMutation, DeleteYaraSourceOperationMutationVariables>(DeleteYaraSourceOperationDocument, options);
      }
export type DeleteYaraSourceOperationMutationHookResult = ReturnType<typeof useDeleteYaraSourceOperationMutation>;
export type DeleteYaraSourceOperationMutationResult = Apollo.MutationResult<DeleteYaraSourceOperationMutation>;
export type DeleteYaraSourceOperationMutationOptions = Apollo.BaseMutationOptions<DeleteYaraSourceOperationMutation, DeleteYaraSourceOperationMutationVariables>;
export const YaraSourceDetailOperationDocument = gql`
    query YaraSourceDetailOperation($id: ID!) {
  yaraSource(id: $id) {
    ...YaraSource
  }
}
    ${YaraSourceFragmentDoc}`;

/**
 * __useYaraSourceDetailOperationQuery__
 *
 * To run a query within a React component, call `useYaraSourceDetailOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useYaraSourceDetailOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYaraSourceDetailOperationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useYaraSourceDetailOperationQuery(baseOptions: Apollo.QueryHookOptions<YaraSourceDetailOperationQuery, YaraSourceDetailOperationQueryVariables> & ({ variables: YaraSourceDetailOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YaraSourceDetailOperationQuery, YaraSourceDetailOperationQueryVariables>(YaraSourceDetailOperationDocument, options);
      }
export function useYaraSourceDetailOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YaraSourceDetailOperationQuery, YaraSourceDetailOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YaraSourceDetailOperationQuery, YaraSourceDetailOperationQueryVariables>(YaraSourceDetailOperationDocument, options);
        }
export function useYaraSourceDetailOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<YaraSourceDetailOperationQuery, YaraSourceDetailOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<YaraSourceDetailOperationQuery, YaraSourceDetailOperationQueryVariables>(YaraSourceDetailOperationDocument, options);
        }
export type YaraSourceDetailOperationQueryHookResult = ReturnType<typeof useYaraSourceDetailOperationQuery>;
export type YaraSourceDetailOperationLazyQueryHookResult = ReturnType<typeof useYaraSourceDetailOperationLazyQuery>;
export type YaraSourceDetailOperationSuspenseQueryHookResult = ReturnType<typeof useYaraSourceDetailOperationSuspenseQuery>;
export type YaraSourceDetailOperationQueryResult = Apollo.QueryResult<YaraSourceDetailOperationQuery, YaraSourceDetailOperationQueryVariables>;
export const YaraRulesOperationDocument = gql`
    query YaraRulesOperation($sourceIds: [String!], $offset: Int, $limit: Int, $sort: YaraRuleSortableField!, $sortDir: SortDir!, $q: String!) {
  yaraRules(
    sourceIds: $sourceIds
    offset: $offset
    limit: $limit
    sort: [{field: $sort, direction: $sortDir}]
    q: $q
  ) {
    total
    hasNextPage
    objects {
      ...YaraRule
    }
  }
}
    ${YaraRuleFragmentDoc}`;

/**
 * __useYaraRulesOperationQuery__
 *
 * To run a query within a React component, call `useYaraRulesOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useYaraRulesOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYaraRulesOperationQuery({
 *   variables: {
 *      sourceIds: // value for 'sourceIds'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useYaraRulesOperationQuery(baseOptions: Apollo.QueryHookOptions<YaraRulesOperationQuery, YaraRulesOperationQueryVariables> & ({ variables: YaraRulesOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YaraRulesOperationQuery, YaraRulesOperationQueryVariables>(YaraRulesOperationDocument, options);
      }
export function useYaraRulesOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YaraRulesOperationQuery, YaraRulesOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YaraRulesOperationQuery, YaraRulesOperationQueryVariables>(YaraRulesOperationDocument, options);
        }
export function useYaraRulesOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<YaraRulesOperationQuery, YaraRulesOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<YaraRulesOperationQuery, YaraRulesOperationQueryVariables>(YaraRulesOperationDocument, options);
        }
export type YaraRulesOperationQueryHookResult = ReturnType<typeof useYaraRulesOperationQuery>;
export type YaraRulesOperationLazyQueryHookResult = ReturnType<typeof useYaraRulesOperationLazyQuery>;
export type YaraRulesOperationSuspenseQueryHookResult = ReturnType<typeof useYaraRulesOperationSuspenseQuery>;
export type YaraRulesOperationQueryResult = Apollo.QueryResult<YaraRulesOperationQuery, YaraRulesOperationQueryVariables>;
export const CreateCustomYaraSourceOperationDocument = gql`
    mutation CreateCustomYaraSourceOperation($fields: CustomYaraSourceFields!) {
  createCustomYaraSource(fields: $fields) {
    data {
      ...YaraSource
    }
  }
}
    ${YaraSourceFragmentDoc}`;
export type CreateCustomYaraSourceOperationMutationFn = Apollo.MutationFunction<CreateCustomYaraSourceOperationMutation, CreateCustomYaraSourceOperationMutationVariables>;

/**
 * __useCreateCustomYaraSourceOperationMutation__
 *
 * To run a mutation, you first call `useCreateCustomYaraSourceOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomYaraSourceOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomYaraSourceOperationMutation, { data, loading, error }] = useCreateCustomYaraSourceOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateCustomYaraSourceOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomYaraSourceOperationMutation, CreateCustomYaraSourceOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomYaraSourceOperationMutation, CreateCustomYaraSourceOperationMutationVariables>(CreateCustomYaraSourceOperationDocument, options);
      }
export type CreateCustomYaraSourceOperationMutationHookResult = ReturnType<typeof useCreateCustomYaraSourceOperationMutation>;
export type CreateCustomYaraSourceOperationMutationResult = Apollo.MutationResult<CreateCustomYaraSourceOperationMutation>;
export type CreateCustomYaraSourceOperationMutationOptions = Apollo.BaseMutationOptions<CreateCustomYaraSourceOperationMutation, CreateCustomYaraSourceOperationMutationVariables>;
export const UpdateCustomYaraSourceOperationDocument = gql`
    mutation UpdateCustomYaraSourceOperation($id: ID!, $fields: UpdatableCustomYaraSourceFields!) {
  updateCustomYaraSource(id: $id, fields: $fields) {
    data {
      ...YaraSource
    }
  }
}
    ${YaraSourceFragmentDoc}`;
export type UpdateCustomYaraSourceOperationMutationFn = Apollo.MutationFunction<UpdateCustomYaraSourceOperationMutation, UpdateCustomYaraSourceOperationMutationVariables>;

/**
 * __useUpdateCustomYaraSourceOperationMutation__
 *
 * To run a mutation, you first call `useUpdateCustomYaraSourceOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomYaraSourceOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomYaraSourceOperationMutation, { data, loading, error }] = useUpdateCustomYaraSourceOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateCustomYaraSourceOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomYaraSourceOperationMutation, UpdateCustomYaraSourceOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomYaraSourceOperationMutation, UpdateCustomYaraSourceOperationMutationVariables>(UpdateCustomYaraSourceOperationDocument, options);
      }
export type UpdateCustomYaraSourceOperationMutationHookResult = ReturnType<typeof useUpdateCustomYaraSourceOperationMutation>;
export type UpdateCustomYaraSourceOperationMutationResult = Apollo.MutationResult<UpdateCustomYaraSourceOperationMutation>;
export type UpdateCustomYaraSourceOperationMutationOptions = Apollo.BaseMutationOptions<UpdateCustomYaraSourceOperationMutation, UpdateCustomYaraSourceOperationMutationVariables>;
export const CreateGithubYaraSourceOperationDocument = gql`
    mutation CreateGithubYaraSourceOperation($fields: GithubYaraSourceFields!) {
  createGithubYaraSource(fields: $fields) {
    data {
      ...YaraSource
    }
  }
}
    ${YaraSourceFragmentDoc}`;
export type CreateGithubYaraSourceOperationMutationFn = Apollo.MutationFunction<CreateGithubYaraSourceOperationMutation, CreateGithubYaraSourceOperationMutationVariables>;

/**
 * __useCreateGithubYaraSourceOperationMutation__
 *
 * To run a mutation, you first call `useCreateGithubYaraSourceOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGithubYaraSourceOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGithubYaraSourceOperationMutation, { data, loading, error }] = useCreateGithubYaraSourceOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateGithubYaraSourceOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateGithubYaraSourceOperationMutation, CreateGithubYaraSourceOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGithubYaraSourceOperationMutation, CreateGithubYaraSourceOperationMutationVariables>(CreateGithubYaraSourceOperationDocument, options);
      }
export type CreateGithubYaraSourceOperationMutationHookResult = ReturnType<typeof useCreateGithubYaraSourceOperationMutation>;
export type CreateGithubYaraSourceOperationMutationResult = Apollo.MutationResult<CreateGithubYaraSourceOperationMutation>;
export type CreateGithubYaraSourceOperationMutationOptions = Apollo.BaseMutationOptions<CreateGithubYaraSourceOperationMutation, CreateGithubYaraSourceOperationMutationVariables>;
export const UpdateGithubYaraSourceOperationDocument = gql`
    mutation UpdateGithubYaraSourceOperation($id: ID!, $fields: UpdatableGithubYaraSourceFields!) {
  updateGithubYaraSource(id: $id, fields: $fields) {
    data {
      ...YaraSource
    }
  }
}
    ${YaraSourceFragmentDoc}`;
export type UpdateGithubYaraSourceOperationMutationFn = Apollo.MutationFunction<UpdateGithubYaraSourceOperationMutation, UpdateGithubYaraSourceOperationMutationVariables>;

/**
 * __useUpdateGithubYaraSourceOperationMutation__
 *
 * To run a mutation, you first call `useUpdateGithubYaraSourceOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGithubYaraSourceOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGithubYaraSourceOperationMutation, { data, loading, error }] = useUpdateGithubYaraSourceOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateGithubYaraSourceOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGithubYaraSourceOperationMutation, UpdateGithubYaraSourceOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGithubYaraSourceOperationMutation, UpdateGithubYaraSourceOperationMutationVariables>(UpdateGithubYaraSourceOperationDocument, options);
      }
export type UpdateGithubYaraSourceOperationMutationHookResult = ReturnType<typeof useUpdateGithubYaraSourceOperationMutation>;
export type UpdateGithubYaraSourceOperationMutationResult = Apollo.MutationResult<UpdateGithubYaraSourceOperationMutation>;
export type UpdateGithubYaraSourceOperationMutationOptions = Apollo.BaseMutationOptions<UpdateGithubYaraSourceOperationMutation, UpdateGithubYaraSourceOperationMutationVariables>;
export const YaraSourceEditorOperationDocument = gql`
    query YaraSourceEditorOperation($id: ID!) {
  yaraSource(id: $id) {
    ...YaraSource
  }
}
    ${YaraSourceFragmentDoc}`;

/**
 * __useYaraSourceEditorOperationQuery__
 *
 * To run a query within a React component, call `useYaraSourceEditorOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useYaraSourceEditorOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYaraSourceEditorOperationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useYaraSourceEditorOperationQuery(baseOptions: Apollo.QueryHookOptions<YaraSourceEditorOperationQuery, YaraSourceEditorOperationQueryVariables> & ({ variables: YaraSourceEditorOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YaraSourceEditorOperationQuery, YaraSourceEditorOperationQueryVariables>(YaraSourceEditorOperationDocument, options);
      }
export function useYaraSourceEditorOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YaraSourceEditorOperationQuery, YaraSourceEditorOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YaraSourceEditorOperationQuery, YaraSourceEditorOperationQueryVariables>(YaraSourceEditorOperationDocument, options);
        }
export function useYaraSourceEditorOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<YaraSourceEditorOperationQuery, YaraSourceEditorOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<YaraSourceEditorOperationQuery, YaraSourceEditorOperationQueryVariables>(YaraSourceEditorOperationDocument, options);
        }
export type YaraSourceEditorOperationQueryHookResult = ReturnType<typeof useYaraSourceEditorOperationQuery>;
export type YaraSourceEditorOperationLazyQueryHookResult = ReturnType<typeof useYaraSourceEditorOperationLazyQuery>;
export type YaraSourceEditorOperationSuspenseQueryHookResult = ReturnType<typeof useYaraSourceEditorOperationSuspenseQuery>;
export type YaraSourceEditorOperationQueryResult = Apollo.QueryResult<YaraSourceEditorOperationQuery, YaraSourceEditorOperationQueryVariables>;
export const YaraSourcesOperationDocument = gql`
    query YaraSourcesOperation($offset: Int!, $limit: Int!, $sort: String!, $sortDir: SortDir!) {
  yaraSources(offset: $offset, limit: $limit, sort: $sort, sortDir: $sortDir) {
    total
    hasNextPage
    objects {
      ...YaraSource
    }
  }
}
    ${YaraSourceFragmentDoc}`;

/**
 * __useYaraSourcesOperationQuery__
 *
 * To run a query within a React component, call `useYaraSourcesOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useYaraSourcesOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useYaraSourcesOperationQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useYaraSourcesOperationQuery(baseOptions: Apollo.QueryHookOptions<YaraSourcesOperationQuery, YaraSourcesOperationQueryVariables> & ({ variables: YaraSourcesOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<YaraSourcesOperationQuery, YaraSourcesOperationQueryVariables>(YaraSourcesOperationDocument, options);
      }
export function useYaraSourcesOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<YaraSourcesOperationQuery, YaraSourcesOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<YaraSourcesOperationQuery, YaraSourcesOperationQueryVariables>(YaraSourcesOperationDocument, options);
        }
export function useYaraSourcesOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<YaraSourcesOperationQuery, YaraSourcesOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<YaraSourcesOperationQuery, YaraSourcesOperationQueryVariables>(YaraSourcesOperationDocument, options);
        }
export type YaraSourcesOperationQueryHookResult = ReturnType<typeof useYaraSourcesOperationQuery>;
export type YaraSourcesOperationLazyQueryHookResult = ReturnType<typeof useYaraSourcesOperationLazyQuery>;
export type YaraSourcesOperationSuspenseQueryHookResult = ReturnType<typeof useYaraSourcesOperationSuspenseQuery>;
export type YaraSourcesOperationQueryResult = Apollo.QueryResult<YaraSourcesOperationQuery, YaraSourcesOperationQueryVariables>;
export const DeleteYaraRuleOperationDocument = gql`
    mutation DeleteYaraRuleOperation($id: ID!) {
  deleteCustomYaraRule(id: $id) {
    ok
  }
}
    `;
export type DeleteYaraRuleOperationMutationFn = Apollo.MutationFunction<DeleteYaraRuleOperationMutation, DeleteYaraRuleOperationMutationVariables>;

/**
 * __useDeleteYaraRuleOperationMutation__
 *
 * To run a mutation, you first call `useDeleteYaraRuleOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteYaraRuleOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteYaraRuleOperationMutation, { data, loading, error }] = useDeleteYaraRuleOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteYaraRuleOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteYaraRuleOperationMutation, DeleteYaraRuleOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteYaraRuleOperationMutation, DeleteYaraRuleOperationMutationVariables>(DeleteYaraRuleOperationDocument, options);
      }
export type DeleteYaraRuleOperationMutationHookResult = ReturnType<typeof useDeleteYaraRuleOperationMutation>;
export type DeleteYaraRuleOperationMutationResult = Apollo.MutationResult<DeleteYaraRuleOperationMutation>;
export type DeleteYaraRuleOperationMutationOptions = Apollo.BaseMutationOptions<DeleteYaraRuleOperationMutation, DeleteYaraRuleOperationMutationVariables>;
export const DeleteCustomMatchListColumnOperationDocument = gql`
    mutation DeleteCustomMatchListColumnOperation($id: ID!) {
  deleteCustomMatchListColumn(id: $id) {
    ok
  }
}
    `;
export type DeleteCustomMatchListColumnOperationMutationFn = Apollo.MutationFunction<DeleteCustomMatchListColumnOperationMutation, DeleteCustomMatchListColumnOperationMutationVariables>;

/**
 * __useDeleteCustomMatchListColumnOperationMutation__
 *
 * To run a mutation, you first call `useDeleteCustomMatchListColumnOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomMatchListColumnOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomMatchListColumnOperationMutation, { data, loading, error }] = useDeleteCustomMatchListColumnOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCustomMatchListColumnOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomMatchListColumnOperationMutation, DeleteCustomMatchListColumnOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomMatchListColumnOperationMutation, DeleteCustomMatchListColumnOperationMutationVariables>(DeleteCustomMatchListColumnOperationDocument, options);
      }
export type DeleteCustomMatchListColumnOperationMutationHookResult = ReturnType<typeof useDeleteCustomMatchListColumnOperationMutation>;
export type DeleteCustomMatchListColumnOperationMutationResult = Apollo.MutationResult<DeleteCustomMatchListColumnOperationMutation>;
export type DeleteCustomMatchListColumnOperationMutationOptions = Apollo.BaseMutationOptions<DeleteCustomMatchListColumnOperationMutation, DeleteCustomMatchListColumnOperationMutationVariables>;
export const CreateCustomMatchListColumnOperationDocument = gql`
    mutation CreateCustomMatchListColumnOperation($fields: CustomMatchListColumnFields!) {
  createCustomMatchListColumn(fields: $fields) {
    data {
      id
      name
      fields
    }
  }
}
    `;
export type CreateCustomMatchListColumnOperationMutationFn = Apollo.MutationFunction<CreateCustomMatchListColumnOperationMutation, CreateCustomMatchListColumnOperationMutationVariables>;

/**
 * __useCreateCustomMatchListColumnOperationMutation__
 *
 * To run a mutation, you first call `useCreateCustomMatchListColumnOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomMatchListColumnOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomMatchListColumnOperationMutation, { data, loading, error }] = useCreateCustomMatchListColumnOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateCustomMatchListColumnOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomMatchListColumnOperationMutation, CreateCustomMatchListColumnOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomMatchListColumnOperationMutation, CreateCustomMatchListColumnOperationMutationVariables>(CreateCustomMatchListColumnOperationDocument, options);
      }
export type CreateCustomMatchListColumnOperationMutationHookResult = ReturnType<typeof useCreateCustomMatchListColumnOperationMutation>;
export type CreateCustomMatchListColumnOperationMutationResult = Apollo.MutationResult<CreateCustomMatchListColumnOperationMutation>;
export type CreateCustomMatchListColumnOperationMutationOptions = Apollo.BaseMutationOptions<CreateCustomMatchListColumnOperationMutation, CreateCustomMatchListColumnOperationMutationVariables>;
export const UpdateCustomMatchListColumnOperationDocument = gql`
    mutation UpdateCustomMatchListColumnOperation($id: ID!, $fields: CustomMatchListColumnFields!) {
  updateCustomMatchListColumn(id: $id, fields: $fields) {
    data {
      id
      name
      fields
    }
  }
}
    `;
export type UpdateCustomMatchListColumnOperationMutationFn = Apollo.MutationFunction<UpdateCustomMatchListColumnOperationMutation, UpdateCustomMatchListColumnOperationMutationVariables>;

/**
 * __useUpdateCustomMatchListColumnOperationMutation__
 *
 * To run a mutation, you first call `useUpdateCustomMatchListColumnOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomMatchListColumnOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomMatchListColumnOperationMutation, { data, loading, error }] = useUpdateCustomMatchListColumnOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateCustomMatchListColumnOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomMatchListColumnOperationMutation, UpdateCustomMatchListColumnOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomMatchListColumnOperationMutation, UpdateCustomMatchListColumnOperationMutationVariables>(UpdateCustomMatchListColumnOperationDocument, options);
      }
export type UpdateCustomMatchListColumnOperationMutationHookResult = ReturnType<typeof useUpdateCustomMatchListColumnOperationMutation>;
export type UpdateCustomMatchListColumnOperationMutationResult = Apollo.MutationResult<UpdateCustomMatchListColumnOperationMutation>;
export type UpdateCustomMatchListColumnOperationMutationOptions = Apollo.BaseMutationOptions<UpdateCustomMatchListColumnOperationMutation, UpdateCustomMatchListColumnOperationMutationVariables>;
export const UploadItemsToListOperationDocument = gql`
    mutation UploadItemsToListOperation($listId: String!, $expiration: DateTime, $file: Upload!) {
  uploadItemsToList(listId: $listId, expiration: $expiration, file: $file) {
    uploadedItemCount
  }
}
    `;
export type UploadItemsToListOperationMutationFn = Apollo.MutationFunction<UploadItemsToListOperationMutation, UploadItemsToListOperationMutationVariables>;

/**
 * __useUploadItemsToListOperationMutation__
 *
 * To run a mutation, you first call `useUploadItemsToListOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadItemsToListOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadItemsToListOperationMutation, { data, loading, error }] = useUploadItemsToListOperationMutation({
 *   variables: {
 *      listId: // value for 'listId'
 *      expiration: // value for 'expiration'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadItemsToListOperationMutation(baseOptions?: Apollo.MutationHookOptions<UploadItemsToListOperationMutation, UploadItemsToListOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadItemsToListOperationMutation, UploadItemsToListOperationMutationVariables>(UploadItemsToListOperationDocument, options);
      }
export type UploadItemsToListOperationMutationHookResult = ReturnType<typeof useUploadItemsToListOperationMutation>;
export type UploadItemsToListOperationMutationResult = Apollo.MutationResult<UploadItemsToListOperationMutation>;
export type UploadItemsToListOperationMutationOptions = Apollo.BaseMutationOptions<UploadItemsToListOperationMutation, UploadItemsToListOperationMutationVariables>;
export const MatchListsOperationDocument = gql`
    query MatchListsOperation($offset: Int!, $limit: Int!, $sort: String!, $sortDir: SortDir!) {
  matchLists(offset: $offset, limit: $limit, sort: $sort, sortDir: $sortDir) {
    total
    hasNextPage
    objects {
      ...MatchList
    }
  }
  matchListItemLimit
  matchListItemCount
}
    ${MatchListFragmentDoc}`;

/**
 * __useMatchListsOperationQuery__
 *
 * To run a query within a React component, call `useMatchListsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchListsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchListsOperationQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useMatchListsOperationQuery(baseOptions: Apollo.QueryHookOptions<MatchListsOperationQuery, MatchListsOperationQueryVariables> & ({ variables: MatchListsOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchListsOperationQuery, MatchListsOperationQueryVariables>(MatchListsOperationDocument, options);
      }
export function useMatchListsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchListsOperationQuery, MatchListsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchListsOperationQuery, MatchListsOperationQueryVariables>(MatchListsOperationDocument, options);
        }
export function useMatchListsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchListsOperationQuery, MatchListsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchListsOperationQuery, MatchListsOperationQueryVariables>(MatchListsOperationDocument, options);
        }
export type MatchListsOperationQueryHookResult = ReturnType<typeof useMatchListsOperationQuery>;
export type MatchListsOperationLazyQueryHookResult = ReturnType<typeof useMatchListsOperationLazyQuery>;
export type MatchListsOperationSuspenseQueryHookResult = ReturnType<typeof useMatchListsOperationSuspenseQuery>;
export type MatchListsOperationQueryResult = Apollo.QueryResult<MatchListsOperationQuery, MatchListsOperationQueryVariables>;
export const DeleteMatchListOperationDocument = gql`
    mutation DeleteMatchListOperation($id: ID!) {
  deleteMatchList(id: $id) {
    ok
  }
}
    `;
export type DeleteMatchListOperationMutationFn = Apollo.MutationFunction<DeleteMatchListOperationMutation, DeleteMatchListOperationMutationVariables>;

/**
 * __useDeleteMatchListOperationMutation__
 *
 * To run a mutation, you first call `useDeleteMatchListOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMatchListOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMatchListOperationMutation, { data, loading, error }] = useDeleteMatchListOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMatchListOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMatchListOperationMutation, DeleteMatchListOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMatchListOperationMutation, DeleteMatchListOperationMutationVariables>(DeleteMatchListOperationDocument, options);
      }
export type DeleteMatchListOperationMutationHookResult = ReturnType<typeof useDeleteMatchListOperationMutation>;
export type DeleteMatchListOperationMutationResult = Apollo.MutationResult<DeleteMatchListOperationMutation>;
export type DeleteMatchListOperationMutationOptions = Apollo.BaseMutationOptions<DeleteMatchListOperationMutation, DeleteMatchListOperationMutationVariables>;
export const CreateMatchListOperationDocument = gql`
    mutation CreateMatchListOperation($fields: MatchListFields!) {
  createMatchList(fields: $fields) {
    data {
      ...MatchList
    }
  }
}
    ${MatchListFragmentDoc}`;
export type CreateMatchListOperationMutationFn = Apollo.MutationFunction<CreateMatchListOperationMutation, CreateMatchListOperationMutationVariables>;

/**
 * __useCreateMatchListOperationMutation__
 *
 * To run a mutation, you first call `useCreateMatchListOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMatchListOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMatchListOperationMutation, { data, loading, error }] = useCreateMatchListOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateMatchListOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateMatchListOperationMutation, CreateMatchListOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMatchListOperationMutation, CreateMatchListOperationMutationVariables>(CreateMatchListOperationDocument, options);
      }
export type CreateMatchListOperationMutationHookResult = ReturnType<typeof useCreateMatchListOperationMutation>;
export type CreateMatchListOperationMutationResult = Apollo.MutationResult<CreateMatchListOperationMutation>;
export type CreateMatchListOperationMutationOptions = Apollo.BaseMutationOptions<CreateMatchListOperationMutation, CreateMatchListOperationMutationVariables>;
export const UpdateMatchListOperationDocument = gql`
    mutation UpdateMatchListOperation($id: ID!, $fields: UpdatableMatchListFields!) {
  updateMatchList(id: $id, fields: $fields) {
    data {
      ...MatchList
    }
  }
}
    ${MatchListFragmentDoc}`;
export type UpdateMatchListOperationMutationFn = Apollo.MutationFunction<UpdateMatchListOperationMutation, UpdateMatchListOperationMutationVariables>;

/**
 * __useUpdateMatchListOperationMutation__
 *
 * To run a mutation, you first call `useUpdateMatchListOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMatchListOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMatchListOperationMutation, { data, loading, error }] = useUpdateMatchListOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateMatchListOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMatchListOperationMutation, UpdateMatchListOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMatchListOperationMutation, UpdateMatchListOperationMutationVariables>(UpdateMatchListOperationDocument, options);
      }
export type UpdateMatchListOperationMutationHookResult = ReturnType<typeof useUpdateMatchListOperationMutation>;
export type UpdateMatchListOperationMutationResult = Apollo.MutationResult<UpdateMatchListOperationMutation>;
export type UpdateMatchListOperationMutationOptions = Apollo.BaseMutationOptions<UpdateMatchListOperationMutation, UpdateMatchListOperationMutationVariables>;
export const AddMatchListItemOperationDocument = gql`
    mutation AddMatchListItemOperation($itemFields: MatchListItemFields!, $listId: ID!) {
  addItemToMatchList(itemFields: $itemFields, listId: $listId) {
    data {
      ...MatchListItem
    }
    finishedProcessing
  }
}
    ${MatchListItemFragmentDoc}`;
export type AddMatchListItemOperationMutationFn = Apollo.MutationFunction<AddMatchListItemOperationMutation, AddMatchListItemOperationMutationVariables>;

/**
 * __useAddMatchListItemOperationMutation__
 *
 * To run a mutation, you first call `useAddMatchListItemOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMatchListItemOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMatchListItemOperationMutation, { data, loading, error }] = useAddMatchListItemOperationMutation({
 *   variables: {
 *      itemFields: // value for 'itemFields'
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useAddMatchListItemOperationMutation(baseOptions?: Apollo.MutationHookOptions<AddMatchListItemOperationMutation, AddMatchListItemOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMatchListItemOperationMutation, AddMatchListItemOperationMutationVariables>(AddMatchListItemOperationDocument, options);
      }
export type AddMatchListItemOperationMutationHookResult = ReturnType<typeof useAddMatchListItemOperationMutation>;
export type AddMatchListItemOperationMutationResult = Apollo.MutationResult<AddMatchListItemOperationMutation>;
export type AddMatchListItemOperationMutationOptions = Apollo.BaseMutationOptions<AddMatchListItemOperationMutation, AddMatchListItemOperationMutationVariables>;
export const UpdateMatchListItemOperationDocument = gql`
    mutation UpdateMatchListItemOperation($id: ID!, $fields: UpdatableMatchListItemFields!) {
  updateMatchListItem(id: $id, fields: $fields) {
    data {
      ...MatchListItem
    }
    finishedProcessing
  }
}
    ${MatchListItemFragmentDoc}`;
export type UpdateMatchListItemOperationMutationFn = Apollo.MutationFunction<UpdateMatchListItemOperationMutation, UpdateMatchListItemOperationMutationVariables>;

/**
 * __useUpdateMatchListItemOperationMutation__
 *
 * To run a mutation, you first call `useUpdateMatchListItemOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMatchListItemOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMatchListItemOperationMutation, { data, loading, error }] = useUpdateMatchListItemOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateMatchListItemOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMatchListItemOperationMutation, UpdateMatchListItemOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMatchListItemOperationMutation, UpdateMatchListItemOperationMutationVariables>(UpdateMatchListItemOperationDocument, options);
      }
export type UpdateMatchListItemOperationMutationHookResult = ReturnType<typeof useUpdateMatchListItemOperationMutation>;
export type UpdateMatchListItemOperationMutationResult = Apollo.MutationResult<UpdateMatchListItemOperationMutation>;
export type UpdateMatchListItemOperationMutationOptions = Apollo.BaseMutationOptions<UpdateMatchListItemOperationMutation, UpdateMatchListItemOperationMutationVariables>;
export const DeleteMatchListItemOperationDocument = gql`
    mutation DeleteMatchListItemOperation($id: ID!) {
  deleteMatchListItem(id: $id) {
    ok
  }
}
    `;
export type DeleteMatchListItemOperationMutationFn = Apollo.MutationFunction<DeleteMatchListItemOperationMutation, DeleteMatchListItemOperationMutationVariables>;

/**
 * __useDeleteMatchListItemOperationMutation__
 *
 * To run a mutation, you first call `useDeleteMatchListItemOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMatchListItemOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMatchListItemOperationMutation, { data, loading, error }] = useDeleteMatchListItemOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMatchListItemOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMatchListItemOperationMutation, DeleteMatchListItemOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMatchListItemOperationMutation, DeleteMatchListItemOperationMutationVariables>(DeleteMatchListItemOperationDocument, options);
      }
export type DeleteMatchListItemOperationMutationHookResult = ReturnType<typeof useDeleteMatchListItemOperationMutation>;
export type DeleteMatchListItemOperationMutationResult = Apollo.MutationResult<DeleteMatchListItemOperationMutation>;
export type DeleteMatchListItemOperationMutationOptions = Apollo.BaseMutationOptions<DeleteMatchListItemOperationMutation, DeleteMatchListItemOperationMutationVariables>;
export const MatchListItemsOperationDocument = gql`
    query MatchListItemsOperation($listIds: [String!], $offset: Int, $limit: Int, $sort: MatchListItemSortableField!, $sortDir: SortDir!, $q: String!) {
  matchListItems: matchListItems2(
    listIds: $listIds
    offset: $offset
    limit: $limit
    sort: [{field: $sort, direction: $sortDir}]
    q: $q
  ) {
    total
    hasNextPage
    objects {
      ...MatchListItem
    }
  }
}
    ${MatchListItemFragmentDoc}`;

/**
 * __useMatchListItemsOperationQuery__
 *
 * To run a query within a React component, call `useMatchListItemsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchListItemsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchListItemsOperationQuery({
 *   variables: {
 *      listIds: // value for 'listIds'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useMatchListItemsOperationQuery(baseOptions: Apollo.QueryHookOptions<MatchListItemsOperationQuery, MatchListItemsOperationQueryVariables> & ({ variables: MatchListItemsOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchListItemsOperationQuery, MatchListItemsOperationQueryVariables>(MatchListItemsOperationDocument, options);
      }
export function useMatchListItemsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchListItemsOperationQuery, MatchListItemsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchListItemsOperationQuery, MatchListItemsOperationQueryVariables>(MatchListItemsOperationDocument, options);
        }
export function useMatchListItemsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchListItemsOperationQuery, MatchListItemsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchListItemsOperationQuery, MatchListItemsOperationQueryVariables>(MatchListItemsOperationDocument, options);
        }
export type MatchListItemsOperationQueryHookResult = ReturnType<typeof useMatchListItemsOperationQuery>;
export type MatchListItemsOperationLazyQueryHookResult = ReturnType<typeof useMatchListItemsOperationLazyQuery>;
export type MatchListItemsOperationSuspenseQueryHookResult = ReturnType<typeof useMatchListItemsOperationSuspenseQuery>;
export type MatchListItemsOperationQueryResult = Apollo.QueryResult<MatchListItemsOperationQuery, MatchListItemsOperationQueryVariables>;
export const MatchListDetailOperationDocument = gql`
    query MatchListDetailOperation($id: ID!) {
  matchList(id: $id) {
    ...MatchList
  }
}
    ${MatchListFragmentDoc}`;

/**
 * __useMatchListDetailOperationQuery__
 *
 * To run a query within a React component, call `useMatchListDetailOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchListDetailOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchListDetailOperationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMatchListDetailOperationQuery(baseOptions: Apollo.QueryHookOptions<MatchListDetailOperationQuery, MatchListDetailOperationQueryVariables> & ({ variables: MatchListDetailOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchListDetailOperationQuery, MatchListDetailOperationQueryVariables>(MatchListDetailOperationDocument, options);
      }
export function useMatchListDetailOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchListDetailOperationQuery, MatchListDetailOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchListDetailOperationQuery, MatchListDetailOperationQueryVariables>(MatchListDetailOperationDocument, options);
        }
export function useMatchListDetailOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchListDetailOperationQuery, MatchListDetailOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchListDetailOperationQuery, MatchListDetailOperationQueryVariables>(MatchListDetailOperationDocument, options);
        }
export type MatchListDetailOperationQueryHookResult = ReturnType<typeof useMatchListDetailOperationQuery>;
export type MatchListDetailOperationLazyQueryHookResult = ReturnType<typeof useMatchListDetailOperationLazyQuery>;
export type MatchListDetailOperationSuspenseQueryHookResult = ReturnType<typeof useMatchListDetailOperationSuspenseQuery>;
export type MatchListDetailOperationQueryResult = Apollo.QueryResult<MatchListDetailOperationQuery, MatchListDetailOperationQueryVariables>;
export const MatchListsSelectOperationDocument = gql`
    query MatchListsSelectOperation($offset: Int, $limit: Int, $sort: String!, $sortDir: SortDir!) {
  matchLists(offset: $offset, limit: $limit, sort: $sort, sortDir: $sortDir) {
    total
    objects {
      ...MatchListSelectFragment
    }
  }
}
    ${MatchListSelectFragmentDoc}`;

/**
 * __useMatchListsSelectOperationQuery__
 *
 * To run a query within a React component, call `useMatchListsSelectOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchListsSelectOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchListsSelectOperationQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useMatchListsSelectOperationQuery(baseOptions: Apollo.QueryHookOptions<MatchListsSelectOperationQuery, MatchListsSelectOperationQueryVariables> & ({ variables: MatchListsSelectOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchListsSelectOperationQuery, MatchListsSelectOperationQueryVariables>(MatchListsSelectOperationDocument, options);
      }
export function useMatchListsSelectOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchListsSelectOperationQuery, MatchListsSelectOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchListsSelectOperationQuery, MatchListsSelectOperationQueryVariables>(MatchListsSelectOperationDocument, options);
        }
export function useMatchListsSelectOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchListsSelectOperationQuery, MatchListsSelectOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchListsSelectOperationQuery, MatchListsSelectOperationQueryVariables>(MatchListsSelectOperationDocument, options);
        }
export type MatchListsSelectOperationQueryHookResult = ReturnType<typeof useMatchListsSelectOperationQuery>;
export type MatchListsSelectOperationLazyQueryHookResult = ReturnType<typeof useMatchListsSelectOperationLazyQuery>;
export type MatchListsSelectOperationSuspenseQueryHookResult = ReturnType<typeof useMatchListsSelectOperationSuspenseQuery>;
export type MatchListsSelectOperationQueryResult = Apollo.QueryResult<MatchListsSelectOperationQuery, MatchListsSelectOperationQueryVariables>;
export const NetworkBlocksOperationDocument = gql`
    query NetworkBlocksOperation($offset: Int!, $limit: Int!, $sort: NetworkBlockSortableField!, $sortDir: SortDir!, $q: String) {
  networkBlocks(
    offset: $offset
    limit: $limit
    sort: [{field: $sort, direction: $sortDir}]
    q: $q
  ) {
    total
    hasNextPage
    objects {
      ...NetworkBlock
    }
  }
}
    ${NetworkBlockFragmentDoc}`;

/**
 * __useNetworkBlocksOperationQuery__
 *
 * To run a query within a React component, call `useNetworkBlocksOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetworkBlocksOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetworkBlocksOperationQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useNetworkBlocksOperationQuery(baseOptions: Apollo.QueryHookOptions<NetworkBlocksOperationQuery, NetworkBlocksOperationQueryVariables> & ({ variables: NetworkBlocksOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NetworkBlocksOperationQuery, NetworkBlocksOperationQueryVariables>(NetworkBlocksOperationDocument, options);
      }
export function useNetworkBlocksOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NetworkBlocksOperationQuery, NetworkBlocksOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NetworkBlocksOperationQuery, NetworkBlocksOperationQueryVariables>(NetworkBlocksOperationDocument, options);
        }
export function useNetworkBlocksOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NetworkBlocksOperationQuery, NetworkBlocksOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NetworkBlocksOperationQuery, NetworkBlocksOperationQueryVariables>(NetworkBlocksOperationDocument, options);
        }
export type NetworkBlocksOperationQueryHookResult = ReturnType<typeof useNetworkBlocksOperationQuery>;
export type NetworkBlocksOperationLazyQueryHookResult = ReturnType<typeof useNetworkBlocksOperationLazyQuery>;
export type NetworkBlocksOperationSuspenseQueryHookResult = ReturnType<typeof useNetworkBlocksOperationSuspenseQuery>;
export type NetworkBlocksOperationQueryResult = Apollo.QueryResult<NetworkBlocksOperationQuery, NetworkBlocksOperationQueryVariables>;
export const CreateNetworkBlockOperationDocument = gql`
    mutation CreateNetworkBlockOperation($fields: NetworkBlockFields!) {
  createNetworkBlock(fields: $fields) {
    data {
      ...NetworkBlock
    }
  }
}
    ${NetworkBlockFragmentDoc}`;
export type CreateNetworkBlockOperationMutationFn = Apollo.MutationFunction<CreateNetworkBlockOperationMutation, CreateNetworkBlockOperationMutationVariables>;

/**
 * __useCreateNetworkBlockOperationMutation__
 *
 * To run a mutation, you first call `useCreateNetworkBlockOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNetworkBlockOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNetworkBlockOperationMutation, { data, loading, error }] = useCreateNetworkBlockOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateNetworkBlockOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateNetworkBlockOperationMutation, CreateNetworkBlockOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNetworkBlockOperationMutation, CreateNetworkBlockOperationMutationVariables>(CreateNetworkBlockOperationDocument, options);
      }
export type CreateNetworkBlockOperationMutationHookResult = ReturnType<typeof useCreateNetworkBlockOperationMutation>;
export type CreateNetworkBlockOperationMutationResult = Apollo.MutationResult<CreateNetworkBlockOperationMutation>;
export type CreateNetworkBlockOperationMutationOptions = Apollo.BaseMutationOptions<CreateNetworkBlockOperationMutation, CreateNetworkBlockOperationMutationVariables>;
export const UpdateNetworkBlockOperationDocument = gql`
    mutation UpdateNetworkBlockOperation($id: ID!, $fields: UpdatableNetworkBlockFields!) {
  updateNetworkBlock(id: $id, fields: $fields) {
    data {
      ...NetworkBlock
    }
  }
}
    ${NetworkBlockFragmentDoc}`;
export type UpdateNetworkBlockOperationMutationFn = Apollo.MutationFunction<UpdateNetworkBlockOperationMutation, UpdateNetworkBlockOperationMutationVariables>;

/**
 * __useUpdateNetworkBlockOperationMutation__
 *
 * To run a mutation, you first call `useUpdateNetworkBlockOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNetworkBlockOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNetworkBlockOperationMutation, { data, loading, error }] = useUpdateNetworkBlockOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateNetworkBlockOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNetworkBlockOperationMutation, UpdateNetworkBlockOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNetworkBlockOperationMutation, UpdateNetworkBlockOperationMutationVariables>(UpdateNetworkBlockOperationDocument, options);
      }
export type UpdateNetworkBlockOperationMutationHookResult = ReturnType<typeof useUpdateNetworkBlockOperationMutation>;
export type UpdateNetworkBlockOperationMutationResult = Apollo.MutationResult<UpdateNetworkBlockOperationMutation>;
export type UpdateNetworkBlockOperationMutationOptions = Apollo.BaseMutationOptions<UpdateNetworkBlockOperationMutation, UpdateNetworkBlockOperationMutationVariables>;
export const DeleteNetworkBlockOperationDocument = gql`
    mutation DeleteNetworkBlockOperation($id: ID!) {
  deleteNetworkBlock(id: $id) {
    ok
  }
}
    `;
export type DeleteNetworkBlockOperationMutationFn = Apollo.MutationFunction<DeleteNetworkBlockOperationMutation, DeleteNetworkBlockOperationMutationVariables>;

/**
 * __useDeleteNetworkBlockOperationMutation__
 *
 * To run a mutation, you first call `useDeleteNetworkBlockOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNetworkBlockOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNetworkBlockOperationMutation, { data, loading, error }] = useDeleteNetworkBlockOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNetworkBlockOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNetworkBlockOperationMutation, DeleteNetworkBlockOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNetworkBlockOperationMutation, DeleteNetworkBlockOperationMutationVariables>(DeleteNetworkBlockOperationDocument, options);
      }
export type DeleteNetworkBlockOperationMutationHookResult = ReturnType<typeof useDeleteNetworkBlockOperationMutation>;
export type DeleteNetworkBlockOperationMutationResult = Apollo.MutationResult<DeleteNetworkBlockOperationMutation>;
export type DeleteNetworkBlockOperationMutationOptions = Apollo.BaseMutationOptions<DeleteNetworkBlockOperationMutation, DeleteNetworkBlockOperationMutationVariables>;
export const UploadNetworkBlocksOperationDocument = gql`
    mutation UploadNetworkBlocksOperation($file: Upload!) {
  uploadNetworkBlocksCsv(file: $file) {
    uploadedNetworkBlockCount
  }
}
    `;
export type UploadNetworkBlocksOperationMutationFn = Apollo.MutationFunction<UploadNetworkBlocksOperationMutation, UploadNetworkBlocksOperationMutationVariables>;

/**
 * __useUploadNetworkBlocksOperationMutation__
 *
 * To run a mutation, you first call `useUploadNetworkBlocksOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadNetworkBlocksOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadNetworkBlocksOperationMutation, { data, loading, error }] = useUploadNetworkBlocksOperationMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadNetworkBlocksOperationMutation(baseOptions?: Apollo.MutationHookOptions<UploadNetworkBlocksOperationMutation, UploadNetworkBlocksOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadNetworkBlocksOperationMutation, UploadNetworkBlocksOperationMutationVariables>(UploadNetworkBlocksOperationDocument, options);
      }
export type UploadNetworkBlocksOperationMutationHookResult = ReturnType<typeof useUploadNetworkBlocksOperationMutation>;
export type UploadNetworkBlocksOperationMutationResult = Apollo.MutationResult<UploadNetworkBlocksOperationMutation>;
export type UploadNetworkBlocksOperationMutationOptions = Apollo.BaseMutationOptions<UploadNetworkBlocksOperationMutation, UploadNetworkBlocksOperationMutationVariables>;
export const RuleTuningExpressionsQueryOperationDocument = gql`
    query RuleTuningExpressionsQueryOperation($offset: Int, $limit: Int, $sort: RuleTuningExpressionSortableField!, $sortDir: SortDir!) {
  ruleTuningExpressions(
    offset: $offset
    limit: $limit
    sort: [{field: $sort, direction: $sortDir}]
  ) {
    total
    hasNextPage
    objects {
      ...RuleTuningExpression
    }
  }
}
    ${RuleTuningExpressionFragmentDoc}`;

/**
 * __useRuleTuningExpressionsQueryOperation__
 *
 * To run a query within a React component, call `useRuleTuningExpressionsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useRuleTuningExpressionsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleTuningExpressionsQueryOperation({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useRuleTuningExpressionsQueryOperation(baseOptions: Apollo.QueryHookOptions<RuleTuningExpressionsQueryOperationQuery, RuleTuningExpressionsQueryOperationQueryVariables> & ({ variables: RuleTuningExpressionsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RuleTuningExpressionsQueryOperationQuery, RuleTuningExpressionsQueryOperationQueryVariables>(RuleTuningExpressionsQueryOperationDocument, options);
      }
export function useRuleTuningExpressionsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuleTuningExpressionsQueryOperationQuery, RuleTuningExpressionsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RuleTuningExpressionsQueryOperationQuery, RuleTuningExpressionsQueryOperationQueryVariables>(RuleTuningExpressionsQueryOperationDocument, options);
        }
export function useRuleTuningExpressionsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RuleTuningExpressionsQueryOperationQuery, RuleTuningExpressionsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RuleTuningExpressionsQueryOperationQuery, RuleTuningExpressionsQueryOperationQueryVariables>(RuleTuningExpressionsQueryOperationDocument, options);
        }
export type RuleTuningExpressionsQueryOperationHookResult = ReturnType<typeof useRuleTuningExpressionsQueryOperation>;
export type RuleTuningExpressionsQueryOperationLazyQueryHookResult = ReturnType<typeof useRuleTuningExpressionsQueryOperationLazyQuery>;
export type RuleTuningExpressionsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useRuleTuningExpressionsQueryOperationSuspenseQuery>;
export type RuleTuningExpressionsQueryOperationQueryResult = Apollo.QueryResult<RuleTuningExpressionsQueryOperationQuery, RuleTuningExpressionsQueryOperationQueryVariables>;
export const RuleTuningExpressionQueryOperationDocument = gql`
    query RuleTuningExpressionQueryOperation($id: ID!) {
  ruleTuningExpression(id: $id) {
    ...RuleTuningExpression
  }
}
    ${RuleTuningExpressionFragmentDoc}`;

/**
 * __useRuleTuningExpressionQueryOperation__
 *
 * To run a query within a React component, call `useRuleTuningExpressionQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useRuleTuningExpressionQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleTuningExpressionQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRuleTuningExpressionQueryOperation(baseOptions: Apollo.QueryHookOptions<RuleTuningExpressionQueryOperationQuery, RuleTuningExpressionQueryOperationQueryVariables> & ({ variables: RuleTuningExpressionQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RuleTuningExpressionQueryOperationQuery, RuleTuningExpressionQueryOperationQueryVariables>(RuleTuningExpressionQueryOperationDocument, options);
      }
export function useRuleTuningExpressionQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuleTuningExpressionQueryOperationQuery, RuleTuningExpressionQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RuleTuningExpressionQueryOperationQuery, RuleTuningExpressionQueryOperationQueryVariables>(RuleTuningExpressionQueryOperationDocument, options);
        }
export function useRuleTuningExpressionQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RuleTuningExpressionQueryOperationQuery, RuleTuningExpressionQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RuleTuningExpressionQueryOperationQuery, RuleTuningExpressionQueryOperationQueryVariables>(RuleTuningExpressionQueryOperationDocument, options);
        }
export type RuleTuningExpressionQueryOperationHookResult = ReturnType<typeof useRuleTuningExpressionQueryOperation>;
export type RuleTuningExpressionQueryOperationLazyQueryHookResult = ReturnType<typeof useRuleTuningExpressionQueryOperationLazyQuery>;
export type RuleTuningExpressionQueryOperationSuspenseQueryHookResult = ReturnType<typeof useRuleTuningExpressionQueryOperationSuspenseQuery>;
export type RuleTuningExpressionQueryOperationQueryResult = Apollo.QueryResult<RuleTuningExpressionQueryOperationQuery, RuleTuningExpressionQueryOperationQueryVariables>;
export const CreateRuleTuningExpressionOperationDocument = gql`
    mutation CreateRuleTuningExpressionOperation($fields: CreateRuleTuningExpressionFields!) {
  createRuleTuningExpression(fields: $fields) {
    data {
      ...RuleTuningExpression
    }
  }
}
    ${RuleTuningExpressionFragmentDoc}`;
export type CreateRuleTuningExpressionOperationMutationFn = Apollo.MutationFunction<CreateRuleTuningExpressionOperationMutation, CreateRuleTuningExpressionOperationMutationVariables>;

/**
 * __useCreateRuleTuningExpressionOperationMutation__
 *
 * To run a mutation, you first call `useCreateRuleTuningExpressionOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRuleTuningExpressionOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRuleTuningExpressionOperationMutation, { data, loading, error }] = useCreateRuleTuningExpressionOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateRuleTuningExpressionOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateRuleTuningExpressionOperationMutation, CreateRuleTuningExpressionOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRuleTuningExpressionOperationMutation, CreateRuleTuningExpressionOperationMutationVariables>(CreateRuleTuningExpressionOperationDocument, options);
      }
export type CreateRuleTuningExpressionOperationMutationHookResult = ReturnType<typeof useCreateRuleTuningExpressionOperationMutation>;
export type CreateRuleTuningExpressionOperationMutationResult = Apollo.MutationResult<CreateRuleTuningExpressionOperationMutation>;
export type CreateRuleTuningExpressionOperationMutationOptions = Apollo.BaseMutationOptions<CreateRuleTuningExpressionOperationMutation, CreateRuleTuningExpressionOperationMutationVariables>;
export const UpdateRuleTuningExpressionOperationDocument = gql`
    mutation UpdateRuleTuningExpressionOperation($id: ID!, $fields: UpdateRuleTuningExpressionFields!) {
  updateRuleTuningExpression(id: $id, fields: $fields) {
    data {
      ...RuleTuningExpression
    }
  }
}
    ${RuleTuningExpressionFragmentDoc}`;
export type UpdateRuleTuningExpressionOperationMutationFn = Apollo.MutationFunction<UpdateRuleTuningExpressionOperationMutation, UpdateRuleTuningExpressionOperationMutationVariables>;

/**
 * __useUpdateRuleTuningExpressionOperationMutation__
 *
 * To run a mutation, you first call `useUpdateRuleTuningExpressionOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRuleTuningExpressionOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRuleTuningExpressionOperationMutation, { data, loading, error }] = useUpdateRuleTuningExpressionOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateRuleTuningExpressionOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRuleTuningExpressionOperationMutation, UpdateRuleTuningExpressionOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRuleTuningExpressionOperationMutation, UpdateRuleTuningExpressionOperationMutationVariables>(UpdateRuleTuningExpressionOperationDocument, options);
      }
export type UpdateRuleTuningExpressionOperationMutationHookResult = ReturnType<typeof useUpdateRuleTuningExpressionOperationMutation>;
export type UpdateRuleTuningExpressionOperationMutationResult = Apollo.MutationResult<UpdateRuleTuningExpressionOperationMutation>;
export type UpdateRuleTuningExpressionOperationMutationOptions = Apollo.BaseMutationOptions<UpdateRuleTuningExpressionOperationMutation, UpdateRuleTuningExpressionOperationMutationVariables>;
export const UpdateRuleTuningExpressionEnabledOperationDocument = gql`
    mutation UpdateRuleTuningExpressionEnabledOperation($id: ID!, $enabled: Boolean!) {
  updateRuleTuningExpressionEnabled(id: $id, enabled: $enabled) {
    ok
  }
}
    `;
export type UpdateRuleTuningExpressionEnabledOperationMutationFn = Apollo.MutationFunction<UpdateRuleTuningExpressionEnabledOperationMutation, UpdateRuleTuningExpressionEnabledOperationMutationVariables>;

/**
 * __useUpdateRuleTuningExpressionEnabledOperationMutation__
 *
 * To run a mutation, you first call `useUpdateRuleTuningExpressionEnabledOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRuleTuningExpressionEnabledOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRuleTuningExpressionEnabledOperationMutation, { data, loading, error }] = useUpdateRuleTuningExpressionEnabledOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUpdateRuleTuningExpressionEnabledOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRuleTuningExpressionEnabledOperationMutation, UpdateRuleTuningExpressionEnabledOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRuleTuningExpressionEnabledOperationMutation, UpdateRuleTuningExpressionEnabledOperationMutationVariables>(UpdateRuleTuningExpressionEnabledOperationDocument, options);
      }
export type UpdateRuleTuningExpressionEnabledOperationMutationHookResult = ReturnType<typeof useUpdateRuleTuningExpressionEnabledOperationMutation>;
export type UpdateRuleTuningExpressionEnabledOperationMutationResult = Apollo.MutationResult<UpdateRuleTuningExpressionEnabledOperationMutation>;
export type UpdateRuleTuningExpressionEnabledOperationMutationOptions = Apollo.BaseMutationOptions<UpdateRuleTuningExpressionEnabledOperationMutation, UpdateRuleTuningExpressionEnabledOperationMutationVariables>;
export const DeleteRuleTuningExpressionOperationDocument = gql`
    mutation DeleteRuleTuningExpressionOperation($id: ID!) {
  deleteRuleTuningExpression(id: $id) {
    ok
  }
}
    `;
export type DeleteRuleTuningExpressionOperationMutationFn = Apollo.MutationFunction<DeleteRuleTuningExpressionOperationMutation, DeleteRuleTuningExpressionOperationMutationVariables>;

/**
 * __useDeleteRuleTuningExpressionOperationMutation__
 *
 * To run a mutation, you first call `useDeleteRuleTuningExpressionOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRuleTuningExpressionOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRuleTuningExpressionOperationMutation, { data, loading, error }] = useDeleteRuleTuningExpressionOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRuleTuningExpressionOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRuleTuningExpressionOperationMutation, DeleteRuleTuningExpressionOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRuleTuningExpressionOperationMutation, DeleteRuleTuningExpressionOperationMutationVariables>(DeleteRuleTuningExpressionOperationDocument, options);
      }
export type DeleteRuleTuningExpressionOperationMutationHookResult = ReturnType<typeof useDeleteRuleTuningExpressionOperationMutation>;
export type DeleteRuleTuningExpressionOperationMutationResult = Apollo.MutationResult<DeleteRuleTuningExpressionOperationMutation>;
export type DeleteRuleTuningExpressionOperationMutationOptions = Apollo.BaseMutationOptions<DeleteRuleTuningExpressionOperationMutation, DeleteRuleTuningExpressionOperationMutationVariables>;
export const DeleteRuleOperationDocument = gql`
    mutation DeleteRuleOperation($id: ID!) {
  deleteRule(id: $id) {
    ok
  }
}
    `;
export type DeleteRuleOperationMutationFn = Apollo.MutationFunction<DeleteRuleOperationMutation, DeleteRuleOperationMutationVariables>;

/**
 * __useDeleteRuleOperationMutation__
 *
 * To run a mutation, you first call `useDeleteRuleOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRuleOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRuleOperationMutation, { data, loading, error }] = useDeleteRuleOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRuleOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRuleOperationMutation, DeleteRuleOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRuleOperationMutation, DeleteRuleOperationMutationVariables>(DeleteRuleOperationDocument, options);
      }
export type DeleteRuleOperationMutationHookResult = ReturnType<typeof useDeleteRuleOperationMutation>;
export type DeleteRuleOperationMutationResult = Apollo.MutationResult<DeleteRuleOperationMutation>;
export type DeleteRuleOperationMutationOptions = Apollo.BaseMutationOptions<DeleteRuleOperationMutation, DeleteRuleOperationMutationVariables>;
export const RuleTranslationOperationDocument = gql`
    query RuleTranslationOperation($ruleExpression: String!, $ruleTuningTranslationExpressions: [RuleTuningExpressionTranslationFields!]!) {
  ruleTranslation(
    ruleExpression: $ruleExpression
    ruleTuningTranslationExpressions: $ruleTuningTranslationExpressions
  )
}
    `;

/**
 * __useRuleTranslationOperationQuery__
 *
 * To run a query within a React component, call `useRuleTranslationOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuleTranslationOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleTranslationOperationQuery({
 *   variables: {
 *      ruleExpression: // value for 'ruleExpression'
 *      ruleTuningTranslationExpressions: // value for 'ruleTuningTranslationExpressions'
 *   },
 * });
 */
export function useRuleTranslationOperationQuery(baseOptions: Apollo.QueryHookOptions<RuleTranslationOperationQuery, RuleTranslationOperationQueryVariables> & ({ variables: RuleTranslationOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RuleTranslationOperationQuery, RuleTranslationOperationQueryVariables>(RuleTranslationOperationDocument, options);
      }
export function useRuleTranslationOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuleTranslationOperationQuery, RuleTranslationOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RuleTranslationOperationQuery, RuleTranslationOperationQueryVariables>(RuleTranslationOperationDocument, options);
        }
export function useRuleTranslationOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RuleTranslationOperationQuery, RuleTranslationOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RuleTranslationOperationQuery, RuleTranslationOperationQueryVariables>(RuleTranslationOperationDocument, options);
        }
export type RuleTranslationOperationQueryHookResult = ReturnType<typeof useRuleTranslationOperationQuery>;
export type RuleTranslationOperationLazyQueryHookResult = ReturnType<typeof useRuleTranslationOperationLazyQuery>;
export type RuleTranslationOperationSuspenseQueryHookResult = ReturnType<typeof useRuleTranslationOperationSuspenseQuery>;
export type RuleTranslationOperationQueryResult = Apollo.QueryResult<RuleTranslationOperationQuery, RuleTranslationOperationQueryVariables>;
export const RuleRecordSchemaOperationDocument = gql`
    query RuleRecordSchemaOperation {
  recordSchema(recordType: "record")
}
    `;

/**
 * __useRuleRecordSchemaOperationQuery__
 *
 * To run a query within a React component, call `useRuleRecordSchemaOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuleRecordSchemaOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleRecordSchemaOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useRuleRecordSchemaOperationQuery(baseOptions?: Apollo.QueryHookOptions<RuleRecordSchemaOperationQuery, RuleRecordSchemaOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RuleRecordSchemaOperationQuery, RuleRecordSchemaOperationQueryVariables>(RuleRecordSchemaOperationDocument, options);
      }
export function useRuleRecordSchemaOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuleRecordSchemaOperationQuery, RuleRecordSchemaOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RuleRecordSchemaOperationQuery, RuleRecordSchemaOperationQueryVariables>(RuleRecordSchemaOperationDocument, options);
        }
export function useRuleRecordSchemaOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RuleRecordSchemaOperationQuery, RuleRecordSchemaOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RuleRecordSchemaOperationQuery, RuleRecordSchemaOperationQueryVariables>(RuleRecordSchemaOperationDocument, options);
        }
export type RuleRecordSchemaOperationQueryHookResult = ReturnType<typeof useRuleRecordSchemaOperationQuery>;
export type RuleRecordSchemaOperationLazyQueryHookResult = ReturnType<typeof useRuleRecordSchemaOperationLazyQuery>;
export type RuleRecordSchemaOperationSuspenseQueryHookResult = ReturnType<typeof useRuleRecordSchemaOperationSuspenseQuery>;
export type RuleRecordSchemaOperationQueryResult = Apollo.QueryResult<RuleRecordSchemaOperationQuery, RuleRecordSchemaOperationQueryVariables>;
export const RuleExportOperationDocument = gql`
    query RuleExportOperation($id: ID!) {
  rule(id: $id) {
    ...RuleExportFragment
  }
}
    ${RuleExportFragmentDoc}`;

/**
 * __useRuleExportOperationQuery__
 *
 * To run a query within a React component, call `useRuleExportOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuleExportOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleExportOperationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRuleExportOperationQuery(baseOptions: Apollo.QueryHookOptions<RuleExportOperationQuery, RuleExportOperationQueryVariables> & ({ variables: RuleExportOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RuleExportOperationQuery, RuleExportOperationQueryVariables>(RuleExportOperationDocument, options);
      }
export function useRuleExportOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuleExportOperationQuery, RuleExportOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RuleExportOperationQuery, RuleExportOperationQueryVariables>(RuleExportOperationDocument, options);
        }
export function useRuleExportOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RuleExportOperationQuery, RuleExportOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RuleExportOperationQuery, RuleExportOperationQueryVariables>(RuleExportOperationDocument, options);
        }
export type RuleExportOperationQueryHookResult = ReturnType<typeof useRuleExportOperationQuery>;
export type RuleExportOperationLazyQueryHookResult = ReturnType<typeof useRuleExportOperationLazyQuery>;
export type RuleExportOperationSuspenseQueryHookResult = ReturnType<typeof useRuleExportOperationSuspenseQuery>;
export type RuleExportOperationQueryResult = Apollo.QueryResult<RuleExportOperationQuery, RuleExportOperationQueryVariables>;
export const ImportRulesMutationDocument = gql`
    mutation ImportRulesMutation($file: Upload!) {
  importRules(file: $file) {
    successCount
    failures {
      ruleName
    }
  }
}
    `;
export type ImportRulesMutationMutationFn = Apollo.MutationFunction<ImportRulesMutation, ImportRulesMutationVariables>;

/**
 * __useImportRulesMutation__
 *
 * To run a mutation, you first call `useImportRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importRulesMutation, { data, loading, error }] = useImportRulesMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useImportRulesMutation(baseOptions?: Apollo.MutationHookOptions<ImportRulesMutation, ImportRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportRulesMutation, ImportRulesMutationVariables>(ImportRulesMutationDocument, options);
      }
export type ImportRulesMutationHookResult = ReturnType<typeof useImportRulesMutation>;
export type ImportRulesMutationMutationResult = Apollo.MutationResult<ImportRulesMutation>;
export type ImportRulesMutationMutationOptions = Apollo.BaseMutationOptions<ImportRulesMutation, ImportRulesMutationVariables>;
export const AggregationRuleFunctionsOperationDocument = gql`
    query AggregationRuleFunctionsOperation {
  aggregationRuleFunctions {
    name
    description
    parameters {
      name
      description
    }
  }
}
    `;

/**
 * __useAggregationRuleFunctionsOperationQuery__
 *
 * To run a query within a React component, call `useAggregationRuleFunctionsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAggregationRuleFunctionsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAggregationRuleFunctionsOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useAggregationRuleFunctionsOperationQuery(baseOptions?: Apollo.QueryHookOptions<AggregationRuleFunctionsOperationQuery, AggregationRuleFunctionsOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AggregationRuleFunctionsOperationQuery, AggregationRuleFunctionsOperationQueryVariables>(AggregationRuleFunctionsOperationDocument, options);
      }
export function useAggregationRuleFunctionsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AggregationRuleFunctionsOperationQuery, AggregationRuleFunctionsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AggregationRuleFunctionsOperationQuery, AggregationRuleFunctionsOperationQueryVariables>(AggregationRuleFunctionsOperationDocument, options);
        }
export function useAggregationRuleFunctionsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AggregationRuleFunctionsOperationQuery, AggregationRuleFunctionsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AggregationRuleFunctionsOperationQuery, AggregationRuleFunctionsOperationQueryVariables>(AggregationRuleFunctionsOperationDocument, options);
        }
export type AggregationRuleFunctionsOperationQueryHookResult = ReturnType<typeof useAggregationRuleFunctionsOperationQuery>;
export type AggregationRuleFunctionsOperationLazyQueryHookResult = ReturnType<typeof useAggregationRuleFunctionsOperationLazyQuery>;
export type AggregationRuleFunctionsOperationSuspenseQueryHookResult = ReturnType<typeof useAggregationRuleFunctionsOperationSuspenseQuery>;
export type AggregationRuleFunctionsOperationQueryResult = Apollo.QueryResult<AggregationRuleFunctionsOperationQuery, AggregationRuleFunctionsOperationQueryVariables>;
export const RuleBuilderQueryOperationDocument = gql`
    query RuleBuilderQueryOperation($id: ID!) {
  rule(id: $id) {
    ...RuleBuilderFragment
  }
}
    ${RuleBuilderFragmentDoc}`;

/**
 * __useRuleBuilderQueryOperation__
 *
 * To run a query within a React component, call `useRuleBuilderQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useRuleBuilderQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleBuilderQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRuleBuilderQueryOperation(baseOptions: Apollo.QueryHookOptions<RuleBuilderQueryOperationQuery, RuleBuilderQueryOperationQueryVariables> & ({ variables: RuleBuilderQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RuleBuilderQueryOperationQuery, RuleBuilderQueryOperationQueryVariables>(RuleBuilderQueryOperationDocument, options);
      }
export function useRuleBuilderQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuleBuilderQueryOperationQuery, RuleBuilderQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RuleBuilderQueryOperationQuery, RuleBuilderQueryOperationQueryVariables>(RuleBuilderQueryOperationDocument, options);
        }
export function useRuleBuilderQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RuleBuilderQueryOperationQuery, RuleBuilderQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RuleBuilderQueryOperationQuery, RuleBuilderQueryOperationQueryVariables>(RuleBuilderQueryOperationDocument, options);
        }
export type RuleBuilderQueryOperationHookResult = ReturnType<typeof useRuleBuilderQueryOperation>;
export type RuleBuilderQueryOperationLazyQueryHookResult = ReturnType<typeof useRuleBuilderQueryOperationLazyQuery>;
export type RuleBuilderQueryOperationSuspenseQueryHookResult = ReturnType<typeof useRuleBuilderQueryOperationSuspenseQuery>;
export type RuleBuilderQueryOperationQueryResult = Apollo.QueryResult<RuleBuilderQueryOperationQuery, RuleBuilderQueryOperationQueryVariables>;
export const UpdateBuiltInRuleOperationDocument = gql`
    mutation UpdateBuiltInRuleOperation($fields: UpdateBuiltInRuleFields!, $id: ID!) {
  updateBuiltInRule(fields: $fields, id: $id) {
    ok
  }
}
    `;
export type UpdateBuiltInRuleOperationMutationFn = Apollo.MutationFunction<UpdateBuiltInRuleOperationMutation, UpdateBuiltInRuleOperationMutationVariables>;

/**
 * __useUpdateBuiltInRuleOperationMutation__
 *
 * To run a mutation, you first call `useUpdateBuiltInRuleOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBuiltInRuleOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBuiltInRuleOperationMutation, { data, loading, error }] = useUpdateBuiltInRuleOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateBuiltInRuleOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBuiltInRuleOperationMutation, UpdateBuiltInRuleOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBuiltInRuleOperationMutation, UpdateBuiltInRuleOperationMutationVariables>(UpdateBuiltInRuleOperationDocument, options);
      }
export type UpdateBuiltInRuleOperationMutationHookResult = ReturnType<typeof useUpdateBuiltInRuleOperationMutation>;
export type UpdateBuiltInRuleOperationMutationResult = Apollo.MutationResult<UpdateBuiltInRuleOperationMutation>;
export type UpdateBuiltInRuleOperationMutationOptions = Apollo.BaseMutationOptions<UpdateBuiltInRuleOperationMutation, UpdateBuiltInRuleOperationMutationVariables>;
export const OverrideBuiltInTemplatedMatchRuleOperationDocument = gql`
    mutation OverrideBuiltInTemplatedMatchRuleOperation($fields: OverrideTemplatedMatchRuleFields!, $id: ID!) {
  overrideTemplatedMatchRule(fields: $fields, id: $id) {
    data {
      ...TemplatedMatchRuleBuilderFields
    }
  }
}
    ${TemplatedMatchRuleBuilderFieldsFragmentDoc}`;
export type OverrideBuiltInTemplatedMatchRuleOperationMutationFn = Apollo.MutationFunction<OverrideBuiltInTemplatedMatchRuleOperationMutation, OverrideBuiltInTemplatedMatchRuleOperationMutationVariables>;

/**
 * __useOverrideBuiltInTemplatedMatchRuleOperationMutation__
 *
 * To run a mutation, you first call `useOverrideBuiltInTemplatedMatchRuleOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideBuiltInTemplatedMatchRuleOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideBuiltInTemplatedMatchRuleOperationMutation, { data, loading, error }] = useOverrideBuiltInTemplatedMatchRuleOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOverrideBuiltInTemplatedMatchRuleOperationMutation(baseOptions?: Apollo.MutationHookOptions<OverrideBuiltInTemplatedMatchRuleOperationMutation, OverrideBuiltInTemplatedMatchRuleOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideBuiltInTemplatedMatchRuleOperationMutation, OverrideBuiltInTemplatedMatchRuleOperationMutationVariables>(OverrideBuiltInTemplatedMatchRuleOperationDocument, options);
      }
export type OverrideBuiltInTemplatedMatchRuleOperationMutationHookResult = ReturnType<typeof useOverrideBuiltInTemplatedMatchRuleOperationMutation>;
export type OverrideBuiltInTemplatedMatchRuleOperationMutationResult = Apollo.MutationResult<OverrideBuiltInTemplatedMatchRuleOperationMutation>;
export type OverrideBuiltInTemplatedMatchRuleOperationMutationOptions = Apollo.BaseMutationOptions<OverrideBuiltInTemplatedMatchRuleOperationMutation, OverrideBuiltInTemplatedMatchRuleOperationMutationVariables>;
export const OverrideBuiltInThresholdRuleOperationDocument = gql`
    mutation OverrideBuiltInThresholdRuleOperation($fields: OverrideThresholdRuleFields!, $id: ID!) {
  overrideThresholdRule(fields: $fields, id: $id) {
    data {
      ...ThresholdRuleBuilderFields
    }
  }
}
    ${ThresholdRuleBuilderFieldsFragmentDoc}`;
export type OverrideBuiltInThresholdRuleOperationMutationFn = Apollo.MutationFunction<OverrideBuiltInThresholdRuleOperationMutation, OverrideBuiltInThresholdRuleOperationMutationVariables>;

/**
 * __useOverrideBuiltInThresholdRuleOperationMutation__
 *
 * To run a mutation, you first call `useOverrideBuiltInThresholdRuleOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideBuiltInThresholdRuleOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideBuiltInThresholdRuleOperationMutation, { data, loading, error }] = useOverrideBuiltInThresholdRuleOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOverrideBuiltInThresholdRuleOperationMutation(baseOptions?: Apollo.MutationHookOptions<OverrideBuiltInThresholdRuleOperationMutation, OverrideBuiltInThresholdRuleOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideBuiltInThresholdRuleOperationMutation, OverrideBuiltInThresholdRuleOperationMutationVariables>(OverrideBuiltInThresholdRuleOperationDocument, options);
      }
export type OverrideBuiltInThresholdRuleOperationMutationHookResult = ReturnType<typeof useOverrideBuiltInThresholdRuleOperationMutation>;
export type OverrideBuiltInThresholdRuleOperationMutationResult = Apollo.MutationResult<OverrideBuiltInThresholdRuleOperationMutation>;
export type OverrideBuiltInThresholdRuleOperationMutationOptions = Apollo.BaseMutationOptions<OverrideBuiltInThresholdRuleOperationMutation, OverrideBuiltInThresholdRuleOperationMutationVariables>;
export const OverrideBuiltInAggregationRuleOperationDocument = gql`
    mutation OverrideBuiltInAggregationRuleOperation($fields: OverrideAggregationRuleFields!, $id: ID!) {
  overrideAggregationRule(fields: $fields, id: $id) {
    data {
      ...AggregationRuleBuilderFields
    }
  }
}
    ${AggregationRuleBuilderFieldsFragmentDoc}`;
export type OverrideBuiltInAggregationRuleOperationMutationFn = Apollo.MutationFunction<OverrideBuiltInAggregationRuleOperationMutation, OverrideBuiltInAggregationRuleOperationMutationVariables>;

/**
 * __useOverrideBuiltInAggregationRuleOperationMutation__
 *
 * To run a mutation, you first call `useOverrideBuiltInAggregationRuleOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideBuiltInAggregationRuleOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideBuiltInAggregationRuleOperationMutation, { data, loading, error }] = useOverrideBuiltInAggregationRuleOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOverrideBuiltInAggregationRuleOperationMutation(baseOptions?: Apollo.MutationHookOptions<OverrideBuiltInAggregationRuleOperationMutation, OverrideBuiltInAggregationRuleOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideBuiltInAggregationRuleOperationMutation, OverrideBuiltInAggregationRuleOperationMutationVariables>(OverrideBuiltInAggregationRuleOperationDocument, options);
      }
export type OverrideBuiltInAggregationRuleOperationMutationHookResult = ReturnType<typeof useOverrideBuiltInAggregationRuleOperationMutation>;
export type OverrideBuiltInAggregationRuleOperationMutationResult = Apollo.MutationResult<OverrideBuiltInAggregationRuleOperationMutation>;
export type OverrideBuiltInAggregationRuleOperationMutationOptions = Apollo.BaseMutationOptions<OverrideBuiltInAggregationRuleOperationMutation, OverrideBuiltInAggregationRuleOperationMutationVariables>;
export const OverrideBuiltInChainRuleOperationDocument = gql`
    mutation OverrideBuiltInChainRuleOperation($fields: OverrideChainRuleFields!, $id: ID!) {
  overrideChainRule(fields: $fields, id: $id) {
    data {
      ...ChainRuleBuilderFields
    }
  }
}
    ${ChainRuleBuilderFieldsFragmentDoc}`;
export type OverrideBuiltInChainRuleOperationMutationFn = Apollo.MutationFunction<OverrideBuiltInChainRuleOperationMutation, OverrideBuiltInChainRuleOperationMutationVariables>;

/**
 * __useOverrideBuiltInChainRuleOperationMutation__
 *
 * To run a mutation, you first call `useOverrideBuiltInChainRuleOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideBuiltInChainRuleOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideBuiltInChainRuleOperationMutation, { data, loading, error }] = useOverrideBuiltInChainRuleOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOverrideBuiltInChainRuleOperationMutation(baseOptions?: Apollo.MutationHookOptions<OverrideBuiltInChainRuleOperationMutation, OverrideBuiltInChainRuleOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideBuiltInChainRuleOperationMutation, OverrideBuiltInChainRuleOperationMutationVariables>(OverrideBuiltInChainRuleOperationDocument, options);
      }
export type OverrideBuiltInChainRuleOperationMutationHookResult = ReturnType<typeof useOverrideBuiltInChainRuleOperationMutation>;
export type OverrideBuiltInChainRuleOperationMutationResult = Apollo.MutationResult<OverrideBuiltInChainRuleOperationMutation>;
export type OverrideBuiltInChainRuleOperationMutationOptions = Apollo.BaseMutationOptions<OverrideBuiltInChainRuleOperationMutation, OverrideBuiltInChainRuleOperationMutationVariables>;
export const OverrideBuiltInFirstSeenRuleOperationDocument = gql`
    mutation OverrideBuiltInFirstSeenRuleOperation($fields: OverrideFirstSeenRuleFields!, $id: ID!) {
  overrideFirstSeenRule(fields: $fields, id: $id) {
    data {
      ...FirstSeenRuleBuilderFields
    }
  }
}
    ${FirstSeenRuleBuilderFieldsFragmentDoc}`;
export type OverrideBuiltInFirstSeenRuleOperationMutationFn = Apollo.MutationFunction<OverrideBuiltInFirstSeenRuleOperationMutation, OverrideBuiltInFirstSeenRuleOperationMutationVariables>;

/**
 * __useOverrideBuiltInFirstSeenRuleOperationMutation__
 *
 * To run a mutation, you first call `useOverrideBuiltInFirstSeenRuleOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideBuiltInFirstSeenRuleOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideBuiltInFirstSeenRuleOperationMutation, { data, loading, error }] = useOverrideBuiltInFirstSeenRuleOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOverrideBuiltInFirstSeenRuleOperationMutation(baseOptions?: Apollo.MutationHookOptions<OverrideBuiltInFirstSeenRuleOperationMutation, OverrideBuiltInFirstSeenRuleOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideBuiltInFirstSeenRuleOperationMutation, OverrideBuiltInFirstSeenRuleOperationMutationVariables>(OverrideBuiltInFirstSeenRuleOperationDocument, options);
      }
export type OverrideBuiltInFirstSeenRuleOperationMutationHookResult = ReturnType<typeof useOverrideBuiltInFirstSeenRuleOperationMutation>;
export type OverrideBuiltInFirstSeenRuleOperationMutationResult = Apollo.MutationResult<OverrideBuiltInFirstSeenRuleOperationMutation>;
export type OverrideBuiltInFirstSeenRuleOperationMutationOptions = Apollo.BaseMutationOptions<OverrideBuiltInFirstSeenRuleOperationMutation, OverrideBuiltInFirstSeenRuleOperationMutationVariables>;
export const OverrideBuiltInOutlierRuleOperationDocument = gql`
    mutation OverrideBuiltInOutlierRuleOperation($fields: OverrideOutlierRuleFields!, $id: ID!) {
  overrideOutlierRule(fields: $fields, id: $id) {
    data {
      ...OutlierRuleBuilderFields
    }
  }
}
    ${OutlierRuleBuilderFieldsFragmentDoc}`;
export type OverrideBuiltInOutlierRuleOperationMutationFn = Apollo.MutationFunction<OverrideBuiltInOutlierRuleOperationMutation, OverrideBuiltInOutlierRuleOperationMutationVariables>;

/**
 * __useOverrideBuiltInOutlierRuleOperationMutation__
 *
 * To run a mutation, you first call `useOverrideBuiltInOutlierRuleOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOverrideBuiltInOutlierRuleOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [overrideBuiltInOutlierRuleOperationMutation, { data, loading, error }] = useOverrideBuiltInOutlierRuleOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOverrideBuiltInOutlierRuleOperationMutation(baseOptions?: Apollo.MutationHookOptions<OverrideBuiltInOutlierRuleOperationMutation, OverrideBuiltInOutlierRuleOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OverrideBuiltInOutlierRuleOperationMutation, OverrideBuiltInOutlierRuleOperationMutationVariables>(OverrideBuiltInOutlierRuleOperationDocument, options);
      }
export type OverrideBuiltInOutlierRuleOperationMutationHookResult = ReturnType<typeof useOverrideBuiltInOutlierRuleOperationMutation>;
export type OverrideBuiltInOutlierRuleOperationMutationResult = Apollo.MutationResult<OverrideBuiltInOutlierRuleOperationMutation>;
export type OverrideBuiltInOutlierRuleOperationMutationOptions = Apollo.BaseMutationOptions<OverrideBuiltInOutlierRuleOperationMutation, OverrideBuiltInOutlierRuleOperationMutationVariables>;
export const RuleSignalCountOperationDocument = gql`
    query RuleSignalCountOperation($bucketDuration: TimeDelta!, $end: DateTime, $ruleId: String!, $start: DateTime!, $timezone: String) {
  signalCounts(
    bucketDuration: $bucketDuration
    end: $end
    ruleId: $ruleId
    start: $start
    timezone: $timezone
  ) {
    timestamp
    value
  }
}
    `;

/**
 * __useRuleSignalCountOperationQuery__
 *
 * To run a query within a React component, call `useRuleSignalCountOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuleSignalCountOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleSignalCountOperationQuery({
 *   variables: {
 *      bucketDuration: // value for 'bucketDuration'
 *      end: // value for 'end'
 *      ruleId: // value for 'ruleId'
 *      start: // value for 'start'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useRuleSignalCountOperationQuery(baseOptions: Apollo.QueryHookOptions<RuleSignalCountOperationQuery, RuleSignalCountOperationQueryVariables> & ({ variables: RuleSignalCountOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RuleSignalCountOperationQuery, RuleSignalCountOperationQueryVariables>(RuleSignalCountOperationDocument, options);
      }
export function useRuleSignalCountOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuleSignalCountOperationQuery, RuleSignalCountOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RuleSignalCountOperationQuery, RuleSignalCountOperationQueryVariables>(RuleSignalCountOperationDocument, options);
        }
export function useRuleSignalCountOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RuleSignalCountOperationQuery, RuleSignalCountOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RuleSignalCountOperationQuery, RuleSignalCountOperationQueryVariables>(RuleSignalCountOperationDocument, options);
        }
export type RuleSignalCountOperationQueryHookResult = ReturnType<typeof useRuleSignalCountOperationQuery>;
export type RuleSignalCountOperationLazyQueryHookResult = ReturnType<typeof useRuleSignalCountOperationLazyQuery>;
export type RuleSignalCountOperationSuspenseQueryHookResult = ReturnType<typeof useRuleSignalCountOperationSuspenseQuery>;
export type RuleSignalCountOperationQueryResult = Apollo.QueryResult<RuleSignalCountOperationQuery, RuleSignalCountOperationQueryVariables>;
export const RuleBuilderLastSignalQueryOperationDocument = gql`
    query RuleBuilderLastSignalQueryOperation($q: String!) {
  signals(limit: 1, q: $q, sort: [{field: TIMESTAMP, direction: DESC}]) {
    objects {
      id
      timestamp
    }
  }
}
    `;

/**
 * __useRuleBuilderLastSignalQueryOperation__
 *
 * To run a query within a React component, call `useRuleBuilderLastSignalQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useRuleBuilderLastSignalQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleBuilderLastSignalQueryOperation({
 *   variables: {
 *      q: // value for 'q'
 *   },
 * });
 */
export function useRuleBuilderLastSignalQueryOperation(baseOptions: Apollo.QueryHookOptions<RuleBuilderLastSignalQueryOperationQuery, RuleBuilderLastSignalQueryOperationQueryVariables> & ({ variables: RuleBuilderLastSignalQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RuleBuilderLastSignalQueryOperationQuery, RuleBuilderLastSignalQueryOperationQueryVariables>(RuleBuilderLastSignalQueryOperationDocument, options);
      }
export function useRuleBuilderLastSignalQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuleBuilderLastSignalQueryOperationQuery, RuleBuilderLastSignalQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RuleBuilderLastSignalQueryOperationQuery, RuleBuilderLastSignalQueryOperationQueryVariables>(RuleBuilderLastSignalQueryOperationDocument, options);
        }
export function useRuleBuilderLastSignalQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RuleBuilderLastSignalQueryOperationQuery, RuleBuilderLastSignalQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RuleBuilderLastSignalQueryOperationQuery, RuleBuilderLastSignalQueryOperationQueryVariables>(RuleBuilderLastSignalQueryOperationDocument, options);
        }
export type RuleBuilderLastSignalQueryOperationHookResult = ReturnType<typeof useRuleBuilderLastSignalQueryOperation>;
export type RuleBuilderLastSignalQueryOperationLazyQueryHookResult = ReturnType<typeof useRuleBuilderLastSignalQueryOperationLazyQuery>;
export type RuleBuilderLastSignalQueryOperationSuspenseQueryHookResult = ReturnType<typeof useRuleBuilderLastSignalQueryOperationSuspenseQuery>;
export type RuleBuilderLastSignalQueryOperationQueryResult = Apollo.QueryResult<RuleBuilderLastSignalQueryOperationQuery, RuleBuilderLastSignalQueryOperationQueryVariables>;
export const MatchRuleValidationResultOperationDocument = gql`
    query MatchRuleValidationResultOperation($ruleFields: MatchRuleFields!) {
  matchRuleValidationResult(ruleFields: $ruleFields) {
    ...RuleValidationResult
  }
}
    ${RuleValidationResultFragmentDoc}`;

/**
 * __useMatchRuleValidationResultOperationQuery__
 *
 * To run a query within a React component, call `useMatchRuleValidationResultOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchRuleValidationResultOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchRuleValidationResultOperationQuery({
 *   variables: {
 *      ruleFields: // value for 'ruleFields'
 *   },
 * });
 */
export function useMatchRuleValidationResultOperationQuery(baseOptions: Apollo.QueryHookOptions<MatchRuleValidationResultOperationQuery, MatchRuleValidationResultOperationQueryVariables> & ({ variables: MatchRuleValidationResultOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchRuleValidationResultOperationQuery, MatchRuleValidationResultOperationQueryVariables>(MatchRuleValidationResultOperationDocument, options);
      }
export function useMatchRuleValidationResultOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchRuleValidationResultOperationQuery, MatchRuleValidationResultOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchRuleValidationResultOperationQuery, MatchRuleValidationResultOperationQueryVariables>(MatchRuleValidationResultOperationDocument, options);
        }
export function useMatchRuleValidationResultOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchRuleValidationResultOperationQuery, MatchRuleValidationResultOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchRuleValidationResultOperationQuery, MatchRuleValidationResultOperationQueryVariables>(MatchRuleValidationResultOperationDocument, options);
        }
export type MatchRuleValidationResultOperationQueryHookResult = ReturnType<typeof useMatchRuleValidationResultOperationQuery>;
export type MatchRuleValidationResultOperationLazyQueryHookResult = ReturnType<typeof useMatchRuleValidationResultOperationLazyQuery>;
export type MatchRuleValidationResultOperationSuspenseQueryHookResult = ReturnType<typeof useMatchRuleValidationResultOperationSuspenseQuery>;
export type MatchRuleValidationResultOperationQueryResult = Apollo.QueryResult<MatchRuleValidationResultOperationQuery, MatchRuleValidationResultOperationQueryVariables>;
export const ThresholdRuleValidationResultOperationDocument = gql`
    query ThresholdRuleValidationResultOperation($ruleFields: ThresholdRuleFields!) {
  thresholdRuleValidationResult(ruleFields: $ruleFields) {
    ...RuleValidationResult
  }
}
    ${RuleValidationResultFragmentDoc}`;

/**
 * __useThresholdRuleValidationResultOperationQuery__
 *
 * To run a query within a React component, call `useThresholdRuleValidationResultOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useThresholdRuleValidationResultOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThresholdRuleValidationResultOperationQuery({
 *   variables: {
 *      ruleFields: // value for 'ruleFields'
 *   },
 * });
 */
export function useThresholdRuleValidationResultOperationQuery(baseOptions: Apollo.QueryHookOptions<ThresholdRuleValidationResultOperationQuery, ThresholdRuleValidationResultOperationQueryVariables> & ({ variables: ThresholdRuleValidationResultOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThresholdRuleValidationResultOperationQuery, ThresholdRuleValidationResultOperationQueryVariables>(ThresholdRuleValidationResultOperationDocument, options);
      }
export function useThresholdRuleValidationResultOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThresholdRuleValidationResultOperationQuery, ThresholdRuleValidationResultOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThresholdRuleValidationResultOperationQuery, ThresholdRuleValidationResultOperationQueryVariables>(ThresholdRuleValidationResultOperationDocument, options);
        }
export function useThresholdRuleValidationResultOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThresholdRuleValidationResultOperationQuery, ThresholdRuleValidationResultOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThresholdRuleValidationResultOperationQuery, ThresholdRuleValidationResultOperationQueryVariables>(ThresholdRuleValidationResultOperationDocument, options);
        }
export type ThresholdRuleValidationResultOperationQueryHookResult = ReturnType<typeof useThresholdRuleValidationResultOperationQuery>;
export type ThresholdRuleValidationResultOperationLazyQueryHookResult = ReturnType<typeof useThresholdRuleValidationResultOperationLazyQuery>;
export type ThresholdRuleValidationResultOperationSuspenseQueryHookResult = ReturnType<typeof useThresholdRuleValidationResultOperationSuspenseQuery>;
export type ThresholdRuleValidationResultOperationQueryResult = Apollo.QueryResult<ThresholdRuleValidationResultOperationQuery, ThresholdRuleValidationResultOperationQueryVariables>;
export const ChainRuleValidationResultOperationDocument = gql`
    query ChainRuleValidationResultOperation($ruleFields: ChainRuleFields!) {
  chainRuleValidationResult(ruleFields: $ruleFields) {
    ...RuleValidationResult
  }
}
    ${RuleValidationResultFragmentDoc}`;

/**
 * __useChainRuleValidationResultOperationQuery__
 *
 * To run a query within a React component, call `useChainRuleValidationResultOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useChainRuleValidationResultOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChainRuleValidationResultOperationQuery({
 *   variables: {
 *      ruleFields: // value for 'ruleFields'
 *   },
 * });
 */
export function useChainRuleValidationResultOperationQuery(baseOptions: Apollo.QueryHookOptions<ChainRuleValidationResultOperationQuery, ChainRuleValidationResultOperationQueryVariables> & ({ variables: ChainRuleValidationResultOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChainRuleValidationResultOperationQuery, ChainRuleValidationResultOperationQueryVariables>(ChainRuleValidationResultOperationDocument, options);
      }
export function useChainRuleValidationResultOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChainRuleValidationResultOperationQuery, ChainRuleValidationResultOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChainRuleValidationResultOperationQuery, ChainRuleValidationResultOperationQueryVariables>(ChainRuleValidationResultOperationDocument, options);
        }
export function useChainRuleValidationResultOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChainRuleValidationResultOperationQuery, ChainRuleValidationResultOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChainRuleValidationResultOperationQuery, ChainRuleValidationResultOperationQueryVariables>(ChainRuleValidationResultOperationDocument, options);
        }
export type ChainRuleValidationResultOperationQueryHookResult = ReturnType<typeof useChainRuleValidationResultOperationQuery>;
export type ChainRuleValidationResultOperationLazyQueryHookResult = ReturnType<typeof useChainRuleValidationResultOperationLazyQuery>;
export type ChainRuleValidationResultOperationSuspenseQueryHookResult = ReturnType<typeof useChainRuleValidationResultOperationSuspenseQuery>;
export type ChainRuleValidationResultOperationQueryResult = Apollo.QueryResult<ChainRuleValidationResultOperationQuery, ChainRuleValidationResultOperationQueryVariables>;
export const AggregationRuleValidationResultOperationDocument = gql`
    query AggregationRuleValidationResultOperation($ruleFields: AggregationRuleFields!) {
  aggregationRuleValidationResult(ruleFields: $ruleFields) {
    ...RuleValidationResult
  }
}
    ${RuleValidationResultFragmentDoc}`;

/**
 * __useAggregationRuleValidationResultOperationQuery__
 *
 * To run a query within a React component, call `useAggregationRuleValidationResultOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAggregationRuleValidationResultOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAggregationRuleValidationResultOperationQuery({
 *   variables: {
 *      ruleFields: // value for 'ruleFields'
 *   },
 * });
 */
export function useAggregationRuleValidationResultOperationQuery(baseOptions: Apollo.QueryHookOptions<AggregationRuleValidationResultOperationQuery, AggregationRuleValidationResultOperationQueryVariables> & ({ variables: AggregationRuleValidationResultOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AggregationRuleValidationResultOperationQuery, AggregationRuleValidationResultOperationQueryVariables>(AggregationRuleValidationResultOperationDocument, options);
      }
export function useAggregationRuleValidationResultOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AggregationRuleValidationResultOperationQuery, AggregationRuleValidationResultOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AggregationRuleValidationResultOperationQuery, AggregationRuleValidationResultOperationQueryVariables>(AggregationRuleValidationResultOperationDocument, options);
        }
export function useAggregationRuleValidationResultOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AggregationRuleValidationResultOperationQuery, AggregationRuleValidationResultOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AggregationRuleValidationResultOperationQuery, AggregationRuleValidationResultOperationQueryVariables>(AggregationRuleValidationResultOperationDocument, options);
        }
export type AggregationRuleValidationResultOperationQueryHookResult = ReturnType<typeof useAggregationRuleValidationResultOperationQuery>;
export type AggregationRuleValidationResultOperationLazyQueryHookResult = ReturnType<typeof useAggregationRuleValidationResultOperationLazyQuery>;
export type AggregationRuleValidationResultOperationSuspenseQueryHookResult = ReturnType<typeof useAggregationRuleValidationResultOperationSuspenseQuery>;
export type AggregationRuleValidationResultOperationQueryResult = Apollo.QueryResult<AggregationRuleValidationResultOperationQuery, AggregationRuleValidationResultOperationQueryVariables>;
export const TemplatedMatchRuleValidationResultOperationDocument = gql`
    query TemplatedMatchRuleValidationResultOperation($ruleFields: TemplatedMatchRuleFields!) {
  templatedMatchRuleValidationResult(ruleFields: $ruleFields) {
    ...RuleValidationResult
  }
}
    ${RuleValidationResultFragmentDoc}`;

/**
 * __useTemplatedMatchRuleValidationResultOperationQuery__
 *
 * To run a query within a React component, call `useTemplatedMatchRuleValidationResultOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTemplatedMatchRuleValidationResultOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplatedMatchRuleValidationResultOperationQuery({
 *   variables: {
 *      ruleFields: // value for 'ruleFields'
 *   },
 * });
 */
export function useTemplatedMatchRuleValidationResultOperationQuery(baseOptions: Apollo.QueryHookOptions<TemplatedMatchRuleValidationResultOperationQuery, TemplatedMatchRuleValidationResultOperationQueryVariables> & ({ variables: TemplatedMatchRuleValidationResultOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplatedMatchRuleValidationResultOperationQuery, TemplatedMatchRuleValidationResultOperationQueryVariables>(TemplatedMatchRuleValidationResultOperationDocument, options);
      }
export function useTemplatedMatchRuleValidationResultOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TemplatedMatchRuleValidationResultOperationQuery, TemplatedMatchRuleValidationResultOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplatedMatchRuleValidationResultOperationQuery, TemplatedMatchRuleValidationResultOperationQueryVariables>(TemplatedMatchRuleValidationResultOperationDocument, options);
        }
export function useTemplatedMatchRuleValidationResultOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplatedMatchRuleValidationResultOperationQuery, TemplatedMatchRuleValidationResultOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplatedMatchRuleValidationResultOperationQuery, TemplatedMatchRuleValidationResultOperationQueryVariables>(TemplatedMatchRuleValidationResultOperationDocument, options);
        }
export type TemplatedMatchRuleValidationResultOperationQueryHookResult = ReturnType<typeof useTemplatedMatchRuleValidationResultOperationQuery>;
export type TemplatedMatchRuleValidationResultOperationLazyQueryHookResult = ReturnType<typeof useTemplatedMatchRuleValidationResultOperationLazyQuery>;
export type TemplatedMatchRuleValidationResultOperationSuspenseQueryHookResult = ReturnType<typeof useTemplatedMatchRuleValidationResultOperationSuspenseQuery>;
export type TemplatedMatchRuleValidationResultOperationQueryResult = Apollo.QueryResult<TemplatedMatchRuleValidationResultOperationQuery, TemplatedMatchRuleValidationResultOperationQueryVariables>;
export const CreateThresholdRuleBuilderOperationDocument = gql`
    mutation CreateThresholdRuleBuilderOperation($fields: CreateThresholdRuleFields!) {
  createThresholdRule(fields: $fields) {
    data {
      ...ThresholdRuleBuilderFields
    }
  }
}
    ${ThresholdRuleBuilderFieldsFragmentDoc}`;
export type CreateThresholdRuleBuilderOperationMutationFn = Apollo.MutationFunction<CreateThresholdRuleBuilderOperationMutation, CreateThresholdRuleBuilderOperationMutationVariables>;

/**
 * __useCreateThresholdRuleBuilderOperationMutation__
 *
 * To run a mutation, you first call `useCreateThresholdRuleBuilderOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThresholdRuleBuilderOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThresholdRuleBuilderOperationMutation, { data, loading, error }] = useCreateThresholdRuleBuilderOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateThresholdRuleBuilderOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateThresholdRuleBuilderOperationMutation, CreateThresholdRuleBuilderOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateThresholdRuleBuilderOperationMutation, CreateThresholdRuleBuilderOperationMutationVariables>(CreateThresholdRuleBuilderOperationDocument, options);
      }
export type CreateThresholdRuleBuilderOperationMutationHookResult = ReturnType<typeof useCreateThresholdRuleBuilderOperationMutation>;
export type CreateThresholdRuleBuilderOperationMutationResult = Apollo.MutationResult<CreateThresholdRuleBuilderOperationMutation>;
export type CreateThresholdRuleBuilderOperationMutationOptions = Apollo.BaseMutationOptions<CreateThresholdRuleBuilderOperationMutation, CreateThresholdRuleBuilderOperationMutationVariables>;
export const UpdateThresholdRuleBuilderOperationDocument = gql`
    mutation UpdateThresholdRuleBuilderOperation($fields: UpdateThresholdRuleFields!, $id: ID!) {
  updateThresholdRule(fields: $fields, id: $id) {
    data {
      ...ThresholdRuleBuilderFields
    }
  }
}
    ${ThresholdRuleBuilderFieldsFragmentDoc}`;
export type UpdateThresholdRuleBuilderOperationMutationFn = Apollo.MutationFunction<UpdateThresholdRuleBuilderOperationMutation, UpdateThresholdRuleBuilderOperationMutationVariables>;

/**
 * __useUpdateThresholdRuleBuilderOperationMutation__
 *
 * To run a mutation, you first call `useUpdateThresholdRuleBuilderOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThresholdRuleBuilderOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThresholdRuleBuilderOperationMutation, { data, loading, error }] = useUpdateThresholdRuleBuilderOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateThresholdRuleBuilderOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThresholdRuleBuilderOperationMutation, UpdateThresholdRuleBuilderOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateThresholdRuleBuilderOperationMutation, UpdateThresholdRuleBuilderOperationMutationVariables>(UpdateThresholdRuleBuilderOperationDocument, options);
      }
export type UpdateThresholdRuleBuilderOperationMutationHookResult = ReturnType<typeof useUpdateThresholdRuleBuilderOperationMutation>;
export type UpdateThresholdRuleBuilderOperationMutationResult = Apollo.MutationResult<UpdateThresholdRuleBuilderOperationMutation>;
export type UpdateThresholdRuleBuilderOperationMutationOptions = Apollo.BaseMutationOptions<UpdateThresholdRuleBuilderOperationMutation, UpdateThresholdRuleBuilderOperationMutationVariables>;
export const CreateAggregationRuleBuilderOperationDocument = gql`
    mutation CreateAggregationRuleBuilderOperation($fields: CreateAggregationRuleFields!) {
  createAggregationRule(fields: $fields) {
    data {
      ...AggregationRuleBuilderFields
    }
  }
}
    ${AggregationRuleBuilderFieldsFragmentDoc}`;
export type CreateAggregationRuleBuilderOperationMutationFn = Apollo.MutationFunction<CreateAggregationRuleBuilderOperationMutation, CreateAggregationRuleBuilderOperationMutationVariables>;

/**
 * __useCreateAggregationRuleBuilderOperationMutation__
 *
 * To run a mutation, you first call `useCreateAggregationRuleBuilderOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAggregationRuleBuilderOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAggregationRuleBuilderOperationMutation, { data, loading, error }] = useCreateAggregationRuleBuilderOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateAggregationRuleBuilderOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAggregationRuleBuilderOperationMutation, CreateAggregationRuleBuilderOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAggregationRuleBuilderOperationMutation, CreateAggregationRuleBuilderOperationMutationVariables>(CreateAggregationRuleBuilderOperationDocument, options);
      }
export type CreateAggregationRuleBuilderOperationMutationHookResult = ReturnType<typeof useCreateAggregationRuleBuilderOperationMutation>;
export type CreateAggregationRuleBuilderOperationMutationResult = Apollo.MutationResult<CreateAggregationRuleBuilderOperationMutation>;
export type CreateAggregationRuleBuilderOperationMutationOptions = Apollo.BaseMutationOptions<CreateAggregationRuleBuilderOperationMutation, CreateAggregationRuleBuilderOperationMutationVariables>;
export const UpdateAggregationRuleBuilderOperationDocument = gql`
    mutation UpdateAggregationRuleBuilderOperation($fields: UpdateAggregationRuleFields!, $id: ID!) {
  updateAggregationRule(fields: $fields, id: $id) {
    data {
      ...AggregationRuleBuilderFields
    }
  }
}
    ${AggregationRuleBuilderFieldsFragmentDoc}`;
export type UpdateAggregationRuleBuilderOperationMutationFn = Apollo.MutationFunction<UpdateAggregationRuleBuilderOperationMutation, UpdateAggregationRuleBuilderOperationMutationVariables>;

/**
 * __useUpdateAggregationRuleBuilderOperationMutation__
 *
 * To run a mutation, you first call `useUpdateAggregationRuleBuilderOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAggregationRuleBuilderOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAggregationRuleBuilderOperationMutation, { data, loading, error }] = useUpdateAggregationRuleBuilderOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAggregationRuleBuilderOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAggregationRuleBuilderOperationMutation, UpdateAggregationRuleBuilderOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAggregationRuleBuilderOperationMutation, UpdateAggregationRuleBuilderOperationMutationVariables>(UpdateAggregationRuleBuilderOperationDocument, options);
      }
export type UpdateAggregationRuleBuilderOperationMutationHookResult = ReturnType<typeof useUpdateAggregationRuleBuilderOperationMutation>;
export type UpdateAggregationRuleBuilderOperationMutationResult = Apollo.MutationResult<UpdateAggregationRuleBuilderOperationMutation>;
export type UpdateAggregationRuleBuilderOperationMutationOptions = Apollo.BaseMutationOptions<UpdateAggregationRuleBuilderOperationMutation, UpdateAggregationRuleBuilderOperationMutationVariables>;
export const CreateChainRuleBuilderOperationDocument = gql`
    mutation CreateChainRuleBuilderOperation($fields: CreateChainRuleFields!) {
  createChainRule(fields: $fields) {
    data {
      ...ChainRuleBuilderFields
    }
  }
}
    ${ChainRuleBuilderFieldsFragmentDoc}`;
export type CreateChainRuleBuilderOperationMutationFn = Apollo.MutationFunction<CreateChainRuleBuilderOperationMutation, CreateChainRuleBuilderOperationMutationVariables>;

/**
 * __useCreateChainRuleBuilderOperationMutation__
 *
 * To run a mutation, you first call `useCreateChainRuleBuilderOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChainRuleBuilderOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChainRuleBuilderOperationMutation, { data, loading, error }] = useCreateChainRuleBuilderOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateChainRuleBuilderOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateChainRuleBuilderOperationMutation, CreateChainRuleBuilderOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChainRuleBuilderOperationMutation, CreateChainRuleBuilderOperationMutationVariables>(CreateChainRuleBuilderOperationDocument, options);
      }
export type CreateChainRuleBuilderOperationMutationHookResult = ReturnType<typeof useCreateChainRuleBuilderOperationMutation>;
export type CreateChainRuleBuilderOperationMutationResult = Apollo.MutationResult<CreateChainRuleBuilderOperationMutation>;
export type CreateChainRuleBuilderOperationMutationOptions = Apollo.BaseMutationOptions<CreateChainRuleBuilderOperationMutation, CreateChainRuleBuilderOperationMutationVariables>;
export const UpdateChainRuleBuilderOperationDocument = gql`
    mutation UpdateChainRuleBuilderOperation($fields: UpdateChainRuleFields!, $id: ID!) {
  updateChainRule(fields: $fields, id: $id) {
    data {
      ...ChainRuleBuilderFields
    }
  }
}
    ${ChainRuleBuilderFieldsFragmentDoc}`;
export type UpdateChainRuleBuilderOperationMutationFn = Apollo.MutationFunction<UpdateChainRuleBuilderOperationMutation, UpdateChainRuleBuilderOperationMutationVariables>;

/**
 * __useUpdateChainRuleBuilderOperationMutation__
 *
 * To run a mutation, you first call `useUpdateChainRuleBuilderOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChainRuleBuilderOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChainRuleBuilderOperationMutation, { data, loading, error }] = useUpdateChainRuleBuilderOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateChainRuleBuilderOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChainRuleBuilderOperationMutation, UpdateChainRuleBuilderOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChainRuleBuilderOperationMutation, UpdateChainRuleBuilderOperationMutationVariables>(UpdateChainRuleBuilderOperationDocument, options);
      }
export type UpdateChainRuleBuilderOperationMutationHookResult = ReturnType<typeof useUpdateChainRuleBuilderOperationMutation>;
export type UpdateChainRuleBuilderOperationMutationResult = Apollo.MutationResult<UpdateChainRuleBuilderOperationMutation>;
export type UpdateChainRuleBuilderOperationMutationOptions = Apollo.BaseMutationOptions<UpdateChainRuleBuilderOperationMutation, UpdateChainRuleBuilderOperationMutationVariables>;
export const CreateFirstSeenRuleBuilderOperationDocument = gql`
    mutation CreateFirstSeenRuleBuilderOperation($fields: CreateFirstSeenRuleFields!) {
  createFirstSeenRule(fields: $fields) {
    data {
      ...FirstSeenRuleBuilderFields
    }
  }
}
    ${FirstSeenRuleBuilderFieldsFragmentDoc}`;
export type CreateFirstSeenRuleBuilderOperationMutationFn = Apollo.MutationFunction<CreateFirstSeenRuleBuilderOperationMutation, CreateFirstSeenRuleBuilderOperationMutationVariables>;

/**
 * __useCreateFirstSeenRuleBuilderOperationMutation__
 *
 * To run a mutation, you first call `useCreateFirstSeenRuleBuilderOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFirstSeenRuleBuilderOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFirstSeenRuleBuilderOperationMutation, { data, loading, error }] = useCreateFirstSeenRuleBuilderOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateFirstSeenRuleBuilderOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateFirstSeenRuleBuilderOperationMutation, CreateFirstSeenRuleBuilderOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFirstSeenRuleBuilderOperationMutation, CreateFirstSeenRuleBuilderOperationMutationVariables>(CreateFirstSeenRuleBuilderOperationDocument, options);
      }
export type CreateFirstSeenRuleBuilderOperationMutationHookResult = ReturnType<typeof useCreateFirstSeenRuleBuilderOperationMutation>;
export type CreateFirstSeenRuleBuilderOperationMutationResult = Apollo.MutationResult<CreateFirstSeenRuleBuilderOperationMutation>;
export type CreateFirstSeenRuleBuilderOperationMutationOptions = Apollo.BaseMutationOptions<CreateFirstSeenRuleBuilderOperationMutation, CreateFirstSeenRuleBuilderOperationMutationVariables>;
export const UpdateFirstSeenRuleBuilderOperationDocument = gql`
    mutation UpdateFirstSeenRuleBuilderOperation($includeSuppressionWindowSize: Boolean!, $fields: UpdateFirstSeenRuleFields!, $id: ID!) {
  updateFirstSeenRule(fields: $fields, id: $id) {
    data {
      suppressionWindowSize @include(if: $includeSuppressionWindowSize)
      ...FirstSeenRuleBuilderFields
    }
  }
}
    ${FirstSeenRuleBuilderFieldsFragmentDoc}`;
export type UpdateFirstSeenRuleBuilderOperationMutationFn = Apollo.MutationFunction<UpdateFirstSeenRuleBuilderOperationMutation, UpdateFirstSeenRuleBuilderOperationMutationVariables>;

/**
 * __useUpdateFirstSeenRuleBuilderOperationMutation__
 *
 * To run a mutation, you first call `useUpdateFirstSeenRuleBuilderOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFirstSeenRuleBuilderOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFirstSeenRuleBuilderOperationMutation, { data, loading, error }] = useUpdateFirstSeenRuleBuilderOperationMutation({
 *   variables: {
 *      includeSuppressionWindowSize: // value for 'includeSuppressionWindowSize'
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateFirstSeenRuleBuilderOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFirstSeenRuleBuilderOperationMutation, UpdateFirstSeenRuleBuilderOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFirstSeenRuleBuilderOperationMutation, UpdateFirstSeenRuleBuilderOperationMutationVariables>(UpdateFirstSeenRuleBuilderOperationDocument, options);
      }
export type UpdateFirstSeenRuleBuilderOperationMutationHookResult = ReturnType<typeof useUpdateFirstSeenRuleBuilderOperationMutation>;
export type UpdateFirstSeenRuleBuilderOperationMutationResult = Apollo.MutationResult<UpdateFirstSeenRuleBuilderOperationMutation>;
export type UpdateFirstSeenRuleBuilderOperationMutationOptions = Apollo.BaseMutationOptions<UpdateFirstSeenRuleBuilderOperationMutation, UpdateFirstSeenRuleBuilderOperationMutationVariables>;
export const CreateTemplatedMatchRuleBuilderOperationDocument = gql`
    mutation CreateTemplatedMatchRuleBuilderOperation($fields: CreateTemplatedMatchRuleFields!) {
  createTemplatedMatchRule(fields: $fields) {
    data {
      ...TemplatedMatchRuleBuilderFields
    }
  }
}
    ${TemplatedMatchRuleBuilderFieldsFragmentDoc}`;
export type CreateTemplatedMatchRuleBuilderOperationMutationFn = Apollo.MutationFunction<CreateTemplatedMatchRuleBuilderOperationMutation, CreateTemplatedMatchRuleBuilderOperationMutationVariables>;

/**
 * __useCreateTemplatedMatchRuleBuilderOperationMutation__
 *
 * To run a mutation, you first call `useCreateTemplatedMatchRuleBuilderOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplatedMatchRuleBuilderOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplatedMatchRuleBuilderOperationMutation, { data, loading, error }] = useCreateTemplatedMatchRuleBuilderOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateTemplatedMatchRuleBuilderOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemplatedMatchRuleBuilderOperationMutation, CreateTemplatedMatchRuleBuilderOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplatedMatchRuleBuilderOperationMutation, CreateTemplatedMatchRuleBuilderOperationMutationVariables>(CreateTemplatedMatchRuleBuilderOperationDocument, options);
      }
export type CreateTemplatedMatchRuleBuilderOperationMutationHookResult = ReturnType<typeof useCreateTemplatedMatchRuleBuilderOperationMutation>;
export type CreateTemplatedMatchRuleBuilderOperationMutationResult = Apollo.MutationResult<CreateTemplatedMatchRuleBuilderOperationMutation>;
export type CreateTemplatedMatchRuleBuilderOperationMutationOptions = Apollo.BaseMutationOptions<CreateTemplatedMatchRuleBuilderOperationMutation, CreateTemplatedMatchRuleBuilderOperationMutationVariables>;
export const UpdateTemplatedMatchRuleBuilderOperationDocument = gql`
    mutation UpdateTemplatedMatchRuleBuilderOperation($includeSuppressionWindowSize: Boolean!, $fields: UpdateTemplatedMatchRuleFields!, $id: ID!) {
  updateTemplatedMatchRule(fields: $fields, id: $id) {
    data {
      suppressionWindowSize @include(if: $includeSuppressionWindowSize)
      ...TemplatedMatchRuleBuilderFields
    }
  }
}
    ${TemplatedMatchRuleBuilderFieldsFragmentDoc}`;
export type UpdateTemplatedMatchRuleBuilderOperationMutationFn = Apollo.MutationFunction<UpdateTemplatedMatchRuleBuilderOperationMutation, UpdateTemplatedMatchRuleBuilderOperationMutationVariables>;

/**
 * __useUpdateTemplatedMatchRuleBuilderOperationMutation__
 *
 * To run a mutation, you first call `useUpdateTemplatedMatchRuleBuilderOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplatedMatchRuleBuilderOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplatedMatchRuleBuilderOperationMutation, { data, loading, error }] = useUpdateTemplatedMatchRuleBuilderOperationMutation({
 *   variables: {
 *      includeSuppressionWindowSize: // value for 'includeSuppressionWindowSize'
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateTemplatedMatchRuleBuilderOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTemplatedMatchRuleBuilderOperationMutation, UpdateTemplatedMatchRuleBuilderOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplatedMatchRuleBuilderOperationMutation, UpdateTemplatedMatchRuleBuilderOperationMutationVariables>(UpdateTemplatedMatchRuleBuilderOperationDocument, options);
      }
export type UpdateTemplatedMatchRuleBuilderOperationMutationHookResult = ReturnType<typeof useUpdateTemplatedMatchRuleBuilderOperationMutation>;
export type UpdateTemplatedMatchRuleBuilderOperationMutationResult = Apollo.MutationResult<UpdateTemplatedMatchRuleBuilderOperationMutation>;
export type UpdateTemplatedMatchRuleBuilderOperationMutationOptions = Apollo.BaseMutationOptions<UpdateTemplatedMatchRuleBuilderOperationMutation, UpdateTemplatedMatchRuleBuilderOperationMutationVariables>;
export const UpdateMatchRuleBuilderOperationDocument = gql`
    mutation UpdateMatchRuleBuilderOperation($fields: UpdateMatchRuleFields!, $id: ID!) {
  updateMatchRule(fields: $fields, id: $id) {
    data {
      ...MatchRuleBuilderFields
    }
  }
}
    ${MatchRuleBuilderFieldsFragmentDoc}`;
export type UpdateMatchRuleBuilderOperationMutationFn = Apollo.MutationFunction<UpdateMatchRuleBuilderOperationMutation, UpdateMatchRuleBuilderOperationMutationVariables>;

/**
 * __useUpdateMatchRuleBuilderOperationMutation__
 *
 * To run a mutation, you first call `useUpdateMatchRuleBuilderOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMatchRuleBuilderOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMatchRuleBuilderOperationMutation, { data, loading, error }] = useUpdateMatchRuleBuilderOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateMatchRuleBuilderOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMatchRuleBuilderOperationMutation, UpdateMatchRuleBuilderOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMatchRuleBuilderOperationMutation, UpdateMatchRuleBuilderOperationMutationVariables>(UpdateMatchRuleBuilderOperationDocument, options);
      }
export type UpdateMatchRuleBuilderOperationMutationHookResult = ReturnType<typeof useUpdateMatchRuleBuilderOperationMutation>;
export type UpdateMatchRuleBuilderOperationMutationResult = Apollo.MutationResult<UpdateMatchRuleBuilderOperationMutation>;
export type UpdateMatchRuleBuilderOperationMutationOptions = Apollo.BaseMutationOptions<UpdateMatchRuleBuilderOperationMutation, UpdateMatchRuleBuilderOperationMutationVariables>;
export const CreateOutlierRuleBuilderOperationDocument = gql`
    mutation CreateOutlierRuleBuilderOperation($fields: CreateOutlierRuleFields!) {
  createOutlierRule(fields: $fields) {
    data {
      ...OutlierRuleBuilderFields
    }
  }
}
    ${OutlierRuleBuilderFieldsFragmentDoc}`;
export type CreateOutlierRuleBuilderOperationMutationFn = Apollo.MutationFunction<CreateOutlierRuleBuilderOperationMutation, CreateOutlierRuleBuilderOperationMutationVariables>;

/**
 * __useCreateOutlierRuleBuilderOperationMutation__
 *
 * To run a mutation, you first call `useCreateOutlierRuleBuilderOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOutlierRuleBuilderOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOutlierRuleBuilderOperationMutation, { data, loading, error }] = useCreateOutlierRuleBuilderOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateOutlierRuleBuilderOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOutlierRuleBuilderOperationMutation, CreateOutlierRuleBuilderOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOutlierRuleBuilderOperationMutation, CreateOutlierRuleBuilderOperationMutationVariables>(CreateOutlierRuleBuilderOperationDocument, options);
      }
export type CreateOutlierRuleBuilderOperationMutationHookResult = ReturnType<typeof useCreateOutlierRuleBuilderOperationMutation>;
export type CreateOutlierRuleBuilderOperationMutationResult = Apollo.MutationResult<CreateOutlierRuleBuilderOperationMutation>;
export type CreateOutlierRuleBuilderOperationMutationOptions = Apollo.BaseMutationOptions<CreateOutlierRuleBuilderOperationMutation, CreateOutlierRuleBuilderOperationMutationVariables>;
export const UpdateOutlierRuleBuilderOperationDocument = gql`
    mutation UpdateOutlierRuleBuilderOperation($fields: UpdateOutlierRuleFields!, $id: ID!) {
  updateOutlierRule(fields: $fields, id: $id) {
    data {
      ...OutlierRuleBuilderFields
    }
  }
}
    ${OutlierRuleBuilderFieldsFragmentDoc}`;
export type UpdateOutlierRuleBuilderOperationMutationFn = Apollo.MutationFunction<UpdateOutlierRuleBuilderOperationMutation, UpdateOutlierRuleBuilderOperationMutationVariables>;

/**
 * __useUpdateOutlierRuleBuilderOperationMutation__
 *
 * To run a mutation, you first call `useUpdateOutlierRuleBuilderOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOutlierRuleBuilderOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOutlierRuleBuilderOperationMutation, { data, loading, error }] = useUpdateOutlierRuleBuilderOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateOutlierRuleBuilderOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOutlierRuleBuilderOperationMutation, UpdateOutlierRuleBuilderOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOutlierRuleBuilderOperationMutation, UpdateOutlierRuleBuilderOperationMutationVariables>(UpdateOutlierRuleBuilderOperationDocument, options);
      }
export type UpdateOutlierRuleBuilderOperationMutationHookResult = ReturnType<typeof useUpdateOutlierRuleBuilderOperationMutation>;
export type UpdateOutlierRuleBuilderOperationMutationResult = Apollo.MutationResult<UpdateOutlierRuleBuilderOperationMutation>;
export type UpdateOutlierRuleBuilderOperationMutationOptions = Apollo.BaseMutationOptions<UpdateOutlierRuleBuilderOperationMutation, UpdateOutlierRuleBuilderOperationMutationVariables>;
export const UpdateRuleEnabledOperationDocument = gql`
    mutation UpdateRuleEnabledOperation($enabled: Boolean!, $id: ID!, $duplicated: Boolean) {
  updateRuleEnabled(enabled: $enabled, id: $id, duplicated: $duplicated) {
    ok
  }
}
    `;
export type UpdateRuleEnabledOperationMutationFn = Apollo.MutationFunction<UpdateRuleEnabledOperationMutation, UpdateRuleEnabledOperationMutationVariables>;

/**
 * __useUpdateRuleEnabledOperationMutation__
 *
 * To run a mutation, you first call `useUpdateRuleEnabledOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRuleEnabledOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRuleEnabledOperationMutation, { data, loading, error }] = useUpdateRuleEnabledOperationMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      id: // value for 'id'
 *      duplicated: // value for 'duplicated'
 *   },
 * });
 */
export function useUpdateRuleEnabledOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRuleEnabledOperationMutation, UpdateRuleEnabledOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRuleEnabledOperationMutation, UpdateRuleEnabledOperationMutationVariables>(UpdateRuleEnabledOperationDocument, options);
      }
export type UpdateRuleEnabledOperationMutationHookResult = ReturnType<typeof useUpdateRuleEnabledOperationMutation>;
export type UpdateRuleEnabledOperationMutationResult = Apollo.MutationResult<UpdateRuleEnabledOperationMutation>;
export type UpdateRuleEnabledOperationMutationOptions = Apollo.BaseMutationOptions<UpdateRuleEnabledOperationMutation, UpdateRuleEnabledOperationMutationVariables>;
export const RulesListQueryOperationDocument = gql`
    query RulesListQueryOperation($q: String, $offset: Int, $limit: Int, $sort: RuleSortableField!, $sortDir: SortDir!) {
  rules(
    q: $q
    offset: $offset
    limit: $limit
    sort: [{field: $sort, direction: $sortDir}]
  ) {
    total
    hasNextPage
    objects {
      ...RuleFragment
    }
  }
}
    ${RuleFragmentDoc}`;

/**
 * __useRulesListQueryOperation__
 *
 * To run a query within a React component, call `useRulesListQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useRulesListQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRulesListQueryOperation({
 *   variables: {
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useRulesListQueryOperation(baseOptions: Apollo.QueryHookOptions<RulesListQueryOperationQuery, RulesListQueryOperationQueryVariables> & ({ variables: RulesListQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RulesListQueryOperationQuery, RulesListQueryOperationQueryVariables>(RulesListQueryOperationDocument, options);
      }
export function useRulesListQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RulesListQueryOperationQuery, RulesListQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RulesListQueryOperationQuery, RulesListQueryOperationQueryVariables>(RulesListQueryOperationDocument, options);
        }
export function useRulesListQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RulesListQueryOperationQuery, RulesListQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RulesListQueryOperationQuery, RulesListQueryOperationQueryVariables>(RulesListQueryOperationDocument, options);
        }
export type RulesListQueryOperationHookResult = ReturnType<typeof useRulesListQueryOperation>;
export type RulesListQueryOperationLazyQueryHookResult = ReturnType<typeof useRulesListQueryOperationLazyQuery>;
export type RulesListQueryOperationSuspenseQueryHookResult = ReturnType<typeof useRulesListQueryOperationSuspenseQuery>;
export type RulesListQueryOperationQueryResult = Apollo.QueryResult<RulesListQueryOperationQuery, RulesListQueryOperationQueryVariables>;
export const UploadListItemsToListOperationDocument = gql`
    mutation UploadListItemsToListOperation($listId: String!, $expiration: DateTime, $file: Upload!) {
  uploadItemsToList(listId: $listId, expiration: $expiration, file: $file) {
    uploadedItemCount
  }
}
    `;
export type UploadListItemsToListOperationMutationFn = Apollo.MutationFunction<UploadListItemsToListOperationMutation, UploadListItemsToListOperationMutationVariables>;

/**
 * __useUploadListItemsToListOperationMutation__
 *
 * To run a mutation, you first call `useUploadListItemsToListOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadListItemsToListOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadListItemsToListOperationMutation, { data, loading, error }] = useUploadListItemsToListOperationMutation({
 *   variables: {
 *      listId: // value for 'listId'
 *      expiration: // value for 'expiration'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadListItemsToListOperationMutation(baseOptions?: Apollo.MutationHookOptions<UploadListItemsToListOperationMutation, UploadListItemsToListOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadListItemsToListOperationMutation, UploadListItemsToListOperationMutationVariables>(UploadListItemsToListOperationDocument, options);
      }
export type UploadListItemsToListOperationMutationHookResult = ReturnType<typeof useUploadListItemsToListOperationMutation>;
export type UploadListItemsToListOperationMutationResult = Apollo.MutationResult<UploadListItemsToListOperationMutation>;
export type UploadListItemsToListOperationMutationOptions = Apollo.BaseMutationOptions<UploadListItemsToListOperationMutation, UploadListItemsToListOperationMutationVariables>;
export const SuppressedListOperationDocument = gql`
    query SuppressedListOperation($id: ID!) {
  suppressList(id: $id) {
    ...SuppressList
  }
}
    ${SuppressListFragmentDoc}`;

/**
 * __useSuppressedListOperationQuery__
 *
 * To run a query within a React component, call `useSuppressedListOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppressedListOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppressedListOperationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSuppressedListOperationQuery(baseOptions: Apollo.QueryHookOptions<SuppressedListOperationQuery, SuppressedListOperationQueryVariables> & ({ variables: SuppressedListOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuppressedListOperationQuery, SuppressedListOperationQueryVariables>(SuppressedListOperationDocument, options);
      }
export function useSuppressedListOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuppressedListOperationQuery, SuppressedListOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuppressedListOperationQuery, SuppressedListOperationQueryVariables>(SuppressedListOperationDocument, options);
        }
export function useSuppressedListOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuppressedListOperationQuery, SuppressedListOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuppressedListOperationQuery, SuppressedListOperationQueryVariables>(SuppressedListOperationDocument, options);
        }
export type SuppressedListOperationQueryHookResult = ReturnType<typeof useSuppressedListOperationQuery>;
export type SuppressedListOperationLazyQueryHookResult = ReturnType<typeof useSuppressedListOperationLazyQuery>;
export type SuppressedListOperationSuspenseQueryHookResult = ReturnType<typeof useSuppressedListOperationSuspenseQuery>;
export type SuppressedListOperationQueryResult = Apollo.QueryResult<SuppressedListOperationQuery, SuppressedListOperationQueryVariables>;
export const SuppressedListItemsOperationDocument = gql`
    query SuppressedListItemsOperation($offset: Int, $limit: Int, $listIds: [String!], $q: String!, $sort: SuppressListItemSortableField!, $sortDir: SortDir!) {
  suppressListItems(
    offset: $offset
    limit: $limit
    listIds: $listIds
    q: $q
    sort: [{field: $sort, direction: $sortDir}]
  ) {
    total
    hasNextPage
    objects {
      ...SuppressListItem
    }
  }
}
    ${SuppressListItemFragmentDoc}`;

/**
 * __useSuppressedListItemsOperationQuery__
 *
 * To run a query within a React component, call `useSuppressedListItemsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppressedListItemsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppressedListItemsOperationQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      listIds: // value for 'listIds'
 *      q: // value for 'q'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useSuppressedListItemsOperationQuery(baseOptions: Apollo.QueryHookOptions<SuppressedListItemsOperationQuery, SuppressedListItemsOperationQueryVariables> & ({ variables: SuppressedListItemsOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuppressedListItemsOperationQuery, SuppressedListItemsOperationQueryVariables>(SuppressedListItemsOperationDocument, options);
      }
export function useSuppressedListItemsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuppressedListItemsOperationQuery, SuppressedListItemsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuppressedListItemsOperationQuery, SuppressedListItemsOperationQueryVariables>(SuppressedListItemsOperationDocument, options);
        }
export function useSuppressedListItemsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuppressedListItemsOperationQuery, SuppressedListItemsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuppressedListItemsOperationQuery, SuppressedListItemsOperationQueryVariables>(SuppressedListItemsOperationDocument, options);
        }
export type SuppressedListItemsOperationQueryHookResult = ReturnType<typeof useSuppressedListItemsOperationQuery>;
export type SuppressedListItemsOperationLazyQueryHookResult = ReturnType<typeof useSuppressedListItemsOperationLazyQuery>;
export type SuppressedListItemsOperationSuspenseQueryHookResult = ReturnType<typeof useSuppressedListItemsOperationSuspenseQuery>;
export type SuppressedListItemsOperationQueryResult = Apollo.QueryResult<SuppressedListItemsOperationQuery, SuppressedListItemsOperationQueryVariables>;
export const SuppressedListsOperationDocument = gql`
    query SuppressedListsOperation($offset: Int!, $limit: Int!, $sort: String!, $sortDir: SortDir!) {
  suppressLists(offset: $offset, limit: $limit, sort: $sort, sortDir: $sortDir) {
    total
    hasNextPage
    objects {
      ...SuppressList
    }
  }
  suppressListItemLimit
  suppressListItemCount
}
    ${SuppressListFragmentDoc}`;

/**
 * __useSuppressedListsOperationQuery__
 *
 * To run a query within a React component, call `useSuppressedListsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppressedListsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppressedListsOperationQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useSuppressedListsOperationQuery(baseOptions: Apollo.QueryHookOptions<SuppressedListsOperationQuery, SuppressedListsOperationQueryVariables> & ({ variables: SuppressedListsOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuppressedListsOperationQuery, SuppressedListsOperationQueryVariables>(SuppressedListsOperationDocument, options);
      }
export function useSuppressedListsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuppressedListsOperationQuery, SuppressedListsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuppressedListsOperationQuery, SuppressedListsOperationQueryVariables>(SuppressedListsOperationDocument, options);
        }
export function useSuppressedListsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuppressedListsOperationQuery, SuppressedListsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuppressedListsOperationQuery, SuppressedListsOperationQueryVariables>(SuppressedListsOperationDocument, options);
        }
export type SuppressedListsOperationQueryHookResult = ReturnType<typeof useSuppressedListsOperationQuery>;
export type SuppressedListsOperationLazyQueryHookResult = ReturnType<typeof useSuppressedListsOperationLazyQuery>;
export type SuppressedListsOperationSuspenseQueryHookResult = ReturnType<typeof useSuppressedListsOperationSuspenseQuery>;
export type SuppressedListsOperationQueryResult = Apollo.QueryResult<SuppressedListsOperationQuery, SuppressedListsOperationQueryVariables>;
export const DeleteSuppressedListItemOperationDocument = gql`
    mutation DeleteSuppressedListItemOperation($id: ID!) {
  deleteSuppressListItem(id: $id) {
    ok
  }
}
    `;
export type DeleteSuppressedListItemOperationMutationFn = Apollo.MutationFunction<DeleteSuppressedListItemOperationMutation, DeleteSuppressedListItemOperationMutationVariables>;

/**
 * __useDeleteSuppressedListItemOperationMutation__
 *
 * To run a mutation, you first call `useDeleteSuppressedListItemOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSuppressedListItemOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSuppressedListItemOperationMutation, { data, loading, error }] = useDeleteSuppressedListItemOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSuppressedListItemOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSuppressedListItemOperationMutation, DeleteSuppressedListItemOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSuppressedListItemOperationMutation, DeleteSuppressedListItemOperationMutationVariables>(DeleteSuppressedListItemOperationDocument, options);
      }
export type DeleteSuppressedListItemOperationMutationHookResult = ReturnType<typeof useDeleteSuppressedListItemOperationMutation>;
export type DeleteSuppressedListItemOperationMutationResult = Apollo.MutationResult<DeleteSuppressedListItemOperationMutation>;
export type DeleteSuppressedListItemOperationMutationOptions = Apollo.BaseMutationOptions<DeleteSuppressedListItemOperationMutation, DeleteSuppressedListItemOperationMutationVariables>;
export const AddItemToSuppressedListOperationDocument = gql`
    mutation AddItemToSuppressedListOperation($listId: ID!, $itemFields: SuppressListItemFields!) {
  addItemToSuppressList(listId: $listId, itemFields: $itemFields) {
    data {
      ...SuppressListItem
    }
    finishedProcessing
  }
}
    ${SuppressListItemFragmentDoc}`;
export type AddItemToSuppressedListOperationMutationFn = Apollo.MutationFunction<AddItemToSuppressedListOperationMutation, AddItemToSuppressedListOperationMutationVariables>;

/**
 * __useAddItemToSuppressedListOperationMutation__
 *
 * To run a mutation, you first call `useAddItemToSuppressedListOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemToSuppressedListOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemToSuppressedListOperationMutation, { data, loading, error }] = useAddItemToSuppressedListOperationMutation({
 *   variables: {
 *      listId: // value for 'listId'
 *      itemFields: // value for 'itemFields'
 *   },
 * });
 */
export function useAddItemToSuppressedListOperationMutation(baseOptions?: Apollo.MutationHookOptions<AddItemToSuppressedListOperationMutation, AddItemToSuppressedListOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddItemToSuppressedListOperationMutation, AddItemToSuppressedListOperationMutationVariables>(AddItemToSuppressedListOperationDocument, options);
      }
export type AddItemToSuppressedListOperationMutationHookResult = ReturnType<typeof useAddItemToSuppressedListOperationMutation>;
export type AddItemToSuppressedListOperationMutationResult = Apollo.MutationResult<AddItemToSuppressedListOperationMutation>;
export type AddItemToSuppressedListOperationMutationOptions = Apollo.BaseMutationOptions<AddItemToSuppressedListOperationMutation, AddItemToSuppressedListOperationMutationVariables>;
export const UpdateSuppressedListItemOperationDocument = gql`
    mutation UpdateSuppressedListItemOperation($id: ID!, $fields: UpdatableSuppressListItemFields!) {
  updateSuppressListItem(id: $id, fields: $fields) {
    data {
      ...SuppressListItem
    }
    finishedProcessing
  }
}
    ${SuppressListItemFragmentDoc}`;
export type UpdateSuppressedListItemOperationMutationFn = Apollo.MutationFunction<UpdateSuppressedListItemOperationMutation, UpdateSuppressedListItemOperationMutationVariables>;

/**
 * __useUpdateSuppressedListItemOperationMutation__
 *
 * To run a mutation, you first call `useUpdateSuppressedListItemOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSuppressedListItemOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSuppressedListItemOperationMutation, { data, loading, error }] = useUpdateSuppressedListItemOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateSuppressedListItemOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSuppressedListItemOperationMutation, UpdateSuppressedListItemOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSuppressedListItemOperationMutation, UpdateSuppressedListItemOperationMutationVariables>(UpdateSuppressedListItemOperationDocument, options);
      }
export type UpdateSuppressedListItemOperationMutationHookResult = ReturnType<typeof useUpdateSuppressedListItemOperationMutation>;
export type UpdateSuppressedListItemOperationMutationResult = Apollo.MutationResult<UpdateSuppressedListItemOperationMutation>;
export type UpdateSuppressedListItemOperationMutationOptions = Apollo.BaseMutationOptions<UpdateSuppressedListItemOperationMutation, UpdateSuppressedListItemOperationMutationVariables>;
export const DeleteSuppressedListOperationDocument = gql`
    mutation DeleteSuppressedListOperation($id: ID!) {
  deleteSuppressList(id: $id) {
    ok
  }
}
    `;
export type DeleteSuppressedListOperationMutationFn = Apollo.MutationFunction<DeleteSuppressedListOperationMutation, DeleteSuppressedListOperationMutationVariables>;

/**
 * __useDeleteSuppressedListOperationMutation__
 *
 * To run a mutation, you first call `useDeleteSuppressedListOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSuppressedListOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSuppressedListOperationMutation, { data, loading, error }] = useDeleteSuppressedListOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSuppressedListOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSuppressedListOperationMutation, DeleteSuppressedListOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSuppressedListOperationMutation, DeleteSuppressedListOperationMutationVariables>(DeleteSuppressedListOperationDocument, options);
      }
export type DeleteSuppressedListOperationMutationHookResult = ReturnType<typeof useDeleteSuppressedListOperationMutation>;
export type DeleteSuppressedListOperationMutationResult = Apollo.MutationResult<DeleteSuppressedListOperationMutation>;
export type DeleteSuppressedListOperationMutationOptions = Apollo.BaseMutationOptions<DeleteSuppressedListOperationMutation, DeleteSuppressedListOperationMutationVariables>;
export const CreateSuppressedListOperationDocument = gql`
    mutation CreateSuppressedListOperation($fields: SuppressListFields!) {
  createSuppressList(fields: $fields) {
    data {
      ...SuppressList
    }
  }
}
    ${SuppressListFragmentDoc}`;
export type CreateSuppressedListOperationMutationFn = Apollo.MutationFunction<CreateSuppressedListOperationMutation, CreateSuppressedListOperationMutationVariables>;

/**
 * __useCreateSuppressedListOperationMutation__
 *
 * To run a mutation, you first call `useCreateSuppressedListOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSuppressedListOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSuppressedListOperationMutation, { data, loading, error }] = useCreateSuppressedListOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateSuppressedListOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSuppressedListOperationMutation, CreateSuppressedListOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSuppressedListOperationMutation, CreateSuppressedListOperationMutationVariables>(CreateSuppressedListOperationDocument, options);
      }
export type CreateSuppressedListOperationMutationHookResult = ReturnType<typeof useCreateSuppressedListOperationMutation>;
export type CreateSuppressedListOperationMutationResult = Apollo.MutationResult<CreateSuppressedListOperationMutation>;
export type CreateSuppressedListOperationMutationOptions = Apollo.BaseMutationOptions<CreateSuppressedListOperationMutation, CreateSuppressedListOperationMutationVariables>;
export const UpdateSuppressedListOperationDocument = gql`
    mutation UpdateSuppressedListOperation($fields: UpdatableSuppressListFields!, $id: ID!) {
  updateSuppressList(fields: $fields, id: $id) {
    data {
      ...SuppressList
    }
  }
}
    ${SuppressListFragmentDoc}`;
export type UpdateSuppressedListOperationMutationFn = Apollo.MutationFunction<UpdateSuppressedListOperationMutation, UpdateSuppressedListOperationMutationVariables>;

/**
 * __useUpdateSuppressedListOperationMutation__
 *
 * To run a mutation, you first call `useUpdateSuppressedListOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSuppressedListOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSuppressedListOperationMutation, { data, loading, error }] = useUpdateSuppressedListOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateSuppressedListOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSuppressedListOperationMutation, UpdateSuppressedListOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSuppressedListOperationMutation, UpdateSuppressedListOperationMutationVariables>(UpdateSuppressedListOperationDocument, options);
      }
export type UpdateSuppressedListOperationMutationHookResult = ReturnType<typeof useUpdateSuppressedListOperationMutation>;
export type UpdateSuppressedListOperationMutationResult = Apollo.MutationResult<UpdateSuppressedListOperationMutation>;
export type UpdateSuppressedListOperationMutationOptions = Apollo.BaseMutationOptions<UpdateSuppressedListOperationMutation, UpdateSuppressedListOperationMutationVariables>;
export const SuppressedListSelectOperationDocument = gql`
    query SuppressedListSelectOperation($offset: Int, $limit: Int, $sort: String!, $sortDir: SortDir!) {
  suppressLists(offset: $offset, limit: $limit, sort: $sort, sortDir: $sortDir) {
    total
    objects {
      ...SuppressListSelectFragment
    }
  }
}
    ${SuppressListSelectFragmentDoc}`;

/**
 * __useSuppressedListSelectOperationQuery__
 *
 * To run a query within a React component, call `useSuppressedListSelectOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuppressedListSelectOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppressedListSelectOperationQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useSuppressedListSelectOperationQuery(baseOptions: Apollo.QueryHookOptions<SuppressedListSelectOperationQuery, SuppressedListSelectOperationQueryVariables> & ({ variables: SuppressedListSelectOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuppressedListSelectOperationQuery, SuppressedListSelectOperationQueryVariables>(SuppressedListSelectOperationDocument, options);
      }
export function useSuppressedListSelectOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuppressedListSelectOperationQuery, SuppressedListSelectOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuppressedListSelectOperationQuery, SuppressedListSelectOperationQueryVariables>(SuppressedListSelectOperationDocument, options);
        }
export function useSuppressedListSelectOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuppressedListSelectOperationQuery, SuppressedListSelectOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuppressedListSelectOperationQuery, SuppressedListSelectOperationQueryVariables>(SuppressedListSelectOperationDocument, options);
        }
export type SuppressedListSelectOperationQueryHookResult = ReturnType<typeof useSuppressedListSelectOperationQuery>;
export type SuppressedListSelectOperationLazyQueryHookResult = ReturnType<typeof useSuppressedListSelectOperationLazyQuery>;
export type SuppressedListSelectOperationSuspenseQueryHookResult = ReturnType<typeof useSuppressedListSelectOperationSuspenseQuery>;
export type SuppressedListSelectOperationQueryResult = Apollo.QueryResult<SuppressedListSelectOperationQuery, SuppressedListSelectOperationQueryVariables>;
export const ThreatIntelItemEditorOperationDocument = gql`
    query ThreatIntelItemEditorOperation($itemId: ID!, $fetchItem: Boolean!) {
  threatIntelItem(id: $itemId) @include(if: $fetchItem) {
    ...ThreatIntelItem
  }
}
    ${ThreatIntelItemFragmentDoc}`;

/**
 * __useThreatIntelItemEditorOperationQuery__
 *
 * To run a query within a React component, call `useThreatIntelItemEditorOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useThreatIntelItemEditorOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThreatIntelItemEditorOperationQuery({
 *   variables: {
 *      itemId: // value for 'itemId'
 *      fetchItem: // value for 'fetchItem'
 *   },
 * });
 */
export function useThreatIntelItemEditorOperationQuery(baseOptions: Apollo.QueryHookOptions<ThreatIntelItemEditorOperationQuery, ThreatIntelItemEditorOperationQueryVariables> & ({ variables: ThreatIntelItemEditorOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThreatIntelItemEditorOperationQuery, ThreatIntelItemEditorOperationQueryVariables>(ThreatIntelItemEditorOperationDocument, options);
      }
export function useThreatIntelItemEditorOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThreatIntelItemEditorOperationQuery, ThreatIntelItemEditorOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThreatIntelItemEditorOperationQuery, ThreatIntelItemEditorOperationQueryVariables>(ThreatIntelItemEditorOperationDocument, options);
        }
export function useThreatIntelItemEditorOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThreatIntelItemEditorOperationQuery, ThreatIntelItemEditorOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThreatIntelItemEditorOperationQuery, ThreatIntelItemEditorOperationQueryVariables>(ThreatIntelItemEditorOperationDocument, options);
        }
export type ThreatIntelItemEditorOperationQueryHookResult = ReturnType<typeof useThreatIntelItemEditorOperationQuery>;
export type ThreatIntelItemEditorOperationLazyQueryHookResult = ReturnType<typeof useThreatIntelItemEditorOperationLazyQuery>;
export type ThreatIntelItemEditorOperationSuspenseQueryHookResult = ReturnType<typeof useThreatIntelItemEditorOperationSuspenseQuery>;
export type ThreatIntelItemEditorOperationQueryResult = Apollo.QueryResult<ThreatIntelItemEditorOperationQuery, ThreatIntelItemEditorOperationQueryVariables>;
export const AddItemToThreatIntelSourceOperationDocument = gql`
    mutation AddItemToThreatIntelSourceOperation($threatIntelSourceId: ID!, $itemFields: ThreatIntelItemFields!) {
  addItemToThreatIntelSource(
    threatIntelSourceId: $threatIntelSourceId
    itemFields: $itemFields
  ) {
    data {
      ...ThreatIntelItem
    }
  }
}
    ${ThreatIntelItemFragmentDoc}`;
export type AddItemToThreatIntelSourceOperationMutationFn = Apollo.MutationFunction<AddItemToThreatIntelSourceOperationMutation, AddItemToThreatIntelSourceOperationMutationVariables>;

/**
 * __useAddItemToThreatIntelSourceOperationMutation__
 *
 * To run a mutation, you first call `useAddItemToThreatIntelSourceOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddItemToThreatIntelSourceOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addItemToThreatIntelSourceOperationMutation, { data, loading, error }] = useAddItemToThreatIntelSourceOperationMutation({
 *   variables: {
 *      threatIntelSourceId: // value for 'threatIntelSourceId'
 *      itemFields: // value for 'itemFields'
 *   },
 * });
 */
export function useAddItemToThreatIntelSourceOperationMutation(baseOptions?: Apollo.MutationHookOptions<AddItemToThreatIntelSourceOperationMutation, AddItemToThreatIntelSourceOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddItemToThreatIntelSourceOperationMutation, AddItemToThreatIntelSourceOperationMutationVariables>(AddItemToThreatIntelSourceOperationDocument, options);
      }
export type AddItemToThreatIntelSourceOperationMutationHookResult = ReturnType<typeof useAddItemToThreatIntelSourceOperationMutation>;
export type AddItemToThreatIntelSourceOperationMutationResult = Apollo.MutationResult<AddItemToThreatIntelSourceOperationMutation>;
export type AddItemToThreatIntelSourceOperationMutationOptions = Apollo.BaseMutationOptions<AddItemToThreatIntelSourceOperationMutation, AddItemToThreatIntelSourceOperationMutationVariables>;
export const UpdateThreatIntelItemOperationDocument = gql`
    mutation UpdateThreatIntelItemOperation($id: ID!, $fields: UpdatableThreatIntelItemFields!) {
  updateThreatIntelItem(id: $id, fields: $fields) {
    data {
      ...ThreatIntelItem
    }
    finishedProcessing
  }
}
    ${ThreatIntelItemFragmentDoc}`;
export type UpdateThreatIntelItemOperationMutationFn = Apollo.MutationFunction<UpdateThreatIntelItemOperationMutation, UpdateThreatIntelItemOperationMutationVariables>;

/**
 * __useUpdateThreatIntelItemOperationMutation__
 *
 * To run a mutation, you first call `useUpdateThreatIntelItemOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThreatIntelItemOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThreatIntelItemOperationMutation, { data, loading, error }] = useUpdateThreatIntelItemOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateThreatIntelItemOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThreatIntelItemOperationMutation, UpdateThreatIntelItemOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateThreatIntelItemOperationMutation, UpdateThreatIntelItemOperationMutationVariables>(UpdateThreatIntelItemOperationDocument, options);
      }
export type UpdateThreatIntelItemOperationMutationHookResult = ReturnType<typeof useUpdateThreatIntelItemOperationMutation>;
export type UpdateThreatIntelItemOperationMutationResult = Apollo.MutationResult<UpdateThreatIntelItemOperationMutation>;
export type UpdateThreatIntelItemOperationMutationOptions = Apollo.BaseMutationOptions<UpdateThreatIntelItemOperationMutation, UpdateThreatIntelItemOperationMutationVariables>;
export const ThreatIntelItemsSearchOperationDocument = gql`
    query ThreatIntelItemsSearchOperation($offset: Int, $limit: Int, $sort: ThreatIntelItemSortableField!, $sortDir: SortDir!, $q: String!) {
  threatIntelItems: threatIntelItems2(
    offset: $offset
    limit: $limit
    sort: [{field: $sort, direction: $sortDir}]
    q: $q
  ) {
    total
    hasNextPage
    objects {
      ...ThreatIntelSearchItem
    }
  }
}
    ${ThreatIntelSearchItemFragmentDoc}`;

/**
 * __useThreatIntelItemsSearchOperationQuery__
 *
 * To run a query within a React component, call `useThreatIntelItemsSearchOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useThreatIntelItemsSearchOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThreatIntelItemsSearchOperationQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useThreatIntelItemsSearchOperationQuery(baseOptions: Apollo.QueryHookOptions<ThreatIntelItemsSearchOperationQuery, ThreatIntelItemsSearchOperationQueryVariables> & ({ variables: ThreatIntelItemsSearchOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThreatIntelItemsSearchOperationQuery, ThreatIntelItemsSearchOperationQueryVariables>(ThreatIntelItemsSearchOperationDocument, options);
      }
export function useThreatIntelItemsSearchOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThreatIntelItemsSearchOperationQuery, ThreatIntelItemsSearchOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThreatIntelItemsSearchOperationQuery, ThreatIntelItemsSearchOperationQueryVariables>(ThreatIntelItemsSearchOperationDocument, options);
        }
export function useThreatIntelItemsSearchOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThreatIntelItemsSearchOperationQuery, ThreatIntelItemsSearchOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThreatIntelItemsSearchOperationQuery, ThreatIntelItemsSearchOperationQueryVariables>(ThreatIntelItemsSearchOperationDocument, options);
        }
export type ThreatIntelItemsSearchOperationQueryHookResult = ReturnType<typeof useThreatIntelItemsSearchOperationQuery>;
export type ThreatIntelItemsSearchOperationLazyQueryHookResult = ReturnType<typeof useThreatIntelItemsSearchOperationLazyQuery>;
export type ThreatIntelItemsSearchOperationSuspenseQueryHookResult = ReturnType<typeof useThreatIntelItemsSearchOperationSuspenseQuery>;
export type ThreatIntelItemsSearchOperationQueryResult = Apollo.QueryResult<ThreatIntelItemsSearchOperationQuery, ThreatIntelItemsSearchOperationQueryVariables>;
export const UploadItemsToThreatIntelSourceOperationDocument = gql`
    mutation UploadItemsToThreatIntelSourceOperation($threatIntelSourceId: String!, $expiration: DateTime, $file: Upload!) {
  uploadItemsToThreatIntelSource(
    threatIntelSourceId: $threatIntelSourceId
    expiration: $expiration
    file: $file
  ) {
    uploadedItemCount
  }
}
    `;
export type UploadItemsToThreatIntelSourceOperationMutationFn = Apollo.MutationFunction<UploadItemsToThreatIntelSourceOperationMutation, UploadItemsToThreatIntelSourceOperationMutationVariables>;

/**
 * __useUploadItemsToThreatIntelSourceOperationMutation__
 *
 * To run a mutation, you first call `useUploadItemsToThreatIntelSourceOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadItemsToThreatIntelSourceOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadItemsToThreatIntelSourceOperationMutation, { data, loading, error }] = useUploadItemsToThreatIntelSourceOperationMutation({
 *   variables: {
 *      threatIntelSourceId: // value for 'threatIntelSourceId'
 *      expiration: // value for 'expiration'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadItemsToThreatIntelSourceOperationMutation(baseOptions?: Apollo.MutationHookOptions<UploadItemsToThreatIntelSourceOperationMutation, UploadItemsToThreatIntelSourceOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadItemsToThreatIntelSourceOperationMutation, UploadItemsToThreatIntelSourceOperationMutationVariables>(UploadItemsToThreatIntelSourceOperationDocument, options);
      }
export type UploadItemsToThreatIntelSourceOperationMutationHookResult = ReturnType<typeof useUploadItemsToThreatIntelSourceOperationMutation>;
export type UploadItemsToThreatIntelSourceOperationMutationResult = Apollo.MutationResult<UploadItemsToThreatIntelSourceOperationMutation>;
export type UploadItemsToThreatIntelSourceOperationMutationOptions = Apollo.BaseMutationOptions<UploadItemsToThreatIntelSourceOperationMutation, UploadItemsToThreatIntelSourceOperationMutationVariables>;
export const DeleteThreatIntelSourceOperationDocument = gql`
    mutation DeleteThreatIntelSourceOperation($id: ID!) {
  deleteThreatIntelSource(id: $id) {
    ok
  }
}
    `;
export type DeleteThreatIntelSourceOperationMutationFn = Apollo.MutationFunction<DeleteThreatIntelSourceOperationMutation, DeleteThreatIntelSourceOperationMutationVariables>;

/**
 * __useDeleteThreatIntelSourceOperationMutation__
 *
 * To run a mutation, you first call `useDeleteThreatIntelSourceOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThreatIntelSourceOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThreatIntelSourceOperationMutation, { data, loading, error }] = useDeleteThreatIntelSourceOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteThreatIntelSourceOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteThreatIntelSourceOperationMutation, DeleteThreatIntelSourceOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteThreatIntelSourceOperationMutation, DeleteThreatIntelSourceOperationMutationVariables>(DeleteThreatIntelSourceOperationDocument, options);
      }
export type DeleteThreatIntelSourceOperationMutationHookResult = ReturnType<typeof useDeleteThreatIntelSourceOperationMutation>;
export type DeleteThreatIntelSourceOperationMutationResult = Apollo.MutationResult<DeleteThreatIntelSourceOperationMutation>;
export type DeleteThreatIntelSourceOperationMutationOptions = Apollo.BaseMutationOptions<DeleteThreatIntelSourceOperationMutation, DeleteThreatIntelSourceOperationMutationVariables>;
export const ThreatIntelSourceDetailOperationDocument = gql`
    query ThreatIntelSourceDetailOperation($id: ID!) {
  threatIntelSource(id: $id) {
    ...ThreatIntelSource
  }
}
    ${ThreatIntelSourceFragmentDoc}`;

/**
 * __useThreatIntelSourceDetailOperationQuery__
 *
 * To run a query within a React component, call `useThreatIntelSourceDetailOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useThreatIntelSourceDetailOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThreatIntelSourceDetailOperationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useThreatIntelSourceDetailOperationQuery(baseOptions: Apollo.QueryHookOptions<ThreatIntelSourceDetailOperationQuery, ThreatIntelSourceDetailOperationQueryVariables> & ({ variables: ThreatIntelSourceDetailOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThreatIntelSourceDetailOperationQuery, ThreatIntelSourceDetailOperationQueryVariables>(ThreatIntelSourceDetailOperationDocument, options);
      }
export function useThreatIntelSourceDetailOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThreatIntelSourceDetailOperationQuery, ThreatIntelSourceDetailOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThreatIntelSourceDetailOperationQuery, ThreatIntelSourceDetailOperationQueryVariables>(ThreatIntelSourceDetailOperationDocument, options);
        }
export function useThreatIntelSourceDetailOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThreatIntelSourceDetailOperationQuery, ThreatIntelSourceDetailOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThreatIntelSourceDetailOperationQuery, ThreatIntelSourceDetailOperationQueryVariables>(ThreatIntelSourceDetailOperationDocument, options);
        }
export type ThreatIntelSourceDetailOperationQueryHookResult = ReturnType<typeof useThreatIntelSourceDetailOperationQuery>;
export type ThreatIntelSourceDetailOperationLazyQueryHookResult = ReturnType<typeof useThreatIntelSourceDetailOperationLazyQuery>;
export type ThreatIntelSourceDetailOperationSuspenseQueryHookResult = ReturnType<typeof useThreatIntelSourceDetailOperationSuspenseQuery>;
export type ThreatIntelSourceDetailOperationQueryResult = Apollo.QueryResult<ThreatIntelSourceDetailOperationQuery, ThreatIntelSourceDetailOperationQueryVariables>;
export const ThreatIntelItemsOperationDocument = gql`
    query ThreatIntelItemsOperation($sourceIds: [String!], $offset: Int, $limit: Int, $sort: ThreatIntelItemSortableField!, $sortDir: SortDir!, $q: String!) {
  threatIntelItems: threatIntelItems2(
    sourceIds: $sourceIds
    offset: $offset
    limit: $limit
    sort: [{field: $sort, direction: $sortDir}]
    q: $q
  ) {
    total
    hasNextPage
    objects {
      ...ThreatIntelItem
    }
  }
}
    ${ThreatIntelItemFragmentDoc}`;

/**
 * __useThreatIntelItemsOperationQuery__
 *
 * To run a query within a React component, call `useThreatIntelItemsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useThreatIntelItemsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThreatIntelItemsOperationQuery({
 *   variables: {
 *      sourceIds: // value for 'sourceIds'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *      q: // value for 'q'
 *   },
 * });
 */
export function useThreatIntelItemsOperationQuery(baseOptions: Apollo.QueryHookOptions<ThreatIntelItemsOperationQuery, ThreatIntelItemsOperationQueryVariables> & ({ variables: ThreatIntelItemsOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThreatIntelItemsOperationQuery, ThreatIntelItemsOperationQueryVariables>(ThreatIntelItemsOperationDocument, options);
      }
export function useThreatIntelItemsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThreatIntelItemsOperationQuery, ThreatIntelItemsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThreatIntelItemsOperationQuery, ThreatIntelItemsOperationQueryVariables>(ThreatIntelItemsOperationDocument, options);
        }
export function useThreatIntelItemsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThreatIntelItemsOperationQuery, ThreatIntelItemsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThreatIntelItemsOperationQuery, ThreatIntelItemsOperationQueryVariables>(ThreatIntelItemsOperationDocument, options);
        }
export type ThreatIntelItemsOperationQueryHookResult = ReturnType<typeof useThreatIntelItemsOperationQuery>;
export type ThreatIntelItemsOperationLazyQueryHookResult = ReturnType<typeof useThreatIntelItemsOperationLazyQuery>;
export type ThreatIntelItemsOperationSuspenseQueryHookResult = ReturnType<typeof useThreatIntelItemsOperationSuspenseQuery>;
export type ThreatIntelItemsOperationQueryResult = Apollo.QueryResult<ThreatIntelItemsOperationQuery, ThreatIntelItemsOperationQueryVariables>;
export const CreateCustomThreatIntelSourceOperationDocument = gql`
    mutation CreateCustomThreatIntelSourceOperation($fields: CustomThreatIntelSourceFields!) {
  createCustomThreatIntelSource(fields: $fields) {
    data {
      ...ThreatIntelSource
    }
  }
}
    ${ThreatIntelSourceFragmentDoc}`;
export type CreateCustomThreatIntelSourceOperationMutationFn = Apollo.MutationFunction<CreateCustomThreatIntelSourceOperationMutation, CreateCustomThreatIntelSourceOperationMutationVariables>;

/**
 * __useCreateCustomThreatIntelSourceOperationMutation__
 *
 * To run a mutation, you first call `useCreateCustomThreatIntelSourceOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomThreatIntelSourceOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomThreatIntelSourceOperationMutation, { data, loading, error }] = useCreateCustomThreatIntelSourceOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateCustomThreatIntelSourceOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomThreatIntelSourceOperationMutation, CreateCustomThreatIntelSourceOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomThreatIntelSourceOperationMutation, CreateCustomThreatIntelSourceOperationMutationVariables>(CreateCustomThreatIntelSourceOperationDocument, options);
      }
export type CreateCustomThreatIntelSourceOperationMutationHookResult = ReturnType<typeof useCreateCustomThreatIntelSourceOperationMutation>;
export type CreateCustomThreatIntelSourceOperationMutationResult = Apollo.MutationResult<CreateCustomThreatIntelSourceOperationMutation>;
export type CreateCustomThreatIntelSourceOperationMutationOptions = Apollo.BaseMutationOptions<CreateCustomThreatIntelSourceOperationMutation, CreateCustomThreatIntelSourceOperationMutationVariables>;
export const UpdateCustomThreatIntelSourceOperationDocument = gql`
    mutation UpdateCustomThreatIntelSourceOperation($id: ID!, $fields: UpdatableCustomThreatIntelSourceFields!) {
  updateCustomThreatIntelSource(id: $id, fields: $fields) {
    data {
      ...ThreatIntelSource
    }
  }
}
    ${ThreatIntelSourceFragmentDoc}`;
export type UpdateCustomThreatIntelSourceOperationMutationFn = Apollo.MutationFunction<UpdateCustomThreatIntelSourceOperationMutation, UpdateCustomThreatIntelSourceOperationMutationVariables>;

/**
 * __useUpdateCustomThreatIntelSourceOperationMutation__
 *
 * To run a mutation, you first call `useUpdateCustomThreatIntelSourceOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomThreatIntelSourceOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomThreatIntelSourceOperationMutation, { data, loading, error }] = useUpdateCustomThreatIntelSourceOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateCustomThreatIntelSourceOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomThreatIntelSourceOperationMutation, UpdateCustomThreatIntelSourceOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomThreatIntelSourceOperationMutation, UpdateCustomThreatIntelSourceOperationMutationVariables>(UpdateCustomThreatIntelSourceOperationDocument, options);
      }
export type UpdateCustomThreatIntelSourceOperationMutationHookResult = ReturnType<typeof useUpdateCustomThreatIntelSourceOperationMutation>;
export type UpdateCustomThreatIntelSourceOperationMutationResult = Apollo.MutationResult<UpdateCustomThreatIntelSourceOperationMutation>;
export type UpdateCustomThreatIntelSourceOperationMutationOptions = Apollo.BaseMutationOptions<UpdateCustomThreatIntelSourceOperationMutation, UpdateCustomThreatIntelSourceOperationMutationVariables>;
export const CreateIdefenseThreatIntelSourceOperationDocument = gql`
    mutation CreateIdefenseThreatIntelSourceOperation($fields: IdefenseThreatIntelSourceFields!) {
  createIdefenseThreatIntelSource(fields: $fields) {
    data {
      ...ThreatIntelSource
    }
  }
}
    ${ThreatIntelSourceFragmentDoc}`;
export type CreateIdefenseThreatIntelSourceOperationMutationFn = Apollo.MutationFunction<CreateIdefenseThreatIntelSourceOperationMutation, CreateIdefenseThreatIntelSourceOperationMutationVariables>;

/**
 * __useCreateIdefenseThreatIntelSourceOperationMutation__
 *
 * To run a mutation, you first call `useCreateIdefenseThreatIntelSourceOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIdefenseThreatIntelSourceOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIdefenseThreatIntelSourceOperationMutation, { data, loading, error }] = useCreateIdefenseThreatIntelSourceOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateIdefenseThreatIntelSourceOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateIdefenseThreatIntelSourceOperationMutation, CreateIdefenseThreatIntelSourceOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIdefenseThreatIntelSourceOperationMutation, CreateIdefenseThreatIntelSourceOperationMutationVariables>(CreateIdefenseThreatIntelSourceOperationDocument, options);
      }
export type CreateIdefenseThreatIntelSourceOperationMutationHookResult = ReturnType<typeof useCreateIdefenseThreatIntelSourceOperationMutation>;
export type CreateIdefenseThreatIntelSourceOperationMutationResult = Apollo.MutationResult<CreateIdefenseThreatIntelSourceOperationMutation>;
export type CreateIdefenseThreatIntelSourceOperationMutationOptions = Apollo.BaseMutationOptions<CreateIdefenseThreatIntelSourceOperationMutation, CreateIdefenseThreatIntelSourceOperationMutationVariables>;
export const UpdateIdefenseThreatIntelSourceOperationDocument = gql`
    mutation UpdateIdefenseThreatIntelSourceOperation($id: ID!, $fields: UpdatableIdefenseThreatIntelSourceFields!) {
  updateIdefenseThreatIntelSource(id: $id, fields: $fields) {
    data {
      ...ThreatIntelSource
    }
  }
}
    ${ThreatIntelSourceFragmentDoc}`;
export type UpdateIdefenseThreatIntelSourceOperationMutationFn = Apollo.MutationFunction<UpdateIdefenseThreatIntelSourceOperationMutation, UpdateIdefenseThreatIntelSourceOperationMutationVariables>;

/**
 * __useUpdateIdefenseThreatIntelSourceOperationMutation__
 *
 * To run a mutation, you first call `useUpdateIdefenseThreatIntelSourceOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdefenseThreatIntelSourceOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIdefenseThreatIntelSourceOperationMutation, { data, loading, error }] = useUpdateIdefenseThreatIntelSourceOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateIdefenseThreatIntelSourceOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIdefenseThreatIntelSourceOperationMutation, UpdateIdefenseThreatIntelSourceOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIdefenseThreatIntelSourceOperationMutation, UpdateIdefenseThreatIntelSourceOperationMutationVariables>(UpdateIdefenseThreatIntelSourceOperationDocument, options);
      }
export type UpdateIdefenseThreatIntelSourceOperationMutationHookResult = ReturnType<typeof useUpdateIdefenseThreatIntelSourceOperationMutation>;
export type UpdateIdefenseThreatIntelSourceOperationMutationResult = Apollo.MutationResult<UpdateIdefenseThreatIntelSourceOperationMutation>;
export type UpdateIdefenseThreatIntelSourceOperationMutationOptions = Apollo.BaseMutationOptions<UpdateIdefenseThreatIntelSourceOperationMutation, UpdateIdefenseThreatIntelSourceOperationMutationVariables>;
export const CreateTaxiiThreatIntelSourceOperationDocument = gql`
    mutation CreateTaxiiThreatIntelSourceOperation($fields: TaxiiThreatIntelSourceFields!) {
  createTaxiiThreatIntelSource(fields: $fields) {
    data {
      ...ThreatIntelSource
    }
  }
}
    ${ThreatIntelSourceFragmentDoc}`;
export type CreateTaxiiThreatIntelSourceOperationMutationFn = Apollo.MutationFunction<CreateTaxiiThreatIntelSourceOperationMutation, CreateTaxiiThreatIntelSourceOperationMutationVariables>;

/**
 * __useCreateTaxiiThreatIntelSourceOperationMutation__
 *
 * To run a mutation, you first call `useCreateTaxiiThreatIntelSourceOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaxiiThreatIntelSourceOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaxiiThreatIntelSourceOperationMutation, { data, loading, error }] = useCreateTaxiiThreatIntelSourceOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateTaxiiThreatIntelSourceOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaxiiThreatIntelSourceOperationMutation, CreateTaxiiThreatIntelSourceOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaxiiThreatIntelSourceOperationMutation, CreateTaxiiThreatIntelSourceOperationMutationVariables>(CreateTaxiiThreatIntelSourceOperationDocument, options);
      }
export type CreateTaxiiThreatIntelSourceOperationMutationHookResult = ReturnType<typeof useCreateTaxiiThreatIntelSourceOperationMutation>;
export type CreateTaxiiThreatIntelSourceOperationMutationResult = Apollo.MutationResult<CreateTaxiiThreatIntelSourceOperationMutation>;
export type CreateTaxiiThreatIntelSourceOperationMutationOptions = Apollo.BaseMutationOptions<CreateTaxiiThreatIntelSourceOperationMutation, CreateTaxiiThreatIntelSourceOperationMutationVariables>;
export const UpdateTaxiiThreatIntelSourceOperationDocument = gql`
    mutation UpdateTaxiiThreatIntelSourceOperation($id: ID!, $fields: UpdatableTaxiiThreatIntelSourceFields!, $fieldsToClear: [TaxiiClearableFields!]!) {
  updateTaxiiThreatIntelSource(
    id: $id
    fields: $fields
    fieldsToClear: $fieldsToClear
  ) {
    data {
      ...ThreatIntelSource
    }
  }
}
    ${ThreatIntelSourceFragmentDoc}`;
export type UpdateTaxiiThreatIntelSourceOperationMutationFn = Apollo.MutationFunction<UpdateTaxiiThreatIntelSourceOperationMutation, UpdateTaxiiThreatIntelSourceOperationMutationVariables>;

/**
 * __useUpdateTaxiiThreatIntelSourceOperationMutation__
 *
 * To run a mutation, you first call `useUpdateTaxiiThreatIntelSourceOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxiiThreatIntelSourceOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxiiThreatIntelSourceOperationMutation, { data, loading, error }] = useUpdateTaxiiThreatIntelSourceOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *      fieldsToClear: // value for 'fieldsToClear'
 *   },
 * });
 */
export function useUpdateTaxiiThreatIntelSourceOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaxiiThreatIntelSourceOperationMutation, UpdateTaxiiThreatIntelSourceOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaxiiThreatIntelSourceOperationMutation, UpdateTaxiiThreatIntelSourceOperationMutationVariables>(UpdateTaxiiThreatIntelSourceOperationDocument, options);
      }
export type UpdateTaxiiThreatIntelSourceOperationMutationHookResult = ReturnType<typeof useUpdateTaxiiThreatIntelSourceOperationMutation>;
export type UpdateTaxiiThreatIntelSourceOperationMutationResult = Apollo.MutationResult<UpdateTaxiiThreatIntelSourceOperationMutation>;
export type UpdateTaxiiThreatIntelSourceOperationMutationOptions = Apollo.BaseMutationOptions<UpdateTaxiiThreatIntelSourceOperationMutation, UpdateTaxiiThreatIntelSourceOperationMutationVariables>;
export const ThreatIntelSourceEditorOperationDocument = gql`
    query ThreatIntelSourceEditorOperation($id: ID!) {
  threatIntelSource(id: $id) {
    ...ThreatIntelSource
  }
}
    ${ThreatIntelSourceFragmentDoc}`;

/**
 * __useThreatIntelSourceEditorOperationQuery__
 *
 * To run a query within a React component, call `useThreatIntelSourceEditorOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useThreatIntelSourceEditorOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThreatIntelSourceEditorOperationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useThreatIntelSourceEditorOperationQuery(baseOptions: Apollo.QueryHookOptions<ThreatIntelSourceEditorOperationQuery, ThreatIntelSourceEditorOperationQueryVariables> & ({ variables: ThreatIntelSourceEditorOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThreatIntelSourceEditorOperationQuery, ThreatIntelSourceEditorOperationQueryVariables>(ThreatIntelSourceEditorOperationDocument, options);
      }
export function useThreatIntelSourceEditorOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThreatIntelSourceEditorOperationQuery, ThreatIntelSourceEditorOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThreatIntelSourceEditorOperationQuery, ThreatIntelSourceEditorOperationQueryVariables>(ThreatIntelSourceEditorOperationDocument, options);
        }
export function useThreatIntelSourceEditorOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThreatIntelSourceEditorOperationQuery, ThreatIntelSourceEditorOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThreatIntelSourceEditorOperationQuery, ThreatIntelSourceEditorOperationQueryVariables>(ThreatIntelSourceEditorOperationDocument, options);
        }
export type ThreatIntelSourceEditorOperationQueryHookResult = ReturnType<typeof useThreatIntelSourceEditorOperationQuery>;
export type ThreatIntelSourceEditorOperationLazyQueryHookResult = ReturnType<typeof useThreatIntelSourceEditorOperationLazyQuery>;
export type ThreatIntelSourceEditorOperationSuspenseQueryHookResult = ReturnType<typeof useThreatIntelSourceEditorOperationSuspenseQuery>;
export type ThreatIntelSourceEditorOperationQueryResult = Apollo.QueryResult<ThreatIntelSourceEditorOperationQuery, ThreatIntelSourceEditorOperationQueryVariables>;
export const CreateThreatQThreatIntelSourceOperationDocument = gql`
    mutation CreateThreatQThreatIntelSourceOperation($fields: ThreatQThreatIntelSourceFields!) {
  createThreatQThreatIntelSource(fields: $fields) {
    data {
      ...ThreatIntelSource
    }
  }
}
    ${ThreatIntelSourceFragmentDoc}`;
export type CreateThreatQThreatIntelSourceOperationMutationFn = Apollo.MutationFunction<CreateThreatQThreatIntelSourceOperationMutation, CreateThreatQThreatIntelSourceOperationMutationVariables>;

/**
 * __useCreateThreatQThreatIntelSourceOperationMutation__
 *
 * To run a mutation, you first call `useCreateThreatQThreatIntelSourceOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThreatQThreatIntelSourceOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThreatQThreatIntelSourceOperationMutation, { data, loading, error }] = useCreateThreatQThreatIntelSourceOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateThreatQThreatIntelSourceOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateThreatQThreatIntelSourceOperationMutation, CreateThreatQThreatIntelSourceOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateThreatQThreatIntelSourceOperationMutation, CreateThreatQThreatIntelSourceOperationMutationVariables>(CreateThreatQThreatIntelSourceOperationDocument, options);
      }
export type CreateThreatQThreatIntelSourceOperationMutationHookResult = ReturnType<typeof useCreateThreatQThreatIntelSourceOperationMutation>;
export type CreateThreatQThreatIntelSourceOperationMutationResult = Apollo.MutationResult<CreateThreatQThreatIntelSourceOperationMutation>;
export type CreateThreatQThreatIntelSourceOperationMutationOptions = Apollo.BaseMutationOptions<CreateThreatQThreatIntelSourceOperationMutation, CreateThreatQThreatIntelSourceOperationMutationVariables>;
export const UpdateThreatQThreatIntelSourceOperationDocument = gql`
    mutation UpdateThreatQThreatIntelSourceOperation($id: ID!, $fields: UpdatableThreatQThreatIntelSourceFields!, $fieldsToClear: [ThreatQClearableFields!]!) {
  updateThreatQThreatIntelSource(
    id: $id
    fields: $fields
    fieldsToClear: $fieldsToClear
  ) {
    data {
      ...ThreatIntelSource
    }
  }
}
    ${ThreatIntelSourceFragmentDoc}`;
export type UpdateThreatQThreatIntelSourceOperationMutationFn = Apollo.MutationFunction<UpdateThreatQThreatIntelSourceOperationMutation, UpdateThreatQThreatIntelSourceOperationMutationVariables>;

/**
 * __useUpdateThreatQThreatIntelSourceOperationMutation__
 *
 * To run a mutation, you first call `useUpdateThreatQThreatIntelSourceOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThreatQThreatIntelSourceOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThreatQThreatIntelSourceOperationMutation, { data, loading, error }] = useUpdateThreatQThreatIntelSourceOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *      fieldsToClear: // value for 'fieldsToClear'
 *   },
 * });
 */
export function useUpdateThreatQThreatIntelSourceOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateThreatQThreatIntelSourceOperationMutation, UpdateThreatQThreatIntelSourceOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateThreatQThreatIntelSourceOperationMutation, UpdateThreatQThreatIntelSourceOperationMutationVariables>(UpdateThreatQThreatIntelSourceOperationDocument, options);
      }
export type UpdateThreatQThreatIntelSourceOperationMutationHookResult = ReturnType<typeof useUpdateThreatQThreatIntelSourceOperationMutation>;
export type UpdateThreatQThreatIntelSourceOperationMutationResult = Apollo.MutationResult<UpdateThreatQThreatIntelSourceOperationMutation>;
export type UpdateThreatQThreatIntelSourceOperationMutationOptions = Apollo.BaseMutationOptions<UpdateThreatQThreatIntelSourceOperationMutation, UpdateThreatQThreatIntelSourceOperationMutationVariables>;
export const ThreatIntelSourcesOperationDocument = gql`
    query ThreatIntelSourcesOperation($offset: Int!, $limit: Int!, $sort: String!, $sortDir: SortDir!) {
  threatIntelSources(
    offset: $offset
    limit: $limit
    sort: $sort
    sortDir: $sortDir
  ) {
    total
    hasNextPage
    objects {
      ...ThreatIntelSource
    }
  }
  threatIntelItemCount
  threatIntelItemLimit
}
    ${ThreatIntelSourceFragmentDoc}`;

/**
 * __useThreatIntelSourcesOperationQuery__
 *
 * To run a query within a React component, call `useThreatIntelSourcesOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useThreatIntelSourcesOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThreatIntelSourcesOperationQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useThreatIntelSourcesOperationQuery(baseOptions: Apollo.QueryHookOptions<ThreatIntelSourcesOperationQuery, ThreatIntelSourcesOperationQueryVariables> & ({ variables: ThreatIntelSourcesOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThreatIntelSourcesOperationQuery, ThreatIntelSourcesOperationQueryVariables>(ThreatIntelSourcesOperationDocument, options);
      }
export function useThreatIntelSourcesOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThreatIntelSourcesOperationQuery, ThreatIntelSourcesOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThreatIntelSourcesOperationQuery, ThreatIntelSourcesOperationQueryVariables>(ThreatIntelSourcesOperationDocument, options);
        }
export function useThreatIntelSourcesOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThreatIntelSourcesOperationQuery, ThreatIntelSourcesOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThreatIntelSourcesOperationQuery, ThreatIntelSourcesOperationQueryVariables>(ThreatIntelSourcesOperationDocument, options);
        }
export type ThreatIntelSourcesOperationQueryHookResult = ReturnType<typeof useThreatIntelSourcesOperationQuery>;
export type ThreatIntelSourcesOperationLazyQueryHookResult = ReturnType<typeof useThreatIntelSourcesOperationLazyQuery>;
export type ThreatIntelSourcesOperationSuspenseQueryHookResult = ReturnType<typeof useThreatIntelSourcesOperationSuspenseQuery>;
export type ThreatIntelSourcesOperationQueryResult = Apollo.QueryResult<ThreatIntelSourcesOperationQuery, ThreatIntelSourcesOperationQueryVariables>;
export const DeleteThreatIntelItemOperationDocument = gql`
    mutation DeleteThreatIntelItemOperation($id: ID!) {
  deleteThreatIntelItem(id: $id) {
    ok
  }
}
    `;
export type DeleteThreatIntelItemOperationMutationFn = Apollo.MutationFunction<DeleteThreatIntelItemOperationMutation, DeleteThreatIntelItemOperationMutationVariables>;

/**
 * __useDeleteThreatIntelItemOperationMutation__
 *
 * To run a mutation, you first call `useDeleteThreatIntelItemOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThreatIntelItemOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThreatIntelItemOperationMutation, { data, loading, error }] = useDeleteThreatIntelItemOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteThreatIntelItemOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteThreatIntelItemOperationMutation, DeleteThreatIntelItemOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteThreatIntelItemOperationMutation, DeleteThreatIntelItemOperationMutationVariables>(DeleteThreatIntelItemOperationDocument, options);
      }
export type DeleteThreatIntelItemOperationMutationHookResult = ReturnType<typeof useDeleteThreatIntelItemOperationMutation>;
export type DeleteThreatIntelItemOperationMutationResult = Apollo.MutationResult<DeleteThreatIntelItemOperationMutation>;
export type DeleteThreatIntelItemOperationMutationOptions = Apollo.BaseMutationOptions<DeleteThreatIntelItemOperationMutation, DeleteThreatIntelItemOperationMutationVariables>;
export const EnrichmentsFilterQueryOperationDocument = gql`
    query EnrichmentsFilterQueryOperation($ids: [ID!]) {
  entitiesByListIds(entityIds: $ids) {
    id
    entityTypeName
    value
  }
}
    `;

/**
 * __useEnrichmentsFilterQueryOperation__
 *
 * To run a query within a React component, call `useEnrichmentsFilterQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEnrichmentsFilterQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnrichmentsFilterQueryOperation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useEnrichmentsFilterQueryOperation(baseOptions?: Apollo.QueryHookOptions<EnrichmentsFilterQueryOperationQuery, EnrichmentsFilterQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnrichmentsFilterQueryOperationQuery, EnrichmentsFilterQueryOperationQueryVariables>(EnrichmentsFilterQueryOperationDocument, options);
      }
export function useEnrichmentsFilterQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnrichmentsFilterQueryOperationQuery, EnrichmentsFilterQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnrichmentsFilterQueryOperationQuery, EnrichmentsFilterQueryOperationQueryVariables>(EnrichmentsFilterQueryOperationDocument, options);
        }
export function useEnrichmentsFilterQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EnrichmentsFilterQueryOperationQuery, EnrichmentsFilterQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnrichmentsFilterQueryOperationQuery, EnrichmentsFilterQueryOperationQueryVariables>(EnrichmentsFilterQueryOperationDocument, options);
        }
export type EnrichmentsFilterQueryOperationHookResult = ReturnType<typeof useEnrichmentsFilterQueryOperation>;
export type EnrichmentsFilterQueryOperationLazyQueryHookResult = ReturnType<typeof useEnrichmentsFilterQueryOperationLazyQuery>;
export type EnrichmentsFilterQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEnrichmentsFilterQueryOperationSuspenseQuery>;
export type EnrichmentsFilterQueryOperationQueryResult = Apollo.QueryResult<EnrichmentsFilterQueryOperationQuery, EnrichmentsFilterQueryOperationQueryVariables>;
export const EntityEnhancementsQueryDetailsOperationDocument = gql`
    query EntityEnhancementsQueryDetailsOperation($id: ID!) {
  entity(id: $id) {
    ... on EntityInterface {
      id
      entityTypeName
      value
      reputation
    }
  }
}
    `;

/**
 * __useEntityEnhancementsQueryDetailsOperation__
 *
 * To run a query within a React component, call `useEntityEnhancementsQueryDetailsOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityEnhancementsQueryDetailsOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityEnhancementsQueryDetailsOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityEnhancementsQueryDetailsOperation(baseOptions: Apollo.QueryHookOptions<EntityEnhancementsQueryDetailsOperationQuery, EntityEnhancementsQueryDetailsOperationQueryVariables> & ({ variables: EntityEnhancementsQueryDetailsOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityEnhancementsQueryDetailsOperationQuery, EntityEnhancementsQueryDetailsOperationQueryVariables>(EntityEnhancementsQueryDetailsOperationDocument, options);
      }
export function useEntityEnhancementsQueryDetailsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityEnhancementsQueryDetailsOperationQuery, EntityEnhancementsQueryDetailsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityEnhancementsQueryDetailsOperationQuery, EntityEnhancementsQueryDetailsOperationQueryVariables>(EntityEnhancementsQueryDetailsOperationDocument, options);
        }
export function useEntityEnhancementsQueryDetailsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityEnhancementsQueryDetailsOperationQuery, EntityEnhancementsQueryDetailsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityEnhancementsQueryDetailsOperationQuery, EntityEnhancementsQueryDetailsOperationQueryVariables>(EntityEnhancementsQueryDetailsOperationDocument, options);
        }
export type EntityEnhancementsQueryDetailsOperationHookResult = ReturnType<typeof useEntityEnhancementsQueryDetailsOperation>;
export type EntityEnhancementsQueryDetailsOperationLazyQueryHookResult = ReturnType<typeof useEntityEnhancementsQueryDetailsOperationLazyQuery>;
export type EntityEnhancementsQueryDetailsOperationSuspenseQueryHookResult = ReturnType<typeof useEntityEnhancementsQueryDetailsOperationSuspenseQuery>;
export type EntityEnhancementsQueryDetailsOperationQueryResult = Apollo.QueryResult<EntityEnhancementsQueryDetailsOperationQuery, EntityEnhancementsQueryDetailsOperationQueryVariables>;
export const SignalEnhancementsDetailsQueryOperationDocument = gql`
    query SignalEnhancementsDetailsQueryOperation($id: ID!) {
  signal(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useSignalEnhancementsDetailsQueryOperation__
 *
 * To run a query within a React component, call `useSignalEnhancementsDetailsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useSignalEnhancementsDetailsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalEnhancementsDetailsQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignalEnhancementsDetailsQueryOperation(baseOptions: Apollo.QueryHookOptions<SignalEnhancementsDetailsQueryOperationQuery, SignalEnhancementsDetailsQueryOperationQueryVariables> & ({ variables: SignalEnhancementsDetailsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalEnhancementsDetailsQueryOperationQuery, SignalEnhancementsDetailsQueryOperationQueryVariables>(SignalEnhancementsDetailsQueryOperationDocument, options);
      }
export function useSignalEnhancementsDetailsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalEnhancementsDetailsQueryOperationQuery, SignalEnhancementsDetailsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalEnhancementsDetailsQueryOperationQuery, SignalEnhancementsDetailsQueryOperationQueryVariables>(SignalEnhancementsDetailsQueryOperationDocument, options);
        }
export function useSignalEnhancementsDetailsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignalEnhancementsDetailsQueryOperationQuery, SignalEnhancementsDetailsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SignalEnhancementsDetailsQueryOperationQuery, SignalEnhancementsDetailsQueryOperationQueryVariables>(SignalEnhancementsDetailsQueryOperationDocument, options);
        }
export type SignalEnhancementsDetailsQueryOperationHookResult = ReturnType<typeof useSignalEnhancementsDetailsQueryOperation>;
export type SignalEnhancementsDetailsQueryOperationLazyQueryHookResult = ReturnType<typeof useSignalEnhancementsDetailsQueryOperationLazyQuery>;
export type SignalEnhancementsDetailsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useSignalEnhancementsDetailsQueryOperationSuspenseQuery>;
export type SignalEnhancementsDetailsQueryOperationQueryResult = Apollo.QueryResult<SignalEnhancementsDetailsQueryOperationQuery, SignalEnhancementsDetailsQueryOperationQueryVariables>;
export const InsightEnhancementsDetailsQueryOperationDocument = gql`
    query InsightEnhancementsDetailsQueryOperation($id: ID!) {
  insight(id: $id) {
    id
    readableId
  }
}
    `;

/**
 * __useInsightEnhancementsDetailsQueryOperation__
 *
 * To run a query within a React component, call `useInsightEnhancementsDetailsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightEnhancementsDetailsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightEnhancementsDetailsQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInsightEnhancementsDetailsQueryOperation(baseOptions: Apollo.QueryHookOptions<InsightEnhancementsDetailsQueryOperationQuery, InsightEnhancementsDetailsQueryOperationQueryVariables> & ({ variables: InsightEnhancementsDetailsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightEnhancementsDetailsQueryOperationQuery, InsightEnhancementsDetailsQueryOperationQueryVariables>(InsightEnhancementsDetailsQueryOperationDocument, options);
      }
export function useInsightEnhancementsDetailsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightEnhancementsDetailsQueryOperationQuery, InsightEnhancementsDetailsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightEnhancementsDetailsQueryOperationQuery, InsightEnhancementsDetailsQueryOperationQueryVariables>(InsightEnhancementsDetailsQueryOperationDocument, options);
        }
export function useInsightEnhancementsDetailsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightEnhancementsDetailsQueryOperationQuery, InsightEnhancementsDetailsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightEnhancementsDetailsQueryOperationQuery, InsightEnhancementsDetailsQueryOperationQueryVariables>(InsightEnhancementsDetailsQueryOperationDocument, options);
        }
export type InsightEnhancementsDetailsQueryOperationHookResult = ReturnType<typeof useInsightEnhancementsDetailsQueryOperation>;
export type InsightEnhancementsDetailsQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightEnhancementsDetailsQueryOperationLazyQuery>;
export type InsightEnhancementsDetailsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightEnhancementsDetailsQueryOperationSuspenseQuery>;
export type InsightEnhancementsDetailsQueryOperationQueryResult = Apollo.QueryResult<InsightEnhancementsDetailsQueryOperationQuery, InsightEnhancementsDetailsQueryOperationQueryVariables>;
export const BulkUpdateEntityCriticalityOperationDocument = gql`
    mutation BulkUpdateEntityCriticalityOperation($entityIds: [ID!]!, $criticality: String) {
  bulkUpdateEntityCriticality(entityIds: $entityIds, criticality: $criticality) {
    data {
      id
      criticality
    }
  }
}
    `;
export type BulkUpdateEntityCriticalityOperationMutationFn = Apollo.MutationFunction<BulkUpdateEntityCriticalityOperationMutation, BulkUpdateEntityCriticalityOperationMutationVariables>;

/**
 * __useBulkUpdateEntityCriticalityOperationMutation__
 *
 * To run a mutation, you first call `useBulkUpdateEntityCriticalityOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateEntityCriticalityOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateEntityCriticalityOperationMutation, { data, loading, error }] = useBulkUpdateEntityCriticalityOperationMutation({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *      criticality: // value for 'criticality'
 *   },
 * });
 */
export function useBulkUpdateEntityCriticalityOperationMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateEntityCriticalityOperationMutation, BulkUpdateEntityCriticalityOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateEntityCriticalityOperationMutation, BulkUpdateEntityCriticalityOperationMutationVariables>(BulkUpdateEntityCriticalityOperationDocument, options);
      }
export type BulkUpdateEntityCriticalityOperationMutationHookResult = ReturnType<typeof useBulkUpdateEntityCriticalityOperationMutation>;
export type BulkUpdateEntityCriticalityOperationMutationResult = Apollo.MutationResult<BulkUpdateEntityCriticalityOperationMutation>;
export type BulkUpdateEntityCriticalityOperationMutationOptions = Apollo.BaseMutationOptions<BulkUpdateEntityCriticalityOperationMutation, BulkUpdateEntityCriticalityOperationMutationVariables>;
export const BulkUpdateEntitySuppressionOperationDocument = gql`
    mutation BulkUpdateEntitySuppressionOperation($comment: String, $entityIds: [ID!]!, $whitelistFlag: Boolean!) {
  bulkUpdateEntityWhitelist(
    comment: $comment
    entityIds: $entityIds
    whitelistFlag: $whitelistFlag
  ) {
    data {
      id
      isWhitelisted
      whitelistedComment
    }
  }
}
    `;
export type BulkUpdateEntitySuppressionOperationMutationFn = Apollo.MutationFunction<BulkUpdateEntitySuppressionOperationMutation, BulkUpdateEntitySuppressionOperationMutationVariables>;

/**
 * __useBulkUpdateEntitySuppressionOperationMutation__
 *
 * To run a mutation, you first call `useBulkUpdateEntitySuppressionOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateEntitySuppressionOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateEntitySuppressionOperationMutation, { data, loading, error }] = useBulkUpdateEntitySuppressionOperationMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *      entityIds: // value for 'entityIds'
 *      whitelistFlag: // value for 'whitelistFlag'
 *   },
 * });
 */
export function useBulkUpdateEntitySuppressionOperationMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateEntitySuppressionOperationMutation, BulkUpdateEntitySuppressionOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateEntitySuppressionOperationMutation, BulkUpdateEntitySuppressionOperationMutationVariables>(BulkUpdateEntitySuppressionOperationDocument, options);
      }
export type BulkUpdateEntitySuppressionOperationMutationHookResult = ReturnType<typeof useBulkUpdateEntitySuppressionOperationMutation>;
export type BulkUpdateEntitySuppressionOperationMutationResult = Apollo.MutationResult<BulkUpdateEntitySuppressionOperationMutation>;
export type BulkUpdateEntitySuppressionOperationMutationOptions = Apollo.BaseMutationOptions<BulkUpdateEntitySuppressionOperationMutation, BulkUpdateEntitySuppressionOperationMutationVariables>;
export const BulkUpdateEntityTagsOperationDocument = gql`
    mutation BulkUpdateEntityTagsOperation($entityIds: [ID!]!, $tags: [String!]!) {
  bulkUpdateEntityTags(entityIds: $entityIds, tags: $tags) {
    data {
      id
      tags
    }
  }
}
    `;
export type BulkUpdateEntityTagsOperationMutationFn = Apollo.MutationFunction<BulkUpdateEntityTagsOperationMutation, BulkUpdateEntityTagsOperationMutationVariables>;

/**
 * __useBulkUpdateEntityTagsOperationMutation__
 *
 * To run a mutation, you first call `useBulkUpdateEntityTagsOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateEntityTagsOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateEntityTagsOperationMutation, { data, loading, error }] = useBulkUpdateEntityTagsOperationMutation({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useBulkUpdateEntityTagsOperationMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateEntityTagsOperationMutation, BulkUpdateEntityTagsOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateEntityTagsOperationMutation, BulkUpdateEntityTagsOperationMutationVariables>(BulkUpdateEntityTagsOperationDocument, options);
      }
export type BulkUpdateEntityTagsOperationMutationHookResult = ReturnType<typeof useBulkUpdateEntityTagsOperationMutation>;
export type BulkUpdateEntityTagsOperationMutationResult = Apollo.MutationResult<BulkUpdateEntityTagsOperationMutation>;
export type BulkUpdateEntityTagsOperationMutationOptions = Apollo.BaseMutationOptions<BulkUpdateEntityTagsOperationMutation, BulkUpdateEntityTagsOperationMutationVariables>;
export const BulkAddEntityTagsOperationDocument = gql`
    mutation BulkAddEntityTagsOperation($entityIds: [ID!]!, $tags: [String!]!) {
  bulkAddEntityTags(entityIds: $entityIds, tags: $tags) {
    data {
      id
      tags
    }
  }
}
    `;
export type BulkAddEntityTagsOperationMutationFn = Apollo.MutationFunction<BulkAddEntityTagsOperationMutation, BulkAddEntityTagsOperationMutationVariables>;

/**
 * __useBulkAddEntityTagsOperationMutation__
 *
 * To run a mutation, you first call `useBulkAddEntityTagsOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkAddEntityTagsOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkAddEntityTagsOperationMutation, { data, loading, error }] = useBulkAddEntityTagsOperationMutation({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useBulkAddEntityTagsOperationMutation(baseOptions?: Apollo.MutationHookOptions<BulkAddEntityTagsOperationMutation, BulkAddEntityTagsOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkAddEntityTagsOperationMutation, BulkAddEntityTagsOperationMutationVariables>(BulkAddEntityTagsOperationDocument, options);
      }
export type BulkAddEntityTagsOperationMutationHookResult = ReturnType<typeof useBulkAddEntityTagsOperationMutation>;
export type BulkAddEntityTagsOperationMutationResult = Apollo.MutationResult<BulkAddEntityTagsOperationMutation>;
export type BulkAddEntityTagsOperationMutationOptions = Apollo.BaseMutationOptions<BulkAddEntityTagsOperationMutation, BulkAddEntityTagsOperationMutationVariables>;
export const BulkRemoveEntityTagsOperationDocument = gql`
    mutation BulkRemoveEntityTagsOperation($entityIds: [ID!]!, $tags: [String!]!) {
  bulkRemoveEntityTags(entityIds: $entityIds, tags: $tags) {
    data {
      id
      tags
    }
  }
}
    `;
export type BulkRemoveEntityTagsOperationMutationFn = Apollo.MutationFunction<BulkRemoveEntityTagsOperationMutation, BulkRemoveEntityTagsOperationMutationVariables>;

/**
 * __useBulkRemoveEntityTagsOperationMutation__
 *
 * To run a mutation, you first call `useBulkRemoveEntityTagsOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkRemoveEntityTagsOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkRemoveEntityTagsOperationMutation, { data, loading, error }] = useBulkRemoveEntityTagsOperationMutation({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useBulkRemoveEntityTagsOperationMutation(baseOptions?: Apollo.MutationHookOptions<BulkRemoveEntityTagsOperationMutation, BulkRemoveEntityTagsOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkRemoveEntityTagsOperationMutation, BulkRemoveEntityTagsOperationMutationVariables>(BulkRemoveEntityTagsOperationDocument, options);
      }
export type BulkRemoveEntityTagsOperationMutationHookResult = ReturnType<typeof useBulkRemoveEntityTagsOperationMutation>;
export type BulkRemoveEntityTagsOperationMutationResult = Apollo.MutationResult<BulkRemoveEntityTagsOperationMutation>;
export type BulkRemoveEntityTagsOperationMutationOptions = Apollo.BaseMutationOptions<BulkRemoveEntityTagsOperationMutation, BulkRemoveEntityTagsOperationMutationVariables>;
export const EntityCriticalitySelectConfigsDocument = gql`
    query EntityCriticalitySelectConfigs {
  entityCriticalityConfigs {
    total
    objects {
      id
      name
      severityExpression
    }
  }
}
    `;

/**
 * __useEntityCriticalitySelectConfigsQuery__
 *
 * To run a query within a React component, call `useEntityCriticalitySelectConfigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityCriticalitySelectConfigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityCriticalitySelectConfigsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntityCriticalitySelectConfigsQuery(baseOptions?: Apollo.QueryHookOptions<EntityCriticalitySelectConfigsQuery, EntityCriticalitySelectConfigsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityCriticalitySelectConfigsQuery, EntityCriticalitySelectConfigsQueryVariables>(EntityCriticalitySelectConfigsDocument, options);
      }
export function useEntityCriticalitySelectConfigsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityCriticalitySelectConfigsQuery, EntityCriticalitySelectConfigsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityCriticalitySelectConfigsQuery, EntityCriticalitySelectConfigsQueryVariables>(EntityCriticalitySelectConfigsDocument, options);
        }
export function useEntityCriticalitySelectConfigsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityCriticalitySelectConfigsQuery, EntityCriticalitySelectConfigsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityCriticalitySelectConfigsQuery, EntityCriticalitySelectConfigsQueryVariables>(EntityCriticalitySelectConfigsDocument, options);
        }
export type EntityCriticalitySelectConfigsQueryHookResult = ReturnType<typeof useEntityCriticalitySelectConfigsQuery>;
export type EntityCriticalitySelectConfigsLazyQueryHookResult = ReturnType<typeof useEntityCriticalitySelectConfigsLazyQuery>;
export type EntityCriticalitySelectConfigsSuspenseQueryHookResult = ReturnType<typeof useEntityCriticalitySelectConfigsSuspenseQuery>;
export type EntityCriticalitySelectConfigsQueryResult = Apollo.QueryResult<EntityCriticalitySelectConfigsQuery, EntityCriticalitySelectConfigsQueryVariables>;
export const EntityDetailsTimelineQueryOperationDocument = gql`
    query EntityDetailsTimelineQueryOperation($limit: Int!, $offset: Int!, $q: String!, $sort: SignalSortableField!, $sortDir: SortDir!) {
  signals(
    limit: $limit
    offset: $offset
    q: $q
    sort: [{field: $sort, direction: $sortDir}]
  ) {
    hasNextPage
    total
    objects {
      ...EntityDetailsTimelineSignalsFragment
    }
  }
}
    ${EntityDetailsTimelineSignalsFragmentDoc}`;

/**
 * __useEntityDetailsTimelineQueryOperation__
 *
 * To run a query within a React component, call `useEntityDetailsTimelineQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityDetailsTimelineQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityDetailsTimelineQueryOperation({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      q: // value for 'q'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useEntityDetailsTimelineQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityDetailsTimelineQueryOperationQuery, EntityDetailsTimelineQueryOperationQueryVariables> & ({ variables: EntityDetailsTimelineQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityDetailsTimelineQueryOperationQuery, EntityDetailsTimelineQueryOperationQueryVariables>(EntityDetailsTimelineQueryOperationDocument, options);
      }
export function useEntityDetailsTimelineQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityDetailsTimelineQueryOperationQuery, EntityDetailsTimelineQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityDetailsTimelineQueryOperationQuery, EntityDetailsTimelineQueryOperationQueryVariables>(EntityDetailsTimelineQueryOperationDocument, options);
        }
export function useEntityDetailsTimelineQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityDetailsTimelineQueryOperationQuery, EntityDetailsTimelineQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityDetailsTimelineQueryOperationQuery, EntityDetailsTimelineQueryOperationQueryVariables>(EntityDetailsTimelineQueryOperationDocument, options);
        }
export type EntityDetailsTimelineQueryOperationHookResult = ReturnType<typeof useEntityDetailsTimelineQueryOperation>;
export type EntityDetailsTimelineQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityDetailsTimelineQueryOperationLazyQuery>;
export type EntityDetailsTimelineQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityDetailsTimelineQueryOperationSuspenseQuery>;
export type EntityDetailsTimelineQueryOperationQueryResult = Apollo.QueryResult<EntityDetailsTimelineQueryOperationQuery, EntityDetailsTimelineQueryOperationQueryVariables>;
export const CreateInsightFromEntitySignalsOperationDocument = gql`
    mutation CreateInsightFromEntitySignalsOperation($signalIds: [ID!]!) {
  createInsightFromSignals(signalIds: $signalIds) {
    data {
      id
    }
  }
}
    `;
export type CreateInsightFromEntitySignalsOperationMutationFn = Apollo.MutationFunction<CreateInsightFromEntitySignalsOperationMutation, CreateInsightFromEntitySignalsOperationMutationVariables>;

/**
 * __useCreateInsightFromEntitySignalsOperationMutation__
 *
 * To run a mutation, you first call `useCreateInsightFromEntitySignalsOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsightFromEntitySignalsOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsightFromEntitySignalsOperationMutation, { data, loading, error }] = useCreateInsightFromEntitySignalsOperationMutation({
 *   variables: {
 *      signalIds: // value for 'signalIds'
 *   },
 * });
 */
export function useCreateInsightFromEntitySignalsOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateInsightFromEntitySignalsOperationMutation, CreateInsightFromEntitySignalsOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInsightFromEntitySignalsOperationMutation, CreateInsightFromEntitySignalsOperationMutationVariables>(CreateInsightFromEntitySignalsOperationDocument, options);
      }
export type CreateInsightFromEntitySignalsOperationMutationHookResult = ReturnType<typeof useCreateInsightFromEntitySignalsOperationMutation>;
export type CreateInsightFromEntitySignalsOperationMutationResult = Apollo.MutationResult<CreateInsightFromEntitySignalsOperationMutation>;
export type CreateInsightFromEntitySignalsOperationMutationOptions = Apollo.BaseMutationOptions<CreateInsightFromEntitySignalsOperationMutation, CreateInsightFromEntitySignalsOperationMutationVariables>;
export const EntityDetailsInsightsSignalsQueryOperationDocument = gql`
    query EntityDetailsInsightsSignalsQueryOperation($entityId: ID!, $insightsQuery: String!, $limit: Int!, $offset: Int!, $signalsQuery: String!, $sort: SignalSortableField!, $sortDir: SortDir!) {
  entity(id: $entityId) {
    ... on EntityInterface {
      id
      activityScore
      currentStateSignals {
        ...SignalFragment
      }
    }
  }
  insights(q: $insightsQuery) {
    objects {
      ...EntityDetailsInsightsFragment
    }
  }
  insightStatuses {
    id
    name
    color
  }
  signals(
    limit: $limit
    offset: $offset
    q: $signalsQuery
    sort: [{field: $sort, direction: $sortDir}]
    includeEntityDetails: true
  ) {
    total
    objects {
      ...SignalFragment
    }
  }
}
    ${SignalFragmentDoc}
${EntityDetailsInsightsFragmentDoc}`;

/**
 * __useEntityDetailsInsightsSignalsQueryOperation__
 *
 * To run a query within a React component, call `useEntityDetailsInsightsSignalsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityDetailsInsightsSignalsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityDetailsInsightsSignalsQueryOperation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      insightsQuery: // value for 'insightsQuery'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      signalsQuery: // value for 'signalsQuery'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useEntityDetailsInsightsSignalsQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityDetailsInsightsSignalsQueryOperationQuery, EntityDetailsInsightsSignalsQueryOperationQueryVariables> & ({ variables: EntityDetailsInsightsSignalsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityDetailsInsightsSignalsQueryOperationQuery, EntityDetailsInsightsSignalsQueryOperationQueryVariables>(EntityDetailsInsightsSignalsQueryOperationDocument, options);
      }
export function useEntityDetailsInsightsSignalsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityDetailsInsightsSignalsQueryOperationQuery, EntityDetailsInsightsSignalsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityDetailsInsightsSignalsQueryOperationQuery, EntityDetailsInsightsSignalsQueryOperationQueryVariables>(EntityDetailsInsightsSignalsQueryOperationDocument, options);
        }
export function useEntityDetailsInsightsSignalsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityDetailsInsightsSignalsQueryOperationQuery, EntityDetailsInsightsSignalsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityDetailsInsightsSignalsQueryOperationQuery, EntityDetailsInsightsSignalsQueryOperationQueryVariables>(EntityDetailsInsightsSignalsQueryOperationDocument, options);
        }
export type EntityDetailsInsightsSignalsQueryOperationHookResult = ReturnType<typeof useEntityDetailsInsightsSignalsQueryOperation>;
export type EntityDetailsInsightsSignalsQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityDetailsInsightsSignalsQueryOperationLazyQuery>;
export type EntityDetailsInsightsSignalsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityDetailsInsightsSignalsQueryOperationSuspenseQuery>;
export type EntityDetailsInsightsSignalsQueryOperationQueryResult = Apollo.QueryResult<EntityDetailsInsightsSignalsQueryOperationQuery, EntityDetailsInsightsSignalsQueryOperationQueryVariables>;
export const EntityDetailsSignalsSummaryQueryOperationDocument = gql`
    query EntityDetailsSignalsSummaryQueryOperation($limit: Int!, $offset: Int!, $allSignalsQuery: String!, $suppressedSignalsQuery: String!, $unsuppressedSignalsQuery: String!, $prototypeSignalsQuery: String!, $sort: SignalSortableField!, $sortDir: SortDir!) {
  allSignals: signals(limit: $limit, offset: $offset, q: $allSignalsQuery) {
    total
  }
  suppressedSignals: signals(
    limit: $limit
    offset: $offset
    q: $suppressedSignalsQuery
    sort: [{field: $sort, direction: $sortDir}]
  ) {
    total
  }
  unSuppressedSignals: signals(
    limit: $limit
    offset: $offset
    q: $unsuppressedSignalsQuery
    sort: [{field: $sort, direction: $sortDir}]
  ) {
    total
  }
  prototypeSignals: signals(
    limit: $limit
    offset: $offset
    q: $prototypeSignalsQuery
    sort: [{field: $sort, direction: $sortDir}]
  ) {
    total
  }
}
    `;

/**
 * __useEntityDetailsSignalsSummaryQueryOperation__
 *
 * To run a query within a React component, call `useEntityDetailsSignalsSummaryQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityDetailsSignalsSummaryQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityDetailsSignalsSummaryQueryOperation({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      allSignalsQuery: // value for 'allSignalsQuery'
 *      suppressedSignalsQuery: // value for 'suppressedSignalsQuery'
 *      unsuppressedSignalsQuery: // value for 'unsuppressedSignalsQuery'
 *      prototypeSignalsQuery: // value for 'prototypeSignalsQuery'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useEntityDetailsSignalsSummaryQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityDetailsSignalsSummaryQueryOperationQuery, EntityDetailsSignalsSummaryQueryOperationQueryVariables> & ({ variables: EntityDetailsSignalsSummaryQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityDetailsSignalsSummaryQueryOperationQuery, EntityDetailsSignalsSummaryQueryOperationQueryVariables>(EntityDetailsSignalsSummaryQueryOperationDocument, options);
      }
export function useEntityDetailsSignalsSummaryQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityDetailsSignalsSummaryQueryOperationQuery, EntityDetailsSignalsSummaryQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityDetailsSignalsSummaryQueryOperationQuery, EntityDetailsSignalsSummaryQueryOperationQueryVariables>(EntityDetailsSignalsSummaryQueryOperationDocument, options);
        }
export function useEntityDetailsSignalsSummaryQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityDetailsSignalsSummaryQueryOperationQuery, EntityDetailsSignalsSummaryQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityDetailsSignalsSummaryQueryOperationQuery, EntityDetailsSignalsSummaryQueryOperationQueryVariables>(EntityDetailsSignalsSummaryQueryOperationDocument, options);
        }
export type EntityDetailsSignalsSummaryQueryOperationHookResult = ReturnType<typeof useEntityDetailsSignalsSummaryQueryOperation>;
export type EntityDetailsSignalsSummaryQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityDetailsSignalsSummaryQueryOperationLazyQuery>;
export type EntityDetailsSignalsSummaryQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityDetailsSignalsSummaryQueryOperationSuspenseQuery>;
export type EntityDetailsSignalsSummaryQueryOperationQueryResult = Apollo.QueryResult<EntityDetailsSignalsSummaryQueryOperationQuery, EntityDetailsSignalsSummaryQueryOperationQueryVariables>;
export const EntityDetailsTagsQueryOperationDocument = gql`
    query EntityDetailsTagsQueryOperation($id: ID!) {
  entity(id: $id) {
    ... on EntityInterface {
      id
      tags
    }
  }
}
    `;

/**
 * __useEntityDetailsTagsQueryOperation__
 *
 * To run a query within a React component, call `useEntityDetailsTagsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityDetailsTagsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityDetailsTagsQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityDetailsTagsQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityDetailsTagsQueryOperationQuery, EntityDetailsTagsQueryOperationQueryVariables> & ({ variables: EntityDetailsTagsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityDetailsTagsQueryOperationQuery, EntityDetailsTagsQueryOperationQueryVariables>(EntityDetailsTagsQueryOperationDocument, options);
      }
export function useEntityDetailsTagsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityDetailsTagsQueryOperationQuery, EntityDetailsTagsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityDetailsTagsQueryOperationQuery, EntityDetailsTagsQueryOperationQueryVariables>(EntityDetailsTagsQueryOperationDocument, options);
        }
export function useEntityDetailsTagsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityDetailsTagsQueryOperationQuery, EntityDetailsTagsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityDetailsTagsQueryOperationQuery, EntityDetailsTagsQueryOperationQueryVariables>(EntityDetailsTagsQueryOperationDocument, options);
        }
export type EntityDetailsTagsQueryOperationHookResult = ReturnType<typeof useEntityDetailsTagsQueryOperation>;
export type EntityDetailsTagsQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityDetailsTagsQueryOperationLazyQuery>;
export type EntityDetailsTagsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityDetailsTagsQueryOperationSuspenseQuery>;
export type EntityDetailsTagsQueryOperationQueryResult = Apollo.QueryResult<EntityDetailsTagsQueryOperationQuery, EntityDetailsTagsQueryOperationQueryVariables>;
export const UpdateEntityDetailsTagsOperationDocument = gql`
    mutation UpdateEntityDetailsTagsOperation($entityId: ID!, $tags: [String!]!) {
  updateEntityTags(entityId: $entityId, tags: $tags) {
    data {
      ... on EntityInterface {
        id
        tags
      }
    }
  }
}
    `;
export type UpdateEntityDetailsTagsOperationMutationFn = Apollo.MutationFunction<UpdateEntityDetailsTagsOperationMutation, UpdateEntityDetailsTagsOperationMutationVariables>;

/**
 * __useUpdateEntityDetailsTagsOperationMutation__
 *
 * To run a mutation, you first call `useUpdateEntityDetailsTagsOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityDetailsTagsOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityDetailsTagsOperationMutation, { data, loading, error }] = useUpdateEntityDetailsTagsOperationMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useUpdateEntityDetailsTagsOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityDetailsTagsOperationMutation, UpdateEntityDetailsTagsOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityDetailsTagsOperationMutation, UpdateEntityDetailsTagsOperationMutationVariables>(UpdateEntityDetailsTagsOperationDocument, options);
      }
export type UpdateEntityDetailsTagsOperationMutationHookResult = ReturnType<typeof useUpdateEntityDetailsTagsOperationMutation>;
export type UpdateEntityDetailsTagsOperationMutationResult = Apollo.MutationResult<UpdateEntityDetailsTagsOperationMutation>;
export type UpdateEntityDetailsTagsOperationMutationOptions = Apollo.BaseMutationOptions<UpdateEntityDetailsTagsOperationMutation, UpdateEntityDetailsTagsOperationMutationVariables>;
export const InsightAsideDocument = gql`
    query InsightAside($id: ID!) {
  insight(id: $id) {
    readableId
    name
    description
    entity {
      id
      entityType
      entityTypeName
      name
      reputation
      reputationSources
    }
    severity
    confidence
    relatedIncidents {
      assignee
      id
      link
      name
      status
      type
    }
    signals {
      id
      timestamp
    }
    uniqueSignalCount
    signalCount
    timestamp
    created
    tags
  }
}
    `;

/**
 * __useInsightAsideQuery__
 *
 * To run a query within a React component, call `useInsightAsideQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightAsideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightAsideQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInsightAsideQuery(baseOptions: Apollo.QueryHookOptions<InsightAsideQuery, InsightAsideQueryVariables> & ({ variables: InsightAsideQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightAsideQuery, InsightAsideQueryVariables>(InsightAsideDocument, options);
      }
export function useInsightAsideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightAsideQuery, InsightAsideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightAsideQuery, InsightAsideQueryVariables>(InsightAsideDocument, options);
        }
export function useInsightAsideSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightAsideQuery, InsightAsideQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightAsideQuery, InsightAsideQueryVariables>(InsightAsideDocument, options);
        }
export type InsightAsideQueryHookResult = ReturnType<typeof useInsightAsideQuery>;
export type InsightAsideLazyQueryHookResult = ReturnType<typeof useInsightAsideLazyQuery>;
export type InsightAsideSuspenseQueryHookResult = ReturnType<typeof useInsightAsideSuspenseQuery>;
export type InsightAsideQueryResult = Apollo.QueryResult<InsightAsideQuery, InsightAsideQueryVariables>;
export const SignalAsideDocument = gql`
    query SignalAside($id: ID!) {
  signal(id: $id) {
    id
    name
    created
    summary
    entity {
      id
      entityType
      entityTypeName
      name
    }
    severity
    ruleId
    ruleType
    contentTypeEnum
    insights {
      readableId
      name
    }
    timestamp
    suppressed
    suppressedBySignal {
      id
      name
      contentTypeEnum
      insights {
        readableId
      }
    }
    isSuppressedBySuppressList
    suppressedByNetworkBlock
    isSuppressedByEntity
    tags
  }
}
    `;

/**
 * __useSignalAsideQuery__
 *
 * To run a query within a React component, call `useSignalAsideQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalAsideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalAsideQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignalAsideQuery(baseOptions: Apollo.QueryHookOptions<SignalAsideQuery, SignalAsideQueryVariables> & ({ variables: SignalAsideQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalAsideQuery, SignalAsideQueryVariables>(SignalAsideDocument, options);
      }
export function useSignalAsideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalAsideQuery, SignalAsideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalAsideQuery, SignalAsideQueryVariables>(SignalAsideDocument, options);
        }
export function useSignalAsideSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignalAsideQuery, SignalAsideQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SignalAsideQuery, SignalAsideQueryVariables>(SignalAsideDocument, options);
        }
export type SignalAsideQueryHookResult = ReturnType<typeof useSignalAsideQuery>;
export type SignalAsideLazyQueryHookResult = ReturnType<typeof useSignalAsideLazyQuery>;
export type SignalAsideSuspenseQueryHookResult = ReturnType<typeof useSignalAsideSuspenseQuery>;
export type SignalAsideQueryResult = Apollo.QueryResult<SignalAsideQuery, SignalAsideQueryVariables>;
export const StartEntityTimelineJobDocument = gql`
    mutation StartEntityTimelineJob($entityId: String!, $startTimestamp: DateTime!, $endTimestamp: DateTime!, $sortDir: SortDir!, $objectTypes: [String!]) {
  startEntityTimelineJob(
    entityId: $entityId
    startTimestamp: $startTimestamp
    endTimestamp: $endTimestamp
    sortDir: $sortDir
    objectTypes: $objectTypes
  ) {
    jobId
  }
}
    `;
export type StartEntityTimelineJobMutationFn = Apollo.MutationFunction<StartEntityTimelineJobMutation, StartEntityTimelineJobMutationVariables>;

/**
 * __useStartEntityTimelineJobMutation__
 *
 * To run a mutation, you first call `useStartEntityTimelineJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartEntityTimelineJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startEntityTimelineJobMutation, { data, loading, error }] = useStartEntityTimelineJobMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      startTimestamp: // value for 'startTimestamp'
 *      endTimestamp: // value for 'endTimestamp'
 *      sortDir: // value for 'sortDir'
 *      objectTypes: // value for 'objectTypes'
 *   },
 * });
 */
export function useStartEntityTimelineJobMutation(baseOptions?: Apollo.MutationHookOptions<StartEntityTimelineJobMutation, StartEntityTimelineJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartEntityTimelineJobMutation, StartEntityTimelineJobMutationVariables>(StartEntityTimelineJobDocument, options);
      }
export type StartEntityTimelineJobMutationHookResult = ReturnType<typeof useStartEntityTimelineJobMutation>;
export type StartEntityTimelineJobMutationResult = Apollo.MutationResult<StartEntityTimelineJobMutation>;
export type StartEntityTimelineJobMutationOptions = Apollo.BaseMutationOptions<StartEntityTimelineJobMutation, StartEntityTimelineJobMutationVariables>;
export const StartEntityTimelineGroupRecordJobDocument = gql`
    mutation StartEntityTimelineGroupRecordJob($entityId: String!, $startTimestamp: DateTime!, $endTimestamp: DateTime!, $summary: String!, $objectTypes: [String!]) {
  startEntityTimelineGroupRecordJob(
    entityId: $entityId
    startTimestamp: $startTimestamp
    endTimestamp: $endTimestamp
    summary: $summary
    objectTypes: $objectTypes
  ) {
    jobId
  }
}
    `;
export type StartEntityTimelineGroupRecordJobMutationFn = Apollo.MutationFunction<StartEntityTimelineGroupRecordJobMutation, StartEntityTimelineGroupRecordJobMutationVariables>;

/**
 * __useStartEntityTimelineGroupRecordJobMutation__
 *
 * To run a mutation, you first call `useStartEntityTimelineGroupRecordJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartEntityTimelineGroupRecordJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startEntityTimelineGroupRecordJobMutation, { data, loading, error }] = useStartEntityTimelineGroupRecordJobMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      startTimestamp: // value for 'startTimestamp'
 *      endTimestamp: // value for 'endTimestamp'
 *      summary: // value for 'summary'
 *      objectTypes: // value for 'objectTypes'
 *   },
 * });
 */
export function useStartEntityTimelineGroupRecordJobMutation(baseOptions?: Apollo.MutationHookOptions<StartEntityTimelineGroupRecordJobMutation, StartEntityTimelineGroupRecordJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartEntityTimelineGroupRecordJobMutation, StartEntityTimelineGroupRecordJobMutationVariables>(StartEntityTimelineGroupRecordJobDocument, options);
      }
export type StartEntityTimelineGroupRecordJobMutationHookResult = ReturnType<typeof useStartEntityTimelineGroupRecordJobMutation>;
export type StartEntityTimelineGroupRecordJobMutationResult = Apollo.MutationResult<StartEntityTimelineGroupRecordJobMutation>;
export type StartEntityTimelineGroupRecordJobMutationOptions = Apollo.BaseMutationOptions<StartEntityTimelineGroupRecordJobMutation, StartEntityTimelineGroupRecordJobMutationVariables>;
export const GetEntityTimelineGroupsDocument = gql`
    query GetEntityTimelineGroups($jobId: ID!, $offset: Int, $limit: Int) {
  entityTimelineGroups(jobId: $jobId, offset: $offset, limit: $limit) {
    startTimestamp
    endTimestamp
    summary
    recordCount
    uids
  }
  sumoRecordSearchJobStatus(jobId: $jobId) {
    state
    total
  }
}
    `;

/**
 * __useGetEntityTimelineGroupsQuery__
 *
 * To run a query within a React component, call `useGetEntityTimelineGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityTimelineGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityTimelineGroupsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetEntityTimelineGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetEntityTimelineGroupsQuery, GetEntityTimelineGroupsQueryVariables> & ({ variables: GetEntityTimelineGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntityTimelineGroupsQuery, GetEntityTimelineGroupsQueryVariables>(GetEntityTimelineGroupsDocument, options);
      }
export function useGetEntityTimelineGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntityTimelineGroupsQuery, GetEntityTimelineGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntityTimelineGroupsQuery, GetEntityTimelineGroupsQueryVariables>(GetEntityTimelineGroupsDocument, options);
        }
export function useGetEntityTimelineGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEntityTimelineGroupsQuery, GetEntityTimelineGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEntityTimelineGroupsQuery, GetEntityTimelineGroupsQueryVariables>(GetEntityTimelineGroupsDocument, options);
        }
export type GetEntityTimelineGroupsQueryHookResult = ReturnType<typeof useGetEntityTimelineGroupsQuery>;
export type GetEntityTimelineGroupsLazyQueryHookResult = ReturnType<typeof useGetEntityTimelineGroupsLazyQuery>;
export type GetEntityTimelineGroupsSuspenseQueryHookResult = ReturnType<typeof useGetEntityTimelineGroupsSuspenseQuery>;
export type GetEntityTimelineGroupsQueryResult = Apollo.QueryResult<GetEntityTimelineGroupsQuery, GetEntityTimelineGroupsQueryVariables>;
export const GetRecordGroupDetailsDocument = gql`
    query GetRecordGroupDetails($jobId: ID!) {
  sumoRecordSearchJobResults(jobId: $jobId)
  sumoRecordSearchJobStatus(jobId: $jobId) {
    state
  }
}
    `;

/**
 * __useGetRecordGroupDetailsQuery__
 *
 * To run a query within a React component, call `useGetRecordGroupDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecordGroupDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecordGroupDetailsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetRecordGroupDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetRecordGroupDetailsQuery, GetRecordGroupDetailsQueryVariables> & ({ variables: GetRecordGroupDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecordGroupDetailsQuery, GetRecordGroupDetailsQueryVariables>(GetRecordGroupDetailsDocument, options);
      }
export function useGetRecordGroupDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecordGroupDetailsQuery, GetRecordGroupDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecordGroupDetailsQuery, GetRecordGroupDetailsQueryVariables>(GetRecordGroupDetailsDocument, options);
        }
export function useGetRecordGroupDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecordGroupDetailsQuery, GetRecordGroupDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecordGroupDetailsQuery, GetRecordGroupDetailsQueryVariables>(GetRecordGroupDetailsDocument, options);
        }
export type GetRecordGroupDetailsQueryHookResult = ReturnType<typeof useGetRecordGroupDetailsQuery>;
export type GetRecordGroupDetailsLazyQueryHookResult = ReturnType<typeof useGetRecordGroupDetailsLazyQuery>;
export type GetRecordGroupDetailsSuspenseQueryHookResult = ReturnType<typeof useGetRecordGroupDetailsSuspenseQuery>;
export type GetRecordGroupDetailsQueryResult = Apollo.QueryResult<GetRecordGroupDetailsQuery, GetRecordGroupDetailsQueryVariables>;
export const GetEntityTimelineSignalsDocument = gql`
    query GetEntityTimelineSignals($id: ID!, $start: DateTime!, $end: DateTime!, $limit: Int!) {
  entity(id: $id) {
    ... on EntityInterface {
      signals: signalsV2(start: $start, end: $end, limit: $limit, uniqueResults: true) {
        total
        objects {
          ...EntityTimelineSignalsFragment
        }
      }
    }
  }
}
    ${EntityTimelineSignalsFragmentDoc}`;

/**
 * __useGetEntityTimelineSignalsQuery__
 *
 * To run a query within a React component, call `useGetEntityTimelineSignalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntityTimelineSignalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntityTimelineSignalsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetEntityTimelineSignalsQuery(baseOptions: Apollo.QueryHookOptions<GetEntityTimelineSignalsQuery, GetEntityTimelineSignalsQueryVariables> & ({ variables: GetEntityTimelineSignalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEntityTimelineSignalsQuery, GetEntityTimelineSignalsQueryVariables>(GetEntityTimelineSignalsDocument, options);
      }
export function useGetEntityTimelineSignalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntityTimelineSignalsQuery, GetEntityTimelineSignalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEntityTimelineSignalsQuery, GetEntityTimelineSignalsQueryVariables>(GetEntityTimelineSignalsDocument, options);
        }
export function useGetEntityTimelineSignalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEntityTimelineSignalsQuery, GetEntityTimelineSignalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEntityTimelineSignalsQuery, GetEntityTimelineSignalsQueryVariables>(GetEntityTimelineSignalsDocument, options);
        }
export type GetEntityTimelineSignalsQueryHookResult = ReturnType<typeof useGetEntityTimelineSignalsQuery>;
export type GetEntityTimelineSignalsLazyQueryHookResult = ReturnType<typeof useGetEntityTimelineSignalsLazyQuery>;
export type GetEntityTimelineSignalsSuspenseQueryHookResult = ReturnType<typeof useGetEntityTimelineSignalsSuspenseQuery>;
export type GetEntityTimelineSignalsQueryResult = Apollo.QueryResult<GetEntityTimelineSignalsQuery, GetEntityTimelineSignalsQueryVariables>;
export const EntityScoreQueryOperationDocument = gql`
    query EntityScoreQueryOperation {
  insightConfig {
    threshold
  }
}
    `;

/**
 * __useEntityScoreQueryOperation__
 *
 * To run a query within a React component, call `useEntityScoreQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityScoreQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityScoreQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useEntityScoreQueryOperation(baseOptions?: Apollo.QueryHookOptions<EntityScoreQueryOperationQuery, EntityScoreQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityScoreQueryOperationQuery, EntityScoreQueryOperationQueryVariables>(EntityScoreQueryOperationDocument, options);
      }
export function useEntityScoreQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityScoreQueryOperationQuery, EntityScoreQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityScoreQueryOperationQuery, EntityScoreQueryOperationQueryVariables>(EntityScoreQueryOperationDocument, options);
        }
export function useEntityScoreQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityScoreQueryOperationQuery, EntityScoreQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityScoreQueryOperationQuery, EntityScoreQueryOperationQueryVariables>(EntityScoreQueryOperationDocument, options);
        }
export type EntityScoreQueryOperationHookResult = ReturnType<typeof useEntityScoreQueryOperation>;
export type EntityScoreQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityScoreQueryOperationLazyQuery>;
export type EntityScoreQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityScoreQueryOperationSuspenseQuery>;
export type EntityScoreQueryOperationQueryResult = Apollo.QueryResult<EntityScoreQueryOperationQuery, EntityScoreQueryOperationQueryVariables>;
export const IndicatorQueryDocument = gql`
    query IndicatorQuery($entityId: ID!) {
  entity(id: $entityId) {
    id
    reputation
    reputationSources
  }
}
    `;

/**
 * __useIndicatorQuery__
 *
 * To run a query within a React component, call `useIndicatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndicatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndicatorQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useIndicatorQuery(baseOptions: Apollo.QueryHookOptions<IndicatorQuery, IndicatorQueryVariables> & ({ variables: IndicatorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndicatorQuery, IndicatorQueryVariables>(IndicatorQueryDocument, options);
      }
export function useIndicatorQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndicatorQuery, IndicatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndicatorQuery, IndicatorQueryVariables>(IndicatorQueryDocument, options);
        }
export function useIndicatorQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IndicatorQuery, IndicatorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndicatorQuery, IndicatorQueryVariables>(IndicatorQueryDocument, options);
        }
export type IndicatorQueryHookResult = ReturnType<typeof useIndicatorQuery>;
export type IndicatorQueryLazyQueryHookResult = ReturnType<typeof useIndicatorQueryLazyQuery>;
export type IndicatorQuerySuspenseQueryHookResult = ReturnType<typeof useIndicatorQuerySuspenseQuery>;
export type IndicatorQueryQueryResult = Apollo.QueryResult<IndicatorQuery, IndicatorQueryVariables>;
export const UploadEntityMutationsCsvDocument = gql`
    mutation UploadEntityMutationsCsv($file: Upload!) {
  uploadEntityMutationsCsv(file: $file) {
    uploadedEntitiesCount
  }
}
    `;
export type UploadEntityMutationsCsvMutationFn = Apollo.MutationFunction<UploadEntityMutationsCsvMutation, UploadEntityMutationsCsvMutationVariables>;

/**
 * __useUploadEntityMutationsCsv__
 *
 * To run a mutation, you first call `useUploadEntityMutationsCsv` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEntityMutationsCsv` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEntityMutationsCsv, { data, loading, error }] = useUploadEntityMutationsCsv({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadEntityMutationsCsv(baseOptions?: Apollo.MutationHookOptions<UploadEntityMutationsCsvMutation, UploadEntityMutationsCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadEntityMutationsCsvMutation, UploadEntityMutationsCsvMutationVariables>(UploadEntityMutationsCsvDocument, options);
      }
export type UploadEntityMutationsCsvHookResult = ReturnType<typeof useUploadEntityMutationsCsv>;
export type UploadEntityMutationsCsvMutationResult = Apollo.MutationResult<UploadEntityMutationsCsvMutation>;
export type UploadEntityMutationsCsvMutationOptions = Apollo.BaseMutationOptions<UploadEntityMutationsCsvMutation, UploadEntityMutationsCsvMutationVariables>;
export const UpdateEntitySuppressionDocument = gql`
    mutation UpdateEntitySuppression($entityId: ID!, $suppressed: Boolean!) {
  updateEntityWhitelist(entityId: $entityId, whitelistFlag: $suppressed) {
    data {
      ...EntityListFragment
    }
  }
}
    ${EntityListFragmentDoc}`;
export type UpdateEntitySuppressionMutationFn = Apollo.MutationFunction<UpdateEntitySuppressionMutation, UpdateEntitySuppressionMutationVariables>;

/**
 * __useUpdateEntitySuppressionMutation__
 *
 * To run a mutation, you first call `useUpdateEntitySuppressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntitySuppressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntitySuppressionMutation, { data, loading, error }] = useUpdateEntitySuppressionMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      suppressed: // value for 'suppressed'
 *   },
 * });
 */
export function useUpdateEntitySuppressionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntitySuppressionMutation, UpdateEntitySuppressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntitySuppressionMutation, UpdateEntitySuppressionMutationVariables>(UpdateEntitySuppressionDocument, options);
      }
export type UpdateEntitySuppressionMutationHookResult = ReturnType<typeof useUpdateEntitySuppressionMutation>;
export type UpdateEntitySuppressionMutationResult = Apollo.MutationResult<UpdateEntitySuppressionMutation>;
export type UpdateEntitySuppressionMutationOptions = Apollo.BaseMutationOptions<UpdateEntitySuppressionMutation, UpdateEntitySuppressionMutationVariables>;
export const EntityListQueryOperationDocument = gql`
    query EntityListQueryOperation($offset: Int, $limit: Int, $q: String, $sort: EntitySortableField!, $sortDir: SortDir!) {
  insightConfig {
    threshold
  }
  entities(
    offset: $offset
    limit: $limit
    q: $q
    sort: [{field: $sort, direction: $sortDir}]
  ) {
    total
    hasNextPage
    objects {
      ...EntityListFragment
    }
  }
}
    ${EntityListFragmentDoc}`;

/**
 * __useEntityListQueryOperation__
 *
 * To run a query within a React component, call `useEntityListQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityListQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityListQueryOperation({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      q: // value for 'q'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useEntityListQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityListQueryOperationQuery, EntityListQueryOperationQueryVariables> & ({ variables: EntityListQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityListQueryOperationQuery, EntityListQueryOperationQueryVariables>(EntityListQueryOperationDocument, options);
      }
export function useEntityListQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityListQueryOperationQuery, EntityListQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityListQueryOperationQuery, EntityListQueryOperationQueryVariables>(EntityListQueryOperationDocument, options);
        }
export function useEntityListQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityListQueryOperationQuery, EntityListQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityListQueryOperationQuery, EntityListQueryOperationQueryVariables>(EntityListQueryOperationDocument, options);
        }
export type EntityListQueryOperationHookResult = ReturnType<typeof useEntityListQueryOperation>;
export type EntityListQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityListQueryOperationLazyQuery>;
export type EntityListQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityListQueryOperationSuspenseQuery>;
export type EntityListQueryOperationQueryResult = Apollo.QueryResult<EntityListQueryOperationQuery, EntityListQueryOperationQueryVariables>;
export const EntityDetailsAuditLogQueryOperationDocument = gql`
    query EntityDetailsAuditLogQueryOperation($id: ID!) {
  entity(id: $id) {
    ... on EntityInterface {
      id
      auditLog {
        ...EntityDetailsAuditLogFragment
      }
    }
  }
}
    ${EntityDetailsAuditLogFragmentDoc}`;

/**
 * __useEntityDetailsAuditLogQueryOperation__
 *
 * To run a query within a React component, call `useEntityDetailsAuditLogQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityDetailsAuditLogQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityDetailsAuditLogQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityDetailsAuditLogQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityDetailsAuditLogQueryOperationQuery, EntityDetailsAuditLogQueryOperationQueryVariables> & ({ variables: EntityDetailsAuditLogQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityDetailsAuditLogQueryOperationQuery, EntityDetailsAuditLogQueryOperationQueryVariables>(EntityDetailsAuditLogQueryOperationDocument, options);
      }
export function useEntityDetailsAuditLogQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityDetailsAuditLogQueryOperationQuery, EntityDetailsAuditLogQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityDetailsAuditLogQueryOperationQuery, EntityDetailsAuditLogQueryOperationQueryVariables>(EntityDetailsAuditLogQueryOperationDocument, options);
        }
export function useEntityDetailsAuditLogQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityDetailsAuditLogQueryOperationQuery, EntityDetailsAuditLogQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityDetailsAuditLogQueryOperationQuery, EntityDetailsAuditLogQueryOperationQueryVariables>(EntityDetailsAuditLogQueryOperationDocument, options);
        }
export type EntityDetailsAuditLogQueryOperationHookResult = ReturnType<typeof useEntityDetailsAuditLogQueryOperation>;
export type EntityDetailsAuditLogQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityDetailsAuditLogQueryOperationLazyQuery>;
export type EntityDetailsAuditLogQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityDetailsAuditLogQueryOperationSuspenseQuery>;
export type EntityDetailsAuditLogQueryOperationQueryResult = Apollo.QueryResult<EntityDetailsAuditLogQueryOperationQuery, EntityDetailsAuditLogQueryOperationQueryVariables>;
export const EntityCriticalityConfigListDocument = gql`
    query EntityCriticalityConfigList {
  entityCriticalityConfigs {
    total
    objects {
      ...EntityCriticalityConfigListFragment
    }
  }
}
    ${EntityCriticalityConfigListFragmentDoc}`;

/**
 * __useEntityCriticalityConfigListQuery__
 *
 * To run a query within a React component, call `useEntityCriticalityConfigListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityCriticalityConfigListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityCriticalityConfigListQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntityCriticalityConfigListQuery(baseOptions?: Apollo.QueryHookOptions<EntityCriticalityConfigListQuery, EntityCriticalityConfigListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityCriticalityConfigListQuery, EntityCriticalityConfigListQueryVariables>(EntityCriticalityConfigListDocument, options);
      }
export function useEntityCriticalityConfigListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityCriticalityConfigListQuery, EntityCriticalityConfigListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityCriticalityConfigListQuery, EntityCriticalityConfigListQueryVariables>(EntityCriticalityConfigListDocument, options);
        }
export function useEntityCriticalityConfigListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityCriticalityConfigListQuery, EntityCriticalityConfigListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityCriticalityConfigListQuery, EntityCriticalityConfigListQueryVariables>(EntityCriticalityConfigListDocument, options);
        }
export type EntityCriticalityConfigListQueryHookResult = ReturnType<typeof useEntityCriticalityConfigListQuery>;
export type EntityCriticalityConfigListLazyQueryHookResult = ReturnType<typeof useEntityCriticalityConfigListLazyQuery>;
export type EntityCriticalityConfigListSuspenseQueryHookResult = ReturnType<typeof useEntityCriticalityConfigListSuspenseQuery>;
export type EntityCriticalityConfigListQueryResult = Apollo.QueryResult<EntityCriticalityConfigListQuery, EntityCriticalityConfigListQueryVariables>;
export const InventoryLookupOperationDocument = gql`
    query InventoryLookupOperation {
  inventoryLookupTableSources
}
    `;

/**
 * __useInventoryLookupOperationQuery__
 *
 * To run a query within a React component, call `useInventoryLookupOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInventoryLookupOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInventoryLookupOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useInventoryLookupOperationQuery(baseOptions?: Apollo.QueryHookOptions<InventoryLookupOperationQuery, InventoryLookupOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InventoryLookupOperationQuery, InventoryLookupOperationQueryVariables>(InventoryLookupOperationDocument, options);
      }
export function useInventoryLookupOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InventoryLookupOperationQuery, InventoryLookupOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InventoryLookupOperationQuery, InventoryLookupOperationQueryVariables>(InventoryLookupOperationDocument, options);
        }
export function useInventoryLookupOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InventoryLookupOperationQuery, InventoryLookupOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InventoryLookupOperationQuery, InventoryLookupOperationQueryVariables>(InventoryLookupOperationDocument, options);
        }
export type InventoryLookupOperationQueryHookResult = ReturnType<typeof useInventoryLookupOperationQuery>;
export type InventoryLookupOperationLazyQueryHookResult = ReturnType<typeof useInventoryLookupOperationLazyQuery>;
export type InventoryLookupOperationSuspenseQueryHookResult = ReturnType<typeof useInventoryLookupOperationSuspenseQuery>;
export type InventoryLookupOperationQueryResult = Apollo.QueryResult<InventoryLookupOperationQuery, InventoryLookupOperationQueryVariables>;
export const HudRadarQueryOperationDocument = gql`
    query HudRadarQueryOperation($start: DateTime!, $end: DateTime, $insightBucket: TimeDelta!, $signalBucket: TimeDelta!, $recordBucket: TimeDelta!) {
  insightCountsByStatus(start: $start, end: $end, bucketDuration: $insightBucket) {
    timestamp
    value {
      closed
      inProgress
      new
      other
      otherDetail {
        statusName
        statusId
        count
      }
    }
  }
  insightStatuses {
    id
    color
    source
  }
  recordCounts(start: $start, end: $end, bucketDuration: $recordBucket) {
    timestamp
    value
  }
  signalCounts(start: $start, end: $end, bucketDuration: $signalBucket) {
    timestamp
    value
  }
}
    `;

/**
 * __useHudRadarQueryOperation__
 *
 * To run a query within a React component, call `useHudRadarQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useHudRadarQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHudRadarQueryOperation({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      insightBucket: // value for 'insightBucket'
 *      signalBucket: // value for 'signalBucket'
 *      recordBucket: // value for 'recordBucket'
 *   },
 * });
 */
export function useHudRadarQueryOperation(baseOptions: Apollo.QueryHookOptions<HudRadarQueryOperationQuery, HudRadarQueryOperationQueryVariables> & ({ variables: HudRadarQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HudRadarQueryOperationQuery, HudRadarQueryOperationQueryVariables>(HudRadarQueryOperationDocument, options);
      }
export function useHudRadarQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HudRadarQueryOperationQuery, HudRadarQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HudRadarQueryOperationQuery, HudRadarQueryOperationQueryVariables>(HudRadarQueryOperationDocument, options);
        }
export function useHudRadarQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HudRadarQueryOperationQuery, HudRadarQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HudRadarQueryOperationQuery, HudRadarQueryOperationQueryVariables>(HudRadarQueryOperationDocument, options);
        }
export type HudRadarQueryOperationHookResult = ReturnType<typeof useHudRadarQueryOperation>;
export type HudRadarQueryOperationLazyQueryHookResult = ReturnType<typeof useHudRadarQueryOperationLazyQuery>;
export type HudRadarQueryOperationSuspenseQueryHookResult = ReturnType<typeof useHudRadarQueryOperationSuspenseQuery>;
export type HudRadarQueryOperationQueryResult = Apollo.QueryResult<HudRadarQueryOperationQuery, HudRadarQueryOperationQueryVariables>;
export const InsightActivityFeedQueryOperationDocument = gql`
    query InsightActivityFeedQueryOperation($nextPageTimestamp: DateTime) {
  insightActivityFeedEvents(limit: 10, nextPageTimestamp: $nextPageTimestamp) {
    nextPageTimestamp
    objects {
      timestamp
      action {
        __typename
        ... on InsightCreatedAction {
          source
        }
        ... on InsightStatusUpdatedAction {
          status {
            displayName
          }
        }
        ... on InsightAssigneeUpdatedAction {
          assignee {
            __typename
            ... on User {
              id
              displayName
            }
            ... on Team {
              id
              name
            }
            ... on UnknownUser {
              username
            }
            ... on UnknownTeam {
              name
            }
          }
        }
        ... on InsightCommentAddedAction {
          body
        }
      }
      insightId
      insightName
      user {
        id
        email
        displayName
      }
    }
  }
}
    `;

/**
 * __useInsightActivityFeedQueryOperation__
 *
 * To run a query within a React component, call `useInsightActivityFeedQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightActivityFeedQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightActivityFeedQueryOperation({
 *   variables: {
 *      nextPageTimestamp: // value for 'nextPageTimestamp'
 *   },
 * });
 */
export function useInsightActivityFeedQueryOperation(baseOptions?: Apollo.QueryHookOptions<InsightActivityFeedQueryOperationQuery, InsightActivityFeedQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightActivityFeedQueryOperationQuery, InsightActivityFeedQueryOperationQueryVariables>(InsightActivityFeedQueryOperationDocument, options);
      }
export function useInsightActivityFeedQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightActivityFeedQueryOperationQuery, InsightActivityFeedQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightActivityFeedQueryOperationQuery, InsightActivityFeedQueryOperationQueryVariables>(InsightActivityFeedQueryOperationDocument, options);
        }
export function useInsightActivityFeedQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightActivityFeedQueryOperationQuery, InsightActivityFeedQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightActivityFeedQueryOperationQuery, InsightActivityFeedQueryOperationQueryVariables>(InsightActivityFeedQueryOperationDocument, options);
        }
export type InsightActivityFeedQueryOperationHookResult = ReturnType<typeof useInsightActivityFeedQueryOperation>;
export type InsightActivityFeedQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightActivityFeedQueryOperationLazyQuery>;
export type InsightActivityFeedQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightActivityFeedQueryOperationSuspenseQuery>;
export type InsightActivityFeedQueryOperationQueryResult = Apollo.QueryResult<InsightActivityFeedQueryOperationQuery, InsightActivityFeedQueryOperationQueryVariables>;
export const InsightCountsQueryOperationDocument = gql`
    query InsightCountsQueryOperation($start: DateTime!, $end: DateTime, $insightBucket: TimeDelta!, $insightClosedBucket: TimeDelta!, $timezone: String) {
  insightCounts(
    start: $start
    end: $end
    bucketDuration: $insightBucket
    timezone: $timezone
  ) {
    timestamp
    value
  }
  insightClosedCounts(
    start: $start
    end: $end
    bucketDuration: $insightClosedBucket
    timezone: $timezone
  ) {
    timestamp
    value
  }
}
    `;

/**
 * __useInsightCountsQueryOperation__
 *
 * To run a query within a React component, call `useInsightCountsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightCountsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightCountsQueryOperation({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      insightBucket: // value for 'insightBucket'
 *      insightClosedBucket: // value for 'insightClosedBucket'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useInsightCountsQueryOperation(baseOptions: Apollo.QueryHookOptions<InsightCountsQueryOperationQuery, InsightCountsQueryOperationQueryVariables> & ({ variables: InsightCountsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightCountsQueryOperationQuery, InsightCountsQueryOperationQueryVariables>(InsightCountsQueryOperationDocument, options);
      }
export function useInsightCountsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightCountsQueryOperationQuery, InsightCountsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightCountsQueryOperationQuery, InsightCountsQueryOperationQueryVariables>(InsightCountsQueryOperationDocument, options);
        }
export function useInsightCountsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightCountsQueryOperationQuery, InsightCountsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightCountsQueryOperationQuery, InsightCountsQueryOperationQueryVariables>(InsightCountsQueryOperationDocument, options);
        }
export type InsightCountsQueryOperationHookResult = ReturnType<typeof useInsightCountsQueryOperation>;
export type InsightCountsQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightCountsQueryOperationLazyQuery>;
export type InsightCountsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightCountsQueryOperationSuspenseQuery>;
export type InsightCountsQueryOperationQueryResult = Apollo.QueryResult<InsightCountsQueryOperationQuery, InsightCountsQueryOperationQueryVariables>;
export const InsightMetricsQueryOperationDocument = gql`
    query InsightMetricsQueryOperation($interval: TimeDelta!) {
  meanTimeToDetection(interval: $interval)
  meanTimeToResponse(interval: $interval)
  meanTimeToRemediation(interval: $interval)
}
    `;

/**
 * __useInsightMetricsQueryOperation__
 *
 * To run a query within a React component, call `useInsightMetricsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightMetricsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightMetricsQueryOperation({
 *   variables: {
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function useInsightMetricsQueryOperation(baseOptions: Apollo.QueryHookOptions<InsightMetricsQueryOperationQuery, InsightMetricsQueryOperationQueryVariables> & ({ variables: InsightMetricsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightMetricsQueryOperationQuery, InsightMetricsQueryOperationQueryVariables>(InsightMetricsQueryOperationDocument, options);
      }
export function useInsightMetricsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightMetricsQueryOperationQuery, InsightMetricsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightMetricsQueryOperationQuery, InsightMetricsQueryOperationQueryVariables>(InsightMetricsQueryOperationDocument, options);
        }
export function useInsightMetricsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightMetricsQueryOperationQuery, InsightMetricsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightMetricsQueryOperationQuery, InsightMetricsQueryOperationQueryVariables>(InsightMetricsQueryOperationDocument, options);
        }
export type InsightMetricsQueryOperationHookResult = ReturnType<typeof useInsightMetricsQueryOperation>;
export type InsightMetricsQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightMetricsQueryOperationLazyQuery>;
export type InsightMetricsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightMetricsQueryOperationSuspenseQuery>;
export type InsightMetricsQueryOperationQueryResult = Apollo.QueryResult<InsightMetricsQueryOperationQuery, InsightMetricsQueryOperationQueryVariables>;
export const InsightStatusMetricsDocument = gql`
    query InsightStatusMetrics($start: DateTime!, $end: DateTime, $insightBucket: TimeDelta!) {
  insightCountsByStatus(start: $start, end: $end, bucketDuration: $insightBucket) {
    ...InsightStatusMetricsFragment
  }
  insightStatuses(includeDisabled: false) {
    ...InsightStatusMetricsStatusFragment
  }
}
    ${InsightStatusMetricsFragmentDoc}
${InsightStatusMetricsStatusFragmentDoc}`;

/**
 * __useInsightStatusMetricsQuery__
 *
 * To run a query within a React component, call `useInsightStatusMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightStatusMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightStatusMetricsQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      insightBucket: // value for 'insightBucket'
 *   },
 * });
 */
export function useInsightStatusMetricsQuery(baseOptions: Apollo.QueryHookOptions<InsightStatusMetricsQuery, InsightStatusMetricsQueryVariables> & ({ variables: InsightStatusMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightStatusMetricsQuery, InsightStatusMetricsQueryVariables>(InsightStatusMetricsDocument, options);
      }
export function useInsightStatusMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightStatusMetricsQuery, InsightStatusMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightStatusMetricsQuery, InsightStatusMetricsQueryVariables>(InsightStatusMetricsDocument, options);
        }
export function useInsightStatusMetricsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightStatusMetricsQuery, InsightStatusMetricsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightStatusMetricsQuery, InsightStatusMetricsQueryVariables>(InsightStatusMetricsDocument, options);
        }
export type InsightStatusMetricsQueryHookResult = ReturnType<typeof useInsightStatusMetricsQuery>;
export type InsightStatusMetricsLazyQueryHookResult = ReturnType<typeof useInsightStatusMetricsLazyQuery>;
export type InsightStatusMetricsSuspenseQueryHookResult = ReturnType<typeof useInsightStatusMetricsSuspenseQuery>;
export type InsightStatusMetricsQueryResult = Apollo.QueryResult<InsightStatusMetricsQuery, InsightStatusMetricsQueryVariables>;
export const PipelineMetricsOperationDocument = gql`
    query PipelineMetricsOperation($interval: TimeDelta) {
  records: bigIntRecordCountWithDelta(interval: $interval) {
    count
    delta
  }
  signals: bigIntSignalCountWithDelta(interval: $interval) {
    count
    delta
  }
  insights: bigIntInsightCountWithDelta(interval: $interval) {
    count
    delta
  }
}
    `;

/**
 * __usePipelineMetricsOperationQuery__
 *
 * To run a query within a React component, call `usePipelineMetricsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `usePipelineMetricsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePipelineMetricsOperationQuery({
 *   variables: {
 *      interval: // value for 'interval'
 *   },
 * });
 */
export function usePipelineMetricsOperationQuery(baseOptions?: Apollo.QueryHookOptions<PipelineMetricsOperationQuery, PipelineMetricsOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PipelineMetricsOperationQuery, PipelineMetricsOperationQueryVariables>(PipelineMetricsOperationDocument, options);
      }
export function usePipelineMetricsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PipelineMetricsOperationQuery, PipelineMetricsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PipelineMetricsOperationQuery, PipelineMetricsOperationQueryVariables>(PipelineMetricsOperationDocument, options);
        }
export function usePipelineMetricsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PipelineMetricsOperationQuery, PipelineMetricsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PipelineMetricsOperationQuery, PipelineMetricsOperationQueryVariables>(PipelineMetricsOperationDocument, options);
        }
export type PipelineMetricsOperationQueryHookResult = ReturnType<typeof usePipelineMetricsOperationQuery>;
export type PipelineMetricsOperationLazyQueryHookResult = ReturnType<typeof usePipelineMetricsOperationLazyQuery>;
export type PipelineMetricsOperationSuspenseQueryHookResult = ReturnType<typeof usePipelineMetricsOperationSuspenseQuery>;
export type PipelineMetricsOperationQueryResult = Apollo.QueryResult<PipelineMetricsOperationQuery, PipelineMetricsOperationQueryVariables>;
export const TopEntitiesQueryOperationDocument = gql`
    query TopEntitiesQueryOperation($limit: Int, $q: String, $sort: [EntitySort!]) {
  entities(limit: $limit, q: $q, sort: $sort) {
    objects {
      currentStateSignalIds
      entityTypeName
      entityType
      id
      name
      recentSignalSeverity
      reputation
      reputationSources
    }
  }
  insightConfig {
    lookbackDays
  }
}
    `;

/**
 * __useTopEntitiesQueryOperation__
 *
 * To run a query within a React component, call `useTopEntitiesQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useTopEntitiesQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopEntitiesQueryOperation({
 *   variables: {
 *      limit: // value for 'limit'
 *      q: // value for 'q'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useTopEntitiesQueryOperation(baseOptions?: Apollo.QueryHookOptions<TopEntitiesQueryOperationQuery, TopEntitiesQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopEntitiesQueryOperationQuery, TopEntitiesQueryOperationQueryVariables>(TopEntitiesQueryOperationDocument, options);
      }
export function useTopEntitiesQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopEntitiesQueryOperationQuery, TopEntitiesQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopEntitiesQueryOperationQuery, TopEntitiesQueryOperationQueryVariables>(TopEntitiesQueryOperationDocument, options);
        }
export function useTopEntitiesQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopEntitiesQueryOperationQuery, TopEntitiesQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopEntitiesQueryOperationQuery, TopEntitiesQueryOperationQueryVariables>(TopEntitiesQueryOperationDocument, options);
        }
export type TopEntitiesQueryOperationHookResult = ReturnType<typeof useTopEntitiesQueryOperation>;
export type TopEntitiesQueryOperationLazyQueryHookResult = ReturnType<typeof useTopEntitiesQueryOperationLazyQuery>;
export type TopEntitiesQueryOperationSuspenseQueryHookResult = ReturnType<typeof useTopEntitiesQueryOperationSuspenseQuery>;
export type TopEntitiesQueryOperationQueryResult = Apollo.QueryResult<TopEntitiesQueryOperationQuery, TopEntitiesQueryOperationQueryVariables>;
export const TopInsightQueryOperationDocument = gql`
    query TopInsightQueryOperation($limit: Int, $q: String, $sort: [InsightSort!], $enableAIInsightSummary: Boolean = false, $enableAgenticSecOps: Boolean = false) {
  insights(limit: $limit, q: $q, sort: $sort) {
    objects {
      ...InsightFields
    }
  }
}
    ${InsightFieldsFragmentDoc}`;

/**
 * __useTopInsightQueryOperation__
 *
 * To run a query within a React component, call `useTopInsightQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useTopInsightQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopInsightQueryOperation({
 *   variables: {
 *      limit: // value for 'limit'
 *      q: // value for 'q'
 *      sort: // value for 'sort'
 *      enableAIInsightSummary: // value for 'enableAIInsightSummary'
 *      enableAgenticSecOps: // value for 'enableAgenticSecOps'
 *   },
 * });
 */
export function useTopInsightQueryOperation(baseOptions?: Apollo.QueryHookOptions<TopInsightQueryOperationQuery, TopInsightQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopInsightQueryOperationQuery, TopInsightQueryOperationQueryVariables>(TopInsightQueryOperationDocument, options);
      }
export function useTopInsightQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopInsightQueryOperationQuery, TopInsightQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopInsightQueryOperationQuery, TopInsightQueryOperationQueryVariables>(TopInsightQueryOperationDocument, options);
        }
export function useTopInsightQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopInsightQueryOperationQuery, TopInsightQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopInsightQueryOperationQuery, TopInsightQueryOperationQueryVariables>(TopInsightQueryOperationDocument, options);
        }
export type TopInsightQueryOperationHookResult = ReturnType<typeof useTopInsightQueryOperation>;
export type TopInsightQueryOperationLazyQueryHookResult = ReturnType<typeof useTopInsightQueryOperationLazyQuery>;
export type TopInsightQueryOperationSuspenseQueryHookResult = ReturnType<typeof useTopInsightQueryOperationSuspenseQuery>;
export type TopInsightQueryOperationQueryResult = Apollo.QueryResult<TopInsightQueryOperationQuery, TopInsightQueryOperationQueryVariables>;
export const InsightAutomationsQueryOperationDocument = gql`
    query InsightAutomationsQueryOperation {
  automations(cseResourceType: "INSIGHT") {
    objects {
      description
      enabled
      executionTypes
      id
      name
      playbookId
    }
  }
}
    `;

/**
 * __useInsightAutomationsQueryOperation__
 *
 * To run a query within a React component, call `useInsightAutomationsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightAutomationsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightAutomationsQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useInsightAutomationsQueryOperation(baseOptions?: Apollo.QueryHookOptions<InsightAutomationsQueryOperationQuery, InsightAutomationsQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightAutomationsQueryOperationQuery, InsightAutomationsQueryOperationQueryVariables>(InsightAutomationsQueryOperationDocument, options);
      }
export function useInsightAutomationsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightAutomationsQueryOperationQuery, InsightAutomationsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightAutomationsQueryOperationQuery, InsightAutomationsQueryOperationQueryVariables>(InsightAutomationsQueryOperationDocument, options);
        }
export function useInsightAutomationsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightAutomationsQueryOperationQuery, InsightAutomationsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightAutomationsQueryOperationQuery, InsightAutomationsQueryOperationQueryVariables>(InsightAutomationsQueryOperationDocument, options);
        }
export type InsightAutomationsQueryOperationHookResult = ReturnType<typeof useInsightAutomationsQueryOperation>;
export type InsightAutomationsQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightAutomationsQueryOperationLazyQuery>;
export type InsightAutomationsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightAutomationsQueryOperationSuspenseQuery>;
export type InsightAutomationsQueryOperationQueryResult = Apollo.QueryResult<InsightAutomationsQueryOperationQuery, InsightAutomationsQueryOperationQueryVariables>;
export const ExecuteInsightAutomationOperationDocument = gql`
    mutation ExecuteInsightAutomationOperation($fields: ExecuteAutomationFields!) {
  executeAutomation(fields: $fields) {
    executionIds
    playbooksWithErrors
  }
}
    `;
export type ExecuteInsightAutomationOperationMutationFn = Apollo.MutationFunction<ExecuteInsightAutomationOperationMutation, ExecuteInsightAutomationOperationMutationVariables>;

/**
 * __useExecuteInsightAutomationOperationMutation__
 *
 * To run a mutation, you first call `useExecuteInsightAutomationOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteInsightAutomationOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeInsightAutomationOperationMutation, { data, loading, error }] = useExecuteInsightAutomationOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useExecuteInsightAutomationOperationMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteInsightAutomationOperationMutation, ExecuteInsightAutomationOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteInsightAutomationOperationMutation, ExecuteInsightAutomationOperationMutationVariables>(ExecuteInsightAutomationOperationDocument, options);
      }
export type ExecuteInsightAutomationOperationMutationHookResult = ReturnType<typeof useExecuteInsightAutomationOperationMutation>;
export type ExecuteInsightAutomationOperationMutationResult = Apollo.MutationResult<ExecuteInsightAutomationOperationMutation>;
export type ExecuteInsightAutomationOperationMutationOptions = Apollo.BaseMutationOptions<ExecuteInsightAutomationOperationMutation, ExecuteInsightAutomationOperationMutationVariables>;
export const DeleteInsightCommentOperationDocument = gql`
    mutation DeleteInsightCommentOperation($id: ID!) {
  deleteInsightComment(id: $id) {
    ok
  }
}
    `;
export type DeleteInsightCommentOperationMutationFn = Apollo.MutationFunction<DeleteInsightCommentOperationMutation, DeleteInsightCommentOperationMutationVariables>;

/**
 * __useDeleteInsightCommentOperationMutation__
 *
 * To run a mutation, you first call `useDeleteInsightCommentOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInsightCommentOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInsightCommentOperationMutation, { data, loading, error }] = useDeleteInsightCommentOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteInsightCommentOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInsightCommentOperationMutation, DeleteInsightCommentOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInsightCommentOperationMutation, DeleteInsightCommentOperationMutationVariables>(DeleteInsightCommentOperationDocument, options);
      }
export type DeleteInsightCommentOperationMutationHookResult = ReturnType<typeof useDeleteInsightCommentOperationMutation>;
export type DeleteInsightCommentOperationMutationResult = Apollo.MutationResult<DeleteInsightCommentOperationMutation>;
export type DeleteInsightCommentOperationMutationOptions = Apollo.BaseMutationOptions<DeleteInsightCommentOperationMutation, DeleteInsightCommentOperationMutationVariables>;
export const AddToIncidentDialogOperationDocument = gql`
    query AddToIncidentDialogOperation($query: String!) {
  incidentSearchResults(query: $query) {
    id
    name
  }
}
    `;

/**
 * __useAddToIncidentDialogOperationQuery__
 *
 * To run a query within a React component, call `useAddToIncidentDialogOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddToIncidentDialogOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddToIncidentDialogOperationQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAddToIncidentDialogOperationQuery(baseOptions: Apollo.QueryHookOptions<AddToIncidentDialogOperationQuery, AddToIncidentDialogOperationQueryVariables> & ({ variables: AddToIncidentDialogOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddToIncidentDialogOperationQuery, AddToIncidentDialogOperationQueryVariables>(AddToIncidentDialogOperationDocument, options);
      }
export function useAddToIncidentDialogOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddToIncidentDialogOperationQuery, AddToIncidentDialogOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddToIncidentDialogOperationQuery, AddToIncidentDialogOperationQueryVariables>(AddToIncidentDialogOperationDocument, options);
        }
export function useAddToIncidentDialogOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddToIncidentDialogOperationQuery, AddToIncidentDialogOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddToIncidentDialogOperationQuery, AddToIncidentDialogOperationQueryVariables>(AddToIncidentDialogOperationDocument, options);
        }
export type AddToIncidentDialogOperationQueryHookResult = ReturnType<typeof useAddToIncidentDialogOperationQuery>;
export type AddToIncidentDialogOperationLazyQueryHookResult = ReturnType<typeof useAddToIncidentDialogOperationLazyQuery>;
export type AddToIncidentDialogOperationSuspenseQueryHookResult = ReturnType<typeof useAddToIncidentDialogOperationSuspenseQuery>;
export type AddToIncidentDialogOperationQueryResult = Apollo.QueryResult<AddToIncidentDialogOperationQuery, AddToIncidentDialogOperationQueryVariables>;
export const AddInsightToIncidentOperationDocument = gql`
    mutation AddInsightToIncidentOperation($insightId: ID!, $incidentId: Int!, $enableAIInsightSummary: Boolean = false, $enableAgenticSecOps: Boolean = false) {
  addInsightToIncident(insightId: $insightId, incidentId: $incidentId) {
    data {
      ...InsightFields
    }
  }
}
    ${InsightFieldsFragmentDoc}`;
export type AddInsightToIncidentOperationMutationFn = Apollo.MutationFunction<AddInsightToIncidentOperationMutation, AddInsightToIncidentOperationMutationVariables>;

/**
 * __useAddInsightToIncidentOperationMutation__
 *
 * To run a mutation, you first call `useAddInsightToIncidentOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInsightToIncidentOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInsightToIncidentOperationMutation, { data, loading, error }] = useAddInsightToIncidentOperationMutation({
 *   variables: {
 *      insightId: // value for 'insightId'
 *      incidentId: // value for 'incidentId'
 *      enableAIInsightSummary: // value for 'enableAIInsightSummary'
 *      enableAgenticSecOps: // value for 'enableAgenticSecOps'
 *   },
 * });
 */
export function useAddInsightToIncidentOperationMutation(baseOptions?: Apollo.MutationHookOptions<AddInsightToIncidentOperationMutation, AddInsightToIncidentOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInsightToIncidentOperationMutation, AddInsightToIncidentOperationMutationVariables>(AddInsightToIncidentOperationDocument, options);
      }
export type AddInsightToIncidentOperationMutationHookResult = ReturnType<typeof useAddInsightToIncidentOperationMutation>;
export type AddInsightToIncidentOperationMutationResult = Apollo.MutationResult<AddInsightToIncidentOperationMutation>;
export type AddInsightToIncidentOperationMutationOptions = Apollo.BaseMutationOptions<AddInsightToIncidentOperationMutation, AddInsightToIncidentOperationMutationVariables>;
export const CreateIncidentFromInsightOperationDocument = gql`
    mutation CreateIncidentFromInsightOperation($insightId: ID!, $incidentTemplateId: Int!, $enableAIInsightSummary: Boolean = false, $enableAgenticSecOps: Boolean = false) {
  createIncidentFromInsight(
    insightId: $insightId
    incidentTemplateId: $incidentTemplateId
  ) {
    data {
      ...InsightFields
    }
  }
}
    ${InsightFieldsFragmentDoc}`;
export type CreateIncidentFromInsightOperationMutationFn = Apollo.MutationFunction<CreateIncidentFromInsightOperationMutation, CreateIncidentFromInsightOperationMutationVariables>;

/**
 * __useCreateIncidentFromInsightOperationMutation__
 *
 * To run a mutation, you first call `useCreateIncidentFromInsightOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIncidentFromInsightOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIncidentFromInsightOperationMutation, { data, loading, error }] = useCreateIncidentFromInsightOperationMutation({
 *   variables: {
 *      insightId: // value for 'insightId'
 *      incidentTemplateId: // value for 'incidentTemplateId'
 *      enableAIInsightSummary: // value for 'enableAIInsightSummary'
 *      enableAgenticSecOps: // value for 'enableAgenticSecOps'
 *   },
 * });
 */
export function useCreateIncidentFromInsightOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateIncidentFromInsightOperationMutation, CreateIncidentFromInsightOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIncidentFromInsightOperationMutation, CreateIncidentFromInsightOperationMutationVariables>(CreateIncidentFromInsightOperationDocument, options);
      }
export type CreateIncidentFromInsightOperationMutationHookResult = ReturnType<typeof useCreateIncidentFromInsightOperationMutation>;
export type CreateIncidentFromInsightOperationMutationResult = Apollo.MutationResult<CreateIncidentFromInsightOperationMutation>;
export type CreateIncidentFromInsightOperationMutationOptions = Apollo.BaseMutationOptions<CreateIncidentFromInsightOperationMutation, CreateIncidentFromInsightOperationMutationVariables>;
export const AddTagToInsightOperationDocument = gql`
    mutation AddTagToInsightOperation($id: ID!, $tagName: String!) {
  addTagToInsight(id: $id, tagName: $tagName) {
    data {
      id
      tags
    }
  }
}
    `;
export type AddTagToInsightOperationMutationFn = Apollo.MutationFunction<AddTagToInsightOperationMutation, AddTagToInsightOperationMutationVariables>;

/**
 * __useAddTagToInsightOperationMutation__
 *
 * To run a mutation, you first call `useAddTagToInsightOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagToInsightOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagToInsightOperationMutation, { data, loading, error }] = useAddTagToInsightOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tagName: // value for 'tagName'
 *   },
 * });
 */
export function useAddTagToInsightOperationMutation(baseOptions?: Apollo.MutationHookOptions<AddTagToInsightOperationMutation, AddTagToInsightOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTagToInsightOperationMutation, AddTagToInsightOperationMutationVariables>(AddTagToInsightOperationDocument, options);
      }
export type AddTagToInsightOperationMutationHookResult = ReturnType<typeof useAddTagToInsightOperationMutation>;
export type AddTagToInsightOperationMutationResult = Apollo.MutationResult<AddTagToInsightOperationMutation>;
export type AddTagToInsightOperationMutationOptions = Apollo.BaseMutationOptions<AddTagToInsightOperationMutation, AddTagToInsightOperationMutationVariables>;
export const RemoveTagFromInsightOperationDocument = gql`
    mutation RemoveTagFromInsightOperation($id: ID!, $tagName: String!) {
  removeTagFromInsight(id: $id, tagName: $tagName) {
    data {
      id
      tags
    }
  }
}
    `;
export type RemoveTagFromInsightOperationMutationFn = Apollo.MutationFunction<RemoveTagFromInsightOperationMutation, RemoveTagFromInsightOperationMutationVariables>;

/**
 * __useRemoveTagFromInsightOperationMutation__
 *
 * To run a mutation, you first call `useRemoveTagFromInsightOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagFromInsightOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagFromInsightOperationMutation, { data, loading, error }] = useRemoveTagFromInsightOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tagName: // value for 'tagName'
 *   },
 * });
 */
export function useRemoveTagFromInsightOperationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTagFromInsightOperationMutation, RemoveTagFromInsightOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTagFromInsightOperationMutation, RemoveTagFromInsightOperationMutationVariables>(RemoveTagFromInsightOperationDocument, options);
      }
export type RemoveTagFromInsightOperationMutationHookResult = ReturnType<typeof useRemoveTagFromInsightOperationMutation>;
export type RemoveTagFromInsightOperationMutationResult = Apollo.MutationResult<RemoveTagFromInsightOperationMutation>;
export type RemoveTagFromInsightOperationMutationOptions = Apollo.BaseMutationOptions<RemoveTagFromInsightOperationMutation, RemoveTagFromInsightOperationMutationVariables>;
export const UpdateInsightOperationDocument = gql`
    mutation UpdateInsightOperation($fields: InsightEditableFields!, $id: ID!, $addComment: Boolean!, $commentBody: String!) {
  addInsightComment(body: $commentBody, insightId: $id) @include(if: $addComment) {
    data {
      id
    }
  }
  updateInsight(fields: $fields, id: $id) {
    data {
      id
      assignee {
        ... on Team {
          id
          name
        }
        ... on User {
          id
          displayName
          username
        }
      }
      status {
        name
        displayName
      }
      ...InsightComments
      ...InsightHistoryEvents
    }
  }
}
    ${InsightCommentsFragmentDoc}
${InsightHistoryEventsFragmentDoc}`;
export type UpdateInsightOperationMutationFn = Apollo.MutationFunction<UpdateInsightOperationMutation, UpdateInsightOperationMutationVariables>;

/**
 * __useUpdateInsightOperationMutation__
 *
 * To run a mutation, you first call `useUpdateInsightOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightOperationMutation, { data, loading, error }] = useUpdateInsightOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *      addComment: // value for 'addComment'
 *      commentBody: // value for 'commentBody'
 *   },
 * });
 */
export function useUpdateInsightOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsightOperationMutation, UpdateInsightOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsightOperationMutation, UpdateInsightOperationMutationVariables>(UpdateInsightOperationDocument, options);
      }
export type UpdateInsightOperationMutationHookResult = ReturnType<typeof useUpdateInsightOperationMutation>;
export type UpdateInsightOperationMutationResult = Apollo.MutationResult<UpdateInsightOperationMutation>;
export type UpdateInsightOperationMutationOptions = Apollo.BaseMutationOptions<UpdateInsightOperationMutation, UpdateInsightOperationMutationVariables>;
export const ExecuteActionOperationDocument = gql`
    mutation ExecuteActionOperation($insightId: ID!, $actionId: ID!, $parameterValues: [ActionParameterValue!]) {
  executeAction(
    insightId: $insightId
    actionId: $actionId
    parameterValues: $parameterValues
  ) {
    ok
  }
}
    `;
export type ExecuteActionOperationMutationFn = Apollo.MutationFunction<ExecuteActionOperationMutation, ExecuteActionOperationMutationVariables>;

/**
 * __useExecuteActionOperationMutation__
 *
 * To run a mutation, you first call `useExecuteActionOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteActionOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeActionOperationMutation, { data, loading, error }] = useExecuteActionOperationMutation({
 *   variables: {
 *      insightId: // value for 'insightId'
 *      actionId: // value for 'actionId'
 *      parameterValues: // value for 'parameterValues'
 *   },
 * });
 */
export function useExecuteActionOperationMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteActionOperationMutation, ExecuteActionOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteActionOperationMutation, ExecuteActionOperationMutationVariables>(ExecuteActionOperationDocument, options);
      }
export type ExecuteActionOperationMutationHookResult = ReturnType<typeof useExecuteActionOperationMutation>;
export type ExecuteActionOperationMutationResult = Apollo.MutationResult<ExecuteActionOperationMutation>;
export type ExecuteActionOperationMutationOptions = Apollo.BaseMutationOptions<ExecuteActionOperationMutation, ExecuteActionOperationMutationVariables>;
export const AddInsightCommentOperationDocument = gql`
    mutation AddInsightCommentOperation($body: String!, $insightId: ID!) {
  addInsightComment(body: $body, insightId: $insightId) {
    data {
      id
      author {
        id
      }
      timestamp
      body
    }
  }
}
    `;
export type AddInsightCommentOperationMutationFn = Apollo.MutationFunction<AddInsightCommentOperationMutation, AddInsightCommentOperationMutationVariables>;

/**
 * __useAddInsightCommentOperationMutation__
 *
 * To run a mutation, you first call `useAddInsightCommentOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInsightCommentOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInsightCommentOperationMutation, { data, loading, error }] = useAddInsightCommentOperationMutation({
 *   variables: {
 *      body: // value for 'body'
 *      insightId: // value for 'insightId'
 *   },
 * });
 */
export function useAddInsightCommentOperationMutation(baseOptions?: Apollo.MutationHookOptions<AddInsightCommentOperationMutation, AddInsightCommentOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInsightCommentOperationMutation, AddInsightCommentOperationMutationVariables>(AddInsightCommentOperationDocument, options);
      }
export type AddInsightCommentOperationMutationHookResult = ReturnType<typeof useAddInsightCommentOperationMutation>;
export type AddInsightCommentOperationMutationResult = Apollo.MutationResult<AddInsightCommentOperationMutation>;
export type AddInsightCommentOperationMutationOptions = Apollo.BaseMutationOptions<AddInsightCommentOperationMutation, AddInsightCommentOperationMutationVariables>;
export const DeleteInsightOperationDocument = gql`
    mutation DeleteInsightOperation($insightId: ID!) {
  deleteInsight(insightId: $insightId) {
    data
  }
}
    `;
export type DeleteInsightOperationMutationFn = Apollo.MutationFunction<DeleteInsightOperationMutation, DeleteInsightOperationMutationVariables>;

/**
 * __useDeleteInsightOperationMutation__
 *
 * To run a mutation, you first call `useDeleteInsightOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInsightOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInsightOperationMutation, { data, loading, error }] = useDeleteInsightOperationMutation({
 *   variables: {
 *      insightId: // value for 'insightId'
 *   },
 * });
 */
export function useDeleteInsightOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInsightOperationMutation, DeleteInsightOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInsightOperationMutation, DeleteInsightOperationMutationVariables>(DeleteInsightOperationDocument, options);
      }
export type DeleteInsightOperationMutationHookResult = ReturnType<typeof useDeleteInsightOperationMutation>;
export type DeleteInsightOperationMutationResult = Apollo.MutationResult<DeleteInsightOperationMutation>;
export type DeleteInsightOperationMutationOptions = Apollo.BaseMutationOptions<DeleteInsightOperationMutation, DeleteInsightOperationMutationVariables>;
export const VisitInsightPageOperationDocument = gql`
    mutation VisitInsightPageOperation($id: ID!) {
  visitInsightPage(id: $id) {
    data {
      ... on VisitedPageInterface {
        timestamp
      }
    }
  }
}
    `;
export type VisitInsightPageOperationMutationFn = Apollo.MutationFunction<VisitInsightPageOperationMutation, VisitInsightPageOperationMutationVariables>;

/**
 * __useVisitInsightPageOperationMutation__
 *
 * To run a mutation, you first call `useVisitInsightPageOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisitInsightPageOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visitInsightPageOperationMutation, { data, loading, error }] = useVisitInsightPageOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVisitInsightPageOperationMutation(baseOptions?: Apollo.MutationHookOptions<VisitInsightPageOperationMutation, VisitInsightPageOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VisitInsightPageOperationMutation, VisitInsightPageOperationMutationVariables>(VisitInsightPageOperationDocument, options);
      }
export type VisitInsightPageOperationMutationHookResult = ReturnType<typeof useVisitInsightPageOperationMutation>;
export type VisitInsightPageOperationMutationResult = Apollo.MutationResult<VisitInsightPageOperationMutation>;
export type VisitInsightPageOperationMutationOptions = Apollo.BaseMutationOptions<VisitInsightPageOperationMutation, VisitInsightPageOperationMutationVariables>;
export const InsightEntityActivityQueryOperationDocument = gql`
    query InsightEntityActivityQueryOperation($insightId: ID!) {
  insightEntityActivity(insightId: $insightId) {
    entityId
    relatedEntityIds
    isPrimaryEntity
  }
}
    `;

/**
 * __useInsightEntityActivityQueryOperation__
 *
 * To run a query within a React component, call `useInsightEntityActivityQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightEntityActivityQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightEntityActivityQueryOperation({
 *   variables: {
 *      insightId: // value for 'insightId'
 *   },
 * });
 */
export function useInsightEntityActivityQueryOperation(baseOptions: Apollo.QueryHookOptions<InsightEntityActivityQueryOperationQuery, InsightEntityActivityQueryOperationQueryVariables> & ({ variables: InsightEntityActivityQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightEntityActivityQueryOperationQuery, InsightEntityActivityQueryOperationQueryVariables>(InsightEntityActivityQueryOperationDocument, options);
      }
export function useInsightEntityActivityQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightEntityActivityQueryOperationQuery, InsightEntityActivityQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightEntityActivityQueryOperationQuery, InsightEntityActivityQueryOperationQueryVariables>(InsightEntityActivityQueryOperationDocument, options);
        }
export function useInsightEntityActivityQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightEntityActivityQueryOperationQuery, InsightEntityActivityQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightEntityActivityQueryOperationQuery, InsightEntityActivityQueryOperationQueryVariables>(InsightEntityActivityQueryOperationDocument, options);
        }
export type InsightEntityActivityQueryOperationHookResult = ReturnType<typeof useInsightEntityActivityQueryOperation>;
export type InsightEntityActivityQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightEntityActivityQueryOperationLazyQuery>;
export type InsightEntityActivityQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightEntityActivityQueryOperationSuspenseQuery>;
export type InsightEntityActivityQueryOperationQueryResult = Apollo.QueryResult<InsightEntityActivityQueryOperationQuery, InsightEntityActivityQueryOperationQueryVariables>;
export const InsightEntitiesByListIdsQueryOperationDocument = gql`
    query InsightEntitiesByListIdsQueryOperation($ids: [ID!]) {
  entitiesByListIds(entityIds: $ids) {
    id
    entityType
    entityTypeName
    value
  }
}
    `;

/**
 * __useInsightEntitiesByListIdsQueryOperation__
 *
 * To run a query within a React component, call `useInsightEntitiesByListIdsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightEntitiesByListIdsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightEntitiesByListIdsQueryOperation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useInsightEntitiesByListIdsQueryOperation(baseOptions?: Apollo.QueryHookOptions<InsightEntitiesByListIdsQueryOperationQuery, InsightEntitiesByListIdsQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightEntitiesByListIdsQueryOperationQuery, InsightEntitiesByListIdsQueryOperationQueryVariables>(InsightEntitiesByListIdsQueryOperationDocument, options);
      }
export function useInsightEntitiesByListIdsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightEntitiesByListIdsQueryOperationQuery, InsightEntitiesByListIdsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightEntitiesByListIdsQueryOperationQuery, InsightEntitiesByListIdsQueryOperationQueryVariables>(InsightEntitiesByListIdsQueryOperationDocument, options);
        }
export function useInsightEntitiesByListIdsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightEntitiesByListIdsQueryOperationQuery, InsightEntitiesByListIdsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightEntitiesByListIdsQueryOperationQuery, InsightEntitiesByListIdsQueryOperationQueryVariables>(InsightEntitiesByListIdsQueryOperationDocument, options);
        }
export type InsightEntitiesByListIdsQueryOperationHookResult = ReturnType<typeof useInsightEntitiesByListIdsQueryOperation>;
export type InsightEntitiesByListIdsQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightEntitiesByListIdsQueryOperationLazyQuery>;
export type InsightEntitiesByListIdsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightEntitiesByListIdsQueryOperationSuspenseQuery>;
export type InsightEntitiesByListIdsQueryOperationQueryResult = Apollo.QueryResult<InsightEntitiesByListIdsQueryOperationQuery, InsightEntitiesByListIdsQueryOperationQueryVariables>;
export const InsightEntityAutomationsQueryOperationDocument = gql`
    query InsightEntityAutomationsQueryOperation {
  automations(cseResourceType: "ENTITY") {
    objects {
      cseResourceSubTypes
      description
      enabled
      executionTypes
      id
      name
      playbookId
    }
  }
}
    `;

/**
 * __useInsightEntityAutomationsQueryOperation__
 *
 * To run a query within a React component, call `useInsightEntityAutomationsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightEntityAutomationsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightEntityAutomationsQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useInsightEntityAutomationsQueryOperation(baseOptions?: Apollo.QueryHookOptions<InsightEntityAutomationsQueryOperationQuery, InsightEntityAutomationsQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightEntityAutomationsQueryOperationQuery, InsightEntityAutomationsQueryOperationQueryVariables>(InsightEntityAutomationsQueryOperationDocument, options);
      }
export function useInsightEntityAutomationsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightEntityAutomationsQueryOperationQuery, InsightEntityAutomationsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightEntityAutomationsQueryOperationQuery, InsightEntityAutomationsQueryOperationQueryVariables>(InsightEntityAutomationsQueryOperationDocument, options);
        }
export function useInsightEntityAutomationsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightEntityAutomationsQueryOperationQuery, InsightEntityAutomationsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightEntityAutomationsQueryOperationQuery, InsightEntityAutomationsQueryOperationQueryVariables>(InsightEntityAutomationsQueryOperationDocument, options);
        }
export type InsightEntityAutomationsQueryOperationHookResult = ReturnType<typeof useInsightEntityAutomationsQueryOperation>;
export type InsightEntityAutomationsQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightEntityAutomationsQueryOperationLazyQuery>;
export type InsightEntityAutomationsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightEntityAutomationsQueryOperationSuspenseQuery>;
export type InsightEntityAutomationsQueryOperationQueryResult = Apollo.QueryResult<InsightEntityAutomationsQueryOperationQuery, InsightEntityAutomationsQueryOperationQueryVariables>;
export const ExecuteInsightEntityAutomationOperationDocument = gql`
    mutation ExecuteInsightEntityAutomationOperation($fields: ExecuteAutomationFields!) {
  executeAutomation(fields: $fields) {
    executionIds
    playbooksWithErrors
  }
}
    `;
export type ExecuteInsightEntityAutomationOperationMutationFn = Apollo.MutationFunction<ExecuteInsightEntityAutomationOperationMutation, ExecuteInsightEntityAutomationOperationMutationVariables>;

/**
 * __useExecuteInsightEntityAutomationOperationMutation__
 *
 * To run a mutation, you first call `useExecuteInsightEntityAutomationOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteInsightEntityAutomationOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeInsightEntityAutomationOperationMutation, { data, loading, error }] = useExecuteInsightEntityAutomationOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useExecuteInsightEntityAutomationOperationMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteInsightEntityAutomationOperationMutation, ExecuteInsightEntityAutomationOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteInsightEntityAutomationOperationMutation, ExecuteInsightEntityAutomationOperationMutationVariables>(ExecuteInsightEntityAutomationOperationDocument, options);
      }
export type ExecuteInsightEntityAutomationOperationMutationHookResult = ReturnType<typeof useExecuteInsightEntityAutomationOperationMutation>;
export type ExecuteInsightEntityAutomationOperationMutationResult = Apollo.MutationResult<ExecuteInsightEntityAutomationOperationMutation>;
export type ExecuteInsightEntityAutomationOperationMutationOptions = Apollo.BaseMutationOptions<ExecuteInsightEntityAutomationOperationMutation, ExecuteInsightEntityAutomationOperationMutationVariables>;
export const InsightEntityDetailsQueryDocument = gql`
    query InsightEntityDetailsQuery($entityId: ID!, $detectionWindowStartTime: DateTime!, $detectionWindowEndTime: DateTime!) {
  entity(id: $entityId) {
    entityType
    entityTypeName
    id
    insights(
      limit: 20
      start: $detectionWindowStartTime
      end: $detectionWindowEndTime
      uniqueResults: true
    ) {
      total
    }
    recentSignalSeverity
    sensorZone
    reputation
    reputationSources
    signals: signalsV2(
      limit: 1
      start: $detectionWindowStartTime
      end: $detectionWindowEndTime
      uniqueResults: true
    ) {
      total
    }
    tags
    value
    __typename
  }
}
    `;

/**
 * __useInsightEntityDetailsQuery__
 *
 * To run a query within a React component, call `useInsightEntityDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightEntityDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightEntityDetailsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      detectionWindowStartTime: // value for 'detectionWindowStartTime'
 *      detectionWindowEndTime: // value for 'detectionWindowEndTime'
 *   },
 * });
 */
export function useInsightEntityDetailsQuery(baseOptions: Apollo.QueryHookOptions<InsightEntityDetailsQuery, InsightEntityDetailsQueryVariables> & ({ variables: InsightEntityDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightEntityDetailsQuery, InsightEntityDetailsQueryVariables>(InsightEntityDetailsQueryDocument, options);
      }
export function useInsightEntityDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightEntityDetailsQuery, InsightEntityDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightEntityDetailsQuery, InsightEntityDetailsQueryVariables>(InsightEntityDetailsQueryDocument, options);
        }
export function useInsightEntityDetailsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightEntityDetailsQuery, InsightEntityDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightEntityDetailsQuery, InsightEntityDetailsQueryVariables>(InsightEntityDetailsQueryDocument, options);
        }
export type InsightEntityDetailsQueryHookResult = ReturnType<typeof useInsightEntityDetailsQuery>;
export type InsightEntityDetailsQueryLazyQueryHookResult = ReturnType<typeof useInsightEntityDetailsQueryLazyQuery>;
export type InsightEntityDetailsQuerySuspenseQueryHookResult = ReturnType<typeof useInsightEntityDetailsQuerySuspenseQuery>;
export type InsightEntityDetailsQueryQueryResult = Apollo.QueryResult<InsightEntityDetailsQuery, InsightEntityDetailsQueryVariables>;
export const EntityRelationshipsByIdsDocument = gql`
    query EntityRelationshipsByIds($entityIds: [ID!], $start: DateTime!, $end: DateTime!, $entityTypes: [String!] = []) {
  entitiesByListIds(entityIds: $entityIds) {
    ...InsightEntityWithRelations
  }
}
    ${InsightEntityWithRelationsFragmentDoc}`;

/**
 * __useEntityRelationshipsByIdsQuery__
 *
 * To run a query within a React component, call `useEntityRelationshipsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityRelationshipsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityRelationshipsByIdsQuery({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      entityTypes: // value for 'entityTypes'
 *   },
 * });
 */
export function useEntityRelationshipsByIdsQuery(baseOptions: Apollo.QueryHookOptions<EntityRelationshipsByIdsQuery, EntityRelationshipsByIdsQueryVariables> & ({ variables: EntityRelationshipsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityRelationshipsByIdsQuery, EntityRelationshipsByIdsQueryVariables>(EntityRelationshipsByIdsDocument, options);
      }
export function useEntityRelationshipsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityRelationshipsByIdsQuery, EntityRelationshipsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityRelationshipsByIdsQuery, EntityRelationshipsByIdsQueryVariables>(EntityRelationshipsByIdsDocument, options);
        }
export function useEntityRelationshipsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityRelationshipsByIdsQuery, EntityRelationshipsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityRelationshipsByIdsQuery, EntityRelationshipsByIdsQueryVariables>(EntityRelationshipsByIdsDocument, options);
        }
export type EntityRelationshipsByIdsQueryHookResult = ReturnType<typeof useEntityRelationshipsByIdsQuery>;
export type EntityRelationshipsByIdsLazyQueryHookResult = ReturnType<typeof useEntityRelationshipsByIdsLazyQuery>;
export type EntityRelationshipsByIdsSuspenseQueryHookResult = ReturnType<typeof useEntityRelationshipsByIdsSuspenseQuery>;
export type EntityRelationshipsByIdsQueryResult = Apollo.QueryResult<EntityRelationshipsByIdsQuery, EntityRelationshipsByIdsQueryVariables>;
export const EntitiesDetailsDocument = gql`
    query EntitiesDetails($entityIds: [ID!]) {
  entitiesByListIds(entityIds: $entityIds) {
    ...InsightEntity
  }
}
    ${InsightEntityFragmentDoc}`;

/**
 * __useEntitiesDetailsQuery__
 *
 * To run a query within a React component, call `useEntitiesDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitiesDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitiesDetailsQuery({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useEntitiesDetailsQuery(baseOptions?: Apollo.QueryHookOptions<EntitiesDetailsQuery, EntitiesDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitiesDetailsQuery, EntitiesDetailsQueryVariables>(EntitiesDetailsDocument, options);
      }
export function useEntitiesDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitiesDetailsQuery, EntitiesDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitiesDetailsQuery, EntitiesDetailsQueryVariables>(EntitiesDetailsDocument, options);
        }
export function useEntitiesDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntitiesDetailsQuery, EntitiesDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntitiesDetailsQuery, EntitiesDetailsQueryVariables>(EntitiesDetailsDocument, options);
        }
export type EntitiesDetailsQueryHookResult = ReturnType<typeof useEntitiesDetailsQuery>;
export type EntitiesDetailsLazyQueryHookResult = ReturnType<typeof useEntitiesDetailsLazyQuery>;
export type EntitiesDetailsSuspenseQueryHookResult = ReturnType<typeof useEntitiesDetailsSuspenseQuery>;
export type EntitiesDetailsQueryResult = Apollo.QueryResult<EntitiesDetailsQuery, EntitiesDetailsQueryVariables>;
export const InsightEntityActivityQueryDocument = gql`
    query InsightEntityActivityQuery($insightId: ID!) {
  insightEntityActivity(insightId: $insightId) {
    entityId
    relatedEntityIds
    involvedSignalIds
    isPrimaryEntity
  }
}
    `;

/**
 * __useInsightEntityActivityQuery__
 *
 * To run a query within a React component, call `useInsightEntityActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightEntityActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightEntityActivityQuery({
 *   variables: {
 *      insightId: // value for 'insightId'
 *   },
 * });
 */
export function useInsightEntityActivityQuery(baseOptions: Apollo.QueryHookOptions<InsightEntityActivityQuery, InsightEntityActivityQueryVariables> & ({ variables: InsightEntityActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightEntityActivityQuery, InsightEntityActivityQueryVariables>(InsightEntityActivityQueryDocument, options);
      }
export function useInsightEntityActivityQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightEntityActivityQuery, InsightEntityActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightEntityActivityQuery, InsightEntityActivityQueryVariables>(InsightEntityActivityQueryDocument, options);
        }
export function useInsightEntityActivityQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightEntityActivityQuery, InsightEntityActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightEntityActivityQuery, InsightEntityActivityQueryVariables>(InsightEntityActivityQueryDocument, options);
        }
export type InsightEntityActivityQueryHookResult = ReturnType<typeof useInsightEntityActivityQuery>;
export type InsightEntityActivityQueryLazyQueryHookResult = ReturnType<typeof useInsightEntityActivityQueryLazyQuery>;
export type InsightEntityActivityQuerySuspenseQueryHookResult = ReturnType<typeof useInsightEntityActivityQuerySuspenseQuery>;
export type InsightEntityActivityQueryQueryResult = Apollo.QueryResult<InsightEntityActivityQuery, InsightEntityActivityQueryVariables>;
export const RelatedEntitiesCountQueryDocument = gql`
    query RelatedEntitiesCountQuery($insightId: ID!) {
  insightEntityActivity(insightId: $insightId) {
    entityId
    relatedEntityIds
  }
}
    `;

/**
 * __useRelatedEntitiesCountQuery__
 *
 * To run a query within a React component, call `useRelatedEntitiesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedEntitiesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedEntitiesCountQuery({
 *   variables: {
 *      insightId: // value for 'insightId'
 *   },
 * });
 */
export function useRelatedEntitiesCountQuery(baseOptions: Apollo.QueryHookOptions<RelatedEntitiesCountQuery, RelatedEntitiesCountQueryVariables> & ({ variables: RelatedEntitiesCountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatedEntitiesCountQuery, RelatedEntitiesCountQueryVariables>(RelatedEntitiesCountQueryDocument, options);
      }
export function useRelatedEntitiesCountQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatedEntitiesCountQuery, RelatedEntitiesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatedEntitiesCountQuery, RelatedEntitiesCountQueryVariables>(RelatedEntitiesCountQueryDocument, options);
        }
export function useRelatedEntitiesCountQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RelatedEntitiesCountQuery, RelatedEntitiesCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RelatedEntitiesCountQuery, RelatedEntitiesCountQueryVariables>(RelatedEntitiesCountQueryDocument, options);
        }
export type RelatedEntitiesCountQueryHookResult = ReturnType<typeof useRelatedEntitiesCountQuery>;
export type RelatedEntitiesCountQueryLazyQueryHookResult = ReturnType<typeof useRelatedEntitiesCountQueryLazyQuery>;
export type RelatedEntitiesCountQuerySuspenseQueryHookResult = ReturnType<typeof useRelatedEntitiesCountQuerySuspenseQuery>;
export type RelatedEntitiesCountQueryQueryResult = Apollo.QueryResult<RelatedEntitiesCountQuery, RelatedEntitiesCountQueryVariables>;
export const InsightsListForSelectQueryOperationDocument = gql`
    query InsightsListForSelectQueryOperation($q: String, $limit: Int, $offset: Int!) {
  insights(q: $q, limit: $limit, offset: $offset) {
    total
    objects {
      readableId
      name
      timestamp
    }
  }
}
    `;

/**
 * __useInsightsListForSelectQueryOperation__
 *
 * To run a query within a React component, call `useInsightsListForSelectQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightsListForSelectQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsListForSelectQueryOperation({
 *   variables: {
 *      q: // value for 'q'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useInsightsListForSelectQueryOperation(baseOptions: Apollo.QueryHookOptions<InsightsListForSelectQueryOperationQuery, InsightsListForSelectQueryOperationQueryVariables> & ({ variables: InsightsListForSelectQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsListForSelectQueryOperationQuery, InsightsListForSelectQueryOperationQueryVariables>(InsightsListForSelectQueryOperationDocument, options);
      }
export function useInsightsListForSelectQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsListForSelectQueryOperationQuery, InsightsListForSelectQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsListForSelectQueryOperationQuery, InsightsListForSelectQueryOperationQueryVariables>(InsightsListForSelectQueryOperationDocument, options);
        }
export function useInsightsListForSelectQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightsListForSelectQueryOperationQuery, InsightsListForSelectQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightsListForSelectQueryOperationQuery, InsightsListForSelectQueryOperationQueryVariables>(InsightsListForSelectQueryOperationDocument, options);
        }
export type InsightsListForSelectQueryOperationHookResult = ReturnType<typeof useInsightsListForSelectQueryOperation>;
export type InsightsListForSelectQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightsListForSelectQueryOperationLazyQuery>;
export type InsightsListForSelectQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightsListForSelectQueryOperationSuspenseQuery>;
export type InsightsListForSelectQueryOperationQueryResult = Apollo.QueryResult<InsightsListForSelectQueryOperationQuery, InsightsListForSelectQueryOperationQueryVariables>;
export const UpdateInsightResolutionOperationDocument = gql`
    mutation UpdateInsightResolutionOperation($fields: InsightEditableFields!, $id: ID!, $addComment: Boolean!, $commentBody: String!) {
  addInsightComment(body: $commentBody, insightId: $id) @include(if: $addComment) {
    data {
      id
    }
  }
  updateInsight(fields: $fields, id: $id) {
    data {
      assignee {
        ... on Team {
          id
          name
        }
        ... on User {
          id
          displayName
          username
        }
      }
      id
      resolution
      status {
        name
        displayName
      }
    }
  }
}
    `;
export type UpdateInsightResolutionOperationMutationFn = Apollo.MutationFunction<UpdateInsightResolutionOperationMutation, UpdateInsightResolutionOperationMutationVariables>;

/**
 * __useUpdateInsightResolutionOperationMutation__
 *
 * To run a mutation, you first call `useUpdateInsightResolutionOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightResolutionOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightResolutionOperationMutation, { data, loading, error }] = useUpdateInsightResolutionOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *      addComment: // value for 'addComment'
 *      commentBody: // value for 'commentBody'
 *   },
 * });
 */
export function useUpdateInsightResolutionOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsightResolutionOperationMutation, UpdateInsightResolutionOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsightResolutionOperationMutation, UpdateInsightResolutionOperationMutationVariables>(UpdateInsightResolutionOperationDocument, options);
      }
export type UpdateInsightResolutionOperationMutationHookResult = ReturnType<typeof useUpdateInsightResolutionOperationMutation>;
export type UpdateInsightResolutionOperationMutationResult = Apollo.MutationResult<UpdateInsightResolutionOperationMutation>;
export type UpdateInsightResolutionOperationMutationOptions = Apollo.BaseMutationOptions<UpdateInsightResolutionOperationMutation, UpdateInsightResolutionOperationMutationVariables>;
export const UpdateInsightsResolutionOperationDocument = gql`
    mutation UpdateInsightsResolutionOperation($fields: InsightEditableFields!, $ids: [ID!]!, $addComment: Boolean!, $commentBody: String!) {
  addInsightCommentsById(body: $commentBody, ids: $ids) @include(if: $addComment) {
    ok
  }
  updateInsightsById(fields: $fields, ids: $ids) {
    ok
  }
}
    `;
export type UpdateInsightsResolutionOperationMutationFn = Apollo.MutationFunction<UpdateInsightsResolutionOperationMutation, UpdateInsightsResolutionOperationMutationVariables>;

/**
 * __useUpdateInsightsResolutionOperationMutation__
 *
 * To run a mutation, you first call `useUpdateInsightsResolutionOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightsResolutionOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightsResolutionOperationMutation, { data, loading, error }] = useUpdateInsightsResolutionOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      ids: // value for 'ids'
 *      addComment: // value for 'addComment'
 *      commentBody: // value for 'commentBody'
 *   },
 * });
 */
export function useUpdateInsightsResolutionOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsightsResolutionOperationMutation, UpdateInsightsResolutionOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsightsResolutionOperationMutation, UpdateInsightsResolutionOperationMutationVariables>(UpdateInsightsResolutionOperationDocument, options);
      }
export type UpdateInsightsResolutionOperationMutationHookResult = ReturnType<typeof useUpdateInsightsResolutionOperationMutation>;
export type UpdateInsightsResolutionOperationMutationResult = Apollo.MutationResult<UpdateInsightsResolutionOperationMutation>;
export type UpdateInsightsResolutionOperationMutationOptions = Apollo.BaseMutationOptions<UpdateInsightsResolutionOperationMutation, UpdateInsightsResolutionOperationMutationVariables>;
export const RemoveSignalsMutationOperationDocument = gql`
    mutation RemoveSignalsMutationOperation($signalIds: [ID!]!, $insightId: ID!) {
  removeSignalsFromInsight(signalIds: $signalIds, insightId: $insightId) {
    data {
      signals {
        ...SignalFragment
      }
      relatedSignals {
        ...SignalFragment
      }
    }
  }
}
    ${SignalFragmentDoc}`;
export type RemoveSignalsMutationOperationMutationFn = Apollo.MutationFunction<RemoveSignalsMutationOperationMutation, RemoveSignalsMutationOperationMutationVariables>;

/**
 * __useRemoveSignalsMutationOperation__
 *
 * To run a mutation, you first call `useRemoveSignalsMutationOperation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSignalsMutationOperation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSignalsMutationOperation, { data, loading, error }] = useRemoveSignalsMutationOperation({
 *   variables: {
 *      signalIds: // value for 'signalIds'
 *      insightId: // value for 'insightId'
 *   },
 * });
 */
export function useRemoveSignalsMutationOperation(baseOptions?: Apollo.MutationHookOptions<RemoveSignalsMutationOperationMutation, RemoveSignalsMutationOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSignalsMutationOperationMutation, RemoveSignalsMutationOperationMutationVariables>(RemoveSignalsMutationOperationDocument, options);
      }
export type RemoveSignalsMutationOperationHookResult = ReturnType<typeof useRemoveSignalsMutationOperation>;
export type RemoveSignalsMutationOperationMutationResult = Apollo.MutationResult<RemoveSignalsMutationOperationMutation>;
export type RemoveSignalsMutationOperationMutationOptions = Apollo.BaseMutationOptions<RemoveSignalsMutationOperationMutation, RemoveSignalsMutationOperationMutationVariables>;
export const AddSignalsMutationOperationDocument = gql`
    mutation AddSignalsMutationOperation($signalId: ID!, $insightId: ID!) {
  addSignalsToInsight(signalIds: [$signalId], insightId: $insightId) {
    data {
      signals {
        ...SignalFragment
      }
      relatedSignals {
        ...SignalFragment
      }
    }
  }
}
    ${SignalFragmentDoc}`;
export type AddSignalsMutationOperationMutationFn = Apollo.MutationFunction<AddSignalsMutationOperationMutation, AddSignalsMutationOperationMutationVariables>;

/**
 * __useAddSignalsMutationOperation__
 *
 * To run a mutation, you first call `useAddSignalsMutationOperation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSignalsMutationOperation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSignalsMutationOperation, { data, loading, error }] = useAddSignalsMutationOperation({
 *   variables: {
 *      signalId: // value for 'signalId'
 *      insightId: // value for 'insightId'
 *   },
 * });
 */
export function useAddSignalsMutationOperation(baseOptions?: Apollo.MutationHookOptions<AddSignalsMutationOperationMutation, AddSignalsMutationOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSignalsMutationOperationMutation, AddSignalsMutationOperationMutationVariables>(AddSignalsMutationOperationDocument, options);
      }
export type AddSignalsMutationOperationHookResult = ReturnType<typeof useAddSignalsMutationOperation>;
export type AddSignalsMutationOperationMutationResult = Apollo.MutationResult<AddSignalsMutationOperationMutation>;
export type AddSignalsMutationOperationMutationOptions = Apollo.BaseMutationOptions<AddSignalsMutationOperationMutation, AddSignalsMutationOperationMutationVariables>;
export const InsightSignalsQueryDocument = gql`
    query InsightSignalsQuery($insightId: ID!) {
  insight(id: $insightId, includeEntityDetails: true) {
    signals {
      ...SignalFragment
    }
  }
}
    ${SignalFragmentDoc}`;

/**
 * __useInsightSignalsQuery__
 *
 * To run a query within a React component, call `useInsightSignalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightSignalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightSignalsQuery({
 *   variables: {
 *      insightId: // value for 'insightId'
 *   },
 * });
 */
export function useInsightSignalsQuery(baseOptions: Apollo.QueryHookOptions<InsightSignalsQuery, InsightSignalsQueryVariables> & ({ variables: InsightSignalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightSignalsQuery, InsightSignalsQueryVariables>(InsightSignalsQueryDocument, options);
      }
export function useInsightSignalsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightSignalsQuery, InsightSignalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightSignalsQuery, InsightSignalsQueryVariables>(InsightSignalsQueryDocument, options);
        }
export function useInsightSignalsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightSignalsQuery, InsightSignalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightSignalsQuery, InsightSignalsQueryVariables>(InsightSignalsQueryDocument, options);
        }
export type InsightSignalsQueryHookResult = ReturnType<typeof useInsightSignalsQuery>;
export type InsightSignalsQueryLazyQueryHookResult = ReturnType<typeof useInsightSignalsQueryLazyQuery>;
export type InsightSignalsQuerySuspenseQueryHookResult = ReturnType<typeof useInsightSignalsQuerySuspenseQuery>;
export type InsightSignalsQueryQueryResult = Apollo.QueryResult<InsightSignalsQuery, InsightSignalsQueryVariables>;
export const RelatedInsightSignalsQueryDocument = gql`
    query RelatedInsightSignalsQuery($insightId: ID!) {
  insight(id: $insightId, includeEntityDetails: true) {
    id
    readableId
    relatedSignals {
      ...SignalFragment
    }
    relatedInsights {
      ...InsightDetailRelatedInsight
    }
  }
}
    ${SignalFragmentDoc}
${InsightDetailRelatedInsightFragmentDoc}`;

/**
 * __useRelatedInsightSignalsQuery__
 *
 * To run a query within a React component, call `useRelatedInsightSignalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedInsightSignalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedInsightSignalsQuery({
 *   variables: {
 *      insightId: // value for 'insightId'
 *   },
 * });
 */
export function useRelatedInsightSignalsQuery(baseOptions: Apollo.QueryHookOptions<RelatedInsightSignalsQuery, RelatedInsightSignalsQueryVariables> & ({ variables: RelatedInsightSignalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatedInsightSignalsQuery, RelatedInsightSignalsQueryVariables>(RelatedInsightSignalsQueryDocument, options);
      }
export function useRelatedInsightSignalsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatedInsightSignalsQuery, RelatedInsightSignalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatedInsightSignalsQuery, RelatedInsightSignalsQueryVariables>(RelatedInsightSignalsQueryDocument, options);
        }
export function useRelatedInsightSignalsQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RelatedInsightSignalsQuery, RelatedInsightSignalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RelatedInsightSignalsQuery, RelatedInsightSignalsQueryVariables>(RelatedInsightSignalsQueryDocument, options);
        }
export type RelatedInsightSignalsQueryHookResult = ReturnType<typeof useRelatedInsightSignalsQuery>;
export type RelatedInsightSignalsQueryLazyQueryHookResult = ReturnType<typeof useRelatedInsightSignalsQueryLazyQuery>;
export type RelatedInsightSignalsQuerySuspenseQueryHookResult = ReturnType<typeof useRelatedInsightSignalsQuerySuspenseQuery>;
export type RelatedInsightSignalsQueryQueryResult = Apollo.QueryResult<RelatedInsightSignalsQuery, RelatedInsightSignalsQueryVariables>;
export const RelatedSignalTimelineQueryDocument = gql`
    query RelatedSignalTimelineQuery($insightId: ID!, $includeRelated: Boolean!) {
  insight(id: $insightId) {
    id
    readableId
    relatedSignals @include(if: $includeRelated) {
      ...SignalTimelineFragment
    }
    signals {
      ...SignalTimelineFragment
    }
  }
}
    ${SignalTimelineFragmentDoc}`;

/**
 * __useRelatedSignalTimelineQuery__
 *
 * To run a query within a React component, call `useRelatedSignalTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedSignalTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedSignalTimelineQuery({
 *   variables: {
 *      insightId: // value for 'insightId'
 *      includeRelated: // value for 'includeRelated'
 *   },
 * });
 */
export function useRelatedSignalTimelineQuery(baseOptions: Apollo.QueryHookOptions<RelatedSignalTimelineQuery, RelatedSignalTimelineQueryVariables> & ({ variables: RelatedSignalTimelineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatedSignalTimelineQuery, RelatedSignalTimelineQueryVariables>(RelatedSignalTimelineQueryDocument, options);
      }
export function useRelatedSignalTimelineQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatedSignalTimelineQuery, RelatedSignalTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatedSignalTimelineQuery, RelatedSignalTimelineQueryVariables>(RelatedSignalTimelineQueryDocument, options);
        }
export function useRelatedSignalTimelineQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RelatedSignalTimelineQuery, RelatedSignalTimelineQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RelatedSignalTimelineQuery, RelatedSignalTimelineQueryVariables>(RelatedSignalTimelineQueryDocument, options);
        }
export type RelatedSignalTimelineQueryHookResult = ReturnType<typeof useRelatedSignalTimelineQuery>;
export type RelatedSignalTimelineQueryLazyQueryHookResult = ReturnType<typeof useRelatedSignalTimelineQueryLazyQuery>;
export type RelatedSignalTimelineQuerySuspenseQueryHookResult = ReturnType<typeof useRelatedSignalTimelineQuerySuspenseQuery>;
export type RelatedSignalTimelineQueryQueryResult = Apollo.QueryResult<RelatedSignalTimelineQuery, RelatedSignalTimelineQueryVariables>;
export const GetLinkableSignalsDocument = gql`
    query GetLinkableSignals($entityId: ID!) {
  entity(id: $entityId) {
    ... on EntityInterface {
      id
      signals(hasInsight: false) {
        id
        name
        timestamp
      }
    }
  }
}
    `;

/**
 * __useGetLinkableSignalsQuery__
 *
 * To run a query within a React component, call `useGetLinkableSignalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkableSignalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkableSignalsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useGetLinkableSignalsQuery(baseOptions: Apollo.QueryHookOptions<GetLinkableSignalsQuery, GetLinkableSignalsQueryVariables> & ({ variables: GetLinkableSignalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkableSignalsQuery, GetLinkableSignalsQueryVariables>(GetLinkableSignalsDocument, options);
      }
export function useGetLinkableSignalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkableSignalsQuery, GetLinkableSignalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkableSignalsQuery, GetLinkableSignalsQueryVariables>(GetLinkableSignalsDocument, options);
        }
export function useGetLinkableSignalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLinkableSignalsQuery, GetLinkableSignalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLinkableSignalsQuery, GetLinkableSignalsQueryVariables>(GetLinkableSignalsDocument, options);
        }
export type GetLinkableSignalsQueryHookResult = ReturnType<typeof useGetLinkableSignalsQuery>;
export type GetLinkableSignalsLazyQueryHookResult = ReturnType<typeof useGetLinkableSignalsLazyQuery>;
export type GetLinkableSignalsSuspenseQueryHookResult = ReturnType<typeof useGetLinkableSignalsSuspenseQuery>;
export type GetLinkableSignalsQueryResult = Apollo.QueryResult<GetLinkableSignalsQuery, GetLinkableSignalsQueryVariables>;
export const InsightHistoryQueryOperationDocument = gql`
    query InsightHistoryQueryOperation($id: ID!) {
  insight(id: $id) {
    id
    ...InsightHistoryEvents
  }
}
    ${InsightHistoryEventsFragmentDoc}`;

/**
 * __useInsightHistoryQueryOperation__
 *
 * To run a query within a React component, call `useInsightHistoryQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightHistoryQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightHistoryQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInsightHistoryQueryOperation(baseOptions: Apollo.QueryHookOptions<InsightHistoryQueryOperationQuery, InsightHistoryQueryOperationQueryVariables> & ({ variables: InsightHistoryQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightHistoryQueryOperationQuery, InsightHistoryQueryOperationQueryVariables>(InsightHistoryQueryOperationDocument, options);
      }
export function useInsightHistoryQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightHistoryQueryOperationQuery, InsightHistoryQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightHistoryQueryOperationQuery, InsightHistoryQueryOperationQueryVariables>(InsightHistoryQueryOperationDocument, options);
        }
export function useInsightHistoryQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightHistoryQueryOperationQuery, InsightHistoryQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightHistoryQueryOperationQuery, InsightHistoryQueryOperationQueryVariables>(InsightHistoryQueryOperationDocument, options);
        }
export type InsightHistoryQueryOperationHookResult = ReturnType<typeof useInsightHistoryQueryOperation>;
export type InsightHistoryQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightHistoryQueryOperationLazyQuery>;
export type InsightHistoryQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightHistoryQueryOperationSuspenseQuery>;
export type InsightHistoryQueryOperationQueryResult = Apollo.QueryResult<InsightHistoryQueryOperationQuery, InsightHistoryQueryOperationQueryVariables>;
export const InsightCommentsQueryOperationDocument = gql`
    query InsightCommentsQueryOperation($id: ID!) {
  insight(id: $id) {
    id
    ...InsightComments
  }
}
    ${InsightCommentsFragmentDoc}`;

/**
 * __useInsightCommentsQueryOperation__
 *
 * To run a query within a React component, call `useInsightCommentsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightCommentsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightCommentsQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInsightCommentsQueryOperation(baseOptions: Apollo.QueryHookOptions<InsightCommentsQueryOperationQuery, InsightCommentsQueryOperationQueryVariables> & ({ variables: InsightCommentsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightCommentsQueryOperationQuery, InsightCommentsQueryOperationQueryVariables>(InsightCommentsQueryOperationDocument, options);
      }
export function useInsightCommentsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightCommentsQueryOperationQuery, InsightCommentsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightCommentsQueryOperationQuery, InsightCommentsQueryOperationQueryVariables>(InsightCommentsQueryOperationDocument, options);
        }
export function useInsightCommentsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightCommentsQueryOperationQuery, InsightCommentsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightCommentsQueryOperationQuery, InsightCommentsQueryOperationQueryVariables>(InsightCommentsQueryOperationDocument, options);
        }
export type InsightCommentsQueryOperationHookResult = ReturnType<typeof useInsightCommentsQueryOperation>;
export type InsightCommentsQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightCommentsQueryOperationLazyQuery>;
export type InsightCommentsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightCommentsQueryOperationSuspenseQuery>;
export type InsightCommentsQueryOperationQueryResult = Apollo.QueryResult<InsightCommentsQueryOperationQuery, InsightCommentsQueryOperationQueryVariables>;
export const InsightExecutedAutomationsCountQueryOperationDocument = gql`
    query InsightExecutedAutomationsCountQueryOperation($id: ID!) {
  insight(id: $id) {
    id
    executedAutomations {
      executionId
      statusCode
    }
  }
}
    `;

/**
 * __useInsightExecutedAutomationsCountQueryOperation__
 *
 * To run a query within a React component, call `useInsightExecutedAutomationsCountQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightExecutedAutomationsCountQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightExecutedAutomationsCountQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInsightExecutedAutomationsCountQueryOperation(baseOptions: Apollo.QueryHookOptions<InsightExecutedAutomationsCountQueryOperationQuery, InsightExecutedAutomationsCountQueryOperationQueryVariables> & ({ variables: InsightExecutedAutomationsCountQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightExecutedAutomationsCountQueryOperationQuery, InsightExecutedAutomationsCountQueryOperationQueryVariables>(InsightExecutedAutomationsCountQueryOperationDocument, options);
      }
export function useInsightExecutedAutomationsCountQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightExecutedAutomationsCountQueryOperationQuery, InsightExecutedAutomationsCountQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightExecutedAutomationsCountQueryOperationQuery, InsightExecutedAutomationsCountQueryOperationQueryVariables>(InsightExecutedAutomationsCountQueryOperationDocument, options);
        }
export function useInsightExecutedAutomationsCountQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightExecutedAutomationsCountQueryOperationQuery, InsightExecutedAutomationsCountQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightExecutedAutomationsCountQueryOperationQuery, InsightExecutedAutomationsCountQueryOperationQueryVariables>(InsightExecutedAutomationsCountQueryOperationDocument, options);
        }
export type InsightExecutedAutomationsCountQueryOperationHookResult = ReturnType<typeof useInsightExecutedAutomationsCountQueryOperation>;
export type InsightExecutedAutomationsCountQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightExecutedAutomationsCountQueryOperationLazyQuery>;
export type InsightExecutedAutomationsCountQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightExecutedAutomationsCountQueryOperationSuspenseQuery>;
export type InsightExecutedAutomationsCountQueryOperationQueryResult = Apollo.QueryResult<InsightExecutedAutomationsCountQueryOperationQuery, InsightExecutedAutomationsCountQueryOperationQueryVariables>;
export const InsightQueryOperationDocument = gql`
    query InsightQueryOperation($id: ID!, $enableAIInsightSummary: Boolean = false, $enableAgenticSecOps: Boolean = false) {
  actions(notificationType: "alert_on_demand") {
    ...InsightDetailActionFragment
  }
  insight(id: $id, includeEntityDetails: true) {
    ...InsightDetailInsightFragment
  }
  insightConfig {
    ...InsightThresholdConfigFragment
  }
  teams {
    hasNextPage
    total
    objects {
      id
      name
    }
  }
  users(active: true, limit: 1000) {
    hasNextPage
    total
    objects {
      id
      name
      email
      username
    }
  }
}
    ${InsightDetailActionFragmentDoc}
${InsightDetailInsightFragmentDoc}
${InsightThresholdConfigFragmentDoc}`;

/**
 * __useInsightQueryOperation__
 *
 * To run a query within a React component, call `useInsightQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *      enableAIInsightSummary: // value for 'enableAIInsightSummary'
 *      enableAgenticSecOps: // value for 'enableAgenticSecOps'
 *   },
 * });
 */
export function useInsightQueryOperation(baseOptions: Apollo.QueryHookOptions<InsightQueryOperationQuery, InsightQueryOperationQueryVariables> & ({ variables: InsightQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightQueryOperationQuery, InsightQueryOperationQueryVariables>(InsightQueryOperationDocument, options);
      }
export function useInsightQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightQueryOperationQuery, InsightQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightQueryOperationQuery, InsightQueryOperationQueryVariables>(InsightQueryOperationDocument, options);
        }
export function useInsightQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightQueryOperationQuery, InsightQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightQueryOperationQuery, InsightQueryOperationQueryVariables>(InsightQueryOperationDocument, options);
        }
export type InsightQueryOperationHookResult = ReturnType<typeof useInsightQueryOperation>;
export type InsightQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightQueryOperationLazyQuery>;
export type InsightQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightQueryOperationSuspenseQuery>;
export type InsightQueryOperationQueryResult = Apollo.QueryResult<InsightQueryOperationQuery, InsightQueryOperationQueryVariables>;
export const EntityRecentSignalsQueryOperationDocument = gql`
    query EntityRecentSignalsQueryOperation($id: ID!, $start: DateTime!, $end: DateTime!, $limit: Int!) {
  entity(id: $id) {
    ... on EntityInterface {
      id
      signals: signalsV2(start: $start, end: $end, limit: $limit, uniqueResults: true) {
        total
        objects {
          ...EntityRecentSignal
        }
      }
    }
  }
}
    ${EntityRecentSignalFragmentDoc}`;

/**
 * __useEntityRecentSignalsQueryOperation__
 *
 * To run a query within a React component, call `useEntityRecentSignalsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityRecentSignalsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityRecentSignalsQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useEntityRecentSignalsQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityRecentSignalsQueryOperationQuery, EntityRecentSignalsQueryOperationQueryVariables> & ({ variables: EntityRecentSignalsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityRecentSignalsQueryOperationQuery, EntityRecentSignalsQueryOperationQueryVariables>(EntityRecentSignalsQueryOperationDocument, options);
      }
export function useEntityRecentSignalsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityRecentSignalsQueryOperationQuery, EntityRecentSignalsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityRecentSignalsQueryOperationQuery, EntityRecentSignalsQueryOperationQueryVariables>(EntityRecentSignalsQueryOperationDocument, options);
        }
export function useEntityRecentSignalsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityRecentSignalsQueryOperationQuery, EntityRecentSignalsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityRecentSignalsQueryOperationQuery, EntityRecentSignalsQueryOperationQueryVariables>(EntityRecentSignalsQueryOperationDocument, options);
        }
export type EntityRecentSignalsQueryOperationHookResult = ReturnType<typeof useEntityRecentSignalsQueryOperation>;
export type EntityRecentSignalsQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityRecentSignalsQueryOperationLazyQuery>;
export type EntityRecentSignalsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityRecentSignalsQueryOperationSuspenseQuery>;
export type EntityRecentSignalsQueryOperationQueryResult = Apollo.QueryResult<EntityRecentSignalsQueryOperationQuery, EntityRecentSignalsQueryOperationQueryVariables>;
export const EntityRecentInsightsQueryOperationDocument = gql`
    query EntityRecentInsightsQueryOperation($id: ID!, $start: DateTime!, $end: DateTime!, $limit: Int!) {
  entity(id: $id) {
    ... on EntityInterface {
      id
      insights(start: $start, end: $end, limit: $limit, uniqueResults: true) {
        objects {
          readableId
          created
          name
          uniqueSignalCount
          signalCount
          severity
        }
      }
    }
  }
}
    `;

/**
 * __useEntityRecentInsightsQueryOperation__
 *
 * To run a query within a React component, call `useEntityRecentInsightsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityRecentInsightsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityRecentInsightsQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useEntityRecentInsightsQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityRecentInsightsQueryOperationQuery, EntityRecentInsightsQueryOperationQueryVariables> & ({ variables: EntityRecentInsightsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityRecentInsightsQueryOperationQuery, EntityRecentInsightsQueryOperationQueryVariables>(EntityRecentInsightsQueryOperationDocument, options);
      }
export function useEntityRecentInsightsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityRecentInsightsQueryOperationQuery, EntityRecentInsightsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityRecentInsightsQueryOperationQuery, EntityRecentInsightsQueryOperationQueryVariables>(EntityRecentInsightsQueryOperationDocument, options);
        }
export function useEntityRecentInsightsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityRecentInsightsQueryOperationQuery, EntityRecentInsightsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityRecentInsightsQueryOperationQuery, EntityRecentInsightsQueryOperationQueryVariables>(EntityRecentInsightsQueryOperationDocument, options);
        }
export type EntityRecentInsightsQueryOperationHookResult = ReturnType<typeof useEntityRecentInsightsQueryOperation>;
export type EntityRecentInsightsQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityRecentInsightsQueryOperationLazyQuery>;
export type EntityRecentInsightsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityRecentInsightsQueryOperationSuspenseQuery>;
export type EntityRecentInsightsQueryOperationQueryResult = Apollo.QueryResult<EntityRecentInsightsQueryOperationQuery, EntityRecentInsightsQueryOperationQueryVariables>;
export const AddInsightCommentsByIdOperationDocument = gql`
    mutation AddInsightCommentsByIdOperation($ids: [ID!]!, $commentBody: String!) {
  addInsightCommentsById(body: $commentBody, ids: $ids) {
    ok
  }
}
    `;
export type AddInsightCommentsByIdOperationMutationFn = Apollo.MutationFunction<AddInsightCommentsByIdOperationMutation, AddInsightCommentsByIdOperationMutationVariables>;

/**
 * __useAddInsightCommentsByIdOperationMutation__
 *
 * To run a mutation, you first call `useAddInsightCommentsByIdOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInsightCommentsByIdOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInsightCommentsByIdOperationMutation, { data, loading, error }] = useAddInsightCommentsByIdOperationMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      commentBody: // value for 'commentBody'
 *   },
 * });
 */
export function useAddInsightCommentsByIdOperationMutation(baseOptions?: Apollo.MutationHookOptions<AddInsightCommentsByIdOperationMutation, AddInsightCommentsByIdOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInsightCommentsByIdOperationMutation, AddInsightCommentsByIdOperationMutationVariables>(AddInsightCommentsByIdOperationDocument, options);
      }
export type AddInsightCommentsByIdOperationMutationHookResult = ReturnType<typeof useAddInsightCommentsByIdOperationMutation>;
export type AddInsightCommentsByIdOperationMutationResult = Apollo.MutationResult<AddInsightCommentsByIdOperationMutation>;
export type AddInsightCommentsByIdOperationMutationOptions = Apollo.BaseMutationOptions<AddInsightCommentsByIdOperationMutation, AddInsightCommentsByIdOperationMutationVariables>;
export const GroupedInsightsQueryOperationDocument = gql`
    query GroupedInsightsQueryOperation($q: String, $offset: Int, $limit: Int, $sort: InsightSortableField!, $sortDir: SortDir!, $groups: [InsightGroupOffset!]) {
  groupedInsights(
    q: $q
    offset: $offset
    limit: $limit
    sort: [{field: $sort, direction: $sortDir}]
    groupBy: STATUS
    groups: $groups
    includeDisabled: false
  ) {
    status {
      id
      name
      displayName
    }
    total
    hasNextPage
    objects {
      ...GroupedInsightFragment
    }
  }
  insightStatuses {
    id
    name
    displayName
    color
  }
}
    ${GroupedInsightFragmentDoc}`;

/**
 * __useGroupedInsightsQueryOperation__
 *
 * To run a query within a React component, call `useGroupedInsightsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useGroupedInsightsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupedInsightsQueryOperation({
 *   variables: {
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *      groups: // value for 'groups'
 *   },
 * });
 */
export function useGroupedInsightsQueryOperation(baseOptions: Apollo.QueryHookOptions<GroupedInsightsQueryOperationQuery, GroupedInsightsQueryOperationQueryVariables> & ({ variables: GroupedInsightsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupedInsightsQueryOperationQuery, GroupedInsightsQueryOperationQueryVariables>(GroupedInsightsQueryOperationDocument, options);
      }
export function useGroupedInsightsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupedInsightsQueryOperationQuery, GroupedInsightsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupedInsightsQueryOperationQuery, GroupedInsightsQueryOperationQueryVariables>(GroupedInsightsQueryOperationDocument, options);
        }
export function useGroupedInsightsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupedInsightsQueryOperationQuery, GroupedInsightsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupedInsightsQueryOperationQuery, GroupedInsightsQueryOperationQueryVariables>(GroupedInsightsQueryOperationDocument, options);
        }
export type GroupedInsightsQueryOperationHookResult = ReturnType<typeof useGroupedInsightsQueryOperation>;
export type GroupedInsightsQueryOperationLazyQueryHookResult = ReturnType<typeof useGroupedInsightsQueryOperationLazyQuery>;
export type GroupedInsightsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useGroupedInsightsQueryOperationSuspenseQuery>;
export type GroupedInsightsQueryOperationQueryResult = Apollo.QueryResult<GroupedInsightsQueryOperationQuery, GroupedInsightsQueryOperationQueryVariables>;
export const InsightsFilterFieldQueryDocument = gql`
    query InsightsFilterFieldQuery {
  insightStatuses {
    displayName
    id
    name
  }
  teams {
    objects {
      id
      name
    }
  }
}
    `;

/**
 * __useInsightsFilterFieldQuery__
 *
 * To run a query within a React component, call `useInsightsFilterFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsFilterFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsFilterFieldQuery({
 *   variables: {
 *   },
 * });
 */
export function useInsightsFilterFieldQuery(baseOptions?: Apollo.QueryHookOptions<InsightsFilterFieldQuery, InsightsFilterFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsFilterFieldQuery, InsightsFilterFieldQueryVariables>(InsightsFilterFieldQueryDocument, options);
      }
export function useInsightsFilterFieldQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsFilterFieldQuery, InsightsFilterFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsFilterFieldQuery, InsightsFilterFieldQueryVariables>(InsightsFilterFieldQueryDocument, options);
        }
export function useInsightsFilterFieldQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightsFilterFieldQuery, InsightsFilterFieldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightsFilterFieldQuery, InsightsFilterFieldQueryVariables>(InsightsFilterFieldQueryDocument, options);
        }
export type InsightsFilterFieldQueryHookResult = ReturnType<typeof useInsightsFilterFieldQuery>;
export type InsightsFilterFieldQueryLazyQueryHookResult = ReturnType<typeof useInsightsFilterFieldQueryLazyQuery>;
export type InsightsFilterFieldQuerySuspenseQueryHookResult = ReturnType<typeof useInsightsFilterFieldQuerySuspenseQuery>;
export type InsightsFilterFieldQueryQueryResult = Apollo.QueryResult<InsightsFilterFieldQuery, InsightsFilterFieldQueryVariables>;
export const InsightsListQueryOperationDocument = gql`
    query InsightsListQueryOperation($q: String, $offset: Int, $limit: Int, $sort: InsightSortableField!, $sortDir: SortDir!, $enableAIInsightSummary: Boolean = false, $enableAgenticSecOps: Boolean = false) {
  insights(
    q: $q
    offset: $offset
    limit: $limit
    sort: [{field: $sort, direction: $sortDir}]
  ) {
    total
    hasNextPage
    objects {
      ...InsightFields
    }
  }
  insightStatuses {
    id
    name
    displayName
    color
  }
  teams {
    objects {
      id
      name
    }
  }
  categories {
    name
  }
}
    ${InsightFieldsFragmentDoc}`;

/**
 * __useInsightsListQueryOperation__
 *
 * To run a query within a React component, call `useInsightsListQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightsListQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsListQueryOperation({
 *   variables: {
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *      enableAIInsightSummary: // value for 'enableAIInsightSummary'
 *      enableAgenticSecOps: // value for 'enableAgenticSecOps'
 *   },
 * });
 */
export function useInsightsListQueryOperation(baseOptions: Apollo.QueryHookOptions<InsightsListQueryOperationQuery, InsightsListQueryOperationQueryVariables> & ({ variables: InsightsListQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsListQueryOperationQuery, InsightsListQueryOperationQueryVariables>(InsightsListQueryOperationDocument, options);
      }
export function useInsightsListQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsListQueryOperationQuery, InsightsListQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsListQueryOperationQuery, InsightsListQueryOperationQueryVariables>(InsightsListQueryOperationDocument, options);
        }
export function useInsightsListQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightsListQueryOperationQuery, InsightsListQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightsListQueryOperationQuery, InsightsListQueryOperationQueryVariables>(InsightsListQueryOperationDocument, options);
        }
export type InsightsListQueryOperationHookResult = ReturnType<typeof useInsightsListQueryOperation>;
export type InsightsListQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightsListQueryOperationLazyQuery>;
export type InsightsListQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightsListQueryOperationSuspenseQuery>;
export type InsightsListQueryOperationQueryResult = Apollo.QueryResult<InsightsListQueryOperationQuery, InsightsListQueryOperationQueryVariables>;
export const InsightsDataGridDocument = gql`
    query InsightsDataGrid($q: String, $offset: Int, $limit: Int, $sort: InsightSortableField!, $sortDir: SortDir!, $enableAIInsightSummary: Boolean = false, $enableAgenticSecOps: Boolean = false) {
  insights(
    q: $q
    offset: $offset
    limit: $limit
    sort: [{field: $sort, direction: $sortDir}]
  ) {
    total
    hasNextPage
    objects {
      ...InsightFields
    }
  }
}
    ${InsightFieldsFragmentDoc}`;

/**
 * __useInsightsDataGridQuery__
 *
 * To run a query within a React component, call `useInsightsDataGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightsDataGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightsDataGridQuery({
 *   variables: {
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *      enableAIInsightSummary: // value for 'enableAIInsightSummary'
 *      enableAgenticSecOps: // value for 'enableAgenticSecOps'
 *   },
 * });
 */
export function useInsightsDataGridQuery(baseOptions: Apollo.QueryHookOptions<InsightsDataGridQuery, InsightsDataGridQueryVariables> & ({ variables: InsightsDataGridQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightsDataGridQuery, InsightsDataGridQueryVariables>(InsightsDataGridDocument, options);
      }
export function useInsightsDataGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightsDataGridQuery, InsightsDataGridQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightsDataGridQuery, InsightsDataGridQueryVariables>(InsightsDataGridDocument, options);
        }
export function useInsightsDataGridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightsDataGridQuery, InsightsDataGridQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightsDataGridQuery, InsightsDataGridQueryVariables>(InsightsDataGridDocument, options);
        }
export type InsightsDataGridQueryHookResult = ReturnType<typeof useInsightsDataGridQuery>;
export type InsightsDataGridLazyQueryHookResult = ReturnType<typeof useInsightsDataGridLazyQuery>;
export type InsightsDataGridSuspenseQueryHookResult = ReturnType<typeof useInsightsDataGridSuspenseQuery>;
export type InsightsDataGridQueryResult = Apollo.QueryResult<InsightsDataGridQuery, InsightsDataGridQueryVariables>;
export const UpdateInsightsByIdOperationDocument = gql`
    mutation UpdateInsightsByIdOperation($fields: InsightEditableFields, $ids: [ID!]!, $addComment: Boolean!, $commentBody: String!) {
  addInsightCommentsById(body: $commentBody, ids: $ids) @include(if: $addComment) {
    ok
  }
  updateInsightsById(fields: $fields, ids: $ids) {
    ok
  }
}
    `;
export type UpdateInsightsByIdOperationMutationFn = Apollo.MutationFunction<UpdateInsightsByIdOperationMutation, UpdateInsightsByIdOperationMutationVariables>;

/**
 * __useUpdateInsightsByIdOperationMutation__
 *
 * To run a mutation, you first call `useUpdateInsightsByIdOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightsByIdOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightsByIdOperationMutation, { data, loading, error }] = useUpdateInsightsByIdOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      ids: // value for 'ids'
 *      addComment: // value for 'addComment'
 *      commentBody: // value for 'commentBody'
 *   },
 * });
 */
export function useUpdateInsightsByIdOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsightsByIdOperationMutation, UpdateInsightsByIdOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsightsByIdOperationMutation, UpdateInsightsByIdOperationMutationVariables>(UpdateInsightsByIdOperationDocument, options);
      }
export type UpdateInsightsByIdOperationMutationHookResult = ReturnType<typeof useUpdateInsightsByIdOperationMutation>;
export type UpdateInsightsByIdOperationMutationResult = Apollo.MutationResult<UpdateInsightsByIdOperationMutation>;
export type UpdateInsightsByIdOperationMutationOptions = Apollo.BaseMutationOptions<UpdateInsightsByIdOperationMutation, UpdateInsightsByIdOperationMutationVariables>;
export const UpdateInsightSeverityOperationDocument = gql`
    mutation UpdateInsightSeverityOperation($id: ID!, $fields: InsightEditableFields!, $enableAIInsightSummary: Boolean = false, $enableAgenticSecOps: Boolean = false) {
  updateInsight(fields: $fields, id: $id) {
    data {
      ...InsightFields
    }
  }
}
    ${InsightFieldsFragmentDoc}`;
export type UpdateInsightSeverityOperationMutationFn = Apollo.MutationFunction<UpdateInsightSeverityOperationMutation, UpdateInsightSeverityOperationMutationVariables>;

/**
 * __useUpdateInsightSeverityOperationMutation__
 *
 * To run a mutation, you first call `useUpdateInsightSeverityOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightSeverityOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightSeverityOperationMutation, { data, loading, error }] = useUpdateInsightSeverityOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fields: // value for 'fields'
 *      enableAIInsightSummary: // value for 'enableAIInsightSummary'
 *      enableAgenticSecOps: // value for 'enableAgenticSecOps'
 *   },
 * });
 */
export function useUpdateInsightSeverityOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsightSeverityOperationMutation, UpdateInsightSeverityOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsightSeverityOperationMutation, UpdateInsightSeverityOperationMutationVariables>(UpdateInsightSeverityOperationDocument, options);
      }
export type UpdateInsightSeverityOperationMutationHookResult = ReturnType<typeof useUpdateInsightSeverityOperationMutation>;
export type UpdateInsightSeverityOperationMutationResult = Apollo.MutationResult<UpdateInsightSeverityOperationMutation>;
export type UpdateInsightSeverityOperationMutationOptions = Apollo.BaseMutationOptions<UpdateInsightSeverityOperationMutation, UpdateInsightSeverityOperationMutationVariables>;
export const UpdateInsightStatusOperationDocument = gql`
    mutation UpdateInsightStatusOperation($fields: InsightEditableFields!, $id: ID!, $addComment: Boolean!, $commentBody: String!, $enableAIInsightSummary: Boolean = false, $enableAgenticSecOps: Boolean = false) {
  addInsightComment(body: $commentBody, insightId: $id) @include(if: $addComment) {
    data {
      id
    }
  }
  updateInsight(fields: $fields, id: $id) {
    data {
      ...InsightFields
    }
  }
}
    ${InsightFieldsFragmentDoc}`;
export type UpdateInsightStatusOperationMutationFn = Apollo.MutationFunction<UpdateInsightStatusOperationMutation, UpdateInsightStatusOperationMutationVariables>;

/**
 * __useUpdateInsightStatusOperationMutation__
 *
 * To run a mutation, you first call `useUpdateInsightStatusOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightStatusOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightStatusOperationMutation, { data, loading, error }] = useUpdateInsightStatusOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *      addComment: // value for 'addComment'
 *      commentBody: // value for 'commentBody'
 *      enableAIInsightSummary: // value for 'enableAIInsightSummary'
 *      enableAgenticSecOps: // value for 'enableAgenticSecOps'
 *   },
 * });
 */
export function useUpdateInsightStatusOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsightStatusOperationMutation, UpdateInsightStatusOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsightStatusOperationMutation, UpdateInsightStatusOperationMutationVariables>(UpdateInsightStatusOperationDocument, options);
      }
export type UpdateInsightStatusOperationMutationHookResult = ReturnType<typeof useUpdateInsightStatusOperationMutation>;
export type UpdateInsightStatusOperationMutationResult = Apollo.MutationResult<UpdateInsightStatusOperationMutation>;
export type UpdateInsightStatusOperationMutationOptions = Apollo.BaseMutationOptions<UpdateInsightStatusOperationMutation, UpdateInsightStatusOperationMutationVariables>;
export const UpdateInsightAssigneeOperationDocument = gql`
    mutation UpdateInsightAssigneeOperation($fields: InsightEditableFields!, $id: ID!, $enableAIInsightSummary: Boolean = false, $enableAgenticSecOps: Boolean = false) {
  updateInsight(fields: $fields, id: $id) {
    data {
      ...InsightFields
    }
  }
}
    ${InsightFieldsFragmentDoc}`;
export type UpdateInsightAssigneeOperationMutationFn = Apollo.MutationFunction<UpdateInsightAssigneeOperationMutation, UpdateInsightAssigneeOperationMutationVariables>;

/**
 * __useUpdateInsightAssigneeOperationMutation__
 *
 * To run a mutation, you first call `useUpdateInsightAssigneeOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsightAssigneeOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsightAssigneeOperationMutation, { data, loading, error }] = useUpdateInsightAssigneeOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *      id: // value for 'id'
 *      enableAIInsightSummary: // value for 'enableAIInsightSummary'
 *      enableAgenticSecOps: // value for 'enableAgenticSecOps'
 *   },
 * });
 */
export function useUpdateInsightAssigneeOperationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInsightAssigneeOperationMutation, UpdateInsightAssigneeOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInsightAssigneeOperationMutation, UpdateInsightAssigneeOperationMutationVariables>(UpdateInsightAssigneeOperationDocument, options);
      }
export type UpdateInsightAssigneeOperationMutationHookResult = ReturnType<typeof useUpdateInsightAssigneeOperationMutation>;
export type UpdateInsightAssigneeOperationMutationResult = Apollo.MutationResult<UpdateInsightAssigneeOperationMutation>;
export type UpdateInsightAssigneeOperationMutationOptions = Apollo.BaseMutationOptions<UpdateInsightAssigneeOperationMutation, UpdateInsightAssigneeOperationMutationVariables>;
export const ConfirmTriageRecommendationOperationDocument = gql`
    mutation ConfirmTriageRecommendationOperation($accepted: Boolean!, $id: ID!, $enableAIInsightSummary: Boolean = false, $enableAgenticSecOps: Boolean = false) {
  confirmInsightTriageRecommendation(accepted: $accepted, id: $id) {
    data {
      ...InsightFields
    }
  }
}
    ${InsightFieldsFragmentDoc}`;
export type ConfirmTriageRecommendationOperationMutationFn = Apollo.MutationFunction<ConfirmTriageRecommendationOperationMutation, ConfirmTriageRecommendationOperationMutationVariables>;

/**
 * __useConfirmTriageRecommendationOperationMutation__
 *
 * To run a mutation, you first call `useConfirmTriageRecommendationOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmTriageRecommendationOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmTriageRecommendationOperationMutation, { data, loading, error }] = useConfirmTriageRecommendationOperationMutation({
 *   variables: {
 *      accepted: // value for 'accepted'
 *      id: // value for 'id'
 *      enableAIInsightSummary: // value for 'enableAIInsightSummary'
 *      enableAgenticSecOps: // value for 'enableAgenticSecOps'
 *   },
 * });
 */
export function useConfirmTriageRecommendationOperationMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmTriageRecommendationOperationMutation, ConfirmTriageRecommendationOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmTriageRecommendationOperationMutation, ConfirmTriageRecommendationOperationMutationVariables>(ConfirmTriageRecommendationOperationDocument, options);
      }
export type ConfirmTriageRecommendationOperationMutationHookResult = ReturnType<typeof useConfirmTriageRecommendationOperationMutation>;
export type ConfirmTriageRecommendationOperationMutationResult = Apollo.MutationResult<ConfirmTriageRecommendationOperationMutation>;
export type ConfirmTriageRecommendationOperationMutationOptions = Apollo.BaseMutationOptions<ConfirmTriageRecommendationOperationMutation, ConfirmTriageRecommendationOperationMutationVariables>;
export const FederatedChildOrgsListDocument = gql`
    query FederatedChildOrgsList {
  federatedChildOrgs {
    tenant
    tenantName
    tenantUrl
  }
}
    `;

/**
 * __useFederatedChildOrgsListQuery__
 *
 * To run a query within a React component, call `useFederatedChildOrgsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFederatedChildOrgsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFederatedChildOrgsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useFederatedChildOrgsListQuery(baseOptions?: Apollo.QueryHookOptions<FederatedChildOrgsListQuery, FederatedChildOrgsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FederatedChildOrgsListQuery, FederatedChildOrgsListQueryVariables>(FederatedChildOrgsListDocument, options);
      }
export function useFederatedChildOrgsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FederatedChildOrgsListQuery, FederatedChildOrgsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FederatedChildOrgsListQuery, FederatedChildOrgsListQueryVariables>(FederatedChildOrgsListDocument, options);
        }
export function useFederatedChildOrgsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FederatedChildOrgsListQuery, FederatedChildOrgsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FederatedChildOrgsListQuery, FederatedChildOrgsListQueryVariables>(FederatedChildOrgsListDocument, options);
        }
export type FederatedChildOrgsListQueryHookResult = ReturnType<typeof useFederatedChildOrgsListQuery>;
export type FederatedChildOrgsListLazyQueryHookResult = ReturnType<typeof useFederatedChildOrgsListLazyQuery>;
export type FederatedChildOrgsListSuspenseQueryHookResult = ReturnType<typeof useFederatedChildOrgsListSuspenseQuery>;
export type FederatedChildOrgsListQueryResult = Apollo.QueryResult<FederatedChildOrgsListQuery, FederatedChildOrgsListQueryVariables>;
export const ApiDocumentationLinkQueryDocument = gql`
    query ApiDocumentationLinkQuery {
  apiDocumentationLink
}
    `;

/**
 * __useApiDocumentationLinkQuery__
 *
 * To run a query within a React component, call `useApiDocumentationLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiDocumentationLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiDocumentationLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiDocumentationLinkQuery(baseOptions?: Apollo.QueryHookOptions<ApiDocumentationLinkQuery, ApiDocumentationLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiDocumentationLinkQuery, ApiDocumentationLinkQueryVariables>(ApiDocumentationLinkQueryDocument, options);
      }
export function useApiDocumentationLinkQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiDocumentationLinkQuery, ApiDocumentationLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiDocumentationLinkQuery, ApiDocumentationLinkQueryVariables>(ApiDocumentationLinkQueryDocument, options);
        }
export function useApiDocumentationLinkQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiDocumentationLinkQuery, ApiDocumentationLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiDocumentationLinkQuery, ApiDocumentationLinkQueryVariables>(ApiDocumentationLinkQueryDocument, options);
        }
export type ApiDocumentationLinkQueryHookResult = ReturnType<typeof useApiDocumentationLinkQuery>;
export type ApiDocumentationLinkQueryLazyQueryHookResult = ReturnType<typeof useApiDocumentationLinkQueryLazyQuery>;
export type ApiDocumentationLinkQuerySuspenseQueryHookResult = ReturnType<typeof useApiDocumentationLinkQuerySuspenseQuery>;
export type ApiDocumentationLinkQueryQueryResult = Apollo.QueryResult<ApiDocumentationLinkQuery, ApiDocumentationLinkQueryVariables>;
export const UserProfileOperationDocument = gql`
    query UserProfileOperation {
  version
  currentUser {
    ...UserProfileFields
  }
}
    ${UserProfileFieldsFragmentDoc}`;

/**
 * __useUserProfileOperationQuery__
 *
 * To run a query within a React component, call `useUserProfileOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserProfileOperationQuery(baseOptions?: Apollo.QueryHookOptions<UserProfileOperationQuery, UserProfileOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileOperationQuery, UserProfileOperationQueryVariables>(UserProfileOperationDocument, options);
      }
export function useUserProfileOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileOperationQuery, UserProfileOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileOperationQuery, UserProfileOperationQueryVariables>(UserProfileOperationDocument, options);
        }
export function useUserProfileOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserProfileOperationQuery, UserProfileOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserProfileOperationQuery, UserProfileOperationQueryVariables>(UserProfileOperationDocument, options);
        }
export type UserProfileOperationQueryHookResult = ReturnType<typeof useUserProfileOperationQuery>;
export type UserProfileOperationLazyQueryHookResult = ReturnType<typeof useUserProfileOperationLazyQuery>;
export type UserProfileOperationSuspenseQueryHookResult = ReturnType<typeof useUserProfileOperationSuspenseQuery>;
export type UserProfileOperationQueryResult = Apollo.QueryResult<UserProfileOperationQuery, UserProfileOperationQueryVariables>;
export const CloudSoarUrlQueryDocument = gql`
    query CloudSoarUrlQuery {
  cloudSoarUrl
}
    `;

/**
 * __useCloudSoarUrlQuery__
 *
 * To run a query within a React component, call `useCloudSoarUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useCloudSoarUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCloudSoarUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useCloudSoarUrlQuery(baseOptions?: Apollo.QueryHookOptions<CloudSoarUrlQuery, CloudSoarUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CloudSoarUrlQuery, CloudSoarUrlQueryVariables>(CloudSoarUrlQueryDocument, options);
      }
export function useCloudSoarUrlQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CloudSoarUrlQuery, CloudSoarUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CloudSoarUrlQuery, CloudSoarUrlQueryVariables>(CloudSoarUrlQueryDocument, options);
        }
export function useCloudSoarUrlQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CloudSoarUrlQuery, CloudSoarUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CloudSoarUrlQuery, CloudSoarUrlQueryVariables>(CloudSoarUrlQueryDocument, options);
        }
export type CloudSoarUrlQueryHookResult = ReturnType<typeof useCloudSoarUrlQuery>;
export type CloudSoarUrlQueryLazyQueryHookResult = ReturnType<typeof useCloudSoarUrlQueryLazyQuery>;
export type CloudSoarUrlQuerySuspenseQueryHookResult = ReturnType<typeof useCloudSoarUrlQuerySuspenseQuery>;
export type CloudSoarUrlQueryQueryResult = Apollo.QueryResult<CloudSoarUrlQuery, CloudSoarUrlQueryVariables>;
export const RecordsTabQueryOperationDocument = gql`
    query RecordsTabQueryOperation {
  recordSchema(recordType: "record")
}
    `;

/**
 * __useRecordsTabQueryOperation__
 *
 * To run a query within a React component, call `useRecordsTabQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useRecordsTabQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecordsTabQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useRecordsTabQueryOperation(baseOptions?: Apollo.QueryHookOptions<RecordsTabQueryOperationQuery, RecordsTabQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecordsTabQueryOperationQuery, RecordsTabQueryOperationQueryVariables>(RecordsTabQueryOperationDocument, options);
      }
export function useRecordsTabQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecordsTabQueryOperationQuery, RecordsTabQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecordsTabQueryOperationQuery, RecordsTabQueryOperationQueryVariables>(RecordsTabQueryOperationDocument, options);
        }
export function useRecordsTabQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecordsTabQueryOperationQuery, RecordsTabQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecordsTabQueryOperationQuery, RecordsTabQueryOperationQueryVariables>(RecordsTabQueryOperationDocument, options);
        }
export type RecordsTabQueryOperationHookResult = ReturnType<typeof useRecordsTabQueryOperation>;
export type RecordsTabQueryOperationLazyQueryHookResult = ReturnType<typeof useRecordsTabQueryOperationLazyQuery>;
export type RecordsTabQueryOperationSuspenseQueryHookResult = ReturnType<typeof useRecordsTabQueryOperationSuspenseQuery>;
export type RecordsTabQueryOperationQueryResult = Apollo.QueryResult<RecordsTabQueryOperationQuery, RecordsTabQueryOperationQueryVariables>;
export const AdvancedSearchQueryOperationDocument = gql`
    query AdvancedSearchQueryOperation($q: String!, $limit: Int!, $offset: Int!, $resultType: SearchResultType!, $sort: [SearchResultSort!]) {
  dslSearchResults(
    q: $q
    limit: $limit
    offset: $offset
    resultType: $resultType
    sort: $sort
  ) {
    hasNextPage
    total
    objects {
      matchedField {
        name
        value
        exact
        characterRanges {
          start
          end
        }
      }
      object {
        ... on Insight {
          id
          name
          timestamp
          signalCount
          uniqueSignalCount
          entity {
            ... on EntityInterface {
              id
              name: value
              value
              sensorZone
            }
          }
        }
        ... on EntityInterface {
          id
          entityType
          name: value
          value
          lastSeen
          activityScore
          entityTypeName
          isWhitelisted
        }
        ... on Signal {
          id
          name
          severity
          timestamp
        }
      }
    }
  }
}
    `;

/**
 * __useAdvancedSearchQueryOperation__
 *
 * To run a query within a React component, call `useAdvancedSearchQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useAdvancedSearchQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdvancedSearchQueryOperation({
 *   variables: {
 *      q: // value for 'q'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      resultType: // value for 'resultType'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useAdvancedSearchQueryOperation(baseOptions: Apollo.QueryHookOptions<AdvancedSearchQueryOperationQuery, AdvancedSearchQueryOperationQueryVariables> & ({ variables: AdvancedSearchQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdvancedSearchQueryOperationQuery, AdvancedSearchQueryOperationQueryVariables>(AdvancedSearchQueryOperationDocument, options);
      }
export function useAdvancedSearchQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdvancedSearchQueryOperationQuery, AdvancedSearchQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdvancedSearchQueryOperationQuery, AdvancedSearchQueryOperationQueryVariables>(AdvancedSearchQueryOperationDocument, options);
        }
export function useAdvancedSearchQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdvancedSearchQueryOperationQuery, AdvancedSearchQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdvancedSearchQueryOperationQuery, AdvancedSearchQueryOperationQueryVariables>(AdvancedSearchQueryOperationDocument, options);
        }
export type AdvancedSearchQueryOperationHookResult = ReturnType<typeof useAdvancedSearchQueryOperation>;
export type AdvancedSearchQueryOperationLazyQueryHookResult = ReturnType<typeof useAdvancedSearchQueryOperationLazyQuery>;
export type AdvancedSearchQueryOperationSuspenseQueryHookResult = ReturnType<typeof useAdvancedSearchQueryOperationSuspenseQuery>;
export type AdvancedSearchQueryOperationQueryResult = Apollo.QueryResult<AdvancedSearchQueryOperationQuery, AdvancedSearchQueryOperationQueryVariables>;
export const KeywordSearchQueryOperationDocument = gql`
    query KeywordSearchQueryOperation($q: String!, $limit: Int!, $offset: Int!, $resultType: SearchResultType!) {
  dslSearchResults(q: $q, limit: $limit, offset: $offset, resultType: $resultType) {
    hasNextPage
    total
    objects {
      matchedField {
        name
        value
        exact
        characterRanges {
          start
          end
        }
      }
      object {
        ... on Insight {
          id
          name
          timestamp
          signalCount
          uniqueSignalCount
          entity {
            ... on EntityInterface {
              id
              name: value
              value
              sensorZone
            }
          }
        }
        ... on EntityInterface {
          id
          entityType
          name: value
          value
          sensorZone
          lastSeen
          activityScore
          entityTypeName
          isWhitelisted
        }
        ... on Signal {
          id
          name
          severity
          timestamp
        }
      }
    }
  }
  insights(q: $q, limit: 0) {
    total
  }
  signals(q: $q, limit: 0) {
    total
  }
  entities(q: $q, limit: 0) {
    total
  }
}
    `;

/**
 * __useKeywordSearchQueryOperation__
 *
 * To run a query within a React component, call `useKeywordSearchQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useKeywordSearchQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeywordSearchQueryOperation({
 *   variables: {
 *      q: // value for 'q'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      resultType: // value for 'resultType'
 *   },
 * });
 */
export function useKeywordSearchQueryOperation(baseOptions: Apollo.QueryHookOptions<KeywordSearchQueryOperationQuery, KeywordSearchQueryOperationQueryVariables> & ({ variables: KeywordSearchQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeywordSearchQueryOperationQuery, KeywordSearchQueryOperationQueryVariables>(KeywordSearchQueryOperationDocument, options);
      }
export function useKeywordSearchQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeywordSearchQueryOperationQuery, KeywordSearchQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeywordSearchQueryOperationQuery, KeywordSearchQueryOperationQueryVariables>(KeywordSearchQueryOperationDocument, options);
        }
export function useKeywordSearchQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<KeywordSearchQueryOperationQuery, KeywordSearchQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<KeywordSearchQueryOperationQuery, KeywordSearchQueryOperationQueryVariables>(KeywordSearchQueryOperationDocument, options);
        }
export type KeywordSearchQueryOperationHookResult = ReturnType<typeof useKeywordSearchQueryOperation>;
export type KeywordSearchQueryOperationLazyQueryHookResult = ReturnType<typeof useKeywordSearchQueryOperationLazyQuery>;
export type KeywordSearchQueryOperationSuspenseQueryHookResult = ReturnType<typeof useKeywordSearchQueryOperationSuspenseQuery>;
export type KeywordSearchQueryOperationQueryResult = Apollo.QueryResult<KeywordSearchQueryOperationQuery, KeywordSearchQueryOperationQueryVariables>;
export const SearchHistoryOperationDocument = gql`
    query SearchHistoryOperation {
  recentlyVisitedDetailPages {
    ...RecentlyVisitedDetailsPageFragment
  }
  recentlyVisitedSearchQueryPages {
    ...VisitedSearchQueryPageFragment
  }
  insightStatuses {
    ...SearchHistoryInsightStatusFragment
  }
  teams {
    objects {
      id
      name
    }
  }
  users {
    objects {
      ...SearchHistoryUserFragment
    }
  }
  entityCriticalityConfigs {
    objects {
      ...EntityCriticalityConfigsFragment
    }
  }
}
    ${RecentlyVisitedDetailsPageFragmentDoc}
${VisitedSearchQueryPageFragmentDoc}
${SearchHistoryInsightStatusFragmentDoc}
${SearchHistoryUserFragmentDoc}
${EntityCriticalityConfigsFragmentDoc}`;

/**
 * __useSearchHistoryOperationQuery__
 *
 * To run a query within a React component, call `useSearchHistoryOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchHistoryOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchHistoryOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchHistoryOperationQuery(baseOptions?: Apollo.QueryHookOptions<SearchHistoryOperationQuery, SearchHistoryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchHistoryOperationQuery, SearchHistoryOperationQueryVariables>(SearchHistoryOperationDocument, options);
      }
export function useSearchHistoryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchHistoryOperationQuery, SearchHistoryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchHistoryOperationQuery, SearchHistoryOperationQueryVariables>(SearchHistoryOperationDocument, options);
        }
export function useSearchHistoryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchHistoryOperationQuery, SearchHistoryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchHistoryOperationQuery, SearchHistoryOperationQueryVariables>(SearchHistoryOperationDocument, options);
        }
export type SearchHistoryOperationQueryHookResult = ReturnType<typeof useSearchHistoryOperationQuery>;
export type SearchHistoryOperationLazyQueryHookResult = ReturnType<typeof useSearchHistoryOperationLazyQuery>;
export type SearchHistoryOperationSuspenseQueryHookResult = ReturnType<typeof useSearchHistoryOperationSuspenseQuery>;
export type SearchHistoryOperationQueryResult = Apollo.QueryResult<SearchHistoryOperationQuery, SearchHistoryOperationQueryVariables>;
export const FilterQueryOperationDocument = gql`
    query FilterQueryOperation {
  recentlyVisitedSearchQueryPages {
    ...VisitedSearchQueryPageFragment
  }
  insightStatuses(includeDisabled: false) {
    id
    name
    displayName
    description
  }
  teams {
    objects {
      id
      name
    }
  }
  users {
    objects {
      id
      name
      email
      username
      displayName
    }
  }
  categories {
    name
  }
  recordSchema(recordType: "record")
  entityCriticalityConfigs {
    objects {
      name
    }
  }
}
    ${VisitedSearchQueryPageFragmentDoc}`;

/**
 * __useFilterQueryOperation__
 *
 * To run a query within a React component, call `useFilterQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useFilterQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useFilterQueryOperation(baseOptions?: Apollo.QueryHookOptions<FilterQueryOperationQuery, FilterQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterQueryOperationQuery, FilterQueryOperationQueryVariables>(FilterQueryOperationDocument, options);
      }
export function useFilterQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterQueryOperationQuery, FilterQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterQueryOperationQuery, FilterQueryOperationQueryVariables>(FilterQueryOperationDocument, options);
        }
export function useFilterQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FilterQueryOperationQuery, FilterQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FilterQueryOperationQuery, FilterQueryOperationQueryVariables>(FilterQueryOperationDocument, options);
        }
export type FilterQueryOperationHookResult = ReturnType<typeof useFilterQueryOperation>;
export type FilterQueryOperationLazyQueryHookResult = ReturnType<typeof useFilterQueryOperationLazyQuery>;
export type FilterQueryOperationSuspenseQueryHookResult = ReturnType<typeof useFilterQueryOperationSuspenseQuery>;
export type FilterQueryOperationQueryResult = Apollo.QueryResult<FilterQueryOperationQuery, FilterQueryOperationQueryVariables>;
export const VisitSearchQueryPageOperationDocument = gql`
    mutation VisitSearchQueryPageOperation($q: String!, $resultType: SearchResultType!) {
  visitSearchQueryPage(q: $q, resultType: $resultType) {
    data {
      q
    }
  }
}
    `;
export type VisitSearchQueryPageOperationMutationFn = Apollo.MutationFunction<VisitSearchQueryPageOperationMutation, VisitSearchQueryPageOperationMutationVariables>;

/**
 * __useVisitSearchQueryPageOperation__
 *
 * To run a mutation, you first call `useVisitSearchQueryPageOperation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisitSearchQueryPageOperation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visitSearchQueryPageOperation, { data, loading, error }] = useVisitSearchQueryPageOperation({
 *   variables: {
 *      q: // value for 'q'
 *      resultType: // value for 'resultType'
 *   },
 * });
 */
export function useVisitSearchQueryPageOperation(baseOptions?: Apollo.MutationHookOptions<VisitSearchQueryPageOperationMutation, VisitSearchQueryPageOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VisitSearchQueryPageOperationMutation, VisitSearchQueryPageOperationMutationVariables>(VisitSearchQueryPageOperationDocument, options);
      }
export type VisitSearchQueryPageOperationHookResult = ReturnType<typeof useVisitSearchQueryPageOperation>;
export type VisitSearchQueryPageOperationMutationResult = Apollo.MutationResult<VisitSearchQueryPageOperationMutation>;
export type VisitSearchQueryPageOperationMutationOptions = Apollo.BaseMutationOptions<VisitSearchQueryPageOperationMutation, VisitSearchQueryPageOperationMutationVariables>;
export const SignalQueryOperationDocument = gql`
    query SignalQueryOperation($id: ID!) {
  signal(id: $id) {
    ...SignalQueryFragment
  }
}
    ${SignalQueryFragmentDoc}`;

/**
 * __useSignalQueryOperation__
 *
 * To run a query within a React component, call `useSignalQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useSignalQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignalQueryOperation(baseOptions: Apollo.QueryHookOptions<SignalQueryOperationQuery, SignalQueryOperationQueryVariables> & ({ variables: SignalQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalQueryOperationQuery, SignalQueryOperationQueryVariables>(SignalQueryOperationDocument, options);
      }
export function useSignalQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalQueryOperationQuery, SignalQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalQueryOperationQuery, SignalQueryOperationQueryVariables>(SignalQueryOperationDocument, options);
        }
export function useSignalQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignalQueryOperationQuery, SignalQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SignalQueryOperationQuery, SignalQueryOperationQueryVariables>(SignalQueryOperationDocument, options);
        }
export type SignalQueryOperationHookResult = ReturnType<typeof useSignalQueryOperation>;
export type SignalQueryOperationLazyQueryHookResult = ReturnType<typeof useSignalQueryOperationLazyQuery>;
export type SignalQueryOperationSuspenseQueryHookResult = ReturnType<typeof useSignalQueryOperationSuspenseQuery>;
export type SignalQueryOperationQueryResult = Apollo.QueryResult<SignalQueryOperationQuery, SignalQueryOperationQueryVariables>;
export const VisitSignalPageOperationDocument = gql`
    mutation VisitSignalPageOperation($id: ID!) {
  visitSignalPage(id: $id) {
    data {
      ... on VisitedPageInterface {
        timestamp
      }
    }
  }
}
    `;
export type VisitSignalPageOperationMutationFn = Apollo.MutationFunction<VisitSignalPageOperationMutation, VisitSignalPageOperationMutationVariables>;

/**
 * __useVisitSignalPageOperationMutation__
 *
 * To run a mutation, you first call `useVisitSignalPageOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisitSignalPageOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visitSignalPageOperationMutation, { data, loading, error }] = useVisitSignalPageOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVisitSignalPageOperationMutation(baseOptions?: Apollo.MutationHookOptions<VisitSignalPageOperationMutation, VisitSignalPageOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VisitSignalPageOperationMutation, VisitSignalPageOperationMutationVariables>(VisitSignalPageOperationDocument, options);
      }
export type VisitSignalPageOperationMutationHookResult = ReturnType<typeof useVisitSignalPageOperationMutation>;
export type VisitSignalPageOperationMutationResult = Apollo.MutationResult<VisitSignalPageOperationMutation>;
export type VisitSignalPageOperationMutationOptions = Apollo.BaseMutationOptions<VisitSignalPageOperationMutation, VisitSignalPageOperationMutationVariables>;
export const SignalRuleQueryOperationDocument = gql`
    query SignalRuleQueryOperation($id: ID!) {
  rule(id: $id) {
    ... on FirstSeenRule {
      baselineWindowSize
      retentionWindowSize
      valueExpression
      valueFields
    }
    ... on OutlierRule {
      aggregationFunctions {
        function
      }
      baselineWindowSize
      deviationThreshold
      floorValue
      retentionWindowSize
      windowSize
      windowSizeName
    }
  }
}
    `;

/**
 * __useSignalRuleQueryOperation__
 *
 * To run a query within a React component, call `useSignalRuleQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useSignalRuleQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalRuleQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignalRuleQueryOperation(baseOptions: Apollo.QueryHookOptions<SignalRuleQueryOperationQuery, SignalRuleQueryOperationQueryVariables> & ({ variables: SignalRuleQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalRuleQueryOperationQuery, SignalRuleQueryOperationQueryVariables>(SignalRuleQueryOperationDocument, options);
      }
export function useSignalRuleQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalRuleQueryOperationQuery, SignalRuleQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalRuleQueryOperationQuery, SignalRuleQueryOperationQueryVariables>(SignalRuleQueryOperationDocument, options);
        }
export function useSignalRuleQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignalRuleQueryOperationQuery, SignalRuleQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SignalRuleQueryOperationQuery, SignalRuleQueryOperationQueryVariables>(SignalRuleQueryOperationDocument, options);
        }
export type SignalRuleQueryOperationHookResult = ReturnType<typeof useSignalRuleQueryOperation>;
export type SignalRuleQueryOperationLazyQueryHookResult = ReturnType<typeof useSignalRuleQueryOperationLazyQuery>;
export type SignalRuleQueryOperationSuspenseQueryHookResult = ReturnType<typeof useSignalRuleQueryOperationSuspenseQuery>;
export type SignalRuleQueryOperationQueryResult = Apollo.QueryResult<SignalRuleQueryOperationQuery, SignalRuleQueryOperationQueryVariables>;
export const StartSumoRecordSearchJobForSignalDocument = gql`
    mutation StartSumoRecordSearchJobForSignal($signalId: String!) {
  startSumoRecordSearchJobForSignal(signalId: $signalId) {
    jobId
    query
    exploreInLogsQuery
    start
    end
  }
}
    `;
export type StartSumoRecordSearchJobForSignalMutationFn = Apollo.MutationFunction<StartSumoRecordSearchJobForSignalMutation, StartSumoRecordSearchJobForSignalMutationVariables>;

/**
 * __useStartSumoRecordSearchJobForSignalMutation__
 *
 * To run a mutation, you first call `useStartSumoRecordSearchJobForSignalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSumoRecordSearchJobForSignalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSumoRecordSearchJobForSignalMutation, { data, loading, error }] = useStartSumoRecordSearchJobForSignalMutation({
 *   variables: {
 *      signalId: // value for 'signalId'
 *   },
 * });
 */
export function useStartSumoRecordSearchJobForSignalMutation(baseOptions?: Apollo.MutationHookOptions<StartSumoRecordSearchJobForSignalMutation, StartSumoRecordSearchJobForSignalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartSumoRecordSearchJobForSignalMutation, StartSumoRecordSearchJobForSignalMutationVariables>(StartSumoRecordSearchJobForSignalDocument, options);
      }
export type StartSumoRecordSearchJobForSignalMutationHookResult = ReturnType<typeof useStartSumoRecordSearchJobForSignalMutation>;
export type StartSumoRecordSearchJobForSignalMutationResult = Apollo.MutationResult<StartSumoRecordSearchJobForSignalMutation>;
export type StartSumoRecordSearchJobForSignalMutationOptions = Apollo.BaseMutationOptions<StartSumoRecordSearchJobForSignalMutation, StartSumoRecordSearchJobForSignalMutationVariables>;
export const CancelSumoRecordSearchJobForSignalOperationDocument = gql`
    mutation CancelSumoRecordSearchJobForSignalOperation($jobId: String!) {
  cancelSumoRecordSearchJob(jobId: $jobId) {
    ok
  }
}
    `;
export type CancelSumoRecordSearchJobForSignalOperationMutationFn = Apollo.MutationFunction<CancelSumoRecordSearchJobForSignalOperationMutation, CancelSumoRecordSearchJobForSignalOperationMutationVariables>;

/**
 * __useCancelSumoRecordSearchJobForSignalOperationMutation__
 *
 * To run a mutation, you first call `useCancelSumoRecordSearchJobForSignalOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSumoRecordSearchJobForSignalOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSumoRecordSearchJobForSignalOperationMutation, { data, loading, error }] = useCancelSumoRecordSearchJobForSignalOperationMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCancelSumoRecordSearchJobForSignalOperationMutation(baseOptions?: Apollo.MutationHookOptions<CancelSumoRecordSearchJobForSignalOperationMutation, CancelSumoRecordSearchJobForSignalOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSumoRecordSearchJobForSignalOperationMutation, CancelSumoRecordSearchJobForSignalOperationMutationVariables>(CancelSumoRecordSearchJobForSignalOperationDocument, options);
      }
export type CancelSumoRecordSearchJobForSignalOperationMutationHookResult = ReturnType<typeof useCancelSumoRecordSearchJobForSignalOperationMutation>;
export type CancelSumoRecordSearchJobForSignalOperationMutationResult = Apollo.MutationResult<CancelSumoRecordSearchJobForSignalOperationMutation>;
export type CancelSumoRecordSearchJobForSignalOperationMutationOptions = Apollo.BaseMutationOptions<CancelSumoRecordSearchJobForSignalOperationMutation, CancelSumoRecordSearchJobForSignalOperationMutationVariables>;
export const RecordSearchResultsForSignalOperationDocument = gql`
    query RecordSearchResultsForSignalOperation($jobId: ID!, $offset: Int!, $limit: Int!) {
  sumoRecordSearchJobStatus(jobId: $jobId) {
    state
    total
    histogramBuckets {
      startTimestamp
      length
      count
    }
  }
  sumoRecordSearchJobResults(jobId: $jobId, offset: $offset, limit: $limit)
}
    `;

/**
 * __useRecordSearchResultsForSignalOperationQuery__
 *
 * To run a query within a React component, call `useRecordSearchResultsForSignalOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecordSearchResultsForSignalOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecordSearchResultsForSignalOperationQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRecordSearchResultsForSignalOperationQuery(baseOptions: Apollo.QueryHookOptions<RecordSearchResultsForSignalOperationQuery, RecordSearchResultsForSignalOperationQueryVariables> & ({ variables: RecordSearchResultsForSignalOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecordSearchResultsForSignalOperationQuery, RecordSearchResultsForSignalOperationQueryVariables>(RecordSearchResultsForSignalOperationDocument, options);
      }
export function useRecordSearchResultsForSignalOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecordSearchResultsForSignalOperationQuery, RecordSearchResultsForSignalOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecordSearchResultsForSignalOperationQuery, RecordSearchResultsForSignalOperationQueryVariables>(RecordSearchResultsForSignalOperationDocument, options);
        }
export function useRecordSearchResultsForSignalOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecordSearchResultsForSignalOperationQuery, RecordSearchResultsForSignalOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecordSearchResultsForSignalOperationQuery, RecordSearchResultsForSignalOperationQueryVariables>(RecordSearchResultsForSignalOperationDocument, options);
        }
export type RecordSearchResultsForSignalOperationQueryHookResult = ReturnType<typeof useRecordSearchResultsForSignalOperationQuery>;
export type RecordSearchResultsForSignalOperationLazyQueryHookResult = ReturnType<typeof useRecordSearchResultsForSignalOperationLazyQuery>;
export type RecordSearchResultsForSignalOperationSuspenseQueryHookResult = ReturnType<typeof useRecordSearchResultsForSignalOperationSuspenseQuery>;
export type RecordSearchResultsForSignalOperationQueryResult = Apollo.QueryResult<RecordSearchResultsForSignalOperationQuery, RecordSearchResultsForSignalOperationQueryVariables>;
export const SuppressedSignalQueryOperationDocument = gql`
    query SuppressedSignalQueryOperation($id: ID!, $limit: Int, $offset: Int) {
  signal(id: $id) {
    id
    suppressesSignals(limit: $limit, offset: $offset) {
      total
      objects {
        ...SignalFragment
      }
      __typename
    }
    __typename
  }
}
    ${SignalFragmentDoc}`;

/**
 * __useSuppressedSignalQueryOperation__
 *
 * To run a query within a React component, call `useSuppressedSignalQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useSuppressedSignalQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuppressedSignalQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSuppressedSignalQueryOperation(baseOptions: Apollo.QueryHookOptions<SuppressedSignalQueryOperationQuery, SuppressedSignalQueryOperationQueryVariables> & ({ variables: SuppressedSignalQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuppressedSignalQueryOperationQuery, SuppressedSignalQueryOperationQueryVariables>(SuppressedSignalQueryOperationDocument, options);
      }
export function useSuppressedSignalQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuppressedSignalQueryOperationQuery, SuppressedSignalQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuppressedSignalQueryOperationQuery, SuppressedSignalQueryOperationQueryVariables>(SuppressedSignalQueryOperationDocument, options);
        }
export function useSuppressedSignalQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuppressedSignalQueryOperationQuery, SuppressedSignalQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuppressedSignalQueryOperationQuery, SuppressedSignalQueryOperationQueryVariables>(SuppressedSignalQueryOperationDocument, options);
        }
export type SuppressedSignalQueryOperationHookResult = ReturnType<typeof useSuppressedSignalQueryOperation>;
export type SuppressedSignalQueryOperationLazyQueryHookResult = ReturnType<typeof useSuppressedSignalQueryOperationLazyQuery>;
export type SuppressedSignalQueryOperationSuspenseQueryHookResult = ReturnType<typeof useSuppressedSignalQueryOperationSuspenseQuery>;
export type SuppressedSignalQueryOperationQueryResult = Apollo.QueryResult<SuppressedSignalQueryOperationQuery, SuppressedSignalQueryOperationQueryVariables>;
export const SignalNameQueryOperationDocument = gql`
    query SignalNameQueryOperation($id: ID!) {
  signal(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useSignalNameQueryOperation__
 *
 * To run a query within a React component, call `useSignalNameQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useSignalNameQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalNameQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSignalNameQueryOperation(baseOptions: Apollo.QueryHookOptions<SignalNameQueryOperationQuery, SignalNameQueryOperationQueryVariables> & ({ variables: SignalNameQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalNameQueryOperationQuery, SignalNameQueryOperationQueryVariables>(SignalNameQueryOperationDocument, options);
      }
export function useSignalNameQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalNameQueryOperationQuery, SignalNameQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalNameQueryOperationQuery, SignalNameQueryOperationQueryVariables>(SignalNameQueryOperationDocument, options);
        }
export function useSignalNameQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignalNameQueryOperationQuery, SignalNameQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SignalNameQueryOperationQuery, SignalNameQueryOperationQueryVariables>(SignalNameQueryOperationDocument, options);
        }
export type SignalNameQueryOperationHookResult = ReturnType<typeof useSignalNameQueryOperation>;
export type SignalNameQueryOperationLazyQueryHookResult = ReturnType<typeof useSignalNameQueryOperationLazyQuery>;
export type SignalNameQueryOperationSuspenseQueryHookResult = ReturnType<typeof useSignalNameQueryOperationSuspenseQuery>;
export type SignalNameQueryOperationQueryResult = Apollo.QueryResult<SignalNameQueryOperationQuery, SignalNameQueryOperationQueryVariables>;
export const SignalsQueryOperationDocument = gql`
    query SignalsQueryOperation($q: String, $offset: Int, $limit: Int, $sort: SignalSortableField!, $sortDir: SortDir!) {
  signals(
    q: $q
    offset: $offset
    limit: $limit
    sort: [{field: $sort, direction: $sortDir}]
  ) {
    hasNextPage
    total
    objects {
      ...SignalFragment
    }
  }
  categories {
    name
  }
  insightConfig {
    threshold
  }
}
    ${SignalFragmentDoc}`;

/**
 * __useSignalsQueryOperation__
 *
 * To run a query within a React component, call `useSignalsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useSignalsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalsQueryOperation({
 *   variables: {
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useSignalsQueryOperation(baseOptions: Apollo.QueryHookOptions<SignalsQueryOperationQuery, SignalsQueryOperationQueryVariables> & ({ variables: SignalsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalsQueryOperationQuery, SignalsQueryOperationQueryVariables>(SignalsQueryOperationDocument, options);
      }
export function useSignalsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalsQueryOperationQuery, SignalsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalsQueryOperationQuery, SignalsQueryOperationQueryVariables>(SignalsQueryOperationDocument, options);
        }
export function useSignalsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignalsQueryOperationQuery, SignalsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SignalsQueryOperationQuery, SignalsQueryOperationQueryVariables>(SignalsQueryOperationDocument, options);
        }
export type SignalsQueryOperationHookResult = ReturnType<typeof useSignalsQueryOperation>;
export type SignalsQueryOperationLazyQueryHookResult = ReturnType<typeof useSignalsQueryOperationLazyQuery>;
export type SignalsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useSignalsQueryOperationSuspenseQuery>;
export type SignalsQueryOperationQueryResult = Apollo.QueryResult<SignalsQueryOperationQuery, SignalsQueryOperationQueryVariables>;
export const EntityDetailsQueryOperationDocument = gql`
    query EntityDetailsQueryOperation($id: ID!) {
  insightConfig {
    threshold
  }
  entity(id: $id) {
    ...EntityDetailsFragment
  }
}
    ${EntityDetailsFragmentDoc}`;

/**
 * __useEntityDetailsQueryOperation__
 *
 * To run a query within a React component, call `useEntityDetailsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityDetailsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityDetailsQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityDetailsQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityDetailsQueryOperationQuery, EntityDetailsQueryOperationQueryVariables> & ({ variables: EntityDetailsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityDetailsQueryOperationQuery, EntityDetailsQueryOperationQueryVariables>(EntityDetailsQueryOperationDocument, options);
      }
export function useEntityDetailsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityDetailsQueryOperationQuery, EntityDetailsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityDetailsQueryOperationQuery, EntityDetailsQueryOperationQueryVariables>(EntityDetailsQueryOperationDocument, options);
        }
export function useEntityDetailsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityDetailsQueryOperationQuery, EntityDetailsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityDetailsQueryOperationQuery, EntityDetailsQueryOperationQueryVariables>(EntityDetailsQueryOperationDocument, options);
        }
export type EntityDetailsQueryOperationHookResult = ReturnType<typeof useEntityDetailsQueryOperation>;
export type EntityDetailsQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityDetailsQueryOperationLazyQuery>;
export type EntityDetailsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityDetailsQueryOperationSuspenseQuery>;
export type EntityDetailsQueryOperationQueryResult = Apollo.QueryResult<EntityDetailsQueryOperationQuery, EntityDetailsQueryOperationQueryVariables>;
export const EntitySummaryQueryOperationDocument = gql`
    query EntitySummaryQueryOperation($id: ID!, $detectionWindowStartTime: DateTime!, $detectionWindowEndTime: DateTime!) {
  entity(id: $id) {
    ...EntitySummaryFragment
  }
}
    ${EntitySummaryFragmentDoc}`;

/**
 * __useEntitySummaryQueryOperation__
 *
 * To run a query within a React component, call `useEntitySummaryQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntitySummaryQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitySummaryQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *      detectionWindowStartTime: // value for 'detectionWindowStartTime'
 *      detectionWindowEndTime: // value for 'detectionWindowEndTime'
 *   },
 * });
 */
export function useEntitySummaryQueryOperation(baseOptions: Apollo.QueryHookOptions<EntitySummaryQueryOperationQuery, EntitySummaryQueryOperationQueryVariables> & ({ variables: EntitySummaryQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitySummaryQueryOperationQuery, EntitySummaryQueryOperationQueryVariables>(EntitySummaryQueryOperationDocument, options);
      }
export function useEntitySummaryQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitySummaryQueryOperationQuery, EntitySummaryQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitySummaryQueryOperationQuery, EntitySummaryQueryOperationQueryVariables>(EntitySummaryQueryOperationDocument, options);
        }
export function useEntitySummaryQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntitySummaryQueryOperationQuery, EntitySummaryQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntitySummaryQueryOperationQuery, EntitySummaryQueryOperationQueryVariables>(EntitySummaryQueryOperationDocument, options);
        }
export type EntitySummaryQueryOperationHookResult = ReturnType<typeof useEntitySummaryQueryOperation>;
export type EntitySummaryQueryOperationLazyQueryHookResult = ReturnType<typeof useEntitySummaryQueryOperationLazyQuery>;
export type EntitySummaryQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntitySummaryQueryOperationSuspenseQuery>;
export type EntitySummaryQueryOperationQueryResult = Apollo.QueryResult<EntitySummaryQueryOperationQuery, EntitySummaryQueryOperationQueryVariables>;
export const EntityExecutedAutomationsCountQueryOperationDocument = gql`
    query EntityExecutedAutomationsCountQueryOperation($id: ID!) {
  entity(id: $id) {
    ... on EntityInterface {
      id
      executedAutomations {
        ...EntityExecutedAutomationsFragment
      }
    }
  }
}
    ${EntityExecutedAutomationsFragmentDoc}`;

/**
 * __useEntityExecutedAutomationsCountQueryOperation__
 *
 * To run a query within a React component, call `useEntityExecutedAutomationsCountQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityExecutedAutomationsCountQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityExecutedAutomationsCountQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityExecutedAutomationsCountQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityExecutedAutomationsCountQueryOperationQuery, EntityExecutedAutomationsCountQueryOperationQueryVariables> & ({ variables: EntityExecutedAutomationsCountQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityExecutedAutomationsCountQueryOperationQuery, EntityExecutedAutomationsCountQueryOperationQueryVariables>(EntityExecutedAutomationsCountQueryOperationDocument, options);
      }
export function useEntityExecutedAutomationsCountQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityExecutedAutomationsCountQueryOperationQuery, EntityExecutedAutomationsCountQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityExecutedAutomationsCountQueryOperationQuery, EntityExecutedAutomationsCountQueryOperationQueryVariables>(EntityExecutedAutomationsCountQueryOperationDocument, options);
        }
export function useEntityExecutedAutomationsCountQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityExecutedAutomationsCountQueryOperationQuery, EntityExecutedAutomationsCountQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityExecutedAutomationsCountQueryOperationQuery, EntityExecutedAutomationsCountQueryOperationQueryVariables>(EntityExecutedAutomationsCountQueryOperationDocument, options);
        }
export type EntityExecutedAutomationsCountQueryOperationHookResult = ReturnType<typeof useEntityExecutedAutomationsCountQueryOperation>;
export type EntityExecutedAutomationsCountQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityExecutedAutomationsCountQueryOperationLazyQuery>;
export type EntityExecutedAutomationsCountQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityExecutedAutomationsCountQueryOperationSuspenseQuery>;
export type EntityExecutedAutomationsCountQueryOperationQueryResult = Apollo.QueryResult<EntityExecutedAutomationsCountQueryOperationQuery, EntityExecutedAutomationsCountQueryOperationQueryVariables>;
export const InsightConfigQueryOperationDocument = gql`
    query InsightConfigQueryOperation {
  insightConfig {
    lookbackDays
    threshold
    globalSignalSuppressionWindow
    __typename
  }
}
    `;

/**
 * __useInsightConfigQueryOperation__
 *
 * To run a query within a React component, call `useInsightConfigQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightConfigQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightConfigQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useInsightConfigQueryOperation(baseOptions?: Apollo.QueryHookOptions<InsightConfigQueryOperationQuery, InsightConfigQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightConfigQueryOperationQuery, InsightConfigQueryOperationQueryVariables>(InsightConfigQueryOperationDocument, options);
      }
export function useInsightConfigQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightConfigQueryOperationQuery, InsightConfigQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightConfigQueryOperationQuery, InsightConfigQueryOperationQueryVariables>(InsightConfigQueryOperationDocument, options);
        }
export function useInsightConfigQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightConfigQueryOperationQuery, InsightConfigQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightConfigQueryOperationQuery, InsightConfigQueryOperationQueryVariables>(InsightConfigQueryOperationDocument, options);
        }
export type InsightConfigQueryOperationHookResult = ReturnType<typeof useInsightConfigQueryOperation>;
export type InsightConfigQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightConfigQueryOperationLazyQuery>;
export type InsightConfigQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightConfigQueryOperationSuspenseQuery>;
export type InsightConfigQueryOperationQueryResult = Apollo.QueryResult<InsightConfigQueryOperationQuery, InsightConfigQueryOperationQueryVariables>;
export const AddSignalsToInsightOperationDocument = gql`
    mutation AddSignalsToInsightOperation($insightId: ID!, $signalIds: [ID!]!) {
  addSignalsToInsight(insightId: $insightId, signalIds: $signalIds) {
    data {
      id
    }
  }
}
    `;
export type AddSignalsToInsightOperationMutationFn = Apollo.MutationFunction<AddSignalsToInsightOperationMutation, AddSignalsToInsightOperationMutationVariables>;

/**
 * __useAddSignalsToInsightOperationMutation__
 *
 * To run a mutation, you first call `useAddSignalsToInsightOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddSignalsToInsightOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addSignalsToInsightOperationMutation, { data, loading, error }] = useAddSignalsToInsightOperationMutation({
 *   variables: {
 *      insightId: // value for 'insightId'
 *      signalIds: // value for 'signalIds'
 *   },
 * });
 */
export function useAddSignalsToInsightOperationMutation(baseOptions?: Apollo.MutationHookOptions<AddSignalsToInsightOperationMutation, AddSignalsToInsightOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddSignalsToInsightOperationMutation, AddSignalsToInsightOperationMutationVariables>(AddSignalsToInsightOperationDocument, options);
      }
export type AddSignalsToInsightOperationMutationHookResult = ReturnType<typeof useAddSignalsToInsightOperationMutation>;
export type AddSignalsToInsightOperationMutationResult = Apollo.MutationResult<AddSignalsToInsightOperationMutation>;
export type AddSignalsToInsightOperationMutationOptions = Apollo.BaseMutationOptions<AddSignalsToInsightOperationMutation, AddSignalsToInsightOperationMutationVariables>;
export const RemoveSignalsFromInsightOperationDocument = gql`
    mutation RemoveSignalsFromInsightOperation($signalIds: [ID!]!, $insightId: ID!, $enableAIInsightSummary: Boolean = false, $enableAgenticSecOps: Boolean = false) {
  removeSignalsFromInsight(signalIds: $signalIds, insightId: $insightId) {
    data {
      ...InsightFields
    }
  }
}
    ${InsightFieldsFragmentDoc}`;
export type RemoveSignalsFromInsightOperationMutationFn = Apollo.MutationFunction<RemoveSignalsFromInsightOperationMutation, RemoveSignalsFromInsightOperationMutationVariables>;

/**
 * __useRemoveSignalsFromInsightOperationMutation__
 *
 * To run a mutation, you first call `useRemoveSignalsFromInsightOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSignalsFromInsightOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSignalsFromInsightOperationMutation, { data, loading, error }] = useRemoveSignalsFromInsightOperationMutation({
 *   variables: {
 *      signalIds: // value for 'signalIds'
 *      insightId: // value for 'insightId'
 *      enableAIInsightSummary: // value for 'enableAIInsightSummary'
 *      enableAgenticSecOps: // value for 'enableAgenticSecOps'
 *   },
 * });
 */
export function useRemoveSignalsFromInsightOperationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSignalsFromInsightOperationMutation, RemoveSignalsFromInsightOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSignalsFromInsightOperationMutation, RemoveSignalsFromInsightOperationMutationVariables>(RemoveSignalsFromInsightOperationDocument, options);
      }
export type RemoveSignalsFromInsightOperationMutationHookResult = ReturnType<typeof useRemoveSignalsFromInsightOperationMutation>;
export type RemoveSignalsFromInsightOperationMutationResult = Apollo.MutationResult<RemoveSignalsFromInsightOperationMutation>;
export type RemoveSignalsFromInsightOperationMutationOptions = Apollo.BaseMutationOptions<RemoveSignalsFromInsightOperationMutation, RemoveSignalsFromInsightOperationMutationVariables>;
export const CreateInsightFromSignalOperationDocument = gql`
    mutation CreateInsightFromSignalOperation($signalId: ID!, $enableAIInsightSummary: Boolean = false, $enableAgenticSecOps: Boolean = false) {
  createInsightFromSignal(signalId: $signalId) {
    data {
      ...InsightFields
    }
  }
}
    ${InsightFieldsFragmentDoc}`;
export type CreateInsightFromSignalOperationMutationFn = Apollo.MutationFunction<CreateInsightFromSignalOperationMutation, CreateInsightFromSignalOperationMutationVariables>;

/**
 * __useCreateInsightFromSignalOperationMutation__
 *
 * To run a mutation, you first call `useCreateInsightFromSignalOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInsightFromSignalOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInsightFromSignalOperationMutation, { data, loading, error }] = useCreateInsightFromSignalOperationMutation({
 *   variables: {
 *      signalId: // value for 'signalId'
 *      enableAIInsightSummary: // value for 'enableAIInsightSummary'
 *      enableAgenticSecOps: // value for 'enableAgenticSecOps'
 *   },
 * });
 */
export function useCreateInsightFromSignalOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateInsightFromSignalOperationMutation, CreateInsightFromSignalOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInsightFromSignalOperationMutation, CreateInsightFromSignalOperationMutationVariables>(CreateInsightFromSignalOperationDocument, options);
      }
export type CreateInsightFromSignalOperationMutationHookResult = ReturnType<typeof useCreateInsightFromSignalOperationMutation>;
export type CreateInsightFromSignalOperationMutationResult = Apollo.MutationResult<CreateInsightFromSignalOperationMutation>;
export type CreateInsightFromSignalOperationMutationOptions = Apollo.BaseMutationOptions<CreateInsightFromSignalOperationMutation, CreateInsightFromSignalOperationMutationVariables>;
export const AssigneeQueryDocument = gql`
    query AssigneeQuery {
  teams {
    objects {
      id
      name
    }
  }
  users(active: true, limit: 1000) {
    objects {
      id
      name
      email
      username
      displayName
    }
  }
}
    `;

/**
 * __useAssigneeQuery__
 *
 * To run a query within a React component, call `useAssigneeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssigneeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssigneeQuery({
 *   variables: {
 *   },
 * });
 */
export function useAssigneeQuery(baseOptions?: Apollo.QueryHookOptions<AssigneeQuery, AssigneeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssigneeQuery, AssigneeQueryVariables>(AssigneeQueryDocument, options);
      }
export function useAssigneeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssigneeQuery, AssigneeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssigneeQuery, AssigneeQueryVariables>(AssigneeQueryDocument, options);
        }
export function useAssigneeQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssigneeQuery, AssigneeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssigneeQuery, AssigneeQueryVariables>(AssigneeQueryDocument, options);
        }
export type AssigneeQueryHookResult = ReturnType<typeof useAssigneeQuery>;
export type AssigneeQueryLazyQueryHookResult = ReturnType<typeof useAssigneeQueryLazyQuery>;
export type AssigneeQuerySuspenseQueryHookResult = ReturnType<typeof useAssigneeQuerySuspenseQuery>;
export type AssigneeQueryQueryResult = Apollo.QueryResult<AssigneeQuery, AssigneeQueryVariables>;
export const EnabledContextActionsQueryOperationDocument = gql`
    query EnabledContextActionsQueryOperation {
  contextActions(enabled: true) {
    hasNextPage
    total
    objects {
      ...EnabledContextActionFragment
    }
  }
  sumoLogicBaseUrl
  sumoLogicRegion
}
    ${EnabledContextActionFragmentDoc}`;

/**
 * __useEnabledContextActionsQueryOperation__
 *
 * To run a query within a React component, call `useEnabledContextActionsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEnabledContextActionsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnabledContextActionsQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useEnabledContextActionsQueryOperation(baseOptions?: Apollo.QueryHookOptions<EnabledContextActionsQueryOperationQuery, EnabledContextActionsQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnabledContextActionsQueryOperationQuery, EnabledContextActionsQueryOperationQueryVariables>(EnabledContextActionsQueryOperationDocument, options);
      }
export function useEnabledContextActionsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnabledContextActionsQueryOperationQuery, EnabledContextActionsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnabledContextActionsQueryOperationQuery, EnabledContextActionsQueryOperationQueryVariables>(EnabledContextActionsQueryOperationDocument, options);
        }
export function useEnabledContextActionsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EnabledContextActionsQueryOperationQuery, EnabledContextActionsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnabledContextActionsQueryOperationQuery, EnabledContextActionsQueryOperationQueryVariables>(EnabledContextActionsQueryOperationDocument, options);
        }
export type EnabledContextActionsQueryOperationHookResult = ReturnType<typeof useEnabledContextActionsQueryOperation>;
export type EnabledContextActionsQueryOperationLazyQueryHookResult = ReturnType<typeof useEnabledContextActionsQueryOperationLazyQuery>;
export type EnabledContextActionsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEnabledContextActionsQueryOperationSuspenseQuery>;
export type EnabledContextActionsQueryOperationQueryResult = Apollo.QueryResult<EnabledContextActionsQueryOperationQuery, EnabledContextActionsQueryOperationQueryVariables>;
export const EntityAsideLookbackOperationDocument = gql`
    query EntityAsideLookbackOperation {
  insightConfig {
    __typename
    lookbackDays
    threshold
  }
}
    `;

/**
 * __useEntityAsideLookbackOperationQuery__
 *
 * To run a query within a React component, call `useEntityAsideLookbackOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityAsideLookbackOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityAsideLookbackOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntityAsideLookbackOperationQuery(baseOptions?: Apollo.QueryHookOptions<EntityAsideLookbackOperationQuery, EntityAsideLookbackOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityAsideLookbackOperationQuery, EntityAsideLookbackOperationQueryVariables>(EntityAsideLookbackOperationDocument, options);
      }
export function useEntityAsideLookbackOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityAsideLookbackOperationQuery, EntityAsideLookbackOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityAsideLookbackOperationQuery, EntityAsideLookbackOperationQueryVariables>(EntityAsideLookbackOperationDocument, options);
        }
export function useEntityAsideLookbackOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityAsideLookbackOperationQuery, EntityAsideLookbackOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityAsideLookbackOperationQuery, EntityAsideLookbackOperationQueryVariables>(EntityAsideLookbackOperationDocument, options);
        }
export type EntityAsideLookbackOperationQueryHookResult = ReturnType<typeof useEntityAsideLookbackOperationQuery>;
export type EntityAsideLookbackOperationLazyQueryHookResult = ReturnType<typeof useEntityAsideLookbackOperationLazyQuery>;
export type EntityAsideLookbackOperationSuspenseQueryHookResult = ReturnType<typeof useEntityAsideLookbackOperationSuspenseQuery>;
export type EntityAsideLookbackOperationQueryResult = Apollo.QueryResult<EntityAsideLookbackOperationQuery, EntityAsideLookbackOperationQueryVariables>;
export const EntityAsideQueryOperationDocument = gql`
    query EntityAsideQueryOperation($detectionWindowStartTime: DateTime!, $detectionWindowEndTime: DateTime!, $id: ID!, $limit: Int!, $offset: Int!) {
  entity(id: $id) {
    ... on EntityInterface {
      ...EntityAsideEntity
    }
  }
}
    ${EntityAsideEntityFragmentDoc}`;

/**
 * __useEntityAsideQueryOperation__
 *
 * To run a query within a React component, call `useEntityAsideQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityAsideQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityAsideQueryOperation({
 *   variables: {
 *      detectionWindowStartTime: // value for 'detectionWindowStartTime'
 *      detectionWindowEndTime: // value for 'detectionWindowEndTime'
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useEntityAsideQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityAsideQueryOperationQuery, EntityAsideQueryOperationQueryVariables> & ({ variables: EntityAsideQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityAsideQueryOperationQuery, EntityAsideQueryOperationQueryVariables>(EntityAsideQueryOperationDocument, options);
      }
export function useEntityAsideQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityAsideQueryOperationQuery, EntityAsideQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityAsideQueryOperationQuery, EntityAsideQueryOperationQueryVariables>(EntityAsideQueryOperationDocument, options);
        }
export function useEntityAsideQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityAsideQueryOperationQuery, EntityAsideQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityAsideQueryOperationQuery, EntityAsideQueryOperationQueryVariables>(EntityAsideQueryOperationDocument, options);
        }
export type EntityAsideQueryOperationHookResult = ReturnType<typeof useEntityAsideQueryOperation>;
export type EntityAsideQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityAsideQueryOperationLazyQuery>;
export type EntityAsideQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityAsideQueryOperationSuspenseQuery>;
export type EntityAsideQueryOperationQueryResult = Apollo.QueryResult<EntityAsideQueryOperationQuery, EntityAsideQueryOperationQueryVariables>;
export const EntityNetworkBlocksQueryOperationDocument = gql`
    query EntityNetworkBlocksQueryOperation($address: String!) {
  networkBlocksByIp(address: $address) {
    id
    addressBlock
    label
  }
}
    `;

/**
 * __useEntityNetworkBlocksQueryOperation__
 *
 * To run a query within a React component, call `useEntityNetworkBlocksQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityNetworkBlocksQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityNetworkBlocksQueryOperation({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useEntityNetworkBlocksQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityNetworkBlocksQueryOperationQuery, EntityNetworkBlocksQueryOperationQueryVariables> & ({ variables: EntityNetworkBlocksQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityNetworkBlocksQueryOperationQuery, EntityNetworkBlocksQueryOperationQueryVariables>(EntityNetworkBlocksQueryOperationDocument, options);
      }
export function useEntityNetworkBlocksQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityNetworkBlocksQueryOperationQuery, EntityNetworkBlocksQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityNetworkBlocksQueryOperationQuery, EntityNetworkBlocksQueryOperationQueryVariables>(EntityNetworkBlocksQueryOperationDocument, options);
        }
export function useEntityNetworkBlocksQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityNetworkBlocksQueryOperationQuery, EntityNetworkBlocksQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityNetworkBlocksQueryOperationQuery, EntityNetworkBlocksQueryOperationQueryVariables>(EntityNetworkBlocksQueryOperationDocument, options);
        }
export type EntityNetworkBlocksQueryOperationHookResult = ReturnType<typeof useEntityNetworkBlocksQueryOperation>;
export type EntityNetworkBlocksQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityNetworkBlocksQueryOperationLazyQuery>;
export type EntityNetworkBlocksQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityNetworkBlocksQueryOperationSuspenseQuery>;
export type EntityNetworkBlocksQueryOperationQueryResult = Apollo.QueryResult<EntityNetworkBlocksQueryOperationQuery, EntityNetworkBlocksQueryOperationQueryVariables>;
export const EntityAsideUpdateSuppressionDocument = gql`
    mutation EntityAsideUpdateSuppression($entityId: ID!, $whitelistFlag: Boolean!) {
  updateEntityWhitelist(entityId: $entityId, whitelistFlag: $whitelistFlag) {
    data {
      id
      isWhitelisted
      __typename
    }
  }
}
    `;
export type EntityAsideUpdateSuppressionMutationFn = Apollo.MutationFunction<EntityAsideUpdateSuppressionMutation, EntityAsideUpdateSuppressionMutationVariables>;

/**
 * __useEntityAsideUpdateSuppressionMutation__
 *
 * To run a mutation, you first call `useEntityAsideUpdateSuppressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEntityAsideUpdateSuppressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [entityAsideUpdateSuppressionMutation, { data, loading, error }] = useEntityAsideUpdateSuppressionMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      whitelistFlag: // value for 'whitelistFlag'
 *   },
 * });
 */
export function useEntityAsideUpdateSuppressionMutation(baseOptions?: Apollo.MutationHookOptions<EntityAsideUpdateSuppressionMutation, EntityAsideUpdateSuppressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EntityAsideUpdateSuppressionMutation, EntityAsideUpdateSuppressionMutationVariables>(EntityAsideUpdateSuppressionDocument, options);
      }
export type EntityAsideUpdateSuppressionMutationHookResult = ReturnType<typeof useEntityAsideUpdateSuppressionMutation>;
export type EntityAsideUpdateSuppressionMutationResult = Apollo.MutationResult<EntityAsideUpdateSuppressionMutation>;
export type EntityAsideUpdateSuppressionMutationOptions = Apollo.BaseMutationOptions<EntityAsideUpdateSuppressionMutation, EntityAsideUpdateSuppressionMutationVariables>;
export const EntityInputTagsQueryOperationDocument = gql`
    query EntityInputTagsQueryOperation($id: ID!) {
  entity(id: $id) {
    ... on EntityInterface {
      id
      tags
    }
  }
  entityTagOptions {
    value
  }
  tagSchemas {
    key
    label
    contentTypeEnums
    freeform
    valueOptionObjects {
      value
      label
      link
    }
  }
}
    `;

/**
 * __useEntityInputTagsQueryOperation__
 *
 * To run a query within a React component, call `useEntityInputTagsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityInputTagsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityInputTagsQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityInputTagsQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityInputTagsQueryOperationQuery, EntityInputTagsQueryOperationQueryVariables> & ({ variables: EntityInputTagsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityInputTagsQueryOperationQuery, EntityInputTagsQueryOperationQueryVariables>(EntityInputTagsQueryOperationDocument, options);
      }
export function useEntityInputTagsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityInputTagsQueryOperationQuery, EntityInputTagsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityInputTagsQueryOperationQuery, EntityInputTagsQueryOperationQueryVariables>(EntityInputTagsQueryOperationDocument, options);
        }
export function useEntityInputTagsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityInputTagsQueryOperationQuery, EntityInputTagsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityInputTagsQueryOperationQuery, EntityInputTagsQueryOperationQueryVariables>(EntityInputTagsQueryOperationDocument, options);
        }
export type EntityInputTagsQueryOperationHookResult = ReturnType<typeof useEntityInputTagsQueryOperation>;
export type EntityInputTagsQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityInputTagsQueryOperationLazyQuery>;
export type EntityInputTagsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityInputTagsQueryOperationSuspenseQuery>;
export type EntityInputTagsQueryOperationQueryResult = Apollo.QueryResult<EntityInputTagsQueryOperationQuery, EntityInputTagsQueryOperationQueryVariables>;
export const EntityInputTagsUpdateOperationDocument = gql`
    mutation EntityInputTagsUpdateOperation($id: ID!, $tags: [String!]!) {
  updateEntityTags(entityId: $id, tags: $tags) {
    data {
      ... on EntityInterface {
        id
        tags
      }
    }
  }
}
    `;
export type EntityInputTagsUpdateOperationMutationFn = Apollo.MutationFunction<EntityInputTagsUpdateOperationMutation, EntityInputTagsUpdateOperationMutationVariables>;

/**
 * __useEntityInputTagsUpdateOperationMutation__
 *
 * To run a mutation, you first call `useEntityInputTagsUpdateOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEntityInputTagsUpdateOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [entityInputTagsUpdateOperationMutation, { data, loading, error }] = useEntityInputTagsUpdateOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEntityInputTagsUpdateOperationMutation(baseOptions?: Apollo.MutationHookOptions<EntityInputTagsUpdateOperationMutation, EntityInputTagsUpdateOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EntityInputTagsUpdateOperationMutation, EntityInputTagsUpdateOperationMutationVariables>(EntityInputTagsUpdateOperationDocument, options);
      }
export type EntityInputTagsUpdateOperationMutationHookResult = ReturnType<typeof useEntityInputTagsUpdateOperationMutation>;
export type EntityInputTagsUpdateOperationMutationResult = Apollo.MutationResult<EntityInputTagsUpdateOperationMutation>;
export type EntityInputTagsUpdateOperationMutationOptions = Apollo.BaseMutationOptions<EntityInputTagsUpdateOperationMutation, EntityInputTagsUpdateOperationMutationVariables>;
export const EntityInputTagsDeleteOperationDocument = gql`
    mutation EntityInputTagsDeleteOperation($id: ID!, $tags: [String!]!) {
  removeEntityTags(entityId: $id, tags: $tags) {
    data {
      id
      tags
    }
  }
}
    `;
export type EntityInputTagsDeleteOperationMutationFn = Apollo.MutationFunction<EntityInputTagsDeleteOperationMutation, EntityInputTagsDeleteOperationMutationVariables>;

/**
 * __useEntityInputTagsDeleteOperationMutation__
 *
 * To run a mutation, you first call `useEntityInputTagsDeleteOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEntityInputTagsDeleteOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [entityInputTagsDeleteOperationMutation, { data, loading, error }] = useEntityInputTagsDeleteOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useEntityInputTagsDeleteOperationMutation(baseOptions?: Apollo.MutationHookOptions<EntityInputTagsDeleteOperationMutation, EntityInputTagsDeleteOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EntityInputTagsDeleteOperationMutation, EntityInputTagsDeleteOperationMutationVariables>(EntityInputTagsDeleteOperationDocument, options);
      }
export type EntityInputTagsDeleteOperationMutationHookResult = ReturnType<typeof useEntityInputTagsDeleteOperationMutation>;
export type EntityInputTagsDeleteOperationMutationResult = Apollo.MutationResult<EntityInputTagsDeleteOperationMutation>;
export type EntityInputTagsDeleteOperationMutationOptions = Apollo.BaseMutationOptions<EntityInputTagsDeleteOperationMutation, EntityInputTagsDeleteOperationMutationVariables>;
export const EntityInputCriticalityQueryOperationDocument = gql`
    query EntityInputCriticalityQueryOperation($id: ID!) {
  entityCriticalityConfigs {
    objects {
      id
      name
      severityExpression
    }
  }
  entity(id: $id) {
    ... on EntityInterface {
      criticality
      id
    }
  }
}
    `;

/**
 * __useEntityInputCriticalityQueryOperation__
 *
 * To run a query within a React component, call `useEntityInputCriticalityQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityInputCriticalityQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityInputCriticalityQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityInputCriticalityQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityInputCriticalityQueryOperationQuery, EntityInputCriticalityQueryOperationQueryVariables> & ({ variables: EntityInputCriticalityQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityInputCriticalityQueryOperationQuery, EntityInputCriticalityQueryOperationQueryVariables>(EntityInputCriticalityQueryOperationDocument, options);
      }
export function useEntityInputCriticalityQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityInputCriticalityQueryOperationQuery, EntityInputCriticalityQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityInputCriticalityQueryOperationQuery, EntityInputCriticalityQueryOperationQueryVariables>(EntityInputCriticalityQueryOperationDocument, options);
        }
export function useEntityInputCriticalityQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityInputCriticalityQueryOperationQuery, EntityInputCriticalityQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityInputCriticalityQueryOperationQuery, EntityInputCriticalityQueryOperationQueryVariables>(EntityInputCriticalityQueryOperationDocument, options);
        }
export type EntityInputCriticalityQueryOperationHookResult = ReturnType<typeof useEntityInputCriticalityQueryOperation>;
export type EntityInputCriticalityQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityInputCriticalityQueryOperationLazyQuery>;
export type EntityInputCriticalityQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityInputCriticalityQueryOperationSuspenseQuery>;
export type EntityInputCriticalityQueryOperationQueryResult = Apollo.QueryResult<EntityInputCriticalityQueryOperationQuery, EntityInputCriticalityQueryOperationQueryVariables>;
export const UpdateEntityInputCriticalityDocument = gql`
    mutation UpdateEntityInputCriticality($entityId: ID!, $criticality: String) {
  updateEntityCriticality(criticality: $criticality, entityId: $entityId) {
    data {
      ... on EntityInterface {
        id
        criticality
      }
    }
  }
}
    `;
export type UpdateEntityInputCriticalityMutationFn = Apollo.MutationFunction<UpdateEntityInputCriticalityMutation, UpdateEntityInputCriticalityMutationVariables>;

/**
 * __useUpdateEntityInputCriticalityMutation__
 *
 * To run a mutation, you first call `useUpdateEntityInputCriticalityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityInputCriticalityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityInputCriticalityMutation, { data, loading, error }] = useUpdateEntityInputCriticalityMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      criticality: // value for 'criticality'
 *   },
 * });
 */
export function useUpdateEntityInputCriticalityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityInputCriticalityMutation, UpdateEntityInputCriticalityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityInputCriticalityMutation, UpdateEntityInputCriticalityMutationVariables>(UpdateEntityInputCriticalityDocument, options);
      }
export type UpdateEntityInputCriticalityMutationHookResult = ReturnType<typeof useUpdateEntityInputCriticalityMutation>;
export type UpdateEntityInputCriticalityMutationResult = Apollo.MutationResult<UpdateEntityInputCriticalityMutation>;
export type UpdateEntityInputCriticalityMutationOptions = Apollo.BaseMutationOptions<UpdateEntityInputCriticalityMutation, UpdateEntityInputCriticalityMutationVariables>;
export const EntityAutomationsQueryOperationDocument = gql`
    query EntityAutomationsQueryOperation {
  automations(cseResourceType: "ENTITY") {
    objects {
      cseResourceSubTypes
      description
      enabled
      executionTypes
      id
      name
      playbookId
    }
  }
}
    `;

/**
 * __useEntityAutomationsQueryOperation__
 *
 * To run a query within a React component, call `useEntityAutomationsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityAutomationsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityAutomationsQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useEntityAutomationsQueryOperation(baseOptions?: Apollo.QueryHookOptions<EntityAutomationsQueryOperationQuery, EntityAutomationsQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityAutomationsQueryOperationQuery, EntityAutomationsQueryOperationQueryVariables>(EntityAutomationsQueryOperationDocument, options);
      }
export function useEntityAutomationsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityAutomationsQueryOperationQuery, EntityAutomationsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityAutomationsQueryOperationQuery, EntityAutomationsQueryOperationQueryVariables>(EntityAutomationsQueryOperationDocument, options);
        }
export function useEntityAutomationsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityAutomationsQueryOperationQuery, EntityAutomationsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityAutomationsQueryOperationQuery, EntityAutomationsQueryOperationQueryVariables>(EntityAutomationsQueryOperationDocument, options);
        }
export type EntityAutomationsQueryOperationHookResult = ReturnType<typeof useEntityAutomationsQueryOperation>;
export type EntityAutomationsQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityAutomationsQueryOperationLazyQuery>;
export type EntityAutomationsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityAutomationsQueryOperationSuspenseQuery>;
export type EntityAutomationsQueryOperationQueryResult = Apollo.QueryResult<EntityAutomationsQueryOperationQuery, EntityAutomationsQueryOperationQueryVariables>;
export const EntityTypeQueryOperationDocument = gql`
    query EntityTypeQueryOperation($id: ID!) {
  entity(id: $id) {
    ... on EntityInterface {
      entityType
      id
    }
  }
}
    `;

/**
 * __useEntityTypeQueryOperation__
 *
 * To run a query within a React component, call `useEntityTypeQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityTypeQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityTypeQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityTypeQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityTypeQueryOperationQuery, EntityTypeQueryOperationQueryVariables> & ({ variables: EntityTypeQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityTypeQueryOperationQuery, EntityTypeQueryOperationQueryVariables>(EntityTypeQueryOperationDocument, options);
      }
export function useEntityTypeQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityTypeQueryOperationQuery, EntityTypeQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityTypeQueryOperationQuery, EntityTypeQueryOperationQueryVariables>(EntityTypeQueryOperationDocument, options);
        }
export function useEntityTypeQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityTypeQueryOperationQuery, EntityTypeQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityTypeQueryOperationQuery, EntityTypeQueryOperationQueryVariables>(EntityTypeQueryOperationDocument, options);
        }
export type EntityTypeQueryOperationHookResult = ReturnType<typeof useEntityTypeQueryOperation>;
export type EntityTypeQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityTypeQueryOperationLazyQuery>;
export type EntityTypeQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityTypeQueryOperationSuspenseQuery>;
export type EntityTypeQueryOperationQueryResult = Apollo.QueryResult<EntityTypeQueryOperationQuery, EntityTypeQueryOperationQueryVariables>;
export const ExecuteEntityAutomationOperationDocument = gql`
    mutation ExecuteEntityAutomationOperation($fields: ExecuteAutomationFields!) {
  executeAutomation(fields: $fields) {
    executionIds
    playbooksWithErrors
  }
}
    `;
export type ExecuteEntityAutomationOperationMutationFn = Apollo.MutationFunction<ExecuteEntityAutomationOperationMutation, ExecuteEntityAutomationOperationMutationVariables>;

/**
 * __useExecuteEntityAutomationOperationMutation__
 *
 * To run a mutation, you first call `useExecuteEntityAutomationOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteEntityAutomationOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeEntityAutomationOperationMutation, { data, loading, error }] = useExecuteEntityAutomationOperationMutation({
 *   variables: {
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useExecuteEntityAutomationOperationMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteEntityAutomationOperationMutation, ExecuteEntityAutomationOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteEntityAutomationOperationMutation, ExecuteEntityAutomationOperationMutationVariables>(ExecuteEntityAutomationOperationDocument, options);
      }
export type ExecuteEntityAutomationOperationMutationHookResult = ReturnType<typeof useExecuteEntityAutomationOperationMutation>;
export type ExecuteEntityAutomationOperationMutationResult = Apollo.MutationResult<ExecuteEntityAutomationOperationMutation>;
export type ExecuteEntityAutomationOperationMutationOptions = Apollo.BaseMutationOptions<ExecuteEntityAutomationOperationMutation, ExecuteEntityAutomationOperationMutationVariables>;
export const EntityFormNotesQueryOperationDocument = gql`
    query EntityFormNotesQueryOperation($entityId: ID!) {
  currentUser {
    displayName
    id
    role
  }
  entityNotes(entityId: $entityId) {
    author {
      displayName
      id
      role
    }
    id
    lastUpdated
    note
    timestamp
  }
}
    `;

/**
 * __useEntityFormNotesQueryOperation__
 *
 * To run a query within a React component, call `useEntityFormNotesQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityFormNotesQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityFormNotesQueryOperation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useEntityFormNotesQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityFormNotesQueryOperationQuery, EntityFormNotesQueryOperationQueryVariables> & ({ variables: EntityFormNotesQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityFormNotesQueryOperationQuery, EntityFormNotesQueryOperationQueryVariables>(EntityFormNotesQueryOperationDocument, options);
      }
export function useEntityFormNotesQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityFormNotesQueryOperationQuery, EntityFormNotesQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityFormNotesQueryOperationQuery, EntityFormNotesQueryOperationQueryVariables>(EntityFormNotesQueryOperationDocument, options);
        }
export function useEntityFormNotesQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityFormNotesQueryOperationQuery, EntityFormNotesQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityFormNotesQueryOperationQuery, EntityFormNotesQueryOperationQueryVariables>(EntityFormNotesQueryOperationDocument, options);
        }
export type EntityFormNotesQueryOperationHookResult = ReturnType<typeof useEntityFormNotesQueryOperation>;
export type EntityFormNotesQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityFormNotesQueryOperationLazyQuery>;
export type EntityFormNotesQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityFormNotesQueryOperationSuspenseQuery>;
export type EntityFormNotesQueryOperationQueryResult = Apollo.QueryResult<EntityFormNotesQueryOperationQuery, EntityFormNotesQueryOperationQueryVariables>;
export const EntityFormNotesUpdateMutationDocument = gql`
    mutation EntityFormNotesUpdateMutation($id: ID!, $note: String!) {
  addEntityNote(entityId: $id, note: $note) {
    data {
      author {
        displayName
        id
        role
      }
      id
      note
      timestamp
    }
  }
}
    `;
export type EntityFormNotesUpdateMutationMutationFn = Apollo.MutationFunction<EntityFormNotesUpdateMutation, EntityFormNotesUpdateMutationVariables>;

/**
 * __useEntityFormNotesUpdateMutation__
 *
 * To run a mutation, you first call `useEntityFormNotesUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEntityFormNotesUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [entityFormNotesUpdateMutation, { data, loading, error }] = useEntityFormNotesUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useEntityFormNotesUpdateMutation(baseOptions?: Apollo.MutationHookOptions<EntityFormNotesUpdateMutation, EntityFormNotesUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EntityFormNotesUpdateMutation, EntityFormNotesUpdateMutationVariables>(EntityFormNotesUpdateMutationDocument, options);
      }
export type EntityFormNotesUpdateMutationHookResult = ReturnType<typeof useEntityFormNotesUpdateMutation>;
export type EntityFormNotesUpdateMutationMutationResult = Apollo.MutationResult<EntityFormNotesUpdateMutation>;
export type EntityFormNotesUpdateMutationMutationOptions = Apollo.BaseMutationOptions<EntityFormNotesUpdateMutation, EntityFormNotesUpdateMutationVariables>;
export const EntityFormNotesDeleteMutationDocument = gql`
    mutation EntityFormNotesDeleteMutation($entityId: ID!, $entityNoteId: ID!) {
  deleteEntityNote(entityId: $entityId, entityNoteId: $entityNoteId) {
    ok
  }
}
    `;
export type EntityFormNotesDeleteMutationMutationFn = Apollo.MutationFunction<EntityFormNotesDeleteMutation, EntityFormNotesDeleteMutationVariables>;

/**
 * __useEntityFormNotesDeleteMutation__
 *
 * To run a mutation, you first call `useEntityFormNotesDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEntityFormNotesDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [entityFormNotesDeleteMutation, { data, loading, error }] = useEntityFormNotesDeleteMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      entityNoteId: // value for 'entityNoteId'
 *   },
 * });
 */
export function useEntityFormNotesDeleteMutation(baseOptions?: Apollo.MutationHookOptions<EntityFormNotesDeleteMutation, EntityFormNotesDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EntityFormNotesDeleteMutation, EntityFormNotesDeleteMutationVariables>(EntityFormNotesDeleteMutationDocument, options);
      }
export type EntityFormNotesDeleteMutationHookResult = ReturnType<typeof useEntityFormNotesDeleteMutation>;
export type EntityFormNotesDeleteMutationMutationResult = Apollo.MutationResult<EntityFormNotesDeleteMutation>;
export type EntityFormNotesDeleteMutationMutationOptions = Apollo.BaseMutationOptions<EntityFormNotesDeleteMutation, EntityFormNotesDeleteMutationVariables>;
export const InsightExecutedAutomationQueryOperationDocument = gql`
    query InsightExecutedAutomationQueryOperation($id: ID!) {
  insight(id: $id) {
    id
    executedAutomations {
      executionId
      cseResourceType
      cseResourceId
      playbookDescription
      playbookName
      startDate
      status
      statusCode
    }
  }
}
    `;

/**
 * __useInsightExecutedAutomationQueryOperation__
 *
 * To run a query within a React component, call `useInsightExecutedAutomationQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightExecutedAutomationQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightExecutedAutomationQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInsightExecutedAutomationQueryOperation(baseOptions: Apollo.QueryHookOptions<InsightExecutedAutomationQueryOperationQuery, InsightExecutedAutomationQueryOperationQueryVariables> & ({ variables: InsightExecutedAutomationQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightExecutedAutomationQueryOperationQuery, InsightExecutedAutomationQueryOperationQueryVariables>(InsightExecutedAutomationQueryOperationDocument, options);
      }
export function useInsightExecutedAutomationQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightExecutedAutomationQueryOperationQuery, InsightExecutedAutomationQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightExecutedAutomationQueryOperationQuery, InsightExecutedAutomationQueryOperationQueryVariables>(InsightExecutedAutomationQueryOperationDocument, options);
        }
export function useInsightExecutedAutomationQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightExecutedAutomationQueryOperationQuery, InsightExecutedAutomationQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightExecutedAutomationQueryOperationQuery, InsightExecutedAutomationQueryOperationQueryVariables>(InsightExecutedAutomationQueryOperationDocument, options);
        }
export type InsightExecutedAutomationQueryOperationHookResult = ReturnType<typeof useInsightExecutedAutomationQueryOperation>;
export type InsightExecutedAutomationQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightExecutedAutomationQueryOperationLazyQuery>;
export type InsightExecutedAutomationQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightExecutedAutomationQueryOperationSuspenseQuery>;
export type InsightExecutedAutomationQueryOperationQueryResult = Apollo.QueryResult<InsightExecutedAutomationQueryOperationQuery, InsightExecutedAutomationQueryOperationQueryVariables>;
export const EntityExecutedAutomationsQueryOperationDocument = gql`
    query EntityExecutedAutomationsQueryOperation($id: ID!) {
  entity(id: $id) {
    id
    executedAutomations {
      executionId
      cseResourceType
      cseResourceId
      playbookDescription
      playbookName
      startDate
      status
      statusCode
    }
  }
}
    `;

/**
 * __useEntityExecutedAutomationsQueryOperation__
 *
 * To run a query within a React component, call `useEntityExecutedAutomationsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityExecutedAutomationsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityExecutedAutomationsQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityExecutedAutomationsQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityExecutedAutomationsQueryOperationQuery, EntityExecutedAutomationsQueryOperationQueryVariables> & ({ variables: EntityExecutedAutomationsQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityExecutedAutomationsQueryOperationQuery, EntityExecutedAutomationsQueryOperationQueryVariables>(EntityExecutedAutomationsQueryOperationDocument, options);
      }
export function useEntityExecutedAutomationsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityExecutedAutomationsQueryOperationQuery, EntityExecutedAutomationsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityExecutedAutomationsQueryOperationQuery, EntityExecutedAutomationsQueryOperationQueryVariables>(EntityExecutedAutomationsQueryOperationDocument, options);
        }
export function useEntityExecutedAutomationsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityExecutedAutomationsQueryOperationQuery, EntityExecutedAutomationsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityExecutedAutomationsQueryOperationQuery, EntityExecutedAutomationsQueryOperationQueryVariables>(EntityExecutedAutomationsQueryOperationDocument, options);
        }
export type EntityExecutedAutomationsQueryOperationHookResult = ReturnType<typeof useEntityExecutedAutomationsQueryOperation>;
export type EntityExecutedAutomationsQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityExecutedAutomationsQueryOperationLazyQuery>;
export type EntityExecutedAutomationsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityExecutedAutomationsQueryOperationSuspenseQuery>;
export type EntityExecutedAutomationsQueryOperationQueryResult = Apollo.QueryResult<EntityExecutedAutomationsQueryOperationQuery, EntityExecutedAutomationsQueryOperationQueryVariables>;
export const InsightDisplayQueryOperationDocument = gql`
    query InsightDisplayQueryOperation($id: ID!) {
  insight(id: $id) {
    id
    readableId
    name
  }
}
    `;

/**
 * __useInsightDisplayQueryOperation__
 *
 * To run a query within a React component, call `useInsightDisplayQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightDisplayQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightDisplayQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInsightDisplayQueryOperation(baseOptions: Apollo.QueryHookOptions<InsightDisplayQueryOperationQuery, InsightDisplayQueryOperationQueryVariables> & ({ variables: InsightDisplayQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightDisplayQueryOperationQuery, InsightDisplayQueryOperationQueryVariables>(InsightDisplayQueryOperationDocument, options);
      }
export function useInsightDisplayQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightDisplayQueryOperationQuery, InsightDisplayQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightDisplayQueryOperationQuery, InsightDisplayQueryOperationQueryVariables>(InsightDisplayQueryOperationDocument, options);
        }
export function useInsightDisplayQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightDisplayQueryOperationQuery, InsightDisplayQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightDisplayQueryOperationQuery, InsightDisplayQueryOperationQueryVariables>(InsightDisplayQueryOperationDocument, options);
        }
export type InsightDisplayQueryOperationHookResult = ReturnType<typeof useInsightDisplayQueryOperation>;
export type InsightDisplayQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightDisplayQueryOperationLazyQuery>;
export type InsightDisplayQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightDisplayQueryOperationSuspenseQuery>;
export type InsightDisplayQueryOperationQueryResult = Apollo.QueryResult<InsightDisplayQueryOperationQuery, InsightDisplayQueryOperationQueryVariables>;
export const EntityDisplayQueryOperationDocument = gql`
    query EntityDisplayQueryOperation($id: ID!) {
  entity(id: $id) {
    id
    entityTypeName
    value
  }
}
    `;

/**
 * __useEntityDisplayQueryOperation__
 *
 * To run a query within a React component, call `useEntityDisplayQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityDisplayQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityDisplayQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityDisplayQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityDisplayQueryOperationQuery, EntityDisplayQueryOperationQueryVariables> & ({ variables: EntityDisplayQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityDisplayQueryOperationQuery, EntityDisplayQueryOperationQueryVariables>(EntityDisplayQueryOperationDocument, options);
      }
export function useEntityDisplayQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityDisplayQueryOperationQuery, EntityDisplayQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityDisplayQueryOperationQuery, EntityDisplayQueryOperationQueryVariables>(EntityDisplayQueryOperationDocument, options);
        }
export function useEntityDisplayQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityDisplayQueryOperationQuery, EntityDisplayQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityDisplayQueryOperationQuery, EntityDisplayQueryOperationQueryVariables>(EntityDisplayQueryOperationDocument, options);
        }
export type EntityDisplayQueryOperationHookResult = ReturnType<typeof useEntityDisplayQueryOperation>;
export type EntityDisplayQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityDisplayQueryOperationLazyQuery>;
export type EntityDisplayQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityDisplayQueryOperationSuspenseQuery>;
export type EntityDisplayQueryOperationQueryResult = Apollo.QueryResult<EntityDisplayQueryOperationQuery, EntityDisplayQueryOperationQueryVariables>;
export const CreateFavoriteFieldOperationDocument = gql`
    mutation CreateFavoriteFieldOperation($fieldName: String!, $fieldType: FavoriteFieldType!) {
  createFavoriteField(
    applyToAllObjectTypes: true
    associatedObjectTypes: []
    fieldName: $fieldName
    fieldType: $fieldType
  ) {
    data {
      applyToAllObjectTypes
      associatedObjectTypes
      fieldName
      fieldType
      id
    }
  }
}
    `;
export type CreateFavoriteFieldOperationMutationFn = Apollo.MutationFunction<CreateFavoriteFieldOperationMutation, CreateFavoriteFieldOperationMutationVariables>;

/**
 * __useCreateFavoriteFieldOperationMutation__
 *
 * To run a mutation, you first call `useCreateFavoriteFieldOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFavoriteFieldOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFavoriteFieldOperationMutation, { data, loading, error }] = useCreateFavoriteFieldOperationMutation({
 *   variables: {
 *      fieldName: // value for 'fieldName'
 *      fieldType: // value for 'fieldType'
 *   },
 * });
 */
export function useCreateFavoriteFieldOperationMutation(baseOptions?: Apollo.MutationHookOptions<CreateFavoriteFieldOperationMutation, CreateFavoriteFieldOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFavoriteFieldOperationMutation, CreateFavoriteFieldOperationMutationVariables>(CreateFavoriteFieldOperationDocument, options);
      }
export type CreateFavoriteFieldOperationMutationHookResult = ReturnType<typeof useCreateFavoriteFieldOperationMutation>;
export type CreateFavoriteFieldOperationMutationResult = Apollo.MutationResult<CreateFavoriteFieldOperationMutation>;
export type CreateFavoriteFieldOperationMutationOptions = Apollo.BaseMutationOptions<CreateFavoriteFieldOperationMutation, CreateFavoriteFieldOperationMutationVariables>;
export const DeleteFavoriteFieldOperationDocument = gql`
    mutation DeleteFavoriteFieldOperation($id: ID!) {
  deleteFavoriteField(id: $id) {
    ok
  }
}
    `;
export type DeleteFavoriteFieldOperationMutationFn = Apollo.MutationFunction<DeleteFavoriteFieldOperationMutation, DeleteFavoriteFieldOperationMutationVariables>;

/**
 * __useDeleteFavoriteFieldOperationMutation__
 *
 * To run a mutation, you first call `useDeleteFavoriteFieldOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFavoriteFieldOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFavoriteFieldOperationMutation, { data, loading, error }] = useDeleteFavoriteFieldOperationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFavoriteFieldOperationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFavoriteFieldOperationMutation, DeleteFavoriteFieldOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFavoriteFieldOperationMutation, DeleteFavoriteFieldOperationMutationVariables>(DeleteFavoriteFieldOperationDocument, options);
      }
export type DeleteFavoriteFieldOperationMutationHookResult = ReturnType<typeof useDeleteFavoriteFieldOperationMutation>;
export type DeleteFavoriteFieldOperationMutationResult = Apollo.MutationResult<DeleteFavoriteFieldOperationMutation>;
export type DeleteFavoriteFieldOperationMutationOptions = Apollo.BaseMutationOptions<DeleteFavoriteFieldOperationMutation, DeleteFavoriteFieldOperationMutationVariables>;
export const FavoriteFieldsQueryOperationDocument = gql`
    query FavoriteFieldsQueryOperation {
  favoriteFields(limit: 5000) {
    objects {
      id
      fieldName
      fieldType
      applyToAllObjectTypes
      associatedObjectTypes
    }
  }
}
    `;

/**
 * __useFavoriteFieldsQueryOperation__
 *
 * To run a query within a React component, call `useFavoriteFieldsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useFavoriteFieldsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFavoriteFieldsQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useFavoriteFieldsQueryOperation(baseOptions?: Apollo.QueryHookOptions<FavoriteFieldsQueryOperationQuery, FavoriteFieldsQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FavoriteFieldsQueryOperationQuery, FavoriteFieldsQueryOperationQueryVariables>(FavoriteFieldsQueryOperationDocument, options);
      }
export function useFavoriteFieldsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FavoriteFieldsQueryOperationQuery, FavoriteFieldsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FavoriteFieldsQueryOperationQuery, FavoriteFieldsQueryOperationQueryVariables>(FavoriteFieldsQueryOperationDocument, options);
        }
export function useFavoriteFieldsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FavoriteFieldsQueryOperationQuery, FavoriteFieldsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FavoriteFieldsQueryOperationQuery, FavoriteFieldsQueryOperationQueryVariables>(FavoriteFieldsQueryOperationDocument, options);
        }
export type FavoriteFieldsQueryOperationHookResult = ReturnType<typeof useFavoriteFieldsQueryOperation>;
export type FavoriteFieldsQueryOperationLazyQueryHookResult = ReturnType<typeof useFavoriteFieldsQueryOperationLazyQuery>;
export type FavoriteFieldsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useFavoriteFieldsQueryOperationSuspenseQuery>;
export type FavoriteFieldsQueryOperationQueryResult = Apollo.QueryResult<FavoriteFieldsQueryOperationQuery, FavoriteFieldsQueryOperationQueryVariables>;
export const EnabledFeatureFlagsDocument = gql`
    query EnabledFeatureFlags($featureFlagsToLookup: [String!]!, $enabledByDefaultFeatureFlags: [String!]!) {
  enabledFeatureFlags(
    featureFlagsToLookup: $featureFlagsToLookup
    enabledByDefaultFeatureFlags: $enabledByDefaultFeatureFlags
  )
}
    `;

/**
 * __useEnabledFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useEnabledFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnabledFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnabledFeatureFlagsQuery({
 *   variables: {
 *      featureFlagsToLookup: // value for 'featureFlagsToLookup'
 *      enabledByDefaultFeatureFlags: // value for 'enabledByDefaultFeatureFlags'
 *   },
 * });
 */
export function useEnabledFeatureFlagsQuery(baseOptions: Apollo.QueryHookOptions<EnabledFeatureFlagsQuery, EnabledFeatureFlagsQueryVariables> & ({ variables: EnabledFeatureFlagsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnabledFeatureFlagsQuery, EnabledFeatureFlagsQueryVariables>(EnabledFeatureFlagsDocument, options);
      }
export function useEnabledFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnabledFeatureFlagsQuery, EnabledFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnabledFeatureFlagsQuery, EnabledFeatureFlagsQueryVariables>(EnabledFeatureFlagsDocument, options);
        }
export function useEnabledFeatureFlagsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EnabledFeatureFlagsQuery, EnabledFeatureFlagsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnabledFeatureFlagsQuery, EnabledFeatureFlagsQueryVariables>(EnabledFeatureFlagsDocument, options);
        }
export type EnabledFeatureFlagsQueryHookResult = ReturnType<typeof useEnabledFeatureFlagsQuery>;
export type EnabledFeatureFlagsLazyQueryHookResult = ReturnType<typeof useEnabledFeatureFlagsLazyQuery>;
export type EnabledFeatureFlagsSuspenseQueryHookResult = ReturnType<typeof useEnabledFeatureFlagsSuspenseQuery>;
export type EnabledFeatureFlagsQueryResult = Apollo.QueryResult<EnabledFeatureFlagsQuery, EnabledFeatureFlagsQueryVariables>;
export const SearchFilterQueryOperationDocument = gql`
    query SearchFilterQueryOperation($query: String!, $resultType: SearchResultType!, $fieldName: String!, $limit: Int) {
  searchFieldSuggestions(
    query: $query
    resultType: $resultType
    fieldName: $fieldName
    limit: $limit
  ) {
    total
    objects {
      value
    }
  }
}
    `;

/**
 * __useSearchFilterQueryOperation__
 *
 * To run a query within a React component, call `useSearchFilterQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useSearchFilterQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFilterQueryOperation({
 *   variables: {
 *      query: // value for 'query'
 *      resultType: // value for 'resultType'
 *      fieldName: // value for 'fieldName'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchFilterQueryOperation(baseOptions: Apollo.QueryHookOptions<SearchFilterQueryOperationQuery, SearchFilterQueryOperationQueryVariables> & ({ variables: SearchFilterQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchFilterQueryOperationQuery, SearchFilterQueryOperationQueryVariables>(SearchFilterQueryOperationDocument, options);
      }
export function useSearchFilterQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchFilterQueryOperationQuery, SearchFilterQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchFilterQueryOperationQuery, SearchFilterQueryOperationQueryVariables>(SearchFilterQueryOperationDocument, options);
        }
export function useSearchFilterQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchFilterQueryOperationQuery, SearchFilterQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchFilterQueryOperationQuery, SearchFilterQueryOperationQueryVariables>(SearchFilterQueryOperationDocument, options);
        }
export type SearchFilterQueryOperationHookResult = ReturnType<typeof useSearchFilterQueryOperation>;
export type SearchFilterQueryOperationLazyQueryHookResult = ReturnType<typeof useSearchFilterQueryOperationLazyQuery>;
export type SearchFilterQueryOperationSuspenseQueryHookResult = ReturnType<typeof useSearchFilterQueryOperationSuspenseQuery>;
export type SearchFilterQueryOperationQueryResult = Apollo.QueryResult<SearchFilterQueryOperationQuery, SearchFilterQueryOperationQueryVariables>;
export const InsightStatusQueryDocument = gql`
    query InsightStatusQuery($id: ID!) {
  insightStatus(id: $id) {
    id
    color
  }
}
    `;

/**
 * __useInsightStatusQuery__
 *
 * To run a query within a React component, call `useInsightStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInsightStatusQuery(baseOptions: Apollo.QueryHookOptions<InsightStatusQuery, InsightStatusQueryVariables> & ({ variables: InsightStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightStatusQuery, InsightStatusQueryVariables>(InsightStatusQueryDocument, options);
      }
export function useInsightStatusQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightStatusQuery, InsightStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightStatusQuery, InsightStatusQueryVariables>(InsightStatusQueryDocument, options);
        }
export function useInsightStatusQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightStatusQuery, InsightStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightStatusQuery, InsightStatusQueryVariables>(InsightStatusQueryDocument, options);
        }
export type InsightStatusQueryHookResult = ReturnType<typeof useInsightStatusQuery>;
export type InsightStatusQueryLazyQueryHookResult = ReturnType<typeof useInsightStatusQueryLazyQuery>;
export type InsightStatusQuerySuspenseQueryHookResult = ReturnType<typeof useInsightStatusQuerySuspenseQuery>;
export type InsightStatusQueryQueryResult = Apollo.QueryResult<InsightStatusQuery, InsightStatusQueryVariables>;
export const InsightStatusesQueryOperationDocument = gql`
    query InsightStatusesQueryOperation {
  insightStatuses(includeDisabled: false) {
    ...InsightStatusDisplay
  }
}
    ${InsightStatusDisplayFragmentDoc}`;

/**
 * __useInsightStatusesQueryOperation__
 *
 * To run a query within a React component, call `useInsightStatusesQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useInsightStatusesQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightStatusesQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useInsightStatusesQueryOperation(baseOptions?: Apollo.QueryHookOptions<InsightStatusesQueryOperationQuery, InsightStatusesQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightStatusesQueryOperationQuery, InsightStatusesQueryOperationQueryVariables>(InsightStatusesQueryOperationDocument, options);
      }
export function useInsightStatusesQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightStatusesQueryOperationQuery, InsightStatusesQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightStatusesQueryOperationQuery, InsightStatusesQueryOperationQueryVariables>(InsightStatusesQueryOperationDocument, options);
        }
export function useInsightStatusesQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightStatusesQueryOperationQuery, InsightStatusesQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightStatusesQueryOperationQuery, InsightStatusesQueryOperationQueryVariables>(InsightStatusesQueryOperationDocument, options);
        }
export type InsightStatusesQueryOperationHookResult = ReturnType<typeof useInsightStatusesQueryOperation>;
export type InsightStatusesQueryOperationLazyQueryHookResult = ReturnType<typeof useInsightStatusesQueryOperationLazyQuery>;
export type InsightStatusesQueryOperationSuspenseQueryHookResult = ReturnType<typeof useInsightStatusesQueryOperationSuspenseQuery>;
export type InsightStatusesQueryOperationQueryResult = Apollo.QueryResult<InsightStatusesQueryOperationQuery, InsightStatusesQueryOperationQueryVariables>;
export const EntityInventoryQueryOperationDocument = gql`
    query EntityInventoryQueryOperation($entityId: ID!, $includeMetadata: Boolean!) {
  entity(id: $entityId) {
    ...EntityInventoryFragment
  }
}
    ${EntityInventoryFragmentDoc}`;

/**
 * __useEntityInventoryQueryOperation__
 *
 * To run a query within a React component, call `useEntityInventoryQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityInventoryQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityInventoryQueryOperation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *      includeMetadata: // value for 'includeMetadata'
 *   },
 * });
 */
export function useEntityInventoryQueryOperation(baseOptions: Apollo.QueryHookOptions<EntityInventoryQueryOperationQuery, EntityInventoryQueryOperationQueryVariables> & ({ variables: EntityInventoryQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityInventoryQueryOperationQuery, EntityInventoryQueryOperationQueryVariables>(EntityInventoryQueryOperationDocument, options);
      }
export function useEntityInventoryQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityInventoryQueryOperationQuery, EntityInventoryQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityInventoryQueryOperationQuery, EntityInventoryQueryOperationQueryVariables>(EntityInventoryQueryOperationDocument, options);
        }
export function useEntityInventoryQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityInventoryQueryOperationQuery, EntityInventoryQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityInventoryQueryOperationQuery, EntityInventoryQueryOperationQueryVariables>(EntityInventoryQueryOperationDocument, options);
        }
export type EntityInventoryQueryOperationHookResult = ReturnType<typeof useEntityInventoryQueryOperation>;
export type EntityInventoryQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityInventoryQueryOperationLazyQuery>;
export type EntityInventoryQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityInventoryQueryOperationSuspenseQuery>;
export type EntityInventoryQueryOperationQueryResult = Apollo.QueryResult<EntityInventoryQueryOperationQuery, EntityInventoryQueryOperationQueryVariables>;
export const RecordSearchResultsOperationDocument = gql`
    query RecordSearchResultsOperation($searchStarted: Boolean!, $jobId: ID!, $offset: Int!, $limit: Int!) {
  sumoRecordSearchJobStatus(jobId: $jobId) @include(if: $searchStarted) {
    state
    total
    histogramBuckets {
      startTimestamp
      length
      count
    }
  }
  sumoRecordSearchJobResults(jobId: $jobId, offset: $offset, limit: $limit) @include(if: $searchStarted)
  sumoRecordSearchJobObjectTypeCounts(jobId: $jobId) @include(if: $searchStarted) {
    objectType
    count
  }
}
    `;

/**
 * __useRecordSearchResultsOperationQuery__
 *
 * To run a query within a React component, call `useRecordSearchResultsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecordSearchResultsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecordSearchResultsOperationQuery({
 *   variables: {
 *      searchStarted: // value for 'searchStarted'
 *      jobId: // value for 'jobId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRecordSearchResultsOperationQuery(baseOptions: Apollo.QueryHookOptions<RecordSearchResultsOperationQuery, RecordSearchResultsOperationQueryVariables> & ({ variables: RecordSearchResultsOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecordSearchResultsOperationQuery, RecordSearchResultsOperationQueryVariables>(RecordSearchResultsOperationDocument, options);
      }
export function useRecordSearchResultsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecordSearchResultsOperationQuery, RecordSearchResultsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecordSearchResultsOperationQuery, RecordSearchResultsOperationQueryVariables>(RecordSearchResultsOperationDocument, options);
        }
export function useRecordSearchResultsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecordSearchResultsOperationQuery, RecordSearchResultsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecordSearchResultsOperationQuery, RecordSearchResultsOperationQueryVariables>(RecordSearchResultsOperationDocument, options);
        }
export type RecordSearchResultsOperationQueryHookResult = ReturnType<typeof useRecordSearchResultsOperationQuery>;
export type RecordSearchResultsOperationLazyQueryHookResult = ReturnType<typeof useRecordSearchResultsOperationLazyQuery>;
export type RecordSearchResultsOperationSuspenseQueryHookResult = ReturnType<typeof useRecordSearchResultsOperationSuspenseQuery>;
export type RecordSearchResultsOperationQueryResult = Apollo.QueryResult<RecordSearchResultsOperationQuery, RecordSearchResultsOperationQueryVariables>;
export const SumoRecordSearchOperationDocument = gql`
    query SumoRecordSearchOperation($q: String!, $sort: String, $sortDir: SortDir, $querySyntax: SumoSearchQuerySyntax) {
  sumoRecordSearchQuery(
    q: $q
    sort: $sort
    sortDir: $sortDir
    querySyntax: $querySyntax
  )
}
    `;

/**
 * __useSumoRecordSearchOperationQuery__
 *
 * To run a query within a React component, call `useSumoRecordSearchOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSumoRecordSearchOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSumoRecordSearchOperationQuery({
 *   variables: {
 *      q: // value for 'q'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *      querySyntax: // value for 'querySyntax'
 *   },
 * });
 */
export function useSumoRecordSearchOperationQuery(baseOptions: Apollo.QueryHookOptions<SumoRecordSearchOperationQuery, SumoRecordSearchOperationQueryVariables> & ({ variables: SumoRecordSearchOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SumoRecordSearchOperationQuery, SumoRecordSearchOperationQueryVariables>(SumoRecordSearchOperationDocument, options);
      }
export function useSumoRecordSearchOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SumoRecordSearchOperationQuery, SumoRecordSearchOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SumoRecordSearchOperationQuery, SumoRecordSearchOperationQueryVariables>(SumoRecordSearchOperationDocument, options);
        }
export function useSumoRecordSearchOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SumoRecordSearchOperationQuery, SumoRecordSearchOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SumoRecordSearchOperationQuery, SumoRecordSearchOperationQueryVariables>(SumoRecordSearchOperationDocument, options);
        }
export type SumoRecordSearchOperationQueryHookResult = ReturnType<typeof useSumoRecordSearchOperationQuery>;
export type SumoRecordSearchOperationLazyQueryHookResult = ReturnType<typeof useSumoRecordSearchOperationLazyQuery>;
export type SumoRecordSearchOperationSuspenseQueryHookResult = ReturnType<typeof useSumoRecordSearchOperationSuspenseQuery>;
export type SumoRecordSearchOperationQueryResult = Apollo.QueryResult<SumoRecordSearchOperationQuery, SumoRecordSearchOperationQueryVariables>;
export const StartSumoRecordSearchJobOperationDocument = gql`
    mutation StartSumoRecordSearchJobOperation($q: String!, $querySyntax: SumoSearchQuerySyntax, $start: DateTime!, $end: DateTime!, $sort: String, $sortDir: SortDir) {
  startSumoRecordSearchJob(
    q: $q
    querySyntax: $querySyntax
    start: $start
    end: $end
    sort: $sort
    sortDir: $sortDir
  ) {
    jobId
  }
}
    `;
export type StartSumoRecordSearchJobOperationMutationFn = Apollo.MutationFunction<StartSumoRecordSearchJobOperationMutation, StartSumoRecordSearchJobOperationMutationVariables>;

/**
 * __useStartSumoRecordSearchJobOperationMutation__
 *
 * To run a mutation, you first call `useStartSumoRecordSearchJobOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSumoRecordSearchJobOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSumoRecordSearchJobOperationMutation, { data, loading, error }] = useStartSumoRecordSearchJobOperationMutation({
 *   variables: {
 *      q: // value for 'q'
 *      querySyntax: // value for 'querySyntax'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useStartSumoRecordSearchJobOperationMutation(baseOptions?: Apollo.MutationHookOptions<StartSumoRecordSearchJobOperationMutation, StartSumoRecordSearchJobOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartSumoRecordSearchJobOperationMutation, StartSumoRecordSearchJobOperationMutationVariables>(StartSumoRecordSearchJobOperationDocument, options);
      }
export type StartSumoRecordSearchJobOperationMutationHookResult = ReturnType<typeof useStartSumoRecordSearchJobOperationMutation>;
export type StartSumoRecordSearchJobOperationMutationResult = Apollo.MutationResult<StartSumoRecordSearchJobOperationMutation>;
export type StartSumoRecordSearchJobOperationMutationOptions = Apollo.BaseMutationOptions<StartSumoRecordSearchJobOperationMutation, StartSumoRecordSearchJobOperationMutationVariables>;
export const StartSumoRecordSearchJobForRuleExpressionDocument = gql`
    mutation startSumoRecordSearchJobForRuleExpression($ruleExpression: String!, $ruleTuningTranslationExpressions: [RuleTuningExpressionTranslationFields!]!, $start: DateTime!, $end: DateTime!) {
  startSumoRecordSearchJobForRuleExpression(
    ruleExpression: $ruleExpression
    ruleTuningTranslationExpressions: $ruleTuningTranslationExpressions
    start: $start
    end: $end
  ) {
    jobId
  }
}
    `;
export type StartSumoRecordSearchJobForRuleExpressionMutationFn = Apollo.MutationFunction<StartSumoRecordSearchJobForRuleExpressionMutation, StartSumoRecordSearchJobForRuleExpressionMutationVariables>;

/**
 * __useStartSumoRecordSearchJobForRuleExpressionMutation__
 *
 * To run a mutation, you first call `useStartSumoRecordSearchJobForRuleExpressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSumoRecordSearchJobForRuleExpressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSumoRecordSearchJobForRuleExpressionMutation, { data, loading, error }] = useStartSumoRecordSearchJobForRuleExpressionMutation({
 *   variables: {
 *      ruleExpression: // value for 'ruleExpression'
 *      ruleTuningTranslationExpressions: // value for 'ruleTuningTranslationExpressions'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useStartSumoRecordSearchJobForRuleExpressionMutation(baseOptions?: Apollo.MutationHookOptions<StartSumoRecordSearchJobForRuleExpressionMutation, StartSumoRecordSearchJobForRuleExpressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartSumoRecordSearchJobForRuleExpressionMutation, StartSumoRecordSearchJobForRuleExpressionMutationVariables>(StartSumoRecordSearchJobForRuleExpressionDocument, options);
      }
export type StartSumoRecordSearchJobForRuleExpressionMutationHookResult = ReturnType<typeof useStartSumoRecordSearchJobForRuleExpressionMutation>;
export type StartSumoRecordSearchJobForRuleExpressionMutationResult = Apollo.MutationResult<StartSumoRecordSearchJobForRuleExpressionMutation>;
export type StartSumoRecordSearchJobForRuleExpressionMutationOptions = Apollo.BaseMutationOptions<StartSumoRecordSearchJobForRuleExpressionMutation, StartSumoRecordSearchJobForRuleExpressionMutationVariables>;
export const CancelSumoRecordSearchJobOperationDocument = gql`
    mutation CancelSumoRecordSearchJobOperation($jobId: String!) {
  cancelSumoRecordSearchJob(jobId: $jobId) {
    ok
  }
}
    `;
export type CancelSumoRecordSearchJobOperationMutationFn = Apollo.MutationFunction<CancelSumoRecordSearchJobOperationMutation, CancelSumoRecordSearchJobOperationMutationVariables>;

/**
 * __useCancelSumoRecordSearchJobOperationMutation__
 *
 * To run a mutation, you first call `useCancelSumoRecordSearchJobOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSumoRecordSearchJobOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSumoRecordSearchJobOperationMutation, { data, loading, error }] = useCancelSumoRecordSearchJobOperationMutation({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useCancelSumoRecordSearchJobOperationMutation(baseOptions?: Apollo.MutationHookOptions<CancelSumoRecordSearchJobOperationMutation, CancelSumoRecordSearchJobOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSumoRecordSearchJobOperationMutation, CancelSumoRecordSearchJobOperationMutationVariables>(CancelSumoRecordSearchJobOperationDocument, options);
      }
export type CancelSumoRecordSearchJobOperationMutationHookResult = ReturnType<typeof useCancelSumoRecordSearchJobOperationMutation>;
export type CancelSumoRecordSearchJobOperationMutationResult = Apollo.MutationResult<CancelSumoRecordSearchJobOperationMutation>;
export type CancelSumoRecordSearchJobOperationMutationOptions = Apollo.BaseMutationOptions<CancelSumoRecordSearchJobOperationMutation, CancelSumoRecordSearchJobOperationMutationVariables>;
export const RuleExpressionResultsOperationDocument = gql`
    query RuleExpressionResultsOperation($jobId: ID!, $offset: Int!, $limit: Int!) {
  sumoRecordSearchJobStatus(jobId: $jobId) {
    state
    total
  }
  sumoRecordSearchJobResults(jobId: $jobId, offset: $offset, limit: $limit)
}
    `;

/**
 * __useRuleExpressionResultsOperationQuery__
 *
 * To run a query within a React component, call `useRuleExpressionResultsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuleExpressionResultsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleExpressionResultsOperationQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRuleExpressionResultsOperationQuery(baseOptions: Apollo.QueryHookOptions<RuleExpressionResultsOperationQuery, RuleExpressionResultsOperationQueryVariables> & ({ variables: RuleExpressionResultsOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RuleExpressionResultsOperationQuery, RuleExpressionResultsOperationQueryVariables>(RuleExpressionResultsOperationDocument, options);
      }
export function useRuleExpressionResultsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuleExpressionResultsOperationQuery, RuleExpressionResultsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RuleExpressionResultsOperationQuery, RuleExpressionResultsOperationQueryVariables>(RuleExpressionResultsOperationDocument, options);
        }
export function useRuleExpressionResultsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RuleExpressionResultsOperationQuery, RuleExpressionResultsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RuleExpressionResultsOperationQuery, RuleExpressionResultsOperationQueryVariables>(RuleExpressionResultsOperationDocument, options);
        }
export type RuleExpressionResultsOperationQueryHookResult = ReturnType<typeof useRuleExpressionResultsOperationQuery>;
export type RuleExpressionResultsOperationLazyQueryHookResult = ReturnType<typeof useRuleExpressionResultsOperationLazyQuery>;
export type RuleExpressionResultsOperationSuspenseQueryHookResult = ReturnType<typeof useRuleExpressionResultsOperationSuspenseQuery>;
export type RuleExpressionResultsOperationQueryResult = Apollo.QueryResult<RuleExpressionResultsOperationQuery, RuleExpressionResultsOperationQueryVariables>;
export const EntityFieldsAndIndicatorDocument = gql`
    query EntityFieldsAndIndicator($entityId: ID!) {
  entityFieldsWithTypes {
    field
    type
  }
  entity(id: $entityId) {
    id
    entityType
    reputation
    reputationSources
  }
}
    `;

/**
 * __useEntityFieldsAndIndicatorQuery__
 *
 * To run a query within a React component, call `useEntityFieldsAndIndicatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityFieldsAndIndicatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityFieldsAndIndicatorQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useEntityFieldsAndIndicatorQuery(baseOptions: Apollo.QueryHookOptions<EntityFieldsAndIndicatorQuery, EntityFieldsAndIndicatorQueryVariables> & ({ variables: EntityFieldsAndIndicatorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityFieldsAndIndicatorQuery, EntityFieldsAndIndicatorQueryVariables>(EntityFieldsAndIndicatorDocument, options);
      }
export function useEntityFieldsAndIndicatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityFieldsAndIndicatorQuery, EntityFieldsAndIndicatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityFieldsAndIndicatorQuery, EntityFieldsAndIndicatorQueryVariables>(EntityFieldsAndIndicatorDocument, options);
        }
export function useEntityFieldsAndIndicatorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityFieldsAndIndicatorQuery, EntityFieldsAndIndicatorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityFieldsAndIndicatorQuery, EntityFieldsAndIndicatorQueryVariables>(EntityFieldsAndIndicatorDocument, options);
        }
export type EntityFieldsAndIndicatorQueryHookResult = ReturnType<typeof useEntityFieldsAndIndicatorQuery>;
export type EntityFieldsAndIndicatorLazyQueryHookResult = ReturnType<typeof useEntityFieldsAndIndicatorLazyQuery>;
export type EntityFieldsAndIndicatorSuspenseQueryHookResult = ReturnType<typeof useEntityFieldsAndIndicatorSuspenseQuery>;
export type EntityFieldsAndIndicatorQueryResult = Apollo.QueryResult<EntityFieldsAndIndicatorQuery, EntityFieldsAndIndicatorQueryVariables>;
export const RelatedEntitiesQueryOperationDocument = gql`
    query RelatedEntitiesQueryOperation($ip: String!, $start: DateTime!, $end: DateTime!) {
  relatedEntities(ip: $ip, start: $start, end: $end) {
    id
    type
    value
  }
}
    `;

/**
 * __useRelatedEntitiesQueryOperation__
 *
 * To run a query within a React component, call `useRelatedEntitiesQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useRelatedEntitiesQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedEntitiesQueryOperation({
 *   variables: {
 *      ip: // value for 'ip'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useRelatedEntitiesQueryOperation(baseOptions: Apollo.QueryHookOptions<RelatedEntitiesQueryOperationQuery, RelatedEntitiesQueryOperationQueryVariables> & ({ variables: RelatedEntitiesQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatedEntitiesQueryOperationQuery, RelatedEntitiesQueryOperationQueryVariables>(RelatedEntitiesQueryOperationDocument, options);
      }
export function useRelatedEntitiesQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatedEntitiesQueryOperationQuery, RelatedEntitiesQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatedEntitiesQueryOperationQuery, RelatedEntitiesQueryOperationQueryVariables>(RelatedEntitiesQueryOperationDocument, options);
        }
export function useRelatedEntitiesQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RelatedEntitiesQueryOperationQuery, RelatedEntitiesQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RelatedEntitiesQueryOperationQuery, RelatedEntitiesQueryOperationQueryVariables>(RelatedEntitiesQueryOperationDocument, options);
        }
export type RelatedEntitiesQueryOperationHookResult = ReturnType<typeof useRelatedEntitiesQueryOperation>;
export type RelatedEntitiesQueryOperationLazyQueryHookResult = ReturnType<typeof useRelatedEntitiesQueryOperationLazyQuery>;
export type RelatedEntitiesQueryOperationSuspenseQueryHookResult = ReturnType<typeof useRelatedEntitiesQueryOperationSuspenseQuery>;
export type RelatedEntitiesQueryOperationQueryResult = Apollo.QueryResult<RelatedEntitiesQueryOperationQuery, RelatedEntitiesQueryOperationQueryVariables>;
export const RuleItemQueryOperationDocument = gql`
    query RuleItemQueryOperation($id: ID!) {
  rule(id: $id) {
    ...RuleItemFragment
  }
}
    ${RuleItemFragmentDoc}`;

/**
 * __useRuleItemQueryOperation__
 *
 * To run a query within a React component, call `useRuleItemQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useRuleItemQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleItemQueryOperation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRuleItemQueryOperation(baseOptions: Apollo.QueryHookOptions<RuleItemQueryOperationQuery, RuleItemQueryOperationQueryVariables> & ({ variables: RuleItemQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RuleItemQueryOperationQuery, RuleItemQueryOperationQueryVariables>(RuleItemQueryOperationDocument, options);
      }
export function useRuleItemQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuleItemQueryOperationQuery, RuleItemQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RuleItemQueryOperationQuery, RuleItemQueryOperationQueryVariables>(RuleItemQueryOperationDocument, options);
        }
export function useRuleItemQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RuleItemQueryOperationQuery, RuleItemQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RuleItemQueryOperationQuery, RuleItemQueryOperationQueryVariables>(RuleItemQueryOperationDocument, options);
        }
export type RuleItemQueryOperationHookResult = ReturnType<typeof useRuleItemQueryOperation>;
export type RuleItemQueryOperationLazyQueryHookResult = ReturnType<typeof useRuleItemQueryOperationLazyQuery>;
export type RuleItemQueryOperationSuspenseQueryHookResult = ReturnType<typeof useRuleItemQueryOperationSuspenseQuery>;
export type RuleItemQueryOperationQueryResult = Apollo.QueryResult<RuleItemQueryOperationQuery, RuleItemQueryOperationQueryVariables>;
export const RulesListForSelectQueryOperationDocument = gql`
    query RulesListForSelectQueryOperation($q: String, $offset: Int, $limit: Int, $sort: RuleSortableField!, $sortDir: SortDir!) {
  rules(
    q: $q
    offset: $offset
    limit: $limit
    sort: [{field: $sort, direction: $sortDir}]
  ) {
    total
    objects {
      ...RuleSelectFragment
    }
  }
}
    ${RuleSelectFragmentDoc}`;

/**
 * __useRulesListForSelectQueryOperation__
 *
 * To run a query within a React component, call `useRulesListForSelectQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useRulesListForSelectQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRulesListForSelectQueryOperation({
 *   variables: {
 *      q: // value for 'q'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      sortDir: // value for 'sortDir'
 *   },
 * });
 */
export function useRulesListForSelectQueryOperation(baseOptions: Apollo.QueryHookOptions<RulesListForSelectQueryOperationQuery, RulesListForSelectQueryOperationQueryVariables> & ({ variables: RulesListForSelectQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RulesListForSelectQueryOperationQuery, RulesListForSelectQueryOperationQueryVariables>(RulesListForSelectQueryOperationDocument, options);
      }
export function useRulesListForSelectQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RulesListForSelectQueryOperationQuery, RulesListForSelectQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RulesListForSelectQueryOperationQuery, RulesListForSelectQueryOperationQueryVariables>(RulesListForSelectQueryOperationDocument, options);
        }
export function useRulesListForSelectQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RulesListForSelectQueryOperationQuery, RulesListForSelectQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RulesListForSelectQueryOperationQuery, RulesListForSelectQueryOperationQueryVariables>(RulesListForSelectQueryOperationDocument, options);
        }
export type RulesListForSelectQueryOperationHookResult = ReturnType<typeof useRulesListForSelectQueryOperation>;
export type RulesListForSelectQueryOperationLazyQueryHookResult = ReturnType<typeof useRulesListForSelectQueryOperationLazyQuery>;
export type RulesListForSelectQueryOperationSuspenseQueryHookResult = ReturnType<typeof useRulesListForSelectQueryOperationSuspenseQuery>;
export type RulesListForSelectQueryOperationQueryResult = Apollo.QueryResult<RulesListForSelectQueryOperationQuery, RulesListForSelectQueryOperationQueryVariables>;
export const SchemaFieldQueryOperationDocument = gql`
    query SchemaFieldQueryOperation {
  logMappingOptions {
    recordTypeOptions {
      objectType
      mappableFields {
        name
        type
      }
    }
  }
}
    `;

/**
 * __useSchemaFieldQueryOperation__
 *
 * To run a query within a React component, call `useSchemaFieldQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useSchemaFieldQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaFieldQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useSchemaFieldQueryOperation(baseOptions?: Apollo.QueryHookOptions<SchemaFieldQueryOperationQuery, SchemaFieldQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchemaFieldQueryOperationQuery, SchemaFieldQueryOperationQueryVariables>(SchemaFieldQueryOperationDocument, options);
      }
export function useSchemaFieldQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchemaFieldQueryOperationQuery, SchemaFieldQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchemaFieldQueryOperationQuery, SchemaFieldQueryOperationQueryVariables>(SchemaFieldQueryOperationDocument, options);
        }
export function useSchemaFieldQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchemaFieldQueryOperationQuery, SchemaFieldQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchemaFieldQueryOperationQuery, SchemaFieldQueryOperationQueryVariables>(SchemaFieldQueryOperationDocument, options);
        }
export type SchemaFieldQueryOperationHookResult = ReturnType<typeof useSchemaFieldQueryOperation>;
export type SchemaFieldQueryOperationLazyQueryHookResult = ReturnType<typeof useSchemaFieldQueryOperationLazyQuery>;
export type SchemaFieldQueryOperationSuspenseQueryHookResult = ReturnType<typeof useSchemaFieldQueryOperationSuspenseQuery>;
export type SchemaFieldQueryOperationQueryResult = Apollo.QueryResult<SchemaFieldQueryOperationQuery, SchemaFieldQueryOperationQueryVariables>;
export const SelectIncidentTemplateDialogOperationDocument = gql`
    query SelectIncidentTemplateDialogOperation {
  incidentTemplates {
    id
    name
  }
}
    `;

/**
 * __useSelectIncidentTemplateDialogOperationQuery__
 *
 * To run a query within a React component, call `useSelectIncidentTemplateDialogOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectIncidentTemplateDialogOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectIncidentTemplateDialogOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useSelectIncidentTemplateDialogOperationQuery(baseOptions?: Apollo.QueryHookOptions<SelectIncidentTemplateDialogOperationQuery, SelectIncidentTemplateDialogOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectIncidentTemplateDialogOperationQuery, SelectIncidentTemplateDialogOperationQueryVariables>(SelectIncidentTemplateDialogOperationDocument, options);
      }
export function useSelectIncidentTemplateDialogOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectIncidentTemplateDialogOperationQuery, SelectIncidentTemplateDialogOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectIncidentTemplateDialogOperationQuery, SelectIncidentTemplateDialogOperationQueryVariables>(SelectIncidentTemplateDialogOperationDocument, options);
        }
export function useSelectIncidentTemplateDialogOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectIncidentTemplateDialogOperationQuery, SelectIncidentTemplateDialogOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectIncidentTemplateDialogOperationQuery, SelectIncidentTemplateDialogOperationQueryVariables>(SelectIncidentTemplateDialogOperationDocument, options);
        }
export type SelectIncidentTemplateDialogOperationQueryHookResult = ReturnType<typeof useSelectIncidentTemplateDialogOperationQuery>;
export type SelectIncidentTemplateDialogOperationLazyQueryHookResult = ReturnType<typeof useSelectIncidentTemplateDialogOperationLazyQuery>;
export type SelectIncidentTemplateDialogOperationSuspenseQueryHookResult = ReturnType<typeof useSelectIncidentTemplateDialogOperationSuspenseQuery>;
export type SelectIncidentTemplateDialogOperationQueryResult = Apollo.QueryResult<SelectIncidentTemplateDialogOperationQuery, SelectIncidentTemplateDialogOperationQueryVariables>;
export const StartSumoRawMessageLookupJobOperationDocument = gql`
    mutation StartSumoRawMessageLookupJobOperation($messageId: String!, $timestamp: DateTime!) {
  startSumoRawMessageLookupJob(messageId: $messageId, timestamp: $timestamp) {
    jobId
  }
}
    `;
export type StartSumoRawMessageLookupJobOperationMutationFn = Apollo.MutationFunction<StartSumoRawMessageLookupJobOperationMutation, StartSumoRawMessageLookupJobOperationMutationVariables>;

/**
 * __useStartSumoRawMessageLookupJobOperationMutation__
 *
 * To run a mutation, you first call `useStartSumoRawMessageLookupJobOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartSumoRawMessageLookupJobOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startSumoRawMessageLookupJobOperationMutation, { data, loading, error }] = useStartSumoRawMessageLookupJobOperationMutation({
 *   variables: {
 *      messageId: // value for 'messageId'
 *      timestamp: // value for 'timestamp'
 *   },
 * });
 */
export function useStartSumoRawMessageLookupJobOperationMutation(baseOptions?: Apollo.MutationHookOptions<StartSumoRawMessageLookupJobOperationMutation, StartSumoRawMessageLookupJobOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartSumoRawMessageLookupJobOperationMutation, StartSumoRawMessageLookupJobOperationMutationVariables>(StartSumoRawMessageLookupJobOperationDocument, options);
      }
export type StartSumoRawMessageLookupJobOperationMutationHookResult = ReturnType<typeof useStartSumoRawMessageLookupJobOperationMutation>;
export type StartSumoRawMessageLookupJobOperationMutationResult = Apollo.MutationResult<StartSumoRawMessageLookupJobOperationMutation>;
export type StartSumoRawMessageLookupJobOperationMutationOptions = Apollo.BaseMutationOptions<StartSumoRawMessageLookupJobOperationMutation, StartSumoRawMessageLookupJobOperationMutationVariables>;
export const SumoRawMessageLookupJobResultOperationDocument = gql`
    query SumoRawMessageLookupJobResultOperation($searchStarted: Boolean!, $jobId: ID!) {
  sumoRecordSearchJobStatus(jobId: $jobId) @include(if: $searchStarted) {
    state
    total
  }
  sumoRawMessageLookupJobResult(jobId: $jobId) @include(if: $searchStarted)
}
    `;

/**
 * __useSumoRawMessageLookupJobResultOperationQuery__
 *
 * To run a query within a React component, call `useSumoRawMessageLookupJobResultOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSumoRawMessageLookupJobResultOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSumoRawMessageLookupJobResultOperationQuery({
 *   variables: {
 *      searchStarted: // value for 'searchStarted'
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useSumoRawMessageLookupJobResultOperationQuery(baseOptions: Apollo.QueryHookOptions<SumoRawMessageLookupJobResultOperationQuery, SumoRawMessageLookupJobResultOperationQueryVariables> & ({ variables: SumoRawMessageLookupJobResultOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SumoRawMessageLookupJobResultOperationQuery, SumoRawMessageLookupJobResultOperationQueryVariables>(SumoRawMessageLookupJobResultOperationDocument, options);
      }
export function useSumoRawMessageLookupJobResultOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SumoRawMessageLookupJobResultOperationQuery, SumoRawMessageLookupJobResultOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SumoRawMessageLookupJobResultOperationQuery, SumoRawMessageLookupJobResultOperationQueryVariables>(SumoRawMessageLookupJobResultOperationDocument, options);
        }
export function useSumoRawMessageLookupJobResultOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SumoRawMessageLookupJobResultOperationQuery, SumoRawMessageLookupJobResultOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SumoRawMessageLookupJobResultOperationQuery, SumoRawMessageLookupJobResultOperationQueryVariables>(SumoRawMessageLookupJobResultOperationDocument, options);
        }
export type SumoRawMessageLookupJobResultOperationQueryHookResult = ReturnType<typeof useSumoRawMessageLookupJobResultOperationQuery>;
export type SumoRawMessageLookupJobResultOperationLazyQueryHookResult = ReturnType<typeof useSumoRawMessageLookupJobResultOperationLazyQuery>;
export type SumoRawMessageLookupJobResultOperationSuspenseQueryHookResult = ReturnType<typeof useSumoRawMessageLookupJobResultOperationSuspenseQuery>;
export type SumoRawMessageLookupJobResultOperationQueryResult = Apollo.QueryResult<SumoRawMessageLookupJobResultOperationQuery, SumoRawMessageLookupJobResultOperationQueryVariables>;
export const InsightTagOptionsOperationDocument = gql`
    query InsightTagOptionsOperation {
  insightTagOptions {
    value
    label
  }
}
    `;

/**
 * __useInsightTagOptionsOperationQuery__
 *
 * To run a query within a React component, call `useInsightTagOptionsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsightTagOptionsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsightTagOptionsOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useInsightTagOptionsOperationQuery(baseOptions?: Apollo.QueryHookOptions<InsightTagOptionsOperationQuery, InsightTagOptionsOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsightTagOptionsOperationQuery, InsightTagOptionsOperationQueryVariables>(InsightTagOptionsOperationDocument, options);
      }
export function useInsightTagOptionsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsightTagOptionsOperationQuery, InsightTagOptionsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsightTagOptionsOperationQuery, InsightTagOptionsOperationQueryVariables>(InsightTagOptionsOperationDocument, options);
        }
export function useInsightTagOptionsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsightTagOptionsOperationQuery, InsightTagOptionsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsightTagOptionsOperationQuery, InsightTagOptionsOperationQueryVariables>(InsightTagOptionsOperationDocument, options);
        }
export type InsightTagOptionsOperationQueryHookResult = ReturnType<typeof useInsightTagOptionsOperationQuery>;
export type InsightTagOptionsOperationLazyQueryHookResult = ReturnType<typeof useInsightTagOptionsOperationLazyQuery>;
export type InsightTagOptionsOperationSuspenseQueryHookResult = ReturnType<typeof useInsightTagOptionsOperationSuspenseQuery>;
export type InsightTagOptionsOperationQueryResult = Apollo.QueryResult<InsightTagOptionsOperationQuery, InsightTagOptionsOperationQueryVariables>;
export const EntityTagOptionsOperationDocument = gql`
    query EntityTagOptionsOperation {
  entityTagOptions {
    value
    label
  }
}
    `;

/**
 * __useEntityTagOptionsOperationQuery__
 *
 * To run a query within a React component, call `useEntityTagOptionsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityTagOptionsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityTagOptionsOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntityTagOptionsOperationQuery(baseOptions?: Apollo.QueryHookOptions<EntityTagOptionsOperationQuery, EntityTagOptionsOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityTagOptionsOperationQuery, EntityTagOptionsOperationQueryVariables>(EntityTagOptionsOperationDocument, options);
      }
export function useEntityTagOptionsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityTagOptionsOperationQuery, EntityTagOptionsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityTagOptionsOperationQuery, EntityTagOptionsOperationQueryVariables>(EntityTagOptionsOperationDocument, options);
        }
export function useEntityTagOptionsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityTagOptionsOperationQuery, EntityTagOptionsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityTagOptionsOperationQuery, EntityTagOptionsOperationQueryVariables>(EntityTagOptionsOperationDocument, options);
        }
export type EntityTagOptionsOperationQueryHookResult = ReturnType<typeof useEntityTagOptionsOperationQuery>;
export type EntityTagOptionsOperationLazyQueryHookResult = ReturnType<typeof useEntityTagOptionsOperationLazyQuery>;
export type EntityTagOptionsOperationSuspenseQueryHookResult = ReturnType<typeof useEntityTagOptionsOperationSuspenseQuery>;
export type EntityTagOptionsOperationQueryResult = Apollo.QueryResult<EntityTagOptionsOperationQuery, EntityTagOptionsOperationQueryVariables>;
export const SignalTagOptionsOperationDocument = gql`
    query SignalTagOptionsOperation {
  signalTagOptions {
    value
    label
  }
}
    `;

/**
 * __useSignalTagOptionsOperationQuery__
 *
 * To run a query within a React component, call `useSignalTagOptionsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignalTagOptionsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignalTagOptionsOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignalTagOptionsOperationQuery(baseOptions?: Apollo.QueryHookOptions<SignalTagOptionsOperationQuery, SignalTagOptionsOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignalTagOptionsOperationQuery, SignalTagOptionsOperationQueryVariables>(SignalTagOptionsOperationDocument, options);
      }
export function useSignalTagOptionsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignalTagOptionsOperationQuery, SignalTagOptionsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignalTagOptionsOperationQuery, SignalTagOptionsOperationQueryVariables>(SignalTagOptionsOperationDocument, options);
        }
export function useSignalTagOptionsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SignalTagOptionsOperationQuery, SignalTagOptionsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SignalTagOptionsOperationQuery, SignalTagOptionsOperationQueryVariables>(SignalTagOptionsOperationDocument, options);
        }
export type SignalTagOptionsOperationQueryHookResult = ReturnType<typeof useSignalTagOptionsOperationQuery>;
export type SignalTagOptionsOperationLazyQueryHookResult = ReturnType<typeof useSignalTagOptionsOperationLazyQuery>;
export type SignalTagOptionsOperationSuspenseQueryHookResult = ReturnType<typeof useSignalTagOptionsOperationSuspenseQuery>;
export type SignalTagOptionsOperationQueryResult = Apollo.QueryResult<SignalTagOptionsOperationQuery, SignalTagOptionsOperationQueryVariables>;
export const RuleTagOptionsOperationDocument = gql`
    query RuleTagOptionsOperation {
  ruleTagOptions {
    value
    label
  }
}
    `;

/**
 * __useRuleTagOptionsOperationQuery__
 *
 * To run a query within a React component, call `useRuleTagOptionsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuleTagOptionsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleTagOptionsOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useRuleTagOptionsOperationQuery(baseOptions?: Apollo.QueryHookOptions<RuleTagOptionsOperationQuery, RuleTagOptionsOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RuleTagOptionsOperationQuery, RuleTagOptionsOperationQueryVariables>(RuleTagOptionsOperationDocument, options);
      }
export function useRuleTagOptionsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuleTagOptionsOperationQuery, RuleTagOptionsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RuleTagOptionsOperationQuery, RuleTagOptionsOperationQueryVariables>(RuleTagOptionsOperationDocument, options);
        }
export function useRuleTagOptionsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RuleTagOptionsOperationQuery, RuleTagOptionsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RuleTagOptionsOperationQuery, RuleTagOptionsOperationQueryVariables>(RuleTagOptionsOperationDocument, options);
        }
export type RuleTagOptionsOperationQueryHookResult = ReturnType<typeof useRuleTagOptionsOperationQuery>;
export type RuleTagOptionsOperationLazyQueryHookResult = ReturnType<typeof useRuleTagOptionsOperationLazyQuery>;
export type RuleTagOptionsOperationSuspenseQueryHookResult = ReturnType<typeof useRuleTagOptionsOperationSuspenseQuery>;
export type RuleTagOptionsOperationQueryResult = Apollo.QueryResult<RuleTagOptionsOperationQuery, RuleTagOptionsOperationQueryVariables>;
export const BulkEntityFieldsAndIndicatorDocument = gql`
    query BulkEntityFieldsAndIndicator($entityIds: [ID!]!) {
  entityFieldsWithTypes {
    field
    type
  }
  entitiesByListIds(entityIds: $entityIds) {
    id
    entityType
    reputation
    reputationSources
  }
}
    `;

/**
 * __useBulkEntityFieldsAndIndicatorQuery__
 *
 * To run a query within a React component, call `useBulkEntityFieldsAndIndicatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkEntityFieldsAndIndicatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkEntityFieldsAndIndicatorQuery({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useBulkEntityFieldsAndIndicatorQuery(baseOptions: Apollo.QueryHookOptions<BulkEntityFieldsAndIndicatorQuery, BulkEntityFieldsAndIndicatorQueryVariables> & ({ variables: BulkEntityFieldsAndIndicatorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkEntityFieldsAndIndicatorQuery, BulkEntityFieldsAndIndicatorQueryVariables>(BulkEntityFieldsAndIndicatorDocument, options);
      }
export function useBulkEntityFieldsAndIndicatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkEntityFieldsAndIndicatorQuery, BulkEntityFieldsAndIndicatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkEntityFieldsAndIndicatorQuery, BulkEntityFieldsAndIndicatorQueryVariables>(BulkEntityFieldsAndIndicatorDocument, options);
        }
export function useBulkEntityFieldsAndIndicatorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkEntityFieldsAndIndicatorQuery, BulkEntityFieldsAndIndicatorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BulkEntityFieldsAndIndicatorQuery, BulkEntityFieldsAndIndicatorQueryVariables>(BulkEntityFieldsAndIndicatorDocument, options);
        }
export type BulkEntityFieldsAndIndicatorQueryHookResult = ReturnType<typeof useBulkEntityFieldsAndIndicatorQuery>;
export type BulkEntityFieldsAndIndicatorLazyQueryHookResult = ReturnType<typeof useBulkEntityFieldsAndIndicatorLazyQuery>;
export type BulkEntityFieldsAndIndicatorSuspenseQueryHookResult = ReturnType<typeof useBulkEntityFieldsAndIndicatorSuspenseQuery>;
export type BulkEntityFieldsAndIndicatorQueryResult = Apollo.QueryResult<BulkEntityFieldsAndIndicatorQuery, BulkEntityFieldsAndIndicatorQueryVariables>;
export const RecordSchemaOperationDocument = gql`
    query RecordSchemaOperation {
  recordSchema(recordType: "record")
}
    `;

/**
 * __useRecordSchemaOperationQuery__
 *
 * To run a query within a React component, call `useRecordSchemaOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecordSchemaOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecordSchemaOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecordSchemaOperationQuery(baseOptions?: Apollo.QueryHookOptions<RecordSchemaOperationQuery, RecordSchemaOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecordSchemaOperationQuery, RecordSchemaOperationQueryVariables>(RecordSchemaOperationDocument, options);
      }
export function useRecordSchemaOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecordSchemaOperationQuery, RecordSchemaOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecordSchemaOperationQuery, RecordSchemaOperationQueryVariables>(RecordSchemaOperationDocument, options);
        }
export function useRecordSchemaOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecordSchemaOperationQuery, RecordSchemaOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecordSchemaOperationQuery, RecordSchemaOperationQueryVariables>(RecordSchemaOperationDocument, options);
        }
export type RecordSchemaOperationQueryHookResult = ReturnType<typeof useRecordSchemaOperationQuery>;
export type RecordSchemaOperationLazyQueryHookResult = ReturnType<typeof useRecordSchemaOperationLazyQuery>;
export type RecordSchemaOperationSuspenseQueryHookResult = ReturnType<typeof useRecordSchemaOperationSuspenseQuery>;
export type RecordSchemaOperationQueryResult = Apollo.QueryResult<RecordSchemaOperationQuery, RecordSchemaOperationQueryVariables>;
export const EntityFieldsQueryOperationDocument = gql`
    query EntityFieldsQueryOperation {
  entityFieldsWithTypes {
    field
    type
  }
}
    `;

/**
 * __useEntityFieldsQueryOperation__
 *
 * To run a query within a React component, call `useEntityFieldsQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntityFieldsQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityFieldsQueryOperation({
 *   variables: {
 *   },
 * });
 */
export function useEntityFieldsQueryOperation(baseOptions?: Apollo.QueryHookOptions<EntityFieldsQueryOperationQuery, EntityFieldsQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityFieldsQueryOperationQuery, EntityFieldsQueryOperationQueryVariables>(EntityFieldsQueryOperationDocument, options);
      }
export function useEntityFieldsQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityFieldsQueryOperationQuery, EntityFieldsQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityFieldsQueryOperationQuery, EntityFieldsQueryOperationQueryVariables>(EntityFieldsQueryOperationDocument, options);
        }
export function useEntityFieldsQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityFieldsQueryOperationQuery, EntityFieldsQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityFieldsQueryOperationQuery, EntityFieldsQueryOperationQueryVariables>(EntityFieldsQueryOperationDocument, options);
        }
export type EntityFieldsQueryOperationHookResult = ReturnType<typeof useEntityFieldsQueryOperation>;
export type EntityFieldsQueryOperationLazyQueryHookResult = ReturnType<typeof useEntityFieldsQueryOperationLazyQuery>;
export type EntityFieldsQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntityFieldsQueryOperationSuspenseQuery>;
export type EntityFieldsQueryOperationQueryResult = Apollo.QueryResult<EntityFieldsQueryOperationQuery, EntityFieldsQueryOperationQueryVariables>;
export const PermissionsDocument = gql`
    query Permissions {
  currentUser {
    permissions
  }
}
    `;

/**
 * __usePermissionsQuery__
 *
 * To run a query within a React component, call `usePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePermissionsQuery(baseOptions?: Apollo.QueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
      }
export function usePermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
        }
export function usePermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
        }
export type PermissionsQueryHookResult = ReturnType<typeof usePermissionsQuery>;
export type PermissionsLazyQueryHookResult = ReturnType<typeof usePermissionsLazyQuery>;
export type PermissionsSuspenseQueryHookResult = ReturnType<typeof usePermissionsSuspenseQuery>;
export type PermissionsQueryResult = Apollo.QueryResult<PermissionsQuery, PermissionsQueryVariables>;
export const EntitiesByListIdQueryOperationDocument = gql`
    query EntitiesByListIdQueryOperation($entityIds: [ID!]!) {
  entitiesByListIds(entityIds: $entityIds) {
    id
    entityType
    reputation
    reputationSources
  }
}
    `;

/**
 * __useEntitiesByListIdQueryOperation__
 *
 * To run a query within a React component, call `useEntitiesByListIdQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useEntitiesByListIdQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitiesByListIdQueryOperation({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *   },
 * });
 */
export function useEntitiesByListIdQueryOperation(baseOptions: Apollo.QueryHookOptions<EntitiesByListIdQueryOperationQuery, EntitiesByListIdQueryOperationQueryVariables> & ({ variables: EntitiesByListIdQueryOperationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitiesByListIdQueryOperationQuery, EntitiesByListIdQueryOperationQueryVariables>(EntitiesByListIdQueryOperationDocument, options);
      }
export function useEntitiesByListIdQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitiesByListIdQueryOperationQuery, EntitiesByListIdQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitiesByListIdQueryOperationQuery, EntitiesByListIdQueryOperationQueryVariables>(EntitiesByListIdQueryOperationDocument, options);
        }
export function useEntitiesByListIdQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntitiesByListIdQueryOperationQuery, EntitiesByListIdQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntitiesByListIdQueryOperationQuery, EntitiesByListIdQueryOperationQueryVariables>(EntitiesByListIdQueryOperationDocument, options);
        }
export type EntitiesByListIdQueryOperationHookResult = ReturnType<typeof useEntitiesByListIdQueryOperation>;
export type EntitiesByListIdQueryOperationLazyQueryHookResult = ReturnType<typeof useEntitiesByListIdQueryOperationLazyQuery>;
export type EntitiesByListIdQueryOperationSuspenseQueryHookResult = ReturnType<typeof useEntitiesByListIdQueryOperationSuspenseQuery>;
export type EntitiesByListIdQueryOperationQueryResult = Apollo.QueryResult<EntitiesByListIdQueryOperationQuery, EntitiesByListIdQueryOperationQueryVariables>;
export const LinkRuleTuningExpressionQueryOperationDocument = gql`
    query LinkRuleTuningExpressionQueryOperation($prefix: String) {
  ruleTuningExpressions(prefix: $prefix) {
    objects {
      ...TestRuleTuningExpressionFragment
    }
  }
}
    ${TestRuleTuningExpressionFragmentDoc}`;

/**
 * __useLinkRuleTuningExpressionQueryOperation__
 *
 * To run a query within a React component, call `useLinkRuleTuningExpressionQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useLinkRuleTuningExpressionQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkRuleTuningExpressionQueryOperation({
 *   variables: {
 *      prefix: // value for 'prefix'
 *   },
 * });
 */
export function useLinkRuleTuningExpressionQueryOperation(baseOptions?: Apollo.QueryHookOptions<LinkRuleTuningExpressionQueryOperationQuery, LinkRuleTuningExpressionQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkRuleTuningExpressionQueryOperationQuery, LinkRuleTuningExpressionQueryOperationQueryVariables>(LinkRuleTuningExpressionQueryOperationDocument, options);
      }
export function useLinkRuleTuningExpressionQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkRuleTuningExpressionQueryOperationQuery, LinkRuleTuningExpressionQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkRuleTuningExpressionQueryOperationQuery, LinkRuleTuningExpressionQueryOperationQueryVariables>(LinkRuleTuningExpressionQueryOperationDocument, options);
        }
export function useLinkRuleTuningExpressionQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LinkRuleTuningExpressionQueryOperationQuery, LinkRuleTuningExpressionQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LinkRuleTuningExpressionQueryOperationQuery, LinkRuleTuningExpressionQueryOperationQueryVariables>(LinkRuleTuningExpressionQueryOperationDocument, options);
        }
export type LinkRuleTuningExpressionQueryOperationHookResult = ReturnType<typeof useLinkRuleTuningExpressionQueryOperation>;
export type LinkRuleTuningExpressionQueryOperationLazyQueryHookResult = ReturnType<typeof useLinkRuleTuningExpressionQueryOperationLazyQuery>;
export type LinkRuleTuningExpressionQueryOperationSuspenseQueryHookResult = ReturnType<typeof useLinkRuleTuningExpressionQueryOperationSuspenseQuery>;
export type LinkRuleTuningExpressionQueryOperationQueryResult = Apollo.QueryResult<LinkRuleTuningExpressionQueryOperationQuery, LinkRuleTuningExpressionQueryOperationQueryVariables>;
export const TestRuleTuningExpressionQueryOperationDocument = gql`
    query TestRuleTuningExpressionQueryOperation($q: String) {
  ruleTuningExpressions(q: $q) {
    objects {
      ...TestRuleTuningExpressionFragment
    }
  }
}
    ${TestRuleTuningExpressionFragmentDoc}`;

/**
 * __useTestRuleTuningExpressionQueryOperation__
 *
 * To run a query within a React component, call `useTestRuleTuningExpressionQueryOperation` and pass it any options that fit your needs.
 * When your component renders, `useTestRuleTuningExpressionQueryOperation` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestRuleTuningExpressionQueryOperation({
 *   variables: {
 *      q: // value for 'q'
 *   },
 * });
 */
export function useTestRuleTuningExpressionQueryOperation(baseOptions?: Apollo.QueryHookOptions<TestRuleTuningExpressionQueryOperationQuery, TestRuleTuningExpressionQueryOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestRuleTuningExpressionQueryOperationQuery, TestRuleTuningExpressionQueryOperationQueryVariables>(TestRuleTuningExpressionQueryOperationDocument, options);
      }
export function useTestRuleTuningExpressionQueryOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestRuleTuningExpressionQueryOperationQuery, TestRuleTuningExpressionQueryOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestRuleTuningExpressionQueryOperationQuery, TestRuleTuningExpressionQueryOperationQueryVariables>(TestRuleTuningExpressionQueryOperationDocument, options);
        }
export function useTestRuleTuningExpressionQueryOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TestRuleTuningExpressionQueryOperationQuery, TestRuleTuningExpressionQueryOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TestRuleTuningExpressionQueryOperationQuery, TestRuleTuningExpressionQueryOperationQueryVariables>(TestRuleTuningExpressionQueryOperationDocument, options);
        }
export type TestRuleTuningExpressionQueryOperationHookResult = ReturnType<typeof useTestRuleTuningExpressionQueryOperation>;
export type TestRuleTuningExpressionQueryOperationLazyQueryHookResult = ReturnType<typeof useTestRuleTuningExpressionQueryOperationLazyQuery>;
export type TestRuleTuningExpressionQueryOperationSuspenseQueryHookResult = ReturnType<typeof useTestRuleTuningExpressionQueryOperationSuspenseQuery>;
export type TestRuleTuningExpressionQueryOperationQueryResult = Apollo.QueryResult<TestRuleTuningExpressionQueryOperationQuery, TestRuleTuningExpressionQueryOperationQueryVariables>;
export const CustomMatchListColumnsOperationDocument = gql`
    query CustomMatchListColumnsOperation {
  customMatchListColumns {
    id
    name
    fields
  }
  customMatchListColumnLimit
}
    `;

/**
 * __useCustomMatchListColumnsOperationQuery__
 *
 * To run a query within a React component, call `useCustomMatchListColumnsOperationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomMatchListColumnsOperationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomMatchListColumnsOperationQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomMatchListColumnsOperationQuery(baseOptions?: Apollo.QueryHookOptions<CustomMatchListColumnsOperationQuery, CustomMatchListColumnsOperationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomMatchListColumnsOperationQuery, CustomMatchListColumnsOperationQueryVariables>(CustomMatchListColumnsOperationDocument, options);
      }
export function useCustomMatchListColumnsOperationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomMatchListColumnsOperationQuery, CustomMatchListColumnsOperationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomMatchListColumnsOperationQuery, CustomMatchListColumnsOperationQueryVariables>(CustomMatchListColumnsOperationDocument, options);
        }
export function useCustomMatchListColumnsOperationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CustomMatchListColumnsOperationQuery, CustomMatchListColumnsOperationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CustomMatchListColumnsOperationQuery, CustomMatchListColumnsOperationQueryVariables>(CustomMatchListColumnsOperationDocument, options);
        }
export type CustomMatchListColumnsOperationQueryHookResult = ReturnType<typeof useCustomMatchListColumnsOperationQuery>;
export type CustomMatchListColumnsOperationLazyQueryHookResult = ReturnType<typeof useCustomMatchListColumnsOperationLazyQuery>;
export type CustomMatchListColumnsOperationSuspenseQueryHookResult = ReturnType<typeof useCustomMatchListColumnsOperationSuspenseQuery>;
export type CustomMatchListColumnsOperationQueryResult = Apollo.QueryResult<CustomMatchListColumnsOperationQuery, CustomMatchListColumnsOperationQueryVariables>;

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAppInfoOperationQuery(
 *   ({ query, variables }) => {
 *     const { featureFlagsToLookup, enabledByDefaultFeatureFlags } = variables;
 *     return HttpResponse.json({
 *       data: { currentUser, isFederatedCluster, enabledFeatureFlags, version, sumoLogicRegion, deployment, orgId, orgName, cspCustomReportUrl, sessionTimeoutMinutes }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAppInfoOperationQuery = (resolver: GraphQLResponseResolver<AppInfoOperationQuery, AppInfoOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AppInfoOperationQuery, AppInfoOperationQueryVariables>(
    'AppInfoOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAppInfoOperationSumoQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { currentUserSumo }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAppInfoOperationSumoQuery = (resolver: GraphQLResponseResolver<AppInfoOperationSumoQuery, AppInfoOperationSumoQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AppInfoOperationSumoQuery, AppInfoOperationSumoQueryVariables>(
    'AppInfoOperationSumo',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUsersOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, sort, sortDir, active } = variables;
 *     return HttpResponse.json({
 *       data: { users, mfaEnabled, ssoEnabled }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUsersOperationQuery = (resolver: GraphQLResponseResolver<UsersOperationQuery, UsersOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<UsersOperationQuery, UsersOperationQueryVariables>(
    'UsersOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAllUsersOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { users }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAllUsersOperationQuery = (resolver: GraphQLResponseResolver<AllUsersOperationQuery, AllUsersOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AllUsersOperationQuery, AllUsersOperationQueryVariables>(
    'AllUsersOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAssignedInsightEmailConfigOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { assignedInsightEmailsEnabled }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAssignedInsightEmailConfigOperationQuery = (resolver: GraphQLResponseResolver<AssignedInsightEmailConfigOperationQuery, AssignedInsightEmailConfigOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AssignedInsightEmailConfigOperationQuery, AssignedInsightEmailConfigOperationQueryVariables>(
    'AssignedInsightEmailConfigOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateAssignedInsightEmailsEnabledMutation(
 *   ({ query, variables }) => {
 *     const { enabled } = variables;
 *     return HttpResponse.json({
 *       data: { updateAssignedInsightEmailsEnabled }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateAssignedInsightEmailsEnabledMutation = (resolver: GraphQLResponseResolver<UpdateAssignedInsightEmailsEnabledMutation, UpdateAssignedInsightEmailsEnabledMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateAssignedInsightEmailsEnabledMutation, UpdateAssignedInsightEmailsEnabledMutationVariables>(
    'UpdateAssignedInsightEmailsEnabled',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockActionsOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { actions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockActionsOperationQuery = (resolver: GraphQLResponseResolver<ActionsOperationQuery, ActionsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ActionsOperationQuery, ActionsOperationQueryVariables>(
    'ActionsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateActionOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createAction }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateActionOperationMutation = (resolver: GraphQLResponseResolver<CreateActionOperationMutation, CreateActionOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateActionOperationMutation, CreateActionOperationMutationVariables>(
    'CreateActionOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateActionOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateAction }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateActionOperationMutation = (resolver: GraphQLResponseResolver<UpdateActionOperationMutation, UpdateActionOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateActionOperationMutation, UpdateActionOperationMutationVariables>(
    'UpdateActionOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockActionConfigurationSchemasOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { actionConfigurationSchemas }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockActionConfigurationSchemasOperationQuery = (resolver: GraphQLResponseResolver<ActionConfigurationSchemasOperationQuery, ActionConfigurationSchemasOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ActionConfigurationSchemasOperationQuery, ActionConfigurationSchemasOperationQueryVariables>(
    'ActionConfigurationSchemasOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteActionOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteAction }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteActionOperationMutation = (resolver: GraphQLResponseResolver<DeleteActionOperationMutation, DeleteActionOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteActionOperationMutation, DeleteActionOperationMutationVariables>(
    'DeleteActionOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAutomationQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, sort } = variables;
 *     return HttpResponse.json({
 *       data: { automations }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAutomationQueryOperationQuery = (resolver: GraphQLResponseResolver<AutomationQueryOperationQuery, AutomationQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AutomationQueryOperationQuery, AutomationQueryOperationQueryVariables>(
    'AutomationQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteAutomationOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteAutomation }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteAutomationOperationMutation = (resolver: GraphQLResponseResolver<DeleteAutomationOperationMutation, DeleteAutomationOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteAutomationOperationMutation, DeleteAutomationOperationMutationVariables>(
    'DeleteAutomationOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateAutomationOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createAutomation }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateAutomationOperationMutation = (resolver: GraphQLResponseResolver<CreateAutomationOperationMutation, CreateAutomationOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateAutomationOperationMutation, CreateAutomationOperationMutationVariables>(
    'CreateAutomationOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateAutomationOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateAutomation }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateAutomationOperationMutation = (resolver: GraphQLResponseResolver<UpdateAutomationOperationMutation, UpdateAutomationOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateAutomationOperationMutation, UpdateAutomationOperationMutationVariables>(
    'UpdateAutomationOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAutomationConfigQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit } = variables;
 *     return HttpResponse.json({
 *       data: { automations }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAutomationConfigQueryOperationQuery = (resolver: GraphQLResponseResolver<AutomationConfigQueryOperationQuery, AutomationConfigQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AutomationConfigQueryOperationQuery, AutomationConfigQueryOperationQueryVariables>(
    'AutomationConfigQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteAutomationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteAutomation }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteAutomationMutation = (resolver: GraphQLResponseResolver<DeleteAutomationMutation, DeleteAutomationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteAutomationMutation, DeleteAutomationMutationVariables>(
    'DeleteAutomation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPlaybooksQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { playbooks }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPlaybooksQueryOperationQuery = (resolver: GraphQLResponseResolver<PlaybooksQueryOperationQuery, PlaybooksQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PlaybooksQueryOperationQuery, PlaybooksQueryOperationQueryVariables>(
    'PlaybooksQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateAutomationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateAutomation }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateAutomationMutation = (resolver: GraphQLResponseResolver<UpdateAutomationMutation, UpdateAutomationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateAutomationMutation, UpdateAutomationMutationVariables>(
    'UpdateAutomation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateAutomationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createAutomation }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateAutomationMutation = (resolver: GraphQLResponseResolver<CreateAutomationMutation, CreateAutomationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateAutomationMutation, CreateAutomationMutationVariables>(
    'CreateAutomation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockToggleContextActionOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateContextAction }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockToggleContextActionOperationMutation = (resolver: GraphQLResponseResolver<ToggleContextActionOperationMutation, ToggleContextActionOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ToggleContextActionOperationMutation, ToggleContextActionOperationMutationVariables>(
    'ToggleContextActionOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteContextActionOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteContextAction }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteContextActionOperationMutation = (resolver: GraphQLResponseResolver<DeleteContextActionOperationMutation, DeleteContextActionOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteContextActionOperationMutation, DeleteContextActionOperationMutationVariables>(
    'DeleteContextActionOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContextActionCreateOperationMutation(
 *   ({ query, variables }) => {
 *     const { allRecordFields, entityTypes, name, recordFields, template, iocTypes, type } = variables;
 *     return HttpResponse.json({
 *       data: { createContextAction }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockContextActionCreateOperationMutation = (resolver: GraphQLResponseResolver<ContextActionCreateOperationMutation, ContextActionCreateOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ContextActionCreateOperationMutation, ContextActionCreateOperationMutationVariables>(
    'ContextActionCreateOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContextActionUpdateOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateContextAction }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockContextActionUpdateOperationMutation = (resolver: GraphQLResponseResolver<ContextActionUpdateOperationMutation, ContextActionUpdateOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ContextActionUpdateOperationMutation, ContextActionUpdateOperationMutationVariables>(
    'ContextActionUpdateOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockContextActionsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, sort } = variables;
 *     return HttpResponse.json({
 *       data: { contextActions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockContextActionsQueryOperationQuery = (resolver: GraphQLResponseResolver<ContextActionsQueryOperationQuery, ContextActionsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ContextActionsQueryOperationQuery, ContextActionsQueryOperationQueryVariables>(
    'ContextActionsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEnrichmentOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { virusTotalConfig }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEnrichmentOperationQuery = (resolver: GraphQLResponseResolver<EnrichmentOperationQuery, EnrichmentOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EnrichmentOperationQuery, EnrichmentOperationQueryVariables>(
    'EnrichmentOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateVirusTotalConfigOperationMutation(
 *   ({ query, variables }) => {
 *     const { apiKey, enabled } = variables;
 *     return HttpResponse.json({
 *       data: { updateVirusTotalConfig }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateVirusTotalConfigOperationMutation = (resolver: GraphQLResponseResolver<UpdateVirusTotalConfigOperationMutation, UpdateVirusTotalConfigOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateVirusTotalConfigOperationMutation, UpdateVirusTotalConfigOperationMutationVariables>(
    'UpdateVirusTotalConfigOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateEntityValueConfigurationGroupMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createEntityValueEntityGroupConfiguration }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateEntityValueConfigurationGroupMutation = (resolver: GraphQLResponseResolver<CreateEntityValueConfigurationGroupMutation, CreateEntityValueConfigurationGroupMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateEntityValueConfigurationGroupMutation, CreateEntityValueConfigurationGroupMutationVariables>(
    'CreateEntityValueConfigurationGroup',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateEntityValueConfigurationGroupMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateEntityValueEntityGroupConfiguration }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateEntityValueConfigurationGroupMutation = (resolver: GraphQLResponseResolver<UpdateEntityValueConfigurationGroupMutation, UpdateEntityValueConfigurationGroupMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateEntityValueConfigurationGroupMutation, UpdateEntityValueConfigurationGroupMutationVariables>(
    'UpdateEntityValueConfigurationGroup',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateInventoryConfigurationGroupMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createInventoryEntityGroupConfiguration }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateInventoryConfigurationGroupMutation = (resolver: GraphQLResponseResolver<CreateInventoryConfigurationGroupMutation, CreateInventoryConfigurationGroupMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateInventoryConfigurationGroupMutation, CreateInventoryConfigurationGroupMutationVariables>(
    'CreateInventoryConfigurationGroup',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateInventoryConfigurationGroupMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateInventoryEntityGroupConfiguration }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateInventoryConfigurationGroupMutation = (resolver: GraphQLResponseResolver<UpdateInventoryConfigurationGroupMutation, UpdateInventoryConfigurationGroupMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateInventoryConfigurationGroupMutation, UpdateInventoryConfigurationGroupMutationVariables>(
    'UpdateInventoryConfigurationGroup',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityCriticalityConfigsListQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { entityCriticalityConfigs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityCriticalityConfigsListQuery = (resolver: GraphQLResponseResolver<EntityCriticalityConfigsListQuery, EntityCriticalityConfigsListQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityCriticalityConfigsListQuery, EntityCriticalityConfigsListQueryVariables>(
    'EntityCriticalityConfigsList',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityGroupConfigurationCriticalityListQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { entityGroupConfigurations }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityGroupConfigurationCriticalityListQuery = (resolver: GraphQLResponseResolver<EntityGroupConfigurationCriticalityListQuery, EntityGroupConfigurationCriticalityListQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityGroupConfigurationCriticalityListQuery, EntityGroupConfigurationCriticalityListQueryVariables>(
    'EntityGroupConfigurationCriticalityList',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteEntityCriticalityConfigMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteEntityCriticalityConfig }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteEntityCriticalityConfigMutation = (resolver: GraphQLResponseResolver<DeleteEntityCriticalityConfigMutation, DeleteEntityCriticalityConfigMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteEntityCriticalityConfigMutation, DeleteEntityCriticalityConfigMutationVariables>(
    'DeleteEntityCriticalityConfig',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateEntityCriticalityConfigMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createEntityCriticalityConfig }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateEntityCriticalityConfigMutation = (resolver: GraphQLResponseResolver<CreateEntityCriticalityConfigMutation, CreateEntityCriticalityConfigMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateEntityCriticalityConfigMutation, CreateEntityCriticalityConfigMutationVariables>(
    'CreateEntityCriticalityConfig',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateEntityCriticalityConfigMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateEntityCriticalityConfig }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateEntityCriticalityConfigMutation = (resolver: GraphQLResponseResolver<UpdateEntityCriticalityConfigMutation, UpdateEntityCriticalityConfigMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateEntityCriticalityConfigMutation, UpdateEntityCriticalityConfigMutationVariables>(
    'UpdateEntityCriticalityConfig',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteEntityGroupConfigurationOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteEntityGroupConfiguration }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteEntityGroupConfigurationOperationMutation = (resolver: GraphQLResponseResolver<DeleteEntityGroupConfigurationOperationMutation, DeleteEntityGroupConfigurationOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteEntityGroupConfigurationOperationMutation, DeleteEntityGroupConfigurationOperationMutationVariables>(
    'DeleteEntityGroupConfigurationOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUploadEntityGroupsCsvOperationMutation(
 *   ({ query, variables }) => {
 *     const { file } = variables;
 *     return HttpResponse.json({
 *       data: { uploadEntityGroupsCsv }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUploadEntityGroupsCsvOperationMutation = (resolver: GraphQLResponseResolver<UploadEntityGroupsCsvOperationMutation, UploadEntityGroupsCsvOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UploadEntityGroupsCsvOperationMutation, UploadEntityGroupsCsvOperationMutationVariables>(
    'UploadEntityGroupsCsvOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityGroupConfigurationsOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, sort, sortDir, q } = variables;
 *     return HttpResponse.json({
 *       data: { entityGroupConfigurations }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityGroupConfigurationsOperationQuery = (resolver: GraphQLResponseResolver<EntityGroupConfigurationsOperationQuery, EntityGroupConfigurationsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityGroupConfigurationsOperationQuery, EntityGroupConfigurationsOperationQueryVariables>(
    'EntityGroupConfigurationsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSensorZonesOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { sensorZones }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSensorZonesOperationQuery = (resolver: GraphQLResponseResolver<SensorZonesOperationQuery, SensorZonesOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SensorZonesOperationQuery, SensorZonesOperationQueryVariables>(
    'SensorZonesOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityDomainConfigOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { entityDomainConfiguration }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityDomainConfigOperationQuery = (resolver: GraphQLResponseResolver<EntityDomainConfigOperationQuery, EntityDomainConfigOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityDomainConfigOperationQuery, EntityDomainConfigOperationQueryVariables>(
    'EntityDomainConfigOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateEntityDomainConfigOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateEntityDomainConfiguration }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateEntityDomainConfigOperationMutation = (resolver: GraphQLResponseResolver<UpdateEntityDomainConfigOperationMutation, UpdateEntityDomainConfigOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateEntityDomainConfigOperationMutation, UpdateEntityDomainConfigOperationMutationVariables>(
    'UpdateEntityDomainConfigOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteInventoryEntityLookupTableOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteInventoryEntityLookupTable }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteInventoryEntityLookupTableOperationMutation = (resolver: GraphQLResponseResolver<DeleteInventoryEntityLookupTableOperationMutation, DeleteInventoryEntityLookupTableOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteInventoryEntityLookupTableOperationMutation, DeleteInventoryEntityLookupTableOperationMutationVariables>(
    'DeleteInventoryEntityLookupTableOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteCustomerSourcedEntityLookupTableOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteCustomerSourcedEntityLookupTable }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteCustomerSourcedEntityLookupTableOperationMutation = (resolver: GraphQLResponseResolver<DeleteCustomerSourcedEntityLookupTableOperationMutation, DeleteCustomerSourcedEntityLookupTableOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteCustomerSourcedEntityLookupTableOperationMutation, DeleteCustomerSourcedEntityLookupTableOperationMutationVariables>(
    'DeleteCustomerSourcedEntityLookupTableOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCustomerSourcedEntityLookupTableOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateCustomerSourcedEntityLookupTable }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateCustomerSourcedEntityLookupTableOperationMutation = (resolver: GraphQLResponseResolver<UpdateCustomerSourcedEntityLookupTableOperationMutation, UpdateCustomerSourcedEntityLookupTableOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateCustomerSourcedEntityLookupTableOperationMutation, UpdateCustomerSourcedEntityLookupTableOperationMutationVariables>(
    'UpdateCustomerSourcedEntityLookupTableOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateCustomerSourcedEntityLookupTableOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createCustomerSourcedEntityLookupTable }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateCustomerSourcedEntityLookupTableOperationMutation = (resolver: GraphQLResponseResolver<CreateCustomerSourcedEntityLookupTableOperationMutation, CreateCustomerSourcedEntityLookupTableOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateCustomerSourcedEntityLookupTableOperationMutation, CreateCustomerSourcedEntityLookupTableOperationMutationVariables>(
    'CreateCustomerSourcedEntityLookupTableOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInventoryLookupTablesQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { inventoryLookupTables }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInventoryLookupTablesQueryOperationQuery = (resolver: GraphQLResponseResolver<InventoryLookupTablesQueryOperationQuery, InventoryLookupTablesQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InventoryLookupTablesQueryOperationQuery, InventoryLookupTablesQueryOperationQueryVariables>(
    'InventoryLookupTablesQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCustomerSourcedLookupTablesQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { customerSourcedLookupTables }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCustomerSourcedLookupTablesQueryOperationQuery = (resolver: GraphQLResponseResolver<CustomerSourcedLookupTablesQueryOperationQuery, CustomerSourcedLookupTablesQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CustomerSourcedLookupTablesQueryOperationQuery, CustomerSourcedLookupTablesQueryOperationQueryVariables>(
    'CustomerSourcedLookupTablesQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCustomEntityTypesQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit } = variables;
 *     return HttpResponse.json({
 *       data: { customEntityTypes }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCustomEntityTypesQuery = (resolver: GraphQLResponseResolver<CustomEntityTypesQuery, CustomEntityTypesQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CustomEntityTypesQuery, CustomEntityTypesQueryVariables>(
    'CustomEntityTypes',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteCustomEntityTypeMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteCustomEntityType }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteCustomEntityTypeMutation = (resolver: GraphQLResponseResolver<DeleteCustomEntityTypeMutation, DeleteCustomEntityTypeMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteCustomEntityTypeMutation, DeleteCustomEntityTypeMutationVariables>(
    'DeleteCustomEntityType',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateCustomEntityTypeMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createCustomEntityType }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateCustomEntityTypeMutation = (resolver: GraphQLResponseResolver<CreateCustomEntityTypeMutation, CreateCustomEntityTypeMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateCustomEntityTypeMutation, CreateCustomEntityTypeMutationVariables>(
    'CreateCustomEntityType',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCustomEntityTypeMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateCustomEntityType }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateCustomEntityTypeMutation = (resolver: GraphQLResponseResolver<UpdateCustomEntityTypeMutation, UpdateCustomEntityTypeMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateCustomEntityTypeMutation, UpdateCustomEntityTypeMutationVariables>(
    'UpdateCustomEntityType',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockReservedEntityFieldsOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { entityFields }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockReservedEntityFieldsOperationQuery = (resolver: GraphQLResponseResolver<ReservedEntityFieldsOperationQuery, ReservedEntityFieldsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ReservedEntityFieldsOperationQuery, ReservedEntityFieldsOperationQueryVariables>(
    'ReservedEntityFieldsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateInsightConfigOperationMutation(
 *   ({ query, variables }) => {
 *     const { config } = variables;
 *     return HttpResponse.json({
 *       data: { updateInsightConfig }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateInsightConfigOperationMutation = (resolver: GraphQLResponseResolver<UpdateInsightConfigOperationMutation, UpdateInsightConfigOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateInsightConfigOperationMutation, UpdateInsightConfigOperationMutationVariables>(
    'UpdateInsightConfigOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightResolutionQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { insightResolutions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightResolutionQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightResolutionQueryOperationQuery, InsightResolutionQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightResolutionQueryOperationQuery, InsightResolutionQueryOperationQueryVariables>(
    'InsightResolutionQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteInsightResolutionOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteInsightResolution }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteInsightResolutionOperationMutation = (resolver: GraphQLResponseResolver<DeleteInsightResolutionOperationMutation, DeleteInsightResolutionOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteInsightResolutionOperationMutation, DeleteInsightResolutionOperationMutationVariables>(
    'DeleteInsightResolutionOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateInsightResolutionMutationOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createInsightResolution }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateInsightResolutionMutationOperationMutation = (resolver: GraphQLResponseResolver<CreateInsightResolutionMutationOperationMutation, CreateInsightResolutionMutationOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateInsightResolutionMutationOperationMutation, CreateInsightResolutionMutationOperationMutationVariables>(
    'CreateInsightResolutionMutationOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateInsightResolutionMutationOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateInsightResolution }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateInsightResolutionMutationOperationMutation = (resolver: GraphQLResponseResolver<UpdateInsightResolutionMutationOperationMutation, UpdateInsightResolutionMutationOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateInsightResolutionMutationOperationMutation, UpdateInsightResolutionMutationOperationMutationVariables>(
    'UpdateInsightResolutionMutationOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSingleInsightResolutionQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { insightResolution }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSingleInsightResolutionQueryOperationQuery = (resolver: GraphQLResponseResolver<SingleInsightResolutionQueryOperationQuery, SingleInsightResolutionQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SingleInsightResolutionQueryOperationQuery, SingleInsightResolutionQueryOperationQueryVariables>(
    'SingleInsightResolutionQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateLogMappingOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateLogMapping }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateLogMappingOperationMutation = (resolver: GraphQLResponseResolver<UpdateLogMappingOperationMutation, UpdateLogMappingOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateLogMappingOperationMutation, UpdateLogMappingOperationMutationVariables>(
    'UpdateLogMappingOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLogMappingOptionsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { logMappingOptions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLogMappingOptionsQueryOperationQuery = (resolver: GraphQLResponseResolver<LogMappingOptionsQueryOperationQuery, LogMappingOptionsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LogMappingOptionsQueryOperationQuery, LogMappingOptionsQueryOperationQueryVariables>(
    'LogMappingOptionsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLogMappingFormatOptionsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { logMappingOptions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLogMappingFormatOptionsQueryOperationQuery = (resolver: GraphQLResponseResolver<LogMappingFormatOptionsQueryOperationQuery, LogMappingFormatOptionsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LogMappingFormatOptionsQueryOperationQuery, LogMappingFormatOptionsQueryOperationQueryVariables>(
    'LogMappingFormatOptionsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLogMappingRecordTypeQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { logMappingOptions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLogMappingRecordTypeQueryOperationQuery = (resolver: GraphQLResponseResolver<LogMappingRecordTypeQueryOperationQuery, LogMappingRecordTypeQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LogMappingRecordTypeQueryOperationQuery, LogMappingRecordTypeQueryOperationQueryVariables>(
    'LogMappingRecordTypeQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockParsingPatternOptionsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { logMappingOptions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockParsingPatternOptionsQueryOperationQuery = (resolver: GraphQLResponseResolver<ParsingPatternOptionsQueryOperationQuery, ParsingPatternOptionsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ParsingPatternOptionsQueryOperationQuery, ParsingPatternOptionsQueryOperationQueryVariables>(
    'ParsingPatternOptionsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLogMappingVendorsAndProductsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { logMappingVendorsAndProducts }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLogMappingVendorsAndProductsQueryOperationQuery = (resolver: GraphQLResponseResolver<LogMappingVendorsAndProductsQueryOperationQuery, LogMappingVendorsAndProductsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LogMappingVendorsAndProductsQueryOperationQuery, LogMappingVendorsAndProductsQueryOperationQueryVariables>(
    'LogMappingVendorsAndProductsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateLogMappingOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createLogMapping }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateLogMappingOperationMutation = (resolver: GraphQLResponseResolver<CreateLogMappingOperationMutation, CreateLogMappingOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateLogMappingOperationMutation, CreateLogMappingOperationMutationVariables>(
    'CreateLogMappingOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEnforcedOutputSchemaFieldsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { enforcedOutputSchemaFields }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEnforcedOutputSchemaFieldsQueryOperationQuery = (resolver: GraphQLResponseResolver<EnforcedOutputSchemaFieldsQueryOperationQuery, EnforcedOutputSchemaFieldsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EnforcedOutputSchemaFieldsQueryOperationQuery, EnforcedOutputSchemaFieldsQueryOperationQueryVariables>(
    'EnforcedOutputSchemaFieldsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLogMappingRecordMetricsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { daysBack, timezone } = variables;
 *     return HttpResponse.json({
 *       data: { recordCountsByParsed, recordCountsByVendorAndProduct, signalCountsByVendorAndProduct }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLogMappingRecordMetricsQueryOperationQuery = (resolver: GraphQLResponseResolver<LogMappingRecordMetricsQueryOperationQuery, LogMappingRecordMetricsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LogMappingRecordMetricsQueryOperationQuery, LogMappingRecordMetricsQueryOperationQueryVariables>(
    'LogMappingRecordMetricsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLogMappingsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, sort, sortDir, q } = variables;
 *     return HttpResponse.json({
 *       data: { logMappings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLogMappingsQueryOperationQuery = (resolver: GraphQLResponseResolver<LogMappingsQueryOperationQuery, LogMappingsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LogMappingsQueryOperationQuery, LogMappingsQueryOperationQueryVariables>(
    'LogMappingsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateMappingEnabledOperationMutation(
 *   ({ query, variables }) => {
 *     const { enabled, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateLogMappingEnabled }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateMappingEnabledOperationMutation = (resolver: GraphQLResponseResolver<UpdateMappingEnabledOperationMutation, UpdateMappingEnabledOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateMappingEnabledOperationMutation, UpdateMappingEnabledOperationMutationVariables>(
    'UpdateMappingEnabledOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteLogMappingOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteLogMapping }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteLogMappingOperationMutation = (resolver: GraphQLResponseResolver<DeleteLogMappingOperationMutation, DeleteLogMappingOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteLogMappingOperationMutation, DeleteLogMappingOperationMutationVariables>(
    'DeleteLogMappingOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLogMappingDetailQueryQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { logMapping, logMappingVendorsAndProducts }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLogMappingDetailQueryQuery = (resolver: GraphQLResponseResolver<LogMappingDetailQuery, LogMappingDetailQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LogMappingDetailQuery, LogMappingDetailQueryVariables>(
    'LogMappingDetailQuery',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSumoMappingsOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, sort, sortDir } = variables;
 *     return HttpResponse.json({
 *       data: { sumoMappings }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSumoMappingsOperationQuery = (resolver: GraphQLResponseResolver<SumoMappingsOperationQuery, SumoMappingsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SumoMappingsOperationQuery, SumoMappingsOperationQueryVariables>(
    'SumoMappingsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteSumoMappingOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteSumoMapping }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteSumoMappingOperationMutation = (resolver: GraphQLResponseResolver<DeleteSumoMappingOperationMutation, DeleteSumoMappingOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteSumoMappingOperationMutation, DeleteSumoMappingOperationMutationVariables>(
    'DeleteSumoMappingOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateSumoMappingOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createSumoMapping }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateSumoMappingOperationMutation = (resolver: GraphQLResponseResolver<CreateSumoMappingOperationMutation, CreateSumoMappingOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateSumoMappingOperationMutation, CreateSumoMappingOperationMutationVariables>(
    'CreateSumoMappingOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateSumoMappingOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateSumoMapping }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateSumoMappingOperationMutation = (resolver: GraphQLResponseResolver<UpdateSumoMappingOperationMutation, UpdateSumoMappingOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateSumoMappingOperationMutation, UpdateSumoMappingOperationMutationVariables>(
    'UpdateSumoMappingOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateTagSchemaOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createTagSchema }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateTagSchemaOperationMutation = (resolver: GraphQLResponseResolver<CreateTagSchemaOperationMutation, CreateTagSchemaOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateTagSchemaOperationMutation, CreateTagSchemaOperationMutationVariables>(
    'CreateTagSchemaOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateTagSchemaOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateTagSchema }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateTagSchemaOperationMutation = (resolver: GraphQLResponseResolver<UpdateTagSchemaOperationMutation, UpdateTagSchemaOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateTagSchemaOperationMutation, UpdateTagSchemaOperationMutationVariables>(
    'UpdateTagSchemaOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteTagSchemaOperationMutation(
 *   ({ query, variables }) => {
 *     const { key } = variables;
 *     return HttpResponse.json({
 *       data: { deleteTagSchema }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteTagSchemaOperationMutation = (resolver: GraphQLResponseResolver<DeleteTagSchemaOperationMutation, DeleteTagSchemaOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteTagSchemaOperationMutation, DeleteTagSchemaOperationMutationVariables>(
    'DeleteTagSchemaOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateInsightStatusOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createInsightStatus }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateInsightStatusOperationMutation = (resolver: GraphQLResponseResolver<CreateInsightStatusOperationMutation, CreateInsightStatusOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateInsightStatusOperationMutation, CreateInsightStatusOperationMutationVariables>(
    'CreateInsightStatusOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateInsightStatusWorkflowOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateInsightStatus }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateInsightStatusWorkflowOperationMutation = (resolver: GraphQLResponseResolver<UpdateInsightStatusWorkflowOperationMutation, UpdateInsightStatusWorkflowOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateInsightStatusWorkflowOperationMutation, UpdateInsightStatusWorkflowOperationMutationVariables>(
    'UpdateInsightStatusWorkflowOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightStatusesOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { insightStatuses, insightStatusInProgressEnabled }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightStatusesOperationQuery = (resolver: GraphQLResponseResolver<InsightStatusesOperationQuery, InsightStatusesOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightStatusesOperationQuery, InsightStatusesOperationQueryVariables>(
    'InsightStatusesOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteInsightStatusOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteInsightStatus }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteInsightStatusOperationMutation = (resolver: GraphQLResponseResolver<DeleteInsightStatusOperationMutation, DeleteInsightStatusOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteInsightStatusOperationMutation, DeleteInsightStatusOperationMutationVariables>(
    'DeleteInsightStatusOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockReorderInsightStatusesOperationMutation(
 *   ({ query, variables }) => {
 *     const { orderedIds } = variables;
 *     return HttpResponse.json({
 *       data: { reorderInsightStatuses }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockReorderInsightStatusesOperationMutation = (resolver: GraphQLResponseResolver<ReorderInsightStatusesOperationMutation, ReorderInsightStatusesOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ReorderInsightStatusesOperationMutation, ReorderInsightStatusesOperationMutationVariables>(
    'ReorderInsightStatusesOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateInsightInProgressStatusOperationMutation(
 *   ({ query, variables }) => {
 *     const { enable } = variables;
 *     return HttpResponse.json({
 *       data: { updateInsightStatusInProgressEnabled }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateInsightInProgressStatusOperationMutation = (resolver: GraphQLResponseResolver<UpdateInsightInProgressStatusOperationMutation, UpdateInsightInProgressStatusOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateInsightInProgressStatusOperationMutation, UpdateInsightInProgressStatusOperationMutationVariables>(
    'UpdateInsightInProgressStatusOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCustomInsightsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit } = variables;
 *     return HttpResponse.json({
 *       data: { customInsights }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCustomInsightsQueryOperationQuery = (resolver: GraphQLResponseResolver<CustomInsightsQueryOperationQuery, CustomInsightsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CustomInsightsQueryOperationQuery, CustomInsightsQueryOperationQueryVariables>(
    'CustomInsightsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCustomInsightQueryQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { customInsight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCustomInsightQueryQuery = (resolver: GraphQLResponseResolver<CustomInsightQuery, CustomInsightQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CustomInsightQuery, CustomInsightQueryVariables>(
    'CustomInsightQuery',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateCustomInsightOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createCustomInsight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateCustomInsightOperationMutation = (resolver: GraphQLResponseResolver<CreateCustomInsightOperationMutation, CreateCustomInsightOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateCustomInsightOperationMutation, CreateCustomInsightOperationMutationVariables>(
    'CreateCustomInsightOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCustomInsightOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateCustomInsight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateCustomInsightOperationMutation = (resolver: GraphQLResponseResolver<UpdateCustomInsightOperationMutation, UpdateCustomInsightOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateCustomInsightOperationMutation, UpdateCustomInsightOperationMutationVariables>(
    'UpdateCustomInsightOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCustomInsightEnabledOperationMutation(
 *   ({ query, variables }) => {
 *     const { enabled, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateCustomInsightEnabled }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateCustomInsightEnabledOperationMutation = (resolver: GraphQLResponseResolver<UpdateCustomInsightEnabledOperationMutation, UpdateCustomInsightEnabledOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateCustomInsightEnabledOperationMutation, UpdateCustomInsightEnabledOperationMutationVariables>(
    'UpdateCustomInsightEnabledOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteCustomInsightOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteCustomInsight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteCustomInsightOperationMutation = (resolver: GraphQLResponseResolver<DeleteCustomInsightOperationMutation, DeleteCustomInsightOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteCustomInsightOperationMutation, DeleteCustomInsightOperationMutationVariables>(
    'DeleteCustomInsightOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockYaraRuleEditorOperationQuery(
 *   ({ query, variables }) => {
 *     const { sourceId, ruleId, fetchYaraRule } = variables;
 *     return HttpResponse.json({
 *       data: { yaraSource, yaraRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockYaraRuleEditorOperationQuery = (resolver: GraphQLResponseResolver<YaraRuleEditorOperationQuery, YaraRuleEditorOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<YaraRuleEditorOperationQuery, YaraRuleEditorOperationQueryVariables>(
    'YaraRuleEditorOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockYaraExpressionValidationOperationQuery(
 *   ({ query, variables }) => {
 *     const { expression, runValidation } = variables;
 *     return HttpResponse.json({
 *       data: { validateYaraExpression }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockYaraExpressionValidationOperationQuery = (resolver: GraphQLResponseResolver<YaraExpressionValidationOperationQuery, YaraExpressionValidationOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<YaraExpressionValidationOperationQuery, YaraExpressionValidationOperationQueryVariables>(
    'YaraExpressionValidationOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAddYaraRuleToYaraSourceOperationMutation(
 *   ({ query, variables }) => {
 *     const { yaraSourceId, ruleFields } = variables;
 *     return HttpResponse.json({
 *       data: { addYaraRuleToCustomYaraSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAddYaraRuleToYaraSourceOperationMutation = (resolver: GraphQLResponseResolver<AddYaraRuleToYaraSourceOperationMutation, AddYaraRuleToYaraSourceOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AddYaraRuleToYaraSourceOperationMutation, AddYaraRuleToYaraSourceOperationMutationVariables>(
    'AddYaraRuleToYaraSourceOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateYaraRuleOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateCustomYaraRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateYaraRuleOperationMutation = (resolver: GraphQLResponseResolver<UpdateYaraRuleOperationMutation, UpdateYaraRuleOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateYaraRuleOperationMutation, UpdateYaraRuleOperationMutationVariables>(
    'UpdateYaraRuleOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockYaraRulesSearchOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, sort, sortDir, q } = variables;
 *     return HttpResponse.json({
 *       data: { yaraRules }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockYaraRulesSearchOperationQuery = (resolver: GraphQLResponseResolver<YaraRulesSearchOperationQuery, YaraRulesSearchOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<YaraRulesSearchOperationQuery, YaraRulesSearchOperationQueryVariables>(
    'YaraRulesSearchOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteYaraSourceOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteYaraSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteYaraSourceOperationMutation = (resolver: GraphQLResponseResolver<DeleteYaraSourceOperationMutation, DeleteYaraSourceOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteYaraSourceOperationMutation, DeleteYaraSourceOperationMutationVariables>(
    'DeleteYaraSourceOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockYaraSourceDetailOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { yaraSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockYaraSourceDetailOperationQuery = (resolver: GraphQLResponseResolver<YaraSourceDetailOperationQuery, YaraSourceDetailOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<YaraSourceDetailOperationQuery, YaraSourceDetailOperationQueryVariables>(
    'YaraSourceDetailOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockYaraRulesOperationQuery(
 *   ({ query, variables }) => {
 *     const { sourceIds, offset, limit, sort, sortDir, q } = variables;
 *     return HttpResponse.json({
 *       data: { yaraRules }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockYaraRulesOperationQuery = (resolver: GraphQLResponseResolver<YaraRulesOperationQuery, YaraRulesOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<YaraRulesOperationQuery, YaraRulesOperationQueryVariables>(
    'YaraRulesOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateCustomYaraSourceOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createCustomYaraSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateCustomYaraSourceOperationMutation = (resolver: GraphQLResponseResolver<CreateCustomYaraSourceOperationMutation, CreateCustomYaraSourceOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateCustomYaraSourceOperationMutation, CreateCustomYaraSourceOperationMutationVariables>(
    'CreateCustomYaraSourceOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCustomYaraSourceOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateCustomYaraSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateCustomYaraSourceOperationMutation = (resolver: GraphQLResponseResolver<UpdateCustomYaraSourceOperationMutation, UpdateCustomYaraSourceOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateCustomYaraSourceOperationMutation, UpdateCustomYaraSourceOperationMutationVariables>(
    'UpdateCustomYaraSourceOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateGithubYaraSourceOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createGithubYaraSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateGithubYaraSourceOperationMutation = (resolver: GraphQLResponseResolver<CreateGithubYaraSourceOperationMutation, CreateGithubYaraSourceOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateGithubYaraSourceOperationMutation, CreateGithubYaraSourceOperationMutationVariables>(
    'CreateGithubYaraSourceOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateGithubYaraSourceOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateGithubYaraSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateGithubYaraSourceOperationMutation = (resolver: GraphQLResponseResolver<UpdateGithubYaraSourceOperationMutation, UpdateGithubYaraSourceOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateGithubYaraSourceOperationMutation, UpdateGithubYaraSourceOperationMutationVariables>(
    'UpdateGithubYaraSourceOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockYaraSourceEditorOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { yaraSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockYaraSourceEditorOperationQuery = (resolver: GraphQLResponseResolver<YaraSourceEditorOperationQuery, YaraSourceEditorOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<YaraSourceEditorOperationQuery, YaraSourceEditorOperationQueryVariables>(
    'YaraSourceEditorOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockYaraSourcesOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, sort, sortDir } = variables;
 *     return HttpResponse.json({
 *       data: { yaraSources }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockYaraSourcesOperationQuery = (resolver: GraphQLResponseResolver<YaraSourcesOperationQuery, YaraSourcesOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<YaraSourcesOperationQuery, YaraSourcesOperationQueryVariables>(
    'YaraSourcesOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteYaraRuleOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteCustomYaraRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteYaraRuleOperationMutation = (resolver: GraphQLResponseResolver<DeleteYaraRuleOperationMutation, DeleteYaraRuleOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteYaraRuleOperationMutation, DeleteYaraRuleOperationMutationVariables>(
    'DeleteYaraRuleOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteCustomMatchListColumnOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteCustomMatchListColumn }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteCustomMatchListColumnOperationMutation = (resolver: GraphQLResponseResolver<DeleteCustomMatchListColumnOperationMutation, DeleteCustomMatchListColumnOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteCustomMatchListColumnOperationMutation, DeleteCustomMatchListColumnOperationMutationVariables>(
    'DeleteCustomMatchListColumnOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateCustomMatchListColumnOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createCustomMatchListColumn }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateCustomMatchListColumnOperationMutation = (resolver: GraphQLResponseResolver<CreateCustomMatchListColumnOperationMutation, CreateCustomMatchListColumnOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateCustomMatchListColumnOperationMutation, CreateCustomMatchListColumnOperationMutationVariables>(
    'CreateCustomMatchListColumnOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCustomMatchListColumnOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateCustomMatchListColumn }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateCustomMatchListColumnOperationMutation = (resolver: GraphQLResponseResolver<UpdateCustomMatchListColumnOperationMutation, UpdateCustomMatchListColumnOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateCustomMatchListColumnOperationMutation, UpdateCustomMatchListColumnOperationMutationVariables>(
    'UpdateCustomMatchListColumnOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUploadItemsToListOperationMutation(
 *   ({ query, variables }) => {
 *     const { listId, expiration, file } = variables;
 *     return HttpResponse.json({
 *       data: { uploadItemsToList }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUploadItemsToListOperationMutation = (resolver: GraphQLResponseResolver<UploadItemsToListOperationMutation, UploadItemsToListOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UploadItemsToListOperationMutation, UploadItemsToListOperationMutationVariables>(
    'UploadItemsToListOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMatchListsOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, sort, sortDir } = variables;
 *     return HttpResponse.json({
 *       data: { matchLists, matchListItemLimit, matchListItemCount }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMatchListsOperationQuery = (resolver: GraphQLResponseResolver<MatchListsOperationQuery, MatchListsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MatchListsOperationQuery, MatchListsOperationQueryVariables>(
    'MatchListsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteMatchListOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteMatchList }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteMatchListOperationMutation = (resolver: GraphQLResponseResolver<DeleteMatchListOperationMutation, DeleteMatchListOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteMatchListOperationMutation, DeleteMatchListOperationMutationVariables>(
    'DeleteMatchListOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateMatchListOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createMatchList }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateMatchListOperationMutation = (resolver: GraphQLResponseResolver<CreateMatchListOperationMutation, CreateMatchListOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateMatchListOperationMutation, CreateMatchListOperationMutationVariables>(
    'CreateMatchListOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateMatchListOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateMatchList }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateMatchListOperationMutation = (resolver: GraphQLResponseResolver<UpdateMatchListOperationMutation, UpdateMatchListOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateMatchListOperationMutation, UpdateMatchListOperationMutationVariables>(
    'UpdateMatchListOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAddMatchListItemOperationMutation(
 *   ({ query, variables }) => {
 *     const { itemFields, listId } = variables;
 *     return HttpResponse.json({
 *       data: { addItemToMatchList }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAddMatchListItemOperationMutation = (resolver: GraphQLResponseResolver<AddMatchListItemOperationMutation, AddMatchListItemOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AddMatchListItemOperationMutation, AddMatchListItemOperationMutationVariables>(
    'AddMatchListItemOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateMatchListItemOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateMatchListItem }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateMatchListItemOperationMutation = (resolver: GraphQLResponseResolver<UpdateMatchListItemOperationMutation, UpdateMatchListItemOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateMatchListItemOperationMutation, UpdateMatchListItemOperationMutationVariables>(
    'UpdateMatchListItemOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteMatchListItemOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteMatchListItem }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteMatchListItemOperationMutation = (resolver: GraphQLResponseResolver<DeleteMatchListItemOperationMutation, DeleteMatchListItemOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteMatchListItemOperationMutation, DeleteMatchListItemOperationMutationVariables>(
    'DeleteMatchListItemOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMatchListItemsOperationQuery(
 *   ({ query, variables }) => {
 *     const { listIds, offset, limit, sort, sortDir, q } = variables;
 *     return HttpResponse.json({
 *       data: { matchListItems2 }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMatchListItemsOperationQuery = (resolver: GraphQLResponseResolver<MatchListItemsOperationQuery, MatchListItemsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MatchListItemsOperationQuery, MatchListItemsOperationQueryVariables>(
    'MatchListItemsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMatchListDetailOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { matchList }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMatchListDetailOperationQuery = (resolver: GraphQLResponseResolver<MatchListDetailOperationQuery, MatchListDetailOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MatchListDetailOperationQuery, MatchListDetailOperationQueryVariables>(
    'MatchListDetailOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMatchListsSelectOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, sort, sortDir } = variables;
 *     return HttpResponse.json({
 *       data: { matchLists }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMatchListsSelectOperationQuery = (resolver: GraphQLResponseResolver<MatchListsSelectOperationQuery, MatchListsSelectOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MatchListsSelectOperationQuery, MatchListsSelectOperationQueryVariables>(
    'MatchListsSelectOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockNetworkBlocksOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, sort, sortDir, q } = variables;
 *     return HttpResponse.json({
 *       data: { networkBlocks }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockNetworkBlocksOperationQuery = (resolver: GraphQLResponseResolver<NetworkBlocksOperationQuery, NetworkBlocksOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<NetworkBlocksOperationQuery, NetworkBlocksOperationQueryVariables>(
    'NetworkBlocksOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateNetworkBlockOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createNetworkBlock }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateNetworkBlockOperationMutation = (resolver: GraphQLResponseResolver<CreateNetworkBlockOperationMutation, CreateNetworkBlockOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateNetworkBlockOperationMutation, CreateNetworkBlockOperationMutationVariables>(
    'CreateNetworkBlockOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateNetworkBlockOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateNetworkBlock }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateNetworkBlockOperationMutation = (resolver: GraphQLResponseResolver<UpdateNetworkBlockOperationMutation, UpdateNetworkBlockOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateNetworkBlockOperationMutation, UpdateNetworkBlockOperationMutationVariables>(
    'UpdateNetworkBlockOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteNetworkBlockOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteNetworkBlock }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteNetworkBlockOperationMutation = (resolver: GraphQLResponseResolver<DeleteNetworkBlockOperationMutation, DeleteNetworkBlockOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteNetworkBlockOperationMutation, DeleteNetworkBlockOperationMutationVariables>(
    'DeleteNetworkBlockOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUploadNetworkBlocksOperationMutation(
 *   ({ query, variables }) => {
 *     const { file } = variables;
 *     return HttpResponse.json({
 *       data: { uploadNetworkBlocksCsv }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUploadNetworkBlocksOperationMutation = (resolver: GraphQLResponseResolver<UploadNetworkBlocksOperationMutation, UploadNetworkBlocksOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UploadNetworkBlocksOperationMutation, UploadNetworkBlocksOperationMutationVariables>(
    'UploadNetworkBlocksOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRuleTuningExpressionsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, sort, sortDir } = variables;
 *     return HttpResponse.json({
 *       data: { ruleTuningExpressions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRuleTuningExpressionsQueryOperationQuery = (resolver: GraphQLResponseResolver<RuleTuningExpressionsQueryOperationQuery, RuleTuningExpressionsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RuleTuningExpressionsQueryOperationQuery, RuleTuningExpressionsQueryOperationQueryVariables>(
    'RuleTuningExpressionsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRuleTuningExpressionQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { ruleTuningExpression }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRuleTuningExpressionQueryOperationQuery = (resolver: GraphQLResponseResolver<RuleTuningExpressionQueryOperationQuery, RuleTuningExpressionQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RuleTuningExpressionQueryOperationQuery, RuleTuningExpressionQueryOperationQueryVariables>(
    'RuleTuningExpressionQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateRuleTuningExpressionOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createRuleTuningExpression }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateRuleTuningExpressionOperationMutation = (resolver: GraphQLResponseResolver<CreateRuleTuningExpressionOperationMutation, CreateRuleTuningExpressionOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateRuleTuningExpressionOperationMutation, CreateRuleTuningExpressionOperationMutationVariables>(
    'CreateRuleTuningExpressionOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateRuleTuningExpressionOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateRuleTuningExpression }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateRuleTuningExpressionOperationMutation = (resolver: GraphQLResponseResolver<UpdateRuleTuningExpressionOperationMutation, UpdateRuleTuningExpressionOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateRuleTuningExpressionOperationMutation, UpdateRuleTuningExpressionOperationMutationVariables>(
    'UpdateRuleTuningExpressionOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateRuleTuningExpressionEnabledOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, enabled } = variables;
 *     return HttpResponse.json({
 *       data: { updateRuleTuningExpressionEnabled }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateRuleTuningExpressionEnabledOperationMutation = (resolver: GraphQLResponseResolver<UpdateRuleTuningExpressionEnabledOperationMutation, UpdateRuleTuningExpressionEnabledOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateRuleTuningExpressionEnabledOperationMutation, UpdateRuleTuningExpressionEnabledOperationMutationVariables>(
    'UpdateRuleTuningExpressionEnabledOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteRuleTuningExpressionOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteRuleTuningExpression }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteRuleTuningExpressionOperationMutation = (resolver: GraphQLResponseResolver<DeleteRuleTuningExpressionOperationMutation, DeleteRuleTuningExpressionOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteRuleTuningExpressionOperationMutation, DeleteRuleTuningExpressionOperationMutationVariables>(
    'DeleteRuleTuningExpressionOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteRuleOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteRuleOperationMutation = (resolver: GraphQLResponseResolver<DeleteRuleOperationMutation, DeleteRuleOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteRuleOperationMutation, DeleteRuleOperationMutationVariables>(
    'DeleteRuleOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRuleTranslationOperationQuery(
 *   ({ query, variables }) => {
 *     const { ruleExpression, ruleTuningTranslationExpressions } = variables;
 *     return HttpResponse.json({
 *       data: { ruleTranslation }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRuleTranslationOperationQuery = (resolver: GraphQLResponseResolver<RuleTranslationOperationQuery, RuleTranslationOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RuleTranslationOperationQuery, RuleTranslationOperationQueryVariables>(
    'RuleTranslationOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRuleRecordSchemaOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { recordSchema }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRuleRecordSchemaOperationQuery = (resolver: GraphQLResponseResolver<RuleRecordSchemaOperationQuery, RuleRecordSchemaOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RuleRecordSchemaOperationQuery, RuleRecordSchemaOperationQueryVariables>(
    'RuleRecordSchemaOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRuleExportOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { rule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRuleExportOperationQuery = (resolver: GraphQLResponseResolver<RuleExportOperationQuery, RuleExportOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RuleExportOperationQuery, RuleExportOperationQueryVariables>(
    'RuleExportOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockImportRulesMutationMutation(
 *   ({ query, variables }) => {
 *     const { file } = variables;
 *     return HttpResponse.json({
 *       data: { importRules }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockImportRulesMutationMutation = (resolver: GraphQLResponseResolver<ImportRulesMutation, ImportRulesMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ImportRulesMutation, ImportRulesMutationVariables>(
    'ImportRulesMutation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAggregationRuleFunctionsOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { aggregationRuleFunctions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAggregationRuleFunctionsOperationQuery = (resolver: GraphQLResponseResolver<AggregationRuleFunctionsOperationQuery, AggregationRuleFunctionsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AggregationRuleFunctionsOperationQuery, AggregationRuleFunctionsOperationQueryVariables>(
    'AggregationRuleFunctionsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRuleBuilderQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { rule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRuleBuilderQueryOperationQuery = (resolver: GraphQLResponseResolver<RuleBuilderQueryOperationQuery, RuleBuilderQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RuleBuilderQueryOperationQuery, RuleBuilderQueryOperationQueryVariables>(
    'RuleBuilderQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateBuiltInRuleOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateBuiltInRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateBuiltInRuleOperationMutation = (resolver: GraphQLResponseResolver<UpdateBuiltInRuleOperationMutation, UpdateBuiltInRuleOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateBuiltInRuleOperationMutation, UpdateBuiltInRuleOperationMutationVariables>(
    'UpdateBuiltInRuleOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockOverrideBuiltInTemplatedMatchRuleOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { overrideTemplatedMatchRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockOverrideBuiltInTemplatedMatchRuleOperationMutation = (resolver: GraphQLResponseResolver<OverrideBuiltInTemplatedMatchRuleOperationMutation, OverrideBuiltInTemplatedMatchRuleOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<OverrideBuiltInTemplatedMatchRuleOperationMutation, OverrideBuiltInTemplatedMatchRuleOperationMutationVariables>(
    'OverrideBuiltInTemplatedMatchRuleOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockOverrideBuiltInThresholdRuleOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { overrideThresholdRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockOverrideBuiltInThresholdRuleOperationMutation = (resolver: GraphQLResponseResolver<OverrideBuiltInThresholdRuleOperationMutation, OverrideBuiltInThresholdRuleOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<OverrideBuiltInThresholdRuleOperationMutation, OverrideBuiltInThresholdRuleOperationMutationVariables>(
    'OverrideBuiltInThresholdRuleOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockOverrideBuiltInAggregationRuleOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { overrideAggregationRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockOverrideBuiltInAggregationRuleOperationMutation = (resolver: GraphQLResponseResolver<OverrideBuiltInAggregationRuleOperationMutation, OverrideBuiltInAggregationRuleOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<OverrideBuiltInAggregationRuleOperationMutation, OverrideBuiltInAggregationRuleOperationMutationVariables>(
    'OverrideBuiltInAggregationRuleOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockOverrideBuiltInChainRuleOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { overrideChainRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockOverrideBuiltInChainRuleOperationMutation = (resolver: GraphQLResponseResolver<OverrideBuiltInChainRuleOperationMutation, OverrideBuiltInChainRuleOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<OverrideBuiltInChainRuleOperationMutation, OverrideBuiltInChainRuleOperationMutationVariables>(
    'OverrideBuiltInChainRuleOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockOverrideBuiltInFirstSeenRuleOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { overrideFirstSeenRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockOverrideBuiltInFirstSeenRuleOperationMutation = (resolver: GraphQLResponseResolver<OverrideBuiltInFirstSeenRuleOperationMutation, OverrideBuiltInFirstSeenRuleOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<OverrideBuiltInFirstSeenRuleOperationMutation, OverrideBuiltInFirstSeenRuleOperationMutationVariables>(
    'OverrideBuiltInFirstSeenRuleOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockOverrideBuiltInOutlierRuleOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { overrideOutlierRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockOverrideBuiltInOutlierRuleOperationMutation = (resolver: GraphQLResponseResolver<OverrideBuiltInOutlierRuleOperationMutation, OverrideBuiltInOutlierRuleOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<OverrideBuiltInOutlierRuleOperationMutation, OverrideBuiltInOutlierRuleOperationMutationVariables>(
    'OverrideBuiltInOutlierRuleOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRuleSignalCountOperationQuery(
 *   ({ query, variables }) => {
 *     const { bucketDuration, end, ruleId, start, timezone } = variables;
 *     return HttpResponse.json({
 *       data: { signalCounts }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRuleSignalCountOperationQuery = (resolver: GraphQLResponseResolver<RuleSignalCountOperationQuery, RuleSignalCountOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RuleSignalCountOperationQuery, RuleSignalCountOperationQueryVariables>(
    'RuleSignalCountOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRuleBuilderLastSignalQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { q } = variables;
 *     return HttpResponse.json({
 *       data: { signals }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRuleBuilderLastSignalQueryOperationQuery = (resolver: GraphQLResponseResolver<RuleBuilderLastSignalQueryOperationQuery, RuleBuilderLastSignalQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RuleBuilderLastSignalQueryOperationQuery, RuleBuilderLastSignalQueryOperationQueryVariables>(
    'RuleBuilderLastSignalQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockMatchRuleValidationResultOperationQuery(
 *   ({ query, variables }) => {
 *     const { ruleFields } = variables;
 *     return HttpResponse.json({
 *       data: { matchRuleValidationResult }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockMatchRuleValidationResultOperationQuery = (resolver: GraphQLResponseResolver<MatchRuleValidationResultOperationQuery, MatchRuleValidationResultOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<MatchRuleValidationResultOperationQuery, MatchRuleValidationResultOperationQueryVariables>(
    'MatchRuleValidationResultOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockThresholdRuleValidationResultOperationQuery(
 *   ({ query, variables }) => {
 *     const { ruleFields } = variables;
 *     return HttpResponse.json({
 *       data: { thresholdRuleValidationResult }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockThresholdRuleValidationResultOperationQuery = (resolver: GraphQLResponseResolver<ThresholdRuleValidationResultOperationQuery, ThresholdRuleValidationResultOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ThresholdRuleValidationResultOperationQuery, ThresholdRuleValidationResultOperationQueryVariables>(
    'ThresholdRuleValidationResultOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockChainRuleValidationResultOperationQuery(
 *   ({ query, variables }) => {
 *     const { ruleFields } = variables;
 *     return HttpResponse.json({
 *       data: { chainRuleValidationResult }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockChainRuleValidationResultOperationQuery = (resolver: GraphQLResponseResolver<ChainRuleValidationResultOperationQuery, ChainRuleValidationResultOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ChainRuleValidationResultOperationQuery, ChainRuleValidationResultOperationQueryVariables>(
    'ChainRuleValidationResultOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAggregationRuleValidationResultOperationQuery(
 *   ({ query, variables }) => {
 *     const { ruleFields } = variables;
 *     return HttpResponse.json({
 *       data: { aggregationRuleValidationResult }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAggregationRuleValidationResultOperationQuery = (resolver: GraphQLResponseResolver<AggregationRuleValidationResultOperationQuery, AggregationRuleValidationResultOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AggregationRuleValidationResultOperationQuery, AggregationRuleValidationResultOperationQueryVariables>(
    'AggregationRuleValidationResultOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTemplatedMatchRuleValidationResultOperationQuery(
 *   ({ query, variables }) => {
 *     const { ruleFields } = variables;
 *     return HttpResponse.json({
 *       data: { templatedMatchRuleValidationResult }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTemplatedMatchRuleValidationResultOperationQuery = (resolver: GraphQLResponseResolver<TemplatedMatchRuleValidationResultOperationQuery, TemplatedMatchRuleValidationResultOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TemplatedMatchRuleValidationResultOperationQuery, TemplatedMatchRuleValidationResultOperationQueryVariables>(
    'TemplatedMatchRuleValidationResultOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateThresholdRuleBuilderOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createThresholdRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateThresholdRuleBuilderOperationMutation = (resolver: GraphQLResponseResolver<CreateThresholdRuleBuilderOperationMutation, CreateThresholdRuleBuilderOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateThresholdRuleBuilderOperationMutation, CreateThresholdRuleBuilderOperationMutationVariables>(
    'CreateThresholdRuleBuilderOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateThresholdRuleBuilderOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateThresholdRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateThresholdRuleBuilderOperationMutation = (resolver: GraphQLResponseResolver<UpdateThresholdRuleBuilderOperationMutation, UpdateThresholdRuleBuilderOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateThresholdRuleBuilderOperationMutation, UpdateThresholdRuleBuilderOperationMutationVariables>(
    'UpdateThresholdRuleBuilderOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateAggregationRuleBuilderOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createAggregationRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateAggregationRuleBuilderOperationMutation = (resolver: GraphQLResponseResolver<CreateAggregationRuleBuilderOperationMutation, CreateAggregationRuleBuilderOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateAggregationRuleBuilderOperationMutation, CreateAggregationRuleBuilderOperationMutationVariables>(
    'CreateAggregationRuleBuilderOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateAggregationRuleBuilderOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateAggregationRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateAggregationRuleBuilderOperationMutation = (resolver: GraphQLResponseResolver<UpdateAggregationRuleBuilderOperationMutation, UpdateAggregationRuleBuilderOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateAggregationRuleBuilderOperationMutation, UpdateAggregationRuleBuilderOperationMutationVariables>(
    'UpdateAggregationRuleBuilderOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateChainRuleBuilderOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createChainRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateChainRuleBuilderOperationMutation = (resolver: GraphQLResponseResolver<CreateChainRuleBuilderOperationMutation, CreateChainRuleBuilderOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateChainRuleBuilderOperationMutation, CreateChainRuleBuilderOperationMutationVariables>(
    'CreateChainRuleBuilderOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateChainRuleBuilderOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateChainRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateChainRuleBuilderOperationMutation = (resolver: GraphQLResponseResolver<UpdateChainRuleBuilderOperationMutation, UpdateChainRuleBuilderOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateChainRuleBuilderOperationMutation, UpdateChainRuleBuilderOperationMutationVariables>(
    'UpdateChainRuleBuilderOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateFirstSeenRuleBuilderOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createFirstSeenRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateFirstSeenRuleBuilderOperationMutation = (resolver: GraphQLResponseResolver<CreateFirstSeenRuleBuilderOperationMutation, CreateFirstSeenRuleBuilderOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateFirstSeenRuleBuilderOperationMutation, CreateFirstSeenRuleBuilderOperationMutationVariables>(
    'CreateFirstSeenRuleBuilderOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateFirstSeenRuleBuilderOperationMutation(
 *   ({ query, variables }) => {
 *     const { includeSuppressionWindowSize, fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateFirstSeenRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateFirstSeenRuleBuilderOperationMutation = (resolver: GraphQLResponseResolver<UpdateFirstSeenRuleBuilderOperationMutation, UpdateFirstSeenRuleBuilderOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateFirstSeenRuleBuilderOperationMutation, UpdateFirstSeenRuleBuilderOperationMutationVariables>(
    'UpdateFirstSeenRuleBuilderOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateTemplatedMatchRuleBuilderOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createTemplatedMatchRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateTemplatedMatchRuleBuilderOperationMutation = (resolver: GraphQLResponseResolver<CreateTemplatedMatchRuleBuilderOperationMutation, CreateTemplatedMatchRuleBuilderOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateTemplatedMatchRuleBuilderOperationMutation, CreateTemplatedMatchRuleBuilderOperationMutationVariables>(
    'CreateTemplatedMatchRuleBuilderOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateTemplatedMatchRuleBuilderOperationMutation(
 *   ({ query, variables }) => {
 *     const { includeSuppressionWindowSize, fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateTemplatedMatchRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateTemplatedMatchRuleBuilderOperationMutation = (resolver: GraphQLResponseResolver<UpdateTemplatedMatchRuleBuilderOperationMutation, UpdateTemplatedMatchRuleBuilderOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateTemplatedMatchRuleBuilderOperationMutation, UpdateTemplatedMatchRuleBuilderOperationMutationVariables>(
    'UpdateTemplatedMatchRuleBuilderOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateMatchRuleBuilderOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateMatchRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateMatchRuleBuilderOperationMutation = (resolver: GraphQLResponseResolver<UpdateMatchRuleBuilderOperationMutation, UpdateMatchRuleBuilderOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateMatchRuleBuilderOperationMutation, UpdateMatchRuleBuilderOperationMutationVariables>(
    'UpdateMatchRuleBuilderOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateOutlierRuleBuilderOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createOutlierRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateOutlierRuleBuilderOperationMutation = (resolver: GraphQLResponseResolver<CreateOutlierRuleBuilderOperationMutation, CreateOutlierRuleBuilderOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateOutlierRuleBuilderOperationMutation, CreateOutlierRuleBuilderOperationMutationVariables>(
    'CreateOutlierRuleBuilderOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateOutlierRuleBuilderOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateOutlierRule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateOutlierRuleBuilderOperationMutation = (resolver: GraphQLResponseResolver<UpdateOutlierRuleBuilderOperationMutation, UpdateOutlierRuleBuilderOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateOutlierRuleBuilderOperationMutation, UpdateOutlierRuleBuilderOperationMutationVariables>(
    'UpdateOutlierRuleBuilderOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateRuleEnabledOperationMutation(
 *   ({ query, variables }) => {
 *     const { enabled, id, duplicated } = variables;
 *     return HttpResponse.json({
 *       data: { updateRuleEnabled }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateRuleEnabledOperationMutation = (resolver: GraphQLResponseResolver<UpdateRuleEnabledOperationMutation, UpdateRuleEnabledOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateRuleEnabledOperationMutation, UpdateRuleEnabledOperationMutationVariables>(
    'UpdateRuleEnabledOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRulesListQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { q, offset, limit, sort, sortDir } = variables;
 *     return HttpResponse.json({
 *       data: { rules }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRulesListQueryOperationQuery = (resolver: GraphQLResponseResolver<RulesListQueryOperationQuery, RulesListQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RulesListQueryOperationQuery, RulesListQueryOperationQueryVariables>(
    'RulesListQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUploadListItemsToListOperationMutation(
 *   ({ query, variables }) => {
 *     const { listId, expiration, file } = variables;
 *     return HttpResponse.json({
 *       data: { uploadItemsToList }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUploadListItemsToListOperationMutation = (resolver: GraphQLResponseResolver<UploadListItemsToListOperationMutation, UploadListItemsToListOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UploadListItemsToListOperationMutation, UploadListItemsToListOperationMutationVariables>(
    'UploadListItemsToListOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuppressedListOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { suppressList }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuppressedListOperationQuery = (resolver: GraphQLResponseResolver<SuppressedListOperationQuery, SuppressedListOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuppressedListOperationQuery, SuppressedListOperationQueryVariables>(
    'SuppressedListOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuppressedListItemsOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, listIds, q, sort, sortDir } = variables;
 *     return HttpResponse.json({
 *       data: { suppressListItems }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuppressedListItemsOperationQuery = (resolver: GraphQLResponseResolver<SuppressedListItemsOperationQuery, SuppressedListItemsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuppressedListItemsOperationQuery, SuppressedListItemsOperationQueryVariables>(
    'SuppressedListItemsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuppressedListsOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, sort, sortDir } = variables;
 *     return HttpResponse.json({
 *       data: { suppressLists, suppressListItemLimit, suppressListItemCount }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuppressedListsOperationQuery = (resolver: GraphQLResponseResolver<SuppressedListsOperationQuery, SuppressedListsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuppressedListsOperationQuery, SuppressedListsOperationQueryVariables>(
    'SuppressedListsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteSuppressedListItemOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteSuppressListItem }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteSuppressedListItemOperationMutation = (resolver: GraphQLResponseResolver<DeleteSuppressedListItemOperationMutation, DeleteSuppressedListItemOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteSuppressedListItemOperationMutation, DeleteSuppressedListItemOperationMutationVariables>(
    'DeleteSuppressedListItemOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAddItemToSuppressedListOperationMutation(
 *   ({ query, variables }) => {
 *     const { listId, itemFields } = variables;
 *     return HttpResponse.json({
 *       data: { addItemToSuppressList }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAddItemToSuppressedListOperationMutation = (resolver: GraphQLResponseResolver<AddItemToSuppressedListOperationMutation, AddItemToSuppressedListOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AddItemToSuppressedListOperationMutation, AddItemToSuppressedListOperationMutationVariables>(
    'AddItemToSuppressedListOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateSuppressedListItemOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateSuppressListItem }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateSuppressedListItemOperationMutation = (resolver: GraphQLResponseResolver<UpdateSuppressedListItemOperationMutation, UpdateSuppressedListItemOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateSuppressedListItemOperationMutation, UpdateSuppressedListItemOperationMutationVariables>(
    'UpdateSuppressedListItemOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteSuppressedListOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteSuppressList }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteSuppressedListOperationMutation = (resolver: GraphQLResponseResolver<DeleteSuppressedListOperationMutation, DeleteSuppressedListOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteSuppressedListOperationMutation, DeleteSuppressedListOperationMutationVariables>(
    'DeleteSuppressedListOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateSuppressedListOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createSuppressList }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateSuppressedListOperationMutation = (resolver: GraphQLResponseResolver<CreateSuppressedListOperationMutation, CreateSuppressedListOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateSuppressedListOperationMutation, CreateSuppressedListOperationMutationVariables>(
    'CreateSuppressedListOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateSuppressedListOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id } = variables;
 *     return HttpResponse.json({
 *       data: { updateSuppressList }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateSuppressedListOperationMutation = (resolver: GraphQLResponseResolver<UpdateSuppressedListOperationMutation, UpdateSuppressedListOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateSuppressedListOperationMutation, UpdateSuppressedListOperationMutationVariables>(
    'UpdateSuppressedListOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuppressedListSelectOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, sort, sortDir } = variables;
 *     return HttpResponse.json({
 *       data: { suppressLists }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuppressedListSelectOperationQuery = (resolver: GraphQLResponseResolver<SuppressedListSelectOperationQuery, SuppressedListSelectOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuppressedListSelectOperationQuery, SuppressedListSelectOperationQueryVariables>(
    'SuppressedListSelectOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockThreatIntelItemEditorOperationQuery(
 *   ({ query, variables }) => {
 *     const { itemId, fetchItem } = variables;
 *     return HttpResponse.json({
 *       data: { threatIntelItem }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockThreatIntelItemEditorOperationQuery = (resolver: GraphQLResponseResolver<ThreatIntelItemEditorOperationQuery, ThreatIntelItemEditorOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ThreatIntelItemEditorOperationQuery, ThreatIntelItemEditorOperationQueryVariables>(
    'ThreatIntelItemEditorOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAddItemToThreatIntelSourceOperationMutation(
 *   ({ query, variables }) => {
 *     const { threatIntelSourceId, itemFields } = variables;
 *     return HttpResponse.json({
 *       data: { addItemToThreatIntelSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAddItemToThreatIntelSourceOperationMutation = (resolver: GraphQLResponseResolver<AddItemToThreatIntelSourceOperationMutation, AddItemToThreatIntelSourceOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AddItemToThreatIntelSourceOperationMutation, AddItemToThreatIntelSourceOperationMutationVariables>(
    'AddItemToThreatIntelSourceOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateThreatIntelItemOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateThreatIntelItem }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateThreatIntelItemOperationMutation = (resolver: GraphQLResponseResolver<UpdateThreatIntelItemOperationMutation, UpdateThreatIntelItemOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateThreatIntelItemOperationMutation, UpdateThreatIntelItemOperationMutationVariables>(
    'UpdateThreatIntelItemOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockThreatIntelItemsSearchOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, sort, sortDir, q } = variables;
 *     return HttpResponse.json({
 *       data: { threatIntelItems2 }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockThreatIntelItemsSearchOperationQuery = (resolver: GraphQLResponseResolver<ThreatIntelItemsSearchOperationQuery, ThreatIntelItemsSearchOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ThreatIntelItemsSearchOperationQuery, ThreatIntelItemsSearchOperationQueryVariables>(
    'ThreatIntelItemsSearchOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUploadItemsToThreatIntelSourceOperationMutation(
 *   ({ query, variables }) => {
 *     const { threatIntelSourceId, expiration, file } = variables;
 *     return HttpResponse.json({
 *       data: { uploadItemsToThreatIntelSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUploadItemsToThreatIntelSourceOperationMutation = (resolver: GraphQLResponseResolver<UploadItemsToThreatIntelSourceOperationMutation, UploadItemsToThreatIntelSourceOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UploadItemsToThreatIntelSourceOperationMutation, UploadItemsToThreatIntelSourceOperationMutationVariables>(
    'UploadItemsToThreatIntelSourceOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteThreatIntelSourceOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteThreatIntelSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteThreatIntelSourceOperationMutation = (resolver: GraphQLResponseResolver<DeleteThreatIntelSourceOperationMutation, DeleteThreatIntelSourceOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteThreatIntelSourceOperationMutation, DeleteThreatIntelSourceOperationMutationVariables>(
    'DeleteThreatIntelSourceOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockThreatIntelSourceDetailOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { threatIntelSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockThreatIntelSourceDetailOperationQuery = (resolver: GraphQLResponseResolver<ThreatIntelSourceDetailOperationQuery, ThreatIntelSourceDetailOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ThreatIntelSourceDetailOperationQuery, ThreatIntelSourceDetailOperationQueryVariables>(
    'ThreatIntelSourceDetailOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockThreatIntelItemsOperationQuery(
 *   ({ query, variables }) => {
 *     const { sourceIds, offset, limit, sort, sortDir, q } = variables;
 *     return HttpResponse.json({
 *       data: { threatIntelItems2 }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockThreatIntelItemsOperationQuery = (resolver: GraphQLResponseResolver<ThreatIntelItemsOperationQuery, ThreatIntelItemsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ThreatIntelItemsOperationQuery, ThreatIntelItemsOperationQueryVariables>(
    'ThreatIntelItemsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateCustomThreatIntelSourceOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createCustomThreatIntelSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateCustomThreatIntelSourceOperationMutation = (resolver: GraphQLResponseResolver<CreateCustomThreatIntelSourceOperationMutation, CreateCustomThreatIntelSourceOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateCustomThreatIntelSourceOperationMutation, CreateCustomThreatIntelSourceOperationMutationVariables>(
    'CreateCustomThreatIntelSourceOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateCustomThreatIntelSourceOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateCustomThreatIntelSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateCustomThreatIntelSourceOperationMutation = (resolver: GraphQLResponseResolver<UpdateCustomThreatIntelSourceOperationMutation, UpdateCustomThreatIntelSourceOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateCustomThreatIntelSourceOperationMutation, UpdateCustomThreatIntelSourceOperationMutationVariables>(
    'UpdateCustomThreatIntelSourceOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateIdefenseThreatIntelSourceOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createIdefenseThreatIntelSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateIdefenseThreatIntelSourceOperationMutation = (resolver: GraphQLResponseResolver<CreateIdefenseThreatIntelSourceOperationMutation, CreateIdefenseThreatIntelSourceOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateIdefenseThreatIntelSourceOperationMutation, CreateIdefenseThreatIntelSourceOperationMutationVariables>(
    'CreateIdefenseThreatIntelSourceOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateIdefenseThreatIntelSourceOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields } = variables;
 *     return HttpResponse.json({
 *       data: { updateIdefenseThreatIntelSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateIdefenseThreatIntelSourceOperationMutation = (resolver: GraphQLResponseResolver<UpdateIdefenseThreatIntelSourceOperationMutation, UpdateIdefenseThreatIntelSourceOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateIdefenseThreatIntelSourceOperationMutation, UpdateIdefenseThreatIntelSourceOperationMutationVariables>(
    'UpdateIdefenseThreatIntelSourceOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateTaxiiThreatIntelSourceOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createTaxiiThreatIntelSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateTaxiiThreatIntelSourceOperationMutation = (resolver: GraphQLResponseResolver<CreateTaxiiThreatIntelSourceOperationMutation, CreateTaxiiThreatIntelSourceOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateTaxiiThreatIntelSourceOperationMutation, CreateTaxiiThreatIntelSourceOperationMutationVariables>(
    'CreateTaxiiThreatIntelSourceOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateTaxiiThreatIntelSourceOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields, fieldsToClear } = variables;
 *     return HttpResponse.json({
 *       data: { updateTaxiiThreatIntelSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateTaxiiThreatIntelSourceOperationMutation = (resolver: GraphQLResponseResolver<UpdateTaxiiThreatIntelSourceOperationMutation, UpdateTaxiiThreatIntelSourceOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateTaxiiThreatIntelSourceOperationMutation, UpdateTaxiiThreatIntelSourceOperationMutationVariables>(
    'UpdateTaxiiThreatIntelSourceOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockThreatIntelSourceEditorOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { threatIntelSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockThreatIntelSourceEditorOperationQuery = (resolver: GraphQLResponseResolver<ThreatIntelSourceEditorOperationQuery, ThreatIntelSourceEditorOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ThreatIntelSourceEditorOperationQuery, ThreatIntelSourceEditorOperationQueryVariables>(
    'ThreatIntelSourceEditorOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateThreatQThreatIntelSourceOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { createThreatQThreatIntelSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateThreatQThreatIntelSourceOperationMutation = (resolver: GraphQLResponseResolver<CreateThreatQThreatIntelSourceOperationMutation, CreateThreatQThreatIntelSourceOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateThreatQThreatIntelSourceOperationMutation, CreateThreatQThreatIntelSourceOperationMutationVariables>(
    'CreateThreatQThreatIntelSourceOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateThreatQThreatIntelSourceOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields, fieldsToClear } = variables;
 *     return HttpResponse.json({
 *       data: { updateThreatQThreatIntelSource }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateThreatQThreatIntelSourceOperationMutation = (resolver: GraphQLResponseResolver<UpdateThreatQThreatIntelSourceOperationMutation, UpdateThreatQThreatIntelSourceOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateThreatQThreatIntelSourceOperationMutation, UpdateThreatQThreatIntelSourceOperationMutationVariables>(
    'UpdateThreatQThreatIntelSourceOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockThreatIntelSourcesOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, sort, sortDir } = variables;
 *     return HttpResponse.json({
 *       data: { threatIntelSources, threatIntelItemCount, threatIntelItemLimit }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockThreatIntelSourcesOperationQuery = (resolver: GraphQLResponseResolver<ThreatIntelSourcesOperationQuery, ThreatIntelSourcesOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ThreatIntelSourcesOperationQuery, ThreatIntelSourcesOperationQueryVariables>(
    'ThreatIntelSourcesOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteThreatIntelItemOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteThreatIntelItem }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteThreatIntelItemOperationMutation = (resolver: GraphQLResponseResolver<DeleteThreatIntelItemOperationMutation, DeleteThreatIntelItemOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteThreatIntelItemOperationMutation, DeleteThreatIntelItemOperationMutationVariables>(
    'DeleteThreatIntelItemOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEnrichmentsFilterQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { ids } = variables;
 *     return HttpResponse.json({
 *       data: { entitiesByListIds }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEnrichmentsFilterQueryOperationQuery = (resolver: GraphQLResponseResolver<EnrichmentsFilterQueryOperationQuery, EnrichmentsFilterQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EnrichmentsFilterQueryOperationQuery, EnrichmentsFilterQueryOperationQueryVariables>(
    'EnrichmentsFilterQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityEnhancementsQueryDetailsOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityEnhancementsQueryDetailsOperationQuery = (resolver: GraphQLResponseResolver<EntityEnhancementsQueryDetailsOperationQuery, EntityEnhancementsQueryDetailsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityEnhancementsQueryDetailsOperationQuery, EntityEnhancementsQueryDetailsOperationQueryVariables>(
    'EntityEnhancementsQueryDetailsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSignalEnhancementsDetailsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { signal }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSignalEnhancementsDetailsQueryOperationQuery = (resolver: GraphQLResponseResolver<SignalEnhancementsDetailsQueryOperationQuery, SignalEnhancementsDetailsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SignalEnhancementsDetailsQueryOperationQuery, SignalEnhancementsDetailsQueryOperationQueryVariables>(
    'SignalEnhancementsDetailsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightEnhancementsDetailsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { insight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightEnhancementsDetailsQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightEnhancementsDetailsQueryOperationQuery, InsightEnhancementsDetailsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightEnhancementsDetailsQueryOperationQuery, InsightEnhancementsDetailsQueryOperationQueryVariables>(
    'InsightEnhancementsDetailsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBulkUpdateEntityCriticalityOperationMutation(
 *   ({ query, variables }) => {
 *     const { entityIds, criticality } = variables;
 *     return HttpResponse.json({
 *       data: { bulkUpdateEntityCriticality }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBulkUpdateEntityCriticalityOperationMutation = (resolver: GraphQLResponseResolver<BulkUpdateEntityCriticalityOperationMutation, BulkUpdateEntityCriticalityOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<BulkUpdateEntityCriticalityOperationMutation, BulkUpdateEntityCriticalityOperationMutationVariables>(
    'BulkUpdateEntityCriticalityOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBulkUpdateEntitySuppressionOperationMutation(
 *   ({ query, variables }) => {
 *     const { comment, entityIds, whitelistFlag } = variables;
 *     return HttpResponse.json({
 *       data: { bulkUpdateEntityWhitelist }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBulkUpdateEntitySuppressionOperationMutation = (resolver: GraphQLResponseResolver<BulkUpdateEntitySuppressionOperationMutation, BulkUpdateEntitySuppressionOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<BulkUpdateEntitySuppressionOperationMutation, BulkUpdateEntitySuppressionOperationMutationVariables>(
    'BulkUpdateEntitySuppressionOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBulkUpdateEntityTagsOperationMutation(
 *   ({ query, variables }) => {
 *     const { entityIds, tags } = variables;
 *     return HttpResponse.json({
 *       data: { bulkUpdateEntityTags }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBulkUpdateEntityTagsOperationMutation = (resolver: GraphQLResponseResolver<BulkUpdateEntityTagsOperationMutation, BulkUpdateEntityTagsOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<BulkUpdateEntityTagsOperationMutation, BulkUpdateEntityTagsOperationMutationVariables>(
    'BulkUpdateEntityTagsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBulkAddEntityTagsOperationMutation(
 *   ({ query, variables }) => {
 *     const { entityIds, tags } = variables;
 *     return HttpResponse.json({
 *       data: { bulkAddEntityTags }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBulkAddEntityTagsOperationMutation = (resolver: GraphQLResponseResolver<BulkAddEntityTagsOperationMutation, BulkAddEntityTagsOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<BulkAddEntityTagsOperationMutation, BulkAddEntityTagsOperationMutationVariables>(
    'BulkAddEntityTagsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBulkRemoveEntityTagsOperationMutation(
 *   ({ query, variables }) => {
 *     const { entityIds, tags } = variables;
 *     return HttpResponse.json({
 *       data: { bulkRemoveEntityTags }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBulkRemoveEntityTagsOperationMutation = (resolver: GraphQLResponseResolver<BulkRemoveEntityTagsOperationMutation, BulkRemoveEntityTagsOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<BulkRemoveEntityTagsOperationMutation, BulkRemoveEntityTagsOperationMutationVariables>(
    'BulkRemoveEntityTagsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityCriticalitySelectConfigsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { entityCriticalityConfigs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityCriticalitySelectConfigsQuery = (resolver: GraphQLResponseResolver<EntityCriticalitySelectConfigsQuery, EntityCriticalitySelectConfigsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityCriticalitySelectConfigsQuery, EntityCriticalitySelectConfigsQueryVariables>(
    'EntityCriticalitySelectConfigs',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityDetailsTimelineQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { limit, offset, q, sort, sortDir } = variables;
 *     return HttpResponse.json({
 *       data: { signals }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityDetailsTimelineQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityDetailsTimelineQueryOperationQuery, EntityDetailsTimelineQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityDetailsTimelineQueryOperationQuery, EntityDetailsTimelineQueryOperationQueryVariables>(
    'EntityDetailsTimelineQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateInsightFromEntitySignalsOperationMutation(
 *   ({ query, variables }) => {
 *     const { signalIds } = variables;
 *     return HttpResponse.json({
 *       data: { createInsightFromSignals }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateInsightFromEntitySignalsOperationMutation = (resolver: GraphQLResponseResolver<CreateInsightFromEntitySignalsOperationMutation, CreateInsightFromEntitySignalsOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateInsightFromEntitySignalsOperationMutation, CreateInsightFromEntitySignalsOperationMutationVariables>(
    'CreateInsightFromEntitySignalsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityDetailsInsightsSignalsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { entityId, insightsQuery, limit, offset, signalsQuery, sort, sortDir } = variables;
 *     return HttpResponse.json({
 *       data: { entity, insights, insightStatuses, signals }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityDetailsInsightsSignalsQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityDetailsInsightsSignalsQueryOperationQuery, EntityDetailsInsightsSignalsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityDetailsInsightsSignalsQueryOperationQuery, EntityDetailsInsightsSignalsQueryOperationQueryVariables>(
    'EntityDetailsInsightsSignalsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityDetailsSignalsSummaryQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { limit, offset, allSignalsQuery, suppressedSignalsQuery, unsuppressedSignalsQuery, prototypeSignalsQuery, sort, sortDir } = variables;
 *     return HttpResponse.json({
 *       data: { signals, signals, signals, signals }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityDetailsSignalsSummaryQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityDetailsSignalsSummaryQueryOperationQuery, EntityDetailsSignalsSummaryQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityDetailsSignalsSummaryQueryOperationQuery, EntityDetailsSignalsSummaryQueryOperationQueryVariables>(
    'EntityDetailsSignalsSummaryQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityDetailsTagsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityDetailsTagsQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityDetailsTagsQueryOperationQuery, EntityDetailsTagsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityDetailsTagsQueryOperationQuery, EntityDetailsTagsQueryOperationQueryVariables>(
    'EntityDetailsTagsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateEntityDetailsTagsOperationMutation(
 *   ({ query, variables }) => {
 *     const { entityId, tags } = variables;
 *     return HttpResponse.json({
 *       data: { updateEntityTags }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateEntityDetailsTagsOperationMutation = (resolver: GraphQLResponseResolver<UpdateEntityDetailsTagsOperationMutation, UpdateEntityDetailsTagsOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateEntityDetailsTagsOperationMutation, UpdateEntityDetailsTagsOperationMutationVariables>(
    'UpdateEntityDetailsTagsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightAsideQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { insight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightAsideQuery = (resolver: GraphQLResponseResolver<InsightAsideQuery, InsightAsideQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightAsideQuery, InsightAsideQueryVariables>(
    'InsightAside',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSignalAsideQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { signal }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSignalAsideQuery = (resolver: GraphQLResponseResolver<SignalAsideQuery, SignalAsideQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SignalAsideQuery, SignalAsideQueryVariables>(
    'SignalAside',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStartEntityTimelineJobMutation(
 *   ({ query, variables }) => {
 *     const { entityId, startTimestamp, endTimestamp, sortDir, objectTypes } = variables;
 *     return HttpResponse.json({
 *       data: { startEntityTimelineJob }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockStartEntityTimelineJobMutation = (resolver: GraphQLResponseResolver<StartEntityTimelineJobMutation, StartEntityTimelineJobMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<StartEntityTimelineJobMutation, StartEntityTimelineJobMutationVariables>(
    'StartEntityTimelineJob',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStartEntityTimelineGroupRecordJobMutation(
 *   ({ query, variables }) => {
 *     const { entityId, startTimestamp, endTimestamp, summary, objectTypes } = variables;
 *     return HttpResponse.json({
 *       data: { startEntityTimelineGroupRecordJob }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockStartEntityTimelineGroupRecordJobMutation = (resolver: GraphQLResponseResolver<StartEntityTimelineGroupRecordJobMutation, StartEntityTimelineGroupRecordJobMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<StartEntityTimelineGroupRecordJobMutation, StartEntityTimelineGroupRecordJobMutationVariables>(
    'StartEntityTimelineGroupRecordJob',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetEntityTimelineGroupsQuery(
 *   ({ query, variables }) => {
 *     const { jobId, offset, limit } = variables;
 *     return HttpResponse.json({
 *       data: { entityTimelineGroups, sumoRecordSearchJobStatus }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetEntityTimelineGroupsQuery = (resolver: GraphQLResponseResolver<GetEntityTimelineGroupsQuery, GetEntityTimelineGroupsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetEntityTimelineGroupsQuery, GetEntityTimelineGroupsQueryVariables>(
    'GetEntityTimelineGroups',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetRecordGroupDetailsQuery(
 *   ({ query, variables }) => {
 *     const { jobId } = variables;
 *     return HttpResponse.json({
 *       data: { sumoRecordSearchJobResults, sumoRecordSearchJobStatus }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetRecordGroupDetailsQuery = (resolver: GraphQLResponseResolver<GetRecordGroupDetailsQuery, GetRecordGroupDetailsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetRecordGroupDetailsQuery, GetRecordGroupDetailsQueryVariables>(
    'GetRecordGroupDetails',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetEntityTimelineSignalsQuery(
 *   ({ query, variables }) => {
 *     const { id, start, end, limit } = variables;
 *     return HttpResponse.json({
 *       data: { entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetEntityTimelineSignalsQuery = (resolver: GraphQLResponseResolver<GetEntityTimelineSignalsQuery, GetEntityTimelineSignalsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetEntityTimelineSignalsQuery, GetEntityTimelineSignalsQueryVariables>(
    'GetEntityTimelineSignals',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityScoreQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { insightConfig }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityScoreQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityScoreQueryOperationQuery, EntityScoreQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityScoreQueryOperationQuery, EntityScoreQueryOperationQueryVariables>(
    'EntityScoreQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockIndicatorQueryQuery(
 *   ({ query, variables }) => {
 *     const { entityId } = variables;
 *     return HttpResponse.json({
 *       data: { entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockIndicatorQueryQuery = (resolver: GraphQLResponseResolver<IndicatorQuery, IndicatorQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<IndicatorQuery, IndicatorQueryVariables>(
    'IndicatorQuery',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUploadEntityMutationsCsvMutation(
 *   ({ query, variables }) => {
 *     const { file } = variables;
 *     return HttpResponse.json({
 *       data: { uploadEntityMutationsCsv }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUploadEntityMutationsCsvMutation = (resolver: GraphQLResponseResolver<UploadEntityMutationsCsvMutation, UploadEntityMutationsCsvMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UploadEntityMutationsCsvMutation, UploadEntityMutationsCsvMutationVariables>(
    'UploadEntityMutationsCsv',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateEntitySuppressionMutation(
 *   ({ query, variables }) => {
 *     const { entityId, suppressed } = variables;
 *     return HttpResponse.json({
 *       data: { updateEntityWhitelist }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateEntitySuppressionMutation = (resolver: GraphQLResponseResolver<UpdateEntitySuppressionMutation, UpdateEntitySuppressionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateEntitySuppressionMutation, UpdateEntitySuppressionMutationVariables>(
    'UpdateEntitySuppression',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityListQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { offset, limit, q, sort, sortDir } = variables;
 *     return HttpResponse.json({
 *       data: { insightConfig, entities }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityListQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityListQueryOperationQuery, EntityListQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityListQueryOperationQuery, EntityListQueryOperationQueryVariables>(
    'EntityListQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityDetailsAuditLogQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityDetailsAuditLogQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityDetailsAuditLogQueryOperationQuery, EntityDetailsAuditLogQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityDetailsAuditLogQueryOperationQuery, EntityDetailsAuditLogQueryOperationQueryVariables>(
    'EntityDetailsAuditLogQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityCriticalityConfigListQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { entityCriticalityConfigs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityCriticalityConfigListQuery = (resolver: GraphQLResponseResolver<EntityCriticalityConfigListQuery, EntityCriticalityConfigListQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityCriticalityConfigListQuery, EntityCriticalityConfigListQueryVariables>(
    'EntityCriticalityConfigList',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInventoryLookupOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { inventoryLookupTableSources }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInventoryLookupOperationQuery = (resolver: GraphQLResponseResolver<InventoryLookupOperationQuery, InventoryLookupOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InventoryLookupOperationQuery, InventoryLookupOperationQueryVariables>(
    'InventoryLookupOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockHudRadarQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { start, end, insightBucket, signalBucket, recordBucket } = variables;
 *     return HttpResponse.json({
 *       data: { insightCountsByStatus, insightStatuses, recordCounts, signalCounts }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockHudRadarQueryOperationQuery = (resolver: GraphQLResponseResolver<HudRadarQueryOperationQuery, HudRadarQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<HudRadarQueryOperationQuery, HudRadarQueryOperationQueryVariables>(
    'HudRadarQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightActivityFeedQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { nextPageTimestamp } = variables;
 *     return HttpResponse.json({
 *       data: { insightActivityFeedEvents }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightActivityFeedQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightActivityFeedQueryOperationQuery, InsightActivityFeedQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightActivityFeedQueryOperationQuery, InsightActivityFeedQueryOperationQueryVariables>(
    'InsightActivityFeedQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightCountsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { start, end, insightBucket, insightClosedBucket, timezone } = variables;
 *     return HttpResponse.json({
 *       data: { insightCounts, insightClosedCounts }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightCountsQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightCountsQueryOperationQuery, InsightCountsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightCountsQueryOperationQuery, InsightCountsQueryOperationQueryVariables>(
    'InsightCountsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightMetricsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { interval } = variables;
 *     return HttpResponse.json({
 *       data: { meanTimeToDetection, meanTimeToResponse, meanTimeToRemediation }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightMetricsQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightMetricsQueryOperationQuery, InsightMetricsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightMetricsQueryOperationQuery, InsightMetricsQueryOperationQueryVariables>(
    'InsightMetricsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightStatusMetricsQuery(
 *   ({ query, variables }) => {
 *     const { start, end, insightBucket } = variables;
 *     return HttpResponse.json({
 *       data: { insightCountsByStatus, insightStatuses }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightStatusMetricsQuery = (resolver: GraphQLResponseResolver<InsightStatusMetricsQuery, InsightStatusMetricsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightStatusMetricsQuery, InsightStatusMetricsQueryVariables>(
    'InsightStatusMetrics',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPipelineMetricsOperationQuery(
 *   ({ query, variables }) => {
 *     const { interval } = variables;
 *     return HttpResponse.json({
 *       data: { bigIntRecordCountWithDelta, bigIntSignalCountWithDelta, bigIntInsightCountWithDelta }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPipelineMetricsOperationQuery = (resolver: GraphQLResponseResolver<PipelineMetricsOperationQuery, PipelineMetricsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PipelineMetricsOperationQuery, PipelineMetricsOperationQueryVariables>(
    'PipelineMetricsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTopEntitiesQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { limit, q, sort } = variables;
 *     return HttpResponse.json({
 *       data: { entities, insightConfig }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTopEntitiesQueryOperationQuery = (resolver: GraphQLResponseResolver<TopEntitiesQueryOperationQuery, TopEntitiesQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TopEntitiesQueryOperationQuery, TopEntitiesQueryOperationQueryVariables>(
    'TopEntitiesQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTopInsightQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { limit, q, sort, enableAIInsightSummary, enableAgenticSecOps } = variables;
 *     return HttpResponse.json({
 *       data: { insights }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTopInsightQueryOperationQuery = (resolver: GraphQLResponseResolver<TopInsightQueryOperationQuery, TopInsightQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TopInsightQueryOperationQuery, TopInsightQueryOperationQueryVariables>(
    'TopInsightQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightAutomationsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { automations }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightAutomationsQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightAutomationsQueryOperationQuery, InsightAutomationsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightAutomationsQueryOperationQuery, InsightAutomationsQueryOperationQueryVariables>(
    'InsightAutomationsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockExecuteInsightAutomationOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { executeAutomation }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockExecuteInsightAutomationOperationMutation = (resolver: GraphQLResponseResolver<ExecuteInsightAutomationOperationMutation, ExecuteInsightAutomationOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ExecuteInsightAutomationOperationMutation, ExecuteInsightAutomationOperationMutationVariables>(
    'ExecuteInsightAutomationOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteInsightCommentOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteInsightComment }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteInsightCommentOperationMutation = (resolver: GraphQLResponseResolver<DeleteInsightCommentOperationMutation, DeleteInsightCommentOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteInsightCommentOperationMutation, DeleteInsightCommentOperationMutationVariables>(
    'DeleteInsightCommentOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAddToIncidentDialogOperationQuery(
 *   ({ query, variables }) => {
 *     const { query } = variables;
 *     return HttpResponse.json({
 *       data: { incidentSearchResults }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAddToIncidentDialogOperationQuery = (resolver: GraphQLResponseResolver<AddToIncidentDialogOperationQuery, AddToIncidentDialogOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AddToIncidentDialogOperationQuery, AddToIncidentDialogOperationQueryVariables>(
    'AddToIncidentDialogOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAddInsightToIncidentOperationMutation(
 *   ({ query, variables }) => {
 *     const { insightId, incidentId, enableAIInsightSummary, enableAgenticSecOps } = variables;
 *     return HttpResponse.json({
 *       data: { addInsightToIncident }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAddInsightToIncidentOperationMutation = (resolver: GraphQLResponseResolver<AddInsightToIncidentOperationMutation, AddInsightToIncidentOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AddInsightToIncidentOperationMutation, AddInsightToIncidentOperationMutationVariables>(
    'AddInsightToIncidentOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateIncidentFromInsightOperationMutation(
 *   ({ query, variables }) => {
 *     const { insightId, incidentTemplateId, enableAIInsightSummary, enableAgenticSecOps } = variables;
 *     return HttpResponse.json({
 *       data: { createIncidentFromInsight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateIncidentFromInsightOperationMutation = (resolver: GraphQLResponseResolver<CreateIncidentFromInsightOperationMutation, CreateIncidentFromInsightOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateIncidentFromInsightOperationMutation, CreateIncidentFromInsightOperationMutationVariables>(
    'CreateIncidentFromInsightOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAddTagToInsightOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, tagName } = variables;
 *     return HttpResponse.json({
 *       data: { addTagToInsight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAddTagToInsightOperationMutation = (resolver: GraphQLResponseResolver<AddTagToInsightOperationMutation, AddTagToInsightOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AddTagToInsightOperationMutation, AddTagToInsightOperationMutationVariables>(
    'AddTagToInsightOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveTagFromInsightOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, tagName } = variables;
 *     return HttpResponse.json({
 *       data: { removeTagFromInsight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRemoveTagFromInsightOperationMutation = (resolver: GraphQLResponseResolver<RemoveTagFromInsightOperationMutation, RemoveTagFromInsightOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<RemoveTagFromInsightOperationMutation, RemoveTagFromInsightOperationMutationVariables>(
    'RemoveTagFromInsightOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateInsightOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id, addComment, commentBody } = variables;
 *     return HttpResponse.json({
 *       data: { addInsightComment, updateInsight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateInsightOperationMutation = (resolver: GraphQLResponseResolver<UpdateInsightOperationMutation, UpdateInsightOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateInsightOperationMutation, UpdateInsightOperationMutationVariables>(
    'UpdateInsightOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockExecuteActionOperationMutation(
 *   ({ query, variables }) => {
 *     const { insightId, actionId, parameterValues } = variables;
 *     return HttpResponse.json({
 *       data: { executeAction }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockExecuteActionOperationMutation = (resolver: GraphQLResponseResolver<ExecuteActionOperationMutation, ExecuteActionOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ExecuteActionOperationMutation, ExecuteActionOperationMutationVariables>(
    'ExecuteActionOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAddInsightCommentOperationMutation(
 *   ({ query, variables }) => {
 *     const { body, insightId } = variables;
 *     return HttpResponse.json({
 *       data: { addInsightComment }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAddInsightCommentOperationMutation = (resolver: GraphQLResponseResolver<AddInsightCommentOperationMutation, AddInsightCommentOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AddInsightCommentOperationMutation, AddInsightCommentOperationMutationVariables>(
    'AddInsightCommentOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteInsightOperationMutation(
 *   ({ query, variables }) => {
 *     const { insightId } = variables;
 *     return HttpResponse.json({
 *       data: { deleteInsight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteInsightOperationMutation = (resolver: GraphQLResponseResolver<DeleteInsightOperationMutation, DeleteInsightOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteInsightOperationMutation, DeleteInsightOperationMutationVariables>(
    'DeleteInsightOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockVisitInsightPageOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { visitInsightPage }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockVisitInsightPageOperationMutation = (resolver: GraphQLResponseResolver<VisitInsightPageOperationMutation, VisitInsightPageOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<VisitInsightPageOperationMutation, VisitInsightPageOperationMutationVariables>(
    'VisitInsightPageOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightEntityActivityQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { insightId } = variables;
 *     return HttpResponse.json({
 *       data: { insightEntityActivity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightEntityActivityQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightEntityActivityQueryOperationQuery, InsightEntityActivityQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightEntityActivityQueryOperationQuery, InsightEntityActivityQueryOperationQueryVariables>(
    'InsightEntityActivityQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightEntitiesByListIdsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { ids } = variables;
 *     return HttpResponse.json({
 *       data: { entitiesByListIds }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightEntitiesByListIdsQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightEntitiesByListIdsQueryOperationQuery, InsightEntitiesByListIdsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightEntitiesByListIdsQueryOperationQuery, InsightEntitiesByListIdsQueryOperationQueryVariables>(
    'InsightEntitiesByListIdsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightEntityAutomationsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { automations }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightEntityAutomationsQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightEntityAutomationsQueryOperationQuery, InsightEntityAutomationsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightEntityAutomationsQueryOperationQuery, InsightEntityAutomationsQueryOperationQueryVariables>(
    'InsightEntityAutomationsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockExecuteInsightEntityAutomationOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { executeAutomation }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockExecuteInsightEntityAutomationOperationMutation = (resolver: GraphQLResponseResolver<ExecuteInsightEntityAutomationOperationMutation, ExecuteInsightEntityAutomationOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ExecuteInsightEntityAutomationOperationMutation, ExecuteInsightEntityAutomationOperationMutationVariables>(
    'ExecuteInsightEntityAutomationOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightEntityDetailsQueryQuery(
 *   ({ query, variables }) => {
 *     const { entityId, detectionWindowStartTime, detectionWindowEndTime } = variables;
 *     return HttpResponse.json({
 *       data: { entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightEntityDetailsQueryQuery = (resolver: GraphQLResponseResolver<InsightEntityDetailsQuery, InsightEntityDetailsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightEntityDetailsQuery, InsightEntityDetailsQueryVariables>(
    'InsightEntityDetailsQuery',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityRelationshipsByIdsQuery(
 *   ({ query, variables }) => {
 *     const { entityIds, start, end, entityTypes } = variables;
 *     return HttpResponse.json({
 *       data: { entitiesByListIds }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityRelationshipsByIdsQuery = (resolver: GraphQLResponseResolver<EntityRelationshipsByIdsQuery, EntityRelationshipsByIdsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityRelationshipsByIdsQuery, EntityRelationshipsByIdsQueryVariables>(
    'EntityRelationshipsByIds',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntitiesDetailsQuery(
 *   ({ query, variables }) => {
 *     const { entityIds } = variables;
 *     return HttpResponse.json({
 *       data: { entitiesByListIds }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntitiesDetailsQuery = (resolver: GraphQLResponseResolver<EntitiesDetailsQuery, EntitiesDetailsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntitiesDetailsQuery, EntitiesDetailsQueryVariables>(
    'EntitiesDetails',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightEntityActivityQueryQuery(
 *   ({ query, variables }) => {
 *     const { insightId } = variables;
 *     return HttpResponse.json({
 *       data: { insightEntityActivity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightEntityActivityQueryQuery = (resolver: GraphQLResponseResolver<InsightEntityActivityQuery, InsightEntityActivityQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightEntityActivityQuery, InsightEntityActivityQueryVariables>(
    'InsightEntityActivityQuery',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRelatedEntitiesCountQueryQuery(
 *   ({ query, variables }) => {
 *     const { insightId } = variables;
 *     return HttpResponse.json({
 *       data: { insightEntityActivity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRelatedEntitiesCountQueryQuery = (resolver: GraphQLResponseResolver<RelatedEntitiesCountQuery, RelatedEntitiesCountQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RelatedEntitiesCountQuery, RelatedEntitiesCountQueryVariables>(
    'RelatedEntitiesCountQuery',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightsListForSelectQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { q, limit, offset } = variables;
 *     return HttpResponse.json({
 *       data: { insights }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightsListForSelectQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightsListForSelectQueryOperationQuery, InsightsListForSelectQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightsListForSelectQueryOperationQuery, InsightsListForSelectQueryOperationQueryVariables>(
    'InsightsListForSelectQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateInsightResolutionOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id, addComment, commentBody } = variables;
 *     return HttpResponse.json({
 *       data: { addInsightComment, updateInsight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateInsightResolutionOperationMutation = (resolver: GraphQLResponseResolver<UpdateInsightResolutionOperationMutation, UpdateInsightResolutionOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateInsightResolutionOperationMutation, UpdateInsightResolutionOperationMutationVariables>(
    'UpdateInsightResolutionOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateInsightsResolutionOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, ids, addComment, commentBody } = variables;
 *     return HttpResponse.json({
 *       data: { addInsightCommentsById, updateInsightsById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateInsightsResolutionOperationMutation = (resolver: GraphQLResponseResolver<UpdateInsightsResolutionOperationMutation, UpdateInsightsResolutionOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateInsightsResolutionOperationMutation, UpdateInsightsResolutionOperationMutationVariables>(
    'UpdateInsightsResolutionOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveSignalsMutationOperationMutation(
 *   ({ query, variables }) => {
 *     const { signalIds, insightId } = variables;
 *     return HttpResponse.json({
 *       data: { removeSignalsFromInsight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRemoveSignalsMutationOperationMutation = (resolver: GraphQLResponseResolver<RemoveSignalsMutationOperationMutation, RemoveSignalsMutationOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<RemoveSignalsMutationOperationMutation, RemoveSignalsMutationOperationMutationVariables>(
    'RemoveSignalsMutationOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAddSignalsMutationOperationMutation(
 *   ({ query, variables }) => {
 *     const { signalId, insightId } = variables;
 *     return HttpResponse.json({
 *       data: { addSignalsToInsight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAddSignalsMutationOperationMutation = (resolver: GraphQLResponseResolver<AddSignalsMutationOperationMutation, AddSignalsMutationOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AddSignalsMutationOperationMutation, AddSignalsMutationOperationMutationVariables>(
    'AddSignalsMutationOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightSignalsQueryQuery(
 *   ({ query, variables }) => {
 *     const { insightId } = variables;
 *     return HttpResponse.json({
 *       data: { insight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightSignalsQueryQuery = (resolver: GraphQLResponseResolver<InsightSignalsQuery, InsightSignalsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightSignalsQuery, InsightSignalsQueryVariables>(
    'InsightSignalsQuery',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRelatedInsightSignalsQueryQuery(
 *   ({ query, variables }) => {
 *     const { insightId } = variables;
 *     return HttpResponse.json({
 *       data: { insight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRelatedInsightSignalsQueryQuery = (resolver: GraphQLResponseResolver<RelatedInsightSignalsQuery, RelatedInsightSignalsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RelatedInsightSignalsQuery, RelatedInsightSignalsQueryVariables>(
    'RelatedInsightSignalsQuery',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRelatedSignalTimelineQueryQuery(
 *   ({ query, variables }) => {
 *     const { insightId, includeRelated } = variables;
 *     return HttpResponse.json({
 *       data: { insight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRelatedSignalTimelineQueryQuery = (resolver: GraphQLResponseResolver<RelatedSignalTimelineQuery, RelatedSignalTimelineQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RelatedSignalTimelineQuery, RelatedSignalTimelineQueryVariables>(
    'RelatedSignalTimelineQuery',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGetLinkableSignalsQuery(
 *   ({ query, variables }) => {
 *     const { entityId } = variables;
 *     return HttpResponse.json({
 *       data: { entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGetLinkableSignalsQuery = (resolver: GraphQLResponseResolver<GetLinkableSignalsQuery, GetLinkableSignalsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GetLinkableSignalsQuery, GetLinkableSignalsQueryVariables>(
    'GetLinkableSignals',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightHistoryQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { insight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightHistoryQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightHistoryQueryOperationQuery, InsightHistoryQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightHistoryQueryOperationQuery, InsightHistoryQueryOperationQueryVariables>(
    'InsightHistoryQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightCommentsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { insight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightCommentsQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightCommentsQueryOperationQuery, InsightCommentsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightCommentsQueryOperationQuery, InsightCommentsQueryOperationQueryVariables>(
    'InsightCommentsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightExecutedAutomationsCountQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { insight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightExecutedAutomationsCountQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightExecutedAutomationsCountQueryOperationQuery, InsightExecutedAutomationsCountQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightExecutedAutomationsCountQueryOperationQuery, InsightExecutedAutomationsCountQueryOperationQueryVariables>(
    'InsightExecutedAutomationsCountQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id, enableAIInsightSummary, enableAgenticSecOps } = variables;
 *     return HttpResponse.json({
 *       data: { actions, insight, insightConfig, teams, users }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightQueryOperationQuery, InsightQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightQueryOperationQuery, InsightQueryOperationQueryVariables>(
    'InsightQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityRecentSignalsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id, start, end, limit } = variables;
 *     return HttpResponse.json({
 *       data: { entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityRecentSignalsQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityRecentSignalsQueryOperationQuery, EntityRecentSignalsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityRecentSignalsQueryOperationQuery, EntityRecentSignalsQueryOperationQueryVariables>(
    'EntityRecentSignalsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityRecentInsightsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id, start, end, limit } = variables;
 *     return HttpResponse.json({
 *       data: { entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityRecentInsightsQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityRecentInsightsQueryOperationQuery, EntityRecentInsightsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityRecentInsightsQueryOperationQuery, EntityRecentInsightsQueryOperationQueryVariables>(
    'EntityRecentInsightsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAddInsightCommentsByIdOperationMutation(
 *   ({ query, variables }) => {
 *     const { ids, commentBody } = variables;
 *     return HttpResponse.json({
 *       data: { addInsightCommentsById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAddInsightCommentsByIdOperationMutation = (resolver: GraphQLResponseResolver<AddInsightCommentsByIdOperationMutation, AddInsightCommentsByIdOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AddInsightCommentsByIdOperationMutation, AddInsightCommentsByIdOperationMutationVariables>(
    'AddInsightCommentsByIdOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockGroupedInsightsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { q, offset, limit, sort, sortDir, groups } = variables;
 *     return HttpResponse.json({
 *       data: { groupedInsights, insightStatuses }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockGroupedInsightsQueryOperationQuery = (resolver: GraphQLResponseResolver<GroupedInsightsQueryOperationQuery, GroupedInsightsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<GroupedInsightsQueryOperationQuery, GroupedInsightsQueryOperationQueryVariables>(
    'GroupedInsightsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightsFilterFieldQueryQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { insightStatuses, teams }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightsFilterFieldQueryQuery = (resolver: GraphQLResponseResolver<InsightsFilterFieldQuery, InsightsFilterFieldQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightsFilterFieldQuery, InsightsFilterFieldQueryVariables>(
    'InsightsFilterFieldQuery',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightsListQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { q, offset, limit, sort, sortDir, enableAIInsightSummary, enableAgenticSecOps } = variables;
 *     return HttpResponse.json({
 *       data: { insights, insightStatuses, teams, categories }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightsListQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightsListQueryOperationQuery, InsightsListQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightsListQueryOperationQuery, InsightsListQueryOperationQueryVariables>(
    'InsightsListQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightsDataGridQuery(
 *   ({ query, variables }) => {
 *     const { q, offset, limit, sort, sortDir, enableAIInsightSummary, enableAgenticSecOps } = variables;
 *     return HttpResponse.json({
 *       data: { insights }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightsDataGridQuery = (resolver: GraphQLResponseResolver<InsightsDataGridQuery, InsightsDataGridQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightsDataGridQuery, InsightsDataGridQueryVariables>(
    'InsightsDataGrid',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateInsightsByIdOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, ids, addComment, commentBody } = variables;
 *     return HttpResponse.json({
 *       data: { addInsightCommentsById, updateInsightsById }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateInsightsByIdOperationMutation = (resolver: GraphQLResponseResolver<UpdateInsightsByIdOperationMutation, UpdateInsightsByIdOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateInsightsByIdOperationMutation, UpdateInsightsByIdOperationMutationVariables>(
    'UpdateInsightsByIdOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateInsightSeverityOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, fields, enableAIInsightSummary, enableAgenticSecOps } = variables;
 *     return HttpResponse.json({
 *       data: { updateInsight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateInsightSeverityOperationMutation = (resolver: GraphQLResponseResolver<UpdateInsightSeverityOperationMutation, UpdateInsightSeverityOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateInsightSeverityOperationMutation, UpdateInsightSeverityOperationMutationVariables>(
    'UpdateInsightSeverityOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateInsightStatusOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id, addComment, commentBody, enableAIInsightSummary, enableAgenticSecOps } = variables;
 *     return HttpResponse.json({
 *       data: { addInsightComment, updateInsight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateInsightStatusOperationMutation = (resolver: GraphQLResponseResolver<UpdateInsightStatusOperationMutation, UpdateInsightStatusOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateInsightStatusOperationMutation, UpdateInsightStatusOperationMutationVariables>(
    'UpdateInsightStatusOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateInsightAssigneeOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields, id, enableAIInsightSummary, enableAgenticSecOps } = variables;
 *     return HttpResponse.json({
 *       data: { updateInsight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateInsightAssigneeOperationMutation = (resolver: GraphQLResponseResolver<UpdateInsightAssigneeOperationMutation, UpdateInsightAssigneeOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateInsightAssigneeOperationMutation, UpdateInsightAssigneeOperationMutationVariables>(
    'UpdateInsightAssigneeOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockConfirmTriageRecommendationOperationMutation(
 *   ({ query, variables }) => {
 *     const { accepted, id, enableAIInsightSummary, enableAgenticSecOps } = variables;
 *     return HttpResponse.json({
 *       data: { confirmInsightTriageRecommendation }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockConfirmTriageRecommendationOperationMutation = (resolver: GraphQLResponseResolver<ConfirmTriageRecommendationOperationMutation, ConfirmTriageRecommendationOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ConfirmTriageRecommendationOperationMutation, ConfirmTriageRecommendationOperationMutationVariables>(
    'ConfirmTriageRecommendationOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFederatedChildOrgsListQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { federatedChildOrgs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockFederatedChildOrgsListQuery = (resolver: GraphQLResponseResolver<FederatedChildOrgsListQuery, FederatedChildOrgsListQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<FederatedChildOrgsListQuery, FederatedChildOrgsListQueryVariables>(
    'FederatedChildOrgsList',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockApiDocumentationLinkQueryQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { apiDocumentationLink }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockApiDocumentationLinkQueryQuery = (resolver: GraphQLResponseResolver<ApiDocumentationLinkQuery, ApiDocumentationLinkQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<ApiDocumentationLinkQuery, ApiDocumentationLinkQueryVariables>(
    'ApiDocumentationLinkQuery',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUserProfileOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { version, currentUser }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUserProfileOperationQuery = (resolver: GraphQLResponseResolver<UserProfileOperationQuery, UserProfileOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<UserProfileOperationQuery, UserProfileOperationQueryVariables>(
    'UserProfileOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCloudSoarUrlQueryQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { cloudSoarUrl }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCloudSoarUrlQueryQuery = (resolver: GraphQLResponseResolver<CloudSoarUrlQuery, CloudSoarUrlQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CloudSoarUrlQuery, CloudSoarUrlQueryVariables>(
    'CloudSoarUrlQuery',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRecordsTabQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { recordSchema }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRecordsTabQueryOperationQuery = (resolver: GraphQLResponseResolver<RecordsTabQueryOperationQuery, RecordsTabQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RecordsTabQueryOperationQuery, RecordsTabQueryOperationQueryVariables>(
    'RecordsTabQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAdvancedSearchQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { q, limit, offset, resultType, sort } = variables;
 *     return HttpResponse.json({
 *       data: { dslSearchResults }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAdvancedSearchQueryOperationQuery = (resolver: GraphQLResponseResolver<AdvancedSearchQueryOperationQuery, AdvancedSearchQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AdvancedSearchQueryOperationQuery, AdvancedSearchQueryOperationQueryVariables>(
    'AdvancedSearchQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockKeywordSearchQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { q, limit, offset, resultType } = variables;
 *     return HttpResponse.json({
 *       data: { dslSearchResults, insights, signals, entities }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockKeywordSearchQueryOperationQuery = (resolver: GraphQLResponseResolver<KeywordSearchQueryOperationQuery, KeywordSearchQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<KeywordSearchQueryOperationQuery, KeywordSearchQueryOperationQueryVariables>(
    'KeywordSearchQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSearchHistoryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { recentlyVisitedDetailPages, recentlyVisitedSearchQueryPages, insightStatuses, teams, users, entityCriticalityConfigs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSearchHistoryOperationQuery = (resolver: GraphQLResponseResolver<SearchHistoryOperationQuery, SearchHistoryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SearchHistoryOperationQuery, SearchHistoryOperationQueryVariables>(
    'SearchHistoryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFilterQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { recentlyVisitedSearchQueryPages, insightStatuses, teams, users, categories, recordSchema, entityCriticalityConfigs }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockFilterQueryOperationQuery = (resolver: GraphQLResponseResolver<FilterQueryOperationQuery, FilterQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<FilterQueryOperationQuery, FilterQueryOperationQueryVariables>(
    'FilterQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockVisitSearchQueryPageOperationMutation(
 *   ({ query, variables }) => {
 *     const { q, resultType } = variables;
 *     return HttpResponse.json({
 *       data: { visitSearchQueryPage }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockVisitSearchQueryPageOperationMutation = (resolver: GraphQLResponseResolver<VisitSearchQueryPageOperationMutation, VisitSearchQueryPageOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<VisitSearchQueryPageOperationMutation, VisitSearchQueryPageOperationMutationVariables>(
    'VisitSearchQueryPageOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSignalQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { signal }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSignalQueryOperationQuery = (resolver: GraphQLResponseResolver<SignalQueryOperationQuery, SignalQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SignalQueryOperationQuery, SignalQueryOperationQueryVariables>(
    'SignalQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockVisitSignalPageOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { visitSignalPage }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockVisitSignalPageOperationMutation = (resolver: GraphQLResponseResolver<VisitSignalPageOperationMutation, VisitSignalPageOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<VisitSignalPageOperationMutation, VisitSignalPageOperationMutationVariables>(
    'VisitSignalPageOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSignalRuleQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { rule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSignalRuleQueryOperationQuery = (resolver: GraphQLResponseResolver<SignalRuleQueryOperationQuery, SignalRuleQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SignalRuleQueryOperationQuery, SignalRuleQueryOperationQueryVariables>(
    'SignalRuleQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStartSumoRecordSearchJobForSignalMutation(
 *   ({ query, variables }) => {
 *     const { signalId } = variables;
 *     return HttpResponse.json({
 *       data: { startSumoRecordSearchJobForSignal }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockStartSumoRecordSearchJobForSignalMutation = (resolver: GraphQLResponseResolver<StartSumoRecordSearchJobForSignalMutation, StartSumoRecordSearchJobForSignalMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<StartSumoRecordSearchJobForSignalMutation, StartSumoRecordSearchJobForSignalMutationVariables>(
    'StartSumoRecordSearchJobForSignal',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCancelSumoRecordSearchJobForSignalOperationMutation(
 *   ({ query, variables }) => {
 *     const { jobId } = variables;
 *     return HttpResponse.json({
 *       data: { cancelSumoRecordSearchJob }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCancelSumoRecordSearchJobForSignalOperationMutation = (resolver: GraphQLResponseResolver<CancelSumoRecordSearchJobForSignalOperationMutation, CancelSumoRecordSearchJobForSignalOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CancelSumoRecordSearchJobForSignalOperationMutation, CancelSumoRecordSearchJobForSignalOperationMutationVariables>(
    'CancelSumoRecordSearchJobForSignalOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRecordSearchResultsForSignalOperationQuery(
 *   ({ query, variables }) => {
 *     const { jobId, offset, limit } = variables;
 *     return HttpResponse.json({
 *       data: { sumoRecordSearchJobStatus, sumoRecordSearchJobResults }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRecordSearchResultsForSignalOperationQuery = (resolver: GraphQLResponseResolver<RecordSearchResultsForSignalOperationQuery, RecordSearchResultsForSignalOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RecordSearchResultsForSignalOperationQuery, RecordSearchResultsForSignalOperationQueryVariables>(
    'RecordSearchResultsForSignalOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSuppressedSignalQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id, limit, offset } = variables;
 *     return HttpResponse.json({
 *       data: { signal }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSuppressedSignalQueryOperationQuery = (resolver: GraphQLResponseResolver<SuppressedSignalQueryOperationQuery, SuppressedSignalQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SuppressedSignalQueryOperationQuery, SuppressedSignalQueryOperationQueryVariables>(
    'SuppressedSignalQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSignalNameQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { signal }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSignalNameQueryOperationQuery = (resolver: GraphQLResponseResolver<SignalNameQueryOperationQuery, SignalNameQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SignalNameQueryOperationQuery, SignalNameQueryOperationQueryVariables>(
    'SignalNameQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSignalsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { q, offset, limit, sort, sortDir } = variables;
 *     return HttpResponse.json({
 *       data: { signals, categories, insightConfig }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSignalsQueryOperationQuery = (resolver: GraphQLResponseResolver<SignalsQueryOperationQuery, SignalsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SignalsQueryOperationQuery, SignalsQueryOperationQueryVariables>(
    'SignalsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityDetailsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { insightConfig, entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityDetailsQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityDetailsQueryOperationQuery, EntityDetailsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityDetailsQueryOperationQuery, EntityDetailsQueryOperationQueryVariables>(
    'EntityDetailsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntitySummaryQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id, detectionWindowStartTime, detectionWindowEndTime } = variables;
 *     return HttpResponse.json({
 *       data: { entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntitySummaryQueryOperationQuery = (resolver: GraphQLResponseResolver<EntitySummaryQueryOperationQuery, EntitySummaryQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntitySummaryQueryOperationQuery, EntitySummaryQueryOperationQueryVariables>(
    'EntitySummaryQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityExecutedAutomationsCountQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityExecutedAutomationsCountQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityExecutedAutomationsCountQueryOperationQuery, EntityExecutedAutomationsCountQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityExecutedAutomationsCountQueryOperationQuery, EntityExecutedAutomationsCountQueryOperationQueryVariables>(
    'EntityExecutedAutomationsCountQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightConfigQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { insightConfig }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightConfigQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightConfigQueryOperationQuery, InsightConfigQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightConfigQueryOperationQuery, InsightConfigQueryOperationQueryVariables>(
    'InsightConfigQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAddSignalsToInsightOperationMutation(
 *   ({ query, variables }) => {
 *     const { insightId, signalIds } = variables;
 *     return HttpResponse.json({
 *       data: { addSignalsToInsight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAddSignalsToInsightOperationMutation = (resolver: GraphQLResponseResolver<AddSignalsToInsightOperationMutation, AddSignalsToInsightOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<AddSignalsToInsightOperationMutation, AddSignalsToInsightOperationMutationVariables>(
    'AddSignalsToInsightOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRemoveSignalsFromInsightOperationMutation(
 *   ({ query, variables }) => {
 *     const { signalIds, insightId, enableAIInsightSummary, enableAgenticSecOps } = variables;
 *     return HttpResponse.json({
 *       data: { removeSignalsFromInsight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRemoveSignalsFromInsightOperationMutation = (resolver: GraphQLResponseResolver<RemoveSignalsFromInsightOperationMutation, RemoveSignalsFromInsightOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<RemoveSignalsFromInsightOperationMutation, RemoveSignalsFromInsightOperationMutationVariables>(
    'RemoveSignalsFromInsightOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateInsightFromSignalOperationMutation(
 *   ({ query, variables }) => {
 *     const { signalId, enableAIInsightSummary, enableAgenticSecOps } = variables;
 *     return HttpResponse.json({
 *       data: { createInsightFromSignal }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateInsightFromSignalOperationMutation = (resolver: GraphQLResponseResolver<CreateInsightFromSignalOperationMutation, CreateInsightFromSignalOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateInsightFromSignalOperationMutation, CreateInsightFromSignalOperationMutationVariables>(
    'CreateInsightFromSignalOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockAssigneeQueryQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { teams, users }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockAssigneeQueryQuery = (resolver: GraphQLResponseResolver<AssigneeQuery, AssigneeQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<AssigneeQuery, AssigneeQueryVariables>(
    'AssigneeQuery',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEnabledContextActionsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { contextActions, sumoLogicBaseUrl, sumoLogicRegion }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEnabledContextActionsQueryOperationQuery = (resolver: GraphQLResponseResolver<EnabledContextActionsQueryOperationQuery, EnabledContextActionsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EnabledContextActionsQueryOperationQuery, EnabledContextActionsQueryOperationQueryVariables>(
    'EnabledContextActionsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityAsideLookbackOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { insightConfig }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityAsideLookbackOperationQuery = (resolver: GraphQLResponseResolver<EntityAsideLookbackOperationQuery, EntityAsideLookbackOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityAsideLookbackOperationQuery, EntityAsideLookbackOperationQueryVariables>(
    'EntityAsideLookbackOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityAsideQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { detectionWindowStartTime, detectionWindowEndTime, id, limit, offset } = variables;
 *     return HttpResponse.json({
 *       data: { entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityAsideQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityAsideQueryOperationQuery, EntityAsideQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityAsideQueryOperationQuery, EntityAsideQueryOperationQueryVariables>(
    'EntityAsideQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityNetworkBlocksQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { address } = variables;
 *     return HttpResponse.json({
 *       data: { networkBlocksByIp }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityNetworkBlocksQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityNetworkBlocksQueryOperationQuery, EntityNetworkBlocksQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityNetworkBlocksQueryOperationQuery, EntityNetworkBlocksQueryOperationQueryVariables>(
    'EntityNetworkBlocksQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityAsideUpdateSuppressionMutation(
 *   ({ query, variables }) => {
 *     const { entityId, whitelistFlag } = variables;
 *     return HttpResponse.json({
 *       data: { updateEntityWhitelist }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityAsideUpdateSuppressionMutation = (resolver: GraphQLResponseResolver<EntityAsideUpdateSuppressionMutation, EntityAsideUpdateSuppressionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EntityAsideUpdateSuppressionMutation, EntityAsideUpdateSuppressionMutationVariables>(
    'EntityAsideUpdateSuppression',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityInputTagsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { entity, entityTagOptions, tagSchemas }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityInputTagsQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityInputTagsQueryOperationQuery, EntityInputTagsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityInputTagsQueryOperationQuery, EntityInputTagsQueryOperationQueryVariables>(
    'EntityInputTagsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityInputTagsUpdateOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, tags } = variables;
 *     return HttpResponse.json({
 *       data: { updateEntityTags }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityInputTagsUpdateOperationMutation = (resolver: GraphQLResponseResolver<EntityInputTagsUpdateOperationMutation, EntityInputTagsUpdateOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EntityInputTagsUpdateOperationMutation, EntityInputTagsUpdateOperationMutationVariables>(
    'EntityInputTagsUpdateOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityInputTagsDeleteOperationMutation(
 *   ({ query, variables }) => {
 *     const { id, tags } = variables;
 *     return HttpResponse.json({
 *       data: { removeEntityTags }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityInputTagsDeleteOperationMutation = (resolver: GraphQLResponseResolver<EntityInputTagsDeleteOperationMutation, EntityInputTagsDeleteOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EntityInputTagsDeleteOperationMutation, EntityInputTagsDeleteOperationMutationVariables>(
    'EntityInputTagsDeleteOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityInputCriticalityQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { entityCriticalityConfigs, entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityInputCriticalityQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityInputCriticalityQueryOperationQuery, EntityInputCriticalityQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityInputCriticalityQueryOperationQuery, EntityInputCriticalityQueryOperationQueryVariables>(
    'EntityInputCriticalityQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockUpdateEntityInputCriticalityMutation(
 *   ({ query, variables }) => {
 *     const { entityId, criticality } = variables;
 *     return HttpResponse.json({
 *       data: { updateEntityCriticality }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockUpdateEntityInputCriticalityMutation = (resolver: GraphQLResponseResolver<UpdateEntityInputCriticalityMutation, UpdateEntityInputCriticalityMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<UpdateEntityInputCriticalityMutation, UpdateEntityInputCriticalityMutationVariables>(
    'UpdateEntityInputCriticality',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityAutomationsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { automations }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityAutomationsQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityAutomationsQueryOperationQuery, EntityAutomationsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityAutomationsQueryOperationQuery, EntityAutomationsQueryOperationQueryVariables>(
    'EntityAutomationsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityTypeQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityTypeQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityTypeQueryOperationQuery, EntityTypeQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityTypeQueryOperationQuery, EntityTypeQueryOperationQueryVariables>(
    'EntityTypeQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockExecuteEntityAutomationOperationMutation(
 *   ({ query, variables }) => {
 *     const { fields } = variables;
 *     return HttpResponse.json({
 *       data: { executeAutomation }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockExecuteEntityAutomationOperationMutation = (resolver: GraphQLResponseResolver<ExecuteEntityAutomationOperationMutation, ExecuteEntityAutomationOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<ExecuteEntityAutomationOperationMutation, ExecuteEntityAutomationOperationMutationVariables>(
    'ExecuteEntityAutomationOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityFormNotesQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { entityId } = variables;
 *     return HttpResponse.json({
 *       data: { currentUser, entityNotes }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityFormNotesQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityFormNotesQueryOperationQuery, EntityFormNotesQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityFormNotesQueryOperationQuery, EntityFormNotesQueryOperationQueryVariables>(
    'EntityFormNotesQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityFormNotesUpdateMutationMutation(
 *   ({ query, variables }) => {
 *     const { id, note } = variables;
 *     return HttpResponse.json({
 *       data: { addEntityNote }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityFormNotesUpdateMutationMutation = (resolver: GraphQLResponseResolver<EntityFormNotesUpdateMutation, EntityFormNotesUpdateMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EntityFormNotesUpdateMutation, EntityFormNotesUpdateMutationVariables>(
    'EntityFormNotesUpdateMutation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityFormNotesDeleteMutationMutation(
 *   ({ query, variables }) => {
 *     const { entityId, entityNoteId } = variables;
 *     return HttpResponse.json({
 *       data: { deleteEntityNote }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityFormNotesDeleteMutationMutation = (resolver: GraphQLResponseResolver<EntityFormNotesDeleteMutation, EntityFormNotesDeleteMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<EntityFormNotesDeleteMutation, EntityFormNotesDeleteMutationVariables>(
    'EntityFormNotesDeleteMutation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightExecutedAutomationQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { insight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightExecutedAutomationQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightExecutedAutomationQueryOperationQuery, InsightExecutedAutomationQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightExecutedAutomationQueryOperationQuery, InsightExecutedAutomationQueryOperationQueryVariables>(
    'InsightExecutedAutomationQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityExecutedAutomationsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityExecutedAutomationsQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityExecutedAutomationsQueryOperationQuery, EntityExecutedAutomationsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityExecutedAutomationsQueryOperationQuery, EntityExecutedAutomationsQueryOperationQueryVariables>(
    'EntityExecutedAutomationsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightDisplayQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { insight }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightDisplayQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightDisplayQueryOperationQuery, InsightDisplayQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightDisplayQueryOperationQuery, InsightDisplayQueryOperationQueryVariables>(
    'InsightDisplayQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityDisplayQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityDisplayQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityDisplayQueryOperationQuery, EntityDisplayQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityDisplayQueryOperationQuery, EntityDisplayQueryOperationQueryVariables>(
    'EntityDisplayQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCreateFavoriteFieldOperationMutation(
 *   ({ query, variables }) => {
 *     const { fieldName, fieldType } = variables;
 *     return HttpResponse.json({
 *       data: { createFavoriteField }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCreateFavoriteFieldOperationMutation = (resolver: GraphQLResponseResolver<CreateFavoriteFieldOperationMutation, CreateFavoriteFieldOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CreateFavoriteFieldOperationMutation, CreateFavoriteFieldOperationMutationVariables>(
    'CreateFavoriteFieldOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockDeleteFavoriteFieldOperationMutation(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { deleteFavoriteField }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockDeleteFavoriteFieldOperationMutation = (resolver: GraphQLResponseResolver<DeleteFavoriteFieldOperationMutation, DeleteFavoriteFieldOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<DeleteFavoriteFieldOperationMutation, DeleteFavoriteFieldOperationMutationVariables>(
    'DeleteFavoriteFieldOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockFavoriteFieldsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { favoriteFields }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockFavoriteFieldsQueryOperationQuery = (resolver: GraphQLResponseResolver<FavoriteFieldsQueryOperationQuery, FavoriteFieldsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<FavoriteFieldsQueryOperationQuery, FavoriteFieldsQueryOperationQueryVariables>(
    'FavoriteFieldsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEnabledFeatureFlagsQuery(
 *   ({ query, variables }) => {
 *     const { featureFlagsToLookup, enabledByDefaultFeatureFlags } = variables;
 *     return HttpResponse.json({
 *       data: { enabledFeatureFlags }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEnabledFeatureFlagsQuery = (resolver: GraphQLResponseResolver<EnabledFeatureFlagsQuery, EnabledFeatureFlagsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EnabledFeatureFlagsQuery, EnabledFeatureFlagsQueryVariables>(
    'EnabledFeatureFlags',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSearchFilterQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { query, resultType, fieldName, limit } = variables;
 *     return HttpResponse.json({
 *       data: { searchFieldSuggestions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSearchFilterQueryOperationQuery = (resolver: GraphQLResponseResolver<SearchFilterQueryOperationQuery, SearchFilterQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SearchFilterQueryOperationQuery, SearchFilterQueryOperationQueryVariables>(
    'SearchFilterQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightStatusQueryQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { insightStatus }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightStatusQueryQuery = (resolver: GraphQLResponseResolver<InsightStatusQuery, InsightStatusQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightStatusQuery, InsightStatusQueryVariables>(
    'InsightStatusQuery',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightStatusesQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { insightStatuses }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightStatusesQueryOperationQuery = (resolver: GraphQLResponseResolver<InsightStatusesQueryOperationQuery, InsightStatusesQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightStatusesQueryOperationQuery, InsightStatusesQueryOperationQueryVariables>(
    'InsightStatusesQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityInventoryQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { entityId, includeMetadata } = variables;
 *     return HttpResponse.json({
 *       data: { entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityInventoryQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityInventoryQueryOperationQuery, EntityInventoryQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityInventoryQueryOperationQuery, EntityInventoryQueryOperationQueryVariables>(
    'EntityInventoryQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRecordSearchResultsOperationQuery(
 *   ({ query, variables }) => {
 *     const { searchStarted, jobId, offset, limit } = variables;
 *     return HttpResponse.json({
 *       data: { sumoRecordSearchJobStatus, sumoRecordSearchJobResults, sumoRecordSearchJobObjectTypeCounts }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRecordSearchResultsOperationQuery = (resolver: GraphQLResponseResolver<RecordSearchResultsOperationQuery, RecordSearchResultsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RecordSearchResultsOperationQuery, RecordSearchResultsOperationQueryVariables>(
    'RecordSearchResultsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSumoRecordSearchOperationQuery(
 *   ({ query, variables }) => {
 *     const { q, sort, sortDir, querySyntax } = variables;
 *     return HttpResponse.json({
 *       data: { sumoRecordSearchQuery }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSumoRecordSearchOperationQuery = (resolver: GraphQLResponseResolver<SumoRecordSearchOperationQuery, SumoRecordSearchOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SumoRecordSearchOperationQuery, SumoRecordSearchOperationQueryVariables>(
    'SumoRecordSearchOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStartSumoRecordSearchJobOperationMutation(
 *   ({ query, variables }) => {
 *     const { q, querySyntax, start, end, sort, sortDir } = variables;
 *     return HttpResponse.json({
 *       data: { startSumoRecordSearchJob }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockStartSumoRecordSearchJobOperationMutation = (resolver: GraphQLResponseResolver<StartSumoRecordSearchJobOperationMutation, StartSumoRecordSearchJobOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<StartSumoRecordSearchJobOperationMutation, StartSumoRecordSearchJobOperationMutationVariables>(
    'StartSumoRecordSearchJobOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStartSumoRecordSearchJobForRuleExpressionMutation(
 *   ({ query, variables }) => {
 *     const { ruleExpression, ruleTuningTranslationExpressions, start, end } = variables;
 *     return HttpResponse.json({
 *       data: { startSumoRecordSearchJobForRuleExpression }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockStartSumoRecordSearchJobForRuleExpressionMutation = (resolver: GraphQLResponseResolver<StartSumoRecordSearchJobForRuleExpressionMutation, StartSumoRecordSearchJobForRuleExpressionMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<StartSumoRecordSearchJobForRuleExpressionMutation, StartSumoRecordSearchJobForRuleExpressionMutationVariables>(
    'startSumoRecordSearchJobForRuleExpression',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCancelSumoRecordSearchJobOperationMutation(
 *   ({ query, variables }) => {
 *     const { jobId } = variables;
 *     return HttpResponse.json({
 *       data: { cancelSumoRecordSearchJob }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCancelSumoRecordSearchJobOperationMutation = (resolver: GraphQLResponseResolver<CancelSumoRecordSearchJobOperationMutation, CancelSumoRecordSearchJobOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<CancelSumoRecordSearchJobOperationMutation, CancelSumoRecordSearchJobOperationMutationVariables>(
    'CancelSumoRecordSearchJobOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRuleExpressionResultsOperationQuery(
 *   ({ query, variables }) => {
 *     const { jobId, offset, limit } = variables;
 *     return HttpResponse.json({
 *       data: { sumoRecordSearchJobStatus, sumoRecordSearchJobResults }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRuleExpressionResultsOperationQuery = (resolver: GraphQLResponseResolver<RuleExpressionResultsOperationQuery, RuleExpressionResultsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RuleExpressionResultsOperationQuery, RuleExpressionResultsOperationQueryVariables>(
    'RuleExpressionResultsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityFieldsAndIndicatorQuery(
 *   ({ query, variables }) => {
 *     const { entityId } = variables;
 *     return HttpResponse.json({
 *       data: { entityFieldsWithTypes, entity }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityFieldsAndIndicatorQuery = (resolver: GraphQLResponseResolver<EntityFieldsAndIndicatorQuery, EntityFieldsAndIndicatorQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityFieldsAndIndicatorQuery, EntityFieldsAndIndicatorQueryVariables>(
    'EntityFieldsAndIndicator',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRelatedEntitiesQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { ip, start, end } = variables;
 *     return HttpResponse.json({
 *       data: { relatedEntities }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRelatedEntitiesQueryOperationQuery = (resolver: GraphQLResponseResolver<RelatedEntitiesQueryOperationQuery, RelatedEntitiesQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RelatedEntitiesQueryOperationQuery, RelatedEntitiesQueryOperationQueryVariables>(
    'RelatedEntitiesQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRuleItemQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { id } = variables;
 *     return HttpResponse.json({
 *       data: { rule }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRuleItemQueryOperationQuery = (resolver: GraphQLResponseResolver<RuleItemQueryOperationQuery, RuleItemQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RuleItemQueryOperationQuery, RuleItemQueryOperationQueryVariables>(
    'RuleItemQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRulesListForSelectQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { q, offset, limit, sort, sortDir } = variables;
 *     return HttpResponse.json({
 *       data: { rules }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRulesListForSelectQueryOperationQuery = (resolver: GraphQLResponseResolver<RulesListForSelectQueryOperationQuery, RulesListForSelectQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RulesListForSelectQueryOperationQuery, RulesListForSelectQueryOperationQueryVariables>(
    'RulesListForSelectQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSchemaFieldQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { logMappingOptions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSchemaFieldQueryOperationQuery = (resolver: GraphQLResponseResolver<SchemaFieldQueryOperationQuery, SchemaFieldQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SchemaFieldQueryOperationQuery, SchemaFieldQueryOperationQueryVariables>(
    'SchemaFieldQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSelectIncidentTemplateDialogOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { incidentTemplates }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSelectIncidentTemplateDialogOperationQuery = (resolver: GraphQLResponseResolver<SelectIncidentTemplateDialogOperationQuery, SelectIncidentTemplateDialogOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SelectIncidentTemplateDialogOperationQuery, SelectIncidentTemplateDialogOperationQueryVariables>(
    'SelectIncidentTemplateDialogOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockStartSumoRawMessageLookupJobOperationMutation(
 *   ({ query, variables }) => {
 *     const { messageId, timestamp } = variables;
 *     return HttpResponse.json({
 *       data: { startSumoRawMessageLookupJob }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockStartSumoRawMessageLookupJobOperationMutation = (resolver: GraphQLResponseResolver<StartSumoRawMessageLookupJobOperationMutation, StartSumoRawMessageLookupJobOperationMutationVariables>, options?: RequestHandlerOptions) =>
  graphql.mutation<StartSumoRawMessageLookupJobOperationMutation, StartSumoRawMessageLookupJobOperationMutationVariables>(
    'StartSumoRawMessageLookupJobOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSumoRawMessageLookupJobResultOperationQuery(
 *   ({ query, variables }) => {
 *     const { searchStarted, jobId } = variables;
 *     return HttpResponse.json({
 *       data: { sumoRecordSearchJobStatus, sumoRawMessageLookupJobResult }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSumoRawMessageLookupJobResultOperationQuery = (resolver: GraphQLResponseResolver<SumoRawMessageLookupJobResultOperationQuery, SumoRawMessageLookupJobResultOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SumoRawMessageLookupJobResultOperationQuery, SumoRawMessageLookupJobResultOperationQueryVariables>(
    'SumoRawMessageLookupJobResultOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockInsightTagOptionsOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { insightTagOptions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockInsightTagOptionsOperationQuery = (resolver: GraphQLResponseResolver<InsightTagOptionsOperationQuery, InsightTagOptionsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<InsightTagOptionsOperationQuery, InsightTagOptionsOperationQueryVariables>(
    'InsightTagOptionsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityTagOptionsOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { entityTagOptions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityTagOptionsOperationQuery = (resolver: GraphQLResponseResolver<EntityTagOptionsOperationQuery, EntityTagOptionsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityTagOptionsOperationQuery, EntityTagOptionsOperationQueryVariables>(
    'EntityTagOptionsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockSignalTagOptionsOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { signalTagOptions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockSignalTagOptionsOperationQuery = (resolver: GraphQLResponseResolver<SignalTagOptionsOperationQuery, SignalTagOptionsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<SignalTagOptionsOperationQuery, SignalTagOptionsOperationQueryVariables>(
    'SignalTagOptionsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRuleTagOptionsOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { ruleTagOptions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRuleTagOptionsOperationQuery = (resolver: GraphQLResponseResolver<RuleTagOptionsOperationQuery, RuleTagOptionsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RuleTagOptionsOperationQuery, RuleTagOptionsOperationQueryVariables>(
    'RuleTagOptionsOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockBulkEntityFieldsAndIndicatorQuery(
 *   ({ query, variables }) => {
 *     const { entityIds } = variables;
 *     return HttpResponse.json({
 *       data: { entityFieldsWithTypes, entitiesByListIds }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockBulkEntityFieldsAndIndicatorQuery = (resolver: GraphQLResponseResolver<BulkEntityFieldsAndIndicatorQuery, BulkEntityFieldsAndIndicatorQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<BulkEntityFieldsAndIndicatorQuery, BulkEntityFieldsAndIndicatorQueryVariables>(
    'BulkEntityFieldsAndIndicator',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockRecordSchemaOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { recordSchema }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockRecordSchemaOperationQuery = (resolver: GraphQLResponseResolver<RecordSchemaOperationQuery, RecordSchemaOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<RecordSchemaOperationQuery, RecordSchemaOperationQueryVariables>(
    'RecordSchemaOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntityFieldsQueryOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { entityFieldsWithTypes }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntityFieldsQueryOperationQuery = (resolver: GraphQLResponseResolver<EntityFieldsQueryOperationQuery, EntityFieldsQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntityFieldsQueryOperationQuery, EntityFieldsQueryOperationQueryVariables>(
    'EntityFieldsQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockPermissionsQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { currentUser }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockPermissionsQuery = (resolver: GraphQLResponseResolver<PermissionsQuery, PermissionsQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<PermissionsQuery, PermissionsQueryVariables>(
    'Permissions',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockEntitiesByListIdQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { entityIds } = variables;
 *     return HttpResponse.json({
 *       data: { entitiesByListIds }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockEntitiesByListIdQueryOperationQuery = (resolver: GraphQLResponseResolver<EntitiesByListIdQueryOperationQuery, EntitiesByListIdQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<EntitiesByListIdQueryOperationQuery, EntitiesByListIdQueryOperationQueryVariables>(
    'EntitiesByListIdQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockLinkRuleTuningExpressionQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { prefix } = variables;
 *     return HttpResponse.json({
 *       data: { ruleTuningExpressions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockLinkRuleTuningExpressionQueryOperationQuery = (resolver: GraphQLResponseResolver<LinkRuleTuningExpressionQueryOperationQuery, LinkRuleTuningExpressionQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<LinkRuleTuningExpressionQueryOperationQuery, LinkRuleTuningExpressionQueryOperationQueryVariables>(
    'LinkRuleTuningExpressionQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockTestRuleTuningExpressionQueryOperationQuery(
 *   ({ query, variables }) => {
 *     const { q } = variables;
 *     return HttpResponse.json({
 *       data: { ruleTuningExpressions }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockTestRuleTuningExpressionQueryOperationQuery = (resolver: GraphQLResponseResolver<TestRuleTuningExpressionQueryOperationQuery, TestRuleTuningExpressionQueryOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<TestRuleTuningExpressionQueryOperationQuery, TestRuleTuningExpressionQueryOperationQueryVariables>(
    'TestRuleTuningExpressionQueryOperation',
    resolver,
    options
  )

/**
 * @param resolver A function that accepts [resolver arguments](https://mswjs.io/docs/api/graphql#resolver-argument) and must always return the instruction on what to do with the intercepted request. ([see more](https://mswjs.io/docs/concepts/response-resolver#resolver-instructions))
 * @param options Options object to customize the behavior of the mock. ([see more](https://mswjs.io/docs/api/graphql#handler-options))
 * @see https://mswjs.io/docs/basics/response-resolver
 * @example
 * mockCustomMatchListColumnsOperationQuery(
 *   ({ query, variables }) => {
 *     return HttpResponse.json({
 *       data: { customMatchListColumns, customMatchListColumnLimit }
 *     })
 *   },
 *   requestOptions
 * )
 */
export const mockCustomMatchListColumnsOperationQuery = (resolver: GraphQLResponseResolver<CustomMatchListColumnsOperationQuery, CustomMatchListColumnsOperationQueryVariables>, options?: RequestHandlerOptions) =>
  graphql.query<CustomMatchListColumnsOperationQuery, CustomMatchListColumnsOperationQueryVariables>(
    'CustomMatchListColumnsOperation',
    resolver,
    options
  )


export const anAccountStatus = (overrides?: Partial<AccountStatus>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AccountStatus' } & AccountStatus => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AccountStatus');
    return {
        __typename: 'AccountStatus',
        accountActivated: overrides && overrides.hasOwnProperty('accountActivated') ? overrides.accountActivated! : true,
        applicationUse: overrides && overrides.hasOwnProperty('applicationUse') ? overrides.applicationUse! : 'volva',
        canUpdatePlan: overrides && overrides.hasOwnProperty('canUpdatePlan') ? overrides.canUpdatePlan! : false,
        logModel: overrides && overrides.hasOwnProperty('logModel') ? overrides.logModel! : 'conspergo',
        planExpirationDays: overrides && overrides.hasOwnProperty('planExpirationDays') ? overrides.planExpirationDays! : 532,
        planType: overrides && overrides.hasOwnProperty('planType') ? overrides.planType! : 'adduco',
        pricingModel: overrides && overrides.hasOwnProperty('pricingModel') ? overrides.pricingModel! : 'vindico',
        totalCredits: overrides && overrides.hasOwnProperty('totalCredits') ? overrides.totalCredits! : 4259,
    };
};

export const anAction = (overrides?: Partial<Action>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Action' } & Action => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Action');
    return {
        __typename: 'Action',
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : true,
        configuration: overrides && overrides.hasOwnProperty('configuration') ? overrides.configuration! : 'dignissimos',
        configurationJson: overrides && overrides.hasOwnProperty('configurationJson') ? overrides.configurationJson! : 'utpote',
        createdTime: overrides && overrides.hasOwnProperty('createdTime') ? overrides.createdTime! : "2025-11-26T19:09:44.236Z",
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ee7d071c-1792-46bf-9445-d022d04f50c4',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'coadunatio',
        notificationTypeEnums: overrides && overrides.hasOwnProperty('notificationTypeEnums') ? overrides.notificationTypeEnums! : [ActionNotificationType.InsightClosed, ActionNotificationType.InsightClosed, ActionNotificationType.InsightClosed],
        notificationTypes: overrides && overrides.hasOwnProperty('notificationTypes') ? overrides.notificationTypes! : 'accendo',
        parameters: overrides && overrides.hasOwnProperty('parameters') ? overrides.parameters! : [relationshipsToOmit.has('ActionParameter') ? {} as ActionParameter : anActionParameter({}, relationshipsToOmit), relationshipsToOmit.has('ActionParameter') ? {} as ActionParameter : anActionParameter({}, relationshipsToOmit), relationshipsToOmit.has('ActionParameter') ? {} as ActionParameter : anActionParameter({}, relationshipsToOmit)],
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'sns',
    };
};

export const anActionConfigurationSchema = (overrides?: Partial<ActionConfigurationSchema>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ActionConfigurationSchema' } & ActionConfigurationSchema => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ActionConfigurationSchema');
    return {
        __typename: 'ActionConfigurationSchema',
        schemaJson: overrides && overrides.hasOwnProperty('schemaJson') ? overrides.schemaJson! : "{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"title\":\"AWS Simple Notification Service\",\"type\":\"object\",\"required\":[\"topic_arn\",\"region\"],\"properties\":{\"access_key\":{\"type\":\"string\",\"ui:title\":\"Access Key\",\"ui:redactAuditLog\":true},\"secret_key\":{\"type\":\"string\",\"ui:title\":\"Secret Key\",\"ui:secret\":true,\"ui:redactAuditLog\":true},\"role_arn\":{\"type\":\"string\",\"ui:title\":\"Assume Role ARN\"},\"topic_arn\":{\"type\":\"string\",\"ui:title\":\"Topic ARN\"},\"region\":{\"type\":\"string\",\"ui:title\":\"Region\"}}}",
        typeName: overrides && overrides.hasOwnProperty('typeName') ? overrides.typeName! : 'vito',
        typeValue: overrides && overrides.hasOwnProperty('typeValue') ? overrides.typeValue! : 'sns',
    };
};

export const anActionFields = (overrides?: Partial<ActionFields>, _relationshipsToOmit: Set<string> = new Set()): ActionFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ActionFields');
    return {
        configurationJson: overrides && overrides.hasOwnProperty('configurationJson') ? overrides.configurationJson! : 'creta',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'abundans',
        notificationTypes: overrides && overrides.hasOwnProperty('notificationTypes') ? overrides.notificationTypes! : [ActionNotificationType.InsightClosed, ActionNotificationType.InsightClosed, ActionNotificationType.InsightClosed],
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'laudantium',
    };
};

export const anActionParameter = (overrides?: Partial<ActionParameter>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ActionParameter' } & ActionParameter => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ActionParameter');
    return {
        __typename: 'ActionParameter',
        displayName: overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'curso',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'clementia',
        required: overrides && overrides.hasOwnProperty('required') ? overrides.required! : false,
    };
};

export const anActionParameterValue = (overrides?: Partial<ActionParameterValue>, _relationshipsToOmit: Set<string> = new Set()): ActionParameterValue => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ActionParameterValue');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'auxilium',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'bis',
    };
};

export const anAddEntityNote = (overrides?: Partial<AddEntityNote>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddEntityNote' } & AddEntityNote => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddEntityNote');
    return {
        __typename: 'AddEntityNote',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('EntityNote') ? {} as EntityNote : anEntityNote({}, relationshipsToOmit),
    };
};

export const anAddEntityTags = (overrides?: Partial<AddEntityTags>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddEntityTags' } & AddEntityTags => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddEntityTags');
    return {
        __typename: 'AddEntityTags',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit),
    };
};

export const anAddInsightComment = (overrides?: Partial<AddInsightComment>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddInsightComment' } & AddInsightComment => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddInsightComment');
    return {
        __typename: 'AddInsightComment',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('InsightComment') ? {} as InsightComment : anInsightComment({}, relationshipsToOmit),
    };
};

export const anAddInsightCommentsById = (overrides?: Partial<AddInsightCommentsById>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddInsightCommentsById' } & AddInsightCommentsById => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddInsightCommentsById');
    return {
        __typename: 'AddInsightCommentsById',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const anAddInsightRelatedIncident = (overrides?: Partial<AddInsightRelatedIncident>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddInsightRelatedIncident' } & AddInsightRelatedIncident => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddInsightRelatedIncident');
    return {
        __typename: 'AddInsightRelatedIncident',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit),
    };
};

export const anAddInsightToIncident = (overrides?: Partial<AddInsightToIncident>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddInsightToIncident' } & AddInsightToIncident => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddInsightToIncident');
    return {
        __typename: 'AddInsightToIncident',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit),
    };
};

export const anAddItemToMatchList = (overrides?: Partial<AddItemToMatchList>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddItemToMatchList' } & AddItemToMatchList => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddItemToMatchList');
    return {
        __typename: 'AddItemToMatchList',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('MatchListItem') ? {} as MatchListItem : aMatchListItem({}, relationshipsToOmit),
        finishedProcessing: overrides && overrides.hasOwnProperty('finishedProcessing') ? overrides.finishedProcessing! : true,
    };
};

export const anAddItemToSuppressList = (overrides?: Partial<AddItemToSuppressList>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddItemToSuppressList' } & AddItemToSuppressList => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddItemToSuppressList');
    return {
        __typename: 'AddItemToSuppressList',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('SuppressListItem') ? {} as SuppressListItem : aSuppressListItem({}, relationshipsToOmit),
        finishedProcessing: overrides && overrides.hasOwnProperty('finishedProcessing') ? overrides.finishedProcessing! : false,
    };
};

export const anAddItemToThreatIntelSource = (overrides?: Partial<AddItemToThreatIntelSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddItemToThreatIntelSource' } & AddItemToThreatIntelSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddItemToThreatIntelSource');
    return {
        __typename: 'AddItemToThreatIntelSource',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ThreatIntelItem') ? {} as ThreatIntelItem : aThreatIntelItem({}, relationshipsToOmit),
        finishedProcessing: overrides && overrides.hasOwnProperty('finishedProcessing') ? overrides.finishedProcessing! : true,
    };
};

export const anAddItemsToList = (overrides?: Partial<AddItemsToList>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddItemsToList' } & AddItemsToList => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddItemsToList');
    return {
        __typename: 'AddItemsToList',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const anAddItemsToSuppressList = (overrides?: Partial<AddItemsToSuppressList>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddItemsToSuppressList' } & AddItemsToSuppressList => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddItemsToSuppressList');
    return {
        __typename: 'AddItemsToSuppressList',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const anAddItemsToThreatIntelSource = (overrides?: Partial<AddItemsToThreatIntelSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddItemsToThreatIntelSource' } & AddItemsToThreatIntelSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddItemsToThreatIntelSource');
    return {
        __typename: 'AddItemsToThreatIntelSource',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const anAddSignalsToInsight = (overrides?: Partial<AddSignalsToInsight>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddSignalsToInsight' } & AddSignalsToInsight => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddSignalsToInsight');
    return {
        __typename: 'AddSignalsToInsight',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit),
    };
};

export const anAddTagToInsight = (overrides?: Partial<AddTagToInsight>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddTagToInsight' } & AddTagToInsight => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddTagToInsight');
    return {
        __typename: 'AddTagToInsight',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit),
    };
};

export const anAddTagToInsightsById = (overrides?: Partial<AddTagToInsightsById>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddTagToInsightsById' } & AddTagToInsightsById => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddTagToInsightsById');
    return {
        __typename: 'AddTagToInsightsById',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const anAddYaraRuleToCustomYaraSource = (overrides?: Partial<AddYaraRuleToCustomYaraSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddYaraRuleToCustomYaraSource' } & AddYaraRuleToCustomYaraSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddYaraRuleToCustomYaraSource');
    return {
        __typename: 'AddYaraRuleToCustomYaraSource',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('YaraRule') ? {} as YaraRule : aYaraRule({}, relationshipsToOmit),
    };
};

export const anAddYaraRulesToCustomYaraSource = (overrides?: Partial<AddYaraRulesToCustomYaraSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AddYaraRulesToCustomYaraSource' } & AddYaraRulesToCustomYaraSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AddYaraRulesToCustomYaraSource');
    return {
        __typename: 'AddYaraRulesToCustomYaraSource',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const anAggregationRule = (overrides?: Partial<AggregationRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AggregationRule' } & AggregationRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AggregationRule');
    return {
        __typename: 'AggregationRule',
        aggregationFunctions: overrides && overrides.hasOwnProperty('aggregationFunctions') ? overrides.aggregationFunctions! : [relationshipsToOmit.has('AggregationRuleAggregationFunction') ? {} as AggregationRuleAggregationFunction : anAggregationRuleAggregationFunction({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRuleAggregationFunction') ? {} as AggregationRuleAggregationFunction : anAggregationRuleAggregationFunction({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRuleAggregationFunction') ? {} as AggregationRuleAggregationFunction : anAggregationRuleAggregationFunction({}, relationshipsToOmit)],
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'contigo',
        autoDisabledReason: overrides && overrides.hasOwnProperty('autoDisabledReason') ? overrides.autoDisabledReason! : 'videlicet',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'tempora',
        contentType: overrides && overrides.hasOwnProperty('contentType') ? overrides.contentType! : ContentType.Anomaly,
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-05-19T16:51:08.891Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'atqui',
        createdByUser: overrides && overrides.hasOwnProperty('createdByUser') ? overrides.createdByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        deleted: overrides && overrides.hasOwnProperty('deleted') ? overrides.deleted! : true,
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'sint',
        descriptionExpressionOverride: overrides && overrides.hasOwnProperty('descriptionExpressionOverride') ? overrides.descriptionExpressionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit)],
        entitySelectorsOverride: overrides && overrides.hasOwnProperty('entitySelectorsOverride') ? overrides.entitySelectorsOverride! : relationshipsToOmit.has('EntitySelectorsRuleOverride') ? {} as EntitySelectorsRuleOverride : anEntitySelectorsRuleOverride({}, relationshipsToOmit),
        exportJson: overrides && overrides.hasOwnProperty('exportJson') ? overrides.exportJson! : 'valde',
        failing: overrides && overrides.hasOwnProperty('failing') ? overrides.failing! : true,
        groupByAsset: overrides && overrides.hasOwnProperty('groupByAsset') ? overrides.groupByAsset! : true,
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['deputo', 'adopto', 'barba'],
        groupByFieldsOverride: overrides && overrides.hasOwnProperty('groupByFieldsOverride') ? overrides.groupByFieldsOverride! : relationshipsToOmit.has('StringListRuleOverride') ? {} as StringListRuleOverride : aStringListRuleOverride({}, relationshipsToOmit),
        hasOverride: overrides && overrides.hasOwnProperty('hasOverride') ? overrides.hasOverride! : false,
        history: overrides && overrides.hasOwnProperty('history') ? overrides.history! : [relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit)],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '593f18cc-ef50-4606-b408-0754e42958a4',
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        isPrototypeOverride: overrides && overrides.hasOwnProperty('isPrototypeOverride') ? overrides.isPrototypeOverride! : relationshipsToOmit.has('BooleanRuleOverride') ? {} as BooleanRuleOverride : aBooleanRuleOverride({}, relationshipsToOmit),
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-01-29T13:12:54.018Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'facilis',
        lastUpdatedByUser: overrides && overrides.hasOwnProperty('lastUpdatedByUser') ? overrides.lastUpdatedByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        matchExpression: overrides && overrides.hasOwnProperty('matchExpression') ? overrides.matchExpression! : 'vitium',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ago',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'corrumpo',
        nameExpressionOverride: overrides && overrides.hasOwnProperty('nameExpressionOverride') ? overrides.nameExpressionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        nameOverride: overrides && overrides.hasOwnProperty('nameOverride') ? overrides.nameOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : 'cff266c4-fb86-4162-be0d-b6767c725de7',
        rawJson: overrides && overrides.hasOwnProperty('rawJson') ? overrides.rawJson! : 'absque',
        rawStatus: overrides && overrides.hasOwnProperty('rawStatus') ? overrides.rawStatus! : relationshipsToOmit.has('RuleStatus') ? {} as RuleStatus : aRuleStatus({}, relationshipsToOmit),
        ruleDescription: overrides && overrides.hasOwnProperty('ruleDescription') ? overrides.ruleDescription! : 'annus',
        ruleId: overrides && overrides.hasOwnProperty('ruleId') ? overrides.ruleId! : 5791,
        ruleSource: overrides && overrides.hasOwnProperty('ruleSource') ? overrides.ruleSource! : 'adimpleo',
        ruleType: overrides && overrides.hasOwnProperty('ruleType') ? overrides.ruleType! : 'cariosus',
        scoreMapping: overrides && overrides.hasOwnProperty('scoreMapping') ? overrides.scoreMapping! : relationshipsToOmit.has('RuleScoreMapping') ? {} as RuleScoreMapping : aRuleScoreMapping({}, relationshipsToOmit),
        scoreMappingOverride: overrides && overrides.hasOwnProperty('scoreMappingOverride') ? overrides.scoreMappingOverride! : relationshipsToOmit.has('RuleScoreMappingRuleOverride') ? {} as RuleScoreMappingRuleOverride : aRuleScoreMappingRuleOverride({}, relationshipsToOmit),
        signalCount07d: overrides && overrides.hasOwnProperty('signalCount07d') ? overrides.signalCount07d! : 6298,
        signalCount24h: overrides && overrides.hasOwnProperty('signalCount24h') ? overrides.signalCount24h! : 3399,
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : relationshipsToOmit.has('RuleStatus') ? {} as RuleStatus : aRuleStatus({}, relationshipsToOmit),
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'acervus',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'tempora',
        summaryExpressionOverride: overrides && overrides.hasOwnProperty('summaryExpressionOverride') ? overrides.summaryExpressionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 5487,
        suppressionWindowSizeOverride: overrides && overrides.hasOwnProperty('suppressionWindowSizeOverride') ? overrides.suppressionWindowSizeOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['spectaculum', 'error', 'apostolus'],
        tagsOverride: overrides && overrides.hasOwnProperty('tagsOverride') ? overrides.tagsOverride! : relationshipsToOmit.has('StringListRuleOverride') ? {} as StringListRuleOverride : aStringListRuleOverride({}, relationshipsToOmit),
        triggerExpression: overrides && overrides.hasOwnProperty('triggerExpression') ? overrides.triggerExpression! : 'acerbitas',
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['eum', 'dedico', 'strues'],
        tuningExpressions: overrides && overrides.hasOwnProperty('tuningExpressions') ? overrides.tuningExpressions! : [relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit)],
        version: overrides && overrides.hasOwnProperty('version') ? overrides.version! : 3349,
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : 950,
        windowSizeName: overrides && overrides.hasOwnProperty('windowSizeName') ? overrides.windowSizeName! : 'creator',
        windowSizeOverride: overrides && overrides.hasOwnProperty('windowSizeOverride') ? overrides.windowSizeOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
    };
};

export const anAggregationRuleAggregationFunction = (overrides?: Partial<AggregationRuleAggregationFunction>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AggregationRuleAggregationFunction' } & AggregationRuleAggregationFunction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AggregationRuleAggregationFunction');
    return {
        __typename: 'AggregationRuleAggregationFunction',
        arguments: overrides && overrides.hasOwnProperty('arguments') ? overrides.arguments! : ['cenaculum', 'pecco', 'altus'],
        function: overrides && overrides.hasOwnProperty('function') ? overrides.function! : 'dignissimos',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tempore',
    };
};

export const anAggregationRuleAggregationFunctionField = (overrides?: Partial<AggregationRuleAggregationFunctionField>, _relationshipsToOmit: Set<string> = new Set()): AggregationRuleAggregationFunctionField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AggregationRuleAggregationFunctionField');
    return {
        arguments: overrides && overrides.hasOwnProperty('arguments') ? overrides.arguments! : ['sophismata', 'super', 'varietas'],
        function: overrides && overrides.hasOwnProperty('function') ? overrides.function! : 'accusator',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'alveus',
    };
};

export const anAggregationRuleFields = (overrides?: Partial<AggregationRuleFields>, _relationshipsToOmit: Set<string> = new Set()): AggregationRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AggregationRuleFields');
    return {
        aggregationFunctions: overrides && overrides.hasOwnProperty('aggregationFunctions') ? overrides.aggregationFunctions! : [relationshipsToOmit.has('AggregationRuleAggregationFunctionField') ? {} as AggregationRuleAggregationFunctionField : anAggregationRuleAggregationFunctionField({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRuleAggregationFunctionField') ? {} as AggregationRuleAggregationFunctionField : anAggregationRuleAggregationFunctionField({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRuleAggregationFunctionField') ? {} as AggregationRuleAggregationFunctionField : anAggregationRuleAggregationFunctionField({}, relationshipsToOmit)],
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'sophismata',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'pel',
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'thymum',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        groupByAsset: overrides && overrides.hasOwnProperty('groupByAsset') ? overrides.groupByAsset! : false,
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['copia', 'paens', 'animus'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        matchExpression: overrides && overrides.hasOwnProperty('matchExpression') ? overrides.matchExpression! : 'derelinquo',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'desipio',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'advenio',
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : '95f4bf20-161c-49c7-9a86-e93e0a046f70',
        scoreMapping: overrides && overrides.hasOwnProperty('scoreMapping') ? overrides.scoreMapping! : relationshipsToOmit.has('RuleScoreMappingFields') ? {} as RuleScoreMappingFields : aRuleScoreMappingFields({}, relationshipsToOmit),
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'assumenda',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'sub',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 167,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['quod', 'vero', 'odit'],
        triggerExpression: overrides && overrides.hasOwnProperty('triggerExpression') ? overrides.triggerExpression! : 'viriliter',
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['2c306a22-c1d2-4049-b18f-43f2ab6303d3', 'ba31c27a-ef7a-47cc-a716-82b7d8c43cd9', '512f1ce8-eb8a-470d-b331-57be655bb31d'],
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : RuleWindowSizeEnum.Custom,
        windowSizeMilliseconds: overrides && overrides.hasOwnProperty('windowSizeMilliseconds') ? overrides.windowSizeMilliseconds! : 342345828747507,
    };
};

export const anAggregationRuleFunction = (overrides?: Partial<AggregationRuleFunction>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AggregationRuleFunction' } & AggregationRuleFunction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AggregationRuleFunction');
    return {
        __typename: 'AggregationRuleFunction',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'attonbitus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'viscus',
        parameters: overrides && overrides.hasOwnProperty('parameters') ? overrides.parameters! : [relationshipsToOmit.has('AggregationRuleFunctionParameter') ? {} as AggregationRuleFunctionParameter : anAggregationRuleFunctionParameter({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRuleFunctionParameter') ? {} as AggregationRuleFunctionParameter : anAggregationRuleFunctionParameter({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRuleFunctionParameter') ? {} as AggregationRuleFunctionParameter : anAggregationRuleFunctionParameter({}, relationshipsToOmit)],
    };
};

export const anAggregationRuleFunctionParameter = (overrides?: Partial<AggregationRuleFunctionParameter>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AggregationRuleFunctionParameter' } & AggregationRuleFunctionParameter => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AggregationRuleFunctionParameter');
    return {
        __typename: 'AggregationRuleFunctionParameter',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'absum',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'triumphus',
    };
};

export const anAllEntityPage = (overrides?: Partial<AllEntityPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AllEntityPage' } & AllEntityPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AllEntityPage');
    return {
        __typename: 'AllEntityPage',
        nextPageToken: overrides && overrides.hasOwnProperty('nextPageToken') ? overrides.nextPageToken! : 'quaerat',
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit)],
    };
};

export const anAllInsightPage = (overrides?: Partial<AllInsightPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AllInsightPage' } & AllInsightPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AllInsightPage');
    return {
        __typename: 'AllInsightPage',
        nextPageToken: overrides && overrides.hasOwnProperty('nextPageToken') ? overrides.nextPageToken! : 'uberrime',
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit), relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit), relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit)],
    };
};

export const anAllSignalPage = (overrides?: Partial<AllSignalPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AllSignalPage' } & AllSignalPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AllSignalPage');
    return {
        __typename: 'AllSignalPage',
        nextPageToken: overrides && overrides.hasOwnProperty('nextPageToken') ? overrides.nextPageToken! : 'speciosus',
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit), relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit), relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit)],
    };
};

export const anAllThreatIntelItemPage = (overrides?: Partial<AllThreatIntelItemPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AllThreatIntelItemPage' } & AllThreatIntelItemPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AllThreatIntelItemPage');
    return {
        __typename: 'AllThreatIntelItemPage',
        nextPageToken: overrides && overrides.hasOwnProperty('nextPageToken') ? overrides.nextPageToken! : 'sumo',
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('ThreatIntelItem') ? {} as ThreatIntelItem : aThreatIntelItem({}, relationshipsToOmit), relationshipsToOmit.has('ThreatIntelItem') ? {} as ThreatIntelItem : aThreatIntelItem({}, relationshipsToOmit), relationshipsToOmit.has('ThreatIntelItem') ? {} as ThreatIntelItem : aThreatIntelItem({}, relationshipsToOmit)],
    };
};

export const anAllowedInsightStatus = (overrides?: Partial<AllowedInsightStatus>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AllowedInsightStatus' } & AllowedInsightStatus => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AllowedInsightStatus');
    return {
        __typename: 'AllowedInsightStatus',
        insightStatus: overrides && overrides.hasOwnProperty('insightStatus') ? overrides.insightStatus! : relationshipsToOmit.has('InsightStatus') ? {} as InsightStatus : anInsightStatus({}, relationshipsToOmit),
        requiredFields: overrides && overrides.hasOwnProperty('requiredFields') ? overrides.requiredFields! : [InsightRequiredFieldType.Comment, InsightRequiredFieldType.Comment, InsightRequiredFieldType.Comment],
    };
};

export const anAnomaliThreatIntelSourceFields = (overrides?: Partial<AnomaliThreatIntelSourceFields>, _relationshipsToOmit: Set<string> = new Set()): AnomaliThreatIntelSourceFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AnomaliThreatIntelSourceFields');
    return {
        apiKey: overrides && overrides.hasOwnProperty('apiKey') ? overrides.apiKey! : 'vorax',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'commemoro',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        filter: overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'alveus',
        inactiveFilter: overrides && overrides.hasOwnProperty('inactiveFilter') ? overrides.inactiveFilter! : 'theatrum',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'adflicto',
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'audio',
    };
};

export const anAuditLog = (overrides?: Partial<AuditLog>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AuditLog' } & AuditLog => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AuditLog');
    return {
        __typename: 'AuditLog',
        actingUsername: overrides && overrides.hasOwnProperty('actingUsername') ? overrides.actingUsername! : 'voco',
        actionType: overrides && overrides.hasOwnProperty('actionType') ? overrides.actionType! : 'tandem',
        authMethod: overrides && overrides.hasOwnProperty('authMethod') ? overrides.authMethod! : AuthenticationMethod.ApiKeyInAuthHeader,
        dataJson: overrides && overrides.hasOwnProperty('dataJson') ? overrides.dataJson! : 'ter',
        httpMethod: overrides && overrides.hasOwnProperty('httpMethod') ? overrides.httpMethod! : 'similique',
        path: overrides && overrides.hasOwnProperty('path') ? overrides.path! : 'annus',
        statusCode: overrides && overrides.hasOwnProperty('statusCode') ? overrides.statusCode! : 3541,
        targetType: overrides && overrides.hasOwnProperty('targetType') ? overrides.targetType! : 'despecto',
        targetsJson: overrides && overrides.hasOwnProperty('targetsJson') ? overrides.targetsJson! : 'adamo',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-05-05T04:41:13.473Z",
    };
};

export const anAuditLogPage = (overrides?: Partial<AuditLogPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AuditLogPage' } & AuditLogPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AuditLogPage');
    return {
        __typename: 'AuditLogPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('AuditLog') ? {} as AuditLog : anAuditLog({}, relationshipsToOmit), relationshipsToOmit.has('AuditLog') ? {} as AuditLog : anAuditLog({}, relationshipsToOmit), relationshipsToOmit.has('AuditLog') ? {} as AuditLog : anAuditLog({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 7774,
    };
};

export const anAutoCompleteValue = (overrides?: Partial<AutoCompleteValue>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AutoCompleteValue' } & AutoCompleteValue => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AutoCompleteValue');
    return {
        __typename: 'AutoCompleteValue',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'tres',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'demulceo',
    };
};

export const anAutoCompleteValueInput = (overrides?: Partial<AutoCompleteValueInput>, _relationshipsToOmit: Set<string> = new Set()): AutoCompleteValueInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AutoCompleteValueInput');
    return {
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'clamo',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'qui',
    };
};

export const anAutomation = (overrides?: Partial<Automation>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Automation' } & Automation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Automation');
    return {
        __typename: 'Automation',
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-05-07T16:10:37.154Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'deleo',
        cseResourceSubTypes: overrides && overrides.hasOwnProperty('cseResourceSubTypes') ? overrides.cseResourceSubTypes! : ['tabesco', 'compono', 'denique'],
        cseResourceType: overrides && overrides.hasOwnProperty('cseResourceType') ? overrides.cseResourceType! : 'peior',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'autus',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        executionTypes: overrides && overrides.hasOwnProperty('executionTypes') ? overrides.executionTypes! : ['claro', 'voluptatem', 'abeo'],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'e1958a12-370f-44ef-a8b4-2d57b9203c0d',
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-07-20T23:07:52.896Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'antiquus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'thalassinus',
        playbookId: overrides && overrides.hasOwnProperty('playbookId') ? overrides.playbookId! : 'soleo',
    };
};

export const anAutomationFields = (overrides?: Partial<AutomationFields>, _relationshipsToOmit: Set<string> = new Set()): AutomationFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AutomationFields');
    return {
        cseResourceSubTypes: overrides && overrides.hasOwnProperty('cseResourceSubTypes') ? overrides.cseResourceSubTypes! : ['video', 'culpo', 'arbitro'],
        cseResourceType: overrides && overrides.hasOwnProperty('cseResourceType') ? overrides.cseResourceType! : 'tergiversatio',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        executionTypes: overrides && overrides.hasOwnProperty('executionTypes') ? overrides.executionTypes! : ['commodo', 'inflammatio', 'cerno'],
        playbookId: overrides && overrides.hasOwnProperty('playbookId') ? overrides.playbookId! : 'arx',
    };
};

export const anAutomationPage = (overrides?: Partial<AutomationPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'AutomationPage' } & AutomationPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AutomationPage');
    return {
        __typename: 'AutomationPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('Automation') ? {} as Automation : anAutomation({}, relationshipsToOmit), relationshipsToOmit.has('Automation') ? {} as Automation : anAutomation({}, relationshipsToOmit), relationshipsToOmit.has('Automation') ? {} as Automation : anAutomation({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 523,
    };
};

export const anAutomationSort = (overrides?: Partial<AutomationSort>, _relationshipsToOmit: Set<string> = new Set()): AutomationSort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('AutomationSort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : AutomationSortableField.Created,
    };
};

export const aBaseLines = (overrides?: Partial<BaseLines>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BaseLines' } & BaseLines => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BaseLines');
    return {
        __typename: 'BaseLines',
        continuousIngest: overrides && overrides.hasOwnProperty('continuousIngest') ? overrides.continuousIngest! : 2805,
        cseIngest: overrides && overrides.hasOwnProperty('cseIngest') ? overrides.cseIngest! : 7778,
        featureActivation: overrides && overrides.hasOwnProperty('featureActivation') ? overrides.featureActivation! : relationshipsToOmit.has('FeatureActivation') ? {} as FeatureActivation : aFeatureActivation({}, relationshipsToOmit),
        frequentIngest: overrides && overrides.hasOwnProperty('frequentIngest') ? overrides.frequentIngest! : 1385,
        infrequentIngest: overrides && overrides.hasOwnProperty('infrequentIngest') ? overrides.infrequentIngest! : 9268,
        metrics: overrides && overrides.hasOwnProperty('metrics') ? overrides.metrics! : 1274,
        tracingIngest: overrides && overrides.hasOwnProperty('tracingIngest') ? overrides.tracingIngest! : 1638,
    };
};

export const aBigIntCountWithDelta = (overrides?: Partial<BigIntCountWithDelta>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BigIntCountWithDelta' } & BigIntCountWithDelta => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BigIntCountWithDelta');
    return {
        __typename: 'BigIntCountWithDelta',
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 748204947679273,
        delta: overrides && overrides.hasOwnProperty('delta') ? overrides.delta! : 0.4,
    };
};

export const aBigIntDataPoint = (overrides?: Partial<BigIntDataPoint>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BigIntDataPoint' } & BigIntDataPoint => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BigIntDataPoint');
    return {
        __typename: 'BigIntDataPoint',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-11-17T05:14:10.038Z",
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 136520989421974,
    };
};

export const aBigIntRuleOverride = (overrides?: Partial<BigIntRuleOverride>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BigIntRuleOverride' } & BigIntRuleOverride => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BigIntRuleOverride');
    return {
        __typename: 'BigIntRuleOverride',
        original: overrides && overrides.hasOwnProperty('original') ? overrides.original! : 280521304391760,
        override: overrides && overrides.hasOwnProperty('override') ? overrides.override! : 748518573886755,
    };
};

export const aBooleanRuleOverride = (overrides?: Partial<BooleanRuleOverride>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BooleanRuleOverride' } & BooleanRuleOverride => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BooleanRuleOverride');
    return {
        __typename: 'BooleanRuleOverride',
        original: overrides && overrides.hasOwnProperty('original') ? overrides.original! : false,
        override: overrides && overrides.hasOwnProperty('override') ? overrides.override! : false,
    };
};

export const aBulkAddEntityTags = (overrides?: Partial<BulkAddEntityTags>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BulkAddEntityTags' } & BulkAddEntityTags => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BulkAddEntityTags');
    return {
        __typename: 'BulkAddEntityTags',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : [relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit)],
    };
};

export const aBulkDeleteMatchListItems = (overrides?: Partial<BulkDeleteMatchListItems>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BulkDeleteMatchListItems' } & BulkDeleteMatchListItems => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BulkDeleteMatchListItems');
    return {
        __typename: 'BulkDeleteMatchListItems',
        errorResults: overrides && overrides.hasOwnProperty('errorResults') ? overrides.errorResults! : ['1d1dde63-1b41-4b82-9b2c-9ba09ebabdc3', '9844da3e-52ee-43ed-a605-e2e6c2930e93', '14e4baee-94e9-4b60-8eb4-67e4057599bb'],
    };
};

export const aBulkRemoveEntityTags = (overrides?: Partial<BulkRemoveEntityTags>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BulkRemoveEntityTags' } & BulkRemoveEntityTags => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BulkRemoveEntityTags');
    return {
        __typename: 'BulkRemoveEntityTags',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : [relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit)],
    };
};

export const aBulkUpdateEntityCriticality = (overrides?: Partial<BulkUpdateEntityCriticality>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BulkUpdateEntityCriticality' } & BulkUpdateEntityCriticality => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BulkUpdateEntityCriticality');
    return {
        __typename: 'BulkUpdateEntityCriticality',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : [relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit)],
    };
};

export const aBulkUpdateEntityTags = (overrides?: Partial<BulkUpdateEntityTags>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BulkUpdateEntityTags' } & BulkUpdateEntityTags => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BulkUpdateEntityTags');
    return {
        __typename: 'BulkUpdateEntityTags',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : [relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit)],
    };
};

export const aBulkUpdateEntityWhitelist = (overrides?: Partial<BulkUpdateEntityWhitelist>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BulkUpdateEntityWhitelist' } & BulkUpdateEntityWhitelist => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BulkUpdateEntityWhitelist');
    return {
        __typename: 'BulkUpdateEntityWhitelist',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : [relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit)],
    };
};

export const aBulkUpsertNetworkBlocks = (overrides?: Partial<BulkUpsertNetworkBlocks>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'BulkUpsertNetworkBlocks' } & BulkUpsertNetworkBlocks => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('BulkUpsertNetworkBlocks');
    return {
        __typename: 'BulkUpsertNetworkBlocks',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : [relationshipsToOmit.has('NetworkBlock') ? {} as NetworkBlock : aNetworkBlock({}, relationshipsToOmit), relationshipsToOmit.has('NetworkBlock') ? {} as NetworkBlock : aNetworkBlock({}, relationshipsToOmit), relationshipsToOmit.has('NetworkBlock') ? {} as NetworkBlock : aNetworkBlock({}, relationshipsToOmit)],
    };
};

export const aCancelSumoRecordSearchJob = (overrides?: Partial<CancelSumoRecordSearchJob>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CancelSumoRecordSearchJob' } & CancelSumoRecordSearchJob => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CancelSumoRecordSearchJob');
    return {
        __typename: 'CancelSumoRecordSearchJob',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const aCategory = (overrides?: Partial<Category>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Category' } & Category => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Category');
    return {
        __typename: 'Category',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'apto',
    };
};

export const aChainRule = (overrides?: Partial<ChainRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ChainRule' } & ChainRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ChainRule');
    return {
        __typename: 'ChainRule',
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'compono',
        autoDisabledReason: overrides && overrides.hasOwnProperty('autoDisabledReason') ? overrides.autoDisabledReason! : 'culpa',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'corroboro',
        contentType: overrides && overrides.hasOwnProperty('contentType') ? overrides.contentType! : ContentType.Anomaly,
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-02-04T07:24:43.707Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'temperantia',
        createdByUser: overrides && overrides.hasOwnProperty('createdByUser') ? overrides.createdByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        deleted: overrides && overrides.hasOwnProperty('deleted') ? overrides.deleted! : true,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'ustilo',
        descriptionOverride: overrides && overrides.hasOwnProperty('descriptionOverride') ? overrides.descriptionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit)],
        entitySelectorsOverride: overrides && overrides.hasOwnProperty('entitySelectorsOverride') ? overrides.entitySelectorsOverride! : relationshipsToOmit.has('EntitySelectorsRuleOverride') ? {} as EntitySelectorsRuleOverride : anEntitySelectorsRuleOverride({}, relationshipsToOmit),
        exportJson: overrides && overrides.hasOwnProperty('exportJson') ? overrides.exportJson! : 'aegre',
        expressionsAndLimits: overrides && overrides.hasOwnProperty('expressionsAndLimits') ? overrides.expressionsAndLimits! : [relationshipsToOmit.has('ChainRuleExpressionAndLimit') ? {} as ChainRuleExpressionAndLimit : aChainRuleExpressionAndLimit({}, relationshipsToOmit), relationshipsToOmit.has('ChainRuleExpressionAndLimit') ? {} as ChainRuleExpressionAndLimit : aChainRuleExpressionAndLimit({}, relationshipsToOmit), relationshipsToOmit.has('ChainRuleExpressionAndLimit') ? {} as ChainRuleExpressionAndLimit : aChainRuleExpressionAndLimit({}, relationshipsToOmit)],
        expressionsAndLimitsOverride: overrides && overrides.hasOwnProperty('expressionsAndLimitsOverride') ? overrides.expressionsAndLimitsOverride! : relationshipsToOmit.has('ExpressionAndLimitsRuleOverride') ? {} as ExpressionAndLimitsRuleOverride : anExpressionAndLimitsRuleOverride({}, relationshipsToOmit),
        failing: overrides && overrides.hasOwnProperty('failing') ? overrides.failing! : true,
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['sophismata', 'tres', 'cohaero'],
        groupByFieldsOverride: overrides && overrides.hasOwnProperty('groupByFieldsOverride') ? overrides.groupByFieldsOverride! : relationshipsToOmit.has('StringListRuleOverride') ? {} as StringListRuleOverride : aStringListRuleOverride({}, relationshipsToOmit),
        hasOverride: overrides && overrides.hasOwnProperty('hasOverride') ? overrides.hasOverride! : true,
        history: overrides && overrides.hasOwnProperty('history') ? overrides.history! : [relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit)],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'c178d217-74b0-448f-9ce5-cb5e28112aeb',
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : false,
        isPrototypeOverride: overrides && overrides.hasOwnProperty('isPrototypeOverride') ? overrides.isPrototypeOverride! : relationshipsToOmit.has('BooleanRuleOverride') ? {} as BooleanRuleOverride : aBooleanRuleOverride({}, relationshipsToOmit),
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-05-18T21:49:17.573Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'temeritas',
        lastUpdatedByUser: overrides && overrides.hasOwnProperty('lastUpdatedByUser') ? overrides.lastUpdatedByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'absens',
        nameOverride: overrides && overrides.hasOwnProperty('nameOverride') ? overrides.nameOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        ordered: overrides && overrides.hasOwnProperty('ordered') ? overrides.ordered! : true,
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : 'c3af0aff-ed9b-40f6-aa38-a48440166fb9',
        rawJson: overrides && overrides.hasOwnProperty('rawJson') ? overrides.rawJson! : 'stella',
        rawStatus: overrides && overrides.hasOwnProperty('rawStatus') ? overrides.rawStatus! : relationshipsToOmit.has('RuleStatus') ? {} as RuleStatus : aRuleStatus({}, relationshipsToOmit),
        ruleDescription: overrides && overrides.hasOwnProperty('ruleDescription') ? overrides.ruleDescription! : 'volutabrum',
        ruleId: overrides && overrides.hasOwnProperty('ruleId') ? overrides.ruleId! : 1739,
        ruleSource: overrides && overrides.hasOwnProperty('ruleSource') ? overrides.ruleSource! : 'arceo',
        ruleType: overrides && overrides.hasOwnProperty('ruleType') ? overrides.ruleType! : 'abscido',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 8344,
        scoreOverride: overrides && overrides.hasOwnProperty('scoreOverride') ? overrides.scoreOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
        signalCount07d: overrides && overrides.hasOwnProperty('signalCount07d') ? overrides.signalCount07d! : 5468,
        signalCount24h: overrides && overrides.hasOwnProperty('signalCount24h') ? overrides.signalCount24h! : 3334,
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : relationshipsToOmit.has('RuleStatus') ? {} as RuleStatus : aRuleStatus({}, relationshipsToOmit),
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'amaritudo',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'pecto',
        summaryExpressionOverride: overrides && overrides.hasOwnProperty('summaryExpressionOverride') ? overrides.summaryExpressionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 1172,
        suppressionWindowSizeOverride: overrides && overrides.hasOwnProperty('suppressionWindowSizeOverride') ? overrides.suppressionWindowSizeOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['attollo', 'eveniet', 'deficio'],
        tagsOverride: overrides && overrides.hasOwnProperty('tagsOverride') ? overrides.tagsOverride! : relationshipsToOmit.has('StringListRuleOverride') ? {} as StringListRuleOverride : aStringListRuleOverride({}, relationshipsToOmit),
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['vinculum', 'contego', 'ambitus'],
        tuningExpressions: overrides && overrides.hasOwnProperty('tuningExpressions') ? overrides.tuningExpressions! : [relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit)],
        version: overrides && overrides.hasOwnProperty('version') ? overrides.version! : 3251,
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : 8586,
        windowSizeName: overrides && overrides.hasOwnProperty('windowSizeName') ? overrides.windowSizeName! : 'credo',
        windowSizeOverride: overrides && overrides.hasOwnProperty('windowSizeOverride') ? overrides.windowSizeOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
    };
};

export const aChainRuleExpressionAndLimit = (overrides?: Partial<ChainRuleExpressionAndLimit>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ChainRuleExpressionAndLimit' } & ChainRuleExpressionAndLimit => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ChainRuleExpressionAndLimit');
    return {
        __typename: 'ChainRuleExpressionAndLimit',
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'verto',
        index: overrides && overrides.hasOwnProperty('index') ? overrides.index! : 6293,
        limit: overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 1239,
    };
};

export const aChainRuleExpressionAndLimitField = (overrides?: Partial<ChainRuleExpressionAndLimitField>, _relationshipsToOmit: Set<string> = new Set()): ChainRuleExpressionAndLimitField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ChainRuleExpressionAndLimitField');
    return {
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'pecco',
        limit: overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 2263,
    };
};

export const aChainRuleFields = (overrides?: Partial<ChainRuleFields>, _relationshipsToOmit: Set<string> = new Set()): ChainRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ChainRuleFields');
    return {
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'aliquam',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'carcer',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'a',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        expressionsAndLimits: overrides && overrides.hasOwnProperty('expressionsAndLimits') ? overrides.expressionsAndLimits! : [relationshipsToOmit.has('ChainRuleExpressionAndLimitField') ? {} as ChainRuleExpressionAndLimitField : aChainRuleExpressionAndLimitField({}, relationshipsToOmit), relationshipsToOmit.has('ChainRuleExpressionAndLimitField') ? {} as ChainRuleExpressionAndLimitField : aChainRuleExpressionAndLimitField({}, relationshipsToOmit), relationshipsToOmit.has('ChainRuleExpressionAndLimitField') ? {} as ChainRuleExpressionAndLimitField : aChainRuleExpressionAndLimitField({}, relationshipsToOmit)],
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['stipes', 'cribro', 'catena'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'decretum',
        ordered: overrides && overrides.hasOwnProperty('ordered') ? overrides.ordered! : true,
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : '7e493c80-16c2-46d2-af1e-a3b1d2fcbb26',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 5723,
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'subseco',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'defluo',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 186,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['cubo', 'versus', 'socius'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['dc71f201-1b9a-45f0-91e2-624ac1a72670', '9d5b01dc-ed00-4e9f-a5c5-cbdfaea5e04c', '253116ba-2ca3-48d7-8050-786a137c18a4'],
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : RuleWindowSizeEnum.Custom,
        windowSizeMilliseconds: overrides && overrides.hasOwnProperty('windowSizeMilliseconds') ? overrides.windowSizeMilliseconds! : 62215460392907,
    };
};

export const aClearSumoLogicGeneralConfig = (overrides?: Partial<ClearSumoLogicGeneralConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ClearSumoLogicGeneralConfig' } & ClearSumoLogicGeneralConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ClearSumoLogicGeneralConfig');
    return {
        __typename: 'ClearSumoLogicGeneralConfig',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const aClearSumoLogicSupportConfig = (overrides?: Partial<ClearSumoLogicSupportConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ClearSumoLogicSupportConfig' } & ClearSumoLogicSupportConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ClearSumoLogicSupportConfig');
    return {
        __typename: 'ClearSumoLogicSupportConfig',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aComputerInventory = (overrides?: Partial<ComputerInventory>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ComputerInventory' } & ComputerInventory => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ComputerInventory');
    return {
        __typename: 'ComputerInventory',
        computerName: overrides && overrides.hasOwnProperty('computerName') ? overrides.computerName! : 'terga',
        deviceUniqueId: overrides && overrides.hasOwnProperty('deviceUniqueId') ? overrides.deviceUniqueId! : 'dicta',
        groups: overrides && overrides.hasOwnProperty('groups') ? overrides.groups! : ['minima', 'viridis', 'pariatur'],
        hostname: overrides && overrides.hasOwnProperty('hostname') ? overrides.hostname! : 'bos',
        ip: overrides && overrides.hasOwnProperty('ip') ? overrides.ip! : ['est', 'tunc', 'eius'],
        location: overrides && overrides.hasOwnProperty('location') ? overrides.location! : 'templum',
        mac: overrides && overrides.hasOwnProperty('mac') ? overrides.mac! : 'reprehenderit',
        metadataJson: overrides && overrides.hasOwnProperty('metadataJson') ? overrides.metadataJson! : "{\"objectCategory\":\"CN=Person,CN=Schema,CN=Configuration,DC=windomain,DC=local\",\"objectClass\":\"top;person;organizationalPerson;user\",\"objectSid\":\"S-1-5-21-2232977720-3053628852-2340862552-1000\",\"primaryGroupId\":\"513\",\"sAMAccountName\":\"vagrant\",\"whenCreated\":\"4/18/2020 6:58:27 AM\",\"userAccountControl\":\"66048\",\"lastLogon\":132765275609170160,\"pwdLastSet\":132316856072608530,\"accountExpires\":0,\"distinguishedName\":\"CN=vagrant,CN=Users,DC=windomain,DC=local\",\"objectGUID\":\"{ea74b2a2-2647-4c02-8941-b801e17f6bf6}\",\"cn\":\"vagrant\"}",
        natIp: overrides && overrides.hasOwnProperty('natIp') ? overrides.natIp! : ['caute', 'delego', 'sum'],
        normalizedComputerName: overrides && overrides.hasOwnProperty('normalizedComputerName') ? overrides.normalizedComputerName! : 'clibanus',
        normalizedHostname: overrides && overrides.hasOwnProperty('normalizedHostname') ? overrides.normalizedHostname! : 'volubilis',
        os: overrides && overrides.hasOwnProperty('os') ? overrides.os! : 'voluptate',
        osVersion: overrides && overrides.hasOwnProperty('osVersion') ? overrides.osVersion! : 'vociferor',
        parsedTime: overrides && overrides.hasOwnProperty('parsedTime') ? overrides.parsedTime! : 'sursum',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'abbas',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : 'avarus',
        uniqueId: overrides && overrides.hasOwnProperty('uniqueId') ? overrides.uniqueId! : 'truculenter',
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'capio',
    };
};

export const aConfirmInsightTriageRecommendation = (overrides?: Partial<ConfirmInsightTriageRecommendation>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ConfirmInsightTriageRecommendation' } & ConfirmInsightTriageRecommendation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ConfirmInsightTriageRecommendation');
    return {
        __typename: 'ConfirmInsightTriageRecommendation',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit),
    };
};

export const aContent = (overrides?: Partial<Content>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Content' } & Content => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Content');
    return {
        __typename: 'Content',
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'carcer',
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'sto',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'ipsa',
        displayName: overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'colo',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 418526201851209,
        icon: overrides && overrides.hasOwnProperty('icon') ? overrides.icon! : 'acer',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '44142c8b-bd50-4bf0-a5bf-7340eb2e48bc',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'trans',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 4450,
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'eveniet',
        parameters: overrides && overrides.hasOwnProperty('parameters') ? overrides.parameters! : [relationshipsToOmit.has('SearchQueryParameter') ? {} as SearchQueryParameter : aSearchQueryParameter({}, relationshipsToOmit), relationshipsToOmit.has('SearchQueryParameter') ? {} as SearchQueryParameter : aSearchQueryParameter({}, relationshipsToOmit), relationshipsToOmit.has('SearchQueryParameter') ? {} as SearchQueryParameter : aSearchQueryParameter({}, relationshipsToOmit)],
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 589413087638860,
        path: overrides && overrides.hasOwnProperty('path') ? overrides.path! : 'carpo',
        query: overrides && overrides.hasOwnProperty('query') ? overrides.query! : 'summopere',
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 6033,
        scheduled: overrides && overrides.hasOwnProperty('scheduled') ? overrides.scheduled! : false,
        timeRangeEnd: overrides && overrides.hasOwnProperty('timeRangeEnd') ? overrides.timeRangeEnd! : 'decumbo',
        timeRangeExpression: overrides && overrides.hasOwnProperty('timeRangeExpression') ? overrides.timeRangeExpression! : 'cunctatio',
        timeRangeStart: overrides && overrides.hasOwnProperty('timeRangeStart') ? overrides.timeRangeStart! : 'aro',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : ContentTypeSumo.Dashboard,
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'coerceo',
    };
};

export const aContentPage = (overrides?: Partial<ContentPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ContentPage' } & ContentPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ContentPage');
    return {
        __typename: 'ContentPage',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '59e4c947-973c-49e1-b7b3-d9d19a038356',
        items: overrides && overrides.hasOwnProperty('items') ? overrides.items! : [relationshipsToOmit.has('Content') ? {} as Content : aContent({}, relationshipsToOmit), relationshipsToOmit.has('Content') ? {} as Content : aContent({}, relationshipsToOmit), relationshipsToOmit.has('Content') ? {} as Content : aContent({}, relationshipsToOmit)],
    };
};

export const aContextAction = (overrides?: Partial<ContextAction>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ContextAction' } & ContextAction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ContextAction');
    return {
        __typename: 'ContextAction',
        allRecordFields: overrides && overrides.hasOwnProperty('allRecordFields') ? overrides.allRecordFields! : false,
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entityTypes: overrides && overrides.hasOwnProperty('entityTypes') ? overrides.entityTypes! : ['tabula', 'celer', 'itaque'],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a3cefe82-2ddf-4812-ad66-515332ff322e',
        iocTypes: overrides && overrides.hasOwnProperty('iocTypes') ? overrides.iocTypes! : [ContextActionIocType.Asn, ContextActionIocType.Asn, ContextActionIocType.Asn],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'solutio',
        recordFields: overrides && overrides.hasOwnProperty('recordFields') ? overrides.recordFields! : ['adnuo', 'repellendus', 'asporto'],
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : ContextActionSource.Jask,
        template: overrides && overrides.hasOwnProperty('template') ? overrides.template! : 'vobis',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : ContextActionType.Query,
        urlTemplate: overrides && overrides.hasOwnProperty('urlTemplate') ? overrides.urlTemplate! : 'sumo',
    };
};

export const aContextActionPage = (overrides?: Partial<ContextActionPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ContextActionPage' } & ContextActionPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ContextActionPage');
    return {
        __typename: 'ContextActionPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('ContextAction') ? {} as ContextAction : aContextAction({}, relationshipsToOmit), relationshipsToOmit.has('ContextAction') ? {} as ContextAction : aContextAction({}, relationshipsToOmit), relationshipsToOmit.has('ContextAction') ? {} as ContextAction : aContextAction({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 7668,
    };
};

export const aContextActionSort = (overrides?: Partial<ContextActionSort>, _relationshipsToOmit: Set<string> = new Set()): ContextActionSort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ContextActionSort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : ContextActionSortableField.Name,
    };
};

export const aCountForVendor = (overrides?: Partial<CountForVendor>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CountForVendor' } & CountForVendor => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CountForVendor');
    return {
        __typename: 'CountForVendor',
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 931222930821596,
        vendor: overrides && overrides.hasOwnProperty('vendor') ? overrides.vendor! : 'dedico',
    };
};

export const aCountForVendorAndProduct = (overrides?: Partial<CountForVendorAndProduct>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CountForVendorAndProduct' } & CountForVendorAndProduct => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CountForVendorAndProduct');
    return {
        __typename: 'CountForVendorAndProduct',
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 87989316529606,
        product: overrides && overrides.hasOwnProperty('product') ? overrides.product! : 'amet',
        vendor: overrides && overrides.hasOwnProperty('vendor') ? overrides.vendor! : 'ait',
    };
};

export const aCountWithDelta = (overrides?: Partial<CountWithDelta>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CountWithDelta' } & CountWithDelta => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CountWithDelta');
    return {
        __typename: 'CountWithDelta',
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 4871,
        delta: overrides && overrides.hasOwnProperty('delta') ? overrides.delta! : 0.5,
    };
};

export const aCountsByVendorAndProductDataPoint = (overrides?: Partial<CountsByVendorAndProductDataPoint>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CountsByVendorAndProductDataPoint' } & CountsByVendorAndProductDataPoint => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CountsByVendorAndProductDataPoint');
    return {
        __typename: 'CountsByVendorAndProductDataPoint',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-07-24T18:32:23.222Z",
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : [relationshipsToOmit.has('CountForVendorAndProduct') ? {} as CountForVendorAndProduct : aCountForVendorAndProduct({}, relationshipsToOmit), relationshipsToOmit.has('CountForVendorAndProduct') ? {} as CountForVendorAndProduct : aCountForVendorAndProduct({}, relationshipsToOmit), relationshipsToOmit.has('CountForVendorAndProduct') ? {} as CountForVendorAndProduct : aCountForVendorAndProduct({}, relationshipsToOmit)],
    };
};

export const aCountsByVendorDataPoint = (overrides?: Partial<CountsByVendorDataPoint>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CountsByVendorDataPoint' } & CountsByVendorDataPoint => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CountsByVendorDataPoint');
    return {
        __typename: 'CountsByVendorDataPoint',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-01-20T21:14:58.774Z",
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : [relationshipsToOmit.has('CountForVendor') ? {} as CountForVendor : aCountForVendor({}, relationshipsToOmit), relationshipsToOmit.has('CountForVendor') ? {} as CountForVendor : aCountForVendor({}, relationshipsToOmit), relationshipsToOmit.has('CountForVendor') ? {} as CountForVendor : aCountForVendor({}, relationshipsToOmit)],
    };
};

export const aCreateAction = (overrides?: Partial<CreateAction>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateAction' } & CreateAction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateAction');
    return {
        __typename: 'CreateAction',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Action') ? {} as Action : anAction({}, relationshipsToOmit),
    };
};

export const aCreateAggregationRule = (overrides?: Partial<CreateAggregationRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateAggregationRule' } & CreateAggregationRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateAggregationRule');
    return {
        __typename: 'CreateAggregationRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('AggregationRule') ? {} as AggregationRule : anAggregationRule({}, relationshipsToOmit),
    };
};

export const aCreateAggregationRuleFields = (overrides?: Partial<CreateAggregationRuleFields>, _relationshipsToOmit: Set<string> = new Set()): CreateAggregationRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateAggregationRuleFields');
    return {
        aggregationFunctions: overrides && overrides.hasOwnProperty('aggregationFunctions') ? overrides.aggregationFunctions! : [relationshipsToOmit.has('AggregationRuleAggregationFunctionField') ? {} as AggregationRuleAggregationFunctionField : anAggregationRuleAggregationFunctionField({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRuleAggregationFunctionField') ? {} as AggregationRuleAggregationFunctionField : anAggregationRuleAggregationFunctionField({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRuleAggregationFunctionField') ? {} as AggregationRuleAggregationFunctionField : anAggregationRuleAggregationFunctionField({}, relationshipsToOmit)],
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'pax',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'tabgo',
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'ventosus',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        groupByAsset: overrides && overrides.hasOwnProperty('groupByAsset') ? overrides.groupByAsset! : true,
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['baiulus', 'quo', 'viduo'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : false,
        matchExpression: overrides && overrides.hasOwnProperty('matchExpression') ? overrides.matchExpression! : 'comes',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'curto',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'advoco',
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : 'ca71db8e-aa72-4de9-a5d8-946d3d7eb5b1',
        scoreMapping: overrides && overrides.hasOwnProperty('scoreMapping') ? overrides.scoreMapping! : relationshipsToOmit.has('RuleScoreMappingFields') ? {} as RuleScoreMappingFields : aRuleScoreMappingFields({}, relationshipsToOmit),
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'vigilo',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'cotidie',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 2713,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['degusto', 'ter', 'abbas'],
        triggerExpression: overrides && overrides.hasOwnProperty('triggerExpression') ? overrides.triggerExpression! : 'vir',
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['72df8ec5-97a7-4b52-8d4e-8caedb318fa1', 'ba9eccda-e6a5-468d-98de-894867c160b7', '6296fed4-9d46-4aa9-a862-901d9eae124c'],
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : RuleWindowSizeEnum.Custom,
        windowSizeMilliseconds: overrides && overrides.hasOwnProperty('windowSizeMilliseconds') ? overrides.windowSizeMilliseconds! : 121351969214508,
    };
};

export const aCreateAnomaliThreatIntelSource = (overrides?: Partial<CreateAnomaliThreatIntelSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateAnomaliThreatIntelSource' } & CreateAnomaliThreatIntelSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateAnomaliThreatIntelSource');
    return {
        __typename: 'CreateAnomaliThreatIntelSource',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ThreatIntelSource') ? {} as ThreatIntelSource : aThreatIntelSource({}, relationshipsToOmit),
    };
};

export const aCreateAutomation = (overrides?: Partial<CreateAutomation>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateAutomation' } & CreateAutomation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateAutomation');
    return {
        __typename: 'CreateAutomation',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Automation') ? {} as Automation : anAutomation({}, relationshipsToOmit),
    };
};

export const aCreateChainRule = (overrides?: Partial<CreateChainRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateChainRule' } & CreateChainRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateChainRule');
    return {
        __typename: 'CreateChainRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ChainRule') ? {} as ChainRule : aChainRule({}, relationshipsToOmit),
    };
};

export const aCreateChainRuleFields = (overrides?: Partial<CreateChainRuleFields>, _relationshipsToOmit: Set<string> = new Set()): CreateChainRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateChainRuleFields');
    return {
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'cultura',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'verumtamen',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'sit',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        expressionsAndLimits: overrides && overrides.hasOwnProperty('expressionsAndLimits') ? overrides.expressionsAndLimits! : [relationshipsToOmit.has('ChainRuleExpressionAndLimitField') ? {} as ChainRuleExpressionAndLimitField : aChainRuleExpressionAndLimitField({}, relationshipsToOmit), relationshipsToOmit.has('ChainRuleExpressionAndLimitField') ? {} as ChainRuleExpressionAndLimitField : aChainRuleExpressionAndLimitField({}, relationshipsToOmit), relationshipsToOmit.has('ChainRuleExpressionAndLimitField') ? {} as ChainRuleExpressionAndLimitField : aChainRuleExpressionAndLimitField({}, relationshipsToOmit)],
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['subnecto', 'ater', 'advenio'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'surgo',
        ordered: overrides && overrides.hasOwnProperty('ordered') ? overrides.ordered! : false,
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : '8841f21c-9b0a-47e0-910b-1278590e7e99',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 1780,
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'adsidue',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'creo',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 7791,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['subiungo', 'sono', 'volutabrum'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['b9628fc1-552f-4074-ad12-bd880d5e0005', 'dcbb3d89-7be7-4325-af0c-4c33de4cf061', 'b02ba8ae-ddcb-4dee-87d1-a581b283846e'],
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : RuleWindowSizeEnum.Custom,
        windowSizeMilliseconds: overrides && overrides.hasOwnProperty('windowSizeMilliseconds') ? overrides.windowSizeMilliseconds! : 687667173422310,
    };
};

export const aCreateContextAction = (overrides?: Partial<CreateContextAction>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateContextAction' } & CreateContextAction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateContextAction');
    return {
        __typename: 'CreateContextAction',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ContextAction') ? {} as ContextAction : aContextAction({}, relationshipsToOmit),
    };
};

export const aCreateCustomEntityType = (overrides?: Partial<CreateCustomEntityType>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateCustomEntityType' } & CreateCustomEntityType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCustomEntityType');
    return {
        __typename: 'CreateCustomEntityType',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('CustomEntityType') ? {} as CustomEntityType : aCustomEntityType({}, relationshipsToOmit),
    };
};

export const aCreateCustomEntityTypeFields = (overrides?: Partial<CreateCustomEntityTypeFields>, _relationshipsToOmit: Set<string> = new Set()): CreateCustomEntityTypeFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCustomEntityTypeFields');
    return {
        fields: overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['sollicito', 'rerum', 'patior'],
        identifier: overrides && overrides.hasOwnProperty('identifier') ? overrides.identifier! : 'bibo',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'civitas',
    };
};

export const aCreateCustomInsight = (overrides?: Partial<CreateCustomInsight>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateCustomInsight' } & CreateCustomInsight => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCustomInsight');
    return {
        __typename: 'CreateCustomInsight',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('CustomInsight') ? {} as CustomInsight : aCustomInsight({}, relationshipsToOmit),
    };
};

export const aCreateCustomInsightFields = (overrides?: Partial<CreateCustomInsightFields>, _relationshipsToOmit: Set<string> = new Set()): CreateCustomInsightFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCustomInsightFields');
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'campana',
        dynamicSeverity: overrides && overrides.hasOwnProperty('dynamicSeverity') ? overrides.dynamicSeverity! : [relationshipsToOmit.has('DynamicInsightSeverityField') ? {} as DynamicInsightSeverityField : aDynamicInsightSeverityField({}, relationshipsToOmit), relationshipsToOmit.has('DynamicInsightSeverityField') ? {} as DynamicInsightSeverityField : aDynamicInsightSeverityField({}, relationshipsToOmit), relationshipsToOmit.has('DynamicInsightSeverityField') ? {} as DynamicInsightSeverityField : aDynamicInsightSeverityField({}, relationshipsToOmit)],
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'enim',
        ordered: overrides && overrides.hasOwnProperty('ordered') ? overrides.ordered! : true,
        ruleIds: overrides && overrides.hasOwnProperty('ruleIds') ? overrides.ruleIds! : ['ducimus', 'sperno', 'pauci'],
        severity: overrides && overrides.hasOwnProperty('severity') ? overrides.severity! : InsightSeverityPyEnum.Critical,
        signalMatchStrategy: overrides && overrides.hasOwnProperty('signalMatchStrategy') ? overrides.signalMatchStrategy! : CustomInsightSignalMatchStrategy.Entity,
        signalNames: overrides && overrides.hasOwnProperty('signalNames') ? overrides.signalNames! : ['stillicidium', 'beneficium', 'credo'],
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['verumtamen', 'cur', 'vacuus'],
    };
};

export const aCreateCustomMatchListColumn = (overrides?: Partial<CreateCustomMatchListColumn>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateCustomMatchListColumn' } & CreateCustomMatchListColumn => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCustomMatchListColumn');
    return {
        __typename: 'CreateCustomMatchListColumn',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('CustomMatchListColumn') ? {} as CustomMatchListColumn : aCustomMatchListColumn({}, relationshipsToOmit),
    };
};

export const aCreateCustomThreatIntelSource = (overrides?: Partial<CreateCustomThreatIntelSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateCustomThreatIntelSource' } & CreateCustomThreatIntelSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCustomThreatIntelSource');
    return {
        __typename: 'CreateCustomThreatIntelSource',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ThreatIntelSource') ? {} as ThreatIntelSource : aThreatIntelSource({}, relationshipsToOmit),
    };
};

export const aCreateCustomYaraSource = (overrides?: Partial<CreateCustomYaraSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateCustomYaraSource' } & CreateCustomYaraSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCustomYaraSource');
    return {
        __typename: 'CreateCustomYaraSource',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('YaraSource') ? {} as YaraSource : aYaraSource({}, relationshipsToOmit),
    };
};

export const aCreateCustomerSourcedEntityLookupTable = (overrides?: Partial<CreateCustomerSourcedEntityLookupTable>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateCustomerSourcedEntityLookupTable' } & CreateCustomerSourcedEntityLookupTable => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCustomerSourcedEntityLookupTable');
    return {
        __typename: 'CreateCustomerSourcedEntityLookupTable',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('CustomerSourcedEntityLookupTable') ? {} as CustomerSourcedEntityLookupTable : aCustomerSourcedEntityLookupTable({}, relationshipsToOmit),
    };
};

export const aCreateCustomerSourcedEntityLookupTableFields = (overrides?: Partial<CreateCustomerSourcedEntityLookupTableFields>, _relationshipsToOmit: Set<string> = new Set()): CreateCustomerSourcedEntityLookupTableFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateCustomerSourcedEntityLookupTableFields');
    return {
        keyColumnName: overrides && overrides.hasOwnProperty('keyColumnName') ? overrides.keyColumnName! : 'calculus',
        sourceCategory: overrides && overrides.hasOwnProperty('sourceCategory') ? overrides.sourceCategory! : 'admiratio',
        tablePath: overrides && overrides.hasOwnProperty('tablePath') ? overrides.tablePath! : 'tenuis',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : EntityLookupTableType.HostIdToHostname,
        valueColumnName: overrides && overrides.hasOwnProperty('valueColumnName') ? overrides.valueColumnName! : 'vereor',
    };
};

export const aCreateEntityCriticalityConfig = (overrides?: Partial<CreateEntityCriticalityConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateEntityCriticalityConfig' } & CreateEntityCriticalityConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateEntityCriticalityConfig');
    return {
        __typename: 'CreateEntityCriticalityConfig',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('EntityCriticalityConfig') ? {} as EntityCriticalityConfig : anEntityCriticalityConfig({}, relationshipsToOmit),
    };
};

export const aCreateEntityCriticalityConfigFields = (overrides?: Partial<CreateEntityCriticalityConfigFields>, _relationshipsToOmit: Set<string> = new Set()): CreateEntityCriticalityConfigFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateEntityCriticalityConfigFields');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'temeritas',
        severityExpression: overrides && overrides.hasOwnProperty('severityExpression') ? overrides.severityExpression! : 'temperantia',
    };
};

export const aCreateEntityValueEntityGroupConfiguration = (overrides?: Partial<CreateEntityValueEntityGroupConfiguration>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateEntityValueEntityGroupConfiguration' } & CreateEntityValueEntityGroupConfiguration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateEntityValueEntityGroupConfiguration');
    return {
        __typename: 'CreateEntityValueEntityGroupConfiguration',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('EntityGroupConfiguration') ? {} as EntityGroupConfiguration : anEntityGroupConfiguration({}, relationshipsToOmit),
    };
};

export const aCreateFavoriteField = (overrides?: Partial<CreateFavoriteField>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateFavoriteField' } & CreateFavoriteField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateFavoriteField');
    return {
        __typename: 'CreateFavoriteField',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('FavoriteField') ? {} as FavoriteField : aFavoriteField({}, relationshipsToOmit),
    };
};

export const aCreateFirstSeenRule = (overrides?: Partial<CreateFirstSeenRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateFirstSeenRule' } & CreateFirstSeenRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateFirstSeenRule');
    return {
        __typename: 'CreateFirstSeenRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('FirstSeenRule') ? {} as FirstSeenRule : aFirstSeenRule({}, relationshipsToOmit),
    };
};

export const aCreateFirstSeenRuleFields = (overrides?: Partial<CreateFirstSeenRuleFields>, _relationshipsToOmit: Set<string> = new Set()): CreateFirstSeenRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateFirstSeenRuleFields');
    return {
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'advenio',
        baselineType: overrides && overrides.hasOwnProperty('baselineType') ? overrides.baselineType! : FirstSeenRuleBaselineType.Global,
        baselineWindowSize: overrides && overrides.hasOwnProperty('baselineWindowSize') ? overrides.baselineWindowSize! : 493579355253858,
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'talus',
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'amitto',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        filterExpression: overrides && overrides.hasOwnProperty('filterExpression') ? overrides.filterExpression! : 'claustrum',
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['ventosus', 'unde', 'bestia'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'alioqui',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'vito',
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : 'fe4b7a86-1094-4d5c-b9dd-b25f75910f62',
        retentionWindowSize: overrides && overrides.hasOwnProperty('retentionWindowSize') ? overrides.retentionWindowSize! : 763470108425610,
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 5641,
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'deludo',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 6685,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['cohaero', 'creo', 'verbum'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['d6a6e62d-2298-4a29-b7cc-739692d90bc2', '96bc17fe-1ff8-487d-a941-437a9a5e6523', 'bc4099de-ac86-461d-b4da-1d31d3161b28'],
        valueExpression: overrides && overrides.hasOwnProperty('valueExpression') ? overrides.valueExpression! : 'curriculum',
        valueFields: overrides && overrides.hasOwnProperty('valueFields') ? overrides.valueFields! : ['tripudio', 'optio', 'viscus'],
        version: overrides && overrides.hasOwnProperty('version') ? overrides.version! : 7349,
    };
};

export const aCreateGithubYaraSource = (overrides?: Partial<CreateGithubYaraSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateGithubYaraSource' } & CreateGithubYaraSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateGithubYaraSource');
    return {
        __typename: 'CreateGithubYaraSource',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('YaraSource') ? {} as YaraSource : aYaraSource({}, relationshipsToOmit),
    };
};

export const aCreateIdefenseThreatIntelSource = (overrides?: Partial<CreateIdefenseThreatIntelSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateIdefenseThreatIntelSource' } & CreateIdefenseThreatIntelSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateIdefenseThreatIntelSource');
    return {
        __typename: 'CreateIdefenseThreatIntelSource',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ThreatIntelSource') ? {} as ThreatIntelSource : aThreatIntelSource({}, relationshipsToOmit),
    };
};

export const aCreateIncidentFromInsight = (overrides?: Partial<CreateIncidentFromInsight>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateIncidentFromInsight' } & CreateIncidentFromInsight => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateIncidentFromInsight');
    return {
        __typename: 'CreateIncidentFromInsight',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit),
    };
};

export const aCreateInsightFromSignal = (overrides?: Partial<CreateInsightFromSignal>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateInsightFromSignal' } & CreateInsightFromSignal => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateInsightFromSignal');
    return {
        __typename: 'CreateInsightFromSignal',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit),
    };
};

export const aCreateInsightFromSignals = (overrides?: Partial<CreateInsightFromSignals>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateInsightFromSignals' } & CreateInsightFromSignals => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateInsightFromSignals');
    return {
        __typename: 'CreateInsightFromSignals',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit),
    };
};

export const aCreateInsightResolution = (overrides?: Partial<CreateInsightResolution>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateInsightResolution' } & CreateInsightResolution => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateInsightResolution');
    return {
        __typename: 'CreateInsightResolution',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('InsightResolution') ? {} as InsightResolution : anInsightResolution({}, relationshipsToOmit),
    };
};

export const aCreateInsightResolutionFields = (overrides?: Partial<CreateInsightResolutionFields>, _relationshipsToOmit: Set<string> = new Set()): CreateInsightResolutionFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateInsightResolutionFields');
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'aegre',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'sulum',
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 2079,
    };
};

export const aCreateInsightStatus = (overrides?: Partial<CreateInsightStatus>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateInsightStatus' } & CreateInsightStatus => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateInsightStatus');
    return {
        __typename: 'CreateInsightStatus',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('InsightStatus') ? {} as InsightStatus : anInsightStatus({}, relationshipsToOmit),
    };
};

export const aCreateInsightStatusFields = (overrides?: Partial<CreateInsightStatusFields>, _relationshipsToOmit: Set<string> = new Set()): CreateInsightStatusFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateInsightStatusFields');
    return {
        color: overrides && overrides.hasOwnProperty('color') ? overrides.color! : 'comedo',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'casus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'terra',
    };
};

export const aCreateInventoryEntityGroupConfiguration = (overrides?: Partial<CreateInventoryEntityGroupConfiguration>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateInventoryEntityGroupConfiguration' } & CreateInventoryEntityGroupConfiguration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateInventoryEntityGroupConfiguration');
    return {
        __typename: 'CreateInventoryEntityGroupConfiguration',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('EntityGroupConfiguration') ? {} as EntityGroupConfiguration : anEntityGroupConfiguration({}, relationshipsToOmit),
    };
};

export const aCreateInventoryEntityLookupTable = (overrides?: Partial<CreateInventoryEntityLookupTable>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateInventoryEntityLookupTable' } & CreateInventoryEntityLookupTable => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateInventoryEntityLookupTable');
    return {
        __typename: 'CreateInventoryEntityLookupTable',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('InventoryEntityLookupTable') ? {} as InventoryEntityLookupTable : anInventoryEntityLookupTable({}, relationshipsToOmit),
    };
};

export const aCreateInventoryEntityLookupTableFields = (overrides?: Partial<CreateInventoryEntityLookupTableFields>, _relationshipsToOmit: Set<string> = new Set()): CreateInventoryEntityLookupTableFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateInventoryEntityLookupTableFields');
    return {
        inventorySource: overrides && overrides.hasOwnProperty('inventorySource') ? overrides.inventorySource! : 'temeritas',
        sourceCategory: overrides && overrides.hasOwnProperty('sourceCategory') ? overrides.sourceCategory! : 'vulgaris',
        tablePath: overrides && overrides.hasOwnProperty('tablePath') ? overrides.tablePath! : 'vesco',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : EntityLookupTableType.HostIdToHostname,
    };
};

export const aCreateLogMapping = (overrides?: Partial<CreateLogMapping>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateLogMapping' } & CreateLogMapping => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateLogMapping');
    return {
        __typename: 'CreateLogMapping',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('LogMapping') ? {} as LogMapping : aLogMapping({}, relationshipsToOmit),
    };
};

export const aCreateLogMappingFields = (overrides?: Partial<CreateLogMappingFields>, _relationshipsToOmit: Set<string> = new Set()): CreateLogMappingFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateLogMappingFields');
    return {
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        fields: overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [relationshipsToOmit.has('LogMappingFieldFields') ? {} as LogMappingFieldFields : aLogMappingFieldFields({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingFieldFields') ? {} as LogMappingFieldFields : aLogMappingFieldFields({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingFieldFields') ? {} as LogMappingFieldFields : aLogMappingFieldFields({}, relationshipsToOmit)],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'correptius',
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 'cunctatio',
        productGuid: overrides && overrides.hasOwnProperty('productGuid') ? overrides.productGuid! : 'catena',
        recordType: overrides && overrides.hasOwnProperty('recordType') ? overrides.recordType! : 'depraedor',
        relatesEntities: overrides && overrides.hasOwnProperty('relatesEntities') ? overrides.relatesEntities! : true,
        skippedValues: overrides && overrides.hasOwnProperty('skippedValues') ? overrides.skippedValues! : ['celo', 'officia', 'conatus'],
        structuredFields: overrides && overrides.hasOwnProperty('structuredFields') ? overrides.structuredFields! : relationshipsToOmit.has('LogMappingStructuredInputFields') ? {} as LogMappingStructuredInputFields : aLogMappingStructuredInputFields({}, relationshipsToOmit),
        structuredInputs: overrides && overrides.hasOwnProperty('structuredInputs') ? overrides.structuredInputs! : [relationshipsToOmit.has('LogMappingStructuredInputFields') ? {} as LogMappingStructuredInputFields : aLogMappingStructuredInputFields({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingStructuredInputFields') ? {} as LogMappingStructuredInputFields : aLogMappingStructuredInputFields({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingStructuredInputFields') ? {} as LogMappingStructuredInputFields : aLogMappingStructuredInputFields({}, relationshipsToOmit)],
        unstructuredFields: overrides && overrides.hasOwnProperty('unstructuredFields') ? overrides.unstructuredFields! : relationshipsToOmit.has('UnstructuredLogMappingFields') ? {} as UnstructuredLogMappingFields : anUnstructuredLogMappingFields({}, relationshipsToOmit),
    };
};

export const aCreateMatchList = (overrides?: Partial<CreateMatchList>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateMatchList' } & CreateMatchList => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateMatchList');
    return {
        __typename: 'CreateMatchList',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('MatchList') ? {} as MatchList : aMatchList({}, relationshipsToOmit),
    };
};

export const aCreateMatchRule = (overrides?: Partial<CreateMatchRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateMatchRule' } & CreateMatchRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateMatchRule');
    return {
        __typename: 'CreateMatchRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('MatchRule') ? {} as MatchRule : aMatchRule({}, relationshipsToOmit),
    };
};

export const aCreateMatchRuleFields = (overrides?: Partial<CreateMatchRuleFields>, _relationshipsToOmit: Set<string> = new Set()): CreateMatchRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateMatchRuleFields');
    return {
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'officia',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'ventus',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'conor',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'correptius',
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : false,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cuppedia',
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : 'bf481d74-0d55-41ee-ab2b-c029881bd9f0',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 4120,
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'capto',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'comis',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 4088,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['decretum', 'alter', 'tumultus'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['eadd9032-e168-4b17-9144-b6aeea605dc2', '63fe7aa1-8684-4cb8-8183-ef2ad4c39a75', 'bbb6e0ac-2f20-44a5-ac25-92b921b54d5e'],
    };
};

export const aCreateNetworkBlock = (overrides?: Partial<CreateNetworkBlock>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateNetworkBlock' } & CreateNetworkBlock => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateNetworkBlock');
    return {
        __typename: 'CreateNetworkBlock',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('NetworkBlock') ? {} as NetworkBlock : aNetworkBlock({}, relationshipsToOmit),
    };
};

export const aCreateOutlierRule = (overrides?: Partial<CreateOutlierRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateOutlierRule' } & CreateOutlierRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateOutlierRule');
    return {
        __typename: 'CreateOutlierRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('OutlierRule') ? {} as OutlierRule : anOutlierRule({}, relationshipsToOmit),
    };
};

export const aCreateOutlierRuleFields = (overrides?: Partial<CreateOutlierRuleFields>, _relationshipsToOmit: Set<string> = new Set()): CreateOutlierRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateOutlierRuleFields');
    return {
        aggregationFunctions: overrides && overrides.hasOwnProperty('aggregationFunctions') ? overrides.aggregationFunctions! : [relationshipsToOmit.has('OutlierRuleAggregationFunctionField') ? {} as OutlierRuleAggregationFunctionField : anOutlierRuleAggregationFunctionField({}, relationshipsToOmit), relationshipsToOmit.has('OutlierRuleAggregationFunctionField') ? {} as OutlierRuleAggregationFunctionField : anOutlierRuleAggregationFunctionField({}, relationshipsToOmit), relationshipsToOmit.has('OutlierRuleAggregationFunctionField') ? {} as OutlierRuleAggregationFunctionField : anOutlierRuleAggregationFunctionField({}, relationshipsToOmit)],
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'earum',
        baselineWindowSize: overrides && overrides.hasOwnProperty('baselineWindowSize') ? overrides.baselineWindowSize! : 206338215645377,
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'aveho',
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'comprehendo',
        deviationThreshold: overrides && overrides.hasOwnProperty('deviationThreshold') ? overrides.deviationThreshold! : 3547,
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        floorValue: overrides && overrides.hasOwnProperty('floorValue') ? overrides.floorValue! : 9399,
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['optio', 'thorax', 'tutamen'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        matchExpression: overrides && overrides.hasOwnProperty('matchExpression') ? overrides.matchExpression! : 'laudantium',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ancilla',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'correptius',
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : '87100c36-7bac-4322-b69f-ac860e2e3bff',
        retentionWindowSize: overrides && overrides.hasOwnProperty('retentionWindowSize') ? overrides.retentionWindowSize! : 129280073387515,
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 9375,
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'bibo',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 8380,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['valetudo', 'tersus', 'aspernatur'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['b92d4c6d-21f3-42e8-acb7-2a58ae9c6ad0', '93cc9f8a-ece2-4004-9a86-2fdad2f5ef50', '63af05da-0a66-4831-ab85-f39732c17e3e'],
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : RuleWindowSizeEnum.Custom,
        windowSizeMilliseconds: overrides && overrides.hasOwnProperty('windowSizeMilliseconds') ? overrides.windowSizeMilliseconds! : 186040625678634,
    };
};

export const aCreateRecordArtifactConfig = (overrides?: Partial<CreateRecordArtifactConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateRecordArtifactConfig' } & CreateRecordArtifactConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateRecordArtifactConfig');
    return {
        __typename: 'CreateRecordArtifactConfig',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('RecordArtifactConfig') ? {} as RecordArtifactConfig : aRecordArtifactConfig({}, relationshipsToOmit),
    };
};

export const aCreateRole = (overrides?: Partial<CreateRole>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateRole' } & CreateRole => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateRole');
    return {
        __typename: 'CreateRole',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Role') ? {} as Role : aRole({}, relationshipsToOmit),
    };
};

export const aCreateRoleFields = (overrides?: Partial<CreateRoleFields>, _relationshipsToOmit: Set<string> = new Set()): CreateRoleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateRoleFields');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'caute',
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : ['e57da96d-b13e-4a9a-ac9b-daebd6604472', '53c3a1c0-c65e-499d-ab70-6fab0e89e0d6', 'dc78100b-2afe-4373-a934-e166547f3004'],
    };
};

export const aCreateRuleTuningExpression = (overrides?: Partial<CreateRuleTuningExpression>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateRuleTuningExpression' } & CreateRuleTuningExpression => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateRuleTuningExpression');
    return {
        __typename: 'CreateRuleTuningExpression',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit),
    };
};

export const aCreateRuleTuningExpressionFields = (overrides?: Partial<CreateRuleTuningExpressionFields>, _relationshipsToOmit: Set<string> = new Set()): CreateRuleTuningExpressionFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateRuleTuningExpressionFields');
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'sordeo',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : true,
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'ancilla',
        isGlobal: overrides && overrides.hasOwnProperty('isGlobal') ? overrides.isGlobal! : false,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'pel',
        ruleIds: overrides && overrides.hasOwnProperty('ruleIds') ? overrides.ruleIds! : ['7a7c8bb9-969c-4f98-b8bb-8d5e23dfe38b', 'c6bf6e5e-5798-4bc5-ba34-1d6761a5d474', '345f750f-81b8-4510-896d-40edf77dc837'],
    };
};

export const aCreateStreamingExportConfiguration = (overrides?: Partial<CreateStreamingExportConfiguration>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateStreamingExportConfiguration' } & CreateStreamingExportConfiguration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateStreamingExportConfiguration');
    return {
        __typename: 'CreateStreamingExportConfiguration',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('StreamingExportConfiguration') ? {} as StreamingExportConfiguration : aStreamingExportConfiguration({}, relationshipsToOmit),
    };
};

export const aCreateSumoMapping = (overrides?: Partial<CreateSumoMapping>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateSumoMapping' } & CreateSumoMapping => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateSumoMapping');
    return {
        __typename: 'CreateSumoMapping',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('SumoMapping') ? {} as SumoMapping : aSumoMapping({}, relationshipsToOmit),
    };
};

export const aCreateSuppressList = (overrides?: Partial<CreateSuppressList>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateSuppressList' } & CreateSuppressList => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateSuppressList');
    return {
        __typename: 'CreateSuppressList',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('SuppressList') ? {} as SuppressList : aSuppressList({}, relationshipsToOmit),
    };
};

export const aCreateTagSchema = (overrides?: Partial<CreateTagSchema>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateTagSchema' } & CreateTagSchema => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateTagSchema');
    return {
        __typename: 'CreateTagSchema',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('TagSchema') ? {} as TagSchema : aTagSchema({}, relationshipsToOmit),
    };
};

export const aCreateTagSchemaFields = (overrides?: Partial<CreateTagSchemaFields>, _relationshipsToOmit: Set<string> = new Set()): CreateTagSchemaFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateTagSchemaFields');
    return {
        contentTypes: overrides && overrides.hasOwnProperty('contentTypes') ? overrides.contentTypes! : [TagContentType.CustomInsight, TagContentType.CustomInsight, TagContentType.CustomInsight],
        freeform: overrides && overrides.hasOwnProperty('freeform') ? overrides.freeform! : true,
        key: overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'f842b364-ba4e-4cbe-af22-acf82a5edb1b',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'careo',
        valueOptions: overrides && overrides.hasOwnProperty('valueOptions') ? overrides.valueOptions! : [relationshipsToOmit.has('TagSchemaValueOptionFields') ? {} as TagSchemaValueOptionFields : aTagSchemaValueOptionFields({}, relationshipsToOmit), relationshipsToOmit.has('TagSchemaValueOptionFields') ? {} as TagSchemaValueOptionFields : aTagSchemaValueOptionFields({}, relationshipsToOmit), relationshipsToOmit.has('TagSchemaValueOptionFields') ? {} as TagSchemaValueOptionFields : aTagSchemaValueOptionFields({}, relationshipsToOmit)],
    };
};

export const aCreateTaxiiThreatIntelSource = (overrides?: Partial<CreateTaxiiThreatIntelSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateTaxiiThreatIntelSource' } & CreateTaxiiThreatIntelSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateTaxiiThreatIntelSource');
    return {
        __typename: 'CreateTaxiiThreatIntelSource',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ThreatIntelSource') ? {} as ThreatIntelSource : aThreatIntelSource({}, relationshipsToOmit),
    };
};

export const aCreateTemplatedMatchRule = (overrides?: Partial<CreateTemplatedMatchRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateTemplatedMatchRule' } & CreateTemplatedMatchRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateTemplatedMatchRule');
    return {
        __typename: 'CreateTemplatedMatchRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('TemplatedMatchRule') ? {} as TemplatedMatchRule : aTemplatedMatchRule({}, relationshipsToOmit),
    };
};

export const aCreateTemplatedMatchRuleFields = (overrides?: Partial<CreateTemplatedMatchRuleFields>, _relationshipsToOmit: Set<string> = new Set()): CreateTemplatedMatchRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateTemplatedMatchRuleFields');
    return {
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'supellex',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'certe',
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'tamisium',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'compono',
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : false,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'repudiandae',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'tum',
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : 'dee8ca67-9313-4601-a725-af16b5e28966',
        scoreMapping: overrides && overrides.hasOwnProperty('scoreMapping') ? overrides.scoreMapping! : relationshipsToOmit.has('RuleScoreMappingFields') ? {} as RuleScoreMappingFields : aRuleScoreMappingFields({}, relationshipsToOmit),
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'cervus',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'decerno',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 48,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['solutio', 'ipsam', 'commodo'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['aafe0450-3fe6-457b-b257-29b1295e48c3', '9a72b759-34a8-4f38-8138-5524ba3cbf7f', '81786a23-3e62-4ba2-babc-5eed64ce163b'],
    };
};

export const aCreateThreatQThreatIntelSource = (overrides?: Partial<CreateThreatQThreatIntelSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateThreatQThreatIntelSource' } & CreateThreatQThreatIntelSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateThreatQThreatIntelSource');
    return {
        __typename: 'CreateThreatQThreatIntelSource',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ThreatIntelSource') ? {} as ThreatIntelSource : aThreatIntelSource({}, relationshipsToOmit),
    };
};

export const aCreateThresholdRule = (overrides?: Partial<CreateThresholdRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreateThresholdRule' } & CreateThresholdRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateThresholdRule');
    return {
        __typename: 'CreateThresholdRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ThresholdRule') ? {} as ThresholdRule : aThresholdRule({}, relationshipsToOmit),
    };
};

export const aCreateThresholdRuleFields = (overrides?: Partial<CreateThresholdRuleFields>, _relationshipsToOmit: Set<string> = new Set()): CreateThresholdRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreateThresholdRuleFields');
    return {
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'deporto',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'creo',
        countDistinct: overrides && overrides.hasOwnProperty('countDistinct') ? overrides.countDistinct! : true,
        countField: overrides && overrides.hasOwnProperty('countField') ? overrides.countField! : 'soluta',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'solium',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'ipsum',
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['caelestis', 'delectus', 'acsi'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        limit: overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 1712,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'conventus',
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : '1ff3f1e8-3273-4425-b690-ee3bd1b9abe7',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 1742,
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'explicabo',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'suffoco',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 1711,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['tumultus', 'tabesco', 'sperno'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['82428a62-63d0-4530-9d0a-7e2b08beabf5', '026e940b-e015-4880-bc8d-09c49cbb19b9', '4bd160fc-86da-4821-b324-6ebf915e165b'],
        version: overrides && overrides.hasOwnProperty('version') ? overrides.version! : 6728,
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : RuleWindowSizeEnum.Custom,
        windowSizeMilliseconds: overrides && overrides.hasOwnProperty('windowSizeMilliseconds') ? overrides.windowSizeMilliseconds! : 392107631092715,
    };
};

export const aCreditSubscription = (overrides?: Partial<CreditSubscription>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreditSubscription' } & CreditSubscription => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreditSubscription');
    return {
        __typename: 'CreditSubscription',
        allocatedCredits: overrides && overrides.hasOwnProperty('allocatedCredits') ? overrides.allocatedCredits! : 3258,
        baselines: overrides && overrides.hasOwnProperty('baselines') ? overrides.baselines! : relationshipsToOmit.has('BaseLines') ? {} as BaseLines : aBaseLines({}, relationshipsToOmit),
        credits: overrides && overrides.hasOwnProperty('credits') ? overrides.credits! : 9973,
        deploymentChargeCredits: overrides && overrides.hasOwnProperty('deploymentChargeCredits') ? overrides.deploymentChargeCredits! : 9191,
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : 'curia',
        plan: overrides && overrides.hasOwnProperty('plan') ? overrides.plan! : relationshipsToOmit.has('CreditSubscriptionPlan') ? {} as CreditSubscriptionPlan : aCreditSubscriptionPlan({}, relationshipsToOmit),
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : 'canis',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : CreditSubscriptionStatus.Active,
    };
};

export const aCreditSubscriptionPlan = (overrides?: Partial<CreditSubscriptionPlan>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CreditSubscriptionPlan' } & CreditSubscriptionPlan => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CreditSubscriptionPlan');
    return {
        __typename: 'CreditSubscriptionPlan',
        planName: overrides && overrides.hasOwnProperty('planName') ? overrides.planName! : 'tolero',
    };
};

export const aCurrentUser = (overrides?: Partial<CurrentUser>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CurrentUser' } & CurrentUser => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CurrentUser');
    return {
        __typename: 'CurrentUser',
        accountNotificationsEnabled: overrides && overrides.hasOwnProperty('accountNotificationsEnabled') ? overrides.accountNotificationsEnabled! : true,
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : true,
        apiKey: overrides && overrides.hasOwnProperty('apiKey') ? overrides.apiKey! : 'adeptio',
        apiKeyEnabled: overrides && overrides.hasOwnProperty('apiKeyEnabled') ? overrides.apiKeyEnabled! : false,
        createdTime: overrides && overrides.hasOwnProperty('createdTime') ? overrides.createdTime! : "2025-09-10T02:06:38.671Z",
        displayName: overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'CSIEM E2E User (Full Permissions)',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'sbu-cse-ui+e2e@sumologic.com',
        emailConfirmed: overrides && overrides.hasOwnProperty('emailConfirmed') ? overrides.emailConfirmed! : true,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '120087074',
        insightReportNotificationInterval: overrides && overrides.hasOwnProperty('insightReportNotificationInterval') ? overrides.insightReportNotificationInterval! : NotificationInterval.Daily,
        intercomUserHash: overrides && overrides.hasOwnProperty('intercomUserHash') ? overrides.intercomUserHash! : 'ocer',
        lastActive: overrides && overrides.hasOwnProperty('lastActive') ? overrides.lastActive! : "2025-03-23T08:23:09.305Z",
        lastLogin: overrides && overrides.hasOwnProperty('lastLogin') ? overrides.lastLogin! : "2025-01-18T21:58:21.248Z",
        mfaEnabled: overrides && overrides.hasOwnProperty('mfaEnabled') ? overrides.mfaEnabled! : false,
        mfaQrCodeUrl: overrides && overrides.hasOwnProperty('mfaQrCodeUrl') ? overrides.mfaQrCodeUrl! : 'angelus',
        mfaSecret: overrides && overrides.hasOwnProperty('mfaSecret') ? overrides.mfaSecret! : 'statua',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'CSIEM E2E User (Full Permissions)',
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : ['urbs', 'accommodo', 'officia'],
        preferredDateFormat: overrides && overrides.hasOwnProperty('preferredDateFormat') ? overrides.preferredDateFormat! : 'collum',
        preferredTimezone: overrides && overrides.hasOwnProperty('preferredTimezone') ? overrides.preferredTimezone! : 'browser',
        role: overrides && overrides.hasOwnProperty('role') ? overrides.role! : 'voveo',
        showTimezoneOffset: overrides && overrides.hasOwnProperty('showTimezoneOffset') ? overrides.showTimezoneOffset! : false,
        teams: overrides && overrides.hasOwnProperty('teams') ? overrides.teams! : ['alter', 'taedium', 'demergo'],
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'sbu-cse-ui+e2e@sumologic.com',
    };
};

export const aCurrentUserSumo = (overrides?: Partial<CurrentUserSumo>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CurrentUserSumo' } & CurrentUserSumo => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CurrentUserSumo');
    return {
        __typename: 'CurrentUserSumo',
        accountOwner: overrides && overrides.hasOwnProperty('accountOwner') ? overrides.accountOwner! : true,
        accountStatus: overrides && overrides.hasOwnProperty('accountStatus') ? overrides.accountStatus! : 'recusandae',
        accountType: overrides && overrides.hasOwnProperty('accountType') ? overrides.accountType! : 'vado',
        authenticationSource: overrides && overrides.hasOwnProperty('authenticationSource') ? overrides.authenticationSource! : 'ocer',
        canManageUsers: overrides && overrides.hasOwnProperty('canManageUsers') ? overrides.canManageUsers! : false,
        daysUntilPasswordExpires: overrides && overrides.hasOwnProperty('daysUntilPasswordExpires') ? overrides.daysUntilPasswordExpires! : 269,
        defaultLoginUrl: overrides && overrides.hasOwnProperty('defaultLoginUrl') ? overrides.defaultLoginUrl! : 'vicissitudo',
        demoConversionLink: overrides && overrides.hasOwnProperty('demoConversionLink') ? overrides.demoConversionLink! : 'utilis',
        demoUser: overrides && overrides.hasOwnProperty('demoUser') ? overrides.demoUser! : true,
        deployment: overrides && overrides.hasOwnProperty('deployment') ? overrides.deployment! : 'similique',
        dynamicProperties: overrides && overrides.hasOwnProperty('dynamicProperties') ? overrides.dynamicProperties! : 'autus',
        eligibleForSelfServe: overrides && overrides.hasOwnProperty('eligibleForSelfServe') ? overrides.eligibleForSelfServe! : true,
        emailVerified: overrides && overrides.hasOwnProperty('emailVerified') ? overrides.emailVerified! : false,
        featureFlags: overrides && overrides.hasOwnProperty('featureFlags') ? overrides.featureFlags! : ['attonbitus', 'summopere', 'solium'],
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'tactus',
        helpBaseUrl: overrides && overrides.hasOwnProperty('helpBaseUrl') ? overrides.helpBaseUrl! : 'concido',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'b7e3bb8c-ce43-4255-90b1-891fc32dab27',
        isChildOrgUser: overrides && overrides.hasOwnProperty('isChildOrgUser') ? overrides.isChildOrgUser! : false,
        isInitialSetupRequired: overrides && overrides.hasOwnProperty('isInitialSetupRequired') ? overrides.isInitialSetupRequired! : true,
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'sono',
        manageAnomaly: overrides && overrides.hasOwnProperty('manageAnomaly') ? overrides.manageAnomaly! : true,
        manageCollectors: overrides && overrides.hasOwnProperty('manageCollectors') ? overrides.manageCollectors! : true,
        maximumNumberOfUsers: overrides && overrides.hasOwnProperty('maximumNumberOfUsers') ? overrides.maximumNumberOfUsers! : 7635,
        mfaAllowed: overrides && overrides.hasOwnProperty('mfaAllowed') ? overrides.mfaAllowed! : true,
        mfaCanDisable: overrides && overrides.hasOwnProperty('mfaCanDisable') ? overrides.mfaCanDisable! : true,
        mfaEnabled: overrides && overrides.hasOwnProperty('mfaEnabled') ? overrides.mfaEnabled! : true,
        mspLogoImagePath: overrides && overrides.hasOwnProperty('mspLogoImagePath') ? overrides.mspLogoImagePath! : 'ullam',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'arcus',
        orgCreationDate: overrides && overrides.hasOwnProperty('orgCreationDate') ? overrides.orgCreationDate! : 'aliquam',
        organization: overrides && overrides.hasOwnProperty('organization') ? overrides.organization! : 'territo',
        organizationId: overrides && overrides.hasOwnProperty('organizationId') ? overrides.organizationId! : 9890,
        partner: overrides && overrides.hasOwnProperty('partner') ? overrides.partner! : 'cunabula',
        partnerKnobs: overrides && overrides.hasOwnProperty('partnerKnobs') ? overrides.partnerKnobs! : 'compono',
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : ['tergiversatio', 'dolorem', 'convoco'],
        readAnomaly: overrides && overrides.hasOwnProperty('readAnomaly') ? overrides.readAnomaly! : false,
        readCollectors: overrides && overrides.hasOwnProperty('readCollectors') ? overrides.readCollectors! : false,
        requiresNewPassword: overrides && overrides.hasOwnProperty('requiresNewPassword') ? overrides.requiresNewPassword! : false,
        roles: overrides && overrides.hasOwnProperty('roles') ? overrides.roles! : ['terminatio', 'virga', 'rem'],
        samlEnabled: overrides && overrides.hasOwnProperty('samlEnabled') ? overrides.samlEnabled! : false,
        samlLockdownEnabled: overrides && overrides.hasOwnProperty('samlLockdownEnabled') ? overrides.samlLockdownEnabled! : false,
        samlLockdownUser: overrides && overrides.hasOwnProperty('samlLockdownUser') ? overrides.samlLockdownUser! : false,
        serverTimestamp: overrides && overrides.hasOwnProperty('serverTimestamp') ? overrides.serverTimestamp! : 7891,
        showDemoOverview: overrides && overrides.hasOwnProperty('showDemoOverview') ? overrides.showDemoOverview! : false,
        slaAccepted: overrides && overrides.hasOwnProperty('slaAccepted') ? overrides.slaAccepted! : true,
        switchableOrgs: overrides && overrides.hasOwnProperty('switchableOrgs') ? overrides.switchableOrgs! : [relationshipsToOmit.has('SwitchableOrg') ? {} as SwitchableOrg : aSwitchableOrg({}, relationshipsToOmit), relationshipsToOmit.has('SwitchableOrg') ? {} as SwitchableOrg : aSwitchableOrg({}, relationshipsToOmit), relationshipsToOmit.has('SwitchableOrg') ? {} as SwitchableOrg : aSwitchableOrg({}, relationshipsToOmit)],
        systemVersion: overrides && overrides.hasOwnProperty('systemVersion') ? overrides.systemVersion! : 'thorax',
        usageStatus: overrides && overrides.hasOwnProperty('usageStatus') ? overrides.usageStatus! : 'praesentium',
        userCreationTime: overrides && overrides.hasOwnProperty('userCreationTime') ? overrides.userCreationTime! : 7545,
        userHashForIntercom: overrides && overrides.hasOwnProperty('userHashForIntercom') ? overrides.userHashForIntercom! : 'tamisium',
        userIdForIntercom: overrides && overrides.hasOwnProperty('userIdForIntercom') ? overrides.userIdForIntercom! : 'cilicium',
    };
};

export const aCustomEntityType = (overrides?: Partial<CustomEntityType>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CustomEntityType' } & CustomEntityType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomEntityType');
    return {
        __typename: 'CustomEntityType',
        fields: overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['cubitum', 'amoveo', 'sui'],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ba469a69-f497-484c-8d58-24fadb9dae14',
        identifier: overrides && overrides.hasOwnProperty('identifier') ? overrides.identifier! : 'adfero',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'colo',
    };
};

export const aCustomEntityTypePage = (overrides?: Partial<CustomEntityTypePage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CustomEntityTypePage' } & CustomEntityTypePage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomEntityTypePage');
    return {
        __typename: 'CustomEntityTypePage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('CustomEntityType') ? {} as CustomEntityType : aCustomEntityType({}, relationshipsToOmit), relationshipsToOmit.has('CustomEntityType') ? {} as CustomEntityType : aCustomEntityType({}, relationshipsToOmit), relationshipsToOmit.has('CustomEntityType') ? {} as CustomEntityType : aCustomEntityType({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 6148,
    };
};

export const aCustomInsight = (overrides?: Partial<CustomInsight>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CustomInsight' } & CustomInsight => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomInsight');
    return {
        __typename: 'CustomInsight',
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-05-09T00:51:32.173Z",
        deleted: overrides && overrides.hasOwnProperty('deleted') ? overrides.deleted! : true,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'eveniet',
        dynamicSeverity: overrides && overrides.hasOwnProperty('dynamicSeverity') ? overrides.dynamicSeverity! : [relationshipsToOmit.has('DynamicInsightSeverity') ? {} as DynamicInsightSeverity : aDynamicInsightSeverity({}, relationshipsToOmit), relationshipsToOmit.has('DynamicInsightSeverity') ? {} as DynamicInsightSeverity : aDynamicInsightSeverity({}, relationshipsToOmit), relationshipsToOmit.has('DynamicInsightSeverity') ? {} as DynamicInsightSeverity : aDynamicInsightSeverity({}, relationshipsToOmit)],
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '52d069ab-348b-4812-8bd9-82856ccd4cda',
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-08-09T00:43:34.641Z",
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'sit',
        ordered: overrides && overrides.hasOwnProperty('ordered') ? overrides.ordered! : true,
        ruleIds: overrides && overrides.hasOwnProperty('ruleIds') ? overrides.ruleIds! : ['cruciamentum', 'autem', 'angelus'],
        severity: overrides && overrides.hasOwnProperty('severity') ? overrides.severity! : InsightSeverityPyEnum.Critical,
        signalMatchStrategy: overrides && overrides.hasOwnProperty('signalMatchStrategy') ? overrides.signalMatchStrategy! : CustomInsightSignalMatchStrategy.Entity,
        signalNames: overrides && overrides.hasOwnProperty('signalNames') ? overrides.signalNames! : ['cattus', 'addo', 'sui'],
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['dolorem', 'cui', 'tersus'],
    };
};

export const aCustomInsightPage = (overrides?: Partial<CustomInsightPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CustomInsightPage' } & CustomInsightPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomInsightPage');
    return {
        __typename: 'CustomInsightPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('CustomInsight') ? {} as CustomInsight : aCustomInsight({}, relationshipsToOmit), relationshipsToOmit.has('CustomInsight') ? {} as CustomInsight : aCustomInsight({}, relationshipsToOmit), relationshipsToOmit.has('CustomInsight') ? {} as CustomInsight : aCustomInsight({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 9088,
    };
};

export const aCustomMatchListColumn = (overrides?: Partial<CustomMatchListColumn>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CustomMatchListColumn' } & CustomMatchListColumn => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomMatchListColumn');
    return {
        __typename: 'CustomMatchListColumn',
        fields: overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['porro', 'valens', 'verus'],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '309ab54b-56c8-4f29-bf3d-206ad3284c3e',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ascit',
    };
};

export const aCustomMatchListColumnFields = (overrides?: Partial<CustomMatchListColumnFields>, _relationshipsToOmit: Set<string> = new Set()): CustomMatchListColumnFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomMatchListColumnFields');
    return {
        fields: overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['subseco', 'argumentum', 'combibo'],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'laboriosam',
    };
};

export const aCustomStatusCount = (overrides?: Partial<CustomStatusCount>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CustomStatusCount' } & CustomStatusCount => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomStatusCount');
    return {
        __typename: 'CustomStatusCount',
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 5039,
        statusId: overrides && overrides.hasOwnProperty('statusId') ? overrides.statusId! : 9689,
        statusName: overrides && overrides.hasOwnProperty('statusName') ? overrides.statusName! : 'abutor',
    };
};

export const aCustomThreatIntelSourceFields = (overrides?: Partial<CustomThreatIntelSourceFields>, _relationshipsToOmit: Set<string> = new Set()): CustomThreatIntelSourceFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomThreatIntelSourceFields');
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'accusamus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'succurro',
    };
};

export const aCustomYaraRuleFields = (overrides?: Partial<CustomYaraRuleFields>, _relationshipsToOmit: Set<string> = new Set()): CustomYaraRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomYaraRuleFields');
    return {
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'vinco',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'cura',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'modi',
        severity: overrides && overrides.hasOwnProperty('severity') ? overrides.severity! : 8610,
    };
};

export const aCustomYaraSourceFields = (overrides?: Partial<CustomYaraSourceFields>, _relationshipsToOmit: Set<string> = new Set()): CustomYaraSourceFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomYaraSourceFields');
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'sollers',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'adsidue',
    };
};

export const aCustomerSourcedEntityLookupTable = (overrides?: Partial<CustomerSourcedEntityLookupTable>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'CustomerSourcedEntityLookupTable' } & CustomerSourcedEntityLookupTable => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('CustomerSourcedEntityLookupTable');
    return {
        __typename: 'CustomerSourcedEntityLookupTable',
        contentId: overrides && overrides.hasOwnProperty('contentId') ? overrides.contentId! : 'non',
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-02-08T09:02:18.148Z",
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '2f1ad6c2-fe22-4340-81ce-69335f97b4cb',
        keyColumnName: overrides && overrides.hasOwnProperty('keyColumnName') ? overrides.keyColumnName! : 'supellex',
        sourceCategory: overrides && overrides.hasOwnProperty('sourceCategory') ? overrides.sourceCategory! : 'adimpleo',
        tableId: overrides && overrides.hasOwnProperty('tableId') ? overrides.tableId! : 'expedita',
        tablePath: overrides && overrides.hasOwnProperty('tablePath') ? overrides.tablePath! : 'audio',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : EntityLookupTableType.HostIdToHostname,
        valueColumnName: overrides && overrides.hasOwnProperty('valueColumnName') ? overrides.valueColumnName! : 'decet',
    };
};

export const aDashboard = (overrides?: Partial<Dashboard>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Dashboard' } & Dashboard => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Dashboard');
    return {
        __typename: 'Dashboard',
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'supplanto',
        actions: overrides && overrides.hasOwnProperty('actions') ? overrides.actions! : ['adeo', 'utor', 'aegre'],
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 291727430432875,
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'angulus',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'correptius',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 161545155967686,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 463040035221426,
        isFavorite: overrides && overrides.hasOwnProperty('isFavorite') ? overrides.isFavorite! : false,
        modifiedAt: overrides && overrides.hasOwnProperty('modifiedAt') ? overrides.modifiedAt! : 857621555182650,
        modifiedBy: overrides && overrides.hasOwnProperty('modifiedBy') ? overrides.modifiedBy! : 'solitudo',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'conitor',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 355171802387310,
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'amplitudo',
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 472231124664749,
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : ['callide', 'audentia', 'tabella'],
        relativePath: overrides && overrides.hasOwnProperty('relativePath') ? overrides.relativePath! : [relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit), relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit), relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit)],
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 482794518803398,
        sharedAt: overrides && overrides.hasOwnProperty('sharedAt') ? overrides.sharedAt! : 411564442936791,
        sharerId: overrides && overrides.hasOwnProperty('sharerId') ? overrides.sharerId! : 797532571302593,
        sharerName: overrides && overrides.hasOwnProperty('sharerName') ? overrides.sharerName! : 'cubicularis',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'truculenter',
        useViewerRbac: overrides && overrides.hasOwnProperty('useViewerRbac') ? overrides.useViewerRbac! : true,
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'aequus',
    };
};

export const aDashboardRecentItem = (overrides?: Partial<DashboardRecentItem>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DashboardRecentItem' } & DashboardRecentItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DashboardRecentItem');
    return {
        __typename: 'DashboardRecentItem',
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'animus',
        accessTime: overrides && overrides.hasOwnProperty('accessTime') ? overrides.accessTime! : 'caveo',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'cubicularis',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 208956365788217,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 5390,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'thema',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 'audio',
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'tot',
        pageType: overrides && overrides.hasOwnProperty('pageType') ? overrides.pageType! : RecentPageType.Dashboard,
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 620868465011573,
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 3860,
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'cursim',
    };
};

export const aDashboardRecentItemFields = (overrides?: Partial<DashboardRecentItemFields>, _relationshipsToOmit: Set<string> = new Set()): DashboardRecentItemFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DashboardRecentItemFields');
    return {
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'quidem',
        accessTime: overrides && overrides.hasOwnProperty('accessTime') ? overrides.accessTime! : 'accedo',
        author: overrides && overrides.hasOwnProperty('author') ? overrides.author! : 'vulgo',
        authorId: overrides && overrides.hasOwnProperty('authorId') ? overrides.authorId! : 'accusantium',
        customerId: overrides && overrides.hasOwnProperty('customerId') ? overrides.customerId! : 'terror',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'censura',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 661351031945941,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 4093,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'callide',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 'desipio',
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'quaerat',
        pageType: overrides && overrides.hasOwnProperty('pageType') ? overrides.pageType! : RecentPageType.Dashboard,
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 4732,
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'commodo',
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'audax',
    };
};

export const aDateTimeRange = (overrides?: Partial<DateTimeRange>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DateTimeRange' } & DateTimeRange => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DateTimeRange');
    return {
        __typename: 'DateTimeRange',
        end: overrides && overrides.hasOwnProperty('end') ? overrides.end! : "2025-10-15T20:22:19.209Z",
        start: overrides && overrides.hasOwnProperty('start') ? overrides.start! : "2025-04-04T10:01:01.867Z",
    };
};

export const aDeleteAction = (overrides?: Partial<DeleteAction>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteAction' } & DeleteAction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteAction');
    return {
        __typename: 'DeleteAction',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteAutomation = (overrides?: Partial<DeleteAutomation>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteAutomation' } & DeleteAutomation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteAutomation');
    return {
        __typename: 'DeleteAutomation',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const aDeleteContextAction = (overrides?: Partial<DeleteContextAction>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteContextAction' } & DeleteContextAction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteContextAction');
    return {
        __typename: 'DeleteContextAction',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const aDeleteCustomEntityType = (overrides?: Partial<DeleteCustomEntityType>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteCustomEntityType' } & DeleteCustomEntityType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteCustomEntityType');
    return {
        __typename: 'DeleteCustomEntityType',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteCustomInsight = (overrides?: Partial<DeleteCustomInsight>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteCustomInsight' } & DeleteCustomInsight => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteCustomInsight');
    return {
        __typename: 'DeleteCustomInsight',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteCustomMatchListColumn = (overrides?: Partial<DeleteCustomMatchListColumn>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteCustomMatchListColumn' } & DeleteCustomMatchListColumn => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteCustomMatchListColumn');
    return {
        __typename: 'DeleteCustomMatchListColumn',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteCustomYaraRule = (overrides?: Partial<DeleteCustomYaraRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteCustomYaraRule' } & DeleteCustomYaraRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteCustomYaraRule');
    return {
        __typename: 'DeleteCustomYaraRule',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteCustomerSourcedEntityLookupTable = (overrides?: Partial<DeleteCustomerSourcedEntityLookupTable>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteCustomerSourcedEntityLookupTable' } & DeleteCustomerSourcedEntityLookupTable => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteCustomerSourcedEntityLookupTable');
    return {
        __typename: 'DeleteCustomerSourcedEntityLookupTable',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const aDeleteEntityCriticalityConfig = (overrides?: Partial<DeleteEntityCriticalityConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteEntityCriticalityConfig' } & DeleteEntityCriticalityConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteEntityCriticalityConfig');
    return {
        __typename: 'DeleteEntityCriticalityConfig',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const aDeleteEntityGroupConfiguration = (overrides?: Partial<DeleteEntityGroupConfiguration>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteEntityGroupConfiguration' } & DeleteEntityGroupConfiguration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteEntityGroupConfiguration');
    return {
        __typename: 'DeleteEntityGroupConfiguration',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteEntityNote = (overrides?: Partial<DeleteEntityNote>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteEntityNote' } & DeleteEntityNote => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteEntityNote');
    return {
        __typename: 'DeleteEntityNote',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const aDeleteFavoriteField = (overrides?: Partial<DeleteFavoriteField>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteFavoriteField' } & DeleteFavoriteField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteFavoriteField');
    return {
        __typename: 'DeleteFavoriteField',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteInsight = (overrides?: Partial<DeleteInsight>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteInsight' } & DeleteInsight => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteInsight');
    return {
        __typename: 'DeleteInsight',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : 'cc1cd742-d236-428d-b34b-17ab0f7c5a4a',
    };
};

export const aDeleteInsightComment = (overrides?: Partial<DeleteInsightComment>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteInsightComment' } & DeleteInsightComment => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteInsightComment');
    return {
        __typename: 'DeleteInsightComment',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteInsightResolution = (overrides?: Partial<DeleteInsightResolution>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteInsightResolution' } & DeleteInsightResolution => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteInsightResolution');
    return {
        __typename: 'DeleteInsightResolution',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteInsightStatus = (overrides?: Partial<DeleteInsightStatus>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteInsightStatus' } & DeleteInsightStatus => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteInsightStatus');
    return {
        __typename: 'DeleteInsightStatus',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const aDeleteInsightsById = (overrides?: Partial<DeleteInsightsById>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteInsightsById' } & DeleteInsightsById => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteInsightsById');
    return {
        __typename: 'DeleteInsightsById',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteInventoryEntityLookupTable = (overrides?: Partial<DeleteInventoryEntityLookupTable>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteInventoryEntityLookupTable' } & DeleteInventoryEntityLookupTable => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteInventoryEntityLookupTable');
    return {
        __typename: 'DeleteInventoryEntityLookupTable',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteLogMapping = (overrides?: Partial<DeleteLogMapping>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteLogMapping' } & DeleteLogMapping => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteLogMapping');
    return {
        __typename: 'DeleteLogMapping',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const aDeleteMatchList = (overrides?: Partial<DeleteMatchList>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteMatchList' } & DeleteMatchList => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteMatchList');
    return {
        __typename: 'DeleteMatchList',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteMatchListItem = (overrides?: Partial<DeleteMatchListItem>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteMatchListItem' } & DeleteMatchListItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteMatchListItem');
    return {
        __typename: 'DeleteMatchListItem',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteNetworkBlock = (overrides?: Partial<DeleteNetworkBlock>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteNetworkBlock' } & DeleteNetworkBlock => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteNetworkBlock');
    return {
        __typename: 'DeleteNetworkBlock',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteRecordArtifactConfig = (overrides?: Partial<DeleteRecordArtifactConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteRecordArtifactConfig' } & DeleteRecordArtifactConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteRecordArtifactConfig');
    return {
        __typename: 'DeleteRecordArtifactConfig',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : '32412e76-763d-4dab-b6ed-deabe65828f5',
    };
};

export const aDeleteRole = (overrides?: Partial<DeleteRole>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteRole' } & DeleteRole => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteRole');
    return {
        __typename: 'DeleteRole',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Role') ? {} as Role : aRole({}, relationshipsToOmit),
    };
};

export const aDeleteRule = (overrides?: Partial<DeleteRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteRule' } & DeleteRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteRule');
    return {
        __typename: 'DeleteRule',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteRuleTuningExpression = (overrides?: Partial<DeleteRuleTuningExpression>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteRuleTuningExpression' } & DeleteRuleTuningExpression => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteRuleTuningExpression');
    return {
        __typename: 'DeleteRuleTuningExpression',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteStreamingExportConfiguration = (overrides?: Partial<DeleteStreamingExportConfiguration>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteStreamingExportConfiguration' } & DeleteStreamingExportConfiguration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteStreamingExportConfiguration');
    return {
        __typename: 'DeleteStreamingExportConfiguration',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const aDeleteSumoMapping = (overrides?: Partial<DeleteSumoMapping>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteSumoMapping' } & DeleteSumoMapping => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteSumoMapping');
    return {
        __typename: 'DeleteSumoMapping',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteSuppressList = (overrides?: Partial<DeleteSuppressList>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteSuppressList' } & DeleteSuppressList => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteSuppressList');
    return {
        __typename: 'DeleteSuppressList',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const aDeleteSuppressListItem = (overrides?: Partial<DeleteSuppressListItem>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteSuppressListItem' } & DeleteSuppressListItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteSuppressListItem');
    return {
        __typename: 'DeleteSuppressListItem',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteTagSchema = (overrides?: Partial<DeleteTagSchema>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteTagSchema' } & DeleteTagSchema => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteTagSchema');
    return {
        __typename: 'DeleteTagSchema',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const aDeleteThreatIntelItem = (overrides?: Partial<DeleteThreatIntelItem>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteThreatIntelItem' } & DeleteThreatIntelItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteThreatIntelItem');
    return {
        __typename: 'DeleteThreatIntelItem',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDeleteThreatIntelSource = (overrides?: Partial<DeleteThreatIntelSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteThreatIntelSource' } & DeleteThreatIntelSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteThreatIntelSource');
    return {
        __typename: 'DeleteThreatIntelSource',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const aDeleteYaraSource = (overrides?: Partial<DeleteYaraSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DeleteYaraSource' } & DeleteYaraSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DeleteYaraSource');
    return {
        __typename: 'DeleteYaraSource',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aDomainMapping = (overrides?: Partial<DomainMapping>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DomainMapping' } & DomainMapping => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DomainMapping');
    return {
        __typename: 'DomainMapping',
        normalizedDomain: overrides && overrides.hasOwnProperty('normalizedDomain') ? overrides.normalizedDomain! : 'credo',
        rawDomain: overrides && overrides.hasOwnProperty('rawDomain') ? overrides.rawDomain! : 'totus',
    };
};

export const aDomainMappingFields = (overrides?: Partial<DomainMappingFields>, _relationshipsToOmit: Set<string> = new Set()): DomainMappingFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DomainMappingFields');
    return {
        normalizedDomain: overrides && overrides.hasOwnProperty('normalizedDomain') ? overrides.normalizedDomain! : 'thema',
        rawDomain: overrides && overrides.hasOwnProperty('rawDomain') ? overrides.rawDomain! : 'admitto',
    };
};

export const aDownload = (overrides?: Partial<Download>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Download' } & Download => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Download');
    return {
        __typename: 'Download',
        checksum: overrides && overrides.hasOwnProperty('checksum') ? overrides.checksum! : 'sonitus',
        displayName: overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'calcar',
        environment: overrides && overrides.hasOwnProperty('environment') ? overrides.environment! : 'apud',
        fileName: overrides && overrides.hasOwnProperty('fileName') ? overrides.fileName! : 'ratione',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '947523dc-9d5a-4cc3-9292-34b37ad99763',
        isRecommendedVersion: overrides && overrides.hasOwnProperty('isRecommendedVersion') ? overrides.isRecommendedVersion! : false,
        product: overrides && overrides.hasOwnProperty('product') ? overrides.product! : 'quas',
        s3Url: overrides && overrides.hasOwnProperty('s3Url') ? overrides.s3Url! : 'vespillo',
        size: overrides && overrides.hasOwnProperty('size') ? overrides.size! : 1592,
        version: overrides && overrides.hasOwnProperty('version') ? overrides.version! : 'deficio',
    };
};

export const aDynamicInsightSeverity = (overrides?: Partial<DynamicInsightSeverity>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'DynamicInsightSeverity' } & DynamicInsightSeverity => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DynamicInsightSeverity');
    return {
        __typename: 'DynamicInsightSeverity',
        insightSeverity: overrides && overrides.hasOwnProperty('insightSeverity') ? overrides.insightSeverity! : InsightSeverityPyEnum.Critical,
        minimumSignalSeverity: overrides && overrides.hasOwnProperty('minimumSignalSeverity') ? overrides.minimumSignalSeverity! : 9243,
    };
};

export const aDynamicInsightSeverityField = (overrides?: Partial<DynamicInsightSeverityField>, _relationshipsToOmit: Set<string> = new Set()): DynamicInsightSeverityField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('DynamicInsightSeverityField');
    return {
        insightSeverity: overrides && overrides.hasOwnProperty('insightSeverity') ? overrides.insightSeverity! : InsightSeverityPyEnum.Critical,
        minimumSignalSeverity: overrides && overrides.hasOwnProperty('minimumSignalSeverity') ? overrides.minimumSignalSeverity! : 7144,
    };
};

export const anEnforcedOutputField = (overrides?: Partial<EnforcedOutputField>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'EnforcedOutputField' } & EnforcedOutputField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EnforcedOutputField');
    return {
        __typename: 'EnforcedOutputField',
        enforcedOutputs: overrides && overrides.hasOwnProperty('enforcedOutputs') ? overrides.enforcedOutputs! : ['sortitus', 'recusandae', 'conduco'],
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : 'attonbitus',
    };
};

export const anEnrichment = (overrides?: Partial<Enrichment>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Enrichment' } & Enrichment => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Enrichment');
    return {
        __typename: 'Enrichment',
        detail: overrides && overrides.hasOwnProperty('detail') ? overrides.detail! : 'praesentium',
        detailJson: overrides && overrides.hasOwnProperty('detailJson') ? overrides.detailJson! : "{}",
        enrichedObjId: overrides && overrides.hasOwnProperty('enrichedObjId') ? overrides.enrichedObjId! : 'degero',
        enrichedObjType: overrides && overrides.hasOwnProperty('enrichedObjType') ? overrides.enrichedObjType! : 'beatus',
        expiresAt: overrides && overrides.hasOwnProperty('expiresAt') ? overrides.expiresAt! : "2025-05-25T12:26:13.436Z",
        externalUrl: overrides && overrides.hasOwnProperty('externalUrl') ? overrides.externalUrl! : 'umquam',
        normalizedIndicator: overrides && overrides.hasOwnProperty('normalizedIndicator') ? overrides.normalizedIndicator! : relationshipsToOmit.has('NormalizedIndicator') ? {} as NormalizedIndicator : aNormalizedIndicator({}, relationshipsToOmit),
        raw: overrides && overrides.hasOwnProperty('raw') ? overrides.raw! : 'tyrannus',
        reputation: overrides && overrides.hasOwnProperty('reputation') ? overrides.reputation! : 'auxilium',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'tenetur',
    };
};

export const anEnrichmentConfig = (overrides?: Partial<EnrichmentConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'EnrichmentConfig' } & EnrichmentConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EnrichmentConfig');
    return {
        __typename: 'EnrichmentConfig',
        enrichment: overrides && overrides.hasOwnProperty('enrichment') ? overrides.enrichment! : 'ipsa',
        virustotalEnabled: overrides && overrides.hasOwnProperty('virustotalEnabled') ? overrides.virustotalEnabled! : true,
    };
};

export const anEntityAuditLog = (overrides?: Partial<EntityAuditLog>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'EntityAuditLog' } & EntityAuditLog => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntityAuditLog');
    return {
        __typename: 'EntityAuditLog',
        action: overrides && overrides.hasOwnProperty('action') ? overrides.action! : EntityAuditLogAction.Criticality,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '8d52a9cd-d7fb-4331-8528-a6bec738ea14',
        metaJson: overrides && overrides.hasOwnProperty('metaJson') ? overrides.metaJson! : "{}",
        suppressedComment: overrides && overrides.hasOwnProperty('suppressedComment') ? overrides.suppressedComment! : 'avarus',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-11-14T00:29:39.929Z",
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'coadunatio',
    };
};

export const anEntityChangeHistory = (overrides?: Partial<EntityChangeHistory>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'EntityChangeHistory' } & EntityChangeHistory => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntityChangeHistory');
    return {
        __typename: 'EntityChangeHistory',
        action: overrides && overrides.hasOwnProperty('action') ? overrides.action! : EntityChangeHistoryAction.Add,
        fieldName: overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'conforto',
        newValue: overrides && overrides.hasOwnProperty('newValue') ? overrides.newValue! : 'abundans',
        oldValue: overrides && overrides.hasOwnProperty('oldValue') ? overrides.oldValue! : 'coruscus',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-10-18T19:24:03.378Z",
    };
};

export const anEntityCriticalityConfig = (overrides?: Partial<EntityCriticalityConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'EntityCriticalityConfig' } & EntityCriticalityConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntityCriticalityConfig');
    return {
        __typename: 'EntityCriticalityConfig',
        entityCount: overrides && overrides.hasOwnProperty('entityCount') ? overrides.entityCount! : 6030,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '0ad89b9d-6f5f-4b91-9151-b6d33b3fdcb7',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'creta',
        severityExpression: overrides && overrides.hasOwnProperty('severityExpression') ? overrides.severityExpression! : 'usque',
    };
};

export const anEntityCriticalityConfigPage = (overrides?: Partial<EntityCriticalityConfigPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'EntityCriticalityConfigPage' } & EntityCriticalityConfigPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntityCriticalityConfigPage');
    return {
        __typename: 'EntityCriticalityConfigPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('EntityCriticalityConfig') ? {} as EntityCriticalityConfig : anEntityCriticalityConfig({}, relationshipsToOmit), relationshipsToOmit.has('EntityCriticalityConfig') ? {} as EntityCriticalityConfig : anEntityCriticalityConfig({}, relationshipsToOmit), relationshipsToOmit.has('EntityCriticalityConfig') ? {} as EntityCriticalityConfig : anEntityCriticalityConfig({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 4971,
    };
};

export const anEntityDomainConfiguration = (overrides?: Partial<EntityDomainConfiguration>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'EntityDomainConfiguration' } & EntityDomainConfiguration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntityDomainConfiguration');
    return {
        __typename: 'EntityDomainConfiguration',
        adDomainNormalizationEnabled: overrides && overrides.hasOwnProperty('adDomainNormalizationEnabled') ? overrides.adDomainNormalizationEnabled! : false,
        awsNormalizationEnabled: overrides && overrides.hasOwnProperty('awsNormalizationEnabled') ? overrides.awsNormalizationEnabled! : true,
        defaultNormalizedDomain: overrides && overrides.hasOwnProperty('defaultNormalizedDomain') ? overrides.defaultNormalizedDomain! : 'deserunt',
        domainMappings: overrides && overrides.hasOwnProperty('domainMappings') ? overrides.domainMappings! : [relationshipsToOmit.has('DomainMapping') ? {} as DomainMapping : aDomainMapping({}, relationshipsToOmit), relationshipsToOmit.has('DomainMapping') ? {} as DomainMapping : aDomainMapping({}, relationshipsToOmit), relationshipsToOmit.has('DomainMapping') ? {} as DomainMapping : aDomainMapping({}, relationshipsToOmit)],
        fqdnNormalizationEnabled: overrides && overrides.hasOwnProperty('fqdnNormalizationEnabled') ? overrides.fqdnNormalizationEnabled! : false,
        normalizeHostnames: overrides && overrides.hasOwnProperty('normalizeHostnames') ? overrides.normalizeHostnames! : false,
        normalizeUsernames: overrides && overrides.hasOwnProperty('normalizeUsernames') ? overrides.normalizeUsernames! : false,
    };
};

export const anEntityDomainConfigurationFields = (overrides?: Partial<EntityDomainConfigurationFields>, _relationshipsToOmit: Set<string> = new Set()): EntityDomainConfigurationFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntityDomainConfigurationFields');
    return {
        adDomainNormalizationEnabled: overrides && overrides.hasOwnProperty('adDomainNormalizationEnabled') ? overrides.adDomainNormalizationEnabled! : false,
        awsNormalizationEnabled: overrides && overrides.hasOwnProperty('awsNormalizationEnabled') ? overrides.awsNormalizationEnabled! : false,
        defaultNormalizedDomain: overrides && overrides.hasOwnProperty('defaultNormalizedDomain') ? overrides.defaultNormalizedDomain! : 'acquiro',
        domainMappings: overrides && overrides.hasOwnProperty('domainMappings') ? overrides.domainMappings! : [relationshipsToOmit.has('DomainMappingFields') ? {} as DomainMappingFields : aDomainMappingFields({}, relationshipsToOmit), relationshipsToOmit.has('DomainMappingFields') ? {} as DomainMappingFields : aDomainMappingFields({}, relationshipsToOmit), relationshipsToOmit.has('DomainMappingFields') ? {} as DomainMappingFields : aDomainMappingFields({}, relationshipsToOmit)],
        fqdnNormalizationEnabled: overrides && overrides.hasOwnProperty('fqdnNormalizationEnabled') ? overrides.fqdnNormalizationEnabled! : true,
        normalizeHostnames: overrides && overrides.hasOwnProperty('normalizeHostnames') ? overrides.normalizeHostnames! : true,
        normalizeUsernames: overrides && overrides.hasOwnProperty('normalizeUsernames') ? overrides.normalizeUsernames! : false,
    };
};

export const anEntityFieldAndType = (overrides?: Partial<EntityFieldAndType>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'EntityFieldAndType' } & EntityFieldAndType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntityFieldAndType');
    return {
        __typename: 'EntityFieldAndType',
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : 'device_ip',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : '_ip',
    };
};

export const anEntityGroupConfiguration = (overrides?: Partial<EntityGroupConfiguration>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'EntityGroupConfiguration' } & EntityGroupConfiguration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntityGroupConfiguration');
    return {
        __typename: 'EntityGroupConfiguration',
        configurationType: overrides && overrides.hasOwnProperty('configurationType') ? overrides.configurationType! : EntityGroupConfigurationType.EntityValue,
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-07-25T11:48:46.907Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'fugit',
        criticality: overrides && overrides.hasOwnProperty('criticality') ? overrides.criticality! : 'quo',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'ambitus',
        dynamicTags: overrides && overrides.hasOwnProperty('dynamicTags') ? overrides.dynamicTags! : false,
        entityNamespace: overrides && overrides.hasOwnProperty('entityNamespace') ? overrides.entityNamespace! : 'uberrime',
        entityType: overrides && overrides.hasOwnProperty('entityType') ? overrides.entityType! : 'derideo',
        group: overrides && overrides.hasOwnProperty('group') ? overrides.group! : 'defetiscor',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '1ebb919b-caab-451d-99d7-819123fa72de',
        inventoryKey: overrides && overrides.hasOwnProperty('inventoryKey') ? overrides.inventoryKey! : 'ciminatio',
        inventorySource: overrides && overrides.hasOwnProperty('inventorySource') ? overrides.inventorySource! : 'spiculum',
        inventoryType: overrides && overrides.hasOwnProperty('inventoryType') ? overrides.inventoryType! : EntityGroupConfigurationInventoryType.Computer,
        inventoryValue: overrides && overrides.hasOwnProperty('inventoryValue') ? overrides.inventoryValue! : 'accusator',
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-07-11T08:45:53.765Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'mollitia',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cogo',
        networkBlock: overrides && overrides.hasOwnProperty('networkBlock') ? overrides.networkBlock! : 'comes',
        prefix: overrides && overrides.hasOwnProperty('prefix') ? overrides.prefix! : 'decretum',
        suffix: overrides && overrides.hasOwnProperty('suffix') ? overrides.suffix! : 'vulnus',
        suppressed: overrides && overrides.hasOwnProperty('suppressed') ? overrides.suppressed! : false,
        tagSchema: overrides && overrides.hasOwnProperty('tagSchema') ? overrides.tagSchema! : 'coniecto',
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['undique', 'triduana', 'tum'],
    };
};

export const anEntityGroupConfigurationPage = (overrides?: Partial<EntityGroupConfigurationPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'EntityGroupConfigurationPage' } & EntityGroupConfigurationPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntityGroupConfigurationPage');
    return {
        __typename: 'EntityGroupConfigurationPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('EntityGroupConfiguration') ? {} as EntityGroupConfiguration : anEntityGroupConfiguration({}, relationshipsToOmit), relationshipsToOmit.has('EntityGroupConfiguration') ? {} as EntityGroupConfiguration : anEntityGroupConfiguration({}, relationshipsToOmit), relationshipsToOmit.has('EntityGroupConfiguration') ? {} as EntityGroupConfiguration : anEntityGroupConfiguration({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 8749,
    };
};

export const anEntityGroupConfigurationSort = (overrides?: Partial<EntityGroupConfigurationSort>, _relationshipsToOmit: Set<string> = new Set()): EntityGroupConfigurationSort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntityGroupConfigurationSort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : EntityGroupConfigurationSortableField.ConfigurationType,
    };
};

export const anEntityInterface = (overrides?: Partial<EntityInterface>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'EntityInterface' } & EntityInterface => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntityInterface');
    return {
        __typename: 'EntityInterface',
        activityScore: overrides && overrides.hasOwnProperty('activityScore') ? overrides.activityScore! : 8709,
        auditLog: overrides && overrides.hasOwnProperty('auditLog') ? overrides.auditLog! : [relationshipsToOmit.has('EntityAuditLog') ? {} as EntityAuditLog : anEntityAuditLog({}, relationshipsToOmit), relationshipsToOmit.has('EntityAuditLog') ? {} as EntityAuditLog : anEntityAuditLog({}, relationshipsToOmit), relationshipsToOmit.has('EntityAuditLog') ? {} as EntityAuditLog : anEntityAuditLog({}, relationshipsToOmit)],
        changeHistory: overrides && overrides.hasOwnProperty('changeHistory') ? overrides.changeHistory! : [relationshipsToOmit.has('EntityChangeHistory') ? {} as EntityChangeHistory : anEntityChangeHistory({}, relationshipsToOmit), relationshipsToOmit.has('EntityChangeHistory') ? {} as EntityChangeHistory : anEntityChangeHistory({}, relationshipsToOmit), relationshipsToOmit.has('EntityChangeHistory') ? {} as EntityChangeHistory : anEntityChangeHistory({}, relationshipsToOmit)],
        criticality: overrides && overrides.hasOwnProperty('criticality') ? overrides.criticality! : 'expedita',
        currentEntity: overrides && overrides.hasOwnProperty('currentEntity') ? overrides.currentEntity! : 'ratione',
        currentStateSignalIds: overrides && overrides.hasOwnProperty('currentStateSignalIds') ? overrides.currentStateSignalIds! : ['stabilis', 'veritas', 'curto'],
        currentStateSignals: overrides && overrides.hasOwnProperty('currentStateSignals') ? overrides.currentStateSignals! : [relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit), relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit), relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit)],
        enrichments: overrides && overrides.hasOwnProperty('enrichments') ? overrides.enrichments! : [relationshipsToOmit.has('Enrichment') ? {} as Enrichment : anEnrichment({}, relationshipsToOmit), relationshipsToOmit.has('Enrichment') ? {} as Enrichment : anEnrichment({}, relationshipsToOmit), relationshipsToOmit.has('Enrichment') ? {} as Enrichment : anEnrichment({}, relationshipsToOmit)],
        entityType: overrides && overrides.hasOwnProperty('entityType') ? overrides.entityType! : 'coaegresco',
        entityTypeName: overrides && overrides.hasOwnProperty('entityTypeName') ? overrides.entityTypeName! : 'certe',
        entityTypeObject: overrides && overrides.hasOwnProperty('entityTypeObject') ? overrides.entityTypeObject! : relationshipsToOmit.has('CustomEntityType') ? {} as CustomEntityType : aCustomEntityType({}, relationshipsToOmit),
        executedAutomations: overrides && overrides.hasOwnProperty('executedAutomations') ? overrides.executedAutomations! : [relationshipsToOmit.has('ExecutedAutomation') ? {} as ExecutedAutomation : anExecutedAutomation({}, relationshipsToOmit), relationshipsToOmit.has('ExecutedAutomation') ? {} as ExecutedAutomation : anExecutedAutomation({}, relationshipsToOmit), relationshipsToOmit.has('ExecutedAutomation') ? {} as ExecutedAutomation : anExecutedAutomation({}, relationshipsToOmit)],
        firstSeen: overrides && overrides.hasOwnProperty('firstSeen') ? overrides.firstSeen! : "2025-11-30T19:05:04.904Z",
        hasIndicator: overrides && overrides.hasOwnProperty('hasIndicator') ? overrides.hasIndicator! : true,
        hostname: overrides && overrides.hasOwnProperty('hostname') ? overrides.hostname! : 'adeo',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '336508b1-99d1-4874-b043-d754653e7db4',
        insights: overrides && overrides.hasOwnProperty('insights') ? overrides.insights! : relationshipsToOmit.has('InsightPage') ? {} as InsightPage : anInsightPage({}, relationshipsToOmit),
        inventory: overrides && overrides.hasOwnProperty('inventory') ? overrides.inventory! : [relationshipsToOmit.has('ComputerInventory') ? {} as ComputerInventory : aComputerInventory({}, relationshipsToOmit), relationshipsToOmit.has('ComputerInventory') ? {} as ComputerInventory : aComputerInventory({}, relationshipsToOmit), relationshipsToOmit.has('ComputerInventory') ? {} as ComputerInventory : aComputerInventory({}, relationshipsToOmit)],
        involvedEntities: overrides && overrides.hasOwnProperty('involvedEntities') ? overrides.involvedEntities! : [relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit)],
        involvedSignals: overrides && overrides.hasOwnProperty('involvedSignals') ? overrides.involvedSignals! : relationshipsToOmit.has('SignalPage') ? {} as SignalPage : aSignalPage({}, relationshipsToOmit),
        ipAddressDetails: overrides && overrides.hasOwnProperty('ipAddressDetails') ? overrides.ipAddressDetails! : relationshipsToOmit.has('IpAddress') ? {} as IpAddress : anIpAddress({}, relationshipsToOmit),
        isWhitelisted: overrides && overrides.hasOwnProperty('isWhitelisted') ? overrides.isWhitelisted! : true,
        lastSeen: overrides && overrides.hasOwnProperty('lastSeen') ? overrides.lastSeen! : "2025-05-18T11:30:47.279Z",
        macAddress: overrides && overrides.hasOwnProperty('macAddress') ? overrides.macAddress! : 'centum',
        metadata: overrides && overrides.hasOwnProperty('metadata') ? overrides.metadata! : 'dedico',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'quod',
        networkBlocks: overrides && overrides.hasOwnProperty('networkBlocks') ? overrides.networkBlocks! : [relationshipsToOmit.has('NetworkBlock') ? {} as NetworkBlock : aNetworkBlock({}, relationshipsToOmit), relationshipsToOmit.has('NetworkBlock') ? {} as NetworkBlock : aNetworkBlock({}, relationshipsToOmit), relationshipsToOmit.has('NetworkBlock') ? {} as NetworkBlock : aNetworkBlock({}, relationshipsToOmit)],
        notes: overrides && overrides.hasOwnProperty('notes') ? overrides.notes! : [relationshipsToOmit.has('EntityNote') ? {} as EntityNote : anEntityNote({}, relationshipsToOmit), relationshipsToOmit.has('EntityNote') ? {} as EntityNote : anEntityNote({}, relationshipsToOmit), relationshipsToOmit.has('EntityNote') ? {} as EntityNote : anEntityNote({}, relationshipsToOmit)],
        recentSignalSeverity: overrides && overrides.hasOwnProperty('recentSignalSeverity') ? overrides.recentSignalSeverity! : 905,
        relatedEntities: overrides && overrides.hasOwnProperty('relatedEntities') ? overrides.relatedEntities! : [relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit)],
        reputation: overrides && overrides.hasOwnProperty('reputation') ? overrides.reputation! : 'aut',
        reputationSources: overrides && overrides.hasOwnProperty('reputationSources') ? overrides.reputationSources! : [EntityReputationSource.Enrichment, EntityReputationSource.Enrichment, EntityReputationSource.Enrichment],
        sensorZone: overrides && overrides.hasOwnProperty('sensorZone') ? overrides.sensorZone! : 'arceo',
        signals: overrides && overrides.hasOwnProperty('signals') ? overrides.signals! : [relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit), relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit), relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit)],
        signalsV2: overrides && overrides.hasOwnProperty('signalsV2') ? overrides.signalsV2! : relationshipsToOmit.has('SignalPage') ? {} as SignalPage : aSignalPage({}, relationshipsToOmit),
        sources: overrides && overrides.hasOwnProperty('sources') ? overrides.sources! : [relationshipsToOmit.has('EntityMetadataSource') ? {} as EntityMetadataSource : anEntityMetadataSource({}, relationshipsToOmit), relationshipsToOmit.has('EntityMetadataSource') ? {} as EntityMetadataSource : anEntityMetadataSource({}, relationshipsToOmit), relationshipsToOmit.has('EntityMetadataSource') ? {} as EntityMetadataSource : anEntityMetadataSource({}, relationshipsToOmit)],
        suppressLists: overrides && overrides.hasOwnProperty('suppressLists') ? overrides.suppressLists! : ['magnam', 'creator', 'cogo'],
        suppressListsObj: overrides && overrides.hasOwnProperty('suppressListsObj') ? overrides.suppressListsObj! : [relationshipsToOmit.has('SuppressList') ? {} as SuppressList : aSuppressList({}, relationshipsToOmit), relationshipsToOmit.has('SuppressList') ? {} as SuppressList : aSuppressList({}, relationshipsToOmit), relationshipsToOmit.has('SuppressList') ? {} as SuppressList : aSuppressList({}, relationshipsToOmit)],
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['cursus', 'vero', 'patrocinor'],
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'thema',
        whitelistedComment: overrides && overrides.hasOwnProperty('whitelistedComment') ? overrides.whitelistedComment! : 'vulariter',
    };
};

export const anEntityMetadataSource = (overrides?: Partial<EntityMetadataSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'EntityMetadataSource' } & EntityMetadataSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntityMetadataSource');
    return {
        __typename: 'EntityMetadataSource',
        criticality: overrides && overrides.hasOwnProperty('criticality') ? overrides.criticality! : 'voluptate',
        entityGroupConfigurationId: overrides && overrides.hasOwnProperty('entityGroupConfigurationId') ? overrides.entityGroupConfigurationId! : 'cedo',
        entityGroupConfigurationName: overrides && overrides.hasOwnProperty('entityGroupConfigurationName') ? overrides.entityGroupConfigurationName! : 'credo',
        sourceType: overrides && overrides.hasOwnProperty('sourceType') ? overrides.sourceType! : 'aestas',
        suppressed: overrides && overrides.hasOwnProperty('suppressed') ? overrides.suppressed! : true,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['corpus', 'terreo', 'suspendo'],
    };
};

export const anEntityNote = (overrides?: Partial<EntityNote>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'EntityNote' } & EntityNote => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntityNote');
    return {
        __typename: 'EntityNote',
        author: overrides && overrides.hasOwnProperty('author') ? overrides.author! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '7eeede86-46c8-4774-b3ed-819fcc6c88d0',
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-03-15T00:12:41.190Z",
        note: overrides && overrides.hasOwnProperty('note') ? overrides.note! : 'ratione',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2024-12-08T10:12:46.368Z",
    };
};

export const anEntityPage = (overrides?: Partial<EntityPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'EntityPage' } & EntityPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntityPage');
    return {
        __typename: 'EntityPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 9440,
    };
};

export const anEntitySelectorsRuleOverride = (overrides?: Partial<EntitySelectorsRuleOverride>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'EntitySelectorsRuleOverride' } & EntitySelectorsRuleOverride => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntitySelectorsRuleOverride');
    return {
        __typename: 'EntitySelectorsRuleOverride',
        original: overrides && overrides.hasOwnProperty('original') ? overrides.original! : [relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit)],
        override: overrides && overrides.hasOwnProperty('override') ? overrides.override! : [relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit)],
    };
};

export const anEntitySort = (overrides?: Partial<EntitySort>, _relationshipsToOmit: Set<string> = new Set()): EntitySort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntitySort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : EntitySortableField.ActivityScore,
    };
};

export const anEntityTagOption = (overrides?: Partial<EntityTagOption>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'EntityTagOption' } & EntityTagOption => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntityTagOption');
    return {
        __typename: 'EntityTagOption',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'demens',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'vitium',
    };
};

export const anEntityTimelineGroup = (overrides?: Partial<EntityTimelineGroup>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'EntityTimelineGroup' } & EntityTimelineGroup => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntityTimelineGroup');
    return {
        __typename: 'EntityTimelineGroup',
        endTimestamp: overrides && overrides.hasOwnProperty('endTimestamp') ? overrides.endTimestamp! : "2025-06-19T05:55:36.914Z",
        recordCount: overrides && overrides.hasOwnProperty('recordCount') ? overrides.recordCount! : 7496,
        startTimestamp: overrides && overrides.hasOwnProperty('startTimestamp') ? overrides.startTimestamp! : "2025-03-06T06:05:18.667Z",
        summary: overrides && overrides.hasOwnProperty('summary') ? overrides.summary! : 'tantillus',
        uids: overrides && overrides.hasOwnProperty('uids') ? overrides.uids! : ['paulatim', 'pecto', 'coruscus'],
    };
};

export const anEntityValueEntityGroupConfigurationFields = (overrides?: Partial<EntityValueEntityGroupConfigurationFields>, _relationshipsToOmit: Set<string> = new Set()): EntityValueEntityGroupConfigurationFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('EntityValueEntityGroupConfigurationFields');
    return {
        configurationType: overrides && overrides.hasOwnProperty('configurationType') ? overrides.configurationType! : EntityGroupConfigurationType.EntityValue,
        criticality: overrides && overrides.hasOwnProperty('criticality') ? overrides.criticality! : 'conventus',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'capto',
        entityNamespace: overrides && overrides.hasOwnProperty('entityNamespace') ? overrides.entityNamespace! : 'ventus',
        entityType: overrides && overrides.hasOwnProperty('entityType') ? overrides.entityType! : 'amplus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'validus',
        networkBlock: overrides && overrides.hasOwnProperty('networkBlock') ? overrides.networkBlock! : 'magni',
        prefix: overrides && overrides.hasOwnProperty('prefix') ? overrides.prefix! : 'sublime',
        suffix: overrides && overrides.hasOwnProperty('suffix') ? overrides.suffix! : 'demitto',
        suppressed: overrides && overrides.hasOwnProperty('suppressed') ? overrides.suppressed! : false,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['abscido', 'ustulo', 'id'],
    };
};

export const anExecuteAction = (overrides?: Partial<ExecuteAction>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ExecuteAction' } & ExecuteAction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExecuteAction');
    return {
        __typename: 'ExecuteAction',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const anExecuteAutomation = (overrides?: Partial<ExecuteAutomation>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ExecuteAutomation' } & ExecuteAutomation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExecuteAutomation');
    return {
        __typename: 'ExecuteAutomation',
        executionIds: overrides && overrides.hasOwnProperty('executionIds') ? overrides.executionIds! : ['vitiosus', 'audacia', 'utroque'],
        playbooksWithErrors: overrides && overrides.hasOwnProperty('playbooksWithErrors') ? overrides.playbooksWithErrors! : ['tenus', 'solio', 'tristis'],
    };
};

export const anExecuteAutomationFields = (overrides?: Partial<ExecuteAutomationFields>, _relationshipsToOmit: Set<string> = new Set()): ExecuteAutomationFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExecuteAutomationFields');
    return {
        automationIds: overrides && overrides.hasOwnProperty('automationIds') ? overrides.automationIds! : ['vinco', 'debeo', 'contigo'],
        executionCseResources: overrides && overrides.hasOwnProperty('executionCseResources') ? overrides.executionCseResources! : [relationshipsToOmit.has('ExecutionCseResource') ? {} as ExecutionCseResource : anExecutionCseResource({}, relationshipsToOmit), relationshipsToOmit.has('ExecutionCseResource') ? {} as ExecutionCseResource : anExecutionCseResource({}, relationshipsToOmit), relationshipsToOmit.has('ExecutionCseResource') ? {} as ExecutionCseResource : anExecutionCseResource({}, relationshipsToOmit)],
    };
};

export const anExecutedAutomation = (overrides?: Partial<ExecutedAutomation>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ExecutedAutomation' } & ExecutedAutomation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExecutedAutomation');
    return {
        __typename: 'ExecutedAutomation',
        cseResourceId: overrides && overrides.hasOwnProperty('cseResourceId') ? overrides.cseResourceId! : 'campana',
        cseResourceType: overrides && overrides.hasOwnProperty('cseResourceType') ? overrides.cseResourceType! : 'veritatis',
        endDate: overrides && overrides.hasOwnProperty('endDate') ? overrides.endDate! : "2025-10-04T09:15:39.896Z",
        executionId: overrides && overrides.hasOwnProperty('executionId') ? overrides.executionId! : 'quasi',
        playbookDescription: overrides && overrides.hasOwnProperty('playbookDescription') ? overrides.playbookDescription! : 'aranea',
        playbookId: overrides && overrides.hasOwnProperty('playbookId') ? overrides.playbookId! : 'amo',
        playbookName: overrides && overrides.hasOwnProperty('playbookName') ? overrides.playbookName! : 'utilis',
        startDate: overrides && overrides.hasOwnProperty('startDate') ? overrides.startDate! : "2025-04-12T00:38:30.518Z",
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : 'fuga',
        statusCode: overrides && overrides.hasOwnProperty('statusCode') ? overrides.statusCode! : 9011,
    };
};

export const anExecutionCseResource = (overrides?: Partial<ExecutionCseResource>, _relationshipsToOmit: Set<string> = new Set()): ExecutionCseResource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExecutionCseResource');
    return {
        cseResourceType: overrides && overrides.hasOwnProperty('cseResourceType') ? overrides.cseResourceType! : 'uter',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'supra',
    };
};

export const anExpressionAndLimitsRuleOverride = (overrides?: Partial<ExpressionAndLimitsRuleOverride>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ExpressionAndLimitsRuleOverride' } & ExpressionAndLimitsRuleOverride => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ExpressionAndLimitsRuleOverride');
    return {
        __typename: 'ExpressionAndLimitsRuleOverride',
        original: overrides && overrides.hasOwnProperty('original') ? overrides.original! : [relationshipsToOmit.has('ChainRuleExpressionAndLimit') ? {} as ChainRuleExpressionAndLimit : aChainRuleExpressionAndLimit({}, relationshipsToOmit), relationshipsToOmit.has('ChainRuleExpressionAndLimit') ? {} as ChainRuleExpressionAndLimit : aChainRuleExpressionAndLimit({}, relationshipsToOmit), relationshipsToOmit.has('ChainRuleExpressionAndLimit') ? {} as ChainRuleExpressionAndLimit : aChainRuleExpressionAndLimit({}, relationshipsToOmit)],
        override: overrides && overrides.hasOwnProperty('override') ? overrides.override! : [relationshipsToOmit.has('ChainRuleExpressionAndLimit') ? {} as ChainRuleExpressionAndLimit : aChainRuleExpressionAndLimit({}, relationshipsToOmit), relationshipsToOmit.has('ChainRuleExpressionAndLimit') ? {} as ChainRuleExpressionAndLimit : aChainRuleExpressionAndLimit({}, relationshipsToOmit), relationshipsToOmit.has('ChainRuleExpressionAndLimit') ? {} as ChainRuleExpressionAndLimit : aChainRuleExpressionAndLimit({}, relationshipsToOmit)],
    };
};

export const aFavoriteField = (overrides?: Partial<FavoriteField>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'FavoriteField' } & FavoriteField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FavoriteField');
    return {
        __typename: 'FavoriteField',
        applyToAllObjectTypes: overrides && overrides.hasOwnProperty('applyToAllObjectTypes') ? overrides.applyToAllObjectTypes! : false,
        associatedObjectTypes: overrides && overrides.hasOwnProperty('associatedObjectTypes') ? overrides.associatedObjectTypes! : ['custodia', 'pel', 'carcer'],
        fieldName: overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'pecco',
        fieldType: overrides && overrides.hasOwnProperty('fieldType') ? overrides.fieldType! : FavoriteFieldType.Inventory,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'b1f51efd-30fe-4a35-87e9-329b943c4419',
    };
};

export const aFavoriteFieldPage = (overrides?: Partial<FavoriteFieldPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'FavoriteFieldPage' } & FavoriteFieldPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FavoriteFieldPage');
    return {
        __typename: 'FavoriteFieldPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('FavoriteField') ? {} as FavoriteField : aFavoriteField({}, relationshipsToOmit), relationshipsToOmit.has('FavoriteField') ? {} as FavoriteField : aFavoriteField({}, relationshipsToOmit), relationshipsToOmit.has('FavoriteField') ? {} as FavoriteField : aFavoriteField({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 5574,
    };
};

export const aFavoriteFieldSort = (overrides?: Partial<FavoriteFieldSort>, _relationshipsToOmit: Set<string> = new Set()): FavoriteFieldSort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FavoriteFieldSort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : FavoriteFieldSortableField.ApplyToAllObjectTypes,
    };
};

export const aFeatureActivation = (overrides?: Partial<FeatureActivation>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'FeatureActivation' } & FeatureActivation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FeatureActivation');
    return {
        __typename: 'FeatureActivation',
        cse: overrides && overrides.hasOwnProperty('cse') ? overrides.cse! : false,
    };
};

export const aFederatedChildOrg = (overrides?: Partial<FederatedChildOrg>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'FederatedChildOrg' } & FederatedChildOrg => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FederatedChildOrg');
    return {
        __typename: 'FederatedChildOrg',
        deployment: overrides && overrides.hasOwnProperty('deployment') ? overrides.deployment! : 'subito',
        tenant: overrides && overrides.hasOwnProperty('tenant') ? overrides.tenant! : 'ipsam',
        tenantName: overrides && overrides.hasOwnProperty('tenantName') ? overrides.tenantName! : 'conspergo',
        tenantUrl: overrides && overrides.hasOwnProperty('tenantUrl') ? overrides.tenantUrl! : 'copiose',
    };
};

export const aFieldGroupBy = (overrides?: Partial<FieldGroupBy>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'FieldGroupBy' } & FieldGroupBy => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FieldGroupBy');
    return {
        __typename: 'FieldGroupBy',
        fieldName: overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'crux',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'accusantium',
    };
};

export const aFinishMfaLogin = (overrides?: Partial<FinishMfaLogin>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'FinishMfaLogin' } & FinishMfaLogin => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FinishMfaLogin');
    return {
        __typename: 'FinishMfaLogin',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('CurrentUser') ? {} as CurrentUser : aCurrentUser({}, relationshipsToOmit),
    };
};

export const aFirstSeenRule = (overrides?: Partial<FirstSeenRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'FirstSeenRule' } & FirstSeenRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('FirstSeenRule');
    return {
        __typename: 'FirstSeenRule',
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'triumphus',
        autoDisabledReason: overrides && overrides.hasOwnProperty('autoDisabledReason') ? overrides.autoDisabledReason! : 'denuncio',
        baselineLastStarted: overrides && overrides.hasOwnProperty('baselineLastStarted') ? overrides.baselineLastStarted! : "2025-05-07T05:43:02.999Z",
        baselineStatus: overrides && overrides.hasOwnProperty('baselineStatus') ? overrides.baselineStatus! : BaselineStatus.Completed,
        baselineType: overrides && overrides.hasOwnProperty('baselineType') ? overrides.baselineType! : FirstSeenRuleBaselineType.Global,
        baselineWindowSize: overrides && overrides.hasOwnProperty('baselineWindowSize') ? overrides.baselineWindowSize! : 193229031129905,
        baselineWindowSizeOverride: overrides && overrides.hasOwnProperty('baselineWindowSizeOverride') ? overrides.baselineWindowSizeOverride! : relationshipsToOmit.has('BigIntRuleOverride') ? {} as BigIntRuleOverride : aBigIntRuleOverride({}, relationshipsToOmit),
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'ver',
        contentType: overrides && overrides.hasOwnProperty('contentType') ? overrides.contentType! : ContentType.Anomaly,
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-09-20T13:53:36.949Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'cognomen',
        createdByUser: overrides && overrides.hasOwnProperty('createdByUser') ? overrides.createdByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        deleted: overrides && overrides.hasOwnProperty('deleted') ? overrides.deleted! : true,
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'tergeo',
        descriptionExpressionOverride: overrides && overrides.hasOwnProperty('descriptionExpressionOverride') ? overrides.descriptionExpressionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit)],
        entitySelectorsOverride: overrides && overrides.hasOwnProperty('entitySelectorsOverride') ? overrides.entitySelectorsOverride! : relationshipsToOmit.has('EntitySelectorsRuleOverride') ? {} as EntitySelectorsRuleOverride : anEntitySelectorsRuleOverride({}, relationshipsToOmit),
        exportJson: overrides && overrides.hasOwnProperty('exportJson') ? overrides.exportJson! : 'ulterius',
        failing: overrides && overrides.hasOwnProperty('failing') ? overrides.failing! : false,
        filterExpression: overrides && overrides.hasOwnProperty('filterExpression') ? overrides.filterExpression! : 'adhuc',
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['cura', 'ventosus', 'vorax'],
        groupByFieldsOverride: overrides && overrides.hasOwnProperty('groupByFieldsOverride') ? overrides.groupByFieldsOverride! : relationshipsToOmit.has('StringListRuleOverride') ? {} as StringListRuleOverride : aStringListRuleOverride({}, relationshipsToOmit),
        hasOverride: overrides && overrides.hasOwnProperty('hasOverride') ? overrides.hasOverride! : false,
        history: overrides && overrides.hasOwnProperty('history') ? overrides.history! : [relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit)],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'bf6f03e6-7ad4-4aae-ad6e-d5d2e0b025aa',
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        isPrototypeOverride: overrides && overrides.hasOwnProperty('isPrototypeOverride') ? overrides.isPrototypeOverride! : relationshipsToOmit.has('BooleanRuleOverride') ? {} as BooleanRuleOverride : aBooleanRuleOverride({}, relationshipsToOmit),
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-11-04T11:30:35.911Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'iste',
        lastUpdatedByUser: overrides && overrides.hasOwnProperty('lastUpdatedByUser') ? overrides.lastUpdatedByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'conservo',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'thymbra',
        nameExpressionOverride: overrides && overrides.hasOwnProperty('nameExpressionOverride') ? overrides.nameExpressionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        nameOverride: overrides && overrides.hasOwnProperty('nameOverride') ? overrides.nameOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : 'be96c86e-f97c-4313-ad8a-0e4bc82f2dcf',
        rawJson: overrides && overrides.hasOwnProperty('rawJson') ? overrides.rawJson! : 'decumbo',
        rawStatus: overrides && overrides.hasOwnProperty('rawStatus') ? overrides.rawStatus! : relationshipsToOmit.has('RuleStatus') ? {} as RuleStatus : aRuleStatus({}, relationshipsToOmit),
        retentionWindowSize: overrides && overrides.hasOwnProperty('retentionWindowSize') ? overrides.retentionWindowSize! : 490125063735680,
        retentionWindowSizeOverride: overrides && overrides.hasOwnProperty('retentionWindowSizeOverride') ? overrides.retentionWindowSizeOverride! : relationshipsToOmit.has('BigIntRuleOverride') ? {} as BigIntRuleOverride : aBigIntRuleOverride({}, relationshipsToOmit),
        ruleDescription: overrides && overrides.hasOwnProperty('ruleDescription') ? overrides.ruleDescription! : 'defaeco',
        ruleId: overrides && overrides.hasOwnProperty('ruleId') ? overrides.ruleId! : 9015,
        ruleSource: overrides && overrides.hasOwnProperty('ruleSource') ? overrides.ruleSource! : 'civis',
        ruleType: overrides && overrides.hasOwnProperty('ruleType') ? overrides.ruleType! : 'nesciunt',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 6849,
        scoreOverride: overrides && overrides.hasOwnProperty('scoreOverride') ? overrides.scoreOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
        signalCount07d: overrides && overrides.hasOwnProperty('signalCount07d') ? overrides.signalCount07d! : 3624,
        signalCount24h: overrides && overrides.hasOwnProperty('signalCount24h') ? overrides.signalCount24h! : 1263,
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : relationshipsToOmit.has('RuleStatus') ? {} as RuleStatus : aRuleStatus({}, relationshipsToOmit),
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'socius',
        summaryExpressionOverride: overrides && overrides.hasOwnProperty('summaryExpressionOverride') ? overrides.summaryExpressionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 2778,
        suppressionWindowSizeOverride: overrides && overrides.hasOwnProperty('suppressionWindowSizeOverride') ? overrides.suppressionWindowSizeOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['suscipio', 'umerus', 'quos'],
        tagsOverride: overrides && overrides.hasOwnProperty('tagsOverride') ? overrides.tagsOverride! : relationshipsToOmit.has('StringListRuleOverride') ? {} as StringListRuleOverride : aStringListRuleOverride({}, relationshipsToOmit),
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['pariatur', 'sonitus', 'dapifer'],
        tuningExpressions: overrides && overrides.hasOwnProperty('tuningExpressions') ? overrides.tuningExpressions! : [relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit)],
        valueExpression: overrides && overrides.hasOwnProperty('valueExpression') ? overrides.valueExpression! : 'denego',
        valueFields: overrides && overrides.hasOwnProperty('valueFields') ? overrides.valueFields! : ['celer', 'sui', 'sono'],
        version: overrides && overrides.hasOwnProperty('version') ? overrides.version! : 7319,
    };
};

export const aFolder = (overrides?: Partial<Folder>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Folder' } & Folder => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Folder');
    return {
        __typename: 'Folder',
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'circumvenio',
        actions: overrides && overrides.hasOwnProperty('actions') ? overrides.actions! : ['delectus', 'valde', 'canonicus'],
        children: overrides && overrides.hasOwnProperty('children') ? overrides.children! : [relationshipsToOmit.has('Dashboard') ? {} as Dashboard : aDashboard({}, relationshipsToOmit), relationshipsToOmit.has('Dashboard') ? {} as Dashboard : aDashboard({}, relationshipsToOmit), relationshipsToOmit.has('Dashboard') ? {} as Dashboard : aDashboard({}, relationshipsToOmit)],
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 977489181301134,
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'ademptio',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'demitto',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 287564489905891,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 659721620539497,
        isFavorite: overrides && overrides.hasOwnProperty('isFavorite') ? overrides.isFavorite! : false,
        modifiedAt: overrides && overrides.hasOwnProperty('modifiedAt') ? overrides.modifiedAt! : 939867614405963,
        modifiedBy: overrides && overrides.hasOwnProperty('modifiedBy') ? overrides.modifiedBy! : 'cavus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'spectaculum',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 750426137231059,
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'cura',
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 256010332891254,
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : ['caveo', 'suscipio', 'bestia'],
        relativePath: overrides && overrides.hasOwnProperty('relativePath') ? overrides.relativePath! : [relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit), relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit), relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit)],
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 553064940451779,
        sharedAt: overrides && overrides.hasOwnProperty('sharedAt') ? overrides.sharedAt! : 494610470385460,
        sharerId: overrides && overrides.hasOwnProperty('sharerId') ? overrides.sharerId! : 244583305112112,
        sharerName: overrides && overrides.hasOwnProperty('sharerName') ? overrides.sharerName! : 'tactus',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'crur',
        useViewerRbac: overrides && overrides.hasOwnProperty('useViewerRbac') ? overrides.useViewerRbac! : false,
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'teres',
    };
};

export const aFolderable = (overrides?: Partial<Folderable>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Folderable' } & Folderable => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Folderable');
    return {
        __typename: 'Folderable',
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'laudantium',
        actions: overrides && overrides.hasOwnProperty('actions') ? overrides.actions! : ['corrigo', 'bellicus', 'cubicularis'],
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 128005289644827,
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'tandem',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'thymbra',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 593404343707996,
        isFavorite: overrides && overrides.hasOwnProperty('isFavorite') ? overrides.isFavorite! : true,
        modifiedAt: overrides && overrides.hasOwnProperty('modifiedAt') ? overrides.modifiedAt! : 704730589444210,
        modifiedBy: overrides && overrides.hasOwnProperty('modifiedBy') ? overrides.modifiedBy! : 'adinventitias',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'debilito',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 23602949220915,
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'ulterius',
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 861946588801646,
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : ['bellum', 'paulatim', 'defaeco'],
        relativePath: overrides && overrides.hasOwnProperty('relativePath') ? overrides.relativePath! : [relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit), relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit), relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit)],
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 840167609856646,
        sharedAt: overrides && overrides.hasOwnProperty('sharedAt') ? overrides.sharedAt! : 651729713148032,
        sharerId: overrides && overrides.hasOwnProperty('sharerId') ? overrides.sharerId! : 919523489122555,
        sharerName: overrides && overrides.hasOwnProperty('sharerName') ? overrides.sharerName! : 'addo',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'cervus',
        useViewerRbac: overrides && overrides.hasOwnProperty('useViewerRbac') ? overrides.useViewerRbac! : true,
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'cicuta',
    };
};

export const aForgotPassword = (overrides?: Partial<ForgotPassword>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ForgotPassword' } & ForgotPassword => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ForgotPassword');
    return {
        __typename: 'ForgotPassword',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aGithubYaraSourceFields = (overrides?: Partial<GithubYaraSourceFields>, _relationshipsToOmit: Set<string> = new Set()): GithubYaraSourceFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GithubYaraSourceFields');
    return {
        branch: overrides && overrides.hasOwnProperty('branch') ? overrides.branch! : 'stips',
        defaultSeverity: overrides && overrides.hasOwnProperty('defaultSeverity') ? overrides.defaultSeverity! : 2782,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'deorsum',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'alter',
        token: overrides && overrides.hasOwnProperty('token') ? overrides.token! : 'adamo',
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'calculus',
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'tantillus',
        yaraFileRegex: overrides && overrides.hasOwnProperty('yaraFileRegex') ? overrides.yaraFileRegex! : 'cometes',
    };
};

export const aGroupByInput = (overrides?: Partial<GroupByInput>, _relationshipsToOmit: Set<string> = new Set()): GroupByInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GroupByInput');
    return {
        fieldName: overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'cinis',
        fieldValue: overrides && overrides.hasOwnProperty('fieldValue') ? overrides.fieldValue! : 'cometes',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'itaque',
    };
};

export const aGroupedInsightPage = (overrides?: Partial<GroupedInsightPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'GroupedInsightPage' } & GroupedInsightPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('GroupedInsightPage');
    return {
        __typename: 'GroupedInsightPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit), relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit), relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit)],
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : relationshipsToOmit.has('InsightStatus') ? {} as InsightStatus : anInsightStatus({}, relationshipsToOmit),
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 5718,
    };
};

export const anIpAddress = (overrides?: Partial<IpAddress>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'IPAddress' } & IpAddress => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IpAddress');
    return {
        __typename: 'IPAddress',
        accuracyRadius: overrides && overrides.hasOwnProperty('accuracyRadius') ? overrides.accuracyRadius! : 7541,
        address: overrides && overrides.hasOwnProperty('address') ? overrides.address! : 'id',
        asn: overrides && overrides.hasOwnProperty('asn') ? overrides.asn! : 'cornu',
        aso: overrides && overrides.hasOwnProperty('aso') ? overrides.aso! : 'caecus',
        city: overrides && overrides.hasOwnProperty('city') ? overrides.city! : 'spes',
        continentCode: overrides && overrides.hasOwnProperty('continentCode') ? overrides.continentCode! : 'agnosco',
        continentName: overrides && overrides.hasOwnProperty('continentName') ? overrides.continentName! : 'bibo',
        countryCode: overrides && overrides.hasOwnProperty('countryCode') ? overrides.countryCode! : 'trepide',
        countryName: overrides && overrides.hasOwnProperty('countryName') ? overrides.countryName! : 'vitiosus',
        isInternal: overrides && overrides.hasOwnProperty('isInternal') ? overrides.isInternal! : true,
        isp: overrides && overrides.hasOwnProperty('isp') ? overrides.isp! : 'confugo',
        latitude: overrides && overrides.hasOwnProperty('latitude') ? overrides.latitude! : 9.1,
        location: overrides && overrides.hasOwnProperty('location') ? overrides.location! : 'victus',
        longitude: overrides && overrides.hasOwnProperty('longitude') ? overrides.longitude! : 9,
        org: overrides && overrides.hasOwnProperty('org') ? overrides.org! : 'thesaurus',
        region: overrides && overrides.hasOwnProperty('region') ? overrides.region! : 'benigne',
        version: overrides && overrides.hasOwnProperty('version') ? overrides.version! : 'colligo',
    };
};

export const anIdefenseConfig = (overrides?: Partial<IdefenseConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'IdefenseConfig' } & IdefenseConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IdefenseConfig');
    return {
        __typename: 'IdefenseConfig',
        apiKey: overrides && overrides.hasOwnProperty('apiKey') ? overrides.apiKey! : 'demonstro',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
    };
};

export const anIdefenseThreatIntelSourceFields = (overrides?: Partial<IdefenseThreatIntelSourceFields>, _relationshipsToOmit: Set<string> = new Set()): IdefenseThreatIntelSourceFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IdefenseThreatIntelSourceFields');
    return {
        apiKey: overrides && overrides.hasOwnProperty('apiKey') ? overrides.apiKey! : 'caute',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'claustrum',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'quae',
    };
};

export const anImportRuleFailure = (overrides?: Partial<ImportRuleFailure>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ImportRuleFailure' } & ImportRuleFailure => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ImportRuleFailure');
    return {
        __typename: 'ImportRuleFailure',
        ruleName: overrides && overrides.hasOwnProperty('ruleName') ? overrides.ruleName! : 'paens',
    };
};

export const anImportRules = (overrides?: Partial<ImportRules>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ImportRules' } & ImportRules => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ImportRules');
    return {
        __typename: 'ImportRules',
        failures: overrides && overrides.hasOwnProperty('failures') ? overrides.failures! : [relationshipsToOmit.has('ImportRuleFailure') ? {} as ImportRuleFailure : anImportRuleFailure({}, relationshipsToOmit), relationshipsToOmit.has('ImportRuleFailure') ? {} as ImportRuleFailure : anImportRuleFailure({}, relationshipsToOmit), relationshipsToOmit.has('ImportRuleFailure') ? {} as ImportRuleFailure : anImportRuleFailure({}, relationshipsToOmit)],
        successCount: overrides && overrides.hasOwnProperty('successCount') ? overrides.successCount! : 1743,
    };
};

export const anIncidentSearchResult = (overrides?: Partial<IncidentSearchResult>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'IncidentSearchResult' } & IncidentSearchResult => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IncidentSearchResult');
    return {
        __typename: 'IncidentSearchResult',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 1208,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'substantia',
    };
};

export const anIncidentTemplate = (overrides?: Partial<IncidentTemplate>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'IncidentTemplate' } & IncidentTemplate => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IncidentTemplate');
    return {
        __typename: 'IncidentTemplate',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 7647,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vos',
    };
};

export const anInputEntitySelectorType = (overrides?: Partial<InputEntitySelectorType>, _relationshipsToOmit: Set<string> = new Set()): InputEntitySelectorType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InputEntitySelectorType');
    return {
        entityType: overrides && overrides.hasOwnProperty('entityType') ? overrides.entityType! : 'varius',
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'coniuratio',
    };
};

export const anInsight = (overrides?: Partial<Insight>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Insight' } & Insight => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Insight');
    return {
        __typename: 'Insight',
        allowedNextStatuses: overrides && overrides.hasOwnProperty('allowedNextStatuses') ? overrides.allowedNextStatuses! : [relationshipsToOmit.has('AllowedInsightStatus') ? {} as AllowedInsightStatus : anAllowedInsightStatus({}, relationshipsToOmit), relationshipsToOmit.has('AllowedInsightStatus') ? {} as AllowedInsightStatus : anAllowedInsightStatus({}, relationshipsToOmit), relationshipsToOmit.has('AllowedInsightStatus') ? {} as AllowedInsightStatus : anAllowedInsightStatus({}, relationshipsToOmit)],
        artifacts: overrides && overrides.hasOwnProperty('artifacts') ? overrides.artifacts! : [relationshipsToOmit.has('InsightArtifact') ? {} as InsightArtifact : anInsightArtifact({}, relationshipsToOmit), relationshipsToOmit.has('InsightArtifact') ? {} as InsightArtifact : anInsightArtifact({}, relationshipsToOmit), relationshipsToOmit.has('InsightArtifact') ? {} as InsightArtifact : anInsightArtifact({}, relationshipsToOmit)],
        assignedTo: overrides && overrides.hasOwnProperty('assignedTo') ? overrides.assignedTo! : 'vinco',
        assignee: overrides && overrides.hasOwnProperty('assignee') ? overrides.assignee! : relationshipsToOmit.has('Team') ? {} as Team : aTeam({}, relationshipsToOmit),
        closed: overrides && overrides.hasOwnProperty('closed') ? overrides.closed! : "2025-02-14T19:52:01.482Z",
        closedBy: overrides && overrides.hasOwnProperty('closedBy') ? overrides.closedBy! : 'undique',
        cluster: overrides && overrides.hasOwnProperty('cluster') ? overrides.cluster! : 'illo',
        comments: overrides && overrides.hasOwnProperty('comments') ? overrides.comments! : [relationshipsToOmit.has('InsightComment') ? {} as InsightComment : anInsightComment({}, relationshipsToOmit), relationshipsToOmit.has('InsightComment') ? {} as InsightComment : anInsightComment({}, relationshipsToOmit), relationshipsToOmit.has('InsightComment') ? {} as InsightComment : anInsightComment({}, relationshipsToOmit)],
        confidence: overrides && overrides.hasOwnProperty('confidence') ? overrides.confidence! : 9.6,
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2024-12-17T11:23:36.068Z",
        deployment: overrides && overrides.hasOwnProperty('deployment') ? overrides.deployment! : 'aureus',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'amiculum',
        duplicateInsight: overrides && overrides.hasOwnProperty('duplicateInsight') ? overrides.duplicateInsight! : relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit),
        duplicateInsightId: overrides && overrides.hasOwnProperty('duplicateInsightId') ? overrides.duplicateInsightId! : 'suasoria',
        enrichments: overrides && overrides.hasOwnProperty('enrichments') ? overrides.enrichments! : [relationshipsToOmit.has('Enrichment') ? {} as Enrichment : anEnrichment({}, relationshipsToOmit), relationshipsToOmit.has('Enrichment') ? {} as Enrichment : anEnrichment({}, relationshipsToOmit), relationshipsToOmit.has('Enrichment') ? {} as Enrichment : anEnrichment({}, relationshipsToOmit)],
        entity: overrides && overrides.hasOwnProperty('entity') ? overrides.entity! : relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit),
        executedAutomations: overrides && overrides.hasOwnProperty('executedAutomations') ? overrides.executedAutomations! : [relationshipsToOmit.has('ExecutedAutomation') ? {} as ExecutedAutomation : anExecutedAutomation({}, relationshipsToOmit), relationshipsToOmit.has('ExecutedAutomation') ? {} as ExecutedAutomation : anExecutedAutomation({}, relationshipsToOmit), relationshipsToOmit.has('ExecutedAutomation') ? {} as ExecutedAutomation : anExecutedAutomation({}, relationshipsToOmit)],
        firstResponded: overrides && overrides.hasOwnProperty('firstResponded') ? overrides.firstResponded! : "2025-02-15T12:42:15.789Z",
        firstRespondedBy: overrides && overrides.hasOwnProperty('firstRespondedBy') ? overrides.firstRespondedBy! : 'depereo',
        history: overrides && overrides.hasOwnProperty('history') ? overrides.history! : [relationshipsToOmit.has('InsightHistoryEvent') ? {} as InsightHistoryEvent : anInsightHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('InsightHistoryEvent') ? {} as InsightHistoryEvent : anInsightHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('InsightHistoryEvent') ? {} as InsightHistoryEvent : anInsightHistoryEvent({}, relationshipsToOmit)],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '81818a33-52b2-45a0-a531-93f720da693b',
        insightSignalSeverityTotal: overrides && overrides.hasOwnProperty('insightSignalSeverityTotal') ? overrides.insightSignalSeverityTotal! : 6534,
        involvedEntities: overrides && overrides.hasOwnProperty('involvedEntities') ? overrides.involvedEntities! : [relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit)],
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-08-24T23:32:54.083Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'substantia',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'audentia',
        originalSeverity: overrides && overrides.hasOwnProperty('originalSeverity') ? overrides.originalSeverity! : InsightSeverityPyEnum.Critical,
        readableId: overrides && overrides.hasOwnProperty('readableId') ? overrides.readableId! : 'supellex',
        recordDateTimeRange: overrides && overrides.hasOwnProperty('recordDateTimeRange') ? overrides.recordDateTimeRange! : relationshipsToOmit.has('DateTimeRange') ? {} as DateTimeRange : aDateTimeRange({}, relationshipsToOmit),
        recordSummaryFields: overrides && overrides.hasOwnProperty('recordSummaryFields') ? overrides.recordSummaryFields! : [relationshipsToOmit.has('RecordSummaryField') ? {} as RecordSummaryField : aRecordSummaryField({}, relationshipsToOmit), relationshipsToOmit.has('RecordSummaryField') ? {} as RecordSummaryField : aRecordSummaryField({}, relationshipsToOmit), relationshipsToOmit.has('RecordSummaryField') ? {} as RecordSummaryField : aRecordSummaryField({}, relationshipsToOmit)],
        relatedEnrichments: overrides && overrides.hasOwnProperty('relatedEnrichments') ? overrides.relatedEnrichments! : [relationshipsToOmit.has('Enrichment') ? {} as Enrichment : anEnrichment({}, relationshipsToOmit), relationshipsToOmit.has('Enrichment') ? {} as Enrichment : anEnrichment({}, relationshipsToOmit), relationshipsToOmit.has('Enrichment') ? {} as Enrichment : anEnrichment({}, relationshipsToOmit)],
        relatedIncidents: overrides && overrides.hasOwnProperty('relatedIncidents') ? overrides.relatedIncidents! : [relationshipsToOmit.has('RelatedIncident') ? {} as RelatedIncident : aRelatedIncident({}, relationshipsToOmit), relationshipsToOmit.has('RelatedIncident') ? {} as RelatedIncident : aRelatedIncident({}, relationshipsToOmit), relationshipsToOmit.has('RelatedIncident') ? {} as RelatedIncident : aRelatedIncident({}, relationshipsToOmit)],
        relatedInsights: overrides && overrides.hasOwnProperty('relatedInsights') ? overrides.relatedInsights! : [relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit), relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit), relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit)],
        relatedSignals: overrides && overrides.hasOwnProperty('relatedSignals') ? overrides.relatedSignals! : [relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit), relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit), relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit)],
        resolution: overrides && overrides.hasOwnProperty('resolution') ? overrides.resolution! : 'curvo',
        severity: overrides && overrides.hasOwnProperty('severity') ? overrides.severity! : InsightSeverityPyEnum.Critical,
        severityValue: overrides && overrides.hasOwnProperty('severityValue') ? overrides.severityValue! : 5682,
        signalCount: overrides && overrides.hasOwnProperty('signalCount') ? overrides.signalCount! : 1628,
        signals: overrides && overrides.hasOwnProperty('signals') ? overrides.signals! : [relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit), relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit), relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit)],
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : AlertSource.Algorithm,
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : relationshipsToOmit.has('InsightStatusName') ? {} as InsightStatusName : anInsightStatusName({}, relationshipsToOmit),
        subResolution: overrides && overrides.hasOwnProperty('subResolution') ? overrides.subResolution! : 'talus',
        summary: overrides && overrides.hasOwnProperty('summary') ? overrides.summary! : 'minus',
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['totidem', 'cohors', 'deficio'],
        teamAssignedTo: overrides && overrides.hasOwnProperty('teamAssignedTo') ? overrides.teamAssignedTo! : 'unde',
        tenant: overrides && overrides.hasOwnProperty('tenant') ? overrides.tenant! : 'deleniti',
        tenantName: overrides && overrides.hasOwnProperty('tenantName') ? overrides.tenantName! : 'absum',
        tenantUrl: overrides && overrides.hasOwnProperty('tenantUrl') ? overrides.tenantUrl! : 'corrigo',
        timeToDetection: overrides && overrides.hasOwnProperty('timeToDetection') ? overrides.timeToDetection! : '93',
        timeToRemediation: overrides && overrides.hasOwnProperty('timeToRemediation') ? overrides.timeToRemediation! : '89',
        timeToResponse: overrides && overrides.hasOwnProperty('timeToResponse') ? overrides.timeToResponse! : '27',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-08-14T04:54:13.589Z",
        triage: overrides && overrides.hasOwnProperty('triage') ? overrides.triage! : relationshipsToOmit.has('Triage') ? {} as Triage : aTriage({}, relationshipsToOmit),
        uniqueSignalCount: overrides && overrides.hasOwnProperty('uniqueSignalCount') ? overrides.uniqueSignalCount! : 2450,
    };
};

export const anInsightActivityFeedEvent = (overrides?: Partial<InsightActivityFeedEvent>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightActivityFeedEvent' } & InsightActivityFeedEvent => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightActivityFeedEvent');
    return {
        __typename: 'InsightActivityFeedEvent',
        action: overrides && overrides.hasOwnProperty('action') ? overrides.action! : relationshipsToOmit.has('InsightAssigneeUpdatedAction') ? {} as InsightAssigneeUpdatedAction : anInsightAssigneeUpdatedAction({}, relationshipsToOmit),
        insightId: overrides && overrides.hasOwnProperty('insightId') ? overrides.insightId! : 'consequatur',
        insightName: overrides && overrides.hasOwnProperty('insightName') ? overrides.insightName! : 'creator',
        insightReadableId: overrides && overrides.hasOwnProperty('insightReadableId') ? overrides.insightReadableId! : 'quod',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-12-01T16:21:10.136Z",
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 6962,
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'comparo',
    };
};

export const anInsightActivityFeedEventPage = (overrides?: Partial<InsightActivityFeedEventPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightActivityFeedEventPage' } & InsightActivityFeedEventPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightActivityFeedEventPage');
    return {
        __typename: 'InsightActivityFeedEventPage',
        nextPageTimestamp: overrides && overrides.hasOwnProperty('nextPageTimestamp') ? overrides.nextPageTimestamp! : "2025-04-26T01:51:56.512Z",
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('InsightActivityFeedEvent') ? {} as InsightActivityFeedEvent : anInsightActivityFeedEvent({}, relationshipsToOmit), relationshipsToOmit.has('InsightActivityFeedEvent') ? {} as InsightActivityFeedEvent : anInsightActivityFeedEvent({}, relationshipsToOmit), relationshipsToOmit.has('InsightActivityFeedEvent') ? {} as InsightActivityFeedEvent : anInsightActivityFeedEvent({}, relationshipsToOmit)],
    };
};

export const anInsightArtifact = (overrides?: Partial<InsightArtifact>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightArtifact' } & InsightArtifact => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightArtifact');
    return {
        __typename: 'InsightArtifact',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'volva',
        recordStream: overrides && overrides.hasOwnProperty('recordStream') ? overrides.recordStream! : 'distinctio',
        recordUid: overrides && overrides.hasOwnProperty('recordUid') ? overrides.recordUid! : 'correptius',
        signal: overrides && overrides.hasOwnProperty('signal') ? overrides.signal! : relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit),
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'abundans',
    };
};

export const anInsightAssigneeUpdatedAction = (overrides?: Partial<InsightAssigneeUpdatedAction>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightAssigneeUpdatedAction' } & InsightAssigneeUpdatedAction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightAssigneeUpdatedAction');
    return {
        __typename: 'InsightAssigneeUpdatedAction',
        assignee: overrides && overrides.hasOwnProperty('assignee') ? overrides.assignee! : relationshipsToOmit.has('Team') ? {} as Team : aTeam({}, relationshipsToOmit),
    };
};

export const anInsightComment = (overrides?: Partial<InsightComment>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightComment' } & InsightComment => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightComment');
    return {
        __typename: 'InsightComment',
        author: overrides && overrides.hasOwnProperty('author') ? overrides.author! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        body: overrides && overrides.hasOwnProperty('body') ? overrides.body! : 'comptus',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '8f67c245-b396-495e-b85a-5c68edfd21d1',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-09-12T04:45:56.438Z",
    };
};

export const anInsightCommentAddedAction = (overrides?: Partial<InsightCommentAddedAction>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightCommentAddedAction' } & InsightCommentAddedAction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightCommentAddedAction');
    return {
        __typename: 'InsightCommentAddedAction',
        body: overrides && overrides.hasOwnProperty('body') ? overrides.body! : 'ara',
    };
};

export const anInsightConfig = (overrides?: Partial<InsightConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightConfig' } & InsightConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightConfig');
    return {
        __typename: 'InsightConfig',
        globalSignalSuppressionWindow: overrides && overrides.hasOwnProperty('globalSignalSuppressionWindow') ? overrides.globalSignalSuppressionWindow! : 1798,
        lookbackDays: overrides && overrides.hasOwnProperty('lookbackDays') ? overrides.lookbackDays! : 3.7,
        threshold: overrides && overrides.hasOwnProperty('threshold') ? overrides.threshold! : 7.3,
    };
};

export const anInsightConfigInput = (overrides?: Partial<InsightConfigInput>, _relationshipsToOmit: Set<string> = new Set()): InsightConfigInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightConfigInput');
    return {
        globalSignalSuppressionWindow: overrides && overrides.hasOwnProperty('globalSignalSuppressionWindow') ? overrides.globalSignalSuppressionWindow! : 9036,
        lookbackDays: overrides && overrides.hasOwnProperty('lookbackDays') ? overrides.lookbackDays! : 6.2,
        threshold: overrides && overrides.hasOwnProperty('threshold') ? overrides.threshold! : 7.7,
    };
};

export const anInsightCountByStatus = (overrides?: Partial<InsightCountByStatus>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightCountByStatus' } & InsightCountByStatus => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightCountByStatus');
    return {
        __typename: 'InsightCountByStatus',
        closed: overrides && overrides.hasOwnProperty('closed') ? overrides.closed! : 2413,
        inProgress: overrides && overrides.hasOwnProperty('inProgress') ? overrides.inProgress! : 3413,
        new: overrides && overrides.hasOwnProperty('new') ? overrides.new! : 1795,
        other: overrides && overrides.hasOwnProperty('other') ? overrides.other! : 3802,
        otherDetail: overrides && overrides.hasOwnProperty('otherDetail') ? overrides.otherDetail! : [relationshipsToOmit.has('CustomStatusCount') ? {} as CustomStatusCount : aCustomStatusCount({}, relationshipsToOmit), relationshipsToOmit.has('CustomStatusCount') ? {} as CustomStatusCount : aCustomStatusCount({}, relationshipsToOmit), relationshipsToOmit.has('CustomStatusCount') ? {} as CustomStatusCount : aCustomStatusCount({}, relationshipsToOmit)],
    };
};

export const anInsightCountsByStatusDataPoint = (overrides?: Partial<InsightCountsByStatusDataPoint>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightCountsByStatusDataPoint' } & InsightCountsByStatusDataPoint => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightCountsByStatusDataPoint');
    return {
        __typename: 'InsightCountsByStatusDataPoint',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-10-16T20:31:29.460Z",
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : relationshipsToOmit.has('InsightCountByStatus') ? {} as InsightCountByStatus : anInsightCountByStatus({}, relationshipsToOmit),
    };
};

export const anInsightCreatedAction = (overrides?: Partial<InsightCreatedAction>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightCreatedAction' } & InsightCreatedAction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightCreatedAction');
    return {
        __typename: 'InsightCreatedAction',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : AlertSource.Algorithm,
    };
};

export const anInsightEditableAssignee = (overrides?: Partial<InsightEditableAssignee>, _relationshipsToOmit: Set<string> = new Set()): InsightEditableAssignee => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightEditableAssignee');
    return {
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : InsightAssigneeTypes.Team,
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'acerbitas',
    };
};

export const anInsightEditableFields = (overrides?: Partial<InsightEditableFields>, _relationshipsToOmit: Set<string> = new Set()): InsightEditableFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightEditableFields');
    return {
        assignee: overrides && overrides.hasOwnProperty('assignee') ? overrides.assignee! : relationshipsToOmit.has('InsightEditableAssignee') ? {} as InsightEditableAssignee : anInsightEditableAssignee({}, relationshipsToOmit),
        duplicateInsightId: overrides && overrides.hasOwnProperty('duplicateInsightId') ? overrides.duplicateInsightId! : 'sol',
        fieldsToClear: overrides && overrides.hasOwnProperty('fieldsToClear') ? overrides.fieldsToClear! : [InsightClearableFields.Assignee, InsightClearableFields.Assignee, InsightClearableFields.Assignee],
        resolution: overrides && overrides.hasOwnProperty('resolution') ? overrides.resolution! : 'ultra',
        severity: overrides && overrides.hasOwnProperty('severity') ? overrides.severity! : InsightSeverityPyEnum.Critical,
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : 'absque',
    };
};

export const anInsightEntityActivity = (overrides?: Partial<InsightEntityActivity>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightEntityActivity' } & InsightEntityActivity => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightEntityActivity');
    return {
        __typename: 'InsightEntityActivity',
        entityId: overrides && overrides.hasOwnProperty('entityId') ? overrides.entityId! : 'aegrotatio',
        involvedSignalIds: overrides && overrides.hasOwnProperty('involvedSignalIds') ? overrides.involvedSignalIds! : ['eveniet', 'quod', 'truculenter'],
        isPrimaryEntity: overrides && overrides.hasOwnProperty('isPrimaryEntity') ? overrides.isPrimaryEntity! : false,
        relatedEntityIds: overrides && overrides.hasOwnProperty('relatedEntityIds') ? overrides.relatedEntityIds! : ['veritas', 'decretum', 'aperio'],
    };
};

export const anInsightGroupOffset = (overrides?: Partial<InsightGroupOffset>, _relationshipsToOmit: Set<string> = new Set()): InsightGroupOffset => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightGroupOffset');
    return {
        limit: overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 7822,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'defungo',
        offset: overrides && overrides.hasOwnProperty('offset') ? overrides.offset! : 1784,
    };
};

export const anInsightHistoryEvent = (overrides?: Partial<InsightHistoryEvent>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightHistoryEvent' } & InsightHistoryEvent => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightHistoryEvent');
    return {
        __typename: 'InsightHistoryEvent',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'viridis',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-11-24T11:00:09.408Z",
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
    };
};

export const anInsightPage = (overrides?: Partial<InsightPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightPage' } & InsightPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightPage');
    return {
        __typename: 'InsightPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit), relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit), relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 7264,
    };
};

export const anInsightResolution = (overrides?: Partial<InsightResolution>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightResolution' } & InsightResolution => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightResolution');
    return {
        __typename: 'InsightResolution',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'curiositas',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 6350,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'animadverto',
        parent: overrides && overrides.hasOwnProperty('parent') ? overrides.parent! : relationshipsToOmit.has('InsightResolution') ? {} as InsightResolution : anInsightResolution({}, relationshipsToOmit),
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 14,
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'defendo',
        subResolutions: overrides && overrides.hasOwnProperty('subResolutions') ? overrides.subResolutions! : [relationshipsToOmit.has('InsightResolution') ? {} as InsightResolution : anInsightResolution({}, relationshipsToOmit), relationshipsToOmit.has('InsightResolution') ? {} as InsightResolution : anInsightResolution({}, relationshipsToOmit), relationshipsToOmit.has('InsightResolution') ? {} as InsightResolution : anInsightResolution({}, relationshipsToOmit)],
    };
};

export const anInsightResolutionPage = (overrides?: Partial<InsightResolutionPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightResolutionPage' } & InsightResolutionPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightResolutionPage');
    return {
        __typename: 'InsightResolutionPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('InsightResolution') ? {} as InsightResolution : anInsightResolution({}, relationshipsToOmit), relationshipsToOmit.has('InsightResolution') ? {} as InsightResolution : anInsightResolution({}, relationshipsToOmit), relationshipsToOmit.has('InsightResolution') ? {} as InsightResolution : anInsightResolution({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 6036,
    };
};

export const anInsightSort = (overrides?: Partial<InsightSort>, _relationshipsToOmit: Set<string> = new Set()): InsightSort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightSort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : InsightSortableField.Assignee,
    };
};

export const anInsightStatus = (overrides?: Partial<InsightStatus>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightStatus' } & InsightStatus => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightStatus');
    return {
        __typename: 'InsightStatus',
        color: overrides && overrides.hasOwnProperty('color') ? overrides.color! : '#ffffff',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'tribuo',
        displayName: overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'vaco',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '4b2d7ea4-6a3d-4695-8b97-a2f84c87d953',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'closed',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'vinculum',
    };
};

export const anInsightStatusName = (overrides?: Partial<InsightStatusName>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightStatusName' } & InsightStatusName => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightStatusName');
    return {
        __typename: 'InsightStatusName',
        displayName: overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'armarium',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '792dca8c-669f-474e-ac43-aad7883f5aba',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tepesco',
    };
};

export const anInsightStatusUpdatedAction = (overrides?: Partial<InsightStatusUpdatedAction>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightStatusUpdatedAction' } & InsightStatusUpdatedAction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightStatusUpdatedAction');
    return {
        __typename: 'InsightStatusUpdatedAction',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : relationshipsToOmit.has('InsightStatus') ? {} as InsightStatus : anInsightStatus({}, relationshipsToOmit),
    };
};

export const anInsightTagOption = (overrides?: Partial<InsightTagOption>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InsightTagOption' } & InsightTagOption => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InsightTagOption');
    return {
        __typename: 'InsightTagOption',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'maxime',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'adiuvo',
    };
};

export const anIntRuleOverride = (overrides?: Partial<IntRuleOverride>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'IntRuleOverride' } & IntRuleOverride => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('IntRuleOverride');
    return {
        __typename: 'IntRuleOverride',
        original: overrides && overrides.hasOwnProperty('original') ? overrides.original! : 6439,
        override: overrides && overrides.hasOwnProperty('override') ? overrides.override! : 3987,
    };
};

export const anInventoryEntityGroupConfigurationFields = (overrides?: Partial<InventoryEntityGroupConfigurationFields>, _relationshipsToOmit: Set<string> = new Set()): InventoryEntityGroupConfigurationFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InventoryEntityGroupConfigurationFields');
    return {
        configurationType: overrides && overrides.hasOwnProperty('configurationType') ? overrides.configurationType! : EntityGroupConfigurationType.EntityValue,
        criticality: overrides && overrides.hasOwnProperty('criticality') ? overrides.criticality! : 'iusto',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'apto',
        dynamicTags: overrides && overrides.hasOwnProperty('dynamicTags') ? overrides.dynamicTags! : false,
        group: overrides && overrides.hasOwnProperty('group') ? overrides.group! : 'utroque',
        inventoryKey: overrides && overrides.hasOwnProperty('inventoryKey') ? overrides.inventoryKey! : 'adipisci',
        inventorySource: overrides && overrides.hasOwnProperty('inventorySource') ? overrides.inventorySource! : 'tondeo',
        inventoryType: overrides && overrides.hasOwnProperty('inventoryType') ? overrides.inventoryType! : EntityGroupConfigurationInventoryType.Computer,
        inventoryValue: overrides && overrides.hasOwnProperty('inventoryValue') ? overrides.inventoryValue! : 'bardus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'careo',
        suppressed: overrides && overrides.hasOwnProperty('suppressed') ? overrides.suppressed! : true,
        tagSchema: overrides && overrides.hasOwnProperty('tagSchema') ? overrides.tagSchema! : 'ipsum',
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['vorago', 'thymbra', 'adopto'],
    };
};

export const anInventoryEntityLookupTable = (overrides?: Partial<InventoryEntityLookupTable>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InventoryEntityLookupTable' } & InventoryEntityLookupTable => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InventoryEntityLookupTable');
    return {
        __typename: 'InventoryEntityLookupTable',
        contentId: overrides && overrides.hasOwnProperty('contentId') ? overrides.contentId! : 'denuncio',
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-10-26T00:18:36.076Z",
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ab5c1052-e78d-49e2-a4ac-8347c0880858',
        inventorySource: overrides && overrides.hasOwnProperty('inventorySource') ? overrides.inventorySource! : 'conculco',
        sourceCategory: overrides && overrides.hasOwnProperty('sourceCategory') ? overrides.sourceCategory! : 'porro',
        tableId: overrides && overrides.hasOwnProperty('tableId') ? overrides.tableId! : 'ter',
        tablePath: overrides && overrides.hasOwnProperty('tablePath') ? overrides.tablePath! : 'vespillo',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : EntityLookupTableType.HostIdToHostname,
    };
};

export const anInventoryGroupOption = (overrides?: Partial<InventoryGroupOption>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InventoryGroupOption' } & InventoryGroupOption => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InventoryGroupOption');
    return {
        __typename: 'InventoryGroupOption',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'pax',
    };
};

export const anInventoryInterface = (overrides?: Partial<InventoryInterface>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InventoryInterface' } & InventoryInterface => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InventoryInterface');
    return {
        __typename: 'InventoryInterface',
        groups: overrides && overrides.hasOwnProperty('groups') ? overrides.groups! : ['thymum', 'celo', 'depromo'],
        metadataJson: overrides && overrides.hasOwnProperty('metadataJson') ? overrides.metadataJson! : 'attollo',
        parsedTime: overrides && overrides.hasOwnProperty('parsedTime') ? overrides.parsedTime! : 'teneo',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'patior',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : 'sol',
        uniqueId: overrides && overrides.hasOwnProperty('uniqueId') ? overrides.uniqueId! : 'consequuntur',
    };
};

export const anInventoryPage = (overrides?: Partial<InventoryPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InventoryPage' } & InventoryPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InventoryPage');
    return {
        __typename: 'InventoryPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('ComputerInventory') ? {} as ComputerInventory : aComputerInventory({}, relationshipsToOmit), relationshipsToOmit.has('ComputerInventory') ? {} as ComputerInventory : aComputerInventory({}, relationshipsToOmit), relationshipsToOmit.has('ComputerInventory') ? {} as ComputerInventory : aComputerInventory({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 1535,
    };
};

export const anInventorySort = (overrides?: Partial<InventorySort>, _relationshipsToOmit: Set<string> = new Set()): InventorySort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InventorySort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : InventorySortableField.Timestamp,
    };
};

export const anInviteFailure = (overrides?: Partial<InviteFailure>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InviteFailure' } & InviteFailure => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InviteFailure');
    return {
        __typename: 'InviteFailure',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'cogito',
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'eum',
    };
};

export const anInviteUser = (overrides?: Partial<InviteUser>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InviteUser' } & InviteUser => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InviteUser');
    return {
        __typename: 'InviteUser',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('UserInvitation') ? {} as UserInvitation : aUserInvitation({}, relationshipsToOmit),
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const anInviteUsers = (overrides?: Partial<InviteUsers>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'InviteUsers' } & InviteUsers => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('InviteUsers');
    return {
        __typename: 'InviteUsers',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : [relationshipsToOmit.has('UserInvitation') ? {} as UserInvitation : aUserInvitation({}, relationshipsToOmit), relationshipsToOmit.has('UserInvitation') ? {} as UserInvitation : aUserInvitation({}, relationshipsToOmit), relationshipsToOmit.has('UserInvitation') ? {} as UserInvitation : aUserInvitation({}, relationshipsToOmit)],
        failures: overrides && overrides.hasOwnProperty('failures') ? overrides.failures! : [relationshipsToOmit.has('InviteFailure') ? {} as InviteFailure : anInviteFailure({}, relationshipsToOmit), relationshipsToOmit.has('InviteFailure') ? {} as InviteFailure : anInviteFailure({}, relationshipsToOmit), relationshipsToOmit.has('InviteFailure') ? {} as InviteFailure : anInviteFailure({}, relationshipsToOmit)],
    };
};

export const anItemMeta = (overrides?: Partial<ItemMeta>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ItemMeta' } & ItemMeta => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ItemMeta');
    return {
        __typename: 'ItemMeta',
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : relationshipsToOmit.has('UserAudit') ? {} as UserAudit : aUserAudit({}, relationshipsToOmit),
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'asperiores',
        updated: overrides && overrides.hasOwnProperty('updated') ? overrides.updated! : relationshipsToOmit.has('UserAudit') ? {} as UserAudit : aUserAudit({}, relationshipsToOmit),
    };
};

export const aKeyEvidence = (overrides?: Partial<KeyEvidence>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'KeyEvidence' } & KeyEvidence => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('KeyEvidence');
    return {
        __typename: 'KeyEvidence',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '46ad29b0-c92e-4da7-962e-5ec1ccbb9a27',
        reasoning: overrides && overrides.hasOwnProperty('reasoning') ? overrides.reasoning! : 'pecco',
        signalAnalyses: overrides && overrides.hasOwnProperty('signalAnalyses') ? overrides.signalAnalyses! : [relationshipsToOmit.has('SignalAnalysis') ? {} as SignalAnalysis : aSignalAnalysis({}, relationshipsToOmit), relationshipsToOmit.has('SignalAnalysis') ? {} as SignalAnalysis : aSignalAnalysis({}, relationshipsToOmit), relationshipsToOmit.has('SignalAnalysis') ? {} as SignalAnalysis : aSignalAnalysis({}, relationshipsToOmit)],
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'adsum',
        verdict: overrides && overrides.hasOwnProperty('verdict') ? overrides.verdict! : SimpleVerdict.Benign,
    };
};

export const aLibraryGlobalView = (overrides?: Partial<LibraryGlobalView>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LibraryGlobalView' } & LibraryGlobalView => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LibraryGlobalView');
    return {
        __typename: 'LibraryGlobalView',
        adminRecommended: overrides && overrides.hasOwnProperty('adminRecommended') ? overrides.adminRecommended! : relationshipsToOmit.has('Folder') ? {} as Folder : aFolder({}, relationshipsToOmit),
        installedApps: overrides && overrides.hasOwnProperty('installedApps') ? overrides.installedApps! : relationshipsToOmit.has('Folder') ? {} as Folder : aFolder({}, relationshipsToOmit),
        users: overrides && overrides.hasOwnProperty('users') ? overrides.users! : relationshipsToOmit.has('Folder') ? {} as Folder : aFolder({}, relationshipsToOmit),
    };
};

export const aLivetailQuery = (overrides?: Partial<LivetailQuery>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LivetailQuery' } & LivetailQuery => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LivetailQuery');
    return {
        __typename: 'LivetailQuery',
        queryString: overrides && overrides.hasOwnProperty('queryString') ? overrides.queryString! : 'viriliter',
        screenId: overrides && overrides.hasOwnProperty('screenId') ? overrides.screenId! : 'cogito',
    };
};

export const aLivetailQueryInput = (overrides?: Partial<LivetailQueryInput>, _relationshipsToOmit: Set<string> = new Set()): LivetailQueryInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LivetailQueryInput');
    return {
        queryString: overrides && overrides.hasOwnProperty('queryString') ? overrides.queryString! : 'tumultus',
        screenId: overrides && overrides.hasOwnProperty('screenId') ? overrides.screenId! : 'subnecto',
    };
};

export const aLivetailRecentItem = (overrides?: Partial<LivetailRecentItem>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LivetailRecentItem' } & LivetailRecentItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LivetailRecentItem');
    return {
        __typename: 'LivetailRecentItem',
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'volubilis',
        accessTime: overrides && overrides.hasOwnProperty('accessTime') ? overrides.accessTime! : 'cribro',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'molestias',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 239150064111476,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 9575,
        livetailQueries: overrides && overrides.hasOwnProperty('livetailQueries') ? overrides.livetailQueries! : [relationshipsToOmit.has('LivetailQuery') ? {} as LivetailQuery : aLivetailQuery({}, relationshipsToOmit), relationshipsToOmit.has('LivetailQuery') ? {} as LivetailQuery : aLivetailQuery({}, relationshipsToOmit), relationshipsToOmit.has('LivetailQuery') ? {} as LivetailQuery : aLivetailQuery({}, relationshipsToOmit)],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'pariatur',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 'demoror',
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'bis',
        pageType: overrides && overrides.hasOwnProperty('pageType') ? overrides.pageType! : RecentPageType.Dashboard,
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 791854843742937,
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 5215,
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'solitudo',
    };
};

export const aLivetailRecentItemFields = (overrides?: Partial<LivetailRecentItemFields>, _relationshipsToOmit: Set<string> = new Set()): LivetailRecentItemFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LivetailRecentItemFields');
    return {
        accessTime: overrides && overrides.hasOwnProperty('accessTime') ? overrides.accessTime! : 'tantum',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 4624,
        livetailQueries: overrides && overrides.hasOwnProperty('livetailQueries') ? overrides.livetailQueries! : [relationshipsToOmit.has('LivetailQueryInput') ? {} as LivetailQueryInput : aLivetailQueryInput({}, relationshipsToOmit), relationshipsToOmit.has('LivetailQueryInput') ? {} as LivetailQueryInput : aLivetailQueryInput({}, relationshipsToOmit), relationshipsToOmit.has('LivetailQueryInput') ? {} as LivetailQueryInput : aLivetailQueryInput({}, relationshipsToOmit)],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'apostolus',
        pageType: overrides && overrides.hasOwnProperty('pageType') ? overrides.pageType! : RecentPageType.Dashboard,
    };
};

export const aLogMapping = (overrides?: Partial<LogMapping>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LogMapping' } & LogMapping => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogMapping');
    return {
        __typename: 'LogMapping',
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-03-02T21:51:40.049Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'ago',
        eventIdPattern: overrides && overrides.hasOwnProperty('eventIdPattern') ? overrides.eventIdPattern! : 'tolero',
        fields: overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [relationshipsToOmit.has('LogMappingField') ? {} as LogMappingField : aLogMappingField({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingField') ? {} as LogMappingField : aLogMappingField({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingField') ? {} as LogMappingField : aLogMappingField({}, relationshipsToOmit)],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'aetas',
        inputJson: overrides && overrides.hasOwnProperty('inputJson') ? overrides.inputJson! : 'valeo',
        inputProduct: overrides && overrides.hasOwnProperty('inputProduct') ? overrides.inputProduct! : 'commodi',
        inputVendor: overrides && overrides.hasOwnProperty('inputVendor') ? overrides.inputVendor! : 'territo',
        isCustom: overrides && overrides.hasOwnProperty('isCustom') ? overrides.isCustom! : false,
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : false,
        isStructured: overrides && overrides.hasOwnProperty('isStructured') ? overrides.isStructured! : false,
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-07-02T23:11:12.175Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'thema',
        logFormat: overrides && overrides.hasOwnProperty('logFormat') ? overrides.logFormat! : 'ultra',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vespillo',
        outputJson: overrides && overrides.hasOwnProperty('outputJson') ? overrides.outputJson! : 'eaque',
        outputProductGuid: overrides && overrides.hasOwnProperty('outputProductGuid') ? overrides.outputProductGuid! : 'turpis',
        parsingPattern: overrides && overrides.hasOwnProperty('parsingPattern') ? overrides.parsingPattern! : relationshipsToOmit.has('ParsingPattern') ? {} as ParsingPattern : aParsingPattern({}, relationshipsToOmit),
        parsingPatterns: overrides && overrides.hasOwnProperty('parsingPatterns') ? overrides.parsingPatterns! : [relationshipsToOmit.has('ParsingPattern') ? {} as ParsingPattern : aParsingPattern({}, relationshipsToOmit), relationshipsToOmit.has('ParsingPattern') ? {} as ParsingPattern : aParsingPattern({}, relationshipsToOmit), relationshipsToOmit.has('ParsingPattern') ? {} as ParsingPattern : aParsingPattern({}, relationshipsToOmit)],
        patternName: overrides && overrides.hasOwnProperty('patternName') ? overrides.patternName! : 'amplitudo',
        product: overrides && overrides.hasOwnProperty('product') ? overrides.product! : 'tyrannus',
        recordCount07d: overrides && overrides.hasOwnProperty('recordCount07d') ? overrides.recordCount07d! : 140054247253650,
        recordCount24h: overrides && overrides.hasOwnProperty('recordCount24h') ? overrides.recordCount24h! : 30070780619083,
        recordType: overrides && overrides.hasOwnProperty('recordType') ? overrides.recordType! : 'ulciscor',
        relatesEntities: overrides && overrides.hasOwnProperty('relatesEntities') ? overrides.relatesEntities! : true,
        skippedValues: overrides && overrides.hasOwnProperty('skippedValues') ? overrides.skippedValues! : ['tero', 'cupiditas', 'quibusdam'],
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'adhaero',
        structuredInputs: overrides && overrides.hasOwnProperty('structuredInputs') ? overrides.structuredInputs! : [relationshipsToOmit.has('LogMappingStructuredInput') ? {} as LogMappingStructuredInput : aLogMappingStructuredInput({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingStructuredInput') ? {} as LogMappingStructuredInput : aLogMappingStructuredInput({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingStructuredInput') ? {} as LogMappingStructuredInput : aLogMappingStructuredInput({}, relationshipsToOmit)],
        unstructuredFields: overrides && overrides.hasOwnProperty('unstructuredFields') ? overrides.unstructuredFields! : relationshipsToOmit.has('UnstructuredLogMappingFieldsApi') ? {} as UnstructuredLogMappingFieldsApi : anUnstructuredLogMappingFieldsApi({}, relationshipsToOmit),
        vendor: overrides && overrides.hasOwnProperty('vendor') ? overrides.vendor! : 'sunt',
    };
};

export const aLogMappingField = (overrides?: Partial<LogMappingField>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LogMappingField' } & LogMappingField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogMappingField');
    return {
        __typename: 'LogMappingField',
        alternateValues: overrides && overrides.hasOwnProperty('alternateValues') ? overrides.alternateValues! : ['sustineo', 'thymbra', 'surculus'],
        caseInsensitive: overrides && overrides.hasOwnProperty('caseInsensitive') ? overrides.caseInsensitive! : true,
        defaultValue: overrides && overrides.hasOwnProperty('defaultValue') ? overrides.defaultValue! : 'vehemens',
        fieldJoin: overrides && overrides.hasOwnProperty('fieldJoin') ? overrides.fieldJoin! : ['vero', 'commodo', 'desolo'],
        format: overrides && overrides.hasOwnProperty('format') ? overrides.format! : 'convoco',
        formatParameters: overrides && overrides.hasOwnProperty('formatParameters') ? overrides.formatParameters! : ['tego', 'perspiciatis', 'claro'],
        joinDelimiter: overrides && overrides.hasOwnProperty('joinDelimiter') ? overrides.joinDelimiter! : 'synagoga',
        lookup: overrides && overrides.hasOwnProperty('lookup') ? overrides.lookup! : [relationshipsToOmit.has('LogMappingFieldLookupKeyValue') ? {} as LogMappingFieldLookupKeyValue : aLogMappingFieldLookupKeyValue({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingFieldLookupKeyValue') ? {} as LogMappingFieldLookupKeyValue : aLogMappingFieldLookupKeyValue({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingFieldLookupKeyValue') ? {} as LogMappingFieldLookupKeyValue : aLogMappingFieldLookupKeyValue({}, relationshipsToOmit)],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'undique',
        skippedValues: overrides && overrides.hasOwnProperty('skippedValues') ? overrides.skippedValues! : ['amo', 'tergo', 'decet'],
        splitDelimiter: overrides && overrides.hasOwnProperty('splitDelimiter') ? overrides.splitDelimiter! : 'acquiro',
        splitIndex: overrides && overrides.hasOwnProperty('splitIndex') ? overrides.splitIndex! : 'denuo',
        timeZone: overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'libero',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'alioqui',
        valueType: overrides && overrides.hasOwnProperty('valueType') ? overrides.valueType! : 'verbera',
    };
};

export const aLogMappingFieldFields = (overrides?: Partial<LogMappingFieldFields>, _relationshipsToOmit: Set<string> = new Set()): LogMappingFieldFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogMappingFieldFields');
    return {
        alternateValues: overrides && overrides.hasOwnProperty('alternateValues') ? overrides.alternateValues! : ['cibus', 'sed', 'alii'],
        caseInsensitive: overrides && overrides.hasOwnProperty('caseInsensitive') ? overrides.caseInsensitive! : true,
        defaultValue: overrides && overrides.hasOwnProperty('defaultValue') ? overrides.defaultValue! : 'demulceo',
        fieldJoin: overrides && overrides.hasOwnProperty('fieldJoin') ? overrides.fieldJoin! : ['aequitas', 'synagoga', 'celebrer'],
        format: overrides && overrides.hasOwnProperty('format') ? overrides.format! : 'ullam',
        formatParameters: overrides && overrides.hasOwnProperty('formatParameters') ? overrides.formatParameters! : ['clamo', 'valetudo', 'talio'],
        joinDelimiter: overrides && overrides.hasOwnProperty('joinDelimiter') ? overrides.joinDelimiter! : 'consequatur',
        lookup: overrides && overrides.hasOwnProperty('lookup') ? overrides.lookup! : [relationshipsToOmit.has('LogMappingFieldLookupKeyValueFields') ? {} as LogMappingFieldLookupKeyValueFields : aLogMappingFieldLookupKeyValueFields({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingFieldLookupKeyValueFields') ? {} as LogMappingFieldLookupKeyValueFields : aLogMappingFieldLookupKeyValueFields({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingFieldLookupKeyValueFields') ? {} as LogMappingFieldLookupKeyValueFields : aLogMappingFieldLookupKeyValueFields({}, relationshipsToOmit)],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'pauci',
        skippedValues: overrides && overrides.hasOwnProperty('skippedValues') ? overrides.skippedValues! : ['quos', 'custodia', 'avarus'],
        splitDelimiter: overrides && overrides.hasOwnProperty('splitDelimiter') ? overrides.splitDelimiter! : 'ipsam',
        splitIndex: overrides && overrides.hasOwnProperty('splitIndex') ? overrides.splitIndex! : 'ara',
        timeZone: overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'talis',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'clarus',
        valueType: overrides && overrides.hasOwnProperty('valueType') ? overrides.valueType! : 'contabesco',
    };
};

export const aLogMappingFieldLookupKeyValue = (overrides?: Partial<LogMappingFieldLookupKeyValue>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LogMappingFieldLookupKeyValue' } & LogMappingFieldLookupKeyValue => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogMappingFieldLookupKeyValue');
    return {
        __typename: 'LogMappingFieldLookupKeyValue',
        key: overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'eius',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'cetera',
    };
};

export const aLogMappingFieldLookupKeyValueFields = (overrides?: Partial<LogMappingFieldLookupKeyValueFields>, _relationshipsToOmit: Set<string> = new Set()): LogMappingFieldLookupKeyValueFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogMappingFieldLookupKeyValueFields');
    return {
        key: overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'universe',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'vacuus',
    };
};

export const aLogMappingFieldValueTypeOption = (overrides?: Partial<LogMappingFieldValueTypeOption>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LogMappingFieldValueTypeOption' } & LogMappingFieldValueTypeOption => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogMappingFieldValueTypeOption');
    return {
        __typename: 'LogMappingFieldValueTypeOption',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'minima',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'vere',
    };
};

export const aLogMappingLogFormatOption = (overrides?: Partial<LogMappingLogFormatOption>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LogMappingLogFormatOption' } & LogMappingLogFormatOption => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogMappingLogFormatOption');
    return {
        __typename: 'LogMappingLogFormatOption',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'bellicus',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'veniam',
    };
};

export const aLogMappingMappableField = (overrides?: Partial<LogMappingMappableField>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LogMappingMappableField' } & LogMappingMappableField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogMappingMappableField');
    return {
        __typename: 'LogMappingMappableField',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'caries',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'depulso',
    };
};

export const aLogMappingOptions = (overrides?: Partial<LogMappingOptions>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LogMappingOptions' } & LogMappingOptions => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogMappingOptions');
    return {
        __typename: 'LogMappingOptions',
        fieldValueTypeOptions: overrides && overrides.hasOwnProperty('fieldValueTypeOptions') ? overrides.fieldValueTypeOptions! : [relationshipsToOmit.has('LogMappingFieldValueTypeOption') ? {} as LogMappingFieldValueTypeOption : aLogMappingFieldValueTypeOption({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingFieldValueTypeOption') ? {} as LogMappingFieldValueTypeOption : aLogMappingFieldValueTypeOption({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingFieldValueTypeOption') ? {} as LogMappingFieldValueTypeOption : aLogMappingFieldValueTypeOption({}, relationshipsToOmit)],
        logFormatOptions: overrides && overrides.hasOwnProperty('logFormatOptions') ? overrides.logFormatOptions! : [relationshipsToOmit.has('LogMappingLogFormatOption') ? {} as LogMappingLogFormatOption : aLogMappingLogFormatOption({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingLogFormatOption') ? {} as LogMappingLogFormatOption : aLogMappingLogFormatOption({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingLogFormatOption') ? {} as LogMappingLogFormatOption : aLogMappingLogFormatOption({}, relationshipsToOmit)],
        parsingPatternOptions: overrides && overrides.hasOwnProperty('parsingPatternOptions') ? overrides.parsingPatternOptions! : [relationshipsToOmit.has('LogMappingParsingPatternOption') ? {} as LogMappingParsingPatternOption : aLogMappingParsingPatternOption({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingParsingPatternOption') ? {} as LogMappingParsingPatternOption : aLogMappingParsingPatternOption({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingParsingPatternOption') ? {} as LogMappingParsingPatternOption : aLogMappingParsingPatternOption({}, relationshipsToOmit)],
        recordTypeOptions: overrides && overrides.hasOwnProperty('recordTypeOptions') ? overrides.recordTypeOptions! : [relationshipsToOmit.has('LogMappingRecordTypeOption') ? {} as LogMappingRecordTypeOption : aLogMappingRecordTypeOption({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingRecordTypeOption') ? {} as LogMappingRecordTypeOption : aLogMappingRecordTypeOption({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingRecordTypeOption') ? {} as LogMappingRecordTypeOption : aLogMappingRecordTypeOption({}, relationshipsToOmit)],
    };
};

export const aLogMappingPage = (overrides?: Partial<LogMappingPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LogMappingPage' } & LogMappingPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogMappingPage');
    return {
        __typename: 'LogMappingPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('LogMapping') ? {} as LogMapping : aLogMapping({}, relationshipsToOmit), relationshipsToOmit.has('LogMapping') ? {} as LogMapping : aLogMapping({}, relationshipsToOmit), relationshipsToOmit.has('LogMapping') ? {} as LogMapping : aLogMapping({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 4682,
    };
};

export const aLogMappingParsingPatternOption = (overrides?: Partial<LogMappingParsingPatternOption>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LogMappingParsingPatternOption' } & LogMappingParsingPatternOption => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogMappingParsingPatternOption');
    return {
        __typename: 'LogMappingParsingPatternOption',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'abutor',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'terebro',
    };
};

export const aLogMappingRecordTypeOption = (overrides?: Partial<LogMappingRecordTypeOption>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LogMappingRecordTypeOption' } & LogMappingRecordTypeOption => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogMappingRecordTypeOption');
    return {
        __typename: 'LogMappingRecordTypeOption',
        mappableFields: overrides && overrides.hasOwnProperty('mappableFields') ? overrides.mappableFields! : [relationshipsToOmit.has('LogMappingMappableField') ? {} as LogMappingMappableField : aLogMappingMappableField({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingMappableField') ? {} as LogMappingMappableField : aLogMappingMappableField({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingMappableField') ? {} as LogMappingMappableField : aLogMappingMappableField({}, relationshipsToOmit)],
        objectType: overrides && overrides.hasOwnProperty('objectType') ? overrides.objectType! : 'conspergo',
    };
};

export const aLogMappingSort = (overrides?: Partial<LogMappingSort>, _relationshipsToOmit: Set<string> = new Set()): LogMappingSort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogMappingSort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : LogMappingSortableField.Enabled,
    };
};

export const aLogMappingStructuredInput = (overrides?: Partial<LogMappingStructuredInput>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LogMappingStructuredInput' } & LogMappingStructuredInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogMappingStructuredInput');
    return {
        __typename: 'LogMappingStructuredInput',
        eventIdPattern: overrides && overrides.hasOwnProperty('eventIdPattern') ? overrides.eventIdPattern! : 'voluptates',
        logFormat: overrides && overrides.hasOwnProperty('logFormat') ? overrides.logFormat! : 'synagoga',
        product: overrides && overrides.hasOwnProperty('product') ? overrides.product! : 'valde',
        vendor: overrides && overrides.hasOwnProperty('vendor') ? overrides.vendor! : 'conspergo',
    };
};

export const aLogMappingStructuredInputFields = (overrides?: Partial<LogMappingStructuredInputFields>, _relationshipsToOmit: Set<string> = new Set()): LogMappingStructuredInputFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogMappingStructuredInputFields');
    return {
        eventIdPattern: overrides && overrides.hasOwnProperty('eventIdPattern') ? overrides.eventIdPattern! : 'tripudio',
        logFormat: overrides && overrides.hasOwnProperty('logFormat') ? overrides.logFormat! : 'territo',
        product: overrides && overrides.hasOwnProperty('product') ? overrides.product! : 'paulatim',
        vendor: overrides && overrides.hasOwnProperty('vendor') ? overrides.vendor! : 'ancilla',
    };
};

export const aLogMappingVendorAndProduct = (overrides?: Partial<LogMappingVendorAndProduct>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LogMappingVendorAndProduct' } & LogMappingVendorAndProduct => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogMappingVendorAndProduct');
    return {
        __typename: 'LogMappingVendorAndProduct',
        guid: overrides && overrides.hasOwnProperty('guid') ? overrides.guid! : 'adulatio',
        product: overrides && overrides.hasOwnProperty('product') ? overrides.product! : 'pel',
        vendor: overrides && overrides.hasOwnProperty('vendor') ? overrides.vendor! : 'combibo',
    };
};

export const aLogRecentItem = (overrides?: Partial<LogRecentItem>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LogRecentItem' } & LogRecentItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogRecentItem');
    return {
        __typename: 'LogRecentItem',
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'venio',
        accessTime: overrides && overrides.hasOwnProperty('accessTime') ? overrides.accessTime! : 'deleo',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'culpo',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 635318224614394,
        hash: overrides && overrides.hasOwnProperty('hash') ? overrides.hash! : 'suscipit',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 9440,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'adamo',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 'audio',
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'tardus',
        pageType: overrides && overrides.hasOwnProperty('pageType') ? overrides.pageType! : RecentPageType.Dashboard,
        parameters: overrides && overrides.hasOwnProperty('parameters') ? overrides.parameters! : [relationshipsToOmit.has('SearchQueryParameter') ? {} as SearchQueryParameter : aSearchQueryParameter({}, relationshipsToOmit), relationshipsToOmit.has('SearchQueryParameter') ? {} as SearchQueryParameter : aSearchQueryParameter({}, relationshipsToOmit), relationshipsToOmit.has('SearchQueryParameter') ? {} as SearchQueryParameter : aSearchQueryParameter({}, relationshipsToOmit)],
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 648447866328043,
        pinned: overrides && overrides.hasOwnProperty('pinned') ? overrides.pinned! : false,
        query: overrides && overrides.hasOwnProperty('query') ? overrides.query! : 'et',
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 376,
        scheduled: overrides && overrides.hasOwnProperty('scheduled') ? overrides.scheduled! : true,
        timeRangeEnd: overrides && overrides.hasOwnProperty('timeRangeEnd') ? overrides.timeRangeEnd! : 'tego',
        timeRangeExpression: overrides && overrides.hasOwnProperty('timeRangeExpression') ? overrides.timeRangeExpression! : 'bestia',
        timeRangeStart: overrides && overrides.hasOwnProperty('timeRangeStart') ? overrides.timeRangeStart! : 'aro',
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'optio',
    };
};

export const aLogRecentItemFields = (overrides?: Partial<LogRecentItemFields>, _relationshipsToOmit: Set<string> = new Set()): LogRecentItemFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogRecentItemFields');
    return {
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'casso',
        accessTime: overrides && overrides.hasOwnProperty('accessTime') ? overrides.accessTime! : 'excepturi',
        author: overrides && overrides.hasOwnProperty('author') ? overrides.author! : 'delibero',
        authorId: overrides && overrides.hasOwnProperty('authorId') ? overrides.authorId! : 'clamo',
        customerId: overrides && overrides.hasOwnProperty('customerId') ? overrides.customerId! : 'aegrus',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'cetera',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 692484914919290,
        hash: overrides && overrides.hasOwnProperty('hash') ? overrides.hash! : 'valens',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 7372,
        metadata: overrides && overrides.hasOwnProperty('metadata') ? overrides.metadata! : relationshipsToOmit.has('LogRecentItemMetadataFields') ? {} as LogRecentItemMetadataFields : aLogRecentItemMetadataFields({}, relationshipsToOmit),
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'articulus',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 'vilis',
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'cometes',
        pageType: overrides && overrides.hasOwnProperty('pageType') ? overrides.pageType! : RecentPageType.Dashboard,
        parameters: overrides && overrides.hasOwnProperty('parameters') ? overrides.parameters! : [relationshipsToOmit.has('SearchQueryParameterInput') ? {} as SearchQueryParameterInput : aSearchQueryParameterInput({}, relationshipsToOmit), relationshipsToOmit.has('SearchQueryParameterInput') ? {} as SearchQueryParameterInput : aSearchQueryParameterInput({}, relationshipsToOmit), relationshipsToOmit.has('SearchQueryParameterInput') ? {} as SearchQueryParameterInput : aSearchQueryParameterInput({}, relationshipsToOmit)],
        pinned: overrides && overrides.hasOwnProperty('pinned') ? overrides.pinned! : false,
        query: overrides && overrides.hasOwnProperty('query') ? overrides.query! : 'coepi',
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 3006,
        timeRangeEnd: overrides && overrides.hasOwnProperty('timeRangeEnd') ? overrides.timeRangeEnd! : 'bonus',
        timeRangeExpression: overrides && overrides.hasOwnProperty('timeRangeExpression') ? overrides.timeRangeExpression! : 'advenio',
        timeRangeStart: overrides && overrides.hasOwnProperty('timeRangeStart') ? overrides.timeRangeStart! : 'soluta',
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'tabgo',
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'agnitio',
    };
};

export const aLogRecentItemMetadata = (overrides?: Partial<LogRecentItemMetadata>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LogRecentItemMetadata' } & LogRecentItemMetadata => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogRecentItemMetadata');
    return {
        __typename: 'LogRecentItemMetadata',
        pinned: overrides && overrides.hasOwnProperty('pinned') ? overrides.pinned! : false,
        saved: overrides && overrides.hasOwnProperty('saved') ? overrides.saved! : true,
    };
};

export const aLogRecentItemMetadataFields = (overrides?: Partial<LogRecentItemMetadataFields>, _relationshipsToOmit: Set<string> = new Set()): LogRecentItemMetadataFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogRecentItemMetadataFields');
    return {
        pinned: overrides && overrides.hasOwnProperty('pinned') ? overrides.pinned! : false,
        saved: overrides && overrides.hasOwnProperty('saved') ? overrides.saved! : true,
    };
};

export const aLoginUser = (overrides?: Partial<LoginUser>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LoginUser' } & LoginUser => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LoginUser');
    return {
        __typename: 'LoginUser',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('CurrentUser') ? {} as CurrentUser : aCurrentUser({}, relationshipsToOmit),
        mfaQrCode: overrides && overrides.hasOwnProperty('mfaQrCode') ? overrides.mfaQrCode! : 'thymbra',
        mfaRequired: overrides && overrides.hasOwnProperty('mfaRequired') ? overrides.mfaRequired! : false,
        mfaSecret: overrides && overrides.hasOwnProperty('mfaSecret') ? overrides.mfaSecret! : 'subnecto',
        mfaSession: overrides && overrides.hasOwnProperty('mfaSession') ? overrides.mfaSession! : 'certus',
    };
};

export const aLogoutUser = (overrides?: Partial<LogoutUser>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LogoutUser' } & LogoutUser => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LogoutUser');
    return {
        __typename: 'LogoutUser',
        redirectUrl: overrides && overrides.hasOwnProperty('redirectUrl') ? overrides.redirectUrl! : 'viscus',
    };
};

export const aLookupTable = (overrides?: Partial<LookupTable>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'LookupTable' } & LookupTable => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('LookupTable');
    return {
        __typename: 'LookupTable',
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'arx',
        actions: overrides && overrides.hasOwnProperty('actions') ? overrides.actions! : ['vallum', 'congregatio', 'utrimque'],
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 141899084924643,
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'tabgo',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'tabula',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 827037802820137,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 384553194543363,
        isFavorite: overrides && overrides.hasOwnProperty('isFavorite') ? overrides.isFavorite! : false,
        modifiedAt: overrides && overrides.hasOwnProperty('modifiedAt') ? overrides.modifiedAt! : 675383035716292,
        modifiedBy: overrides && overrides.hasOwnProperty('modifiedBy') ? overrides.modifiedBy! : 'delicate',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'acer',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 235749560823478,
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'amor',
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 949062627312400,
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : ['armarium', 'triumphus', 'accedo'],
        relativePath: overrides && overrides.hasOwnProperty('relativePath') ? overrides.relativePath! : [relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit), relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit), relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit)],
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 528817833550726,
        sharedAt: overrides && overrides.hasOwnProperty('sharedAt') ? overrides.sharedAt! : 798876711571782,
        sharerId: overrides && overrides.hasOwnProperty('sharerId') ? overrides.sharerId! : 274445883223532,
        sharerName: overrides && overrides.hasOwnProperty('sharerName') ? overrides.sharerName! : 'defessus',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'dens',
        useViewerRbac: overrides && overrides.hasOwnProperty('useViewerRbac') ? overrides.useViewerRbac! : false,
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'atavus',
    };
};

export const aMatchList = (overrides?: Partial<MatchList>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MatchList' } & MatchList => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MatchList');
    return {
        __typename: 'MatchList',
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : true,
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-08-31T03:20:28.602Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'denego',
        defaultTtl: overrides && overrides.hasOwnProperty('defaultTtl') ? overrides.defaultTtl! : 7972,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'tertius',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'a7f779b7-8a62-49b0-b68f-0d05090bf84e',
        items: overrides && overrides.hasOwnProperty('items') ? overrides.items! : relationshipsToOmit.has('MatchListItemPage') ? {} as MatchListItemPage : aMatchListItemPage({}, relationshipsToOmit),
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-05-26T21:10:47.428Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'quos',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'compono',
        targetColumn: overrides && overrides.hasOwnProperty('targetColumn') ? overrides.targetColumn! : 'quos',
    };
};

export const aMatchListFields = (overrides?: Partial<MatchListFields>, _relationshipsToOmit: Set<string> = new Set()): MatchListFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MatchListFields');
    return {
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : true,
        defaultTtl: overrides && overrides.hasOwnProperty('defaultTtl') ? overrides.defaultTtl! : 4747,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'delego',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'accedo',
        targetColumn: overrides && overrides.hasOwnProperty('targetColumn') ? overrides.targetColumn! : 'conforto',
    };
};

export const aMatchListItem = (overrides?: Partial<MatchListItem>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MatchListItem' } & MatchListItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MatchListItem');
    return {
        __typename: 'MatchListItem',
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : false,
        expiration: overrides && overrides.hasOwnProperty('expiration') ? overrides.expiration! : "2025-11-04T05:36:44.693Z",
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '78ca45e8-76aa-447d-9ed7-48bf97b2fb79',
        listId: overrides && overrides.hasOwnProperty('listId') ? overrides.listId! : 'consuasor',
        meta: overrides && overrides.hasOwnProperty('meta') ? overrides.meta! : relationshipsToOmit.has('ItemMeta') ? {} as ItemMeta : anItemMeta({}, relationshipsToOmit),
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'comprehendo',
    };
};

export const aMatchListItemFields = (overrides?: Partial<MatchListItemFields>, _relationshipsToOmit: Set<string> = new Set()): MatchListItemFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MatchListItemFields');
    return {
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : true,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'sunt',
        expiration: overrides && overrides.hasOwnProperty('expiration') ? overrides.expiration! : "2025-09-13T09:33:18.352Z",
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'suppono',
    };
};

export const aMatchListItemPage = (overrides?: Partial<MatchListItemPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MatchListItemPage' } & MatchListItemPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MatchListItemPage');
    return {
        __typename: 'MatchListItemPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('MatchListItem') ? {} as MatchListItem : aMatchListItem({}, relationshipsToOmit), relationshipsToOmit.has('MatchListItem') ? {} as MatchListItem : aMatchListItem({}, relationshipsToOmit), relationshipsToOmit.has('MatchListItem') ? {} as MatchListItem : aMatchListItem({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 4749,
    };
};

export const aMatchListItemSort = (overrides?: Partial<MatchListItemSort>, _relationshipsToOmit: Set<string> = new Set()): MatchListItemSort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MatchListItemSort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : MatchListItemSortableField.Active,
    };
};

export const aMatchListPage = (overrides?: Partial<MatchListPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MatchListPage' } & MatchListPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MatchListPage');
    return {
        __typename: 'MatchListPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('MatchList') ? {} as MatchList : aMatchList({}, relationshipsToOmit), relationshipsToOmit.has('MatchList') ? {} as MatchList : aMatchList({}, relationshipsToOmit), relationshipsToOmit.has('MatchList') ? {} as MatchList : aMatchList({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 8116,
    };
};

export const aMatchRule = (overrides?: Partial<MatchRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MatchRule' } & MatchRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MatchRule');
    return {
        __typename: 'MatchRule',
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'una',
        autoDisabledReason: overrides && overrides.hasOwnProperty('autoDisabledReason') ? overrides.autoDisabledReason! : 'sunt',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'creo',
        contentType: overrides && overrides.hasOwnProperty('contentType') ? overrides.contentType! : ContentType.Anomaly,
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-01-06T23:16:28.695Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'comptus',
        createdByUser: overrides && overrides.hasOwnProperty('createdByUser') ? overrides.createdByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        deleted: overrides && overrides.hasOwnProperty('deleted') ? overrides.deleted! : false,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'maxime',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit)],
        entitySelectorsOverride: overrides && overrides.hasOwnProperty('entitySelectorsOverride') ? overrides.entitySelectorsOverride! : relationshipsToOmit.has('EntitySelectorsRuleOverride') ? {} as EntitySelectorsRuleOverride : anEntitySelectorsRuleOverride({}, relationshipsToOmit),
        exportJson: overrides && overrides.hasOwnProperty('exportJson') ? overrides.exportJson! : 'adstringo',
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'arguo',
        failing: overrides && overrides.hasOwnProperty('failing') ? overrides.failing! : false,
        hasOverride: overrides && overrides.hasOwnProperty('hasOverride') ? overrides.hasOverride! : true,
        history: overrides && overrides.hasOwnProperty('history') ? overrides.history! : [relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit)],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '0841fea8-9001-4ae1-bb6c-c104caa47408',
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : false,
        isPrototypeOverride: overrides && overrides.hasOwnProperty('isPrototypeOverride') ? overrides.isPrototypeOverride! : relationshipsToOmit.has('BooleanRuleOverride') ? {} as BooleanRuleOverride : aBooleanRuleOverride({}, relationshipsToOmit),
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-02-23T02:57:11.659Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'valetudo',
        lastUpdatedByUser: overrides && overrides.hasOwnProperty('lastUpdatedByUser') ? overrides.lastUpdatedByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'annus',
        nameOverride: overrides && overrides.hasOwnProperty('nameOverride') ? overrides.nameOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : 'ec9cd3ed-7ff1-4193-a805-8d715ce9a4d9',
        rawJson: overrides && overrides.hasOwnProperty('rawJson') ? overrides.rawJson! : 'aestas',
        rawStatus: overrides && overrides.hasOwnProperty('rawStatus') ? overrides.rawStatus! : relationshipsToOmit.has('RuleStatus') ? {} as RuleStatus : aRuleStatus({}, relationshipsToOmit),
        ruleDescription: overrides && overrides.hasOwnProperty('ruleDescription') ? overrides.ruleDescription! : 'subseco',
        ruleId: overrides && overrides.hasOwnProperty('ruleId') ? overrides.ruleId! : 5233,
        ruleSource: overrides && overrides.hasOwnProperty('ruleSource') ? overrides.ruleSource! : 'urbanus',
        ruleType: overrides && overrides.hasOwnProperty('ruleType') ? overrides.ruleType! : 'ter',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 7422,
        signalCount07d: overrides && overrides.hasOwnProperty('signalCount07d') ? overrides.signalCount07d! : 7098,
        signalCount24h: overrides && overrides.hasOwnProperty('signalCount24h') ? overrides.signalCount24h! : 7368,
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : relationshipsToOmit.has('RuleStatus') ? {} as RuleStatus : aRuleStatus({}, relationshipsToOmit),
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'videlicet',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'unus',
        summaryExpressionOverride: overrides && overrides.hasOwnProperty('summaryExpressionOverride') ? overrides.summaryExpressionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 197,
        suppressionWindowSizeOverride: overrides && overrides.hasOwnProperty('suppressionWindowSizeOverride') ? overrides.suppressionWindowSizeOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['defendo', 'audio', 'cohaero'],
        tagsOverride: overrides && overrides.hasOwnProperty('tagsOverride') ? overrides.tagsOverride! : relationshipsToOmit.has('StringListRuleOverride') ? {} as StringListRuleOverride : aStringListRuleOverride({}, relationshipsToOmit),
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['vulpes', 'tenax', 'aestivus'],
        tuningExpressions: overrides && overrides.hasOwnProperty('tuningExpressions') ? overrides.tuningExpressions! : [relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit)],
    };
};

export const aMatchRuleFields = (overrides?: Partial<MatchRuleFields>, _relationshipsToOmit: Set<string> = new Set()): MatchRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MatchRuleFields');
    return {
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'corpus',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'alias',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'sopor',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'via',
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : false,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'capto',
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : '4be2312d-825b-48af-a9be-986df9734fe9',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 2617,
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'voluptatem',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'thesis',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 7809,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['ulterius', 'aiunt', 'corrumpo'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['bc393f30-d1dd-4fd1-8da5-4efa918afa0d', 'c0641935-cd88-49dc-9f4d-aeb11875698f', 'e3d36911-9f4f-41b6-87fe-fe35701e3772'],
    };
};

export const aMatchedField = (overrides?: Partial<MatchedField>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MatchedField' } & MatchedField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MatchedField');
    return {
        __typename: 'MatchedField',
        characterRanges: overrides && overrides.hasOwnProperty('characterRanges') ? overrides.characterRanges! : [relationshipsToOmit.has('MatchedFieldCharacterRange') ? {} as MatchedFieldCharacterRange : aMatchedFieldCharacterRange({}, relationshipsToOmit), relationshipsToOmit.has('MatchedFieldCharacterRange') ? {} as MatchedFieldCharacterRange : aMatchedFieldCharacterRange({}, relationshipsToOmit), relationshipsToOmit.has('MatchedFieldCharacterRange') ? {} as MatchedFieldCharacterRange : aMatchedFieldCharacterRange({}, relationshipsToOmit)],
        exact: overrides && overrides.hasOwnProperty('exact') ? overrides.exact! : false,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'praesentium',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'spectaculum',
    };
};

export const aMatchedFieldCharacterRange = (overrides?: Partial<MatchedFieldCharacterRange>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MatchedFieldCharacterRange' } & MatchedFieldCharacterRange => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MatchedFieldCharacterRange');
    return {
        __typename: 'MatchedFieldCharacterRange',
        end: overrides && overrides.hasOwnProperty('end') ? overrides.end! : 9579,
        start: overrides && overrides.hasOwnProperty('start') ? overrides.start! : 8482,
    };
};

export const aMetric = (overrides?: Partial<Metric>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Metric' } & Metric => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Metric');
    return {
        __typename: 'Metric',
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'sperno',
        actions: overrides && overrides.hasOwnProperty('actions') ? overrides.actions! : ['quas', 'corrigo', 'canis'],
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 933431745931075,
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'conor',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'thesis',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 267799246581610,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 20290100823233,
        isFavorite: overrides && overrides.hasOwnProperty('isFavorite') ? overrides.isFavorite! : true,
        modifiedAt: overrides && overrides.hasOwnProperty('modifiedAt') ? overrides.modifiedAt! : 229200148302460,
        modifiedBy: overrides && overrides.hasOwnProperty('modifiedBy') ? overrides.modifiedBy! : 'cupiditate',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'quam',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 879150795657350,
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'esse',
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 598208325874202,
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : ['sit', 'teres', 'claudeo'],
        relativePath: overrides && overrides.hasOwnProperty('relativePath') ? overrides.relativePath! : [relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit), relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit), relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit)],
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 10623261374291,
        sharedAt: overrides && overrides.hasOwnProperty('sharedAt') ? overrides.sharedAt! : 756942694823330,
        sharerId: overrides && overrides.hasOwnProperty('sharerId') ? overrides.sharerId! : 265886686782166,
        sharerName: overrides && overrides.hasOwnProperty('sharerName') ? overrides.sharerName! : 'ager',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'adeptio',
        useViewerRbac: overrides && overrides.hasOwnProperty('useViewerRbac') ? overrides.useViewerRbac! : true,
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'cattus',
    };
};

export const aMetricQueryFields = (overrides?: Partial<MetricQueryFields>, _relationshipsToOmit: Set<string> = new Set()): MetricQueryFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MetricQueryFields');
    return {
        metricsQueryData: overrides && overrides.hasOwnProperty('metricsQueryData') ? overrides.metricsQueryData! : relationshipsToOmit.has('MetricsQueryDataInput') ? {} as MetricsQueryDataInput : aMetricsQueryDataInput({}, relationshipsToOmit),
        metricsQueryMode: overrides && overrides.hasOwnProperty('metricsQueryMode') ? overrides.metricsQueryMode! : QueryModes.Advanced,
        queryKey: overrides && overrides.hasOwnProperty('queryKey') ? overrides.queryKey! : 'hic',
        queryString: overrides && overrides.hasOwnProperty('queryString') ? overrides.queryString! : 'uredo',
        queryType: overrides && overrides.hasOwnProperty('queryType') ? overrides.queryType! : QueryTypes.Logs,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : MetricsQueryType.AdvancedMetricsQuery,
    };
};

export const aMetricRecentItem = (overrides?: Partial<MetricRecentItem>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MetricRecentItem' } & MetricRecentItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MetricRecentItem');
    return {
        __typename: 'MetricRecentItem',
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'tergo',
        accessTime: overrides && overrides.hasOwnProperty('accessTime') ? overrides.accessTime! : 'nobis',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'minus',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 439843693176856,
        hash: overrides && overrides.hasOwnProperty('hash') ? overrides.hash! : 'tergeo',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 9798,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'inventore',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 'quos',
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'sol',
        pageType: overrides && overrides.hasOwnProperty('pageType') ? overrides.pageType! : RecentPageType.Dashboard,
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 993683270373781,
        queries: overrides && overrides.hasOwnProperty('queries') ? overrides.queries! : [relationshipsToOmit.has('MetricsQuery') ? {} as MetricsQuery : aMetricsQuery({}, relationshipsToOmit), relationshipsToOmit.has('MetricsQuery') ? {} as MetricsQuery : aMetricsQuery({}, relationshipsToOmit), relationshipsToOmit.has('MetricsQuery') ? {} as MetricsQuery : aMetricsQuery({}, relationshipsToOmit)],
        query: overrides && overrides.hasOwnProperty('query') ? overrides.query! : 'tantillus',
        queryType: overrides && overrides.hasOwnProperty('queryType') ? overrides.queryType! : QueryTypes.Logs,
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 2341,
        timeRangeEnd: overrides && overrides.hasOwnProperty('timeRangeEnd') ? overrides.timeRangeEnd! : 'deleniti',
        timeRangeExpression: overrides && overrides.hasOwnProperty('timeRangeExpression') ? overrides.timeRangeExpression! : 'cauda',
        timeRangeStart: overrides && overrides.hasOwnProperty('timeRangeStart') ? overrides.timeRangeStart! : 'alias',
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'deorsum',
    };
};

export const aMetricRecentItemFields = (overrides?: Partial<MetricRecentItemFields>, _relationshipsToOmit: Set<string> = new Set()): MetricRecentItemFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MetricRecentItemFields');
    return {
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'ascisco',
        accessTime: overrides && overrides.hasOwnProperty('accessTime') ? overrides.accessTime! : 'bos',
        author: overrides && overrides.hasOwnProperty('author') ? overrides.author! : 'combibo',
        authorId: overrides && overrides.hasOwnProperty('authorId') ? overrides.authorId! : 'succurro',
        customerId: overrides && overrides.hasOwnProperty('customerId') ? overrides.customerId! : 'dignissimos',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'suadeo',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 6014632859009,
        hash: overrides && overrides.hasOwnProperty('hash') ? overrides.hash! : 'inflammatio',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 6107,
        metadata: overrides && overrides.hasOwnProperty('metadata') ? overrides.metadata! : relationshipsToOmit.has('MetricRecentItemMetadataFields') ? {} as MetricRecentItemMetadataFields : aMetricRecentItemMetadataFields({}, relationshipsToOmit),
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'pauper',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 'aeger',
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'ceno',
        pageType: overrides && overrides.hasOwnProperty('pageType') ? overrides.pageType! : RecentPageType.Dashboard,
        queries: overrides && overrides.hasOwnProperty('queries') ? overrides.queries! : [relationshipsToOmit.has('MetricQueryFields') ? {} as MetricQueryFields : aMetricQueryFields({}, relationshipsToOmit), relationshipsToOmit.has('MetricQueryFields') ? {} as MetricQueryFields : aMetricQueryFields({}, relationshipsToOmit), relationshipsToOmit.has('MetricQueryFields') ? {} as MetricQueryFields : aMetricQueryFields({}, relationshipsToOmit)],
        query: overrides && overrides.hasOwnProperty('query') ? overrides.query! : 'tametsi',
        queryType: overrides && overrides.hasOwnProperty('queryType') ? overrides.queryType! : QueryTypes.Logs,
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 8578,
        timeRangeEnd: overrides && overrides.hasOwnProperty('timeRangeEnd') ? overrides.timeRangeEnd! : 'autus',
        timeRangeExpression: overrides && overrides.hasOwnProperty('timeRangeExpression') ? overrides.timeRangeExpression! : 'usitas',
        timeRangeStart: overrides && overrides.hasOwnProperty('timeRangeStart') ? overrides.timeRangeStart! : 'cur',
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'atrocitas',
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'adeptio',
    };
};

export const aMetricRecentItemMetadata = (overrides?: Partial<MetricRecentItemMetadata>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MetricRecentItemMetadata' } & MetricRecentItemMetadata => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MetricRecentItemMetadata');
    return {
        __typename: 'MetricRecentItemMetadata',
        saved: overrides && overrides.hasOwnProperty('saved') ? overrides.saved! : false,
    };
};

export const aMetricRecentItemMetadataFields = (overrides?: Partial<MetricRecentItemMetadataFields>, _relationshipsToOmit: Set<string> = new Set()): MetricRecentItemMetadataFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MetricRecentItemMetadataFields');
    return {
        saved: overrides && overrides.hasOwnProperty('saved') ? overrides.saved! : true,
    };
};

export const aMetricV2 = (overrides?: Partial<MetricV2>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MetricV2' } & MetricV2 => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MetricV2');
    return {
        __typename: 'MetricV2',
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'ubi',
        actions: overrides && overrides.hasOwnProperty('actions') ? overrides.actions! : ['tenax', 'audeo', 'thymbra'],
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 865644760926237,
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'soluta',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'tripudio',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 137631407874555,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 695770396318262,
        isFavorite: overrides && overrides.hasOwnProperty('isFavorite') ? overrides.isFavorite! : false,
        modifiedAt: overrides && overrides.hasOwnProperty('modifiedAt') ? overrides.modifiedAt! : 613727639969205,
        modifiedBy: overrides && overrides.hasOwnProperty('modifiedBy') ? overrides.modifiedBy! : 'via',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'pariatur',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 510748512744956,
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'terreo',
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 176287388119481,
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : ['volva', 'accusantium', 'tracto'],
        relativePath: overrides && overrides.hasOwnProperty('relativePath') ? overrides.relativePath! : [relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit), relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit), relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit)],
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 527962162095765,
        sharedAt: overrides && overrides.hasOwnProperty('sharedAt') ? overrides.sharedAt! : 104167413357658,
        sharerId: overrides && overrides.hasOwnProperty('sharerId') ? overrides.sharerId! : 345023651043930,
        sharerName: overrides && overrides.hasOwnProperty('sharerName') ? overrides.sharerName! : 'suscipit',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'impedit',
        useViewerRbac: overrides && overrides.hasOwnProperty('useViewerRbac') ? overrides.useViewerRbac! : false,
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'venio',
    };
};

export const aMetricsQuery = (overrides?: Partial<MetricsQuery>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MetricsQuery' } & MetricsQuery => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MetricsQuery');
    return {
        __typename: 'MetricsQuery',
        metricsQueryData: overrides && overrides.hasOwnProperty('metricsQueryData') ? overrides.metricsQueryData! : relationshipsToOmit.has('MetricsQueryData') ? {} as MetricsQueryData : aMetricsQueryData({}, relationshipsToOmit),
        metricsQueryMode: overrides && overrides.hasOwnProperty('metricsQueryMode') ? overrides.metricsQueryMode! : QueryModes.Advanced,
        queryKey: overrides && overrides.hasOwnProperty('queryKey') ? overrides.queryKey! : 'undique',
        queryString: overrides && overrides.hasOwnProperty('queryString') ? overrides.queryString! : 'adeptio',
        queryType: overrides && overrides.hasOwnProperty('queryType') ? overrides.queryType! : QueryTypes.Logs,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : MetricsQueryType.AdvancedMetricsQuery,
    };
};

export const aMetricsQueryData = (overrides?: Partial<MetricsQueryData>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MetricsQueryData' } & MetricsQueryData => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MetricsQueryData');
    return {
        __typename: 'MetricsQueryData',
        filters: overrides && overrides.hasOwnProperty('filters') ? overrides.filters! : [relationshipsToOmit.has('MetricsQueryFilterByPair') ? {} as MetricsQueryFilterByPair : aMetricsQueryFilterByPair({}, relationshipsToOmit), relationshipsToOmit.has('MetricsQueryFilterByPair') ? {} as MetricsQueryFilterByPair : aMetricsQueryFilterByPair({}, relationshipsToOmit), relationshipsToOmit.has('MetricsQueryFilterByPair') ? {} as MetricsQueryFilterByPair : aMetricsQueryFilterByPair({}, relationshipsToOmit)],
        metric: overrides && overrides.hasOwnProperty('metric') ? overrides.metric! : 'vulariter',
        operators: overrides && overrides.hasOwnProperty('operators') ? overrides.operators! : 'ager',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'umquam',
    };
};

export const aMetricsQueryDataInput = (overrides?: Partial<MetricsQueryDataInput>, _relationshipsToOmit: Set<string> = new Set()): MetricsQueryDataInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MetricsQueryDataInput');
    return {
        filters: overrides && overrides.hasOwnProperty('filters') ? overrides.filters! : [relationshipsToOmit.has('MetricsQueryFilterInput') ? {} as MetricsQueryFilterInput : aMetricsQueryFilterInput({}, relationshipsToOmit), relationshipsToOmit.has('MetricsQueryFilterInput') ? {} as MetricsQueryFilterInput : aMetricsQueryFilterInput({}, relationshipsToOmit), relationshipsToOmit.has('MetricsQueryFilterInput') ? {} as MetricsQueryFilterInput : aMetricsQueryFilterInput({}, relationshipsToOmit)],
        metric: overrides && overrides.hasOwnProperty('metric') ? overrides.metric! : 'amita',
        operators: overrides && overrides.hasOwnProperty('operators') ? overrides.operators! : 'pecto',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'commemoro',
    };
};

export const aMetricsQueryFilterByPair = (overrides?: Partial<MetricsQueryFilterByPair>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MetricsQueryFilterByPair' } & MetricsQueryFilterByPair => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MetricsQueryFilterByPair');
    return {
        __typename: 'MetricsQueryFilterByPair',
        key: overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'tener',
        negation: overrides && overrides.hasOwnProperty('negation') ? overrides.negation! : false,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'denique',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'congregatio',
    };
};

export const aMetricsQueryFilterByValue = (overrides?: Partial<MetricsQueryFilterByValue>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MetricsQueryFilterByValue' } & MetricsQueryFilterByValue => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MetricsQueryFilterByValue');
    return {
        __typename: 'MetricsQueryFilterByValue',
        negation: overrides && overrides.hasOwnProperty('negation') ? overrides.negation! : false,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'amaritudo',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'despecto',
    };
};

export const aMetricsQueryFilterInput = (overrides?: Partial<MetricsQueryFilterInput>, _relationshipsToOmit: Set<string> = new Set()): MetricsQueryFilterInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MetricsQueryFilterInput');
    return {
        key: overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'degenero',
        negation: overrides && overrides.hasOwnProperty('negation') ? overrides.negation! : true,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'coepi',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'pecto',
    };
};

export const aMitreCoverageColorLegend = (overrides?: Partial<MitreCoverageColorLegend>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MitreCoverageColorLegend' } & MitreCoverageColorLegend => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MitreCoverageColorLegend');
    return {
        __typename: 'MitreCoverageColorLegend',
        coverageLevelHighHexCode: overrides && overrides.hasOwnProperty('coverageLevelHighHexCode') ? overrides.coverageLevelHighHexCode! : 'credo',
        coverageLevelLowHexCode: overrides && overrides.hasOwnProperty('coverageLevelLowHexCode') ? overrides.coverageLevelLowHexCode! : 'animus',
        coverageLevelMediumHexCode: overrides && overrides.hasOwnProperty('coverageLevelMediumHexCode') ? overrides.coverageLevelMediumHexCode! : 'depraedor',
        coverageLevelNoneHexCode: overrides && overrides.hasOwnProperty('coverageLevelNoneHexCode') ? overrides.coverageLevelNoneHexCode! : 'totus',
    };
};

export const aMitreTactic = (overrides?: Partial<MitreTactic>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MitreTactic' } & MitreTactic => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MitreTactic');
    return {
        __typename: 'MitreTactic',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'ulciscor',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'esse',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'conventus',
        techniques: overrides && overrides.hasOwnProperty('techniques') ? overrides.techniques! : [relationshipsToOmit.has('MitreTechnique') ? {} as MitreTechnique : aMitreTechnique({}, relationshipsToOmit), relationshipsToOmit.has('MitreTechnique') ? {} as MitreTechnique : aMitreTechnique({}, relationshipsToOmit), relationshipsToOmit.has('MitreTechnique') ? {} as MitreTechnique : aMitreTechnique({}, relationshipsToOmit)],
    };
};

export const aMitreTacticCoverageView = (overrides?: Partial<MitreTacticCoverageView>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MitreTacticCoverageView' } & MitreTacticCoverageView => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MitreTacticCoverageView');
    return {
        __typename: 'MitreTacticCoverageView',
        subTechniqueCoverageCount: overrides && overrides.hasOwnProperty('subTechniqueCoverageCount') ? overrides.subTechniqueCoverageCount! : 3042,
        subTechniqueCoverageTotal: overrides && overrides.hasOwnProperty('subTechniqueCoverageTotal') ? overrides.subTechniqueCoverageTotal! : 8624,
        tactics: overrides && overrides.hasOwnProperty('tactics') ? overrides.tactics! : [relationshipsToOmit.has('MitreTactic') ? {} as MitreTactic : aMitreTactic({}, relationshipsToOmit), relationshipsToOmit.has('MitreTactic') ? {} as MitreTactic : aMitreTactic({}, relationshipsToOmit), relationshipsToOmit.has('MitreTactic') ? {} as MitreTactic : aMitreTactic({}, relationshipsToOmit)],
        techniqueCoverageCount: overrides && overrides.hasOwnProperty('techniqueCoverageCount') ? overrides.techniqueCoverageCount! : 970,
        techniqueCoverageTotal: overrides && overrides.hasOwnProperty('techniqueCoverageTotal') ? overrides.techniqueCoverageTotal! : 6460,
    };
};

export const aMitreTacticTechniqueFilter = (overrides?: Partial<MitreTacticTechniqueFilter>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MitreTacticTechniqueFilter' } & MitreTacticTechniqueFilter => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MitreTacticTechniqueFilter');
    return {
        __typename: 'MitreTacticTechniqueFilter',
        subTechniques: overrides && overrides.hasOwnProperty('subTechniques') ? overrides.subTechniques! : [relationshipsToOmit.has('MitreTechnique') ? {} as MitreTechnique : aMitreTechnique({}, relationshipsToOmit), relationshipsToOmit.has('MitreTechnique') ? {} as MitreTechnique : aMitreTechnique({}, relationshipsToOmit), relationshipsToOmit.has('MitreTechnique') ? {} as MitreTechnique : aMitreTechnique({}, relationshipsToOmit)],
        tactics: overrides && overrides.hasOwnProperty('tactics') ? overrides.tactics! : [relationshipsToOmit.has('MitreTactic') ? {} as MitreTactic : aMitreTactic({}, relationshipsToOmit), relationshipsToOmit.has('MitreTactic') ? {} as MitreTactic : aMitreTactic({}, relationshipsToOmit), relationshipsToOmit.has('MitreTactic') ? {} as MitreTactic : aMitreTactic({}, relationshipsToOmit)],
        techniques: overrides && overrides.hasOwnProperty('techniques') ? overrides.techniques! : [relationshipsToOmit.has('MitreTechnique') ? {} as MitreTechnique : aMitreTechnique({}, relationshipsToOmit), relationshipsToOmit.has('MitreTechnique') ? {} as MitreTechnique : aMitreTechnique({}, relationshipsToOmit), relationshipsToOmit.has('MitreTechnique') ? {} as MitreTechnique : aMitreTechnique({}, relationshipsToOmit)],
    };
};

export const aMitreTaggedRule = (overrides?: Partial<MitreTaggedRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MitreTaggedRule' } & MitreTaggedRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MitreTaggedRule');
    return {
        __typename: 'MitreTaggedRule',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'tabesco',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'clam',
        prototype: overrides && overrides.hasOwnProperty('prototype') ? overrides.prototype! : true,
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'templum',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'vicinus',
    };
};

export const aMitreTaggedRules = (overrides?: Partial<MitreTaggedRules>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MitreTaggedRules' } & MitreTaggedRules => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MitreTaggedRules');
    return {
        __typename: 'MitreTaggedRules',
        rules: overrides && overrides.hasOwnProperty('rules') ? overrides.rules! : [relationshipsToOmit.has('MitreTaggedRule') ? {} as MitreTaggedRule : aMitreTaggedRule({}, relationshipsToOmit), relationshipsToOmit.has('MitreTaggedRule') ? {} as MitreTaggedRule : aMitreTaggedRule({}, relationshipsToOmit), relationshipsToOmit.has('MitreTaggedRule') ? {} as MitreTaggedRule : aMitreTaggedRule({}, relationshipsToOmit)],
    };
};

export const aMitreTechnique = (overrides?: Partial<MitreTechnique>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MitreTechnique' } & MitreTechnique => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MitreTechnique');
    return {
        __typename: 'MitreTechnique',
        coverageLevel: overrides && overrides.hasOwnProperty('coverageLevel') ? overrides.coverageLevel! : 'demens',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'crepusculum',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 'antea',
        externalUrl: overrides && overrides.hasOwnProperty('externalUrl') ? overrides.externalUrl! : 'artificiose',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '6df8db44-eafd-4696-926a-3028ee2096e3',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cras',
        rules: overrides && overrides.hasOwnProperty('rules') ? overrides.rules! : [relationshipsToOmit.has('AggregationRule') ? {} as AggregationRule : anAggregationRule({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRule') ? {} as AggregationRule : anAggregationRule({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRule') ? {} as AggregationRule : anAggregationRule({}, relationshipsToOmit)],
        rulesCoverageFields: overrides && overrides.hasOwnProperty('rulesCoverageFields') ? overrides.rulesCoverageFields! : ['valde', 'placeat', 'creptio'],
        rulesFiredRecently: overrides && overrides.hasOwnProperty('rulesFiredRecently') ? overrides.rulesFiredRecently! : [relationshipsToOmit.has('AggregationRule') ? {} as AggregationRule : anAggregationRule({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRule') ? {} as AggregationRule : anAggregationRule({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRule') ? {} as AggregationRule : anAggregationRule({}, relationshipsToOmit)],
        subTechniques: overrides && overrides.hasOwnProperty('subTechniques') ? overrides.subTechniques! : [relationshipsToOmit.has('MitreTechnique') ? {} as MitreTechnique : aMitreTechnique({}, relationshipsToOmit), relationshipsToOmit.has('MitreTechnique') ? {} as MitreTechnique : aMitreTechnique({}, relationshipsToOmit), relationshipsToOmit.has('MitreTechnique') ? {} as MitreTechnique : aMitreTechnique({}, relationshipsToOmit)],
        undetectable: overrides && overrides.hasOwnProperty('undetectable') ? overrides.undetectable! : 'porro',
    };
};

export const aMutation = (overrides?: Partial<Mutation>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Mutation' } & Mutation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Mutation');
    return {
        __typename: 'Mutation',
        addEntityNote: overrides && overrides.hasOwnProperty('addEntityNote') ? overrides.addEntityNote! : relationshipsToOmit.has('AddEntityNote') ? {} as AddEntityNote : anAddEntityNote({}, relationshipsToOmit),
        addEntityTags: overrides && overrides.hasOwnProperty('addEntityTags') ? overrides.addEntityTags! : relationshipsToOmit.has('AddEntityTags') ? {} as AddEntityTags : anAddEntityTags({}, relationshipsToOmit),
        addFavorite: overrides && overrides.hasOwnProperty('addFavorite') ? overrides.addFavorite! : relationshipsToOmit.has('ContentPage') ? {} as ContentPage : aContentPage({}, relationshipsToOmit),
        addInsightComment: overrides && overrides.hasOwnProperty('addInsightComment') ? overrides.addInsightComment! : relationshipsToOmit.has('AddInsightComment') ? {} as AddInsightComment : anAddInsightComment({}, relationshipsToOmit),
        addInsightCommentsById: overrides && overrides.hasOwnProperty('addInsightCommentsById') ? overrides.addInsightCommentsById! : relationshipsToOmit.has('AddInsightCommentsById') ? {} as AddInsightCommentsById : anAddInsightCommentsById({}, relationshipsToOmit),
        addInsightRelatedIncident: overrides && overrides.hasOwnProperty('addInsightRelatedIncident') ? overrides.addInsightRelatedIncident! : relationshipsToOmit.has('AddInsightRelatedIncident') ? {} as AddInsightRelatedIncident : anAddInsightRelatedIncident({}, relationshipsToOmit),
        addInsightToIncident: overrides && overrides.hasOwnProperty('addInsightToIncident') ? overrides.addInsightToIncident! : relationshipsToOmit.has('AddInsightToIncident') ? {} as AddInsightToIncident : anAddInsightToIncident({}, relationshipsToOmit),
        addItemToMatchList: overrides && overrides.hasOwnProperty('addItemToMatchList') ? overrides.addItemToMatchList! : relationshipsToOmit.has('AddItemToMatchList') ? {} as AddItemToMatchList : anAddItemToMatchList({}, relationshipsToOmit),
        addItemToSuppressList: overrides && overrides.hasOwnProperty('addItemToSuppressList') ? overrides.addItemToSuppressList! : relationshipsToOmit.has('AddItemToSuppressList') ? {} as AddItemToSuppressList : anAddItemToSuppressList({}, relationshipsToOmit),
        addItemToThreatIntelSource: overrides && overrides.hasOwnProperty('addItemToThreatIntelSource') ? overrides.addItemToThreatIntelSource! : relationshipsToOmit.has('AddItemToThreatIntelSource') ? {} as AddItemToThreatIntelSource : anAddItemToThreatIntelSource({}, relationshipsToOmit),
        addItemsToList: overrides && overrides.hasOwnProperty('addItemsToList') ? overrides.addItemsToList! : relationshipsToOmit.has('AddItemsToList') ? {} as AddItemsToList : anAddItemsToList({}, relationshipsToOmit),
        addItemsToSuppressList: overrides && overrides.hasOwnProperty('addItemsToSuppressList') ? overrides.addItemsToSuppressList! : relationshipsToOmit.has('AddItemsToSuppressList') ? {} as AddItemsToSuppressList : anAddItemsToSuppressList({}, relationshipsToOmit),
        addItemsToThreatIntelSource: overrides && overrides.hasOwnProperty('addItemsToThreatIntelSource') ? overrides.addItemsToThreatIntelSource! : relationshipsToOmit.has('AddItemsToThreatIntelSource') ? {} as AddItemsToThreatIntelSource : anAddItemsToThreatIntelSource({}, relationshipsToOmit),
        addSignalsToInsight: overrides && overrides.hasOwnProperty('addSignalsToInsight') ? overrides.addSignalsToInsight! : relationshipsToOmit.has('AddSignalsToInsight') ? {} as AddSignalsToInsight : anAddSignalsToInsight({}, relationshipsToOmit),
        addTagToInsight: overrides && overrides.hasOwnProperty('addTagToInsight') ? overrides.addTagToInsight! : relationshipsToOmit.has('AddTagToInsight') ? {} as AddTagToInsight : anAddTagToInsight({}, relationshipsToOmit),
        addTagToInsightsById: overrides && overrides.hasOwnProperty('addTagToInsightsById') ? overrides.addTagToInsightsById! : relationshipsToOmit.has('AddTagToInsightsById') ? {} as AddTagToInsightsById : anAddTagToInsightsById({}, relationshipsToOmit),
        addYaraRuleToCustomYaraSource: overrides && overrides.hasOwnProperty('addYaraRuleToCustomYaraSource') ? overrides.addYaraRuleToCustomYaraSource! : relationshipsToOmit.has('AddYaraRuleToCustomYaraSource') ? {} as AddYaraRuleToCustomYaraSource : anAddYaraRuleToCustomYaraSource({}, relationshipsToOmit),
        addYaraRulesToCustomYaraSource: overrides && overrides.hasOwnProperty('addYaraRulesToCustomYaraSource') ? overrides.addYaraRulesToCustomYaraSource! : relationshipsToOmit.has('AddYaraRulesToCustomYaraSource') ? {} as AddYaraRulesToCustomYaraSource : anAddYaraRulesToCustomYaraSource({}, relationshipsToOmit),
        bulkAddEntityTags: overrides && overrides.hasOwnProperty('bulkAddEntityTags') ? overrides.bulkAddEntityTags! : relationshipsToOmit.has('BulkAddEntityTags') ? {} as BulkAddEntityTags : aBulkAddEntityTags({}, relationshipsToOmit),
        bulkDeleteMatchListItems: overrides && overrides.hasOwnProperty('bulkDeleteMatchListItems') ? overrides.bulkDeleteMatchListItems! : relationshipsToOmit.has('BulkDeleteMatchListItems') ? {} as BulkDeleteMatchListItems : aBulkDeleteMatchListItems({}, relationshipsToOmit),
        bulkRemoveEntityTags: overrides && overrides.hasOwnProperty('bulkRemoveEntityTags') ? overrides.bulkRemoveEntityTags! : relationshipsToOmit.has('BulkRemoveEntityTags') ? {} as BulkRemoveEntityTags : aBulkRemoveEntityTags({}, relationshipsToOmit),
        bulkUpdateEntityCriticality: overrides && overrides.hasOwnProperty('bulkUpdateEntityCriticality') ? overrides.bulkUpdateEntityCriticality! : relationshipsToOmit.has('BulkUpdateEntityCriticality') ? {} as BulkUpdateEntityCriticality : aBulkUpdateEntityCriticality({}, relationshipsToOmit),
        bulkUpdateEntityTags: overrides && overrides.hasOwnProperty('bulkUpdateEntityTags') ? overrides.bulkUpdateEntityTags! : relationshipsToOmit.has('BulkUpdateEntityTags') ? {} as BulkUpdateEntityTags : aBulkUpdateEntityTags({}, relationshipsToOmit),
        bulkUpdateEntityWhitelist: overrides && overrides.hasOwnProperty('bulkUpdateEntityWhitelist') ? overrides.bulkUpdateEntityWhitelist! : relationshipsToOmit.has('BulkUpdateEntityWhitelist') ? {} as BulkUpdateEntityWhitelist : aBulkUpdateEntityWhitelist({}, relationshipsToOmit),
        bulkUpsertNetworkBlocks: overrides && overrides.hasOwnProperty('bulkUpsertNetworkBlocks') ? overrides.bulkUpsertNetworkBlocks! : relationshipsToOmit.has('BulkUpsertNetworkBlocks') ? {} as BulkUpsertNetworkBlocks : aBulkUpsertNetworkBlocks({}, relationshipsToOmit),
        cancelSumoRecordSearchJob: overrides && overrides.hasOwnProperty('cancelSumoRecordSearchJob') ? overrides.cancelSumoRecordSearchJob! : relationshipsToOmit.has('CancelSumoRecordSearchJob') ? {} as CancelSumoRecordSearchJob : aCancelSumoRecordSearchJob({}, relationshipsToOmit),
        clearSumoLogicConfig: overrides && overrides.hasOwnProperty('clearSumoLogicConfig') ? overrides.clearSumoLogicConfig! : relationshipsToOmit.has('ClearSumoLogicSupportConfig') ? {} as ClearSumoLogicSupportConfig : aClearSumoLogicSupportConfig({}, relationshipsToOmit),
        clearSumoLogicGeneralConfig: overrides && overrides.hasOwnProperty('clearSumoLogicGeneralConfig') ? overrides.clearSumoLogicGeneralConfig! : relationshipsToOmit.has('ClearSumoLogicGeneralConfig') ? {} as ClearSumoLogicGeneralConfig : aClearSumoLogicGeneralConfig({}, relationshipsToOmit),
        clearSumoLogicSupportConfig: overrides && overrides.hasOwnProperty('clearSumoLogicSupportConfig') ? overrides.clearSumoLogicSupportConfig! : relationshipsToOmit.has('ClearSumoLogicSupportConfig') ? {} as ClearSumoLogicSupportConfig : aClearSumoLogicSupportConfig({}, relationshipsToOmit),
        confirmInsightTriageRecommendation: overrides && overrides.hasOwnProperty('confirmInsightTriageRecommendation') ? overrides.confirmInsightTriageRecommendation! : relationshipsToOmit.has('ConfirmInsightTriageRecommendation') ? {} as ConfirmInsightTriageRecommendation : aConfirmInsightTriageRecommendation({}, relationshipsToOmit),
        createAction: overrides && overrides.hasOwnProperty('createAction') ? overrides.createAction! : relationshipsToOmit.has('CreateAction') ? {} as CreateAction : aCreateAction({}, relationshipsToOmit),
        createAggregationRule: overrides && overrides.hasOwnProperty('createAggregationRule') ? overrides.createAggregationRule! : relationshipsToOmit.has('CreateAggregationRule') ? {} as CreateAggregationRule : aCreateAggregationRule({}, relationshipsToOmit),
        createAnomaliThreatIntelSource: overrides && overrides.hasOwnProperty('createAnomaliThreatIntelSource') ? overrides.createAnomaliThreatIntelSource! : relationshipsToOmit.has('CreateAnomaliThreatIntelSource') ? {} as CreateAnomaliThreatIntelSource : aCreateAnomaliThreatIntelSource({}, relationshipsToOmit),
        createAutomation: overrides && overrides.hasOwnProperty('createAutomation') ? overrides.createAutomation! : relationshipsToOmit.has('CreateAutomation') ? {} as CreateAutomation : aCreateAutomation({}, relationshipsToOmit),
        createChainRule: overrides && overrides.hasOwnProperty('createChainRule') ? overrides.createChainRule! : relationshipsToOmit.has('CreateChainRule') ? {} as CreateChainRule : aCreateChainRule({}, relationshipsToOmit),
        createContextAction: overrides && overrides.hasOwnProperty('createContextAction') ? overrides.createContextAction! : relationshipsToOmit.has('CreateContextAction') ? {} as CreateContextAction : aCreateContextAction({}, relationshipsToOmit),
        createCustomEntityType: overrides && overrides.hasOwnProperty('createCustomEntityType') ? overrides.createCustomEntityType! : relationshipsToOmit.has('CreateCustomEntityType') ? {} as CreateCustomEntityType : aCreateCustomEntityType({}, relationshipsToOmit),
        createCustomInsight: overrides && overrides.hasOwnProperty('createCustomInsight') ? overrides.createCustomInsight! : relationshipsToOmit.has('CreateCustomInsight') ? {} as CreateCustomInsight : aCreateCustomInsight({}, relationshipsToOmit),
        createCustomMatchListColumn: overrides && overrides.hasOwnProperty('createCustomMatchListColumn') ? overrides.createCustomMatchListColumn! : relationshipsToOmit.has('CreateCustomMatchListColumn') ? {} as CreateCustomMatchListColumn : aCreateCustomMatchListColumn({}, relationshipsToOmit),
        createCustomThreatIntelSource: overrides && overrides.hasOwnProperty('createCustomThreatIntelSource') ? overrides.createCustomThreatIntelSource! : relationshipsToOmit.has('CreateCustomThreatIntelSource') ? {} as CreateCustomThreatIntelSource : aCreateCustomThreatIntelSource({}, relationshipsToOmit),
        createCustomYaraSource: overrides && overrides.hasOwnProperty('createCustomYaraSource') ? overrides.createCustomYaraSource! : relationshipsToOmit.has('CreateCustomYaraSource') ? {} as CreateCustomYaraSource : aCreateCustomYaraSource({}, relationshipsToOmit),
        createCustomerSourcedEntityLookupTable: overrides && overrides.hasOwnProperty('createCustomerSourcedEntityLookupTable') ? overrides.createCustomerSourcedEntityLookupTable! : relationshipsToOmit.has('CreateCustomerSourcedEntityLookupTable') ? {} as CreateCustomerSourcedEntityLookupTable : aCreateCustomerSourcedEntityLookupTable({}, relationshipsToOmit),
        createEntityCriticalityConfig: overrides && overrides.hasOwnProperty('createEntityCriticalityConfig') ? overrides.createEntityCriticalityConfig! : relationshipsToOmit.has('CreateEntityCriticalityConfig') ? {} as CreateEntityCriticalityConfig : aCreateEntityCriticalityConfig({}, relationshipsToOmit),
        createEntityValueEntityGroupConfiguration: overrides && overrides.hasOwnProperty('createEntityValueEntityGroupConfiguration') ? overrides.createEntityValueEntityGroupConfiguration! : relationshipsToOmit.has('CreateEntityValueEntityGroupConfiguration') ? {} as CreateEntityValueEntityGroupConfiguration : aCreateEntityValueEntityGroupConfiguration({}, relationshipsToOmit),
        createFavoriteField: overrides && overrides.hasOwnProperty('createFavoriteField') ? overrides.createFavoriteField! : relationshipsToOmit.has('CreateFavoriteField') ? {} as CreateFavoriteField : aCreateFavoriteField({}, relationshipsToOmit),
        createFirstSeenRule: overrides && overrides.hasOwnProperty('createFirstSeenRule') ? overrides.createFirstSeenRule! : relationshipsToOmit.has('CreateFirstSeenRule') ? {} as CreateFirstSeenRule : aCreateFirstSeenRule({}, relationshipsToOmit),
        createGithubYaraSource: overrides && overrides.hasOwnProperty('createGithubYaraSource') ? overrides.createGithubYaraSource! : relationshipsToOmit.has('CreateGithubYaraSource') ? {} as CreateGithubYaraSource : aCreateGithubYaraSource({}, relationshipsToOmit),
        createIdefenseThreatIntelSource: overrides && overrides.hasOwnProperty('createIdefenseThreatIntelSource') ? overrides.createIdefenseThreatIntelSource! : relationshipsToOmit.has('CreateIdefenseThreatIntelSource') ? {} as CreateIdefenseThreatIntelSource : aCreateIdefenseThreatIntelSource({}, relationshipsToOmit),
        createIncidentFromInsight: overrides && overrides.hasOwnProperty('createIncidentFromInsight') ? overrides.createIncidentFromInsight! : relationshipsToOmit.has('CreateIncidentFromInsight') ? {} as CreateIncidentFromInsight : aCreateIncidentFromInsight({}, relationshipsToOmit),
        createInsightFromSignal: overrides && overrides.hasOwnProperty('createInsightFromSignal') ? overrides.createInsightFromSignal! : relationshipsToOmit.has('CreateInsightFromSignal') ? {} as CreateInsightFromSignal : aCreateInsightFromSignal({}, relationshipsToOmit),
        createInsightFromSignals: overrides && overrides.hasOwnProperty('createInsightFromSignals') ? overrides.createInsightFromSignals! : relationshipsToOmit.has('CreateInsightFromSignals') ? {} as CreateInsightFromSignals : aCreateInsightFromSignals({}, relationshipsToOmit),
        createInsightResolution: overrides && overrides.hasOwnProperty('createInsightResolution') ? overrides.createInsightResolution! : relationshipsToOmit.has('CreateInsightResolution') ? {} as CreateInsightResolution : aCreateInsightResolution({}, relationshipsToOmit),
        createInsightStatus: overrides && overrides.hasOwnProperty('createInsightStatus') ? overrides.createInsightStatus! : relationshipsToOmit.has('CreateInsightStatus') ? {} as CreateInsightStatus : aCreateInsightStatus({}, relationshipsToOmit),
        createInventoryEntityGroupConfiguration: overrides && overrides.hasOwnProperty('createInventoryEntityGroupConfiguration') ? overrides.createInventoryEntityGroupConfiguration! : relationshipsToOmit.has('CreateInventoryEntityGroupConfiguration') ? {} as CreateInventoryEntityGroupConfiguration : aCreateInventoryEntityGroupConfiguration({}, relationshipsToOmit),
        createInventoryEntityLookupTable: overrides && overrides.hasOwnProperty('createInventoryEntityLookupTable') ? overrides.createInventoryEntityLookupTable! : relationshipsToOmit.has('CreateInventoryEntityLookupTable') ? {} as CreateInventoryEntityLookupTable : aCreateInventoryEntityLookupTable({}, relationshipsToOmit),
        createLogMapping: overrides && overrides.hasOwnProperty('createLogMapping') ? overrides.createLogMapping! : relationshipsToOmit.has('CreateLogMapping') ? {} as CreateLogMapping : aCreateLogMapping({}, relationshipsToOmit),
        createMatchList: overrides && overrides.hasOwnProperty('createMatchList') ? overrides.createMatchList! : relationshipsToOmit.has('CreateMatchList') ? {} as CreateMatchList : aCreateMatchList({}, relationshipsToOmit),
        createMatchRule: overrides && overrides.hasOwnProperty('createMatchRule') ? overrides.createMatchRule! : relationshipsToOmit.has('CreateMatchRule') ? {} as CreateMatchRule : aCreateMatchRule({}, relationshipsToOmit),
        createNetworkBlock: overrides && overrides.hasOwnProperty('createNetworkBlock') ? overrides.createNetworkBlock! : relationshipsToOmit.has('CreateNetworkBlock') ? {} as CreateNetworkBlock : aCreateNetworkBlock({}, relationshipsToOmit),
        createOutlierRule: overrides && overrides.hasOwnProperty('createOutlierRule') ? overrides.createOutlierRule! : relationshipsToOmit.has('CreateOutlierRule') ? {} as CreateOutlierRule : aCreateOutlierRule({}, relationshipsToOmit),
        createRecordArtifactConfig: overrides && overrides.hasOwnProperty('createRecordArtifactConfig') ? overrides.createRecordArtifactConfig! : relationshipsToOmit.has('CreateRecordArtifactConfig') ? {} as CreateRecordArtifactConfig : aCreateRecordArtifactConfig({}, relationshipsToOmit),
        createRole: overrides && overrides.hasOwnProperty('createRole') ? overrides.createRole! : relationshipsToOmit.has('CreateRole') ? {} as CreateRole : aCreateRole({}, relationshipsToOmit),
        createRuleTuningExpression: overrides && overrides.hasOwnProperty('createRuleTuningExpression') ? overrides.createRuleTuningExpression! : relationshipsToOmit.has('CreateRuleTuningExpression') ? {} as CreateRuleTuningExpression : aCreateRuleTuningExpression({}, relationshipsToOmit),
        createStreamingExportConfiguration: overrides && overrides.hasOwnProperty('createStreamingExportConfiguration') ? overrides.createStreamingExportConfiguration! : relationshipsToOmit.has('CreateStreamingExportConfiguration') ? {} as CreateStreamingExportConfiguration : aCreateStreamingExportConfiguration({}, relationshipsToOmit),
        createSumoMapping: overrides && overrides.hasOwnProperty('createSumoMapping') ? overrides.createSumoMapping! : relationshipsToOmit.has('CreateSumoMapping') ? {} as CreateSumoMapping : aCreateSumoMapping({}, relationshipsToOmit),
        createSuppressList: overrides && overrides.hasOwnProperty('createSuppressList') ? overrides.createSuppressList! : relationshipsToOmit.has('CreateSuppressList') ? {} as CreateSuppressList : aCreateSuppressList({}, relationshipsToOmit),
        createTagSchema: overrides && overrides.hasOwnProperty('createTagSchema') ? overrides.createTagSchema! : relationshipsToOmit.has('CreateTagSchema') ? {} as CreateTagSchema : aCreateTagSchema({}, relationshipsToOmit),
        createTaxiiThreatIntelSource: overrides && overrides.hasOwnProperty('createTaxiiThreatIntelSource') ? overrides.createTaxiiThreatIntelSource! : relationshipsToOmit.has('CreateTaxiiThreatIntelSource') ? {} as CreateTaxiiThreatIntelSource : aCreateTaxiiThreatIntelSource({}, relationshipsToOmit),
        createTemplatedMatchRule: overrides && overrides.hasOwnProperty('createTemplatedMatchRule') ? overrides.createTemplatedMatchRule! : relationshipsToOmit.has('CreateTemplatedMatchRule') ? {} as CreateTemplatedMatchRule : aCreateTemplatedMatchRule({}, relationshipsToOmit),
        createThreatQThreatIntelSource: overrides && overrides.hasOwnProperty('createThreatQThreatIntelSource') ? overrides.createThreatQThreatIntelSource! : relationshipsToOmit.has('CreateThreatQThreatIntelSource') ? {} as CreateThreatQThreatIntelSource : aCreateThreatQThreatIntelSource({}, relationshipsToOmit),
        createThresholdRule: overrides && overrides.hasOwnProperty('createThresholdRule') ? overrides.createThresholdRule! : relationshipsToOmit.has('CreateThresholdRule') ? {} as CreateThresholdRule : aCreateThresholdRule({}, relationshipsToOmit),
        deleteAction: overrides && overrides.hasOwnProperty('deleteAction') ? overrides.deleteAction! : relationshipsToOmit.has('DeleteAction') ? {} as DeleteAction : aDeleteAction({}, relationshipsToOmit),
        deleteAutomation: overrides && overrides.hasOwnProperty('deleteAutomation') ? overrides.deleteAutomation! : relationshipsToOmit.has('DeleteAutomation') ? {} as DeleteAutomation : aDeleteAutomation({}, relationshipsToOmit),
        deleteContentAdminMode: overrides && overrides.hasOwnProperty('deleteContentAdminMode') ? overrides.deleteContentAdminMode! : true,
        deleteContextAction: overrides && overrides.hasOwnProperty('deleteContextAction') ? overrides.deleteContextAction! : relationshipsToOmit.has('DeleteContextAction') ? {} as DeleteContextAction : aDeleteContextAction({}, relationshipsToOmit),
        deleteCustomEntityType: overrides && overrides.hasOwnProperty('deleteCustomEntityType') ? overrides.deleteCustomEntityType! : relationshipsToOmit.has('DeleteCustomEntityType') ? {} as DeleteCustomEntityType : aDeleteCustomEntityType({}, relationshipsToOmit),
        deleteCustomInsight: overrides && overrides.hasOwnProperty('deleteCustomInsight') ? overrides.deleteCustomInsight! : relationshipsToOmit.has('DeleteCustomInsight') ? {} as DeleteCustomInsight : aDeleteCustomInsight({}, relationshipsToOmit),
        deleteCustomMatchListColumn: overrides && overrides.hasOwnProperty('deleteCustomMatchListColumn') ? overrides.deleteCustomMatchListColumn! : relationshipsToOmit.has('DeleteCustomMatchListColumn') ? {} as DeleteCustomMatchListColumn : aDeleteCustomMatchListColumn({}, relationshipsToOmit),
        deleteCustomYaraRule: overrides && overrides.hasOwnProperty('deleteCustomYaraRule') ? overrides.deleteCustomYaraRule! : relationshipsToOmit.has('DeleteCustomYaraRule') ? {} as DeleteCustomYaraRule : aDeleteCustomYaraRule({}, relationshipsToOmit),
        deleteCustomerSourcedEntityLookupTable: overrides && overrides.hasOwnProperty('deleteCustomerSourcedEntityLookupTable') ? overrides.deleteCustomerSourcedEntityLookupTable! : relationshipsToOmit.has('DeleteCustomerSourcedEntityLookupTable') ? {} as DeleteCustomerSourcedEntityLookupTable : aDeleteCustomerSourcedEntityLookupTable({}, relationshipsToOmit),
        deleteEntityCriticalityConfig: overrides && overrides.hasOwnProperty('deleteEntityCriticalityConfig') ? overrides.deleteEntityCriticalityConfig! : relationshipsToOmit.has('DeleteEntityCriticalityConfig') ? {} as DeleteEntityCriticalityConfig : aDeleteEntityCriticalityConfig({}, relationshipsToOmit),
        deleteEntityGroupConfiguration: overrides && overrides.hasOwnProperty('deleteEntityGroupConfiguration') ? overrides.deleteEntityGroupConfiguration! : relationshipsToOmit.has('DeleteEntityGroupConfiguration') ? {} as DeleteEntityGroupConfiguration : aDeleteEntityGroupConfiguration({}, relationshipsToOmit),
        deleteEntityNote: overrides && overrides.hasOwnProperty('deleteEntityNote') ? overrides.deleteEntityNote! : relationshipsToOmit.has('DeleteEntityNote') ? {} as DeleteEntityNote : aDeleteEntityNote({}, relationshipsToOmit),
        deleteFavoriteField: overrides && overrides.hasOwnProperty('deleteFavoriteField') ? overrides.deleteFavoriteField! : relationshipsToOmit.has('DeleteFavoriteField') ? {} as DeleteFavoriteField : aDeleteFavoriteField({}, relationshipsToOmit),
        deleteInsight: overrides && overrides.hasOwnProperty('deleteInsight') ? overrides.deleteInsight! : relationshipsToOmit.has('DeleteInsight') ? {} as DeleteInsight : aDeleteInsight({}, relationshipsToOmit),
        deleteInsightComment: overrides && overrides.hasOwnProperty('deleteInsightComment') ? overrides.deleteInsightComment! : relationshipsToOmit.has('DeleteInsightComment') ? {} as DeleteInsightComment : aDeleteInsightComment({}, relationshipsToOmit),
        deleteInsightResolution: overrides && overrides.hasOwnProperty('deleteInsightResolution') ? overrides.deleteInsightResolution! : relationshipsToOmit.has('DeleteInsightResolution') ? {} as DeleteInsightResolution : aDeleteInsightResolution({}, relationshipsToOmit),
        deleteInsightStatus: overrides && overrides.hasOwnProperty('deleteInsightStatus') ? overrides.deleteInsightStatus! : relationshipsToOmit.has('DeleteInsightStatus') ? {} as DeleteInsightStatus : aDeleteInsightStatus({}, relationshipsToOmit),
        deleteInsightsById: overrides && overrides.hasOwnProperty('deleteInsightsById') ? overrides.deleteInsightsById! : relationshipsToOmit.has('DeleteInsightsById') ? {} as DeleteInsightsById : aDeleteInsightsById({}, relationshipsToOmit),
        deleteInventoryEntityLookupTable: overrides && overrides.hasOwnProperty('deleteInventoryEntityLookupTable') ? overrides.deleteInventoryEntityLookupTable! : relationshipsToOmit.has('DeleteInventoryEntityLookupTable') ? {} as DeleteInventoryEntityLookupTable : aDeleteInventoryEntityLookupTable({}, relationshipsToOmit),
        deleteLogMapping: overrides && overrides.hasOwnProperty('deleteLogMapping') ? overrides.deleteLogMapping! : relationshipsToOmit.has('DeleteLogMapping') ? {} as DeleteLogMapping : aDeleteLogMapping({}, relationshipsToOmit),
        deleteMatchList: overrides && overrides.hasOwnProperty('deleteMatchList') ? overrides.deleteMatchList! : relationshipsToOmit.has('DeleteMatchList') ? {} as DeleteMatchList : aDeleteMatchList({}, relationshipsToOmit),
        deleteMatchListItem: overrides && overrides.hasOwnProperty('deleteMatchListItem') ? overrides.deleteMatchListItem! : relationshipsToOmit.has('DeleteMatchListItem') ? {} as DeleteMatchListItem : aDeleteMatchListItem({}, relationshipsToOmit),
        deleteNetworkBlock: overrides && overrides.hasOwnProperty('deleteNetworkBlock') ? overrides.deleteNetworkBlock! : relationshipsToOmit.has('DeleteNetworkBlock') ? {} as DeleteNetworkBlock : aDeleteNetworkBlock({}, relationshipsToOmit),
        deleteRecordArtifactConfig: overrides && overrides.hasOwnProperty('deleteRecordArtifactConfig') ? overrides.deleteRecordArtifactConfig! : relationshipsToOmit.has('DeleteRecordArtifactConfig') ? {} as DeleteRecordArtifactConfig : aDeleteRecordArtifactConfig({}, relationshipsToOmit),
        deleteRole: overrides && overrides.hasOwnProperty('deleteRole') ? overrides.deleteRole! : relationshipsToOmit.has('DeleteRole') ? {} as DeleteRole : aDeleteRole({}, relationshipsToOmit),
        deleteRule: overrides && overrides.hasOwnProperty('deleteRule') ? overrides.deleteRule! : relationshipsToOmit.has('DeleteRule') ? {} as DeleteRule : aDeleteRule({}, relationshipsToOmit),
        deleteRuleTuningExpression: overrides && overrides.hasOwnProperty('deleteRuleTuningExpression') ? overrides.deleteRuleTuningExpression! : relationshipsToOmit.has('DeleteRuleTuningExpression') ? {} as DeleteRuleTuningExpression : aDeleteRuleTuningExpression({}, relationshipsToOmit),
        deleteStreamingExportConfiguration: overrides && overrides.hasOwnProperty('deleteStreamingExportConfiguration') ? overrides.deleteStreamingExportConfiguration! : relationshipsToOmit.has('DeleteStreamingExportConfiguration') ? {} as DeleteStreamingExportConfiguration : aDeleteStreamingExportConfiguration({}, relationshipsToOmit),
        deleteSumoMapping: overrides && overrides.hasOwnProperty('deleteSumoMapping') ? overrides.deleteSumoMapping! : relationshipsToOmit.has('DeleteSumoMapping') ? {} as DeleteSumoMapping : aDeleteSumoMapping({}, relationshipsToOmit),
        deleteSuppressList: overrides && overrides.hasOwnProperty('deleteSuppressList') ? overrides.deleteSuppressList! : relationshipsToOmit.has('DeleteSuppressList') ? {} as DeleteSuppressList : aDeleteSuppressList({}, relationshipsToOmit),
        deleteSuppressListItem: overrides && overrides.hasOwnProperty('deleteSuppressListItem') ? overrides.deleteSuppressListItem! : relationshipsToOmit.has('DeleteSuppressListItem') ? {} as DeleteSuppressListItem : aDeleteSuppressListItem({}, relationshipsToOmit),
        deleteTagSchema: overrides && overrides.hasOwnProperty('deleteTagSchema') ? overrides.deleteTagSchema! : relationshipsToOmit.has('DeleteTagSchema') ? {} as DeleteTagSchema : aDeleteTagSchema({}, relationshipsToOmit),
        deleteThreatIntelItem: overrides && overrides.hasOwnProperty('deleteThreatIntelItem') ? overrides.deleteThreatIntelItem! : relationshipsToOmit.has('DeleteThreatIntelItem') ? {} as DeleteThreatIntelItem : aDeleteThreatIntelItem({}, relationshipsToOmit),
        deleteThreatIntelSource: overrides && overrides.hasOwnProperty('deleteThreatIntelSource') ? overrides.deleteThreatIntelSource! : relationshipsToOmit.has('DeleteThreatIntelSource') ? {} as DeleteThreatIntelSource : aDeleteThreatIntelSource({}, relationshipsToOmit),
        deleteYaraSource: overrides && overrides.hasOwnProperty('deleteYaraSource') ? overrides.deleteYaraSource! : relationshipsToOmit.has('DeleteYaraSource') ? {} as DeleteYaraSource : aDeleteYaraSource({}, relationshipsToOmit),
        executeAction: overrides && overrides.hasOwnProperty('executeAction') ? overrides.executeAction! : relationshipsToOmit.has('ExecuteAction') ? {} as ExecuteAction : anExecuteAction({}, relationshipsToOmit),
        executeAutomation: overrides && overrides.hasOwnProperty('executeAutomation') ? overrides.executeAutomation! : relationshipsToOmit.has('ExecuteAutomation') ? {} as ExecuteAutomation : anExecuteAutomation({}, relationshipsToOmit),
        finishMfaLogin: overrides && overrides.hasOwnProperty('finishMfaLogin') ? overrides.finishMfaLogin! : relationshipsToOmit.has('FinishMfaLogin') ? {} as FinishMfaLogin : aFinishMfaLogin({}, relationshipsToOmit),
        forgotPassword: overrides && overrides.hasOwnProperty('forgotPassword') ? overrides.forgotPassword! : relationshipsToOmit.has('ForgotPassword') ? {} as ForgotPassword : aForgotPassword({}, relationshipsToOmit),
        importRules: overrides && overrides.hasOwnProperty('importRules') ? overrides.importRules! : relationshipsToOmit.has('ImportRules') ? {} as ImportRules : anImportRules({}, relationshipsToOmit),
        inviteUser: overrides && overrides.hasOwnProperty('inviteUser') ? overrides.inviteUser! : relationshipsToOmit.has('InviteUser') ? {} as InviteUser : anInviteUser({}, relationshipsToOmit),
        inviteUsers: overrides && overrides.hasOwnProperty('inviteUsers') ? overrides.inviteUsers! : relationshipsToOmit.has('InviteUsers') ? {} as InviteUsers : anInviteUsers({}, relationshipsToOmit),
        loginUser: overrides && overrides.hasOwnProperty('loginUser') ? overrides.loginUser! : relationshipsToOmit.has('LoginUser') ? {} as LoginUser : aLoginUser({}, relationshipsToOmit),
        logoutUser: overrides && overrides.hasOwnProperty('logoutUser') ? overrides.logoutUser! : relationshipsToOmit.has('LogoutUser') ? {} as LogoutUser : aLogoutUser({}, relationshipsToOmit),
        migrateRecents: overrides && overrides.hasOwnProperty('migrateRecents') ? overrides.migrateRecents! : relationshipsToOmit.has('MutationResponse') ? {} as MutationResponse : aMutationResponse({}, relationshipsToOmit),
        overrideAggregationRule: overrides && overrides.hasOwnProperty('overrideAggregationRule') ? overrides.overrideAggregationRule! : relationshipsToOmit.has('OverrideAggregationRule') ? {} as OverrideAggregationRule : anOverrideAggregationRule({}, relationshipsToOmit),
        overrideChainRule: overrides && overrides.hasOwnProperty('overrideChainRule') ? overrides.overrideChainRule! : relationshipsToOmit.has('OverrideChainRule') ? {} as OverrideChainRule : anOverrideChainRule({}, relationshipsToOmit),
        overrideFirstSeenRule: overrides && overrides.hasOwnProperty('overrideFirstSeenRule') ? overrides.overrideFirstSeenRule! : relationshipsToOmit.has('OverrideFirstSeenRule') ? {} as OverrideFirstSeenRule : anOverrideFirstSeenRule({}, relationshipsToOmit),
        overrideMatchRule: overrides && overrides.hasOwnProperty('overrideMatchRule') ? overrides.overrideMatchRule! : relationshipsToOmit.has('OverrideMatchRule') ? {} as OverrideMatchRule : anOverrideMatchRule({}, relationshipsToOmit),
        overrideOutlierRule: overrides && overrides.hasOwnProperty('overrideOutlierRule') ? overrides.overrideOutlierRule! : relationshipsToOmit.has('OverrideOutlierRule') ? {} as OverrideOutlierRule : anOverrideOutlierRule({}, relationshipsToOmit),
        overrideTemplatedMatchRule: overrides && overrides.hasOwnProperty('overrideTemplatedMatchRule') ? overrides.overrideTemplatedMatchRule! : relationshipsToOmit.has('OverrideTemplatedMatchRule') ? {} as OverrideTemplatedMatchRule : anOverrideTemplatedMatchRule({}, relationshipsToOmit),
        overrideThresholdRule: overrides && overrides.hasOwnProperty('overrideThresholdRule') ? overrides.overrideThresholdRule! : relationshipsToOmit.has('OverrideThresholdRule') ? {} as OverrideThresholdRule : anOverrideThresholdRule({}, relationshipsToOmit),
        promoteTriageToIncident: overrides && overrides.hasOwnProperty('promoteTriageToIncident') ? overrides.promoteTriageToIncident! : relationshipsToOmit.has('PromoteTriageToIncident') ? {} as PromoteTriageToIncident : aPromoteTriageToIncident({}, relationshipsToOmit),
        removeEntityTags: overrides && overrides.hasOwnProperty('removeEntityTags') ? overrides.removeEntityTags! : relationshipsToOmit.has('RemoveEntityTags') ? {} as RemoveEntityTags : aRemoveEntityTags({}, relationshipsToOmit),
        removeFavorite: overrides && overrides.hasOwnProperty('removeFavorite') ? overrides.removeFavorite! : relationshipsToOmit.has('ContentPage') ? {} as ContentPage : aContentPage({}, relationshipsToOmit),
        removeInsightRelatedIncident: overrides && overrides.hasOwnProperty('removeInsightRelatedIncident') ? overrides.removeInsightRelatedIncident! : relationshipsToOmit.has('RemoveInsightRelatedIncident') ? {} as RemoveInsightRelatedIncident : aRemoveInsightRelatedIncident({}, relationshipsToOmit),
        removeSignalsFromInsight: overrides && overrides.hasOwnProperty('removeSignalsFromInsight') ? overrides.removeSignalsFromInsight! : relationshipsToOmit.has('RemoveSignalsFromInsight') ? {} as RemoveSignalsFromInsight : aRemoveSignalsFromInsight({}, relationshipsToOmit),
        removeTagFromInsight: overrides && overrides.hasOwnProperty('removeTagFromInsight') ? overrides.removeTagFromInsight! : relationshipsToOmit.has('RemoveTagFromInsight') ? {} as RemoveTagFromInsight : aRemoveTagFromInsight({}, relationshipsToOmit),
        removeTagFromInsightsById: overrides && overrides.hasOwnProperty('removeTagFromInsightsById') ? overrides.removeTagFromInsightsById! : relationshipsToOmit.has('RemoveTagFromInsightsById') ? {} as RemoveTagFromInsightsById : aRemoveTagFromInsightsById({}, relationshipsToOmit),
        reorderInsightStatuses: overrides && overrides.hasOwnProperty('reorderInsightStatuses') ? overrides.reorderInsightStatuses! : relationshipsToOmit.has('ReorderInsightStatuses') ? {} as ReorderInsightStatuses : aReorderInsightStatuses({}, relationshipsToOmit),
        resendCurrentUserConfirmationEmail: overrides && overrides.hasOwnProperty('resendCurrentUserConfirmationEmail') ? overrides.resendCurrentUserConfirmationEmail! : relationshipsToOmit.has('ResendCurrentUserConfirmationEmail') ? {} as ResendCurrentUserConfirmationEmail : aResendCurrentUserConfirmationEmail({}, relationshipsToOmit),
        resendUserConfirmationEmail: overrides && overrides.hasOwnProperty('resendUserConfirmationEmail') ? overrides.resendUserConfirmationEmail! : relationshipsToOmit.has('ResendUserConfirmationEmail') ? {} as ResendUserConfirmationEmail : aResendUserConfirmationEmail({}, relationshipsToOmit),
        resetCurrentUserApiKey: overrides && overrides.hasOwnProperty('resetCurrentUserApiKey') ? overrides.resetCurrentUserApiKey! : relationshipsToOmit.has('ResetCurrentUserApiKey') ? {} as ResetCurrentUserApiKey : aResetCurrentUserApiKey({}, relationshipsToOmit),
        resetCurrentUserMfaSecret: overrides && overrides.hasOwnProperty('resetCurrentUserMfaSecret') ? overrides.resetCurrentUserMfaSecret! : relationshipsToOmit.has('ResetCurrentUserMfaSecret') ? {} as ResetCurrentUserMfaSecret : aResetCurrentUserMfaSecret({}, relationshipsToOmit),
        resetPassword: overrides && overrides.hasOwnProperty('resetPassword') ? overrides.resetPassword! : relationshipsToOmit.has('ResetPassword') ? {} as ResetPassword : aResetPassword({}, relationshipsToOmit),
        resetUserApiKey: overrides && overrides.hasOwnProperty('resetUserApiKey') ? overrides.resetUserApiKey! : relationshipsToOmit.has('ResetUserApiKey') ? {} as ResetUserApiKey : aResetUserApiKey({}, relationshipsToOmit),
        resetUserMfaSecret: overrides && overrides.hasOwnProperty('resetUserMfaSecret') ? overrides.resetUserMfaSecret! : relationshipsToOmit.has('ResetUserMfaSecret') ? {} as ResetUserMfaSecret : aResetUserMfaSecret({}, relationshipsToOmit),
        resyncFilteredRecents: overrides && overrides.hasOwnProperty('resyncFilteredRecents') ? overrides.resyncFilteredRecents! : relationshipsToOmit.has('MutationResponse') ? {} as MutationResponse : aMutationResponse({}, relationshipsToOmit),
        saveEntityEnrichment: overrides && overrides.hasOwnProperty('saveEntityEnrichment') ? overrides.saveEntityEnrichment! : relationshipsToOmit.has('SaveEntityEnrichment') ? {} as SaveEntityEnrichment : aSaveEntityEnrichment({}, relationshipsToOmit),
        saveInsightEnrichment: overrides && overrides.hasOwnProperty('saveInsightEnrichment') ? overrides.saveInsightEnrichment! : relationshipsToOmit.has('SaveInsightEnrichment') ? {} as SaveInsightEnrichment : aSaveInsightEnrichment({}, relationshipsToOmit),
        saveSignalEnrichment: overrides && overrides.hasOwnProperty('saveSignalEnrichment') ? overrides.saveSignalEnrichment! : relationshipsToOmit.has('SaveSignalEnrichment') ? {} as SaveSignalEnrichment : aSaveSignalEnrichment({}, relationshipsToOmit),
        setContentAdminMode: overrides && overrides.hasOwnProperty('setContentAdminMode') ? overrides.setContentAdminMode! : true,
        setNavAsideCollapsed: overrides && overrides.hasOwnProperty('setNavAsideCollapsed') ? overrides.setNavAsideCollapsed! : relationshipsToOmit.has('MutationResponse') ? {} as MutationResponse : aMutationResponse({}, relationshipsToOmit),
        setNavDrawerPinnedMenu: overrides && overrides.hasOwnProperty('setNavDrawerPinnedMenu') ? overrides.setNavDrawerPinnedMenu! : relationshipsToOmit.has('MutationResponse') ? {} as MutationResponse : aMutationResponse({}, relationshipsToOmit),
        setNavDrawerWidth: overrides && overrides.hasOwnProperty('setNavDrawerWidth') ? overrides.setNavDrawerWidth! : relationshipsToOmit.has('MutationResponse') ? {} as MutationResponse : aMutationResponse({}, relationshipsToOmit),
        signUp: overrides && overrides.hasOwnProperty('signUp') ? overrides.signUp! : relationshipsToOmit.has('SignUp') ? {} as SignUp : aSignUp({}, relationshipsToOmit),
        startCanaryLookupJob: overrides && overrides.hasOwnProperty('startCanaryLookupJob') ? overrides.startCanaryLookupJob! : relationshipsToOmit.has('StartCanaryLookupJob') ? {} as StartCanaryLookupJob : aStartCanaryLookupJob({}, relationshipsToOmit),
        startEntityTimelineGroupRecordJob: overrides && overrides.hasOwnProperty('startEntityTimelineGroupRecordJob') ? overrides.startEntityTimelineGroupRecordJob! : relationshipsToOmit.has('StartEntityTimelineGroupRecordJob') ? {} as StartEntityTimelineGroupRecordJob : aStartEntityTimelineGroupRecordJob({}, relationshipsToOmit),
        startEntityTimelineJob: overrides && overrides.hasOwnProperty('startEntityTimelineJob') ? overrides.startEntityTimelineJob! : relationshipsToOmit.has('StartEntityTimelineJob') ? {} as StartEntityTimelineJob : aStartEntityTimelineJob({}, relationshipsToOmit),
        startSumoInsightSearchJob: overrides && overrides.hasOwnProperty('startSumoInsightSearchJob') ? overrides.startSumoInsightSearchJob! : relationshipsToOmit.has('StartSumoInsightSearchJob') ? {} as StartSumoInsightSearchJob : aStartSumoInsightSearchJob({}, relationshipsToOmit),
        startSumoRawMessageLookupJob: overrides && overrides.hasOwnProperty('startSumoRawMessageLookupJob') ? overrides.startSumoRawMessageLookupJob! : relationshipsToOmit.has('StartSumoRawMessageLookupJob') ? {} as StartSumoRawMessageLookupJob : aStartSumoRawMessageLookupJob({}, relationshipsToOmit),
        startSumoRecordSearchJob: overrides && overrides.hasOwnProperty('startSumoRecordSearchJob') ? overrides.startSumoRecordSearchJob! : relationshipsToOmit.has('StartSumoRecordSearchJob') ? {} as StartSumoRecordSearchJob : aStartSumoRecordSearchJob({}, relationshipsToOmit),
        startSumoRecordSearchJobForRuleExpression: overrides && overrides.hasOwnProperty('startSumoRecordSearchJobForRuleExpression') ? overrides.startSumoRecordSearchJobForRuleExpression! : relationshipsToOmit.has('StartSumoRecordSearchJobForRuleExpression') ? {} as StartSumoRecordSearchJobForRuleExpression : aStartSumoRecordSearchJobForRuleExpression({}, relationshipsToOmit),
        startSumoRecordSearchJobForSignal: overrides && overrides.hasOwnProperty('startSumoRecordSearchJobForSignal') ? overrides.startSumoRecordSearchJobForSignal! : relationshipsToOmit.has('StartSumoRecordSearchJobForSignal') ? {} as StartSumoRecordSearchJobForSignal : aStartSumoRecordSearchJobForSignal({}, relationshipsToOmit),
        triggerActivationEmail: overrides && overrides.hasOwnProperty('triggerActivationEmail') ? overrides.triggerActivationEmail! : relationshipsToOmit.has('MutationResponse') ? {} as MutationResponse : aMutationResponse({}, relationshipsToOmit),
        triggerVerificationEmail: overrides && overrides.hasOwnProperty('triggerVerificationEmail') ? overrides.triggerVerificationEmail! : relationshipsToOmit.has('MutationResponse') ? {} as MutationResponse : aMutationResponse({}, relationshipsToOmit),
        uninviteUser: overrides && overrides.hasOwnProperty('uninviteUser') ? overrides.uninviteUser! : relationshipsToOmit.has('UninviteUser') ? {} as UninviteUser : anUninviteUser({}, relationshipsToOmit),
        updateAction: overrides && overrides.hasOwnProperty('updateAction') ? overrides.updateAction! : relationshipsToOmit.has('UpdateAction') ? {} as UpdateAction : anUpdateAction({}, relationshipsToOmit),
        updateAggregationRule: overrides && overrides.hasOwnProperty('updateAggregationRule') ? overrides.updateAggregationRule! : relationshipsToOmit.has('UpdateAggregationRule') ? {} as UpdateAggregationRule : anUpdateAggregationRule({}, relationshipsToOmit),
        updateAnomaliThreatIntelSource: overrides && overrides.hasOwnProperty('updateAnomaliThreatIntelSource') ? overrides.updateAnomaliThreatIntelSource! : relationshipsToOmit.has('UpdateAnomaliThreatIntelSource') ? {} as UpdateAnomaliThreatIntelSource : anUpdateAnomaliThreatIntelSource({}, relationshipsToOmit),
        updateAssignedInsightEmailsEnabled: overrides && overrides.hasOwnProperty('updateAssignedInsightEmailsEnabled') ? overrides.updateAssignedInsightEmailsEnabled! : relationshipsToOmit.has('UpdateAssignedInsightEmailsEnabled') ? {} as UpdateAssignedInsightEmailsEnabled : anUpdateAssignedInsightEmailsEnabled({}, relationshipsToOmit),
        updateAutomation: overrides && overrides.hasOwnProperty('updateAutomation') ? overrides.updateAutomation! : relationshipsToOmit.has('UpdateAutomation') ? {} as UpdateAutomation : anUpdateAutomation({}, relationshipsToOmit),
        updateBuiltInRule: overrides && overrides.hasOwnProperty('updateBuiltInRule') ? overrides.updateBuiltInRule! : relationshipsToOmit.has('UpdateBuiltInRule') ? {} as UpdateBuiltInRule : anUpdateBuiltInRule({}, relationshipsToOmit),
        updateChainRule: overrides && overrides.hasOwnProperty('updateChainRule') ? overrides.updateChainRule! : relationshipsToOmit.has('UpdateChainRule') ? {} as UpdateChainRule : anUpdateChainRule({}, relationshipsToOmit),
        updateContextAction: overrides && overrides.hasOwnProperty('updateContextAction') ? overrides.updateContextAction! : relationshipsToOmit.has('UpdateContextAction') ? {} as UpdateContextAction : anUpdateContextAction({}, relationshipsToOmit),
        updateCurrentUser: overrides && overrides.hasOwnProperty('updateCurrentUser') ? overrides.updateCurrentUser! : relationshipsToOmit.has('UpdateCurrentUser') ? {} as UpdateCurrentUser : anUpdateCurrentUser({}, relationshipsToOmit),
        updateCustomEntityType: overrides && overrides.hasOwnProperty('updateCustomEntityType') ? overrides.updateCustomEntityType! : relationshipsToOmit.has('UpdateCustomEntityType') ? {} as UpdateCustomEntityType : anUpdateCustomEntityType({}, relationshipsToOmit),
        updateCustomInsight: overrides && overrides.hasOwnProperty('updateCustomInsight') ? overrides.updateCustomInsight! : relationshipsToOmit.has('UpdateCustomInsight') ? {} as UpdateCustomInsight : anUpdateCustomInsight({}, relationshipsToOmit),
        updateCustomInsightEnabled: overrides && overrides.hasOwnProperty('updateCustomInsightEnabled') ? overrides.updateCustomInsightEnabled! : relationshipsToOmit.has('UpdateCustomInsightEnabled') ? {} as UpdateCustomInsightEnabled : anUpdateCustomInsightEnabled({}, relationshipsToOmit),
        updateCustomMatchListColumn: overrides && overrides.hasOwnProperty('updateCustomMatchListColumn') ? overrides.updateCustomMatchListColumn! : relationshipsToOmit.has('UpdateCustomMatchListColumn') ? {} as UpdateCustomMatchListColumn : anUpdateCustomMatchListColumn({}, relationshipsToOmit),
        updateCustomThreatIntelSource: overrides && overrides.hasOwnProperty('updateCustomThreatIntelSource') ? overrides.updateCustomThreatIntelSource! : relationshipsToOmit.has('UpdateCustomThreatIntelSource') ? {} as UpdateCustomThreatIntelSource : anUpdateCustomThreatIntelSource({}, relationshipsToOmit),
        updateCustomYaraRule: overrides && overrides.hasOwnProperty('updateCustomYaraRule') ? overrides.updateCustomYaraRule! : relationshipsToOmit.has('UpdateCustomYaraRule') ? {} as UpdateCustomYaraRule : anUpdateCustomYaraRule({}, relationshipsToOmit),
        updateCustomYaraSource: overrides && overrides.hasOwnProperty('updateCustomYaraSource') ? overrides.updateCustomYaraSource! : relationshipsToOmit.has('UpdateCustomYaraSource') ? {} as UpdateCustomYaraSource : anUpdateCustomYaraSource({}, relationshipsToOmit),
        updateCustomerSourcedEntityLookupTable: overrides && overrides.hasOwnProperty('updateCustomerSourcedEntityLookupTable') ? overrides.updateCustomerSourcedEntityLookupTable! : relationshipsToOmit.has('UpdateCustomerSourcedEntityLookupTable') ? {} as UpdateCustomerSourcedEntityLookupTable : anUpdateCustomerSourcedEntityLookupTable({}, relationshipsToOmit),
        updateDashboardRecentItems: overrides && overrides.hasOwnProperty('updateDashboardRecentItems') ? overrides.updateDashboardRecentItems! : [relationshipsToOmit.has('DashboardRecentItem') ? {} as DashboardRecentItem : aDashboardRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('DashboardRecentItem') ? {} as DashboardRecentItem : aDashboardRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('DashboardRecentItem') ? {} as DashboardRecentItem : aDashboardRecentItem({}, relationshipsToOmit)],
        updateDashboardRecentItemsV2: overrides && overrides.hasOwnProperty('updateDashboardRecentItemsV2') ? overrides.updateDashboardRecentItemsV2! : relationshipsToOmit.has('MutationResponse') ? {} as MutationResponse : aMutationResponse({}, relationshipsToOmit),
        updateEntityCriticality: overrides && overrides.hasOwnProperty('updateEntityCriticality') ? overrides.updateEntityCriticality! : relationshipsToOmit.has('UpdateEntityCriticality') ? {} as UpdateEntityCriticality : anUpdateEntityCriticality({}, relationshipsToOmit),
        updateEntityCriticalityConfig: overrides && overrides.hasOwnProperty('updateEntityCriticalityConfig') ? overrides.updateEntityCriticalityConfig! : relationshipsToOmit.has('UpdateEntityCriticalityConfig') ? {} as UpdateEntityCriticalityConfig : anUpdateEntityCriticalityConfig({}, relationshipsToOmit),
        updateEntityDomainConfiguration: overrides && overrides.hasOwnProperty('updateEntityDomainConfiguration') ? overrides.updateEntityDomainConfiguration! : relationshipsToOmit.has('UpdateEntityDomainConfiguration') ? {} as UpdateEntityDomainConfiguration : anUpdateEntityDomainConfiguration({}, relationshipsToOmit),
        updateEntityNote: overrides && overrides.hasOwnProperty('updateEntityNote') ? overrides.updateEntityNote! : relationshipsToOmit.has('UpdateEntityNote') ? {} as UpdateEntityNote : anUpdateEntityNote({}, relationshipsToOmit),
        updateEntityTags: overrides && overrides.hasOwnProperty('updateEntityTags') ? overrides.updateEntityTags! : relationshipsToOmit.has('UpdateEntityTags') ? {} as UpdateEntityTags : anUpdateEntityTags({}, relationshipsToOmit),
        updateEntityValueEntityGroupConfiguration: overrides && overrides.hasOwnProperty('updateEntityValueEntityGroupConfiguration') ? overrides.updateEntityValueEntityGroupConfiguration! : relationshipsToOmit.has('UpdateEntityValueEntityGroupConfiguration') ? {} as UpdateEntityValueEntityGroupConfiguration : anUpdateEntityValueEntityGroupConfiguration({}, relationshipsToOmit),
        updateEntityWhitelist: overrides && overrides.hasOwnProperty('updateEntityWhitelist') ? overrides.updateEntityWhitelist! : relationshipsToOmit.has('UpdateEntityWhitelist') ? {} as UpdateEntityWhitelist : anUpdateEntityWhitelist({}, relationshipsToOmit),
        updateFavoriteField: overrides && overrides.hasOwnProperty('updateFavoriteField') ? overrides.updateFavoriteField! : relationshipsToOmit.has('UpdateFavoriteField') ? {} as UpdateFavoriteField : anUpdateFavoriteField({}, relationshipsToOmit),
        updateFirstSeenRule: overrides && overrides.hasOwnProperty('updateFirstSeenRule') ? overrides.updateFirstSeenRule! : relationshipsToOmit.has('UpdateFirstSeenRule') ? {} as UpdateFirstSeenRule : anUpdateFirstSeenRule({}, relationshipsToOmit),
        updateGithubYaraSource: overrides && overrides.hasOwnProperty('updateGithubYaraSource') ? overrides.updateGithubYaraSource! : relationshipsToOmit.has('UpdateGithubYaraSource') ? {} as UpdateGithubYaraSource : anUpdateGithubYaraSource({}, relationshipsToOmit),
        updateIdefenseThreatIntelSource: overrides && overrides.hasOwnProperty('updateIdefenseThreatIntelSource') ? overrides.updateIdefenseThreatIntelSource! : relationshipsToOmit.has('UpdateIdefenseThreatIntelSource') ? {} as UpdateIdefenseThreatIntelSource : anUpdateIdefenseThreatIntelSource({}, relationshipsToOmit),
        updateInsight: overrides && overrides.hasOwnProperty('updateInsight') ? overrides.updateInsight! : relationshipsToOmit.has('UpdateInsight') ? {} as UpdateInsight : anUpdateInsight({}, relationshipsToOmit),
        updateInsightComment: overrides && overrides.hasOwnProperty('updateInsightComment') ? overrides.updateInsightComment! : relationshipsToOmit.has('UpdateInsightComment') ? {} as UpdateInsightComment : anUpdateInsightComment({}, relationshipsToOmit),
        updateInsightConfig: overrides && overrides.hasOwnProperty('updateInsightConfig') ? overrides.updateInsightConfig! : relationshipsToOmit.has('UpdateInsightConfig') ? {} as UpdateInsightConfig : anUpdateInsightConfig({}, relationshipsToOmit),
        updateInsightResolution: overrides && overrides.hasOwnProperty('updateInsightResolution') ? overrides.updateInsightResolution! : relationshipsToOmit.has('UpdateInsightResolution') ? {} as UpdateInsightResolution : anUpdateInsightResolution({}, relationshipsToOmit),
        updateInsightStatus: overrides && overrides.hasOwnProperty('updateInsightStatus') ? overrides.updateInsightStatus! : relationshipsToOmit.has('UpdateInsightStatus') ? {} as UpdateInsightStatus : anUpdateInsightStatus({}, relationshipsToOmit),
        updateInsightStatusInProgressEnabled: overrides && overrides.hasOwnProperty('updateInsightStatusInProgressEnabled') ? overrides.updateInsightStatusInProgressEnabled! : relationshipsToOmit.has('UpdateInsightStatusInProgressEnabled') ? {} as UpdateInsightStatusInProgressEnabled : anUpdateInsightStatusInProgressEnabled({}, relationshipsToOmit),
        updateInsightsById: overrides && overrides.hasOwnProperty('updateInsightsById') ? overrides.updateInsightsById! : relationshipsToOmit.has('UpdateInsightsById') ? {} as UpdateInsightsById : anUpdateInsightsById({}, relationshipsToOmit),
        updateInventoryEntityGroupConfiguration: overrides && overrides.hasOwnProperty('updateInventoryEntityGroupConfiguration') ? overrides.updateInventoryEntityGroupConfiguration! : relationshipsToOmit.has('UpdateInventoryEntityGroupConfiguration') ? {} as UpdateInventoryEntityGroupConfiguration : anUpdateInventoryEntityGroupConfiguration({}, relationshipsToOmit),
        updateInventoryEntityLookupTable: overrides && overrides.hasOwnProperty('updateInventoryEntityLookupTable') ? overrides.updateInventoryEntityLookupTable! : relationshipsToOmit.has('UpdateInventoryEntityLookupTable') ? {} as UpdateInventoryEntityLookupTable : anUpdateInventoryEntityLookupTable({}, relationshipsToOmit),
        updateLivetailRecentItems: overrides && overrides.hasOwnProperty('updateLivetailRecentItems') ? overrides.updateLivetailRecentItems! : relationshipsToOmit.has('MutationResponse') ? {} as MutationResponse : aMutationResponse({}, relationshipsToOmit),
        updateLogMapping: overrides && overrides.hasOwnProperty('updateLogMapping') ? overrides.updateLogMapping! : relationshipsToOmit.has('UpdateLogMapping') ? {} as UpdateLogMapping : anUpdateLogMapping({}, relationshipsToOmit),
        updateLogMappingEnabled: overrides && overrides.hasOwnProperty('updateLogMappingEnabled') ? overrides.updateLogMappingEnabled! : relationshipsToOmit.has('UpdateLogMappingEnabled') ? {} as UpdateLogMappingEnabled : anUpdateLogMappingEnabled({}, relationshipsToOmit),
        updateLogRecentItems: overrides && overrides.hasOwnProperty('updateLogRecentItems') ? overrides.updateLogRecentItems! : [relationshipsToOmit.has('LogRecentItem') ? {} as LogRecentItem : aLogRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('LogRecentItem') ? {} as LogRecentItem : aLogRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('LogRecentItem') ? {} as LogRecentItem : aLogRecentItem({}, relationshipsToOmit)],
        updateLogRecentItemsV2: overrides && overrides.hasOwnProperty('updateLogRecentItemsV2') ? overrides.updateLogRecentItemsV2! : relationshipsToOmit.has('MutationResponse') ? {} as MutationResponse : aMutationResponse({}, relationshipsToOmit),
        updateMatchList: overrides && overrides.hasOwnProperty('updateMatchList') ? overrides.updateMatchList! : relationshipsToOmit.has('UpdateMatchList') ? {} as UpdateMatchList : anUpdateMatchList({}, relationshipsToOmit),
        updateMatchListItem: overrides && overrides.hasOwnProperty('updateMatchListItem') ? overrides.updateMatchListItem! : relationshipsToOmit.has('UpdateMatchListItem') ? {} as UpdateMatchListItem : anUpdateMatchListItem({}, relationshipsToOmit),
        updateMatchRule: overrides && overrides.hasOwnProperty('updateMatchRule') ? overrides.updateMatchRule! : relationshipsToOmit.has('UpdateMatchRule') ? {} as UpdateMatchRule : anUpdateMatchRule({}, relationshipsToOmit),
        updateMetricRecentItems: overrides && overrides.hasOwnProperty('updateMetricRecentItems') ? overrides.updateMetricRecentItems! : [relationshipsToOmit.has('MetricRecentItem') ? {} as MetricRecentItem : aMetricRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('MetricRecentItem') ? {} as MetricRecentItem : aMetricRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('MetricRecentItem') ? {} as MetricRecentItem : aMetricRecentItem({}, relationshipsToOmit)],
        updateMetricRecentItemsV2: overrides && overrides.hasOwnProperty('updateMetricRecentItemsV2') ? overrides.updateMetricRecentItemsV2! : relationshipsToOmit.has('MutationResponse') ? {} as MutationResponse : aMutationResponse({}, relationshipsToOmit),
        updateMfaEnabled: overrides && overrides.hasOwnProperty('updateMfaEnabled') ? overrides.updateMfaEnabled! : relationshipsToOmit.has('UpdateMfaEnabled') ? {} as UpdateMfaEnabled : anUpdateMfaEnabled({}, relationshipsToOmit),
        updateMitreAttackCoverageColors: overrides && overrides.hasOwnProperty('updateMitreAttackCoverageColors') ? overrides.updateMitreAttackCoverageColors! : relationshipsToOmit.has('UpdateMitreAttackCoverageColors') ? {} as UpdateMitreAttackCoverageColors : anUpdateMitreAttackCoverageColors({}, relationshipsToOmit),
        updateNetworkBlock: overrides && overrides.hasOwnProperty('updateNetworkBlock') ? overrides.updateNetworkBlock! : relationshipsToOmit.has('UpdateNetworkBlock') ? {} as UpdateNetworkBlock : anUpdateNetworkBlock({}, relationshipsToOmit),
        updateOutlierRule: overrides && overrides.hasOwnProperty('updateOutlierRule') ? overrides.updateOutlierRule! : relationshipsToOmit.has('UpdateOutlierRule') ? {} as UpdateOutlierRule : anUpdateOutlierRule({}, relationshipsToOmit),
        updateRecordArtifactConfig: overrides && overrides.hasOwnProperty('updateRecordArtifactConfig') ? overrides.updateRecordArtifactConfig! : relationshipsToOmit.has('UpdateRecordArtifactConfig') ? {} as UpdateRecordArtifactConfig : anUpdateRecordArtifactConfig({}, relationshipsToOmit),
        updateRole: overrides && overrides.hasOwnProperty('updateRole') ? overrides.updateRole! : relationshipsToOmit.has('UpdateRole') ? {} as UpdateRole : anUpdateRole({}, relationshipsToOmit),
        updateRuleEnabled: overrides && overrides.hasOwnProperty('updateRuleEnabled') ? overrides.updateRuleEnabled! : relationshipsToOmit.has('UpdateRuleEnabled') ? {} as UpdateRuleEnabled : anUpdateRuleEnabled({}, relationshipsToOmit),
        updateRuleTuningExpression: overrides && overrides.hasOwnProperty('updateRuleTuningExpression') ? overrides.updateRuleTuningExpression! : relationshipsToOmit.has('UpdateRuleTuningExpression') ? {} as UpdateRuleTuningExpression : anUpdateRuleTuningExpression({}, relationshipsToOmit),
        updateRuleTuningExpressionEnabled: overrides && overrides.hasOwnProperty('updateRuleTuningExpressionEnabled') ? overrides.updateRuleTuningExpressionEnabled! : relationshipsToOmit.has('UpdateRuleTuningExpressionEnabled') ? {} as UpdateRuleTuningExpressionEnabled : anUpdateRuleTuningExpressionEnabled({}, relationshipsToOmit),
        updateSpanRecentItems: overrides && overrides.hasOwnProperty('updateSpanRecentItems') ? overrides.updateSpanRecentItems! : relationshipsToOmit.has('MutationResponse') ? {} as MutationResponse : aMutationResponse({}, relationshipsToOmit),
        updateSsoSettings: overrides && overrides.hasOwnProperty('updateSsoSettings') ? overrides.updateSsoSettings! : relationshipsToOmit.has('UpdateSsoSettings') ? {} as UpdateSsoSettings : anUpdateSsoSettings({}, relationshipsToOmit),
        updateStandardPageRecentItems: overrides && overrides.hasOwnProperty('updateStandardPageRecentItems') ? overrides.updateStandardPageRecentItems! : relationshipsToOmit.has('MutationResponse') ? {} as MutationResponse : aMutationResponse({}, relationshipsToOmit),
        updateStreamingExportConfiguration: overrides && overrides.hasOwnProperty('updateStreamingExportConfiguration') ? overrides.updateStreamingExportConfiguration! : relationshipsToOmit.has('UpdateStreamingExportConfiguration') ? {} as UpdateStreamingExportConfiguration : anUpdateStreamingExportConfiguration({}, relationshipsToOmit),
        updateSumoLogicConfig: overrides && overrides.hasOwnProperty('updateSumoLogicConfig') ? overrides.updateSumoLogicConfig! : relationshipsToOmit.has('UpdateSumoLogicSupportConfig') ? {} as UpdateSumoLogicSupportConfig : anUpdateSumoLogicSupportConfig({}, relationshipsToOmit),
        updateSumoLogicGeneralConfig: overrides && overrides.hasOwnProperty('updateSumoLogicGeneralConfig') ? overrides.updateSumoLogicGeneralConfig! : relationshipsToOmit.has('UpdateSumoLogicGeneralConfig') ? {} as UpdateSumoLogicGeneralConfig : anUpdateSumoLogicGeneralConfig({}, relationshipsToOmit),
        updateSumoLogicSupportConfig: overrides && overrides.hasOwnProperty('updateSumoLogicSupportConfig') ? overrides.updateSumoLogicSupportConfig! : relationshipsToOmit.has('UpdateSumoLogicSupportConfig') ? {} as UpdateSumoLogicSupportConfig : anUpdateSumoLogicSupportConfig({}, relationshipsToOmit),
        updateSumoMapping: overrides && overrides.hasOwnProperty('updateSumoMapping') ? overrides.updateSumoMapping! : relationshipsToOmit.has('UpdateSumoMapping') ? {} as UpdateSumoMapping : anUpdateSumoMapping({}, relationshipsToOmit),
        updateSumoSsoEnabled: overrides && overrides.hasOwnProperty('updateSumoSsoEnabled') ? overrides.updateSumoSsoEnabled! : relationshipsToOmit.has('UpdateSumoSsoEnabled') ? {} as UpdateSumoSsoEnabled : anUpdateSumoSsoEnabled({}, relationshipsToOmit),
        updateSuppressList: overrides && overrides.hasOwnProperty('updateSuppressList') ? overrides.updateSuppressList! : relationshipsToOmit.has('UpdateSuppressList') ? {} as UpdateSuppressList : anUpdateSuppressList({}, relationshipsToOmit),
        updateSuppressListItem: overrides && overrides.hasOwnProperty('updateSuppressListItem') ? overrides.updateSuppressListItem! : relationshipsToOmit.has('UpdateSuppressListItem') ? {} as UpdateSuppressListItem : anUpdateSuppressListItem({}, relationshipsToOmit),
        updateTagSchema: overrides && overrides.hasOwnProperty('updateTagSchema') ? overrides.updateTagSchema! : relationshipsToOmit.has('UpdateTagSchema') ? {} as UpdateTagSchema : anUpdateTagSchema({}, relationshipsToOmit),
        updateTaxiiThreatIntelSource: overrides && overrides.hasOwnProperty('updateTaxiiThreatIntelSource') ? overrides.updateTaxiiThreatIntelSource! : relationshipsToOmit.has('UpdateTaxiiThreatIntelSource') ? {} as UpdateTaxiiThreatIntelSource : anUpdateTaxiiThreatIntelSource({}, relationshipsToOmit),
        updateTemplatedMatchRule: overrides && overrides.hasOwnProperty('updateTemplatedMatchRule') ? overrides.updateTemplatedMatchRule! : relationshipsToOmit.has('UpdateTemplatedMatchRule') ? {} as UpdateTemplatedMatchRule : anUpdateTemplatedMatchRule({}, relationshipsToOmit),
        updateThreatIntelItem: overrides && overrides.hasOwnProperty('updateThreatIntelItem') ? overrides.updateThreatIntelItem! : relationshipsToOmit.has('UpdateThreatIntelItem') ? {} as UpdateThreatIntelItem : anUpdateThreatIntelItem({}, relationshipsToOmit),
        updateThreatQThreatIntelSource: overrides && overrides.hasOwnProperty('updateThreatQThreatIntelSource') ? overrides.updateThreatQThreatIntelSource! : relationshipsToOmit.has('UpdateThreatQThreatIntelSource') ? {} as UpdateThreatQThreatIntelSource : anUpdateThreatQThreatIntelSource({}, relationshipsToOmit),
        updateThresholdRule: overrides && overrides.hasOwnProperty('updateThresholdRule') ? overrides.updateThresholdRule! : relationshipsToOmit.has('UpdateThresholdRule') ? {} as UpdateThresholdRule : anUpdateThresholdRule({}, relationshipsToOmit),
        updateUser: overrides && overrides.hasOwnProperty('updateUser') ? overrides.updateUser! : relationshipsToOmit.has('UpdateUser') ? {} as UpdateUser : anUpdateUser({}, relationshipsToOmit),
        updateVirusTotalConfig: overrides && overrides.hasOwnProperty('updateVirusTotalConfig') ? overrides.updateVirusTotalConfig! : relationshipsToOmit.has('UpdateVirusTotalConfig') ? {} as UpdateVirusTotalConfig : anUpdateVirusTotalConfig({}, relationshipsToOmit),
        uploadEntityGroupsCsv: overrides && overrides.hasOwnProperty('uploadEntityGroupsCsv') ? overrides.uploadEntityGroupsCsv! : relationshipsToOmit.has('UploadEntityGroupConfigurationMutationsCsv') ? {} as UploadEntityGroupConfigurationMutationsCsv : anUploadEntityGroupConfigurationMutationsCsv({}, relationshipsToOmit),
        uploadEntityMutationsCsv: overrides && overrides.hasOwnProperty('uploadEntityMutationsCsv') ? overrides.uploadEntityMutationsCsv! : relationshipsToOmit.has('UploadEntityMutationsCsv') ? {} as UploadEntityMutationsCsv : anUploadEntityMutationsCsv({}, relationshipsToOmit),
        uploadItemsToList: overrides && overrides.hasOwnProperty('uploadItemsToList') ? overrides.uploadItemsToList! : relationshipsToOmit.has('UploadItemsToList') ? {} as UploadItemsToList : anUploadItemsToList({}, relationshipsToOmit),
        uploadItemsToSuppressList: overrides && overrides.hasOwnProperty('uploadItemsToSuppressList') ? overrides.uploadItemsToSuppressList! : relationshipsToOmit.has('UploadItemsToSuppressList') ? {} as UploadItemsToSuppressList : anUploadItemsToSuppressList({}, relationshipsToOmit),
        uploadItemsToThreatIntelSource: overrides && overrides.hasOwnProperty('uploadItemsToThreatIntelSource') ? overrides.uploadItemsToThreatIntelSource! : relationshipsToOmit.has('UploadItemsToThreatIntelSource') ? {} as UploadItemsToThreatIntelSource : anUploadItemsToThreatIntelSource({}, relationshipsToOmit),
        uploadNetworkBlocksCsv: overrides && overrides.hasOwnProperty('uploadNetworkBlocksCsv') ? overrides.uploadNetworkBlocksCsv! : relationshipsToOmit.has('UploadNetworkBlocksCsv') ? {} as UploadNetworkBlocksCsv : anUploadNetworkBlocksCsv({}, relationshipsToOmit),
        visitEntityPage: overrides && overrides.hasOwnProperty('visitEntityPage') ? overrides.visitEntityPage! : relationshipsToOmit.has('VisitEntityPage') ? {} as VisitEntityPage : aVisitEntityPage({}, relationshipsToOmit),
        visitInsightPage: overrides && overrides.hasOwnProperty('visitInsightPage') ? overrides.visitInsightPage! : relationshipsToOmit.has('VisitInsightPage') ? {} as VisitInsightPage : aVisitInsightPage({}, relationshipsToOmit),
        visitSearchQueryPage: overrides && overrides.hasOwnProperty('visitSearchQueryPage') ? overrides.visitSearchQueryPage! : relationshipsToOmit.has('VisitSearchQueryPage') ? {} as VisitSearchQueryPage : aVisitSearchQueryPage({}, relationshipsToOmit),
        visitSignalPage: overrides && overrides.hasOwnProperty('visitSignalPage') ? overrides.visitSignalPage! : relationshipsToOmit.has('VisitSignalPage') ? {} as VisitSignalPage : aVisitSignalPage({}, relationshipsToOmit),
    };
};

export const aMutationResponse = (overrides?: Partial<MutationResponse>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'MutationResponse' } & MutationResponse => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('MutationResponse');
    return {
        __typename: 'MutationResponse',
        success: overrides && overrides.hasOwnProperty('success') ? overrides.success! : false,
    };
};

export const aNetworkBlock = (overrides?: Partial<NetworkBlock>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'NetworkBlock' } & NetworkBlock => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('NetworkBlock');
    return {
        __typename: 'NetworkBlock',
        addressBlock: overrides && overrides.hasOwnProperty('addressBlock') ? overrides.addressBlock! : 'cohaero',
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-03-28T09:53:41.539Z",
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '8db2e03c-4cb9-4842-ae42-62c6c483bb98',
        internal: overrides && overrides.hasOwnProperty('internal') ? overrides.internal! : false,
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'demonstro',
        suppressesSignals: overrides && overrides.hasOwnProperty('suppressesSignals') ? overrides.suppressesSignals! : false,
    };
};

export const aNetworkBlockFields = (overrides?: Partial<NetworkBlockFields>, _relationshipsToOmit: Set<string> = new Set()): NetworkBlockFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('NetworkBlockFields');
    return {
        addressBlock: overrides && overrides.hasOwnProperty('addressBlock') ? overrides.addressBlock! : 'ad',
        internal: overrides && overrides.hasOwnProperty('internal') ? overrides.internal! : true,
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'trado',
        suppressesSignals: overrides && overrides.hasOwnProperty('suppressesSignals') ? overrides.suppressesSignals! : true,
    };
};

export const aNetworkBlockPage = (overrides?: Partial<NetworkBlockPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'NetworkBlockPage' } & NetworkBlockPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('NetworkBlockPage');
    return {
        __typename: 'NetworkBlockPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('NetworkBlock') ? {} as NetworkBlock : aNetworkBlock({}, relationshipsToOmit), relationshipsToOmit.has('NetworkBlock') ? {} as NetworkBlock : aNetworkBlock({}, relationshipsToOmit), relationshipsToOmit.has('NetworkBlock') ? {} as NetworkBlock : aNetworkBlock({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 7420,
    };
};

export const aNetworkBlockSort = (overrides?: Partial<NetworkBlockSort>, _relationshipsToOmit: Set<string> = new Set()): NetworkBlockSort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('NetworkBlockSort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : NetworkBlockSortableField.AddressBlock,
    };
};

export const aNonTrialPlan = (overrides?: Partial<NonTrialPlan>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'NonTrialPlan' } & NonTrialPlan => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('NonTrialPlan');
    return {
        __typename: 'NonTrialPlan',
        planName: overrides && overrides.hasOwnProperty('planName') ? overrides.planName! : 'sufficio',
    };
};

export const aNormalizedIndicator = (overrides?: Partial<NormalizedIndicator>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'NormalizedIndicator' } & NormalizedIndicator => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('NormalizedIndicator');
    return {
        __typename: 'NormalizedIndicator',
        actors: overrides && overrides.hasOwnProperty('actors') ? overrides.actors! : 'tego',
        confidence: overrides && overrides.hasOwnProperty('confidence') ? overrides.confidence! : 8895,
        fields: overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : 'umerus',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'et',
        imported: overrides && overrides.hasOwnProperty('imported') ? overrides.imported! : "2025-09-04T03:55:14.476Z",
        indicator: overrides && overrides.hasOwnProperty('indicator') ? overrides.indicator! : 'desipio',
        killChain: overrides && overrides.hasOwnProperty('killChain') ? overrides.killChain! : 'praesentium',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'ustilo',
        threatType: overrides && overrides.hasOwnProperty('threatType') ? overrides.threatType! : 'conqueror',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'bos',
        validFrom: overrides && overrides.hasOwnProperty('validFrom') ? overrides.validFrom! : "2025-01-29T21:46:18.667Z",
        validUntil: overrides && overrides.hasOwnProperty('validUntil') ? overrides.validUntil! : "2025-08-06T12:27:54.820Z",
    };
};

export const anOrganization = (overrides?: Partial<Organization>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Organization' } & Organization => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Organization');
    return {
        __typename: 'Organization',
        deploymentId: overrides && overrides.hasOwnProperty('deploymentId') ? overrides.deploymentId! : 'tendo',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'natus',
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'nobis',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'denuncio',
        orgId: overrides && overrides.hasOwnProperty('orgId') ? overrides.orgId! : 'paulatim',
        organizationName: overrides && overrides.hasOwnProperty('organizationName') ? overrides.organizationName! : 'amo',
        subscription: overrides && overrides.hasOwnProperty('subscription') ? overrides.subscription! : relationshipsToOmit.has('CreditSubscription') ? {} as CreditSubscription : aCreditSubscription({}, relationshipsToOmit),
    };
};

export const anOrganizationsPage = (overrides?: Partial<OrganizationsPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'OrganizationsPage' } & OrganizationsPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OrganizationsPage');
    return {
        __typename: 'OrganizationsPage',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : [relationshipsToOmit.has('Organization') ? {} as Organization : anOrganization({}, relationshipsToOmit), relationshipsToOmit.has('Organization') ? {} as Organization : anOrganization({}, relationshipsToOmit), relationshipsToOmit.has('Organization') ? {} as Organization : anOrganization({}, relationshipsToOmit)],
        next: overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'celo',
    };
};

export const anOutlierRule = (overrides?: Partial<OutlierRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'OutlierRule' } & OutlierRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OutlierRule');
    return {
        __typename: 'OutlierRule',
        aggregationFunctions: overrides && overrides.hasOwnProperty('aggregationFunctions') ? overrides.aggregationFunctions! : [relationshipsToOmit.has('OutlierRuleAggregationFunction') ? {} as OutlierRuleAggregationFunction : anOutlierRuleAggregationFunction({}, relationshipsToOmit), relationshipsToOmit.has('OutlierRuleAggregationFunction') ? {} as OutlierRuleAggregationFunction : anOutlierRuleAggregationFunction({}, relationshipsToOmit), relationshipsToOmit.has('OutlierRuleAggregationFunction') ? {} as OutlierRuleAggregationFunction : anOutlierRuleAggregationFunction({}, relationshipsToOmit)],
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'tenax',
        autoDisabledReason: overrides && overrides.hasOwnProperty('autoDisabledReason') ? overrides.autoDisabledReason! : 'comes',
        baselineLastStarted: overrides && overrides.hasOwnProperty('baselineLastStarted') ? overrides.baselineLastStarted! : "2025-01-22T13:48:16.217Z",
        baselineStatus: overrides && overrides.hasOwnProperty('baselineStatus') ? overrides.baselineStatus! : BaselineStatus.Completed,
        baselineWindowSize: overrides && overrides.hasOwnProperty('baselineWindowSize') ? overrides.baselineWindowSize! : 739874210954868,
        baselineWindowSizeOverride: overrides && overrides.hasOwnProperty('baselineWindowSizeOverride') ? overrides.baselineWindowSizeOverride! : relationshipsToOmit.has('BigIntRuleOverride') ? {} as BigIntRuleOverride : aBigIntRuleOverride({}, relationshipsToOmit),
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'termes',
        contentType: overrides && overrides.hasOwnProperty('contentType') ? overrides.contentType! : ContentType.Anomaly,
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-01-22T16:43:21.612Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'suspendo',
        createdByUser: overrides && overrides.hasOwnProperty('createdByUser') ? overrides.createdByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        deleted: overrides && overrides.hasOwnProperty('deleted') ? overrides.deleted! : false,
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'absens',
        descriptionExpressionOverride: overrides && overrides.hasOwnProperty('descriptionExpressionOverride') ? overrides.descriptionExpressionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        deviationThreshold: overrides && overrides.hasOwnProperty('deviationThreshold') ? overrides.deviationThreshold! : 1288,
        deviationThresholdOverride: overrides && overrides.hasOwnProperty('deviationThresholdOverride') ? overrides.deviationThresholdOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit)],
        entitySelectorsOverride: overrides && overrides.hasOwnProperty('entitySelectorsOverride') ? overrides.entitySelectorsOverride! : relationshipsToOmit.has('EntitySelectorsRuleOverride') ? {} as EntitySelectorsRuleOverride : anEntitySelectorsRuleOverride({}, relationshipsToOmit),
        exportJson: overrides && overrides.hasOwnProperty('exportJson') ? overrides.exportJson! : 'pecus',
        failing: overrides && overrides.hasOwnProperty('failing') ? overrides.failing! : false,
        floorValue: overrides && overrides.hasOwnProperty('floorValue') ? overrides.floorValue! : 9030,
        floorValueOverride: overrides && overrides.hasOwnProperty('floorValueOverride') ? overrides.floorValueOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['cupiditate', 'blanditiis', 'commodo'],
        groupByFieldsOverride: overrides && overrides.hasOwnProperty('groupByFieldsOverride') ? overrides.groupByFieldsOverride! : relationshipsToOmit.has('StringListRuleOverride') ? {} as StringListRuleOverride : aStringListRuleOverride({}, relationshipsToOmit),
        hasOverride: overrides && overrides.hasOwnProperty('hasOverride') ? overrides.hasOverride! : false,
        history: overrides && overrides.hasOwnProperty('history') ? overrides.history! : [relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit)],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '46d2de25-ff87-472e-b55d-5d4f3c860e12',
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : false,
        isPrototypeOverride: overrides && overrides.hasOwnProperty('isPrototypeOverride') ? overrides.isPrototypeOverride! : relationshipsToOmit.has('BooleanRuleOverride') ? {} as BooleanRuleOverride : aBooleanRuleOverride({}, relationshipsToOmit),
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-11-30T22:23:56.447Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'adeo',
        lastUpdatedByUser: overrides && overrides.hasOwnProperty('lastUpdatedByUser') ? overrides.lastUpdatedByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        matchExpression: overrides && overrides.hasOwnProperty('matchExpression') ? overrides.matchExpression! : 'sonitus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'atque',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'ago',
        nameExpressionOverride: overrides && overrides.hasOwnProperty('nameExpressionOverride') ? overrides.nameExpressionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        nameOverride: overrides && overrides.hasOwnProperty('nameOverride') ? overrides.nameOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : '5a7b7457-344f-42e8-aadc-4c3e495799fb',
        rawJson: overrides && overrides.hasOwnProperty('rawJson') ? overrides.rawJson! : 'temptatio',
        rawStatus: overrides && overrides.hasOwnProperty('rawStatus') ? overrides.rawStatus! : relationshipsToOmit.has('RuleStatus') ? {} as RuleStatus : aRuleStatus({}, relationshipsToOmit),
        retentionWindowSize: overrides && overrides.hasOwnProperty('retentionWindowSize') ? overrides.retentionWindowSize! : 905788649935273,
        retentionWindowSizeOverride: overrides && overrides.hasOwnProperty('retentionWindowSizeOverride') ? overrides.retentionWindowSizeOverride! : relationshipsToOmit.has('BigIntRuleOverride') ? {} as BigIntRuleOverride : aBigIntRuleOverride({}, relationshipsToOmit),
        ruleDescription: overrides && overrides.hasOwnProperty('ruleDescription') ? overrides.ruleDescription! : 'debeo',
        ruleId: overrides && overrides.hasOwnProperty('ruleId') ? overrides.ruleId! : 5510,
        ruleSource: overrides && overrides.hasOwnProperty('ruleSource') ? overrides.ruleSource! : 'tertius',
        ruleType: overrides && overrides.hasOwnProperty('ruleType') ? overrides.ruleType! : 'adsuesco',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 2640,
        scoreOverride: overrides && overrides.hasOwnProperty('scoreOverride') ? overrides.scoreOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
        signalCount07d: overrides && overrides.hasOwnProperty('signalCount07d') ? overrides.signalCount07d! : 949,
        signalCount24h: overrides && overrides.hasOwnProperty('signalCount24h') ? overrides.signalCount24h! : 3582,
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : relationshipsToOmit.has('RuleStatus') ? {} as RuleStatus : aRuleStatus({}, relationshipsToOmit),
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'cerno',
        summaryExpressionOverride: overrides && overrides.hasOwnProperty('summaryExpressionOverride') ? overrides.summaryExpressionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 9130,
        suppressionWindowSizeOverride: overrides && overrides.hasOwnProperty('suppressionWindowSizeOverride') ? overrides.suppressionWindowSizeOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['cunctatio', 'catena', 'crux'],
        tagsOverride: overrides && overrides.hasOwnProperty('tagsOverride') ? overrides.tagsOverride! : relationshipsToOmit.has('StringListRuleOverride') ? {} as StringListRuleOverride : aStringListRuleOverride({}, relationshipsToOmit),
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['pauper', 'ara', 'tergo'],
        tuningExpressions: overrides && overrides.hasOwnProperty('tuningExpressions') ? overrides.tuningExpressions! : [relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit)],
        version: overrides && overrides.hasOwnProperty('version') ? overrides.version! : 5309,
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : 4855,
        windowSizeName: overrides && overrides.hasOwnProperty('windowSizeName') ? overrides.windowSizeName! : 'culpo',
        windowSizeOverride: overrides && overrides.hasOwnProperty('windowSizeOverride') ? overrides.windowSizeOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
    };
};

export const anOutlierRuleAggregationFunction = (overrides?: Partial<OutlierRuleAggregationFunction>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'OutlierRuleAggregationFunction' } & OutlierRuleAggregationFunction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OutlierRuleAggregationFunction');
    return {
        __typename: 'OutlierRuleAggregationFunction',
        arguments: overrides && overrides.hasOwnProperty('arguments') ? overrides.arguments! : ['arguo', 'statua', 'verus'],
        function: overrides && overrides.hasOwnProperty('function') ? overrides.function! : 'blanditiis',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cena',
    };
};

export const anOutlierRuleAggregationFunctionField = (overrides?: Partial<OutlierRuleAggregationFunctionField>, _relationshipsToOmit: Set<string> = new Set()): OutlierRuleAggregationFunctionField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OutlierRuleAggregationFunctionField');
    return {
        arguments: overrides && overrides.hasOwnProperty('arguments') ? overrides.arguments! : ['tantillus', 'causa', 'cervus'],
        function: overrides && overrides.hasOwnProperty('function') ? overrides.function! : 'caritas',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'traho',
    };
};

export const anOutputEntitySelectorType = (overrides?: Partial<OutputEntitySelectorType>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'OutputEntitySelectorType' } & OutputEntitySelectorType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OutputEntitySelectorType');
    return {
        __typename: 'OutputEntitySelectorType',
        entityType: overrides && overrides.hasOwnProperty('entityType') ? overrides.entityType! : 'quasi',
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'cattus',
    };
};

export const anOverrideAggregationRule = (overrides?: Partial<OverrideAggregationRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'OverrideAggregationRule' } & OverrideAggregationRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OverrideAggregationRule');
    return {
        __typename: 'OverrideAggregationRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('AggregationRule') ? {} as AggregationRule : anAggregationRule({}, relationshipsToOmit),
    };
};

export const anOverrideAggregationRuleFields = (overrides?: Partial<OverrideAggregationRuleFields>, _relationshipsToOmit: Set<string> = new Set()): OverrideAggregationRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OverrideAggregationRuleFields');
    return {
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'bos',
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['apud', 'abundans', 'abutor'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'volutabrum',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'vis',
        ruleDescription: overrides && overrides.hasOwnProperty('ruleDescription') ? overrides.ruleDescription! : 'derelinquo',
        scoreMapping: overrides && overrides.hasOwnProperty('scoreMapping') ? overrides.scoreMapping! : relationshipsToOmit.has('RuleScoreMappingFields') ? {} as RuleScoreMappingFields : aRuleScoreMappingFields({}, relationshipsToOmit),
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'curiositas',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 476,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['anser', 'tui', 'cornu'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['88681d9b-2065-4fe2-8b68-d94138567084', '644188ea-749c-4cca-a79f-c1ef81942996', '34ff635f-c867-48c0-9f0e-051a29d04627'],
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : RuleWindowSizeEnum.Custom,
        windowSizeMilliseconds: overrides && overrides.hasOwnProperty('windowSizeMilliseconds') ? overrides.windowSizeMilliseconds! : 979986996229507,
    };
};

export const anOverrideChainRule = (overrides?: Partial<OverrideChainRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'OverrideChainRule' } & OverrideChainRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OverrideChainRule');
    return {
        __typename: 'OverrideChainRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ChainRule') ? {} as ChainRule : aChainRule({}, relationshipsToOmit),
    };
};

export const anOverrideChainRuleFields = (overrides?: Partial<OverrideChainRuleFields>, _relationshipsToOmit: Set<string> = new Set()): OverrideChainRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OverrideChainRuleFields');
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'suffragium',
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['accusator', 'porro', 'aveho'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : false,
        limits: overrides && overrides.hasOwnProperty('limits') ? overrides.limits! : [relationshipsToOmit.has('OverrideChainRuleLimitField') ? {} as OverrideChainRuleLimitField : anOverrideChainRuleLimitField({}, relationshipsToOmit), relationshipsToOmit.has('OverrideChainRuleLimitField') ? {} as OverrideChainRuleLimitField : anOverrideChainRuleLimitField({}, relationshipsToOmit), relationshipsToOmit.has('OverrideChainRuleLimitField') ? {} as OverrideChainRuleLimitField : anOverrideChainRuleLimitField({}, relationshipsToOmit)],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'traho',
        ruleDescription: overrides && overrides.hasOwnProperty('ruleDescription') ? overrides.ruleDescription! : 'alter',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 5110,
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'allatus',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 6363,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['sollers', 'defero', 'ustilo'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['974eda4a-3f8b-40c7-8d3a-ed0bd7289893', '9acba4a9-0bf8-4e76-a584-be30a0a8ce2b', 'f8f0c7d4-20bc-45eb-bd9c-01629924d919'],
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : RuleWindowSizeEnum.Custom,
        windowSizeMilliseconds: overrides && overrides.hasOwnProperty('windowSizeMilliseconds') ? overrides.windowSizeMilliseconds! : 110025551878754,
    };
};

export const anOverrideChainRuleLimitField = (overrides?: Partial<OverrideChainRuleLimitField>, _relationshipsToOmit: Set<string> = new Set()): OverrideChainRuleLimitField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OverrideChainRuleLimitField');
    return {
        index: overrides && overrides.hasOwnProperty('index') ? overrides.index! : 5862,
        limit: overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 302,
    };
};

export const anOverrideFirstSeenRule = (overrides?: Partial<OverrideFirstSeenRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'OverrideFirstSeenRule' } & OverrideFirstSeenRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OverrideFirstSeenRule');
    return {
        __typename: 'OverrideFirstSeenRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('FirstSeenRule') ? {} as FirstSeenRule : aFirstSeenRule({}, relationshipsToOmit),
    };
};

export const anOverrideFirstSeenRuleFields = (overrides?: Partial<OverrideFirstSeenRuleFields>, _relationshipsToOmit: Set<string> = new Set()): OverrideFirstSeenRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OverrideFirstSeenRuleFields');
    return {
        baselineWindowSize: overrides && overrides.hasOwnProperty('baselineWindowSize') ? overrides.baselineWindowSize! : 589532013659202,
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'venio',
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['victoria', 'adhaero', 'xiphias'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : false,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'concedo',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'bardus',
        retentionWindowSize: overrides && overrides.hasOwnProperty('retentionWindowSize') ? overrides.retentionWindowSize! : 583531847995390,
        ruleDescription: overrides && overrides.hasOwnProperty('ruleDescription') ? overrides.ruleDescription! : 'adaugeo',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 5222,
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'tero',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 2018,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['canonicus', 'distinctio', 'aequitas'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['fa8d12d2-7911-482f-aaf8-dff7bf488830', '11747f71-b325-4413-a8f2-0405f60ae43e', 'a01d22fc-bc49-404b-b711-e5a932c5908b'],
    };
};

export const anOverrideMatchRule = (overrides?: Partial<OverrideMatchRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'OverrideMatchRule' } & OverrideMatchRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OverrideMatchRule');
    return {
        __typename: 'OverrideMatchRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('MatchRule') ? {} as MatchRule : aMatchRule({}, relationshipsToOmit),
    };
};

export const anOverrideMatchRuleFields = (overrides?: Partial<OverrideMatchRuleFields>, _relationshipsToOmit: Set<string> = new Set()): OverrideMatchRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OverrideMatchRuleFields');
    return {
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'paulatim',
        ruleDescription: overrides && overrides.hasOwnProperty('ruleDescription') ? overrides.ruleDescription! : 'coruscus',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'versus',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 8574,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['teneo', 'dedico', 'curatio'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['ac8f2e6b-bada-481a-be22-48977cfc23b0', '7d268d52-19c0-411f-add2-562783e2468f', '8b60218b-5207-4d23-8cb0-05ee4b2aece6'],
    };
};

export const anOverrideOutlierRule = (overrides?: Partial<OverrideOutlierRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'OverrideOutlierRule' } & OverrideOutlierRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OverrideOutlierRule');
    return {
        __typename: 'OverrideOutlierRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('OutlierRule') ? {} as OutlierRule : anOutlierRule({}, relationshipsToOmit),
    };
};

export const anOverrideOutlierRuleFields = (overrides?: Partial<OverrideOutlierRuleFields>, _relationshipsToOmit: Set<string> = new Set()): OverrideOutlierRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OverrideOutlierRuleFields');
    return {
        baselineWindowSize: overrides && overrides.hasOwnProperty('baselineWindowSize') ? overrides.baselineWindowSize! : 544670994450108,
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'auxilium',
        deviationThreshold: overrides && overrides.hasOwnProperty('deviationThreshold') ? overrides.deviationThreshold! : 609789724082042,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        floorValue: overrides && overrides.hasOwnProperty('floorValue') ? overrides.floorValue! : 508414837206218,
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['pecto', 'teres', 'eius'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : false,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'crustulum',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'tunc',
        retentionWindowSize: overrides && overrides.hasOwnProperty('retentionWindowSize') ? overrides.retentionWindowSize! : 93008997982245,
        ruleDescription: overrides && overrides.hasOwnProperty('ruleDescription') ? overrides.ruleDescription! : 'coaegresco',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 1103,
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'tero',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 3912,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['cubo', 'absque', 'quis'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['17e3c6b3-de1c-458f-8ca4-631f036450f2', 'b123ac51-fc7d-4878-9bed-75f2f9f11da2', '5a8243a2-1132-4765-9e5b-5c0e5be7375d'],
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : RuleWindowSizeEnum.Custom,
        windowSizeMilliseconds: overrides && overrides.hasOwnProperty('windowSizeMilliseconds') ? overrides.windowSizeMilliseconds! : 345973587662441,
    };
};

export const anOverrideTemplatedMatchRule = (overrides?: Partial<OverrideTemplatedMatchRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'OverrideTemplatedMatchRule' } & OverrideTemplatedMatchRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OverrideTemplatedMatchRule');
    return {
        __typename: 'OverrideTemplatedMatchRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('TemplatedMatchRule') ? {} as TemplatedMatchRule : aTemplatedMatchRule({}, relationshipsToOmit),
    };
};

export const anOverrideTemplatedMatchRuleFields = (overrides?: Partial<OverrideTemplatedMatchRuleFields>, _relationshipsToOmit: Set<string> = new Set()): OverrideTemplatedMatchRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OverrideTemplatedMatchRuleFields');
    return {
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'tandem',
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : false,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'bis',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'sustineo',
        ruleDescription: overrides && overrides.hasOwnProperty('ruleDescription') ? overrides.ruleDescription! : 'ipsa',
        scoreMapping: overrides && overrides.hasOwnProperty('scoreMapping') ? overrides.scoreMapping! : relationshipsToOmit.has('RuleScoreMappingFields') ? {} as RuleScoreMappingFields : aRuleScoreMappingFields({}, relationshipsToOmit),
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'ad',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 5044,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['dolore', 'victoria', 'beneficium'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['cad4bdac-28bb-4b56-8911-1f73d3c0fec6', '1c120d5c-1f2b-4cd0-a337-b1c98b920009', '045a2568-ef8c-44fd-968c-cc052ffc5076'],
    };
};

export const anOverrideThresholdRule = (overrides?: Partial<OverrideThresholdRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'OverrideThresholdRule' } & OverrideThresholdRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OverrideThresholdRule');
    return {
        __typename: 'OverrideThresholdRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ThresholdRule') ? {} as ThresholdRule : aThresholdRule({}, relationshipsToOmit),
    };
};

export const anOverrideThresholdRuleFields = (overrides?: Partial<OverrideThresholdRuleFields>, _relationshipsToOmit: Set<string> = new Set()): OverrideThresholdRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('OverrideThresholdRuleFields');
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'ventus',
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['ocer', 'tergo', 'vigor'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        limit: overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 2455,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'apud',
        ruleDescription: overrides && overrides.hasOwnProperty('ruleDescription') ? overrides.ruleDescription! : 'amitto',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 4665,
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'subseco',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 8831,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['nihil', 'denuncio', 'ipsam'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['74d9fff2-9701-4030-aefd-191b9d0238b7', '61a8ee1b-de39-4966-9ac7-0db8603842cc', '6dec7b8b-8253-4bfa-96de-aef2fd5b814e'],
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : RuleWindowSizeEnum.Custom,
        windowSizeMilliseconds: overrides && overrides.hasOwnProperty('windowSizeMilliseconds') ? overrides.windowSizeMilliseconds! : 381670012983289,
    };
};

export const aParameterAutoComplete = (overrides?: Partial<ParameterAutoComplete>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ParameterAutoComplete' } & ParameterAutoComplete => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ParameterAutoComplete');
    return {
        __typename: 'ParameterAutoComplete',
        autoCompleteKey: overrides && overrides.hasOwnProperty('autoCompleteKey') ? overrides.autoCompleteKey! : 'cruentus',
        autoCompleteValues: overrides && overrides.hasOwnProperty('autoCompleteValues') ? overrides.autoCompleteValues! : [relationshipsToOmit.has('AutoCompleteValue') ? {} as AutoCompleteValue : anAutoCompleteValue({}, relationshipsToOmit), relationshipsToOmit.has('AutoCompleteValue') ? {} as AutoCompleteValue : anAutoCompleteValue({}, relationshipsToOmit), relationshipsToOmit.has('AutoCompleteValue') ? {} as AutoCompleteValue : anAutoCompleteValue({}, relationshipsToOmit)],
        lookupMetaData: overrides && overrides.hasOwnProperty('lookupMetaData') ? overrides.lookupMetaData! : relationshipsToOmit.has('ServiceAutoCompleteLookupMetaData') ? {} as ServiceAutoCompleteLookupMetaData : aServiceAutoCompleteLookupMetaData({}, relationshipsToOmit),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'vis',
    };
};

export const aParameterAutoCompleteInput = (overrides?: Partial<ParameterAutoCompleteInput>, _relationshipsToOmit: Set<string> = new Set()): ParameterAutoCompleteInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ParameterAutoCompleteInput');
    return {
        autoCompleteKey: overrides && overrides.hasOwnProperty('autoCompleteKey') ? overrides.autoCompleteKey! : 'cervus',
        autoCompleteValues: overrides && overrides.hasOwnProperty('autoCompleteValues') ? overrides.autoCompleteValues! : [relationshipsToOmit.has('AutoCompleteValueInput') ? {} as AutoCompleteValueInput : anAutoCompleteValueInput({}, relationshipsToOmit), relationshipsToOmit.has('AutoCompleteValueInput') ? {} as AutoCompleteValueInput : anAutoCompleteValueInput({}, relationshipsToOmit), relationshipsToOmit.has('AutoCompleteValueInput') ? {} as AutoCompleteValueInput : anAutoCompleteValueInput({}, relationshipsToOmit)],
        lookupMetaData: overrides && overrides.hasOwnProperty('lookupMetaData') ? overrides.lookupMetaData! : relationshipsToOmit.has('ServiceAutoCompleteLookupMetaDataInput') ? {} as ServiceAutoCompleteLookupMetaDataInput : aServiceAutoCompleteLookupMetaDataInput({}, relationshipsToOmit),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'demo',
    };
};

export const aParameterLabelValue = (overrides?: Partial<ParameterLabelValue>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ParameterLabelValue' } & ParameterLabelValue => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ParameterLabelValue');
    return {
        __typename: 'ParameterLabelValue',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'tum',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'adaugeo',
    };
};

export const aParameterLabelValueInput = (overrides?: Partial<ParameterLabelValueInput>, _relationshipsToOmit: Set<string> = new Set()): ParameterLabelValueInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ParameterLabelValueInput');
    return {
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'asporto',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'comedo',
    };
};

export const aParsedStructuredLogField = (overrides?: Partial<ParsedStructuredLogField>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ParsedStructuredLogField' } & ParsedStructuredLogField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ParsedStructuredLogField');
    return {
        __typename: 'ParsedStructuredLogField',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'stillicidium',
        samples: overrides && overrides.hasOwnProperty('samples') ? overrides.samples! : [relationshipsToOmit.has('ParsedStructuredLogSample') ? {} as ParsedStructuredLogSample : aParsedStructuredLogSample({}, relationshipsToOmit), relationshipsToOmit.has('ParsedStructuredLogSample') ? {} as ParsedStructuredLogSample : aParsedStructuredLogSample({}, relationshipsToOmit), relationshipsToOmit.has('ParsedStructuredLogSample') ? {} as ParsedStructuredLogSample : aParsedStructuredLogSample({}, relationshipsToOmit)],
    };
};

export const aParsedStructuredLogResult = (overrides?: Partial<ParsedStructuredLogResult>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ParsedStructuredLogResult' } & ParsedStructuredLogResult => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ParsedStructuredLogResult');
    return {
        __typename: 'ParsedStructuredLogResult',
        fields: overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [relationshipsToOmit.has('ParsedStructuredLogField') ? {} as ParsedStructuredLogField : aParsedStructuredLogField({}, relationshipsToOmit), relationshipsToOmit.has('ParsedStructuredLogField') ? {} as ParsedStructuredLogField : aParsedStructuredLogField({}, relationshipsToOmit), relationshipsToOmit.has('ParsedStructuredLogField') ? {} as ParsedStructuredLogField : aParsedStructuredLogField({}, relationshipsToOmit)],
        format: overrides && overrides.hasOwnProperty('format') ? overrides.format! : 'vix',
    };
};

export const aParsedStructuredLogSample = (overrides?: Partial<ParsedStructuredLogSample>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ParsedStructuredLogSample' } & ParsedStructuredLogSample => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ParsedStructuredLogSample');
    return {
        __typename: 'ParsedStructuredLogSample',
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 8192,
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'error',
    };
};

export const aParsingPattern = (overrides?: Partial<ParsingPattern>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ParsingPattern' } & ParsingPattern => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ParsingPattern');
    return {
        __typename: 'ParsingPattern',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'coniuratio',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'agnitio',
    };
};

export const aPathElement = (overrides?: Partial<PathElement>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'PathElement' } & PathElement => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PathElement');
    return {
        __typename: 'PathElement',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'crudelis',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'aer',
    };
};

export const aPermission = (overrides?: Partial<Permission>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Permission' } & Permission => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Permission');
    return {
        __typename: 'Permission',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '3a51e098-6a44-4e19-8b85-4212a524a4e4',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'demens',
    };
};

export const aPermissionPage = (overrides?: Partial<PermissionPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'PermissionPage' } & PermissionPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PermissionPage');
    return {
        __typename: 'PermissionPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('Permission') ? {} as Permission : aPermission({}, relationshipsToOmit), relationshipsToOmit.has('Permission') ? {} as Permission : aPermission({}, relationshipsToOmit), relationshipsToOmit.has('Permission') ? {} as Permission : aPermission({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 7209,
    };
};

export const aPlaybook = (overrides?: Partial<Playbook>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Playbook' } & Playbook => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Playbook');
    return {
        __typename: 'Playbook',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'theatrum',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'celebrer',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'aggredior',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'degusto',
    };
};

export const aPrivilege = (overrides?: Partial<Privilege>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Privilege' } & Privilege => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Privilege');
    return {
        __typename: 'Privilege',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'confugo',
        key: overrides && overrides.hasOwnProperty('key') ? overrides.key! : UserPrivilege.AwsApps,
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : false,
    };
};

export const aPromoteTriageToIncident = (overrides?: Partial<PromoteTriageToIncident>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'PromoteTriageToIncident' } & PromoteTriageToIncident => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('PromoteTriageToIncident');
    return {
        __typename: 'PromoteTriageToIncident',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit),
    };
};

export const aQuery = (overrides?: Partial<Query>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Query' } & Query => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Query');
    return {
        __typename: 'Query',
        accountStatus: overrides && overrides.hasOwnProperty('accountStatus') ? overrides.accountStatus! : relationshipsToOmit.has('AccountStatus') ? {} as AccountStatus : anAccountStatus({}, relationshipsToOmit),
        action: overrides && overrides.hasOwnProperty('action') ? overrides.action! : relationshipsToOmit.has('Action') ? {} as Action : anAction({}, relationshipsToOmit),
        actionConfigurationSchema: overrides && overrides.hasOwnProperty('actionConfigurationSchema') ? overrides.actionConfigurationSchema! : relationshipsToOmit.has('ActionConfigurationSchema') ? {} as ActionConfigurationSchema : anActionConfigurationSchema({}, relationshipsToOmit),
        actionConfigurationSchemas: overrides && overrides.hasOwnProperty('actionConfigurationSchemas') ? overrides.actionConfigurationSchemas! : [relationshipsToOmit.has('ActionConfigurationSchema') ? {} as ActionConfigurationSchema : anActionConfigurationSchema({}, relationshipsToOmit), relationshipsToOmit.has('ActionConfigurationSchema') ? {} as ActionConfigurationSchema : anActionConfigurationSchema({}, relationshipsToOmit), relationshipsToOmit.has('ActionConfigurationSchema') ? {} as ActionConfigurationSchema : anActionConfigurationSchema({}, relationshipsToOmit)],
        actions: overrides && overrides.hasOwnProperty('actions') ? overrides.actions! : [relationshipsToOmit.has('Action') ? {} as Action : anAction({}, relationshipsToOmit), relationshipsToOmit.has('Action') ? {} as Action : anAction({}, relationshipsToOmit), relationshipsToOmit.has('Action') ? {} as Action : anAction({}, relationshipsToOmit)],
        activeDeviceCount: overrides && overrides.hasOwnProperty('activeDeviceCount') ? overrides.activeDeviceCount! : 3619,
        activeUserCount: overrides && overrides.hasOwnProperty('activeUserCount') ? overrides.activeUserCount! : 7084,
        aggregationRuleFunctions: overrides && overrides.hasOwnProperty('aggregationRuleFunctions') ? overrides.aggregationRuleFunctions! : [relationshipsToOmit.has('AggregationRuleFunction') ? {} as AggregationRuleFunction : anAggregationRuleFunction({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRuleFunction') ? {} as AggregationRuleFunction : anAggregationRuleFunction({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRuleFunction') ? {} as AggregationRuleFunction : anAggregationRuleFunction({}, relationshipsToOmit)],
        aggregationRuleValidationResult: overrides && overrides.hasOwnProperty('aggregationRuleValidationResult') ? overrides.aggregationRuleValidationResult! : relationshipsToOmit.has('RuleValidationResult') ? {} as RuleValidationResult : aRuleValidationResult({}, relationshipsToOmit),
        alertCount: overrides && overrides.hasOwnProperty('alertCount') ? overrides.alertCount! : 6765,
        allEntities: overrides && overrides.hasOwnProperty('allEntities') ? overrides.allEntities! : relationshipsToOmit.has('AllEntityPage') ? {} as AllEntityPage : anAllEntityPage({}, relationshipsToOmit),
        allInsights: overrides && overrides.hasOwnProperty('allInsights') ? overrides.allInsights! : relationshipsToOmit.has('AllInsightPage') ? {} as AllInsightPage : anAllInsightPage({}, relationshipsToOmit),
        allSignals: overrides && overrides.hasOwnProperty('allSignals') ? overrides.allSignals! : relationshipsToOmit.has('AllSignalPage') ? {} as AllSignalPage : anAllSignalPage({}, relationshipsToOmit),
        allThreatIntelItems: overrides && overrides.hasOwnProperty('allThreatIntelItems') ? overrides.allThreatIntelItems! : relationshipsToOmit.has('AllThreatIntelItemPage') ? {} as AllThreatIntelItemPage : anAllThreatIntelItemPage({}, relationshipsToOmit),
        allowedInsightStatuses: overrides && overrides.hasOwnProperty('allowedInsightStatuses') ? overrides.allowedInsightStatuses! : [relationshipsToOmit.has('AllowedInsightStatus') ? {} as AllowedInsightStatus : anAllowedInsightStatus({}, relationshipsToOmit), relationshipsToOmit.has('AllowedInsightStatus') ? {} as AllowedInsightStatus : anAllowedInsightStatus({}, relationshipsToOmit), relationshipsToOmit.has('AllowedInsightStatus') ? {} as AllowedInsightStatus : anAllowedInsightStatus({}, relationshipsToOmit)],
        apiDocumentationLink: overrides && overrides.hasOwnProperty('apiDocumentationLink') ? overrides.apiDocumentationLink! : 'utroque',
        assignedInsightEmailsEnabled: overrides && overrides.hasOwnProperty('assignedInsightEmailsEnabled') ? overrides.assignedInsightEmailsEnabled! : true,
        auditLogs: overrides && overrides.hasOwnProperty('auditLogs') ? overrides.auditLogs! : relationshipsToOmit.has('AuditLogPage') ? {} as AuditLogPage : anAuditLogPage({}, relationshipsToOmit),
        automation: overrides && overrides.hasOwnProperty('automation') ? overrides.automation! : relationshipsToOmit.has('Automation') ? {} as Automation : anAutomation({}, relationshipsToOmit),
        automations: overrides && overrides.hasOwnProperty('automations') ? overrides.automations! : relationshipsToOmit.has('AutomationPage') ? {} as AutomationPage : anAutomationPage({}, relationshipsToOmit),
        bigIntInsightCountWithDelta: overrides && overrides.hasOwnProperty('bigIntInsightCountWithDelta') ? overrides.bigIntInsightCountWithDelta! : relationshipsToOmit.has('BigIntCountWithDelta') ? {} as BigIntCountWithDelta : aBigIntCountWithDelta({}, relationshipsToOmit),
        bigIntRecordCountWithDelta: overrides && overrides.hasOwnProperty('bigIntRecordCountWithDelta') ? overrides.bigIntRecordCountWithDelta! : relationshipsToOmit.has('BigIntCountWithDelta') ? {} as BigIntCountWithDelta : aBigIntCountWithDelta({}, relationshipsToOmit),
        bigIntSignalCountWithDelta: overrides && overrides.hasOwnProperty('bigIntSignalCountWithDelta') ? overrides.bigIntSignalCountWithDelta! : relationshipsToOmit.has('BigIntCountWithDelta') ? {} as BigIntCountWithDelta : aBigIntCountWithDelta({}, relationshipsToOmit),
        categories: overrides && overrides.hasOwnProperty('categories') ? overrides.categories! : [relationshipsToOmit.has('Category') ? {} as Category : aCategory({}, relationshipsToOmit), relationshipsToOmit.has('Category') ? {} as Category : aCategory({}, relationshipsToOmit), relationshipsToOmit.has('Category') ? {} as Category : aCategory({}, relationshipsToOmit)],
        chainRuleValidationResult: overrides && overrides.hasOwnProperty('chainRuleValidationResult') ? overrides.chainRuleValidationResult! : relationshipsToOmit.has('RuleValidationResult') ? {} as RuleValidationResult : aRuleValidationResult({}, relationshipsToOmit),
        cloudSoarUrl: overrides && overrides.hasOwnProperty('cloudSoarUrl') ? overrides.cloudSoarUrl! : 'catena',
        contentItems: overrides && overrides.hasOwnProperty('contentItems') ? overrides.contentItems! : [relationshipsToOmit.has('Dashboard') ? {} as Dashboard : aDashboard({}, relationshipsToOmit), relationshipsToOmit.has('Dashboard') ? {} as Dashboard : aDashboard({}, relationshipsToOmit), relationshipsToOmit.has('Dashboard') ? {} as Dashboard : aDashboard({}, relationshipsToOmit)],
        contextAction: overrides && overrides.hasOwnProperty('contextAction') ? overrides.contextAction! : relationshipsToOmit.has('ContextAction') ? {} as ContextAction : aContextAction({}, relationshipsToOmit),
        contextActions: overrides && overrides.hasOwnProperty('contextActions') ? overrides.contextActions! : relationshipsToOmit.has('ContextActionPage') ? {} as ContextActionPage : aContextActionPage({}, relationshipsToOmit),
        coverageColorHexCodes: overrides && overrides.hasOwnProperty('coverageColorHexCodes') ? overrides.coverageColorHexCodes! : relationshipsToOmit.has('MitreCoverageColorLegend') ? {} as MitreCoverageColorLegend : aMitreCoverageColorLegend({}, relationshipsToOmit),
        cspCustomReportUrl: overrides && overrides.hasOwnProperty('cspCustomReportUrl') ? overrides.cspCustomReportUrl! : 'usitas',
        currentUser: overrides && overrides.hasOwnProperty('currentUser') ? overrides.currentUser! : relationshipsToOmit.has('CurrentUser') ? {} as CurrentUser : aCurrentUser({}, relationshipsToOmit),
        currentUserSumo: overrides && overrides.hasOwnProperty('currentUserSumo') ? overrides.currentUserSumo! : relationshipsToOmit.has('CurrentUserSumo') ? {} as CurrentUserSumo : aCurrentUserSumo({}, relationshipsToOmit),
        customEntityType: overrides && overrides.hasOwnProperty('customEntityType') ? overrides.customEntityType! : relationshipsToOmit.has('CustomEntityType') ? {} as CustomEntityType : aCustomEntityType({}, relationshipsToOmit),
        customEntityTypes: overrides && overrides.hasOwnProperty('customEntityTypes') ? overrides.customEntityTypes! : relationshipsToOmit.has('CustomEntityTypePage') ? {} as CustomEntityTypePage : aCustomEntityTypePage({}, relationshipsToOmit),
        customInsight: overrides && overrides.hasOwnProperty('customInsight') ? overrides.customInsight! : relationshipsToOmit.has('CustomInsight') ? {} as CustomInsight : aCustomInsight({}, relationshipsToOmit),
        customInsights: overrides && overrides.hasOwnProperty('customInsights') ? overrides.customInsights! : relationshipsToOmit.has('CustomInsightPage') ? {} as CustomInsightPage : aCustomInsightPage({}, relationshipsToOmit),
        customMatchListColumn: overrides && overrides.hasOwnProperty('customMatchListColumn') ? overrides.customMatchListColumn! : relationshipsToOmit.has('CustomMatchListColumn') ? {} as CustomMatchListColumn : aCustomMatchListColumn({}, relationshipsToOmit),
        customMatchListColumnLimit: overrides && overrides.hasOwnProperty('customMatchListColumnLimit') ? overrides.customMatchListColumnLimit! : 8456,
        customMatchListColumns: overrides && overrides.hasOwnProperty('customMatchListColumns') ? overrides.customMatchListColumns! : [relationshipsToOmit.has('CustomMatchListColumn') ? {} as CustomMatchListColumn : aCustomMatchListColumn({}, relationshipsToOmit), relationshipsToOmit.has('CustomMatchListColumn') ? {} as CustomMatchListColumn : aCustomMatchListColumn({}, relationshipsToOmit), relationshipsToOmit.has('CustomMatchListColumn') ? {} as CustomMatchListColumn : aCustomMatchListColumn({}, relationshipsToOmit)],
        customerSourcedLookupTable: overrides && overrides.hasOwnProperty('customerSourcedLookupTable') ? overrides.customerSourcedLookupTable! : relationshipsToOmit.has('CustomerSourcedEntityLookupTable') ? {} as CustomerSourcedEntityLookupTable : aCustomerSourcedEntityLookupTable({}, relationshipsToOmit),
        customerSourcedLookupTables: overrides && overrides.hasOwnProperty('customerSourcedLookupTables') ? overrides.customerSourcedLookupTables! : [relationshipsToOmit.has('CustomerSourcedEntityLookupTable') ? {} as CustomerSourcedEntityLookupTable : aCustomerSourcedEntityLookupTable({}, relationshipsToOmit), relationshipsToOmit.has('CustomerSourcedEntityLookupTable') ? {} as CustomerSourcedEntityLookupTable : aCustomerSourcedEntityLookupTable({}, relationshipsToOmit), relationshipsToOmit.has('CustomerSourcedEntityLookupTable') ? {} as CustomerSourcedEntityLookupTable : aCustomerSourcedEntityLookupTable({}, relationshipsToOmit)],
        deployment: overrides && overrides.hasOwnProperty('deployment') ? overrides.deployment! : 'alveus',
        downloadsForProduct: overrides && overrides.hasOwnProperty('downloadsForProduct') ? overrides.downloadsForProduct! : [relationshipsToOmit.has('Download') ? {} as Download : aDownload({}, relationshipsToOmit), relationshipsToOmit.has('Download') ? {} as Download : aDownload({}, relationshipsToOmit), relationshipsToOmit.has('Download') ? {} as Download : aDownload({}, relationshipsToOmit)],
        dslSearchResults: overrides && overrides.hasOwnProperty('dslSearchResults') ? overrides.dslSearchResults! : relationshipsToOmit.has('SearchResultPage') ? {} as SearchResultPage : aSearchResultPage({}, relationshipsToOmit),
        enabledFeatureFlagEnums: overrides && overrides.hasOwnProperty('enabledFeatureFlagEnums') ? overrides.enabledFeatureFlagEnums! : [FeatureFlag.BulkInsightActions, FeatureFlag.BulkInsightActions, FeatureFlag.BulkInsightActions],
        enabledFeatureFlags: overrides && overrides.hasOwnProperty('enabledFeatureFlags') ? overrides.enabledFeatureFlags! : ['temporibus', 'curtus', 'thesaurus'],
        enabledFeatureflagsV2: overrides && overrides.hasOwnProperty('enabledFeatureflagsV2') ? overrides.enabledFeatureflagsV2! : ['deludo', 'bis', 'placeat'],
        enforcedOutputSchemaFields: overrides && overrides.hasOwnProperty('enforcedOutputSchemaFields') ? overrides.enforcedOutputSchemaFields! : [relationshipsToOmit.has('EnforcedOutputField') ? {} as EnforcedOutputField : anEnforcedOutputField({}, relationshipsToOmit), relationshipsToOmit.has('EnforcedOutputField') ? {} as EnforcedOutputField : anEnforcedOutputField({}, relationshipsToOmit), relationshipsToOmit.has('EnforcedOutputField') ? {} as EnforcedOutputField : anEnforcedOutputField({}, relationshipsToOmit)],
        enrichmentConfig: overrides && overrides.hasOwnProperty('enrichmentConfig') ? overrides.enrichmentConfig! : relationshipsToOmit.has('EnrichmentConfig') ? {} as EnrichmentConfig : anEnrichmentConfig({}, relationshipsToOmit),
        entities: overrides && overrides.hasOwnProperty('entities') ? overrides.entities! : relationshipsToOmit.has('EntityPage') ? {} as EntityPage : anEntityPage({}, relationshipsToOmit),
        entitiesByListIds: overrides && overrides.hasOwnProperty('entitiesByListIds') ? overrides.entitiesByListIds! : [relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit)],
        entity: overrides && overrides.hasOwnProperty('entity') ? overrides.entity! : relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit),
        entityCriticalityConfig: overrides && overrides.hasOwnProperty('entityCriticalityConfig') ? overrides.entityCriticalityConfig! : relationshipsToOmit.has('EntityCriticalityConfig') ? {} as EntityCriticalityConfig : anEntityCriticalityConfig({}, relationshipsToOmit),
        entityCriticalityConfigs: overrides && overrides.hasOwnProperty('entityCriticalityConfigs') ? overrides.entityCriticalityConfigs! : relationshipsToOmit.has('EntityCriticalityConfigPage') ? {} as EntityCriticalityConfigPage : anEntityCriticalityConfigPage({}, relationshipsToOmit),
        entityDomainConfiguration: overrides && overrides.hasOwnProperty('entityDomainConfiguration') ? overrides.entityDomainConfiguration! : relationshipsToOmit.has('EntityDomainConfiguration') ? {} as EntityDomainConfiguration : anEntityDomainConfiguration({}, relationshipsToOmit),
        entityFields: overrides && overrides.hasOwnProperty('entityFields') ? overrides.entityFields! : ['utrimque', 'cattus', 'corrigo'],
        entityFieldsWithTypes: overrides && overrides.hasOwnProperty('entityFieldsWithTypes') ? overrides.entityFieldsWithTypes! : [relationshipsToOmit.has('EntityFieldAndType') ? {} as EntityFieldAndType : anEntityFieldAndType({}, relationshipsToOmit), relationshipsToOmit.has('EntityFieldAndType') ? {} as EntityFieldAndType : anEntityFieldAndType({}, relationshipsToOmit), relationshipsToOmit.has('EntityFieldAndType') ? {} as EntityFieldAndType : anEntityFieldAndType({}, relationshipsToOmit)],
        entityGroupConfiguration: overrides && overrides.hasOwnProperty('entityGroupConfiguration') ? overrides.entityGroupConfiguration! : relationshipsToOmit.has('EntityGroupConfiguration') ? {} as EntityGroupConfiguration : anEntityGroupConfiguration({}, relationshipsToOmit),
        entityGroupConfigurations: overrides && overrides.hasOwnProperty('entityGroupConfigurations') ? overrides.entityGroupConfigurations! : relationshipsToOmit.has('EntityGroupConfigurationPage') ? {} as EntityGroupConfigurationPage : anEntityGroupConfigurationPage({}, relationshipsToOmit),
        entityNotes: overrides && overrides.hasOwnProperty('entityNotes') ? overrides.entityNotes! : [relationshipsToOmit.has('EntityNote') ? {} as EntityNote : anEntityNote({}, relationshipsToOmit), relationshipsToOmit.has('EntityNote') ? {} as EntityNote : anEntityNote({}, relationshipsToOmit), relationshipsToOmit.has('EntityNote') ? {} as EntityNote : anEntityNote({}, relationshipsToOmit)],
        entityTagOptions: overrides && overrides.hasOwnProperty('entityTagOptions') ? overrides.entityTagOptions! : [relationshipsToOmit.has('EntityTagOption') ? {} as EntityTagOption : anEntityTagOption({}, relationshipsToOmit), relationshipsToOmit.has('EntityTagOption') ? {} as EntityTagOption : anEntityTagOption({}, relationshipsToOmit), relationshipsToOmit.has('EntityTagOption') ? {} as EntityTagOption : anEntityTagOption({}, relationshipsToOmit)],
        entityTimelineGroups: overrides && overrides.hasOwnProperty('entityTimelineGroups') ? overrides.entityTimelineGroups! : [relationshipsToOmit.has('EntityTimelineGroup') ? {} as EntityTimelineGroup : anEntityTimelineGroup({}, relationshipsToOmit), relationshipsToOmit.has('EntityTimelineGroup') ? {} as EntityTimelineGroup : anEntityTimelineGroup({}, relationshipsToOmit), relationshipsToOmit.has('EntityTimelineGroup') ? {} as EntityTimelineGroup : anEntityTimelineGroup({}, relationshipsToOmit)],
        favoriteFields: overrides && overrides.hasOwnProperty('favoriteFields') ? overrides.favoriteFields! : relationshipsToOmit.has('FavoriteFieldPage') ? {} as FavoriteFieldPage : aFavoriteFieldPage({}, relationshipsToOmit),
        favoriteItems: overrides && overrides.hasOwnProperty('favoriteItems') ? overrides.favoriteItems! : relationshipsToOmit.has('ContentPage') ? {} as ContentPage : aContentPage({}, relationshipsToOmit),
        federatedChildOrgs: overrides && overrides.hasOwnProperty('federatedChildOrgs') ? overrides.federatedChildOrgs! : [relationshipsToOmit.has('FederatedChildOrg') ? {} as FederatedChildOrg : aFederatedChildOrg({}, relationshipsToOmit), relationshipsToOmit.has('FederatedChildOrg') ? {} as FederatedChildOrg : aFederatedChildOrg({}, relationshipsToOmit), relationshipsToOmit.has('FederatedChildOrg') ? {} as FederatedChildOrg : aFederatedChildOrg({}, relationshipsToOmit)],
        folder: overrides && overrides.hasOwnProperty('folder') ? overrides.folder! : relationshipsToOmit.has('Folder') ? {} as Folder : aFolder({}, relationshipsToOmit),
        groupedInsights: overrides && overrides.hasOwnProperty('groupedInsights') ? overrides.groupedInsights! : [relationshipsToOmit.has('GroupedInsightPage') ? {} as GroupedInsightPage : aGroupedInsightPage({}, relationshipsToOmit), relationshipsToOmit.has('GroupedInsightPage') ? {} as GroupedInsightPage : aGroupedInsightPage({}, relationshipsToOmit), relationshipsToOmit.has('GroupedInsightPage') ? {} as GroupedInsightPage : aGroupedInsightPage({}, relationshipsToOmit)],
        healthCheck: overrides && overrides.hasOwnProperty('healthCheck') ? overrides.healthCheck! : 'debeo',
        incidentSearchResults: overrides && overrides.hasOwnProperty('incidentSearchResults') ? overrides.incidentSearchResults! : [relationshipsToOmit.has('IncidentSearchResult') ? {} as IncidentSearchResult : anIncidentSearchResult({}, relationshipsToOmit), relationshipsToOmit.has('IncidentSearchResult') ? {} as IncidentSearchResult : anIncidentSearchResult({}, relationshipsToOmit), relationshipsToOmit.has('IncidentSearchResult') ? {} as IncidentSearchResult : anIncidentSearchResult({}, relationshipsToOmit)],
        incidentTemplates: overrides && overrides.hasOwnProperty('incidentTemplates') ? overrides.incidentTemplates! : [relationshipsToOmit.has('IncidentTemplate') ? {} as IncidentTemplate : anIncidentTemplate({}, relationshipsToOmit), relationshipsToOmit.has('IncidentTemplate') ? {} as IncidentTemplate : anIncidentTemplate({}, relationshipsToOmit), relationshipsToOmit.has('IncidentTemplate') ? {} as IncidentTemplate : anIncidentTemplate({}, relationshipsToOmit)],
        insight: overrides && overrides.hasOwnProperty('insight') ? overrides.insight! : relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit),
        insightActivityFeedEvents: overrides && overrides.hasOwnProperty('insightActivityFeedEvents') ? overrides.insightActivityFeedEvents! : relationshipsToOmit.has('InsightActivityFeedEventPage') ? {} as InsightActivityFeedEventPage : anInsightActivityFeedEventPage({}, relationshipsToOmit),
        insightClosedCounts: overrides && overrides.hasOwnProperty('insightClosedCounts') ? overrides.insightClosedCounts! : [relationshipsToOmit.has('BigIntDataPoint') ? {} as BigIntDataPoint : aBigIntDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('BigIntDataPoint') ? {} as BigIntDataPoint : aBigIntDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('BigIntDataPoint') ? {} as BigIntDataPoint : aBigIntDataPoint({}, relationshipsToOmit)],
        insightConfig: overrides && overrides.hasOwnProperty('insightConfig') ? overrides.insightConfig! : relationshipsToOmit.has('InsightConfig') ? {} as InsightConfig : anInsightConfig({}, relationshipsToOmit),
        insightCountWithDelta: overrides && overrides.hasOwnProperty('insightCountWithDelta') ? overrides.insightCountWithDelta! : relationshipsToOmit.has('CountWithDelta') ? {} as CountWithDelta : aCountWithDelta({}, relationshipsToOmit),
        insightCounts: overrides && overrides.hasOwnProperty('insightCounts') ? overrides.insightCounts! : [relationshipsToOmit.has('BigIntDataPoint') ? {} as BigIntDataPoint : aBigIntDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('BigIntDataPoint') ? {} as BigIntDataPoint : aBigIntDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('BigIntDataPoint') ? {} as BigIntDataPoint : aBigIntDataPoint({}, relationshipsToOmit)],
        insightCountsByStatus: overrides && overrides.hasOwnProperty('insightCountsByStatus') ? overrides.insightCountsByStatus! : [relationshipsToOmit.has('InsightCountsByStatusDataPoint') ? {} as InsightCountsByStatusDataPoint : anInsightCountsByStatusDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('InsightCountsByStatusDataPoint') ? {} as InsightCountsByStatusDataPoint : anInsightCountsByStatusDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('InsightCountsByStatusDataPoint') ? {} as InsightCountsByStatusDataPoint : anInsightCountsByStatusDataPoint({}, relationshipsToOmit)],
        insightEntityActivity: overrides && overrides.hasOwnProperty('insightEntityActivity') ? overrides.insightEntityActivity! : [relationshipsToOmit.has('InsightEntityActivity') ? {} as InsightEntityActivity : anInsightEntityActivity({}, relationshipsToOmit), relationshipsToOmit.has('InsightEntityActivity') ? {} as InsightEntityActivity : anInsightEntityActivity({}, relationshipsToOmit), relationshipsToOmit.has('InsightEntityActivity') ? {} as InsightEntityActivity : anInsightEntityActivity({}, relationshipsToOmit)],
        insightResolution: overrides && overrides.hasOwnProperty('insightResolution') ? overrides.insightResolution! : relationshipsToOmit.has('InsightResolution') ? {} as InsightResolution : anInsightResolution({}, relationshipsToOmit),
        insightResolutions: overrides && overrides.hasOwnProperty('insightResolutions') ? overrides.insightResolutions! : relationshipsToOmit.has('InsightResolutionPage') ? {} as InsightResolutionPage : anInsightResolutionPage({}, relationshipsToOmit),
        insightStatus: overrides && overrides.hasOwnProperty('insightStatus') ? overrides.insightStatus! : relationshipsToOmit.has('InsightStatus') ? {} as InsightStatus : anInsightStatus({}, relationshipsToOmit),
        insightStatusInProgressEnabled: overrides && overrides.hasOwnProperty('insightStatusInProgressEnabled') ? overrides.insightStatusInProgressEnabled! : true,
        insightStatuses: overrides && overrides.hasOwnProperty('insightStatuses') ? overrides.insightStatuses! : [relationshipsToOmit.has('InsightStatus') ? {} as InsightStatus : anInsightStatus({}, relationshipsToOmit), relationshipsToOmit.has('InsightStatus') ? {} as InsightStatus : anInsightStatus({}, relationshipsToOmit), relationshipsToOmit.has('InsightStatus') ? {} as InsightStatus : anInsightStatus({}, relationshipsToOmit)],
        insightTagOptions: overrides && overrides.hasOwnProperty('insightTagOptions') ? overrides.insightTagOptions! : [relationshipsToOmit.has('InsightTagOption') ? {} as InsightTagOption : anInsightTagOption({}, relationshipsToOmit), relationshipsToOmit.has('InsightTagOption') ? {} as InsightTagOption : anInsightTagOption({}, relationshipsToOmit), relationshipsToOmit.has('InsightTagOption') ? {} as InsightTagOption : anInsightTagOption({}, relationshipsToOmit)],
        insights: overrides && overrides.hasOwnProperty('insights') ? overrides.insights! : relationshipsToOmit.has('InsightPage') ? {} as InsightPage : anInsightPage({}, relationshipsToOmit),
        inventories: overrides && overrides.hasOwnProperty('inventories') ? overrides.inventories! : relationshipsToOmit.has('InventoryPage') ? {} as InventoryPage : anInventoryPage({}, relationshipsToOmit),
        inventoryGroupOptions: overrides && overrides.hasOwnProperty('inventoryGroupOptions') ? overrides.inventoryGroupOptions! : [relationshipsToOmit.has('InventoryGroupOption') ? {} as InventoryGroupOption : anInventoryGroupOption({}, relationshipsToOmit), relationshipsToOmit.has('InventoryGroupOption') ? {} as InventoryGroupOption : anInventoryGroupOption({}, relationshipsToOmit), relationshipsToOmit.has('InventoryGroupOption') ? {} as InventoryGroupOption : anInventoryGroupOption({}, relationshipsToOmit)],
        inventoryLookupTable: overrides && overrides.hasOwnProperty('inventoryLookupTable') ? overrides.inventoryLookupTable! : relationshipsToOmit.has('InventoryEntityLookupTable') ? {} as InventoryEntityLookupTable : anInventoryEntityLookupTable({}, relationshipsToOmit),
        inventoryLookupTableSources: overrides && overrides.hasOwnProperty('inventoryLookupTableSources') ? overrides.inventoryLookupTableSources! : ['via', 'admiratio', 'caritas'],
        inventoryLookupTables: overrides && overrides.hasOwnProperty('inventoryLookupTables') ? overrides.inventoryLookupTables! : [relationshipsToOmit.has('InventoryEntityLookupTable') ? {} as InventoryEntityLookupTable : anInventoryEntityLookupTable({}, relationshipsToOmit), relationshipsToOmit.has('InventoryEntityLookupTable') ? {} as InventoryEntityLookupTable : anInventoryEntityLookupTable({}, relationshipsToOmit), relationshipsToOmit.has('InventoryEntityLookupTable') ? {} as InventoryEntityLookupTable : anInventoryEntityLookupTable({}, relationshipsToOmit)],
        inventorySources: overrides && overrides.hasOwnProperty('inventorySources') ? overrides.inventorySources! : ['artificiose', 'adficio', 'illo'],
        isFederatedCluster: overrides && overrides.hasOwnProperty('isFederatedCluster') ? overrides.isFederatedCluster! : false,
        isInContentAdminMode: overrides && overrides.hasOwnProperty('isInContentAdminMode') ? overrides.isInContentAdminMode! : true,
        libraryGlobalView: overrides && overrides.hasOwnProperty('libraryGlobalView') ? overrides.libraryGlobalView! : relationshipsToOmit.has('LibraryGlobalView') ? {} as LibraryGlobalView : aLibraryGlobalView({}, relationshipsToOmit),
        logExecutionContext: overrides && overrides.hasOwnProperty('logExecutionContext') ? overrides.logExecutionContext! : 'antea',
        logMapping: overrides && overrides.hasOwnProperty('logMapping') ? overrides.logMapping! : relationshipsToOmit.has('LogMapping') ? {} as LogMapping : aLogMapping({}, relationshipsToOmit),
        logMappingOptions: overrides && overrides.hasOwnProperty('logMappingOptions') ? overrides.logMappingOptions! : relationshipsToOmit.has('LogMappingOptions') ? {} as LogMappingOptions : aLogMappingOptions({}, relationshipsToOmit),
        logMappingVendorsAndProducts: overrides && overrides.hasOwnProperty('logMappingVendorsAndProducts') ? overrides.logMappingVendorsAndProducts! : [relationshipsToOmit.has('LogMappingVendorAndProduct') ? {} as LogMappingVendorAndProduct : aLogMappingVendorAndProduct({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingVendorAndProduct') ? {} as LogMappingVendorAndProduct : aLogMappingVendorAndProduct({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingVendorAndProduct') ? {} as LogMappingVendorAndProduct : aLogMappingVendorAndProduct({}, relationshipsToOmit)],
        logMappings: overrides && overrides.hasOwnProperty('logMappings') ? overrides.logMappings! : relationshipsToOmit.has('LogMappingPage') ? {} as LogMappingPage : aLogMappingPage({}, relationshipsToOmit),
        matchList: overrides && overrides.hasOwnProperty('matchList') ? overrides.matchList! : relationshipsToOmit.has('MatchList') ? {} as MatchList : aMatchList({}, relationshipsToOmit),
        matchListItem: overrides && overrides.hasOwnProperty('matchListItem') ? overrides.matchListItem! : relationshipsToOmit.has('MatchListItem') ? {} as MatchListItem : aMatchListItem({}, relationshipsToOmit),
        matchListItemCount: overrides && overrides.hasOwnProperty('matchListItemCount') ? overrides.matchListItemCount! : 105,
        matchListItemLimit: overrides && overrides.hasOwnProperty('matchListItemLimit') ? overrides.matchListItemLimit! : 4660,
        matchListItems: overrides && overrides.hasOwnProperty('matchListItems') ? overrides.matchListItems! : relationshipsToOmit.has('MatchListItemPage') ? {} as MatchListItemPage : aMatchListItemPage({}, relationshipsToOmit),
        matchListItems2: overrides && overrides.hasOwnProperty('matchListItems2') ? overrides.matchListItems2! : relationshipsToOmit.has('MatchListItemPage') ? {} as MatchListItemPage : aMatchListItemPage({}, relationshipsToOmit),
        matchLists: overrides && overrides.hasOwnProperty('matchLists') ? overrides.matchLists! : relationshipsToOmit.has('MatchListPage') ? {} as MatchListPage : aMatchListPage({}, relationshipsToOmit),
        matchRuleValidationResult: overrides && overrides.hasOwnProperty('matchRuleValidationResult') ? overrides.matchRuleValidationResult! : relationshipsToOmit.has('RuleValidationResult') ? {} as RuleValidationResult : aRuleValidationResult({}, relationshipsToOmit),
        meanTimeToDetection: overrides && overrides.hasOwnProperty('meanTimeToDetection') ? overrides.meanTimeToDetection! : '10',
        meanTimeToRemediation: overrides && overrides.hasOwnProperty('meanTimeToRemediation') ? overrides.meanTimeToRemediation! : '66',
        meanTimeToResponse: overrides && overrides.hasOwnProperty('meanTimeToResponse') ? overrides.meanTimeToResponse! : '57',
        mfaEnabled: overrides && overrides.hasOwnProperty('mfaEnabled') ? overrides.mfaEnabled! : true,
        mitreAttackCoverageExportJson: overrides && overrides.hasOwnProperty('mitreAttackCoverageExportJson') ? overrides.mitreAttackCoverageExportJson! : 'delibero',
        mitreTaggedRules: overrides && overrides.hasOwnProperty('mitreTaggedRules') ? overrides.mitreTaggedRules! : relationshipsToOmit.has('MitreTaggedRules') ? {} as MitreTaggedRules : aMitreTaggedRules({}, relationshipsToOmit),
        networkBlock: overrides && overrides.hasOwnProperty('networkBlock') ? overrides.networkBlock! : relationshipsToOmit.has('NetworkBlock') ? {} as NetworkBlock : aNetworkBlock({}, relationshipsToOmit),
        networkBlocks: overrides && overrides.hasOwnProperty('networkBlocks') ? overrides.networkBlocks! : relationshipsToOmit.has('NetworkBlockPage') ? {} as NetworkBlockPage : aNetworkBlockPage({}, relationshipsToOmit),
        networkBlocksByIp: overrides && overrides.hasOwnProperty('networkBlocksByIp') ? overrides.networkBlocksByIp! : [relationshipsToOmit.has('NetworkBlock') ? {} as NetworkBlock : aNetworkBlock({}, relationshipsToOmit), relationshipsToOmit.has('NetworkBlock') ? {} as NetworkBlock : aNetworkBlock({}, relationshipsToOmit), relationshipsToOmit.has('NetworkBlock') ? {} as NetworkBlock : aNetworkBlock({}, relationshipsToOmit)],
        objectTypes: overrides && overrides.hasOwnProperty('objectTypes') ? overrides.objectTypes! : ['vir', 'ipsam', 'quam'],
        orgId: overrides && overrides.hasOwnProperty('orgId') ? overrides.orgId! : 'paens',
        orgName: overrides && overrides.hasOwnProperty('orgName') ? overrides.orgName! : 'amoveo',
        organizations: overrides && overrides.hasOwnProperty('organizations') ? overrides.organizations! : relationshipsToOmit.has('OrganizationsPage') ? {} as OrganizationsPage : anOrganizationsPage({}, relationshipsToOmit),
        parsedStructuredLog: overrides && overrides.hasOwnProperty('parsedStructuredLog') ? overrides.parsedStructuredLog! : relationshipsToOmit.has('ParsedStructuredLogResult') ? {} as ParsedStructuredLogResult : aParsedStructuredLogResult({}, relationshipsToOmit),
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : relationshipsToOmit.has('PermissionPage') ? {} as PermissionPage : aPermissionPage({}, relationshipsToOmit),
        pinnedSearches: overrides && overrides.hasOwnProperty('pinnedSearches') ? overrides.pinnedSearches! : relationshipsToOmit.has('ContentPage') ? {} as ContentPage : aContentPage({}, relationshipsToOmit),
        playbooks: overrides && overrides.hasOwnProperty('playbooks') ? overrides.playbooks! : [relationshipsToOmit.has('Playbook') ? {} as Playbook : aPlaybook({}, relationshipsToOmit), relationshipsToOmit.has('Playbook') ? {} as Playbook : aPlaybook({}, relationshipsToOmit), relationshipsToOmit.has('Playbook') ? {} as Playbook : aPlaybook({}, relationshipsToOmit)],
        recentItems: overrides && overrides.hasOwnProperty('recentItems') ? overrides.recentItems! : relationshipsToOmit.has('ContentPage') ? {} as ContentPage : aContentPage({}, relationshipsToOmit),
        recentItemsV2: overrides && overrides.hasOwnProperty('recentItemsV2') ? overrides.recentItemsV2! : relationshipsToOmit.has('RecentItemsByType') ? {} as RecentItemsByType : aRecentItemsByType({}, relationshipsToOmit),
        recentlyVisitedDetailPages: overrides && overrides.hasOwnProperty('recentlyVisitedDetailPages') ? overrides.recentlyVisitedDetailPages! : [relationshipsToOmit.has('VisitedEntityPage') ? {} as VisitedEntityPage : aVisitedEntityPage({}, relationshipsToOmit), relationshipsToOmit.has('VisitedEntityPage') ? {} as VisitedEntityPage : aVisitedEntityPage({}, relationshipsToOmit), relationshipsToOmit.has('VisitedEntityPage') ? {} as VisitedEntityPage : aVisitedEntityPage({}, relationshipsToOmit)],
        recentlyVisitedSearchQueryPages: overrides && overrides.hasOwnProperty('recentlyVisitedSearchQueryPages') ? overrides.recentlyVisitedSearchQueryPages! : [relationshipsToOmit.has('VisitedSearchQueryPage') ? {} as VisitedSearchQueryPage : aVisitedSearchQueryPage({}, relationshipsToOmit), relationshipsToOmit.has('VisitedSearchQueryPage') ? {} as VisitedSearchQueryPage : aVisitedSearchQueryPage({}, relationshipsToOmit), relationshipsToOmit.has('VisitedSearchQueryPage') ? {} as VisitedSearchQueryPage : aVisitedSearchQueryPage({}, relationshipsToOmit)],
        recordArtifactConfigs: overrides && overrides.hasOwnProperty('recordArtifactConfigs') ? overrides.recordArtifactConfigs! : relationshipsToOmit.has('RecordArtifactConfigPage') ? {} as RecordArtifactConfigPage : aRecordArtifactConfigPage({}, relationshipsToOmit),
        recordCountWithDelta: overrides && overrides.hasOwnProperty('recordCountWithDelta') ? overrides.recordCountWithDelta! : relationshipsToOmit.has('CountWithDelta') ? {} as CountWithDelta : aCountWithDelta({}, relationshipsToOmit),
        recordCounts: overrides && overrides.hasOwnProperty('recordCounts') ? overrides.recordCounts! : [relationshipsToOmit.has('BigIntDataPoint') ? {} as BigIntDataPoint : aBigIntDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('BigIntDataPoint') ? {} as BigIntDataPoint : aBigIntDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('BigIntDataPoint') ? {} as BigIntDataPoint : aBigIntDataPoint({}, relationshipsToOmit)],
        recordCountsByParsed: overrides && overrides.hasOwnProperty('recordCountsByParsed') ? overrides.recordCountsByParsed! : [relationshipsToOmit.has('RecordCountsByParsedDataPoint') ? {} as RecordCountsByParsedDataPoint : aRecordCountsByParsedDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('RecordCountsByParsedDataPoint') ? {} as RecordCountsByParsedDataPoint : aRecordCountsByParsedDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('RecordCountsByParsedDataPoint') ? {} as RecordCountsByParsedDataPoint : aRecordCountsByParsedDataPoint({}, relationshipsToOmit)],
        recordCountsByVendor: overrides && overrides.hasOwnProperty('recordCountsByVendor') ? overrides.recordCountsByVendor! : [relationshipsToOmit.has('CountsByVendorDataPoint') ? {} as CountsByVendorDataPoint : aCountsByVendorDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('CountsByVendorDataPoint') ? {} as CountsByVendorDataPoint : aCountsByVendorDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('CountsByVendorDataPoint') ? {} as CountsByVendorDataPoint : aCountsByVendorDataPoint({}, relationshipsToOmit)],
        recordCountsByVendorAndProduct: overrides && overrides.hasOwnProperty('recordCountsByVendorAndProduct') ? overrides.recordCountsByVendorAndProduct! : [relationshipsToOmit.has('CountsByVendorAndProductDataPoint') ? {} as CountsByVendorAndProductDataPoint : aCountsByVendorAndProductDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('CountsByVendorAndProductDataPoint') ? {} as CountsByVendorAndProductDataPoint : aCountsByVendorAndProductDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('CountsByVendorAndProductDataPoint') ? {} as CountsByVendorAndProductDataPoint : aCountsByVendorAndProductDataPoint({}, relationshipsToOmit)],
        recordSchema: overrides && overrides.hasOwnProperty('recordSchema') ? overrides.recordSchema! : 'vere',
        recordStreams: overrides && overrides.hasOwnProperty('recordStreams') ? overrides.recordStreams! : ['libero', 'toties', 'audacia'],
        relatedEntities: overrides && overrides.hasOwnProperty('relatedEntities') ? overrides.relatedEntities! : [relationshipsToOmit.has('RelatedEntity') ? {} as RelatedEntity : aRelatedEntity({}, relationshipsToOmit), relationshipsToOmit.has('RelatedEntity') ? {} as RelatedEntity : aRelatedEntity({}, relationshipsToOmit), relationshipsToOmit.has('RelatedEntity') ? {} as RelatedEntity : aRelatedEntity({}, relationshipsToOmit)],
        relatedEntitiesById: overrides && overrides.hasOwnProperty('relatedEntitiesById') ? overrides.relatedEntitiesById! : [relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit)],
        role: overrides && overrides.hasOwnProperty('role') ? overrides.role! : relationshipsToOmit.has('Role') ? {} as Role : aRole({}, relationshipsToOmit),
        roles: overrides && overrides.hasOwnProperty('roles') ? overrides.roles! : relationshipsToOmit.has('RolePage') ? {} as RolePage : aRolePage({}, relationshipsToOmit),
        rule: overrides && overrides.hasOwnProperty('rule') ? overrides.rule! : relationshipsToOmit.has('AggregationRule') ? {} as AggregationRule : anAggregationRule({}, relationshipsToOmit),
        ruleStreams: overrides && overrides.hasOwnProperty('ruleStreams') ? overrides.ruleStreams! : ['consectetur', 'caelum', 'ventito'],
        ruleTagOptions: overrides && overrides.hasOwnProperty('ruleTagOptions') ? overrides.ruleTagOptions! : [relationshipsToOmit.has('RuleTagOption') ? {} as RuleTagOption : aRuleTagOption({}, relationshipsToOmit), relationshipsToOmit.has('RuleTagOption') ? {} as RuleTagOption : aRuleTagOption({}, relationshipsToOmit), relationshipsToOmit.has('RuleTagOption') ? {} as RuleTagOption : aRuleTagOption({}, relationshipsToOmit)],
        ruleTranslation: overrides && overrides.hasOwnProperty('ruleTranslation') ? overrides.ruleTranslation! : 'spero',
        ruleTuningExpression: overrides && overrides.hasOwnProperty('ruleTuningExpression') ? overrides.ruleTuningExpression! : relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit),
        ruleTuningExpressions: overrides && overrides.hasOwnProperty('ruleTuningExpressions') ? overrides.ruleTuningExpressions! : relationshipsToOmit.has('RuleTuningExpressionPage') ? {} as RuleTuningExpressionPage : aRuleTuningExpressionPage({}, relationshipsToOmit),
        rules: overrides && overrides.hasOwnProperty('rules') ? overrides.rules! : relationshipsToOmit.has('RulePage') ? {} as RulePage : aRulePage({}, relationshipsToOmit),
        savedSearches: overrides && overrides.hasOwnProperty('savedSearches') ? overrides.savedSearches! : [relationshipsToOmit.has('SavedSearch') ? {} as SavedSearch : aSavedSearch({}, relationshipsToOmit), relationshipsToOmit.has('SavedSearch') ? {} as SavedSearch : aSavedSearch({}, relationshipsToOmit), relationshipsToOmit.has('SavedSearch') ? {} as SavedSearch : aSavedSearch({}, relationshipsToOmit)],
        searchFieldSuggestions: overrides && overrides.hasOwnProperty('searchFieldSuggestions') ? overrides.searchFieldSuggestions! : relationshipsToOmit.has('SearchFieldSuggestionPage') ? {} as SearchFieldSuggestionPage : aSearchFieldSuggestionPage({}, relationshipsToOmit),
        sensorZones: overrides && overrides.hasOwnProperty('sensorZones') ? overrides.sensorZones! : ['ulciscor', 'saepe', 'crudelis'],
        sessionTimeoutMinutes: overrides && overrides.hasOwnProperty('sessionTimeoutMinutes') ? overrides.sessionTimeoutMinutes! : 6789,
        signal: overrides && overrides.hasOwnProperty('signal') ? overrides.signal! : relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit),
        signalCountWithDelta: overrides && overrides.hasOwnProperty('signalCountWithDelta') ? overrides.signalCountWithDelta! : relationshipsToOmit.has('CountWithDelta') ? {} as CountWithDelta : aCountWithDelta({}, relationshipsToOmit),
        signalCounts: overrides && overrides.hasOwnProperty('signalCounts') ? overrides.signalCounts! : [relationshipsToOmit.has('BigIntDataPoint') ? {} as BigIntDataPoint : aBigIntDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('BigIntDataPoint') ? {} as BigIntDataPoint : aBigIntDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('BigIntDataPoint') ? {} as BigIntDataPoint : aBigIntDataPoint({}, relationshipsToOmit)],
        signalCountsByVendor: overrides && overrides.hasOwnProperty('signalCountsByVendor') ? overrides.signalCountsByVendor! : [relationshipsToOmit.has('CountsByVendorDataPoint') ? {} as CountsByVendorDataPoint : aCountsByVendorDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('CountsByVendorDataPoint') ? {} as CountsByVendorDataPoint : aCountsByVendorDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('CountsByVendorDataPoint') ? {} as CountsByVendorDataPoint : aCountsByVendorDataPoint({}, relationshipsToOmit)],
        signalCountsByVendorAndProduct: overrides && overrides.hasOwnProperty('signalCountsByVendorAndProduct') ? overrides.signalCountsByVendorAndProduct! : [relationshipsToOmit.has('CountsByVendorAndProductDataPoint') ? {} as CountsByVendorAndProductDataPoint : aCountsByVendorAndProductDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('CountsByVendorAndProductDataPoint') ? {} as CountsByVendorAndProductDataPoint : aCountsByVendorAndProductDataPoint({}, relationshipsToOmit), relationshipsToOmit.has('CountsByVendorAndProductDataPoint') ? {} as CountsByVendorAndProductDataPoint : aCountsByVendorAndProductDataPoint({}, relationshipsToOmit)],
        signalTagOptions: overrides && overrides.hasOwnProperty('signalTagOptions') ? overrides.signalTagOptions! : [relationshipsToOmit.has('SignalTagOption') ? {} as SignalTagOption : aSignalTagOption({}, relationshipsToOmit), relationshipsToOmit.has('SignalTagOption') ? {} as SignalTagOption : aSignalTagOption({}, relationshipsToOmit), relationshipsToOmit.has('SignalTagOption') ? {} as SignalTagOption : aSignalTagOption({}, relationshipsToOmit)],
        signals: overrides && overrides.hasOwnProperty('signals') ? overrides.signals! : relationshipsToOmit.has('SignalPage') ? {} as SignalPage : aSignalPage({}, relationshipsToOmit),
        ssoEnabled: overrides && overrides.hasOwnProperty('ssoEnabled') ? overrides.ssoEnabled! : true,
        ssoSettings: overrides && overrides.hasOwnProperty('ssoSettings') ? overrides.ssoSettings! : relationshipsToOmit.has('SsoSettings') ? {} as SsoSettings : aSsoSettings({}, relationshipsToOmit),
        streamingExportConfiguration: overrides && overrides.hasOwnProperty('streamingExportConfiguration') ? overrides.streamingExportConfiguration! : relationshipsToOmit.has('StreamingExportConfiguration') ? {} as StreamingExportConfiguration : aStreamingExportConfiguration({}, relationshipsToOmit),
        streamingExportConfigurations: overrides && overrides.hasOwnProperty('streamingExportConfigurations') ? overrides.streamingExportConfigurations! : relationshipsToOmit.has('StreamingExportConfigurationPage') ? {} as StreamingExportConfigurationPage : aStreamingExportConfigurationPage({}, relationshipsToOmit),
        sumoLogicAccessId: overrides && overrides.hasOwnProperty('sumoLogicAccessId') ? overrides.sumoLogicAccessId! : 'itaque',
        sumoLogicBaseUrl: overrides && overrides.hasOwnProperty('sumoLogicBaseUrl') ? overrides.sumoLogicBaseUrl! : 'amplus',
        sumoLogicCustomerId: overrides && overrides.hasOwnProperty('sumoLogicCustomerId') ? overrides.sumoLogicCustomerId! : 'curto',
        sumoLogicRegion: overrides && overrides.hasOwnProperty('sumoLogicRegion') ? overrides.sumoLogicRegion! : 'expedita',
        sumoMapping: overrides && overrides.hasOwnProperty('sumoMapping') ? overrides.sumoMapping! : relationshipsToOmit.has('SumoMapping') ? {} as SumoMapping : aSumoMapping({}, relationshipsToOmit),
        sumoMappings: overrides && overrides.hasOwnProperty('sumoMappings') ? overrides.sumoMappings! : relationshipsToOmit.has('SumoMappingPage') ? {} as SumoMappingPage : aSumoMappingPage({}, relationshipsToOmit),
        sumoRawMessageLookupJobResult: overrides && overrides.hasOwnProperty('sumoRawMessageLookupJobResult') ? overrides.sumoRawMessageLookupJobResult! : 'dolorum',
        sumoRecordSearchJobObjectTypeCounts: overrides && overrides.hasOwnProperty('sumoRecordSearchJobObjectTypeCounts') ? overrides.sumoRecordSearchJobObjectTypeCounts! : [relationshipsToOmit.has('SumoSearchObjectTypeCount') ? {} as SumoSearchObjectTypeCount : aSumoSearchObjectTypeCount({}, relationshipsToOmit), relationshipsToOmit.has('SumoSearchObjectTypeCount') ? {} as SumoSearchObjectTypeCount : aSumoSearchObjectTypeCount({}, relationshipsToOmit), relationshipsToOmit.has('SumoSearchObjectTypeCount') ? {} as SumoSearchObjectTypeCount : aSumoSearchObjectTypeCount({}, relationshipsToOmit)],
        sumoRecordSearchJobResults: overrides && overrides.hasOwnProperty('sumoRecordSearchJobResults') ? overrides.sumoRecordSearchJobResults! : ['terreo', 'careo', 'cui'],
        sumoRecordSearchJobStatus: overrides && overrides.hasOwnProperty('sumoRecordSearchJobStatus') ? overrides.sumoRecordSearchJobStatus! : relationshipsToOmit.has('SumoSearchJobStatus') ? {} as SumoSearchJobStatus : aSumoSearchJobStatus({}, relationshipsToOmit),
        sumoRecordSearchQuery: overrides && overrides.hasOwnProperty('sumoRecordSearchQuery') ? overrides.sumoRecordSearchQuery! : 'compono',
        sumoSsoEnabled: overrides && overrides.hasOwnProperty('sumoSsoEnabled') ? overrides.sumoSsoEnabled! : true,
        sumoUsers: overrides && overrides.hasOwnProperty('sumoUsers') ? overrides.sumoUsers! : relationshipsToOmit.has('SumoUsersPage') ? {} as SumoUsersPage : aSumoUsersPage({}, relationshipsToOmit),
        suppressList: overrides && overrides.hasOwnProperty('suppressList') ? overrides.suppressList! : relationshipsToOmit.has('SuppressList') ? {} as SuppressList : aSuppressList({}, relationshipsToOmit),
        suppressListItem: overrides && overrides.hasOwnProperty('suppressListItem') ? overrides.suppressListItem! : relationshipsToOmit.has('SuppressListItem') ? {} as SuppressListItem : aSuppressListItem({}, relationshipsToOmit),
        suppressListItemCount: overrides && overrides.hasOwnProperty('suppressListItemCount') ? overrides.suppressListItemCount! : 5239,
        suppressListItemLimit: overrides && overrides.hasOwnProperty('suppressListItemLimit') ? overrides.suppressListItemLimit! : 5159,
        suppressListItems: overrides && overrides.hasOwnProperty('suppressListItems') ? overrides.suppressListItems! : relationshipsToOmit.has('SuppressListItemPage') ? {} as SuppressListItemPage : aSuppressListItemPage({}, relationshipsToOmit),
        suppressLists: overrides && overrides.hasOwnProperty('suppressLists') ? overrides.suppressLists! : relationshipsToOmit.has('SuppressListPage') ? {} as SuppressListPage : aSuppressListPage({}, relationshipsToOmit),
        tactics: overrides && overrides.hasOwnProperty('tactics') ? overrides.tactics! : relationshipsToOmit.has('MitreTacticCoverageView') ? {} as MitreTacticCoverageView : aMitreTacticCoverageView({}, relationshipsToOmit),
        tacticsAndTechniquesFilter: overrides && overrides.hasOwnProperty('tacticsAndTechniquesFilter') ? overrides.tacticsAndTechniquesFilter! : relationshipsToOmit.has('MitreTacticTechniqueFilter') ? {} as MitreTacticTechniqueFilter : aMitreTacticTechniqueFilter({}, relationshipsToOmit),
        tagSchema: overrides && overrides.hasOwnProperty('tagSchema') ? overrides.tagSchema! : relationshipsToOmit.has('TagSchema') ? {} as TagSchema : aTagSchema({}, relationshipsToOmit),
        tagSchemas: overrides && overrides.hasOwnProperty('tagSchemas') ? overrides.tagSchemas! : [relationshipsToOmit.has('TagSchema') ? {} as TagSchema : aTagSchema({}, relationshipsToOmit), relationshipsToOmit.has('TagSchema') ? {} as TagSchema : aTagSchema({}, relationshipsToOmit), relationshipsToOmit.has('TagSchema') ? {} as TagSchema : aTagSchema({}, relationshipsToOmit)],
        teams: overrides && overrides.hasOwnProperty('teams') ? overrides.teams! : relationshipsToOmit.has('TeamPage') ? {} as TeamPage : aTeamPage({}, relationshipsToOmit),
        technique: overrides && overrides.hasOwnProperty('technique') ? overrides.technique! : relationshipsToOmit.has('MitreTechnique') ? {} as MitreTechnique : aMitreTechnique({}, relationshipsToOmit),
        templatedMatchRuleValidationResult: overrides && overrides.hasOwnProperty('templatedMatchRuleValidationResult') ? overrides.templatedMatchRuleValidationResult! : relationshipsToOmit.has('RuleValidationResult') ? {} as RuleValidationResult : aRuleValidationResult({}, relationshipsToOmit),
        threatIntelItem: overrides && overrides.hasOwnProperty('threatIntelItem') ? overrides.threatIntelItem! : relationshipsToOmit.has('ThreatIntelItem') ? {} as ThreatIntelItem : aThreatIntelItem({}, relationshipsToOmit),
        threatIntelItemCount: overrides && overrides.hasOwnProperty('threatIntelItemCount') ? overrides.threatIntelItemCount! : 423,
        threatIntelItemLimit: overrides && overrides.hasOwnProperty('threatIntelItemLimit') ? overrides.threatIntelItemLimit! : 3681,
        threatIntelItems: overrides && overrides.hasOwnProperty('threatIntelItems') ? overrides.threatIntelItems! : relationshipsToOmit.has('ThreatIntelItemPage') ? {} as ThreatIntelItemPage : aThreatIntelItemPage({}, relationshipsToOmit),
        threatIntelItems2: overrides && overrides.hasOwnProperty('threatIntelItems2') ? overrides.threatIntelItems2! : relationshipsToOmit.has('ThreatIntelItemPage') ? {} as ThreatIntelItemPage : aThreatIntelItemPage({}, relationshipsToOmit),
        threatIntelSource: overrides && overrides.hasOwnProperty('threatIntelSource') ? overrides.threatIntelSource! : relationshipsToOmit.has('ThreatIntelSource') ? {} as ThreatIntelSource : aThreatIntelSource({}, relationshipsToOmit),
        threatIntelSources: overrides && overrides.hasOwnProperty('threatIntelSources') ? overrides.threatIntelSources! : relationshipsToOmit.has('ThreatIntelSourcePage') ? {} as ThreatIntelSourcePage : aThreatIntelSourcePage({}, relationshipsToOmit),
        thresholdRuleValidationResult: overrides && overrides.hasOwnProperty('thresholdRuleValidationResult') ? overrides.thresholdRuleValidationResult! : relationshipsToOmit.has('RuleValidationResult') ? {} as RuleValidationResult : aRuleValidationResult({}, relationshipsToOmit),
        tiers: overrides && overrides.hasOwnProperty('tiers') ? overrides.tiers! : relationshipsToOmit.has('TiersPage') ? {} as TiersPage : aTiersPage({}, relationshipsToOmit),
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        userInvitations: overrides && overrides.hasOwnProperty('userInvitations') ? overrides.userInvitations! : relationshipsToOmit.has('UserInvitationPage') ? {} as UserInvitationPage : aUserInvitationPage({}, relationshipsToOmit),
        userPreferences: overrides && overrides.hasOwnProperty('userPreferences') ? overrides.userPreferences! : relationshipsToOmit.has('UserPreferences') ? {} as UserPreferences : aUserPreferences({}, relationshipsToOmit),
        userPrivileges: overrides && overrides.hasOwnProperty('userPrivileges') ? overrides.userPrivileges! : [relationshipsToOmit.has('Privilege') ? {} as Privilege : aPrivilege({}, relationshipsToOmit), relationshipsToOmit.has('Privilege') ? {} as Privilege : aPrivilege({}, relationshipsToOmit), relationshipsToOmit.has('Privilege') ? {} as Privilege : aPrivilege({}, relationshipsToOmit)],
        usernameForPasswordReset: overrides && overrides.hasOwnProperty('usernameForPasswordReset') ? overrides.usernameForPasswordReset! : 'tollo',
        users: overrides && overrides.hasOwnProperty('users') ? overrides.users! : relationshipsToOmit.has('UserPage') ? {} as UserPage : aUserPage({}, relationshipsToOmit),
        validateYaraExpression: overrides && overrides.hasOwnProperty('validateYaraExpression') ? overrides.validateYaraExpression! : YaraExpressionValidationError.IncludesNotAllowed,
        vendorProductsFilter: overrides && overrides.hasOwnProperty('vendorProductsFilter') ? overrides.vendorProductsFilter! : relationshipsToOmit.has('VendorProductFilter') ? {} as VendorProductFilter : aVendorProductFilter({}, relationshipsToOmit),
        version: overrides && overrides.hasOwnProperty('version') ? overrides.version! : 'vesper',
        virusTotalConfig: overrides && overrides.hasOwnProperty('virusTotalConfig') ? overrides.virusTotalConfig! : relationshipsToOmit.has('VirusTotalConfig') ? {} as VirusTotalConfig : aVirusTotalConfig({}, relationshipsToOmit),
        yaraRule: overrides && overrides.hasOwnProperty('yaraRule') ? overrides.yaraRule! : relationshipsToOmit.has('YaraRule') ? {} as YaraRule : aYaraRule({}, relationshipsToOmit),
        yaraRules: overrides && overrides.hasOwnProperty('yaraRules') ? overrides.yaraRules! : relationshipsToOmit.has('YaraRulePage') ? {} as YaraRulePage : aYaraRulePage({}, relationshipsToOmit),
        yaraSource: overrides && overrides.hasOwnProperty('yaraSource') ? overrides.yaraSource! : relationshipsToOmit.has('YaraSource') ? {} as YaraSource : aYaraSource({}, relationshipsToOmit),
        yaraSources: overrides && overrides.hasOwnProperty('yaraSources') ? overrides.yaraSources! : relationshipsToOmit.has('YaraSourcePage') ? {} as YaraSourcePage : aYaraSourcePage({}, relationshipsToOmit),
    };
};

export const aRecentItem = (overrides?: Partial<RecentItem>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RecentItem' } & RecentItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RecentItem');
    return {
        __typename: 'RecentItem',
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'blanditiis',
        accessTime: overrides && overrides.hasOwnProperty('accessTime') ? overrides.accessTime! : 'beneficium',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'contego',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 952911342535802,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 3522,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'curo',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 'sufficio',
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'crur',
        pageType: overrides && overrides.hasOwnProperty('pageType') ? overrides.pageType! : RecentPageType.Dashboard,
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 587542235623572,
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 8377,
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'labore',
    };
};

export const aRecentItemsByType = (overrides?: Partial<RecentItemsByType>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RecentItemsByType' } & RecentItemsByType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RecentItemsByType');
    return {
        __typename: 'RecentItemsByType',
        dashboards: overrides && overrides.hasOwnProperty('dashboards') ? overrides.dashboards! : [relationshipsToOmit.has('DashboardRecentItem') ? {} as DashboardRecentItem : aDashboardRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('DashboardRecentItem') ? {} as DashboardRecentItem : aDashboardRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('DashboardRecentItem') ? {} as DashboardRecentItem : aDashboardRecentItem({}, relationshipsToOmit)],
        livetails: overrides && overrides.hasOwnProperty('livetails') ? overrides.livetails! : [relationshipsToOmit.has('LivetailRecentItem') ? {} as LivetailRecentItem : aLivetailRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('LivetailRecentItem') ? {} as LivetailRecentItem : aLivetailRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('LivetailRecentItem') ? {} as LivetailRecentItem : aLivetailRecentItem({}, relationshipsToOmit)],
        logs: overrides && overrides.hasOwnProperty('logs') ? overrides.logs! : [relationshipsToOmit.has('LogRecentItem') ? {} as LogRecentItem : aLogRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('LogRecentItem') ? {} as LogRecentItem : aLogRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('LogRecentItem') ? {} as LogRecentItem : aLogRecentItem({}, relationshipsToOmit)],
        metrics: overrides && overrides.hasOwnProperty('metrics') ? overrides.metrics! : [relationshipsToOmit.has('MetricRecentItem') ? {} as MetricRecentItem : aMetricRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('MetricRecentItem') ? {} as MetricRecentItem : aMetricRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('MetricRecentItem') ? {} as MetricRecentItem : aMetricRecentItem({}, relationshipsToOmit)],
        spans: overrides && overrides.hasOwnProperty('spans') ? overrides.spans! : [relationshipsToOmit.has('SpanRecentItem') ? {} as SpanRecentItem : aSpanRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('SpanRecentItem') ? {} as SpanRecentItem : aSpanRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('SpanRecentItem') ? {} as SpanRecentItem : aSpanRecentItem({}, relationshipsToOmit)],
        standardPages: overrides && overrides.hasOwnProperty('standardPages') ? overrides.standardPages! : [relationshipsToOmit.has('StandardPageRecentItem') ? {} as StandardPageRecentItem : aStandardPageRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('StandardPageRecentItem') ? {} as StandardPageRecentItem : aStandardPageRecentItem({}, relationshipsToOmit), relationshipsToOmit.has('StandardPageRecentItem') ? {} as StandardPageRecentItem : aStandardPageRecentItem({}, relationshipsToOmit)],
    };
};

export const aRecordArtifactConfig = (overrides?: Partial<RecordArtifactConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RecordArtifactConfig' } & RecordArtifactConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RecordArtifactConfig');
    return {
        __typename: 'RecordArtifactConfig',
        fieldPath: overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'peior',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '486aef18-a664-4871-95e9-412f1ca10529',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'suppono',
        recordType: overrides && overrides.hasOwnProperty('recordType') ? overrides.recordType! : 'adopto',
    };
};

export const aRecordArtifactConfigEditableFields = (overrides?: Partial<RecordArtifactConfigEditableFields>, _relationshipsToOmit: Set<string> = new Set()): RecordArtifactConfigEditableFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RecordArtifactConfigEditableFields');
    return {
        fieldPath: overrides && overrides.hasOwnProperty('fieldPath') ? overrides.fieldPath! : 'conicio',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'suspendo',
        recordType: overrides && overrides.hasOwnProperty('recordType') ? overrides.recordType! : 'eos',
    };
};

export const aRecordArtifactConfigPage = (overrides?: Partial<RecordArtifactConfigPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RecordArtifactConfigPage' } & RecordArtifactConfigPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RecordArtifactConfigPage');
    return {
        __typename: 'RecordArtifactConfigPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('RecordArtifactConfig') ? {} as RecordArtifactConfig : aRecordArtifactConfig({}, relationshipsToOmit), relationshipsToOmit.has('RecordArtifactConfig') ? {} as RecordArtifactConfig : aRecordArtifactConfig({}, relationshipsToOmit), relationshipsToOmit.has('RecordArtifactConfig') ? {} as RecordArtifactConfig : aRecordArtifactConfig({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 7245,
    };
};

export const aRecordCountByParsed = (overrides?: Partial<RecordCountByParsed>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RecordCountByParsed' } & RecordCountByParsed => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RecordCountByParsed');
    return {
        __typename: 'RecordCountByParsed',
        parsed: overrides && overrides.hasOwnProperty('parsed') ? overrides.parsed! : 170420567270280,
        unparsed: overrides && overrides.hasOwnProperty('unparsed') ? overrides.unparsed! : 495465247993421,
    };
};

export const aRecordCountsByParsedDataPoint = (overrides?: Partial<RecordCountsByParsedDataPoint>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RecordCountsByParsedDataPoint' } & RecordCountsByParsedDataPoint => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RecordCountsByParsedDataPoint');
    return {
        __typename: 'RecordCountsByParsedDataPoint',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-03-11T10:30:26.836Z",
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : relationshipsToOmit.has('RecordCountByParsed') ? {} as RecordCountByParsed : aRecordCountByParsed({}, relationshipsToOmit),
    };
};

export const aRecordSummaryField = (overrides?: Partial<RecordSummaryField>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RecordSummaryField' } & RecordSummaryField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RecordSummaryField');
    return {
        __typename: 'RecordSummaryField',
        fieldName: overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'thermae',
        fieldValue: overrides && overrides.hasOwnProperty('fieldValue') ? overrides.fieldValue! : 'tergiversatio',
        recordCount: overrides && overrides.hasOwnProperty('recordCount') ? overrides.recordCount! : 232,
    };
};

export const aRelatedEntity = (overrides?: Partial<RelatedEntity>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RelatedEntity' } & RelatedEntity => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RelatedEntity');
    return {
        __typename: 'RelatedEntity',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'cc530d97-ed13-4066-b522-d9c5f2d03a77',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'theatrum',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'trepide',
    };
};

export const aRelatedIncident = (overrides?: Partial<RelatedIncident>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RelatedIncident' } & RelatedIncident => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RelatedIncident');
    return {
        __typename: 'RelatedIncident',
        assignee: overrides && overrides.hasOwnProperty('assignee') ? overrides.assignee! : 'deficio',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 6504,
        link: overrides && overrides.hasOwnProperty('link') ? overrides.link! : 'volaticus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cruciamentum',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : 'vado',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'vere',
    };
};

export const aRelatedIncidentFields = (overrides?: Partial<RelatedIncidentFields>, _relationshipsToOmit: Set<string> = new Set()): RelatedIncidentFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RelatedIncidentFields');
    return {
        assignee: overrides && overrides.hasOwnProperty('assignee') ? overrides.assignee! : 'balbus',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 8251,
        link: overrides && overrides.hasOwnProperty('link') ? overrides.link! : 'aestas',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'talis',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : 'at',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'apparatus',
    };
};

export const aRemoveEntityTags = (overrides?: Partial<RemoveEntityTags>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RemoveEntityTags' } & RemoveEntityTags => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RemoveEntityTags');
    return {
        __typename: 'RemoveEntityTags',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit),
    };
};

export const aRemoveInsightRelatedIncident = (overrides?: Partial<RemoveInsightRelatedIncident>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RemoveInsightRelatedIncident' } & RemoveInsightRelatedIncident => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RemoveInsightRelatedIncident');
    return {
        __typename: 'RemoveInsightRelatedIncident',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit),
    };
};

export const aRemoveSignalsFromInsight = (overrides?: Partial<RemoveSignalsFromInsight>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RemoveSignalsFromInsight' } & RemoveSignalsFromInsight => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RemoveSignalsFromInsight');
    return {
        __typename: 'RemoveSignalsFromInsight',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit),
    };
};

export const aRemoveTagFromInsight = (overrides?: Partial<RemoveTagFromInsight>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RemoveTagFromInsight' } & RemoveTagFromInsight => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RemoveTagFromInsight');
    return {
        __typename: 'RemoveTagFromInsight',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit),
    };
};

export const aRemoveTagFromInsightsById = (overrides?: Partial<RemoveTagFromInsightsById>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RemoveTagFromInsightsById' } & RemoveTagFromInsightsById => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RemoveTagFromInsightsById');
    return {
        __typename: 'RemoveTagFromInsightsById',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const aReorderInsightStatuses = (overrides?: Partial<ReorderInsightStatuses>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ReorderInsightStatuses' } & ReorderInsightStatuses => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ReorderInsightStatuses');
    return {
        __typename: 'ReorderInsightStatuses',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const aResendCurrentUserConfirmationEmail = (overrides?: Partial<ResendCurrentUserConfirmationEmail>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ResendCurrentUserConfirmationEmail' } & ResendCurrentUserConfirmationEmail => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ResendCurrentUserConfirmationEmail');
    return {
        __typename: 'ResendCurrentUserConfirmationEmail',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aResendUserConfirmationEmail = (overrides?: Partial<ResendUserConfirmationEmail>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ResendUserConfirmationEmail' } & ResendUserConfirmationEmail => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ResendUserConfirmationEmail');
    return {
        __typename: 'ResendUserConfirmationEmail',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const aResetCurrentUserApiKey = (overrides?: Partial<ResetCurrentUserApiKey>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ResetCurrentUserApiKey' } & ResetCurrentUserApiKey => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ResetCurrentUserApiKey');
    return {
        __typename: 'ResetCurrentUserApiKey',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('CurrentUser') ? {} as CurrentUser : aCurrentUser({}, relationshipsToOmit),
    };
};

export const aResetCurrentUserMfaSecret = (overrides?: Partial<ResetCurrentUserMfaSecret>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ResetCurrentUserMfaSecret' } & ResetCurrentUserMfaSecret => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ResetCurrentUserMfaSecret');
    return {
        __typename: 'ResetCurrentUserMfaSecret',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('CurrentUser') ? {} as CurrentUser : aCurrentUser({}, relationshipsToOmit),
    };
};

export const aResetPassword = (overrides?: Partial<ResetPassword>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ResetPassword' } & ResetPassword => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ResetPassword');
    return {
        __typename: 'ResetPassword',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const aResetUserApiKey = (overrides?: Partial<ResetUserApiKey>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ResetUserApiKey' } & ResetUserApiKey => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ResetUserApiKey');
    return {
        __typename: 'ResetUserApiKey',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
    };
};

export const aResetUserMfaSecret = (overrides?: Partial<ResetUserMfaSecret>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ResetUserMfaSecret' } & ResetUserMfaSecret => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ResetUserMfaSecret');
    return {
        __typename: 'ResetUserMfaSecret',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
    };
};

export const aRole = (overrides?: Partial<Role>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Role' } & Role => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Role');
    return {
        __typename: 'Role',
        assignedTo: overrides && overrides.hasOwnProperty('assignedTo') ? overrides.assignedTo! : [relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit), relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit), relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit)],
        deleted: overrides && overrides.hasOwnProperty('deleted') ? overrides.deleted! : true,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '41582826-57fb-40a9-8ede-fba3ce32a8ac',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'taedium',
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : [relationshipsToOmit.has('Permission') ? {} as Permission : aPermission({}, relationshipsToOmit), relationshipsToOmit.has('Permission') ? {} as Permission : aPermission({}, relationshipsToOmit), relationshipsToOmit.has('Permission') ? {} as Permission : aPermission({}, relationshipsToOmit)],
    };
};

export const aRolePage = (overrides?: Partial<RolePage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RolePage' } & RolePage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RolePage');
    return {
        __typename: 'RolePage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('Role') ? {} as Role : aRole({}, relationshipsToOmit), relationshipsToOmit.has('Role') ? {} as Role : aRole({}, relationshipsToOmit), relationshipsToOmit.has('Role') ? {} as Role : aRole({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 173,
    };
};

export const aRuleHistoryEvent = (overrides?: Partial<RuleHistoryEvent>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RuleHistoryEvent' } & RuleHistoryEvent => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RuleHistoryEvent');
    return {
        __typename: 'RuleHistoryEvent',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'nemo',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-03-26T02:11:43.542Z",
        user: overrides && overrides.hasOwnProperty('user') ? overrides.user! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
    };
};

export const aRuleInterface = (overrides?: Partial<RuleInterface>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RuleInterface' } & RuleInterface => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RuleInterface');
    return {
        __typename: 'RuleInterface',
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'avarus',
        autoDisabledReason: overrides && overrides.hasOwnProperty('autoDisabledReason') ? overrides.autoDisabledReason! : 'aestivus',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'curvo',
        contentType: overrides && overrides.hasOwnProperty('contentType') ? overrides.contentType! : ContentType.Anomaly,
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-08-24T00:00:49.146Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'quod',
        createdByUser: overrides && overrides.hasOwnProperty('createdByUser') ? overrides.createdByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        deleted: overrides && overrides.hasOwnProperty('deleted') ? overrides.deleted! : true,
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit)],
        entitySelectorsOverride: overrides && overrides.hasOwnProperty('entitySelectorsOverride') ? overrides.entitySelectorsOverride! : relationshipsToOmit.has('EntitySelectorsRuleOverride') ? {} as EntitySelectorsRuleOverride : anEntitySelectorsRuleOverride({}, relationshipsToOmit),
        exportJson: overrides && overrides.hasOwnProperty('exportJson') ? overrides.exportJson! : 'quis',
        failing: overrides && overrides.hasOwnProperty('failing') ? overrides.failing! : true,
        hasOverride: overrides && overrides.hasOwnProperty('hasOverride') ? overrides.hasOverride! : false,
        history: overrides && overrides.hasOwnProperty('history') ? overrides.history! : [relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit)],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '807f2620-dd66-4a54-9b6c-eef9cc5c9bef',
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        isPrototypeOverride: overrides && overrides.hasOwnProperty('isPrototypeOverride') ? overrides.isPrototypeOverride! : relationshipsToOmit.has('BooleanRuleOverride') ? {} as BooleanRuleOverride : aBooleanRuleOverride({}, relationshipsToOmit),
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-04-03T12:30:04.418Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'centum',
        lastUpdatedByUser: overrides && overrides.hasOwnProperty('lastUpdatedByUser') ? overrides.lastUpdatedByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'timidus',
        nameOverride: overrides && overrides.hasOwnProperty('nameOverride') ? overrides.nameOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : '9aa6406c-462c-41db-b929-7899eba662e6',
        rawJson: overrides && overrides.hasOwnProperty('rawJson') ? overrides.rawJson! : 'spiritus',
        rawStatus: overrides && overrides.hasOwnProperty('rawStatus') ? overrides.rawStatus! : relationshipsToOmit.has('RuleStatus') ? {} as RuleStatus : aRuleStatus({}, relationshipsToOmit),
        ruleDescription: overrides && overrides.hasOwnProperty('ruleDescription') ? overrides.ruleDescription! : 'conor',
        ruleId: overrides && overrides.hasOwnProperty('ruleId') ? overrides.ruleId! : 4197,
        ruleSource: overrides && overrides.hasOwnProperty('ruleSource') ? overrides.ruleSource! : 'magnam',
        ruleType: overrides && overrides.hasOwnProperty('ruleType') ? overrides.ruleType! : 'claustrum',
        signalCount07d: overrides && overrides.hasOwnProperty('signalCount07d') ? overrides.signalCount07d! : 9007,
        signalCount24h: overrides && overrides.hasOwnProperty('signalCount24h') ? overrides.signalCount24h! : 5419,
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : relationshipsToOmit.has('RuleStatus') ? {} as RuleStatus : aRuleStatus({}, relationshipsToOmit),
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'umerus',
        summaryExpressionOverride: overrides && overrides.hasOwnProperty('summaryExpressionOverride') ? overrides.summaryExpressionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 3369,
        suppressionWindowSizeOverride: overrides && overrides.hasOwnProperty('suppressionWindowSizeOverride') ? overrides.suppressionWindowSizeOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['carcer', 'aut', 'ventosus'],
        tagsOverride: overrides && overrides.hasOwnProperty('tagsOverride') ? overrides.tagsOverride! : relationshipsToOmit.has('StringListRuleOverride') ? {} as StringListRuleOverride : aStringListRuleOverride({}, relationshipsToOmit),
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['certus', 'vinitor', 'aduro'],
        tuningExpressions: overrides && overrides.hasOwnProperty('tuningExpressions') ? overrides.tuningExpressions! : [relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit)],
    };
};

export const aRulePage = (overrides?: Partial<RulePage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RulePage' } & RulePage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RulePage');
    return {
        __typename: 'RulePage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('AggregationRule') ? {} as AggregationRule : anAggregationRule({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRule') ? {} as AggregationRule : anAggregationRule({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRule') ? {} as AggregationRule : anAggregationRule({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 4060,
    };
};

export const aRuleScoreMapping = (overrides?: Partial<RuleScoreMapping>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RuleScoreMapping' } & RuleScoreMapping => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RuleScoreMapping');
    return {
        __typename: 'RuleScoreMapping',
        default: overrides && overrides.hasOwnProperty('default') ? overrides.default! : 1520,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : 'usque',
        mapping: overrides && overrides.hasOwnProperty('mapping') ? overrides.mapping! : [relationshipsToOmit.has('RuleScoreMappingItem') ? {} as RuleScoreMappingItem : aRuleScoreMappingItem({}, relationshipsToOmit), relationshipsToOmit.has('RuleScoreMappingItem') ? {} as RuleScoreMappingItem : aRuleScoreMappingItem({}, relationshipsToOmit), relationshipsToOmit.has('RuleScoreMappingItem') ? {} as RuleScoreMappingItem : aRuleScoreMappingItem({}, relationshipsToOmit)],
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'tredecim',
    };
};

export const aRuleScoreMappingFields = (overrides?: Partial<RuleScoreMappingFields>, _relationshipsToOmit: Set<string> = new Set()): RuleScoreMappingFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RuleScoreMappingFields');
    return {
        default: overrides && overrides.hasOwnProperty('default') ? overrides.default! : 9735,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : 'aegrotatio',
        mapping: overrides && overrides.hasOwnProperty('mapping') ? overrides.mapping! : [relationshipsToOmit.has('RuleScoreMappingItemFields') ? {} as RuleScoreMappingItemFields : aRuleScoreMappingItemFields({}, relationshipsToOmit), relationshipsToOmit.has('RuleScoreMappingItemFields') ? {} as RuleScoreMappingItemFields : aRuleScoreMappingItemFields({}, relationshipsToOmit), relationshipsToOmit.has('RuleScoreMappingItemFields') ? {} as RuleScoreMappingItemFields : aRuleScoreMappingItemFields({}, relationshipsToOmit)],
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'appositus',
    };
};

export const aRuleScoreMappingItem = (overrides?: Partial<RuleScoreMappingItem>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RuleScoreMappingItem' } & RuleScoreMappingItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RuleScoreMappingItem');
    return {
        __typename: 'RuleScoreMappingItem',
        from: overrides && overrides.hasOwnProperty('from') ? overrides.from! : 'accusamus',
        fromEnd: overrides && overrides.hasOwnProperty('fromEnd') ? overrides.fromEnd! : 'valetudo',
        to: overrides && overrides.hasOwnProperty('to') ? overrides.to! : 5787,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'appello',
    };
};

export const aRuleScoreMappingItemFields = (overrides?: Partial<RuleScoreMappingItemFields>, _relationshipsToOmit: Set<string> = new Set()): RuleScoreMappingItemFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RuleScoreMappingItemFields');
    return {
        from: overrides && overrides.hasOwnProperty('from') ? overrides.from! : 'atqui',
        fromEnd: overrides && overrides.hasOwnProperty('fromEnd') ? overrides.fromEnd! : 'arcesso',
        to: overrides && overrides.hasOwnProperty('to') ? overrides.to! : 8689,
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'denuncio',
    };
};

export const aRuleScoreMappingRuleOverride = (overrides?: Partial<RuleScoreMappingRuleOverride>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RuleScoreMappingRuleOverride' } & RuleScoreMappingRuleOverride => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RuleScoreMappingRuleOverride');
    return {
        __typename: 'RuleScoreMappingRuleOverride',
        original: overrides && overrides.hasOwnProperty('original') ? overrides.original! : relationshipsToOmit.has('RuleScoreMapping') ? {} as RuleScoreMapping : aRuleScoreMapping({}, relationshipsToOmit),
        override: overrides && overrides.hasOwnProperty('override') ? overrides.override! : relationshipsToOmit.has('RuleScoreMapping') ? {} as RuleScoreMapping : aRuleScoreMapping({}, relationshipsToOmit),
    };
};

export const aRuleSort = (overrides?: Partial<RuleSort>, _relationshipsToOmit: Set<string> = new Set()): RuleSort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RuleSort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : RuleSortableField.Created,
    };
};

export const aRuleStatus = (overrides?: Partial<RuleStatus>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RuleStatus' } & RuleStatus => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RuleStatus');
    return {
        __typename: 'RuleStatus',
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'animus',
        expressionErrorEndIndex: overrides && overrides.hasOwnProperty('expressionErrorEndIndex') ? overrides.expressionErrorEndIndex! : 5842,
        expressionErrorStartIndex: overrides && overrides.hasOwnProperty('expressionErrorStartIndex') ? overrides.expressionErrorStartIndex! : 9413,
        message: overrides && overrides.hasOwnProperty('message') ? overrides.message! : 'adiuvo',
        stackTrace: overrides && overrides.hasOwnProperty('stackTrace') ? overrides.stackTrace! : 'aegre',
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : RuleStatusEnum.Active,
    };
};

export const aRuleTagOption = (overrides?: Partial<RuleTagOption>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RuleTagOption' } & RuleTagOption => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RuleTagOption');
    return {
        __typename: 'RuleTagOption',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'congregatio',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'spectaculum',
    };
};

export const aRuleTuningExpression = (overrides?: Partial<RuleTuningExpression>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RuleTuningExpression' } & RuleTuningExpression => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RuleTuningExpression');
    return {
        __typename: 'RuleTuningExpression',
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-05-02T11:36:45.782Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'aestivus',
        createdByUser: overrides && overrides.hasOwnProperty('createdByUser') ? overrides.createdByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'conventus',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : true,
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'dolorum',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '18f2e9e6-53b4-41d2-8268-89534268c906',
        isGlobal: overrides && overrides.hasOwnProperty('isGlobal') ? overrides.isGlobal! : false,
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-11-11T06:11:24.471Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'derideo',
        lastUpdatedByUser: overrides && overrides.hasOwnProperty('lastUpdatedByUser') ? overrides.lastUpdatedByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'defessus',
        relatedRuleCount: overrides && overrides.hasOwnProperty('relatedRuleCount') ? overrides.relatedRuleCount! : 5025,
        ruleIds: overrides && overrides.hasOwnProperty('ruleIds') ? overrides.ruleIds! : ['aro', 'utrum', 'utrum'],
        rules: overrides && overrides.hasOwnProperty('rules') ? overrides.rules! : [relationshipsToOmit.has('AggregationRule') ? {} as AggregationRule : anAggregationRule({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRule') ? {} as AggregationRule : anAggregationRule({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRule') ? {} as AggregationRule : anAggregationRule({}, relationshipsToOmit)],
    };
};

export const aRuleTuningExpressionPage = (overrides?: Partial<RuleTuningExpressionPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RuleTuningExpressionPage' } & RuleTuningExpressionPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RuleTuningExpressionPage');
    return {
        __typename: 'RuleTuningExpressionPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 9032,
    };
};

export const aRuleTuningExpressionSort = (overrides?: Partial<RuleTuningExpressionSort>, _relationshipsToOmit: Set<string> = new Set()): RuleTuningExpressionSort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RuleTuningExpressionSort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : RuleTuningExpressionSortableField.Created,
    };
};

export const aRuleTuningExpressionTranslationFields = (overrides?: Partial<RuleTuningExpressionTranslationFields>, _relationshipsToOmit: Set<string> = new Set()): RuleTuningExpressionTranslationFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RuleTuningExpressionTranslationFields');
    return {
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : true,
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'ulciscor',
    };
};

export const aRuleValidationResult = (overrides?: Partial<RuleValidationResult>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'RuleValidationResult' } & RuleValidationResult => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('RuleValidationResult');
    return {
        __typename: 'RuleValidationResult',
        errorMessage: overrides && overrides.hasOwnProperty('errorMessage') ? overrides.errorMessage! : 'thesis',
        isValid: overrides && overrides.hasOwnProperty('isValid') ? overrides.isValid! : true,
    };
};

export const aSaveEntityEnrichment = (overrides?: Partial<SaveEntityEnrichment>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SaveEntityEnrichment' } & SaveEntityEnrichment => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SaveEntityEnrichment');
    return {
        __typename: 'SaveEntityEnrichment',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Enrichment') ? {} as Enrichment : anEnrichment({}, relationshipsToOmit),
    };
};

export const aSaveInsightEnrichment = (overrides?: Partial<SaveInsightEnrichment>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SaveInsightEnrichment' } & SaveInsightEnrichment => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SaveInsightEnrichment');
    return {
        __typename: 'SaveInsightEnrichment',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Enrichment') ? {} as Enrichment : anEnrichment({}, relationshipsToOmit),
    };
};

export const aSaveSignalEnrichment = (overrides?: Partial<SaveSignalEnrichment>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SaveSignalEnrichment' } & SaveSignalEnrichment => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SaveSignalEnrichment');
    return {
        __typename: 'SaveSignalEnrichment',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Enrichment') ? {} as Enrichment : anEnrichment({}, relationshipsToOmit),
    };
};

export const aSavedSearch = (overrides?: Partial<SavedSearch>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SavedSearch' } & SavedSearch => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SavedSearch');
    return {
        __typename: 'SavedSearch',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'verus',
        hash: overrides && overrides.hasOwnProperty('hash') ? overrides.hash! : 'suscipit',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 3256,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'aiunt',
        ownersId: overrides && overrides.hasOwnProperty('ownersId') ? overrides.ownersId! : 8398,
        parameters: overrides && overrides.hasOwnProperty('parameters') ? overrides.parameters! : [relationshipsToOmit.has('SearchQueryParameter') ? {} as SearchQueryParameter : aSearchQueryParameter({}, relationshipsToOmit), relationshipsToOmit.has('SearchQueryParameter') ? {} as SearchQueryParameter : aSearchQueryParameter({}, relationshipsToOmit), relationshipsToOmit.has('SearchQueryParameter') ? {} as SearchQueryParameter : aSearchQueryParameter({}, relationshipsToOmit)],
        query: overrides && overrides.hasOwnProperty('query') ? overrides.query! : relationshipsToOmit.has('SavedSearchQuery') ? {} as SavedSearchQuery : aSavedSearchQuery({}, relationshipsToOmit),
        shared: overrides && overrides.hasOwnProperty('shared') ? overrides.shared! : true,
    };
};

export const aSavedSearchQuery = (overrides?: Partial<SavedSearchQuery>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SavedSearchQuery' } & SavedSearchQuery => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SavedSearchQuery');
    return {
        __typename: 'SavedSearchQuery',
        endTimestamp: overrides && overrides.hasOwnProperty('endTimestamp') ? overrides.endTimestamp! : 'angelus',
        fromSavedSearch: overrides && overrides.hasOwnProperty('fromSavedSearch') ? overrides.fromSavedSearch! : false,
        nameOverride: overrides && overrides.hasOwnProperty('nameOverride') ? overrides.nameOverride! : 'abstergo',
        queryString: overrides && overrides.hasOwnProperty('queryString') ? overrides.queryString! : 'corrigo',
        savedSearchId: overrides && overrides.hasOwnProperty('savedSearchId') ? overrides.savedSearchId! : 790,
        startTimestamp: overrides && overrides.hasOwnProperty('startTimestamp') ? overrides.startTimestamp! : 'cerno',
        timeExecuted: overrides && overrides.hasOwnProperty('timeExecuted') ? overrides.timeExecuted! : 780802325890567,
        timeRange: overrides && overrides.hasOwnProperty('timeRange') ? overrides.timeRange! : 'desidero',
    };
};

export const aSearch = (overrides?: Partial<Search>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Search' } & Search => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Search');
    return {
        __typename: 'Search',
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'talus',
        actions: overrides && overrides.hasOwnProperty('actions') ? overrides.actions! : ['ancilla', 'modi', 'sulum'],
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 434831881846939,
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'inventore',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'corpus',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 667150307634304,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 539889085382508,
        isFavorite: overrides && overrides.hasOwnProperty('isFavorite') ? overrides.isFavorite! : false,
        modifiedAt: overrides && overrides.hasOwnProperty('modifiedAt') ? overrides.modifiedAt! : 632867128125534,
        modifiedBy: overrides && overrides.hasOwnProperty('modifiedBy') ? overrides.modifiedBy! : 'acer',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'civis',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 505569780387772,
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'votum',
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 839074062114433,
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : ['cum', 'curo', 'circumvenio'],
        relativePath: overrides && overrides.hasOwnProperty('relativePath') ? overrides.relativePath! : [relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit), relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit), relationshipsToOmit.has('PathElement') ? {} as PathElement : aPathElement({}, relationshipsToOmit)],
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 751157925724073,
        scheduled: overrides && overrides.hasOwnProperty('scheduled') ? overrides.scheduled! : false,
        scheduledKnown: overrides && overrides.hasOwnProperty('scheduledKnown') ? overrides.scheduledKnown! : true,
        sharedAt: overrides && overrides.hasOwnProperty('sharedAt') ? overrides.sharedAt! : 495380151487137,
        sharerId: overrides && overrides.hasOwnProperty('sharerId') ? overrides.sharerId! : 355955828975145,
        sharerName: overrides && overrides.hasOwnProperty('sharerName') ? overrides.sharerName! : 'canis',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'ago',
        useViewerRbac: overrides && overrides.hasOwnProperty('useViewerRbac') ? overrides.useViewerRbac! : false,
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'sopor',
    };
};

export const aSearchFieldSuggestion = (overrides?: Partial<SearchFieldSuggestion>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SearchFieldSuggestion' } & SearchFieldSuggestion => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SearchFieldSuggestion');
    return {
        __typename: 'SearchFieldSuggestion',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'autus',
    };
};

export const aSearchFieldSuggestionPage = (overrides?: Partial<SearchFieldSuggestionPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SearchFieldSuggestionPage' } & SearchFieldSuggestionPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SearchFieldSuggestionPage');
    return {
        __typename: 'SearchFieldSuggestionPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('SearchFieldSuggestion') ? {} as SearchFieldSuggestion : aSearchFieldSuggestion({}, relationshipsToOmit), relationshipsToOmit.has('SearchFieldSuggestion') ? {} as SearchFieldSuggestion : aSearchFieldSuggestion({}, relationshipsToOmit), relationshipsToOmit.has('SearchFieldSuggestion') ? {} as SearchFieldSuggestion : aSearchFieldSuggestion({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 9777,
    };
};

export const aSearchQueryParameter = (overrides?: Partial<SearchQueryParameter>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SearchQueryParameter' } & SearchQueryParameter => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SearchQueryParameter');
    return {
        __typename: 'SearchQueryParameter',
        autoComplete: overrides && overrides.hasOwnProperty('autoComplete') ? overrides.autoComplete! : relationshipsToOmit.has('ParameterAutoComplete') ? {} as ParameterAutoComplete : aParameterAutoComplete({}, relationshipsToOmit),
        dataType: overrides && overrides.hasOwnProperty('dataType') ? overrides.dataType! : 'impedit',
        desc: overrides && overrides.hasOwnProperty('desc') ? overrides.desc! : 'brevis',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'tondeo',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'blanditiis',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : relationshipsToOmit.has('ParameterLabelValue') ? {} as ParameterLabelValue : aParameterLabelValue({}, relationshipsToOmit),
    };
};

export const aSearchQueryParameterInput = (overrides?: Partial<SearchQueryParameterInput>, _relationshipsToOmit: Set<string> = new Set()): SearchQueryParameterInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SearchQueryParameterInput');
    return {
        autoComplete: overrides && overrides.hasOwnProperty('autoComplete') ? overrides.autoComplete! : relationshipsToOmit.has('ParameterAutoCompleteInput') ? {} as ParameterAutoCompleteInput : aParameterAutoCompleteInput({}, relationshipsToOmit),
        dataType: overrides && overrides.hasOwnProperty('dataType') ? overrides.dataType! : 'vergo',
        desc: overrides && overrides.hasOwnProperty('desc') ? overrides.desc! : 'tempore',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'victus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'adsum',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : relationshipsToOmit.has('ParameterLabelValueInput') ? {} as ParameterLabelValueInput : aParameterLabelValueInput({}, relationshipsToOmit),
    };
};

export const aSearchResult = (overrides?: Partial<SearchResult>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SearchResult' } & SearchResult => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SearchResult');
    return {
        __typename: 'SearchResult',
        matchedField: overrides && overrides.hasOwnProperty('matchedField') ? overrides.matchedField! : relationshipsToOmit.has('MatchedField') ? {} as MatchedField : aMatchedField({}, relationshipsToOmit),
        object: overrides && overrides.hasOwnProperty('object') ? overrides.object! : relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit),
    };
};

export const aSearchResultPage = (overrides?: Partial<SearchResultPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SearchResultPage' } & SearchResultPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SearchResultPage');
    return {
        __typename: 'SearchResultPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('SearchResult') ? {} as SearchResult : aSearchResult({}, relationshipsToOmit), relationshipsToOmit.has('SearchResult') ? {} as SearchResult : aSearchResult({}, relationshipsToOmit), relationshipsToOmit.has('SearchResult') ? {} as SearchResult : aSearchResult({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 235,
    };
};

export const aSearchResultSort = (overrides?: Partial<SearchResultSort>, _relationshipsToOmit: Set<string> = new Set()): SearchResultSort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SearchResultSort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : SearchResultSortableField.ActivityScore,
    };
};

export const aServiceAutoCompleteLookupMetaData = (overrides?: Partial<ServiceAutoCompleteLookupMetaData>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ServiceAutoCompleteLookupMetaData' } & ServiceAutoCompleteLookupMetaData => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ServiceAutoCompleteLookupMetaData');
    return {
        __typename: 'ServiceAutoCompleteLookupMetaData',
        fileName: overrides && overrides.hasOwnProperty('fileName') ? overrides.fileName! : 'uberrime',
        labelColumn: overrides && overrides.hasOwnProperty('labelColumn') ? overrides.labelColumn! : 'aureus',
        valueColumn: overrides && overrides.hasOwnProperty('valueColumn') ? overrides.valueColumn! : 'cavus',
    };
};

export const aServiceAutoCompleteLookupMetaDataInput = (overrides?: Partial<ServiceAutoCompleteLookupMetaDataInput>, _relationshipsToOmit: Set<string> = new Set()): ServiceAutoCompleteLookupMetaDataInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ServiceAutoCompleteLookupMetaDataInput');
    return {
        fileName: overrides && overrides.hasOwnProperty('fileName') ? overrides.fileName! : 'ulciscor',
        labelColumn: overrides && overrides.hasOwnProperty('labelColumn') ? overrides.labelColumn! : 'sint',
        valueColumn: overrides && overrides.hasOwnProperty('valueColumn') ? overrides.valueColumn! : 'ratione',
    };
};

export const aSignUp = (overrides?: Partial<SignUp>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SignUp' } & SignUp => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SignUp');
    return {
        __typename: 'SignUp',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('CurrentUser') ? {} as CurrentUser : aCurrentUser({}, relationshipsToOmit),
    };
};

export const aSignal = (overrides?: Partial<Signal>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Signal' } & Signal => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Signal');
    return {
        __typename: 'Signal',
        allRecordsJson: overrides && overrides.hasOwnProperty('allRecordsJson') ? overrides.allRecordsJson! : "[{\"fields\":{\"source_ip\":\"22.182.12.244\",\"origin_product\":\"Microsoft Azure\",\"dest_port\":\"443\",\"category\":\"AzureFirewallApplicationRule\",\"time\":\"2023-04-13T22:46:15.682Z\",\"operationName\":\"AzureFirewallApplicationRuleLog\",\"action\":\"Deny\",\"destination\":\"md-wbvnbjlhnxlg.z13.blob.storage.azure.net\",\"source_port\":\"46348\",\"protocol\":\"HTTPS\",\"properties.msg\":\"HTTPS request from 22.182.12.244:46348 to md-wbvnbjlhnxlg.z13.blob.storage.azure.net:443. Action: Deny. No rule matched. Proceeding with default action\",\"resourceId\":\"/SUBSCRIPTIONS/09D6CAF5-641C-42EF-8108-4FD414AA3ABF/RESOURCEGROUPS/RG-AKS-FW/PROVIDERS/MICROSOFT.NETWORK/AZUREFIREWALLS/AKS-AZFW-PROTECTION-FW\"},\"accountId\":null,\"action\":null,\"application\":null,\"cloud_provider\":null,\"cloud_region\":null,\"description\":\"AzureFirewallApplicationRuleLog\",\"dstPort\":443,\"email_sender\":null,\"fieldTags\":{},\"http_requestHeaders\":{},\"http_url\":\"md-wbvnbjlhnxlg.z13.blob.storage.azure.net\",\"http_url_conditionalFrequency\":1.5231821014504016e-12,\"http_url_entropyFqdn\":4.300072113709065,\"http_url_entropyRootDomain\":2.94770277922009,\"http_url_fqdn\":\"md-wbvnbjlhnxlg.z13.blob.storage.azure.net\",\"http_url_possibleDynDns\":false,\"http_url_rootDomain\":\"azure.net\",\"http_url_tld\":\"net\",\"http_userAgent\":null,\"listMatches\":[],\"matchedItems\":[],\"metadata_deviceEventId\":\"AzureFirewallApplicationRule\",\"metadata_mapperName\":\"Azure Firewall Application Rule\",\"metadata_mapperUid\":\"db25fd08-e994-4f29-8c94-c2ef9ffd68e2\",\"metadata_orgId\":\"0000000006AAD08A\",\"metadata_parseTime\":1681417375440,\"metadata_parser\":\"/Parsers/System/Microsoft/Microsoft Azure JSON\",\"metadata_product\":\"Azure\",\"metadata_productGuid\":\"a1225af5-e778-4068-a9a2-47da93d1ff24\",\"metadata_sensorZone\":\"default\",\"metadata_sourceCategory\":\"purgatory-v2/alpha/x4Yzha/AnchorOutlierRuleTest/OUTLIER-S00004-TEST-1\",\"metadata_sourceMessageId\":\"2456377680296453054\",\"metadata_vendor\":\"Microsoft\",\"normalizedAction\":\"deny\",\"normalizedResource\":\"network\",\"objectClassification\":\"Network\",\"objectType\":\"NetworkProxy\",\"srcDevice_ip\":\"22.182.12.244\",\"srcDevice_ip_asnNumber\":749,\"srcDevice_ip_asnOrg\":\"Dod Network Information Center\",\"srcDevice_ip_city\":\"Ashburn\",\"srcDevice_ip_countryCode\":\"US\",\"srcDevice_ip_countryName\":\"United States\",\"srcDevice_ip_ipv4IntValue\":381029620,\"srcDevice_ip_isInternal\":false,\"srcDevice_ip_latitude\":39.043701171875,\"srcDevice_ip_longitude\":-77.47419738769531,\"srcDevice_ip_region\":\"Virginia\",\"srcDevice_ip_version\":4,\"srcPort\":46348,\"success\":false,\"tcpProtocol\":\"HTTPS\",\"threat_name\":null,\"timestamp\":1681425975682,\"uid\":\"0bee0459-407e-527f-8f53-c427b9d6d114\",\"user_email\":null,\"user_username\":null,\"user_username_raw\":null},{\"fields\":{\"source_ip\":\"22.182.12.244\",\"origin_product\":\"Microsoft Azure\",\"dest_port\":\"443\",\"category\":\"AzureFirewallApplicationRule\",\"time\":\"2023-04-13T22:46:11.682Z\",\"operationName\":\"AzureFirewallApplicationRuleLog\",\"action\":\"Deny\",\"destination\":\"md-wbvnbjlhnxlg.z13.blob.storage.azure.net\",\"source_port\":\"46348\",\"protocol\":\"HTTPS\",\"properties.msg\":\"HTTPS request from 22.182.12.244:46348 to md-wbvnbjlhnxlg.z13.blob.storage.azure.net:443. Action: Deny. No rule matched. Proceeding with default action\",\"resourceId\":\"/SUBSCRIPTIONS/09D6CAF5-641C-42EF-8108-4FD414AA3ABF/RESOURCEGROUPS/RG-AKS-FW/PROVIDERS/MICROSOFT.NETWORK/AZUREFIREWALLS/AKS-AZFW-PROTECTION-FW\"},\"accountId\":null,\"action\":null,\"application\":null,\"cloud_provider\":null,\"cloud_region\":null,\"description\":\"AzureFirewallApplicationRuleLog\",\"dstPort\":443,\"email_sender\":null,\"fieldTags\":{},\"http_requestHeaders\":{},\"http_url\":\"md-wbvnbjlhnxlg.z13.blob.storage.azure.net\",\"http_url_conditionalFrequency\":1.5231821014504016e-12,\"http_url_entropyFqdn\":4.300072113709065,\"http_url_entropyRootDomain\":2.94770277922009,\"http_url_fqdn\":\"md-wbvnbjlhnxlg.z13.blob.storage.azure.net\",\"http_url_possibleDynDns\":false,\"http_url_rootDomain\":\"azure.net\",\"http_url_tld\":\"net\",\"http_userAgent\":null,\"listMatches\":[],\"matchedItems\":[],\"metadata_deviceEventId\":\"AzureFirewallApplicationRule\",\"metadata_mapperName\":\"Azure Firewall Application Rule\",\"metadata_mapperUid\":\"db25fd08-e994-4f29-8c94-c2ef9ffd68e2\",\"metadata_orgId\":\"0000000006AAD08A\",\"metadata_parseTime\":1681413232860,\"metadata_parser\":\"/Parsers/System/Microsoft/Microsoft Azure JSON\",\"metadata_product\":\"Azure\",\"metadata_productGuid\":\"a1225af5-e778-4068-a9a2-47da93d1ff24\",\"metadata_sensorZone\":\"default\",\"metadata_sourceCategory\":\"purgatory-v2/alpha/d4eGpF/AnchorOutlierRuleTest/OUTLIER-S00004-TEST-1\",\"metadata_sourceMessageId\":\"2456308140699067207\",\"metadata_vendor\":\"Microsoft\",\"normalizedAction\":\"deny\",\"normalizedResource\":\"network\",\"objectClassification\":\"Network\",\"objectType\":\"NetworkProxy\",\"srcDevice_ip\":\"22.182.12.244\",\"srcDevice_ip_asnNumber\":749,\"srcDevice_ip_asnOrg\":\"Dod Network Information Center\",\"srcDevice_ip_city\":\"Ashburn\",\"srcDevice_ip_countryCode\":\"US\",\"srcDevice_ip_countryName\":\"United States\",\"srcDevice_ip_ipv4IntValue\":381029620,\"srcDevice_ip_isInternal\":false,\"srcDevice_ip_latitude\":39.043701171875,\"srcDevice_ip_longitude\":-77.47419738769531,\"srcDevice_ip_region\":\"Virginia\",\"srcDevice_ip_version\":4,\"srcPort\":46348,\"success\":false,\"tcpProtocol\":\"HTTPS\",\"threat_name\":null,\"timestamp\":1681425971682,\"uid\":\"6a16e6f1-8499-5ca5-8e36-cc1b23eab9ac\",\"user_email\":null,\"user_username\":null,\"user_username_raw\":null}]",
        artifacts: overrides && overrides.hasOwnProperty('artifacts') ? overrides.artifacts! : [relationshipsToOmit.has('SignalArtifact') ? {} as SignalArtifact : aSignalArtifact({}, relationshipsToOmit), relationshipsToOmit.has('SignalArtifact') ? {} as SignalArtifact : aSignalArtifact({}, relationshipsToOmit), relationshipsToOmit.has('SignalArtifact') ? {} as SignalArtifact : aSignalArtifact({}, relationshipsToOmit)],
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'tutamen',
        cipRecordsQuery: overrides && overrides.hasOwnProperty('cipRecordsQuery') ? overrides.cipRecordsQuery! : 'virga',
        contentType: overrides && overrides.hasOwnProperty('contentType') ? overrides.contentType! : 'autem',
        contentTypeEnum: overrides && overrides.hasOwnProperty('contentTypeEnum') ? overrides.contentTypeEnum! : ContentType.Anomaly,
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-05-29T04:36:15.093Z",
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'stipes',
        enrichments: overrides && overrides.hasOwnProperty('enrichments') ? overrides.enrichments! : [relationshipsToOmit.has('Enrichment') ? {} as Enrichment : anEnrichment({}, relationshipsToOmit), relationshipsToOmit.has('Enrichment') ? {} as Enrichment : anEnrichment({}, relationshipsToOmit), relationshipsToOmit.has('Enrichment') ? {} as Enrichment : anEnrichment({}, relationshipsToOmit)],
        entities: overrides && overrides.hasOwnProperty('entities') ? overrides.entities! : [relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit)],
        entity: overrides && overrides.hasOwnProperty('entity') ? overrides.entity! : relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit),
        extra: overrides && overrides.hasOwnProperty('extra') ? overrides.extra! : "{\"matchExpression\":\"true\"}",
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '4c74ebf9-83c0-4529-81eb-71709ff0ee35',
        insights: overrides && overrides.hasOwnProperty('insights') ? overrides.insights! : [relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit), relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit), relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit)],
        involvedEntities: overrides && overrides.hasOwnProperty('involvedEntities') ? overrides.involvedEntities! : [relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit), relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit)],
        isSuppressedByEntity: overrides && overrides.hasOwnProperty('isSuppressedByEntity') ? overrides.isSuppressedByEntity! : true,
        isSuppressedBySuppressList: overrides && overrides.hasOwnProperty('isSuppressedBySuppressList') ? overrides.isSuppressedBySuppressList! : false,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'nam',
        prototype: overrides && overrides.hasOwnProperty('prototype') ? overrides.prototype! : false,
        recordCount: overrides && overrides.hasOwnProperty('recordCount') ? overrides.recordCount! : 1982,
        recordSearchDetails: overrides && overrides.hasOwnProperty('recordSearchDetails') ? overrides.recordSearchDetails! : relationshipsToOmit.has('SignalRecordSearchDetails') ? {} as SignalRecordSearchDetails : aSignalRecordSearchDetails({}, relationshipsToOmit),
        recordTypes: overrides && overrides.hasOwnProperty('recordTypes') ? overrides.recordTypes! : ['utilis', 'commemoro', 'ullus'],
        ruleId: overrides && overrides.hasOwnProperty('ruleId') ? overrides.ruleId! : 'solitudo',
        ruleType: overrides && overrides.hasOwnProperty('ruleType') ? overrides.ruleType! : 'tabernus',
        severity: overrides && overrides.hasOwnProperty('severity') ? overrides.severity! : 4315,
        sourceType: overrides && overrides.hasOwnProperty('sourceType') ? overrides.sourceType! : 'approbo',
        stage: overrides && overrides.hasOwnProperty('stage') ? overrides.stage! : 'viscus',
        summary: overrides && overrides.hasOwnProperty('summary') ? overrides.summary! : 'dolores',
        supportsRecordSearch: overrides && overrides.hasOwnProperty('supportsRecordSearch') ? overrides.supportsRecordSearch! : false,
        suppressed: overrides && overrides.hasOwnProperty('suppressed') ? overrides.suppressed! : false,
        suppressedBy: overrides && overrides.hasOwnProperty('suppressedBy') ? overrides.suppressedBy! : 'depraedor',
        suppressedByNetworkBlock: overrides && overrides.hasOwnProperty('suppressedByNetworkBlock') ? overrides.suppressedByNetworkBlock! : false,
        suppressedBySignal: overrides && overrides.hasOwnProperty('suppressedBySignal') ? overrides.suppressedBySignal! : relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit),
        suppressedBySuppressListNames: overrides && overrides.hasOwnProperty('suppressedBySuppressListNames') ? overrides.suppressedBySuppressListNames! : ['spiculum', 'sum', 'libero'],
        suppressedBySuppressLists: overrides && overrides.hasOwnProperty('suppressedBySuppressLists') ? overrides.suppressedBySuppressLists! : [relationshipsToOmit.has('SuppressList') ? {} as SuppressList : aSuppressList({}, relationshipsToOmit), relationshipsToOmit.has('SuppressList') ? {} as SuppressList : aSuppressList({}, relationshipsToOmit), relationshipsToOmit.has('SuppressList') ? {} as SuppressList : aSuppressList({}, relationshipsToOmit)],
        suppressesSignals: overrides && overrides.hasOwnProperty('suppressesSignals') ? overrides.suppressesSignals! : relationshipsToOmit.has('SignalPage') ? {} as SignalPage : aSignalPage({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['vulgaris', 'textilis', 'velit'],
        threatIntelIndicatorIds: overrides && overrides.hasOwnProperty('threatIntelIndicatorIds') ? overrides.threatIntelIndicatorIds! : ['copiose', 'adflicto', 'clibanus'],
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-05-12T09:06:31.746Z",
    };
};

export const aSignalAnalysis = (overrides?: Partial<SignalAnalysis>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SignalAnalysis' } & SignalAnalysis => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SignalAnalysis');
    return {
        __typename: 'SignalAnalysis',
        artifact: overrides && overrides.hasOwnProperty('artifact') ? overrides.artifact! : ['volo', 'vox', 'adimpleo'],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '889a0917-e9a3-4b60-891f-b6bf42d5d3e6',
        reasoning: overrides && overrides.hasOwnProperty('reasoning') ? overrides.reasoning! : 'vitae',
        rootCause: overrides && overrides.hasOwnProperty('rootCause') ? overrides.rootCause! : 'contego',
        ruleId: overrides && overrides.hasOwnProperty('ruleId') ? overrides.ruleId! : '6982817c-69c4-4e7d-8d8c-b4ff7c4daf2f',
        summary: overrides && overrides.hasOwnProperty('summary') ? overrides.summary! : 'cito',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-03-03T19:08:56.597Z",
        title: overrides && overrides.hasOwnProperty('title') ? overrides.title! : 'optio',
        verdict: overrides && overrides.hasOwnProperty('verdict') ? overrides.verdict! : SimpleVerdict.Benign,
    };
};

export const aSignalArtifact = (overrides?: Partial<SignalArtifact>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SignalArtifact' } & SignalArtifact => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SignalArtifact');
    return {
        __typename: 'SignalArtifact',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'amita',
        recordStream: overrides && overrides.hasOwnProperty('recordStream') ? overrides.recordStream! : 'rerum',
        recordUid: overrides && overrides.hasOwnProperty('recordUid') ? overrides.recordUid! : 'demulceo',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'aequus',
    };
};

export const aSignalPage = (overrides?: Partial<SignalPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SignalPage' } & SignalPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SignalPage');
    return {
        __typename: 'SignalPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit), relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit), relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 4429,
    };
};

export const aSignalRecordSearchDetails = (overrides?: Partial<SignalRecordSearchDetails>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SignalRecordSearchDetails' } & SignalRecordSearchDetails => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SignalRecordSearchDetails');
    return {
        __typename: 'SignalRecordSearchDetails',
        query: overrides && overrides.hasOwnProperty('query') ? overrides.query! : 'vulgo',
        queryEndTime: overrides && overrides.hasOwnProperty('queryEndTime') ? overrides.queryEndTime! : "2025-10-11T13:22:54.157Z",
        queryStartTime: overrides && overrides.hasOwnProperty('queryStartTime') ? overrides.queryStartTime! : "2025-05-18T14:31:15.930Z",
    };
};

export const aSignalSort = (overrides?: Partial<SignalSort>, _relationshipsToOmit: Set<string> = new Set()): SignalSort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SignalSort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : SignalSortableField.ContentType,
    };
};

export const aSignalTagOption = (overrides?: Partial<SignalTagOption>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SignalTagOption' } & SignalTagOption => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SignalTagOption');
    return {
        __typename: 'SignalTagOption',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'cupressus',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'error',
    };
};

export const aSpanFilterInput = (overrides?: Partial<SpanFilterInput>, _relationshipsToOmit: Set<string> = new Set()): SpanFilterInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SpanFilterInput');
    return {
        fieldName: overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'advenio',
        fieldValue: overrides && overrides.hasOwnProperty('fieldValue') ? overrides.fieldValue! : 'agnitio',
        operator: overrides && overrides.hasOwnProperty('operator') ? overrides.operator! : 'astrum',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'vomer',
    };
};

export const aSpanFilterKeyValuePair = (overrides?: Partial<SpanFilterKeyValuePair>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SpanFilterKeyValuePair' } & SpanFilterKeyValuePair => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SpanFilterKeyValuePair');
    return {
        __typename: 'SpanFilterKeyValuePair',
        fieldName: overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'minima',
        fieldValue: overrides && overrides.hasOwnProperty('fieldValue') ? overrides.fieldValue! : 'tunc',
        operator: overrides && overrides.hasOwnProperty('operator') ? overrides.operator! : 'candidus',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'virtus',
    };
};

export const aSpanFilterStandAloneKey = (overrides?: Partial<SpanFilterStandAloneKey>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SpanFilterStandAloneKey' } & SpanFilterStandAloneKey => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SpanFilterStandAloneKey');
    return {
        __typename: 'SpanFilterStandAloneKey',
        fieldName: overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'dedecor',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'bos',
    };
};

export const aSpanQuery = (overrides?: Partial<SpanQuery>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SpanQuery' } & SpanQuery => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SpanQuery');
    return {
        __typename: 'SpanQuery',
        queryKey: overrides && overrides.hasOwnProperty('queryKey') ? overrides.queryKey! : 'dolore',
        queryString: overrides && overrides.hasOwnProperty('queryString') ? overrides.queryString! : 'depulso',
        queryType: overrides && overrides.hasOwnProperty('queryType') ? overrides.queryType! : 'tametsi',
        spansQueryData: overrides && overrides.hasOwnProperty('spansQueryData') ? overrides.spansQueryData! : relationshipsToOmit.has('SpansQueryData') ? {} as SpansQueryData : aSpansQueryData({}, relationshipsToOmit),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'virgo',
    };
};

export const aSpanQueryInput = (overrides?: Partial<SpanQueryInput>, _relationshipsToOmit: Set<string> = new Set()): SpanQueryInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SpanQueryInput');
    return {
        queryKey: overrides && overrides.hasOwnProperty('queryKey') ? overrides.queryKey! : 'caelestis',
        queryString: overrides && overrides.hasOwnProperty('queryString') ? overrides.queryString! : 'facilis',
        queryType: overrides && overrides.hasOwnProperty('queryType') ? overrides.queryType! : 'nobis',
        spansQueryData: overrides && overrides.hasOwnProperty('spansQueryData') ? overrides.spansQueryData! : relationshipsToOmit.has('SpansQueryDataInput') ? {} as SpansQueryDataInput : aSpansQueryDataInput({}, relationshipsToOmit),
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'callide',
    };
};

export const aSpanRecentItem = (overrides?: Partial<SpanRecentItem>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SpanRecentItem' } & SpanRecentItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SpanRecentItem');
    return {
        __typename: 'SpanRecentItem',
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'stultus',
        accessTime: overrides && overrides.hasOwnProperty('accessTime') ? overrides.accessTime! : 'deficio',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'crepusculum',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 184636194844153,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 8983,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'casso',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 'depraedor',
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'thema',
        pageType: overrides && overrides.hasOwnProperty('pageType') ? overrides.pageType! : RecentPageType.Dashboard,
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 143027859030664,
        queryString: overrides && overrides.hasOwnProperty('queryString') ? overrides.queryString! : 'suadeo',
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 2474,
        spanQueries: overrides && overrides.hasOwnProperty('spanQueries') ? overrides.spanQueries! : [relationshipsToOmit.has('SpanQuery') ? {} as SpanQuery : aSpanQuery({}, relationshipsToOmit), relationshipsToOmit.has('SpanQuery') ? {} as SpanQuery : aSpanQuery({}, relationshipsToOmit), relationshipsToOmit.has('SpanQuery') ? {} as SpanQuery : aSpanQuery({}, relationshipsToOmit)],
        timeRange: overrides && overrides.hasOwnProperty('timeRange') ? overrides.timeRange! : [relationshipsToOmit.has('SpanTimeRange') ? {} as SpanTimeRange : aSpanTimeRange({}, relationshipsToOmit), relationshipsToOmit.has('SpanTimeRange') ? {} as SpanTimeRange : aSpanTimeRange({}, relationshipsToOmit), relationshipsToOmit.has('SpanTimeRange') ? {} as SpanTimeRange : aSpanTimeRange({}, relationshipsToOmit)],
        urlHash: overrides && overrides.hasOwnProperty('urlHash') ? overrides.urlHash! : 'cinis',
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'arbustum',
    };
};

export const aSpanTimeRange = (overrides?: Partial<SpanTimeRange>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SpanTimeRange' } & SpanTimeRange => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SpanTimeRange');
    return {
        __typename: 'SpanTimeRange',
        d: overrides && overrides.hasOwnProperty('d') ? overrides.d! : 551780886561820,
        t: overrides && overrides.hasOwnProperty('t') ? overrides.t! : 'deleo',
    };
};

export const aSpanTimeRangeInput = (overrides?: Partial<SpanTimeRangeInput>, _relationshipsToOmit: Set<string> = new Set()): SpanTimeRangeInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SpanTimeRangeInput');
    return {
        d: overrides && overrides.hasOwnProperty('d') ? overrides.d! : 943553978581653,
        t: overrides && overrides.hasOwnProperty('t') ? overrides.t! : 'pax',
    };
};

export const aSpansLimit = (overrides?: Partial<SpansLimit>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SpansLimit' } & SpansLimit => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SpansLimit');
    return {
        __typename: 'SpansLimit',
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : 'aut',
        limitValue: overrides && overrides.hasOwnProperty('limitValue') ? overrides.limitValue! : 1189,
    };
};

export const aSpansLimitInput = (overrides?: Partial<SpansLimitInput>, _relationshipsToOmit: Set<string> = new Set()): SpansLimitInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SpansLimitInput');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : 'ascisco',
        limitValue: overrides && overrides.hasOwnProperty('limitValue') ? overrides.limitValue! : 2188,
    };
};

export const aSpansQueryData = (overrides?: Partial<SpansQueryData>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SpansQueryData' } & SpansQueryData => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SpansQueryData');
    return {
        __typename: 'SpansQueryData',
        facetsQueryString: overrides && overrides.hasOwnProperty('facetsQueryString') ? overrides.facetsQueryString! : 'magni',
        filters: overrides && overrides.hasOwnProperty('filters') ? overrides.filters! : [relationshipsToOmit.has('SpanFilterKeyValuePair') ? {} as SpanFilterKeyValuePair : aSpanFilterKeyValuePair({}, relationshipsToOmit), relationshipsToOmit.has('SpanFilterKeyValuePair') ? {} as SpanFilterKeyValuePair : aSpanFilterKeyValuePair({}, relationshipsToOmit), relationshipsToOmit.has('SpanFilterKeyValuePair') ? {} as SpanFilterKeyValuePair : aSpanFilterKeyValuePair({}, relationshipsToOmit)],
        groupBy: overrides && overrides.hasOwnProperty('groupBy') ? overrides.groupBy! : [relationshipsToOmit.has('FieldGroupBy') ? {} as FieldGroupBy : aFieldGroupBy({}, relationshipsToOmit), relationshipsToOmit.has('FieldGroupBy') ? {} as FieldGroupBy : aFieldGroupBy({}, relationshipsToOmit), relationshipsToOmit.has('FieldGroupBy') ? {} as FieldGroupBy : aFieldGroupBy({}, relationshipsToOmit)],
        limit: overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : [relationshipsToOmit.has('SpansLimit') ? {} as SpansLimit : aSpansLimit({}, relationshipsToOmit), relationshipsToOmit.has('SpansLimit') ? {} as SpansLimit : aSpansLimit({}, relationshipsToOmit), relationshipsToOmit.has('SpansLimit') ? {} as SpansLimit : aSpansLimit({}, relationshipsToOmit)],
        visualizations: overrides && overrides.hasOwnProperty('visualizations') ? overrides.visualizations! : ['clarus', 'tametsi', 'fugiat'],
    };
};

export const aSpansQueryDataInput = (overrides?: Partial<SpansQueryDataInput>, _relationshipsToOmit: Set<string> = new Set()): SpansQueryDataInput => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SpansQueryDataInput');
    return {
        facetsQueryString: overrides && overrides.hasOwnProperty('facetsQueryString') ? overrides.facetsQueryString! : 'vespillo',
        filters: overrides && overrides.hasOwnProperty('filters') ? overrides.filters! : [relationshipsToOmit.has('SpanFilterInput') ? {} as SpanFilterInput : aSpanFilterInput({}, relationshipsToOmit), relationshipsToOmit.has('SpanFilterInput') ? {} as SpanFilterInput : aSpanFilterInput({}, relationshipsToOmit), relationshipsToOmit.has('SpanFilterInput') ? {} as SpanFilterInput : aSpanFilterInput({}, relationshipsToOmit)],
        groupBy: overrides && overrides.hasOwnProperty('groupBy') ? overrides.groupBy! : [relationshipsToOmit.has('GroupByInput') ? {} as GroupByInput : aGroupByInput({}, relationshipsToOmit), relationshipsToOmit.has('GroupByInput') ? {} as GroupByInput : aGroupByInput({}, relationshipsToOmit), relationshipsToOmit.has('GroupByInput') ? {} as GroupByInput : aGroupByInput({}, relationshipsToOmit)],
        limit: overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : [relationshipsToOmit.has('SpansLimitInput') ? {} as SpansLimitInput : aSpansLimitInput({}, relationshipsToOmit), relationshipsToOmit.has('SpansLimitInput') ? {} as SpansLimitInput : aSpansLimitInput({}, relationshipsToOmit), relationshipsToOmit.has('SpansLimitInput') ? {} as SpansLimitInput : aSpansLimitInput({}, relationshipsToOmit)],
        visualizations: overrides && overrides.hasOwnProperty('visualizations') ? overrides.visualizations! : ['stabilis', 'coruscus', 'tantillus'],
    };
};

export const aSpansRecentItemFields = (overrides?: Partial<SpansRecentItemFields>, _relationshipsToOmit: Set<string> = new Set()): SpansRecentItemFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SpansRecentItemFields');
    return {
        accessTime: overrides && overrides.hasOwnProperty('accessTime') ? overrides.accessTime! : 'qui',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 9631,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tego',
        pageType: overrides && overrides.hasOwnProperty('pageType') ? overrides.pageType! : RecentPageType.Dashboard,
        queryString: overrides && overrides.hasOwnProperty('queryString') ? overrides.queryString! : 'tracto',
        spanQueries: overrides && overrides.hasOwnProperty('spanQueries') ? overrides.spanQueries! : [relationshipsToOmit.has('SpanQueryInput') ? {} as SpanQueryInput : aSpanQueryInput({}, relationshipsToOmit), relationshipsToOmit.has('SpanQueryInput') ? {} as SpanQueryInput : aSpanQueryInput({}, relationshipsToOmit), relationshipsToOmit.has('SpanQueryInput') ? {} as SpanQueryInput : aSpanQueryInput({}, relationshipsToOmit)],
        timeRange: overrides && overrides.hasOwnProperty('timeRange') ? overrides.timeRange! : [relationshipsToOmit.has('SpanTimeRangeInput') ? {} as SpanTimeRangeInput : aSpanTimeRangeInput({}, relationshipsToOmit), relationshipsToOmit.has('SpanTimeRangeInput') ? {} as SpanTimeRangeInput : aSpanTimeRangeInput({}, relationshipsToOmit), relationshipsToOmit.has('SpanTimeRangeInput') ? {} as SpanTimeRangeInput : aSpanTimeRangeInput({}, relationshipsToOmit)],
        urlHash: overrides && overrides.hasOwnProperty('urlHash') ? overrides.urlHash! : 'quidem',
    };
};

export const aSsoSettings = (overrides?: Partial<SsoSettings>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SsoSettings' } & SsoSettings => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SsoSettings');
    return {
        __typename: 'SsoSettings',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        logoutUrl: overrides && overrides.hasOwnProperty('logoutUrl') ? overrides.logoutUrl! : 'debilito',
        metadataUrl: overrides && overrides.hasOwnProperty('metadataUrl') ? overrides.metadataUrl! : 'aut',
        metadataXml: overrides && overrides.hasOwnProperty('metadataXml') ? overrides.metadataXml! : 'uredo',
        ssoUrl: overrides && overrides.hasOwnProperty('ssoUrl') ? overrides.ssoUrl! : 'decor',
    };
};

export const aStandardPageRecentItem = (overrides?: Partial<StandardPageRecentItem>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'StandardPageRecentItem' } & StandardPageRecentItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StandardPageRecentItem');
    return {
        __typename: 'StandardPageRecentItem',
        accessId: overrides && overrides.hasOwnProperty('accessId') ? overrides.accessId! : 'consequatur',
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'solus',
        accessTime: overrides && overrides.hasOwnProperty('accessTime') ? overrides.accessTime! : 'considero',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'animadverto',
        externalId: overrides && overrides.hasOwnProperty('externalId') ? overrides.externalId! : 961753614272005,
        feature: overrides && overrides.hasOwnProperty('feature') ? overrides.feature! : FeatureType.Cip,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 2708,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'uterque',
        ownerId: overrides && overrides.hasOwnProperty('ownerId') ? overrides.ownerId! : 'aer',
        ownerName: overrides && overrides.hasOwnProperty('ownerName') ? overrides.ownerName! : 'alioqui',
        pageType: overrides && overrides.hasOwnProperty('pageType') ? overrides.pageType! : RecentPageType.Dashboard,
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 160031304299360,
        runAsIdOverride: overrides && overrides.hasOwnProperty('runAsIdOverride') ? overrides.runAsIdOverride! : 3005,
        standardPageType: overrides && overrides.hasOwnProperty('standardPageType') ? overrides.standardPageType! : StandardPageType.Alert,
        visibility: overrides && overrides.hasOwnProperty('visibility') ? overrides.visibility! : 'vulgaris',
    };
};

export const aStandardPageRecentItemFields = (overrides?: Partial<StandardPageRecentItemFields>, _relationshipsToOmit: Set<string> = new Set()): StandardPageRecentItemFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StandardPageRecentItemFields');
    return {
        accessId: overrides && overrides.hasOwnProperty('accessId') ? overrides.accessId! : 'deleo',
        accessKey: overrides && overrides.hasOwnProperty('accessKey') ? overrides.accessKey! : 'casso',
        accessTime: overrides && overrides.hasOwnProperty('accessTime') ? overrides.accessTime! : 'triumphus',
        feature: overrides && overrides.hasOwnProperty('feature') ? overrides.feature! : FeatureType.Cip,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 1225,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'asper',
        pageType: overrides && overrides.hasOwnProperty('pageType') ? overrides.pageType! : RecentPageType.Dashboard,
        standardPageType: overrides && overrides.hasOwnProperty('standardPageType') ? overrides.standardPageType! : StandardPageType.Alert,
    };
};

export const aStartCanaryLookupJob = (overrides?: Partial<StartCanaryLookupJob>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'StartCanaryLookupJob' } & StartCanaryLookupJob => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StartCanaryLookupJob');
    return {
        __typename: 'StartCanaryLookupJob',
        jobId: overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'capillus',
    };
};

export const aStartEntityTimelineGroupRecordJob = (overrides?: Partial<StartEntityTimelineGroupRecordJob>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'StartEntityTimelineGroupRecordJob' } & StartEntityTimelineGroupRecordJob => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StartEntityTimelineGroupRecordJob');
    return {
        __typename: 'StartEntityTimelineGroupRecordJob',
        jobId: overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'aut',
    };
};

export const aStartEntityTimelineJob = (overrides?: Partial<StartEntityTimelineJob>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'StartEntityTimelineJob' } & StartEntityTimelineJob => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StartEntityTimelineJob');
    return {
        __typename: 'StartEntityTimelineJob',
        jobId: overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'antepono',
    };
};

export const aStartSumoInsightSearchJob = (overrides?: Partial<StartSumoInsightSearchJob>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'StartSumoInsightSearchJob' } & StartSumoInsightSearchJob => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StartSumoInsightSearchJob');
    return {
        __typename: 'StartSumoInsightSearchJob',
        end: overrides && overrides.hasOwnProperty('end') ? overrides.end! : "2025-01-19T15:14:45.006Z",
        jobId: overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'defetiscor',
        query: overrides && overrides.hasOwnProperty('query') ? overrides.query! : 'conservo',
        start: overrides && overrides.hasOwnProperty('start') ? overrides.start! : "2025-01-02T16:59:41.622Z",
    };
};

export const aStartSumoRawMessageLookupJob = (overrides?: Partial<StartSumoRawMessageLookupJob>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'StartSumoRawMessageLookupJob' } & StartSumoRawMessageLookupJob => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StartSumoRawMessageLookupJob');
    return {
        __typename: 'StartSumoRawMessageLookupJob',
        end: overrides && overrides.hasOwnProperty('end') ? overrides.end! : "2025-03-19T01:36:08.532Z",
        jobId: overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'decretum',
        query: overrides && overrides.hasOwnProperty('query') ? overrides.query! : 'theca',
        start: overrides && overrides.hasOwnProperty('start') ? overrides.start! : "2025-03-27T07:05:03.438Z",
    };
};

export const aStartSumoRecordSearchJob = (overrides?: Partial<StartSumoRecordSearchJob>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'StartSumoRecordSearchJob' } & StartSumoRecordSearchJob => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StartSumoRecordSearchJob');
    return {
        __typename: 'StartSumoRecordSearchJob',
        end: overrides && overrides.hasOwnProperty('end') ? overrides.end! : "2025-09-02T02:26:09.512Z",
        jobId: overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'suscipit',
        query: overrides && overrides.hasOwnProperty('query') ? overrides.query! : 'tardus',
        start: overrides && overrides.hasOwnProperty('start') ? overrides.start! : "2025-05-14T21:38:19.134Z",
    };
};

export const aStartSumoRecordSearchJobForRuleExpression = (overrides?: Partial<StartSumoRecordSearchJobForRuleExpression>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'StartSumoRecordSearchJobForRuleExpression' } & StartSumoRecordSearchJobForRuleExpression => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StartSumoRecordSearchJobForRuleExpression');
    return {
        __typename: 'StartSumoRecordSearchJobForRuleExpression',
        end: overrides && overrides.hasOwnProperty('end') ? overrides.end! : "2024-12-13T21:46:52.299Z",
        jobId: overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'cerno',
        query: overrides && overrides.hasOwnProperty('query') ? overrides.query! : 'abscido',
        start: overrides && overrides.hasOwnProperty('start') ? overrides.start! : "2024-12-10T13:43:10.136Z",
    };
};

export const aStartSumoRecordSearchJobForSignal = (overrides?: Partial<StartSumoRecordSearchJobForSignal>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'StartSumoRecordSearchJobForSignal' } & StartSumoRecordSearchJobForSignal => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StartSumoRecordSearchJobForSignal');
    return {
        __typename: 'StartSumoRecordSearchJobForSignal',
        end: overrides && overrides.hasOwnProperty('end') ? overrides.end! : "2025-06-12T20:12:16.027Z",
        exploreInLogsQuery: overrides && overrides.hasOwnProperty('exploreInLogsQuery') ? overrides.exploreInLogsQuery! : 'curso',
        jobId: overrides && overrides.hasOwnProperty('jobId') ? overrides.jobId! : 'amoveo',
        query: overrides && overrides.hasOwnProperty('query') ? overrides.query! : 'desidero',
        start: overrides && overrides.hasOwnProperty('start') ? overrides.start! : "2025-02-09T04:37:39.876Z",
    };
};

export const aStreamingExportConfiguration = (overrides?: Partial<StreamingExportConfiguration>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'StreamingExportConfiguration' } & StreamingExportConfiguration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StreamingExportConfiguration');
    return {
        __typename: 'StreamingExportConfiguration',
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-03-11T11:35:36.769Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'consequuntur',
        dataStream: overrides && overrides.hasOwnProperty('dataStream') ? overrides.dataStream! : StreamingExportConfigurationDataStream.Raw,
        exportUrl: overrides && overrides.hasOwnProperty('exportUrl') ? overrides.exportUrl! : 'caecus',
        filterExpression: overrides && overrides.hasOwnProperty('filterExpression') ? overrides.filterExpression! : 'cum',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '32933c25-2863-4734-9df7-520f24a3a348',
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-03-07T09:11:52.428Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'velum',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'aveho',
        sourceCategory: overrides && overrides.hasOwnProperty('sourceCategory') ? overrides.sourceCategory! : 'subnecto',
    };
};

export const aStreamingExportConfigurationFields = (overrides?: Partial<StreamingExportConfigurationFields>, _relationshipsToOmit: Set<string> = new Set()): StreamingExportConfigurationFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StreamingExportConfigurationFields');
    return {
        dataStream: overrides && overrides.hasOwnProperty('dataStream') ? overrides.dataStream! : StreamingExportConfigurationDataStream.Raw,
        exportUrl: overrides && overrides.hasOwnProperty('exportUrl') ? overrides.exportUrl! : 'termes',
        filterExpression: overrides && overrides.hasOwnProperty('filterExpression') ? overrides.filterExpression! : 'atrocitas',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'umerus',
        sourceCategory: overrides && overrides.hasOwnProperty('sourceCategory') ? overrides.sourceCategory! : 'suasoria',
    };
};

export const aStreamingExportConfigurationPage = (overrides?: Partial<StreamingExportConfigurationPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'StreamingExportConfigurationPage' } & StreamingExportConfigurationPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StreamingExportConfigurationPage');
    return {
        __typename: 'StreamingExportConfigurationPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('StreamingExportConfiguration') ? {} as StreamingExportConfiguration : aStreamingExportConfiguration({}, relationshipsToOmit), relationshipsToOmit.has('StreamingExportConfiguration') ? {} as StreamingExportConfiguration : aStreamingExportConfiguration({}, relationshipsToOmit), relationshipsToOmit.has('StreamingExportConfiguration') ? {} as StreamingExportConfiguration : aStreamingExportConfiguration({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 2562,
    };
};

export const aStreamingExportConfigurationSort = (overrides?: Partial<StreamingExportConfigurationSort>, _relationshipsToOmit: Set<string> = new Set()): StreamingExportConfigurationSort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StreamingExportConfigurationSort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : StreamingExportConfigurationSortableField.DataStream,
    };
};

export const aStringListRuleOverride = (overrides?: Partial<StringListRuleOverride>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'StringListRuleOverride' } & StringListRuleOverride => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StringListRuleOverride');
    return {
        __typename: 'StringListRuleOverride',
        original: overrides && overrides.hasOwnProperty('original') ? overrides.original! : ['deprimo', 'velit', 'temperantia'],
        override: overrides && overrides.hasOwnProperty('override') ? overrides.override! : ['attonbitus', 'desipio', 'arcus'],
    };
};

export const aStringRuleOverride = (overrides?: Partial<StringRuleOverride>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'StringRuleOverride' } & StringRuleOverride => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('StringRuleOverride');
    return {
        __typename: 'StringRuleOverride',
        original: overrides && overrides.hasOwnProperty('original') ? overrides.original! : 'arceo',
        override: overrides && overrides.hasOwnProperty('override') ? overrides.override! : 'bellum',
    };
};

export const aSumoMapping = (overrides?: Partial<SumoMapping>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SumoMapping' } & SumoMapping => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SumoMapping');
    return {
        __typename: 'SumoMapping',
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-08-10T03:04:20.337Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'saepe',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'voluptatibus',
        exportConfigJson: overrides && overrides.hasOwnProperty('exportConfigJson') ? overrides.exportConfigJson! : 'suscipit',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ba1030a0-c35c-476e-85d9-3ba3efe68f16',
        jsonExplode: overrides && overrides.hasOwnProperty('jsonExplode') ? overrides.jsonExplode! : 'utroque',
        jsonZipOperations: overrides && overrides.hasOwnProperty('jsonZipOperations') ? overrides.jsonZipOperations! : [relationshipsToOmit.has('SumoMappingJsonZipOperation') ? {} as SumoMappingJsonZipOperation : aSumoMappingJsonZipOperation({}, relationshipsToOmit), relationshipsToOmit.has('SumoMappingJsonZipOperation') ? {} as SumoMappingJsonZipOperation : aSumoMappingJsonZipOperation({}, relationshipsToOmit), relationshipsToOmit.has('SumoMappingJsonZipOperation') ? {} as SumoMappingJsonZipOperation : aSumoMappingJsonZipOperation({}, relationshipsToOmit)],
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-10-28T11:04:59.338Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'videlicet',
        logFormat: overrides && overrides.hasOwnProperty('logFormat') ? overrides.logFormat! : 'benigne',
        product: overrides && overrides.hasOwnProperty('product') ? overrides.product! : 'baiulus',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'laudantium',
        sourceCategory: overrides && overrides.hasOwnProperty('sourceCategory') ? overrides.sourceCategory! : 'spoliatio',
        syslogDelimiter: overrides && overrides.hasOwnProperty('syslogDelimiter') ? overrides.syslogDelimiter! : 'crur',
        syslogFormat: overrides && overrides.hasOwnProperty('syslogFormat') ? overrides.syslogFormat! : 'ubi',
        syslogKvDelimiter: overrides && overrides.hasOwnProperty('syslogKvDelimiter') ? overrides.syslogKvDelimiter! : 'voluptate',
        vendor: overrides && overrides.hasOwnProperty('vendor') ? overrides.vendor! : 'summopere',
    };
};

export const aSumoMappingFields = (overrides?: Partial<SumoMappingFields>, _relationshipsToOmit: Set<string> = new Set()): SumoMappingFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SumoMappingFields');
    return {
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        eventId: overrides && overrides.hasOwnProperty('eventId') ? overrides.eventId! : 'acies',
        jsonExplode: overrides && overrides.hasOwnProperty('jsonExplode') ? overrides.jsonExplode! : 'campana',
        jsonZipOperations: overrides && overrides.hasOwnProperty('jsonZipOperations') ? overrides.jsonZipOperations! : [relationshipsToOmit.has('SumoMappingJsonZipOperationFields') ? {} as SumoMappingJsonZipOperationFields : aSumoMappingJsonZipOperationFields({}, relationshipsToOmit), relationshipsToOmit.has('SumoMappingJsonZipOperationFields') ? {} as SumoMappingJsonZipOperationFields : aSumoMappingJsonZipOperationFields({}, relationshipsToOmit), relationshipsToOmit.has('SumoMappingJsonZipOperationFields') ? {} as SumoMappingJsonZipOperationFields : aSumoMappingJsonZipOperationFields({}, relationshipsToOmit)],
        logFormat: overrides && overrides.hasOwnProperty('logFormat') ? overrides.logFormat! : 'subito',
        product: overrides && overrides.hasOwnProperty('product') ? overrides.product! : 'valetudo',
        sourceCategory: overrides && overrides.hasOwnProperty('sourceCategory') ? overrides.sourceCategory! : 'theatrum',
        syslogDelimiter: overrides && overrides.hasOwnProperty('syslogDelimiter') ? overrides.syslogDelimiter! : 'vis',
        syslogFormat: overrides && overrides.hasOwnProperty('syslogFormat') ? overrides.syslogFormat! : 'minima',
        syslogKvDelimiter: overrides && overrides.hasOwnProperty('syslogKvDelimiter') ? overrides.syslogKvDelimiter! : 'quam',
        vendor: overrides && overrides.hasOwnProperty('vendor') ? overrides.vendor! : 'aer',
    };
};

export const aSumoMappingJsonZipOperation = (overrides?: Partial<SumoMappingJsonZipOperation>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SumoMappingJsonZipOperation' } & SumoMappingJsonZipOperation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SumoMappingJsonZipOperation');
    return {
        __typename: 'SumoMappingJsonZipOperation',
        keyName: overrides && overrides.hasOwnProperty('keyName') ? overrides.keyName! : 'audax',
        matchKey: overrides && overrides.hasOwnProperty('matchKey') ? overrides.matchKey! : 'tener',
        matchValue: overrides && overrides.hasOwnProperty('matchValue') ? overrides.matchValue! : 'ventus',
    };
};

export const aSumoMappingJsonZipOperationFields = (overrides?: Partial<SumoMappingJsonZipOperationFields>, _relationshipsToOmit: Set<string> = new Set()): SumoMappingJsonZipOperationFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SumoMappingJsonZipOperationFields');
    return {
        keyName: overrides && overrides.hasOwnProperty('keyName') ? overrides.keyName! : 'veniam',
        matchKey: overrides && overrides.hasOwnProperty('matchKey') ? overrides.matchKey! : 'videlicet',
        matchValue: overrides && overrides.hasOwnProperty('matchValue') ? overrides.matchValue! : 'denego',
    };
};

export const aSumoMappingPage = (overrides?: Partial<SumoMappingPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SumoMappingPage' } & SumoMappingPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SumoMappingPage');
    return {
        __typename: 'SumoMappingPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('SumoMapping') ? {} as SumoMapping : aSumoMapping({}, relationshipsToOmit), relationshipsToOmit.has('SumoMapping') ? {} as SumoMapping : aSumoMapping({}, relationshipsToOmit), relationshipsToOmit.has('SumoMapping') ? {} as SumoMapping : aSumoMapping({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 6088,
    };
};

export const aSumoMappingSort = (overrides?: Partial<SumoMappingSort>, _relationshipsToOmit: Set<string> = new Set()): SumoMappingSort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SumoMappingSort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : SumoMappingSortableField.Enabled,
    };
};

export const aSumoSearchHistogramBucket = (overrides?: Partial<SumoSearchHistogramBucket>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SumoSearchHistogramBucket' } & SumoSearchHistogramBucket => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SumoSearchHistogramBucket');
    return {
        __typename: 'SumoSearchHistogramBucket',
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 1447,
        length: overrides && overrides.hasOwnProperty('length') ? overrides.length! : '93',
        startTimestamp: overrides && overrides.hasOwnProperty('startTimestamp') ? overrides.startTimestamp! : "2025-03-16T09:48:06.856Z",
    };
};

export const aSumoSearchJobStatus = (overrides?: Partial<SumoSearchJobStatus>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SumoSearchJobStatus' } & SumoSearchJobStatus => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SumoSearchJobStatus');
    return {
        __typename: 'SumoSearchJobStatus',
        histogramBuckets: overrides && overrides.hasOwnProperty('histogramBuckets') ? overrides.histogramBuckets! : [relationshipsToOmit.has('SumoSearchHistogramBucket') ? {} as SumoSearchHistogramBucket : aSumoSearchHistogramBucket({}, relationshipsToOmit), relationshipsToOmit.has('SumoSearchHistogramBucket') ? {} as SumoSearchHistogramBucket : aSumoSearchHistogramBucket({}, relationshipsToOmit), relationshipsToOmit.has('SumoSearchHistogramBucket') ? {} as SumoSearchHistogramBucket : aSumoSearchHistogramBucket({}, relationshipsToOmit)],
        state: overrides && overrides.hasOwnProperty('state') ? overrides.state! : SumoSearchJobState.Cancelled,
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 9388,
    };
};

export const aSumoSearchObjectTypeCount = (overrides?: Partial<SumoSearchObjectTypeCount>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SumoSearchObjectTypeCount' } & SumoSearchObjectTypeCount => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SumoSearchObjectTypeCount');
    return {
        __typename: 'SumoSearchObjectTypeCount',
        count: overrides && overrides.hasOwnProperty('count') ? overrides.count! : 7412,
        objectType: overrides && overrides.hasOwnProperty('objectType') ? overrides.objectType! : 'virga',
    };
};

export const aSumoUser = (overrides?: Partial<SumoUser>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SumoUser' } & SumoUser => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SumoUser');
    return {
        __typename: 'SumoUser',
        createdAt: overrides && overrides.hasOwnProperty('createdAt') ? overrides.createdAt! : 'laborum',
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'triduana',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'ancilla',
        firstName: overrides && overrides.hasOwnProperty('firstName') ? overrides.firstName! : 'spiculum',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'audio',
        isActive: overrides && overrides.hasOwnProperty('isActive') ? overrides.isActive! : true,
        isLocked: overrides && overrides.hasOwnProperty('isLocked') ? overrides.isLocked! : true,
        isMfaEnabled: overrides && overrides.hasOwnProperty('isMfaEnabled') ? overrides.isMfaEnabled! : true,
        lastLoginTimestamp: overrides && overrides.hasOwnProperty('lastLoginTimestamp') ? overrides.lastLoginTimestamp! : 'degenero',
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'perferendis',
        modifiedAt: overrides && overrides.hasOwnProperty('modifiedAt') ? overrides.modifiedAt! : 'thymbra',
        modifiedBy: overrides && overrides.hasOwnProperty('modifiedBy') ? overrides.modifiedBy! : 'vomer',
        roleIds: overrides && overrides.hasOwnProperty('roleIds') ? overrides.roleIds! : ['taceo', 'patruus', 'terebro'],
    };
};

export const aSumoUsersPage = (overrides?: Partial<SumoUsersPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SumoUsersPage' } & SumoUsersPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SumoUsersPage');
    return {
        __typename: 'SumoUsersPage',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : [relationshipsToOmit.has('SumoUser') ? {} as SumoUser : aSumoUser({}, relationshipsToOmit), relationshipsToOmit.has('SumoUser') ? {} as SumoUser : aSumoUser({}, relationshipsToOmit), relationshipsToOmit.has('SumoUser') ? {} as SumoUser : aSumoUser({}, relationshipsToOmit)],
        next: overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'assumenda',
    };
};

export const aSuppressList = (overrides?: Partial<SuppressList>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SuppressList' } & SuppressList => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SuppressList');
    return {
        __typename: 'SuppressList',
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : false,
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-09-26T13:42:22.421Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'charisma',
        defaultTtl: overrides && overrides.hasOwnProperty('defaultTtl') ? overrides.defaultTtl! : 9899,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'cado',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '585c89a0-c751-47b6-995d-05877785c34c',
        items: overrides && overrides.hasOwnProperty('items') ? overrides.items! : relationshipsToOmit.has('SuppressListItemPage') ? {} as SuppressListItemPage : aSuppressListItemPage({}, relationshipsToOmit),
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-09-16T14:52:22.979Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'valens',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'animus',
        targetColumn: overrides && overrides.hasOwnProperty('targetColumn') ? overrides.targetColumn! : 'assumenda',
    };
};

export const aSuppressListFields = (overrides?: Partial<SuppressListFields>, _relationshipsToOmit: Set<string> = new Set()): SuppressListFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SuppressListFields');
    return {
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : false,
        defaultTtl: overrides && overrides.hasOwnProperty('defaultTtl') ? overrides.defaultTtl! : 7748,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'deleniti',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'apud',
        targetColumn: overrides && overrides.hasOwnProperty('targetColumn') ? overrides.targetColumn! : 'tabernus',
    };
};

export const aSuppressListItem = (overrides?: Partial<SuppressListItem>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SuppressListItem' } & SuppressListItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SuppressListItem');
    return {
        __typename: 'SuppressListItem',
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : false,
        expiration: overrides && overrides.hasOwnProperty('expiration') ? overrides.expiration! : "2025-10-15T03:16:10.147Z",
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '3aa114d4-20cb-4fd2-9290-71c41a2228ff',
        listId: overrides && overrides.hasOwnProperty('listId') ? overrides.listId! : 'collum',
        meta: overrides && overrides.hasOwnProperty('meta') ? overrides.meta! : relationshipsToOmit.has('ItemMeta') ? {} as ItemMeta : anItemMeta({}, relationshipsToOmit),
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'theca',
    };
};

export const aSuppressListItemFields = (overrides?: Partial<SuppressListItemFields>, _relationshipsToOmit: Set<string> = new Set()): SuppressListItemFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SuppressListItemFields');
    return {
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : true,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'trepide',
        expiration: overrides && overrides.hasOwnProperty('expiration') ? overrides.expiration! : "2025-06-05T04:58:46.102Z",
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'velit',
    };
};

export const aSuppressListItemPage = (overrides?: Partial<SuppressListItemPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SuppressListItemPage' } & SuppressListItemPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SuppressListItemPage');
    return {
        __typename: 'SuppressListItemPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('SuppressListItem') ? {} as SuppressListItem : aSuppressListItem({}, relationshipsToOmit), relationshipsToOmit.has('SuppressListItem') ? {} as SuppressListItem : aSuppressListItem({}, relationshipsToOmit), relationshipsToOmit.has('SuppressListItem') ? {} as SuppressListItem : aSuppressListItem({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 9978,
    };
};

export const aSuppressListItemSort = (overrides?: Partial<SuppressListItemSort>, _relationshipsToOmit: Set<string> = new Set()): SuppressListItemSort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SuppressListItemSort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : SuppressListItemSortableField.Active,
    };
};

export const aSuppressListPage = (overrides?: Partial<SuppressListPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SuppressListPage' } & SuppressListPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SuppressListPage');
    return {
        __typename: 'SuppressListPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('SuppressList') ? {} as SuppressList : aSuppressList({}, relationshipsToOmit), relationshipsToOmit.has('SuppressList') ? {} as SuppressList : aSuppressList({}, relationshipsToOmit), relationshipsToOmit.has('SuppressList') ? {} as SuppressList : aSuppressList({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 1113,
    };
};

export const aSwitchableOrg = (overrides?: Partial<SwitchableOrg>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'SwitchableOrg' } & SwitchableOrg => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('SwitchableOrg');
    return {
        __typename: 'SwitchableOrg',
        deployment: overrides && overrides.hasOwnProperty('deployment') ? overrides.deployment! : 'audentia',
        displayName: overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'sophismata',
        emailVerified: overrides && overrides.hasOwnProperty('emailVerified') ? overrides.emailVerified! : false,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ventosus',
        isCurrent: overrides && overrides.hasOwnProperty('isCurrent') ? overrides.isCurrent! : true,
        isEnabled: overrides && overrides.hasOwnProperty('isEnabled') ? overrides.isEnabled! : true,
        orgId: overrides && overrides.hasOwnProperty('orgId') ? overrides.orgId! : 'trado',
        path: overrides && overrides.hasOwnProperty('path') ? overrides.path! : 'conservo',
        subdomain: overrides && overrides.hasOwnProperty('subdomain') ? overrides.subdomain! : 'quam',
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'vulgo',
    };
};

export const aTagSchema = (overrides?: Partial<TagSchema>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'TagSchema' } & TagSchema => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TagSchema');
    return {
        __typename: 'TagSchema',
        contentTypeEnums: overrides && overrides.hasOwnProperty('contentTypeEnums') ? overrides.contentTypeEnums! : [TagContentType.CustomInsight, TagContentType.CustomInsight, TagContentType.CustomInsight],
        contentTypes: overrides && overrides.hasOwnProperty('contentTypes') ? overrides.contentTypes! : ['auxilium', 'dedecor', 'commodo'],
        freeform: overrides && overrides.hasOwnProperty('freeform') ? overrides.freeform! : false,
        key: overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'dens',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'exercitationem',
        valueOptionObjects: overrides && overrides.hasOwnProperty('valueOptionObjects') ? overrides.valueOptionObjects! : [relationshipsToOmit.has('TagSchemaValueOption') ? {} as TagSchemaValueOption : aTagSchemaValueOption({}, relationshipsToOmit), relationshipsToOmit.has('TagSchemaValueOption') ? {} as TagSchemaValueOption : aTagSchemaValueOption({}, relationshipsToOmit), relationshipsToOmit.has('TagSchemaValueOption') ? {} as TagSchemaValueOption : aTagSchemaValueOption({}, relationshipsToOmit)],
        valueOptions: overrides && overrides.hasOwnProperty('valueOptions') ? overrides.valueOptions! : 'thalassinus',
    };
};

export const aTagSchemaValueOption = (overrides?: Partial<TagSchemaValueOption>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'TagSchemaValueOption' } & TagSchemaValueOption => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TagSchemaValueOption');
    return {
        __typename: 'TagSchemaValueOption',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'Collection',
        link: overrides && overrides.hasOwnProperty('link') ? overrides.link! : 'https://attack.mitre.org/tactics/TA0009',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'TA0009',
    };
};

export const aTagSchemaValueOptionFields = (overrides?: Partial<TagSchemaValueOptionFields>, _relationshipsToOmit: Set<string> = new Set()): TagSchemaValueOptionFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TagSchemaValueOptionFields');
    return {
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'studio',
        link: overrides && overrides.hasOwnProperty('link') ? overrides.link! : 'maiores',
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'depereo',
    };
};

export const aTaxiiFeed = (overrides?: Partial<TaxiiFeed>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'TaxiiFeed' } & TaxiiFeed => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TaxiiFeed');
    return {
        __typename: 'TaxiiFeed',
        collections: overrides && overrides.hasOwnProperty('collections') ? overrides.collections! : 'vulnus',
        consecutiveFailureCount: overrides && overrides.hasOwnProperty('consecutiveFailureCount') ? overrides.consecutiveFailureCount! : 1153,
        defaultTtlDays: overrides && overrides.hasOwnProperty('defaultTtlDays') ? overrides.defaultTtlDays! : 7.3,
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        hasCertificate: overrides && overrides.hasOwnProperty('hasCertificate') ? overrides.hasCertificate! : false,
        hasCertificatePassword: overrides && overrides.hasOwnProperty('hasCertificatePassword') ? overrides.hasCertificatePassword! : true,
        hasPassword: overrides && overrides.hasOwnProperty('hasPassword') ? overrides.hasPassword! : false,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '8bee1942-d0d6-4b72-b568-45550cab9c52',
        lastPollSize: overrides && overrides.hasOwnProperty('lastPollSize') ? overrides.lastPollSize! : 4896,
        lastRun: overrides && overrides.hasOwnProperty('lastRun') ? overrides.lastRun! : "2025-04-08T10:33:55.939Z",
        lastTimeDataReceived: overrides && overrides.hasOwnProperty('lastTimeDataReceived') ? overrides.lastTimeDataReceived! : "2024-12-07T23:37:36.864Z",
        lastTimeFailed: overrides && overrides.hasOwnProperty('lastTimeFailed') ? overrides.lastTimeFailed! : "2025-05-25T22:57:48.920Z",
        maxLookbackDays: overrides && overrides.hasOwnProperty('maxLookbackDays') ? overrides.maxLookbackDays! : 7154,
        pollIntervalMinutes: overrides && overrides.hasOwnProperty('pollIntervalMinutes') ? overrides.pollIntervalMinutes! : 6779,
        recentFailures: overrides && overrides.hasOwnProperty('recentFailures') ? overrides.recentFailures! : [relationshipsToOmit.has('TaxiiFeedFailure') ? {} as TaxiiFeedFailure : aTaxiiFeedFailure({}, relationshipsToOmit), relationshipsToOmit.has('TaxiiFeedFailure') ? {} as TaxiiFeedFailure : aTaxiiFeedFailure({}, relationshipsToOmit), relationshipsToOmit.has('TaxiiFeedFailure') ? {} as TaxiiFeedFailure : aTaxiiFeedFailure({}, relationshipsToOmit)],
        subscriptionId: overrides && overrides.hasOwnProperty('subscriptionId') ? overrides.subscriptionId! : 'abundans',
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'volva',
        useTtlFromIndicators: overrides && overrides.hasOwnProperty('useTtlFromIndicators') ? overrides.useTtlFromIndicators! : true,
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'crapula',
    };
};

export const aTaxiiFeedFailure = (overrides?: Partial<TaxiiFeedFailure>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'TaxiiFeedFailure' } & TaxiiFeedFailure => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TaxiiFeedFailure');
    return {
        __typename: 'TaxiiFeedFailure',
        collectionName: overrides && overrides.hasOwnProperty('collectionName') ? overrides.collectionName! : 'tristis',
        error: overrides && overrides.hasOwnProperty('error') ? overrides.error! : 'certe',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-03-18T09:56:32.788Z",
    };
};

export const aTaxiiThreatIntelSourceFields = (overrides?: Partial<TaxiiThreatIntelSourceFields>, _relationshipsToOmit: Set<string> = new Set()): TaxiiThreatIntelSourceFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TaxiiThreatIntelSourceFields');
    return {
        certificate: overrides && overrides.hasOwnProperty('certificate') ? overrides.certificate! : 'cibo',
        certificatePassword: overrides && overrides.hasOwnProperty('certificatePassword') ? overrides.certificatePassword! : 'admitto',
        collections: overrides && overrides.hasOwnProperty('collections') ? overrides.collections! : 'utor',
        defaultTtlDays: overrides && overrides.hasOwnProperty('defaultTtlDays') ? overrides.defaultTtlDays! : 1.1,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'unde',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        maxLookbackDays: overrides && overrides.hasOwnProperty('maxLookbackDays') ? overrides.maxLookbackDays! : 2133,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'antiquus',
        password: overrides && overrides.hasOwnProperty('password') ? overrides.password! : 'admoveo',
        pollIntervalMinutes: overrides && overrides.hasOwnProperty('pollIntervalMinutes') ? overrides.pollIntervalMinutes! : 2424,
        subscriptionId: overrides && overrides.hasOwnProperty('subscriptionId') ? overrides.subscriptionId! : 'non',
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'pecto',
        useTtlFromIndicators: overrides && overrides.hasOwnProperty('useTtlFromIndicators') ? overrides.useTtlFromIndicators! : false,
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'vilis',
    };
};

export const aTeam = (overrides?: Partial<Team>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Team' } & Team => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Team');
    return {
        __typename: 'Team',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '120087074',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'CSIEM E2E User (Full Permissions)',
    };
};

export const aTeamPage = (overrides?: Partial<TeamPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'TeamPage' } & TeamPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TeamPage');
    return {
        __typename: 'TeamPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('Team') ? {} as Team : aTeam({}, relationshipsToOmit), relationshipsToOmit.has('Team') ? {} as Team : aTeam({}, relationshipsToOmit), relationshipsToOmit.has('Team') ? {} as Team : aTeam({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 9702,
    };
};

export const aTemplatedMatchRule = (overrides?: Partial<TemplatedMatchRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'TemplatedMatchRule' } & TemplatedMatchRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TemplatedMatchRule');
    return {
        __typename: 'TemplatedMatchRule',
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'uredo',
        autoDisabledReason: overrides && overrides.hasOwnProperty('autoDisabledReason') ? overrides.autoDisabledReason! : 'damnatio',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'stipes',
        contentType: overrides && overrides.hasOwnProperty('contentType') ? overrides.contentType! : ContentType.Anomaly,
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-03-29T14:59:00.575Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'caecus',
        createdByUser: overrides && overrides.hasOwnProperty('createdByUser') ? overrides.createdByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        deleted: overrides && overrides.hasOwnProperty('deleted') ? overrides.deleted! : false,
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'caritas',
        descriptionExpressionOverride: overrides && overrides.hasOwnProperty('descriptionExpressionOverride') ? overrides.descriptionExpressionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit)],
        entitySelectorsOverride: overrides && overrides.hasOwnProperty('entitySelectorsOverride') ? overrides.entitySelectorsOverride! : relationshipsToOmit.has('EntitySelectorsRuleOverride') ? {} as EntitySelectorsRuleOverride : anEntitySelectorsRuleOverride({}, relationshipsToOmit),
        exportJson: overrides && overrides.hasOwnProperty('exportJson') ? overrides.exportJson! : 'textus',
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'coaegresco',
        failing: overrides && overrides.hasOwnProperty('failing') ? overrides.failing! : true,
        hasOverride: overrides && overrides.hasOwnProperty('hasOverride') ? overrides.hasOverride! : true,
        history: overrides && overrides.hasOwnProperty('history') ? overrides.history! : [relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit)],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '946c2ff2-fd40-4cf7-85d1-c854cec99116',
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        isPrototypeOverride: overrides && overrides.hasOwnProperty('isPrototypeOverride') ? overrides.isPrototypeOverride! : relationshipsToOmit.has('BooleanRuleOverride') ? {} as BooleanRuleOverride : aBooleanRuleOverride({}, relationshipsToOmit),
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-01-17T12:59:10.846Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'solum',
        lastUpdatedByUser: overrides && overrides.hasOwnProperty('lastUpdatedByUser') ? overrides.lastUpdatedByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cunabula',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'nemo',
        nameExpressionOverride: overrides && overrides.hasOwnProperty('nameExpressionOverride') ? overrides.nameExpressionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        nameOverride: overrides && overrides.hasOwnProperty('nameOverride') ? overrides.nameOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : '400b9d32-c225-4176-9ade-7919ac270125',
        rawJson: overrides && overrides.hasOwnProperty('rawJson') ? overrides.rawJson! : 'canis',
        rawStatus: overrides && overrides.hasOwnProperty('rawStatus') ? overrides.rawStatus! : relationshipsToOmit.has('RuleStatus') ? {} as RuleStatus : aRuleStatus({}, relationshipsToOmit),
        ruleDescription: overrides && overrides.hasOwnProperty('ruleDescription') ? overrides.ruleDescription! : 'congregatio',
        ruleId: overrides && overrides.hasOwnProperty('ruleId') ? overrides.ruleId! : 3137,
        ruleSource: overrides && overrides.hasOwnProperty('ruleSource') ? overrides.ruleSource! : 'omnis',
        ruleType: overrides && overrides.hasOwnProperty('ruleType') ? overrides.ruleType! : 'cinis',
        scoreMapping: overrides && overrides.hasOwnProperty('scoreMapping') ? overrides.scoreMapping! : relationshipsToOmit.has('RuleScoreMapping') ? {} as RuleScoreMapping : aRuleScoreMapping({}, relationshipsToOmit),
        scoreMappingOverride: overrides && overrides.hasOwnProperty('scoreMappingOverride') ? overrides.scoreMappingOverride! : relationshipsToOmit.has('RuleScoreMappingRuleOverride') ? {} as RuleScoreMappingRuleOverride : aRuleScoreMappingRuleOverride({}, relationshipsToOmit),
        signalCount07d: overrides && overrides.hasOwnProperty('signalCount07d') ? overrides.signalCount07d! : 8758,
        signalCount24h: overrides && overrides.hasOwnProperty('signalCount24h') ? overrides.signalCount24h! : 3107,
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : relationshipsToOmit.has('RuleStatus') ? {} as RuleStatus : aRuleStatus({}, relationshipsToOmit),
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'contego',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'cruentus',
        summaryExpressionOverride: overrides && overrides.hasOwnProperty('summaryExpressionOverride') ? overrides.summaryExpressionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 5673,
        suppressionWindowSizeOverride: overrides && overrides.hasOwnProperty('suppressionWindowSizeOverride') ? overrides.suppressionWindowSizeOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['corrumpo', 'quo', 'tondeo'],
        tagsOverride: overrides && overrides.hasOwnProperty('tagsOverride') ? overrides.tagsOverride! : relationshipsToOmit.has('StringListRuleOverride') ? {} as StringListRuleOverride : aStringListRuleOverride({}, relationshipsToOmit),
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['calcar', 'communis', 'curto'],
        tuningExpressions: overrides && overrides.hasOwnProperty('tuningExpressions') ? overrides.tuningExpressions! : [relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit)],
    };
};

export const aTemplatedMatchRuleFields = (overrides?: Partial<TemplatedMatchRuleFields>, _relationshipsToOmit: Set<string> = new Set()): TemplatedMatchRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TemplatedMatchRuleFields');
    return {
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'consuasor',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'ipsum',
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'vetus',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'catena',
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'corroboro',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'defessus',
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : 'f5d587cb-891f-4aba-badc-02b5d73da2a9',
        scoreMapping: overrides && overrides.hasOwnProperty('scoreMapping') ? overrides.scoreMapping! : relationshipsToOmit.has('RuleScoreMappingFields') ? {} as RuleScoreMappingFields : aRuleScoreMappingFields({}, relationshipsToOmit),
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'terminatio',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'mollitia',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 9396,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['aegre', 'ultra', 'bene'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['187f9429-3b94-418f-a8ef-670d58223ca4', '8c8762c0-bad1-4993-b549-bfb4d067ae90', '3b4158ce-2435-4980-8f8f-0d51bd504dd8'],
    };
};

export const aThreatIntelItem = (overrides?: Partial<ThreatIntelItem>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ThreatIntelItem' } & ThreatIntelItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ThreatIntelItem');
    return {
        __typename: 'ThreatIntelItem',
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : true,
        expiration: overrides && overrides.hasOwnProperty('expiration') ? overrides.expiration! : "2024-12-14T15:10:08.297Z",
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '39416f58-82d0-4f33-876f-e5584374c759',
        listId: overrides && overrides.hasOwnProperty('listId') ? overrides.listId! : 'nesciunt',
        meta: overrides && overrides.hasOwnProperty('meta') ? overrides.meta! : relationshipsToOmit.has('ItemMeta') ? {} as ItemMeta : anItemMeta({}, relationshipsToOmit),
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : relationshipsToOmit.has('ThreatIntelSource') ? {} as ThreatIntelSource : aThreatIntelSource({}, relationshipsToOmit),
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'sono',
    };
};

export const aThreatIntelItemFields = (overrides?: Partial<ThreatIntelItemFields>, _relationshipsToOmit: Set<string> = new Set()): ThreatIntelItemFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ThreatIntelItemFields');
    return {
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : true,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'adfectus',
        expiration: overrides && overrides.hasOwnProperty('expiration') ? overrides.expiration! : "2025-05-08T22:22:47.258Z",
        value: overrides && overrides.hasOwnProperty('value') ? overrides.value! : 'absconditus',
    };
};

export const aThreatIntelItemPage = (overrides?: Partial<ThreatIntelItemPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ThreatIntelItemPage' } & ThreatIntelItemPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ThreatIntelItemPage');
    return {
        __typename: 'ThreatIntelItemPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('ThreatIntelItem') ? {} as ThreatIntelItem : aThreatIntelItem({}, relationshipsToOmit), relationshipsToOmit.has('ThreatIntelItem') ? {} as ThreatIntelItem : aThreatIntelItem({}, relationshipsToOmit), relationshipsToOmit.has('ThreatIntelItem') ? {} as ThreatIntelItem : aThreatIntelItem({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 7296,
    };
};

export const aThreatIntelItemSort = (overrides?: Partial<ThreatIntelItemSort>, _relationshipsToOmit: Set<string> = new Set()): ThreatIntelItemSort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ThreatIntelItemSort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : ThreatIntelItemSortableField.Active,
    };
};

export const aThreatIntelSource = (overrides?: Partial<ThreatIntelSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ThreatIntelSource' } & ThreatIntelSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ThreatIntelSource');
    return {
        __typename: 'ThreatIntelSource',
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-03-18T08:58:28.935Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'suffoco',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'celo',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '02fa64c5-fb69-4dbf-92de-84162d553b0c',
        idefenseConfig: overrides && overrides.hasOwnProperty('idefenseConfig') ? overrides.idefenseConfig! : relationshipsToOmit.has('IdefenseConfig') ? {} as IdefenseConfig : anIdefenseConfig({}, relationshipsToOmit),
        items: overrides && overrides.hasOwnProperty('items') ? overrides.items! : relationshipsToOmit.has('ThreatIntelItemPage') ? {} as ThreatIntelItemPage : aThreatIntelItemPage({}, relationshipsToOmit),
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-04-30T14:25:18.466Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'delego',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'altus',
        sourceType: overrides && overrides.hasOwnProperty('sourceType') ? overrides.sourceType! : ThreatIntelSourceType.Anomali,
        taxiiFeed: overrides && overrides.hasOwnProperty('taxiiFeed') ? overrides.taxiiFeed! : relationshipsToOmit.has('TaxiiFeed') ? {} as TaxiiFeed : aTaxiiFeed({}, relationshipsToOmit),
        threatQConfig: overrides && overrides.hasOwnProperty('threatQConfig') ? overrides.threatQConfig! : relationshipsToOmit.has('ThreatQConfig') ? {} as ThreatQConfig : aThreatQConfig({}, relationshipsToOmit),
    };
};

export const aThreatIntelSourcePage = (overrides?: Partial<ThreatIntelSourcePage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ThreatIntelSourcePage' } & ThreatIntelSourcePage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ThreatIntelSourcePage');
    return {
        __typename: 'ThreatIntelSourcePage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('ThreatIntelSource') ? {} as ThreatIntelSource : aThreatIntelSource({}, relationshipsToOmit), relationshipsToOmit.has('ThreatIntelSource') ? {} as ThreatIntelSource : aThreatIntelSource({}, relationshipsToOmit), relationshipsToOmit.has('ThreatIntelSource') ? {} as ThreatIntelSource : aThreatIntelSource({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 5277,
    };
};

export const aThreatQConfig = (overrides?: Partial<ThreatQConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ThreatQConfig' } & ThreatQConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ThreatQConfig');
    return {
        __typename: 'ThreatQConfig',
        baseUrl: overrides && overrides.hasOwnProperty('baseUrl') ? overrides.baseUrl! : 'aranea',
        clientId: overrides && overrides.hasOwnProperty('clientId') ? overrides.clientId! : 'sulum',
        customFiltersJson: overrides && overrides.hasOwnProperty('customFiltersJson') ? overrides.customFiltersJson! : 'abstergo',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        extraHeaders: overrides && overrides.hasOwnProperty('extraHeaders') ? overrides.extraHeaders! : 'carus',
        hasCertificate: overrides && overrides.hasOwnProperty('hasCertificate') ? overrides.hasCertificate! : true,
        pollIntervalMinutes: overrides && overrides.hasOwnProperty('pollIntervalMinutes') ? overrides.pollIntervalMinutes! : 3558,
        useExpiration: overrides && overrides.hasOwnProperty('useExpiration') ? overrides.useExpiration! : true,
    };
};

export const aThreatQThreatIntelSourceFields = (overrides?: Partial<ThreatQThreatIntelSourceFields>, _relationshipsToOmit: Set<string> = new Set()): ThreatQThreatIntelSourceFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ThreatQThreatIntelSourceFields');
    return {
        baseUrl: overrides && overrides.hasOwnProperty('baseUrl') ? overrides.baseUrl! : 'rem',
        certificate: overrides && overrides.hasOwnProperty('certificate') ? overrides.certificate! : 'stultus',
        clientId: overrides && overrides.hasOwnProperty('clientId') ? overrides.clientId! : 'admitto',
        clientSecret: overrides && overrides.hasOwnProperty('clientSecret') ? overrides.clientSecret! : 'solutio',
        customFiltersJson: overrides && overrides.hasOwnProperty('customFiltersJson') ? overrides.customFiltersJson! : 'vesica',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'degero',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        extraHeaders: overrides && overrides.hasOwnProperty('extraHeaders') ? overrides.extraHeaders! : 'campana',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'bibo',
        pollIntervalMinutes: overrides && overrides.hasOwnProperty('pollIntervalMinutes') ? overrides.pollIntervalMinutes! : 6380,
        useExpiration: overrides && overrides.hasOwnProperty('useExpiration') ? overrides.useExpiration! : false,
    };
};

export const aThresholdRule = (overrides?: Partial<ThresholdRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'ThresholdRule' } & ThresholdRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ThresholdRule');
    return {
        __typename: 'ThresholdRule',
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'ait',
        autoDisabledReason: overrides && overrides.hasOwnProperty('autoDisabledReason') ? overrides.autoDisabledReason! : 'demo',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'damnatio',
        contentType: overrides && overrides.hasOwnProperty('contentType') ? overrides.contentType! : ContentType.Anomaly,
        countDistinct: overrides && overrides.hasOwnProperty('countDistinct') ? overrides.countDistinct! : true,
        countField: overrides && overrides.hasOwnProperty('countField') ? overrides.countField! : 'curis',
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-02-25T10:24:29.248Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'articulus',
        createdByUser: overrides && overrides.hasOwnProperty('createdByUser') ? overrides.createdByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        deleted: overrides && overrides.hasOwnProperty('deleted') ? overrides.deleted! : true,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'valens',
        descriptionOverride: overrides && overrides.hasOwnProperty('descriptionOverride') ? overrides.descriptionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('OutputEntitySelectorType') ? {} as OutputEntitySelectorType : anOutputEntitySelectorType({}, relationshipsToOmit)],
        entitySelectorsOverride: overrides && overrides.hasOwnProperty('entitySelectorsOverride') ? overrides.entitySelectorsOverride! : relationshipsToOmit.has('EntitySelectorsRuleOverride') ? {} as EntitySelectorsRuleOverride : anEntitySelectorsRuleOverride({}, relationshipsToOmit),
        exportJson: overrides && overrides.hasOwnProperty('exportJson') ? overrides.exportJson! : 'bis',
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'textor',
        failing: overrides && overrides.hasOwnProperty('failing') ? overrides.failing! : false,
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['mollitia', 'eaque', 'aliquid'],
        groupByFieldsOverride: overrides && overrides.hasOwnProperty('groupByFieldsOverride') ? overrides.groupByFieldsOverride! : relationshipsToOmit.has('StringListRuleOverride') ? {} as StringListRuleOverride : aStringListRuleOverride({}, relationshipsToOmit),
        hasOverride: overrides && overrides.hasOwnProperty('hasOverride') ? overrides.hasOverride! : false,
        history: overrides && overrides.hasOwnProperty('history') ? overrides.history! : [relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit)],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'ad0b5ce7-877a-43d5-9a1d-90145b6f078d',
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        isPrototypeOverride: overrides && overrides.hasOwnProperty('isPrototypeOverride') ? overrides.isPrototypeOverride! : relationshipsToOmit.has('BooleanRuleOverride') ? {} as BooleanRuleOverride : aBooleanRuleOverride({}, relationshipsToOmit),
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-06-25T14:30:19.964Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'defleo',
        lastUpdatedByUser: overrides && overrides.hasOwnProperty('lastUpdatedByUser') ? overrides.lastUpdatedByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        limit: overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 8666,
        limitOverride: overrides && overrides.hasOwnProperty('limitOverride') ? overrides.limitOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'velum',
        nameOverride: overrides && overrides.hasOwnProperty('nameOverride') ? overrides.nameOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : '9a1715cd-2f86-49cf-899c-25770227a247',
        rawJson: overrides && overrides.hasOwnProperty('rawJson') ? overrides.rawJson! : 'corrupti',
        rawStatus: overrides && overrides.hasOwnProperty('rawStatus') ? overrides.rawStatus! : relationshipsToOmit.has('RuleStatus') ? {} as RuleStatus : aRuleStatus({}, relationshipsToOmit),
        ruleDescription: overrides && overrides.hasOwnProperty('ruleDescription') ? overrides.ruleDescription! : 'strues',
        ruleId: overrides && overrides.hasOwnProperty('ruleId') ? overrides.ruleId! : 57,
        ruleSource: overrides && overrides.hasOwnProperty('ruleSource') ? overrides.ruleSource! : 'turba',
        ruleType: overrides && overrides.hasOwnProperty('ruleType') ? overrides.ruleType! : 'thorax',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 6336,
        scoreOverride: overrides && overrides.hasOwnProperty('scoreOverride') ? overrides.scoreOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
        signalCount07d: overrides && overrides.hasOwnProperty('signalCount07d') ? overrides.signalCount07d! : 6456,
        signalCount24h: overrides && overrides.hasOwnProperty('signalCount24h') ? overrides.signalCount24h! : 6783,
        status: overrides && overrides.hasOwnProperty('status') ? overrides.status! : relationshipsToOmit.has('RuleStatus') ? {} as RuleStatus : aRuleStatus({}, relationshipsToOmit),
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'corona',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'caute',
        summaryExpressionOverride: overrides && overrides.hasOwnProperty('summaryExpressionOverride') ? overrides.summaryExpressionOverride! : relationshipsToOmit.has('StringRuleOverride') ? {} as StringRuleOverride : aStringRuleOverride({}, relationshipsToOmit),
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 5924,
        suppressionWindowSizeOverride: overrides && overrides.hasOwnProperty('suppressionWindowSizeOverride') ? overrides.suppressionWindowSizeOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['conitor', 'odio', 'appositus'],
        tagsOverride: overrides && overrides.hasOwnProperty('tagsOverride') ? overrides.tagsOverride! : relationshipsToOmit.has('StringListRuleOverride') ? {} as StringListRuleOverride : aStringListRuleOverride({}, relationshipsToOmit),
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['vorago', 'deleniti', 'capillus'],
        tuningExpressions: overrides && overrides.hasOwnProperty('tuningExpressions') ? overrides.tuningExpressions! : [relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit), relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit)],
        version: overrides && overrides.hasOwnProperty('version') ? overrides.version! : 2506,
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : 4416,
        windowSizeName: overrides && overrides.hasOwnProperty('windowSizeName') ? overrides.windowSizeName! : 'concido',
        windowSizeOverride: overrides && overrides.hasOwnProperty('windowSizeOverride') ? overrides.windowSizeOverride! : relationshipsToOmit.has('IntRuleOverride') ? {} as IntRuleOverride : anIntRuleOverride({}, relationshipsToOmit),
    };
};

export const aThresholdRuleFields = (overrides?: Partial<ThresholdRuleFields>, _relationshipsToOmit: Set<string> = new Set()): ThresholdRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('ThresholdRuleFields');
    return {
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'amplexus',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'ver',
        countDistinct: overrides && overrides.hasOwnProperty('countDistinct') ? overrides.countDistinct! : true,
        countField: overrides && overrides.hasOwnProperty('countField') ? overrides.countField! : 'caelum',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'bellum',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'iste',
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['colo', 'amet', 'delectatio'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        limit: overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 9333,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'consequatur',
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : '8d5deb9d-2a86-41f2-baf2-63d54cf5ec4e',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 7870,
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'comminor',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'cauda',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 9312,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['valeo', 'tamen', 'veritatis'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['c771c29f-eb45-4961-9445-c14eb72ab464', '562728f5-506d-4c72-b992-ee6bedfbe881', 'e922c67d-72f0-47cc-8da7-3ea807d460d1'],
        version: overrides && overrides.hasOwnProperty('version') ? overrides.version! : 1047,
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : RuleWindowSizeEnum.Custom,
        windowSizeMilliseconds: overrides && overrides.hasOwnProperty('windowSizeMilliseconds') ? overrides.windowSizeMilliseconds! : 744771496462344,
    };
};

export const aTier = (overrides?: Partial<Tier>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Tier' } & Tier => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Tier');
    return {
        __typename: 'Tier',
        analyticsTier: overrides && overrides.hasOwnProperty('analyticsTier') ? overrides.analyticsTier! : 'cognatus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'tubineus',
    };
};

export const aTiersPage = (overrides?: Partial<TiersPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'TiersPage' } & TiersPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TiersPage');
    return {
        __typename: 'TiersPage',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : [relationshipsToOmit.has('Tier') ? {} as Tier : aTier({}, relationshipsToOmit), relationshipsToOmit.has('Tier') ? {} as Tier : aTier({}, relationshipsToOmit), relationshipsToOmit.has('Tier') ? {} as Tier : aTier({}, relationshipsToOmit)],
        next: overrides && overrides.hasOwnProperty('next') ? overrides.next! : 'in',
    };
};

export const aTimeGroupBy = (overrides?: Partial<TimeGroupBy>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'TimeGroupBy' } & TimeGroupBy => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TimeGroupBy');
    return {
        __typename: 'TimeGroupBy',
        fieldValue: overrides && overrides.hasOwnProperty('fieldValue') ? overrides.fieldValue! : 'pel',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : 'creber',
    };
};

export const aTriage = (overrides?: Partial<Triage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'Triage' } & Triage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('Triage');
    return {
        __typename: 'Triage',
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '747c3714-be53-4e41-8c5a-bb6c3443824e',
        insightID: overrides && overrides.hasOwnProperty('insightID') ? overrides.insightID! : 'b0ad8a93-0901-4751-9936-806ea245b6c5',
        keyEvidences: overrides && overrides.hasOwnProperty('keyEvidences') ? overrides.keyEvidences! : [relationshipsToOmit.has('KeyEvidence') ? {} as KeyEvidence : aKeyEvidence({}, relationshipsToOmit), relationshipsToOmit.has('KeyEvidence') ? {} as KeyEvidence : aKeyEvidence({}, relationshipsToOmit), relationshipsToOmit.has('KeyEvidence') ? {} as KeyEvidence : aKeyEvidence({}, relationshipsToOmit)],
        recommendation: overrides && overrides.hasOwnProperty('recommendation') ? overrides.recommendation! : relationshipsToOmit.has('TriageRecommendation') ? {} as TriageRecommendation : aTriageRecommendation({}, relationshipsToOmit),
        summary: overrides && overrides.hasOwnProperty('summary') ? overrides.summary! : 'theatrum',
        verdict: overrides && overrides.hasOwnProperty('verdict') ? overrides.verdict! : TriageVerdict.Benign,
    };
};

export const aTriageRecommendation = (overrides?: Partial<TriageRecommendation>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'TriageRecommendation' } & TriageRecommendation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TriageRecommendation');
    return {
        __typename: 'TriageRecommendation',
        accepted: overrides && overrides.hasOwnProperty('accepted') ? overrides.accepted! : true,
        severity: overrides && overrides.hasOwnProperty('severity') ? overrides.severity! : InsightSeverityPyEnum.Critical,
    };
};

export const aTrialPlan = (overrides?: Partial<TrialPlan>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'TrialPlan' } & TrialPlan => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('TrialPlan');
    return {
        __typename: 'TrialPlan',
        daysLeft: overrides && overrides.hasOwnProperty('daysLeft') ? overrides.daysLeft! : 4074,
        planName: overrides && overrides.hasOwnProperty('planName') ? overrides.planName! : 'canis',
    };
};

export const anUninviteUser = (overrides?: Partial<UninviteUser>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UninviteUser' } & UninviteUser => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UninviteUser');
    return {
        __typename: 'UninviteUser',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const anUnknownTeam = (overrides?: Partial<UnknownTeam>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UnknownTeam' } & UnknownTeam => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UnknownTeam');
    return {
        __typename: 'UnknownTeam',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'amita',
    };
};

export const anUnknownUser = (overrides?: Partial<UnknownUser>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UnknownUser' } & UnknownUser => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UnknownUser');
    return {
        __typename: 'UnknownUser',
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'armarium',
    };
};

export const anUnstructuredLogMappingFields = (overrides?: Partial<UnstructuredLogMappingFields>, _relationshipsToOmit: Set<string> = new Set()): UnstructuredLogMappingFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UnstructuredLogMappingFields');
    return {
        patternNames: overrides && overrides.hasOwnProperty('patternNames') ? overrides.patternNames! : ['vulgus', 'caelestis', 'coepi'],
    };
};

export const anUnstructuredLogMappingFieldsApi = (overrides?: Partial<UnstructuredLogMappingFieldsApi>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UnstructuredLogMappingFieldsApi' } & UnstructuredLogMappingFieldsApi => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UnstructuredLogMappingFieldsApi');
    return {
        __typename: 'UnstructuredLogMappingFieldsApi',
        patternNames: overrides && overrides.hasOwnProperty('patternNames') ? overrides.patternNames! : ['celer', 'infit', 'temporibus'],
    };
};

export const anUpdatableAnomaliThreatIntelSourceFields = (overrides?: Partial<UpdatableAnomaliThreatIntelSourceFields>, _relationshipsToOmit: Set<string> = new Set()): UpdatableAnomaliThreatIntelSourceFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatableAnomaliThreatIntelSourceFields');
    return {
        apiKey: overrides && overrides.hasOwnProperty('apiKey') ? overrides.apiKey! : 'universe',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'curatio',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : 'caries',
        filter: overrides && overrides.hasOwnProperty('filter') ? overrides.filter! : 'bellum',
        inactiveFilter: overrides && overrides.hasOwnProperty('inactiveFilter') ? overrides.inactiveFilter! : 'trans',
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'sto',
    };
};

export const anUpdatableContextActionFields = (overrides?: Partial<UpdatableContextActionFields>, _relationshipsToOmit: Set<string> = new Set()): UpdatableContextActionFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatableContextActionFields');
    return {
        allRecordFields: overrides && overrides.hasOwnProperty('allRecordFields') ? overrides.allRecordFields! : false,
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entityTypes: overrides && overrides.hasOwnProperty('entityTypes') ? overrides.entityTypes! : ['caelum', 'sustineo', 'tum'],
        iocTypes: overrides && overrides.hasOwnProperty('iocTypes') ? overrides.iocTypes! : [ContextActionIocType.Asn, ContextActionIocType.Asn, ContextActionIocType.Asn],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'crudelis',
        recordFields: overrides && overrides.hasOwnProperty('recordFields') ? overrides.recordFields! : ['nesciunt', 'curriculum', 'peccatus'],
        template: overrides && overrides.hasOwnProperty('template') ? overrides.template! : 'solium',
        type: overrides && overrides.hasOwnProperty('type') ? overrides.type! : ContextActionType.Query,
        urlTemplate: overrides && overrides.hasOwnProperty('urlTemplate') ? overrides.urlTemplate! : 'texo',
    };
};

export const anUpdatableCustomThreatIntelSourceFields = (overrides?: Partial<UpdatableCustomThreatIntelSourceFields>, _relationshipsToOmit: Set<string> = new Set()): UpdatableCustomThreatIntelSourceFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatableCustomThreatIntelSourceFields');
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'deleniti',
    };
};

export const anUpdatableCustomYaraSourceFields = (overrides?: Partial<UpdatableCustomYaraSourceFields>, _relationshipsToOmit: Set<string> = new Set()): UpdatableCustomYaraSourceFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatableCustomYaraSourceFields');
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'fugiat',
    };
};

export const anUpdatableFavoriteFieldFields = (overrides?: Partial<UpdatableFavoriteFieldFields>, _relationshipsToOmit: Set<string> = new Set()): UpdatableFavoriteFieldFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatableFavoriteFieldFields');
    return {
        applyToAllObjectTypes: overrides && overrides.hasOwnProperty('applyToAllObjectTypes') ? overrides.applyToAllObjectTypes! : true,
        associatedObjectTypes: overrides && overrides.hasOwnProperty('associatedObjectTypes') ? overrides.associatedObjectTypes! : ['theatrum', 'vesco', 'comparo'],
        fieldName: overrides && overrides.hasOwnProperty('fieldName') ? overrides.fieldName! : 'artificiose',
    };
};

export const anUpdatableGithubYaraSourceFields = (overrides?: Partial<UpdatableGithubYaraSourceFields>, _relationshipsToOmit: Set<string> = new Set()): UpdatableGithubYaraSourceFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatableGithubYaraSourceFields');
    return {
        branch: overrides && overrides.hasOwnProperty('branch') ? overrides.branch! : 'quaerat',
        defaultSeverity: overrides && overrides.hasOwnProperty('defaultSeverity') ? overrides.defaultSeverity! : 5049,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'aggredior',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        token: overrides && overrides.hasOwnProperty('token') ? overrides.token! : 'surculus',
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'deduco',
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'pecus',
        yaraFileRegex: overrides && overrides.hasOwnProperty('yaraFileRegex') ? overrides.yaraFileRegex! : 'in',
    };
};

export const anUpdatableIdefenseThreatIntelSourceFields = (overrides?: Partial<UpdatableIdefenseThreatIntelSourceFields>, _relationshipsToOmit: Set<string> = new Set()): UpdatableIdefenseThreatIntelSourceFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatableIdefenseThreatIntelSourceFields');
    return {
        apiKey: overrides && overrides.hasOwnProperty('apiKey') ? overrides.apiKey! : 'agnosco',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'corporis',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
    };
};

export const anUpdatableMatchListFields = (overrides?: Partial<UpdatableMatchListFields>, _relationshipsToOmit: Set<string> = new Set()): UpdatableMatchListFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatableMatchListFields');
    return {
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : true,
        defaultTtl: overrides && overrides.hasOwnProperty('defaultTtl') ? overrides.defaultTtl! : 7781,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'demitto',
    };
};

export const anUpdatableMatchListItemFields = (overrides?: Partial<UpdatableMatchListItemFields>, _relationshipsToOmit: Set<string> = new Set()): UpdatableMatchListItemFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatableMatchListItemFields');
    return {
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : true,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'aliquam',
        expiration: overrides && overrides.hasOwnProperty('expiration') ? overrides.expiration! : "2025-06-05T05:18:40.775Z",
    };
};

export const anUpdatableNetworkBlockFields = (overrides?: Partial<UpdatableNetworkBlockFields>, _relationshipsToOmit: Set<string> = new Set()): UpdatableNetworkBlockFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatableNetworkBlockFields');
    return {
        addressBlock: overrides && overrides.hasOwnProperty('addressBlock') ? overrides.addressBlock! : 'defetiscor',
        internal: overrides && overrides.hasOwnProperty('internal') ? overrides.internal! : false,
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'dicta',
        suppressesSignals: overrides && overrides.hasOwnProperty('suppressesSignals') ? overrides.suppressesSignals! : false,
    };
};

export const anUpdatableSuppressListFields = (overrides?: Partial<UpdatableSuppressListFields>, _relationshipsToOmit: Set<string> = new Set()): UpdatableSuppressListFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatableSuppressListFields');
    return {
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : true,
        defaultTtl: overrides && overrides.hasOwnProperty('defaultTtl') ? overrides.defaultTtl! : 5804,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'culpo',
    };
};

export const anUpdatableSuppressListItemFields = (overrides?: Partial<UpdatableSuppressListItemFields>, _relationshipsToOmit: Set<string> = new Set()): UpdatableSuppressListItemFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatableSuppressListItemFields');
    return {
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : false,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'architecto',
        expiration: overrides && overrides.hasOwnProperty('expiration') ? overrides.expiration! : "2025-08-17T22:12:55.788Z",
    };
};

export const anUpdatableTaxiiThreatIntelSourceFields = (overrides?: Partial<UpdatableTaxiiThreatIntelSourceFields>, _relationshipsToOmit: Set<string> = new Set()): UpdatableTaxiiThreatIntelSourceFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatableTaxiiThreatIntelSourceFields');
    return {
        certificate: overrides && overrides.hasOwnProperty('certificate') ? overrides.certificate! : 'blandior',
        certificatePassword: overrides && overrides.hasOwnProperty('certificatePassword') ? overrides.certificatePassword! : 'commemoro',
        collections: overrides && overrides.hasOwnProperty('collections') ? overrides.collections! : 'statim',
        defaultTtlDays: overrides && overrides.hasOwnProperty('defaultTtlDays') ? overrides.defaultTtlDays! : 7.5,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'vergo',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        maxLookbackDays: overrides && overrides.hasOwnProperty('maxLookbackDays') ? overrides.maxLookbackDays! : 8178,
        password: overrides && overrides.hasOwnProperty('password') ? overrides.password! : 'facilis',
        pollIntervalMinutes: overrides && overrides.hasOwnProperty('pollIntervalMinutes') ? overrides.pollIntervalMinutes! : 715,
        subscriptionId: overrides && overrides.hasOwnProperty('subscriptionId') ? overrides.subscriptionId! : 'spargo',
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'corpus',
        useTtlFromIndicators: overrides && overrides.hasOwnProperty('useTtlFromIndicators') ? overrides.useTtlFromIndicators! : false,
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'candidus',
    };
};

export const anUpdatableThreatIntelItemFields = (overrides?: Partial<UpdatableThreatIntelItemFields>, _relationshipsToOmit: Set<string> = new Set()): UpdatableThreatIntelItemFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatableThreatIntelItemFields');
    return {
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : false,
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'tametsi',
        expiration: overrides && overrides.hasOwnProperty('expiration') ? overrides.expiration! : "2025-08-24T08:58:35.719Z",
    };
};

export const anUpdatableThreatQThreatIntelSourceFields = (overrides?: Partial<UpdatableThreatQThreatIntelSourceFields>, _relationshipsToOmit: Set<string> = new Set()): UpdatableThreatQThreatIntelSourceFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatableThreatQThreatIntelSourceFields');
    return {
        baseUrl: overrides && overrides.hasOwnProperty('baseUrl') ? overrides.baseUrl! : 'auxilium',
        certificate: overrides && overrides.hasOwnProperty('certificate') ? overrides.certificate! : 'tutis',
        clientId: overrides && overrides.hasOwnProperty('clientId') ? overrides.clientId! : 'tutamen',
        clientSecret: overrides && overrides.hasOwnProperty('clientSecret') ? overrides.clientSecret! : 'tredecim',
        customFiltersJson: overrides && overrides.hasOwnProperty('customFiltersJson') ? overrides.customFiltersJson! : 'crustulum',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'apud',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        extraHeaders: overrides && overrides.hasOwnProperty('extraHeaders') ? overrides.extraHeaders! : 'ventus',
        pollIntervalMinutes: overrides && overrides.hasOwnProperty('pollIntervalMinutes') ? overrides.pollIntervalMinutes! : 2341,
        useExpiration: overrides && overrides.hasOwnProperty('useExpiration') ? overrides.useExpiration! : false,
    };
};

export const anUpdateAction = (overrides?: Partial<UpdateAction>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateAction' } & UpdateAction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateAction');
    return {
        __typename: 'UpdateAction',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Action') ? {} as Action : anAction({}, relationshipsToOmit),
    };
};

export const anUpdateAggregationRule = (overrides?: Partial<UpdateAggregationRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateAggregationRule' } & UpdateAggregationRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateAggregationRule');
    return {
        __typename: 'UpdateAggregationRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('AggregationRule') ? {} as AggregationRule : anAggregationRule({}, relationshipsToOmit),
    };
};

export const anUpdateAggregationRuleFields = (overrides?: Partial<UpdateAggregationRuleFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateAggregationRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateAggregationRuleFields');
    return {
        aggregationFunctions: overrides && overrides.hasOwnProperty('aggregationFunctions') ? overrides.aggregationFunctions! : [relationshipsToOmit.has('AggregationRuleAggregationFunctionField') ? {} as AggregationRuleAggregationFunctionField : anAggregationRuleAggregationFunctionField({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRuleAggregationFunctionField') ? {} as AggregationRuleAggregationFunctionField : anAggregationRuleAggregationFunctionField({}, relationshipsToOmit), relationshipsToOmit.has('AggregationRuleAggregationFunctionField') ? {} as AggregationRuleAggregationFunctionField : anAggregationRuleAggregationFunctionField({}, relationshipsToOmit)],
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'corrupti',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'molestias',
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'damnatio',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        groupByAsset: overrides && overrides.hasOwnProperty('groupByAsset') ? overrides.groupByAsset! : true,
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['acceptus', 'umquam', 'callide'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        matchExpression: overrides && overrides.hasOwnProperty('matchExpression') ? overrides.matchExpression! : 'testimonium',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'quo',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'angulus',
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : '165c5866-6917-485b-b5b9-64cde886a7c3',
        scoreMapping: overrides && overrides.hasOwnProperty('scoreMapping') ? overrides.scoreMapping! : relationshipsToOmit.has('RuleScoreMappingFields') ? {} as RuleScoreMappingFields : aRuleScoreMappingFields({}, relationshipsToOmit),
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'blanditiis',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'compello',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 95,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['occaecati', 'abeo', 'bellum'],
        triggerExpression: overrides && overrides.hasOwnProperty('triggerExpression') ? overrides.triggerExpression! : 'aegre',
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['21053897-e3fc-452c-be94-f6d5f88b76ad', '3bb73cd0-afbb-460e-b68a-098ca1f79f5e', '47d6b54e-da7f-4a4b-90ab-7c9ff15c1b1e'],
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : RuleWindowSizeEnum.Custom,
        windowSizeMilliseconds: overrides && overrides.hasOwnProperty('windowSizeMilliseconds') ? overrides.windowSizeMilliseconds! : 25996189180113,
    };
};

export const anUpdateAnomaliThreatIntelSource = (overrides?: Partial<UpdateAnomaliThreatIntelSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateAnomaliThreatIntelSource' } & UpdateAnomaliThreatIntelSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateAnomaliThreatIntelSource');
    return {
        __typename: 'UpdateAnomaliThreatIntelSource',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ThreatIntelSource') ? {} as ThreatIntelSource : aThreatIntelSource({}, relationshipsToOmit),
    };
};

export const anUpdateAssignedInsightEmailsEnabled = (overrides?: Partial<UpdateAssignedInsightEmailsEnabled>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateAssignedInsightEmailsEnabled' } & UpdateAssignedInsightEmailsEnabled => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateAssignedInsightEmailsEnabled');
    return {
        __typename: 'UpdateAssignedInsightEmailsEnabled',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const anUpdateAutomation = (overrides?: Partial<UpdateAutomation>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateAutomation' } & UpdateAutomation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateAutomation');
    return {
        __typename: 'UpdateAutomation',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Automation') ? {} as Automation : anAutomation({}, relationshipsToOmit),
    };
};

export const anUpdateAutomationFields = (overrides?: Partial<UpdateAutomationFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateAutomationFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateAutomationFields');
    return {
        cseResourceSubTypes: overrides && overrides.hasOwnProperty('cseResourceSubTypes') ? overrides.cseResourceSubTypes! : ['aedificium', 'caveo', 'vespillo'],
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        executionTypes: overrides && overrides.hasOwnProperty('executionTypes') ? overrides.executionTypes! : ['cursus', 'caste', 'depereo'],
    };
};

export const anUpdateBuiltInRule = (overrides?: Partial<UpdateBuiltInRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateBuiltInRule' } & UpdateBuiltInRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateBuiltInRule');
    return {
        __typename: 'UpdateBuiltInRule',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const anUpdateBuiltInRuleFields = (overrides?: Partial<UpdateBuiltInRuleFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateBuiltInRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateBuiltInRuleFields');
    return {
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : false,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'volaticus',
        ruleDescription: overrides && overrides.hasOwnProperty('ruleDescription') ? overrides.ruleDescription! : 'dapifer',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'adicio',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 3110,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['ver', 'cursim', 'numquam'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['89d11d8a-bbc1-47e4-91e0-b5aa07abfa10', 'f9bc09b0-55b6-452d-8cc4-9f5bd9f929c6', '2a9e646a-a560-49ba-8ab0-4b1783c670a3'],
    };
};

export const anUpdateChainRule = (overrides?: Partial<UpdateChainRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateChainRule' } & UpdateChainRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateChainRule');
    return {
        __typename: 'UpdateChainRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ChainRule') ? {} as ChainRule : aChainRule({}, relationshipsToOmit),
    };
};

export const anUpdateChainRuleFields = (overrides?: Partial<UpdateChainRuleFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateChainRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateChainRuleFields');
    return {
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'vicinus',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'dolores',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'correptius',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        expressionsAndLimits: overrides && overrides.hasOwnProperty('expressionsAndLimits') ? overrides.expressionsAndLimits! : [relationshipsToOmit.has('ChainRuleExpressionAndLimitField') ? {} as ChainRuleExpressionAndLimitField : aChainRuleExpressionAndLimitField({}, relationshipsToOmit), relationshipsToOmit.has('ChainRuleExpressionAndLimitField') ? {} as ChainRuleExpressionAndLimitField : aChainRuleExpressionAndLimitField({}, relationshipsToOmit), relationshipsToOmit.has('ChainRuleExpressionAndLimitField') ? {} as ChainRuleExpressionAndLimitField : aChainRuleExpressionAndLimitField({}, relationshipsToOmit)],
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['inventore', 'id', 'verbera'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'volubilis',
        ordered: overrides && overrides.hasOwnProperty('ordered') ? overrides.ordered! : true,
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : 'bcb6bf7f-147a-4d28-be26-90df9bbcd9e3',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 9877,
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'conitor',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'abstergo',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 466,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['decerno', 'commemoro', 'ago'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['27c4ed3b-5515-405c-9711-103a2b72c792', 'f42a1bdc-913a-428d-b1b5-076729a75cfb', 'e573d166-14bd-413c-95a9-0bb0985853d2'],
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : RuleWindowSizeEnum.Custom,
        windowSizeMilliseconds: overrides && overrides.hasOwnProperty('windowSizeMilliseconds') ? overrides.windowSizeMilliseconds! : 474692202892767,
    };
};

export const anUpdateContextAction = (overrides?: Partial<UpdateContextAction>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateContextAction' } & UpdateContextAction => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateContextAction');
    return {
        __typename: 'UpdateContextAction',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ContextAction') ? {} as ContextAction : aContextAction({}, relationshipsToOmit),
    };
};

export const anUpdateCurrentUser = (overrides?: Partial<UpdateCurrentUser>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateCurrentUser' } & UpdateCurrentUser => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCurrentUser');
    return {
        __typename: 'UpdateCurrentUser',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('CurrentUser') ? {} as CurrentUser : aCurrentUser({}, relationshipsToOmit),
    };
};

export const anUpdateCustomEntityType = (overrides?: Partial<UpdateCustomEntityType>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateCustomEntityType' } & UpdateCustomEntityType => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomEntityType');
    return {
        __typename: 'UpdateCustomEntityType',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('CustomEntityType') ? {} as CustomEntityType : aCustomEntityType({}, relationshipsToOmit),
    };
};

export const anUpdateCustomEntityTypeFields = (overrides?: Partial<UpdateCustomEntityTypeFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateCustomEntityTypeFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomEntityTypeFields');
    return {
        fields: overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : ['tametsi', 'approbo', 'conforto'],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'demonstro',
    };
};

export const anUpdateCustomInsight = (overrides?: Partial<UpdateCustomInsight>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateCustomInsight' } & UpdateCustomInsight => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomInsight');
    return {
        __typename: 'UpdateCustomInsight',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('CustomInsight') ? {} as CustomInsight : aCustomInsight({}, relationshipsToOmit),
    };
};

export const anUpdateCustomInsightEnabled = (overrides?: Partial<UpdateCustomInsightEnabled>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateCustomInsightEnabled' } & UpdateCustomInsightEnabled => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomInsightEnabled');
    return {
        __typename: 'UpdateCustomInsightEnabled',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const anUpdateCustomInsightFields = (overrides?: Partial<UpdateCustomInsightFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateCustomInsightFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomInsightFields');
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'sequi',
        dynamicSeverity: overrides && overrides.hasOwnProperty('dynamicSeverity') ? overrides.dynamicSeverity! : [relationshipsToOmit.has('DynamicInsightSeverityField') ? {} as DynamicInsightSeverityField : aDynamicInsightSeverityField({}, relationshipsToOmit), relationshipsToOmit.has('DynamicInsightSeverityField') ? {} as DynamicInsightSeverityField : aDynamicInsightSeverityField({}, relationshipsToOmit), relationshipsToOmit.has('DynamicInsightSeverityField') ? {} as DynamicInsightSeverityField : aDynamicInsightSeverityField({}, relationshipsToOmit)],
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'creator',
        ordered: overrides && overrides.hasOwnProperty('ordered') ? overrides.ordered! : true,
        ruleIds: overrides && overrides.hasOwnProperty('ruleIds') ? overrides.ruleIds! : ['bene', 'sponte', 'deinde'],
        severity: overrides && overrides.hasOwnProperty('severity') ? overrides.severity! : InsightSeverityPyEnum.Critical,
        signalMatchStrategy: overrides && overrides.hasOwnProperty('signalMatchStrategy') ? overrides.signalMatchStrategy! : CustomInsightSignalMatchStrategy.Entity,
        signalNames: overrides && overrides.hasOwnProperty('signalNames') ? overrides.signalNames! : ['curo', 'decens', 'amitto'],
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['conatus', 'tero', 'rerum'],
    };
};

export const anUpdateCustomMatchListColumn = (overrides?: Partial<UpdateCustomMatchListColumn>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateCustomMatchListColumn' } & UpdateCustomMatchListColumn => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomMatchListColumn');
    return {
        __typename: 'UpdateCustomMatchListColumn',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('CustomMatchListColumn') ? {} as CustomMatchListColumn : aCustomMatchListColumn({}, relationshipsToOmit),
    };
};

export const anUpdateCustomThreatIntelSource = (overrides?: Partial<UpdateCustomThreatIntelSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateCustomThreatIntelSource' } & UpdateCustomThreatIntelSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomThreatIntelSource');
    return {
        __typename: 'UpdateCustomThreatIntelSource',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ThreatIntelSource') ? {} as ThreatIntelSource : aThreatIntelSource({}, relationshipsToOmit),
    };
};

export const anUpdateCustomYaraRule = (overrides?: Partial<UpdateCustomYaraRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateCustomYaraRule' } & UpdateCustomYaraRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomYaraRule');
    return {
        __typename: 'UpdateCustomYaraRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('YaraRule') ? {} as YaraRule : aYaraRule({}, relationshipsToOmit),
    };
};

export const anUpdateCustomYaraSource = (overrides?: Partial<UpdateCustomYaraSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateCustomYaraSource' } & UpdateCustomYaraSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomYaraSource');
    return {
        __typename: 'UpdateCustomYaraSource',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('YaraSource') ? {} as YaraSource : aYaraSource({}, relationshipsToOmit),
    };
};

export const anUpdateCustomerSourcedEntityLookupTable = (overrides?: Partial<UpdateCustomerSourcedEntityLookupTable>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateCustomerSourcedEntityLookupTable' } & UpdateCustomerSourcedEntityLookupTable => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomerSourcedEntityLookupTable');
    return {
        __typename: 'UpdateCustomerSourcedEntityLookupTable',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('CustomerSourcedEntityLookupTable') ? {} as CustomerSourcedEntityLookupTable : aCustomerSourcedEntityLookupTable({}, relationshipsToOmit),
    };
};

export const anUpdateCustomerSourcedEntityLookupTableFields = (overrides?: Partial<UpdateCustomerSourcedEntityLookupTableFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateCustomerSourcedEntityLookupTableFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateCustomerSourcedEntityLookupTableFields');
    return {
        sourceCategory: overrides && overrides.hasOwnProperty('sourceCategory') ? overrides.sourceCategory! : 'aestas',
    };
};

export const anUpdateEntityCriticality = (overrides?: Partial<UpdateEntityCriticality>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateEntityCriticality' } & UpdateEntityCriticality => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateEntityCriticality');
    return {
        __typename: 'UpdateEntityCriticality',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit),
    };
};

export const anUpdateEntityCriticalityConfig = (overrides?: Partial<UpdateEntityCriticalityConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateEntityCriticalityConfig' } & UpdateEntityCriticalityConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateEntityCriticalityConfig');
    return {
        __typename: 'UpdateEntityCriticalityConfig',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('EntityCriticalityConfig') ? {} as EntityCriticalityConfig : anEntityCriticalityConfig({}, relationshipsToOmit),
    };
};

export const anUpdateEntityCriticalityConfigFields = (overrides?: Partial<UpdateEntityCriticalityConfigFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateEntityCriticalityConfigFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateEntityCriticalityConfigFields');
    return {
        severityExpression: overrides && overrides.hasOwnProperty('severityExpression') ? overrides.severityExpression! : 'molestias',
    };
};

export const anUpdateEntityDomainConfiguration = (overrides?: Partial<UpdateEntityDomainConfiguration>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateEntityDomainConfiguration' } & UpdateEntityDomainConfiguration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateEntityDomainConfiguration');
    return {
        __typename: 'UpdateEntityDomainConfiguration',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const anUpdateEntityNote = (overrides?: Partial<UpdateEntityNote>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateEntityNote' } & UpdateEntityNote => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateEntityNote');
    return {
        __typename: 'UpdateEntityNote',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('EntityNote') ? {} as EntityNote : anEntityNote({}, relationshipsToOmit),
    };
};

export const anUpdateEntityTags = (overrides?: Partial<UpdateEntityTags>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateEntityTags' } & UpdateEntityTags => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateEntityTags');
    return {
        __typename: 'UpdateEntityTags',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit),
    };
};

export const anUpdateEntityValueEntityGroupConfiguration = (overrides?: Partial<UpdateEntityValueEntityGroupConfiguration>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateEntityValueEntityGroupConfiguration' } & UpdateEntityValueEntityGroupConfiguration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateEntityValueEntityGroupConfiguration');
    return {
        __typename: 'UpdateEntityValueEntityGroupConfiguration',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('EntityGroupConfiguration') ? {} as EntityGroupConfiguration : anEntityGroupConfiguration({}, relationshipsToOmit),
    };
};

export const anUpdateEntityWhitelist = (overrides?: Partial<UpdateEntityWhitelist>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateEntityWhitelist' } & UpdateEntityWhitelist => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateEntityWhitelist');
    return {
        __typename: 'UpdateEntityWhitelist',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit),
    };
};

export const anUpdateFavoriteField = (overrides?: Partial<UpdateFavoriteField>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateFavoriteField' } & UpdateFavoriteField => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateFavoriteField');
    return {
        __typename: 'UpdateFavoriteField',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('FavoriteField') ? {} as FavoriteField : aFavoriteField({}, relationshipsToOmit),
    };
};

export const anUpdateFirstSeenRule = (overrides?: Partial<UpdateFirstSeenRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateFirstSeenRule' } & UpdateFirstSeenRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateFirstSeenRule');
    return {
        __typename: 'UpdateFirstSeenRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('FirstSeenRule') ? {} as FirstSeenRule : aFirstSeenRule({}, relationshipsToOmit),
    };
};

export const anUpdateFirstSeenRuleFields = (overrides?: Partial<UpdateFirstSeenRuleFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateFirstSeenRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateFirstSeenRuleFields');
    return {
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'vaco',
        baselineType: overrides && overrides.hasOwnProperty('baselineType') ? overrides.baselineType! : FirstSeenRuleBaselineType.Global,
        baselineWindowSize: overrides && overrides.hasOwnProperty('baselineWindowSize') ? overrides.baselineWindowSize! : 431377990679145,
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'exercitationem',
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'deorsum',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        filterExpression: overrides && overrides.hasOwnProperty('filterExpression') ? overrides.filterExpression! : 'et',
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['virgo', 'vestrum', 'bellicus'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'arca',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'absum',
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : '0bfbb717-b0ea-4003-a57e-ef806dbf2e7c',
        retentionWindowSize: overrides && overrides.hasOwnProperty('retentionWindowSize') ? overrides.retentionWindowSize! : 319246389128423,
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 4709,
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'tepesco',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 1336,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['molestias', 'tibi', 'cupio'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['c1500721-a752-4177-ab38-af85b55d2e5e', '4776e607-5d14-47ed-afe5-061bdc5deee7', '54bed255-37e9-4a55-bfd0-88c8f76ab248'],
        valueExpression: overrides && overrides.hasOwnProperty('valueExpression') ? overrides.valueExpression! : 'vilis',
        valueFields: overrides && overrides.hasOwnProperty('valueFields') ? overrides.valueFields! : ['velut', 'callide', 'demergo'],
        version: overrides && overrides.hasOwnProperty('version') ? overrides.version! : 4506,
    };
};

export const anUpdateGithubYaraSource = (overrides?: Partial<UpdateGithubYaraSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateGithubYaraSource' } & UpdateGithubYaraSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateGithubYaraSource');
    return {
        __typename: 'UpdateGithubYaraSource',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('YaraSource') ? {} as YaraSource : aYaraSource({}, relationshipsToOmit),
    };
};

export const anUpdateIdefenseThreatIntelSource = (overrides?: Partial<UpdateIdefenseThreatIntelSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateIdefenseThreatIntelSource' } & UpdateIdefenseThreatIntelSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateIdefenseThreatIntelSource');
    return {
        __typename: 'UpdateIdefenseThreatIntelSource',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ThreatIntelSource') ? {} as ThreatIntelSource : aThreatIntelSource({}, relationshipsToOmit),
    };
};

export const anUpdateInsight = (overrides?: Partial<UpdateInsight>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateInsight' } & UpdateInsight => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateInsight');
    return {
        __typename: 'UpdateInsight',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit),
    };
};

export const anUpdateInsightComment = (overrides?: Partial<UpdateInsightComment>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateInsightComment' } & UpdateInsightComment => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateInsightComment');
    return {
        __typename: 'UpdateInsightComment',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('InsightComment') ? {} as InsightComment : anInsightComment({}, relationshipsToOmit),
    };
};

export const anUpdateInsightConfig = (overrides?: Partial<UpdateInsightConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateInsightConfig' } & UpdateInsightConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateInsightConfig');
    return {
        __typename: 'UpdateInsightConfig',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('InsightConfig') ? {} as InsightConfig : anInsightConfig({}, relationshipsToOmit),
    };
};

export const anUpdateInsightResolution = (overrides?: Partial<UpdateInsightResolution>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateInsightResolution' } & UpdateInsightResolution => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateInsightResolution');
    return {
        __typename: 'UpdateInsightResolution',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('InsightResolution') ? {} as InsightResolution : anInsightResolution({}, relationshipsToOmit),
    };
};

export const anUpdateInsightResolutionFields = (overrides?: Partial<UpdateInsightResolutionFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateInsightResolutionFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateInsightResolutionFields');
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'defessus',
    };
};

export const anUpdateInsightStatus = (overrides?: Partial<UpdateInsightStatus>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateInsightStatus' } & UpdateInsightStatus => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateInsightStatus');
    return {
        __typename: 'UpdateInsightStatus',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('InsightStatus') ? {} as InsightStatus : anInsightStatus({}, relationshipsToOmit),
    };
};

export const anUpdateInsightStatusFields = (overrides?: Partial<UpdateInsightStatusFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateInsightStatusFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateInsightStatusFields');
    return {
        color: overrides && overrides.hasOwnProperty('color') ? overrides.color! : 'cuius',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'cursus',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'adopto',
    };
};

export const anUpdateInsightStatusInProgressEnabled = (overrides?: Partial<UpdateInsightStatusInProgressEnabled>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateInsightStatusInProgressEnabled' } & UpdateInsightStatusInProgressEnabled => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateInsightStatusInProgressEnabled');
    return {
        __typename: 'UpdateInsightStatusInProgressEnabled',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const anUpdateInsightsById = (overrides?: Partial<UpdateInsightsById>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateInsightsById' } & UpdateInsightsById => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateInsightsById');
    return {
        __typename: 'UpdateInsightsById',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const anUpdateInventoryEntityGroupConfiguration = (overrides?: Partial<UpdateInventoryEntityGroupConfiguration>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateInventoryEntityGroupConfiguration' } & UpdateInventoryEntityGroupConfiguration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateInventoryEntityGroupConfiguration');
    return {
        __typename: 'UpdateInventoryEntityGroupConfiguration',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('EntityGroupConfiguration') ? {} as EntityGroupConfiguration : anEntityGroupConfiguration({}, relationshipsToOmit),
    };
};

export const anUpdateInventoryEntityLookupTable = (overrides?: Partial<UpdateInventoryEntityLookupTable>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateInventoryEntityLookupTable' } & UpdateInventoryEntityLookupTable => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateInventoryEntityLookupTable');
    return {
        __typename: 'UpdateInventoryEntityLookupTable',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('InventoryEntityLookupTable') ? {} as InventoryEntityLookupTable : anInventoryEntityLookupTable({}, relationshipsToOmit),
    };
};

export const anUpdateInventoryEntityLookupTableFields = (overrides?: Partial<UpdateInventoryEntityLookupTableFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateInventoryEntityLookupTableFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateInventoryEntityLookupTableFields');
    return {
        sourceCategory: overrides && overrides.hasOwnProperty('sourceCategory') ? overrides.sourceCategory! : 'adflicto',
    };
};

export const anUpdateLogMapping = (overrides?: Partial<UpdateLogMapping>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateLogMapping' } & UpdateLogMapping => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateLogMapping');
    return {
        __typename: 'UpdateLogMapping',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('LogMapping') ? {} as LogMapping : aLogMapping({}, relationshipsToOmit),
    };
};

export const anUpdateLogMappingEnabled = (overrides?: Partial<UpdateLogMappingEnabled>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateLogMappingEnabled' } & UpdateLogMappingEnabled => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateLogMappingEnabled');
    return {
        __typename: 'UpdateLogMappingEnabled',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('LogMapping') ? {} as LogMapping : aLogMapping({}, relationshipsToOmit),
    };
};

export const anUpdateLogMappingFields = (overrides?: Partial<UpdateLogMappingFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateLogMappingFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateLogMappingFields');
    return {
        fields: overrides && overrides.hasOwnProperty('fields') ? overrides.fields! : [relationshipsToOmit.has('LogMappingFieldFields') ? {} as LogMappingFieldFields : aLogMappingFieldFields({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingFieldFields') ? {} as LogMappingFieldFields : aLogMappingFieldFields({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingFieldFields') ? {} as LogMappingFieldFields : aLogMappingFieldFields({}, relationshipsToOmit)],
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'alioqui',
        parentId: overrides && overrides.hasOwnProperty('parentId') ? overrides.parentId! : 'unde',
        productGuid: overrides && overrides.hasOwnProperty('productGuid') ? overrides.productGuid! : 'usque',
        recordType: overrides && overrides.hasOwnProperty('recordType') ? overrides.recordType! : 'approbo',
        relatesEntities: overrides && overrides.hasOwnProperty('relatesEntities') ? overrides.relatesEntities! : true,
        skippedValues: overrides && overrides.hasOwnProperty('skippedValues') ? overrides.skippedValues! : ['tripudio', 'tredecim', 'atrocitas'],
        structuredFields: overrides && overrides.hasOwnProperty('structuredFields') ? overrides.structuredFields! : relationshipsToOmit.has('LogMappingStructuredInputFields') ? {} as LogMappingStructuredInputFields : aLogMappingStructuredInputFields({}, relationshipsToOmit),
        structuredInputs: overrides && overrides.hasOwnProperty('structuredInputs') ? overrides.structuredInputs! : [relationshipsToOmit.has('LogMappingStructuredInputFields') ? {} as LogMappingStructuredInputFields : aLogMappingStructuredInputFields({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingStructuredInputFields') ? {} as LogMappingStructuredInputFields : aLogMappingStructuredInputFields({}, relationshipsToOmit), relationshipsToOmit.has('LogMappingStructuredInputFields') ? {} as LogMappingStructuredInputFields : aLogMappingStructuredInputFields({}, relationshipsToOmit)],
        unstructuredFields: overrides && overrides.hasOwnProperty('unstructuredFields') ? overrides.unstructuredFields! : relationshipsToOmit.has('UnstructuredLogMappingFields') ? {} as UnstructuredLogMappingFields : anUnstructuredLogMappingFields({}, relationshipsToOmit),
    };
};

export const anUpdateMatchList = (overrides?: Partial<UpdateMatchList>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateMatchList' } & UpdateMatchList => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateMatchList');
    return {
        __typename: 'UpdateMatchList',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('MatchList') ? {} as MatchList : aMatchList({}, relationshipsToOmit),
    };
};

export const anUpdateMatchListItem = (overrides?: Partial<UpdateMatchListItem>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateMatchListItem' } & UpdateMatchListItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateMatchListItem');
    return {
        __typename: 'UpdateMatchListItem',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('MatchListItem') ? {} as MatchListItem : aMatchListItem({}, relationshipsToOmit),
        finishedProcessing: overrides && overrides.hasOwnProperty('finishedProcessing') ? overrides.finishedProcessing! : false,
    };
};

export const anUpdateMatchRule = (overrides?: Partial<UpdateMatchRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateMatchRule' } & UpdateMatchRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateMatchRule');
    return {
        __typename: 'UpdateMatchRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('MatchRule') ? {} as MatchRule : aMatchRule({}, relationshipsToOmit),
    };
};

export const anUpdateMatchRuleFields = (overrides?: Partial<UpdateMatchRuleFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateMatchRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateMatchRuleFields');
    return {
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'cribro',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'conqueror',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'cicuta',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'admiratio',
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'vel',
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : 'c0b4a71e-a599-497f-9251-f2d7455e350a',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 5907,
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'thermae',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'volubilis',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 5776,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['vitiosus', 'ater', 'amo'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['c9485361-7d67-48b4-92da-7a2efd44257a', 'b51187f9-640c-4b59-9f6d-28569b27201c', '5c869bdc-4b06-4715-a1ea-e03be9a4b402'],
    };
};

export const anUpdateMfaEnabled = (overrides?: Partial<UpdateMfaEnabled>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateMfaEnabled' } & UpdateMfaEnabled => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateMfaEnabled');
    return {
        __typename: 'UpdateMfaEnabled',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const anUpdateMitreAttackCoverageColors = (overrides?: Partial<UpdateMitreAttackCoverageColors>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateMitreAttackCoverageColors' } & UpdateMitreAttackCoverageColors => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateMitreAttackCoverageColors');
    return {
        __typename: 'UpdateMitreAttackCoverageColors',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('MitreCoverageColorLegend') ? {} as MitreCoverageColorLegend : aMitreCoverageColorLegend({}, relationshipsToOmit),
    };
};

export const anUpdateNetworkBlock = (overrides?: Partial<UpdateNetworkBlock>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateNetworkBlock' } & UpdateNetworkBlock => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateNetworkBlock');
    return {
        __typename: 'UpdateNetworkBlock',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('NetworkBlock') ? {} as NetworkBlock : aNetworkBlock({}, relationshipsToOmit),
    };
};

export const anUpdateOutlierRule = (overrides?: Partial<UpdateOutlierRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateOutlierRule' } & UpdateOutlierRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateOutlierRule');
    return {
        __typename: 'UpdateOutlierRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('OutlierRule') ? {} as OutlierRule : anOutlierRule({}, relationshipsToOmit),
    };
};

export const anUpdateOutlierRuleFields = (overrides?: Partial<UpdateOutlierRuleFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateOutlierRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateOutlierRuleFields');
    return {
        aggregationFunctions: overrides && overrides.hasOwnProperty('aggregationFunctions') ? overrides.aggregationFunctions! : [relationshipsToOmit.has('OutlierRuleAggregationFunctionField') ? {} as OutlierRuleAggregationFunctionField : anOutlierRuleAggregationFunctionField({}, relationshipsToOmit), relationshipsToOmit.has('OutlierRuleAggregationFunctionField') ? {} as OutlierRuleAggregationFunctionField : anOutlierRuleAggregationFunctionField({}, relationshipsToOmit), relationshipsToOmit.has('OutlierRuleAggregationFunctionField') ? {} as OutlierRuleAggregationFunctionField : anOutlierRuleAggregationFunctionField({}, relationshipsToOmit)],
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'accusamus',
        baselineWindowSize: overrides && overrides.hasOwnProperty('baselineWindowSize') ? overrides.baselineWindowSize! : 405732490804418,
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'solum',
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'attero',
        deviationThreshold: overrides && overrides.hasOwnProperty('deviationThreshold') ? overrides.deviationThreshold! : 3931,
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        floorValue: overrides && overrides.hasOwnProperty('floorValue') ? overrides.floorValue! : 8076,
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['asperiores', 'clarus', 'corrigo'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : false,
        matchExpression: overrides && overrides.hasOwnProperty('matchExpression') ? overrides.matchExpression! : 'auctor',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'accusator',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'somnus',
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : 'ce6c6333-7a8f-4d66-b6dd-77232e2df9b0',
        retentionWindowSize: overrides && overrides.hasOwnProperty('retentionWindowSize') ? overrides.retentionWindowSize! : 316702886129245,
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 2162,
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'et',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 1179,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['virga', 'ducimus', 'commemoro'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['96db59fd-37d5-4d97-be70-4029180a97fa', 'c5d76525-aa8c-493e-8746-d451692e6775', '0ee32b71-1b21-4a4e-b0c5-1e80822550b7'],
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : RuleWindowSizeEnum.Custom,
        windowSizeMilliseconds: overrides && overrides.hasOwnProperty('windowSizeMilliseconds') ? overrides.windowSizeMilliseconds! : 516514417610239,
    };
};

export const anUpdateRecordArtifactConfig = (overrides?: Partial<UpdateRecordArtifactConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateRecordArtifactConfig' } & UpdateRecordArtifactConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateRecordArtifactConfig');
    return {
        __typename: 'UpdateRecordArtifactConfig',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('RecordArtifactConfig') ? {} as RecordArtifactConfig : aRecordArtifactConfig({}, relationshipsToOmit),
    };
};

export const anUpdateRole = (overrides?: Partial<UpdateRole>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateRole' } & UpdateRole => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateRole');
    return {
        __typename: 'UpdateRole',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('Role') ? {} as Role : aRole({}, relationshipsToOmit),
    };
};

export const anUpdateRoleFields = (overrides?: Partial<UpdateRoleFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateRoleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateRoleFields');
    return {
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'cui',
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : ['785fe175-78ca-4fce-afa3-bef9486b0359', 'ec97c694-68bf-4113-a80f-cfd351adbb75', 'e5c9a9d3-55b5-4efa-a3fe-3d87367e66df'],
    };
};

export const anUpdateRuleEnabled = (overrides?: Partial<UpdateRuleEnabled>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateRuleEnabled' } & UpdateRuleEnabled => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateRuleEnabled');
    return {
        __typename: 'UpdateRuleEnabled',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : false,
    };
};

export const anUpdateRuleTuningExpression = (overrides?: Partial<UpdateRuleTuningExpression>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateRuleTuningExpression' } & UpdateRuleTuningExpression => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateRuleTuningExpression');
    return {
        __typename: 'UpdateRuleTuningExpression',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('RuleTuningExpression') ? {} as RuleTuningExpression : aRuleTuningExpression({}, relationshipsToOmit),
    };
};

export const anUpdateRuleTuningExpressionEnabled = (overrides?: Partial<UpdateRuleTuningExpressionEnabled>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateRuleTuningExpressionEnabled' } & UpdateRuleTuningExpressionEnabled => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateRuleTuningExpressionEnabled');
    return {
        __typename: 'UpdateRuleTuningExpressionEnabled',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const anUpdateRuleTuningExpressionFields = (overrides?: Partial<UpdateRuleTuningExpressionFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateRuleTuningExpressionFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateRuleTuningExpressionFields');
    return {
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'bellum',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
        exclude: overrides && overrides.hasOwnProperty('exclude') ? overrides.exclude! : true,
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'tabella',
        isGlobal: overrides && overrides.hasOwnProperty('isGlobal') ? overrides.isGlobal! : true,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'apud',
        ruleIds: overrides && overrides.hasOwnProperty('ruleIds') ? overrides.ruleIds! : ['d75ec1f1-1e8e-4594-847a-1b6f16af72c2', '11170ba1-63c9-46e4-8562-33945cc635a2', 'bf77ae5a-38bf-4d33-bb1c-1cdb64610902'],
    };
};

export const anUpdateSsoSettings = (overrides?: Partial<UpdateSsoSettings>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateSsoSettings' } & UpdateSsoSettings => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateSsoSettings');
    return {
        __typename: 'UpdateSsoSettings',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('SsoSettings') ? {} as SsoSettings : aSsoSettings({}, relationshipsToOmit),
    };
};

export const anUpdateStreamingExportConfiguration = (overrides?: Partial<UpdateStreamingExportConfiguration>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateStreamingExportConfiguration' } & UpdateStreamingExportConfiguration => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateStreamingExportConfiguration');
    return {
        __typename: 'UpdateStreamingExportConfiguration',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('StreamingExportConfiguration') ? {} as StreamingExportConfiguration : aStreamingExportConfiguration({}, relationshipsToOmit),
    };
};

export const anUpdateSumoLogicGeneralConfig = (overrides?: Partial<UpdateSumoLogicGeneralConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateSumoLogicGeneralConfig' } & UpdateSumoLogicGeneralConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateSumoLogicGeneralConfig');
    return {
        __typename: 'UpdateSumoLogicGeneralConfig',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const anUpdateSumoLogicSupportConfig = (overrides?: Partial<UpdateSumoLogicSupportConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateSumoLogicSupportConfig' } & UpdateSumoLogicSupportConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateSumoLogicSupportConfig');
    return {
        __typename: 'UpdateSumoLogicSupportConfig',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const anUpdateSumoMapping = (overrides?: Partial<UpdateSumoMapping>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateSumoMapping' } & UpdateSumoMapping => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateSumoMapping');
    return {
        __typename: 'UpdateSumoMapping',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('SumoMapping') ? {} as SumoMapping : aSumoMapping({}, relationshipsToOmit),
    };
};

export const anUpdateSumoSsoEnabled = (overrides?: Partial<UpdateSumoSsoEnabled>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateSumoSsoEnabled' } & UpdateSumoSsoEnabled => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateSumoSsoEnabled');
    return {
        __typename: 'UpdateSumoSsoEnabled',
        ok: overrides && overrides.hasOwnProperty('ok') ? overrides.ok! : true,
    };
};

export const anUpdateSuppressList = (overrides?: Partial<UpdateSuppressList>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateSuppressList' } & UpdateSuppressList => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateSuppressList');
    return {
        __typename: 'UpdateSuppressList',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('SuppressList') ? {} as SuppressList : aSuppressList({}, relationshipsToOmit),
    };
};

export const anUpdateSuppressListItem = (overrides?: Partial<UpdateSuppressListItem>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateSuppressListItem' } & UpdateSuppressListItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateSuppressListItem');
    return {
        __typename: 'UpdateSuppressListItem',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('SuppressListItem') ? {} as SuppressListItem : aSuppressListItem({}, relationshipsToOmit),
        finishedProcessing: overrides && overrides.hasOwnProperty('finishedProcessing') ? overrides.finishedProcessing! : false,
    };
};

export const anUpdateTagSchema = (overrides?: Partial<UpdateTagSchema>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateTagSchema' } & UpdateTagSchema => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateTagSchema');
    return {
        __typename: 'UpdateTagSchema',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('TagSchema') ? {} as TagSchema : aTagSchema({}, relationshipsToOmit),
    };
};

export const anUpdateTagSchemaFields = (overrides?: Partial<UpdateTagSchemaFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateTagSchemaFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateTagSchemaFields');
    return {
        contentTypes: overrides && overrides.hasOwnProperty('contentTypes') ? overrides.contentTypes! : [TagContentType.CustomInsight, TagContentType.CustomInsight, TagContentType.CustomInsight],
        freeform: overrides && overrides.hasOwnProperty('freeform') ? overrides.freeform! : false,
        key: overrides && overrides.hasOwnProperty('key') ? overrides.key! : 'e9ee91d7-0972-41eb-9177-f7642ad70ff8',
        label: overrides && overrides.hasOwnProperty('label') ? overrides.label! : 'advenio',
        valueOptions: overrides && overrides.hasOwnProperty('valueOptions') ? overrides.valueOptions! : [relationshipsToOmit.has('TagSchemaValueOptionFields') ? {} as TagSchemaValueOptionFields : aTagSchemaValueOptionFields({}, relationshipsToOmit), relationshipsToOmit.has('TagSchemaValueOptionFields') ? {} as TagSchemaValueOptionFields : aTagSchemaValueOptionFields({}, relationshipsToOmit), relationshipsToOmit.has('TagSchemaValueOptionFields') ? {} as TagSchemaValueOptionFields : aTagSchemaValueOptionFields({}, relationshipsToOmit)],
    };
};

export const anUpdateTaxiiThreatIntelSource = (overrides?: Partial<UpdateTaxiiThreatIntelSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateTaxiiThreatIntelSource' } & UpdateTaxiiThreatIntelSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateTaxiiThreatIntelSource');
    return {
        __typename: 'UpdateTaxiiThreatIntelSource',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ThreatIntelSource') ? {} as ThreatIntelSource : aThreatIntelSource({}, relationshipsToOmit),
    };
};

export const anUpdateTemplatedMatchRule = (overrides?: Partial<UpdateTemplatedMatchRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateTemplatedMatchRule' } & UpdateTemplatedMatchRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateTemplatedMatchRule');
    return {
        __typename: 'UpdateTemplatedMatchRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('TemplatedMatchRule') ? {} as TemplatedMatchRule : aTemplatedMatchRule({}, relationshipsToOmit),
    };
};

export const anUpdateTemplatedMatchRuleFields = (overrides?: Partial<UpdateTemplatedMatchRuleFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateTemplatedMatchRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateTemplatedMatchRuleFields');
    return {
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'debitis',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'asperiores',
        descriptionExpression: overrides && overrides.hasOwnProperty('descriptionExpression') ? overrides.descriptionExpression! : 'temperantia',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'deficio',
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : true,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'adsum',
        nameExpression: overrides && overrides.hasOwnProperty('nameExpression') ? overrides.nameExpression! : 'cupio',
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : '8e1a9b80-40dc-4167-8be1-5423de4d9309',
        scoreMapping: overrides && overrides.hasOwnProperty('scoreMapping') ? overrides.scoreMapping! : relationshipsToOmit.has('RuleScoreMappingFields') ? {} as RuleScoreMappingFields : aRuleScoreMappingFields({}, relationshipsToOmit),
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'saepe',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'aro',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 6274,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['quis', 'cupiditas', 'trepide'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['7dc64f1f-83d8-4943-90f3-8b349fc20cba', 'cec63c36-fd78-4726-83df-d9435fcbf9c5', '48b35aca-fdbe-4891-8c42-0936c8e6a8f1'],
    };
};

export const anUpdateThreatIntelItem = (overrides?: Partial<UpdateThreatIntelItem>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateThreatIntelItem' } & UpdateThreatIntelItem => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateThreatIntelItem');
    return {
        __typename: 'UpdateThreatIntelItem',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ThreatIntelItem') ? {} as ThreatIntelItem : aThreatIntelItem({}, relationshipsToOmit),
        finishedProcessing: overrides && overrides.hasOwnProperty('finishedProcessing') ? overrides.finishedProcessing! : true,
    };
};

export const anUpdateThreatQThreatIntelSource = (overrides?: Partial<UpdateThreatQThreatIntelSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateThreatQThreatIntelSource' } & UpdateThreatQThreatIntelSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateThreatQThreatIntelSource');
    return {
        __typename: 'UpdateThreatQThreatIntelSource',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ThreatIntelSource') ? {} as ThreatIntelSource : aThreatIntelSource({}, relationshipsToOmit),
    };
};

export const anUpdateThresholdRule = (overrides?: Partial<UpdateThresholdRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateThresholdRule' } & UpdateThresholdRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateThresholdRule');
    return {
        __typename: 'UpdateThresholdRule',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('ThresholdRule') ? {} as ThresholdRule : aThresholdRule({}, relationshipsToOmit),
    };
};

export const anUpdateThresholdRuleFields = (overrides?: Partial<UpdateThresholdRuleFields>, _relationshipsToOmit: Set<string> = new Set()): UpdateThresholdRuleFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateThresholdRuleFields');
    return {
        assetField: overrides && overrides.hasOwnProperty('assetField') ? overrides.assetField! : 'crebro',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'eveniet',
        countDistinct: overrides && overrides.hasOwnProperty('countDistinct') ? overrides.countDistinct! : true,
        countField: overrides && overrides.hasOwnProperty('countField') ? overrides.countField! : 'delectus',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'virtus',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        entitySelectors: overrides && overrides.hasOwnProperty('entitySelectors') ? overrides.entitySelectors! : [relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit), relationshipsToOmit.has('InputEntitySelectorType') ? {} as InputEntitySelectorType : anInputEntitySelectorType({}, relationshipsToOmit)],
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'exercitationem',
        groupByFields: overrides && overrides.hasOwnProperty('groupByFields') ? overrides.groupByFields! : ['quia', 'beneficium', 'voluptas'],
        isPrototype: overrides && overrides.hasOwnProperty('isPrototype') ? overrides.isPrototype! : false,
        limit: overrides && overrides.hasOwnProperty('limit') ? overrides.limit! : 2306,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'aspicio',
        parentJaskId: overrides && overrides.hasOwnProperty('parentJaskId') ? overrides.parentJaskId! : '0636a1e9-bc47-4909-b7dc-4eb786233e44',
        score: overrides && overrides.hasOwnProperty('score') ? overrides.score! : 6356,
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'brevis',
        summaryExpression: overrides && overrides.hasOwnProperty('summaryExpression') ? overrides.summaryExpression! : 'subseco',
        suppressionWindowSize: overrides && overrides.hasOwnProperty('suppressionWindowSize') ? overrides.suppressionWindowSize! : 8368,
        tags: overrides && overrides.hasOwnProperty('tags') ? overrides.tags! : ['quibusdam', 'aliqua', 'arcus'],
        tuningExpressionIds: overrides && overrides.hasOwnProperty('tuningExpressionIds') ? overrides.tuningExpressionIds! : ['bbf6adcf-182c-4a23-8f43-e3bdee1312a4', '7a2f24ad-f983-495d-b5e6-2b955e9ffb27', 'a68e70eb-914c-4a99-b174-a4e458c2c7b9'],
        version: overrides && overrides.hasOwnProperty('version') ? overrides.version! : 1702,
        windowSize: overrides && overrides.hasOwnProperty('windowSize') ? overrides.windowSize! : RuleWindowSizeEnum.Custom,
        windowSizeMilliseconds: overrides && overrides.hasOwnProperty('windowSizeMilliseconds') ? overrides.windowSizeMilliseconds! : 631501291968652,
    };
};

export const anUpdateUser = (overrides?: Partial<UpdateUser>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateUser' } & UpdateUser => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateUser');
    return {
        __typename: 'UpdateUser',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
    };
};

export const anUpdateVirusTotalConfig = (overrides?: Partial<UpdateVirusTotalConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UpdateVirusTotalConfig' } & UpdateVirusTotalConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdateVirusTotalConfig');
    return {
        __typename: 'UpdateVirusTotalConfig',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : relationshipsToOmit.has('VirusTotalConfig') ? {} as VirusTotalConfig : aVirusTotalConfig({}, relationshipsToOmit),
    };
};

export const anUpdatedCurrentUserFields = (overrides?: Partial<UpdatedCurrentUserFields>, _relationshipsToOmit: Set<string> = new Set()): UpdatedCurrentUserFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatedCurrentUserFields');
    return {
        accountNotificationsEnabled: overrides && overrides.hasOwnProperty('accountNotificationsEnabled') ? overrides.accountNotificationsEnabled! : false,
        apiKeyEnabled: overrides && overrides.hasOwnProperty('apiKeyEnabled') ? overrides.apiKeyEnabled! : false,
        confirmPassword: overrides && overrides.hasOwnProperty('confirmPassword') ? overrides.confirmPassword! : 'summisse',
        currentPassword: overrides && overrides.hasOwnProperty('currentPassword') ? overrides.currentPassword! : 'auditor',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'canonicus',
        insightReportNotificationInterval: overrides && overrides.hasOwnProperty('insightReportNotificationInterval') ? overrides.insightReportNotificationInterval! : NotificationInterval.Daily,
        mfaEnabled: overrides && overrides.hasOwnProperty('mfaEnabled') ? overrides.mfaEnabled! : true,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'currus',
        newPassword: overrides && overrides.hasOwnProperty('newPassword') ? overrides.newPassword! : 'denego',
        preferredTimezone: overrides && overrides.hasOwnProperty('preferredTimezone') ? overrides.preferredTimezone! : 'sonitus',
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'pecus',
    };
};

export const anUpdatedUserFields = (overrides?: Partial<UpdatedUserFields>, _relationshipsToOmit: Set<string> = new Set()): UpdatedUserFields => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UpdatedUserFields');
    return {
        accountNotificationsEnabled: overrides && overrides.hasOwnProperty('accountNotificationsEnabled') ? overrides.accountNotificationsEnabled! : false,
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : false,
        apiKeyEnabled: overrides && overrides.hasOwnProperty('apiKeyEnabled') ? overrides.apiKeyEnabled! : false,
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'doloremque',
        insightReportNotificationInterval: overrides && overrides.hasOwnProperty('insightReportNotificationInterval') ? overrides.insightReportNotificationInterval! : NotificationInterval.Daily,
        mfaEnabled: overrides && overrides.hasOwnProperty('mfaEnabled') ? overrides.mfaEnabled! : false,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'solitudo',
        role: overrides && overrides.hasOwnProperty('role') ? overrides.role! : 'curia',
        teams: overrides && overrides.hasOwnProperty('teams') ? overrides.teams! : ['sit', 'quaerat', 'bardus'],
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'incidunt',
    };
};

export const anUploadEntityGroupConfigurationMutationsCsv = (overrides?: Partial<UploadEntityGroupConfigurationMutationsCsv>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UploadEntityGroupConfigurationMutationsCsv' } & UploadEntityGroupConfigurationMutationsCsv => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UploadEntityGroupConfigurationMutationsCsv');
    return {
        __typename: 'UploadEntityGroupConfigurationMutationsCsv',
        uploadedEntityGroupCount: overrides && overrides.hasOwnProperty('uploadedEntityGroupCount') ? overrides.uploadedEntityGroupCount! : 6278,
    };
};

export const anUploadEntityMutationsCsv = (overrides?: Partial<UploadEntityMutationsCsv>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UploadEntityMutationsCsv' } & UploadEntityMutationsCsv => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UploadEntityMutationsCsv');
    return {
        __typename: 'UploadEntityMutationsCsv',
        uploadedEntitiesCount: overrides && overrides.hasOwnProperty('uploadedEntitiesCount') ? overrides.uploadedEntitiesCount! : 9253,
    };
};

export const anUploadItemsToList = (overrides?: Partial<UploadItemsToList>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UploadItemsToList' } & UploadItemsToList => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UploadItemsToList');
    return {
        __typename: 'UploadItemsToList',
        uploadedItemCount: overrides && overrides.hasOwnProperty('uploadedItemCount') ? overrides.uploadedItemCount! : 1712,
    };
};

export const anUploadItemsToSuppressList = (overrides?: Partial<UploadItemsToSuppressList>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UploadItemsToSuppressList' } & UploadItemsToSuppressList => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UploadItemsToSuppressList');
    return {
        __typename: 'UploadItemsToSuppressList',
        uploadedItemCount: overrides && overrides.hasOwnProperty('uploadedItemCount') ? overrides.uploadedItemCount! : 2534,
    };
};

export const anUploadItemsToThreatIntelSource = (overrides?: Partial<UploadItemsToThreatIntelSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UploadItemsToThreatIntelSource' } & UploadItemsToThreatIntelSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UploadItemsToThreatIntelSource');
    return {
        __typename: 'UploadItemsToThreatIntelSource',
        uploadedItemCount: overrides && overrides.hasOwnProperty('uploadedItemCount') ? overrides.uploadedItemCount! : 7988,
    };
};

export const anUploadNetworkBlocksCsv = (overrides?: Partial<UploadNetworkBlocksCsv>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UploadNetworkBlocksCsv' } & UploadNetworkBlocksCsv => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UploadNetworkBlocksCsv');
    return {
        __typename: 'UploadNetworkBlocksCsv',
        uploadedNetworkBlockCount: overrides && overrides.hasOwnProperty('uploadedNetworkBlockCount') ? overrides.uploadedNetworkBlockCount! : 9207,
    };
};

export const aUser = (overrides?: Partial<User>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'User' } & User => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('User');
    return {
        __typename: 'User',
        accountNotificationsEnabled: overrides && overrides.hasOwnProperty('accountNotificationsEnabled') ? overrides.accountNotificationsEnabled! : true,
        active: overrides && overrides.hasOwnProperty('active') ? overrides.active! : false,
        apiKeyEnabled: overrides && overrides.hasOwnProperty('apiKeyEnabled') ? overrides.apiKeyEnabled! : false,
        createdTime: overrides && overrides.hasOwnProperty('createdTime') ? overrides.createdTime! : "2025-10-02T00:36:32.491Z",
        displayName: overrides && overrides.hasOwnProperty('displayName') ? overrides.displayName! : 'CSIEM E2E User (Full Permissions)',
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'sbu-cse-ui+e2e@sumologic.com',
        emailConfirmed: overrides && overrides.hasOwnProperty('emailConfirmed') ? overrides.emailConfirmed! : true,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '120087074',
        insightReportNotificationInterval: overrides && overrides.hasOwnProperty('insightReportNotificationInterval') ? overrides.insightReportNotificationInterval! : NotificationInterval.Daily,
        lastActive: overrides && overrides.hasOwnProperty('lastActive') ? overrides.lastActive! : "2025-02-04T03:33:13.407Z",
        lastLogin: overrides && overrides.hasOwnProperty('lastLogin') ? overrides.lastLogin! : "2025-01-06T14:13:57.755Z",
        mfaEnabled: overrides && overrides.hasOwnProperty('mfaEnabled') ? overrides.mfaEnabled! : false,
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'CSIEM E2E User (Full Permissions)',
        permissions: overrides && overrides.hasOwnProperty('permissions') ? overrides.permissions! : ['suadeo', 'synagoga', 'alii'],
        role: overrides && overrides.hasOwnProperty('role') ? overrides.role! : 'apostolus',
        teams: overrides && overrides.hasOwnProperty('teams') ? overrides.teams! : ['angustus', 'usitas', 'clementia'],
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'sbu-cse-ui+e2e@sumologic.com',
    };
};

export const aUserAudit = (overrides?: Partial<UserAudit>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UserAudit' } & UserAudit => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UserAudit');
    return {
        __typename: 'UserAudit',
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'coniecto',
        when: overrides && overrides.hasOwnProperty('when') ? overrides.when! : "2025-06-01T11:15:23.756Z",
    };
};

export const aUserInventory = (overrides?: Partial<UserInventory>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UserInventory' } & UserInventory => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UserInventory');
    return {
        __typename: 'UserInventory',
        department: overrides && overrides.hasOwnProperty('department') ? overrides.department! : 'tersus',
        emails: overrides && overrides.hasOwnProperty('emails') ? overrides.emails! : ['defetiscor', 'demum', 'strues'],
        givenName: overrides && overrides.hasOwnProperty('givenName') ? overrides.givenName! : 'denuo',
        groups: overrides && overrides.hasOwnProperty('groups') ? overrides.groups! : ['stillicidium', 'beatae', 'tamquam'],
        lastName: overrides && overrides.hasOwnProperty('lastName') ? overrides.lastName! : 'molestias',
        metadataJson: overrides && overrides.hasOwnProperty('metadataJson') ? overrides.metadataJson! : "{\"objectCategory\":\"CN=Person,CN=Schema,CN=Configuration,DC=windomain,DC=local\",\"objectClass\":\"top;person;organizationalPerson;user\",\"objectSid\":\"S-1-5-21-2232977720-3053628852-2340862552-1000\",\"primaryGroupId\":\"513\",\"sAMAccountName\":\"vagrant\",\"whenCreated\":\"4/18/2020 6:58:27 AM\",\"userAccountControl\":\"66048\",\"lastLogon\":132765275609170160,\"pwdLastSet\":132316856072608530,\"accountExpires\":0,\"distinguishedName\":\"CN=vagrant,CN=Users,DC=windomain,DC=local\",\"objectGUID\":\"{ea74b2a2-2647-4c02-8941-b801e17f6bf6}\",\"cn\":\"vagrant\"}",
        middleName: overrides && overrides.hasOwnProperty('middleName') ? overrides.middleName! : 'ater',
        normalizedUsername: overrides && overrides.hasOwnProperty('normalizedUsername') ? overrides.normalizedUsername! : 'possimus',
        parsedTime: overrides && overrides.hasOwnProperty('parsedTime') ? overrides.parsedTime! : 'enim',
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : 'vespillo',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : 'praesentium',
        uniqueId: overrides && overrides.hasOwnProperty('uniqueId') ? overrides.uniqueId! : 'catena',
        userId: overrides && overrides.hasOwnProperty('userId') ? overrides.userId! : 'torrens',
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'terreo',
    };
};

export const aUserInvitation = (overrides?: Partial<UserInvitation>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UserInvitation' } & UserInvitation => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UserInvitation');
    return {
        __typename: 'UserInvitation',
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-06-07T05:50:45.440Z",
        email: overrides && overrides.hasOwnProperty('email') ? overrides.email! : 'odit',
        expired: overrides && overrides.hasOwnProperty('expired') ? overrides.expired! : false,
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '7fc69e59-d1fa-43d7-a531-424703f5013b',
        role: overrides && overrides.hasOwnProperty('role') ? overrides.role! : 'beatus',
    };
};

export const aUserInvitationPage = (overrides?: Partial<UserInvitationPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UserInvitationPage' } & UserInvitationPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UserInvitationPage');
    return {
        __typename: 'UserInvitationPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('UserInvitation') ? {} as UserInvitation : aUserInvitation({}, relationshipsToOmit), relationshipsToOmit.has('UserInvitation') ? {} as UserInvitation : aUserInvitation({}, relationshipsToOmit), relationshipsToOmit.has('UserInvitation') ? {} as UserInvitation : aUserInvitation({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 2447,
    };
};

export const aUserPage = (overrides?: Partial<UserPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UserPage' } & UserPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UserPage');
    return {
        __typename: 'UserPage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : false,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit), relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit), relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 1680,
    };
};

export const aUserPreferences = (overrides?: Partial<UserPreferences>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'UserPreferences' } & UserPreferences => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('UserPreferences');
    return {
        __typename: 'UserPreferences',
        displayAlertBadge: overrides && overrides.hasOwnProperty('displayAlertBadge') ? overrides.displayAlertBadge! : false,
        navAsideCollapsed: overrides && overrides.hasOwnProperty('navAsideCollapsed') ? overrides.navAsideCollapsed! : true,
        navDrawerPinnedMenu: overrides && overrides.hasOwnProperty('navDrawerPinnedMenu') ? overrides.navDrawerPinnedMenu! : 'sodalitas',
        navDrawerWidth: overrides && overrides.hasOwnProperty('navDrawerWidth') ? overrides.navDrawerWidth! : 8985,
        navOpenLinksInNewTab: overrides && overrides.hasOwnProperty('navOpenLinksInNewTab') ? overrides.navOpenLinksInNewTab! : false,
        sessionTimeout: overrides && overrides.hasOwnProperty('sessionTimeout') ? overrides.sessionTimeout! : 8193,
        timeZone: overrides && overrides.hasOwnProperty('timeZone') ? overrides.timeZone! : 'solus',
        useDarkTheme: overrides && overrides.hasOwnProperty('useDarkTheme') ? overrides.useDarkTheme! : true,
    };
};

export const aVendorProduct = (overrides?: Partial<VendorProduct>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'VendorProduct' } & VendorProduct => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('VendorProduct');
    return {
        __typename: 'VendorProduct',
        guid: overrides && overrides.hasOwnProperty('guid') ? overrides.guid! : 'utor',
        product: overrides && overrides.hasOwnProperty('product') ? overrides.product! : 'suspendo',
        vendor: overrides && overrides.hasOwnProperty('vendor') ? overrides.vendor! : 'dapifer',
    };
};

export const aVendorProductFilter = (overrides?: Partial<VendorProductFilter>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'VendorProductFilter' } & VendorProductFilter => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('VendorProductFilter');
    return {
        __typename: 'VendorProductFilter',
        vendorProducts: overrides && overrides.hasOwnProperty('vendorProducts') ? overrides.vendorProducts! : [relationshipsToOmit.has('VendorProduct') ? {} as VendorProduct : aVendorProduct({}, relationshipsToOmit), relationshipsToOmit.has('VendorProduct') ? {} as VendorProduct : aVendorProduct({}, relationshipsToOmit), relationshipsToOmit.has('VendorProduct') ? {} as VendorProduct : aVendorProduct({}, relationshipsToOmit)],
    };
};

export const aVirusTotalConfig = (overrides?: Partial<VirusTotalConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'VirusTotalConfig' } & VirusTotalConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('VirusTotalConfig');
    return {
        __typename: 'VirusTotalConfig',
        apiKey: overrides && overrides.hasOwnProperty('apiKey') ? overrides.apiKey! : 'qui',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : true,
    };
};

export const aVisitEntityPage = (overrides?: Partial<VisitEntityPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'VisitEntityPage' } & VisitEntityPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('VisitEntityPage');
    return {
        __typename: 'VisitEntityPage',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : [relationshipsToOmit.has('VisitedEntityPage') ? {} as VisitedEntityPage : aVisitedEntityPage({}, relationshipsToOmit), relationshipsToOmit.has('VisitedEntityPage') ? {} as VisitedEntityPage : aVisitedEntityPage({}, relationshipsToOmit), relationshipsToOmit.has('VisitedEntityPage') ? {} as VisitedEntityPage : aVisitedEntityPage({}, relationshipsToOmit)],
    };
};

export const aVisitInsightPage = (overrides?: Partial<VisitInsightPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'VisitInsightPage' } & VisitInsightPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('VisitInsightPage');
    return {
        __typename: 'VisitInsightPage',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : [relationshipsToOmit.has('VisitedEntityPage') ? {} as VisitedEntityPage : aVisitedEntityPage({}, relationshipsToOmit), relationshipsToOmit.has('VisitedEntityPage') ? {} as VisitedEntityPage : aVisitedEntityPage({}, relationshipsToOmit), relationshipsToOmit.has('VisitedEntityPage') ? {} as VisitedEntityPage : aVisitedEntityPage({}, relationshipsToOmit)],
    };
};

export const aVisitSearchQueryPage = (overrides?: Partial<VisitSearchQueryPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'VisitSearchQueryPage' } & VisitSearchQueryPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('VisitSearchQueryPage');
    return {
        __typename: 'VisitSearchQueryPage',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : [relationshipsToOmit.has('VisitedSearchQueryPage') ? {} as VisitedSearchQueryPage : aVisitedSearchQueryPage({}, relationshipsToOmit), relationshipsToOmit.has('VisitedSearchQueryPage') ? {} as VisitedSearchQueryPage : aVisitedSearchQueryPage({}, relationshipsToOmit), relationshipsToOmit.has('VisitedSearchQueryPage') ? {} as VisitedSearchQueryPage : aVisitedSearchQueryPage({}, relationshipsToOmit)],
    };
};

export const aVisitSignalPage = (overrides?: Partial<VisitSignalPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'VisitSignalPage' } & VisitSignalPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('VisitSignalPage');
    return {
        __typename: 'VisitSignalPage',
        data: overrides && overrides.hasOwnProperty('data') ? overrides.data! : [relationshipsToOmit.has('VisitedEntityPage') ? {} as VisitedEntityPage : aVisitedEntityPage({}, relationshipsToOmit), relationshipsToOmit.has('VisitedEntityPage') ? {} as VisitedEntityPage : aVisitedEntityPage({}, relationshipsToOmit), relationshipsToOmit.has('VisitedEntityPage') ? {} as VisitedEntityPage : aVisitedEntityPage({}, relationshipsToOmit)],
    };
};

export const aVisitedEntityPage = (overrides?: Partial<VisitedEntityPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'VisitedEntityPage' } & VisitedEntityPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('VisitedEntityPage');
    return {
        __typename: 'VisitedEntityPage',
        entity: overrides && overrides.hasOwnProperty('entity') ? overrides.entity! : relationshipsToOmit.has('EntityInterface') ? {} as EntityInterface : anEntityInterface({}, relationshipsToOmit),
        entityId: overrides && overrides.hasOwnProperty('entityId') ? overrides.entityId! : 'ed25a4bb-9ec3-486a-99e2-08e96bca63cb',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-02-04T04:30:52.816Z",
    };
};

export const aVisitedInsightPage = (overrides?: Partial<VisitedInsightPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'VisitedInsightPage' } & VisitedInsightPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('VisitedInsightPage');
    return {
        __typename: 'VisitedInsightPage',
        insight: overrides && overrides.hasOwnProperty('insight') ? overrides.insight! : relationshipsToOmit.has('Insight') ? {} as Insight : anInsight({}, relationshipsToOmit),
        insightId: overrides && overrides.hasOwnProperty('insightId') ? overrides.insightId! : '6bf70edd-f81e-4fe2-90e6-8698f0cd43fc',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-09-06T10:58:53.368Z",
    };
};

export const aVisitedPageInterface = (overrides?: Partial<VisitedPageInterface>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'VisitedPageInterface' } & VisitedPageInterface => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('VisitedPageInterface');
    return {
        __typename: 'VisitedPageInterface',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-01-08T13:19:26.398Z",
    };
};

export const aVisitedSearchQueryPage = (overrides?: Partial<VisitedSearchQueryPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'VisitedSearchQueryPage' } & VisitedSearchQueryPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('VisitedSearchQueryPage');
    return {
        __typename: 'VisitedSearchQueryPage',
        q: overrides && overrides.hasOwnProperty('q') ? overrides.q! : 'crur',
        resultType: overrides && overrides.hasOwnProperty('resultType') ? overrides.resultType! : SearchResultType.All,
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-07-18T02:02:47.051Z",
    };
};

export const aVisitedSignalPage = (overrides?: Partial<VisitedSignalPage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'VisitedSignalPage' } & VisitedSignalPage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('VisitedSignalPage');
    return {
        __typename: 'VisitedSignalPage',
        signal: overrides && overrides.hasOwnProperty('signal') ? overrides.signal! : relationshipsToOmit.has('Signal') ? {} as Signal : aSignal({}, relationshipsToOmit),
        signalId: overrides && overrides.hasOwnProperty('signalId') ? overrides.signalId! : '4caea3d3-8c33-477e-b2d4-7a458c716e44',
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-09-19T19:20:53.879Z",
    };
};

export const aYaraGithubConfig = (overrides?: Partial<YaraGithubConfig>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'YaraGithubConfig' } & YaraGithubConfig => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('YaraGithubConfig');
    return {
        __typename: 'YaraGithubConfig',
        branch: overrides && overrides.hasOwnProperty('branch') ? overrides.branch! : 'clibanus',
        defaultSeverity: overrides && overrides.hasOwnProperty('defaultSeverity') ? overrides.defaultSeverity! : 5638,
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        lastChecked: overrides && overrides.hasOwnProperty('lastChecked') ? overrides.lastChecked! : "2025-06-04T21:34:52.671Z",
        lastRunReport: overrides && overrides.hasOwnProperty('lastRunReport') ? overrides.lastRunReport! : relationshipsToOmit.has('YaraGithubRunReport') ? {} as YaraGithubRunReport : aYaraGithubRunReport({}, relationshipsToOmit),
        token: overrides && overrides.hasOwnProperty('token') ? overrides.token! : 'adaugeo',
        url: overrides && overrides.hasOwnProperty('url') ? overrides.url! : 'conservo',
        username: overrides && overrides.hasOwnProperty('username') ? overrides.username! : 'aeternus',
        yaraFileRegex: overrides && overrides.hasOwnProperty('yaraFileRegex') ? overrides.yaraFileRegex! : 'clementia',
    };
};

export const aYaraGithubRunReport = (overrides?: Partial<YaraGithubRunReport>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'YaraGithubRunReport' } & YaraGithubRunReport => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('YaraGithubRunReport');
    return {
        __typename: 'YaraGithubRunReport',
        changed: overrides && overrides.hasOwnProperty('changed') ? overrides.changed! : ['aspicio', 'ad', 'corrumpo'],
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : ['delinquo', 'attollo', 'adulescens'],
        deleted: overrides && overrides.hasOwnProperty('deleted') ? overrides.deleted! : ['comes', 'voluptatum', 'apud'],
        duplicates: overrides && overrides.hasOwnProperty('duplicates') ? overrides.duplicates! : ['debilito', 'commodi', 'conturbo'],
        parsedRules: overrides && overrides.hasOwnProperty('parsedRules') ? overrides.parsedRules! : ['cumque', 'damno', 'absum'],
        timestamp: overrides && overrides.hasOwnProperty('timestamp') ? overrides.timestamp! : "2025-09-30T05:51:23.927Z",
        unchanged: overrides && overrides.hasOwnProperty('unchanged') ? overrides.unchanged! : ['anser', 'eaque', 'veritatis'],
        yaraFilePaths: overrides && overrides.hasOwnProperty('yaraFilePaths') ? overrides.yaraFilePaths! : ['paulatim', 'amiculum', 'conqueror'],
        yaraFileRegex: overrides && overrides.hasOwnProperty('yaraFileRegex') ? overrides.yaraFileRegex! : 'cultura',
        zipUrl: overrides && overrides.hasOwnProperty('zipUrl') ? overrides.zipUrl! : 'impedit',
    };
};

export const aYaraRule = (overrides?: Partial<YaraRule>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'YaraRule' } & YaraRule => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('YaraRule');
    return {
        __typename: 'YaraRule',
        category: overrides && overrides.hasOwnProperty('category') ? overrides.category! : 'delicate',
        contentType: overrides && overrides.hasOwnProperty('contentType') ? overrides.contentType! : ContentType.Anomaly,
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-03-29T06:49:39.901Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'volo',
        createdByUser: overrides && overrides.hasOwnProperty('createdByUser') ? overrides.createdByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'theatrum',
        enabled: overrides && overrides.hasOwnProperty('enabled') ? overrides.enabled! : false,
        expression: overrides && overrides.hasOwnProperty('expression') ? overrides.expression! : 'molestias',
        history: overrides && overrides.hasOwnProperty('history') ? overrides.history! : [relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit), relationshipsToOmit.has('RuleHistoryEvent') ? {} as RuleHistoryEvent : aRuleHistoryEvent({}, relationshipsToOmit)],
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : 'fb3250a6-7941-4555-96d4-9a787b647938',
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2025-03-27T21:07:38.514Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'pax',
        lastUpdatedByUser: overrides && overrides.hasOwnProperty('lastUpdatedByUser') ? overrides.lastUpdatedByUser! : relationshipsToOmit.has('User') ? {} as User : aUser({}, relationshipsToOmit),
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'viridis',
        ruleSource: overrides && overrides.hasOwnProperty('ruleSource') ? overrides.ruleSource! : 'ter',
        severity: overrides && overrides.hasOwnProperty('severity') ? overrides.severity! : 1269,
        signalCount07d: overrides && overrides.hasOwnProperty('signalCount07d') ? overrides.signalCount07d! : 4486,
        signalCount24h: overrides && overrides.hasOwnProperty('signalCount24h') ? overrides.signalCount24h! : 7906,
        source: overrides && overrides.hasOwnProperty('source') ? overrides.source! : relationshipsToOmit.has('YaraSource') ? {} as YaraSource : aYaraSource({}, relationshipsToOmit),
        stream: overrides && overrides.hasOwnProperty('stream') ? overrides.stream! : 'cito',
        yaraSourceId: overrides && overrides.hasOwnProperty('yaraSourceId') ? overrides.yaraSourceId! : 'vorago',
    };
};

export const aYaraRulePage = (overrides?: Partial<YaraRulePage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'YaraRulePage' } & YaraRulePage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('YaraRulePage');
    return {
        __typename: 'YaraRulePage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('YaraRule') ? {} as YaraRule : aYaraRule({}, relationshipsToOmit), relationshipsToOmit.has('YaraRule') ? {} as YaraRule : aYaraRule({}, relationshipsToOmit), relationshipsToOmit.has('YaraRule') ? {} as YaraRule : aYaraRule({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 3043,
    };
};

export const aYaraRuleSort = (overrides?: Partial<YaraRuleSort>, _relationshipsToOmit: Set<string> = new Set()): YaraRuleSort => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('YaraRuleSort');
    return {
        direction: overrides && overrides.hasOwnProperty('direction') ? overrides.direction! : SortDir.Asc,
        field: overrides && overrides.hasOwnProperty('field') ? overrides.field! : YaraRuleSortableField.Created,
    };
};

export const aYaraSource = (overrides?: Partial<YaraSource>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'YaraSource' } & YaraSource => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('YaraSource');
    return {
        __typename: 'YaraSource',
        created: overrides && overrides.hasOwnProperty('created') ? overrides.created! : "2025-09-29T16:10:25.275Z",
        createdBy: overrides && overrides.hasOwnProperty('createdBy') ? overrides.createdBy! : 'campana',
        description: overrides && overrides.hasOwnProperty('description') ? overrides.description! : 'eius',
        githubConfig: overrides && overrides.hasOwnProperty('githubConfig') ? overrides.githubConfig! : relationshipsToOmit.has('YaraGithubConfig') ? {} as YaraGithubConfig : aYaraGithubConfig({}, relationshipsToOmit),
        id: overrides && overrides.hasOwnProperty('id') ? overrides.id! : '7c3eba48-26a1-45b0-8f68-896f301d93db',
        issues: overrides && overrides.hasOwnProperty('issues') ? overrides.issues! : ['vir', 'usus', 'tepesco'],
        lastUpdated: overrides && overrides.hasOwnProperty('lastUpdated') ? overrides.lastUpdated! : "2024-12-28T01:19:35.952Z",
        lastUpdatedBy: overrides && overrides.hasOwnProperty('lastUpdatedBy') ? overrides.lastUpdatedBy! : 'veritas',
        name: overrides && overrides.hasOwnProperty('name') ? overrides.name! : 'ratione',
        rules: overrides && overrides.hasOwnProperty('rules') ? overrides.rules! : relationshipsToOmit.has('YaraRulePage') ? {} as YaraRulePage : aYaraRulePage({}, relationshipsToOmit),
        sourceType: overrides && overrides.hasOwnProperty('sourceType') ? overrides.sourceType! : YaraSourceType.Custom,
    };
};

export const aYaraSourcePage = (overrides?: Partial<YaraSourcePage>, _relationshipsToOmit: Set<string> = new Set()): { __typename: 'YaraSourcePage' } & YaraSourcePage => {
    const relationshipsToOmit: Set<string> = new Set(_relationshipsToOmit);
    relationshipsToOmit.add('YaraSourcePage');
    return {
        __typename: 'YaraSourcePage',
        hasNextPage: overrides && overrides.hasOwnProperty('hasNextPage') ? overrides.hasNextPage! : true,
        objects: overrides && overrides.hasOwnProperty('objects') ? overrides.objects! : [relationshipsToOmit.has('YaraSource') ? {} as YaraSource : aYaraSource({}, relationshipsToOmit), relationshipsToOmit.has('YaraSource') ? {} as YaraSource : aYaraSource({}, relationshipsToOmit), relationshipsToOmit.has('YaraSource') ? {} as YaraSource : aYaraSource({}, relationshipsToOmit)],
        total: overrides && overrides.hasOwnProperty('total') ? overrides.total! : 4569,
    };
};
